var GL = Object.defineProperty, qL = Object.defineProperties;
var YL = Object.getOwnPropertyDescriptors;
var lp = Object.getOwnPropertySymbols;
var WS = Object.prototype.hasOwnProperty, KS = Object.prototype.propertyIsEnumerable;
var US = Math.pow, VS = (e, t, n) => t in e ? GL(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, je = (e, t) => {
  for (var n in t || (t = {}))
    WS.call(t, n) && VS(e, n, t[n]);
  if (lp)
    for (var n of lp(t))
      KS.call(t, n) && VS(e, n, t[n]);
  return e;
}, Bt = (e, t) => qL(e, YL(t));
var Cv = (e, t) => {
  var n = {};
  for (var r in e)
    WS.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && lp)
    for (var r of lp(e))
      t.indexOf(r) < 0 && KS.call(e, r) && (n[r] = e[r]);
  return n;
};
var xv = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var rt = (e, t, n) => (xv(e, t, "read from private field"), n ? n.call(e) : t.get(e)), zn = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, gn = (e, t, n, r) => (xv(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
var cp = (e, t, n, r) => ({
  set _(o) {
    gn(e, t, o, n);
  },
  get _() {
    return rt(e, t, r);
  }
}), mo = (e, t, n) => (xv(e, t, "access private method"), n);
var an = (e, t, n) => new Promise((r, o) => {
  var i = (l) => {
    try {
      s(n.next(l));
    } catch (u) {
      o(u);
    }
  }, a = (l) => {
    try {
      s(n.throw(l));
    } catch (u) {
      o(u);
    }
  }, s = (l) => l.done ? r(l.value) : Promise.resolve(l.value).then(i, a);
  s((n = n.apply(e, t)).next());
});
import * as c from "react";
import be, { isValidElement as XL, useContext as Cn, createContext as Rs, useRef as _t, useLayoutEffect as A0, useEffect as kt, useState as Ot, forwardRef as ni, useMemo as mr, Children as ZL, createRef as QL, useCallback as ar, useImperativeHandle as Ua, cloneElement as JL, useDebugValue as GS, createElement as eA, memo as Gy } from "react";
import * as tA from "react-dom";
import j0, { createPortal as e4, unstable_batchedUpdates as t4, flushSync as k0 } from "react-dom";
function nA(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const o in r)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(r, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => r[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var lo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Vi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var F0 = { exports: {} }, Lu = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qS;
function rA() {
  if (qS)
    return Lu;
  qS = 1;
  var e = be, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var f, p = {}, h = null, y = null;
    u !== void 0 && (h = "" + u), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (y = l.ref);
    for (f in l)
      r.call(l, f) && !i.hasOwnProperty(f) && (p[f] = l[f]);
    if (s && s.defaultProps)
      for (f in l = s.defaultProps, l)
        p[f] === void 0 && (p[f] = l[f]);
    return { $$typeof: t, type: s, key: h, ref: y, props: p, _owner: o.current };
  }
  return Lu.Fragment = n, Lu.jsx = a, Lu.jsxs = a, Lu;
}
var Au = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YS;
function oA() {
  return YS || (YS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = be, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = Symbol.iterator, m = "@@iterator";
    function v(q) {
      if (q === null || typeof q != "object")
        return null;
      var Se = b && q[b] || q[m];
      return typeof Se == "function" ? Se : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(q) {
      {
        for (var Se = arguments.length, Re = new Array(Se > 1 ? Se - 1 : 0), ut = 1; ut < Se; ut++)
          Re[ut - 1] = arguments[ut];
        S("error", q, Re);
      }
    }
    function S(q, Se, Re) {
      {
        var ut = C.ReactDebugCurrentFrame, $t = ut.getStackAddendum();
        $t !== "" && (Se += "%s", Re = Re.concat([$t]));
        var Ne = Re.map(function(Ie) {
          return String(Ie);
        });
        Ne.unshift("Warning: " + Se), Function.prototype.apply.call(console[q], console, Ne);
      }
    }
    var E = !1, O = !1, $ = !1, _ = !1, R = !1, P;
    P = Symbol.for("react.module.reference");
    function I(q) {
      return !!(typeof q == "string" || typeof q == "function" || q === r || q === i || R || q === o || q === u || q === f || _ || q === y || E || O || $ || typeof q == "object" && q !== null && (q.$$typeof === h || q.$$typeof === p || q.$$typeof === a || q.$$typeof === s || q.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      q.$$typeof === P || q.getModuleId !== void 0));
    }
    function j(q, Se, Re) {
      var ut = q.displayName;
      if (ut)
        return ut;
      var $t = Se.displayName || Se.name || "";
      return $t !== "" ? Re + "(" + $t + ")" : Re;
    }
    function F(q) {
      return q.displayName || "Context";
    }
    function A(q) {
      if (q == null)
        return null;
      if (typeof q.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof q == "function")
        return q.displayName || q.name || null;
      if (typeof q == "string")
        return q;
      switch (q) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case s:
            var Se = q;
            return F(Se) + ".Consumer";
          case a:
            var Re = q;
            return F(Re._context) + ".Provider";
          case l:
            return j(q, q.render, "ForwardRef");
          case p:
            var ut = q.displayName || null;
            return ut !== null ? ut : A(q.type) || "Memo";
          case h: {
            var $t = q, Ne = $t._payload, Ie = $t._init;
            try {
              return A(Ie(Ne));
            } catch (De) {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, N = 0, D, T, L, z, H, V, Y;
    function Z() {
    }
    Z.__reactDisabledLog = !0;
    function oe() {
      {
        if (N === 0) {
          D = console.log, T = console.info, L = console.warn, z = console.error, H = console.group, V = console.groupCollapsed, Y = console.groupEnd;
          var q = {
            configurable: !0,
            enumerable: !0,
            value: Z,
            writable: !0
          };
          Object.defineProperties(console, {
            info: q,
            log: q,
            warn: q,
            error: q,
            group: q,
            groupCollapsed: q,
            groupEnd: q
          });
        }
        N++;
      }
    }
    function ee() {
      {
        if (N--, N === 0) {
          var q = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, q, {
              value: D
            }),
            info: M({}, q, {
              value: T
            }),
            warn: M({}, q, {
              value: L
            }),
            error: M({}, q, {
              value: z
            }),
            group: M({}, q, {
              value: H
            }),
            groupCollapsed: M({}, q, {
              value: V
            }),
            groupEnd: M({}, q, {
              value: Y
            })
          });
        }
        N < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ae = C.ReactCurrentDispatcher, le;
    function ue(q, Se, Re) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch ($t) {
            var ut = $t.stack.trim().match(/\n( *(at )?)/);
            le = ut && ut[1] || "";
          }
        return `
` + le + q;
      }
    }
    var ie = !1, re;
    {
      var Q = typeof WeakMap == "function" ? WeakMap : Map;
      re = new Q();
    }
    function ce(q, Se) {
      if (!q || ie)
        return "";
      {
        var Re = re.get(q);
        if (Re !== void 0)
          return Re;
      }
      var ut;
      ie = !0;
      var $t = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ne;
      Ne = ae.current, ae.current = null, oe();
      try {
        if (Se) {
          var Ie = function() {
            throw Error();
          };
          if (Object.defineProperty(Ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ie, []);
            } catch (Jt) {
              ut = Jt;
            }
            Reflect.construct(q, [], Ie);
          } else {
            try {
              Ie.call();
            } catch (Jt) {
              ut = Jt;
            }
            q.call(Ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Jt) {
            ut = Jt;
          }
          q();
        }
      } catch (Jt) {
        if (Jt && ut && typeof Jt.stack == "string") {
          for (var De = Jt.stack.split(`
`), Me = ut.stack.split(`
`), Tt = De.length - 1, Pt = Me.length - 1; Tt >= 1 && Pt >= 0 && De[Tt] !== Me[Pt]; )
            Pt--;
          for (; Tt >= 1 && Pt >= 0; Tt--, Pt--)
            if (De[Tt] !== Me[Pt]) {
              if (Tt !== 1 || Pt !== 1)
                do
                  if (Tt--, Pt--, Pt < 0 || De[Tt] !== Me[Pt]) {
                    var Ut = `
` + De[Tt].replace(" at new ", " at ");
                    return q.displayName && Ut.includes("<anonymous>") && (Ut = Ut.replace("<anonymous>", q.displayName)), typeof q == "function" && re.set(q, Ut), Ut;
                  }
                while (Tt >= 1 && Pt >= 0);
              break;
            }
        }
      } finally {
        ie = !1, ae.current = Ne, ee(), Error.prepareStackTrace = $t;
      }
      var Kt = q ? q.displayName || q.name : "", $n = Kt ? ue(Kt) : "";
      return typeof q == "function" && re.set(q, $n), $n;
    }
    function ge(q, Se, Re) {
      return ce(q, !1);
    }
    function G(q) {
      var Se = q.prototype;
      return !!(Se && Se.isReactComponent);
    }
    function ne(q, Se, Re) {
      if (q == null)
        return "";
      if (typeof q == "function")
        return ce(q, G(q));
      if (typeof q == "string")
        return ue(q);
      switch (q) {
        case u:
          return ue("Suspense");
        case f:
          return ue("SuspenseList");
      }
      if (typeof q == "object")
        switch (q.$$typeof) {
          case l:
            return ge(q.render);
          case p:
            return ne(q.type, Se, Re);
          case h: {
            var ut = q, $t = ut._payload, Ne = ut._init;
            try {
              return ne(Ne($t), Se, Re);
            } catch (Ie) {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, ye = {}, we = C.ReactDebugCurrentFrame;
    function he(q) {
      if (q) {
        var Se = q._owner, Re = ne(q.type, q._source, Se ? Se.type : null);
        we.setExtraStackFrame(Re);
      } else
        we.setExtraStackFrame(null);
    }
    function me(q, Se, Re, ut, $t) {
      {
        var Ne = Function.call.bind(fe);
        for (var Ie in q)
          if (Ne(q, Ie)) {
            var De = void 0;
            try {
              if (typeof q[Ie] != "function") {
                var Me = Error((ut || "React class") + ": " + Re + " type `" + Ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof q[Ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Me.name = "Invariant Violation", Me;
              }
              De = q[Ie](Se, Ie, ut, Re, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Tt) {
              De = Tt;
            }
            De && !(De instanceof Error) && (he($t), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ut || "React class", Re, Ie, typeof De), he(null)), De instanceof Error && !(De.message in ye) && (ye[De.message] = !0, he($t), x("Failed %s type: %s", Re, De.message), he(null));
          }
      }
    }
    var Ce = Array.isArray;
    function Te(q) {
      return Ce(q);
    }
    function Ee(q) {
      {
        var Se = typeof Symbol == "function" && Symbol.toStringTag, Re = Se && q[Symbol.toStringTag] || q.constructor.name || "Object";
        return Re;
      }
    }
    function Ge(q) {
      try {
        return ke(q), !1;
      } catch (Se) {
        return !0;
      }
    }
    function ke(q) {
      return "" + q;
    }
    function qe(q) {
      if (Ge(q))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ee(q)), ke(q);
    }
    var ze = C.ReactCurrentOwner, pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ke, et, Je;
    Je = {};
    function Et(q) {
      if (fe.call(q, "ref")) {
        var Se = Object.getOwnPropertyDescriptor(q, "ref").get;
        if (Se && Se.isReactWarning)
          return !1;
      }
      return q.ref !== void 0;
    }
    function Ye(q) {
      if (fe.call(q, "key")) {
        var Se = Object.getOwnPropertyDescriptor(q, "key").get;
        if (Se && Se.isReactWarning)
          return !1;
      }
      return q.key !== void 0;
    }
    function wt(q, Se) {
      if (typeof q.ref == "string" && ze.current && Se && ze.current.stateNode !== Se) {
        var Re = A(ze.current.type);
        Je[Re] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(ze.current.type), q.ref), Je[Re] = !0);
      }
    }
    function dt(q, Se) {
      {
        var Re = function() {
          Ke || (Ke = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Se));
        };
        Re.isReactWarning = !0, Object.defineProperty(q, "key", {
          get: Re,
          configurable: !0
        });
      }
    }
    function Ct(q, Se) {
      {
        var Re = function() {
          et || (et = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Se));
        };
        Re.isReactWarning = !0, Object.defineProperty(q, "ref", {
          get: Re,
          configurable: !0
        });
      }
    }
    var ot = function(q, Se, Re, ut, $t, Ne, Ie) {
      var De = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: q,
        key: Se,
        ref: Re,
        props: Ie,
        // Record the component responsible for creating this element.
        _owner: Ne
      };
      return De._store = {}, Object.defineProperty(De._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(De, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.defineProperty(De, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $t
      }), Object.freeze && (Object.freeze(De.props), Object.freeze(De)), De;
    };
    function jt(q, Se, Re, ut, $t) {
      {
        var Ne, Ie = {}, De = null, Me = null;
        Re !== void 0 && (qe(Re), De = "" + Re), Ye(Se) && (qe(Se.key), De = "" + Se.key), Et(Se) && (Me = Se.ref, wt(Se, $t));
        for (Ne in Se)
          fe.call(Se, Ne) && !pt.hasOwnProperty(Ne) && (Ie[Ne] = Se[Ne]);
        if (q && q.defaultProps) {
          var Tt = q.defaultProps;
          for (Ne in Tt)
            Ie[Ne] === void 0 && (Ie[Ne] = Tt[Ne]);
        }
        if (De || Me) {
          var Pt = typeof q == "function" ? q.displayName || q.name || "Unknown" : q;
          De && dt(Ie, Pt), Me && Ct(Ie, Pt);
        }
        return ot(q, De, Me, $t, ut, ze.current, Ie);
      }
    }
    var Rt = C.ReactCurrentOwner, Le = C.ReactDebugCurrentFrame;
    function Ve(q) {
      if (q) {
        var Se = q._owner, Re = ne(q.type, q._source, Se ? Se.type : null);
        Le.setExtraStackFrame(Re);
      } else
        Le.setExtraStackFrame(null);
    }
    var Ae;
    Ae = !1;
    function ft(q) {
      return typeof q == "object" && q !== null && q.$$typeof === t;
    }
    function He() {
      {
        if (Rt.current) {
          var q = A(Rt.current.type);
          if (q)
            return `

Check the render method of \`` + q + "`.";
        }
        return "";
      }
    }
    function Fe(q) {
      {
        if (q !== void 0) {
          var Se = q.fileName.replace(/^.*[\\\/]/, ""), Re = q.lineNumber;
          return `

Check your code at ` + Se + ":" + Re + ".";
        }
        return "";
      }
    }
    var yt = {};
    function Qe(q) {
      {
        var Se = He();
        if (!Se) {
          var Re = typeof q == "string" ? q : q.displayName || q.name;
          Re && (Se = `

Check the top-level render call using <` + Re + ">.");
        }
        return Se;
      }
    }
    function tt(q, Se) {
      {
        if (!q._store || q._store.validated || q.key != null)
          return;
        q._store.validated = !0;
        var Re = Qe(Se);
        if (yt[Re])
          return;
        yt[Re] = !0;
        var ut = "";
        q && q._owner && q._owner !== Rt.current && (ut = " It was passed a child from " + A(q._owner.type) + "."), Ve(q), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Re, ut), Ve(null);
      }
    }
    function lt(q, Se) {
      {
        if (typeof q != "object")
          return;
        if (Te(q))
          for (var Re = 0; Re < q.length; Re++) {
            var ut = q[Re];
            ft(ut) && tt(ut, Se);
          }
        else if (ft(q))
          q._store && (q._store.validated = !0);
        else if (q) {
          var $t = v(q);
          if (typeof $t == "function" && $t !== q.entries)
            for (var Ne = $t.call(q), Ie; !(Ie = Ne.next()).done; )
              ft(Ie.value) && tt(Ie.value, Se);
        }
      }
    }
    function ht(q) {
      {
        var Se = q.type;
        if (Se == null || typeof Se == "string")
          return;
        var Re;
        if (typeof Se == "function")
          Re = Se.propTypes;
        else if (typeof Se == "object" && (Se.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Se.$$typeof === p))
          Re = Se.propTypes;
        else
          return;
        if (Re) {
          var ut = A(Se);
          me(Re, q.props, "prop", ut, q);
        } else if (Se.PropTypes !== void 0 && !Ae) {
          Ae = !0;
          var $t = A(Se);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $t || "Unknown");
        }
        typeof Se.getDefaultProps == "function" && !Se.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function bt(q) {
      {
        for (var Se = Object.keys(q.props), Re = 0; Re < Se.length; Re++) {
          var ut = Se[Re];
          if (ut !== "children" && ut !== "key") {
            Ve(q), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ut), Ve(null);
            break;
          }
        }
        q.ref !== null && (Ve(q), x("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    function ct(q, Se, Re, ut, $t, Ne) {
      {
        var Ie = I(q);
        if (!Ie) {
          var De = "";
          (q === void 0 || typeof q == "object" && q !== null && Object.keys(q).length === 0) && (De += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Me = Fe($t);
          Me ? De += Me : De += He();
          var Tt;
          q === null ? Tt = "null" : Te(q) ? Tt = "array" : q !== void 0 && q.$$typeof === t ? (Tt = "<" + (A(q.type) || "Unknown") + " />", De = " Did you accidentally export a JSX literal instead of a component?") : Tt = typeof q, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Tt, De);
        }
        var Pt = jt(q, Se, Re, $t, Ne);
        if (Pt == null)
          return Pt;
        if (Ie) {
          var Ut = Se.children;
          if (Ut !== void 0)
            if (ut)
              if (Te(Ut)) {
                for (var Kt = 0; Kt < Ut.length; Kt++)
                  lt(Ut[Kt], q);
                Object.freeze && Object.freeze(Ut);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              lt(Ut, q);
        }
        return q === r ? bt(Pt) : ht(Pt), Pt;
      }
    }
    function xt(q, Se, Re) {
      return ct(q, Se, Re, !0);
    }
    function vt(q, Se, Re) {
      return ct(q, Se, Re, !1);
    }
    var _e = vt, Ze = xt;
    Au.Fragment = r, Au.jsx = _e, Au.jsxs = Ze;
  }()), Au;
}
process.env.NODE_ENV === "production" ? F0.exports = rA() : F0.exports = oA();
var B = F0.exports;
function n4(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: iA } = Object.prototype, { getPrototypeOf: qy } = Object, ig = /* @__PURE__ */ ((e) => (t) => {
  const n = iA.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ca = (e) => (e = e.toLowerCase(), (t) => ig(t) === e), ag = (e) => (t) => typeof t === e, { isArray: Xc } = Array, pd = ag("undefined");
function aA(e) {
  return e !== null && !pd(e) && e.constructor !== null && !pd(e.constructor) && bi(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const r4 = ca("ArrayBuffer");
function sA(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && r4(e.buffer), t;
}
const lA = ag("string"), bi = ag("function"), o4 = ag("number"), sg = (e) => e !== null && typeof e == "object", cA = (e) => e === !0 || e === !1, Wp = (e) => {
  if (ig(e) !== "object")
    return !1;
  const t = qy(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, uA = ca("Date"), dA = ca("File"), fA = ca("Blob"), pA = ca("FileList"), hA = (e) => sg(e) && bi(e.pipe), gA = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || bi(e.append) && ((t = ig(e)) === "formdata" || // detect form-data instance
  t === "object" && bi(e.toString) && e.toString() === "[object FormData]"));
}, mA = ca("URLSearchParams"), vA = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function zd(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Xc(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let s;
    for (r = 0; r < a; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function i4(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const a4 = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, s4 = (e) => !pd(e) && e !== a4;
function B0() {
  const { caseless: e } = s4(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && i4(t, o) || o;
    Wp(t[i]) && Wp(r) ? t[i] = B0(t[i], r) : Wp(r) ? t[i] = B0({}, r) : Xc(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && zd(arguments[r], n);
  return t;
}
const yA = (e, t, n, { allOwnKeys: r } = {}) => (zd(t, (o, i) => {
  n && bi(o) ? e[i] = n4(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), bA = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), CA = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, xA = (e, t, n, r) => {
  let o, i, a;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && qy(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, SA = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, wA = (e) => {
  if (!e)
    return null;
  if (Xc(e))
    return e;
  let t = e.length;
  if (!o4(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, EA = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && qy(Uint8Array)), $A = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, OA = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, _A = ca("HTMLFormElement"), NA = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), XS = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), PA = ca("RegExp"), l4 = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  zd(n, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (r[i] = a || o);
  }), Object.defineProperties(e, r);
}, IA = (e) => {
  l4(e, (t, n) => {
    if (bi(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (bi(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, RA = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return Xc(e) ? r(e) : r(String(e).split(t)), n;
}, DA = () => {
}, TA = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Sv = "abcdefghijklmnopqrstuvwxyz", ZS = "0123456789", c4 = {
  DIGIT: ZS,
  ALPHA: Sv,
  ALPHA_DIGIT: Sv + Sv.toUpperCase() + ZS
}, MA = (e = 16, t = c4.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function LA(e) {
  return !!(e && bi(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const AA = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (sg(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = Xc(r) ? [] : {};
        return zd(r, (a, s) => {
          const l = n(a, o + 1);
          !pd(l) && (i[s] = l);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, jA = ca("AsyncFunction"), kA = (e) => e && (sg(e) || bi(e)) && bi(e.then) && bi(e.catch), st = {
  isArray: Xc,
  isArrayBuffer: r4,
  isBuffer: aA,
  isFormData: gA,
  isArrayBufferView: sA,
  isString: lA,
  isNumber: o4,
  isBoolean: cA,
  isObject: sg,
  isPlainObject: Wp,
  isUndefined: pd,
  isDate: uA,
  isFile: dA,
  isBlob: fA,
  isRegExp: PA,
  isFunction: bi,
  isStream: hA,
  isURLSearchParams: mA,
  isTypedArray: EA,
  isFileList: pA,
  forEach: zd,
  merge: B0,
  extend: yA,
  trim: vA,
  stripBOM: bA,
  inherits: CA,
  toFlatObject: xA,
  kindOf: ig,
  kindOfTest: ca,
  endsWith: SA,
  toArray: wA,
  forEachEntry: $A,
  matchAll: OA,
  isHTMLForm: _A,
  hasOwnProperty: XS,
  hasOwnProp: XS,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: l4,
  freezeMethods: IA,
  toObjectSet: RA,
  toCamelCase: NA,
  noop: DA,
  toFiniteNumber: TA,
  findKey: i4,
  global: a4,
  isContextDefined: s4,
  ALPHABET: c4,
  generateString: MA,
  isSpecCompliantForm: LA,
  toJSONObject: AA,
  isAsyncFn: jA,
  isThenable: kA
};
function kn(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
st.inherits(kn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: st.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const u4 = kn.prototype, d4 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  d4[e] = { value: e };
});
Object.defineProperties(kn, d4);
Object.defineProperty(u4, "isAxiosError", { value: !0 });
kn.from = (e, t, n, r, o, i) => {
  const a = Object.create(u4);
  return st.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), kn.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const FA = null;
function H0(e) {
  return st.isPlainObject(e) || st.isArray(e);
}
function f4(e) {
  return st.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function QS(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = f4(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function BA(e) {
  return st.isArray(e) && !e.some(H0);
}
const HA = st.toFlatObject(st, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function lg(e, t, n) {
  if (!st.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = st.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, v) {
    return !st.isUndefined(v[m]);
  });
  const r = n.metaTokens, o = n.visitor || f, i = n.dots, a = n.indexes, l = (n.Blob || typeof Blob != "undefined" && Blob) && st.isSpecCompliantForm(t);
  if (!st.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(b) {
    if (b === null)
      return "";
    if (st.isDate(b))
      return b.toISOString();
    if (!l && st.isBlob(b))
      throw new kn("Blob is not supported. Use a Buffer instead.");
    return st.isArrayBuffer(b) || st.isTypedArray(b) ? l && typeof Blob == "function" ? new Blob([b]) : Buffer.from(b) : b;
  }
  function f(b, m, v) {
    let C = b;
    if (b && !v && typeof b == "object") {
      if (st.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), b = JSON.stringify(b);
      else if (st.isArray(b) && BA(b) || (st.isFileList(b) || st.endsWith(m, "[]")) && (C = st.toArray(b)))
        return m = f4(m), C.forEach(function(S, E) {
          !(st.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? QS([m], E, i) : a === null ? m : m + "[]",
            u(S)
          );
        }), !1;
    }
    return H0(b) ? !0 : (t.append(QS(v, m, i), u(b)), !1);
  }
  const p = [], h = Object.assign(HA, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: H0
  });
  function y(b, m) {
    if (!st.isUndefined(b)) {
      if (p.indexOf(b) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      p.push(b), st.forEach(b, function(C, x) {
        (!(st.isUndefined(C) || C === null) && o.call(
          t,
          C,
          st.isString(x) ? x.trim() : x,
          m,
          h
        )) === !0 && y(C, m ? m.concat(x) : [x]);
      }), p.pop();
    }
  }
  if (!st.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function JS(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Yy(e, t) {
  this._pairs = [], e && lg(e, this, t);
}
const p4 = Yy.prototype;
p4.append = function(t, n) {
  this._pairs.push([t, n]);
};
p4.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, JS);
  } : JS;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function zA(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function h4(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || zA, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = st.isURLSearchParams(t) ? t.toString() : new Yy(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class e2 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    st.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const g4 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, VA = typeof URLSearchParams != "undefined" ? URLSearchParams : Yy, WA = typeof FormData != "undefined" ? FormData : null, KA = typeof Blob != "undefined" ? Blob : null, UA = {
  isBrowser: !0,
  classes: {
    URLSearchParams: VA,
    FormData: WA,
    Blob: KA
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, m4 = typeof window != "undefined" && typeof document != "undefined", GA = ((e) => m4 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator != "undefined" && navigator.product), qA = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", YA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: m4,
  hasStandardBrowserEnv: GA,
  hasStandardBrowserWebWorkerEnv: qA
}, Symbol.toStringTag, { value: "Module" })), aa = je(je({}, YA), UA);
function XA(e, t) {
  return lg(e, new aa.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return aa.isNode && st.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function ZA(e) {
  return st.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function QA(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function v4(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    if (a === "__proto__")
      return !0;
    const s = Number.isFinite(+a), l = i >= n.length;
    return a = !a && st.isArray(o) ? o.length : a, l ? (st.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !s) : ((!o[a] || !st.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && st.isArray(o[a]) && (o[a] = QA(o[a])), !s);
  }
  if (st.isFormData(e) && st.isFunction(e.entries)) {
    const n = {};
    return st.forEachEntry(e, (r, o) => {
      t(ZA(r), o, n, 0);
    }), n;
  }
  return null;
}
function JA(e, t, n) {
  if (st.isString(e))
    try {
      return (t || JSON.parse)(e), st.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Xy = {
  transitional: g4,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = st.isObject(t);
    if (i && st.isHTMLForm(t) && (t = new FormData(t)), st.isFormData(t))
      return o ? JSON.stringify(v4(t)) : t;
    if (st.isArrayBuffer(t) || st.isBuffer(t) || st.isStream(t) || st.isFile(t) || st.isBlob(t))
      return t;
    if (st.isArrayBufferView(t))
      return t.buffer;
    if (st.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return XA(t, this.formSerializer).toString();
      if ((s = st.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return lg(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), JA(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Xy.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (t && st.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? kn.from(s, kn.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: aa.classes.FormData,
    Blob: aa.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
st.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Xy.headers[e] = {};
});
const Zy = Xy, ej = st.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), tj = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && ej[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, t2 = Symbol("internals");
function ju(e) {
  return e && String(e).trim().toLowerCase();
}
function Kp(e) {
  return e === !1 || e == null ? e : st.isArray(e) ? e.map(Kp) : String(e);
}
function nj(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const rj = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function wv(e, t, n, r, o) {
  if (st.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!st.isString(t)) {
    if (st.isString(r))
      return t.indexOf(r) !== -1;
    if (st.isRegExp(r))
      return r.test(t);
  }
}
function oj(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function ij(e, t) {
  const n = st.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class cg {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(s, l, u) {
      const f = ju(l);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const p = st.findKey(o, f);
      (!p || o[p] === void 0 || u === !0 || u === void 0 && o[p] !== !1) && (o[p || l] = Kp(s));
    }
    const a = (s, l) => st.forEach(s, (u, f) => i(u, f, l));
    return st.isPlainObject(t) || t instanceof this.constructor ? a(t, n) : st.isString(t) && (t = t.trim()) && !rj(t) ? a(tj(t), n) : t != null && i(n, t, r), this;
  }
  get(t, n) {
    if (t = ju(t), t) {
      const r = st.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return nj(o);
        if (st.isFunction(n))
          return n.call(this, o, r);
        if (st.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = ju(t), t) {
      const r = st.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || wv(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = ju(a), a) {
        const s = st.findKey(r, a);
        s && (!n || wv(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return st.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || wv(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return st.forEach(this, (o, i) => {
      const a = st.findKey(r, i);
      if (a) {
        n[a] = Kp(o), delete n[i];
        return;
      }
      const s = t ? oj(i) : String(i).trim();
      s !== i && delete n[i], n[s] = Kp(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return st.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && st.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[t2] = this[t2] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const s = ju(a);
      r[s] || (ij(o, a), r[s] = !0);
    }
    return st.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
cg.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
st.reduceDescriptors(cg.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
st.freezeMethods(cg);
const ja = cg;
function Ev(e, t) {
  const n = this || Zy, r = t || n, o = ja.from(r.headers);
  let i = r.data;
  return st.forEach(e, function(s) {
    i = s.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function y4(e) {
  return !!(e && e.__CANCEL__);
}
function Vd(e, t, n) {
  kn.call(this, e == null ? "canceled" : e, kn.ERR_CANCELED, t, n), this.name = "CanceledError";
}
st.inherits(Vd, kn, {
  __CANCEL__: !0
});
function aj(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new kn(
    "Request failed with status code " + n.status,
    [kn.ERR_BAD_REQUEST, kn.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const sj = aa.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      st.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), st.isString(r) && a.push("path=" + r), st.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function lj(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function cj(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function b4(e, t) {
  return e && !lj(t) ? cj(e, t) : t;
}
const uj = aa.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let a = i;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const s = st.isString(a) ? o(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function dj(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function fj(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), f = r[i];
    a || (a = u), n[o] = l, r[o] = u;
    let p = i, h = 0;
    for (; p !== o; )
      h += n[p++], p = p % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), u - a < t)
      return;
    const y = f && u - f;
    return y ? Math.round(h * 1e3 / y) : void 0;
  };
}
function n2(e, t) {
  let n = 0;
  const r = fj(50, 250);
  return (o) => {
    const i = o.loaded, a = o.lengthComputable ? o.total : void 0, s = i - n, l = r(s), u = i <= a;
    n = i;
    const f = {
      loaded: i,
      total: a,
      progress: a ? i / a : void 0,
      bytes: s,
      rate: l || void 0,
      estimated: l && a && u ? (a - i) / l : void 0,
      event: o
    };
    f[t ? "download" : "upload"] = !0, e(f);
  };
}
const pj = typeof XMLHttpRequest != "undefined", hj = pj && function(e) {
  return new Promise(function(n, r) {
    let o = e.data;
    const i = ja.from(e.headers).normalize();
    let { responseType: a, withXSRFToken: s } = e, l;
    function u() {
      e.cancelToken && e.cancelToken.unsubscribe(l), e.signal && e.signal.removeEventListener("abort", l);
    }
    let f;
    if (st.isFormData(o)) {
      if (aa.hasStandardBrowserEnv || aa.hasStandardBrowserWebWorkerEnv)
        i.setContentType(!1);
      else if ((f = i.getContentType()) !== !1) {
        const [m, ...v] = f ? f.split(";").map((C) => C.trim()).filter(Boolean) : [];
        i.setContentType([m || "multipart/form-data", ...v].join("; "));
      }
    }
    let p = new XMLHttpRequest();
    if (e.auth) {
      const m = e.auth.username || "", v = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(m + ":" + v));
    }
    const h = b4(e.baseURL, e.url);
    p.open(e.method.toUpperCase(), h4(h, e.params, e.paramsSerializer), !0), p.timeout = e.timeout;
    function y() {
      if (!p)
        return;
      const m = ja.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), C = {
        data: !a || a === "text" || a === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: m,
        config: e,
        request: p
      };
      aj(function(S) {
        n(S), u();
      }, function(S) {
        r(S), u();
      }, C), p = null;
    }
    if ("onloadend" in p ? p.onloadend = y : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, p.onabort = function() {
      p && (r(new kn("Request aborted", kn.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function() {
      r(new kn("Network Error", kn.ERR_NETWORK, e, p)), p = null;
    }, p.ontimeout = function() {
      let v = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const C = e.transitional || g4;
      e.timeoutErrorMessage && (v = e.timeoutErrorMessage), r(new kn(
        v,
        C.clarifyTimeoutError ? kn.ETIMEDOUT : kn.ECONNABORTED,
        e,
        p
      )), p = null;
    }, aa.hasStandardBrowserEnv && (s && st.isFunction(s) && (s = s(e)), s || s !== !1 && uj(h))) {
      const m = e.xsrfHeaderName && e.xsrfCookieName && sj.read(e.xsrfCookieName);
      m && i.set(e.xsrfHeaderName, m);
    }
    o === void 0 && i.setContentType(null), "setRequestHeader" in p && st.forEach(i.toJSON(), function(v, C) {
      p.setRequestHeader(C, v);
    }), st.isUndefined(e.withCredentials) || (p.withCredentials = !!e.withCredentials), a && a !== "json" && (p.responseType = e.responseType), typeof e.onDownloadProgress == "function" && p.addEventListener("progress", n2(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", n2(e.onUploadProgress)), (e.cancelToken || e.signal) && (l = (m) => {
      p && (r(!m || m.type ? new Vd(null, e, p) : m), p.abort(), p = null);
    }, e.cancelToken && e.cancelToken.subscribe(l), e.signal && (e.signal.aborted ? l() : e.signal.addEventListener("abort", l)));
    const b = dj(h);
    if (b && aa.protocols.indexOf(b) === -1) {
      r(new kn("Unsupported protocol " + b + ":", kn.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(o || null);
  });
}, z0 = {
  http: FA,
  xhr: hj
};
st.forEach(z0, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (n) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const r2 = (e) => `- ${e}`, gj = (e) => st.isFunction(e) || e === null || e === !1, C4 = {
  getAdapter: (e) => {
    e = st.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let a;
      if (r = n, !gj(n) && (r = z0[(a = String(n)).toLowerCase()], r === void 0))
        throw new kn(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(r2).join(`
`) : " " + r2(i[0]) : "as no adapter specified";
      throw new kn(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: z0
};
function $v(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Vd(null, e);
}
function o2(e) {
  return $v(e), e.headers = ja.from(e.headers), e.data = Ev.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), C4.getAdapter(e.adapter || Zy.adapter)(e).then(function(r) {
    return $v(e), r.data = Ev.call(
      e,
      e.transformResponse,
      r
    ), r.headers = ja.from(r.headers), r;
  }, function(r) {
    return y4(r) || ($v(e), r && r.response && (r.response.data = Ev.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = ja.from(r.response.headers))), Promise.reject(r);
  });
}
const i2 = (e) => e instanceof ja ? je({}, e) : e;
function Rc(e, t) {
  t = t || {};
  const n = {};
  function r(u, f, p) {
    return st.isPlainObject(u) && st.isPlainObject(f) ? st.merge.call({ caseless: p }, u, f) : st.isPlainObject(f) ? st.merge({}, f) : st.isArray(f) ? f.slice() : f;
  }
  function o(u, f, p) {
    if (st.isUndefined(f)) {
      if (!st.isUndefined(u))
        return r(void 0, u, p);
    } else
      return r(u, f, p);
  }
  function i(u, f) {
    if (!st.isUndefined(f))
      return r(void 0, f);
  }
  function a(u, f) {
    if (st.isUndefined(f)) {
      if (!st.isUndefined(u))
        return r(void 0, u);
    } else
      return r(void 0, f);
  }
  function s(u, f, p) {
    if (p in t)
      return r(u, f);
    if (p in e)
      return r(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (u, f) => o(i2(u), i2(f), !0)
  };
  return st.forEach(Object.keys(Object.assign({}, e, t)), function(f) {
    const p = l[f] || o, h = p(e[f], t[f], f);
    st.isUndefined(h) && p !== s || (n[f] = h);
  }), n;
}
const x4 = "1.6.8", Qy = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Qy[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const a2 = {};
Qy.transitional = function(t, n, r) {
  function o(i, a) {
    return "[Axios v" + x4 + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, s) => {
    if (t === !1)
      throw new kn(
        o(a, " has been removed" + (n ? " in " + n : "")),
        kn.ERR_DEPRECATED
      );
    return n && !a2[a] && (a2[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function mj(e, t, n) {
  if (typeof e != "object")
    throw new kn("options must be an object", kn.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const s = e[i], l = s === void 0 || a(s, i, e);
      if (l !== !0)
        throw new kn("option " + i + " must be " + l, kn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new kn("Unknown option " + i, kn.ERR_BAD_OPTION);
  }
}
const V0 = {
  assertOptions: mj,
  validators: Qy
}, ss = V0.validators;
class fh {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new e2(),
      response: new e2()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    return an(this, null, function* () {
      try {
        return yield this._request(t, n);
      } catch (r) {
        if (r instanceof Error) {
          let o;
          Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
          const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        }
        throw r;
      }
    });
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Rc(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && V0.assertOptions(r, {
      silentJSONParsing: ss.transitional(ss.boolean),
      forcedJSONParsing: ss.transitional(ss.boolean),
      clarifyTimeoutError: ss.transitional(ss.boolean)
    }, !1), o != null && (st.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : V0.assertOptions(o, {
      encode: ss.function,
      serialize: ss.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = i && st.merge(
      i.common,
      i[n.method]
    );
    i && st.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (b) => {
        delete i[b];
      }
    ), n.headers = ja.concat(a, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, s.unshift(m.fulfilled, m.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(m) {
      u.push(m.fulfilled, m.rejected);
    });
    let f, p = 0, h;
    if (!l) {
      const b = [o2.bind(this), void 0];
      for (b.unshift.apply(b, s), b.push.apply(b, u), h = b.length, f = Promise.resolve(n); p < h; )
        f = f.then(b[p++], b[p++]);
      return f;
    }
    h = s.length;
    let y = n;
    for (p = 0; p < h; ) {
      const b = s[p++], m = s[p++];
      try {
        y = b(y);
      } catch (v) {
        m.call(this, v);
        break;
      }
    }
    try {
      f = o2.call(this, y);
    } catch (b) {
      return Promise.reject(b);
    }
    for (p = 0, h = u.length; p < h; )
      f = f.then(u[p++], u[p++]);
    return f;
  }
  getUri(t) {
    t = Rc(this.defaults, t);
    const n = b4(t.baseURL, t.url);
    return h4(n, t.params, t.paramsSerializer);
  }
}
st.forEach(["delete", "get", "head", "options"], function(t) {
  fh.prototype[t] = function(n, r) {
    return this.request(Rc(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
st.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, s) {
      return this.request(Rc(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  fh.prototype[t] = n(), fh.prototype[t + "Form"] = n(!0);
});
const Up = fh;
class Jy {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, s) {
      r.reason || (r.reason = new Vd(i, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Jy(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const vj = Jy;
function yj(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function bj(e) {
  return st.isObject(e) && e.isAxiosError === !0;
}
const W0 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(W0).forEach(([e, t]) => {
  W0[t] = e;
});
const Cj = W0;
function S4(e) {
  const t = new Up(e), n = n4(Up.prototype.request, t);
  return st.extend(n, Up.prototype, t, { allOwnKeys: !0 }), st.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return S4(Rc(e, o));
  }, n;
}
const wr = S4(Zy);
wr.Axios = Up;
wr.CanceledError = Vd;
wr.CancelToken = vj;
wr.isCancel = y4;
wr.VERSION = x4;
wr.toFormData = lg;
wr.AxiosError = kn;
wr.Cancel = wr.CanceledError;
wr.all = function(t) {
  return Promise.all(t);
};
wr.spread = yj;
wr.isAxiosError = bj;
wr.mergeConfig = Rc;
wr.AxiosHeaders = ja;
wr.formToJSON = (e) => v4(st.isHTMLForm(e) ? new FormData(e) : e);
wr.getAdapter = C4.getAdapter;
wr.HttpStatusCode = Cj;
wr.default = wr;
const Fo = wr.create({
  baseURL: "https://api.staging.base.cropwise.com",
  timeout: 6e4,
  headers: {
    "Content-Type": "application/json"
  }
}), ph = wr.create({
  baseURL: "https://api.staging.beta.base.strider.ag",
  timeout: 6e4,
  headers: {
    "Content-Type": "application/json"
  }
}), hh = wr.create({
  baseURL: "https://api.staging.beta.protector.strider.ag",
  timeout: 6e4,
  headers: {
    "Content-Type": "application/json"
  }
}), s2 = wr.create({
  baseURL: "https://api.staging.protector.cropwise.com",
  timeout: 6e4,
  headers: {
    "Content-Type": "application/json"
  }
});
var ug = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, dg = typeof window == "undefined" || "Deno" in globalThis;
function Ii() {
}
function xj(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Sj(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function wj(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function l2(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ej(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function c2(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: o,
    predicate: i,
    queryKey: a,
    stale: s
  } = e;
  if (a) {
    if (r) {
      if (t.queryHash !== eb(a, t.options))
        return !1;
    } else if (!gd(t.queryKey, a))
      return !1;
  }
  if (n !== "all") {
    const l = t.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || o && o !== t.state.fetchStatus || i && !i(t));
}
function u2(e, t) {
  const { exact: n, status: r, predicate: o, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (hd(t.options.mutationKey) !== hd(i))
        return !1;
    } else if (!gd(t.options.mutationKey, i))
      return !1;
  }
  return !(r && t.state.status !== r || o && !o(t));
}
function eb(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || hd)(e);
}
function hd(e) {
  return JSON.stringify(
    e,
    (t, n) => U0(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n
  );
}
function gd(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !gd(e[n], t[n])) : !1;
}
function K0(e, t) {
  if (e === t)
    return e;
  const n = d2(e) && d2(t);
  if (n || U0(e) && U0(t)) {
    const r = n ? e : Object.keys(e), o = r.length, i = n ? t : Object.keys(t), a = i.length, s = n ? [] : {};
    let l = 0;
    for (let u = 0; u < a; u++) {
      const f = n ? u : i[u];
      (!n && r.includes(f) || n) && e[f] === void 0 && t[f] === void 0 ? (s[f] = void 0, l++) : (s[f] = K0(e[f], t[f]), s[f] === e[f] && e[f] !== void 0 && l++);
    }
    return o === a && l === o ? e : s;
  }
  return t;
}
function d2(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function U0(e) {
  if (!f2(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!f2(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function f2(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function $j(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Oj(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return K0(e, t);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        );
      }
    return K0(e, t);
  }
  return t;
}
function _j(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function Nj(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var gh = Symbol();
function w4(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === gh && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === gh ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var al, fs, Sc, U3, Pj = (U3 = class extends ug {
  constructor() {
    super();
    zn(this, al, void 0);
    zn(this, fs, void 0);
    zn(this, Sc, void 0);
    gn(this, Sc, (t) => {
      if (!dg && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    rt(this, fs) || this.setEventListener(rt(this, Sc));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = rt(this, fs)) == null || t.call(this), gn(this, fs, void 0));
  }
  setEventListener(t) {
    var n;
    gn(this, Sc, t), (n = rt(this, fs)) == null || n.call(this), gn(this, fs, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    rt(this, al) !== t && (gn(this, al, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof rt(this, al) == "boolean" ? rt(this, al) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, al = new WeakMap(), fs = new WeakMap(), Sc = new WeakMap(), U3), E4 = new Pj(), wc, ps, Ec, G3, Ij = (G3 = class extends ug {
  constructor() {
    super();
    zn(this, wc, !0);
    zn(this, ps, void 0);
    zn(this, Ec, void 0);
    gn(this, Ec, (t) => {
      if (!dg && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    rt(this, ps) || this.setEventListener(rt(this, Ec));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = rt(this, ps)) == null || t.call(this), gn(this, ps, void 0));
  }
  setEventListener(t) {
    var n;
    gn(this, Ec, t), (n = rt(this, ps)) == null || n.call(this), gn(this, ps, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    rt(this, wc) !== t && (gn(this, wc, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return rt(this, wc);
  }
}, wc = new WeakMap(), ps = new WeakMap(), Ec = new WeakMap(), G3), mh = new Ij();
function Rj() {
  let e, t;
  const n = new Promise((o, i) => {
    e = o, t = i;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(o) {
    Object.assign(n, o), delete n.resolve, delete n.reject;
  }
  return n.resolve = (o) => {
    r({
      status: "fulfilled",
      value: o
    }), e(o);
  }, n.reject = (o) => {
    r({
      status: "rejected",
      reason: o
    }), t(o);
  }, n;
}
function Dj(e) {
  return Math.min(1e3 * US(2, e), 3e4);
}
function $4(e) {
  return (e != null ? e : "online") === "online" ? mh.isOnline() : !0;
}
var O4 = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function Ov(e) {
  return e instanceof O4;
}
function _4(e) {
  let t = !1, n = 0, r = !1, o;
  const i = Rj(), a = (m) => {
    var v;
    r || (h(new O4(m)), (v = e.abort) == null || v.call(e));
  }, s = () => {
    t = !0;
  }, l = () => {
    t = !1;
  }, u = () => E4.isFocused() && (e.networkMode === "always" || mh.isOnline()) && e.canRun(), f = () => $4(e.networkMode) && e.canRun(), p = (m) => {
    var v;
    r || (r = !0, (v = e.onSuccess) == null || v.call(e, m), o == null || o(), i.resolve(m));
  }, h = (m) => {
    var v;
    r || (r = !0, (v = e.onError) == null || v.call(e, m), o == null || o(), i.reject(m));
  }, y = () => new Promise((m) => {
    var v;
    o = (C) => {
      (r || u()) && m(C);
    }, (v = e.onPause) == null || v.call(e);
  }).then(() => {
    var m;
    o = void 0, r || (m = e.onContinue) == null || m.call(e);
  }), b = () => {
    if (r)
      return;
    let m;
    const v = n === 0 ? e.initialPromise : void 0;
    try {
      m = v != null ? v : e.fn();
    } catch (C) {
      m = Promise.reject(C);
    }
    Promise.resolve(m).then(p).catch((C) => {
      var $, _, R;
      if (r)
        return;
      const x = ($ = e.retry) != null ? $ : dg ? 0 : 3, S = (_ = e.retryDelay) != null ? _ : Dj, E = typeof S == "function" ? S(n, C) : S, O = x === !0 || typeof x == "number" && n < x || typeof x == "function" && x(n, C);
      if (t || !O) {
        h(C);
        return;
      }
      n++, (R = e.onFail) == null || R.call(e, n, C), $j(E).then(() => u() ? void 0 : y()).then(() => {
        t ? h(C) : b();
      });
    });
  };
  return {
    promise: i,
    cancel: a,
    continue: () => (o == null || o(), i),
    cancelRetry: s,
    continueRetry: l,
    canStart: f,
    start: () => (f() ? b() : y().then(b), i)
  };
}
function Tj() {
  let e = [], t = 0, n = (s) => {
    s();
  }, r = (s) => {
    s();
  }, o = (s) => setTimeout(s, 0);
  const i = (s) => {
    t ? e.push(s) : o(() => {
      n(s);
    });
  }, a = () => {
    const s = e;
    e = [], s.length && o(() => {
      r(() => {
        s.forEach((l) => {
          n(l);
        });
      });
    });
  };
  return {
    batch: (s) => {
      let l;
      t++;
      try {
        l = s();
      } finally {
        t--, t || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (s) => (...l) => {
      i(() => {
        s(...l);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (s) => {
      n = s;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (s) => {
      r = s;
    },
    setScheduler: (s) => {
      o = s;
    }
  };
}
var No = Tj(), sl, q3, N4 = (q3 = class {
  constructor() {
    zn(this, sl, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Sj(this.gcTime) && gn(this, sl, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e != null ? e : dg ? 1 / 0 : 5 * 60 * 1e3
    );
  }
  clearGcTimeout() {
    rt(this, sl) && (clearTimeout(rt(this, sl)), gn(this, sl, void 0));
  }
}, sl = new WeakMap(), q3), $c, Oc, mi, ll, vo, Bd, cl, Ri, Na, Y3, Mj = (Y3 = class extends N4 {
  constructor(t) {
    var n;
    super();
    zn(this, Ri);
    zn(this, $c, void 0);
    zn(this, Oc, void 0);
    zn(this, mi, void 0);
    zn(this, ll, void 0);
    zn(this, vo, void 0);
    zn(this, Bd, void 0);
    zn(this, cl, void 0);
    gn(this, cl, !1), gn(this, Bd, t.defaultOptions), this.setOptions(t.options), this.observers = [], gn(this, ll, t.client), gn(this, mi, rt(this, ll).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, gn(this, $c, Aj(this.options)), this.state = (n = t.state) != null ? n : rt(this, $c), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = rt(this, vo)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = je(je({}, rt(this, Bd)), t), this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && rt(this, mi).remove(this);
  }
  setData(t, n) {
    const r = Oj(this.state.data, t, this.options);
    return mo(this, Ri, Na).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    mo(this, Ri, Na).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, o;
    const n = (r = rt(this, vo)) == null ? void 0 : r.promise;
    return (o = rt(this, vo)) == null || o.cancel(t), n ? n.then(Ii).catch(Ii) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(rt(this, $c));
  }
  isActive() {
    return this.observers.some(
      (t) => Ej(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === gh || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !wj(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = rt(this, vo)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = rt(this, vo)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), rt(this, mi).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (rt(this, vo) && (rt(this, cl) ? rt(this, vo).cancel({ revert: !0 }) : rt(this, vo).cancelRetry()), this.scheduleGc()), rt(this, mi).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || mo(this, Ri, Na).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var l, u, f;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (rt(this, vo))
        return rt(this, vo).continueRetry(), rt(this, vo).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const p = this.observers.find((h) => h.options.queryFn);
      p && this.setOptions(p.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), o = (p) => {
      Object.defineProperty(p, "signal", {
        enumerable: !0,
        get: () => (gn(this, cl, !0), r.signal)
      });
    }, i = () => {
      const p = w4(this.options, n), h = {
        client: rt(this, ll),
        queryKey: this.queryKey,
        meta: this.meta
      };
      return o(h), gn(this, cl, !1), this.options.persister ? this.options.persister(
        p,
        h,
        this
      ) : p(h);
    }, a = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      client: rt(this, ll),
      state: this.state,
      fetchFn: i
    };
    o(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), gn(this, Oc, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = a.fetchOptions) == null ? void 0 : u.meta)) && mo(this, Ri, Na).call(this, { type: "fetch", meta: (f = a.fetchOptions) == null ? void 0 : f.meta });
    const s = (p) => {
      var h, y, b, m;
      Ov(p) && p.silent || mo(this, Ri, Na).call(this, {
        type: "error",
        error: p
      }), Ov(p) || ((y = (h = rt(this, mi).config).onError) == null || y.call(
        h,
        p,
        this
      ), (m = (b = rt(this, mi).config).onSettled) == null || m.call(
        b,
        this.state.data,
        p,
        this
      )), this.scheduleGc();
    };
    return gn(this, vo, _4({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: a.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (p) => {
        var h, y, b, m;
        if (p === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), s(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(p);
        } catch (v) {
          s(v);
          return;
        }
        (y = (h = rt(this, mi).config).onSuccess) == null || y.call(h, p, this), (m = (b = rt(this, mi).config).onSettled) == null || m.call(
          b,
          p,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: s,
      onFail: (p, h) => {
        mo(this, Ri, Na).call(this, { type: "failed", failureCount: p, error: h });
      },
      onPause: () => {
        mo(this, Ri, Na).call(this, { type: "pause" });
      },
      onContinue: () => {
        mo(this, Ri, Na).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), rt(this, vo).start();
  }
}, $c = new WeakMap(), Oc = new WeakMap(), mi = new WeakMap(), ll = new WeakMap(), vo = new WeakMap(), Bd = new WeakMap(), cl = new WeakMap(), Ri = new WeakSet(), Na = function(t) {
  const n = (r) => {
    var o, i;
    switch (t.type) {
      case "failed":
        return Bt(je({}, r), {
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        });
      case "pause":
        return Bt(je({}, r), {
          fetchStatus: "paused"
        });
      case "continue":
        return Bt(je({}, r), {
          fetchStatus: "fetching"
        });
      case "fetch":
        return Bt(je(je({}, r), Lj(r.data, this.options)), {
          fetchMeta: (o = t.meta) != null ? o : null
        });
      case "success":
        return je(Bt(je({}, r), {
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: (i = t.dataUpdatedAt) != null ? i : Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success"
        }), !t.manual && {
          fetchStatus: "idle",
          fetchFailureCount: 0,
          fetchFailureReason: null
        });
      case "error":
        const a = t.error;
        return Ov(a) && a.revert && rt(this, Oc) ? Bt(je({}, rt(this, Oc)), { fetchStatus: "idle" }) : Bt(je({}, r), {
          error: a,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: a,
          fetchStatus: "idle",
          status: "error"
        });
      case "invalidate":
        return Bt(je({}, r), {
          isInvalidated: !0
        });
      case "setState":
        return je(je({}, r), t.state);
    }
  };
  this.state = n(this.state), No.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), rt(this, mi).notify({ query: this, type: "updated", action: t });
  });
}, Y3);
function Lj(e, t) {
  return je({
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: $4(t.networkMode) ? "fetching" : "paused"
  }, e === void 0 && {
    error: null,
    status: "pending"
  });
}
function Aj(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r != null ? r : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var na, X3, jj = (X3 = class extends ug {
  constructor(t = {}) {
    super();
    zn(this, na, void 0);
    this.config = t, gn(this, na, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    var s;
    const o = n.queryKey, i = (s = n.queryHash) != null ? s : eb(o, n);
    let a = this.get(i);
    return a || (a = new Mj({
      client: t,
      queryKey: o,
      queryHash: i,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(o)
    }), this.add(a)), a;
  }
  add(t) {
    rt(this, na).has(t.queryHash) || (rt(this, na).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = rt(this, na).get(t.queryHash);
    n && (t.destroy(), n === t && rt(this, na).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    No.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return rt(this, na).get(t);
  }
  getAll() {
    return [...rt(this, na).values()];
  }
  find(t) {
    const n = je({ exact: !0 }, t);
    return this.getAll().find(
      (r) => c2(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => c2(t, r)) : n;
  }
  notify(t) {
    No.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    No.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    No.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, na = new WeakMap(), X3), ra, Oo, ul, oa, cs, Z3, kj = (Z3 = class extends N4 {
  constructor(t) {
    super();
    zn(this, oa);
    zn(this, ra, void 0);
    zn(this, Oo, void 0);
    zn(this, ul, void 0);
    this.mutationId = t.mutationId, gn(this, Oo, t.mutationCache), gn(this, ra, []), this.state = t.state || Fj(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    rt(this, ra).includes(t) || (rt(this, ra).push(t), this.clearGcTimeout(), rt(this, Oo).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    gn(this, ra, rt(this, ra).filter((n) => n !== t)), this.scheduleGc(), rt(this, Oo).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    rt(this, ra).length || (this.state.status === "pending" ? this.scheduleGc() : rt(this, Oo).remove(this));
  }
  continue() {
    var t, n;
    return (n = (t = rt(this, ul)) == null ? void 0 : t.continue()) != null ? n : (
      // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
      this.execute(this.state.variables)
    );
  }
  execute(t) {
    return an(this, null, function* () {
      var o, i, a, s, l, u, f, p, h, y, b, m, v, C, x, S, E, O, $, _, R;
      gn(this, ul, _4({
        fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
        onFail: (P, I) => {
          mo(this, oa, cs).call(this, { type: "failed", failureCount: P, error: I });
        },
        onPause: () => {
          mo(this, oa, cs).call(this, { type: "pause" });
        },
        onContinue: () => {
          mo(this, oa, cs).call(this, { type: "continue" });
        },
        retry: (o = this.options.retry) != null ? o : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode,
        canRun: () => rt(this, Oo).canRun(this)
      }));
      const n = this.state.status === "pending", r = !rt(this, ul).canStart();
      try {
        if (!n) {
          mo(this, oa, cs).call(this, { type: "pending", variables: t, isPaused: r }), yield (a = (i = rt(this, Oo).config).onMutate) == null ? void 0 : a.call(
            i,
            t,
            this
          );
          const I = yield (l = (s = this.options).onMutate) == null ? void 0 : l.call(s, t);
          I !== this.state.context && mo(this, oa, cs).call(this, {
            type: "pending",
            context: I,
            variables: t,
            isPaused: r
          });
        }
        const P = yield rt(this, ul).start();
        return yield (f = (u = rt(this, Oo).config).onSuccess) == null ? void 0 : f.call(
          u,
          P,
          t,
          this.state.context,
          this
        ), yield (h = (p = this.options).onSuccess) == null ? void 0 : h.call(p, P, t, this.state.context), yield (b = (y = rt(this, Oo).config).onSettled) == null ? void 0 : b.call(
          y,
          P,
          null,
          this.state.variables,
          this.state.context,
          this
        ), yield (v = (m = this.options).onSettled) == null ? void 0 : v.call(m, P, null, t, this.state.context), mo(this, oa, cs).call(this, { type: "success", data: P }), P;
      } catch (P) {
        try {
          throw yield (x = (C = rt(this, Oo).config).onError) == null ? void 0 : x.call(
            C,
            P,
            t,
            this.state.context,
            this
          ), yield (E = (S = this.options).onError) == null ? void 0 : E.call(
            S,
            P,
            t,
            this.state.context
          ), yield ($ = (O = rt(this, Oo).config).onSettled) == null ? void 0 : $.call(
            O,
            void 0,
            P,
            this.state.variables,
            this.state.context,
            this
          ), yield (R = (_ = this.options).onSettled) == null ? void 0 : R.call(
            _,
            void 0,
            P,
            t,
            this.state.context
          ), P;
        } finally {
          mo(this, oa, cs).call(this, { type: "error", error: P });
        }
      } finally {
        rt(this, Oo).runNext(this);
      }
    });
  }
}, ra = new WeakMap(), Oo = new WeakMap(), ul = new WeakMap(), oa = new WeakSet(), cs = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return Bt(je({}, r), {
          failureCount: t.failureCount,
          failureReason: t.error
        });
      case "pause":
        return Bt(je({}, r), {
          isPaused: !0
        });
      case "continue":
        return Bt(je({}, r), {
          isPaused: !1
        });
      case "pending":
        return Bt(je({}, r), {
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        });
      case "success":
        return Bt(je({}, r), {
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        });
      case "error":
        return Bt(je({}, r), {
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        });
    }
  };
  this.state = n(this.state), No.batch(() => {
    rt(this, ra).forEach((r) => {
      r.onMutationUpdate(t);
    }), rt(this, Oo).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, Z3);
function Fj() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ta, Di, Hd, Q3, Bj = (Q3 = class extends ug {
  constructor(t = {}) {
    super();
    zn(this, Ta, void 0);
    zn(this, Di, void 0);
    zn(this, Hd, void 0);
    this.config = t, gn(this, Ta, /* @__PURE__ */ new Set()), gn(this, Di, /* @__PURE__ */ new Map()), gn(this, Hd, 0);
  }
  build(t, n, r) {
    const o = new kj({
      mutationCache: this,
      mutationId: ++cp(this, Hd)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(o), o;
  }
  add(t) {
    rt(this, Ta).add(t);
    const n = up(t);
    if (typeof n == "string") {
      const r = rt(this, Di).get(n);
      r ? r.push(t) : rt(this, Di).set(n, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (rt(this, Ta).delete(t)) {
      const n = up(t);
      if (typeof n == "string") {
        const r = rt(this, Di).get(n);
        if (r)
          if (r.length > 1) {
            const o = r.indexOf(t);
            o !== -1 && r.splice(o, 1);
          } else
            r[0] === t && rt(this, Di).delete(n);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const n = up(t);
    if (typeof n == "string") {
      const r = rt(this, Di).get(n), o = r == null ? void 0 : r.find(
        (i) => i.state.status === "pending"
      );
      return !o || o === t;
    } else
      return !0;
  }
  runNext(t) {
    var r, o;
    const n = up(t);
    if (typeof n == "string") {
      const i = (r = rt(this, Di).get(n)) == null ? void 0 : r.find((a) => a !== t && a.state.isPaused);
      return (o = i == null ? void 0 : i.continue()) != null ? o : Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    No.batch(() => {
      rt(this, Ta).forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), rt(this, Ta).clear(), rt(this, Di).clear();
    });
  }
  getAll() {
    return Array.from(rt(this, Ta));
  }
  find(t) {
    const n = je({ exact: !0 }, t);
    return this.getAll().find(
      (r) => u2(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => u2(t, n));
  }
  notify(t) {
    No.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return No.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(Ii))
      )
    );
  }
}, Ta = new WeakMap(), Di = new WeakMap(), Hd = new WeakMap(), Q3);
function up(e) {
  var t;
  return (t = e.options.scope) == null ? void 0 : t.id;
}
function p2(e) {
  return {
    onFetch: (t, n) => {
      var f, p, h, y, b;
      const r = t.options, o = (h = (p = (f = t.fetchOptions) == null ? void 0 : f.meta) == null ? void 0 : p.fetchMore) == null ? void 0 : h.direction, i = ((y = t.state.data) == null ? void 0 : y.pages) || [], a = ((b = t.state.data) == null ? void 0 : b.pageParams) || [];
      let s = { pages: [], pageParams: [] }, l = 0;
      const u = () => an(this, null, function* () {
        var S;
        let m = !1;
        const v = (E) => {
          Object.defineProperty(E, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? m = !0 : t.signal.addEventListener("abort", () => {
              m = !0;
            }), t.signal)
          });
        }, C = w4(t.options, t.fetchOptions), x = (E, O, $) => an(this, null, function* () {
          if (m)
            return Promise.reject();
          if (O == null && E.pages.length)
            return Promise.resolve(E);
          const _ = {
            client: t.client,
            queryKey: t.queryKey,
            pageParam: O,
            direction: $ ? "backward" : "forward",
            meta: t.options.meta
          };
          v(_);
          const R = yield C(
            _
          ), { maxPages: P } = t.options, I = $ ? Nj : _j;
          return {
            pages: I(E.pages, R, P),
            pageParams: I(E.pageParams, O, P)
          };
        });
        if (o && i.length) {
          const E = o === "backward", O = E ? Hj : h2, $ = {
            pages: i,
            pageParams: a
          }, _ = O(r, $);
          s = yield x($, _, E);
        } else {
          const E = e != null ? e : i.length;
          do {
            const O = l === 0 ? (S = a[0]) != null ? S : r.initialPageParam : h2(r, s);
            if (l > 0 && O == null)
              break;
            s = yield x(s, O), l++;
          } while (l < E);
        }
        return s;
      });
      t.options.persister ? t.fetchFn = () => {
        var m, v;
        return (v = (m = t.options).persister) == null ? void 0 : v.call(
          m,
          u,
          {
            client: t.client,
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = u;
    }
  };
}
function h2(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function Hj(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var Pr, hs, gs, _c, Nc, ms, Pc, Ic, J3, zj = (J3 = class {
  constructor(e = {}) {
    zn(this, Pr, void 0);
    zn(this, hs, void 0);
    zn(this, gs, void 0);
    zn(this, _c, void 0);
    zn(this, Nc, void 0);
    zn(this, ms, void 0);
    zn(this, Pc, void 0);
    zn(this, Ic, void 0);
    gn(this, Pr, e.queryCache || new jj()), gn(this, hs, e.mutationCache || new Bj()), gn(this, gs, e.defaultOptions || {}), gn(this, _c, /* @__PURE__ */ new Map()), gn(this, Nc, /* @__PURE__ */ new Map()), gn(this, ms, 0);
  }
  mount() {
    cp(this, ms)._++, rt(this, ms) === 1 && (gn(this, Pc, E4.subscribe((e) => an(this, null, function* () {
      e && (yield this.resumePausedMutations(), rt(this, Pr).onFocus());
    }))), gn(this, Ic, mh.subscribe((e) => an(this, null, function* () {
      e && (yield this.resumePausedMutations(), rt(this, Pr).onOnline());
    }))));
  }
  unmount() {
    var e, t;
    cp(this, ms)._--, rt(this, ms) === 0 && ((e = rt(this, Pc)) == null || e.call(this), gn(this, Pc, void 0), (t = rt(this, Ic)) == null || t.call(this), gn(this, Ic, void 0));
  }
  isFetching(e) {
    return rt(this, Pr).findAll(Bt(je({}, e), { fetchStatus: "fetching" })).length;
  }
  isMutating(e) {
    return rt(this, hs).findAll(Bt(je({}, e), { status: "pending" })).length;
  }
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = rt(this, Pr).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), n = rt(this, Pr).build(this, t), r = n.state.data;
    return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(l2(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
  }
  getQueriesData(e) {
    return rt(this, Pr).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), o = rt(this, Pr).get(
      r.queryHash
    ), i = o == null ? void 0 : o.state.data, a = xj(t, i);
    if (a !== void 0)
      return rt(this, Pr).build(this, r).setData(a, Bt(je({}, n), { manual: !0 }));
  }
  setQueriesData(e, t, n) {
    return No.batch(
      () => rt(this, Pr).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = rt(this, Pr).get(
      t.queryHash
    )) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = rt(this, Pr);
    No.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = rt(this, Pr), r = je({
      type: "active"
    }, e);
    return No.batch(() => (n.findAll(e).forEach((o) => {
      o.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e, t = {}) {
    const n = je({ revert: !0 }, t), r = No.batch(
      () => rt(this, Pr).findAll(e).map((o) => o.cancel(n))
    );
    return Promise.all(r).then(Ii).catch(Ii);
  }
  invalidateQueries(e, t = {}) {
    return No.batch(() => {
      var r, o;
      if (rt(this, Pr).findAll(e).forEach((i) => {
        i.invalidate();
      }), (e == null ? void 0 : e.refetchType) === "none")
        return Promise.resolve();
      const n = Bt(je({}, e), {
        type: (o = (r = e == null ? void 0 : e.refetchType) != null ? r : e == null ? void 0 : e.type) != null ? o : "active"
      });
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e, t = {}) {
    var o;
    const n = Bt(je({}, t), {
      cancelRefetch: (o = t.cancelRefetch) != null ? o : !0
    }), r = No.batch(
      () => rt(this, Pr).findAll(e).filter((i) => !i.isDisabled()).map((i) => {
        let a = i.fetch(void 0, n);
        return n.throwOnError || (a = a.catch(Ii)), i.state.fetchStatus === "paused" ? Promise.resolve() : a;
      })
    );
    return Promise.all(r).then(Ii);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = rt(this, Pr).build(this, t);
    return n.isStaleByTime(
      l2(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Ii).catch(Ii);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = p2(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Ii).catch(Ii);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = p2(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return mh.isOnline() ? rt(this, hs).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return rt(this, Pr);
  }
  getMutationCache() {
    return rt(this, hs);
  }
  getDefaultOptions() {
    return rt(this, gs);
  }
  setDefaultOptions(e) {
    gn(this, gs, e);
  }
  setQueryDefaults(e, t) {
    rt(this, _c).set(hd(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...rt(this, _c).values()], n = {};
    return t.forEach((r) => {
      gd(e, r.queryKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  setMutationDefaults(e, t) {
    rt(this, Nc).set(hd(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...rt(this, Nc).values()];
    let n = {};
    return t.forEach((r) => {
      gd(e, r.mutationKey) && (n = je(je({}, n), r.defaultOptions));
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = Bt(je(je(je({}, rt(this, gs).queries), this.getQueryDefaults(e.queryKey)), e), {
      _defaulted: !0
    });
    return t.queryHash || (t.queryHash = eb(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === gh && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : Bt(je(je(je({}, rt(this, gs).mutations), (e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey)), e), {
      _defaulted: !0
    });
  }
  clear() {
    rt(this, Pr).clear(), rt(this, hs).clear();
  }
}, Pr = new WeakMap(), hs = new WeakMap(), gs = new WeakMap(), _c = new WeakMap(), Nc = new WeakMap(), ms = new WeakMap(), Pc = new WeakMap(), Ic = new WeakMap(), J3), Vj = c.createContext(
  void 0
), Wj = ({
  client: e,
  children: t
}) => (c.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ B.jsx(Vj.Provider, { value: e, children: t })), P4 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(P4);
var Kj = P4.exports;
const se = /* @__PURE__ */ Vi(Kj);
function Oe() {
  return Oe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oe.apply(this, arguments);
}
var G0 = { exports: {} }, Yn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g2;
function Uj() {
  if (g2)
    return Yn;
  g2 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function m(v) {
    if (typeof v == "object" && v !== null) {
      var C = v.$$typeof;
      switch (C) {
        case e:
          switch (v = v.type, v) {
            case n:
            case o:
            case r:
            case u:
            case f:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case a:
                case l:
                case h:
                case p:
                case i:
                  return v;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return Yn.ContextConsumer = a, Yn.ContextProvider = i, Yn.Element = e, Yn.ForwardRef = l, Yn.Fragment = n, Yn.Lazy = h, Yn.Memo = p, Yn.Portal = t, Yn.Profiler = o, Yn.StrictMode = r, Yn.Suspense = u, Yn.SuspenseList = f, Yn.isAsyncMode = function() {
    return !1;
  }, Yn.isConcurrentMode = function() {
    return !1;
  }, Yn.isContextConsumer = function(v) {
    return m(v) === a;
  }, Yn.isContextProvider = function(v) {
    return m(v) === i;
  }, Yn.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, Yn.isForwardRef = function(v) {
    return m(v) === l;
  }, Yn.isFragment = function(v) {
    return m(v) === n;
  }, Yn.isLazy = function(v) {
    return m(v) === h;
  }, Yn.isMemo = function(v) {
    return m(v) === p;
  }, Yn.isPortal = function(v) {
    return m(v) === t;
  }, Yn.isProfiler = function(v) {
    return m(v) === o;
  }, Yn.isStrictMode = function(v) {
    return m(v) === r;
  }, Yn.isSuspense = function(v) {
    return m(v) === u;
  }, Yn.isSuspenseList = function(v) {
    return m(v) === f;
  }, Yn.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === o || v === r || v === u || v === f || v === y || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === p || v.$$typeof === i || v.$$typeof === a || v.$$typeof === l || v.$$typeof === b || v.getModuleId !== void 0);
  }, Yn.typeOf = m, Yn;
}
var Xn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m2;
function Gj() {
  return m2 || (m2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), b = !1, m = !1, v = !1, C = !1, x = !1, S;
    S = Symbol.for("react.module.reference");
    function E(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === n || G === o || x || G === r || G === u || G === f || C || G === y || b || m || v || typeof G == "object" && G !== null && (G.$$typeof === h || G.$$typeof === p || G.$$typeof === i || G.$$typeof === a || G.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === S || G.getModuleId !== void 0));
    }
    function O(G) {
      if (typeof G == "object" && G !== null) {
        var ne = G.$$typeof;
        switch (ne) {
          case e:
            var fe = G.type;
            switch (fe) {
              case n:
              case o:
              case r:
              case u:
              case f:
                return fe;
              default:
                var ye = fe && fe.$$typeof;
                switch (ye) {
                  case s:
                  case a:
                  case l:
                  case h:
                  case p:
                  case i:
                    return ye;
                  default:
                    return ne;
                }
            }
          case t:
            return ne;
        }
      }
    }
    var $ = a, _ = i, R = e, P = l, I = n, j = h, F = p, A = t, M = o, N = r, D = u, T = f, L = !1, z = !1;
    function H(G) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(G) {
      return z || (z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(G) {
      return O(G) === a;
    }
    function Z(G) {
      return O(G) === i;
    }
    function oe(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function ee(G) {
      return O(G) === l;
    }
    function ae(G) {
      return O(G) === n;
    }
    function le(G) {
      return O(G) === h;
    }
    function ue(G) {
      return O(G) === p;
    }
    function ie(G) {
      return O(G) === t;
    }
    function re(G) {
      return O(G) === o;
    }
    function Q(G) {
      return O(G) === r;
    }
    function ce(G) {
      return O(G) === u;
    }
    function ge(G) {
      return O(G) === f;
    }
    Xn.ContextConsumer = $, Xn.ContextProvider = _, Xn.Element = R, Xn.ForwardRef = P, Xn.Fragment = I, Xn.Lazy = j, Xn.Memo = F, Xn.Portal = A, Xn.Profiler = M, Xn.StrictMode = N, Xn.Suspense = D, Xn.SuspenseList = T, Xn.isAsyncMode = H, Xn.isConcurrentMode = V, Xn.isContextConsumer = Y, Xn.isContextProvider = Z, Xn.isElement = oe, Xn.isForwardRef = ee, Xn.isFragment = ae, Xn.isLazy = le, Xn.isMemo = ue, Xn.isPortal = ie, Xn.isProfiler = re, Xn.isStrictMode = Q, Xn.isSuspense = ce, Xn.isSuspenseList = ge, Xn.isValidElementType = E, Xn.typeOf = O;
  }()), Xn;
}
process.env.NODE_ENV === "production" ? G0.exports = Uj() : G0.exports = Gj();
var tb = G0.exports;
function Rr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return be.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(Rr(r)) : tb.isFragment(r) && r.props ? n = n.concat(Rr(r.props.children, t)) : n.push(r));
  }), n;
}
var q0 = {}, nb = [], qj = function(t) {
  nb.push(t);
};
function pl(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = nb.reduce(function(r, o) {
      return o(r != null ? r : "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function Yj(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = nb.reduce(function(r, o) {
      return o(r != null ? r : "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function I4() {
  q0 = {};
}
function R4(e, t, n) {
  !t && !q0[n] && (e(!1, n), q0[n] = !0);
}
function mt(e, t) {
  R4(pl, e, t);
}
function vh(e, t) {
  R4(Yj, e, t);
}
mt.preMessage = qj;
mt.resetWarned = I4;
mt.noteOnce = vh;
function Vt(e) {
  "@babel/helpers - typeof";
  return Vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vt(e);
}
function Xj(e, t) {
  if (Vt(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Vt(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function D4(e) {
  var t = Xj(e, "string");
  return Vt(t) == "symbol" ? t : String(t);
}
function K(e, t, n) {
  return t = D4(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function v2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function J(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? v2(Object(n), !0).forEach(function(r) {
      K(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function yh(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function Ju(e) {
  return yh(e) ? e : e instanceof be.Component ? j0.findDOMNode(e) : null;
}
function ua(e, t, n) {
  var r = c.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
function md(e, t) {
  typeof e == "function" ? e(t) : Vt(e) === "object" && e && "current" in e && (e.current = t);
}
function Do() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t.filter(function(o) {
    return o;
  });
  return r.length <= 1 ? r[0] : function(o) {
    t.forEach(function(i) {
      md(i, o);
    });
  };
}
function Ol() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ua(function() {
    return Do.apply(void 0, t);
  }, t, function(r, o) {
    return r.length !== o.length || r.every(function(i, a) {
      return i !== o[a];
    });
  });
}
function ki(e) {
  var t, n, r = tb.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) !== null && t !== void 0 && t.render) || typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render));
}
function Zj(e) {
  return !/* @__PURE__ */ XL(e) || tb.isFragment(e) ? !1 : ki(e);
}
var Y0 = /* @__PURE__ */ c.createContext(null);
function Qj(e) {
  var t = e.children, n = e.onBatchResize, r = c.useRef(0), o = c.useRef([]), i = c.useContext(Y0), a = c.useCallback(function(s, l, u) {
    r.current += 1;
    var f = r.current;
    o.current.push({
      size: s,
      element: l,
      data: u
    }), Promise.resolve().then(function() {
      f === r.current && (n == null || n(o.current), o.current = []);
    }), i == null || i(s, l, u);
  }, [n, i]);
  return /* @__PURE__ */ c.createElement(Y0.Provider, {
    value: a
  }, t);
}
var T4 = function() {
  if (typeof Map != "undefined")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(o, i) {
      return o[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, t.prototype.set = function(n, r) {
        var o = e(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, o = e(r, n);
        ~o && r.splice(o, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, i = this.__entries__; o < i.length; o++) {
          var a = i[o];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), X0 = typeof window != "undefined" && typeof document != "undefined" && window.document === document, bh = function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
}(), Jj = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(bh) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), ek = 2;
function tk(e, t) {
  var n = !1, r = !1, o = 0;
  function i() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    Jj(i);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - o < ek)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    o = l;
  }
  return s;
}
var nk = 20, rk = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], ok = typeof MutationObserver != "undefined", ik = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = tk(this.refresh.bind(this), nk);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !X0 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), ok ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !X0 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, o = rk.some(function(i) {
        return !!~r.indexOf(i);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), M4 = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Dc = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || bh;
}, L4 = fg(0, 0, 0, 0);
function Ch(e) {
  return parseFloat(e) || 0;
}
function y2(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, o) {
    var i = e["border-" + o + "-width"];
    return r + Ch(i);
  }, 0);
}
function ak(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = e["padding-" + i];
    n[i] = Ch(a);
  }
  return n;
}
function sk(e) {
  var t = e.getBBox();
  return fg(0, 0, t.width, t.height);
}
function lk(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return L4;
  var r = Dc(e).getComputedStyle(e), o = ak(r), i = o.left + o.right, a = o.top + o.bottom, s = Ch(r.width), l = Ch(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= y2(r, "left", "right") + i), Math.round(l + a) !== n && (l -= y2(r, "top", "bottom") + a)), !uk(e)) {
    var u = Math.round(s + i) - t, f = Math.round(l + a) - n;
    Math.abs(u) !== 1 && (s -= u), Math.abs(f) !== 1 && (l -= f);
  }
  return fg(o.left, o.top, s, l);
}
var ck = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement != "undefined" ? function(e) {
    return e instanceof Dc(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Dc(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function uk(e) {
  return e === Dc(e).document.documentElement;
}
function dk(e) {
  return X0 ? ck(e) ? sk(e) : lk(e) : L4;
}
function fk(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, i = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, a = Object.create(i.prototype);
  return M4(a, {
    x: t,
    y: n,
    width: r,
    height: o,
    top: n,
    right: t + r,
    bottom: o + n,
    left: t
  }), a;
}
function fg(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var pk = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = fg(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = dk(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), hk = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = fk(n);
      M4(this, { target: t, contentRect: r });
    }
    return e;
  }()
), gk = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new T4(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(t instanceof Dc(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new pk(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(t instanceof Dc(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new hk(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), A4 = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new T4(), j4 = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = ik.getInstance(), r = new gk(t, n, this);
      A4.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  j4.prototype[e] = function() {
    var t;
    return (t = A4.get(this))[e].apply(t, arguments);
  };
});
var mk = function() {
  return typeof bh.ResizeObserver != "undefined" ? bh.ResizeObserver : j4;
}(), Ma = /* @__PURE__ */ new Map();
function k4(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = Ma.get(r)) === null || n === void 0 || n.forEach(function(o) {
      return o(r);
    });
  });
}
var F4 = new mk(k4);
process.env.NODE_ENV;
process.env.NODE_ENV;
function vk(e, t) {
  Ma.has(e) || (Ma.set(e, /* @__PURE__ */ new Set()), F4.observe(e)), Ma.get(e).add(t);
}
function yk(e, t) {
  Ma.has(e) && (Ma.get(e).delete(t), Ma.get(e).size || (F4.unobserve(e), Ma.delete(e)));
}
function zr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function b2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, D4(r.key), r);
  }
}
function Vr(e, t, n) {
  return t && b2(e.prototype, t), n && b2(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Z0(e, t) {
  return Z0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Z0(e, t);
}
function Wi(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Z0(e, t);
}
function $s(e) {
  return $s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $s(e);
}
function pg() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t) {
  }
  return (pg = function() {
    return !!e;
  })();
}
function nt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rb(e, t) {
  if (t && (Vt(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return nt(e);
}
function Ga(e) {
  var t = pg();
  return function() {
    var r = $s(e), o;
    if (t) {
      var i = $s(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return rb(this, o);
  };
}
var bk = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    return zr(this, n), t.apply(this, arguments);
  }
  return Vr(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(c.Component);
function Ck(e, t) {
  var n = e.children, r = e.disabled, o = c.useRef(null), i = c.useRef(null), a = c.useContext(Y0), s = typeof n == "function", l = s ? n(o) : n, u = c.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), f = !s && /* @__PURE__ */ c.isValidElement(l) && ki(l), p = f ? l.ref : null, h = Ol(p, o), y = function() {
    var C;
    return Ju(o.current) || // Support `nativeElement` format
    (o.current && Vt(o.current) === "object" ? Ju((C = o.current) === null || C === void 0 ? void 0 : C.nativeElement) : null) || Ju(i.current);
  };
  c.useImperativeHandle(t, function() {
    return y();
  });
  var b = c.useRef(e);
  b.current = e;
  var m = c.useCallback(function(v) {
    var C = b.current, x = C.onResize, S = C.data, E = v.getBoundingClientRect(), O = E.width, $ = E.height, _ = v.offsetWidth, R = v.offsetHeight, P = Math.floor(O), I = Math.floor($);
    if (u.current.width !== P || u.current.height !== I || u.current.offsetWidth !== _ || u.current.offsetHeight !== R) {
      var j = {
        width: P,
        height: I,
        offsetWidth: _,
        offsetHeight: R
      };
      u.current = j;
      var F = _ === Math.round(O) ? O : _, A = R === Math.round($) ? $ : R, M = J(J({}, j), {}, {
        offsetWidth: F,
        offsetHeight: A
      });
      a == null || a(M, v, S), x && Promise.resolve().then(function() {
        x(M, v);
      });
    }
  }, []);
  return c.useEffect(function() {
    var v = y();
    return v && !r && vk(v, m), function() {
      return yk(v, m);
    };
  }, [o.current, r]), /* @__PURE__ */ c.createElement(bk, {
    ref: i
  }, f ? /* @__PURE__ */ c.cloneElement(l, {
    ref: h
  }) : l);
}
var B4 = /* @__PURE__ */ c.forwardRef(Ck);
process.env.NODE_ENV !== "production" && (B4.displayName = "SingleObserver");
var xk = "rc-observer-key";
function Sk(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : Rr(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? pl(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && pl(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(o, i) {
    var a = (o == null ? void 0 : o.key) || "".concat(xk, "-").concat(i);
    return /* @__PURE__ */ c.createElement(B4, Oe({}, e, {
      key: a,
      ref: i === 0 ? t : void 0
    }), o);
  });
}
var zo = /* @__PURE__ */ c.forwardRef(Sk);
process.env.NODE_ENV !== "production" && (zo.displayName = "ResizeObserver");
zo.Collection = Qj;
function dr(e, t) {
  var n = J({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function Q0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function wk(e) {
  if (Array.isArray(e))
    return Q0(e);
}
function H4(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ob(e, t) {
  if (e) {
    if (typeof e == "string")
      return Q0(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Q0(e, t);
  }
}
function Ek() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function We(e) {
  return wk(e) || H4(e) || ob(e) || Ek();
}
var z4 = function(t) {
  return +setTimeout(t, 16);
}, V4 = function(t) {
  return clearTimeout(t);
};
typeof window != "undefined" && "requestAnimationFrame" in window && (z4 = function(t) {
  return window.requestAnimationFrame(t);
}, V4 = function(t) {
  return window.cancelAnimationFrame(t);
});
var C2 = 0, hg = /* @__PURE__ */ new Map();
function W4(e) {
  hg.delete(e);
}
var Pn = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  C2 += 1;
  var r = C2;
  function o(i) {
    if (i === 0)
      W4(r), t();
    else {
      var a = z4(function() {
        o(i - 1);
      });
      hg.set(r, a);
    }
  }
  return o(n), r;
};
Pn.cancel = function(e) {
  var t = hg.get(e);
  return W4(e), V4(t);
};
process.env.NODE_ENV !== "production" && (Pn.ids = function() {
  return hg;
});
function K4(e) {
  if (Array.isArray(e))
    return e;
}
function $k(e, t) {
  var n = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, u = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (f) {
      u = !0, o = f;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (u)
          throw o;
      }
    }
    return s;
  }
}
function U4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function de(e, t) {
  return K4(e) || $k(e, t) || ob(e, t) || U4();
}
function xh(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Hr() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function Ok(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var x2 = "data-rc-order", S2 = "data-rc-priority", _k = "rc-util-key", J0 = /* @__PURE__ */ new Map();
function G4() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : _k;
}
function gg(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function Nk(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function q4(e) {
  return Array.from((J0.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function Y4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Hr())
    return null;
  var n = t.csp, r = t.prepend, o = t.priority, i = o === void 0 ? 0 : o, a = Nk(r), s = a === "prependQueue", l = document.createElement("style");
  l.setAttribute(x2, a), s && i && l.setAttribute(S2, "".concat(i)), n != null && n.nonce && (l.nonce = n == null ? void 0 : n.nonce), l.innerHTML = e;
  var u = gg(t), f = u.firstChild;
  if (r) {
    if (s) {
      var p = q4(u).filter(function(h) {
        if (!["prepend", "prependQueue"].includes(h.getAttribute(x2)))
          return !1;
        var y = Number(h.getAttribute(S2) || 0);
        return i >= y;
      });
      if (p.length)
        return u.insertBefore(l, p[p.length - 1].nextSibling), l;
    }
    u.insertBefore(l, f);
  } else
    u.appendChild(l);
  return l;
}
function X4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = gg(t);
  return q4(n).find(function(r) {
    return r.getAttribute(G4(t)) === e;
  });
}
function vd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = X4(e, t);
  if (n) {
    var r = gg(t);
    r.removeChild(n);
  }
}
function Pk(e, t) {
  var n = J0.get(e);
  if (!n || !Ok(document, n)) {
    var r = Y4("", t), o = r.parentNode;
    J0.set(e, o), e.removeChild(r);
  }
}
function Os(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = gg(n);
  Pk(r, n);
  var o = X4(t, n);
  if (o) {
    var i, a;
    if ((i = n.csp) !== null && i !== void 0 && i.nonce && o.nonce !== ((a = n.csp) === null || a === void 0 ? void 0 : a.nonce)) {
      var s;
      o.nonce = (s = n.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return o.innerHTML !== e && (o.innerHTML = e), o;
  }
  var l = Y4(e, n);
  return l.setAttribute(G4(n), t), l;
}
function Ik(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Yt(e, t) {
  if (e == null)
    return {};
  var n = Ik(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Fi(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function o(i, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = r.has(i);
    if (mt(!l, "Warning: There may be circular references"), l)
      return !1;
    if (i === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(i);
    var u = s + 1;
    if (Array.isArray(i)) {
      if (!Array.isArray(a) || i.length !== a.length)
        return !1;
      for (var f = 0; f < i.length; f++)
        if (!o(i[f], a[f], u))
          return !1;
      return !0;
    }
    if (i && a && Vt(i) === "object" && Vt(a) === "object") {
      var p = Object.keys(i);
      return p.length !== Object.keys(a).length ? !1 : p.every(function(h) {
        return o(i[h], a[h], u);
      });
    }
    return !1;
  }
  return o(e, t);
}
var Rk = "%";
function e1(e) {
  return e.join(Rk);
}
var Dk = /* @__PURE__ */ function() {
  function e(t) {
    zr(this, e), K(this, "instanceId", void 0), K(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return Vr(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(e1(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(e1(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var o = this.cache.get(n), i = r(o);
      i === null ? this.cache.delete(n) : this.cache.set(n, i);
    }
  }]), e;
}(), Tc = "data-token-hash", Ai = "data-css-hash", Tk = "data-cache-path", vs = "__cssinjs_instance__";
function Mk() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document != "undefined" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(Ai, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(o) {
      o[vs] = o[vs] || e, o[vs] === e && document.head.insertBefore(o, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(Ai, "]"))).forEach(function(o) {
      var i = o.getAttribute(Ai);
      if (r[i]) {
        if (o[vs] === e) {
          var a;
          (a = o.parentNode) === null || a === void 0 || a.removeChild(o);
        }
      } else
        r[i] = !0;
    });
  }
  return new Dk(e);
}
var Lk = /* @__PURE__ */ c.createContext({
  hashPriority: "low",
  cache: Mk(),
  defaultCache: !0
});
const mg = Lk;
function Ak(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var ib = /* @__PURE__ */ function() {
  function e() {
    zr(this, e), K(this, "cache", void 0), K(this, "keys", void 0), K(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return Vr(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, o, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return n.forEach(function(s) {
        if (!a)
          a = void 0;
        else {
          var l;
          a = (l = a) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(s);
        }
      }), (r = a) !== null && r !== void 0 && r.value && i && (a.value[1] = this.cacheCallTimes++), (o = a) === null || o === void 0 ? void 0 : o.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var o = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var i = this.keys.reduce(function(u, f) {
            var p = de(u, 2), h = p[1];
            return o.internalGet(f)[1] < h ? [f, o.internalGet(f)[1]] : u;
          }, [this.keys[0], this.cacheCallTimes]), a = de(i, 1), s = a[0];
          this.delete(s);
        }
        this.keys.push(n);
      }
      var l = this.cache;
      n.forEach(function(u, f) {
        if (f === n.length - 1)
          l.set(u, {
            value: [r, o.cacheCallTimes++]
          });
        else {
          var p = l.get(u);
          p ? p.map || (p.map = /* @__PURE__ */ new Map()) : l.set(u, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(u).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var o = n.get(r[0]);
      if (r.length === 1) {
        var i;
        return o.map ? n.set(r[0], {
          map: o.map
        }) : n.delete(r[0]), (i = o.value) === null || i === void 0 ? void 0 : i[0];
      }
      var a = this.deleteByPath(o.map, r.slice(1));
      return (!o.map || o.map.size === 0) && !o.value && n.delete(r[0]), a;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !Ak(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
K(ib, "MAX_CACHE_SIZE", 20);
K(ib, "MAX_CACHE_OFFSET", 5);
var w2 = 0, Z4 = /* @__PURE__ */ function() {
  function e(t) {
    zr(this, e), K(this, "derivatives", void 0), K(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = w2, t.length === 0 && pl(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), w2 += 1;
  }
  return Vr(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, o) {
        return o(n, r);
      }, void 0);
    }
  }]), e;
}(), _v = new ib();
function t1(e) {
  var t = Array.isArray(e) ? e : [e];
  return _v.has(t) || _v.set(t, new Z4(t)), _v.get(t);
}
var jk = /* @__PURE__ */ new WeakMap(), Nv = {};
function kk(e, t) {
  for (var n = jk, r = 0; r < t.length; r += 1) {
    var o = t[r];
    n.has(o) || n.set(o, /* @__PURE__ */ new WeakMap()), n = n.get(o);
  }
  return n.has(Nv) || n.set(Nv, e()), n.get(Nv);
}
var E2 = /* @__PURE__ */ new WeakMap();
function ed(e) {
  var t = E2.get(e) || "";
  return t || (Object.keys(e).forEach(function(n) {
    var r = e[n];
    t += n, r instanceof Z4 ? t += r.id : r && Vt(r) === "object" ? t += ed(r) : t += r;
  }), E2.set(e, t)), t;
}
function $2(e, t) {
  return xh("".concat(t, "_").concat(ed(e)));
}
var td = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), Q4 = "_bAmBoO_";
function Fk(e, t, n) {
  if (Hr()) {
    var r, o;
    Os(e, td);
    var i = document.createElement("div");
    i.style.position = "fixed", i.style.left = "0", i.style.top = "0", t == null || t(i), document.body.appendChild(i), process.env.NODE_ENV !== "production" && (i.innerHTML = "Test", i.style.zIndex = "9999999");
    var a = n ? n(i) : (r = getComputedStyle(i).content) === null || r === void 0 ? void 0 : r.includes(Q4);
    return (o = i.parentNode) === null || o === void 0 || o.removeChild(i), vd(td), a;
  }
  return !1;
}
var Pv = void 0;
function Bk() {
  return Pv === void 0 && (Pv = Fk("@layer ".concat(td, " { .").concat(td, ' { content: "').concat(Q4, '"!important; } }'), function(e) {
    e.className = td;
  })), Pv;
}
var n1 = Hr();
function te(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function Sh(e, t, n) {
  var r, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var a = J(J({}, o), {}, (r = {}, K(r, Tc, t), K(r, Ai, n), r)), s = Object.keys(a).map(function(l) {
    var u = a[l];
    return u ? "".concat(l, '="').concat(u, '"') : null;
  }).filter(function(l) {
    return l;
  }).join(" ");
  return "<style ".concat(s, ">").concat(e, "</style>");
}
var J4 = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, Hk = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(o) {
    var i = de(o, 2), a = i[0], s = i[1];
    return "".concat(a, ":").concat(s, ";");
  }).join(""), "}") : "";
}, eO = function(t, n, r) {
  var o = {}, i = {};
  return Object.entries(t).forEach(function(a) {
    var s, l, u = de(a, 2), f = u[0], p = u[1];
    if (r != null && (s = r.preserve) !== null && s !== void 0 && s[f])
      i[f] = p;
    else if ((typeof p == "string" || typeof p == "number") && !(r != null && (l = r.ignore) !== null && l !== void 0 && l[f])) {
      var h, y = J4(f, r == null ? void 0 : r.prefix);
      o[y] = typeof p == "number" && !(r != null && (h = r.unitless) !== null && h !== void 0 && h[f]) ? "".concat(p, "px") : String(p), i[f] = "var(".concat(y, ")");
    }
  }), [i, Hk(o, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, O2 = process.env.NODE_ENV !== "test" && Hr() ? c.useLayoutEffect : c.useEffect, Nn = function(t, n) {
  var r = c.useRef(!0);
  O2(function() {
    return t(r.current);
  }, n), O2(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, _2 = function(t, n) {
  Nn(function(r) {
    if (!r)
      return t();
  }, n);
}, zk = J({}, c), N2 = zk.useInsertionEffect, Vk = function(t, n, r) {
  c.useMemo(t, r), Nn(function() {
    return n(!0);
  }, r);
}, Wk = N2 ? function(e, t, n) {
  return N2(function() {
    return e(), t();
  }, n);
} : Vk;
const Kk = Wk;
var Uk = J({}, c), Gk = Uk.useInsertionEffect, qk = function(t) {
  var n = [], r = !1;
  function o(i) {
    if (r) {
      process.env.NODE_ENV !== "production" && pl(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    n.push(i);
  }
  return c.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(i) {
        return i();
      });
    };
  }, t), o;
}, Yk = function() {
  return function(t) {
    t();
  };
}, Xk = typeof Gk != "undefined" ? qk : Yk;
const Zk = Xk;
function Qk() {
  return !1;
}
var r1 = !1;
function Jk() {
  return r1;
}
const eF = process.env.NODE_ENV === "production" ? Qk : Jk;
if (process.env.NODE_ENV !== "production" && typeof module != "undefined" && module && module.hot && typeof window != "undefined") {
  var Iv = window;
  if (typeof Iv.webpackHotUpdate == "function") {
    var tF = Iv.webpackHotUpdate;
    Iv.webpackHotUpdate = function() {
      return r1 = !0, setTimeout(function() {
        r1 = !1;
      }, 0), tF.apply(void 0, arguments);
    };
  }
}
function ab(e, t, n, r, o) {
  var i = c.useContext(mg), a = i.cache, s = [e].concat(We(t)), l = e1(s), u = Zk([l]), f = eF(), p = function(m) {
    a.opUpdate(l, function(v) {
      var C = v || [void 0, void 0], x = de(C, 2), S = x[0], E = S === void 0 ? 0 : S, O = x[1], $ = O;
      process.env.NODE_ENV !== "production" && O && f && (r == null || r($, f), $ = null);
      var _ = $ || n(), R = [E, _];
      return m ? m(R) : R;
    });
  };
  c.useMemo(
    function() {
      p();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var h = a.opGet(l);
  process.env.NODE_ENV !== "production" && !h && (p(), h = a.opGet(l));
  var y = h[1];
  return Kk(function() {
    o == null || o(y);
  }, function(b) {
    return p(function(m) {
      var v = de(m, 2), C = v[0], x = v[1];
      return b && C === 0 && (o == null || o(y)), [C + 1, x];
    }), function() {
      a.opUpdate(l, function(m) {
        var v = m || [], C = de(v, 2), x = C[0], S = x === void 0 ? 0 : x, E = C[1], O = S - 1;
        return O === 0 ? (u(function() {
          (b || !a.opGet(l)) && (r == null || r(E, !1));
        }), null) : [S - 1, E];
      });
    };
  }, [l]), y;
}
var nF = {}, rF = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", Qs = /* @__PURE__ */ new Map();
function oF(e) {
  Qs.set(e, (Qs.get(e) || 0) + 1);
}
function iF(e, t) {
  if (typeof document != "undefined") {
    var n = document.querySelectorAll("style[".concat(Tc, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[vs] === t) {
        var o;
        (o = r.parentNode) === null || o === void 0 || o.removeChild(r);
      }
    });
  }
}
var aF = 0;
function sF(e, t) {
  Qs.set(e, (Qs.get(e) || 0) - 1);
  var n = Array.from(Qs.keys()), r = n.filter(function(o) {
    var i = Qs.get(o) || 0;
    return i <= 0;
  });
  n.length - r.length > aF && r.forEach(function(o) {
    iF(o, t), Qs.delete(o);
  });
}
var lF = function(t, n, r, o) {
  var i = r.getDerivativeToken(t), a = J(J({}, i), n);
  return o && (a = o(a)), a;
}, tO = "token";
function cF(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Cn(mg), o = r.cache.instanceId, i = r.container, a = n.salt, s = a === void 0 ? "" : a, l = n.override, u = l === void 0 ? nF : l, f = n.formatToken, p = n.getComputedToken, h = n.cssVar, y = kk(function() {
    return Object.assign.apply(Object, [{}].concat(We(t)));
  }, t), b = ed(y), m = ed(u), v = h ? ed(h) : "", C = ab(tO, [s, e.id, b, m, v], function() {
    var x, S = p ? p(y, u, e) : lF(y, u, e, f), E = J({}, S), O = "";
    if (h) {
      var $ = eO(S, h.key, {
        prefix: h.prefix,
        ignore: h.ignore,
        unitless: h.unitless,
        preserve: h.preserve
      }), _ = de($, 2);
      S = _[0], O = _[1];
    }
    var R = $2(S, s);
    S._tokenKey = R, E._tokenKey = $2(E, s);
    var P = (x = h == null ? void 0 : h.key) !== null && x !== void 0 ? x : R;
    S._themeKey = P, oF(P);
    var I = "".concat(rF, "-").concat(xh(R));
    return S._hashId = I, [S, I, E, O, (h == null ? void 0 : h.key) || ""];
  }, function(x) {
    sF(x[0]._themeKey, o);
  }, function(x) {
    var S = de(x, 4), E = S[0], O = S[3];
    if (h && O) {
      var $ = Os(O, xh("css-variables-".concat(E._themeKey)), {
        mark: Ai,
        prepend: "queue",
        attachTo: i,
        priority: -999
      });
      $[vs] = o, $.setAttribute(Tc, E._themeKey);
    }
  });
  return C;
}
var uF = function(t, n, r) {
  var o = de(t, 5), i = o[2], a = o[3], s = o[4], l = r || {}, u = l.plain;
  if (!a)
    return null;
  var f = i._tokenKey, p = -999, h = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(p)
  }, y = Sh(a, s, f, h, u);
  return [p, f, y];
}, dF = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, gr = "-ms-", nd = "-moz-", Zn = "-webkit-", nO = "comm", vg = "rule", sb = "decl", fF = "@import", rO = "@keyframes", pF = "@layer", oO = Math.abs, lb = String.fromCharCode, o1 = Object.assign;
function hF(e, t) {
  return to(e, 0) ^ 45 ? (((t << 2 ^ to(e, 0)) << 2 ^ to(e, 1)) << 2 ^ to(e, 2)) << 2 ^ to(e, 3) : 0;
}
function iO(e) {
  return e.trim();
}
function Ra(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function En(e, t, n) {
  return e.replace(t, n);
}
function Gp(e, t, n) {
  return e.indexOf(t, n);
}
function to(e, t) {
  return e.charCodeAt(t) | 0;
}
function Mc(e, t, n) {
  return e.slice(t, n);
}
function ia(e) {
  return e.length;
}
function aO(e) {
  return e.length;
}
function qu(e, t) {
  return t.push(e), e;
}
function gF(e, t) {
  return e.map(t).join("");
}
function P2(e, t) {
  return e.filter(function(n) {
    return !Ra(n, t);
  });
}
var yg = 1, Lc = 1, sO = 0, xi = 0, Fr = 0, Zc = "";
function bg(e, t, n, r, o, i, a, s) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: yg, column: Lc, length: a, return: "", siblings: s };
}
function us(e, t) {
  return o1(bg("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function Zl(e) {
  for (; e.root; )
    e = us(e.root, { children: [e] });
  qu(e, e.siblings);
}
function mF() {
  return Fr;
}
function vF() {
  return Fr = xi > 0 ? to(Zc, --xi) : 0, Lc--, Fr === 10 && (Lc = 1, yg--), Fr;
}
function ji() {
  return Fr = xi < sO ? to(Zc, xi++) : 0, Lc++, Fr === 10 && (Lc = 1, yg++), Fr;
}
function dl() {
  return to(Zc, xi);
}
function qp() {
  return xi;
}
function Cg(e, t) {
  return Mc(Zc, e, t);
}
function i1(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function yF(e) {
  return yg = Lc = 1, sO = ia(Zc = e), xi = 0, [];
}
function bF(e) {
  return Zc = "", e;
}
function Rv(e) {
  return iO(Cg(xi - 1, a1(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function CF(e) {
  for (; (Fr = dl()) && Fr < 33; )
    ji();
  return i1(e) > 2 || i1(Fr) > 3 ? "" : " ";
}
function xF(e, t) {
  for (; --t && ji() && !(Fr < 48 || Fr > 102 || Fr > 57 && Fr < 65 || Fr > 70 && Fr < 97); )
    ;
  return Cg(e, qp() + (t < 6 && dl() == 32 && ji() == 32));
}
function a1(e) {
  for (; ji(); )
    switch (Fr) {
      case e:
        return xi;
      case 34:
      case 39:
        e !== 34 && e !== 39 && a1(Fr);
        break;
      case 40:
        e === 41 && a1(e);
        break;
      case 92:
        ji();
        break;
    }
  return xi;
}
function SF(e, t) {
  for (; ji() && e + Fr !== 57; )
    if (e + Fr === 84 && dl() === 47)
      break;
  return "/*" + Cg(t, xi - 1) + "*" + lb(e === 47 ? e : ji());
}
function wF(e) {
  for (; !i1(dl()); )
    ji();
  return Cg(e, xi);
}
function lO(e) {
  return bF(Yp("", null, null, null, [""], e = yF(e), 0, [0], e));
}
function Yp(e, t, n, r, o, i, a, s, l) {
  for (var u = 0, f = 0, p = a, h = 0, y = 0, b = 0, m = 1, v = 1, C = 1, x = 0, S = "", E = o, O = i, $ = r, _ = S; v; )
    switch (b = x, x = ji()) {
      case 40:
        if (b != 108 && to(_, p - 1) == 58) {
          Gp(_ += En(Rv(x), "&", "&\f"), "&\f", oO(u ? s[u - 1] : 0)) != -1 && (C = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Rv(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += CF(b);
        break;
      case 92:
        _ += xF(qp() - 1, 7);
        continue;
      case 47:
        switch (dl()) {
          case 42:
          case 47:
            qu(EF(SF(ji(), qp()), t, n, l), l);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * m:
        s[u++] = ia(_) * C;
      case 125 * m:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            v = 0;
          case 59 + f:
            C == -1 && (_ = En(_, /\f/g, "")), y > 0 && ia(_) - p && qu(y > 32 ? R2(_ + ";", r, n, p - 1, l) : R2(En(_, " ", "") + ";", r, n, p - 2, l), l);
            break;
          case 59:
            _ += ";";
          default:
            if (qu($ = I2(_, t, n, u, f, o, s, S, E = [], O = [], p, i), i), x === 123)
              if (f === 0)
                Yp(_, t, $, $, E, i, p, s, O);
              else
                switch (h === 99 && to(_, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Yp(e, $, $, r && qu(I2(e, $, $, 0, 0, o, s, S, o, E = [], p, O), O), o, O, p, s, r ? E : O);
                    break;
                  default:
                    Yp(_, $, $, $, [""], O, 0, s, O);
                }
        }
        u = f = y = 0, m = C = 1, S = _ = "", p = a;
        break;
      case 58:
        p = 1 + ia(_), y = b;
      default:
        if (m < 1) {
          if (x == 123)
            --m;
          else if (x == 125 && m++ == 0 && vF() == 125)
            continue;
        }
        switch (_ += lb(x), x * m) {
          case 38:
            C = f > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[u++] = (ia(_) - 1) * C, C = 1;
            break;
          case 64:
            dl() === 45 && (_ += Rv(ji())), h = dl(), f = p = ia(S = _ += wF(qp())), x++;
            break;
          case 45:
            b === 45 && ia(_) == 2 && (m = 0);
        }
    }
  return i;
}
function I2(e, t, n, r, o, i, a, s, l, u, f, p) {
  for (var h = o - 1, y = o === 0 ? i : [""], b = aO(y), m = 0, v = 0, C = 0; m < r; ++m)
    for (var x = 0, S = Mc(e, h + 1, h = oO(v = a[m])), E = e; x < b; ++x)
      (E = iO(v > 0 ? y[x] + " " + S : En(S, /&\f/g, y[x]))) && (l[C++] = E);
  return bg(e, t, n, o === 0 ? vg : s, l, u, f, p);
}
function EF(e, t, n, r) {
  return bg(e, t, n, nO, lb(mF()), Mc(e, 2, -2), 0, r);
}
function R2(e, t, n, r, o) {
  return bg(e, t, n, sb, Mc(e, 0, r), Mc(e, r + 1, -1), r, o);
}
function cO(e, t, n) {
  switch (hF(e, t)) {
    case 5103:
      return Zn + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Zn + e + e;
    case 4789:
      return nd + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Zn + e + nd + e + gr + e + e;
    case 5936:
      switch (to(e, t + 11)) {
        case 114:
          return Zn + e + gr + En(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Zn + e + gr + En(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Zn + e + gr + En(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return Zn + e + gr + e + e;
    case 6165:
      return Zn + e + gr + "flex-" + e + e;
    case 5187:
      return Zn + e + En(e, /(\w+).+(:[^]+)/, Zn + "box-$1$2" + gr + "flex-$1$2") + e;
    case 5443:
      return Zn + e + gr + "flex-item-" + En(e, /flex-|-self/g, "") + (Ra(e, /flex-|baseline/) ? "" : gr + "grid-row-" + En(e, /flex-|-self/g, "")) + e;
    case 4675:
      return Zn + e + gr + "flex-line-pack" + En(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return Zn + e + gr + En(e, "shrink", "negative") + e;
    case 5292:
      return Zn + e + gr + En(e, "basis", "preferred-size") + e;
    case 6060:
      return Zn + "box-" + En(e, "-grow", "") + Zn + e + gr + En(e, "grow", "positive") + e;
    case 4554:
      return Zn + En(e, /([^-])(transform)/g, "$1" + Zn + "$2") + e;
    case 6187:
      return En(En(En(e, /(zoom-|grab)/, Zn + "$1"), /(image-set)/, Zn + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return En(e, /(image-set\([^]*)/, Zn + "$1$`$1");
    case 4968:
      return En(En(e, /(.+:)(flex-)?(.*)/, Zn + "box-pack:$3" + gr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Zn + e + e;
    case 4200:
      if (!Ra(e, /flex-|baseline/))
        return gr + "grid-column-align" + Mc(e, t) + e;
      break;
    case 2592:
    case 3360:
      return gr + En(e, "template-", "") + e;
    case 4384:
    case 3616:
      return n && n.some(function(r, o) {
        return t = o, Ra(r.props, /grid-\w+-end/);
      }) ? ~Gp(e + (n = n[t].value), "span", 0) ? e : gr + En(e, "-start", "") + e + gr + "grid-row-span:" + (~Gp(n, "span", 0) ? Ra(n, /\d+/) : +Ra(n, /\d+/) - +Ra(e, /\d+/)) + ";" : gr + En(e, "-start", "") + e;
    case 4896:
    case 4128:
      return n && n.some(function(r) {
        return Ra(r.props, /grid-\w+-start/);
      }) ? e : gr + En(En(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return En(e, /(.+)-inline(.+)/, Zn + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ia(e) - 1 - t > 6)
        switch (to(e, t + 1)) {
          case 109:
            if (to(e, t + 4) !== 45)
              break;
          case 102:
            return En(e, /(.+:)(.+)-([^]+)/, "$1" + Zn + "$2-$3$1" + nd + (to(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Gp(e, "stretch", 0) ? cO(En(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return En(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, o, i, a, s, l, u) {
        return gr + o + ":" + i + u + (a ? gr + o + "-span:" + (s ? l : +l - +i) + u : "") + e;
      });
    case 4949:
      if (to(e, t + 6) === 121)
        return En(e, ":", ":" + Zn) + e;
      break;
    case 6444:
      switch (to(e, to(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return En(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Zn + (to(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Zn + "$2$3$1" + gr + "$2box$3") + e;
        case 100:
          return En(e, ":", ":" + gr) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return En(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function yd(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function uO(e, t, n, r) {
  switch (e.type) {
    case pF:
      if (e.children.length)
        break;
    case fF:
    case sb:
      return e.return = e.return || e.value;
    case nO:
      return "";
    case rO:
      return e.return = e.value + "{" + yd(e.children, r) + "}";
    case vg:
      if (!ia(e.value = e.props.join(",")))
        return "";
  }
  return ia(n = yd(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function $F(e) {
  var t = aO(e);
  return function(n, r, o, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, r, o, i) || "";
    return a;
  };
}
function OF(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function _F(e, t, n, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case sb:
        e.return = cO(e.value, e.length, n);
        return;
      case rO:
        return yd([us(e, { value: En(e.value, "@", "@" + Zn) })], r);
      case vg:
        if (e.length)
          return gF(n = e.props, function(o) {
            switch (Ra(o, r = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Zl(us(e, { props: [En(o, /:(read-\w+)/, ":" + nd + "$1")] })), Zl(us(e, { props: [o] })), o1(e, { props: P2(n, r) });
                break;
              case "::placeholder":
                Zl(us(e, { props: [En(o, /:(plac\w+)/, ":" + Zn + "input-$1")] })), Zl(us(e, { props: [En(o, /:(plac\w+)/, ":" + nd + "$1")] })), Zl(us(e, { props: [En(o, /:(plac\w+)/, gr + "input-$1")] })), Zl(us(e, { props: [o] })), o1(e, { props: P2(n, r) });
                break;
            }
            return "";
          });
    }
}
function dO(e, t) {
  var n = t.path, r = t.parentSelectors;
  mt(!1, "[Ant Design CSS-in-JS] ".concat(n ? "Error in ".concat(n, ": ") : "").concat(e).concat(r.length ? " Selector: ".concat(r.join(" | ")) : ""));
}
var NF = function(t, n, r) {
  if (t === "content") {
    var o = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, i = ["normal", "none", "initial", "inherit", "unset"];
    (typeof n != "string" || i.indexOf(n) === -1 && !o.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")) && dO("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(n, "\"'`."), r);
  }
}, PF = function(t, n, r) {
  t === "animation" && r.hashId && n !== "none" && dO("You seem to be using hashed animation '".concat(n, "', in which case 'animationName' with Keyframe as value is recommended."), r);
}, D2 = "data-ant-cssinjs-cache-path", fO = "_FILE_STYLE__", fl, pO = !0;
function IF() {
  if (!fl && (fl = {}, Hr())) {
    var e = document.createElement("div");
    e.className = D2, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(o) {
      var i = o.split(":"), a = de(i, 2), s = a[0], l = a[1];
      fl[s] = l;
    });
    var n = document.querySelector("style[".concat(D2, "]"));
    if (n) {
      var r;
      pO = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function RF(e) {
  return IF(), !!fl[e];
}
function DF(e) {
  var t = fl[e], n = null;
  if (t && Hr())
    if (pO)
      n = fO;
    else {
      var r = document.querySelector("style[".concat(Ai, '="').concat(fl[e], '"]'));
      r ? n = r.innerHTML : delete fl[e];
    }
  return [n, t];
}
var hO = "_skip_check_", gO = "_multi_value_";
function s1(e) {
  var t = yd(lO(e), uO);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function TF(e) {
  return Vt(e) === "object" && e && (hO in e || gO in e);
}
function MF(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), o = n === "low" ? ":where(".concat(r, ")") : r, i = e.split(",").map(function(a) {
    var s, l = a.trim().split(/\s+/), u = l[0] || "", f = ((s = u.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return u = "".concat(f).concat(o).concat(u.slice(f.length)), [u].concat(We(l.slice(1))).join(" ");
  });
  return i.join(",");
}
var LF = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, o = r.root, i = r.injectHash, a = r.parentSelectors, s = n.hashId, l = n.layer, u = n.path, f = n.hashPriority, p = n.transformers, h = p === void 0 ? [] : p, y = n.linters, b = y === void 0 ? [] : y, m = "", v = {};
  function C($) {
    var _ = $.getName(s);
    if (!v[_]) {
      var R = e($.style, n, {
        root: !1,
        parentSelectors: a
      }), P = de(R, 1), I = P[0];
      v[_] = "@keyframes ".concat($.getName(s)).concat(I);
    }
  }
  function x($) {
    var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return $.forEach(function(R) {
      Array.isArray(R) ? x(R, _) : R && _.push(R);
    }), _;
  }
  var S = x(Array.isArray(t) ? t : [t]);
  if (S.forEach(function($) {
    var _ = typeof $ == "string" && !o ? {} : $;
    if (typeof _ == "string")
      m += "".concat(_, `
`);
    else if (_._keyframe)
      C(_);
    else {
      var R = h.reduce(function(P, I) {
        var j;
        return (I == null || (j = I.visit) === null || j === void 0 ? void 0 : j.call(I, P)) || P;
      }, _);
      Object.keys(R).forEach(function(P) {
        var I = R[P];
        if (Vt(I) === "object" && I && (P !== "animationName" || !I._keyframe) && !TF(I)) {
          var j = !1, F = P.trim(), A = !1;
          (o || i) && s ? F.startsWith("@") ? j = !0 : F = MF(P, s, f) : o && !s && (F === "&" || F === "") && (F = "", A = !0);
          var M = e(I, n, {
            root: A,
            injectHash: j,
            parentSelectors: [].concat(We(a), [F])
          }), N = de(M, 2), D = N[0], T = N[1];
          v = J(J({}, v), T), m += "".concat(F).concat(D);
        } else {
          let H = function(V, Y) {
            process.env.NODE_ENV !== "production" && (Vt(I) !== "object" || !(I != null && I[hO])) && [NF, PF].concat(We(b)).forEach(function(ee) {
              return ee(V, Y, {
                path: u,
                hashId: s,
                parentSelectors: a
              });
            });
            var Z = V.replace(/[A-Z]/g, function(ee) {
              return "-".concat(ee.toLowerCase());
            }), oe = Y;
            !dF[V] && typeof oe == "number" && oe !== 0 && (oe = "".concat(oe, "px")), V === "animationName" && Y !== null && Y !== void 0 && Y._keyframe && (C(Y), oe = Y.getName(s)), m += "".concat(Z, ":").concat(oe, ";");
          };
          var L, z = (L = I == null ? void 0 : I.value) !== null && L !== void 0 ? L : I;
          Vt(I) === "object" && I !== null && I !== void 0 && I[gO] && Array.isArray(z) ? z.forEach(function(V) {
            H(P, V);
          }) : H(P, z);
        }
      });
    }
  }), !o)
    m = "{".concat(m, "}");
  else if (l && Bk()) {
    var E = l.split(","), O = E[E.length - 1].trim();
    m = "@layer ".concat(O, " {").concat(m, "}"), E.length > 1 && (m = "@layer ".concat(l, "{%%%:%}").concat(m));
  }
  return [m, v];
};
function mO(e, t) {
  return xh("".concat(e.join("%")).concat(t));
}
function AF() {
  return null;
}
var vO = "style";
function l1(e, t) {
  var n = e.token, r = e.path, o = e.hashId, i = e.layer, a = e.nonce, s = e.clientOnly, l = e.order, u = l === void 0 ? 0 : l, f = c.useContext(mg), p = f.autoClear, h = f.mock, y = f.defaultCache, b = f.hashPriority, m = f.container, v = f.ssrInline, C = f.transformers, x = f.linters, S = f.cache, E = n._tokenKey, O = [E].concat(We(r)), $ = n1;
  process.env.NODE_ENV !== "production" && h !== void 0 && ($ = h === "client");
  var _ = ab(
    vO,
    O,
    // Create cache if needed
    function() {
      var F = O.join("|");
      if (RF(F)) {
        var A = DF(F), M = de(A, 2), N = M[0], D = M[1];
        if (N)
          return [N, E, D, {}, s, u];
      }
      var T = t(), L = LF(T, {
        hashId: o,
        hashPriority: b,
        layer: i,
        path: r.join("-"),
        transformers: C,
        linters: x
      }), z = de(L, 2), H = z[0], V = z[1], Y = s1(H), Z = mO(O, Y);
      return [Y, E, Z, V, s, u];
    },
    // Remove cache if no need
    function(F, A) {
      var M = de(F, 3), N = M[2];
      (A || p) && n1 && vd(N, {
        mark: Ai
      });
    },
    // Effect: Inject style here
    function(F) {
      var A = de(F, 4), M = A[0];
      A[1];
      var N = A[2], D = A[3];
      if ($ && M !== fO) {
        var T = {
          mark: Ai,
          prepend: "queue",
          attachTo: m,
          priority: u
        }, L = typeof a == "function" ? a() : a;
        L && (T.csp = {
          nonce: L
        });
        var z = Os(M, N, T);
        z[vs] = S.instanceId, z.setAttribute(Tc, E), process.env.NODE_ENV !== "production" && z.setAttribute(Tk, O.join("|")), Object.keys(D).forEach(function(H) {
          Os(s1(D[H]), "_effect-".concat(H), T);
        });
      }
    }
  ), R = de(_, 3), P = R[0], I = R[1], j = R[2];
  return function(F) {
    var A;
    if (!v || $ || !y)
      A = /* @__PURE__ */ c.createElement(AF, null);
    else {
      var M;
      A = /* @__PURE__ */ c.createElement("style", Oe({}, (M = {}, K(M, Tc, I), K(M, Ai, j), M), {
        dangerouslySetInnerHTML: {
          __html: P
        }
      }));
    }
    return /* @__PURE__ */ c.createElement(c.Fragment, null, A, F);
  };
}
var jF = function(t, n, r) {
  var o = de(t, 6), i = o[0], a = o[1], s = o[2], l = o[3], u = o[4], f = o[5], p = r || {}, h = p.plain;
  if (u)
    return null;
  var y = i, b = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(f)
  };
  return y = Sh(i, a, s, b, h), l && Object.keys(l).forEach(function(m) {
    if (!n[m]) {
      n[m] = !0;
      var v = s1(l[m]);
      y += Sh(v, a, "_effect-".concat(m), b, h);
    }
  }), [f, s, y];
}, yO = "cssVar", kF = function(t, n) {
  var r = t.key, o = t.prefix, i = t.unitless, a = t.ignore, s = t.token, l = t.scope, u = l === void 0 ? "" : l, f = Cn(mg), p = f.cache.instanceId, h = f.container, y = s._tokenKey, b = [].concat(We(t.path), [r, u, y]), m = ab(yO, b, function() {
    var v = n(), C = eO(v, r, {
      prefix: o,
      unitless: i,
      ignore: a,
      scope: u
    }), x = de(C, 2), S = x[0], E = x[1], O = mO(b, E);
    return [S, E, O, r];
  }, function(v) {
    var C = de(v, 3), x = C[2];
    n1 && vd(x, {
      mark: Ai
    });
  }, function(v) {
    var C = de(v, 3), x = C[1], S = C[2];
    if (x) {
      var E = Os(x, S, {
        mark: Ai,
        prepend: "queue",
        attachTo: h,
        priority: -999
      });
      E[vs] = p, E.setAttribute(Tc, r);
    }
  });
  return m;
}, FF = function(t, n, r) {
  var o = de(t, 4), i = o[1], a = o[2], s = o[3], l = r || {}, u = l.plain;
  if (!i)
    return null;
  var f = -999, p = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(f)
  }, h = Sh(i, s, a, p, u);
  return [f, a, h];
}, ku;
ku = {}, K(ku, vO, jF), K(ku, tO, uF), K(ku, yO, FF);
var Bn = /* @__PURE__ */ function() {
  function e(t, n) {
    zr(this, e), K(this, "name", void 0), K(this, "style", void 0), K(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return Vr(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function Ql(e) {
  return e.notSplit = !0, e;
}
Ql(["borderTop", "borderBottom"]), Ql(["borderTop"]), Ql(["borderBottom"]), Ql(["borderLeft", "borderRight"]), Ql(["borderLeft"]), Ql(["borderRight"]);
var cb = /* @__PURE__ */ Rs({});
function bO(e) {
  return K4(e) || H4(e) || ob(e) || U4();
}
function yi(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function CO(e, t, n, r) {
  if (!t.length)
    return n;
  var o = bO(t), i = o[0], a = o.slice(1), s;
  return !e && typeof i == "number" ? s = [] : Array.isArray(e) ? s = We(e) : s = J({}, e), r && n === void 0 && a.length === 1 ? delete s[i][a[0]] : s[i] = CO(s[i], a, n, r), s;
}
function Ti(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !yi(e, t.slice(0, -1)) ? e : CO(e, t, n, r);
}
function BF(e) {
  return Vt(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function T2(e) {
  return Array.isArray(e) ? [] : {};
}
var HF = typeof Reflect == "undefined" ? Object.keys : Reflect.ownKeys;
function gc() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = T2(t[0]);
  return t.forEach(function(o) {
    function i(a, s) {
      var l = new Set(s), u = yi(o, a), f = Array.isArray(u);
      if (f || BF(u)) {
        if (!l.has(u)) {
          l.add(u);
          var p = yi(r, a);
          f ? r = Ti(r, a, []) : (!p || Vt(p) !== "object") && (r = Ti(r, a, T2(u))), HF(u).forEach(function(h) {
            i([].concat(We(a), [h]), l);
          });
        }
      } else
        r = Ti(r, a, u);
    }
    i([]);
  }), r;
}
function xO() {
}
let Pa = null;
function zF() {
  Pa = null, I4();
}
let ub = xO;
process.env.NODE_ENV !== "production" && (ub = (e, t, n) => {
  mt(e, `[antd: ${t}] ${n}`), process.env.NODE_ENV === "test" && zF();
});
const SO = /* @__PURE__ */ c.createContext({}), xn = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = c.useContext(SO), n = (r, o, i) => {
    if (!r)
      if (t === !1 && o === "deprecated") {
        const a = Pa;
        Pa || (Pa = {}), Pa[e] = Pa[e] || [], Pa[e].includes(i || "") || Pa[e].push(i || ""), a || console.warn("[antd] There exists deprecated usage in your code:", Pa);
      } else
        process.env.NODE_ENV !== "production" && ub(r, e, i);
  };
  return n.deprecated = (r, o, i, a) => {
    n(r, "deprecated", `\`${o}\` is deprecated. Please use \`${i}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = xO, e;
}, Wd = ub, wO = /* @__PURE__ */ Rs(void 0);
var EO = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, VF = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const WF = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, $O = WF, KF = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, VF),
  timePickerLocale: Object.assign({}, $O)
}, wh = KF, Yo = "${label} is not a valid ${type}", za = {
  locale: "en",
  Pagination: EO,
  DatePicker: wh,
  TimePicker: $O,
  Calendar: wh,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: Yo,
        method: Yo,
        array: Yo,
        object: Yo,
        number: Yo,
        date: Yo,
        boolean: Yo,
        integer: Yo,
        float: Yo,
        regexp: Yo,
        email: Yo,
        url: Yo,
        hex: Yo
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
};
Object.assign({}, za.Modal);
let Xp = [];
const M2 = () => Xp.reduce((e, t) => Object.assign(Object.assign({}, e), t), za.Modal);
function UF(e) {
  if (e) {
    const t = Object.assign({}, e);
    return Xp.push(t), M2(), () => {
      Xp = Xp.filter((n) => n !== t), M2();
    };
  }
  Object.assign({}, za.Modal);
}
const GF = /* @__PURE__ */ Rs(void 0), db = GF, _l = (e, t) => {
  const n = c.useContext(db), r = c.useMemo(() => {
    var i;
    const a = t || za[e], s = (i = n == null ? void 0 : n[e]) !== null && i !== void 0 ? i : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), o = c.useMemo(() => {
    const i = n == null ? void 0 : n.locale;
    return n != null && n.exist && !i ? za.locale : i;
  }, [n]);
  return [r, o];
}, OO = "internalMark", _O = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = xn("LocaleProvider");
    process.env.NODE_ENV !== "production" && i(r === OO, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  c.useEffect(() => UF(t && t.Modal), [t]);
  const o = c.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ c.createElement(db.Provider, {
    value: o
  }, n);
};
process.env.NODE_ENV !== "production" && (_O.displayName = "LocaleProvider");
const qF = _O;
function co(e, t) {
  YF(e) && (e = "100%");
  var n = XF(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function dp(e) {
  return Math.min(1, Math.max(0, e));
}
function YF(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function XF(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function NO(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function fp(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function tl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function ZF(e, t, n) {
  return {
    r: co(e, 255) * 255,
    g: co(t, 255) * 255,
    b: co(n, 255) * 255
  };
}
function L2(e, t, n) {
  e = co(e, 255), t = co(t, 255), n = co(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i = 0, a = 0, s = (r + o) / 2;
  if (r === o)
    a = 0, i = 0;
  else {
    var l = r - o;
    switch (a = s > 0.5 ? l / (2 - r - o) : l / (r + o), r) {
      case e:
        i = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / l + 2;
        break;
      case n:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: a, l: s };
}
function Dv(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function QF(e, t, n) {
  var r, o, i;
  if (e = co(e, 360), t = co(t, 100), n = co(n, 100), t === 0)
    o = n, i = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - a;
    r = Dv(s, a, e + 1 / 3), o = Dv(s, a, e), i = Dv(s, a, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: i * 255 };
}
function c1(e, t, n) {
  e = co(e, 255), t = co(t, 255), n = co(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i = 0, a = r, s = r - o, l = r === 0 ? 0 : s / r;
  if (r === o)
    i = 0;
  else {
    switch (r) {
      case e:
        i = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / s + 2;
        break;
      case n:
        i = (e - t) / s + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, v: a };
}
function JF(e, t, n) {
  e = co(e, 360) * 6, t = co(t, 100), n = co(n, 100);
  var r = Math.floor(e), o = e - r, i = n * (1 - t), a = n * (1 - o * t), s = n * (1 - (1 - o) * t), l = r % 6, u = [n, a, i, i, s, n][l], f = [s, n, n, a, i, i][l], p = [i, i, s, n, n, a][l];
  return { r: u * 255, g: f * 255, b: p * 255 };
}
function u1(e, t, n, r) {
  var o = [
    tl(Math.round(e).toString(16)),
    tl(Math.round(t).toString(16)),
    tl(Math.round(n).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function eB(e, t, n, r, o) {
  var i = [
    tl(Math.round(e).toString(16)),
    tl(Math.round(t).toString(16)),
    tl(Math.round(n).toString(16)),
    tl(tB(r))
  ];
  return o && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function tB(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function A2(e) {
  return Zo(e) / 255;
}
function Zo(e) {
  return parseInt(e, 16);
}
function nB(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var d1 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function dc(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, o = null, i = null, a = !1, s = !1;
  return typeof e == "string" && (e = iB(e)), typeof e == "object" && (Oa(e.r) && Oa(e.g) && Oa(e.b) ? (t = ZF(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Oa(e.h) && Oa(e.s) && Oa(e.v) ? (r = fp(e.s), o = fp(e.v), t = JF(e.h, r, o), a = !0, s = "hsv") : Oa(e.h) && Oa(e.s) && Oa(e.l) && (r = fp(e.s), i = fp(e.l), t = QF(e.h, r, i), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = NO(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var rB = "[-\\+]?\\d+%?", oB = "[-\\+]?\\d*\\.\\d+%?", ys = "(?:".concat(oB, ")|(?:").concat(rB, ")"), Tv = "[\\s|\\(]+(".concat(ys, ")[,|\\s]+(").concat(ys, ")[,|\\s]+(").concat(ys, ")\\s*\\)?"), Mv = "[\\s|\\(]+(".concat(ys, ")[,|\\s]+(").concat(ys, ")[,|\\s]+(").concat(ys, ")[,|\\s]+(").concat(ys, ")\\s*\\)?"), Pi = {
  CSS_UNIT: new RegExp(ys),
  rgb: new RegExp("rgb" + Tv),
  rgba: new RegExp("rgba" + Mv),
  hsl: new RegExp("hsl" + Tv),
  hsla: new RegExp("hsla" + Mv),
  hsv: new RegExp("hsv" + Tv),
  hsva: new RegExp("hsva" + Mv),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function iB(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (d1[e])
    e = d1[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Pi.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Pi.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Pi.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Pi.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Pi.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Pi.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Pi.hex8.exec(e), n ? {
    r: Zo(n[1]),
    g: Zo(n[2]),
    b: Zo(n[3]),
    a: A2(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Pi.hex6.exec(e), n ? {
    r: Zo(n[1]),
    g: Zo(n[2]),
    b: Zo(n[3]),
    format: t ? "name" : "hex"
  } : (n = Pi.hex4.exec(e), n ? {
    r: Zo(n[1] + n[1]),
    g: Zo(n[2] + n[2]),
    b: Zo(n[3] + n[3]),
    a: A2(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Pi.hex3.exec(e), n ? {
    r: Zo(n[1] + n[1]),
    g: Zo(n[2] + n[2]),
    b: Zo(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Oa(e) {
  return !!Pi.CSS_UNIT.exec(String(e));
}
var sr = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = nB(t)), this.originalInput = t;
      var o = dc(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, o, i = t.r / 255, a = t.g / 255, s = t.b / 255;
      return i <= 0.03928 ? n = i / 12.92 : n = Math.pow((i + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? o = s / 12.92 : o = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = NO(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = c1(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = c1(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = L2(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = L2(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), u1(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), eB(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(co(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(co(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + u1(this.r, this.g, this.b, !1), n = 0, r = Object.entries(d1); n < r.length; n++) {
        var o = r[n], i = o[0], a = o[1];
        if (t === a)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t != null ? t : this.format;
      var r = !1, o = this.a < 1 && this.a >= 0, i = !n && o && (t.startsWith("hex") || t === "name");
      return i ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = dp(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = dp(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = dp(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = dp(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), o = new e(t).toRgb(), i = n / 100, a = {
        r: (o.r - r.r) * i + r.r,
        g: (o.g - r.g) * i + r.g,
        b: (o.b - r.b) * i + r.b,
        a: (o.a - r.a) * i + r.a
      };
      return new e(a);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), o = 360 / n, i = [this];
      for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + o) % 360, i.push(new e(r));
      return i;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, o = n.s, i = n.v, a = [], s = 1 / t; t--; )
        a.push(new e({ h: r, s: o, v: i })), i = (i + s) % 1;
      return a;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), o = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / o,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / o,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, o = [this], i = 360 / t, a = 1; a < t; a++)
        o.push(new e({ h: (r + a * i) % 360, s: n.s, l: n.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
), pp = 2, j2 = 0.16, aB = 0.05, sB = 0.05, lB = 0.15, PO = 5, IO = 4, cB = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function k2(e) {
  var t = e.r, n = e.g, r = e.b, o = c1(t, n, r);
  return {
    h: o.h * 360,
    s: o.s,
    v: o.v
  };
}
function hp(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(u1(t, n, r, !1));
}
function uB(e, t, n) {
  var r = n / 100, o = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return o;
}
function F2(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - pp * t : Math.round(e.h) + pp * t : r = n ? Math.round(e.h) + pp * t : Math.round(e.h) - pp * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function B2(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - j2 * t : t === IO ? r = e.s + j2 : r = e.s + aB * t, r > 1 && (r = 1), n && t === PO && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function H2(e, t, n) {
  var r;
  return n ? r = e.v + sB * t : r = e.v - lB * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function hl(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = dc(e), o = PO; o > 0; o -= 1) {
    var i = k2(r), a = hp(dc({
      h: F2(i, o, !0),
      s: B2(i, o, !0),
      v: H2(i, o, !0)
    }));
    n.push(a);
  }
  n.push(hp(r));
  for (var s = 1; s <= IO; s += 1) {
    var l = k2(r), u = hp(dc({
      h: F2(l, s),
      s: B2(l, s),
      v: H2(l, s)
    }));
    n.push(u);
  }
  return t.theme === "dark" ? cB.map(function(f) {
    var p = f.index, h = f.opacity, y = hp(uB(dc(t.backgroundColor || "#141414"), dc(n[p]), h * 100));
    return y;
  }) : n;
}
var bc = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, rd = {}, Lv = {};
Object.keys(bc).forEach(function(e) {
  rd[e] = hl(bc[e]), rd[e].primary = rd[e][5], Lv[e] = hl(bc[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), Lv[e].primary = Lv[e][5];
});
var dB = rd.gold, fB = rd.blue;
const pB = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function hB(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const RO = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, gB = Object.assign(Object.assign({}, RO), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), bd = gB;
function mB(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: o,
    colorWarning: i,
    colorError: a,
    colorInfo: s,
    colorPrimary: l,
    colorBgBase: u,
    colorTextBase: f
  } = e, p = n(l), h = n(o), y = n(i), b = n(a), m = n(s), v = r(u, f), C = e.colorLink || e.colorInfo, x = n(C);
  return Object.assign(Object.assign({}, v), {
    colorPrimaryBg: p[1],
    colorPrimaryBgHover: p[2],
    colorPrimaryBorder: p[3],
    colorPrimaryBorderHover: p[4],
    colorPrimaryHover: p[5],
    colorPrimary: p[6],
    colorPrimaryActive: p[7],
    colorPrimaryTextHover: p[8],
    colorPrimaryText: p[9],
    colorPrimaryTextActive: p[10],
    colorSuccessBg: h[1],
    colorSuccessBgHover: h[2],
    colorSuccessBorder: h[3],
    colorSuccessBorderHover: h[4],
    colorSuccessHover: h[4],
    colorSuccess: h[6],
    colorSuccessActive: h[7],
    colorSuccessTextHover: h[8],
    colorSuccessText: h[9],
    colorSuccessTextActive: h[10],
    colorErrorBg: b[1],
    colorErrorBgHover: b[2],
    colorErrorBorder: b[3],
    colorErrorBorderHover: b[4],
    colorErrorHover: b[5],
    colorError: b[6],
    colorErrorActive: b[7],
    colorErrorTextHover: b[8],
    colorErrorText: b[9],
    colorErrorTextActive: b[10],
    colorWarningBg: y[1],
    colorWarningBgHover: y[2],
    colorWarningBorder: y[3],
    colorWarningBorderHover: y[4],
    colorWarningHover: y[4],
    colorWarning: y[6],
    colorWarningActive: y[7],
    colorWarningTextHover: y[8],
    colorWarningText: y[9],
    colorWarningTextActive: y[10],
    colorInfoBg: m[1],
    colorInfoBgHover: m[2],
    colorInfoBorder: m[3],
    colorInfoBorderHover: m[4],
    colorInfoHover: m[4],
    colorInfo: m[6],
    colorInfoActive: m[7],
    colorInfoTextHover: m[8],
    colorInfoText: m[9],
    colorInfoTextActive: m[10],
    colorLinkHover: x[4],
    colorLink: x[6],
    colorLinkActive: x[7],
    colorBgMask: new sr("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const vB = (e) => {
  let t = e, n = e, r = e, o = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: o
  };
};
function yB(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, vB(r));
}
const _a = (e, t) => new sr(e).setAlpha(t).toRgbString(), Fu = (e, t) => new sr(e).darken(t).toHexString(), bB = (e) => {
  const t = hl(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, CB = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: _a(r, 0.88),
    colorTextSecondary: _a(r, 0.65),
    colorTextTertiary: _a(r, 0.45),
    colorTextQuaternary: _a(r, 0.25),
    colorFill: _a(r, 0.15),
    colorFillSecondary: _a(r, 0.06),
    colorFillTertiary: _a(r, 0.04),
    colorFillQuaternary: _a(r, 0.02),
    colorBgLayout: Fu(n, 4),
    colorBgContainer: Fu(n, 0),
    colorBgElevated: Fu(n, 0),
    colorBgSpotlight: _a(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: Fu(n, 15),
    colorBorderSecondary: Fu(n, 6)
  };
};
function Zp(e) {
  return (e + 8) / e;
}
function xB(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const o = r - 1, i = e * Math.pow(2.71828, o / 5), a = r > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: Zp(n)
  }));
}
const SB = (e) => {
  const t = xB(e), n = t.map((f) => f.size), r = t.map((f) => f.lineHeight), o = n[1], i = n[0], a = n[2], s = r[1], l = r[0], u = r[2];
  return {
    fontSizeSM: i,
    fontSize: o,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: u,
    lineHeightSM: l,
    fontHeight: Math.round(s * o),
    fontHeightLG: Math.round(u * a),
    fontHeightSM: Math.round(l * i),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
};
function wB(e) {
  const t = Object.keys(RO).map((n) => {
    const r = hl(e[n]);
    return new Array(10).fill(1).reduce((o, i, a) => (o[`${n}-${a + 1}`] = r[a], o[`${n}${a + 1}`] = r[a], o), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), mB(e, {
    generateColorPalettes: bB,
    generateNeutralColorPalettes: CB
  })), SB(e.fontSize)), hB(e)), pB(e)), yB(e));
}
const DO = t1(wB), TO = {
  token: bd,
  override: {
    override: bd
  },
  hashed: !0
}, MO = /* @__PURE__ */ be.createContext(TO), fb = "anticon", EB = (e, t) => t || (e ? `ant-${e}` : "ant"), Ft = /* @__PURE__ */ c.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: EB,
  iconPrefixCls: fb
}), $B = `-ant-${Date.now()}-${Math.random()}`;
function OB(e, t) {
  const n = {}, r = (a, s) => {
    let l = a.clone();
    return l = (s == null ? void 0 : s(l)) || l, l.toRgbString();
  }, o = (a, s) => {
    const l = new sr(a), u = hl(l.toRgbString());
    n[`${s}-color`] = r(l), n[`${s}-color-disabled`] = u[1], n[`${s}-color-hover`] = u[4], n[`${s}-color-active`] = u[6], n[`${s}-color-outline`] = l.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = u[0], n[`${s}-color-deprecated-border`] = u[2];
  };
  if (t.primaryColor) {
    o(t.primaryColor, "primary");
    const a = new sr(t.primaryColor), s = hl(a.toRgbString());
    s.forEach((u, f) => {
      n[`primary-${f + 1}`] = u;
    }), n["primary-color-deprecated-l-35"] = r(a, (u) => u.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (u) => u.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (u) => u.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (u) => u.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (u) => u.setAlpha(u.getAlpha() * 0.12));
    const l = new sr(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(l, (u) => u.setAlpha(u.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(l, (u) => u.darken(2));
  }
  return t.successColor && o(t.successColor, "success"), t.warningColor && o(t.warningColor, "warning"), t.errorColor && o(t.errorColor, "error"), t.infoColor && o(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function _B(e, t) {
  const n = OB(e, t);
  Hr() ? Os(n, `${$B}-dynamic-theme`) : process.env.NODE_ENV !== "production" && Wd(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const f1 = /* @__PURE__ */ c.createContext(!1), LO = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = c.useContext(f1);
  return /* @__PURE__ */ c.createElement(f1.Provider, {
    value: n != null ? n : r
  }, t);
}, Ki = f1, p1 = /* @__PURE__ */ c.createContext(void 0), NB = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = c.useContext(p1);
  return /* @__PURE__ */ c.createElement(p1.Provider, {
    value: n || r
  }, t);
}, Kd = p1;
function PB() {
  const e = Cn(Ki), t = Cn(Kd);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
const Cd = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], IB = "5.13.3";
function Av(e) {
  return e >= 0 && e <= 255;
}
function gp(e, t) {
  const {
    r: n,
    g: r,
    b: o,
    a: i
  } = new sr(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: a,
    g: s,
    b: l
  } = new sr(t).toRgb();
  for (let u = 0.01; u <= 1; u += 0.01) {
    const f = Math.round((n - a * (1 - u)) / u), p = Math.round((r - s * (1 - u)) / u), h = Math.round((o - l * (1 - u)) / u);
    if (Av(f) && Av(p) && Av(h))
      return new sr({
        r: f,
        g: p,
        b: h,
        a: Math.round(u * 100) / 100
      }).toRgbString();
  }
  return new sr({
    r: n,
    g: r,
    b: o,
    a: 1
  }).toRgbString();
}
var RB = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function AO(e) {
  const {
    override: t
  } = e, n = RB(e, ["override"]), r = Object.assign({}, t);
  Object.keys(bd).forEach((h) => {
    delete r[h];
  });
  const o = Object.assign(Object.assign({}, n), r), i = 480, a = 576, s = 768, l = 992, u = 1200, f = 1600;
  if (o.motion === !1) {
    const h = "0s";
    o.motionDurationFast = h, o.motionDurationMid = h, o.motionDurationSlow = h;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: gp(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: gp(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: gp(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 4,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: gp(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: u - 1,
    screenXL: u,
    screenXLMin: u,
    screenXLMax: f - 1,
    screenXXL: f,
    screenXXLMin: f,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new sr("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new sr("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new sr("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var z2 = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const jO = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, kO = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, DB = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, FO = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: o
  } = t, i = z2(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: o
  });
  return a = AO(a), i && Object.entries(i).forEach((s) => {
    let [l, u] = s;
    const {
      theme: f
    } = u, p = z2(u, ["theme"]);
    let h = p;
    f && (h = FO(Object.assign(Object.assign({}, a), p), {
      override: p
    }, f)), a[l] = h;
  }), a;
};
function ro() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: o
  } = be.useContext(MO), i = `${IB}-${t || ""}`, a = n || DO, [s, l, u] = cF(a, [bd, e], {
    salt: i,
    override: r,
    getComputedToken: FO,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: AO,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: jO,
      ignore: kO,
      preserve: DB
    }
  });
  return [a, u, t ? l : "", s, o];
}
function Ir(e) {
  var t = c.useRef();
  t.current = e;
  var n = c.useCallback(function() {
    for (var r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(i));
  }, []);
  return n;
}
function xs(e) {
  var t = c.useRef(!1), n = c.useState(e), r = de(n, 2), o = r[0], i = r[1];
  c.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || i(s);
  }
  return [o, a];
}
function jv(e) {
  return e !== void 0;
}
function Fn(e, t) {
  var n = t || {}, r = n.defaultValue, o = n.value, i = n.onChange, a = n.postState, s = xs(function() {
    return jv(o) ? o : jv(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = de(s, 2), u = l[0], f = l[1], p = o !== void 0 ? o : u, h = a ? a(p) : p, y = Ir(i), b = xs([p]), m = de(b, 2), v = m[0], C = m[1];
  _2(function() {
    var S = v[0];
    u !== S && y(u, S);
  }, [v]), _2(function() {
    jv(o) || f(o);
  }, [o]);
  var x = Ir(function(S, E) {
    f(S, E), C([p], E);
  });
  return [h, x];
}
const pb = (e) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${e.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
}), gl = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, Qn = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, Ud = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), Eh = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), TB = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), MB = (e, t) => {
  const {
    fontFamily: n,
    fontSize: r
  } = e, o = `[class^="${t}"], [class*=" ${t}"]`;
  return {
    [o]: {
      fontFamily: n,
      fontSize: r,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [o]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
}, Va = (e) => ({
  outline: `${te(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), $h = (e) => ({
  "&:focus-visible": Object.assign({}, Va(e))
});
let LB = /* @__PURE__ */ Vr(function e() {
  zr(this, e);
});
const BO = LB;
function AB(e, t, n) {
  return t = $s(t), rb(e, pg() ? Reflect.construct(t, n || [], $s(e).constructor) : t.apply(e, n));
}
let jB = /* @__PURE__ */ function(e) {
  Wi(t, e);
  function t(n) {
    var r;
    return zr(this, t), r = AB(this, t), r.result = 0, n instanceof t ? r.result = n.result : typeof n == "number" && (r.result = n), r;
  }
  return Vr(t, [{
    key: "add",
    value: function(r) {
      return r instanceof t ? this.result += r.result : typeof r == "number" && (this.result += r), this;
    }
  }, {
    key: "sub",
    value: function(r) {
      return r instanceof t ? this.result -= r.result : typeof r == "number" && (this.result -= r), this;
    }
  }, {
    key: "mul",
    value: function(r) {
      return r instanceof t ? this.result *= r.result : typeof r == "number" && (this.result *= r), this;
    }
  }, {
    key: "div",
    value: function(r) {
      return r instanceof t ? this.result /= r.result : typeof r == "number" && (this.result /= r), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), t;
}(BO);
function kB(e, t, n) {
  return t = $s(t), rb(e, pg() ? Reflect.construct(t, n || [], $s(e).constructor) : t.apply(e, n));
}
const HO = "CALC_UNIT";
function kv(e) {
  return typeof e == "number" ? `${e}${HO}` : e;
}
let FB = /* @__PURE__ */ function(e) {
  Wi(t, e);
  function t(n) {
    var r;
    return zr(this, t), r = kB(this, t), r.result = "", n instanceof t ? r.result = `(${n.result})` : typeof n == "number" ? r.result = kv(n) : typeof n == "string" && (r.result = n), r;
  }
  return Vr(t, [{
    key: "add",
    value: function(r) {
      return r instanceof t ? this.result = `${this.result} + ${r.getResult()}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} + ${kv(r)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(r) {
      return r instanceof t ? this.result = `${this.result} - ${r.getResult()}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} - ${kv(r)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(r) {
      return this.lowPriority && (this.result = `(${this.result})`), r instanceof t ? this.result = `${this.result} * ${r.getResult(!0)}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} * ${r}`), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(r) {
      return this.lowPriority && (this.result = `(${this.result})`), r instanceof t ? this.result = `${this.result} / ${r.getResult(!0)}` : (typeof r == "number" || typeof r == "string") && (this.result = `${this.result} / ${r}`), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(r) {
      return this.lowPriority || r ? `(${this.result})` : this.result;
    }
  }, {
    key: "equal",
    value: function(r) {
      const {
        unit: o = !0
      } = r || {}, i = new RegExp(`${HO}`, "g");
      return this.result = this.result.replace(i, o ? "px" : ""), typeof this.lowPriority != "undefined" ? `calc(${this.result})` : this.result;
    }
  }]), t;
}(BO);
const BB = (e) => {
  const t = e === "css" ? FB : jB;
  return (n) => new t(n);
};
function HB(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return `max(${n.map((o) => te(o)).join(",")})`;
    },
    min: function() {
      for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
        n[r] = arguments[r];
      return `min(${n.map((o) => te(o)).join(",")})`;
    }
  };
}
const zO = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC != "undefined";
let h1 = !0;
function Sn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!zO)
    return Object.assign.apply(Object, [{}].concat(t));
  h1 = !1;
  const r = {};
  return t.forEach((o) => {
    Object.keys(o).forEach((a) => {
      Object.defineProperty(r, a, {
        configurable: !0,
        enumerable: !0,
        get: () => o[a]
      });
    });
  }), h1 = !0, r;
}
const V2 = {};
function zB() {
}
const VB = (e) => {
  let t, n = e, r = zB;
  return zO && typeof Proxy != "undefined" && (t = /* @__PURE__ */ new Set(), n = new Proxy(e, {
    get(o, i) {
      return h1 && t.add(i), o[i];
    }
  }), r = (o, i) => {
    var a;
    V2[o] = {
      global: Array.from(t),
      component: Object.assign(Object.assign({}, (a = V2[o]) === null || a === void 0 ? void 0 : a.component), i)
    };
  }), {
    token: n,
    keys: t,
    flush: r
  };
}, VO = (e, t) => {
  const [n, r] = ro();
  return l1({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, Ud()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, WO = (e, t, n) => {
  var r;
  return typeof n == "function" ? n(Sn(t, (r = t[e]) !== null && r !== void 0 ? r : {})) : n != null ? n : {};
}, KO = (e, t, n, r) => {
  const o = Object.assign({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    const {
      deprecatedTokens: a
    } = r;
    a.forEach((s) => {
      let [l, u] = s;
      var f;
      process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && mt(!(o != null && o[l]), `Component Token \`${String(l)}\` of ${e} is deprecated. Please use \`${String(u)}\` instead.`), (o != null && o[l] || o != null && o[u]) && ((f = o[u]) !== null && f !== void 0 || (o[u] = o == null ? void 0 : o[l]));
    });
  }
  const i = Object.assign(Object.assign({}, n), o);
  return Object.keys(i).forEach((a) => {
    i[a] === t[a] && delete i[a];
  }), i;
}, WB = (e, t) => `${[t, e.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function hb(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const o = Array.isArray(e) ? e : [e, e], [i] = o, a = o.join("-");
  return (s) => {
    const [l, u, f, p, h] = ro(), {
      getPrefixCls: y,
      iconPrefixCls: b,
      csp: m
    } = Cn(Ft), v = y(), C = h ? "css" : "js", x = BB(C), {
      max: S,
      min: E
    } = HB(C), O = {
      theme: l,
      token: p,
      hashId: f,
      nonce: () => m == null ? void 0 : m.nonce,
      clientOnly: r.clientOnly,
      // antd is always at top of styles
      order: r.order || -999
    };
    return l1(Object.assign(Object.assign({}, O), {
      clientOnly: !1,
      path: ["Shared", v]
    }), () => [{
      // Link
      "&": TB(p)
    }]), VO(b, m), [l1(Object.assign(Object.assign({}, O), {
      path: [a, s, b]
    }), () => {
      if (r.injectStyle === !1)
        return [];
      const {
        token: _,
        flush: R
      } = VB(p), P = WO(i, u, n), I = `.${s}`, j = KO(i, u, P, {
        deprecatedTokens: r.deprecatedTokens
      });
      h && Object.keys(P).forEach((M) => {
        P[M] = `var(${J4(M, WB(i, h.prefix))})`;
      });
      const F = Sn(_, {
        componentCls: I,
        prefixCls: s,
        iconCls: `.${b}`,
        antCls: `.${v}`,
        calc: x,
        max: S,
        min: E
      }, h ? P : j), A = t(F, {
        hashId: f,
        prefixCls: s,
        rootPrefixCls: v,
        iconPrefixCls: b
      });
      return R(i, j), [r.resetStyle === !1 ? null : MB(F, s), A];
    }), f];
  };
}
const gb = (e, t, n, r) => {
  const o = hb(e, t, n, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, r)), i = (a) => {
    let {
      prefixCls: s
    } = a;
    return o(s), null;
  };
  return process.env.NODE_ENV !== "production" && (i.displayName = `SubStyle_${Array.isArray(e) ? e.join(".") : e}`), i;
}, KB = (e, t, n) => {
  function r(u) {
    return `${e}${u.slice(0, 1).toUpperCase()}${u.slice(1)}`;
  }
  const {
    unitless: o = {},
    injectStyle: i = !0
  } = n != null ? n : {}, a = {
    [r("zIndexPopup")]: !0
  };
  Object.keys(o).forEach((u) => {
    a[r(u)] = o[u];
  });
  const s = (u) => {
    let {
      rootCls: f,
      cssVar: p
    } = u;
    const [, h] = ro();
    return kF({
      path: [e],
      prefix: p.prefix,
      key: p == null ? void 0 : p.key,
      unitless: Object.assign(Object.assign({}, jO), a),
      ignore: kO,
      token: h,
      scope: f
    }, () => {
      const y = WO(e, h, t), b = KO(e, h, y, {
        deprecatedTokens: n == null ? void 0 : n.deprecatedTokens
      });
      return Object.keys(y).forEach((m) => {
        b[r(m)] = b[m], delete b[m];
      }), b;
    }), null;
  };
  return (u) => {
    const [, , , , f] = ro();
    return [(p) => i && f ? /* @__PURE__ */ be.createElement(be.Fragment, null, /* @__PURE__ */ be.createElement(s, {
      rootCls: u,
      cssVar: f,
      component: e
    }), p) : p, f == null ? void 0 : f.key];
  };
}, Gn = (e, t, n, r) => {
  const o = hb(e, t, n, r), i = KB(Array.isArray(e) ? e[0] : e, n, r);
  return function(a) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a;
    const [, l] = o(a), [u, f] = i(s);
    return [u, l, f];
  };
};
function UB(e, t) {
  return Cd.reduce((n, r) => {
    const o = e[`${r}1`], i = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: o,
      lightBorderColor: i,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
const GB = Object.assign({}, c), {
  useId: W2
} = GB, qB = () => "", YB = typeof W2 == "undefined" ? qB : W2;
function XB(e, t) {
  var n;
  const r = xn("ConfigProvider"), o = e || {}, i = o.inherit === !1 || !t ? TO : t, a = YB();
  if (process.env.NODE_ENV !== "production") {
    const s = o.cssVar || i.cssVar, l = !!(typeof o.cssVar == "object" && (!((n = o.cssVar) === null || n === void 0) && n.key) || a);
    process.env.NODE_ENV !== "production" && r(!s || l, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return ua(() => {
    var s, l;
    if (!e)
      return t;
    const u = Object.assign({}, i.components);
    Object.keys(e.components || {}).forEach((h) => {
      u[h] = Object.assign(Object.assign({}, u[h]), e.components[h]);
    });
    const f = `css-var-${a.replace(/:/g, "")}`, p = ((s = o.cssVar) !== null && s !== void 0 ? s : i.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: "ant"
    }, typeof i.cssVar == "object" ? i.cssVar : {}), typeof o.cssVar == "object" ? o.cssVar : {}), {
      key: typeof o.cssVar == "object" && ((l = o.cssVar) === null || l === void 0 ? void 0 : l.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, i), o), {
      token: Object.assign(Object.assign({}, i.token), o.token),
      components: u,
      cssVar: p
    });
  }, [o, i], (s, l) => s.some((u, f) => {
    const p = l[f];
    return !Fi(u, p, !0);
  }));
}
var ZB = ["children"], UO = /* @__PURE__ */ c.createContext({});
function QB(e) {
  var t = e.children, n = Yt(e, ZB);
  return /* @__PURE__ */ c.createElement(UO.Provider, {
    value: n
  }, t);
}
var JB = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    return zr(this, n), t.apply(this, arguments);
  }
  return Vr(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(c.Component), Ys = "none", mp = "appear", vp = "enter", yp = "leave", K2 = "none", Mi = "prepare", mc = "start", vc = "active", mb = "end", GO = "prepared";
function U2(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function eH(e, t) {
  var n = {
    animationend: U2("Animation", "AnimationEnd"),
    transitionend: U2("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var tH = eH(Hr(), typeof window != "undefined" ? window : {}), qO = {};
if (Hr()) {
  var nH = document.createElement("div");
  qO = nH.style;
}
var bp = {};
function YO(e) {
  if (bp[e])
    return bp[e];
  var t = tH[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, o = 0; o < r; o += 1) {
      var i = n[o];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in qO)
        return bp[e] = t[i], bp[e];
    }
  return "";
}
var XO = YO("animationend"), ZO = YO("transitionend"), QO = !!(XO && ZO), G2 = XO || "animationend", q2 = ZO || "transitionend";
function Y2(e, t) {
  if (!e)
    return null;
  if (Vt(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const rH = function(e) {
  var t = _t(), n = _t(e);
  n.current = e;
  var r = c.useCallback(function(a) {
    n.current(a);
  }, []);
  function o(a) {
    a && (a.removeEventListener(q2, r), a.removeEventListener(G2, r));
  }
  function i(a) {
    t.current && t.current !== a && o(t.current), a && a !== t.current && (a.addEventListener(q2, r), a.addEventListener(G2, r), t.current = a);
  }
  return c.useEffect(function() {
    return function() {
      o(t.current);
    };
  }, []), [i, o];
};
var JO = Hr() ? A0 : kt;
const oH = function() {
  var e = c.useRef(null);
  function t() {
    Pn.cancel(e.current);
  }
  function n(r) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = Pn(function() {
      o <= 1 ? r({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : n(r, o - 1);
    });
    e.current = i;
  }
  return c.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var iH = [Mi, mc, vc, mb], aH = [Mi, GO], e5 = !1, sH = !0;
function t5(e) {
  return e === vc || e === mb;
}
const lH = function(e, t, n) {
  var r = xs(K2), o = de(r, 2), i = o[0], a = o[1], s = oH(), l = de(s, 2), u = l[0], f = l[1];
  function p() {
    a(Mi, !0);
  }
  var h = t ? aH : iH;
  return JO(function() {
    if (i !== K2 && i !== mb) {
      var y = h.indexOf(i), b = h[y + 1], m = n(i);
      m === e5 ? a(b, !0) : b && u(function(v) {
        function C() {
          v.isCanceled() || a(b, !0);
        }
        m === !0 ? C() : Promise.resolve(m).then(C);
      });
    }
  }, [e, i]), c.useEffect(function() {
    return function() {
      f();
    };
  }, []), [p, i];
};
function cH(e, t, n, r) {
  var o = r.motionEnter, i = o === void 0 ? !0 : o, a = r.motionAppear, s = a === void 0 ? !0 : a, l = r.motionLeave, u = l === void 0 ? !0 : l, f = r.motionDeadline, p = r.motionLeaveImmediately, h = r.onAppearPrepare, y = r.onEnterPrepare, b = r.onLeavePrepare, m = r.onAppearStart, v = r.onEnterStart, C = r.onLeaveStart, x = r.onAppearActive, S = r.onEnterActive, E = r.onLeaveActive, O = r.onAppearEnd, $ = r.onEnterEnd, _ = r.onLeaveEnd, R = r.onVisibleChanged, P = xs(), I = de(P, 2), j = I[0], F = I[1], A = xs(Ys), M = de(A, 2), N = M[0], D = M[1], T = xs(null), L = de(T, 2), z = L[0], H = L[1], V = _t(!1), Y = _t(null);
  function Z() {
    return n();
  }
  var oe = _t(!1);
  function ee() {
    D(Ys, !0), H(null, !0);
  }
  function ae(he) {
    var me = Z();
    if (!(he && !he.deadline && he.target !== me)) {
      var Ce = oe.current, Te;
      N === mp && Ce ? Te = O == null ? void 0 : O(me, he) : N === vp && Ce ? Te = $ == null ? void 0 : $(me, he) : N === yp && Ce && (Te = _ == null ? void 0 : _(me, he)), N !== Ys && Ce && Te !== !1 && ee();
    }
  }
  var le = rH(ae), ue = de(le, 1), ie = ue[0], re = function(me) {
    var Ce, Te, Ee;
    switch (me) {
      case mp:
        return Ce = {}, K(Ce, Mi, h), K(Ce, mc, m), K(Ce, vc, x), Ce;
      case vp:
        return Te = {}, K(Te, Mi, y), K(Te, mc, v), K(Te, vc, S), Te;
      case yp:
        return Ee = {}, K(Ee, Mi, b), K(Ee, mc, C), K(Ee, vc, E), Ee;
      default:
        return {};
    }
  }, Q = c.useMemo(function() {
    return re(N);
  }, [N]), ce = lH(N, !e, function(he) {
    if (he === Mi) {
      var me = Q[Mi];
      return me ? me(Z()) : e5;
    }
    if (ne in Q) {
      var Ce;
      H(((Ce = Q[ne]) === null || Ce === void 0 ? void 0 : Ce.call(Q, Z(), null)) || null);
    }
    return ne === vc && (ie(Z()), f > 0 && (clearTimeout(Y.current), Y.current = setTimeout(function() {
      ae({
        deadline: !0
      });
    }, f))), ne === GO && ee(), sH;
  }), ge = de(ce, 2), G = ge[0], ne = ge[1], fe = t5(ne);
  oe.current = fe, JO(function() {
    F(t);
    var he = V.current;
    V.current = !0;
    var me;
    !he && t && s && (me = mp), he && t && i && (me = vp), (he && !t && u || !he && p && !t && u) && (me = yp);
    var Ce = re(me);
    me && (e || Ce[Mi]) ? (D(me), G()) : D(Ys);
  }, [t]), kt(function() {
    // Cancel appear
    (N === mp && !s || // Cancel enter
    N === vp && !i || // Cancel leave
    N === yp && !u) && D(Ys);
  }, [s, i, u]), kt(function() {
    return function() {
      V.current = !1, clearTimeout(Y.current);
    };
  }, []);
  var ye = c.useRef(!1);
  kt(function() {
    j && (ye.current = !0), j !== void 0 && N === Ys && ((ye.current || j) && (R == null || R(j)), ye.current = !0);
  }, [j, N]);
  var we = z;
  return Q[Mi] && ne === mc && (we = J({
    transition: "none"
  }, we)), [N, ne, we, j != null ? j : t];
}
function uH(e) {
  var t = e;
  Vt(e) === "object" && (t = e.transitionSupport);
  function n(o, i) {
    return !!(o.motionName && t && i !== !1);
  }
  var r = /* @__PURE__ */ c.forwardRef(function(o, i) {
    var a = o.visible, s = a === void 0 ? !0 : a, l = o.removeOnLeave, u = l === void 0 ? !0 : l, f = o.forceRender, p = o.children, h = o.motionName, y = o.leavedClassName, b = o.eventProps, m = c.useContext(UO), v = m.motion, C = n(o, v), x = _t(), S = _t();
    function E() {
      try {
        return x.current instanceof HTMLElement ? x.current : Ju(S.current);
      } catch (H) {
        return null;
      }
    }
    var O = cH(C, s, E, o), $ = de(O, 4), _ = $[0], R = $[1], P = $[2], I = $[3], j = c.useRef(I);
    I && (j.current = !0);
    var F = c.useCallback(function(H) {
      x.current = H, md(i, H);
    }, [i]), A, M = J(J({}, b), {}, {
      visible: s
    });
    if (!p)
      A = null;
    else if (_ === Ys)
      I ? A = p(J({}, M), F) : !u && j.current && y ? A = p(J(J({}, M), {}, {
        className: y
      }), F) : f || !u && !y ? A = p(J(J({}, M), {}, {
        style: {
          display: "none"
        }
      }), F) : A = null;
    else {
      var N, D;
      R === Mi ? D = "prepare" : t5(R) ? D = "active" : R === mc && (D = "start");
      var T = Y2(h, "".concat(_, "-").concat(D));
      A = p(J(J({}, M), {}, {
        className: se(Y2(h, _), (N = {}, K(N, T, T && D), K(N, h, typeof h == "string"), N)),
        style: P
      }), F);
    }
    if (/* @__PURE__ */ c.isValidElement(A) && ki(A)) {
      var L = A, z = L.ref;
      z || (A = /* @__PURE__ */ c.cloneElement(A, {
        ref: F
      }));
    }
    return /* @__PURE__ */ c.createElement(JB, {
      ref: S
    }, A);
  });
  return r.displayName = "CSSMotion", r;
}
const Bi = uH(QO);
var g1 = "add", m1 = "keep", v1 = "remove", Fv = "removed";
function dH(e) {
  var t;
  return e && Vt(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, J(J({}, t), {}, {
    key: String(t.key)
  });
}
function y1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(dH);
}
function fH() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, o = t.length, i = y1(e), a = y1(t);
  i.forEach(function(u) {
    for (var f = !1, p = r; p < o; p += 1) {
      var h = a[p];
      if (h.key === u.key) {
        r < p && (n = n.concat(a.slice(r, p).map(function(y) {
          return J(J({}, y), {}, {
            status: g1
          });
        })), r = p), n.push(J(J({}, h), {}, {
          status: m1
        })), r += 1, f = !0;
        break;
      }
    }
    f || n.push(J(J({}, u), {}, {
      status: v1
    }));
  }), r < o && (n = n.concat(a.slice(r).map(function(u) {
    return J(J({}, u), {}, {
      status: g1
    });
  })));
  var s = {};
  n.forEach(function(u) {
    var f = u.key;
    s[f] = (s[f] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(u) {
    return s[u] > 1;
  });
  return l.forEach(function(u) {
    n = n.filter(function(f) {
      var p = f.key, h = f.status;
      return p !== u || h !== v1;
    }), n.forEach(function(f) {
      f.key === u && (f.status = m1);
    });
  }), n;
}
var pH = ["component", "children", "onVisibleChanged", "onAllRemoved"], hH = ["status"], gH = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function mH(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Bi, n = /* @__PURE__ */ function(r) {
    Wi(i, r);
    var o = Ga(i);
    function i() {
      var a;
      zr(this, i);
      for (var s = arguments.length, l = new Array(s), u = 0; u < s; u++)
        l[u] = arguments[u];
      return a = o.call.apply(o, [this].concat(l)), K(nt(a), "state", {
        keyEntities: []
      }), K(nt(a), "removeKey", function(f) {
        var p = a.state.keyEntities, h = p.map(function(y) {
          return y.key !== f ? y : J(J({}, y), {}, {
            status: Fv
          });
        });
        return a.setState({
          keyEntities: h
        }), h.filter(function(y) {
          var b = y.status;
          return b !== Fv;
        }).length;
      }), a;
    }
    return Vr(i, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, u = this.props, f = u.component, p = u.children, h = u.onVisibleChanged, y = u.onAllRemoved, b = Yt(u, pH), m = f || c.Fragment, v = {};
        return gH.forEach(function(C) {
          v[C] = b[C], delete b[C];
        }), delete b.keys, /* @__PURE__ */ c.createElement(m, b, l.map(function(C, x) {
          var S = C.status, E = Yt(C, hH), O = S === g1 || S === m1;
          return /* @__PURE__ */ c.createElement(t, Oe({}, v, {
            key: E.key,
            visible: O,
            eventProps: E,
            onVisibleChanged: function(_) {
              if (h == null || h(_, {
                key: E.key
              }), !_) {
                var R = s.removeKey(E.key);
                R === 0 && y && y();
              }
            }
          }), function($, _) {
            return p(J(J({}, $), {}, {
              index: x
            }), _);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var u = s.keys, f = l.keyEntities, p = y1(u), h = fH(f, p);
        return {
          keyEntities: h.filter(function(y) {
            var b = f.find(function(m) {
              var v = m.key;
              return y.key === v;
            });
            return !(b && b.status === Fv && y.status === v1);
          })
        };
      }
    }]), i;
  }(c.Component);
  return K(n, "defaultProps", {
    component: "div"
  }), n;
}
const n5 = mH(QO);
function vH(e) {
  const {
    children: t
  } = e, [, n] = ro(), {
    motion: r
  } = n, o = c.useRef(!1);
  return o.current = o.current || r === !1, o.current ? /* @__PURE__ */ c.createElement(QB, {
    motion: r
  }, t) : t;
}
const r5 = /* @__PURE__ */ c.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return xn("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (r5.displayName = "PropWarning");
const yH = process.env.NODE_ENV !== "production" ? r5 : () => null;
var bH = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let b1 = !1;
const CH = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && Wd(!b1, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), xH = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"], SH = "ant";
let Oh, o5, i5, a5;
function Qp() {
  return Oh || SH;
}
function wH() {
  return o5 || fb;
}
function EH(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const $H = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: o
  } = e;
  t !== void 0 && (Oh = t), n !== void 0 && (o5 = n), "holderRender" in e && (a5 = o), r && (EH(r) ? (process.env.NODE_ENV !== "production" && Wd(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), _B(Qp(), r)) : i5 = r);
}, s5 = () => ({
  getPrefixCls: (e, t) => t || (e ? `${Qp()}-${e}` : Qp()),
  getIconPrefixCls: wH,
  getRootPrefixCls: () => Oh || Qp(),
  getTheme: () => i5,
  holderRender: a5
}), OH = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    form: a,
    locale: s,
    componentSize: l,
    direction: u,
    space: f,
    virtual: p,
    dropdownMatchSelectWidth: h,
    popupMatchSelectWidth: y,
    popupOverflow: b,
    legacyLocale: m,
    parentContext: v,
    iconPrefixCls: C,
    theme: x,
    componentDisabled: S,
    segmented: E,
    statistic: O,
    spin: $,
    calendar: _,
    carousel: R,
    cascader: P,
    collapse: I,
    typography: j,
    checkbox: F,
    descriptions: A,
    divider: M,
    drawer: N,
    skeleton: D,
    steps: T,
    image: L,
    layout: z,
    list: H,
    mentions: V,
    modal: Y,
    progress: Z,
    result: oe,
    slider: ee,
    breadcrumb: ae,
    menu: le,
    pagination: ue,
    input: ie,
    empty: re,
    badge: Q,
    radio: ce,
    rate: ge,
    switch: G,
    transfer: ne,
    avatar: fe,
    message: ye,
    tag: we,
    table: he,
    card: me,
    tabs: Ce,
    timeline: Te,
    timePicker: Ee,
    upload: Ge,
    notification: ke,
    tree: qe,
    colorPicker: ze,
    datePicker: pt,
    rangePicker: Ke,
    flex: et,
    wave: Je,
    dropdown: Et,
    warning: Ye
  } = e, wt = c.useCallback((Fe, yt) => {
    const {
      prefixCls: Qe
    } = e;
    if (yt)
      return yt;
    const tt = Qe || v.getPrefixCls("");
    return Fe ? `${tt}-${Fe}` : tt;
  }, [v.getPrefixCls, e.prefixCls]), dt = C || v.iconPrefixCls || fb, Ct = n || v.csp;
  VO(dt, Ct);
  const ot = XB(x, v.theme);
  process.env.NODE_ENV !== "production" && (b1 = b1 || !!ot);
  const jt = {
    csp: Ct,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    locale: s || m,
    direction: u,
    space: f,
    virtual: p,
    popupMatchSelectWidth: y != null ? y : h,
    popupOverflow: b,
    getPrefixCls: wt,
    iconPrefixCls: dt,
    theme: ot,
    segmented: E,
    statistic: O,
    spin: $,
    calendar: _,
    carousel: R,
    cascader: P,
    collapse: I,
    typography: j,
    checkbox: F,
    descriptions: A,
    divider: M,
    drawer: N,
    skeleton: D,
    steps: T,
    image: L,
    input: ie,
    layout: z,
    list: H,
    mentions: V,
    modal: Y,
    progress: Z,
    result: oe,
    slider: ee,
    breadcrumb: ae,
    menu: le,
    pagination: ue,
    empty: re,
    badge: Q,
    radio: ce,
    rate: ge,
    switch: G,
    transfer: ne,
    avatar: fe,
    message: ye,
    tag: we,
    table: he,
    card: me,
    tabs: Ce,
    timeline: Te,
    timePicker: Ee,
    upload: Ge,
    notification: ke,
    tree: qe,
    colorPicker: ze,
    datePicker: pt,
    rangePicker: Ke,
    flex: et,
    wave: Je,
    dropdown: Et,
    warning: Ye
  }, Rt = Object.assign({}, v);
  Object.keys(jt).forEach((Fe) => {
    jt[Fe] !== void 0 && (Rt[Fe] = jt[Fe]);
  }), xH.forEach((Fe) => {
    const yt = e[Fe];
    yt && (Rt[Fe] = yt);
  });
  const Le = ua(() => Rt, Rt, (Fe, yt) => {
    const Qe = Object.keys(Fe), tt = Object.keys(yt);
    return Qe.length !== tt.length || Qe.some((lt) => Fe[lt] !== yt[lt]);
  }), Ve = c.useMemo(() => ({
    prefixCls: dt,
    csp: Ct
  }), [dt, Ct]);
  let Ae = /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(yH, {
    dropdownMatchSelectWidth: h
  }), t);
  const ft = c.useMemo(() => {
    var Fe, yt, Qe, tt;
    return gc(((Fe = za.Form) === null || Fe === void 0 ? void 0 : Fe.defaultValidateMessages) || {}, ((Qe = (yt = Le.locale) === null || yt === void 0 ? void 0 : yt.Form) === null || Qe === void 0 ? void 0 : Qe.defaultValidateMessages) || {}, ((tt = Le.form) === null || tt === void 0 ? void 0 : tt.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [Le, a == null ? void 0 : a.validateMessages]);
  Object.keys(ft).length > 0 && (Ae = /* @__PURE__ */ c.createElement(wO.Provider, {
    value: ft
  }, Ae)), s && (Ae = /* @__PURE__ */ c.createElement(qF, {
    locale: s,
    _ANT_MARK__: OO
  }, Ae)), (dt || Ct) && (Ae = /* @__PURE__ */ c.createElement(cb.Provider, {
    value: Ve
  }, Ae)), l && (Ae = /* @__PURE__ */ c.createElement(NB, {
    size: l
  }, Ae)), Ae = /* @__PURE__ */ c.createElement(vH, null, Ae);
  const He = c.useMemo(() => {
    const Fe = ot || {}, {
      algorithm: yt,
      token: Qe,
      components: tt,
      cssVar: lt
    } = Fe, ht = bH(Fe, ["algorithm", "token", "components", "cssVar"]), bt = yt && (!Array.isArray(yt) || yt.length > 0) ? t1(yt) : DO, ct = {};
    Object.entries(tt || {}).forEach((vt) => {
      let [_e, Ze] = vt;
      const q = Object.assign({}, Ze);
      "algorithm" in q && (q.algorithm === !0 ? q.theme = bt : (Array.isArray(q.algorithm) || typeof q.algorithm == "function") && (q.theme = t1(q.algorithm)), delete q.algorithm), ct[_e] = q;
    });
    const xt = Object.assign(Object.assign({}, bd), Qe);
    return Object.assign(Object.assign({}, ht), {
      theme: bt,
      token: xt,
      components: ct,
      override: Object.assign({
        override: xt
      }, ct),
      cssVar: lt
    });
  }, [ot]);
  return x && (Ae = /* @__PURE__ */ c.createElement(MO.Provider, {
    value: He
  }, Ae)), Le.warning && (Ae = /* @__PURE__ */ c.createElement(SO.Provider, {
    value: Le.warning
  }, Ae)), S !== void 0 && (Ae = /* @__PURE__ */ c.createElement(LO, {
    disabled: S
  }, Ae)), /* @__PURE__ */ c.createElement(Ft.Provider, {
    value: Le
  }, Ae);
}, Nl = (e) => {
  const t = c.useContext(Ft), n = c.useContext(db);
  return /* @__PURE__ */ c.createElement(OH, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
Nl.ConfigContext = Ft;
Nl.SizeContext = Kd;
Nl.config = $H;
Nl.useConfig = PB;
Object.defineProperty(Nl, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && Wd(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Kd)
});
process.env.NODE_ENV !== "production" && (Nl.displayName = "ConfigProvider");
const vb = Nl;
var _H = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const NH = _H;
function l5(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function PH(e) {
  return l5(e) instanceof ShadowRoot;
}
function _h(e) {
  return PH(e) ? l5(e) : null;
}
function IH(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function RH(e, t) {
  mt(e, "[@ant-design/icons] ".concat(t));
}
function X2(e) {
  return Vt(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Vt(e.icon) === "object" || typeof e.icon == "function");
}
function Z2() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[IH(n)] = r;
    }
    return t;
  }, {});
}
function C1(e, t, n) {
  return n ? /* @__PURE__ */ be.createElement(e.tag, J(J({
    key: t
  }, Z2(e.attrs)), n), (e.children || []).map(function(r, o) {
    return C1(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  })) : /* @__PURE__ */ be.createElement(e.tag, J({
    key: t
  }, Z2(e.attrs)), (e.children || []).map(function(r, o) {
    return C1(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  }));
}
function c5(e) {
  return hl(e)[0];
}
function u5(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var DH = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, TH = function(t) {
  var n = Cn(cb), r = n.csp, o = n.prefixCls, i = DH;
  o && (i = i.replace(/anticon/g, o)), kt(function() {
    var a = t.current, s = _h(a);
    Os(i, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
}, MH = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], od = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function LH(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  od.primaryColor = t, od.secondaryColor = n || c5(t), od.calculated = !!n;
}
function AH() {
  return J({}, od);
}
var xg = function(t) {
  var n = t.icon, r = t.className, o = t.onClick, i = t.style, a = t.primaryColor, s = t.secondaryColor, l = Yt(t, MH), u = c.useRef(), f = od;
  if (a && (f = {
    primaryColor: a,
    secondaryColor: s || c5(a)
  }), TH(u), RH(X2(n), "icon should be icon definiton, but got ".concat(n)), !X2(n))
    return null;
  var p = n;
  return p && typeof p.icon == "function" && (p = J(J({}, p), {}, {
    icon: p.icon(f.primaryColor, f.secondaryColor)
  })), C1(p.icon, "svg-".concat(p.name), J(J({
    className: r,
    onClick: o,
    style: i,
    "data-icon": p.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: u
  }));
};
xg.displayName = "IconReact";
xg.getTwoToneColors = AH;
xg.setTwoToneColors = LH;
const yb = xg;
function d5(e) {
  var t = u5(e), n = de(t, 2), r = n[0], o = n[1];
  return yb.setTwoToneColors({
    primaryColor: r,
    secondaryColor: o
  });
}
function jH() {
  var e = yb.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var kH = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
d5(fB.primary);
var Sg = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, o = e.spin, i = e.rotate, a = e.tabIndex, s = e.onClick, l = e.twoToneColor, u = Yt(e, kH), f = c.useContext(cb), p = f.prefixCls, h = p === void 0 ? "anticon" : p, y = f.rootClassName, b = se(y, h, K(K({}, "".concat(h, "-").concat(r.name), !!r.name), "".concat(h, "-spin"), !!o || r.name === "loading"), n), m = a;
  m === void 0 && s && (m = -1);
  var v = i ? {
    msTransform: "rotate(".concat(i, "deg)"),
    transform: "rotate(".concat(i, "deg)")
  } : void 0, C = u5(l), x = de(C, 2), S = x[0], E = x[1];
  return /* @__PURE__ */ c.createElement("span", Oe({
    role: "img",
    "aria-label": r.name
  }, u, {
    ref: t,
    tabIndex: m,
    onClick: s,
    className: b
  }), /* @__PURE__ */ c.createElement(yb, {
    icon: r,
    primaryColor: S,
    secondaryColor: E,
    style: v
  }));
});
Sg.displayName = "AntdIcon";
Sg.getTwoToneColor = jH;
Sg.setTwoToneColor = d5;
const Tn = Sg;
var f5 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: NH
  }));
};
process.env.NODE_ENV !== "production" && (f5.displayName = "CheckCircleFilled");
const bb = /* @__PURE__ */ c.forwardRef(f5);
var FH = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const BH = FH;
var p5 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: BH
  }));
};
process.env.NODE_ENV !== "production" && (p5.displayName = "CloseCircleFilled");
const Ds = /* @__PURE__ */ c.forwardRef(p5);
var HH = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const zH = HH;
var h5 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: zH
  }));
};
process.env.NODE_ENV !== "production" && (h5.displayName = "CloseOutlined");
const Gd = /* @__PURE__ */ c.forwardRef(h5);
var VH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const WH = VH;
var g5 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: WH
  }));
};
process.env.NODE_ENV !== "production" && (g5.displayName = "ExclamationCircleFilled");
const wg = /* @__PURE__ */ c.forwardRef(g5);
var KH = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const UH = KH;
var m5 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: UH
  }));
};
process.env.NODE_ENV !== "production" && (m5.displayName = "InfoCircleFilled");
const GH = /* @__PURE__ */ c.forwardRef(m5);
var qH = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, YH = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, XH = "".concat(qH, " ").concat(YH).split(/[\s\n]+/), ZH = "aria-", QH = "data-";
function Q2(e, t) {
  return e.indexOf(t) === 0;
}
function ei(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = J({}, t);
  var r = {};
  return Object.keys(e).forEach(function(o) {
    // Aria
    (n.aria && (o === "role" || Q2(o, ZH)) || // Data
    n.data && Q2(o, QH) || // Attr
    n.attr && XH.includes(o)) && (r[o] = e[o]);
  }), r;
}
const {
  isValidElement: ti
} = c;
function v5(e) {
  return e && ti(e) && e.type === c.Fragment;
}
function JH(e, t, n) {
  return ti(e) ? /* @__PURE__ */ c.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
}
function Yr(e, t) {
  return JH(e, e, t);
}
const J2 = (e) => typeof e == "object" && e != null && e.nodeType === 1, ew = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", Bv = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return ew(n.overflowY, t) || ew(n.overflowX, t) || ((r) => {
      const o = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch (a) {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, Cp = (e, t, n, r, o, i, a, s) => i < e && a > t || i > e && a < t ? 0 : i <= e && s <= n || a >= t && s >= n ? i - e - r : a > t && s < n || i < e && s > n ? a - t + o : 0, ez = (e) => {
  const t = e.parentElement;
  return t == null ? e.getRootNode().host || null : t;
}, tw = (e, t) => {
  var n, r, o, i;
  if (typeof document == "undefined")
    return [];
  const { scrollMode: a, block: s, inline: l, boundary: u, skipOverflowHiddenElements: f } = t, p = typeof u == "function" ? u : (D) => D !== u;
  if (!J2(e))
    throw new TypeError("Invalid target");
  const h = document.scrollingElement || document.documentElement, y = [];
  let b = e;
  for (; J2(b) && p(b); ) {
    if (b = ez(b), b === h) {
      y.push(b);
      break;
    }
    b != null && b === document.body && Bv(b) && !Bv(document.documentElement) || b != null && Bv(b, f) && y.push(b);
  }
  const m = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, v = (i = (o = window.visualViewport) == null ? void 0 : o.height) != null ? i : innerHeight, { scrollX: C, scrollY: x } = window, { height: S, width: E, top: O, right: $, bottom: _, left: R } = e.getBoundingClientRect(), { top: P, right: I, bottom: j, left: F } = ((D) => {
    const T = window.getComputedStyle(D);
    return { top: parseFloat(T.scrollMarginTop) || 0, right: parseFloat(T.scrollMarginRight) || 0, bottom: parseFloat(T.scrollMarginBottom) || 0, left: parseFloat(T.scrollMarginLeft) || 0 };
  })(e);
  let A = s === "start" || s === "nearest" ? O - P : s === "end" ? _ + j : O + S / 2 - P + j, M = l === "center" ? R + E / 2 - F + I : l === "end" ? $ + I : R - F;
  const N = [];
  for (let D = 0; D < y.length; D++) {
    const T = y[D], { height: L, width: z, top: H, right: V, bottom: Y, left: Z } = T.getBoundingClientRect();
    if (a === "if-needed" && O >= 0 && R >= 0 && _ <= v && $ <= m && O >= H && _ <= Y && R >= Z && $ <= V)
      return N;
    const oe = getComputedStyle(T), ee = parseInt(oe.borderLeftWidth, 10), ae = parseInt(oe.borderTopWidth, 10), le = parseInt(oe.borderRightWidth, 10), ue = parseInt(oe.borderBottomWidth, 10);
    let ie = 0, re = 0;
    const Q = "offsetWidth" in T ? T.offsetWidth - T.clientWidth - ee - le : 0, ce = "offsetHeight" in T ? T.offsetHeight - T.clientHeight - ae - ue : 0, ge = "offsetWidth" in T ? T.offsetWidth === 0 ? 0 : z / T.offsetWidth : 0, G = "offsetHeight" in T ? T.offsetHeight === 0 ? 0 : L / T.offsetHeight : 0;
    if (h === T)
      ie = s === "start" ? A : s === "end" ? A - v : s === "nearest" ? Cp(x, x + v, v, ae, ue, x + A, x + A + S, S) : A - v / 2, re = l === "start" ? M : l === "center" ? M - m / 2 : l === "end" ? M - m : Cp(C, C + m, m, ee, le, C + M, C + M + E, E), ie = Math.max(0, ie + x), re = Math.max(0, re + C);
    else {
      ie = s === "start" ? A - H - ae : s === "end" ? A - Y + ue + ce : s === "nearest" ? Cp(H, Y, L, ae, ue + ce, A, A + S, S) : A - (H + L / 2) + ce / 2, re = l === "start" ? M - Z - ee : l === "center" ? M - (Z + z / 2) + Q / 2 : l === "end" ? M - V + le + Q : Cp(Z, V, z, ee, le + Q, M, M + E, E);
      const { scrollLeft: ne, scrollTop: fe } = T;
      ie = G === 0 ? 0 : Math.max(0, Math.min(fe + ie / G, T.scrollHeight - L / G + ce)), re = ge === 0 ? 0 : Math.max(0, Math.min(ne + re / ge, T.scrollWidth - z / ge + Q)), A += fe - ie, M += ne - re;
    }
    N.push({ el: T, top: ie, left: re });
  }
  return N;
}, tz = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function nz(e, t) {
  if (!e.isConnected || !((o) => {
    let i = o;
    for (; i && i.parentNode; ) {
      if (i.parentNode === document)
        return !0;
      i = i.parentNode instanceof ShadowRoot ? i.parentNode.host : i.parentNode;
    }
    return !1;
  })(e))
    return;
  const n = ((o) => {
    const i = window.getComputedStyle(o);
    return { top: parseFloat(i.scrollMarginTop) || 0, right: parseFloat(i.scrollMarginRight) || 0, bottom: parseFloat(i.scrollMarginBottom) || 0, left: parseFloat(i.scrollMarginLeft) || 0 };
  })(e);
  if (((o) => typeof o == "object" && typeof o.behavior == "function")(t))
    return t.behavior(tw(e, t));
  const r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: o, top: i, left: a } of tw(e, tz(t))) {
    const s = i - n.top + n.bottom, l = a - n.left + n.right;
    o.scroll({ top: s, left: l, behavior: r });
  }
}
function x1(e) {
  return e != null && e === e.window;
}
function rz(e, t) {
  var n, r;
  if (typeof window == "undefined")
    return 0;
  const o = t ? "scrollTop" : "scrollLeft";
  let i = 0;
  return x1(e) ? i = e[t ? "pageYOffset" : "pageXOffset"] : e instanceof Document ? i = e.documentElement[o] : (e instanceof HTMLElement || e) && (i = e[o]), e && !x1(e) && typeof i != "number" && (i = (r = ((n = e.ownerDocument) !== null && n !== void 0 ? n : e).documentElement) === null || r === void 0 ? void 0 : r[o]), i;
}
function oz(e, t, n, r) {
  const o = n - t;
  return e /= r / 2, e < 1 ? o / 2 * e * e * e + t : o / 2 * ((e -= 2) * e * e + 2) + t;
}
function iz(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    getContainer: n = () => window,
    callback: r,
    duration: o = 450
  } = t, i = n(), a = rz(i, !0), s = Date.now(), l = () => {
    const f = Date.now() - s, p = oz(f > o ? o : f, a, e, o);
    x1(i) ? i.scrollTo(window.pageXOffset, p) : i instanceof Document || i.constructor.name === "HTMLDocument" ? i.documentElement.scrollTop = p : i.scrollTop = p, f < o ? Pn(l) : typeof r == "function" && r();
  };
  Pn(l);
}
const Ar = (e) => {
  const [, , , , t] = ro();
  return t ? `${e}-css-var` : "";
};
var Pe = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Pe.F1 && n <= Pe.F12)
      return !1;
    switch (n) {
      case Pe.ALT:
      case Pe.CAPS_LOCK:
      case Pe.CONTEXT_MENU:
      case Pe.CTRL:
      case Pe.DOWN:
      case Pe.END:
      case Pe.ESC:
      case Pe.HOME:
      case Pe.INSERT:
      case Pe.LEFT:
      case Pe.MAC_FF_META:
      case Pe.META:
      case Pe.NUMLOCK:
      case Pe.NUM_CENTER:
      case Pe.PAGE_DOWN:
      case Pe.PAGE_UP:
      case Pe.PAUSE:
      case Pe.PRINT_SCREEN:
      case Pe.RIGHT:
      case Pe.SHIFT:
      case Pe.UP:
      case Pe.WIN_KEY:
      case Pe.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Pe.ZERO && t <= Pe.NINE || t >= Pe.NUM_ZERO && t <= Pe.NUM_MULTIPLY || t >= Pe.A && t <= Pe.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Pe.SPACE:
      case Pe.QUESTION_MARK:
      case Pe.NUM_PLUS:
      case Pe.NUM_MINUS:
      case Pe.NUM_PERIOD:
      case Pe.NUM_DIVISION:
      case Pe.SEMICOLON:
      case Pe.DASH:
      case Pe.EQUALS:
      case Pe.COMMA:
      case Pe.PERIOD:
      case Pe.SLASH:
      case Pe.APOSTROPHE:
      case Pe.SINGLE_QUOTE:
      case Pe.OPEN_SQUARE_BRACKET:
      case Pe.BACKSLASH:
      case Pe.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, y5 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, o = e.className, i = e.duration, a = i === void 0 ? 4.5 : i, s = e.eventKey, l = e.content, u = e.closable, f = e.closeIcon, p = f === void 0 ? "x" : f, h = e.props, y = e.onClick, b = e.onNoticeClose, m = e.times, v = e.hovering, C = c.useState(!1), x = de(C, 2), S = x[0], E = x[1], O = v || S, $ = function() {
    b(s);
  }, _ = function(I) {
    (I.key === "Enter" || I.code === "Enter" || I.keyCode === Pe.ENTER) && $();
  };
  c.useEffect(function() {
    if (!O && a > 0) {
      var P = setTimeout(function() {
        $();
      }, a * 1e3);
      return function() {
        clearTimeout(P);
      };
    }
  }, [a, O, m]);
  var R = "".concat(n, "-notice");
  return /* @__PURE__ */ c.createElement("div", Oe({}, h, {
    ref: t,
    className: se(R, o, K({}, "".concat(R, "-closable"), u)),
    style: r,
    onMouseEnter: function(I) {
      var j;
      E(!0), h == null || (j = h.onMouseEnter) === null || j === void 0 || j.call(h, I);
    },
    onMouseLeave: function(I) {
      var j;
      E(!1), h == null || (j = h.onMouseLeave) === null || j === void 0 || j.call(h, I);
    },
    onClick: y
  }), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(R, "-content")
  }, l), u && /* @__PURE__ */ c.createElement("a", {
    tabIndex: 0,
    className: "".concat(R, "-close"),
    onKeyDown: _,
    onClick: function(I) {
      I.preventDefault(), I.stopPropagation(), $();
    }
  }, p));
}), b5 = /* @__PURE__ */ be.createContext({}), az = function(t) {
  var n = t.children, r = t.classNames;
  return /* @__PURE__ */ be.createElement(b5.Provider, {
    value: {
      classNames: r
    }
  }, n);
}, nw = 8, rw = 3, ow = 16, sz = function(t) {
  var n = {
    offset: nw,
    threshold: rw,
    gap: ow
  };
  if (t && Vt(t) === "object") {
    var r, o, i;
    n.offset = (r = t.offset) !== null && r !== void 0 ? r : nw, n.threshold = (o = t.threshold) !== null && o !== void 0 ? o : rw, n.gap = (i = t.gap) !== null && i !== void 0 ? i : ow;
  }
  return [!!t, n];
}, lz = ["className", "style", "classNames", "styles"], C5 = function(t) {
  var n, r = t.configList, o = t.placement, i = t.prefixCls, a = t.className, s = t.style, l = t.motion, u = t.onAllNoticeRemoved, f = t.onNoticeClose, p = t.stack, h = Cn(b5), y = h.classNames, b = _t({}), m = Ot(null), v = de(m, 2), C = v[0], x = v[1], S = Ot([]), E = de(S, 2), O = E[0], $ = E[1], _ = r.map(function(T) {
    return {
      config: T,
      key: String(T.key)
    };
  }), R = sz(p), P = de(R, 2), I = P[0], j = P[1], F = j.offset, A = j.threshold, M = j.gap, N = I && (O.length > 0 || _.length <= A), D = typeof l == "function" ? l(o) : l;
  return kt(function() {
    I && O.length > 1 && $(function(T) {
      return T.filter(function(L) {
        return _.some(function(z) {
          var H = z.key;
          return L === H;
        });
      });
    });
  }, [O, _, I]), kt(function() {
    var T;
    if (I && b.current[(T = _[_.length - 1]) === null || T === void 0 ? void 0 : T.key]) {
      var L;
      x(b.current[(L = _[_.length - 1]) === null || L === void 0 ? void 0 : L.key]);
    }
  }, [_, I]), /* @__PURE__ */ be.createElement(n5, Oe({
    key: o,
    className: se(i, "".concat(i, "-").concat(o), y == null ? void 0 : y.list, a, (n = {}, K(n, "".concat(i, "-stack"), !!I), K(n, "".concat(i, "-stack-expanded"), N), n)),
    style: s,
    keys: _,
    motionAppear: !0
  }, D, {
    onAllRemoved: function() {
      u(o);
    }
  }), function(T, L) {
    var z = T.config, H = T.className, V = T.style, Y = T.index, Z = z, oe = Z.key, ee = Z.times, ae = String(oe), le = z, ue = le.className, ie = le.style, re = le.classNames, Q = le.styles, ce = Yt(le, lz), ge = _.findIndex(function(ke) {
      return ke.key === ae;
    }), G = {};
    if (I) {
      var ne = _.length - 1 - (ge > -1 ? ge : Y - 1), fe = o === "top" || o === "bottom" ? "-50%" : "0";
      if (ne > 0) {
        var ye, we, he;
        G.height = N ? (ye = b.current[ae]) === null || ye === void 0 ? void 0 : ye.offsetHeight : C == null ? void 0 : C.offsetHeight;
        for (var me = 0, Ce = 0; Ce < ne; Ce++) {
          var Te;
          me += ((Te = b.current[_[_.length - 1 - Ce].key]) === null || Te === void 0 ? void 0 : Te.offsetHeight) + M;
        }
        var Ee = (N ? me : ne * F) * (o.startsWith("top") ? 1 : -1), Ge = !N && C !== null && C !== void 0 && C.offsetWidth && (we = b.current[ae]) !== null && we !== void 0 && we.offsetWidth ? ((C == null ? void 0 : C.offsetWidth) - F * 2 * (ne < 3 ? ne : 3)) / ((he = b.current[ae]) === null || he === void 0 ? void 0 : he.offsetWidth) : 1;
        G.transform = "translate3d(".concat(fe, ", ").concat(Ee, "px, 0) scaleX(").concat(Ge, ")");
      } else
        G.transform = "translate3d(".concat(fe, ", 0, 0)");
    }
    return /* @__PURE__ */ be.createElement("div", {
      ref: L,
      className: se("".concat(i, "-notice-wrapper"), H, re == null ? void 0 : re.wrapper),
      style: J(J(J({}, V), G), Q == null ? void 0 : Q.wrapper),
      onMouseEnter: function() {
        return $(function(qe) {
          return qe.includes(ae) ? qe : [].concat(We(qe), [ae]);
        });
      },
      onMouseLeave: function() {
        return $(function(qe) {
          return qe.filter(function(ze) {
            return ze !== ae;
          });
        });
      }
    }, /* @__PURE__ */ be.createElement(y5, Oe({}, ce, {
      ref: function(qe) {
        ge > -1 ? b.current[ae] = qe : delete b.current[ae];
      },
      prefixCls: i,
      classNames: re,
      styles: Q,
      className: se(ue, y == null ? void 0 : y.notice),
      style: ie,
      times: ee,
      key: oe,
      eventKey: oe,
      onNoticeClose: f,
      hovering: I && O.length > 0
    })));
  });
};
process.env.NODE_ENV !== "production" && (C5.displayName = "NoticeList");
var x5 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-notification" : n, o = e.container, i = e.motion, a = e.maxCount, s = e.className, l = e.style, u = e.onAllRemoved, f = e.stack, p = e.renderNotifications, h = c.useState([]), y = de(h, 2), b = y[0], m = y[1], v = function(P) {
    var I, j = b.find(function(F) {
      return F.key === P;
    });
    j == null || (I = j.onClose) === null || I === void 0 || I.call(j), m(function(F) {
      return F.filter(function(A) {
        return A.key !== P;
      });
    });
  };
  c.useImperativeHandle(t, function() {
    return {
      open: function(P) {
        m(function(I) {
          var j = We(I), F = j.findIndex(function(N) {
            return N.key === P.key;
          }), A = J({}, P);
          if (F >= 0) {
            var M;
            A.times = (((M = I[F]) === null || M === void 0 ? void 0 : M.times) || 0) + 1, j[F] = A;
          } else
            A.times = 0, j.push(A);
          return a > 0 && j.length > a && (j = j.slice(-a)), j;
        });
      },
      close: function(P) {
        v(P);
      },
      destroy: function() {
        m([]);
      }
    };
  });
  var C = c.useState({}), x = de(C, 2), S = x[0], E = x[1];
  c.useEffect(function() {
    var R = {};
    b.forEach(function(P) {
      var I = P.placement, j = I === void 0 ? "topRight" : I;
      j && (R[j] = R[j] || [], R[j].push(P));
    }), Object.keys(S).forEach(function(P) {
      R[P] = R[P] || [];
    }), E(R);
  }, [b]);
  var O = function(P) {
    E(function(I) {
      var j = J({}, I), F = j[P] || [];
      return F.length || delete j[P], j;
    });
  }, $ = c.useRef(!1);
  if (c.useEffect(function() {
    Object.keys(S).length > 0 ? $.current = !0 : $.current && (u == null || u(), $.current = !1);
  }, [S]), !o)
    return null;
  var _ = Object.keys(S);
  return /* @__PURE__ */ e4(/* @__PURE__ */ c.createElement(c.Fragment, null, _.map(function(R) {
    var P = S[R], I = /* @__PURE__ */ c.createElement(C5, {
      key: R,
      configList: P,
      placement: R,
      prefixCls: r,
      className: s == null ? void 0 : s(R),
      style: l == null ? void 0 : l(R),
      motion: i,
      onNoticeClose: v,
      onAllNoticeRemoved: O,
      stack: f
    });
    return p ? p(I, {
      prefixCls: r,
      key: R
    }) : I;
  })), o);
});
process.env.NODE_ENV !== "production" && (x5.displayName = "Notifications");
var cz = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], uz = function() {
  return document.body;
}, iw = 0;
function dz() {
  for (var e = {}, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach(function(o) {
    o && Object.keys(o).forEach(function(i) {
      var a = o[i];
      a !== void 0 && (e[i] = a);
    });
  }), e;
}
function fz() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.getContainer, n = t === void 0 ? uz : t, r = e.motion, o = e.prefixCls, i = e.maxCount, a = e.className, s = e.style, l = e.onAllRemoved, u = e.stack, f = e.renderNotifications, p = Yt(e, cz), h = c.useState(), y = de(h, 2), b = y[0], m = y[1], v = c.useRef(), C = /* @__PURE__ */ c.createElement(x5, {
    container: b,
    ref: v,
    prefixCls: o,
    motion: r,
    maxCount: i,
    className: a,
    style: s,
    onAllRemoved: l,
    stack: u,
    renderNotifications: f
  }), x = c.useState([]), S = de(x, 2), E = S[0], O = S[1], $ = c.useMemo(function() {
    return {
      open: function(R) {
        var P = dz(p, R);
        (P.key === null || P.key === void 0) && (P.key = "rc-notification-".concat(iw), iw += 1), O(function(I) {
          return [].concat(We(I), [{
            type: "open",
            config: P
          }]);
        });
      },
      close: function(R) {
        O(function(P) {
          return [].concat(We(P), [{
            type: "close",
            key: R
          }]);
        });
      },
      destroy: function() {
        O(function(R) {
          return [].concat(We(R), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return c.useEffect(function() {
    m(n());
  }), c.useEffect(function() {
    v.current && E.length && (E.forEach(function(_) {
      switch (_.type) {
        case "open":
          v.current.open(_.config);
          break;
        case "close":
          v.current.close(_.key);
          break;
        case "destroy":
          v.current.destroy();
          break;
      }
    }), O(function(_) {
      return _.filter(function(R) {
        return !E.includes(R);
      });
    }));
  }, [E]), [$, C];
}
var pz = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const hz = pz;
var S5 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: hz
  }));
};
process.env.NODE_ENV !== "production" && (S5.displayName = "LoadingOutlined");
const qd = /* @__PURE__ */ c.forwardRef(S5), w5 = /* @__PURE__ */ be.createContext(void 0);
process.env.NODE_ENV !== "production" && (w5.displayName = "zIndexContext");
const Eg = w5, Xs = 100, gz = 10, E5 = Xs * gz, $5 = {
  Modal: Xs,
  Drawer: Xs,
  Popover: Xs,
  Popconfirm: Xs,
  Tooltip: Xs,
  Tour: Xs
}, mz = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function vz(e) {
  return e in $5;
}
function Ts(e, t) {
  const [, n] = ro(), r = be.useContext(Eg), o = vz(e);
  if (t !== void 0)
    return [t, t];
  let i = r != null ? r : 0;
  return o ? (i += // Use preset token zIndex by default but not stack when has parent container
  (r ? 0 : n.zIndexPopupBase) + // Container offset
  $5[e], i = Math.min(i, n.zIndexPopupBase + E5)) : i += mz[e], [r === void 0 ? t : i, i];
}
const yz = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    boxShadow: r,
    colorText: o,
    colorSuccess: i,
    colorError: a,
    colorWarning: s,
    colorInfo: l,
    fontSizeLG: u,
    motionEaseInOutCirc: f,
    motionDurationSlow: p,
    marginXS: h,
    paddingXS: y,
    borderRadiusLG: b,
    zIndexPopup: m,
    // Custom token
    contentPadding: v,
    contentBg: C
  } = e, x = `${t}-notice`, S = new Bn("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: y,
      transform: "translateY(0)",
      opacity: 1
    }
  }), E = new Bn("MessageMoveOut", {
    "0%": {
      maxHeight: e.height,
      padding: y,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), O = {
    padding: y,
    textAlign: "center",
    [`${t}-custom-content > ${n}`]: {
      verticalAlign: "text-bottom",
      marginInlineEnd: h,
      // affected by ltr or rtl
      fontSize: u
    },
    [`${x}-content`]: {
      display: "inline-block",
      padding: v,
      background: C,
      borderRadius: b,
      boxShadow: r,
      pointerEvents: "all"
    },
    [`${t}-success > ${n}`]: {
      color: i
    },
    [`${t}-error > ${n}`]: {
      color: a
    },
    [`${t}-warning > ${n}`]: {
      color: s
    },
    [`${t}-info > ${n},
      ${t}-loading > ${n}`]: {
      color: l
    }
  };
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, Qn(e)), {
        color: o,
        position: "fixed",
        top: h,
        width: "100%",
        pointerEvents: "none",
        zIndex: m,
        [`${t}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${t}-move-up-appear,
        ${t}-move-up-enter
      `]: {
          animationName: S,
          animationDuration: p,
          animationPlayState: "paused",
          animationTimingFunction: f
        },
        [`
        ${t}-move-up-appear${t}-move-up-appear-active,
        ${t}-move-up-enter${t}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${t}-move-up-leave`]: {
          animationName: E,
          animationDuration: p,
          animationPlayState: "paused",
          animationTimingFunction: f
        },
        [`${t}-move-up-leave${t}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${x}-wrapper`]: Object.assign({}, O)
      }
    },
    // ============================= Pure =============================
    {
      [`${t}-notice-pure-panel`]: Object.assign(Object.assign({}, O), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, bz = (e) => ({
  zIndexPopup: e.zIndexPopupBase + E5 + 10,
  contentBg: e.colorBgElevated,
  contentPadding: `${(e.controlHeightLG - e.fontSize * e.lineHeight) / 2}px ${e.paddingSM}px`
}), O5 = Gn("Message", (e) => {
  const t = Sn(e, {
    height: 150
  });
  return [yz(t)];
}, bz);
var Cz = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const xz = {
  info: /* @__PURE__ */ c.createElement(GH, null),
  success: /* @__PURE__ */ c.createElement(bb, null),
  error: /* @__PURE__ */ c.createElement(Ds, null),
  warning: /* @__PURE__ */ c.createElement(wg, null),
  loading: /* @__PURE__ */ c.createElement(qd, null)
}, _5 = (e) => {
  let {
    prefixCls: t,
    type: n,
    icon: r,
    children: o
  } = e;
  return /* @__PURE__ */ c.createElement("div", {
    className: se(`${t}-custom-content`, `${t}-${n}`)
  }, r || xz[n], /* @__PURE__ */ c.createElement("span", null, o));
}, Sz = (e) => {
  const {
    prefixCls: t,
    className: n,
    type: r,
    icon: o,
    content: i
  } = e, a = Cz(e, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: s
  } = c.useContext(Ft), l = t || s("message"), u = Ar(l), [f, p, h] = O5(l, u);
  return f(/* @__PURE__ */ c.createElement(y5, Object.assign({}, a, {
    prefixCls: l,
    className: se(n, p, `${l}-notice-pure-panel`, h, u),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ c.createElement(_5, {
      prefixCls: l,
      type: r,
      icon: o
    }, i)
  })));
}, wz = Sz;
function Ez(e, t) {
  return {
    motionName: t != null ? t : `${e}-move-up`
  };
}
function Cb(e) {
  let t;
  const n = new Promise((o) => {
    t = e(() => {
      o(!0);
    });
  }), r = () => {
    t == null || t();
  };
  return r.then = (o, i) => n.then(o, i), r.promise = n, r;
}
var $z = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Oz = 8, _z = 3, Nz = (e) => {
  let {
    children: t,
    prefixCls: n
  } = e;
  const r = Ar(n), [o, i, a] = O5(n, r);
  return o(/* @__PURE__ */ c.createElement(az, {
    classNames: {
      list: se(i, a, r)
    }
  }, t));
}, Pz = (e, t) => {
  let {
    prefixCls: n,
    key: r
  } = t;
  return /* @__PURE__ */ c.createElement(Nz, {
    prefixCls: n,
    key: r
  }, e);
}, Iz = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    top: n,
    prefixCls: r,
    getContainer: o,
    maxCount: i,
    duration: a = _z,
    rtl: s,
    transitionName: l,
    onAllRemoved: u
  } = e, {
    getPrefixCls: f,
    getPopupContainer: p,
    message: h,
    direction: y
  } = c.useContext(Ft), b = r || f("message"), m = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: n != null ? n : Oz
  }), v = () => se({
    [`${b}-rtl`]: s != null ? s : y === "rtl"
  }), C = () => Ez(b, l), x = /* @__PURE__ */ c.createElement("span", {
    className: `${b}-close-x`
  }, /* @__PURE__ */ c.createElement(Gd, {
    className: `${b}-close-icon`
  })), [S, E] = fz({
    prefixCls: b,
    style: m,
    className: v,
    motion: C,
    closable: !1,
    closeIcon: x,
    duration: a,
    getContainer: () => (o == null ? void 0 : o()) || (p == null ? void 0 : p()) || document.body,
    maxCount: i,
    onAllRemoved: u,
    renderNotifications: Pz
  });
  return c.useImperativeHandle(t, () => Object.assign(Object.assign({}, S), {
    prefixCls: b,
    message: h
  })), E;
});
let aw = 0;
function N5(e) {
  const t = c.useRef(null), n = xn("Message");
  return [c.useMemo(() => {
    const o = (u) => {
      var f;
      (f = t.current) === null || f === void 0 || f.close(u);
    }, i = (u) => {
      if (!t.current) {
        process.env.NODE_ENV !== "production" && n(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        const _ = () => {
        };
        return _.then = () => {
        }, _;
      }
      const {
        open: f,
        prefixCls: p,
        message: h
      } = t.current, y = `${p}-notice`, {
        content: b,
        icon: m,
        type: v,
        key: C,
        className: x,
        style: S,
        onClose: E
      } = u, O = $z(u, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let $ = C;
      return $ == null && (aw += 1, $ = `antd-message-${aw}`), Cb((_) => (f(Object.assign(Object.assign({}, O), {
        key: $,
        content: /* @__PURE__ */ c.createElement(_5, {
          prefixCls: p,
          type: v,
          icon: m
        }, b),
        placement: "top",
        className: se(v && `${y}-${v}`, x, h == null ? void 0 : h.className),
        style: Object.assign(Object.assign({}, h == null ? void 0 : h.style), S),
        onClose: () => {
          E == null || E(), _();
        }
      })), () => {
        o($);
      }));
    }, s = {
      open: i,
      destroy: (u) => {
        var f;
        u !== void 0 ? o(u) : (f = t.current) === null || f === void 0 || f.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((u) => {
      const f = (p, h, y) => {
        let b;
        p && typeof p == "object" && "content" in p ? b = p : b = {
          content: p
        };
        let m, v;
        typeof h == "function" ? v = h : (m = h, v = y);
        const C = Object.assign(Object.assign({
          onClose: v,
          duration: m
        }, b), {
          type: u
        });
        return i(C);
      };
      s[u] = f;
    }), s;
  }, []), /* @__PURE__ */ c.createElement(Iz, Object.assign({
    key: "message-holder"
  }, e, {
    ref: t
  }))];
}
function Rz(e) {
  return N5(e);
}
function Po() {
  Po = function() {
    return t;
  };
  var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(D, T, L) {
    D[T] = L.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, a = i.iterator || "@@iterator", s = i.asyncIterator || "@@asyncIterator", l = i.toStringTag || "@@toStringTag";
  function u(D, T, L) {
    return Object.defineProperty(D, T, {
      value: L,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), D[T];
  }
  try {
    u({}, "");
  } catch (D) {
    u = function(L, z, H) {
      return L[z] = H;
    };
  }
  function f(D, T, L, z) {
    var H = T && T.prototype instanceof C ? T : C, V = Object.create(H.prototype), Y = new M(z || []);
    return o(V, "_invoke", {
      value: I(D, L, Y)
    }), V;
  }
  function p(D, T, L) {
    try {
      return {
        type: "normal",
        arg: D.call(T, L)
      };
    } catch (z) {
      return {
        type: "throw",
        arg: z
      };
    }
  }
  t.wrap = f;
  var h = "suspendedStart", y = "suspendedYield", b = "executing", m = "completed", v = {};
  function C() {
  }
  function x() {
  }
  function S() {
  }
  var E = {};
  u(E, a, function() {
    return this;
  });
  var O = Object.getPrototypeOf, $ = O && O(O(N([])));
  $ && $ !== n && r.call($, a) && (E = $);
  var _ = S.prototype = C.prototype = Object.create(E);
  function R(D) {
    ["next", "throw", "return"].forEach(function(T) {
      u(D, T, function(L) {
        return this._invoke(T, L);
      });
    });
  }
  function P(D, T) {
    function L(H, V, Y, Z) {
      var oe = p(D[H], D, V);
      if (oe.type !== "throw") {
        var ee = oe.arg, ae = ee.value;
        return ae && Vt(ae) == "object" && r.call(ae, "__await") ? T.resolve(ae.__await).then(function(le) {
          L("next", le, Y, Z);
        }, function(le) {
          L("throw", le, Y, Z);
        }) : T.resolve(ae).then(function(le) {
          ee.value = le, Y(ee);
        }, function(le) {
          return L("throw", le, Y, Z);
        });
      }
      Z(oe.arg);
    }
    var z;
    o(this, "_invoke", {
      value: function(V, Y) {
        function Z() {
          return new T(function(oe, ee) {
            L(V, Y, oe, ee);
          });
        }
        return z = z ? z.then(Z, Z) : Z();
      }
    });
  }
  function I(D, T, L) {
    var z = h;
    return function(H, V) {
      if (z === b)
        throw new Error("Generator is already running");
      if (z === m) {
        if (H === "throw")
          throw V;
        return {
          value: e,
          done: !0
        };
      }
      for (L.method = H, L.arg = V; ; ) {
        var Y = L.delegate;
        if (Y) {
          var Z = j(Y, L);
          if (Z) {
            if (Z === v)
              continue;
            return Z;
          }
        }
        if (L.method === "next")
          L.sent = L._sent = L.arg;
        else if (L.method === "throw") {
          if (z === h)
            throw z = m, L.arg;
          L.dispatchException(L.arg);
        } else
          L.method === "return" && L.abrupt("return", L.arg);
        z = b;
        var oe = p(D, T, L);
        if (oe.type === "normal") {
          if (z = L.done ? m : y, oe.arg === v)
            continue;
          return {
            value: oe.arg,
            done: L.done
          };
        }
        oe.type === "throw" && (z = m, L.method = "throw", L.arg = oe.arg);
      }
    };
  }
  function j(D, T) {
    var L = T.method, z = D.iterator[L];
    if (z === e)
      return T.delegate = null, L === "throw" && D.iterator.return && (T.method = "return", T.arg = e, j(D, T), T.method === "throw") || L !== "return" && (T.method = "throw", T.arg = new TypeError("The iterator does not provide a '" + L + "' method")), v;
    var H = p(z, D.iterator, T.arg);
    if (H.type === "throw")
      return T.method = "throw", T.arg = H.arg, T.delegate = null, v;
    var V = H.arg;
    return V ? V.done ? (T[D.resultName] = V.value, T.next = D.nextLoc, T.method !== "return" && (T.method = "next", T.arg = e), T.delegate = null, v) : V : (T.method = "throw", T.arg = new TypeError("iterator result is not an object"), T.delegate = null, v);
  }
  function F(D) {
    var T = {
      tryLoc: D[0]
    };
    1 in D && (T.catchLoc = D[1]), 2 in D && (T.finallyLoc = D[2], T.afterLoc = D[3]), this.tryEntries.push(T);
  }
  function A(D) {
    var T = D.completion || {};
    T.type = "normal", delete T.arg, D.completion = T;
  }
  function M(D) {
    this.tryEntries = [{
      tryLoc: "root"
    }], D.forEach(F, this), this.reset(!0);
  }
  function N(D) {
    if (D || D === "") {
      var T = D[a];
      if (T)
        return T.call(D);
      if (typeof D.next == "function")
        return D;
      if (!isNaN(D.length)) {
        var L = -1, z = function H() {
          for (; ++L < D.length; )
            if (r.call(D, L))
              return H.value = D[L], H.done = !1, H;
          return H.value = e, H.done = !0, H;
        };
        return z.next = z;
      }
    }
    throw new TypeError(Vt(D) + " is not iterable");
  }
  return x.prototype = S, o(_, "constructor", {
    value: S,
    configurable: !0
  }), o(S, "constructor", {
    value: x,
    configurable: !0
  }), x.displayName = u(S, l, "GeneratorFunction"), t.isGeneratorFunction = function(D) {
    var T = typeof D == "function" && D.constructor;
    return !!T && (T === x || (T.displayName || T.name) === "GeneratorFunction");
  }, t.mark = function(D) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(D, S) : (D.__proto__ = S, u(D, l, "GeneratorFunction")), D.prototype = Object.create(_), D;
  }, t.awrap = function(D) {
    return {
      __await: D
    };
  }, R(P.prototype), u(P.prototype, s, function() {
    return this;
  }), t.AsyncIterator = P, t.async = function(D, T, L, z, H) {
    H === void 0 && (H = Promise);
    var V = new P(f(D, T, L, z), H);
    return t.isGeneratorFunction(T) ? V : V.next().then(function(Y) {
      return Y.done ? Y.value : V.next();
    });
  }, R(_), u(_, l, "Generator"), u(_, a, function() {
    return this;
  }), u(_, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(D) {
    var T = Object(D), L = [];
    for (var z in T)
      L.push(z);
    return L.reverse(), function H() {
      for (; L.length; ) {
        var V = L.pop();
        if (V in T)
          return H.value = V, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, t.values = N, M.prototype = {
    constructor: M,
    reset: function(T) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(A), !T)
        for (var L in this)
          L.charAt(0) === "t" && r.call(this, L) && !isNaN(+L.slice(1)) && (this[L] = e);
    },
    stop: function() {
      this.done = !0;
      var T = this.tryEntries[0].completion;
      if (T.type === "throw")
        throw T.arg;
      return this.rval;
    },
    dispatchException: function(T) {
      if (this.done)
        throw T;
      var L = this;
      function z(ee, ae) {
        return Y.type = "throw", Y.arg = T, L.next = ee, ae && (L.method = "next", L.arg = e), !!ae;
      }
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var V = this.tryEntries[H], Y = V.completion;
        if (V.tryLoc === "root")
          return z("end");
        if (V.tryLoc <= this.prev) {
          var Z = r.call(V, "catchLoc"), oe = r.call(V, "finallyLoc");
          if (Z && oe) {
            if (this.prev < V.catchLoc)
              return z(V.catchLoc, !0);
            if (this.prev < V.finallyLoc)
              return z(V.finallyLoc);
          } else if (Z) {
            if (this.prev < V.catchLoc)
              return z(V.catchLoc, !0);
          } else {
            if (!oe)
              throw new Error("try statement without catch or finally");
            if (this.prev < V.finallyLoc)
              return z(V.finallyLoc);
          }
        }
      }
    },
    abrupt: function(T, L) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var H = this.tryEntries[z];
        if (H.tryLoc <= this.prev && r.call(H, "finallyLoc") && this.prev < H.finallyLoc) {
          var V = H;
          break;
        }
      }
      V && (T === "break" || T === "continue") && V.tryLoc <= L && L <= V.finallyLoc && (V = null);
      var Y = V ? V.completion : {};
      return Y.type = T, Y.arg = L, V ? (this.method = "next", this.next = V.finallyLoc, v) : this.complete(Y);
    },
    complete: function(T, L) {
      if (T.type === "throw")
        throw T.arg;
      return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && L && (this.next = L), v;
    },
    finish: function(T) {
      for (var L = this.tryEntries.length - 1; L >= 0; --L) {
        var z = this.tryEntries[L];
        if (z.finallyLoc === T)
          return this.complete(z.completion, z.afterLoc), A(z), v;
      }
    },
    catch: function(T) {
      for (var L = this.tryEntries.length - 1; L >= 0; --L) {
        var z = this.tryEntries[L];
        if (z.tryLoc === T) {
          var H = z.completion;
          if (H.type === "throw") {
            var V = H.arg;
            A(z);
          }
          return V;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(T, L, z) {
      return this.delegate = {
        iterator: N(T),
        resultName: L,
        nextLoc: z
      }, this.method === "next" && (this.arg = e), v;
    }
  }, t;
}
function sw(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a), l = s.value;
  } catch (u) {
    n(u);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(r, o);
}
function Pl(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, o) {
      var i = e.apply(t, n);
      function a(l) {
        sw(i, r, o, a, s, "next", l);
      }
      function s(l) {
        sw(i, r, o, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
var Yd = J({}, tA), Dz = Yd.version, Tz = Yd.render, Mz = Yd.unmountComponentAtNode, $g;
try {
  var Lz = Number((Dz || "").split(".")[0]);
  Lz >= 18 && ($g = Yd.createRoot);
} catch (e) {
}
function lw(e) {
  var t = Yd.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && Vt(t) === "object" && (t.usingClientEntryPoint = e);
}
var Nh = "__rc_react_root__";
function Az(e, t) {
  lw(!0);
  var n = t[Nh] || $g(t);
  lw(!1), n.render(e), t[Nh] = n;
}
function jz(e, t) {
  Tz(e, t);
}
function P5(e, t) {
  if ($g) {
    Az(e, t);
    return;
  }
  jz(e, t);
}
function kz(e) {
  return S1.apply(this, arguments);
}
function S1() {
  return S1 = Pl(/* @__PURE__ */ Po().mark(function e(t) {
    return Po().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var o;
              (o = t[Nh]) === null || o === void 0 || o.unmount(), delete t[Nh];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), S1.apply(this, arguments);
}
function Fz(e) {
  Mz(e);
}
function Bz(e) {
  return w1.apply(this, arguments);
}
function w1() {
  return w1 = Pl(/* @__PURE__ */ Po().mark(function e(t) {
    return Po().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if ($g === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", kz(t));
          case 2:
            Fz(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), w1.apply(this, arguments);
}
const Hv = () => ({
  height: 0,
  opacity: 0
}), cw = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, Hz = (e) => ({
  height: e ? e.offsetHeight : 0
}), zv = (e, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", xd = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: Hv,
    onEnterStart: Hv,
    onAppearActive: cw,
    onEnterActive: cw,
    onLeaveStart: Hz,
    onLeaveActive: Hv,
    onAppearEnd: zv,
    onEnterEnd: zv,
    onLeaveEnd: zv,
    motionDeadline: 500
  };
}, ml = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, Qc = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), i = o.width, a = o.height;
      if (i || a)
        return !0;
    }
  }
  return !1;
}, zz = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow 0.3s ${e.motionEaseInOut}`, `opacity 0.35s ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, Vz = hb("Wave", (e) => [zz(e)]);
function Wz(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function Vv(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && Wz(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function Kz(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return Vv(t) ? t : Vv(n) ? n : Vv(r) ? r : null;
}
const Og = "ant-wave-target";
function Wv(e) {
  return Number.isNaN(e) ? 0 : e;
}
const Uz = (e) => {
  const {
    className: t,
    target: n,
    component: r
  } = e, o = c.useRef(null), [i, a] = c.useState(null), [s, l] = c.useState([]), [u, f] = c.useState(0), [p, h] = c.useState(0), [y, b] = c.useState(0), [m, v] = c.useState(0), [C, x] = c.useState(!1), S = {
    left: u,
    top: p,
    width: y,
    height: m,
    borderRadius: s.map(($) => `${$}px`).join(" ")
  };
  i && (S["--wave-color"] = i);
  function E() {
    const $ = getComputedStyle(n);
    a(Kz(n));
    const _ = $.position === "static", {
      borderLeftWidth: R,
      borderTopWidth: P
    } = $;
    f(_ ? n.offsetLeft : Wv(-parseFloat(R))), h(_ ? n.offsetTop : Wv(-parseFloat(P))), b(n.offsetWidth), v(n.offsetHeight);
    const {
      borderTopLeftRadius: I,
      borderTopRightRadius: j,
      borderBottomLeftRadius: F,
      borderBottomRightRadius: A
    } = $;
    l([I, j, A, F].map((M) => Wv(parseFloat(M))));
  }
  if (c.useEffect(() => {
    if (n) {
      const $ = Pn(() => {
        E(), x(!0);
      });
      let _;
      return typeof ResizeObserver != "undefined" && (_ = new ResizeObserver(E), _.observe(n)), () => {
        Pn.cancel($), _ == null || _.disconnect();
      };
    }
  }, []), !C)
    return null;
  const O = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(Og));
  return /* @__PURE__ */ c.createElement(Bi, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: ($, _) => {
      var R;
      if (_.deadline || _.propertyName === "opacity") {
        const P = (R = o.current) === null || R === void 0 ? void 0 : R.parentElement;
        Bz(P).then(() => {
          P == null || P.remove();
        });
      }
      return !1;
    }
  }, ($) => {
    let {
      className: _
    } = $;
    return /* @__PURE__ */ c.createElement("div", {
      ref: o,
      className: se(t, {
        "wave-quick": O
      }, _),
      style: S
    });
  });
}, Gz = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", e == null || e.insertBefore(o, e == null ? void 0 : e.firstChild), P5(/* @__PURE__ */ c.createElement(Uz, Object.assign({}, t, {
    target: e
  })), o);
}, qz = Gz;
function Yz(e, t, n) {
  const {
    wave: r
  } = c.useContext(Ft), [, o, i] = ro(), a = Ir((u) => {
    const f = e.current;
    if (r != null && r.disabled || !f)
      return;
    const p = f.querySelector(`.${Og}`) || f, {
      showEffect: h
    } = r || {};
    (h || qz)(p, {
      className: t,
      token: o,
      component: n,
      event: u,
      hashId: i
    });
  }), s = c.useRef();
  return (u) => {
    Pn.cancel(s.current), s.current = Pn(() => {
      a(u);
    });
  };
}
const I5 = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: o
  } = Cn(Ft), i = _t(null), a = o("wave"), [, s] = Vz(a), l = Yz(i, se(a, s), r);
  if (be.useEffect(() => {
    const f = i.current;
    if (!f || f.nodeType !== 1 || n)
      return;
    const p = (h) => {
      !Qc(h.target) || // No need wave
      !f.getAttribute || f.getAttribute("disabled") || f.disabled || f.className.includes("disabled") || f.className.includes("-leave") || l(h);
    };
    return f.addEventListener("click", p, !0), () => {
      f.removeEventListener("click", p, !0);
    };
  }, [n]), !/* @__PURE__ */ be.isValidElement(t))
    return t != null ? t : null;
  const u = ki(t) ? Do(t.ref, i) : i;
  return Yr(t, {
    ref: u
  });
};
process.env.NODE_ENV !== "production" && (I5.displayName = "Wave");
const xb = I5, Co = (e) => {
  const t = be.useContext(Kd);
  return be.useMemo(() => e ? typeof e == "string" ? e != null ? e : t : e instanceof Function ? e(t) : t : t, [e, t]);
}, Xz = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, Zz = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      }
    }
  };
}, Qz = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, R5 = Gn("Space", (e) => {
  const t = Sn(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [Zz(t), Qz(t), Xz(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var D5 = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const _g = /* @__PURE__ */ c.createContext(null), Ms = (e, t) => {
  const n = c.useContext(_g), r = c.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: o,
      isFirstItem: i,
      isLastItem: a
    } = n, s = o === "vertical" ? "-vertical-" : "-";
    return se(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: i,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, vl = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ c.createElement(_g.Provider, {
    value: null
  }, t);
}, Jz = (e) => {
  var {
    children: t
  } = e, n = D5(e, ["children"]);
  return /* @__PURE__ */ c.createElement(_g.Provider, {
    value: n
  }, t);
}, eV = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = c.useContext(Ft), {
    size: r,
    direction: o,
    block: i,
    prefixCls: a,
    className: s,
    rootClassName: l,
    children: u
  } = e, f = D5(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), p = Co((S) => r != null ? r : S), h = t("space-compact", a), [y, b] = R5(h), m = se(h, b, {
    [`${h}-rtl`]: n === "rtl",
    [`${h}-block`]: i,
    [`${h}-vertical`]: o === "vertical"
  }, s, l), v = c.useContext(_g), C = Rr(u), x = c.useMemo(() => C.map((S, E) => {
    const O = S && S.key || `${h}-item-${E}`;
    return /* @__PURE__ */ c.createElement(Jz, {
      key: O,
      compactSize: p,
      compactDirection: o,
      isFirstItem: E === 0 && (!v || (v == null ? void 0 : v.isFirstItem)),
      isLastItem: E === C.length - 1 && (!v || (v == null ? void 0 : v.isLastItem))
    }, S);
  }), [r, C, v]);
  return C.length === 0 ? null : y(/* @__PURE__ */ c.createElement("div", Object.assign({
    className: m
  }, f), x));
};
var tV = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const T5 = /* @__PURE__ */ c.createContext(void 0), nV = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = c.useContext(Ft), {
    prefixCls: r,
    size: o,
    className: i
  } = e, a = tV(e, ["prefixCls", "size", "className"]), s = t("btn-group", r), [, , l] = ro();
  let u = "";
  switch (o) {
    case "large":
      u = "lg";
      break;
    case "small":
      u = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const p = xn("Button.Group");
    process.env.NODE_ENV !== "production" && p(!o || ["large", "small", "middle"].includes(o), "usage", "Invalid prop `size`.");
  }
  const f = se(s, {
    [`${s}-${u}`]: u,
    [`${s}-rtl`]: n === "rtl"
  }, i, l);
  return /* @__PURE__ */ c.createElement(T5.Provider, {
    value: o
  }, /* @__PURE__ */ c.createElement("div", Object.assign({}, a, {
    className: f
  })));
}, rV = nV, uw = /^[\u4e00-\u9fa5]{2}$/, E1 = uw.test.bind(uw);
function M5(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function dw(e) {
  return typeof e == "string";
}
function xp(e) {
  return e === "text" || e === "link";
}
function oV(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && dw(e.type) && E1(e.props.children) ? Yr(e, {
    children: e.props.children.split("").join(n)
  }) : dw(e) ? E1(e) ? /* @__PURE__ */ be.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ be.createElement("span", null, e) : v5(e) ? /* @__PURE__ */ be.createElement("span", null, e) : e;
}
function iV(e, t) {
  let n = !1;
  const r = [];
  return be.Children.forEach(e, (o) => {
    const i = typeof o, a = i === "string" || i === "number";
    if (n && a) {
      const s = r.length - 1, l = r[s];
      r[s] = `${l}${o}`;
    } else
      r.push(o);
    n = a;
  }), be.Children.map(r, (o) => oV(o, t));
}
const aV = /* @__PURE__ */ ni((e, t) => {
  const {
    className: n,
    style: r,
    children: o,
    prefixCls: i
  } = e, a = se(`${i}-icon`, n);
  return /* @__PURE__ */ be.createElement("span", {
    ref: t,
    className: a,
    style: r
  }, o);
}), L5 = aV, fw = /* @__PURE__ */ ni((e, t) => {
  let {
    prefixCls: n,
    className: r,
    style: o,
    iconClassName: i
  } = e;
  const a = se(`${n}-loading-icon`, r);
  return /* @__PURE__ */ be.createElement(L5, {
    prefixCls: n,
    className: a,
    style: o,
    ref: t
  }, /* @__PURE__ */ be.createElement(qd, {
    className: i
  }));
}), Kv = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), Uv = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), sV = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: o,
    style: i
  } = e, a = !!n;
  return r ? /* @__PURE__ */ be.createElement(fw, {
    prefixCls: t,
    className: o,
    style: i
  }) : /* @__PURE__ */ be.createElement(Bi, {
    visible: a,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: a,
    removeOnLeave: !0,
    onAppearStart: Kv,
    onAppearActive: Uv,
    onEnterStart: Kv,
    onEnterActive: Uv,
    onLeaveStart: Uv,
    onLeaveActive: Kv
  }, (s, l) => {
    let {
      className: u,
      style: f
    } = s;
    return /* @__PURE__ */ be.createElement(fw, {
      prefixCls: t,
      className: o,
      style: Object.assign(Object.assign({}, i), f),
      ref: l,
      iconClassName: u
    });
  });
}, lV = sV, pw = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), cV = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: o,
    colorErrorHover: i
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      pw(`${t}-primary`, o),
      pw(`${t}-danger`, i)
    ]
  };
}, uV = cV, A5 = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n,
    paddingBlock: r
  } = e;
  return Sn(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: r,
    buttonIconOnlyFontSize: n
  });
}, j5 = (e) => {
  var t, n, r, o, i, a;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, l = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, u = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, f = (o = e.contentLineHeight) !== null && o !== void 0 ? o : Zp(s), p = (i = e.contentLineHeightSM) !== null && i !== void 0 ? i : Zp(l), h = (a = e.contentLineHeightLG) !== null && a !== void 0 ? a : Zp(u);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: e.colorBgTextHover,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    contentFontSize: s,
    contentFontSizeSM: l,
    contentFontSizeLG: u,
    contentLineHeight: f,
    contentLineHeightSM: p,
    contentLineHeightLG: h,
    paddingBlock: Math.max((e.controlHeight - s * f) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - l * p) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - u * h) / 2 - e.lineWidth, 0)
  };
}, dV = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${te(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 0
      },
      // Leave a space between icon and text.
      [`> ${n} + span, > span + ${n}`]: {
        marginInlineStart: e.marginXS
      },
      [`&:not(${t}-icon-only) > ${t}-icon`]: {
        [`&${t}-loading-icon, &:not(:last-child)`]: {
          marginInlineEnd: e.marginXS
        }
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, $h(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // make `btn-icon-only` not too narrow
      [`&-icon-only${t}-compact-item`]: {
        flex: "none"
      }
    }
  };
}, Wa = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), fV = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), pV = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), hV = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), Sd = (e, t, n, r, o, i, a, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, Wa(e, Object.assign({
    background: t
  }, a), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: o || void 0,
      borderColor: i || void 0
    }
  })
}), Sb = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, hV(e))
}), k5 = (e) => Object.assign({}, Sb(e)), Ph = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), F5 = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, k5(e)), {
  background: e.defaultBg,
  borderColor: e.defaultBorderColor,
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}), Wa(e.componentCls, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), Sd(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: e.colorError,
    borderColor: e.colorError
  }, Wa(e.componentCls, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), Sd(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), Sb(e))
}), gV = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, k5(e)), {
  color: e.primaryColor,
  background: e.colorPrimary,
  boxShadow: e.primaryShadow
}), Wa(e.componentCls, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryActive
})), Sd(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: e.colorError,
    boxShadow: e.dangerShadow,
    color: e.dangerColor
  }, Wa(e.componentCls, {
    background: e.colorErrorHover
  }, {
    background: e.colorErrorActive
  })), Sd(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), Sb(e))
}), mV = (e) => Object.assign(Object.assign({}, F5(e)), {
  borderStyle: "dashed"
}), vV = (e) => Object.assign(Object.assign(Object.assign({
  color: e.colorLink
}, Wa(e.componentCls, {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), Ph(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, Wa(e.componentCls, {
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), Ph(e))
}), yV = (e) => Object.assign(Object.assign(Object.assign({}, Wa(e.componentCls, {
  color: e.colorText,
  background: e.textHoverBg
}, {
  color: e.colorText,
  background: e.colorBgTextActive
})), Ph(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, Ph(e)), Wa(e.componentCls, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }))
}), bV = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: F5(e),
    [`${t}-primary`]: gV(e),
    [`${t}-dashed`]: mV(e),
    [`${t}-link`]: vV(e),
    [`${t}-text`]: yV(e),
    [`${t}-ghost`]: Sd(e.componentCls, e.ghostBg, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)
  };
}, wb = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: o,
    lineHeight: i,
    borderRadius: a,
    buttonPaddingHorizontal: s,
    iconCls: l,
    buttonPaddingVertical: u
  } = e, f = `${n}-icon-only`;
  return [
    {
      [`${t}`]: {
        fontSize: o,
        lineHeight: i,
        height: r,
        padding: `${te(u)} ${te(s)}`,
        borderRadius: a,
        [`&${f}`]: {
          width: r,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${n}-round`]: {
            width: "auto"
          },
          [l]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${n}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${n}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: fV(e)
    },
    {
      [`${n}${n}-round${t}`]: pV(e)
    }
  ];
}, CV = (e) => {
  const t = Sn(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return wb(t, e.componentCls);
}, xV = (e) => {
  const t = Sn(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return wb(t, `${e.componentCls}-sm`);
}, SV = (e) => {
  const t = Sn(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return wb(t, `${e.componentCls}-lg`);
}, wV = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, EV = Gn("Button", (e) => {
  const t = A5(e);
  return [
    // Shared
    dV(t),
    // Size
    CV(t),
    xV(t),
    SV(t),
    // Block
    wV(t),
    // Group (type, ghost, danger, loading)
    bV(t),
    // Button Group
    uV(t)
  ];
}, j5, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function $V(e, t, n) {
  const {
    focusElCls: r,
    focus: o,
    borderElCls: i
  } = n, a = i ? "> *" : "", s = ["hover", o ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function OV(e, t, n) {
  const {
    borderElCls: r
  } = n, o = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${o}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function Ng(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, $V(e, r, t)), OV(n, r, t))
  };
}
function _V(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function NV(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function PV(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, _V(e, t)), NV(e.componentCls, t))
  };
}
const IV = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: n(e.lineWidth).mul(-1).equal(),
            insetInlineStart: n(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${te(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: n(e.lineWidth).mul(-1).equal(),
              insetInlineStart: n(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${te(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, RV = gb(["Button", "compact"], (e) => {
  const t = A5(e);
  return [
    // Space Compact
    Ng(t),
    PV(t),
    IV(t)
  ];
}, j5);
var DV = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function TV(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const MV = (e, t) => {
  var n, r;
  const {
    loading: o = !1,
    prefixCls: i,
    type: a = "default",
    danger: s,
    shape: l = "default",
    size: u,
    styles: f,
    disabled: p,
    className: h,
    rootClassName: y,
    children: b,
    icon: m,
    ghost: v = !1,
    block: C = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: x = "button",
    classNames: S,
    style: E = {}
  } = e, O = DV(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "ghost", "block", "htmlType", "classNames", "style"]), {
    getPrefixCls: $,
    autoInsertSpaceInButton: _,
    direction: R,
    button: P
  } = Cn(Ft), I = $("btn", i), [j, F, A] = EV(I), M = Cn(Ki), N = p != null ? p : M, D = Cn(T5), T = mr(() => TV(o), [o]), [L, z] = Ot(T.loading), [H, V] = Ot(!1), Z = Do(t, /* @__PURE__ */ QL()), oe = ZL.count(b) === 1 && !m && !xp(a);
  kt(() => {
    let Ce = null;
    T.delay > 0 ? Ce = setTimeout(() => {
      Ce = null, z(!0);
    }, T.delay) : z(T.loading);
    function Te() {
      Ce && (clearTimeout(Ce), Ce = null);
    }
    return Te;
  }, [T]), kt(() => {
    if (!Z || !Z.current || _ === !1)
      return;
    const Ce = Z.current.textContent;
    oe && E1(Ce) ? H || V(!0) : H && V(!1);
  }, [Z]);
  const ee = (Ce) => {
    const {
      onClick: Te
    } = e;
    if (L || N) {
      Ce.preventDefault();
      return;
    }
    Te == null || Te(Ce);
  };
  if (process.env.NODE_ENV !== "production") {
    const Ce = xn("Button");
    process.env.NODE_ENV !== "production" && Ce(!(typeof m == "string" && m.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${m}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && Ce(!(v && xp(a)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const ae = _ !== !1, {
    compactSize: le,
    compactItemClassnames: ue
  } = Ms(I, R), ie = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, re = Co((Ce) => {
    var Te, Ee;
    return (Ee = (Te = u != null ? u : le) !== null && Te !== void 0 ? Te : D) !== null && Ee !== void 0 ? Ee : Ce;
  }), Q = re && ie[re] || "", ce = L ? "loading" : m, ge = dr(O, ["navigate"]), G = se(I, F, A, {
    [`${I}-${l}`]: l !== "default" && l,
    [`${I}-${a}`]: a,
    [`${I}-${Q}`]: Q,
    [`${I}-icon-only`]: !b && b !== 0 && !!ce,
    [`${I}-background-ghost`]: v && !xp(a),
    [`${I}-loading`]: L,
    [`${I}-two-chinese-chars`]: H && ae && !L,
    [`${I}-block`]: C,
    [`${I}-dangerous`]: !!s,
    [`${I}-rtl`]: R === "rtl"
  }, ue, h, y, P == null ? void 0 : P.className), ne = Object.assign(Object.assign({}, P == null ? void 0 : P.style), E), fe = se(S == null ? void 0 : S.icon, (n = P == null ? void 0 : P.classNames) === null || n === void 0 ? void 0 : n.icon), ye = Object.assign(Object.assign({}, (f == null ? void 0 : f.icon) || {}), ((r = P == null ? void 0 : P.styles) === null || r === void 0 ? void 0 : r.icon) || {}), we = m && !L ? /* @__PURE__ */ be.createElement(L5, {
    prefixCls: I,
    className: fe,
    style: ye
  }, m) : /* @__PURE__ */ be.createElement(lV, {
    existIcon: !!m,
    prefixCls: I,
    loading: !!L
  }), he = b || b === 0 ? iV(b, oe && ae) : null;
  if (ge.href !== void 0)
    return j(/* @__PURE__ */ be.createElement("a", Object.assign({}, ge, {
      className: se(G, {
        [`${I}-disabled`]: N
      }),
      href: N ? void 0 : ge.href,
      style: ne,
      onClick: ee,
      ref: Z,
      tabIndex: N ? -1 : 0
    }), we, he));
  let me = /* @__PURE__ */ be.createElement("button", Object.assign({}, O, {
    type: x,
    className: G,
    style: ne,
    onClick: ee,
    disabled: N,
    ref: Z
  }), we, he, !!ue && /* @__PURE__ */ be.createElement(RV, {
    key: "compact",
    prefixCls: I
  }));
  return xp(a) || (me = /* @__PURE__ */ be.createElement(xb, {
    component: "Button",
    disabled: !!L
  }, me)), j(me);
}, Pg = /* @__PURE__ */ ni(MV);
process.env.NODE_ENV !== "production" && (Pg.displayName = "Button");
Pg.Group = rV;
Pg.__ANT_BUTTON = !0;
const Io = Pg;
function hw(e) {
  return !!(e && e.then);
}
const LV = (e) => {
  const {
    type: t,
    children: n,
    prefixCls: r,
    buttonProps: o,
    close: i,
    autoFocus: a,
    emitEvent: s,
    isSilent: l,
    quitOnNullishReturnValue: u,
    actionFn: f
  } = e, p = c.useRef(!1), h = c.useRef(null), [y, b] = xs(!1), m = function() {
    i == null || i.apply(void 0, arguments);
  };
  c.useEffect(() => {
    let x = null;
    return a && (x = setTimeout(() => {
      var S;
      (S = h.current) === null || S === void 0 || S.focus();
    })), () => {
      x && clearTimeout(x);
    };
  }, []);
  const v = (x) => {
    hw(x) && (b(!0), x.then(function() {
      b(!1, !0), m.apply(void 0, arguments), p.current = !1;
    }, (S) => {
      if (b(!1, !0), p.current = !1, !(l != null && l()))
        return Promise.reject(S);
    }));
  }, C = (x) => {
    if (p.current)
      return;
    if (p.current = !0, !f) {
      m();
      return;
    }
    let S;
    if (s) {
      if (S = f(x), u && !hw(S)) {
        p.current = !1, m(x);
        return;
      }
    } else if (f.length)
      S = f(i), p.current = !1;
    else if (S = f(), !S) {
      m();
      return;
    }
    v(S);
  };
  return /* @__PURE__ */ c.createElement(Io, Object.assign({}, M5(t), {
    onClick: C,
    loading: y,
    prefixCls: r
  }, o, {
    ref: h
  }), n);
}, AV = LV;
var B5 = /* @__PURE__ */ c.createContext(null), gw = [];
function jV(e, t) {
  var n = c.useState(function() {
    if (!Hr())
      return null;
    var b = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && b.setAttribute("data-debug", t), b;
  }), r = de(n, 1), o = r[0], i = c.useRef(!1), a = c.useContext(B5), s = c.useState(gw), l = de(s, 2), u = l[0], f = l[1], p = a || (i.current ? void 0 : function(b) {
    f(function(m) {
      var v = [b].concat(We(m));
      return v;
    });
  });
  function h() {
    o.parentElement || document.body.appendChild(o), i.current = !0;
  }
  function y() {
    var b;
    (b = o.parentElement) === null || b === void 0 || b.removeChild(o), i.current = !1;
  }
  return Nn(function() {
    return e ? a ? a(h) : h() : y(), y;
  }, [e]), Nn(function() {
    u.length && (u.forEach(function(b) {
      return b();
    }), f(gw));
  }, [u]), [o, p];
}
var Gv;
function $1(e) {
  if (typeof document == "undefined")
    return 0;
  if (e || Gv === void 0) {
    var t = document.createElement("div");
    t.style.width = "100%", t.style.height = "200px";
    var n = document.createElement("div"), r = n.style;
    r.position = "absolute", r.top = "0", r.left = "0", r.pointerEvents = "none", r.visibility = "hidden", r.width = "200px", r.height = "150px", r.overflow = "hidden", n.appendChild(t), document.body.appendChild(n);
    var o = t.offsetWidth;
    n.style.overflow = "scroll";
    var i = t.offsetWidth;
    o === i && (i = n.clientWidth), document.body.removeChild(n), Gv = o - i;
  }
  return Gv;
}
function mw(e) {
  var t = e.match(/^(.*)px$/), n = Number(t == null ? void 0 : t[1]);
  return Number.isNaN(n) ? $1() : n;
}
function O1(e) {
  if (typeof document == "undefined" || !e || !(e instanceof Element))
    return {
      width: 0,
      height: 0
    };
  var t = getComputedStyle(e, "::-webkit-scrollbar"), n = t.width, r = t.height;
  return {
    width: mw(n),
    height: mw(r)
  };
}
function kV() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var FV = "rc-util-locker-".concat(Date.now()), vw = 0;
function BV(e) {
  var t = !!e, n = c.useState(function() {
    return vw += 1, "".concat(FV, "_").concat(vw);
  }), r = de(n, 1), o = r[0];
  Nn(function() {
    if (t) {
      var i = O1(document.body).width, a = kV();
      Os(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), o);
    } else
      vd(o);
    return function() {
      vd(o);
    };
  }, [t, o]);
}
var yw = !1;
function HV(e) {
  return typeof e == "boolean" && (yw = e), yw;
}
var bw = function(t) {
  return t === !1 ? !1 : !Hr() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, Ig = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, o = e.getContainer, i = e.debug, a = e.autoDestroy, s = a === void 0 ? !0 : a, l = e.children, u = c.useState(n), f = de(u, 2), p = f[0], h = f[1], y = p || n;
  process.env.NODE_ENV !== "production" && mt(Hr() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), c.useEffect(function() {
    (s || n) && h(n);
  }, [n, s]);
  var b = c.useState(function() {
    return bw(o);
  }), m = de(b, 2), v = m[0], C = m[1];
  c.useEffect(function() {
    var F = bw(o);
    C(F != null ? F : null);
  });
  var x = jV(y && !v, i), S = de(x, 2), E = S[0], O = S[1], $ = v != null ? v : E;
  BV(r && n && Hr() && ($ === E || $ === document.body));
  var _ = null;
  if (l && ki(l) && t) {
    var R = l;
    _ = R.ref;
  }
  var P = Ol(_, t);
  if (!y || !Hr() || v === void 0)
    return null;
  var I = $ === !1 || HV(), j = l;
  return t && (j = /* @__PURE__ */ c.cloneElement(l, {
    ref: P
  })), /* @__PURE__ */ c.createElement(B5.Provider, {
    value: O
  }, I ? j : /* @__PURE__ */ e4(j, $));
});
process.env.NODE_ENV !== "production" && (Ig.displayName = "Portal");
function zV() {
  var e = J({}, c);
  return e.useId;
}
var Cw = 0, xw = zV();
const VV = xw ? (
  // Use React `useId`
  function(t) {
    var n = xw();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = c.useState("ssr-id"), r = de(n, 2), o = r[0], i = r[1];
    return c.useEffect(function() {
      var a = Cw;
      Cw += 1, i("rc_unique_".concat(a));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : o);
  }
);
function WV(e, t, n) {
  return typeof e == "boolean" ? e : t === void 0 ? !!n : t !== !1 && t !== null;
}
function KV(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : /* @__PURE__ */ be.createElement(Gd, null), o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (!WV(e, t, o))
    return [!1, null];
  const a = typeof t == "boolean" || t === void 0 || t === null ? r : t;
  return [!0, n ? n(a) : a];
}
var H5 = function(t) {
  if (Hr() && window.document.documentElement) {
    var n = Array.isArray(t) ? t : [t], r = window.document.documentElement;
    return n.some(function(o) {
      return o in r.style;
    });
  }
  return !1;
}, UV = function(t, n) {
  if (!H5(t))
    return !1;
  var r = document.createElement("div"), o = r.style[t];
  return r.style[t] = n, r.style[t] !== o;
};
function _1(e, t) {
  return !Array.isArray(e) && t !== void 0 ? UV(e, t) : H5(e);
}
var nl = "RC_FORM_INTERNAL_HOOKS", ir = function() {
  mt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, yl = /* @__PURE__ */ c.createContext({
  getFieldValue: ir,
  getFieldsValue: ir,
  getFieldError: ir,
  getFieldWarning: ir,
  getFieldsError: ir,
  isFieldsTouched: ir,
  isFieldTouched: ir,
  isFieldValidating: ir,
  isFieldsValidating: ir,
  resetFields: ir,
  setFields: ir,
  setFieldValue: ir,
  setFieldsValue: ir,
  validateFields: ir,
  submit: ir,
  getInternalHooks: function() {
    return ir(), {
      dispatch: ir,
      initEntityValue: ir,
      registerField: ir,
      useSubscribe: ir,
      setInitialValues: ir,
      destroyForm: ir,
      setCallbacks: ir,
      registerWatch: ir,
      getFields: ir,
      setValidateMessages: ir,
      setPreserve: ir,
      getInitialValue: ir
    };
  }
}), wd = /* @__PURE__ */ c.createContext(null);
function N1(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function GV(e) {
  return e && !!e._init;
}
function rl() {
  return rl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rl.apply(this, arguments);
}
function qV(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Ed(e, t);
}
function P1(e) {
  return P1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, P1(e);
}
function Ed(e, t) {
  return Ed = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ed(e, t);
}
function YV() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function Jp(e, t, n) {
  return YV() ? Jp = Reflect.construct.bind() : Jp = function(o, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var l = Function.bind.apply(o, s), u = new l();
    return a && Ed(u, a.prototype), u;
  }, Jp.apply(null, arguments);
}
function XV(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function I1(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return I1 = function(r) {
    if (r === null || !XV(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t != "undefined") {
      if (t.has(r))
        return t.get(r);
      t.set(r, o);
    }
    function o() {
      return Jp(r, arguments, P1(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Ed(o, r);
  }, I1(e);
}
var ZV = /%[sdj%]/g, z5 = function() {
};
typeof process != "undefined" && process.env && process.env.NODE_ENV !== "production" && typeof window != "undefined" && typeof document != "undefined" && (z5 = function(t, n) {
  typeof console != "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING == "undefined" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function R1(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function Jo(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = 0, i = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var a = e.replace(ZV, function(s) {
      if (s === "%%")
        return "%";
      if (o >= i)
        return s;
      switch (s) {
        case "%s":
          return String(n[o++]);
        case "%d":
          return Number(n[o++]);
        case "%j":
          try {
            return JSON.stringify(n[o++]);
          } catch (l) {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function QV(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Xr(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || QV(t) && typeof e == "string" && !e);
}
function JV(e, t, n) {
  var r = [], o = 0, i = e.length;
  function a(s) {
    r.push.apply(r, s || []), o++, o === i && n(r);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function Sw(e, t, n) {
  var r = 0, o = e.length;
  function i(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < o ? t(e[s], i) : n([]);
  }
  i([]);
}
function eW(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, e[n] || []);
  }), t;
}
var ww = /* @__PURE__ */ function(e) {
  qV(t, e);
  function t(n, r) {
    var o;
    return o = e.call(this, "Async Validation Error") || this, o.errors = n, o.fields = r, o;
  }
  return t;
}(/* @__PURE__ */ I1(Error));
function tW(e, t, n, r, o) {
  if (t.first) {
    var i = new Promise(function(h, y) {
      var b = function(C) {
        return r(C), C.length ? y(new ww(C, R1(C))) : h(o);
      }, m = eW(e);
      Sw(m, n, b);
    });
    return i.catch(function(h) {
      return h;
    }), i;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, u = 0, f = [], p = new Promise(function(h, y) {
    var b = function(v) {
      if (f.push.apply(f, v), u++, u === l)
        return r(f), f.length ? y(new ww(f, R1(f))) : h(o);
    };
    s.length || (r(f), h(o)), s.forEach(function(m) {
      var v = e[m];
      a.indexOf(m) !== -1 ? Sw(v, n, b) : JV(v, n, b);
    });
  });
  return p.catch(function(h) {
    return h;
  }), p;
}
function nW(e) {
  return !!(e && e.message !== void 0);
}
function rW(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function Ew(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = rW(t, e.fullFields) : r = t[n.field || e.fullField], nW(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function $w(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        typeof r == "object" && typeof e[n] == "object" ? e[n] = rl({}, e[n], r) : e[n] = r;
      }
  }
  return e;
}
var V5 = function(t, n, r, o, i, a) {
  t.required && (!r.hasOwnProperty(t.field) || Xr(n, a || t.type)) && o.push(Jo(i.messages.required, t.fullField));
}, oW = function(t, n, r, o, i) {
  (/^\s+$/.test(n) || n === "") && o.push(Jo(i.messages.whitespace, t.fullField));
}, Sp, iW = function() {
  if (Sp)
    return Sp;
  var e = "[a-fA-F\\d:]", t = function(E) {
    return E && E.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", o = (`
(?:
(?:` + r + ":){7}(?:" + r + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + r + ":){6}(?:" + n + "|:" + r + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + r + ":){5}(?::" + n + "|(?::" + r + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + r + ":){4}(?:(?::" + r + "){0,1}:" + n + "|(?::" + r + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + r + ":){3}(?:(?::" + r + "){0,2}:" + n + "|(?::" + r + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + r + ":){2}(?:(?::" + r + "){0,3}:" + n + "|(?::" + r + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + r + ":){1}(?:(?::" + r + "){0,4}:" + n + "|(?::" + r + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + r + "){0,5}:" + n + "|(?::" + r + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), i = new RegExp("(?:^" + n + "$)|(?:^" + o + "$)"), a = new RegExp("^" + n + "$"), s = new RegExp("^" + o + "$"), l = function(E) {
    return E && E.exact ? i : new RegExp("(?:" + t(E) + n + t(E) + ")|(?:" + t(E) + o + t(E) + ")", "g");
  };
  l.v4 = function(S) {
    return S && S.exact ? a : new RegExp("" + t(S) + n + t(S), "g");
  }, l.v6 = function(S) {
    return S && S.exact ? s : new RegExp("" + t(S) + o + t(S), "g");
  };
  var u = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", p = l.v4().source, h = l.v6().source, y = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", b = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", m = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", v = "(?::\\d{2,5})?", C = '(?:[/?#][^\\s"]*)?', x = "(?:" + u + "|www\\.)" + f + "(?:localhost|" + p + "|" + h + "|" + y + b + m + ")" + v + C;
  return Sp = new RegExp("(?:^" + x + "$)", "i"), Sp;
}, Ow = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, Yu = {
  integer: function(t) {
    return Yu.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return Yu.number(t) && !Yu.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch (n) {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !Yu.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(Ow.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(iW());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(Ow.hex);
  }
}, aW = function(t, n, r, o, i) {
  if (t.required && n === void 0) {
    V5(t, n, r, o, i);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? Yu[s](n) || o.push(Jo(i.messages.types[s], t.fullField, t.type)) : s && typeof n !== t.type && o.push(Jo(i.messages.types[s], t.fullField, t.type));
}, sW = function(t, n, r, o, i) {
  var a = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", u = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, f = n, p = null, h = typeof n == "number", y = typeof n == "string", b = Array.isArray(n);
  if (h ? p = "number" : y ? p = "string" : b && (p = "array"), !p)
    return !1;
  b && (f = n.length), y && (f = n.replace(u, "_").length), a ? f !== t.len && o.push(Jo(i.messages[p].len, t.fullField, t.len)) : s && !l && f < t.min ? o.push(Jo(i.messages[p].min, t.fullField, t.min)) : l && !s && f > t.max ? o.push(Jo(i.messages[p].max, t.fullField, t.max)) : s && l && (f < t.min || f > t.max) && o.push(Jo(i.messages[p].range, t.fullField, t.min, t.max));
}, Jl = "enum", lW = function(t, n, r, o, i) {
  t[Jl] = Array.isArray(t[Jl]) ? t[Jl] : [], t[Jl].indexOf(n) === -1 && o.push(Jo(i.messages[Jl], t.fullField, t[Jl].join(", ")));
}, cW = function(t, n, r, o, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || o.push(Jo(i.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(n) || o.push(Jo(i.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, Dn = {
  required: V5,
  whitespace: oW,
  type: aW,
  range: sW,
  enum: lW,
  pattern: cW
}, uW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n, "string") && !t.required)
      return r();
    Dn.required(t, n, o, a, i, "string"), Xr(n, "string") || (Dn.type(t, n, o, a, i), Dn.range(t, n, o, a, i), Dn.pattern(t, n, o, a, i), t.whitespace === !0 && Dn.whitespace(t, n, o, a, i));
  }
  r(a);
}, dW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && Dn.type(t, n, o, a, i);
  }
  r(a);
}, fW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && (Dn.type(t, n, o, a, i), Dn.range(t, n, o, a, i));
  }
  r(a);
}, pW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && Dn.type(t, n, o, a, i);
  }
  r(a);
}, hW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), Xr(n) || Dn.type(t, n, o, a, i);
  }
  r(a);
}, gW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && (Dn.type(t, n, o, a, i), Dn.range(t, n, o, a, i));
  }
  r(a);
}, mW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && (Dn.type(t, n, o, a, i), Dn.range(t, n, o, a, i));
  }
  r(a);
}, vW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    Dn.required(t, n, o, a, i, "array"), n != null && (Dn.type(t, n, o, a, i), Dn.range(t, n, o, a, i));
  }
  r(a);
}, yW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && Dn.type(t, n, o, a, i);
  }
  r(a);
}, bW = "enum", CW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i), n !== void 0 && Dn[bW](t, n, o, a, i);
  }
  r(a);
}, xW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n, "string") && !t.required)
      return r();
    Dn.required(t, n, o, a, i), Xr(n, "string") || Dn.pattern(t, n, o, a, i);
  }
  r(a);
}, SW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n, "date") && !t.required)
      return r();
    if (Dn.required(t, n, o, a, i), !Xr(n, "date")) {
      var l;
      n instanceof Date ? l = n : l = new Date(n), Dn.type(t, l, o, a, i), l && Dn.range(t, l.getTime(), o, a, i);
    }
  }
  r(a);
}, wW = function(t, n, r, o, i) {
  var a = [], s = Array.isArray(n) ? "array" : typeof n;
  Dn.required(t, n, o, a, i, s), r(a);
}, qv = function(t, n, r, o, i) {
  var a = t.type, s = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Xr(n, a) && !t.required)
      return r();
    Dn.required(t, n, o, s, i, a), Xr(n, a) || Dn.type(t, n, o, s, i);
  }
  r(s);
}, EW = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xr(n) && !t.required)
      return r();
    Dn.required(t, n, o, a, i);
  }
  r(a);
}, id = {
  string: uW,
  method: dW,
  number: fW,
  boolean: pW,
  regexp: hW,
  integer: gW,
  float: mW,
  array: vW,
  object: yW,
  enum: CW,
  pattern: xW,
  date: SW,
  url: qv,
  hex: qv,
  email: qv,
  required: wW,
  any: EW
};
function D1() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var T1 = D1(), Xd = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = null, this._messages = T1, this.define(n);
  }
  var t = e.prototype;
  return t.define = function(r) {
    var o = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(i) {
      var a = r[i];
      o.rules[i] = Array.isArray(a) ? a : [a];
    });
  }, t.messages = function(r) {
    return r && (this._messages = $w(D1(), r)), this._messages;
  }, t.validate = function(r, o, i) {
    var a = this;
    o === void 0 && (o = {}), i === void 0 && (i = function() {
    });
    var s = r, l = o, u = i;
    if (typeof l == "function" && (u = l, l = {}), !this.rules || Object.keys(this.rules).length === 0)
      return u && u(null, s), Promise.resolve(s);
    function f(m) {
      var v = [], C = {};
      function x(E) {
        if (Array.isArray(E)) {
          var O;
          v = (O = v).concat.apply(O, E);
        } else
          v.push(E);
      }
      for (var S = 0; S < m.length; S++)
        x(m[S]);
      v.length ? (C = R1(v), u(v, C)) : u(null, s);
    }
    if (l.messages) {
      var p = this.messages();
      p === T1 && (p = D1()), $w(p, l.messages), l.messages = p;
    } else
      l.messages = this.messages();
    var h = {}, y = l.keys || Object.keys(this.rules);
    y.forEach(function(m) {
      var v = a.rules[m], C = s[m];
      v.forEach(function(x) {
        var S = x;
        typeof S.transform == "function" && (s === r && (s = rl({}, s)), C = s[m] = S.transform(C)), typeof S == "function" ? S = {
          validator: S
        } : S = rl({}, S), S.validator = a.getValidationMethod(S), S.validator && (S.field = m, S.fullField = S.fullField || m, S.type = a.getType(S), h[m] = h[m] || [], h[m].push({
          rule: S,
          value: C,
          source: s,
          field: m
        }));
      });
    });
    var b = {};
    return tW(h, l, function(m, v) {
      var C = m.rule, x = (C.type === "object" || C.type === "array") && (typeof C.fields == "object" || typeof C.defaultField == "object");
      x = x && (C.required || !C.required && m.value), C.field = m.field;
      function S($, _) {
        return rl({}, _, {
          fullField: C.fullField + "." + $,
          fullFields: C.fullFields ? [].concat(C.fullFields, [$]) : [$]
        });
      }
      function E($) {
        $ === void 0 && ($ = []);
        var _ = Array.isArray($) ? $ : [$];
        !l.suppressWarning && _.length && e.warning("async-validator:", _), _.length && C.message !== void 0 && (_ = [].concat(C.message));
        var R = _.map(Ew(C, s));
        if (l.first && R.length)
          return b[C.field] = 1, v(R);
        if (!x)
          v(R);
        else {
          if (C.required && !m.value)
            return C.message !== void 0 ? R = [].concat(C.message).map(Ew(C, s)) : l.error && (R = [l.error(C, Jo(l.messages.required, C.field))]), v(R);
          var P = {};
          C.defaultField && Object.keys(m.value).map(function(F) {
            P[F] = C.defaultField;
          }), P = rl({}, P, m.rule.fields);
          var I = {};
          Object.keys(P).forEach(function(F) {
            var A = P[F], M = Array.isArray(A) ? A : [A];
            I[F] = M.map(S.bind(null, F));
          });
          var j = new e(I);
          j.messages(l.messages), m.rule.options && (m.rule.options.messages = l.messages, m.rule.options.error = l.error), j.validate(m.value, m.rule.options || l, function(F) {
            var A = [];
            R && R.length && A.push.apply(A, R), F && F.length && A.push.apply(A, F), v(A.length ? A : null);
          });
        }
      }
      var O;
      if (C.asyncValidator)
        O = C.asyncValidator(C, m.value, E, m.source, l);
      else if (C.validator) {
        try {
          O = C.validator(C, m.value, E, m.source, l);
        } catch ($) {
          console.error == null || console.error($), l.suppressValidatorError || setTimeout(function() {
            throw $;
          }, 0), E($.message);
        }
        O === !0 ? E() : O === !1 ? E(typeof C.message == "function" ? C.message(C.fullField || C.field) : C.message || (C.fullField || C.field) + " fails") : O instanceof Array ? E(O) : O instanceof Error && E(O.message);
      }
      O && O.then && O.then(function() {
        return E();
      }, function($) {
        return E($);
      });
    }, function(m) {
      f(m);
    }, s);
  }, t.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !id.hasOwnProperty(r.type))
      throw new Error(Jo("Unknown rule type %s", r.type));
    return r.type || "string";
  }, t.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var o = Object.keys(r), i = o.indexOf("message");
    return i !== -1 && o.splice(i, 1), o.length === 1 && o[0] === "required" ? id.required : id[this.getType(r)] || void 0;
  }, e;
}();
Xd.register = function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  id[t] = n;
};
Xd.warning = z5;
Xd.messages = T1;
Xd.validators = id;
var Xo = "'${name}' is not a valid ${type}", W5 = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: Xo,
    method: Xo,
    array: Xo,
    object: Xo,
    number: Xo,
    date: Xo,
    boolean: Xo,
    integer: Xo,
    float: Xo,
    regexp: Xo,
    email: Xo,
    url: Xo,
    hex: Xo
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, _w = Xd;
function $W(e, t) {
  return e.replace(/\$\{\w+\}/g, function(n) {
    var r = n.slice(2, -1);
    return t[r];
  });
}
var Nw = "CODE_LOGIC_ERROR";
function M1(e, t, n, r, o) {
  return L1.apply(this, arguments);
}
function L1() {
  return L1 = Pl(/* @__PURE__ */ Po().mark(function e(t, n, r, o, i) {
    var a, s, l, u, f, p, h, y, b;
    return Po().wrap(function(v) {
      for (; ; )
        switch (v.prev = v.next) {
          case 0:
            return a = J({}, r), delete a.ruleIndex, _w.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (C) {
                return console.error(C), Promise.reject(Nw);
              }
            }), l = null, a && a.type === "array" && a.defaultField && (l = a.defaultField, delete a.defaultField), u = new _w(K({}, t, [a])), f = gc(W5, o.validateMessages), u.messages(f), p = [], v.prev = 10, v.next = 13, Promise.resolve(u.validate(K({}, t, n), J({}, o)));
          case 13:
            v.next = 18;
            break;
          case 15:
            v.prev = 15, v.t0 = v.catch(10), v.t0.errors && (p = v.t0.errors.map(function(C, x) {
              var S = C.message, E = S === Nw ? f.default : S;
              return /* @__PURE__ */ c.isValidElement(E) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ c.cloneElement(E, {
                  key: "error_".concat(x)
                })
              ) : E;
            }));
          case 18:
            if (!(!p.length && l)) {
              v.next = 23;
              break;
            }
            return v.next = 21, Promise.all(n.map(function(C, x) {
              return M1("".concat(t, ".").concat(x), C, l, o, i);
            }));
          case 21:
            return h = v.sent, v.abrupt("return", h.reduce(function(C, x) {
              return [].concat(We(C), We(x));
            }, []));
          case 23:
            return y = J(J({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, i), b = p.map(function(C) {
              return typeof C == "string" ? $W(C, y) : C;
            }), v.abrupt("return", b);
          case 26:
          case "end":
            return v.stop();
        }
    }, e, null, [[10, 15]]);
  })), L1.apply(this, arguments);
}
function OW(e, t, n, r, o, i) {
  var a = e.join("."), s = n.map(function(f, p) {
    var h = f.validator, y = J(J({}, f), {}, {
      ruleIndex: p
    });
    return h && (y.validator = function(b, m, v) {
      var C = !1, x = function() {
        for (var O = arguments.length, $ = new Array(O), _ = 0; _ < O; _++)
          $[_] = arguments[_];
        Promise.resolve().then(function() {
          mt(!C, "Your validator function has already return a promise. `callback` will be ignored."), C || v.apply(void 0, $);
        });
      }, S = h(b, m, x);
      C = S && typeof S.then == "function" && typeof S.catch == "function", mt(C, "`callback` is deprecated. Please return a promise instead."), C && S.then(function() {
        v();
      }).catch(function(E) {
        v(E || " ");
      });
    }), y;
  }).sort(function(f, p) {
    var h = f.warningOnly, y = f.ruleIndex, b = p.warningOnly, m = p.ruleIndex;
    return !!h == !!b ? y - m : h ? 1 : -1;
  }), l;
  if (o === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var f = Pl(/* @__PURE__ */ Po().mark(function p(h, y) {
        var b, m, v;
        return Po().wrap(function(x) {
          for (; ; )
            switch (x.prev = x.next) {
              case 0:
                b = 0;
              case 1:
                if (!(b < s.length)) {
                  x.next = 12;
                  break;
                }
                return m = s[b], x.next = 5, M1(a, t, m, r, i);
              case 5:
                if (v = x.sent, !v.length) {
                  x.next = 9;
                  break;
                }
                return y([{
                  errors: v,
                  rule: m
                }]), x.abrupt("return");
              case 9:
                b += 1, x.next = 1;
                break;
              case 12:
                h([]);
              case 13:
              case "end":
                return x.stop();
            }
        }, p);
      }));
      return function(p, h) {
        return f.apply(this, arguments);
      };
    }());
  else {
    var u = s.map(function(f) {
      return M1(a, t, f, r, i).then(function(p) {
        return {
          errors: p,
          rule: f
        };
      });
    });
    l = (o ? NW(u) : _W(u)).then(function(f) {
      return Promise.reject(f);
    });
  }
  return l.catch(function(f) {
    return f;
  }), l;
}
function _W(e) {
  return A1.apply(this, arguments);
}
function A1() {
  return A1 = Pl(/* @__PURE__ */ Po().mark(function e(t) {
    return Po().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(o) {
              var i, a = (i = []).concat.apply(i, We(o));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), A1.apply(this, arguments);
}
function NW(e) {
  return j1.apply(this, arguments);
}
function j1() {
  return j1 = Pl(/* @__PURE__ */ Po().mark(function e(t) {
    var n;
    return Po().wrap(function(o) {
      for (; ; )
        switch (o.prev = o.next) {
          case 0:
            return n = 0, o.abrupt("return", new Promise(function(i) {
              t.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && i([s]), n += 1, n === t.length && i([]);
                });
              });
            }));
          case 2:
          case "end":
            return o.stop();
        }
    }, e);
  })), j1.apply(this, arguments);
}
function Lr(e) {
  return N1(e);
}
function Pw(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var o = yi(e, r);
    n = Ti(n, r, o);
  }), n;
}
function Cc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return K5(t, r, n);
  });
}
function K5(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, o) {
    return e[o] === r;
  });
}
function PW(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || Vt(e) !== "object" || Vt(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), o = new Set([].concat(n, r));
  return We(o).every(function(i) {
    var a = e[i], s = t[i];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function IW(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && Vt(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function Iw(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var o = e[t], i = t - n;
  return i > 0 ? [].concat(We(e.slice(0, n)), [o], We(e.slice(n, t)), We(e.slice(t + 1, r))) : i < 0 ? [].concat(We(e.slice(0, t)), We(e.slice(t + 1, n + 1)), [o], We(e.slice(n + 1, r))) : e;
}
var RW = ["name"], fi = [];
function Rw(e, t, n, r, o, i) {
  return typeof e == "function" ? e(t, n, "source" in i ? {
    source: i.source
  } : {}) : r !== o;
}
var Eb = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n(r) {
    var o;
    if (zr(this, n), o = t.call(this, r), K(nt(o), "state", {
      resetCount: 0
    }), K(nt(o), "cancelRegisterFunc", null), K(nt(o), "mounted", !1), K(nt(o), "touched", !1), K(nt(o), "dirty", !1), K(nt(o), "validatePromise", void 0), K(nt(o), "prevValidating", void 0), K(nt(o), "errors", fi), K(nt(o), "warnings", fi), K(nt(o), "cancelRegister", function() {
      var l = o.props, u = l.preserve, f = l.isListField, p = l.name;
      o.cancelRegisterFunc && o.cancelRegisterFunc(f, u, Lr(p)), o.cancelRegisterFunc = null;
    }), K(nt(o), "getNamePath", function() {
      var l = o.props, u = l.name, f = l.fieldContext, p = f.prefixName, h = p === void 0 ? [] : p;
      return u !== void 0 ? [].concat(We(h), We(u)) : [];
    }), K(nt(o), "getRules", function() {
      var l = o.props, u = l.rules, f = u === void 0 ? [] : u, p = l.fieldContext;
      return f.map(function(h) {
        return typeof h == "function" ? h(p) : h;
      });
    }), K(nt(o), "refresh", function() {
      o.mounted && o.setState(function(l) {
        var u = l.resetCount;
        return {
          resetCount: u + 1
        };
      });
    }), K(nt(o), "metaCache", null), K(nt(o), "triggerMetaEvent", function(l) {
      var u = o.props.onMetaChange;
      if (u) {
        var f = J(J({}, o.getMeta()), {}, {
          destroy: l
        });
        Fi(o.metaCache, f) || u(f), o.metaCache = f;
      } else
        o.metaCache = null;
    }), K(nt(o), "onStoreChange", function(l, u, f) {
      var p = o.props, h = p.shouldUpdate, y = p.dependencies, b = y === void 0 ? [] : y, m = p.onReset, v = f.store, C = o.getNamePath(), x = o.getValue(l), S = o.getValue(v), E = u && Cc(u, C);
      switch (f.type === "valueUpdate" && f.source === "external" && x !== S && (o.touched = !0, o.dirty = !0, o.validatePromise = null, o.errors = fi, o.warnings = fi, o.triggerMetaEvent()), f.type) {
        case "reset":
          if (!u || E) {
            o.touched = !1, o.dirty = !1, o.validatePromise = void 0, o.errors = fi, o.warnings = fi, o.triggerMetaEvent(), m == null || m(), o.refresh();
            return;
          }
          break;
        case "remove": {
          if (h) {
            o.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var O = f.data;
          if (E) {
            "touched" in O && (o.touched = O.touched), "validating" in O && !("originRCField" in O) && (o.validatePromise = O.validating ? Promise.resolve([]) : null), "errors" in O && (o.errors = O.errors || fi), "warnings" in O && (o.warnings = O.warnings || fi), o.dirty = !0, o.triggerMetaEvent(), o.reRender();
            return;
          } else if ("value" in O && Cc(u, C, !0)) {
            o.reRender();
            return;
          }
          if (h && !C.length && Rw(h, l, v, x, S, f)) {
            o.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var $ = b.map(Lr);
          if ($.some(function(_) {
            return Cc(f.relatedFields, _);
          })) {
            o.reRender();
            return;
          }
          break;
        }
        default:
          if (E || (!b.length || C.length || h) && Rw(h, l, v, x, S, f)) {
            o.reRender();
            return;
          }
          break;
      }
      h === !0 && o.reRender();
    }), K(nt(o), "validateRules", function(l) {
      var u = o.getNamePath(), f = o.getValue(), p = l || {}, h = p.triggerName, y = p.validateOnly, b = y === void 0 ? !1 : y, m = Promise.resolve().then(/* @__PURE__ */ Pl(/* @__PURE__ */ Po().mark(function v() {
        var C, x, S, E, O, $, _;
        return Po().wrap(function(P) {
          for (; ; )
            switch (P.prev = P.next) {
              case 0:
                if (o.mounted) {
                  P.next = 2;
                  break;
                }
                return P.abrupt("return", []);
              case 2:
                if (C = o.props, x = C.validateFirst, S = x === void 0 ? !1 : x, E = C.messageVariables, O = C.validateDebounce, $ = o.getRules(), h && ($ = $.filter(function(I) {
                  return I;
                }).filter(function(I) {
                  var j = I.validateTrigger;
                  if (!j)
                    return !0;
                  var F = N1(j);
                  return F.includes(h);
                })), !(O && h)) {
                  P.next = 10;
                  break;
                }
                return P.next = 8, new Promise(function(I) {
                  setTimeout(I, O);
                });
              case 8:
                if (o.validatePromise === m) {
                  P.next = 10;
                  break;
                }
                return P.abrupt("return", []);
              case 10:
                return _ = OW(u, f, $, l, S, E), _.catch(function(I) {
                  return I;
                }).then(function() {
                  var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fi;
                  if (o.validatePromise === m) {
                    var j;
                    o.validatePromise = null;
                    var F = [], A = [];
                    (j = I.forEach) === null || j === void 0 || j.call(I, function(M) {
                      var N = M.rule.warningOnly, D = M.errors, T = D === void 0 ? fi : D;
                      N ? A.push.apply(A, We(T)) : F.push.apply(F, We(T));
                    }), o.errors = F, o.warnings = A, o.triggerMetaEvent(), o.reRender();
                  }
                }), P.abrupt("return", _);
              case 13:
              case "end":
                return P.stop();
            }
        }, v);
      })));
      return b || (o.validatePromise = m, o.dirty = !0, o.errors = fi, o.warnings = fi, o.triggerMetaEvent(), o.reRender()), m;
    }), K(nt(o), "isFieldValidating", function() {
      return !!o.validatePromise;
    }), K(nt(o), "isFieldTouched", function() {
      return o.touched;
    }), K(nt(o), "isFieldDirty", function() {
      if (o.dirty || o.props.initialValue !== void 0)
        return !0;
      var l = o.props.fieldContext, u = l.getInternalHooks(nl), f = u.getInitialValue;
      return f(o.getNamePath()) !== void 0;
    }), K(nt(o), "getErrors", function() {
      return o.errors;
    }), K(nt(o), "getWarnings", function() {
      return o.warnings;
    }), K(nt(o), "isListField", function() {
      return o.props.isListField;
    }), K(nt(o), "isList", function() {
      return o.props.isList;
    }), K(nt(o), "isPreserve", function() {
      return o.props.preserve;
    }), K(nt(o), "getMeta", function() {
      o.prevValidating = o.isFieldValidating();
      var l = {
        touched: o.isFieldTouched(),
        validating: o.prevValidating,
        errors: o.errors,
        warnings: o.warnings,
        name: o.getNamePath(),
        validated: o.validatePromise === null
      };
      return l;
    }), K(nt(o), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var u = o.getMeta();
        return J(J({}, o.getOnlyChild(l(o.getControlled(), u, o.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var f = Rr(l);
      return f.length !== 1 || !/* @__PURE__ */ c.isValidElement(f[0]) ? {
        child: f,
        isFunction: !1
      } : {
        child: f[0],
        isFunction: !1
      };
    }), K(nt(o), "getValue", function(l) {
      var u = o.props.fieldContext.getFieldsValue, f = o.getNamePath();
      return yi(l || u(!0), f);
    }), K(nt(o), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = o.props, f = u.trigger, p = u.validateTrigger, h = u.getValueFromEvent, y = u.normalize, b = u.valuePropName, m = u.getValueProps, v = u.fieldContext, C = p !== void 0 ? p : v.validateTrigger, x = o.getNamePath(), S = v.getInternalHooks, E = v.getFieldsValue, O = S(nl), $ = O.dispatch, _ = o.getValue(), R = m || function(F) {
        return K({}, b, F);
      }, P = l[f], I = J(J({}, l), R(_));
      I[f] = function() {
        o.touched = !0, o.dirty = !0, o.triggerMetaEvent();
        for (var F, A = arguments.length, M = new Array(A), N = 0; N < A; N++)
          M[N] = arguments[N];
        h ? F = h.apply(void 0, M) : F = IW.apply(void 0, [b].concat(M)), y && (F = y(F, _, E(!0))), $({
          type: "updateValue",
          namePath: x,
          value: F
        }), P && P.apply(void 0, M);
      };
      var j = N1(C || []);
      return j.forEach(function(F) {
        var A = I[F];
        I[F] = function() {
          A && A.apply(void 0, arguments);
          var M = o.props.rules;
          M && M.length && $({
            type: "validateField",
            namePath: x,
            triggerName: F
          });
        };
      }), I;
    }), r.fieldContext) {
      var i = r.fieldContext.getInternalHooks, a = i(nl), s = a.initEntityValue;
      s(nt(o));
    }
    return o;
  }
  return Vr(n, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, i = o.shouldUpdate, a = o.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, l = s(nl), u = l.registerField;
        this.cancelRegisterFunc = u(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state.resetCount, i = this.props.children, a = this.getOnlyChild(i), s = a.child, l = a.isFunction, u;
      return l ? u = s : /* @__PURE__ */ c.isValidElement(s) ? u = /* @__PURE__ */ c.cloneElement(s, this.getControlled(s.props)) : (mt(!s, "`children` of Field is not validate ReactElement."), u = s), /* @__PURE__ */ c.createElement(c.Fragment, {
        key: o
      }, u);
    }
  }]), n;
}(c.Component);
K(Eb, "contextType", yl);
K(Eb, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function $b(e) {
  var t = e.name, n = Yt(e, RW), r = c.useContext(yl), o = c.useContext(wd), i = t !== void 0 ? Lr(t) : void 0, a = "keep";
  return n.isListField || (a = "_".concat((i || []).join("_"))), process.env.NODE_ENV !== "production" && n.preserve === !1 && n.isListField && i.length <= 1 && mt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ c.createElement(Eb, Oe({
    key: a,
    name: i,
    isListField: !!o
  }, n, {
    fieldContext: r
  }));
}
function U5(e) {
  var t = e.name, n = e.initialValue, r = e.children, o = e.rules, i = e.validateTrigger, a = e.isListField, s = c.useContext(yl), l = c.useContext(wd), u = c.useRef({
    keys: [],
    id: 0
  }), f = u.current, p = c.useMemo(function() {
    var m = Lr(s.prefixName) || [];
    return [].concat(We(m), We(Lr(t)));
  }, [s.prefixName, t]), h = c.useMemo(function() {
    return J(J({}, s), {}, {
      prefixName: p
    });
  }, [s, p]), y = c.useMemo(function() {
    return {
      getKey: function(v) {
        var C = p.length, x = v[C];
        return [f.keys[x], v.slice(C + 1)];
      }
    };
  }, [p]);
  if (typeof r != "function")
    return mt(!1, "Form.List only accepts function as children."), null;
  var b = function(v, C, x) {
    var S = x.source;
    return S === "internal" ? !1 : v !== C;
  };
  return /* @__PURE__ */ c.createElement(wd.Provider, {
    value: y
  }, /* @__PURE__ */ c.createElement(yl.Provider, {
    value: h
  }, /* @__PURE__ */ c.createElement($b, {
    name: [],
    shouldUpdate: b,
    rules: o,
    validateTrigger: i,
    initialValue: n,
    isList: !0,
    isListField: a != null ? a : !!l
  }, function(m, v) {
    var C = m.value, x = C === void 0 ? [] : C, S = m.onChange, E = s.getFieldValue, O = function() {
      var P = E(p || []);
      return P || [];
    }, $ = {
      add: function(P, I) {
        var j = O();
        I >= 0 && I <= j.length ? (f.keys = [].concat(We(f.keys.slice(0, I)), [f.id], We(f.keys.slice(I))), S([].concat(We(j.slice(0, I)), [P], We(j.slice(I))))) : (process.env.NODE_ENV !== "production" && (I < 0 || I > j.length) && mt(!1, "The second parameter of the add function should be a valid positive number."), f.keys = [].concat(We(f.keys), [f.id]), S([].concat(We(j), [P]))), f.id += 1;
      },
      remove: function(P) {
        var I = O(), j = new Set(Array.isArray(P) ? P : [P]);
        j.size <= 0 || (f.keys = f.keys.filter(function(F, A) {
          return !j.has(A);
        }), S(I.filter(function(F, A) {
          return !j.has(A);
        })));
      },
      move: function(P, I) {
        if (P !== I) {
          var j = O();
          P < 0 || P >= j.length || I < 0 || I >= j.length || (f.keys = Iw(f.keys, P, I), S(Iw(j, P, I)));
        }
      }
    }, _ = x || [];
    return Array.isArray(_) || (_ = [], process.env.NODE_ENV !== "production" && mt(!1, "Current value of '".concat(p.join(" > "), "' is not an array type."))), r(_.map(function(R, P) {
      var I = f.keys[P];
      return I === void 0 && (f.keys[P] = f.id, I = f.keys[P], f.id += 1), {
        name: P,
        key: I,
        isListField: !0
      };
    }), $, v);
  })));
}
function DW(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(o, i) {
    e.forEach(function(a, s) {
      a.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        n -= 1, r[s] = l, !(n > 0) && (t && i(r), o(r));
      });
    });
  }) : Promise.resolve([]);
}
var G5 = "__@field_split__";
function Yv(e) {
  return e.map(function(t) {
    return "".concat(Vt(t), ":").concat(t);
  }).join(G5);
}
var ec = /* @__PURE__ */ function() {
  function e() {
    zr(this, e), K(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Vr(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(Yv(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(Yv(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var o = this.get(n), i = r(o);
      i ? this.set(n, i) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(Yv(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return We(this.kvs.entries()).map(function(r) {
        var o = de(r, 2), i = o[0], a = o[1], s = i.split(G5);
        return n({
          key: s.map(function(l) {
            var u = l.match(/^([^:]*):(.*)$/), f = de(u, 3), p = f[1], h = f[2];
            return p === "number" ? Number(h) : h;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var o = r.key, i = r.value;
        return n[o.join(".")] = i, null;
      }), n;
    }
  }]), e;
}(), TW = ["name"], MW = /* @__PURE__ */ Vr(function e(t) {
  var n = this;
  zr(this, e), K(this, "formHooked", !1), K(this, "forceRootUpdate", void 0), K(this, "subscribable", !0), K(this, "store", {}), K(this, "fieldEntities", []), K(this, "initialValues", {}), K(this, "callbacks", {}), K(this, "validateMessages", null), K(this, "preserve", null), K(this, "lastValidatePromise", null), K(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), K(this, "getInternalHooks", function(r) {
    return r === nl ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (mt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), K(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), K(this, "prevWithoutPreserves", null), K(this, "setInitialValues", function(r, o) {
    if (n.initialValues = r || {}, o) {
      var i, a = gc(r, n.store);
      (i = n.prevWithoutPreserves) === null || i === void 0 || i.map(function(s) {
        var l = s.key;
        a = Ti(a, l, yi(r, l));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), K(this, "destroyForm", function() {
    var r = new ec();
    n.getFieldEntities(!0).forEach(function(o) {
      n.isMergedPreserve(o.isPreserve()) || r.set(o.getNamePath(), !0);
    }), n.prevWithoutPreserves = r;
  }), K(this, "getInitialValue", function(r) {
    var o = yi(n.initialValues, r);
    return r.length ? gc(o) : o;
  }), K(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), K(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), K(this, "setPreserve", function(r) {
    n.preserve = r;
  }), K(this, "watchList", []), K(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(o) {
        return o !== r;
      });
    };
  }), K(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var o = n.getFieldsValue(), i = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(o, i, r);
      });
    }
  }), K(this, "timeoutId", null), K(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !n.timeoutId && typeof window != "undefined" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || mt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), K(this, "updateStore", function(r) {
    n.store = r;
  }), K(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(o) {
      return o.getNamePath().length;
    }) : n.fieldEntities;
  }), K(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = new ec();
    return n.getFieldEntities(r).forEach(function(i) {
      var a = i.getNamePath();
      o.set(a, i);
    }), o;
  }), K(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var o = n.getFieldsMap(!0);
    return r.map(function(i) {
      var a = Lr(i);
      return o.get(a) || {
        INVALIDATE_NAME_PATH: Lr(i)
      };
    });
  }), K(this, "getFieldsValue", function(r, o) {
    n.warningUnhooked();
    var i, a, s;
    if (r === !0 || Array.isArray(r) ? (i = r, a = o) : r && Vt(r) === "object" && (s = r.strict, a = r.filter), i === !0 && !a)
      return n.store;
    var l = n.getFieldEntitiesForNamePathList(Array.isArray(i) ? i : null), u = [];
    return l.forEach(function(f) {
      var p, h, y = "INVALIDATE_NAME_PATH" in f ? f.INVALIDATE_NAME_PATH : f.getNamePath();
      if (s) {
        var b, m;
        if ((b = (m = f).isList) !== null && b !== void 0 && b.call(m))
          return;
      } else if (!i && (p = (h = f).isListField) !== null && p !== void 0 && p.call(h))
        return;
      if (!a)
        u.push(y);
      else {
        var v = "getMeta" in f ? f.getMeta() : null;
        a(v) && u.push(y);
      }
    }), Pw(n.store, u.map(Lr));
  }), K(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var o = Lr(r);
    return yi(n.store, o);
  }), K(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntitiesForNamePathList(r);
    return o.map(function(i, a) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: Lr(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), K(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var o = Lr(r), i = n.getFieldsError([o])[0];
    return i.errors;
  }), K(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var o = Lr(r), i = n.getFieldsError([o])[0];
    return i.warnings;
  }), K(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    var a = o[0], s = o[1], l, u = !1;
    o.length === 0 ? l = null : o.length === 1 ? Array.isArray(a) ? (l = a.map(Lr), u = !1) : (l = null, u = a) : (l = a.map(Lr), u = s);
    var f = n.getFieldEntities(!0), p = function(v) {
      return v.isFieldTouched();
    };
    if (!l)
      return u ? f.every(p) : f.some(p);
    var h = new ec();
    l.forEach(function(m) {
      h.set(m, []);
    }), f.forEach(function(m) {
      var v = m.getNamePath();
      l.forEach(function(C) {
        C.every(function(x, S) {
          return v[S] === x;
        }) && h.update(C, function(x) {
          return [].concat(We(x), [m]);
        });
      });
    });
    var y = function(v) {
      return v.some(p);
    }, b = h.map(function(m) {
      var v = m.value;
      return v;
    });
    return u ? b.every(y) : b.some(y);
  }), K(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), K(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntities();
    if (!r)
      return o.some(function(a) {
        return a.isFieldValidating();
      });
    var i = r.map(Lr);
    return o.some(function(a) {
      var s = a.getNamePath();
      return Cc(i, s) && a.isFieldValidating();
    });
  }), K(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), K(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = new ec(), i = n.getFieldEntities(!0);
    i.forEach(function(l) {
      var u = l.props.initialValue, f = l.getNamePath();
      if (u !== void 0) {
        var p = o.get(f) || /* @__PURE__ */ new Set();
        p.add({
          entity: l,
          value: u
        }), o.set(f, p);
      }
    });
    var a = function(u) {
      u.forEach(function(f) {
        var p = f.props.initialValue;
        if (p !== void 0) {
          var h = f.getNamePath(), y = n.getInitialValue(h);
          if (y !== void 0)
            mt(!1, "Form already set 'initialValues' with path '".concat(h.join("."), "'. Field can not overwrite it."));
          else {
            var b = o.get(h);
            if (b && b.size > 1)
              mt(!1, "Multiple Field with path '".concat(h.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (b) {
              var m = n.getFieldValue(h), v = f.isListField();
              !v && (!r.skipExist || m === void 0) && n.updateStore(Ti(n.store, h, We(b)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(l) {
      var u = o.get(l);
      if (u) {
        var f;
        (f = s).push.apply(f, We(We(u).map(function(p) {
          return p.entity;
        })));
      }
    })) : s = i, a(s);
  }), K(this, "resetFields", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (!r) {
      n.updateStore(gc(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(o, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var i = r.map(Lr);
    i.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(Ti(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: i
    }), n.notifyObservers(o, i, {
      type: "reset"
    }), n.notifyWatch(i);
  }), K(this, "setFields", function(r) {
    n.warningUnhooked();
    var o = n.store, i = [];
    r.forEach(function(a) {
      var s = a.name, l = Yt(a, TW), u = Lr(s);
      i.push(u), "value" in l && n.updateStore(Ti(n.store, u, l.value)), n.notifyObservers(o, [u], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(i);
  }), K(this, "getFields", function() {
    var r = n.getFieldEntities(!0), o = r.map(function(i) {
      var a = i.getNamePath(), s = i.getMeta(), l = J(J({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return o;
  }), K(this, "initEntityValue", function(r) {
    var o = r.props.initialValue;
    if (o !== void 0) {
      var i = r.getNamePath(), a = yi(n.store, i);
      a === void 0 && n.updateStore(Ti(n.store, i, o));
    }
  }), K(this, "isMergedPreserve", function(r) {
    var o = r !== void 0 ? r : n.preserve;
    return o != null ? o : !0;
  }), K(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var o = r.getNamePath();
    if (n.notifyWatch([o]), r.props.initialValue !== void 0) {
      var i = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(i, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(p) {
        return p !== r;
      }), !n.isMergedPreserve(s) && (!a || l.length > 1)) {
        var u = a ? void 0 : n.getInitialValue(o);
        if (o.length && n.getFieldValue(o) !== u && n.fieldEntities.every(function(p) {
          return (
            // Only reset when no namePath exist
            !K5(p.getNamePath(), o)
          );
        })) {
          var f = n.store;
          n.updateStore(Ti(f, o, u, !0)), n.notifyObservers(f, [o], {
            type: "remove"
          }), n.triggerDependenciesUpdate(f, o);
        }
      }
      n.notifyWatch([o]);
    };
  }), K(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var o = r.namePath, i = r.value;
        n.updateValue(o, i);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), K(this, "notifyObservers", function(r, o, i) {
    if (n.subscribable) {
      var a = J(J({}, i), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var l = s.onStoreChange;
        l(r, o, a);
      });
    } else
      n.forceRootUpdate();
  }), K(this, "triggerDependenciesUpdate", function(r, o) {
    var i = n.getDependencyChildrenFields(o);
    return i.length && n.validateFields(i), n.notifyObservers(r, i, {
      type: "dependenciesUpdate",
      relatedFields: [o].concat(We(i))
    }), i;
  }), K(this, "updateValue", function(r, o) {
    var i = Lr(r), a = n.store;
    n.updateStore(Ti(n.store, i, o)), n.notifyObservers(a, [i], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([i]);
    var s = n.triggerDependenciesUpdate(a, i), l = n.callbacks.onValuesChange;
    if (l) {
      var u = Pw(n.store, [i]);
      l(u, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([i].concat(We(s)));
  }), K(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (r) {
      var i = gc(n.store, r);
      n.updateStore(i);
    }
    n.notifyObservers(o, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), K(this, "setFieldValue", function(r, o) {
    n.setFields([{
      name: r,
      value: o
    }]);
  }), K(this, "getDependencyChildrenFields", function(r) {
    var o = /* @__PURE__ */ new Set(), i = [], a = new ec();
    n.getFieldEntities().forEach(function(l) {
      var u = l.props.dependencies;
      (u || []).forEach(function(f) {
        var p = Lr(f);
        a.update(p, function() {
          var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return h.add(l), h;
        });
      });
    });
    var s = function l(u) {
      var f = a.get(u) || /* @__PURE__ */ new Set();
      f.forEach(function(p) {
        if (!o.has(p)) {
          o.add(p);
          var h = p.getNamePath();
          p.isFieldDirty() && h.length && (i.push(h), l(h));
        }
      });
    };
    return s(r), i;
  }), K(this, "triggerOnFieldsChange", function(r, o) {
    var i = n.callbacks.onFieldsChange;
    if (i) {
      var a = n.getFields();
      if (o) {
        var s = new ec();
        o.forEach(function(u) {
          var f = u.name, p = u.errors;
          s.set(f, p);
        }), a.forEach(function(u) {
          u.errors = s.get(u.name) || u.errors;
        });
      }
      var l = a.filter(function(u) {
        var f = u.name;
        return Cc(r, f);
      });
      l.length && i(l, a);
    }
  }), K(this, "validateFields", function(r, o) {
    n.warningUnhooked();
    var i, a;
    Array.isArray(r) || typeof r == "string" || typeof o == "string" ? (i = r, a = o) : a = r;
    var s = !!i, l = s ? i.map(Lr) : [], u = [], f = String(Date.now()), p = /* @__PURE__ */ new Set(), h = a || {}, y = h.recursive, b = h.dirty;
    n.getFieldEntities(!0).forEach(function(x) {
      if (s || l.push(x.getNamePath()), !(!x.props.rules || !x.props.rules.length) && !(b && !x.isFieldDirty())) {
        var S = x.getNamePath();
        if (p.add(S.join(f)), !s || Cc(l, S, y)) {
          var E = x.validateRules(J({
            validateMessages: J(J({}, W5), n.validateMessages)
          }, a));
          u.push(E.then(function() {
            return {
              name: S,
              errors: [],
              warnings: []
            };
          }).catch(function(O) {
            var $, _ = [], R = [];
            return ($ = O.forEach) === null || $ === void 0 || $.call(O, function(P) {
              var I = P.rule.warningOnly, j = P.errors;
              I ? R.push.apply(R, We(j)) : _.push.apply(_, We(j));
            }), _.length ? Promise.reject({
              name: S,
              errors: _,
              warnings: R
            }) : {
              name: S,
              errors: _,
              warnings: R
            };
          }));
        }
      }
    });
    var m = DW(u);
    n.lastValidatePromise = m, m.catch(function(x) {
      return x;
    }).then(function(x) {
      var S = x.map(function(E) {
        var O = E.name;
        return O;
      });
      n.notifyObservers(n.store, S, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(S, x);
    });
    var v = m.then(function() {
      return n.lastValidatePromise === m ? Promise.resolve(n.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(x) {
      var S = x.filter(function(E) {
        return E && E.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(l),
        errorFields: S,
        outOfDate: n.lastValidatePromise !== m
      });
    });
    v.catch(function(x) {
      return x;
    });
    var C = l.filter(function(x) {
      return p.has(x.join(f));
    });
    return n.triggerOnFieldsChange(C), v;
  }), K(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var o = n.callbacks.onFinish;
      if (o)
        try {
          o(r);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(r) {
      var o = n.callbacks.onFinishFailed;
      o && o(r);
    });
  }), this.forceRootUpdate = t;
});
function Ob(e) {
  var t = c.useRef(), n = c.useState({}), r = de(n, 2), o = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var i = function() {
        o({});
      }, a = new MW(i);
      t.current = a.getForm();
    }
  return [t.current];
}
var k1 = /* @__PURE__ */ c.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), q5 = function(t) {
  var n = t.validateMessages, r = t.onFormChange, o = t.onFormFinish, i = t.children, a = c.useContext(k1), s = c.useRef({});
  return /* @__PURE__ */ c.createElement(k1.Provider, {
    value: J(J({}, a), {}, {
      validateMessages: J(J({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(u, f) {
        r && r(u, {
          changedFields: f,
          forms: s.current
        }), a.triggerFormChange(u, f);
      },
      triggerFormFinish: function(u, f) {
        o && o(u, {
          values: f,
          forms: s.current
        }), a.triggerFormFinish(u, f);
      },
      registerForm: function(u, f) {
        u && (s.current = J(J({}, s.current), {}, K({}, u, f))), a.registerForm(u, f);
      },
      unregisterForm: function(u) {
        var f = J({}, s.current);
        delete f[u], s.current = f, a.unregisterForm(u);
      }
    })
  }, i);
}, LW = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], AW = function(t, n) {
  var r = t.name, o = t.initialValues, i = t.fields, a = t.form, s = t.preserve, l = t.children, u = t.component, f = u === void 0 ? "form" : u, p = t.validateMessages, h = t.validateTrigger, y = h === void 0 ? "onChange" : h, b = t.onValuesChange, m = t.onFieldsChange, v = t.onFinish, C = t.onFinishFailed, x = Yt(t, LW), S = c.useContext(k1), E = Ob(a), O = de(E, 1), $ = O[0], _ = $.getInternalHooks(nl), R = _.useSubscribe, P = _.setInitialValues, I = _.setCallbacks, j = _.setValidateMessages, F = _.setPreserve, A = _.destroyForm;
  c.useImperativeHandle(n, function() {
    return $;
  }), c.useEffect(function() {
    return S.registerForm(r, $), function() {
      S.unregisterForm(r);
    };
  }, [S, $, r]), j(J(J({}, S.validateMessages), p)), I({
    onValuesChange: b,
    onFieldsChange: function(Y) {
      if (S.triggerFormChange(r, Y), m) {
        for (var Z = arguments.length, oe = new Array(Z > 1 ? Z - 1 : 0), ee = 1; ee < Z; ee++)
          oe[ee - 1] = arguments[ee];
        m.apply(void 0, [Y].concat(oe));
      }
    },
    onFinish: function(Y) {
      S.triggerFormFinish(r, Y), v && v(Y);
    },
    onFinishFailed: C
  }), F(s);
  var M = c.useRef(null);
  P(o, !M.current), M.current || (M.current = !0), c.useEffect(
    function() {
      return A;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var N, D = typeof l == "function";
  if (D) {
    var T = $.getFieldsValue(!0);
    N = l(T, $);
  } else
    N = l;
  R(!D);
  var L = c.useRef();
  c.useEffect(function() {
    PW(L.current || [], i || []) || $.setFields(i || []), L.current = i;
  }, [i, $]);
  var z = c.useMemo(function() {
    return J(J({}, $), {}, {
      validateTrigger: y
    });
  }, [$, y]), H = /* @__PURE__ */ c.createElement(wd.Provider, {
    value: null
  }, /* @__PURE__ */ c.createElement(yl.Provider, {
    value: z
  }, N));
  return f === !1 ? H : /* @__PURE__ */ c.createElement(f, Oe({}, x, {
    onSubmit: function(Y) {
      Y.preventDefault(), Y.stopPropagation(), $.submit();
    },
    onReset: function(Y) {
      var Z;
      Y.preventDefault(), $.resetFields(), (Z = x.onReset) === null || Z === void 0 || Z.call(x, Y);
    }
  }), H);
};
function Dw(e) {
  try {
    return JSON.stringify(e);
  } catch (t) {
    return Math.random();
  }
}
var jW = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), n = _t(t);
  mt(n.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function Y5() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], o = t[1], i = o === void 0 ? {} : o, a = GV(i) ? {
    form: i
  } : i, s = a.form, l = Ot(), u = de(l, 2), f = u[0], p = u[1], h = mr(function() {
    return Dw(f);
  }, [f]), y = _t(h);
  y.current = h;
  var b = Cn(yl), m = s || b, v = m && m._init;
  process.env.NODE_ENV !== "production" && mt(t.length === 2 ? s ? v : !0 : v, "useWatch requires a form instance since it can not auto detect from context.");
  var C = Lr(r), x = _t(C);
  return x.current = C, jW(C), kt(
    function() {
      if (v) {
        var S = m.getFieldsValue, E = m.getInternalHooks, O = E(nl), $ = O.registerWatch, _ = function(j, F) {
          var A = a.preserve ? F : j;
          return typeof r == "function" ? r(A) : yi(A, x.current);
        }, R = $(function(I, j) {
          var F = _(I, j), A = Dw(F);
          y.current !== A && (y.current = A, p(F));
        }), P = _(S(), S(!0));
        return f !== P && p(P), R;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), f;
}
var kW = /* @__PURE__ */ c.forwardRef(AW), Jc = kW;
Jc.FormProvider = q5;
Jc.Field = $b;
Jc.List = U5;
Jc.useForm = Ob;
Jc.useWatch = Y5;
const Ka = /* @__PURE__ */ c.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
}), X5 = /* @__PURE__ */ c.createContext(null), Z5 = (e) => {
  const t = dr(e, ["prefixCls"]);
  return /* @__PURE__ */ c.createElement(q5, Object.assign({}, t));
}, _b = /* @__PURE__ */ c.createContext({
  prefixCls: ""
}), uo = /* @__PURE__ */ c.createContext({});
process.env.NODE_ENV !== "production" && (uo.displayName = "FormItemInputContext");
const F1 = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const o = Cn(uo), i = mr(() => {
    const a = Object.assign({}, o);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, o]);
  return /* @__PURE__ */ c.createElement(uo.Provider, {
    value: i
  }, t);
}, Q5 = /* @__PURE__ */ Rs(void 0);
function Tw() {
}
const FW = /* @__PURE__ */ c.createContext({
  add: Tw,
  remove: Tw
});
function BW(e) {
  const t = c.useContext(FW), n = c.useRef();
  return Ir((o) => {
    if (o) {
      const i = e ? o.querySelector(e) : o;
      t.add(i), n.current = i;
    } else
      t.remove(n.current);
  });
}
const HW = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), zW = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Nb = function(e, t, n, r) {
  const i = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${i}${e}-enter,
      ${i}${e}-appear
    `]: Object.assign(Object.assign({}, HW(r)), {
      animationPlayState: "paused"
    }),
    [`${i}${e}-leave`]: Object.assign(Object.assign({}, zW(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${i}${e}-enter${e}-enter-active,
      ${i}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${i}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, VW = new Bn("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), WW = new Bn("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), KW = new Bn("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), UW = new Bn("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), GW = new Bn("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), qW = new Bn("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), YW = new Bn("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), XW = new Bn("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), ZW = {
  "move-up": {
    inKeyframes: YW,
    outKeyframes: XW
  },
  "move-down": {
    inKeyframes: VW,
    outKeyframes: WW
  },
  "move-left": {
    inKeyframes: KW,
    outKeyframes: UW
  },
  "move-right": {
    inKeyframes: GW,
    outKeyframes: qW
  }
}, Ac = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: i
  } = ZW[t];
  return [Nb(r, o, i, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, Rg = new Bn("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Dg = new Bn("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), Tg = new Bn("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), Mg = new Bn("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), QW = new Bn("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), JW = new Bn("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), eK = new Bn("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), tK = new Bn("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), nK = {
  "slide-up": {
    inKeyframes: Rg,
    outKeyframes: Dg
  },
  "slide-down": {
    inKeyframes: Tg,
    outKeyframes: Mg
  },
  "slide-left": {
    inKeyframes: QW,
    outKeyframes: JW
  },
  "slide-right": {
    inKeyframes: eK,
    outKeyframes: tK
  }
}, _s = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: i
  } = nK[t];
  return [Nb(r, o, i, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, Pb = new Bn("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), rK = new Bn("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), Mw = new Bn("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), Lw = new Bn("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), oK = new Bn("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), iK = new Bn("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), aK = new Bn("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), sK = new Bn("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), lK = new Bn("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), cK = new Bn("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), uK = new Bn("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), dK = new Bn("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), fK = {
  zoom: {
    inKeyframes: Pb,
    outKeyframes: rK
  },
  "zoom-big": {
    inKeyframes: Mw,
    outKeyframes: Lw
  },
  "zoom-big-fast": {
    inKeyframes: Mw,
    outKeyframes: Lw
  },
  "zoom-left": {
    inKeyframes: aK,
    outKeyframes: sK
  },
  "zoom-right": {
    inKeyframes: lK,
    outKeyframes: cK
  },
  "zoom-up": {
    inKeyframes: oK,
    outKeyframes: iK
  },
  "zoom-down": {
    inKeyframes: uK,
    outKeyframes: dK
  }
}, Lg = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: i
  } = fK[t];
  return [Nb(r, o, i, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, pK = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), Ag = pK, hK = /* @__PURE__ */ be.createContext({});
function gK(e) {
  return (t) => /* @__PURE__ */ c.createElement(vb, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ c.createElement(e, Object.assign({}, t)));
}
const Zd = (e, t, n, r) => gK((i) => {
  const {
    prefixCls: a,
    style: s
  } = i, l = c.useRef(null), [u, f] = c.useState(0), [p, h] = c.useState(0), [y, b] = Fn(!1, {
    value: i.open
  }), {
    getPrefixCls: m
  } = c.useContext(Ft), v = m(t || "select", a);
  c.useEffect(() => {
    if (b(!0), typeof ResizeObserver != "undefined") {
      const S = new ResizeObserver((O) => {
        const $ = O[0].target;
        f($.offsetHeight + 8), h($.offsetWidth);
      }), E = setInterval(() => {
        var O;
        const $ = n ? `.${n(v)}` : `.${v}-dropdown`, _ = (O = l.current) === null || O === void 0 ? void 0 : O.querySelector($);
        _ && (clearInterval(E), S.observe(_));
      }, 10);
      return () => {
        clearInterval(E), S.disconnect();
      };
    }
  }, []);
  let C = Object.assign(Object.assign({}, i), {
    style: Object.assign(Object.assign({}, s), {
      margin: 0
    }),
    open: y,
    visible: y,
    getPopupContainer: () => l.current
  });
  r && (C = r(C));
  const x = {
    paddingBottom: u,
    position: "relative",
    minWidth: p
  };
  return /* @__PURE__ */ c.createElement("div", {
    ref: l,
    style: x
  }, /* @__PURE__ */ c.createElement(e, Object.assign({}, C)));
}), J5 = function() {
  if (typeof navigator == "undefined" || typeof window == "undefined")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
var jg = function(t) {
  var n = t.className, r = t.customizeIcon, o = t.customizeIconProps, i = t.children, a = t.onMouseDown, s = t.onClick, l = typeof r == "function" ? r(o) : r;
  return /* @__PURE__ */ c.createElement("span", {
    className: n,
    onMouseDown: function(f) {
      f.preventDefault(), a == null || a(f);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: s,
    "aria-hidden": !0
  }, l !== void 0 ? l : /* @__PURE__ */ c.createElement("span", {
    className: se(n.split(/\s+/).map(function(u) {
      return "".concat(u, "-icon");
    }))
  }, i));
}, mK = function(t, n, r, o, i) {
  var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, s = arguments.length > 6 ? arguments[6] : void 0, l = arguments.length > 7 ? arguments[7] : void 0, u = be.useMemo(function() {
    if (Vt(o) === "object")
      return o.clearIcon;
    if (i)
      return i;
  }, [o, i]), f = be.useMemo(function() {
    return !!(!a && o && (r.length || s) && !(l === "combobox" && s === ""));
  }, [o, a, r.length, s, l]);
  return {
    allowClear: f,
    clearIcon: /* @__PURE__ */ be.createElement(jg, {
      className: "".concat(t, "-clear"),
      onMouseDown: n,
      customizeIcon: u
    }, "×")
  };
}, e6 = /* @__PURE__ */ c.createContext(null);
function t6() {
  return c.useContext(e6);
}
function vK() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = c.useState(!1), n = de(t, 2), r = n[0], o = n[1], i = c.useRef(null), a = function() {
    window.clearTimeout(i.current);
  };
  c.useEffect(function() {
    return a;
  }, []);
  var s = function(u, f) {
    a(), i.current = window.setTimeout(function() {
      o(u), f && f();
    }, e);
  };
  return [r, s, a];
}
function n6() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = c.useRef(null), n = c.useRef(null);
  c.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function r(o) {
    (o || t.current === null) && (t.current = o), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, r];
}
function yK(e, t, n, r) {
  var o = c.useRef(null);
  o.current = {
    open: t,
    triggerOpen: n,
    customizedTrigger: r
  }, c.useEffect(function() {
    function i(a) {
      var s;
      if (!((s = o.current) !== null && s !== void 0 && s.customizedTrigger)) {
        var l = a.target;
        l.shadowRoot && a.composed && (l = a.composedPath()[0] || l), o.current.open && e().filter(function(u) {
          return u;
        }).every(function(u) {
          return !u.contains(l) && u !== l;
        }) && o.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", i), function() {
      return window.removeEventListener("mousedown", i);
    };
  }, []);
}
var bK = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], tc = void 0;
function CK(e, t) {
  var n = e.prefixCls, r = e.invalidate, o = e.item, i = e.renderItem, a = e.responsive, s = e.responsiveDisabled, l = e.registerSize, u = e.itemKey, f = e.className, p = e.style, h = e.children, y = e.display, b = e.order, m = e.component, v = m === void 0 ? "div" : m, C = Yt(e, bK), x = a && !y;
  function S(R) {
    l(u, R);
  }
  c.useEffect(function() {
    return function() {
      S(null);
    };
  }, []);
  var E = i && o !== tc ? i(o) : h, O;
  r || (O = {
    opacity: x ? 0 : 1,
    height: x ? 0 : tc,
    overflowY: x ? "hidden" : tc,
    order: a ? b : tc,
    pointerEvents: x ? "none" : tc,
    position: x ? "absolute" : tc
  });
  var $ = {};
  x && ($["aria-hidden"] = !0);
  var _ = /* @__PURE__ */ c.createElement(v, Oe({
    className: se(!r && n, f),
    style: J(J({}, O), p)
  }, $, C, {
    ref: t
  }), E);
  return a && (_ = /* @__PURE__ */ c.createElement(zo, {
    onResize: function(P) {
      var I = P.offsetWidth;
      S(I);
    },
    disabled: s
  }, _)), _;
}
var ad = /* @__PURE__ */ c.forwardRef(CK);
ad.displayName = "Item";
function xK(e) {
  if (typeof MessageChannel == "undefined")
    Pn(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function SK() {
  var e = c.useRef(null), t = function(r) {
    e.current || (e.current = [], xK(function() {
      t4(function() {
        e.current.forEach(function(o) {
          o();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function Bu(e, t) {
  var n = c.useState(t), r = de(n, 2), o = r[0], i = r[1], a = Ir(function(s) {
    e(function() {
      i(s);
    });
  });
  return [o, a];
}
var Ih = /* @__PURE__ */ be.createContext(null), wK = ["component"], EK = ["className"], $K = ["className"], OK = function(t, n) {
  var r = c.useContext(Ih);
  if (!r) {
    var o = t.component, i = o === void 0 ? "div" : o, a = Yt(t, wK);
    return /* @__PURE__ */ c.createElement(i, Oe({}, a, {
      ref: n
    }));
  }
  var s = r.className, l = Yt(r, EK), u = t.className, f = Yt(t, $K);
  return /* @__PURE__ */ c.createElement(Ih.Provider, {
    value: null
  }, /* @__PURE__ */ c.createElement(ad, Oe({
    ref: n,
    className: se(s, u)
  }, l, f)));
}, r6 = /* @__PURE__ */ c.forwardRef(OK);
r6.displayName = "RawItem";
var _K = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], o6 = "responsive", i6 = "invalidate";
function NK(e) {
  return "+ ".concat(e.length, " ...");
}
function PK(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, o = e.data, i = o === void 0 ? [] : o, a = e.renderItem, s = e.renderRawItem, l = e.itemKey, u = e.itemWidth, f = u === void 0 ? 10 : u, p = e.ssr, h = e.style, y = e.className, b = e.maxCount, m = e.renderRest, v = e.renderRawRest, C = e.suffix, x = e.component, S = x === void 0 ? "div" : x, E = e.itemComponent, O = e.onVisibleChange, $ = Yt(e, _K), _ = p === "full", R = SK(), P = Bu(R, null), I = de(P, 2), j = I[0], F = I[1], A = j || 0, M = Bu(R, /* @__PURE__ */ new Map()), N = de(M, 2), D = N[0], T = N[1], L = Bu(R, 0), z = de(L, 2), H = z[0], V = z[1], Y = Bu(R, 0), Z = de(Y, 2), oe = Z[0], ee = Z[1], ae = Bu(R, 0), le = de(ae, 2), ue = le[0], ie = le[1], re = Ot(null), Q = de(re, 2), ce = Q[0], ge = Q[1], G = Ot(null), ne = de(G, 2), fe = ne[0], ye = ne[1], we = c.useMemo(function() {
    return fe === null && _ ? Number.MAX_SAFE_INTEGER : fe || 0;
  }, [fe, j]), he = Ot(!1), me = de(he, 2), Ce = me[0], Te = me[1], Ee = "".concat(r, "-item"), Ge = Math.max(H, oe), ke = b === o6, qe = i.length && ke, ze = b === i6, pt = qe || typeof b == "number" && i.length > b, Ke = mr(function() {
    var Qe = i;
    return qe ? j === null && _ ? Qe = i : Qe = i.slice(0, Math.min(i.length, A / f)) : typeof b == "number" && (Qe = i.slice(0, b)), Qe;
  }, [i, f, j, b, qe]), et = mr(function() {
    return qe ? i.slice(we + 1) : i.slice(Ke.length);
  }, [i, Ke, qe, we]), Je = ar(function(Qe, tt) {
    var lt;
    return typeof l == "function" ? l(Qe) : (lt = l && (Qe == null ? void 0 : Qe[l])) !== null && lt !== void 0 ? lt : tt;
  }, [l]), Et = ar(a || function(Qe) {
    return Qe;
  }, [a]);
  function Ye(Qe, tt, lt) {
    fe === Qe && (tt === void 0 || tt === ce) || (ye(Qe), lt || (Te(Qe < i.length - 1), O == null || O(Qe)), tt !== void 0 && ge(tt));
  }
  function wt(Qe, tt) {
    F(tt.clientWidth);
  }
  function dt(Qe, tt) {
    T(function(lt) {
      var ht = new Map(lt);
      return tt === null ? ht.delete(Qe) : ht.set(Qe, tt), ht;
    });
  }
  function Ct(Qe, tt) {
    ee(tt), V(oe);
  }
  function ot(Qe, tt) {
    ie(tt);
  }
  function jt(Qe) {
    return D.get(Je(Ke[Qe], Qe));
  }
  Nn(function() {
    if (A && typeof Ge == "number" && Ke) {
      var Qe = ue, tt = Ke.length, lt = tt - 1;
      if (!tt) {
        Ye(0, null);
        return;
      }
      for (var ht = 0; ht < tt; ht += 1) {
        var bt = jt(ht);
        if (_ && (bt = bt || 0), bt === void 0) {
          Ye(ht - 1, void 0, !0);
          break;
        }
        if (Qe += bt, // Only one means `totalWidth` is the final width
        lt === 0 && Qe <= A || // Last two width will be the final width
        ht === lt - 1 && Qe + jt(lt) <= A) {
          Ye(lt, null);
          break;
        } else if (Qe + Ge > A) {
          Ye(ht - 1, Qe - bt - ue + oe);
          break;
        }
      }
      C && jt(0) + ue > A && ge(null);
    }
  }, [A, D, oe, ue, Je, Ke]);
  var Rt = Ce && !!et.length, Le = {};
  ce !== null && qe && (Le = {
    position: "absolute",
    left: ce,
    top: 0
  });
  var Ve = {
    prefixCls: Ee,
    responsive: qe,
    component: E,
    invalidate: ze
  }, Ae = s ? function(Qe, tt) {
    var lt = Je(Qe, tt);
    return /* @__PURE__ */ c.createElement(Ih.Provider, {
      key: lt,
      value: J(J({}, Ve), {}, {
        order: tt,
        item: Qe,
        itemKey: lt,
        registerSize: dt,
        display: tt <= we
      })
    }, s(Qe, tt));
  } : function(Qe, tt) {
    var lt = Je(Qe, tt);
    return /* @__PURE__ */ c.createElement(ad, Oe({}, Ve, {
      order: tt,
      key: lt,
      item: Qe,
      renderItem: Et,
      itemKey: lt,
      registerSize: dt,
      display: tt <= we
    }));
  }, ft, He = {
    order: Rt ? we : Number.MAX_SAFE_INTEGER,
    className: "".concat(Ee, "-rest"),
    registerSize: Ct,
    display: Rt
  };
  if (v)
    v && (ft = /* @__PURE__ */ c.createElement(Ih.Provider, {
      value: J(J({}, Ve), He)
    }, v(et)));
  else {
    var Fe = m || NK;
    ft = /* @__PURE__ */ c.createElement(ad, Oe({}, Ve, He), typeof Fe == "function" ? Fe(et) : Fe);
  }
  var yt = /* @__PURE__ */ c.createElement(S, Oe({
    className: se(!ze && r, y),
    style: h,
    ref: t
  }, $), Ke.map(Ae), pt ? ft : null, C && /* @__PURE__ */ c.createElement(ad, Oe({}, Ve, {
    responsive: ke,
    responsiveDisabled: !qe,
    order: we,
    className: "".concat(Ee, "-suffix"),
    registerSize: ot,
    display: !0,
    style: Le
  }), C));
  return ke && (yt = /* @__PURE__ */ c.createElement(zo, {
    onResize: wt,
    disabled: !qe
  }, yt)), yt;
}
var la = /* @__PURE__ */ c.forwardRef(PK);
la.displayName = "Overflow";
la.Item = r6;
la.RESPONSIVE = o6;
la.INVALIDATE = i6;
var IK = function(t, n) {
  var r, o = t.prefixCls, i = t.id, a = t.inputElement, s = t.disabled, l = t.tabIndex, u = t.autoFocus, f = t.autoComplete, p = t.editable, h = t.activeDescendantId, y = t.value, b = t.maxLength, m = t.onKeyDown, v = t.onMouseDown, C = t.onChange, x = t.onPaste, S = t.onCompositionStart, E = t.onCompositionEnd, O = t.open, $ = t.attrs, _ = a || /* @__PURE__ */ c.createElement("input", null), R = _, P = R.ref, I = R.props, j = I.onKeyDown, F = I.onChange, A = I.onMouseDown, M = I.onCompositionStart, N = I.onCompositionEnd, D = I.style;
  return pl(!("maxLength" in _.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), _ = /* @__PURE__ */ c.cloneElement(_, J(J(J({
    type: "search"
  }, I), {}, {
    // Override over origin props
    id: i,
    ref: Do(n, P),
    disabled: s,
    tabIndex: l,
    autoComplete: f || "off",
    autoFocus: u,
    className: se("".concat(o, "-selection-search-input"), (r = _) === null || r === void 0 || (r = r.props) === null || r === void 0 ? void 0 : r.className),
    role: "combobox",
    "aria-expanded": O || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(i, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(i, "_list"),
    "aria-activedescendant": O ? h : void 0
  }, $), {}, {
    value: p ? y : "",
    maxLength: b,
    readOnly: !p,
    unselectable: p ? null : "on",
    style: J(J({}, D), {}, {
      opacity: p ? null : 0
    }),
    onKeyDown: function(L) {
      m(L), j && j(L);
    },
    onMouseDown: function(L) {
      v(L), A && A(L);
    },
    onChange: function(L) {
      C(L), F && F(L);
    },
    onCompositionStart: function(L) {
      S(L), M && M(L);
    },
    onCompositionEnd: function(L) {
      E(L), N && N(L);
    },
    onPaste: x
  })), _;
}, Ib = /* @__PURE__ */ c.forwardRef(IK);
process.env.NODE_ENV !== "production" && (Ib.displayName = "Input");
function Rb(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var RK = typeof window != "undefined" && window.document && window.document.documentElement, DK = process.env.NODE_ENV !== "test" && RK;
function TK(e) {
  return e != null;
}
function MK(e) {
  return !e && e !== 0;
}
function Aw(e) {
  return ["string", "number"].includes(Vt(e));
}
function a6(e) {
  var t = void 0;
  return e && (Aw(e.title) ? t = e.title.toString() : Aw(e.label) && (t = e.label.toString())), t;
}
function LK(e, t) {
  DK ? c.useLayoutEffect(e, t) : c.useEffect(e, t);
}
function AK(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var jw = function(t) {
  t.preventDefault(), t.stopPropagation();
}, jK = function(t) {
  var n = t.id, r = t.prefixCls, o = t.values, i = t.open, a = t.searchValue, s = t.autoClearSearchValue, l = t.inputRef, u = t.placeholder, f = t.disabled, p = t.mode, h = t.showSearch, y = t.autoFocus, b = t.autoComplete, m = t.activeDescendantId, v = t.tabIndex, C = t.removeIcon, x = t.maxTagCount, S = t.maxTagTextLength, E = t.maxTagPlaceholder, O = E === void 0 ? function(ge) {
    return "+ ".concat(ge.length, " ...");
  } : E, $ = t.tagRender, _ = t.onToggleOpen, R = t.onRemove, P = t.onInputChange, I = t.onInputPaste, j = t.onInputKeyDown, F = t.onInputMouseDown, A = t.onInputCompositionStart, M = t.onInputCompositionEnd, N = c.useRef(null), D = Ot(0), T = de(D, 2), L = T[0], z = T[1], H = Ot(!1), V = de(H, 2), Y = V[0], Z = V[1], oe = "".concat(r, "-selection"), ee = i || p === "multiple" && s === !1 || p === "tags" ? a : "", ae = p === "tags" || p === "multiple" && s === !1 || h && (i || Y);
  LK(function() {
    z(N.current.scrollWidth);
  }, [ee]);
  var le = function(G, ne, fe, ye, we) {
    return /* @__PURE__ */ c.createElement("span", {
      title: a6(G),
      className: se("".concat(oe, "-item"), K({}, "".concat(oe, "-item-disabled"), fe))
    }, /* @__PURE__ */ c.createElement("span", {
      className: "".concat(oe, "-item-content")
    }, ne), ye && /* @__PURE__ */ c.createElement(jg, {
      className: "".concat(oe, "-item-remove"),
      onMouseDown: jw,
      onClick: we,
      customizeIcon: C
    }, "×"));
  }, ue = function(G, ne, fe, ye, we) {
    var he = function(Ce) {
      jw(Ce), _(!i);
    };
    return /* @__PURE__ */ c.createElement("span", {
      onMouseDown: he
    }, $({
      label: ne,
      value: G,
      disabled: fe,
      closable: ye,
      onClose: we
    }));
  }, ie = function(G) {
    var ne = G.disabled, fe = G.label, ye = G.value, we = !f && !ne, he = fe;
    if (typeof S == "number" && (typeof fe == "string" || typeof fe == "number")) {
      var me = String(he);
      me.length > S && (he = "".concat(me.slice(0, S), "..."));
    }
    var Ce = function(Ee) {
      Ee && Ee.stopPropagation(), R(G);
    };
    return typeof $ == "function" ? ue(ye, he, ne, we, Ce) : le(G, he, ne, we, Ce);
  }, re = function(G) {
    var ne = typeof O == "function" ? O(G) : O;
    return le({
      title: ne
    }, ne, !1);
  }, Q = /* @__PURE__ */ c.createElement("div", {
    className: "".concat(oe, "-search"),
    style: {
      width: L
    },
    onFocus: function() {
      Z(!0);
    },
    onBlur: function() {
      Z(!1);
    }
  }, /* @__PURE__ */ c.createElement(Ib, {
    ref: l,
    open: i,
    prefixCls: r,
    id: n,
    inputElement: null,
    disabled: f,
    autoFocus: y,
    autoComplete: b,
    editable: ae,
    activeDescendantId: m,
    value: ee,
    onKeyDown: j,
    onMouseDown: F,
    onChange: P,
    onPaste: I,
    onCompositionStart: A,
    onCompositionEnd: M,
    tabIndex: v,
    attrs: ei(t, !0)
  }), /* @__PURE__ */ c.createElement("span", {
    ref: N,
    className: "".concat(oe, "-search-mirror"),
    "aria-hidden": !0
  }, ee, " ")), ce = /* @__PURE__ */ c.createElement(la, {
    prefixCls: "".concat(oe, "-overflow"),
    data: o,
    renderItem: ie,
    renderRest: re,
    suffix: Q,
    itemKey: AK,
    maxCount: x
  });
  return /* @__PURE__ */ c.createElement(c.Fragment, null, ce, !o.length && !ee && /* @__PURE__ */ c.createElement("span", {
    className: "".concat(oe, "-placeholder")
  }, u));
}, kK = function(t) {
  var n = t.inputElement, r = t.prefixCls, o = t.id, i = t.inputRef, a = t.disabled, s = t.autoFocus, l = t.autoComplete, u = t.activeDescendantId, f = t.mode, p = t.open, h = t.values, y = t.placeholder, b = t.tabIndex, m = t.showSearch, v = t.searchValue, C = t.activeValue, x = t.maxLength, S = t.onInputKeyDown, E = t.onInputMouseDown, O = t.onInputChange, $ = t.onInputPaste, _ = t.onInputCompositionStart, R = t.onInputCompositionEnd, P = t.title, I = c.useState(!1), j = de(I, 2), F = j[0], A = j[1], M = f === "combobox", N = M || m, D = h[0], T = v || "";
  M && C && !F && (T = C), c.useEffect(function() {
    M && A(!1);
  }, [M, C]);
  var L = f !== "combobox" && !p && !m ? !1 : !!T, z = P === void 0 ? a6(D) : P, H = c.useMemo(function() {
    return D ? null : /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-selection-placeholder"),
      style: L ? {
        visibility: "hidden"
      } : void 0
    }, y);
  }, [D, L, y, r]);
  return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("span", {
    className: "".concat(r, "-selection-search")
  }, /* @__PURE__ */ c.createElement(Ib, {
    ref: i,
    prefixCls: r,
    id: o,
    open: p,
    inputElement: n,
    disabled: a,
    autoFocus: s,
    autoComplete: l,
    editable: N,
    activeDescendantId: u,
    value: T,
    onKeyDown: S,
    onMouseDown: E,
    onChange: function(Y) {
      A(!0), O(Y);
    },
    onPaste: $,
    onCompositionStart: _,
    onCompositionEnd: R,
    tabIndex: b,
    attrs: ei(t, !0),
    maxLength: M ? x : void 0
  })), !M && D ? /* @__PURE__ */ c.createElement("span", {
    className: "".concat(r, "-selection-item"),
    title: z,
    style: L ? {
      visibility: "hidden"
    } : void 0
  }, D.label) : null, H);
};
function FK(e) {
  return ![
    // System function button
    Pe.ESC,
    Pe.SHIFT,
    Pe.BACKSPACE,
    Pe.TAB,
    Pe.WIN_KEY,
    Pe.ALT,
    Pe.META,
    Pe.WIN_KEY_RIGHT,
    Pe.CTRL,
    Pe.SEMICOLON,
    Pe.EQUALS,
    Pe.CAPS_LOCK,
    Pe.CONTEXT_MENU,
    // F1-F12
    Pe.F1,
    Pe.F2,
    Pe.F3,
    Pe.F4,
    Pe.F5,
    Pe.F6,
    Pe.F7,
    Pe.F8,
    Pe.F9,
    Pe.F10,
    Pe.F11,
    Pe.F12
  ].includes(e);
}
var BK = function(t, n) {
  var r = _t(null), o = _t(!1), i = t.prefixCls, a = t.open, s = t.mode, l = t.showSearch, u = t.tokenWithEnter, f = t.autoClearSearchValue, p = t.onSearch, h = t.onSearchSubmit, y = t.onToggleOpen, b = t.onInputKeyDown, m = t.domRef;
  c.useImperativeHandle(n, function() {
    return {
      focus: function() {
        r.current.focus();
      },
      blur: function() {
        r.current.blur();
      }
    };
  });
  var v = n6(0), C = de(v, 2), x = C[0], S = C[1], E = function(T) {
    var L = T.which;
    (L === Pe.UP || L === Pe.DOWN) && T.preventDefault(), b && b(T), L === Pe.ENTER && s === "tags" && !o.current && !a && (h == null || h(T.target.value)), FK(L) && y(!0);
  }, O = function() {
    S(!0);
  }, $ = _t(null), _ = function(T) {
    p(T, !0, o.current) !== !1 && y(!0);
  }, R = function() {
    o.current = !0;
  }, P = function(T) {
    o.current = !1, s !== "combobox" && _(T.target.value);
  }, I = function(T) {
    var L = T.target.value;
    if (u && $.current && /[\r\n]/.test($.current)) {
      var z = $.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      L = L.replace(z, $.current);
    }
    $.current = null, _(L);
  }, j = function(T) {
    var L = T.clipboardData, z = L == null ? void 0 : L.getData("text");
    $.current = z || "";
  }, F = function(T) {
    var L = T.target;
    if (L !== r.current) {
      var z = document.body.style.msTouchAction !== void 0;
      z ? setTimeout(function() {
        r.current.focus();
      }) : r.current.focus();
    }
  }, A = function(T) {
    var L = x();
    T.target !== r.current && !L && s !== "combobox" && T.preventDefault(), (s !== "combobox" && (!l || !L) || !a) && (a && f !== !1 && p("", !0, !1), y());
  }, M = {
    inputRef: r,
    onInputKeyDown: E,
    onInputMouseDown: O,
    onInputChange: I,
    onInputPaste: j,
    onInputCompositionStart: R,
    onInputCompositionEnd: P
  }, N = s === "multiple" || s === "tags" ? /* @__PURE__ */ c.createElement(jK, Oe({}, t, M)) : /* @__PURE__ */ c.createElement(kK, Oe({}, t, M));
  return /* @__PURE__ */ c.createElement("div", {
    ref: m,
    className: "".concat(i, "-selector"),
    onClick: F,
    onMouseDown: A
  }, N);
}, s6 = /* @__PURE__ */ c.forwardRef(BK);
process.env.NODE_ENV !== "production" && (s6.displayName = "Selector");
function HK(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, o = e.arrowPos, i = r || {}, a = i.className, s = i.content, l = o.x, u = l === void 0 ? 0 : l, f = o.y, p = f === void 0 ? 0 : f, h = c.useRef();
  if (!n || !n.points)
    return null;
  var y = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var b = n.points[0], m = n.points[1], v = b[0], C = b[1], x = m[0], S = m[1];
    v === x || !["t", "b"].includes(v) ? y.top = p : v === "t" ? y.top = 0 : y.bottom = 0, C === S || !["l", "r"].includes(C) ? y.left = u : C === "l" ? y.left = 0 : y.right = 0;
  }
  return /* @__PURE__ */ c.createElement("div", {
    ref: h,
    className: se("".concat(t, "-arrow"), a),
    style: y
  }, s);
}
function zK(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, o = e.mask, i = e.motion;
  return o ? /* @__PURE__ */ c.createElement(Bi, Oe({}, i, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ c.createElement("div", {
      style: {
        zIndex: r
      },
      className: se("".concat(t, "-mask"), s)
    });
  }) : null;
}
var l6 = /* @__PURE__ */ c.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (l6.displayName = "PopupContent");
var c6 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, o = e.prefixCls, i = e.style, a = e.target, s = e.onVisibleChanged, l = e.open, u = e.keepDom, f = e.fresh, p = e.onClick, h = e.mask, y = e.arrow, b = e.arrowPos, m = e.align, v = e.motion, C = e.maskMotion, x = e.forceRender, S = e.getPopupContainer, E = e.autoDestroy, O = e.portal, $ = e.zIndex, _ = e.onMouseEnter, R = e.onMouseLeave, P = e.onPointerEnter, I = e.ready, j = e.offsetX, F = e.offsetY, A = e.offsetR, M = e.offsetB, N = e.onAlign, D = e.onPrepare, T = e.stretch, L = e.targetWidth, z = e.targetHeight, H = typeof n == "function" ? n() : n, V = l || u, Y = (S == null ? void 0 : S.length) > 0, Z = c.useState(!S || !Y), oe = de(Z, 2), ee = oe[0], ae = oe[1];
  if (Nn(function() {
    !ee && Y && a && ae(!0);
  }, [ee, Y, a]), !ee)
    return null;
  var le = "auto", ue = {
    left: "-1000vw",
    top: "-1000vh",
    right: le,
    bottom: le
  };
  if (I || !l) {
    var ie, re = m.points, Q = m.dynamicInset || ((ie = m._experimental) === null || ie === void 0 ? void 0 : ie.dynamicInset), ce = Q && re[0][1] === "r", ge = Q && re[0][0] === "b";
    ce ? (ue.right = A, ue.left = le) : (ue.left = j, ue.right = le), ge ? (ue.bottom = M, ue.top = le) : (ue.top = F, ue.bottom = le);
  }
  var G = {};
  return T && (T.includes("height") && z ? G.height = z : T.includes("minHeight") && z && (G.minHeight = z), T.includes("width") && L ? G.width = L : T.includes("minWidth") && L && (G.minWidth = L)), l || (G.pointerEvents = "none"), /* @__PURE__ */ c.createElement(O, {
    open: x || V,
    getContainer: S && function() {
      return S(a);
    },
    autoDestroy: E
  }, /* @__PURE__ */ c.createElement(zK, {
    prefixCls: o,
    open: l,
    zIndex: $,
    mask: h,
    motion: C
  }), /* @__PURE__ */ c.createElement(zo, {
    onResize: N,
    disabled: !l
  }, function(ne) {
    return /* @__PURE__ */ c.createElement(Bi, Oe({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: x,
      leavedClassName: "".concat(o, "-hidden")
    }, v, {
      onAppearPrepare: D,
      onEnterPrepare: D,
      visible: l,
      onVisibleChanged: function(ye) {
        var we;
        v == null || (we = v.onVisibleChanged) === null || we === void 0 || we.call(v, ye), s(ye);
      }
    }), function(fe, ye) {
      var we = fe.className, he = fe.style, me = se(o, we, r);
      return /* @__PURE__ */ c.createElement("div", {
        ref: Do(ne, t, ye),
        className: me,
        style: J(J(J(J({
          "--arrow-x": "".concat(b.x || 0, "px"),
          "--arrow-y": "".concat(b.y || 0, "px")
        }, ue), G), he), {}, {
          boxSizing: "border-box",
          zIndex: $
        }, i),
        onMouseEnter: _,
        onMouseLeave: R,
        onPointerEnter: P,
        onClick: p
      }, y && /* @__PURE__ */ c.createElement(HK, {
        prefixCls: o,
        arrow: y,
        arrowPos: b,
        align: m
      }), /* @__PURE__ */ c.createElement(l6, {
        cache: !l && !f
      }, H));
    });
  }));
});
process.env.NODE_ENV !== "production" && (c6.displayName = "Popup");
var u6 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, o = ki(n), i = c.useCallback(function(s) {
    md(t, r ? r(s) : s);
  }, [r]), a = Ol(i, n.ref);
  return o ? /* @__PURE__ */ c.cloneElement(n, {
    ref: a
  }) : n;
});
process.env.NODE_ENV !== "production" && (u6.displayName = "TriggerWrapper");
var kw = /* @__PURE__ */ c.createContext(null);
function Fw(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function VK(e, t, n, r) {
  return c.useMemo(function() {
    var o = Fw(n != null ? n : t), i = Fw(r != null ? r : t), a = new Set(o), s = new Set(i);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
function WK() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function KK(e, t, n, r) {
  for (var o = n.points, i = Object.keys(e), a = 0; a < i.length; a += 1) {
    var s, l = i[a];
    if (WK((s = e[l]) === null || s === void 0 ? void 0 : s.points, o, r))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function Bw(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function Qd(e) {
  return e.ownerDocument.defaultView;
}
function B1(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var o = Qd(n).getComputedStyle(n), i = o.overflowX, a = o.overflowY, s = o.overflow;
    [i, a, s].some(function(l) {
      return r.includes(l);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function $d(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Hu(e) {
  return $d(parseFloat(e), 0);
}
function Hw(e, t) {
  var n = J({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var o = Qd(r).getComputedStyle(r), i = o.overflow, a = o.overflowClipMargin, s = o.borderTopWidth, l = o.borderBottomWidth, u = o.borderLeftWidth, f = o.borderRightWidth, p = r.getBoundingClientRect(), h = r.offsetHeight, y = r.clientHeight, b = r.offsetWidth, m = r.clientWidth, v = Hu(s), C = Hu(l), x = Hu(u), S = Hu(f), E = $d(Math.round(p.width / b * 1e3) / 1e3), O = $d(Math.round(p.height / h * 1e3) / 1e3), $ = (b - m - x - S) * E, _ = (h - y - v - C) * O, R = v * O, P = C * O, I = x * E, j = S * E, F = 0, A = 0;
      if (i === "clip") {
        var M = Hu(a);
        F = M * E, A = M * O;
      }
      var N = p.x + I - F, D = p.y + R - A, T = N + p.width + 2 * F - I - j - $, L = D + p.height + 2 * A - R - P - _;
      n.left = Math.max(n.left, N), n.top = Math.max(n.top, D), n.right = Math.min(n.right, T), n.bottom = Math.min(n.bottom, L);
    }
  }), n;
}
function zw(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function Vw(e, t) {
  var n = t || [], r = de(n, 2), o = r[0], i = r[1];
  return [zw(e.width, o), zw(e.height, i)];
}
function Ww() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function nc(e, t) {
  var n = t[0], r = t[1], o, i;
  return n === "t" ? i = e.y : n === "b" ? i = e.y + e.height : i = e.y + e.height / 2, r === "l" ? o = e.x : r === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: i
  };
}
function ls(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, o) {
    return o === t ? n[r] || "c" : r;
  }).join("");
}
function UK(e, t, n, r, o, i, a) {
  var s = c.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[r] || {}
  }), l = de(s, 2), u = l[0], f = l[1], p = c.useRef(0), h = c.useMemo(function() {
    return t ? B1(t) : [];
  }, [t]), y = c.useRef({}), b = function() {
    y.current = {};
  };
  e || b();
  var m = Ir(function() {
    if (t && n && e) {
      let tn = function(_r, Wr) {
        var jr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : me, ao = H.x + _r, To = H.y + Wr, Gi = ao + ie, pa = To + ue, ri = Math.max(ao, jr.left), Xa = Math.max(To, jr.top), Za = Math.min(Gi, jr.right), ha = Math.min(pa, jr.bottom);
        return Math.max(0, (Za - ri) * (ha - Xa));
      }, yr = function() {
        Se = H.y + Fe, Re = Se + ue, ut = H.x + He, $t = ut + ie;
      };
      var x, S, E = t, O = E.ownerDocument, $ = Qd(E), _ = $.getComputedStyle(E), R = _.width, P = _.height, I = _.position, j = E.style.left, F = E.style.top, A = E.style.right, M = E.style.bottom, N = E.style.overflow, D = J(J({}, o[r]), i), T = O.createElement("div");
      (x = E.parentElement) === null || x === void 0 || x.appendChild(T), T.style.left = "".concat(E.offsetLeft, "px"), T.style.top = "".concat(E.offsetTop, "px"), T.style.position = I, T.style.height = "".concat(E.offsetHeight, "px"), T.style.width = "".concat(E.offsetWidth, "px"), E.style.left = "0", E.style.top = "0", E.style.right = "auto", E.style.bottom = "auto", E.style.overflow = "hidden";
      var L;
      if (Array.isArray(n))
        L = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var z = n.getBoundingClientRect();
        L = {
          x: z.x,
          y: z.y,
          width: z.width,
          height: z.height
        };
      }
      var H = E.getBoundingClientRect(), V = O.documentElement, Y = V.clientWidth, Z = V.clientHeight, oe = V.scrollWidth, ee = V.scrollHeight, ae = V.scrollTop, le = V.scrollLeft, ue = H.height, ie = H.width, re = L.height, Q = L.width, ce = {
        left: 0,
        top: 0,
        right: Y,
        bottom: Z
      }, ge = {
        left: -le,
        top: -ae,
        right: oe - le,
        bottom: ee - ae
      }, G = D.htmlRegion, ne = "visible", fe = "visibleFirst";
      G !== "scroll" && G !== fe && (G = ne);
      var ye = G === fe, we = Hw(ge, h), he = Hw(ce, h), me = G === ne ? he : we, Ce = ye ? he : me;
      E.style.left = "auto", E.style.top = "auto", E.style.right = "0", E.style.bottom = "0";
      var Te = E.getBoundingClientRect();
      E.style.left = j, E.style.top = F, E.style.right = A, E.style.bottom = M, E.style.overflow = N, (S = E.parentElement) === null || S === void 0 || S.removeChild(T);
      var Ee = $d(Math.round(ie / parseFloat(R) * 1e3) / 1e3), Ge = $d(Math.round(ue / parseFloat(P) * 1e3) / 1e3);
      if (Ee === 0 || Ge === 0 || yh(n) && !Qc(n))
        return;
      var ke = D.offset, qe = D.targetOffset, ze = Vw(H, ke), pt = de(ze, 2), Ke = pt[0], et = pt[1], Je = Vw(L, qe), Et = de(Je, 2), Ye = Et[0], wt = Et[1];
      L.x -= Ye, L.y -= wt;
      var dt = D.points || [], Ct = de(dt, 2), ot = Ct[0], jt = Ct[1], Rt = Ww(jt), Le = Ww(ot), Ve = nc(L, Rt), Ae = nc(H, Le), ft = J({}, D), He = Ve.x - Ae.x + Ke, Fe = Ve.y - Ae.y + et, yt = tn(He, Fe), Qe = tn(He, Fe, he), tt = nc(L, ["t", "l"]), lt = nc(H, ["t", "l"]), ht = nc(L, ["b", "r"]), bt = nc(H, ["b", "r"]), ct = D.overflow || {}, xt = ct.adjustX, vt = ct.adjustY, _e = ct.shiftX, Ze = ct.shiftY, q = function(Wr) {
        return typeof Wr == "boolean" ? Wr : Wr >= 0;
      }, Se, Re, ut, $t;
      yr();
      var Ne = q(vt), Ie = Le[0] === Rt[0];
      if (Ne && Le[0] === "t" && (Re > Ce.bottom || y.current.bt)) {
        var De = Fe;
        Ie ? De -= ue - re : De = tt.y - bt.y - et;
        var Me = tn(He, De), Tt = tn(He, De, he);
        // Of course use larger one
        Me > yt || Me === yt && (!ye || // Choose recommend one
        Tt >= Qe) ? (y.current.bt = !0, Fe = De, et = -et, ft.points = [ls(Le, 0), ls(Rt, 0)]) : y.current.bt = !1;
      }
      if (Ne && Le[0] === "b" && (Se < Ce.top || y.current.tb)) {
        var Pt = Fe;
        Ie ? Pt += ue - re : Pt = ht.y - lt.y - et;
        var Ut = tn(He, Pt), Kt = tn(He, Pt, he);
        // Of course use larger one
        Ut > yt || Ut === yt && (!ye || // Choose recommend one
        Kt >= Qe) ? (y.current.tb = !0, Fe = Pt, et = -et, ft.points = [ls(Le, 0), ls(Rt, 0)]) : y.current.tb = !1;
      }
      var $n = q(xt), Jt = Le[1] === Rt[1];
      if ($n && Le[1] === "l" && ($t > Ce.right || y.current.rl)) {
        var On = He;
        Jt ? On -= ie - Q : On = tt.x - bt.x - Ke;
        var Jn = tn(On, Fe), er = tn(On, Fe, he);
        // Of course use larger one
        Jn > yt || Jn === yt && (!ye || // Choose recommend one
        er >= Qe) ? (y.current.rl = !0, He = On, Ke = -Ke, ft.points = [ls(Le, 1), ls(Rt, 1)]) : y.current.rl = !1;
      }
      if ($n && Le[1] === "r" && (ut < Ce.left || y.current.lr)) {
        var Xt = He;
        Jt ? Xt += ie - Q : Xt = ht.x - lt.x - Ke;
        var It = tn(Xt, Fe), St = tn(Xt, Fe, he);
        // Of course use larger one
        It > yt || It === yt && (!ye || // Choose recommend one
        St >= Qe) ? (y.current.lr = !0, He = Xt, Ke = -Ke, ft.points = [ls(Le, 1), ls(Rt, 1)]) : y.current.lr = !1;
      }
      yr();
      var Lt = _e === !0 ? 0 : _e;
      typeof Lt == "number" && (ut < he.left && (He -= ut - he.left - Ke, L.x + Q < he.left + Lt && (He += L.x - he.left + Q - Lt)), $t > he.right && (He -= $t - he.right - Ke, L.x > he.right - Lt && (He += L.x - he.right + Lt)));
      var ln = Ze === !0 ? 0 : Ze;
      typeof ln == "number" && (Se < he.top && (Fe -= Se - he.top - et, L.y + re < he.top + ln && (Fe += L.y - he.top + re - ln)), Re > he.bottom && (Fe -= Re - he.bottom - et, L.y > he.bottom - ln && (Fe += L.y - he.bottom + ln)));
      var lr = H.x + He, fr = lr + ie, Er = H.y + Fe, Qr = Er + ue, $r = L.x, Or = $r + Q, io = L.y, At = io + re, Nt = Math.max(lr, $r), Qt = Math.min(fr, Or), vn = (Nt + Qt) / 2, sn = vn - lr, Mn = Math.max(Er, io), Wn = Math.min(Qr, At), Dr = (Mn + Wn) / 2, Gt = Dr - Er;
      a == null || a(t, ft);
      var Zt = Te.right - H.x - (He + H.width), hn = Te.bottom - H.y - (Fe + H.height);
      f({
        ready: !0,
        offsetX: He / Ee,
        offsetY: Fe / Ge,
        offsetR: Zt / Ee,
        offsetB: hn / Ge,
        arrowX: sn / Ee,
        arrowY: Gt / Ge,
        scaleX: Ee,
        scaleY: Ge,
        align: ft
      });
    }
  }), v = function() {
    p.current += 1;
    var S = p.current;
    Promise.resolve().then(function() {
      p.current === S && m();
    });
  }, C = function() {
    f(function(S) {
      return J(J({}, S), {}, {
        ready: !1
      });
    });
  };
  return Nn(C, [r]), Nn(function() {
    e || C();
  }, [e]), [u.ready, u.offsetX, u.offsetY, u.offsetR, u.offsetB, u.arrowX, u.arrowY, u.scaleX, u.scaleY, u.align, v];
}
function GK(e, t, n, r, o) {
  Nn(function() {
    if (e && t && n) {
      let p = function() {
        r(), o();
      };
      var i = t, a = n, s = B1(i), l = B1(a), u = Qd(a), f = new Set([u].concat(We(s), We(l)));
      return f.forEach(function(h) {
        h.addEventListener("scroll", p, {
          passive: !0
        });
      }), u.addEventListener("resize", p, {
        passive: !0
      }), r(), function() {
        f.forEach(function(h) {
          h.removeEventListener("scroll", p), u.removeEventListener("resize", p);
        });
      };
    }
  }, [e, t, n]);
}
function qK(e, t, n, r, o, i, a, s) {
  var l = c.useRef(e), u = c.useRef(!1);
  l.current !== e && (u.current = !0, l.current = e), c.useEffect(function() {
    var f = Pn(function() {
      u.current = !1;
    });
    return function() {
      Pn.cancel(f);
    };
  }, [e]), c.useEffect(function() {
    if (t && r && (!o || i)) {
      var f = function() {
        var I = !1, j = function(M) {
          var N = M.target;
          I = a(N);
        }, F = function(M) {
          var N = M.target;
          !u.current && l.current && !I && !a(N) && s(!1);
        };
        return [j, F];
      }, p = f(), h = de(p, 2), y = h[0], b = h[1], m = f(), v = de(m, 2), C = v[0], x = v[1], S = Qd(r);
      S.addEventListener("mousedown", y, !0), S.addEventListener("click", b, !0), S.addEventListener("contextmenu", b, !0);
      var E = _h(n);
      if (E && (E.addEventListener("mousedown", C, !0), E.addEventListener("click", x, !0), E.addEventListener("contextmenu", x, !0)), process.env.NODE_ENV !== "production") {
        var O, $, _ = n == null || (O = n.getRootNode) === null || O === void 0 ? void 0 : O.call(n), R = ($ = r.getRootNode) === null || $ === void 0 ? void 0 : $.call(r);
        pl(_ === R, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        S.removeEventListener("mousedown", y, !0), S.removeEventListener("click", b, !0), S.removeEventListener("contextmenu", b, !0), E && (E.removeEventListener("mousedown", C, !0), E.removeEventListener("click", x, !0), E.removeEventListener("contextmenu", x, !0));
      };
    }
  }, [t, n, r, o, i]);
}
var YK = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function XK() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ig, t = /* @__PURE__ */ c.forwardRef(function(n, r) {
    var o = n.prefixCls, i = o === void 0 ? "rc-trigger-popup" : o, a = n.children, s = n.action, l = s === void 0 ? "hover" : s, u = n.showAction, f = n.hideAction, p = n.popupVisible, h = n.defaultPopupVisible, y = n.onPopupVisibleChange, b = n.afterPopupVisibleChange, m = n.mouseEnterDelay, v = n.mouseLeaveDelay, C = v === void 0 ? 0.1 : v, x = n.focusDelay, S = n.blurDelay, E = n.mask, O = n.maskClosable, $ = O === void 0 ? !0 : O, _ = n.getPopupContainer, R = n.forceRender, P = n.autoDestroy, I = n.destroyPopupOnHide, j = n.popup, F = n.popupClassName, A = n.popupStyle, M = n.popupPlacement, N = n.builtinPlacements, D = N === void 0 ? {} : N, T = n.popupAlign, L = n.zIndex, z = n.stretch, H = n.getPopupClassNameFromAlign, V = n.fresh, Y = n.alignPoint, Z = n.onPopupClick, oe = n.onPopupAlign, ee = n.arrow, ae = n.popupMotion, le = n.maskMotion, ue = n.popupTransitionName, ie = n.popupAnimation, re = n.maskTransitionName, Q = n.maskAnimation, ce = n.className, ge = n.getTriggerDOMNode, G = Yt(n, YK), ne = P || I || !1, fe = c.useState(!1), ye = de(fe, 2), we = ye[0], he = ye[1];
    Nn(function() {
      he(J5());
    }, []);
    var me = c.useRef({}), Ce = c.useContext(kw), Te = c.useMemo(function() {
      return {
        registerSubPopup: function(nn, nr) {
          me.current[nn] = nr, Ce == null || Ce.registerSubPopup(nn, nr);
        }
      };
    }, [Ce]), Ee = VV(), Ge = c.useState(null), ke = de(Ge, 2), qe = ke[0], ze = ke[1], pt = Ir(function(Wt) {
      yh(Wt) && qe !== Wt && ze(Wt), Ce == null || Ce.registerSubPopup(Ee, Wt);
    }), Ke = c.useState(null), et = de(Ke, 2), Je = et[0], Et = et[1], Ye = c.useRef(null), wt = Ir(function(Wt) {
      yh(Wt) && Je !== Wt && (Et(Wt), Ye.current = Wt);
    }), dt = c.Children.only(a), Ct = (dt == null ? void 0 : dt.props) || {}, ot = {}, jt = Ir(function(Wt) {
      var nn, nr, hr = Je;
      return (hr == null ? void 0 : hr.contains(Wt)) || ((nn = _h(hr)) === null || nn === void 0 ? void 0 : nn.host) === Wt || Wt === hr || (qe == null ? void 0 : qe.contains(Wt)) || ((nr = _h(qe)) === null || nr === void 0 ? void 0 : nr.host) === Wt || Wt === qe || Object.values(me.current).some(function(rr) {
        return (rr == null ? void 0 : rr.contains(Wt)) || Wt === rr;
      });
    }), Rt = Bw(i, ae, ie, ue), Le = Bw(i, le, Q, re), Ve = c.useState(h || !1), Ae = de(Ve, 2), ft = Ae[0], He = Ae[1], Fe = p != null ? p : ft, yt = Ir(function(Wt) {
      p === void 0 && He(Wt);
    });
    Nn(function() {
      He(p || !1);
    }, [p]);
    var Qe = c.useRef(Fe);
    Qe.current = Fe;
    var tt = c.useRef([]);
    tt.current = [];
    var lt = Ir(function(Wt) {
      var nn;
      yt(Wt), ((nn = tt.current[tt.current.length - 1]) !== null && nn !== void 0 ? nn : Fe) !== Wt && (tt.current.push(Wt), y == null || y(Wt));
    }), ht = c.useRef(), bt = function() {
      clearTimeout(ht.current);
    }, ct = function(nn) {
      var nr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      bt(), nr === 0 ? lt(nn) : ht.current = setTimeout(function() {
        lt(nn);
      }, nr * 1e3);
    };
    c.useEffect(function() {
      return bt;
    }, []);
    var xt = c.useState(!1), vt = de(xt, 2), _e = vt[0], Ze = vt[1];
    Nn(function(Wt) {
      (!Wt || Fe) && Ze(!0);
    }, [Fe]);
    var q = c.useState(null), Se = de(q, 2), Re = Se[0], ut = Se[1], $t = c.useState([0, 0]), Ne = de($t, 2), Ie = Ne[0], De = Ne[1], Me = function(nn) {
      De([nn.clientX, nn.clientY]);
    }, Tt = UK(Fe, qe, Y ? Ie : Je, M, D, T, oe), Pt = de(Tt, 11), Ut = Pt[0], Kt = Pt[1], $n = Pt[2], Jt = Pt[3], On = Pt[4], Jn = Pt[5], er = Pt[6], Xt = Pt[7], It = Pt[8], St = Pt[9], Lt = Pt[10], ln = VK(we, l, u, f), lr = de(ln, 2), fr = lr[0], Er = lr[1], Qr = fr.has("click"), $r = Er.has("click") || Er.has("contextMenu"), Or = Ir(function() {
      _e || Lt();
    }), io = function() {
      Qe.current && Y && $r && ct(!1);
    };
    GK(Fe, Je, qe, Or, io), Nn(function() {
      Or();
    }, [Ie, M]), Nn(function() {
      Fe && !(D != null && D[M]) && Or();
    }, [JSON.stringify(T)]);
    var At = c.useMemo(function() {
      var Wt = KK(D, i, St, Y);
      return se(Wt, H == null ? void 0 : H(St));
    }, [St, H, D, i, Y]);
    c.useImperativeHandle(r, function() {
      return {
        nativeElement: Ye.current,
        forceAlign: Or
      };
    });
    var Nt = c.useState(0), Qt = de(Nt, 2), vn = Qt[0], sn = Qt[1], Mn = c.useState(0), Wn = de(Mn, 2), Dr = Wn[0], Gt = Wn[1], Zt = function() {
      if (z && Je) {
        var nn = Je.getBoundingClientRect();
        sn(nn.width), Gt(nn.height);
      }
    }, hn = function() {
      Zt(), Or();
    }, tn = function(nn) {
      Ze(!1), Lt(), b == null || b(nn);
    }, yr = function() {
      return new Promise(function(nn) {
        Zt(), ut(function() {
          return nn;
        });
      });
    };
    Nn(function() {
      Re && (Lt(), Re(), ut(null));
    }, [Re]);
    function _r(Wt, nn, nr, hr) {
      ot[Wt] = function(rr) {
        var ga;
        hr == null || hr(rr), ct(nn, nr);
        for (var ks = arguments.length, Qa = new Array(ks > 1 ? ks - 1 : 0), Ja = 1; Ja < ks; Ja++)
          Qa[Ja - 1] = arguments[Ja];
        (ga = Ct[Wt]) === null || ga === void 0 || ga.call.apply(ga, [Ct, rr].concat(Qa));
      };
    }
    (Qr || $r) && (ot.onClick = function(Wt) {
      var nn;
      Qe.current && $r ? ct(!1) : !Qe.current && Qr && (Me(Wt), ct(!0));
      for (var nr = arguments.length, hr = new Array(nr > 1 ? nr - 1 : 0), rr = 1; rr < nr; rr++)
        hr[rr - 1] = arguments[rr];
      (nn = Ct.onClick) === null || nn === void 0 || nn.call.apply(nn, [Ct, Wt].concat(hr));
    }), qK(Fe, $r, Je, qe, E, $, jt, ct);
    var Wr = fr.has("hover"), jr = Er.has("hover"), ao, To;
    Wr && (_r("onMouseEnter", !0, m, function(Wt) {
      Me(Wt);
    }), _r("onPointerEnter", !0, m, function(Wt) {
      Me(Wt);
    }), ao = function(nn) {
      (Fe || _e) && qe !== null && qe !== void 0 && qe.contains(nn.target) && ct(!0, m);
    }, Y && (ot.onMouseMove = function(Wt) {
      var nn;
      (nn = Ct.onMouseMove) === null || nn === void 0 || nn.call(Ct, Wt);
    })), jr && (_r("onMouseLeave", !1, C), _r("onPointerLeave", !1, C), To = function() {
      ct(!1, C);
    }), fr.has("focus") && _r("onFocus", !0, x), Er.has("focus") && _r("onBlur", !1, S), fr.has("contextMenu") && (ot.onContextMenu = function(Wt) {
      var nn;
      Qe.current && Er.has("contextMenu") ? ct(!1) : (Me(Wt), ct(!0)), Wt.preventDefault();
      for (var nr = arguments.length, hr = new Array(nr > 1 ? nr - 1 : 0), rr = 1; rr < nr; rr++)
        hr[rr - 1] = arguments[rr];
      (nn = Ct.onContextMenu) === null || nn === void 0 || nn.call.apply(nn, [Ct, Wt].concat(hr));
    }), ce && (ot.className = se(Ct.className, ce));
    var Gi = J(J({}, Ct), ot), pa = {}, ri = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    ri.forEach(function(Wt) {
      G[Wt] && (pa[Wt] = function() {
        for (var nn, nr = arguments.length, hr = new Array(nr), rr = 0; rr < nr; rr++)
          hr[rr] = arguments[rr];
        (nn = Gi[Wt]) === null || nn === void 0 || nn.call.apply(nn, [Gi].concat(hr)), G[Wt].apply(G, hr);
      });
    });
    var Xa = /* @__PURE__ */ c.cloneElement(dt, J(J({}, Gi), pa)), Za = {
      x: Jn,
      y: er
    }, ha = ee ? J({}, ee !== !0 ? ee : {}) : null;
    return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(zo, {
      disabled: !Fe,
      ref: wt,
      onResize: hn
    }, /* @__PURE__ */ c.createElement(u6, {
      getTriggerDOMNode: ge
    }, Xa)), /* @__PURE__ */ c.createElement(kw.Provider, {
      value: Te
    }, /* @__PURE__ */ c.createElement(c6, {
      portal: e,
      ref: pt,
      prefixCls: i,
      popup: j,
      className: se(F, At),
      style: A,
      target: Je,
      onMouseEnter: ao,
      onMouseLeave: To,
      onPointerEnter: ao,
      zIndex: L,
      open: Fe,
      keepDom: _e,
      fresh: V,
      onClick: Z,
      mask: E,
      motion: Rt,
      maskMotion: Le,
      onVisibleChanged: tn,
      onPrepare: yr,
      forceRender: R,
      autoDestroy: ne,
      getPopupContainer: _,
      align: St,
      arrow: ha,
      arrowPos: Za,
      ready: Ut,
      offsetX: Kt,
      offsetY: $n,
      offsetR: Jt,
      offsetB: On,
      onAlign: Or,
      stretch: z,
      targetWidth: vn / Xt,
      targetHeight: Dr / It
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const Jd = XK(Ig);
var ZK = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], QK = function(t) {
  var n = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, JK = function(t, n) {
  var r = t.prefixCls;
  t.disabled;
  var o = t.visible, i = t.children, a = t.popupElement, s = t.animation, l = t.transitionName, u = t.dropdownStyle, f = t.dropdownClassName, p = t.direction, h = p === void 0 ? "ltr" : p, y = t.placement, b = t.builtinPlacements, m = t.dropdownMatchSelectWidth, v = t.dropdownRender, C = t.dropdownAlign, x = t.getPopupContainer, S = t.empty, E = t.getTriggerDOMNode, O = t.onPopupVisibleChange, $ = t.onPopupMouseEnter, _ = Yt(t, ZK), R = "".concat(r, "-dropdown"), P = a;
  v && (P = v(a));
  var I = c.useMemo(function() {
    return b || QK(m);
  }, [b, m]), j = s ? "".concat(R, "-").concat(s) : l, F = typeof m == "number", A = c.useMemo(function() {
    return F ? null : m === !1 ? "minWidth" : "width";
  }, [m, F]), M = u;
  F && (M = J(J({}, M), {}, {
    width: m
  }));
  var N = c.useRef(null);
  return c.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        return N.current;
      }
    };
  }), /* @__PURE__ */ c.createElement(Jd, Oe({}, _, {
    showAction: O ? ["click"] : [],
    hideAction: O ? ["click"] : [],
    popupPlacement: y || (h === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: I,
    prefixCls: R,
    popupTransitionName: j,
    popup: /* @__PURE__ */ c.createElement("div", {
      ref: N,
      onMouseEnter: $
    }, P),
    stretch: A,
    popupAlign: C,
    popupVisible: o,
    getPopupContainer: x,
    popupClassName: se(f, K({}, "".concat(R, "-empty"), S)),
    popupStyle: M,
    getTriggerDOMNode: E,
    onPopupVisibleChange: O
  }), i);
}, d6 = /* @__PURE__ */ c.forwardRef(JK);
process.env.NODE_ENV !== "production" && (d6.displayName = "SelectTrigger");
function Kw(e, t) {
  var n = e.key, r;
  return "value" in e && (r = e.value), n != null ? n : r !== void 0 ? r : "rc-index-key-".concat(t);
}
function f6(e, t) {
  var n = e || {}, r = n.label, o = n.value, i = n.options, a = n.groupLabel, s = r || (t ? "children" : "label");
  return {
    label: s,
    value: o || "value",
    options: i || "options",
    groupLabel: a || s
  };
}
function eU(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.fieldNames, r = t.childrenAsData, o = [], i = f6(n, !1), a = i.label, s = i.value, l = i.options, u = i.groupLabel;
  function f(p, h) {
    Array.isArray(p) && p.forEach(function(y) {
      if (h || !(l in y)) {
        var b = y[s];
        o.push({
          key: Kw(y, o.length),
          groupOption: h,
          data: y,
          label: y[a],
          value: b
        });
      } else {
        var m = y[u];
        m === void 0 && r && (m = y.label), o.push({
          key: Kw(y, o.length),
          group: !0,
          data: y,
          label: m
        }), f(y[l], !0);
      }
    });
  }
  return f(e, !1), o;
}
function H1(e) {
  var t = J({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return mt(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var tU = function(t, n, r) {
  if (!n || !n.length)
    return null;
  var o = !1, i = function s(l, u) {
    var f = bO(u), p = f[0], h = f.slice(1);
    if (!p)
      return [l];
    var y = l.split(p);
    return o = o || y.length > 1, y.reduce(function(b, m) {
      return [].concat(We(b), We(s(m, h)));
    }, []).filter(Boolean);
  }, a = i(t, n);
  return o ? typeof r != "undefined" ? a.slice(0, r) : a : null;
}, Db = /* @__PURE__ */ c.createContext(null), nU = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], rU = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], Rh = function(t) {
  return t === "tags" || t === "multiple";
}, Tb = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n, r, o = e.id, i = e.prefixCls, a = e.className, s = e.showSearch, l = e.tagRender, u = e.direction, f = e.omitDomProps, p = e.displayValues, h = e.onDisplayValuesChange, y = e.emptyOptions, b = e.notFoundContent, m = b === void 0 ? "Not Found" : b, v = e.onClear, C = e.mode, x = e.disabled, S = e.loading, E = e.getInputElement, O = e.getRawInputElement, $ = e.open, _ = e.defaultOpen, R = e.onDropdownVisibleChange, P = e.activeValue, I = e.onActiveValueChange, j = e.activeDescendantId, F = e.searchValue, A = e.autoClearSearchValue, M = e.onSearch, N = e.onSearchSplit, D = e.tokenSeparators, T = e.allowClear, L = e.suffixIcon, z = e.clearIcon, H = e.OptionList, V = e.animation, Y = e.transitionName, Z = e.dropdownStyle, oe = e.dropdownClassName, ee = e.dropdownMatchSelectWidth, ae = e.dropdownRender, le = e.dropdownAlign, ue = e.placement, ie = e.builtinPlacements, re = e.getPopupContainer, Q = e.showAction, ce = Q === void 0 ? [] : Q, ge = e.onFocus, G = e.onBlur, ne = e.onKeyUp, fe = e.onKeyDown, ye = e.onMouseDown, we = Yt(e, nU), he = Rh(C), me = (s !== void 0 ? s : he) || C === "combobox", Ce = J({}, we);
  rU.forEach(function(At) {
    delete Ce[At];
  }), f == null || f.forEach(function(At) {
    delete Ce[At];
  });
  var Te = c.useState(!1), Ee = de(Te, 2), Ge = Ee[0], ke = Ee[1];
  c.useEffect(function() {
    ke(J5());
  }, []);
  var qe = c.useRef(null), ze = c.useRef(null), pt = c.useRef(null), Ke = c.useRef(null), et = c.useRef(null), Je = c.useRef(!1), Et = vK(), Ye = de(Et, 3), wt = Ye[0], dt = Ye[1], Ct = Ye[2];
  c.useImperativeHandle(t, function() {
    var At, Nt;
    return {
      focus: (At = Ke.current) === null || At === void 0 ? void 0 : At.focus,
      blur: (Nt = Ke.current) === null || Nt === void 0 ? void 0 : Nt.blur,
      scrollTo: function(vn) {
        var sn;
        return (sn = et.current) === null || sn === void 0 ? void 0 : sn.scrollTo(vn);
      }
    };
  });
  var ot = c.useMemo(function() {
    var At;
    if (C !== "combobox")
      return F;
    var Nt = (At = p[0]) === null || At === void 0 ? void 0 : At.value;
    return typeof Nt == "string" || typeof Nt == "number" ? String(Nt) : "";
  }, [F, C, p]), jt = C === "combobox" && typeof E == "function" && E() || null, Rt = typeof O == "function" && O(), Le = Ol(ze, Rt == null || (n = Rt.props) === null || n === void 0 ? void 0 : n.ref), Ve = c.useState(!1), Ae = de(Ve, 2), ft = Ae[0], He = Ae[1];
  Nn(function() {
    He(!0);
  }, []);
  var Fe = Fn(!1, {
    defaultValue: _,
    value: $
  }), yt = de(Fe, 2), Qe = yt[0], tt = yt[1], lt = ft ? Qe : !1, ht = !m && y;
  (x || ht && lt && C === "combobox") && (lt = !1);
  var bt = ht ? !1 : lt, ct = c.useCallback(function(At) {
    var Nt = At !== void 0 ? At : !lt;
    x || (tt(Nt), lt !== Nt && (R == null || R(Nt)));
  }, [x, lt, tt, R]), xt = c.useMemo(function() {
    return (D || []).some(function(At) {
      return [`
`, `\r
`].includes(At);
    });
  }, [D]), vt = c.useContext(Db) || {}, _e = vt.maxCount, Ze = vt.rawValues, q = function(Nt, Qt, vn) {
    if (!((Ze == null ? void 0 : Ze.size) >= _e)) {
      var sn = !0, Mn = Nt;
      I == null || I(null);
      var Wn = tU(Nt, D, _e && _e - Ze.size), Dr = vn ? null : Wn;
      return C !== "combobox" && Dr && (Mn = "", N == null || N(Dr), ct(!1), sn = !1), M && ot !== Mn && M(Mn, {
        source: Qt ? "typing" : "effect"
      }), sn;
    }
  }, Se = function(Nt) {
    !Nt || !Nt.trim() || M(Nt, {
      source: "submit"
    });
  };
  c.useEffect(function() {
    !lt && !he && C !== "combobox" && q("", !1, !1);
  }, [lt]), c.useEffect(function() {
    Qe && x && tt(!1), x && !Je.current && dt(!1);
  }, [x]);
  var Re = n6(), ut = de(Re, 2), $t = ut[0], Ne = ut[1], Ie = function(Nt) {
    var Qt = $t(), vn = Nt.which;
    if (vn === Pe.ENTER && (C !== "combobox" && Nt.preventDefault(), lt || ct(!0)), Ne(!!ot), vn === Pe.BACKSPACE && !Qt && he && !ot && p.length) {
      for (var sn = We(p), Mn = null, Wn = sn.length - 1; Wn >= 0; Wn -= 1) {
        var Dr = sn[Wn];
        if (!Dr.disabled) {
          sn.splice(Wn, 1), Mn = Dr;
          break;
        }
      }
      Mn && h(sn, {
        type: "remove",
        values: [Mn]
      });
    }
    for (var Gt = arguments.length, Zt = new Array(Gt > 1 ? Gt - 1 : 0), hn = 1; hn < Gt; hn++)
      Zt[hn - 1] = arguments[hn];
    if (lt) {
      var tn;
      (tn = et.current) === null || tn === void 0 || tn.onKeyDown.apply(tn, [Nt].concat(Zt));
    }
    fe == null || fe.apply(void 0, [Nt].concat(Zt));
  }, De = function(Nt) {
    for (var Qt = arguments.length, vn = new Array(Qt > 1 ? Qt - 1 : 0), sn = 1; sn < Qt; sn++)
      vn[sn - 1] = arguments[sn];
    if (lt) {
      var Mn;
      (Mn = et.current) === null || Mn === void 0 || Mn.onKeyUp.apply(Mn, [Nt].concat(vn));
    }
    ne == null || ne.apply(void 0, [Nt].concat(vn));
  }, Me = function(Nt) {
    var Qt = p.filter(function(vn) {
      return vn !== Nt;
    });
    h(Qt, {
      type: "remove",
      values: [Nt]
    });
  }, Tt = c.useRef(!1), Pt = function() {
    dt(!0), x || (ge && !Tt.current && ge.apply(void 0, arguments), ce.includes("focus") && ct(!0)), Tt.current = !0;
  }, Ut = function() {
    Je.current = !0, dt(!1, function() {
      Tt.current = !1, Je.current = !1, ct(!1);
    }), !x && (ot && (C === "tags" ? M(ot, {
      source: "submit"
    }) : C === "multiple" && M("", {
      source: "blur"
    })), G && G.apply(void 0, arguments));
  }, Kt = [];
  c.useEffect(function() {
    return function() {
      Kt.forEach(function(At) {
        return clearTimeout(At);
      }), Kt.splice(0, Kt.length);
    };
  }, []);
  var $n = function(Nt) {
    var Qt, vn = Nt.target, sn = (Qt = pt.current) === null || Qt === void 0 ? void 0 : Qt.getPopupElement();
    if (sn && sn.contains(vn)) {
      var Mn = setTimeout(function() {
        var Zt = Kt.indexOf(Mn);
        if (Zt !== -1 && Kt.splice(Zt, 1), Ct(), !Ge && !sn.contains(document.activeElement)) {
          var hn;
          (hn = Ke.current) === null || hn === void 0 || hn.focus();
        }
      });
      Kt.push(Mn);
    }
    for (var Wn = arguments.length, Dr = new Array(Wn > 1 ? Wn - 1 : 0), Gt = 1; Gt < Wn; Gt++)
      Dr[Gt - 1] = arguments[Gt];
    ye == null || ye.apply(void 0, [Nt].concat(Dr));
  }, Jt = c.useState({}), On = de(Jt, 2), Jn = On[1];
  function er() {
    Jn({});
  }
  var Xt;
  Rt && (Xt = function(Nt) {
    ct(Nt);
  }), yK(function() {
    var At;
    return [qe.current, (At = pt.current) === null || At === void 0 ? void 0 : At.getPopupElement()];
  }, bt, ct, !!Rt);
  var It = c.useMemo(function() {
    return J(J({}, e), {}, {
      notFoundContent: m,
      open: lt,
      triggerOpen: bt,
      id: o,
      showSearch: me,
      multiple: he,
      toggleOpen: ct
    });
  }, [e, m, bt, lt, o, me, he, ct]), St = !!L || S, Lt;
  St && (Lt = /* @__PURE__ */ c.createElement(jg, {
    className: se("".concat(i, "-arrow"), K({}, "".concat(i, "-arrow-loading"), S)),
    customizeIcon: L,
    customizeIconProps: {
      loading: S,
      searchValue: ot,
      open: lt,
      focused: wt,
      showSearch: me
    }
  }));
  var ln = function() {
    var Nt;
    v == null || v(), (Nt = Ke.current) === null || Nt === void 0 || Nt.focus(), h([], {
      type: "clear",
      values: p
    }), q("", !1, !1);
  }, lr = mK(i, ln, p, T, z, x, ot, C), fr = lr.allowClear, Er = lr.clearIcon, Qr = /* @__PURE__ */ c.createElement(H, {
    ref: et
  }), $r = se(i, a, (r = {}, K(r, "".concat(i, "-focused"), wt), K(r, "".concat(i, "-multiple"), he), K(r, "".concat(i, "-single"), !he), K(r, "".concat(i, "-allow-clear"), T), K(r, "".concat(i, "-show-arrow"), St), K(r, "".concat(i, "-disabled"), x), K(r, "".concat(i, "-loading"), S), K(r, "".concat(i, "-open"), lt), K(r, "".concat(i, "-customize-input"), jt), K(r, "".concat(i, "-show-search"), me), r)), Or = /* @__PURE__ */ c.createElement(d6, {
    ref: pt,
    disabled: x,
    prefixCls: i,
    visible: bt,
    popupElement: Qr,
    animation: V,
    transitionName: Y,
    dropdownStyle: Z,
    dropdownClassName: oe,
    direction: u,
    dropdownMatchSelectWidth: ee,
    dropdownRender: ae,
    dropdownAlign: le,
    placement: ue,
    builtinPlacements: ie,
    getPopupContainer: re,
    empty: y,
    getTriggerDOMNode: function() {
      return ze.current;
    },
    onPopupVisibleChange: Xt,
    onPopupMouseEnter: er
  }, Rt ? /* @__PURE__ */ c.cloneElement(Rt, {
    ref: Le
  }) : /* @__PURE__ */ c.createElement(s6, Oe({}, e, {
    domRef: ze,
    prefixCls: i,
    inputElement: jt,
    ref: Ke,
    id: o,
    showSearch: me,
    autoClearSearchValue: A,
    mode: C,
    activeDescendantId: j,
    tagRender: l,
    values: p,
    open: lt,
    onToggleOpen: ct,
    activeValue: P,
    searchValue: ot,
    onSearch: q,
    onSearchSubmit: Se,
    onRemove: Me,
    tokenWithEnter: xt
  }))), io;
  return Rt ? io = Or : io = /* @__PURE__ */ c.createElement("div", Oe({
    className: $r
  }, Ce, {
    ref: qe,
    onMouseDown: $n,
    onKeyDown: Ie,
    onKeyUp: De,
    onFocus: Pt,
    onBlur: Ut
  }), wt && !lt && /* @__PURE__ */ c.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(p.map(function(At) {
    var Nt = At.label, Qt = At.value;
    return ["number", "string"].includes(Vt(Nt)) ? Nt : Qt;
  }).join(", "))), Or, Lt, fr && Er), /* @__PURE__ */ c.createElement(e6.Provider, {
    value: It
  }, io);
});
process.env.NODE_ENV !== "production" && (Tb.displayName = "BaseSelect");
var Mb = function() {
  return null;
};
Mb.isSelectOptGroup = !0;
var Lb = function() {
  return null;
};
Lb.isSelectOption = !0;
var p6 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.height, r = e.offsetY, o = e.offsetX, i = e.children, a = e.prefixCls, s = e.onInnerResize, l = e.innerProps, u = e.rtl, f = e.extra, p = {}, h = {
    display: "flex",
    flexDirection: "column"
  };
  return r !== void 0 && (p = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, h = J(J({}, h), {}, K(K(K(K(K({
    transform: "translateY(".concat(r, "px)")
  }, u ? "marginRight" : "marginLeft", -o), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ c.createElement("div", {
    style: p
  }, /* @__PURE__ */ c.createElement(zo, {
    onResize: function(b) {
      var m = b.offsetHeight;
      m && s && s();
    }
  }, /* @__PURE__ */ c.createElement("div", Oe({
    style: h,
    className: se(K({}, "".concat(a, "-holder-inner"), a)),
    ref: t
  }, l), i, f)));
});
p6.displayName = "Filler";
function Uw(e, t) {
  var n = "touches" in e ? e.touches[0] : e;
  return n[t ? "pageX" : "pageY"];
}
var z1 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.rtl, o = e.scrollOffset, i = e.scrollRange, a = e.onStartMove, s = e.onStopMove, l = e.onScroll, u = e.horizontal, f = e.spinSize, p = e.containerSize, h = e.style, y = e.thumbStyle, b = c.useState(!1), m = de(b, 2), v = m[0], C = m[1], x = c.useState(null), S = de(x, 2), E = S[0], O = S[1], $ = c.useState(null), _ = de($, 2), R = _[0], P = _[1], I = !r, j = c.useRef(), F = c.useRef(), A = c.useState(!1), M = de(A, 2), N = M[0], D = M[1], T = c.useRef(), L = function() {
    clearTimeout(T.current), D(!0), T.current = setTimeout(function() {
      D(!1);
    }, 3e3);
  }, z = i - p || 0, H = p - f || 0, V = c.useMemo(function() {
    if (o === 0 || z === 0)
      return 0;
    var re = o / z;
    return re * H;
  }, [o, z, H]), Y = function(Q) {
    Q.stopPropagation(), Q.preventDefault();
  }, Z = c.useRef({
    top: V,
    dragging: v,
    pageY: E,
    startTop: R
  });
  Z.current = {
    top: V,
    dragging: v,
    pageY: E,
    startTop: R
  };
  var oe = function(Q) {
    C(!0), O(Uw(Q, u)), P(Z.current.top), a(), Q.stopPropagation(), Q.preventDefault();
  };
  c.useEffect(function() {
    var re = function(G) {
      G.preventDefault();
    }, Q = j.current, ce = F.current;
    return Q.addEventListener("touchstart", re), ce.addEventListener("touchstart", oe), function() {
      Q.removeEventListener("touchstart", re), ce.removeEventListener("touchstart", oe);
    };
  }, []);
  var ee = c.useRef();
  ee.current = z;
  var ae = c.useRef();
  ae.current = H, c.useEffect(function() {
    if (v) {
      var re, Q = function(G) {
        var ne = Z.current, fe = ne.dragging, ye = ne.pageY, we = ne.startTop;
        if (Pn.cancel(re), fe) {
          var he = Uw(G, u) - ye, me = we;
          !I && u ? me -= he : me += he;
          var Ce = ee.current, Te = ae.current, Ee = Te ? me / Te : 0, Ge = Math.ceil(Ee * Ce);
          Ge = Math.max(Ge, 0), Ge = Math.min(Ge, Ce), re = Pn(function() {
            l(Ge, u);
          });
        }
      }, ce = function() {
        C(!1), s();
      };
      return window.addEventListener("mousemove", Q), window.addEventListener("touchmove", Q), window.addEventListener("mouseup", ce), window.addEventListener("touchend", ce), function() {
        window.removeEventListener("mousemove", Q), window.removeEventListener("touchmove", Q), window.removeEventListener("mouseup", ce), window.removeEventListener("touchend", ce), Pn.cancel(re);
      };
    }
  }, [v]), c.useEffect(function() {
    L();
  }, [o]), c.useImperativeHandle(t, function() {
    return {
      delayHidden: L
    };
  });
  var le = "".concat(n, "-scrollbar"), ue = {
    position: "absolute",
    visibility: N ? null : "hidden"
  }, ie = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return u ? (ue.height = 8, ue.left = 0, ue.right = 0, ue.bottom = 0, ie.height = "100%", ie.width = f, I ? ie.left = V : ie.right = V) : (ue.width = 8, ue.top = 0, ue.bottom = 0, I ? ue.right = 0 : ue.left = 0, ie.width = "100%", ie.height = f, ie.top = V), /* @__PURE__ */ c.createElement("div", {
    ref: j,
    className: se(le, K(K(K({}, "".concat(le, "-horizontal"), u), "".concat(le, "-vertical"), !u), "".concat(le, "-visible"), N)),
    style: J(J({}, ue), h),
    onMouseDown: Y,
    onMouseMove: L
  }, /* @__PURE__ */ c.createElement("div", {
    ref: F,
    className: se("".concat(le, "-thumb"), K({}, "".concat(le, "-thumb-moving"), v)),
    style: J(J({}, ie), y),
    onMouseDown: oe
  }));
});
process.env.NODE_ENV !== "production" && (z1.displayName = "ScrollBar");
function oU(e) {
  var t = e.children, n = e.setRef, r = c.useCallback(function(o) {
    n(o);
  }, []);
  return /* @__PURE__ */ c.cloneElement(t, {
    ref: r
  });
}
function iU(e, t, n, r, o, i, a) {
  var s = a.getKey;
  return e.slice(t, n + 1).map(function(l, u) {
    var f = t + u, p = i(l, f, {
      style: {
        width: r
      }
    }), h = s(l);
    return /* @__PURE__ */ c.createElement(oU, {
      key: h,
      setRef: function(b) {
        return o(l, b);
      }
    }, p);
  });
}
var aU = /* @__PURE__ */ function() {
  function e() {
    zr(this, e), K(this, "maps", void 0), K(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return Vr(e, [{
    key: "set",
    value: function(n, r) {
      this.maps[n] = r, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), e;
}();
function sU(e, t, n) {
  var r = c.useState(0), o = de(r, 2), i = o[0], a = o[1], s = _t(/* @__PURE__ */ new Map()), l = _t(new aU()), u = _t();
  function f() {
    Pn.cancel(u.current);
  }
  function p() {
    var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    f();
    var b = function() {
      s.current.forEach(function(v, C) {
        if (v && v.offsetParent) {
          var x = Ju(v), S = x.offsetHeight;
          l.current.get(C) !== S && l.current.set(C, x.offsetHeight);
        }
      }), a(function(v) {
        return v + 1;
      });
    };
    y ? b() : u.current = Pn(b);
  }
  function h(y, b) {
    var m = e(y), v = s.current.get(m);
    b ? (s.current.set(m, b), p()) : s.current.delete(m), !v != !b && (b ? t == null || t(y) : n == null || n(y));
  }
  return kt(function() {
    return f;
  }, []), [h, p, l.current, i];
}
var Gw = 10;
function lU(e, t, n, r, o, i, a, s) {
  var l = c.useRef(), u = c.useState(null), f = de(u, 2), p = f[0], h = f[1];
  return Nn(function() {
    if (p && p.times < Gw) {
      if (!e.current) {
        h(function(z) {
          return J({}, z);
        });
        return;
      }
      i();
      var y = p.targetAlign, b = p.originAlign, m = p.index, v = p.offset, C = e.current.clientHeight, x = !1, S = y, E = null;
      if (C) {
        for (var O = y || b, $ = 0, _ = 0, R = 0, P = Math.min(t.length - 1, m), I = 0; I <= P; I += 1) {
          var j = o(t[I]);
          _ = $;
          var F = n.get(j);
          R = _ + (F === void 0 ? r : F), $ = R;
        }
        for (var A = O === "top" ? v : C - v, M = P; M >= 0; M -= 1) {
          var N = o(t[M]), D = n.get(N);
          if (D === void 0) {
            x = !0;
            break;
          }
          if (A -= D, A <= 0)
            break;
        }
        switch (O) {
          case "top":
            E = _ - v;
            break;
          case "bottom":
            E = R - C + v;
            break;
          default: {
            var T = e.current.scrollTop, L = T + C;
            _ < T ? S = "top" : R > L && (S = "bottom");
          }
        }
        E !== null && a(E), E !== p.lastTop && (x = !0);
      }
      x && h(J(J({}, p), {}, {
        times: p.times + 1,
        targetAlign: S,
        lastTop: E
      }));
    } else
      process.env.NODE_ENV !== "production" && (p == null ? void 0 : p.times) === Gw && mt(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [p, e.current]), function(y) {
    if (y == null) {
      s();
      return;
    }
    if (Pn.cancel(l.current), typeof y == "number")
      a(y);
    else if (y && Vt(y) === "object") {
      var b, m = y.align;
      "index" in y ? b = y.index : b = t.findIndex(function(x) {
        return o(x) === y.key;
      });
      var v = y.offset, C = v === void 0 ? 0 : v;
      h({
        times: 0,
        index: b,
        offset: C,
        originAlign: m
      });
    }
  };
}
function cU(e, t, n) {
  var r = e.length, o = t.length, i, a;
  if (r === 0 && o === 0)
    return null;
  r < o ? (i = e, a = t) : (i = t, a = e);
  var s = {
    __EMPTY_ITEM__: !0
  };
  function l(b) {
    return b !== void 0 ? n(b) : s;
  }
  for (var u = null, f = Math.abs(r - o) !== 1, p = 0; p < a.length; p += 1) {
    var h = l(i[p]), y = l(a[p]);
    if (h !== y) {
      u = p, f = f || h !== l(a[p + 1]);
      break;
    }
  }
  return u === null ? null : {
    index: u,
    multiple: f
  };
}
function uU(e, t, n) {
  var r = c.useState(e), o = de(r, 2), i = o[0], a = o[1], s = c.useState(null), l = de(s, 2), u = l[0], f = l[1];
  return c.useEffect(function() {
    var p = cU(i || [], e || [], t);
    (p == null ? void 0 : p.index) !== void 0 && (n == null || n(p.index), f(e[p.index])), a(e);
  }, [e]), [u];
}
var qw = (typeof navigator == "undefined" ? "undefined" : Vt(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const h6 = function(e, t) {
  var n = _t(!1), r = _t(null);
  function o() {
    clearTimeout(r.current), n.current = !0, r.current = setTimeout(function() {
      n.current = !1;
    }, 50);
  }
  var i = _t({
    top: e,
    bottom: t
  });
  return i.current.top = e, i.current.bottom = t, function(a) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = (
      // Pass origin wheel when on the top
      a < 0 && i.current.top || // Pass origin wheel when on the bottom
      a > 0 && i.current.bottom
    );
    return s && l ? (clearTimeout(r.current), n.current = !1) : (!l || n.current) && o(), !n.current && l;
  };
};
function dU(e, t, n, r, o) {
  var i = _t(0), a = _t(null), s = _t(null), l = _t(!1), u = h6(t, n);
  function f(v, C) {
    Pn.cancel(a.current), i.current += C, s.current = C, !u(C) && (qw || v.preventDefault(), a.current = Pn(function() {
      var x = l.current ? 10 : 1;
      o(i.current * x), i.current = 0;
    }));
  }
  function p(v, C) {
    o(C, !0), qw || v.preventDefault();
  }
  var h = _t(null), y = _t(null);
  function b(v) {
    if (e) {
      Pn.cancel(y.current), y.current = Pn(function() {
        h.current = null;
      }, 2);
      var C = v.deltaX, x = v.deltaY, S = v.shiftKey, E = C, O = x;
      (h.current === "sx" || !h.current && S && x && !C) && (E = x, O = 0, h.current = "sx");
      var $ = Math.abs(E), _ = Math.abs(O);
      h.current === null && (h.current = r && $ > _ ? "x" : "y"), h.current === "y" ? f(v, O) : p(v, E);
    }
  }
  function m(v) {
    e && (l.current = v.detail === s.current);
  }
  return [b, m];
}
var fU = 14 / 15;
function pU(e, t, n) {
  var r = _t(!1), o = _t(0), i = _t(null), a = _t(null), s, l = function(h) {
    if (r.current) {
      var y = Math.ceil(h.touches[0].pageY), b = o.current - y;
      o.current = y, n(b) && h.preventDefault(), clearInterval(a.current), a.current = setInterval(function() {
        b *= fU, (!n(b, !0) || Math.abs(b) <= 0.1) && clearInterval(a.current);
      }, 16);
    }
  }, u = function() {
    r.current = !1, s();
  }, f = function(h) {
    s(), h.touches.length === 1 && !r.current && (r.current = !0, o.current = Math.ceil(h.touches[0].pageY), i.current = h.target, i.current.addEventListener("touchmove", l), i.current.addEventListener("touchend", u));
  };
  s = function() {
    i.current && (i.current.removeEventListener("touchmove", l), i.current.removeEventListener("touchend", u));
  }, Nn(function() {
    return e && t.current.addEventListener("touchstart", f), function() {
      var p;
      (p = t.current) === null || p === void 0 || p.removeEventListener("touchstart", f), s(), clearInterval(a.current);
    };
  }, [e]);
}
var hU = 20;
function Yw() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e / t * e;
  return isNaN(n) && (n = 0), n = Math.max(n, hU), Math.floor(n);
}
function gU(e, t, n, r) {
  var o = c.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, n.id, r]), i = de(o, 2), a = i[0], s = i[1], l = function(f) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : f, h = a.get(f), y = a.get(p);
    if (h === void 0 || y === void 0)
      for (var b = e.length, m = s.length; m < b; m += 1) {
        var v, C = e[m], x = t(C);
        a.set(x, m);
        var S = (v = n.get(x)) !== null && v !== void 0 ? v : r;
        if (s[m] = (s[m - 1] || 0) + S, x === f && (h = m), x === p && (y = m), h !== void 0 && y !== void 0)
          break;
      }
    return {
      top: s[h - 1] || 0,
      bottom: s[y]
    };
  };
  return l;
}
var mU = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], vU = [], yU = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function bU(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-virtual-list" : n, o = e.className, i = e.height, a = e.itemHeight, s = e.fullHeight, l = s === void 0 ? !0 : s, u = e.style, f = e.data, p = e.children, h = e.itemKey, y = e.virtual, b = e.direction, m = e.scrollWidth, v = e.component, C = v === void 0 ? "div" : v, x = e.onScroll, S = e.onVirtualScroll, E = e.onVisibleChange, O = e.innerProps, $ = e.extraRender, _ = e.styles, R = Yt(e, mU), P = !!(y !== !1 && i && a), I = P && f && (a * f.length > i || !!m), j = b === "rtl", F = se(r, K({}, "".concat(r, "-rtl"), j), o), A = f || vU, M = _t(), N = _t(), D = Ot(0), T = de(D, 2), L = T[0], z = T[1], H = Ot(0), V = de(H, 2), Y = V[0], Z = V[1], oe = Ot(!1), ee = de(oe, 2), ae = ee[0], le = ee[1], ue = function() {
    le(!0);
  }, ie = function() {
    le(!1);
  }, re = c.useCallback(function(Ne) {
    return typeof h == "function" ? h(Ne) : Ne == null ? void 0 : Ne[h];
  }, [h]), Q = {
    getKey: re
  };
  function ce(Ne) {
    z(function(Ie) {
      var De;
      typeof Ne == "function" ? De = Ne(Ie) : De = Ne;
      var Me = Le(De);
      return M.current.scrollTop = Me, Me;
    });
  }
  var ge = _t({
    start: 0,
    end: A.length
  }), G = _t(), ne = uU(A, re), fe = de(ne, 1), ye = fe[0];
  G.current = ye;
  var we = sU(re, null, null), he = de(we, 4), me = he[0], Ce = he[1], Te = he[2], Ee = he[3], Ge = c.useMemo(function() {
    if (!P)
      return {
        scrollHeight: void 0,
        start: 0,
        end: A.length - 1,
        offset: void 0
      };
    if (!I) {
      var Ne;
      return {
        scrollHeight: ((Ne = N.current) === null || Ne === void 0 ? void 0 : Ne.offsetHeight) || 0,
        start: 0,
        end: A.length - 1,
        offset: void 0
      };
    }
    for (var Ie = 0, De, Me, Tt, Pt = A.length, Ut = 0; Ut < Pt; Ut += 1) {
      var Kt = A[Ut], $n = re(Kt), Jt = Te.get($n), On = Ie + (Jt === void 0 ? a : Jt);
      On >= L && De === void 0 && (De = Ut, Me = Ie), On > L + i && Tt === void 0 && (Tt = Ut), Ie = On;
    }
    return De === void 0 && (De = 0, Me = 0, Tt = Math.ceil(i / a)), Tt === void 0 && (Tt = A.length - 1), Tt = Math.min(Tt + 1, A.length - 1), {
      scrollHeight: Ie,
      start: De,
      end: Tt,
      offset: Me
    };
  }, [I, P, L, A, Ee, i]), ke = Ge.scrollHeight, qe = Ge.start, ze = Ge.end, pt = Ge.offset;
  ge.current.start = qe, ge.current.end = ze;
  var Ke = c.useState({
    width: 0,
    height: i
  }), et = de(Ke, 2), Je = et[0], Et = et[1], Ye = function(Ie) {
    Et({
      width: Ie.width || Ie.offsetWidth,
      height: Ie.height || Ie.offsetHeight
    });
  }, wt = _t(), dt = _t(), Ct = c.useMemo(function() {
    return Yw(Je.width, m);
  }, [Je.width, m]), ot = c.useMemo(function() {
    return Yw(Je.height, ke);
  }, [Je.height, ke]), jt = ke - i, Rt = _t(jt);
  Rt.current = jt;
  function Le(Ne) {
    var Ie = Ne;
    return Number.isNaN(Rt.current) || (Ie = Math.min(Ie, Rt.current)), Ie = Math.max(Ie, 0), Ie;
  }
  var Ve = L <= 0, Ae = L >= jt, ft = h6(Ve, Ae), He = function() {
    return {
      x: j ? -Y : Y,
      y: L
    };
  }, Fe = _t(He()), yt = Ir(function() {
    if (S) {
      var Ne = He();
      (Fe.current.x !== Ne.x || Fe.current.y !== Ne.y) && (S(Ne), Fe.current = Ne);
    }
  });
  function Qe(Ne, Ie) {
    var De = Ne;
    Ie ? (k0(function() {
      Z(De);
    }), yt()) : ce(De);
  }
  function tt(Ne) {
    var Ie = Ne.currentTarget.scrollTop;
    Ie !== L && ce(Ie), x == null || x(Ne), yt();
  }
  var lt = function(Ie) {
    var De = Ie, Me = m - Je.width;
    return De = Math.max(De, 0), De = Math.min(De, Me), De;
  }, ht = Ir(function(Ne, Ie) {
    Ie ? (k0(function() {
      Z(function(De) {
        var Me = De + (j ? -Ne : Ne);
        return lt(Me);
      });
    }), yt()) : ce(function(De) {
      var Me = De + Ne;
      return Me;
    });
  }), bt = dU(P, Ve, Ae, !!m, ht), ct = de(bt, 2), xt = ct[0], vt = ct[1];
  pU(P, M, function(Ne, Ie) {
    return ft(Ne, Ie) ? !1 : (xt({
      preventDefault: function() {
      },
      deltaY: Ne
    }), !0);
  }), Nn(function() {
    function Ne(De) {
      P && De.preventDefault();
    }
    var Ie = M.current;
    return Ie.addEventListener("wheel", xt), Ie.addEventListener("DOMMouseScroll", vt), Ie.addEventListener("MozMousePixelScroll", Ne), function() {
      Ie.removeEventListener("wheel", xt), Ie.removeEventListener("DOMMouseScroll", vt), Ie.removeEventListener("MozMousePixelScroll", Ne);
    };
  }, [P]), Nn(function() {
    m && Z(function(Ne) {
      return lt(Ne);
    });
  }, [Je.width, m]);
  var _e = function() {
    var Ie, De;
    (Ie = wt.current) === null || Ie === void 0 || Ie.delayHidden(), (De = dt.current) === null || De === void 0 || De.delayHidden();
  }, Ze = lU(M, A, Te, a, re, function() {
    return Ce(!0);
  }, ce, _e);
  c.useImperativeHandle(t, function() {
    return {
      getScrollInfo: He,
      scrollTo: function(Ie) {
        function De(Me) {
          return Me && Vt(Me) === "object" && ("left" in Me || "top" in Me);
        }
        De(Ie) ? (Ie.left !== void 0 && Z(lt(Ie.left)), Ze(Ie.top)) : Ze(Ie);
      }
    };
  }), Nn(function() {
    if (E) {
      var Ne = A.slice(qe, ze + 1);
      E(Ne, A);
    }
  }, [qe, ze, A]);
  var q = gU(A, re, Te, a), Se = $ == null ? void 0 : $({
    start: qe,
    end: ze,
    virtual: I,
    offsetX: Y,
    offsetY: pt,
    rtl: j,
    getSize: q
  }), Re = iU(A, qe, ze, m, me, p, Q), ut = null;
  i && (ut = J(K({}, l ? "height" : "maxHeight", i), yU), P && (ut.overflowY = "hidden", m && (ut.overflowX = "hidden"), ae && (ut.pointerEvents = "none")));
  var $t = {};
  return j && ($t.dir = "rtl"), /* @__PURE__ */ c.createElement("div", Oe({
    style: J(J({}, u), {}, {
      position: "relative"
    }),
    className: F
  }, $t, R), /* @__PURE__ */ c.createElement(zo, {
    onResize: Ye
  }, /* @__PURE__ */ c.createElement(C, {
    className: "".concat(r, "-holder"),
    style: ut,
    ref: M,
    onScroll: tt,
    onMouseEnter: _e
  }, /* @__PURE__ */ c.createElement(p6, {
    prefixCls: r,
    height: ke,
    offsetX: Y,
    offsetY: pt,
    scrollWidth: m,
    onInnerResize: Ce,
    ref: N,
    innerProps: O,
    rtl: j,
    extra: Se
  }, Re))), I && ke > i && /* @__PURE__ */ c.createElement(z1, {
    ref: wt,
    prefixCls: r,
    scrollOffset: L,
    scrollRange: ke,
    rtl: j,
    onScroll: Qe,
    onStartMove: ue,
    onStopMove: ie,
    spinSize: ot,
    containerSize: Je.height,
    style: _ == null ? void 0 : _.verticalScrollBar,
    thumbStyle: _ == null ? void 0 : _.verticalScrollBarThumb
  }), I && m > Je.width && /* @__PURE__ */ c.createElement(z1, {
    ref: dt,
    prefixCls: r,
    scrollOffset: Y,
    scrollRange: m,
    rtl: j,
    onScroll: Qe,
    onStartMove: ue,
    onStopMove: ie,
    spinSize: Ct,
    containerSize: Je.width,
    horizontal: !0,
    style: _ == null ? void 0 : _.horizontalScrollBar,
    thumbStyle: _ == null ? void 0 : _.horizontalScrollBarThumb
  }));
}
var kg = /* @__PURE__ */ c.forwardRef(bU);
kg.displayName = "List";
function CU() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var xU = ["disabled", "title", "children", "style", "className"];
function Xw(e) {
  return typeof e == "string" || typeof e == "number";
}
var SU = function(t, n) {
  var r = t6(), o = r.prefixCls, i = r.id, a = r.open, s = r.multiple, l = r.mode, u = r.searchValue, f = r.toggleOpen, p = r.notFoundContent, h = r.onPopupScroll, y = c.useContext(Db), b = y.maxCount, m = y.flattenOptions, v = y.onActiveValue, C = y.defaultActiveFirstOption, x = y.onSelect, S = y.menuItemSelectedIcon, E = y.rawValues, O = y.fieldNames, $ = y.virtual, _ = y.direction, R = y.listHeight, P = y.listItemHeight, I = y.optionRender, j = "".concat(o, "-item"), F = ua(function() {
    return m;
  }, [a, m], function(re, Q) {
    return Q[0] && re[1] !== Q[1];
  }), A = c.useRef(null), M = c.useMemo(function() {
    return s && typeof b != "undefined" && (E == null ? void 0 : E.size) >= b;
  }, [s, b, E == null ? void 0 : E.size]), N = function(Q) {
    Q.preventDefault();
  }, D = function(Q) {
    var ce;
    (ce = A.current) === null || ce === void 0 || ce.scrollTo(typeof Q == "number" ? {
      index: Q
    } : Q);
  }, T = function(Q) {
    for (var ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, ge = F.length, G = 0; G < ge; G += 1) {
      var ne = (Q + G * ce + ge) % ge, fe = F[ne] || {}, ye = fe.group, we = fe.data;
      if (!ye && !(we != null && we.disabled) && !M)
        return ne;
    }
    return -1;
  }, L = c.useState(function() {
    return T(0);
  }), z = de(L, 2), H = z[0], V = z[1], Y = function(Q) {
    var ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    V(Q);
    var ge = {
      source: ce ? "keyboard" : "mouse"
    }, G = F[Q];
    if (!G) {
      v(null, -1, ge);
      return;
    }
    v(G.value, Q, ge);
  };
  kt(function() {
    Y(C !== !1 ? T(0) : -1);
  }, [F.length, u]);
  var Z = c.useCallback(function(re) {
    return E.has(re) && l !== "combobox";
  }, [l, We(E).toString(), E.size]);
  kt(function() {
    var re = setTimeout(function() {
      if (!s && a && E.size === 1) {
        var ce = Array.from(E)[0], ge = F.findIndex(function(G) {
          var ne = G.data;
          return ne.value === ce;
        });
        ge !== -1 && (Y(ge), D(ge));
      }
    });
    if (a) {
      var Q;
      (Q = A.current) === null || Q === void 0 || Q.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(re);
    };
  }, [a, u]);
  var oe = function(Q) {
    Q !== void 0 && x(Q, {
      selected: !E.has(Q)
    }), s || f(!1);
  };
  if (c.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(Q) {
        var ce = Q.which, ge = Q.ctrlKey;
        switch (ce) {
          case Pe.N:
          case Pe.P:
          case Pe.UP:
          case Pe.DOWN: {
            var G = 0;
            if (ce === Pe.UP ? G = -1 : ce === Pe.DOWN ? G = 1 : CU() && ge && (ce === Pe.N ? G = 1 : ce === Pe.P && (G = -1)), G !== 0) {
              var ne = T(H + G, G);
              D(ne), Y(ne, !0);
            }
            break;
          }
          case Pe.ENTER: {
            var fe, ye = F[H];
            ye && !(ye != null && (fe = ye.data) !== null && fe !== void 0 && fe.disabled) && !M ? oe(ye.value) : oe(void 0), a && Q.preventDefault();
            break;
          }
          case Pe.ESC:
            f(!1), a && Q.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(Q) {
        D(Q);
      }
    };
  }), F.length === 0)
    return /* @__PURE__ */ c.createElement("div", {
      role: "listbox",
      id: "".concat(i, "_list"),
      className: "".concat(j, "-empty"),
      onMouseDown: N
    }, p);
  var ee = Object.keys(O).map(function(re) {
    return O[re];
  }), ae = function(Q) {
    return Q.label;
  };
  function le(re, Q) {
    var ce = re.group;
    return {
      role: ce ? "presentation" : "option",
      id: "".concat(i, "_list_").concat(Q)
    };
  }
  var ue = function(Q) {
    var ce = F[Q];
    if (!ce)
      return null;
    var ge = ce.data || {}, G = ge.value, ne = ce.group, fe = ei(ge, !0), ye = ae(ce);
    return ce ? /* @__PURE__ */ c.createElement("div", Oe({
      "aria-label": typeof ye == "string" && !ne ? ye : null
    }, fe, {
      key: Q
    }, le(ce, Q), {
      "aria-selected": Z(G)
    }), G) : null;
  }, ie = {
    role: "listbox",
    id: "".concat(i, "_list")
  };
  return /* @__PURE__ */ c.createElement(c.Fragment, null, $ && /* @__PURE__ */ c.createElement("div", Oe({}, ie, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), ue(H - 1), ue(H), ue(H + 1)), /* @__PURE__ */ c.createElement(kg, {
    itemKey: "key",
    ref: A,
    data: F,
    height: R,
    itemHeight: P,
    fullHeight: !1,
    onMouseDown: N,
    onScroll: h,
    virtual: $,
    direction: _,
    innerProps: $ ? null : ie
  }, function(re, Q) {
    var ce, ge = re.group, G = re.groupOption, ne = re.data, fe = re.label, ye = re.value, we = ne.key;
    if (ge) {
      var he, me = (he = ne.title) !== null && he !== void 0 ? he : Xw(fe) ? fe.toString() : void 0;
      return /* @__PURE__ */ c.createElement("div", {
        className: se(j, "".concat(j, "-group")),
        title: me
      }, fe !== void 0 ? fe : we);
    }
    var Ce = ne.disabled, Te = ne.title;
    ne.children;
    var Ee = ne.style, Ge = ne.className, ke = Yt(ne, xU), qe = dr(ke, ee), ze = Z(ye), pt = Ce || !ze && M, Ke = "".concat(j, "-option"), et = se(j, Ke, Ge, (ce = {}, K(ce, "".concat(Ke, "-grouped"), G), K(ce, "".concat(Ke, "-active"), H === Q && !pt), K(ce, "".concat(Ke, "-disabled"), pt), K(ce, "".concat(Ke, "-selected"), ze), ce)), Je = ae(re), Et = !S || typeof S == "function" || ze, Ye = typeof Je == "number" ? Je : Je || ye, wt = Xw(Ye) ? Ye.toString() : void 0;
    return Te !== void 0 && (wt = Te), /* @__PURE__ */ c.createElement("div", Oe({}, ei(qe), $ ? {} : le(re, Q), {
      "aria-selected": ze,
      className: et,
      title: wt,
      onMouseMove: function() {
        H === Q || pt || Y(Q);
      },
      onClick: function() {
        pt || oe(ye);
      },
      style: Ee
    }), /* @__PURE__ */ c.createElement("div", {
      className: "".concat(Ke, "-content")
    }, typeof I == "function" ? I(re, {
      index: Q
    }) : Ye), /* @__PURE__ */ c.isValidElement(S) || ze, Et && /* @__PURE__ */ c.createElement(jg, {
      className: "".concat(j, "-option-state"),
      customizeIcon: S,
      customizeIconProps: {
        value: ye,
        disabled: pt,
        isSelected: ze
      }
    }, ze ? "✓" : null));
  }));
}, g6 = /* @__PURE__ */ c.forwardRef(SU);
process.env.NODE_ENV !== "production" && (g6.displayName = "OptionList");
const wU = function(e, t) {
  var n = c.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), r = c.useMemo(function() {
    var i = n.current, a = i.values, s = i.options, l = e.map(function(p) {
      if (p.label === void 0) {
        var h;
        return J(J({}, p), {}, {
          label: (h = a.get(p.value)) === null || h === void 0 ? void 0 : h.label
        });
      }
      return p;
    }), u = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
    return l.forEach(function(p) {
      u.set(p.value, p), f.set(p.value, t.get(p.value) || s.get(p.value));
    }), n.current.values = u, n.current.options = f, l;
  }, [e, t]), o = c.useCallback(function(i) {
    return t.get(i) || n.current.options.get(i);
  }, [t]);
  return [r, o];
};
function Xv(e, t) {
  return Rb(e).join("").toUpperCase().includes(t);
}
const EU = function(e, t, n, r, o) {
  return c.useMemo(function() {
    if (!n || r === !1)
      return e;
    var i = t.options, a = t.label, s = t.value, l = [], u = typeof r == "function", f = n.toUpperCase(), p = u ? r : function(y, b) {
      return o ? Xv(b[o], f) : b[i] ? Xv(b[a !== "children" ? a : "label"], f) : Xv(b[s], f);
    }, h = u ? function(y) {
      return H1(y);
    } : function(y) {
      return y;
    };
    return e.forEach(function(y) {
      if (y[i]) {
        var b = p(n, h(y));
        if (b)
          l.push(y);
        else {
          var m = y[i].filter(function(v) {
            return p(n, h(v));
          });
          m.length && l.push(J(J({}, y), {}, K({}, i, m)));
        }
        return;
      }
      p(n, h(y)) && l.push(y);
    }), l;
  }, [e, r, o, n, t]);
};
var Zw = 0, $U = process.env.NODE_ENV !== "test" && Hr();
function OU() {
  var e;
  return $U ? (e = Zw, Zw += 1) : e = "TEST_OR_SSR", e;
}
function m6(e) {
  var t = c.useState(), n = de(t, 2), r = n[0], o = n[1];
  return c.useEffect(function() {
    o("rc_select_".concat(OU()));
  }, []), e || r;
}
var _U = ["children", "value"], NU = ["children"];
function PU(e) {
  var t = e, n = t.key, r = t.props, o = r.children, i = r.value, a = Yt(r, _U);
  return J({
    key: n,
    value: i !== void 0 ? i : n,
    children: o
  }, a);
}
function Ab(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return Rr(e).map(function(n, r) {
    if (!/* @__PURE__ */ c.isValidElement(n) || !n.type)
      return null;
    var o = n, i = o.type.isSelectOptGroup, a = o.key, s = o.props, l = s.children, u = Yt(s, NU);
    return t || !i ? PU(n) : J(J({
      key: "__RC_SELECT_GRP__".concat(a === null ? r : a, "__"),
      label: a
    }, u), {}, {
      options: Ab(l)
    });
  }).filter(function(n) {
    return n;
  });
}
var IU = function(t, n, r, o, i) {
  return c.useMemo(function() {
    var a = t, s = !t;
    s && (a = Ab(n));
    var l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), f = function(y, b, m) {
      m && typeof m == "string" && y.set(b[m], b);
    }, p = function h(y) {
      for (var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, m = 0; m < y.length; m += 1) {
        var v = y[m];
        !v[r.options] || b ? (l.set(v[r.value], v), f(u, v, r.label), f(u, v, o), f(u, v, i)) : h(v[r.options], !0);
      }
    };
    return p(a), {
      options: a,
      valueOptions: l,
      labelOptions: u
    };
  }, [t, n, r, o, i]);
};
function Qw(e) {
  var t = c.useRef();
  t.current = e;
  var n = c.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function RU(e) {
  var t = e.mode, n = e.options, r = e.children, o = e.backfill, i = e.allowClear, a = e.placeholder, s = e.getInputElement, l = e.showSearch, u = e.onSearch, f = e.defaultOpen, p = e.autoFocus, h = e.labelInValue, y = e.value, b = e.inputValue, m = e.optionLabelProp, v = Rh(t), C = l !== void 0 ? l : v || t === "combobox", x = n || Ab(r);
  if (mt(t !== "tags" || x.every(function($) {
    return !$.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var S = x.some(function($) {
      return $.options ? $.options.some(function(_) {
        return typeof ("value" in _ ? _.value : _.key) == "number";
      }) : typeof ("value" in $ ? $.value : $.key) == "number";
    });
    mt(!S, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (mt(t !== "combobox" || !m, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), mt(t === "combobox" || !o, "`backfill` only works with `combobox` mode."), mt(t === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), vh(t !== "combobox" || !s || !i || !a, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), u && !C && t !== "combobox" && t !== "tags" && mt(!1, "`onSearch` should work with `showSearch` instead of use alone."), vh(!f || p, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), y != null) {
    var E = Rb(y);
    mt(!h || E.every(function($) {
      return Vt($) === "object" && ("key" in $ || "value" in $);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), mt(!v || Array.isArray(y), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    var O = null;
    Rr(r).some(function($) {
      if (!/* @__PURE__ */ c.isValidElement($) || !$.type)
        return !1;
      var _ = $, R = _.type;
      if (R.isSelectOption)
        return !1;
      if (R.isSelectOptGroup) {
        var P = Rr($.props.children).every(function(I) {
          return !/* @__PURE__ */ c.isValidElement(I) || !$.type || I.type.isSelectOption ? !0 : (O = I.type, !1);
        });
        return !P;
      }
      return O = R, !0;
    }), O && mt(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(O.displayName || O.name || O, "`.")), mt(b === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function DU(e, t) {
  if (e) {
    var n = function r(o) {
      for (var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = 0; a < o.length; a++) {
        var s = o[a];
        if (s[t == null ? void 0 : t.value] === null)
          return mt(!1, "`value` in Select options should not be `null`."), !0;
        if (!i && Array.isArray(s[t == null ? void 0 : t.options]) && r(s[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    n(e);
  }
}
var TU = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], MU = ["inputValue"];
function LU(e) {
  return !e || Vt(e) !== "object";
}
var v6 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.id, r = e.mode, o = e.prefixCls, i = o === void 0 ? "rc-select" : o, a = e.backfill, s = e.fieldNames, l = e.inputValue, u = e.searchValue, f = e.onSearch, p = e.autoClearSearchValue, h = p === void 0 ? !0 : p, y = e.onSelect, b = e.onDeselect, m = e.dropdownMatchSelectWidth, v = m === void 0 ? !0 : m, C = e.filterOption, x = e.filterSort, S = e.optionFilterProp, E = e.optionLabelProp, O = e.options, $ = e.optionRender, _ = e.children, R = e.defaultActiveFirstOption, P = e.menuItemSelectedIcon, I = e.virtual, j = e.direction, F = e.listHeight, A = F === void 0 ? 200 : F, M = e.listItemHeight, N = M === void 0 ? 20 : M, D = e.value, T = e.defaultValue, L = e.labelInValue, z = e.onChange, H = e.maxCount, V = Yt(e, TU), Y = m6(n), Z = Rh(r), oe = !!(!O && _), ee = c.useMemo(function() {
    return C === void 0 && r === "combobox" ? !1 : C;
  }, [C, r]), ae = c.useMemo(
    function() {
      return f6(s, oe);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(s),
      oe
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), le = Fn("", {
    value: u !== void 0 ? u : l,
    postState: function(bt) {
      return bt || "";
    }
  }), ue = de(le, 2), ie = ue[0], re = ue[1], Q = IU(O, _, ae, S, E), ce = Q.valueOptions, ge = Q.labelOptions, G = Q.options, ne = c.useCallback(function(ht) {
    var bt = Rb(ht);
    return bt.map(function(ct) {
      var xt, vt, _e, Ze, q;
      if (LU(ct))
        xt = ct;
      else {
        var Se;
        _e = ct.key, vt = ct.label, xt = (Se = ct.value) !== null && Se !== void 0 ? Se : _e;
      }
      var Re = ce.get(xt);
      if (Re) {
        var ut;
        if (vt === void 0 && (vt = Re == null ? void 0 : Re[E || ae.label]), _e === void 0 && (_e = (ut = Re == null ? void 0 : Re.key) !== null && ut !== void 0 ? ut : xt), Ze = Re == null ? void 0 : Re.disabled, q = Re == null ? void 0 : Re.title, process.env.NODE_ENV !== "production" && !E) {
          var $t = Re == null ? void 0 : Re[ae.label];
          $t !== void 0 && !/* @__PURE__ */ c.isValidElement($t) && !/* @__PURE__ */ c.isValidElement(vt) && $t !== vt && mt(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: vt,
        value: xt,
        key: _e,
        disabled: Ze,
        title: q
      };
    });
  }, [ae, E, ce]), fe = Fn(T, {
    value: D
  }), ye = de(fe, 2), we = ye[0], he = ye[1], me = c.useMemo(function() {
    var ht, bt = Z && we === null ? [] : we, ct = ne(bt);
    return r === "combobox" && MK((ht = ct[0]) === null || ht === void 0 ? void 0 : ht.value) ? [] : ct;
  }, [we, ne, r, Z]), Ce = wU(me, ce), Te = de(Ce, 2), Ee = Te[0], Ge = Te[1], ke = c.useMemo(function() {
    if (!r && Ee.length === 1) {
      var ht = Ee[0];
      if (ht.value === null && (ht.label === null || ht.label === void 0))
        return [];
    }
    return Ee.map(function(bt) {
      var ct;
      return J(J({}, bt), {}, {
        label: (ct = bt.label) !== null && ct !== void 0 ? ct : bt.value
      });
    });
  }, [r, Ee]), qe = c.useMemo(function() {
    return new Set(Ee.map(function(ht) {
      return ht.value;
    }));
  }, [Ee]);
  c.useEffect(function() {
    if (r === "combobox") {
      var ht, bt = (ht = Ee[0]) === null || ht === void 0 ? void 0 : ht.value;
      re(TK(bt) ? String(bt) : "");
    }
  }, [Ee]);
  var ze = Qw(function(ht, bt) {
    var ct, xt = bt != null ? bt : ht;
    return ct = {}, K(ct, ae.value, ht), K(ct, ae.label, xt), ct;
  }), pt = c.useMemo(function() {
    if (r !== "tags")
      return G;
    var ht = We(G), bt = function(xt) {
      return ce.has(xt);
    };
    return We(Ee).sort(function(ct, xt) {
      return ct.value < xt.value ? -1 : 1;
    }).forEach(function(ct) {
      var xt = ct.value;
      bt(xt) || ht.push(ze(xt, ct.label));
    }), ht;
  }, [ze, G, ce, Ee, r]), Ke = EU(pt, ae, ie, ee, S), et = c.useMemo(function() {
    return r !== "tags" || !ie || Ke.some(function(ht) {
      return ht[S || "value"] === ie;
    }) || Ke.some(function(ht) {
      return ht[ae.value] === ie;
    }) ? Ke : [ze(ie)].concat(We(Ke));
  }, [ze, S, r, Ke, ie, ae]), Je = c.useMemo(function() {
    return x ? We(et).sort(function(ht, bt) {
      return x(ht, bt);
    }) : et;
  }, [et, x]), Et = c.useMemo(function() {
    return eU(Je, {
      fieldNames: ae,
      childrenAsData: oe
    });
  }, [Je, ae, oe]), Ye = function(bt) {
    var ct = ne(bt);
    if (he(ct), z && // Trigger event only when value changed
    (ct.length !== Ee.length || ct.some(function(_e, Ze) {
      var q;
      return ((q = Ee[Ze]) === null || q === void 0 ? void 0 : q.value) !== (_e == null ? void 0 : _e.value);
    }))) {
      var xt = L ? ct : ct.map(function(_e) {
        return _e.value;
      }), vt = ct.map(function(_e) {
        return H1(Ge(_e.value));
      });
      z(
        // Value
        Z ? xt : xt[0],
        // Option
        Z ? vt : vt[0]
      );
    }
  }, wt = c.useState(null), dt = de(wt, 2), Ct = dt[0], ot = dt[1], jt = c.useState(0), Rt = de(jt, 2), Le = Rt[0], Ve = Rt[1], Ae = R !== void 0 ? R : r !== "combobox", ft = c.useCallback(function(ht, bt) {
    var ct = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, xt = ct.source, vt = xt === void 0 ? "keyboard" : xt;
    Ve(bt), a && r === "combobox" && ht !== null && vt === "keyboard" && ot(String(ht));
  }, [a, r]), He = function(bt, ct, xt) {
    var vt = function() {
      var De, Me = Ge(bt);
      return [L ? {
        label: Me == null ? void 0 : Me[ae.label],
        value: bt,
        key: (De = Me == null ? void 0 : Me.key) !== null && De !== void 0 ? De : bt
      } : bt, H1(Me)];
    };
    if (ct && y) {
      var _e = vt(), Ze = de(_e, 2), q = Ze[0], Se = Ze[1];
      y(q, Se);
    } else if (!ct && b && xt !== "clear") {
      var Re = vt(), ut = de(Re, 2), $t = ut[0], Ne = ut[1];
      b($t, Ne);
    }
  }, Fe = Qw(function(ht, bt) {
    var ct, xt = Z ? bt.selected : !0;
    xt ? ct = Z ? [].concat(We(Ee), [ht]) : [ht] : ct = Ee.filter(function(vt) {
      return vt.value !== ht;
    }), Ye(ct), He(ht, xt), r === "combobox" ? ot("") : (!Rh || h) && (re(""), ot(""));
  }), yt = function(bt, ct) {
    Ye(bt);
    var xt = ct.type, vt = ct.values;
    (xt === "remove" || xt === "clear") && vt.forEach(function(_e) {
      He(_e.value, !1, xt);
    });
  }, Qe = function(bt, ct) {
    if (re(bt), ot(null), ct.source === "submit") {
      var xt = (bt || "").trim();
      if (xt) {
        var vt = Array.from(new Set([].concat(We(qe), [xt])));
        Ye(vt), He(xt, !0), re("");
      }
      return;
    }
    ct.source !== "blur" && (r === "combobox" && Ye(bt), f == null || f(bt));
  }, tt = function(bt) {
    var ct = bt;
    r !== "tags" && (ct = bt.map(function(vt) {
      var _e = ge.get(vt);
      return _e == null ? void 0 : _e.value;
    }).filter(function(vt) {
      return vt !== void 0;
    }));
    var xt = Array.from(new Set([].concat(We(qe), We(ct))));
    Ye(xt), xt.forEach(function(vt) {
      He(vt, !0);
    });
  }, lt = c.useMemo(function() {
    var ht = I !== !1 && v !== !1;
    return J(J({}, Q), {}, {
      flattenOptions: Et,
      onActiveValue: ft,
      defaultActiveFirstOption: Ae,
      onSelect: Fe,
      menuItemSelectedIcon: P,
      rawValues: qe,
      fieldNames: ae,
      virtual: ht,
      direction: j,
      listHeight: A,
      listItemHeight: N,
      childrenAsData: oe,
      maxCount: H,
      optionRender: $
    });
  }, [H, Q, Et, ft, Ae, Fe, P, qe, ae, I, v, j, A, N, oe, $]);
  return process.env.NODE_ENV !== "production" && (RU(e), DU(G, ae)), /* @__PURE__ */ c.createElement(Db.Provider, {
    value: lt
  }, /* @__PURE__ */ c.createElement(Tb, Oe({}, V, {
    // >>> MISC
    id: Y,
    prefixCls: i,
    ref: t,
    omitDomProps: MU,
    mode: r,
    displayValues: ke,
    onDisplayValuesChange: yt,
    direction: j,
    searchValue: ie,
    onSearch: Qe,
    autoClearSearchValue: h,
    onSearchSplit: tt,
    dropdownMatchSelectWidth: v,
    OptionList: g6,
    emptyOptions: !Et.length,
    activeValue: Ct,
    activeDescendantId: "".concat(Y, "_list_").concat(Le)
  })));
});
process.env.NODE_ENV !== "production" && (v6.displayName = "Select");
var jb = v6;
jb.Option = Lb;
jb.OptGroup = Mb;
function bl(e, t, n) {
  return se({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const eu = (e, t) => t || e, y6 = () => {
  const [, e] = ro(), n = new sr(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ c.createElement("svg", {
    style: n,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ c.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ c.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ c.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ c.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ c.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ c.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ c.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ c.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ c.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ c.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ c.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (y6.displayName = "EmptyImage");
const AU = y6, b6 = () => {
  const [, e] = ro(), {
    colorFill: t,
    colorFillTertiary: n,
    colorFillQuaternary: r,
    colorBgContainer: o
  } = e, {
    borderColor: i,
    shadowColor: a,
    contentColor: s
  } = mr(() => ({
    borderColor: new sr(t).onBackground(o).toHexShortString(),
    shadowColor: new sr(n).onBackground(o).toHexShortString(),
    contentColor: new sr(r).onBackground(o).toHexShortString()
  }), [t, n, r, o]);
  return /* @__PURE__ */ c.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ c.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ c.createElement("ellipse", {
    fill: a,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ c.createElement("g", {
    fillRule: "nonzero",
    stroke: i
  }, /* @__PURE__ */ c.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ c.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: s
  }))));
};
process.env.NODE_ENV !== "production" && (b6.displayName = "SimpleImage");
const jU = b6, kU = (e) => {
  const {
    componentCls: t,
    margin: n,
    marginXS: r,
    marginXL: o,
    fontSize: i,
    lineHeight: a
  } = e;
  return {
    [t]: {
      marginInline: r,
      fontSize: i,
      lineHeight: a,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: r,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorText
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${t}-footer`]: {
        marginTop: n
      },
      "&-normal": {
        marginBlock: o,
        color: e.colorTextDisabled,
        [`${t}-description`]: {
          color: e.colorTextDisabled
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: r,
        color: e.colorTextDisabled,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, FU = Gn("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    calc: r
  } = e, o = Sn(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: r(n).mul(2.5).equal(),
    emptyImgHeightMD: n,
    emptyImgHeightSM: r(n).mul(0.875).equal()
  });
  return [kU(o)];
});
var BU = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const C6 = /* @__PURE__ */ c.createElement(AU, null), x6 = /* @__PURE__ */ c.createElement(jU, null), Fg = (e) => {
  var {
    className: t,
    rootClassName: n,
    prefixCls: r,
    image: o = C6,
    description: i,
    children: a,
    imageStyle: s,
    style: l
  } = e, u = BU(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: f,
    direction: p,
    empty: h
  } = c.useContext(Ft), y = f("empty", r), [b, m, v] = FU(y), [C] = _l("Empty"), x = typeof i != "undefined" ? i : C == null ? void 0 : C.description, S = typeof x == "string" ? x : "empty";
  let E = null;
  return typeof o == "string" ? E = /* @__PURE__ */ c.createElement("img", {
    alt: S,
    src: o
  }) : E = o, b(/* @__PURE__ */ c.createElement("div", Object.assign({
    className: se(m, v, y, h == null ? void 0 : h.className, {
      [`${y}-normal`]: o === x6,
      [`${y}-rtl`]: p === "rtl"
    }, t, n),
    style: Object.assign(Object.assign({}, h == null ? void 0 : h.style), l)
  }, u), /* @__PURE__ */ c.createElement("div", {
    className: `${y}-image`,
    style: s
  }, E), x && /* @__PURE__ */ c.createElement("div", {
    className: `${y}-description`
  }, x), a && /* @__PURE__ */ c.createElement("div", {
    className: `${y}-footer`
  }, a)));
};
Fg.PRESENTED_IMAGE_DEFAULT = C6;
Fg.PRESENTED_IMAGE_SIMPLE = x6;
process.env.NODE_ENV !== "production" && (Fg.displayName = "Empty");
const Js = Fg, HU = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: n
  } = Cn(Ft), r = n("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ be.createElement(Js, {
        image: Js.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ be.createElement(Js, {
        image: Js.PRESENTED_IMAGE_SIMPLE,
        className: `${r}-small`
      });
    default:
      return /* @__PURE__ */ be.createElement(Js, null);
  }
}, kb = HU, zU = ["outlined", "borderless", "filled"], tu = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  const n = Cn(Q5);
  let r;
  typeof e != "undefined" ? r = e : t === !1 ? r = "borderless" : r = n != null ? n : "outlined";
  const o = zU.includes(r);
  return [r, o];
}, VU = (e) => {
  const n = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, n), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, n), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, n), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, n), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function S6(e, t) {
  return e || VU(t);
}
const Jw = (e) => {
  const {
    optionHeight: t,
    optionFontSize: n,
    optionLineHeight: r,
    optionPadding: o
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: o,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: n,
    lineHeight: r,
    boxSizing: "border-box"
  };
}, WU = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, r = `${n}-item`, o = `&${t}-slide-up-enter${t}-slide-up-enter-active`, i = `&${t}-slide-up-appear${t}-slide-up-appear-active`, a = `&${t}-slide-up-leave${t}-slide-up-leave-active`, s = `${n}-dropdown-placement-`;
  return [
    {
      [`${n}-dropdown`]: Object.assign(Object.assign({}, Qn(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${o}${s}bottomLeft,
          ${i}${s}bottomLeft
        `]: {
          animationName: Rg
        },
        [`
          ${o}${s}topLeft,
          ${i}${s}topLeft,
          ${o}${s}topRight,
          ${i}${s}topRight
        `]: {
          animationName: Tg
        },
        [`${a}${s}bottomLeft`]: {
          animationName: Dg
        },
        [`
          ${a}${s}topLeft,
          ${a}${s}topRight
        `]: {
          animationName: Mg
        },
        "&-hidden": {
          display: "none"
        },
        [`${r}`]: Object.assign(Object.assign({}, Jw(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, gl),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${r}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${r}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${r}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${r}-option-selected:not(${r}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${r}-option-selected:not(${r}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${r}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, Jw(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    _s(e, "slide-up"),
    _s(e, "slide-down"),
    Ac(e, "move-up"),
    Ac(e, "move-down")
  ];
}, rc = 2, KU = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: n,
    lineWidth: r
  } = e;
  return e.calc(n).sub(t).div(2).sub(r).equal();
};
function Zv(e, t) {
  const {
    componentCls: n,
    iconCls: r
  } = e, o = `${n}-selection-overflow`, i = e.multipleSelectItemHeight, a = KU(e), s = t ? `${n}-${t}` : "";
  return {
    [`${n}-multiple${s}`]: {
      fontSize: e.fontSize,
      /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */
      // =========================== Overflow ===========================
      [o]: {
        position: "relative",
        display: "flex",
        flex: "auto",
        flexWrap: "wrap",
        maxWidth: "100%",
        "&-item": {
          flex: "none",
          alignSelf: "center",
          maxWidth: "100%",
          display: "inline-flex"
        }
      },
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: e.calc(rc).mul(2).equal(),
        paddingBlock: e.calc(a).sub(rc).equal(),
        borderRadius: e.borderRadius,
        [`${n}-show-search&`]: {
          cursor: "text"
        },
        [`${n}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${te(rc)} 0`,
          lineHeight: te(i),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        height: i,
        marginTop: rc,
        marginBottom: rc,
        lineHeight: te(e.calc(i).sub(e.calc(e.lineWidth).mul(2)).equal()),
        borderRadius: e.borderRadiusSM,
        cursor: "default",
        transition: `font-size ${e.motionDurationSlow}, line-height ${e.motionDurationSlow}, height ${e.motionDurationSlow}`,
        marginInlineEnd: e.calc(rc).mul(2).equal(),
        paddingInlineStart: e.paddingXS,
        paddingInlineEnd: e.calc(e.paddingXS).div(2).equal(),
        [`${n}-disabled&`]: {
          color: e.multipleItemColorDisabled,
          borderColor: e.multipleItemBorderColorDisabled,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(e.paddingXS).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, Ud()), {
          display: "inline-flex",
          alignItems: "center",
          color: e.colorIcon,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${r}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: e.colorIconHover
          }
        })
      },
      // ========================== Input ==========================
      [`${o}-item + ${o}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${o}-item-suffix`]: {
        height: "100%"
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(a).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: i,
          fontFamily: e.fontFamily,
          lineHeight: te(i),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      }
    }
  };
}
const UU = (e) => {
  const {
    componentCls: t
  } = e, n = Sn(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.controlHeightXS,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), r = Sn(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    Zv(e),
    // ======================== Small ========================
    Zv(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    Zv(r, "lg")
  ];
};
function Qv(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: r,
    borderRadius: o
  } = e, i = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), a = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${a}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${n}-selector`]: Object.assign(Object.assign({}, Qn(e, !0)), {
        display: "flex",
        borderRadius: o,
        [`${n}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: r,
          insetInlineEnd: r,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: te(i),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${te(r)}`,
          [`${n}-selection-search-input`]: {
            height: i
          },
          "&:after": {
            lineHeight: te(i)
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${te(r)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function GU(e) {
  const {
    componentCls: t
  } = e, n = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    Qv(e),
    // ======================== Small ========================
    // Shared
    Qv(Sn(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selection-search`]: {
            insetInlineStart: n,
            insetInlineEnd: n
          },
          [`${t}-selector`]: {
            padding: `0 ${te(n)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(n).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    Qv(Sn(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const qU = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    controlHeight: r,
    controlPaddingHorizontal: o,
    zIndexPopupBase: i,
    colorText: a,
    fontWeightStrong: s,
    controlItemBgActive: l,
    controlItemBgHover: u,
    colorBgContainer: f,
    colorFillSecondary: p,
    controlHeightLG: h,
    controlHeightSM: y,
    colorBgContainerDisabled: b,
    colorTextDisabled: m
  } = e;
  return {
    zIndexPopup: i + 50,
    optionSelectedColor: a,
    optionSelectedFontWeight: s,
    optionSelectedBg: l,
    optionActiveBg: u,
    optionPadding: `${(r - t * n) / 2}px ${o}px`,
    optionFontSize: t,
    optionLineHeight: n,
    optionHeight: r,
    selectorBg: f,
    clearBg: f,
    singleItemHeightLG: h,
    multipleItemBg: p,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: y,
    multipleItemHeightLG: r,
    multipleSelectorBgDisabled: b,
    multipleItemColorDisabled: m,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25)
  };
}, w6 = (e, t) => {
  const {
    componentCls: n,
    antCls: r,
    controlOutlineWidth: o
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      border: `${te(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${n}-focused& ${n}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${te(o)} ${t.activeShadowColor}`,
        outline: 0
      }
    }
  };
}, eE = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, w6(e, t))
}), YU = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, w6(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.colorPrimaryHover,
    activeBorderColor: e.colorPrimary,
    activeShadowColor: e.controlOutline
  })), eE(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeShadowColor: e.colorErrorOutline
  })), eE(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeShadowColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${te(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), E6 = (e, t) => {
  const {
    componentCls: n,
    antCls: r
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      background: t.bg,
      border: `${te(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        background: t.hoverBg
      },
      [`${n}-focused& ${n}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, tE = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, E6(e, t))
}), XU = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, E6(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary,
    color: e.colorText
  })), tE(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), tE(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${te(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), ZU = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${te(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  }
}), QU = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, YU(e)), XU(e)), ZU(e))
}), JU = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, eG = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, tG = (e) => {
  const {
    antCls: t,
    componentCls: n,
    inputPaddingHorizontalBase: r,
    iconCls: o
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, Qn(e)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${n}-customize-input) ${n}-selector`]: Object.assign(Object.assign({}, JU(e)), eG(e)),
      // ======================== Selection ========================
      [`${n}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, gl), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: Object.assign(Object.assign({}, gl), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${n}-arrow`]: Object.assign(Object.assign({}, Ud()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [o]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${n}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${n}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${n}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      "&:hover": {
        [`${n}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
        [`${n}-arrow:not(:last-child)`]: {
          opacity: 0
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${n}-has-feedback`]: {
      [`${n}-clear`]: {
        insetInlineEnd: e.calc(r).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, nG = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    tG(e),
    // Single
    GU(e),
    // Multiple
    UU(e),
    // Dropdown
    WU(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    Ng(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, $6 = Gn("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = Sn(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [nG(r), QU(r)];
}, qU, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var rG = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const oG = rG;
var O6 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: oG
  }));
};
process.env.NODE_ENV !== "production" && (O6.displayName = "CheckOutlined");
const Bg = /* @__PURE__ */ c.forwardRef(O6);
var iG = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const aG = iG;
var _6 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: aG
  }));
};
process.env.NODE_ENV !== "production" && (_6.displayName = "DownOutlined");
const ef = /* @__PURE__ */ c.forwardRef(_6);
var sG = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const lG = sG;
var N6 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: lG
  }));
};
process.env.NODE_ENV !== "production" && (N6.displayName = "SearchOutlined");
const Hg = /* @__PURE__ */ c.forwardRef(N6);
function P6(e) {
  let {
    suffixIcon: t,
    clearIcon: n,
    menuItemSelectedIcon: r,
    removeIcon: o,
    loading: i,
    multiple: a,
    hasFeedback: s,
    prefixCls: l,
    showSuffixIcon: u,
    feedbackIcon: f,
    showArrow: p,
    componentName: h
  } = e;
  process.env.NODE_ENV !== "production" && xn(h).deprecated(!n, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const y = n != null ? n : /* @__PURE__ */ c.createElement(Ds, null), b = (x) => t === null && !s && !p ? null : /* @__PURE__ */ c.createElement(c.Fragment, null, u !== !1 && x, s && f);
  let m = null;
  if (t !== void 0)
    m = b(t);
  else if (i)
    m = b(/* @__PURE__ */ c.createElement(qd, {
      spin: !0
    }));
  else {
    const x = `${l}-suffix`;
    m = (S) => {
      let {
        open: E,
        showSearch: O
      } = S;
      return b(E && O ? /* @__PURE__ */ c.createElement(Hg, {
        className: x
      }) : /* @__PURE__ */ c.createElement(ef, {
        className: x
      }));
    };
  }
  let v = null;
  r !== void 0 ? v = r : a ? v = /* @__PURE__ */ c.createElement(Bg, null) : v = null;
  let C = null;
  return o !== void 0 ? C = o : C = /* @__PURE__ */ c.createElement(Gd, null), {
    clearIcon: y,
    suffixIcon: m,
    itemIcon: v,
    removeIcon: C
  };
}
function I6(e, t) {
  return t !== void 0 ? t : e !== null;
}
var cG = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const R6 = "SECRET_COMBOBOX_MODE_DO_NOT_USE", D6 = (e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o,
    className: i,
    rootClassName: a,
    getPopupContainer: s,
    popupClassName: l,
    dropdownClassName: u,
    listHeight: f = 256,
    placement: p,
    listItemHeight: h,
    size: y,
    disabled: b,
    notFoundContent: m,
    status: v,
    builtinPlacements: C,
    dropdownMatchSelectWidth: x,
    popupMatchSelectWidth: S,
    direction: E,
    style: O,
    allowClear: $,
    variant: _,
    dropdownStyle: R,
    transitionName: P,
    tagRender: I,
    maxCount: j
  } = e, F = cG(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount"]), {
    getPopupContainer: A,
    getPrefixCls: M,
    renderEmpty: N,
    direction: D,
    virtual: T,
    popupMatchSelectWidth: L,
    popupOverflow: z,
    select: H
  } = c.useContext(Ft), [, V] = ro(), Y = h != null ? h : V == null ? void 0 : V.controlHeight, Z = M("select", r), oe = M(), ee = E != null ? E : D, {
    compactSize: ae,
    compactItemClassnames: le
  } = Ms(Z, ee), [ue, ie] = tu(_, o), re = Ar(Z), [Q, ce, ge] = $6(Z, re), G = c.useMemo(() => {
    const {
      mode: ot
    } = e;
    if (ot !== "combobox")
      return ot === R6 ? "combobox" : ot;
  }, [e.mode]), ne = G === "multiple" || G === "tags", fe = I6(e.suffixIcon, e.showArrow), ye = (n = S != null ? S : x) !== null && n !== void 0 ? n : L, {
    status: we,
    hasFeedback: he,
    isFormItemInput: me,
    feedbackIcon: Ce
  } = c.useContext(uo), Te = eu(we, v);
  let Ee;
  m !== void 0 ? Ee = m : G === "combobox" ? Ee = null : Ee = (N == null ? void 0 : N("Select")) || /* @__PURE__ */ c.createElement(kb, {
    componentName: "Select"
  });
  const {
    suffixIcon: Ge,
    itemIcon: ke,
    removeIcon: qe,
    clearIcon: ze
  } = P6(Object.assign(Object.assign({}, F), {
    multiple: ne,
    hasFeedback: he,
    feedbackIcon: Ce,
    showSuffixIcon: fe,
    prefixCls: Z,
    componentName: "Select"
  })), pt = $ === !0 ? {
    clearIcon: ze
  } : $, Ke = dr(F, ["suffixIcon", "itemIcon"]), et = se(l || u, {
    [`${Z}-dropdown-${ee}`]: ee === "rtl"
  }, a, ge, re, ce), Je = Co((ot) => {
    var jt;
    return (jt = y != null ? y : ae) !== null && jt !== void 0 ? jt : ot;
  }), Et = c.useContext(Ki), Ye = b != null ? b : Et, wt = se({
    [`${Z}-lg`]: Je === "large",
    [`${Z}-sm`]: Je === "small",
    [`${Z}-rtl`]: ee === "rtl",
    [`${Z}-${ue}`]: ie,
    [`${Z}-in-form-item`]: me
  }, bl(Z, Te, he), le, H == null ? void 0 : H.className, i, a, ge, re, ce), dt = c.useMemo(() => p !== void 0 ? p : ee === "rtl" ? "bottomRight" : "bottomLeft", [p, ee]);
  if (process.env.NODE_ENV !== "production") {
    const ot = xn("Select");
    ot.deprecated(!u, "dropdownClassName", "popupClassName"), ot.deprecated(x === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && ot(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), ot.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && ot(!(typeof j != "undefined" && !ne), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [Ct] = Ts("SelectLike", R == null ? void 0 : R.zIndex);
  return Q(/* @__PURE__ */ c.createElement(jb, Object.assign({
    ref: t,
    virtual: T,
    showSearch: H == null ? void 0 : H.showSearch
  }, Ke, {
    style: Object.assign(Object.assign({}, H == null ? void 0 : H.style), O),
    dropdownMatchSelectWidth: ye,
    transitionName: ml(oe, "slide-up", P),
    builtinPlacements: S6(C, z),
    listHeight: f,
    listItemHeight: Y,
    mode: G,
    prefixCls: Z,
    placement: dt,
    direction: ee,
    suffixIcon: Ge,
    menuItemSelectedIcon: ke,
    removeIcon: qe,
    allowClear: pt,
    notFoundContent: Ee,
    className: wt,
    getPopupContainer: s || A,
    dropdownClassName: et,
    disabled: Ye,
    dropdownStyle: Object.assign(Object.assign({}, R), {
      zIndex: Ct
    }),
    maxCount: ne ? j : void 0,
    tagRender: ne ? I : void 0
  })));
};
process.env.NODE_ENV !== "production" && (D6.displayName = "Select");
const Il = /* @__PURE__ */ c.forwardRef(D6), uG = Zd(Il);
Il.SECRET_COMBOBOX_MODE_DO_NOT_USE = R6;
Il.Option = Lb;
Il.OptGroup = Mb;
Il._InternalPanelDoNotUseOrYouWillBeFired = uG;
process.env.NODE_ENV !== "production" && (Il.displayName = "Select");
const Ls = Il, jc = ["xxl", "xl", "lg", "md", "sm", "xs"], dG = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), fG = (e) => {
  const t = e, n = [].concat(jc).reverse();
  return n.forEach((r, o) => {
    const i = r.toUpperCase(), a = `screen${i}Min`, s = `screen${i}`;
    if (!(t[a] <= t[s]))
      throw new Error(`${a}<=${s} fails : !(${t[a]}<=${t[s]})`);
    if (o < n.length - 1) {
      const l = `screen${i}Max`;
      if (!(t[s] <= t[l]))
        throw new Error(`${s}<=${l} fails : !(${t[s]}<=${t[l]})`);
      const f = `screen${n[o + 1].toUpperCase()}Min`;
      if (!(t[l] <= t[f]))
        throw new Error(`${l}<=${f} fails : !(${t[l]}<=${t[f]})`);
    }
  }), e;
};
function T6() {
  const [, e] = ro(), t = dG(fG(e));
  return be.useMemo(() => {
    const n = /* @__PURE__ */ new Map();
    let r = -1, o = {};
    return {
      matchHandlers: {},
      dispatch(i) {
        return o = i, n.forEach((a) => a(o)), n.size >= 1;
      },
      subscribe(i) {
        return n.size || this.register(), r += 1, n.set(r, i), i(o), r;
      },
      unsubscribe(i) {
        n.delete(i), n.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((i) => {
          const a = t[i], s = this.matchHandlers[a];
          s == null || s.mql.removeListener(s == null ? void 0 : s.listener);
        }), n.clear();
      },
      register() {
        Object.keys(t).forEach((i) => {
          const a = t[i], s = (u) => {
            let {
              matches: f
            } = u;
            this.dispatch(Object.assign(Object.assign({}, o), {
              [i]: f
            }));
          }, l = window.matchMedia(a);
          l.addListener(s), this.matchHandlers[a] = {
            mql: l,
            listener: s
          }, s(l);
        });
      },
      responsiveMap: t
    };
  }, [e]);
}
function M6() {
  const [, e] = c.useReducer((t) => t + 1, 0);
  return e;
}
function zg() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const t = _t({}), n = M6(), r = T6();
  return Nn(() => {
    const o = r.subscribe((i) => {
      t.current = i, e && n();
    });
    return () => r.unsubscribe(o);
  }, []), t.current;
}
const pG = /* @__PURE__ */ c.createContext({}), V1 = pG, hG = (e) => {
  const {
    antCls: t,
    componentCls: n,
    iconCls: r,
    avatarBg: o,
    avatarColor: i,
    containerSize: a,
    containerSizeLG: s,
    containerSizeSM: l,
    textFontSize: u,
    textFontSizeLG: f,
    textFontSizeSM: p,
    borderRadius: h,
    borderRadiusLG: y,
    borderRadiusSM: b,
    lineWidth: m,
    lineType: v,
    calc: C
  } = e, x = (S, E, O) => ({
    width: S,
    height: S,
    lineHeight: te(C(S).sub(C(m).mul(2)).equal()),
    borderRadius: "50%",
    [`&${n}-square`]: {
      borderRadius: O
    },
    [`${n}-string`]: {
      position: "absolute",
      left: {
        _skip_check_: !0,
        value: "50%"
      },
      transformOrigin: "0 center"
    },
    [`&${n}-icon`]: {
      fontSize: E,
      [`> ${r}`]: {
        margin: 0
      }
    }
  });
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e)), {
      position: "relative",
      display: "inline-block",
      overflow: "hidden",
      color: i,
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "middle",
      background: o,
      border: `${te(m)} ${v} transparent`,
      "&-image": {
        background: "transparent"
      },
      [`${t}-image-img`]: {
        display: "block"
      }
    }), x(a, u, h)), {
      "&-lg": Object.assign({}, x(s, f, y)),
      "&-sm": Object.assign({}, x(l, p, b)),
      "> img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    })
  };
}, gG = (e) => {
  const {
    componentCls: t,
    groupBorderColor: n,
    groupOverlapping: r,
    groupSpace: o
  } = e;
  return {
    [`${t}-group`]: {
      display: "inline-flex",
      [`${t}`]: {
        borderColor: n
      },
      "> *:not(:first-child)": {
        marginInlineStart: r
      }
    },
    [`${t}-group-popover`]: {
      [`${t} + ${t}`]: {
        marginInlineStart: o
      }
    }
  };
}, mG = (e) => {
  const {
    controlHeight: t,
    controlHeightLG: n,
    controlHeightSM: r,
    fontSize: o,
    fontSizeLG: i,
    fontSizeXL: a,
    fontSizeHeading3: s,
    marginXS: l,
    marginXXS: u,
    colorBorderBg: f
  } = e;
  return {
    containerSize: t,
    containerSizeLG: n,
    containerSizeSM: r,
    textFontSize: Math.round((i + a) / 2),
    textFontSizeLG: s,
    textFontSizeSM: o,
    groupSpace: u,
    groupOverlapping: -l,
    groupBorderColor: f
  };
}, L6 = Gn("Avatar", (e) => {
  const {
    colorTextLightSolid: t,
    colorTextPlaceholder: n
  } = e, r = Sn(e, {
    avatarBg: n,
    avatarColor: t
  });
  return [hG(r), gG(r)];
}, mG);
var vG = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const yG = (e, t) => {
  const [n, r] = c.useState(1), [o, i] = c.useState(!1), [a, s] = c.useState(!0), l = c.useRef(null), u = c.useRef(null), f = Do(t, l), {
    getPrefixCls: p,
    avatar: h
  } = c.useContext(Ft), y = c.useContext(V1), b = () => {
    if (!u.current || !l.current)
      return;
    const ue = u.current.offsetWidth, ie = l.current.offsetWidth;
    if (ue !== 0 && ie !== 0) {
      const {
        gap: re = 4
      } = e;
      re * 2 < ie && r(ie - re * 2 < ue ? (ie - re * 2) / ue : 1);
    }
  };
  c.useEffect(() => {
    i(!0);
  }, []), c.useEffect(() => {
    s(!0), r(1);
  }, [e.src]), c.useEffect(b, [e.gap]);
  const m = () => {
    const {
      onError: ue
    } = e;
    (ue == null ? void 0 : ue()) !== !1 && s(!1);
  }, {
    prefixCls: v,
    shape: C,
    size: x,
    src: S,
    srcSet: E,
    icon: O,
    className: $,
    rootClassName: _,
    alt: R,
    draggable: P,
    children: I,
    crossOrigin: j
  } = e, F = vG(e, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "alt", "draggable", "children", "crossOrigin"]), A = Co((ue) => {
    var ie, re;
    return (re = (ie = x != null ? x : y == null ? void 0 : y.size) !== null && ie !== void 0 ? ie : ue) !== null && re !== void 0 ? re : "default";
  }), M = Object.keys(typeof A == "object" ? A || {} : {}).some((ue) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(ue)), N = zg(M), D = c.useMemo(() => {
    if (typeof A != "object")
      return {};
    const ue = jc.find((re) => N[re]), ie = A[ue];
    return ie ? {
      width: ie,
      height: ie,
      lineHeight: `${ie}px`,
      fontSize: ie && (O || I) ? ie / 2 : 18
    } : {};
  }, [N, A]);
  if (process.env.NODE_ENV !== "production") {
    const ue = xn("Avatar");
    process.env.NODE_ENV !== "production" && ue(!(typeof O == "string" && O.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${O}\` at https://ant.design/components/icon`);
  }
  const T = p("avatar", v), L = Ar(T), [z, H, V] = L6(T, L), Y = se({
    [`${T}-lg`]: A === "large",
    [`${T}-sm`]: A === "small"
  }), Z = /* @__PURE__ */ c.isValidElement(S), oe = C || (y == null ? void 0 : y.shape) || "circle", ee = se(T, Y, h == null ? void 0 : h.className, `${T}-${oe}`, {
    [`${T}-image`]: Z || S && a,
    [`${T}-icon`]: !!O
  }, V, L, $, _, H), ae = typeof A == "number" ? {
    width: A,
    height: A,
    lineHeight: `${A}px`,
    fontSize: O ? A / 2 : 18
  } : {};
  let le;
  if (typeof S == "string" && a)
    le = /* @__PURE__ */ c.createElement("img", {
      src: S,
      draggable: P,
      srcSet: E,
      onError: m,
      alt: R,
      crossOrigin: j
    });
  else if (Z)
    le = S;
  else if (O)
    le = O;
  else if (o || n !== 1) {
    const ue = `scale(${n}) translateX(-50%)`, ie = {
      msTransform: ue,
      WebkitTransform: ue,
      transform: ue
    }, re = typeof A == "number" ? {
      lineHeight: `${A}px`
    } : {};
    le = /* @__PURE__ */ c.createElement(zo, {
      onResize: b
    }, /* @__PURE__ */ c.createElement("span", {
      className: `${T}-string`,
      ref: u,
      style: Object.assign(Object.assign({}, re), ie)
    }, I));
  } else
    le = /* @__PURE__ */ c.createElement("span", {
      className: `${T}-string`,
      style: {
        opacity: 0
      },
      ref: u
    }, I);
  return delete F.onError, delete F.gap, z(/* @__PURE__ */ c.createElement("span", Object.assign({}, F, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, ae), D), h == null ? void 0 : h.style), F.style),
    className: ee,
    ref: f
  }), le));
}, A6 = /* @__PURE__ */ c.forwardRef(yG);
process.env.NODE_ENV !== "production" && (A6.displayName = "Avatar");
const j6 = A6, kc = (e) => e ? typeof e == "function" ? e() : e : null;
function Fb(e) {
  var t = e.children, n = e.prefixCls, r = e.id, o = e.overlayInnerStyle, i = e.className, a = e.style;
  return /* @__PURE__ */ c.createElement("div", {
    className: se("".concat(n, "-content"), i),
    style: a
  }, /* @__PURE__ */ c.createElement("div", {
    className: "".concat(n, "-inner"),
    id: r,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
}
var oc = {
  shiftX: 64,
  adjustY: 1
}, ic = {
  adjustX: 1,
  shiftY: !0
}, pi = [0, 0], bG = {
  left: {
    points: ["cr", "cl"],
    overflow: ic,
    offset: [-4, 0],
    targetOffset: pi
  },
  right: {
    points: ["cl", "cr"],
    overflow: ic,
    offset: [4, 0],
    targetOffset: pi
  },
  top: {
    points: ["bc", "tc"],
    overflow: oc,
    offset: [0, -4],
    targetOffset: pi
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: oc,
    offset: [0, 4],
    targetOffset: pi
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: oc,
    offset: [0, -4],
    targetOffset: pi
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ic,
    offset: [-4, 0],
    targetOffset: pi
  },
  topRight: {
    points: ["br", "tr"],
    overflow: oc,
    offset: [0, -4],
    targetOffset: pi
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ic,
    offset: [4, 0],
    targetOffset: pi
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: oc,
    offset: [0, 4],
    targetOffset: pi
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ic,
    offset: [4, 0],
    targetOffset: pi
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: oc,
    offset: [0, 4],
    targetOffset: pi
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ic,
    offset: [-4, 0],
    targetOffset: pi
  }
}, CG = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], xG = function(t, n) {
  var r = t.overlayClassName, o = t.trigger, i = o === void 0 ? ["hover"] : o, a = t.mouseEnterDelay, s = a === void 0 ? 0 : a, l = t.mouseLeaveDelay, u = l === void 0 ? 0.1 : l, f = t.overlayStyle, p = t.prefixCls, h = p === void 0 ? "rc-tooltip" : p, y = t.children, b = t.onVisibleChange, m = t.afterVisibleChange, v = t.transitionName, C = t.animation, x = t.motion, S = t.placement, E = S === void 0 ? "right" : S, O = t.align, $ = O === void 0 ? {} : O, _ = t.destroyTooltipOnHide, R = _ === void 0 ? !1 : _, P = t.defaultVisible, I = t.getTooltipContainer, j = t.overlayInnerStyle;
  t.arrowContent;
  var F = t.overlay, A = t.id, M = t.showArrow, N = M === void 0 ? !0 : M, D = Yt(t, CG), T = _t(null);
  Ua(n, function() {
    return T.current;
  });
  var L = J({}, D);
  "visible" in t && (L.popupVisible = t.visible);
  var z = function() {
    return /* @__PURE__ */ c.createElement(Fb, {
      key: "content",
      prefixCls: h,
      id: A,
      overlayInnerStyle: j
    }, F);
  };
  return /* @__PURE__ */ c.createElement(Jd, Oe({
    popupClassName: r,
    prefixCls: h,
    popup: z,
    action: i,
    builtinPlacements: bG,
    popupPlacement: E,
    ref: T,
    popupAlign: $,
    getPopupContainer: I,
    onPopupVisibleChange: b,
    afterPopupVisibleChange: m,
    popupTransitionName: v,
    popupAnimation: C,
    popupMotion: x,
    defaultPopupVisible: P,
    autoDestroy: R,
    mouseLeaveDelay: u,
    popupStyle: f,
    mouseEnterDelay: s,
    arrow: N
  }, L), y);
};
const SG = /* @__PURE__ */ ni(xG);
function Vg(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, o = t / 2, i = 0, a = o, s = r * 1 / Math.sqrt(2), l = o - r * (1 - 1 / Math.sqrt(2)), u = o - n * (1 / Math.sqrt(2)), f = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), p = 2 * o - u, h = f, y = 2 * o - s, b = l, m = 2 * o - i, v = a, C = o * Math.sqrt(2) + r * (Math.sqrt(2) - 2), x = r * (Math.sqrt(2) - 1), S = `polygon(${x}px 100%, 50% ${x}px, ${2 * o - x}px 100%, ${x}px 100%)`, E = `path('M ${i} ${a} A ${r} ${r} 0 0 0 ${s} ${l} L ${u} ${f} A ${n} ${n} 0 0 1 ${p} ${h} L ${y} ${b} A ${r} ${r} 0 0 0 ${m} ${v} Z')`;
  return {
    arrowShadowWidth: C,
    arrowPath: E,
    arrowPolygon: S
  };
}
const k6 = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: o,
    arrowPath: i,
    arrowShadowWidth: a,
    borderRadiusXS: s,
    calc: l
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: l(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [o, i]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: a,
      height: a,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${te(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, F6 = 8;
function Wg(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? F6 : r
  };
}
function wp(e, t) {
  return e ? t : {};
}
function Bb(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: o,
    arrowOffsetVertical: i,
    arrowOffsetHorizontal: a
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = n || {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, k6(e, t, o)), {
        "&:before": {
          background: t
        }
      })]
    }, wp(!!l.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: a
        }
      },
      [`&-placement-topRight > ${r}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: a
        }
      }
    })), wp(!!l.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: a
        }
      },
      [`&-placement-bottomRight > ${r}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: a
        }
      }
    })), wp(!!l.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: i
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: i
      }
    })), wp(!!l.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: i
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: i
      }
    }))
  };
}
function wG(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const o = r && typeof r == "object" ? r : {}, i = {};
  switch (e) {
    case "top":
    case "bottom":
      i.shiftX = t.arrowOffsetHorizontal * 2 + n, i.shiftY = !0, i.adjustY = !0;
      break;
    case "left":
    case "right":
      i.shiftY = t.arrowOffsetVertical * 2 + n, i.shiftX = !0, i.adjustX = !0;
      break;
  }
  const a = Object.assign(Object.assign({}, i), o);
  return a.shiftX || (a.adjustX = !0), a.shiftY || (a.adjustY = !0), a;
}
const nE = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, EG = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, $G = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function B6(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: o,
    borderRadius: i,
    visibleFirst: a
  } = e, s = t / 2, l = {};
  return Object.keys(nE).forEach((u) => {
    const f = r && EG[u] || nE[u], p = Object.assign(Object.assign({}, f), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[u] = p, $G.has(u) && (p.autoArrow = !1), u) {
      case "top":
      case "topLeft":
      case "topRight":
        p.offset[1] = -s - o;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        p.offset[1] = s + o;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        p.offset[0] = -s - o;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        p.offset[0] = s + o;
        break;
    }
    const h = Wg({
      contentRadius: i,
      limitVerticalRadius: !0
    });
    if (r)
      switch (u) {
        case "topLeft":
        case "bottomLeft":
          p.offset[0] = -h.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          p.offset[0] = h.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          p.offset[1] = -h.arrowOffsetHorizontal - s;
          break;
        case "leftBottom":
        case "rightBottom":
          p.offset[1] = h.arrowOffsetHorizontal + s;
          break;
      }
    p.overflow = wG(u, h, t, n), a && (p.htmlRegion = "visibleFirst");
  }), l;
}
const OG = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: n,
    tooltipColor: r,
    tooltipBg: o,
    tooltipBorderRadius: i,
    zIndexPopup: a,
    controlHeight: s,
    boxShadowSecondary: l,
    paddingSM: u,
    paddingXS: f
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e)), {
        position: "absolute",
        zIndex: a,
        display: "block",
        width: "max-content",
        maxWidth: n,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": o,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: s,
          minHeight: s,
          padding: `${te(e.calc(u).div(2).equal())} ${te(f)}`,
          color: r,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: o,
          borderRadius: i,
          boxShadow: l,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(i, F6)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), UB(e, (p, h) => {
        let {
          darkColor: y
        } = h;
        return {
          [`&${t}-${p}`]: {
            [`${t}-inner`]: {
              backgroundColor: y
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": y
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    Bb(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, _G = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, Wg({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), Vg(Sn(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), H6 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Gn("Tooltip", (r) => {
    const {
      borderRadius: o,
      colorTextLightSolid: i,
      colorBgSpotlight: a
    } = r, s = Sn(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: i,
      tooltipBorderRadius: o,
      tooltipBg: a
    });
    return [OG(s), Lg(r, "zoom-big-fast")];
  }, _G, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, NG = Cd.map((e) => `${e}-inverse`);
function PG(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(We(NG), We(Cd)).includes(e) : Cd.includes(e);
}
function z6(e, t) {
  const n = PG(t), r = se({
    [`${e}-${t}`]: t && n
  }), o = {}, i = {};
  return t && !n && (o.background = t, i["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: o,
    arrowStyle: i
  };
}
const IG = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: o,
    color: i,
    overlayInnerStyle: a
  } = e, {
    getPrefixCls: s
  } = c.useContext(Ft), l = s("tooltip", t), [u, f, p] = H6(l), h = z6(l, i), y = h.arrowStyle, b = Object.assign(Object.assign({}, a), h.overlayStyle), m = se(f, p, l, `${l}-pure`, `${l}-placement-${r}`, n, h.className);
  return u(/* @__PURE__ */ c.createElement("div", {
    className: m,
    style: y
  }, /* @__PURE__ */ c.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ c.createElement(Fb, Object.assign({}, e, {
    className: f,
    prefixCls: l,
    overlayInnerStyle: b
  }), o)));
}, RG = IG;
var DG = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Hb = /* @__PURE__ */ c.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: o,
    openClassName: i,
    getTooltipContainer: a,
    overlayClassName: s,
    color: l,
    overlayInnerStyle: u,
    children: f,
    afterOpenChange: p,
    afterVisibleChange: h,
    destroyTooltipOnHide: y,
    arrow: b = !0,
    title: m,
    overlay: v,
    builtinPlacements: C,
    arrowPointAtCenter: x = !1,
    autoAdjustOverflow: S = !0
  } = e, E = !!b, [, O] = ro(), {
    getPopupContainer: $,
    getPrefixCls: _,
    direction: R
  } = c.useContext(Ft), P = xn("Tooltip"), I = c.useRef(null), j = () => {
    var Ee;
    (Ee = I.current) === null || Ee === void 0 || Ee.forceAlign();
  };
  c.useImperativeHandle(t, () => ({
    forceAlign: j,
    forcePopupAlign: () => {
      P.deprecated(!1, "forcePopupAlign", "forceAlign"), j();
    }
  })), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((Ee) => {
    let [Ge, ke] = Ee;
    P.deprecated(!(Ge in e), Ge, ke);
  }), process.env.NODE_ENV !== "production" && P(!y || typeof y == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && P(!b || typeof b == "boolean" || !("arrowPointAtCenter" in b), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [F, A] = Fn(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), M = !m && !v && m !== 0, N = (Ee) => {
    var Ge, ke;
    A(M ? !1 : Ee), M || ((Ge = e.onOpenChange) === null || Ge === void 0 || Ge.call(e, Ee), (ke = e.onVisibleChange) === null || ke === void 0 || ke.call(e, Ee));
  }, D = c.useMemo(() => {
    var Ee, Ge;
    let ke = x;
    return typeof b == "object" && (ke = (Ge = (Ee = b.pointAtCenter) !== null && Ee !== void 0 ? Ee : b.arrowPointAtCenter) !== null && Ge !== void 0 ? Ge : x), C || B6({
      arrowPointAtCenter: ke,
      autoAdjustOverflow: S,
      arrowWidth: E ? O.sizePopupArrow : 0,
      borderRadius: O.borderRadius,
      offset: O.marginXXS,
      visibleFirst: !0
    });
  }, [x, b, C, O]), T = c.useMemo(() => m === 0 ? m : v || m || "", [v, m]), L = /* @__PURE__ */ c.createElement(vl, null, typeof T == "function" ? T() : T), {
    getPopupContainer: z,
    placement: H = "top",
    mouseEnterDelay: V = 0.1,
    mouseLeaveDelay: Y = 0.1,
    overlayStyle: Z,
    rootClassName: oe
  } = e, ee = DG(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), ae = _("tooltip", o), le = _(), ue = e["data-popover-inject"];
  let ie = F;
  !("open" in e) && !("visible" in e) && M && (ie = !1);
  const re = ti(f) && !v5(f) ? f : /* @__PURE__ */ c.createElement("span", null, f), Q = re.props, ce = !Q.className || typeof Q.className == "string" ? se(Q.className, i || `${ae}-open`) : Q.className, [ge, G, ne] = H6(ae, !ue), fe = z6(ae, l), ye = fe.arrowStyle, we = Object.assign(Object.assign({}, u), fe.overlayStyle), he = se(s, {
    [`${ae}-rtl`]: R === "rtl"
  }, fe.className, oe, G, ne), [me, Ce] = Ts("Tooltip", ee.zIndex), Te = /* @__PURE__ */ c.createElement(SG, Object.assign({}, ee, {
    zIndex: me,
    showArrow: E,
    placement: H,
    mouseEnterDelay: V,
    mouseLeaveDelay: Y,
    prefixCls: ae,
    overlayClassName: he,
    overlayStyle: Object.assign(Object.assign({}, ye), Z),
    getTooltipContainer: z || a || $,
    ref: I,
    builtinPlacements: D,
    overlay: L,
    visible: ie,
    onVisibleChange: N,
    afterVisibleChange: p != null ? p : h,
    overlayInnerStyle: we,
    arrowContent: /* @__PURE__ */ c.createElement("span", {
      className: `${ae}-arrow-content`
    }),
    motion: {
      motionName: ml(le, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!y
  }), ie ? Yr(re, {
    className: ce
  }) : re);
  return ge(/* @__PURE__ */ c.createElement(Eg.Provider, {
    value: Ce
  }, Te));
});
process.env.NODE_ENV !== "production" && (Hb.displayName = "Tooltip");
Hb._InternalPanelDoNotUseOrYouWillBeFired = RG;
const Bo = Hb, TG = (e) => {
  const {
    componentCls: t,
    popoverColor: n,
    titleMinWidth: r,
    fontWeightStrong: o,
    innerPadding: i,
    boxShadowSecondary: a,
    colorTextHeading: s,
    borderRadiusLG: l,
    zIndexPopup: u,
    titleMarginBottom: f,
    colorBgElevated: p,
    popoverBg: h,
    titleBorderBottom: y,
    innerContentPadding: b,
    titlePadding: m
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Qn(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: u,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "--antd-arrow-background-color": p,
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: h,
          backgroundClip: "padding-box",
          borderRadius: l,
          boxShadow: a,
          padding: i
        },
        [`${t}-title`]: {
          minWidth: r,
          marginBottom: f,
          color: s,
          fontWeight: o,
          borderBottom: y,
          padding: m
        },
        [`${t}-inner-content`]: {
          color: n,
          padding: b
        }
      })
    },
    // Arrow Style
    Bb(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, MG = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Cd.map((n) => {
      const r = e[`${n}6`];
      return {
        [`&${t}-${n}`]: {
          "--antd-arrow-background-color": r,
          [`${t}-inner`]: {
            backgroundColor: r
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, LG = (e) => {
  const {
    lineWidth: t,
    controlHeight: n,
    fontHeight: r,
    padding: o,
    wireframe: i,
    zIndexPopupBase: a,
    borderRadiusLG: s,
    marginXS: l,
    lineType: u,
    colorSplit: f,
    paddingSM: p
  } = e, h = n - r, y = h / 2, b = h / 2 - t, m = o;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: a + 30
  }, Vg(e)), Wg({
    contentRadius: s,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: i ? 0 : 12,
    titleMarginBottom: i ? 0 : l,
    titlePadding: i ? `${y}px ${m}px ${b}px` : 0,
    titleBorderBottom: i ? `${t}px ${u} ${f}` : "none",
    innerContentPadding: i ? `${p}px ${m}px` : 0
  });
}, V6 = Gn("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: n
  } = e, r = Sn(e, {
    popoverBg: t,
    popoverColor: n
  });
  return [TG(r), MG(r), Lg(r, "zoom-big")];
}, LG, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var AG = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const jG = (e, t, n) => !t && !n ? null : /* @__PURE__ */ c.createElement(c.Fragment, null, t && /* @__PURE__ */ c.createElement("div", {
  className: `${e}-title`
}, kc(t)), /* @__PURE__ */ c.createElement("div", {
  className: `${e}-inner-content`
}, kc(n))), kG = (e) => {
  const {
    hashId: t,
    prefixCls: n,
    className: r,
    style: o,
    placement: i = "top",
    title: a,
    content: s,
    children: l
  } = e;
  return /* @__PURE__ */ c.createElement("div", {
    className: se(t, n, `${n}-pure`, `${n}-placement-${i}`, r),
    style: o
  }, /* @__PURE__ */ c.createElement("div", {
    className: `${n}-arrow`
  }), /* @__PURE__ */ c.createElement(Fb, Object.assign({}, e, {
    className: t,
    prefixCls: n
  }), l || jG(n, a, s)));
}, FG = (e) => {
  const {
    prefixCls: t,
    className: n
  } = e, r = AG(e, ["prefixCls", "className"]), {
    getPrefixCls: o
  } = c.useContext(Ft), i = o("popover", t), [a, s, l] = V6(i);
  return a(/* @__PURE__ */ c.createElement(kG, Object.assign({}, r, {
    prefixCls: i,
    hashId: s,
    className: se(n, l)
  })));
}, W6 = FG;
var BG = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const HG = (e) => {
  let {
    title: t,
    content: n,
    prefixCls: r
  } = e;
  return /* @__PURE__ */ c.createElement(c.Fragment, null, t && /* @__PURE__ */ c.createElement("div", {
    className: `${r}-title`
  }, kc(t)), /* @__PURE__ */ c.createElement("div", {
    className: `${r}-inner-content`
  }, kc(n)));
}, zb = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    title: r,
    content: o,
    overlayClassName: i,
    placement: a = "top",
    trigger: s = "hover",
    mouseEnterDelay: l = 0.1,
    mouseLeaveDelay: u = 0.1,
    overlayStyle: f = {}
  } = e, p = BG(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle"]), {
    getPrefixCls: h
  } = c.useContext(Ft), y = h("popover", n), [b, m, v] = V6(y), C = h(), x = se(i, m, v);
  return b(/* @__PURE__ */ c.createElement(Bo, Object.assign({
    placement: a,
    trigger: s,
    mouseEnterDelay: l,
    mouseLeaveDelay: u,
    overlayStyle: f
  }, p, {
    prefixCls: y,
    overlayClassName: x,
    ref: t,
    overlay: r || o ? /* @__PURE__ */ c.createElement(HG, {
      prefixCls: y,
      title: r,
      content: o
    }) : null,
    transitionName: ml(C, "zoom-big", p.transitionName),
    "data-popover-inject": !0
  })));
});
process.env.NODE_ENV !== "production" && (zb.displayName = "Popover");
zb._InternalPanelDoNotUseOrYouWillBeFired = W6;
const K6 = zb, rE = (e) => {
  const {
    size: t,
    shape: n
  } = c.useContext(V1), r = c.useMemo(() => ({
    size: e.size || t,
    shape: e.shape || n
  }), [e.size, e.shape, t, n]);
  return /* @__PURE__ */ c.createElement(V1.Provider, {
    value: r
  }, e.children);
}, zG = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = c.useContext(Ft), {
    prefixCls: r,
    className: o,
    rootClassName: i,
    style: a,
    maxCount: s,
    maxStyle: l,
    size: u,
    shape: f,
    maxPopoverPlacement: p = "top",
    maxPopoverTrigger: h = "hover",
    children: y
  } = e, b = t("avatar", r), m = `${b}-group`, v = Ar(b), [C, x, S] = L6(b, v), E = se(m, {
    [`${m}-rtl`]: n === "rtl"
  }, S, v, o, i, x), O = Rr(y).map((_, R) => Yr(_, {
    key: `avatar-key-${R}`
  })), $ = O.length;
  if (s && s < $) {
    const _ = O.slice(0, s), R = O.slice(s, $);
    return _.push(/* @__PURE__ */ c.createElement(K6, {
      key: "avatar-popover-key",
      content: R,
      trigger: h,
      placement: p,
      overlayClassName: `${m}-popover`
    }, /* @__PURE__ */ c.createElement(j6, {
      style: l
    }, `+${$ - s}`))), C(/* @__PURE__ */ c.createElement(rE, {
      shape: f,
      size: u
    }, /* @__PURE__ */ c.createElement("div", {
      className: E,
      style: a
    }, _)));
  }
  return C(/* @__PURE__ */ c.createElement(rE, {
    shape: f,
    size: u
  }, /* @__PURE__ */ c.createElement("div", {
    className: E,
    style: a
  }, O)));
}, VG = zG, U6 = j6;
U6.Group = VG;
const eh = U6;
var WG = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const KG = WG;
var G6 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: KG
  }));
};
process.env.NODE_ENV !== "production" && (G6.displayName = "RightOutlined");
const Fc = /* @__PURE__ */ c.forwardRef(G6);
var UG = Pe.ESC, GG = Pe.TAB;
function qG(e) {
  var t = e.visible, n = e.triggerRef, r = e.onVisibleChange, o = e.autoFocus, i = e.overlayRef, a = c.useRef(!1), s = function() {
    if (t) {
      var p, h;
      (p = n.current) === null || p === void 0 || (h = p.focus) === null || h === void 0 || h.call(p), r == null || r(!1);
    }
  }, l = function() {
    var p;
    return (p = i.current) !== null && p !== void 0 && p.focus ? (i.current.focus(), a.current = !0, !0) : !1;
  }, u = function(p) {
    switch (p.keyCode) {
      case UG:
        s();
        break;
      case GG: {
        var h = !1;
        a.current || (h = l()), h ? p.preventDefault() : s();
        break;
      }
    }
  };
  c.useEffect(function() {
    return t ? (window.addEventListener("keydown", u), o && Pn(l, 3), function() {
      window.removeEventListener("keydown", u), a.current = !1;
    }) : function() {
      a.current = !1;
    };
  }, [t]);
}
var YG = /* @__PURE__ */ ni(function(e, t) {
  var n = e.overlay, r = e.arrow, o = e.prefixCls, i = mr(function() {
    var s;
    return typeof n == "function" ? s = n() : s = n, s;
  }, [n]), a = Do(t, i == null ? void 0 : i.ref);
  return /* @__PURE__ */ be.createElement(be.Fragment, null, r && /* @__PURE__ */ be.createElement("div", {
    className: "".concat(o, "-arrow")
  }), /* @__PURE__ */ be.cloneElement(i, {
    ref: ki(i) ? a : void 0
  }));
}), ac = {
  adjustX: 1,
  adjustY: 1
}, sc = [0, 0], XG = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: ac,
    offset: [0, -4],
    targetOffset: sc
  },
  top: {
    points: ["bc", "tc"],
    overflow: ac,
    offset: [0, -4],
    targetOffset: sc
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ac,
    offset: [0, -4],
    targetOffset: sc
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ac,
    offset: [0, 4],
    targetOffset: sc
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: ac,
    offset: [0, 4],
    targetOffset: sc
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ac,
    offset: [0, 4],
    targetOffset: sc
  }
}, ZG = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function QG(e, t) {
  var n, r = e.arrow, o = r === void 0 ? !1 : r, i = e.prefixCls, a = i === void 0 ? "rc-dropdown" : i, s = e.transitionName, l = e.animation, u = e.align, f = e.placement, p = f === void 0 ? "bottomLeft" : f, h = e.placements, y = h === void 0 ? XG : h, b = e.getPopupContainer, m = e.showAction, v = e.hideAction, C = e.overlayClassName, x = e.overlayStyle, S = e.visible, E = e.trigger, O = E === void 0 ? ["hover"] : E, $ = e.autoFocus, _ = e.overlay, R = e.children, P = e.onVisibleChange, I = Yt(e, ZG), j = be.useState(), F = de(j, 2), A = F[0], M = F[1], N = "visible" in e ? S : A, D = be.useRef(null), T = be.useRef(null), L = be.useRef(null);
  be.useImperativeHandle(t, function() {
    return D.current;
  });
  var z = function(ue) {
    M(ue), P == null || P(ue);
  };
  qG({
    visible: N,
    triggerRef: L,
    onVisibleChange: z,
    autoFocus: $,
    overlayRef: T
  });
  var H = function(ue) {
    var ie = e.onOverlayClick;
    M(!1), ie && ie(ue);
  }, V = function() {
    return /* @__PURE__ */ be.createElement(YG, {
      ref: T,
      overlay: _,
      prefixCls: a,
      arrow: o
    });
  }, Y = function() {
    return typeof _ == "function" ? V : V();
  }, Z = function() {
    var ue = e.minOverlayWidthMatchTrigger, ie = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? ue : !ie;
  }, oe = function() {
    var ue = e.openClassName;
    return ue !== void 0 ? ue : "".concat(a, "-open");
  }, ee = /* @__PURE__ */ be.cloneElement(R, {
    className: se((n = R.props) === null || n === void 0 ? void 0 : n.className, N && oe()),
    ref: ki(R) ? Do(L, R.ref) : void 0
  }), ae = v;
  return !ae && O.indexOf("contextMenu") !== -1 && (ae = ["click"]), /* @__PURE__ */ be.createElement(Jd, Oe({
    builtinPlacements: y
  }, I, {
    prefixCls: a,
    ref: D,
    popupClassName: se(C, K({}, "".concat(a, "-show-arrow"), o)),
    popupStyle: x,
    action: O,
    showAction: m,
    hideAction: ae,
    popupPlacement: p,
    popupAlign: u,
    popupTransitionName: s,
    popupAnimation: l,
    popupVisible: N,
    stretch: Z() ? "minWidth" : "",
    popup: Y(),
    onPopupVisibleChange: z,
    onPopupClick: H,
    getPopupContainer: b
  }), ee);
}
const JG = /* @__PURE__ */ be.forwardRef(QG);
var q6 = /* @__PURE__ */ c.createContext(null);
function Y6(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function X6(e) {
  var t = c.useContext(q6);
  return Y6(t, e);
}
var eq = ["children", "locked"], Hi = /* @__PURE__ */ c.createContext(null);
function tq(e, t) {
  var n = J({}, e);
  return Object.keys(t).forEach(function(r) {
    var o = t[r];
    o !== void 0 && (n[r] = o);
  }), n;
}
function Od(e) {
  var t = e.children, n = e.locked, r = Yt(e, eq), o = c.useContext(Hi), i = ua(function() {
    return tq(o, r);
  }, [o, r], function(a, s) {
    return !n && (a[0] !== s[0] || !Fi(a[1], s[1], !0));
  });
  return /* @__PURE__ */ c.createElement(Hi.Provider, {
    value: i
  }, t);
}
var nq = [], Z6 = /* @__PURE__ */ c.createContext(null);
function Kg() {
  return c.useContext(Z6);
}
var Q6 = /* @__PURE__ */ c.createContext(nq);
function nu(e) {
  var t = c.useContext(Q6);
  return c.useMemo(function() {
    return e !== void 0 ? [].concat(We(t), [e]) : t;
  }, [t, e]);
}
var J6 = /* @__PURE__ */ c.createContext(null), Vb = /* @__PURE__ */ c.createContext({});
function oE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (Qc(e)) {
    var n = e.nodeName.toLowerCase(), r = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(n) || // Editable element
      e.isContentEditable || // Anchor with href element
      n === "a" && !!e.getAttribute("href")
    ), o = e.getAttribute("tabindex"), i = Number(o), a = null;
    return o && !Number.isNaN(i) ? a = i : r && a === null && (a = 0), r && e.disabled && (a = null), a !== null && (a >= 0 || t && a < 0);
  }
  return !1;
}
function rq(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = We(e.querySelectorAll("*")).filter(function(r) {
    return oE(r, t);
  });
  return oE(e, t) && n.unshift(e), n;
}
var W1 = Pe.LEFT, K1 = Pe.RIGHT, U1 = Pe.UP, th = Pe.DOWN, nh = Pe.ENTER, e_ = Pe.ESC, zu = Pe.HOME, Vu = Pe.END, iE = [U1, th, W1, K1];
function oq(e, t, n, r) {
  var o, i, a, s, l = "prev", u = "next", f = "children", p = "parent";
  if (e === "inline" && r === nh)
    return {
      inlineTrigger: !0
    };
  var h = (o = {}, K(o, U1, l), K(o, th, u), o), y = (i = {}, K(i, W1, n ? u : l), K(i, K1, n ? l : u), K(i, th, f), K(i, nh, f), i), b = (a = {}, K(a, U1, l), K(a, th, u), K(a, nh, f), K(a, e_, p), K(a, W1, n ? f : p), K(a, K1, n ? p : f), a), m = {
    inline: h,
    horizontal: y,
    vertical: b,
    inlineSub: h,
    horizontalSub: b,
    verticalSub: b
  }, v = (s = m["".concat(e).concat(t ? "" : "Sub")]) === null || s === void 0 ? void 0 : s[r];
  switch (v) {
    case l:
      return {
        offset: -1,
        sibling: !0
      };
    case u:
      return {
        offset: 1,
        sibling: !0
      };
    case p:
      return {
        offset: -1,
        sibling: !1
      };
    case f:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function iq(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function aq(e, t) {
  for (var n = e || document.activeElement; n; ) {
    if (t.has(n))
      return n;
    n = n.parentElement;
  }
  return null;
}
function Wb(e, t) {
  var n = rq(e, !0);
  return n.filter(function(r) {
    return t.has(r);
  });
}
function aE(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var o = Wb(e, t), i = o.length, a = o.findIndex(function(s) {
    return n === s;
  });
  return r < 0 ? a === -1 ? a = i - 1 : a -= 1 : r > 0 && (a += 1), a = (a + i) % i, o[a];
}
var G1 = function(t, n) {
  var r = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  return t.forEach(function(a) {
    var s = document.querySelector("[data-menu-id='".concat(Y6(n, a), "']"));
    s && (r.add(s), i.set(s, a), o.set(a, s));
  }), {
    elements: r,
    key2element: o,
    element2key: i
  };
};
function sq(e, t, n, r, o, i, a, s, l, u) {
  var f = c.useRef(), p = c.useRef();
  p.current = t;
  var h = function() {
    Pn.cancel(f.current);
  };
  return c.useEffect(function() {
    return function() {
      h();
    };
  }, []), function(y) {
    var b = y.which;
    if ([].concat(iE, [nh, e_, zu, Vu]).includes(b)) {
      var m = i(), v = G1(m, r), C = v, x = C.elements, S = C.key2element, E = C.element2key, O = S.get(t), $ = aq(O, x), _ = E.get($), R = oq(e, a(_, !0).length === 1, n, b);
      if (!R && b !== zu && b !== Vu)
        return;
      (iE.includes(b) || [zu, Vu].includes(b)) && y.preventDefault();
      var P = function(T) {
        if (T) {
          var L = T, z = T.querySelector("a");
          z != null && z.getAttribute("href") && (L = z);
          var H = E.get(T);
          s(H), h(), f.current = Pn(function() {
            p.current === H && L.focus();
          });
        }
      };
      if ([zu, Vu].includes(b) || R.sibling || !$) {
        var I;
        !$ || e === "inline" ? I = o.current : I = iq($);
        var j, F = Wb(I, x);
        b === zu ? j = F[0] : b === Vu ? j = F[F.length - 1] : j = aE(I, x, $, R.offset), P(j);
      } else if (R.inlineTrigger)
        l(_);
      else if (R.offset > 0)
        l(_, !0), h(), f.current = Pn(function() {
          v = G1(m, r);
          var D = $.getAttribute("aria-controls"), T = document.getElementById(D), L = aE(T, v.elements);
          P(L);
        }, 5);
      else if (R.offset < 0) {
        var A = a(_, !0), M = A[A.length - 2], N = S.get(M);
        l(M, !1), P(N);
      }
    }
    u == null || u(y);
  };
}
function lq(e) {
  Promise.resolve().then(e);
}
var Kb = "__RC_UTIL_PATH_SPLIT__", sE = function(t) {
  return t.join(Kb);
}, cq = function(t) {
  return t.split(Kb);
}, q1 = "rc-menu-more";
function uq() {
  var e = c.useState({}), t = de(e, 2), n = t[1], r = _t(/* @__PURE__ */ new Map()), o = _t(/* @__PURE__ */ new Map()), i = c.useState([]), a = de(i, 2), s = a[0], l = a[1], u = _t(0), f = _t(!1), p = function() {
    f.current || n({});
  }, h = ar(function(S, E) {
    process.env.NODE_ENV !== "production" && mt(!r.current.has(S), "Duplicated key '".concat(S, "' used in Menu by path [").concat(E.join(" > "), "]"));
    var O = sE(E);
    o.current.set(O, S), r.current.set(S, O), u.current += 1;
    var $ = u.current;
    lq(function() {
      $ === u.current && p();
    });
  }, []), y = ar(function(S, E) {
    var O = sE(E);
    o.current.delete(O), r.current.delete(S);
  }, []), b = ar(function(S) {
    l(S);
  }, []), m = ar(function(S, E) {
    var O = r.current.get(S) || "", $ = cq(O);
    return E && s.includes($[0]) && $.unshift(q1), $;
  }, [s]), v = ar(function(S, E) {
    return S.some(function(O) {
      var $ = m(O, !0);
      return $.includes(E);
    });
  }, [m]), C = function() {
    var E = We(r.current.keys());
    return s.length && E.push(q1), E;
  }, x = ar(function(S) {
    var E = "".concat(r.current.get(S)).concat(Kb), O = /* @__PURE__ */ new Set();
    return We(o.current.keys()).forEach(function($) {
      $.startsWith(E) && O.add(o.current.get($));
    }), O;
  }, []);
  return c.useEffect(function() {
    return function() {
      f.current = !0;
    };
  }, []), {
    // Register
    registerPath: h,
    unregisterPath: y,
    refreshOverflowKeys: b,
    // Util
    isSubPathKey: v,
    getKeyPath: m,
    getKeys: C,
    getSubPathKeys: x
  };
}
function Xu(e) {
  var t = c.useRef(e);
  t.current = e;
  var n = c.useCallback(function() {
    for (var r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(i));
  }, []);
  return e ? n : void 0;
}
var dq = Math.random().toFixed(5).toString().slice(2), lE = 0;
function fq(e) {
  var t = Fn(e, {
    value: e
  }), n = de(t, 2), r = n[0], o = n[1];
  return c.useEffect(function() {
    lE += 1;
    var i = process.env.NODE_ENV === "test" ? "test" : "".concat(dq, "-").concat(lE);
    o("rc-menu-uuid-".concat(i));
  }, []), r;
}
function t_(e, t, n, r) {
  var o = c.useContext(Hi), i = o.activeKey, a = o.onActive, s = o.onInactive, l = {
    active: i === e
  };
  return t || (l.onMouseEnter = function(u) {
    n == null || n({
      key: e,
      domEvent: u
    }), a(e);
  }, l.onMouseLeave = function(u) {
    r == null || r({
      key: e,
      domEvent: u
    }), s(e);
  }), l;
}
function n_(e) {
  var t = c.useContext(Hi), n = t.mode, r = t.rtl, o = t.inlineIndent;
  if (n !== "inline")
    return null;
  var i = e;
  return r ? {
    paddingRight: i * o
  } : {
    paddingLeft: i * o
  };
}
function r_(e) {
  var t = e.icon, n = e.props, r = e.children, o;
  return t === null || t === !1 ? null : (typeof t == "function" ? o = /* @__PURE__ */ c.createElement(t, J({}, n)) : typeof t != "boolean" && (o = t), o || r || null);
}
var pq = ["item"];
function Dh(e) {
  var t = e.item, n = Yt(e, pq);
  return Object.defineProperty(n, "item", {
    get: function() {
      return mt(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), n;
}
var hq = ["title", "attribute", "elementRef"], gq = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], mq = ["active"], vq = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    return zr(this, n), t.apply(this, arguments);
  }
  return Vr(n, [{
    key: "render",
    value: function() {
      var o = this.props, i = o.title, a = o.attribute, s = o.elementRef, l = Yt(o, hq), u = dr(l, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return mt(!a, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ c.createElement(la.Item, Oe({}, a, {
        title: typeof i == "string" ? i : void 0
      }, u, {
        ref: s
      }));
    }
  }]), n;
}(c.Component), yq = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n, r = e.style, o = e.className, i = e.eventKey, a = e.warnKey, s = e.disabled, l = e.itemIcon, u = e.children, f = e.role, p = e.onMouseEnter, h = e.onMouseLeave, y = e.onClick, b = e.onKeyDown, m = e.onFocus, v = Yt(e, gq), C = X6(i), x = c.useContext(Hi), S = x.prefixCls, E = x.onItemClick, O = x.disabled, $ = x.overflowDisabled, _ = x.itemIcon, R = x.selectedKeys, P = x.onActive, I = c.useContext(Vb), j = I._internalRenderMenuItem, F = "".concat(S, "-item"), A = c.useRef(), M = c.useRef(), N = O || s, D = Ol(t, M), T = nu(i);
  process.env.NODE_ENV !== "production" && a && mt(!1, "MenuItem should not leave undefined `key`.");
  var L = function(Q) {
    return {
      key: i,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: We(T).reverse(),
      item: A.current,
      domEvent: Q
    };
  }, z = l || _, H = t_(i, N, p, h), V = H.active, Y = Yt(H, mq), Z = R.includes(i), oe = n_(T.length), ee = function(Q) {
    if (!N) {
      var ce = L(Q);
      y == null || y(Dh(ce)), E(ce);
    }
  }, ae = function(Q) {
    if (b == null || b(Q), Q.which === Pe.ENTER) {
      var ce = L(Q);
      y == null || y(Dh(ce)), E(ce);
    }
  }, le = function(Q) {
    P(i), m == null || m(Q);
  }, ue = {};
  e.role === "option" && (ue["aria-selected"] = Z);
  var ie = /* @__PURE__ */ c.createElement(vq, Oe({
    ref: A,
    elementRef: D,
    role: f === null ? "none" : f || "menuitem",
    tabIndex: s ? null : -1,
    "data-menu-id": $ && C ? null : C
  }, v, Y, ue, {
    component: "li",
    "aria-disabled": s,
    style: J(J({}, oe), r),
    className: se(F, (n = {}, K(n, "".concat(F, "-active"), V), K(n, "".concat(F, "-selected"), Z), K(n, "".concat(F, "-disabled"), N), n), o),
    onClick: ee,
    onKeyDown: ae,
    onFocus: le
  }), u, /* @__PURE__ */ c.createElement(r_, {
    props: J(J({}, e), {}, {
      isSelected: Z
    }),
    icon: z
  }));
  return j && (ie = j(ie, e, {
    selected: Z
  })), ie;
});
function bq(e, t) {
  var n = e.eventKey, r = Kg(), o = nu(n);
  return c.useEffect(function() {
    if (r)
      return r.registerPath(n, o), function() {
        r.unregisterPath(n, o);
      };
  }, [o]), r ? null : /* @__PURE__ */ c.createElement(yq, Oe({}, e, {
    ref: t
  }));
}
const Ug = /* @__PURE__ */ c.forwardRef(bq);
var Cq = ["className", "children"], xq = function(t, n) {
  var r = t.className, o = t.children, i = Yt(t, Cq), a = c.useContext(Hi), s = a.prefixCls, l = a.mode, u = a.rtl;
  return /* @__PURE__ */ c.createElement("ul", Oe({
    className: se(s, u && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(l === "inline" ? "inline" : "vertical"), r),
    role: "menu"
  }, i, {
    "data-menu-list": !0,
    ref: n
  }), o);
}, Ub = /* @__PURE__ */ c.forwardRef(xq);
Ub.displayName = "SubMenuList";
function Gb(e, t) {
  return Rr(e).map(function(n, r) {
    if (/* @__PURE__ */ c.isValidElement(n)) {
      var o, i, a = n.key, s = (o = (i = n.props) === null || i === void 0 ? void 0 : i.eventKey) !== null && o !== void 0 ? o : a, l = s == null;
      l && (s = "tmp_key-".concat([].concat(We(t), [r]).join("-")));
      var u = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && l && (u.warnKey = !0), /* @__PURE__ */ c.cloneElement(n, u);
    }
    return n;
  });
}
var yo = {
  adjustX: 1,
  adjustY: 1
}, Sq = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: yo
  },
  topRight: {
    points: ["br", "tr"],
    overflow: yo
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: yo
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: yo
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: yo
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: yo
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: yo
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: yo
  }
}, wq = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: yo
  },
  topRight: {
    points: ["br", "tr"],
    overflow: yo
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: yo
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: yo
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: yo
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: yo
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: yo
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: yo
  }
};
function o_(e, t, n) {
  if (t)
    return t;
  if (n)
    return n[e] || n.other;
}
var Eq = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function $q(e) {
  var t = e.prefixCls, n = e.visible, r = e.children, o = e.popup, i = e.popupStyle, a = e.popupClassName, s = e.popupOffset, l = e.disabled, u = e.mode, f = e.onVisibleChange, p = c.useContext(Hi), h = p.getPopupContainer, y = p.rtl, b = p.subMenuOpenDelay, m = p.subMenuCloseDelay, v = p.builtinPlacements, C = p.triggerSubMenuAction, x = p.forceSubMenuRender, S = p.rootClassName, E = p.motion, O = p.defaultMotions, $ = c.useState(!1), _ = de($, 2), R = _[0], P = _[1], I = J(y ? J({}, wq) : J({}, Sq), v), j = Eq[u], F = o_(u, E, O), A = c.useRef(F);
  u !== "inline" && (A.current = F);
  var M = J(J({}, A.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), N = c.useRef();
  return c.useEffect(function() {
    return N.current = Pn(function() {
      P(n);
    }), function() {
      Pn.cancel(N.current);
    };
  }, [n]), /* @__PURE__ */ c.createElement(Jd, {
    prefixCls: t,
    popupClassName: se("".concat(t, "-popup"), K({}, "".concat(t, "-rtl"), y), a, S),
    stretch: u === "horizontal" ? "minWidth" : null,
    getPopupContainer: h,
    builtinPlacements: I,
    popupPlacement: j,
    popupVisible: R,
    popup: o,
    popupStyle: i,
    popupAlign: s && {
      offset: s
    },
    action: l ? [] : [C],
    mouseEnterDelay: b,
    mouseLeaveDelay: m,
    onPopupVisibleChange: f,
    forceRender: x,
    popupMotion: M,
    fresh: !0
  }, r);
}
function Oq(e) {
  var t = e.id, n = e.open, r = e.keyPath, o = e.children, i = "inline", a = c.useContext(Hi), s = a.prefixCls, l = a.forceSubMenuRender, u = a.motion, f = a.defaultMotions, p = a.mode, h = c.useRef(!1);
  h.current = p === i;
  var y = c.useState(!h.current), b = de(y, 2), m = b[0], v = b[1], C = h.current ? n : !1;
  c.useEffect(function() {
    h.current && v(!1);
  }, [p]);
  var x = J({}, o_(i, u, f));
  r.length > 1 && (x.motionAppear = !1);
  var S = x.onVisibleChanged;
  return x.onVisibleChanged = function(E) {
    return !h.current && !E && v(!0), S == null ? void 0 : S(E);
  }, m ? null : /* @__PURE__ */ c.createElement(Od, {
    mode: i,
    locked: !h.current
  }, /* @__PURE__ */ c.createElement(Bi, Oe({
    visible: C
  }, x, {
    forceRender: l,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(E) {
    var O = E.className, $ = E.style;
    return /* @__PURE__ */ c.createElement(Ub, {
      id: t,
      className: O,
      style: $
    }, o);
  }));
}
var _q = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], Nq = ["active"], Pq = function(t) {
  var n, r = t.style, o = t.className, i = t.title, a = t.eventKey, s = t.warnKey, l = t.disabled, u = t.internalPopupClose, f = t.children, p = t.itemIcon, h = t.expandIcon, y = t.popupClassName, b = t.popupOffset, m = t.popupStyle, v = t.onClick, C = t.onMouseEnter, x = t.onMouseLeave, S = t.onTitleClick, E = t.onTitleMouseEnter, O = t.onTitleMouseLeave, $ = Yt(t, _q), _ = X6(a), R = c.useContext(Hi), P = R.prefixCls, I = R.mode, j = R.openKeys, F = R.disabled, A = R.overflowDisabled, M = R.activeKey, N = R.selectedKeys, D = R.itemIcon, T = R.expandIcon, L = R.onItemClick, z = R.onOpenChange, H = R.onActive, V = c.useContext(Vb), Y = V._internalRenderSubMenuItem, Z = c.useContext(J6), oe = Z.isSubPathKey, ee = nu(), ae = "".concat(P, "-submenu"), le = F || l, ue = c.useRef(), ie = c.useRef();
  process.env.NODE_ENV !== "production" && s && mt(!1, "SubMenu should not leave undefined `key`.");
  var re = p != null ? p : D, Q = h != null ? h : T, ce = j.includes(a), ge = !A && ce, G = oe(N, a), ne = t_(a, le, E, O), fe = ne.active, ye = Yt(ne, Nq), we = c.useState(!1), he = de(we, 2), me = he[0], Ce = he[1], Te = function(ot) {
    le || Ce(ot);
  }, Ee = function(ot) {
    Te(!0), C == null || C({
      key: a,
      domEvent: ot
    });
  }, Ge = function(ot) {
    Te(!1), x == null || x({
      key: a,
      domEvent: ot
    });
  }, ke = c.useMemo(function() {
    return fe || (I !== "inline" ? me || oe([M], a) : !1);
  }, [I, fe, M, me, a, oe]), qe = n_(ee.length), ze = function(ot) {
    le || (S == null || S({
      key: a,
      domEvent: ot
    }), I === "inline" && z(a, !ce));
  }, pt = Xu(function(Ct) {
    v == null || v(Dh(Ct)), L(Ct);
  }), Ke = function(ot) {
    I !== "inline" && z(a, ot);
  }, et = function() {
    H(a);
  }, Je = _ && "".concat(_, "-popup"), Et = /* @__PURE__ */ c.createElement("div", Oe({
    role: "menuitem",
    style: qe,
    className: "".concat(ae, "-title"),
    tabIndex: le ? null : -1,
    ref: ue,
    title: typeof i == "string" ? i : null,
    "data-menu-id": A && _ ? null : _,
    "aria-expanded": ge,
    "aria-haspopup": !0,
    "aria-controls": Je,
    "aria-disabled": le,
    onClick: ze,
    onFocus: et
  }, ye), i, /* @__PURE__ */ c.createElement(r_, {
    icon: I !== "horizontal" ? Q : void 0,
    props: J(J({}, t), {}, {
      isOpen: ge,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ c.createElement("i", {
    className: "".concat(ae, "-arrow")
  }))), Ye = c.useRef(I);
  if (I !== "inline" && ee.length > 1 ? Ye.current = "vertical" : Ye.current = I, !A) {
    var wt = Ye.current;
    Et = /* @__PURE__ */ c.createElement($q, {
      mode: wt,
      prefixCls: ae,
      visible: !u && ge && I !== "inline",
      popupClassName: y,
      popupOffset: b,
      popupStyle: m,
      popup: /* @__PURE__ */ c.createElement(
        Od,
        {
          mode: wt === "horizontal" ? "vertical" : wt
        },
        /* @__PURE__ */ c.createElement(Ub, {
          id: Je,
          ref: ie
        }, f)
      ),
      disabled: le,
      onVisibleChange: Ke
    }, Et);
  }
  var dt = /* @__PURE__ */ c.createElement(la.Item, Oe({
    role: "none"
  }, $, {
    component: "li",
    style: r,
    className: se(ae, "".concat(ae, "-").concat(I), o, (n = {}, K(n, "".concat(ae, "-open"), ge), K(n, "".concat(ae, "-active"), ke), K(n, "".concat(ae, "-selected"), G), K(n, "".concat(ae, "-disabled"), le), n)),
    onMouseEnter: Ee,
    onMouseLeave: Ge
  }), Et, !A && /* @__PURE__ */ c.createElement(Oq, {
    id: Je,
    open: ge,
    keyPath: ee
  }, f));
  return Y && (dt = Y(dt, t, {
    selected: G,
    active: ke,
    open: ge,
    disabled: le
  })), /* @__PURE__ */ c.createElement(Od, {
    onItemClick: pt,
    mode: I === "horizontal" ? "vertical" : I,
    itemIcon: re,
    expandIcon: Q
  }, dt);
};
function Gg(e) {
  var t = e.eventKey, n = e.children, r = nu(t), o = Gb(n, r), i = Kg();
  c.useEffect(function() {
    if (i)
      return i.registerPath(t, r), function() {
        i.unregisterPath(t, r);
      };
  }, [r]);
  var a;
  return i ? a = o : a = /* @__PURE__ */ c.createElement(Pq, e, o), /* @__PURE__ */ c.createElement(Q6.Provider, {
    value: r
  }, a);
}
var Iq = ["className", "title", "eventKey", "children"], Rq = ["children"], Dq = function(t) {
  var n = t.className, r = t.title;
  t.eventKey;
  var o = t.children, i = Yt(t, Iq), a = c.useContext(Hi), s = a.prefixCls, l = "".concat(s, "-item-group");
  return /* @__PURE__ */ c.createElement("li", Oe({
    role: "presentation"
  }, i, {
    onClick: function(f) {
      return f.stopPropagation();
    },
    className: se(l, n)
  }), /* @__PURE__ */ c.createElement("div", {
    role: "presentation",
    className: "".concat(l, "-title"),
    title: typeof r == "string" ? r : void 0
  }, r), /* @__PURE__ */ c.createElement("ul", {
    role: "group",
    className: "".concat(l, "-list")
  }, o));
};
function qg(e) {
  var t = e.children, n = Yt(e, Rq), r = nu(n.eventKey), o = Gb(t, r), i = Kg();
  return i ? o : /* @__PURE__ */ c.createElement(Dq, dr(n, ["warnKey"]), o);
}
function qb(e) {
  var t = e.className, n = e.style, r = c.useContext(Hi), o = r.prefixCls, i = Kg();
  return i ? null : /* @__PURE__ */ c.createElement("li", {
    role: "separator",
    className: se("".concat(o, "-item-divider"), t),
    style: n
  });
}
var Tq = ["label", "children", "key", "type"];
function Y1(e) {
  return (e || []).map(function(t, n) {
    if (t && Vt(t) === "object") {
      var r = t, o = r.label, i = r.children, a = r.key, s = r.type, l = Yt(r, Tq), u = a != null ? a : "tmp-".concat(n);
      return i || s === "group" ? s === "group" ? /* @__PURE__ */ c.createElement(qg, Oe({
        key: u
      }, l, {
        title: o
      }), Y1(i)) : /* @__PURE__ */ c.createElement(Gg, Oe({
        key: u
      }, l, {
        title: o
      }), Y1(i)) : s === "divider" ? /* @__PURE__ */ c.createElement(qb, Oe({
        key: u
      }, l)) : /* @__PURE__ */ c.createElement(Ug, Oe({
        key: u
      }, l), o);
    }
    return null;
  }).filter(function(t) {
    return t;
  });
}
function Mq(e, t, n) {
  var r = e;
  return t && (r = Y1(t)), Gb(r, n);
}
var Lq = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem"], lc = [], Aq = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n, r, o = e, i = o.prefixCls, a = i === void 0 ? "rc-menu" : i, s = o.rootClassName, l = o.style, u = o.className, f = o.tabIndex, p = f === void 0 ? 0 : f, h = o.items, y = o.children, b = o.direction, m = o.id, v = o.mode, C = v === void 0 ? "vertical" : v, x = o.inlineCollapsed, S = o.disabled, E = o.disabledOverflow, O = o.subMenuOpenDelay, $ = O === void 0 ? 0.1 : O, _ = o.subMenuCloseDelay, R = _ === void 0 ? 0.1 : _, P = o.forceSubMenuRender, I = o.defaultOpenKeys, j = o.openKeys, F = o.activeKey, A = o.defaultActiveFirst, M = o.selectable, N = M === void 0 ? !0 : M, D = o.multiple, T = D === void 0 ? !1 : D, L = o.defaultSelectedKeys, z = o.selectedKeys, H = o.onSelect, V = o.onDeselect, Y = o.inlineIndent, Z = Y === void 0 ? 24 : Y, oe = o.motion, ee = o.defaultMotions, ae = o.triggerSubMenuAction, le = ae === void 0 ? "hover" : ae, ue = o.builtinPlacements, ie = o.itemIcon, re = o.expandIcon, Q = o.overflowedIndicator, ce = Q === void 0 ? "..." : Q, ge = o.overflowedIndicatorPopupClassName, G = o.getPopupContainer, ne = o.onClick, fe = o.onOpenChange, ye = o.onKeyDown, we = o.openAnimation, he = o.openTransitionName, me = o._internalRenderMenuItem, Ce = o._internalRenderSubMenuItem, Te = Yt(o, Lq), Ee = c.useMemo(function() {
    return Mq(y, h, lc);
  }, [y, h]), Ge = c.useState(!1), ke = de(Ge, 2), qe = ke[0], ze = ke[1], pt = c.useRef(), Ke = fq(m), et = b === "rtl";
  process.env.NODE_ENV !== "production" && mt(!we && !he, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var Je = Fn(I, {
    value: j,
    postState: function(Nt) {
      return Nt || lc;
    }
  }), Et = de(Je, 2), Ye = Et[0], wt = Et[1], dt = function(Nt) {
    var Qt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function vn() {
      wt(Nt), fe == null || fe(Nt);
    }
    Qt ? k0(vn) : vn();
  }, Ct = c.useState(Ye), ot = de(Ct, 2), jt = ot[0], Rt = ot[1], Le = c.useRef(!1), Ve = c.useMemo(function() {
    return (C === "inline" || C === "vertical") && x ? ["vertical", x] : [C, !1];
  }, [C, x]), Ae = de(Ve, 2), ft = Ae[0], He = Ae[1], Fe = ft === "inline", yt = c.useState(ft), Qe = de(yt, 2), tt = Qe[0], lt = Qe[1], ht = c.useState(He), bt = de(ht, 2), ct = bt[0], xt = bt[1];
  c.useEffect(function() {
    lt(ft), xt(He), Le.current && (Fe ? wt(jt) : dt(lc));
  }, [ft, He]);
  var vt = c.useState(0), _e = de(vt, 2), Ze = _e[0], q = _e[1], Se = Ze >= Ee.length - 1 || tt !== "horizontal" || E;
  c.useEffect(function() {
    Fe && Rt(Ye);
  }, [Ye]), c.useEffect(function() {
    return Le.current = !0, function() {
      Le.current = !1;
    };
  }, []);
  var Re = uq(), ut = Re.registerPath, $t = Re.unregisterPath, Ne = Re.refreshOverflowKeys, Ie = Re.isSubPathKey, De = Re.getKeyPath, Me = Re.getKeys, Tt = Re.getSubPathKeys, Pt = c.useMemo(function() {
    return {
      registerPath: ut,
      unregisterPath: $t
    };
  }, [ut, $t]), Ut = c.useMemo(function() {
    return {
      isSubPathKey: Ie
    };
  }, [Ie]);
  c.useEffect(function() {
    Ne(Se ? lc : Ee.slice(Ze + 1).map(function(At) {
      return At.key;
    }));
  }, [Ze, Se]);
  var Kt = Fn(F || A && ((n = Ee[0]) === null || n === void 0 ? void 0 : n.key), {
    value: F
  }), $n = de(Kt, 2), Jt = $n[0], On = $n[1], Jn = Xu(function(At) {
    On(At);
  }), er = Xu(function() {
    On(void 0);
  });
  Ua(t, function() {
    return {
      list: pt.current,
      focus: function(Nt) {
        var Qt, vn = Me(), sn = G1(vn, Ke), Mn = sn.elements, Wn = sn.key2element, Dr = sn.element2key, Gt = Wb(pt.current, Mn), Zt = Jt != null ? Jt : Gt[0] ? Dr.get(Gt[0]) : (Qt = Ee.find(function(yr) {
          return !yr.props.disabled;
        })) === null || Qt === void 0 ? void 0 : Qt.key, hn = Wn.get(Zt);
        if (Zt && hn) {
          var tn;
          hn == null || (tn = hn.focus) === null || tn === void 0 || tn.call(hn, Nt);
        }
      }
    };
  });
  var Xt = Fn(L || [], {
    value: z,
    // Legacy convert key to array
    postState: function(Nt) {
      return Array.isArray(Nt) ? Nt : Nt == null ? lc : [Nt];
    }
  }), It = de(Xt, 2), St = It[0], Lt = It[1], ln = function(Nt) {
    if (N) {
      var Qt = Nt.key, vn = St.includes(Qt), sn;
      T ? vn ? sn = St.filter(function(Wn) {
        return Wn !== Qt;
      }) : sn = [].concat(We(St), [Qt]) : sn = [Qt], Lt(sn);
      var Mn = J(J({}, Nt), {}, {
        selectedKeys: sn
      });
      vn ? V == null || V(Mn) : H == null || H(Mn);
    }
    !T && Ye.length && tt !== "inline" && dt(lc);
  }, lr = Xu(function(At) {
    ne == null || ne(Dh(At)), ln(At);
  }), fr = Xu(function(At, Nt) {
    var Qt = Ye.filter(function(sn) {
      return sn !== At;
    });
    if (Nt)
      Qt.push(At);
    else if (tt !== "inline") {
      var vn = Tt(At);
      Qt = Qt.filter(function(sn) {
        return !vn.has(sn);
      });
    }
    Fi(Ye, Qt, !0) || dt(Qt, !0);
  }), Er = function(Nt, Qt) {
    var vn = Qt != null ? Qt : !Ye.includes(Nt);
    fr(Nt, vn);
  }, Qr = sq(tt, Jt, et, Ke, pt, Me, De, On, Er, ye);
  c.useEffect(function() {
    ze(!0);
  }, []);
  var $r = c.useMemo(function() {
    return {
      _internalRenderMenuItem: me,
      _internalRenderSubMenuItem: Ce
    };
  }, [me, Ce]), Or = tt !== "horizontal" || E ? Ee : (
    // Need wrap for overflow dropdown that do not response for open
    Ee.map(function(At, Nt) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ c.createElement(Od, {
          key: At.key,
          overflowDisabled: Nt > Ze
        }, At)
      );
    })
  ), io = /* @__PURE__ */ c.createElement(la, Oe({
    id: m,
    ref: pt,
    prefixCls: "".concat(a, "-overflow"),
    component: "ul",
    itemComponent: Ug,
    className: se(a, "".concat(a, "-root"), "".concat(a, "-").concat(tt), u, (r = {}, K(r, "".concat(a, "-inline-collapsed"), ct), K(r, "".concat(a, "-rtl"), et), r), s),
    dir: b,
    style: l,
    role: "menu",
    tabIndex: p,
    data: Or,
    renderRawItem: function(Nt) {
      return Nt;
    },
    renderRawRest: function(Nt) {
      var Qt = Nt.length, vn = Qt ? Ee.slice(-Qt) : null;
      return /* @__PURE__ */ c.createElement(Gg, {
        eventKey: q1,
        title: ce,
        disabled: Se,
        internalPopupClose: Qt === 0,
        popupClassName: ge
      }, vn);
    },
    maxCount: tt !== "horizontal" || E ? la.INVALIDATE : la.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(Nt) {
      q(Nt);
    },
    onKeyDown: Qr
  }, Te));
  return /* @__PURE__ */ c.createElement(Vb.Provider, {
    value: $r
  }, /* @__PURE__ */ c.createElement(q6.Provider, {
    value: Ke
  }, /* @__PURE__ */ c.createElement(Od, {
    prefixCls: a,
    rootClassName: s,
    mode: tt,
    openKeys: Ye,
    rtl: et,
    disabled: S,
    motion: qe ? oe : null,
    defaultMotions: qe ? ee : null,
    activeKey: Jt,
    onActive: Jn,
    onInactive: er,
    selectedKeys: St,
    inlineIndent: Z,
    subMenuOpenDelay: $,
    subMenuCloseDelay: R,
    forceSubMenuRender: P,
    builtinPlacements: ue,
    triggerSubMenuAction: le,
    getPopupContainer: G,
    itemIcon: ie,
    expandIcon: re,
    onItemClick: lr,
    onOpenChange: fr
  }, /* @__PURE__ */ c.createElement(J6.Provider, {
    value: Ut
  }, io), /* @__PURE__ */ c.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ c.createElement(Z6.Provider, {
    value: Pt
  }, Ee)))));
}), tf = Aq;
tf.Item = Ug;
tf.SubMenu = Gg;
tf.ItemGroup = qg;
tf.Divider = qb;
var jq = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" };
const kq = jq;
var i_ = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: kq
  }));
};
process.env.NODE_ENV !== "production" && (i_.displayName = "BarsOutlined");
const Fq = /* @__PURE__ */ c.forwardRef(i_);
var Bq = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const Hq = Bq;
var a_ = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Hq
  }));
};
process.env.NODE_ENV !== "production" && (a_.displayName = "LeftOutlined");
const Th = /* @__PURE__ */ c.forwardRef(a_), zq = (e) => !isNaN(parseFloat(e)) && isFinite(e), s_ = /* @__PURE__ */ c.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
});
var Vq = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const cE = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, Yg = /* @__PURE__ */ c.createContext({}), Wq = /* @__PURE__ */ (() => {
  let e = 0;
  return function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e += 1, `${t}${e}`;
  };
})(), l_ = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    trigger: o,
    children: i,
    defaultCollapsed: a = !1,
    theme: s = "dark",
    style: l = {},
    collapsible: u = !1,
    reverseArrow: f = !1,
    width: p = 200,
    collapsedWidth: h = 80,
    zeroWidthTriggerStyle: y,
    breakpoint: b,
    onCollapse: m,
    onBreakpoint: v
  } = e, C = Vq(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: x
  } = Cn(s_), [S, E] = Ot("collapsed" in e ? e.collapsed : a), [O, $] = Ot(!1);
  kt(() => {
    "collapsed" in e && E(e.collapsed);
  }, [e.collapsed]);
  const _ = (A, M) => {
    "collapsed" in e || E(A), m == null || m(A, M);
  }, R = _t();
  R.current = (A) => {
    $(A.matches), v == null || v(A.matches), S !== A.matches && _(A.matches, "responsive");
  }, kt(() => {
    function A(N) {
      return R.current(N);
    }
    let M;
    if (typeof window != "undefined") {
      const {
        matchMedia: N
      } = window;
      if (N && b && b in cE) {
        M = N(`screen and (max-width: ${cE[b]})`);
        try {
          M.addEventListener("change", A);
        } catch (D) {
          M.addListener(A);
        }
        A(M);
      }
    }
    return () => {
      try {
        M == null || M.removeEventListener("change", A);
      } catch (N) {
        M == null || M.removeListener(A);
      }
    };
  }, [b]), kt(() => {
    const A = Wq("ant-sider-");
    return x.addSider(A), () => x.removeSider(A);
  }, []);
  const P = () => {
    _(!S, "clickTrigger");
  }, {
    getPrefixCls: I
  } = Cn(Ft), j = () => {
    const A = I("layout-sider", n), M = dr(C, ["collapsed"]), N = S ? h : p, D = zq(N) ? `${N}px` : String(N), T = parseFloat(String(h || 0)) === 0 ? /* @__PURE__ */ c.createElement("span", {
      onClick: P,
      className: se(`${A}-zero-width-trigger`, `${A}-zero-width-trigger-${f ? "right" : "left"}`),
      style: y
    }, o || /* @__PURE__ */ c.createElement(Fq, null)) : null, H = {
      expanded: f ? /* @__PURE__ */ c.createElement(Fc, null) : /* @__PURE__ */ c.createElement(Th, null),
      collapsed: f ? /* @__PURE__ */ c.createElement(Th, null) : /* @__PURE__ */ c.createElement(Fc, null)
    }[S ? "collapsed" : "expanded"], V = o !== null ? T || /* @__PURE__ */ c.createElement("div", {
      className: `${A}-trigger`,
      onClick: P,
      style: {
        width: D
      }
    }, o || H) : null, Y = Object.assign(Object.assign({}, l), {
      flex: `0 0 ${D}`,
      maxWidth: D,
      minWidth: D,
      width: D
    }), Z = se(A, `${A}-${s}`, {
      [`${A}-collapsed`]: !!S,
      [`${A}-has-trigger`]: u && o !== null && !T,
      [`${A}-below`]: !!O,
      [`${A}-zero-width`]: parseFloat(D) === 0
    }, r);
    return /* @__PURE__ */ c.createElement("aside", Object.assign({
      className: Z
    }, M, {
      style: Y,
      ref: t
    }), /* @__PURE__ */ c.createElement("div", {
      className: `${A}-children`
    }, i), u || O && T ? V : null);
  }, F = c.useMemo(() => ({
    siderCollapsed: S
  }), [S]);
  return /* @__PURE__ */ c.createElement(Yg.Provider, {
    value: F
  }, j());
});
process.env.NODE_ENV !== "production" && (l_.displayName = "Sider");
const c_ = l_;
var Kq = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
const Uq = Kq;
var u_ = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Uq
  }));
};
process.env.NODE_ENV !== "production" && (u_.displayName = "EllipsisOutlined");
const d_ = /* @__PURE__ */ c.forwardRef(u_);
var Gq = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const qq = (e) => {
  const {
    prefixCls: t,
    className: n,
    dashed: r
  } = e, o = Gq(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: i
  } = c.useContext(Ft), a = i("menu", t), s = se({
    [`${a}-item-divider-dashed`]: !!r
  }, n);
  return /* @__PURE__ */ c.createElement(qb, Object.assign({
    className: s
  }, o));
}, f_ = qq, Yq = /* @__PURE__ */ Rs({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
}), Mh = Yq, Xq = (e) => {
  var t;
  const {
    className: n,
    children: r,
    icon: o,
    title: i,
    danger: a
  } = e, {
    prefixCls: s,
    firstLevel: l,
    direction: u,
    disableMenuItemTitleTooltip: f,
    inlineCollapsed: p
  } = c.useContext(Mh), h = (x) => {
    const S = /* @__PURE__ */ c.createElement("span", {
      className: `${s}-title-content`
    }, r);
    return (!o || ti(r) && r.type === "span") && r && x && l && typeof r == "string" ? /* @__PURE__ */ c.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, r.charAt(0)) : S;
  }, {
    siderCollapsed: y
  } = c.useContext(Yg);
  let b = i;
  typeof i == "undefined" ? b = l ? r : "" : i === !1 && (b = "");
  const m = {
    title: b
  };
  !y && !p && (m.title = null, m.open = !1);
  const v = Rr(r).length;
  let C = /* @__PURE__ */ c.createElement(Ug, Object.assign({}, dr(e, ["title", "icon", "danger"]), {
    className: se({
      [`${s}-item-danger`]: a,
      [`${s}-item-only-child`]: (o ? v + 1 : v) === 1
    }, n),
    title: typeof i == "string" ? i : void 0
  }), Yr(o, {
    className: se(ti(o) ? (t = o.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
  }), h(p));
  return f || (C = /* @__PURE__ */ c.createElement(Bo, Object.assign({}, m, {
    placement: u === "rtl" ? "left" : "right",
    overlayClassName: `${s}-inline-collapsed-tooltip`
  }), C)), C;
}, p_ = Xq, Zq = (e) => {
  var t;
  const {
    popupClassName: n,
    icon: r,
    title: o,
    theme: i
  } = e, a = c.useContext(Mh), {
    prefixCls: s,
    inlineCollapsed: l,
    theme: u
  } = a, f = nu();
  let p;
  if (!r)
    p = l && !f.length && o && typeof o == "string" ? /* @__PURE__ */ c.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, o.charAt(0)) : /* @__PURE__ */ c.createElement("span", {
      className: `${s}-title-content`
    }, o);
  else {
    const b = ti(o) && o.type === "span";
    p = /* @__PURE__ */ c.createElement(c.Fragment, null, Yr(r, {
      className: se(ti(r) ? (t = r.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
    }), b ? o : /* @__PURE__ */ c.createElement("span", {
      className: `${s}-title-content`
    }, o));
  }
  const h = c.useMemo(() => Object.assign(Object.assign({}, a), {
    firstLevel: !1
  }), [a]), [y] = Ts("Menu");
  return /* @__PURE__ */ c.createElement(Mh.Provider, {
    value: h
  }, /* @__PURE__ */ c.createElement(Gg, Object.assign({}, dr(e, ["icon"]), {
    title: p,
    popupClassName: se(s, n, `${s}-${i || u}`),
    popupStyle: {
      zIndex: y
    }
  })));
}, h_ = Zq;
var Qq = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function X1(e) {
  return (e || []).map((t, n) => {
    if (t && typeof t == "object") {
      const r = t, {
        label: o,
        children: i,
        key: a,
        type: s
      } = r, l = Qq(r, ["label", "children", "key", "type"]), u = a != null ? a : `tmp-${n}`;
      return i || s === "group" ? s === "group" ? /* @__PURE__ */ c.createElement(qg, Object.assign({
        key: u
      }, l, {
        title: o
      }), X1(i)) : /* @__PURE__ */ c.createElement(h_, Object.assign({
        key: u
      }, l, {
        title: o
      }), X1(i)) : s === "divider" ? /* @__PURE__ */ c.createElement(f_, Object.assign({
        key: u
      }, l)) : /* @__PURE__ */ c.createElement(p_, Object.assign({
        key: u
      }, l), o);
    }
    return null;
  }).filter((t) => t);
}
function Jq(e) {
  return c.useMemo(() => e && X1(e), [e]);
}
var eY = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Lh = /* @__PURE__ */ c.createContext(null), g_ = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    children: n
  } = e, r = eY(e, ["children"]), o = c.useContext(Lh), i = c.useMemo(() => Object.assign(Object.assign({}, o), r), [
    o,
    r.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    r.mode,
    r.selectable,
    r.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), a = Zj(n), s = Ol(t, a ? n.ref : null);
  return /* @__PURE__ */ c.createElement(Lh.Provider, {
    value: i
  }, /* @__PURE__ */ c.createElement(vl, null, a ? /* @__PURE__ */ c.cloneElement(n, {
    ref: s
  }) : n));
}), tY = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    horizontalLineHeight: r,
    colorSplit: o,
    lineWidth: i,
    lineType: a,
    itemPaddingInline: s
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: r,
      border: 0,
      borderBottom: `${te(i)} ${a} ${o}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: s
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${n}`, `background ${n}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, nY = (e) => {
  let {
    componentCls: t,
    menuArrowOffset: n,
    calc: r
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    },
    [`${t}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${t}-rtl${t}-vertical,
    ${t}-submenu-rtl ${t}-vertical`]: {
      [`${t}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(${te(r(n).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${te(n)})`
        }
      }
    }
  };
}, uE = (e) => Object.assign({}, Va(e)), dE = (e, t) => {
  const {
    componentCls: n,
    itemColor: r,
    itemSelectedColor: o,
    groupTitleColor: i,
    itemBg: a,
    subMenuItemBg: s,
    itemSelectedBg: l,
    activeBarHeight: u,
    activeBarWidth: f,
    activeBarBorderWidth: p,
    motionDurationSlow: h,
    motionEaseInOut: y,
    motionEaseOut: b,
    itemPaddingInline: m,
    motionDurationMid: v,
    itemHoverColor: C,
    lineType: x,
    colorSplit: S,
    // Disabled
    itemDisabledColor: E,
    // Danger
    dangerItemColor: O,
    dangerItemHoverColor: $,
    dangerItemSelectedColor: _,
    dangerItemActiveBg: R,
    dangerItemSelectedBg: P,
    // Bg
    popupBg: I,
    itemHoverBg: j,
    itemActiveBg: F,
    menuSubMenuBg: A,
    // Horizontal
    horizontalItemSelectedColor: M,
    horizontalItemSelectedBg: N,
    horizontalItemBorderRadius: D,
    horizontalItemHoverBg: T
  } = e;
  return {
    [`${n}-${t}, ${n}-${t} > ${n}`]: {
      color: r,
      background: a,
      [`&${n}-root:focus-visible`]: Object.assign({}, uE(e)),
      // ======================== Item ========================
      [`${n}-item-group-title`]: {
        color: i
      },
      [`${n}-submenu-selected`]: {
        [`> ${n}-submenu-title`]: {
          color: o
        }
      },
      // Disabled
      [`${n}-item-disabled, ${n}-submenu-disabled`]: {
        color: `${E} !important`
      },
      // Hover
      [`${n}-item:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
        [`&:hover, > ${n}-submenu-title:hover`]: {
          color: C
        }
      },
      [`&:not(${n}-horizontal)`]: {
        [`${n}-item:not(${n}-item-selected)`]: {
          "&:hover": {
            backgroundColor: j
          },
          "&:active": {
            backgroundColor: F
          }
        },
        [`${n}-submenu-title`]: {
          "&:hover": {
            backgroundColor: j
          },
          "&:active": {
            backgroundColor: F
          }
        }
      },
      // Danger - only Item has
      [`${n}-item-danger`]: {
        color: O,
        [`&${n}-item:hover`]: {
          [`&:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
            color: $
          }
        },
        [`&${n}-item:active`]: {
          background: R
        }
      },
      [`${n}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${n}-item-selected`]: {
        color: o,
        // Danger
        [`&${n}-item-danger`]: {
          color: _
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${n}-item-selected`]: {
        backgroundColor: l,
        // Danger
        [`&${n}-item-danger`]: {
          backgroundColor: P
        }
      },
      [`${n}-item, ${n}-submenu-title`]: {
        [`&:not(${n}-item-disabled):focus-visible`]: Object.assign({}, uE(e))
      },
      [`&${n}-submenu > ${n}`]: {
        backgroundColor: A
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${n}-popup > ${n}`]: {
        backgroundColor: I
      },
      [`&${n}-submenu-popup > ${n}`]: {
        backgroundColor: I
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${n}-horizontal`]: Object.assign(Object.assign({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${n}-item, > ${n}-submenu`]: {
          top: p,
          marginTop: e.calc(p).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: D,
          "&::after": {
            position: "absolute",
            insetInline: m,
            bottom: 0,
            borderBottom: `${te(u)} solid transparent`,
            transition: `border-color ${h} ${y}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: T,
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: M
            }
          },
          "&-selected": {
            color: M,
            backgroundColor: N,
            "&:hover": {
              backgroundColor: N
            },
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: M
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${n}-root`]: {
        [`&${n}-inline, &${n}-vertical`]: {
          borderInlineEnd: `${te(p)} ${x} ${S}`
        }
      },
      // ======================== Inline ========================
      [`&${n}-inline`]: {
        // Sub
        [`${n}-sub${n}-inline`]: {
          background: s
        },
        [`${n}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${te(f)} solid ${o}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${v} ${b}`, `opacity ${v} ${b}`].join(","),
            content: '""'
          },
          // Danger
          [`&${n}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: _
            }
          }
        },
        [`${n}-selected, ${n}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${v} ${y}`, `opacity ${v} ${y}`].join(",")
          }
        }
      }
    }
  };
}, fE = (e) => {
  const {
    componentCls: t,
    itemHeight: n,
    itemMarginInline: r,
    padding: o,
    menuArrowSize: i,
    marginXS: a,
    itemMarginBlock: s,
    itemWidth: l
  } = e, u = e.calc(i).add(o).add(a).equal();
  return {
    [`${t}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: n,
      lineHeight: te(n),
      paddingInline: o,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: r,
      marginBlock: s,
      width: l
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: n,
      lineHeight: te(n)
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: u
    }
  };
}, rY = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    itemHeight: r,
    colorTextLightSolid: o,
    dropdownWidth: i,
    controlHeightLG: a,
    motionDurationMid: s,
    motionEaseOut: l,
    paddingXL: u,
    itemMarginInline: f,
    fontSizeLG: p,
    motionDurationSlow: h,
    paddingXS: y,
    boxShadowSecondary: b,
    collapsedWidth: m,
    collapsedIconSize: v
  } = e, C = {
    height: r,
    lineHeight: te(r),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        "&-inline, &-vertical": Object.assign({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, fE(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: Object.assign(Object.assign({}, fE(e)), {
          boxShadow: b
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: i,
        maxHeight: `calc(100vh - ${te(e.calc(a).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${h}`, `background ${h}`, `padding ${s} ${l}`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: C,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: u
          }
        },
        // >>>>> Item
        [`${t}-item`]: C
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: m,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: p,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${te(e.calc(p).div(2).equal())} - ${te(f)})`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${n}`]: {
            margin: 0,
            fontSize: v,
            lineHeight: te(r),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${n}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${n}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: o
          }
        },
        [`${t}-item-group-title`]: Object.assign(Object.assign({}, gl), {
          paddingInline: y
        })
      }
    }
  ];
}, pE = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionDurationMid: r,
    motionEaseInOut: o,
    motionEaseOut: i,
    iconCls: a,
    iconSize: s,
    iconMarginInlineEnd: l
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${n}`, `background ${n}`, `padding ${n} ${o}`].join(","),
      [`${t}-item-icon, ${a}`]: {
        minWidth: s,
        fontSize: s,
        transition: [`font-size ${r} ${i}`, `margin ${n} ${o}`, `color ${n}`].join(","),
        "+ span": {
          marginInlineStart: l,
          opacity: 1,
          transition: [`opacity ${n} ${o}`, `margin ${n}`, `color ${n}`].join(",")
        }
      },
      [`${t}-item-icon`]: Object.assign({}, Ud()),
      [`&${t}-item-only-child`]: {
        [`> ${a}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, hE = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionEaseInOut: r,
    borderRadius: o,
    menuArrowSize: i,
    menuArrowOffset: a
  } = e;
  return {
    [`${t}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: i,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${n} ${r}, opacity ${n}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(i).mul(0.6).equal(),
          height: e.calc(i).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: o,
          transition: [`background ${n} ${r}`, `transform ${n} ${r}`, `top ${n} ${r}`, `color ${n} ${r}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${te(e.calc(a).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${te(a)})`
        }
      }
    }
  };
}, oY = (e) => {
  const {
    antCls: t,
    componentCls: n,
    fontSize: r,
    motionDurationSlow: o,
    motionDurationMid: i,
    motionEaseInOut: a,
    paddingXS: s,
    padding: l,
    colorSplit: u,
    lineWidth: f,
    zIndexPopup: p,
    borderRadiusLG: h,
    subMenuItemBorderRadius: y,
    menuArrowSize: b,
    menuArrowOffset: m,
    lineType: v,
    menuPanelMaskInset: C,
    groupTitleLineHeight: x,
    groupTitleFontSize: S
  } = e;
  return [
    // Misc
    {
      "": {
        [`${n}`]: Object.assign(Object.assign({}, Eh()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${n}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [n]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e)), Eh()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: r,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${o} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${n}-item`]: {
            flex: "none"
          }
        },
        [`${n}-item, ${n}-submenu, ${n}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${n}-item-group-title`]: {
          padding: `${te(s)} ${te(l)}`,
          fontSize: S,
          lineHeight: x,
          transition: `all ${o}`
        },
        [`&-horizontal ${n}-submenu`]: {
          transition: [`border-color ${o} ${a}`, `background ${o} ${a}`].join(",")
        },
        [`${n}-submenu, ${n}-submenu-inline`]: {
          transition: [`border-color ${o} ${a}`, `background ${o} ${a}`, `padding ${i} ${a}`].join(",")
        },
        [`${n}-submenu ${n}-sub`]: {
          cursor: "initial",
          transition: [`background ${o} ${a}`, `padding ${o} ${a}`].join(",")
        },
        [`${n}-title-content`]: {
          transition: `color ${o}`,
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${t}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          }
        },
        [`${n}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${n}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: u,
          borderStyle: v,
          borderWidth: 0,
          borderTopWidth: f,
          marginBlock: f,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), pE(e)), {
        [`${n}-item-group`]: {
          [`${n}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${n}-item, ${n}-submenu-title`]: {
              paddingInline: `${te(e.calc(r).mul(2).equal())} ${te(l)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: p,
            borderRadius: h,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${n}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: `${te(C)} 0 0`,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            }
          },
          // https://github.com/ant-design/ant-design/issues/13955
          "&-placement-rightTop::before": {
            top: 0,
            insetInlineStart: C
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: e.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: e.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: e.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: e.paddingXS
          },
          [`> ${n}`]: Object.assign(Object.assign(Object.assign({
            borderRadius: h
          }, pE(e)), hE(e)), {
            [`${n}-item, ${n}-submenu > ${n}-submenu-title`]: {
              borderRadius: y
            },
            [`${n}-submenu-title::after`]: {
              transition: `transform ${o} ${a}`
            }
          })
        }
      }), hE(e)), {
        [`&-inline-collapsed ${n}-submenu-arrow,
        &-inline ${n}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${te(m)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${te(e.calc(m).mul(-1).equal())})`
          }
        },
        [`${n}-submenu-open${n}-submenu-inline > ${n}-submenu-title > ${n}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${te(e.calc(b).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${te(e.calc(m).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${te(m)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [n]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, iY = (e) => {
  var t, n, r;
  const {
    colorPrimary: o,
    colorError: i,
    colorTextDisabled: a,
    colorErrorBg: s,
    colorText: l,
    colorTextDescription: u,
    colorBgContainer: f,
    colorFillAlter: p,
    colorFillContent: h,
    lineWidth: y,
    lineWidthBold: b,
    controlItemBgActive: m,
    colorBgTextHover: v,
    controlHeightLG: C,
    lineHeight: x,
    colorBgElevated: S,
    marginXXS: E,
    padding: O,
    fontSize: $,
    controlHeightSM: _,
    fontSizeLG: R,
    colorTextLightSolid: P,
    colorErrorHover: I
  } = e, j = (t = e.activeBarWidth) !== null && t !== void 0 ? t : 0, F = (n = e.activeBarBorderWidth) !== null && n !== void 0 ? n : y, A = (r = e.itemMarginInline) !== null && r !== void 0 ? r : e.marginXXS, M = new sr(P).setAlpha(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: l,
    itemColor: l,
    colorItemTextHover: l,
    itemHoverColor: l,
    colorItemTextHoverHorizontal: o,
    horizontalItemHoverColor: o,
    colorGroupTitle: u,
    groupTitleColor: u,
    colorItemTextSelected: o,
    itemSelectedColor: o,
    colorItemTextSelectedHorizontal: o,
    horizontalItemSelectedColor: o,
    colorItemBg: f,
    itemBg: f,
    colorItemBgHover: v,
    itemHoverBg: v,
    colorItemBgActive: h,
    itemActiveBg: m,
    colorSubItemBg: p,
    subMenuItemBg: p,
    colorItemBgSelected: m,
    itemSelectedBg: m,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: j,
    colorActiveBarHeight: b,
    activeBarHeight: b,
    colorActiveBarBorderSize: y,
    activeBarBorderWidth: F,
    // Disabled
    colorItemTextDisabled: a,
    itemDisabledColor: a,
    // Danger
    colorDangerItemText: i,
    dangerItemColor: i,
    colorDangerItemTextHover: i,
    dangerItemHoverColor: i,
    colorDangerItemTextSelected: i,
    dangerItemSelectedColor: i,
    colorDangerItemBgActive: s,
    dangerItemActiveBg: s,
    colorDangerItemBgSelected: s,
    dangerItemSelectedBg: s,
    itemMarginInline: A,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: C,
    groupTitleLineHeight: x,
    collapsedWidth: C * 2,
    popupBg: S,
    itemMarginBlock: E,
    itemPaddingInline: O,
    horizontalLineHeight: `${C * 1.15}px`,
    iconSize: $,
    iconMarginInlineEnd: _ - $,
    collapsedIconSize: R,
    groupTitleFontSize: $,
    // Disabled
    darkItemDisabledColor: new sr(P).setAlpha(0.25).toRgbString(),
    // Dark
    darkItemColor: M,
    darkDangerItemColor: i,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: P,
    darkItemSelectedBg: o,
    darkDangerItemSelectedBg: i,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: M,
    darkItemHoverColor: P,
    darkDangerItemHoverColor: I,
    darkDangerItemSelectedColor: P,
    darkDangerItemActiveBg: i,
    // internal
    itemWidth: j ? `calc(100% + ${F}px)` : `calc(100% - ${A * 2}px)`
  };
}, aY = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return Gn("Menu", (o) => {
    const {
      colorBgElevated: i,
      colorPrimary: a,
      colorTextLightSolid: s,
      controlHeightLG: l,
      fontSize: u,
      darkItemColor: f,
      darkDangerItemColor: p,
      darkItemBg: h,
      darkSubMenuItemBg: y,
      darkItemSelectedColor: b,
      darkItemSelectedBg: m,
      darkDangerItemSelectedBg: v,
      darkItemHoverBg: C,
      darkGroupTitleColor: x,
      darkItemHoverColor: S,
      darkItemDisabledColor: E,
      darkDangerItemHoverColor: O,
      darkDangerItemSelectedColor: $,
      darkDangerItemActiveBg: _,
      popupBg: R,
      darkPopupBg: P
    } = o, I = o.calc(u).div(7).mul(5).equal(), j = Sn(o, {
      menuArrowSize: I,
      menuHorizontalHeight: o.calc(l).mul(1.15).equal(),
      menuArrowOffset: o.calc(I).mul(0.25).equal(),
      menuPanelMaskInset: -7,
      // Still a hardcode here since it's offset by rc-align
      menuSubMenuBg: i,
      calc: o.calc,
      popupBg: R
    }), F = Sn(j, {
      itemColor: f,
      itemHoverColor: S,
      groupTitleColor: x,
      itemSelectedColor: b,
      itemBg: h,
      popupBg: P,
      subMenuItemBg: y,
      itemActiveBg: "transparent",
      itemSelectedBg: m,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: C,
      // Disabled
      itemDisabledColor: E,
      // Danger
      dangerItemColor: p,
      dangerItemHoverColor: O,
      dangerItemSelectedColor: $,
      dangerItemActiveBg: _,
      dangerItemSelectedBg: v,
      menuSubMenuBg: y,
      // Horizontal
      horizontalItemSelectedColor: s,
      horizontalItemSelectedBg: a
    });
    return [
      // Basic
      oY(j),
      // Horizontal
      tY(j),
      // Hard code for some light style
      // Vertical
      rY(j),
      // Hard code for some light style
      // Theme
      dE(j, "light"),
      dE(F, "dark"),
      // RTL
      nY(j),
      // Motion
      Ag(j),
      _s(j, "slide-up"),
      _s(j, "slide-down"),
      Lg(j, "zoom-big")
    ];
  }, iY, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: n,
    unitless: {
      groupTitleLineHeight: !0
    }
  })(e, t);
};
var sY = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const lY = /* @__PURE__ */ ni((e, t) => {
  var n, r;
  const o = c.useContext(Lh), i = o || {}, {
    getPrefixCls: a,
    getPopupContainer: s,
    direction: l,
    menu: u
  } = c.useContext(Ft), f = a(), {
    prefixCls: p,
    className: h,
    style: y,
    theme: b = "light",
    expandIcon: m,
    _internalDisableMenuItemTitleTooltip: v,
    inlineCollapsed: C,
    siderCollapsed: x,
    items: S,
    children: E,
    rootClassName: O,
    mode: $,
    selectable: _,
    onClick: R,
    overflowedIndicatorPopupClassName: P
  } = e, I = sY(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "items", "children", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), j = dr(I, ["collapsedWidth"]), F = Jq(S) || E;
  if (process.env.NODE_ENV !== "production") {
    const ae = xn("Menu");
    process.env.NODE_ENV !== "production" && ae(!("inlineCollapsed" in e && $ !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), process.env.NODE_ENV !== "production" && ae(!(e.siderCollapsed !== void 0 && "inlineCollapsed" in e), "usage", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead."), ae.deprecated("items" in e && !E, "children", "items");
  }
  (n = i.validator) === null || n === void 0 || n.call(i, {
    mode: $
  });
  const A = Ir(function() {
    var ae;
    R == null || R.apply(void 0, arguments), (ae = i.onClick) === null || ae === void 0 || ae.call(i);
  }), M = i.mode || $, N = _ != null ? _ : i.selectable, D = c.useMemo(() => x !== void 0 ? x : C, [C, x]), T = {
    horizontal: {
      motionName: `${f}-slide-up`
    },
    inline: xd(f),
    other: {
      motionName: `${f}-zoom-big`
    }
  }, L = a("menu", p || i.prefixCls), z = Ar(L), [H, V, Y] = aY(L, z, !o), Z = se(`${L}-${b}`, u == null ? void 0 : u.className, h);
  let oe;
  if (typeof m == "function")
    oe = m;
  else if (m === null || m === !1)
    oe = null;
  else if (i.expandIcon === null || i.expandIcon === !1)
    oe = null;
  else {
    const ae = m != null ? m : i.expandIcon;
    oe = Yr(ae, {
      className: se(`${L}-submenu-expand-icon`, ti(ae) ? (r = ae.props) === null || r === void 0 ? void 0 : r.className : "")
    });
  }
  const ee = c.useMemo(() => ({
    prefixCls: L,
    inlineCollapsed: D || !1,
    direction: l,
    firstLevel: !0,
    theme: b,
    mode: M,
    disableMenuItemTitleTooltip: v
  }), [L, D, l, v, b]);
  return H(/* @__PURE__ */ c.createElement(Lh.Provider, {
    value: null
  }, /* @__PURE__ */ c.createElement(Mh.Provider, {
    value: ee
  }, /* @__PURE__ */ c.createElement(tf, Object.assign({
    getPopupContainer: s,
    overflowedIndicator: /* @__PURE__ */ c.createElement(d_, null),
    overflowedIndicatorPopupClassName: se(L, `${L}-${b}`, P),
    mode: M,
    selectable: N,
    onClick: A
  }, j, {
    inlineCollapsed: D,
    style: Object.assign(Object.assign({}, u == null ? void 0 : u.style), y),
    className: Z,
    prefixCls: L,
    direction: l,
    defaultMotions: T,
    expandIcon: oe,
    ref: t,
    rootClassName: se(O, V, i.rootClassName, Y, z)
  }), F))));
}), cY = lY, ru = /* @__PURE__ */ ni((e, t) => {
  const n = _t(null), r = c.useContext(Yg);
  return Ua(t, () => ({
    menu: n.current,
    focus: (o) => {
      var i;
      (i = n.current) === null || i === void 0 || i.focus(o);
    }
  })), /* @__PURE__ */ c.createElement(cY, Object.assign({
    ref: n
  }, e, r));
});
ru.Item = p_;
ru.SubMenu = h_;
ru.Divider = f_;
ru.ItemGroup = qg;
process.env.NODE_ENV !== "production" && (ru.displayName = "Menu");
const m_ = ru, uY = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    colorError: r,
    colorTextLightSolid: o
  } = e, i = `${n}-item`;
  return {
    [`${t}, ${t}-menu-submenu`]: {
      [`${n} ${i}`]: {
        [`&${i}-danger:not(${i}-disabled)`]: {
          color: r,
          "&:hover": {
            color: o,
            backgroundColor: r
          }
        }
      }
    }
  };
}, dY = (e) => {
  const {
    componentCls: t,
    menuCls: n,
    zIndexPopup: r,
    dropdownArrowDistance: o,
    sizePopupArrow: i,
    antCls: a,
    iconCls: s,
    motionDurationMid: l,
    paddingBlock: u,
    fontSize: f,
    dropdownEdgeChildPadding: p,
    colorTextDisabled: h,
    fontSizeIcon: y,
    controlPaddingHorizontal: b,
    colorBgElevated: m
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, Qn(e)), {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: r,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(i).div(2).sub(o).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`&-trigger${a}-btn`]: {
          [`& > ${s}-down, & > ${a}-btn-icon > ${s}-down`]: {
            fontSize: y
          }
        },
        [`${t}-wrap`]: {
          position: "relative",
          [`${a}-btn > ${s}-down`]: {
            fontSize: y
          },
          [`${s}-down::before`]: {
            transition: `transform ${l}`
          }
        },
        [`${t}-wrap-open`]: {
          [`${s}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${a}-slide-down-enter${a}-slide-down-enter-active${t}-placement-bottomLeft,
          &${a}-slide-down-appear${a}-slide-down-appear-active${t}-placement-bottomLeft,
          &${a}-slide-down-enter${a}-slide-down-enter-active${t}-placement-bottom,
          &${a}-slide-down-appear${a}-slide-down-appear-active${t}-placement-bottom,
          &${a}-slide-down-enter${a}-slide-down-enter-active${t}-placement-bottomRight,
          &${a}-slide-down-appear${a}-slide-down-appear-active${t}-placement-bottomRight`]: {
          animationName: Rg
        },
        [`&${a}-slide-up-enter${a}-slide-up-enter-active${t}-placement-topLeft,
          &${a}-slide-up-appear${a}-slide-up-appear-active${t}-placement-topLeft,
          &${a}-slide-up-enter${a}-slide-up-enter-active${t}-placement-top,
          &${a}-slide-up-appear${a}-slide-up-appear-active${t}-placement-top,
          &${a}-slide-up-enter${a}-slide-up-enter-active${t}-placement-topRight,
          &${a}-slide-up-appear${a}-slide-up-appear-active${t}-placement-topRight`]: {
          animationName: Tg
        },
        [`&${a}-slide-down-leave${a}-slide-down-leave-active${t}-placement-bottomLeft,
          &${a}-slide-down-leave${a}-slide-down-leave-active${t}-placement-bottom,
          &${a}-slide-down-leave${a}-slide-down-leave-active${t}-placement-bottomRight`]: {
          animationName: Dg
        },
        [`&${a}-slide-up-leave${a}-slide-up-leave-active${t}-placement-topLeft,
          &${a}-slide-up-leave${a}-slide-up-leave-active${t}-placement-top,
          &${a}-slide-up-leave${a}-slide-up-leave-active${t}-placement-topRight`]: {
          animationName: Mg
        }
      })
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    Bb(e, m, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${t} ${n}`]: {
        position: "relative",
        margin: 0
      },
      [`${n}-submenu-popup`]: {
        position: "absolute",
        zIndex: r,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${t}, ${t}-menu-submenu`]: {
        [n]: Object.assign(Object.assign({
          padding: p,
          listStyleType: "none",
          backgroundColor: m,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, $h(e)), {
          [`${n}-item-group-title`]: {
            padding: `${te(u)} ${te(b)}`,
            color: e.colorTextDescription,
            transition: `all ${l}`
          },
          // ======================= Item Content =======================
          [`${n}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${n}-item-icon`]: {
            minWidth: f,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${n}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${l}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${n}-item, ${n}-submenu-title`]: Object.assign(Object.assign({
            clear: "both",
            margin: 0,
            padding: `${te(u)} ${te(b)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: f,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${l}`,
            borderRadius: e.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, $h(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: h,
              cursor: "not-allowed",
              "&:hover": {
                color: h,
                backgroundColor: m,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${te(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${t}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${t}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorTextDescription,
                fontSize: y,
                fontStyle: "normal"
              }
            }
          }),
          [`${n}-item-group-list`]: {
            margin: `0 ${te(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${n}-submenu-title`]: {
            paddingInlineEnd: e.calc(b).add(e.fontSizeSM).equal()
          },
          [`${n}-submenu-vertical`]: {
            position: "relative"
          },
          [`${n}-submenu${n}-submenu-disabled ${t}-menu-submenu-title`]: {
            [`&, ${t}-menu-submenu-arrow-icon`]: {
              color: h,
              backgroundColor: m,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${n}-submenu-selected ${t}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      }
    },
    // Follow code may reuse in other components
    [_s(e, "slide-up"), _s(e, "slide-down"), Ac(e, "move-up"), Ac(e, "move-down"), Lg(e, "zoom-big")]
  ];
}, fY = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, Wg({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), Vg(e)), pY = Gn("Dropdown", (e) => {
  const {
    marginXXS: t,
    sizePopupArrow: n,
    paddingXXS: r,
    componentCls: o
  } = e, i = Sn(e, {
    menuCls: `${o}-menu`,
    dropdownArrowDistance: e.calc(n).div(2).add(t).equal(),
    dropdownEdgeChildPadding: r
  });
  return [dY(i), uY(i)];
}, fY), Xg = (e) => {
  const {
    menu: t,
    arrow: n,
    prefixCls: r,
    children: o,
    trigger: i,
    disabled: a,
    dropdownRender: s,
    getPopupContainer: l,
    overlayClassName: u,
    rootClassName: f,
    overlayStyle: p,
    open: h,
    onOpenChange: y,
    // Deprecated
    visible: b,
    onVisibleChange: m,
    mouseEnterDelay: v = 0.15,
    mouseLeaveDelay: C = 0.1,
    autoAdjustOverflow: x = !0,
    placement: S = "",
    overlay: E,
    transitionName: O
  } = e, {
    getPopupContainer: $,
    getPrefixCls: _,
    direction: R,
    dropdown: P
  } = c.useContext(Ft), I = xn("Dropdown");
  process.env.NODE_ENV !== "production" && ([["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((ge) => {
    let [G, ne] = ge;
    I.deprecated(!(G in e), G, ne);
  }), I.deprecated(!("overlay" in e), "overlay", "menu"));
  const j = c.useMemo(() => {
    const ge = _();
    return O !== void 0 ? O : S.includes("top") ? `${ge}-slide-down` : `${ge}-slide-up`;
  }, [_, S, O]), F = c.useMemo(() => S ? S.includes("Center") ? S.slice(0, S.indexOf("Center")) : S : R === "rtl" ? "bottomRight" : "bottomLeft", [S, R]);
  if (process.env.NODE_ENV !== "production") {
    if (S.includes("Center")) {
      const ge = S.slice(0, S.indexOf("Center"));
      process.env.NODE_ENV !== "production" && I(!S.includes("Center"), "deprecated", `You are using '${S}' placement in Dropdown, which is deprecated. Try to use '${ge}' instead.`);
    }
    [["visible", "open"], ["onVisibleChange", "onOpenChange"]].forEach((ge) => {
      let [G, ne] = ge;
      I.deprecated(!(G in e), G, ne);
    });
  }
  const A = _("dropdown", r), M = Ar(A), [N, D, T] = pY(A, M), [, L] = ro(), z = c.Children.only(o), H = Yr(z, {
    className: se(`${A}-trigger`, {
      [`${A}-rtl`]: R === "rtl"
    }, z.props.className),
    disabled: a
  }), V = a ? [] : i;
  let Y;
  V && V.includes("contextMenu") && (Y = !0);
  const [Z, oe] = Fn(!1, {
    value: h != null ? h : b
  }), ee = Ir((ge) => {
    y == null || y(ge, {
      source: "trigger"
    }), m == null || m(ge), oe(ge);
  }), ae = se(u, f, D, T, M, P == null ? void 0 : P.className, {
    [`${A}-rtl`]: R === "rtl"
  }), le = B6({
    arrowPointAtCenter: typeof n == "object" && n.pointAtCenter,
    autoAdjustOverflow: x,
    offset: L.marginXXS,
    arrowWidth: n ? L.sizePopupArrow : 0,
    borderRadius: L.borderRadius
  }), ue = c.useCallback(() => {
    t != null && t.selectable && (t != null && t.multiple) || (y == null || y(!1, {
      source: "menu"
    }), oe(!1));
  }, [t == null ? void 0 : t.selectable, t == null ? void 0 : t.multiple]), ie = () => {
    let ge;
    return t != null && t.items ? ge = /* @__PURE__ */ c.createElement(m_, Object.assign({}, t)) : typeof E == "function" ? ge = E() : ge = E, s && (ge = s(ge)), ge = c.Children.only(typeof ge == "string" ? /* @__PURE__ */ c.createElement("span", null, ge) : ge), /* @__PURE__ */ c.createElement(g_, {
      prefixCls: `${A}-menu`,
      rootClassName: se(T, M),
      expandIcon: /* @__PURE__ */ c.createElement("span", {
        className: `${A}-menu-submenu-arrow`
      }, /* @__PURE__ */ c.createElement(Fc, {
        className: `${A}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: ue,
      validator: (G) => {
        let {
          mode: ne
        } = G;
        process.env.NODE_ENV !== "production" && I(!ne || ne === "vertical", "usage", `mode="${ne}" is not supported for Dropdown's Menu.`);
      }
    }, ge);
  }, [re, Q] = Ts("Dropdown", p == null ? void 0 : p.zIndex);
  let ce = /* @__PURE__ */ c.createElement(JG, Object.assign({
    alignPoint: Y
  }, dr(e, ["rootClassName"]), {
    mouseEnterDelay: v,
    mouseLeaveDelay: C,
    visible: Z,
    builtinPlacements: le,
    arrow: !!n,
    overlayClassName: ae,
    prefixCls: A,
    getPopupContainer: l || $,
    transitionName: j,
    trigger: V,
    overlay: ie,
    placement: F,
    onVisibleChange: ee,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, P == null ? void 0 : P.style), p), {
      zIndex: re
    })
  }), H);
  return re && (ce = /* @__PURE__ */ c.createElement(Eg.Provider, {
    value: Q
  }, ce)), N(ce);
};
function hY(e) {
  return Object.assign(Object.assign({}, e), {
    align: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
}
const gY = Zd(Xg, "dropdown", (e) => e, hY), mY = (e) => /* @__PURE__ */ c.createElement(gY, Object.assign({}, e), /* @__PURE__ */ c.createElement("span", null));
Xg._InternalPanelDoNotUseOrYouWillBeFired = mY;
process.env.NODE_ENV !== "production" && (Xg.displayName = "Dropdown");
const v_ = Xg;
var y_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    var n = 1e3, r = 6e4, o = 36e5, i = "millisecond", a = "second", s = "minute", l = "hour", u = "day", f = "week", p = "month", h = "quarter", y = "year", b = "date", m = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, C = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, x = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
      var N = ["th", "st", "nd", "rd"], D = M % 100;
      return "[" + M + (N[(D - 20) % 10] || N[D] || N[0]) + "]";
    } }, S = function(M, N, D) {
      var T = String(M);
      return !T || T.length >= N ? M : "" + Array(N + 1 - T.length).join(D) + M;
    }, E = { s: S, z: function(M) {
      var N = -M.utcOffset(), D = Math.abs(N), T = Math.floor(D / 60), L = D % 60;
      return (N <= 0 ? "+" : "-") + S(T, 2, "0") + ":" + S(L, 2, "0");
    }, m: function M(N, D) {
      if (N.date() < D.date())
        return -M(D, N);
      var T = 12 * (D.year() - N.year()) + (D.month() - N.month()), L = N.clone().add(T, p), z = D - L < 0, H = N.clone().add(T + (z ? -1 : 1), p);
      return +(-(T + (D - L) / (z ? L - H : H - L)) || 0);
    }, a: function(M) {
      return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
    }, p: function(M) {
      return { M: p, y, w: f, d: u, D: b, h: l, m: s, s: a, ms: i, Q: h }[M] || String(M || "").toLowerCase().replace(/s$/, "");
    }, u: function(M) {
      return M === void 0;
    } }, O = "en", $ = {};
    $[O] = x;
    var _ = "$isDayjsObject", R = function(M) {
      return M instanceof F || !(!M || !M[_]);
    }, P = function M(N, D, T) {
      var L;
      if (!N)
        return O;
      if (typeof N == "string") {
        var z = N.toLowerCase();
        $[z] && (L = z), D && ($[z] = D, L = z);
        var H = N.split("-");
        if (!L && H.length > 1)
          return M(H[0]);
      } else {
        var V = N.name;
        $[V] = N, L = V;
      }
      return !T && L && (O = L), L || !T && O;
    }, I = function(M, N) {
      if (R(M))
        return M.clone();
      var D = typeof N == "object" ? N : {};
      return D.date = M, D.args = arguments, new F(D);
    }, j = E;
    j.l = P, j.i = R, j.w = function(M, N) {
      return I(M, { locale: N.$L, utc: N.$u, x: N.$x, $offset: N.$offset });
    };
    var F = function() {
      function M(D) {
        this.$L = P(D.locale, null, !0), this.parse(D), this.$x = this.$x || D.x || {}, this[_] = !0;
      }
      var N = M.prototype;
      return N.parse = function(D) {
        this.$d = function(T) {
          var L = T.date, z = T.utc;
          if (L === null)
            return /* @__PURE__ */ new Date(NaN);
          if (j.u(L))
            return /* @__PURE__ */ new Date();
          if (L instanceof Date)
            return new Date(L);
          if (typeof L == "string" && !/Z$/i.test(L)) {
            var H = L.match(v);
            if (H) {
              var V = H[2] - 1 || 0, Y = (H[7] || "0").substring(0, 3);
              return z ? new Date(Date.UTC(H[1], V, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, Y)) : new Date(H[1], V, H[3] || 1, H[4] || 0, H[5] || 0, H[6] || 0, Y);
            }
          }
          return new Date(L);
        }(D), this.init();
      }, N.init = function() {
        var D = this.$d;
        this.$y = D.getFullYear(), this.$M = D.getMonth(), this.$D = D.getDate(), this.$W = D.getDay(), this.$H = D.getHours(), this.$m = D.getMinutes(), this.$s = D.getSeconds(), this.$ms = D.getMilliseconds();
      }, N.$utils = function() {
        return j;
      }, N.isValid = function() {
        return this.$d.toString() !== m;
      }, N.isSame = function(D, T) {
        var L = I(D);
        return this.startOf(T) <= L && L <= this.endOf(T);
      }, N.isAfter = function(D, T) {
        return I(D) < this.startOf(T);
      }, N.isBefore = function(D, T) {
        return this.endOf(T) < I(D);
      }, N.$g = function(D, T, L) {
        return j.u(D) ? this[T] : this.set(L, D);
      }, N.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, N.valueOf = function() {
        return this.$d.getTime();
      }, N.startOf = function(D, T) {
        var L = this, z = !!j.u(T) || T, H = j.p(D), V = function(ie, re) {
          var Q = j.w(L.$u ? Date.UTC(L.$y, re, ie) : new Date(L.$y, re, ie), L);
          return z ? Q : Q.endOf(u);
        }, Y = function(ie, re) {
          return j.w(L.toDate()[ie].apply(L.toDate("s"), (z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(re)), L);
        }, Z = this.$W, oe = this.$M, ee = this.$D, ae = "set" + (this.$u ? "UTC" : "");
        switch (H) {
          case y:
            return z ? V(1, 0) : V(31, 11);
          case p:
            return z ? V(1, oe) : V(0, oe + 1);
          case f:
            var le = this.$locale().weekStart || 0, ue = (Z < le ? Z + 7 : Z) - le;
            return V(z ? ee - ue : ee + (6 - ue), oe);
          case u:
          case b:
            return Y(ae + "Hours", 0);
          case l:
            return Y(ae + "Minutes", 1);
          case s:
            return Y(ae + "Seconds", 2);
          case a:
            return Y(ae + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, N.endOf = function(D) {
        return this.startOf(D, !1);
      }, N.$set = function(D, T) {
        var L, z = j.p(D), H = "set" + (this.$u ? "UTC" : ""), V = (L = {}, L[u] = H + "Date", L[b] = H + "Date", L[p] = H + "Month", L[y] = H + "FullYear", L[l] = H + "Hours", L[s] = H + "Minutes", L[a] = H + "Seconds", L[i] = H + "Milliseconds", L)[z], Y = z === u ? this.$D + (T - this.$W) : T;
        if (z === p || z === y) {
          var Z = this.clone().set(b, 1);
          Z.$d[V](Y), Z.init(), this.$d = Z.set(b, Math.min(this.$D, Z.daysInMonth())).$d;
        } else
          V && this.$d[V](Y);
        return this.init(), this;
      }, N.set = function(D, T) {
        return this.clone().$set(D, T);
      }, N.get = function(D) {
        return this[j.p(D)]();
      }, N.add = function(D, T) {
        var L, z = this;
        D = Number(D);
        var H = j.p(T), V = function(oe) {
          var ee = I(z);
          return j.w(ee.date(ee.date() + Math.round(oe * D)), z);
        };
        if (H === p)
          return this.set(p, this.$M + D);
        if (H === y)
          return this.set(y, this.$y + D);
        if (H === u)
          return V(1);
        if (H === f)
          return V(7);
        var Y = (L = {}, L[s] = r, L[l] = o, L[a] = n, L)[H] || 1, Z = this.$d.getTime() + D * Y;
        return j.w(Z, this);
      }, N.subtract = function(D, T) {
        return this.add(-1 * D, T);
      }, N.format = function(D) {
        var T = this, L = this.$locale();
        if (!this.isValid())
          return L.invalidDate || m;
        var z = D || "YYYY-MM-DDTHH:mm:ssZ", H = j.z(this), V = this.$H, Y = this.$m, Z = this.$M, oe = L.weekdays, ee = L.months, ae = L.meridiem, le = function(re, Q, ce, ge) {
          return re && (re[Q] || re(T, z)) || ce[Q].slice(0, ge);
        }, ue = function(re) {
          return j.s(V % 12 || 12, re, "0");
        }, ie = ae || function(re, Q, ce) {
          var ge = re < 12 ? "AM" : "PM";
          return ce ? ge.toLowerCase() : ge;
        };
        return z.replace(C, function(re, Q) {
          return Q || function(ce) {
            switch (ce) {
              case "YY":
                return String(T.$y).slice(-2);
              case "YYYY":
                return j.s(T.$y, 4, "0");
              case "M":
                return Z + 1;
              case "MM":
                return j.s(Z + 1, 2, "0");
              case "MMM":
                return le(L.monthsShort, Z, ee, 3);
              case "MMMM":
                return le(ee, Z);
              case "D":
                return T.$D;
              case "DD":
                return j.s(T.$D, 2, "0");
              case "d":
                return String(T.$W);
              case "dd":
                return le(L.weekdaysMin, T.$W, oe, 2);
              case "ddd":
                return le(L.weekdaysShort, T.$W, oe, 3);
              case "dddd":
                return oe[T.$W];
              case "H":
                return String(V);
              case "HH":
                return j.s(V, 2, "0");
              case "h":
                return ue(1);
              case "hh":
                return ue(2);
              case "a":
                return ie(V, Y, !0);
              case "A":
                return ie(V, Y, !1);
              case "m":
                return String(Y);
              case "mm":
                return j.s(Y, 2, "0");
              case "s":
                return String(T.$s);
              case "ss":
                return j.s(T.$s, 2, "0");
              case "SSS":
                return j.s(T.$ms, 3, "0");
              case "Z":
                return H;
            }
            return null;
          }(re) || H.replace(":", "");
        });
      }, N.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, N.diff = function(D, T, L) {
        var z, H = this, V = j.p(T), Y = I(D), Z = (Y.utcOffset() - this.utcOffset()) * r, oe = this - Y, ee = function() {
          return j.m(H, Y);
        };
        switch (V) {
          case y:
            z = ee() / 12;
            break;
          case p:
            z = ee();
            break;
          case h:
            z = ee() / 3;
            break;
          case f:
            z = (oe - Z) / 6048e5;
            break;
          case u:
            z = (oe - Z) / 864e5;
            break;
          case l:
            z = oe / o;
            break;
          case s:
            z = oe / r;
            break;
          case a:
            z = oe / n;
            break;
          default:
            z = oe;
        }
        return L ? z : j.a(z);
      }, N.daysInMonth = function() {
        return this.endOf(p).$D;
      }, N.$locale = function() {
        return $[this.$L];
      }, N.locale = function(D, T) {
        if (!D)
          return this.$L;
        var L = this.clone(), z = P(D, T, !0);
        return z && (L.$L = z), L;
      }, N.clone = function() {
        return j.w(this.$d, this);
      }, N.toDate = function() {
        return new Date(this.valueOf());
      }, N.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, N.toISOString = function() {
        return this.$d.toISOString();
      }, N.toString = function() {
        return this.$d.toUTCString();
      }, M;
    }(), A = F.prototype;
    return I.prototype = A, [["$ms", i], ["$s", a], ["$m", s], ["$H", l], ["$W", u], ["$M", p], ["$y", y], ["$D", b]].forEach(function(M) {
      A[M[1]] = function(N) {
        return this.$g(N, M[0], M[1]);
      };
    }), I.extend = function(M, N) {
      return M.$i || (M(N, F, I), M.$i = !0), I;
    }, I.locale = P, I.isDayjs = R, I.unix = function(M) {
      return I(1e3 * M);
    }, I.en = $[O], I.Ls = $, I.p = {}, I;
  });
})(y_);
var vY = y_.exports;
const qr = /* @__PURE__ */ Vi(vY);
var b_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    return function(n, r) {
      r.prototype.weekday = function(o) {
        var i = this.$locale().weekStart || 0, a = this.$W, s = (a < i ? a + 7 : a) - i;
        return this.$utils().u(o) ? s : this.subtract(s, "day").add(o, "day");
      };
    };
  });
})(b_);
var yY = b_.exports;
const bY = /* @__PURE__ */ Vi(yY);
var C_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    return function(n, r, o) {
      var i = r.prototype, a = function(p) {
        return p && (p.indexOf ? p : p.s);
      }, s = function(p, h, y, b, m) {
        var v = p.name ? p : p.$locale(), C = a(v[h]), x = a(v[y]), S = C || x.map(function(O) {
          return O.slice(0, b);
        });
        if (!m)
          return S;
        var E = v.weekStart;
        return S.map(function(O, $) {
          return S[($ + (E || 0)) % 7];
        });
      }, l = function() {
        return o.Ls[o.locale()];
      }, u = function(p, h) {
        return p.formats[h] || function(y) {
          return y.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(b, m, v) {
            return m || v.slice(1);
          });
        }(p.formats[h.toUpperCase()]);
      }, f = function() {
        var p = this;
        return { months: function(h) {
          return h ? h.format("MMMM") : s(p, "months");
        }, monthsShort: function(h) {
          return h ? h.format("MMM") : s(p, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return p.$locale().weekStart || 0;
        }, weekdays: function(h) {
          return h ? h.format("dddd") : s(p, "weekdays");
        }, weekdaysMin: function(h) {
          return h ? h.format("dd") : s(p, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(h) {
          return h ? h.format("ddd") : s(p, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(h) {
          return u(p.$locale(), h);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      i.localeData = function() {
        return f.bind(this)();
      }, o.localeData = function() {
        var p = l();
        return { firstDayOfWeek: function() {
          return p.weekStart || 0;
        }, weekdays: function() {
          return o.weekdays();
        }, weekdaysShort: function() {
          return o.weekdaysShort();
        }, weekdaysMin: function() {
          return o.weekdaysMin();
        }, months: function() {
          return o.months();
        }, monthsShort: function() {
          return o.monthsShort();
        }, longDateFormat: function(h) {
          return u(p, h);
        }, meridiem: p.meridiem, ordinal: p.ordinal };
      }, o.months = function() {
        return s(l(), "months");
      }, o.monthsShort = function() {
        return s(l(), "monthsShort", "months", 3);
      }, o.weekdays = function(p) {
        return s(l(), "weekdays", null, null, p);
      }, o.weekdaysShort = function(p) {
        return s(l(), "weekdaysShort", "weekdays", 3, p);
      }, o.weekdaysMin = function(p) {
        return s(l(), "weekdaysMin", "weekdays", 2, p);
      };
    };
  });
})(C_);
var CY = C_.exports;
const xY = /* @__PURE__ */ Vi(CY);
var x_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    var n = "week", r = "year";
    return function(o, i, a) {
      var s = i.prototype;
      s.week = function(l) {
        if (l === void 0 && (l = null), l !== null)
          return this.add(7 * (l - this.week()), "day");
        var u = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var f = a(this).startOf(r).add(1, r).date(u), p = a(this).endOf(n);
          if (f.isBefore(p))
            return 1;
        }
        var h = a(this).startOf(r).date(u).startOf(n).subtract(1, "millisecond"), y = this.diff(h, n, !0);
        return y < 0 ? a(this).startOf("week").week() : Math.ceil(y);
      }, s.weeks = function(l) {
        return l === void 0 && (l = null), this.week(l);
      };
    };
  });
})(x_);
var SY = x_.exports;
const wY = /* @__PURE__ */ Vi(SY);
var S_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    return function(n, r) {
      r.prototype.weekYear = function() {
        var o = this.month(), i = this.week(), a = this.year();
        return i === 1 && o === 11 ? a + 1 : o === 0 && i >= 52 ? a - 1 : a;
      };
    };
  });
})(S_);
var EY = S_.exports;
const $Y = /* @__PURE__ */ Vi(EY);
var w_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    return function(n, r) {
      var o = r.prototype, i = o.format;
      o.format = function(a) {
        var s = this, l = this.$locale();
        if (!this.isValid())
          return i.bind(this)(a);
        var u = this.$utils(), f = (a || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(p) {
          switch (p) {
            case "Q":
              return Math.ceil((s.$M + 1) / 3);
            case "Do":
              return l.ordinal(s.$D);
            case "gggg":
              return s.weekYear();
            case "GGGG":
              return s.isoWeekYear();
            case "wo":
              return l.ordinal(s.week(), "W");
            case "w":
            case "ww":
              return u.s(s.week(), p === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return u.s(s.isoWeek(), p === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return u.s(String(s.$H === 0 ? 24 : s.$H), p === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(s.$d.getTime() / 1e3);
            case "x":
              return s.$d.getTime();
            case "z":
              return "[" + s.offsetName() + "]";
            case "zzz":
              return "[" + s.offsetName("long") + "]";
            default:
              return p;
          }
        });
        return i.bind(this)(f);
      };
    };
  });
})(w_);
var OY = w_.exports;
const _Y = /* @__PURE__ */ Vi(OY);
var E_ = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(lo, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d\d/, i = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, s = {}, l = function(m) {
      return (m = +m) + (m > 68 ? 1900 : 2e3);
    }, u = function(m) {
      return function(v) {
        this[m] = +v;
      };
    }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(m) {
      (this.zone || (this.zone = {})).offset = function(v) {
        if (!v || v === "Z")
          return 0;
        var C = v.match(/([+-]|\d\d)/g), x = 60 * C[1] + (+C[2] || 0);
        return x === 0 ? 0 : C[0] === "+" ? -x : x;
      }(m);
    }], p = function(m) {
      var v = s[m];
      return v && (v.indexOf ? v : v.s.concat(v.f));
    }, h = function(m, v) {
      var C, x = s.meridiem;
      if (x) {
        for (var S = 1; S <= 24; S += 1)
          if (m.indexOf(x(S, 0, v)) > -1) {
            C = S > 12;
            break;
          }
      } else
        C = m === (v ? "pm" : "PM");
      return C;
    }, y = { A: [a, function(m) {
      this.afternoon = h(m, !1);
    }], a: [a, function(m) {
      this.afternoon = h(m, !0);
    }], S: [/\d/, function(m) {
      this.milliseconds = 100 * +m;
    }], SS: [o, function(m) {
      this.milliseconds = 10 * +m;
    }], SSS: [/\d{3}/, function(m) {
      this.milliseconds = +m;
    }], s: [i, u("seconds")], ss: [i, u("seconds")], m: [i, u("minutes")], mm: [i, u("minutes")], H: [i, u("hours")], h: [i, u("hours")], HH: [i, u("hours")], hh: [i, u("hours")], D: [i, u("day")], DD: [o, u("day")], Do: [a, function(m) {
      var v = s.ordinal, C = m.match(/\d+/);
      if (this.day = C[0], v)
        for (var x = 1; x <= 31; x += 1)
          v(x).replace(/\[|\]/g, "") === m && (this.day = x);
    }], M: [i, u("month")], MM: [o, u("month")], MMM: [a, function(m) {
      var v = p("months"), C = (p("monthsShort") || v.map(function(x) {
        return x.slice(0, 3);
      })).indexOf(m) + 1;
      if (C < 1)
        throw new Error();
      this.month = C % 12 || C;
    }], MMMM: [a, function(m) {
      var v = p("months").indexOf(m) + 1;
      if (v < 1)
        throw new Error();
      this.month = v % 12 || v;
    }], Y: [/[+-]?\d+/, u("year")], YY: [o, function(m) {
      this.year = l(m);
    }], YYYY: [/\d{4}/, u("year")], Z: f, ZZ: f };
    function b(m) {
      var v, C;
      v = m, C = s && s.formats;
      for (var x = (m = v.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(P, I, j) {
        var F = j && j.toUpperCase();
        return I || C[j] || n[j] || C[F].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(A, M, N) {
          return M || N.slice(1);
        });
      })).match(r), S = x.length, E = 0; E < S; E += 1) {
        var O = x[E], $ = y[O], _ = $ && $[0], R = $ && $[1];
        x[E] = R ? { regex: _, parser: R } : O.replace(/^\[|\]$/g, "");
      }
      return function(P) {
        for (var I = {}, j = 0, F = 0; j < S; j += 1) {
          var A = x[j];
          if (typeof A == "string")
            F += A.length;
          else {
            var M = A.regex, N = A.parser, D = P.slice(F), T = M.exec(D)[0];
            N.call(I, T), P = P.replace(T, "");
          }
        }
        return function(L) {
          var z = L.afternoon;
          if (z !== void 0) {
            var H = L.hours;
            z ? H < 12 && (L.hours += 12) : H === 12 && (L.hours = 0), delete L.afternoon;
          }
        }(I), I;
      };
    }
    return function(m, v, C) {
      C.p.customParseFormat = !0, m && m.parseTwoDigitYear && (l = m.parseTwoDigitYear);
      var x = v.prototype, S = x.parse;
      x.parse = function(E) {
        var O = E.date, $ = E.utc, _ = E.args;
        this.$u = $;
        var R = _[1];
        if (typeof R == "string") {
          var P = _[2] === !0, I = _[3] === !0, j = P || I, F = _[2];
          I && (F = _[2]), s = this.$locale(), !P && F && (s = C.Ls[F]), this.$d = function(D, T, L) {
            try {
              if (["x", "X"].indexOf(T) > -1)
                return new Date((T === "X" ? 1e3 : 1) * D);
              var z = b(T)(D), H = z.year, V = z.month, Y = z.day, Z = z.hours, oe = z.minutes, ee = z.seconds, ae = z.milliseconds, le = z.zone, ue = /* @__PURE__ */ new Date(), ie = Y || (H || V ? 1 : ue.getDate()), re = H || ue.getFullYear(), Q = 0;
              H && !V || (Q = V > 0 ? V - 1 : ue.getMonth());
              var ce = Z || 0, ge = oe || 0, G = ee || 0, ne = ae || 0;
              return le ? new Date(Date.UTC(re, Q, ie, ce, ge, G, ne + 60 * le.offset * 1e3)) : L ? new Date(Date.UTC(re, Q, ie, ce, ge, G, ne)) : new Date(re, Q, ie, ce, ge, G, ne);
            } catch (fe) {
              return /* @__PURE__ */ new Date("");
            }
          }(O, R, $), this.init(), F && F !== !0 && (this.$L = this.locale(F).$L), j && O != this.format(R) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (R instanceof Array)
          for (var A = R.length, M = 1; M <= A; M += 1) {
            _[1] = R[M - 1];
            var N = C.apply(this, _);
            if (N.isValid()) {
              this.$d = N.$d, this.$L = N.$L, this.init();
              break;
            }
            M === A && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          S.call(this, E);
      };
    };
  });
})(E_);
var NY = E_.exports;
const PY = /* @__PURE__ */ Vi(NY);
qr.extend(PY);
qr.extend(_Y);
qr.extend(bY);
qr.extend(xY);
qr.extend(wY);
qr.extend($Y);
qr.extend(function(e, t) {
  var n = t.prototype, r = n.format;
  n.format = function(i) {
    var a = (i || "").replace("Wo", "wo");
    return r.bind(this)(a);
  };
});
var IY = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, Gs = function(t) {
  var n = IY[t];
  return n || t.split("_")[0];
}, gE = function() {
  vh(!1, "Not match any format. Please help to fire a issue about this.");
}, RY = {
  // get
  getNow: function() {
    return qr();
  },
  getFixedDate: function(t) {
    return qr(t, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function(t) {
    return t.endOf("month");
  },
  getWeekDay: function(t) {
    var n = t.locale("en");
    return n.weekday() + n.localeData().firstDayOfWeek();
  },
  getYear: function(t) {
    return t.year();
  },
  getMonth: function(t) {
    return t.month();
  },
  getDate: function(t) {
    return t.date();
  },
  getHour: function(t) {
    return t.hour();
  },
  getMinute: function(t) {
    return t.minute();
  },
  getSecond: function(t) {
    return t.second();
  },
  // set
  addYear: function(t, n) {
    return t.add(n, "year");
  },
  addMonth: function(t, n) {
    return t.add(n, "month");
  },
  addDate: function(t, n) {
    return t.add(n, "day");
  },
  setYear: function(t, n) {
    return t.year(n);
  },
  setMonth: function(t, n) {
    return t.month(n);
  },
  setDate: function(t, n) {
    return t.date(n);
  },
  setHour: function(t, n) {
    return t.hour(n);
  },
  setMinute: function(t, n) {
    return t.minute(n);
  },
  setSecond: function(t, n) {
    return t.second(n);
  },
  // Compare
  isAfter: function(t, n) {
    return t.isAfter(n);
  },
  isValidate: function(t) {
    return t.isValid();
  },
  locale: {
    getWeekFirstDay: function(t) {
      return qr().locale(Gs(t)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function(t, n) {
      return n.locale(Gs(t)).weekday(0);
    },
    getWeek: function(t, n) {
      return n.locale(Gs(t)).week();
    },
    getShortWeekDays: function(t) {
      return qr().locale(Gs(t)).localeData().weekdaysMin();
    },
    getShortMonths: function(t) {
      return qr().locale(Gs(t)).localeData().monthsShort();
    },
    format: function(t, n, r) {
      return n.locale(Gs(t)).format(r);
    },
    parse: function(t, n, r) {
      for (var o = Gs(t), i = 0; i < r.length; i += 1) {
        var a = r[i], s = n;
        if (a.includes("wo") || a.includes("Wo")) {
          for (var l = s.split("-")[0], u = s.split("-")[1], f = qr(l, "YYYY").startOf("year").locale(o), p = 0; p <= 52; p += 1) {
            var h = f.add(p, "week");
            if (h.format("Wo") === u)
              return h;
          }
          return gE(), null;
        }
        var y = qr(s, a, !0).locale(o);
        if (y.isValid())
          return y;
      }
      return n && gE(), null;
    }
  }
}, Li = 10, La = Li * 10, sd = 7;
function Rl(e, t) {
  if (!e && !t)
    return !0;
  if (!e || !t)
    return !1;
}
function DY(e, t, n) {
  var r = Rl(t, n);
  if (typeof r == "boolean")
    return r;
  var o = Math.floor(e.getYear(t) / 10), i = Math.floor(e.getYear(n) / 10);
  return o === i;
}
function nf(e, t, n) {
  var r = Rl(t, n);
  return typeof r == "boolean" ? r : e.getYear(t) === e.getYear(n);
}
function Z1(e, t) {
  var n = Math.floor(e.getMonth(t) / 3);
  return n + 1;
}
function $_(e, t, n) {
  var r = Rl(t, n);
  return typeof r == "boolean" ? r : nf(e, t, n) && Z1(e, t) === Z1(e, n);
}
function Yb(e, t, n) {
  var r = Rl(t, n);
  return typeof r == "boolean" ? r : nf(e, t, n) && e.getMonth(t) === e.getMonth(n);
}
function Aa(e, t, n) {
  var r = Rl(t, n);
  return typeof r == "boolean" ? r : e.getYear(t) === e.getYear(n) && e.getMonth(t) === e.getMonth(n) && e.getDate(t) === e.getDate(n);
}
function TY(e, t, n) {
  var r = Rl(t, n);
  return typeof r == "boolean" ? r : e.getHour(t) === e.getHour(n) && e.getMinute(t) === e.getMinute(n) && e.getSecond(t) === e.getSecond(n);
}
function rh(e, t, n, r) {
  var o = Rl(n, r);
  return typeof o == "boolean" ? o : nf(e, n, r) && e.locale.getWeek(t, n) === e.locale.getWeek(t, r);
}
function Bc(e, t, n) {
  return Aa(e, t, n) && TY(e, t, n);
}
function Zu(e, t, n, r) {
  return !t || !n || !r ? !1 : !Aa(e, t, r) && !Aa(e, n, r) && e.isAfter(r, t) && e.isAfter(n, r);
}
function MY(e, t, n) {
  var r = t.locale.getWeekFirstDay(e), o = t.setDate(n, 1), i = t.getWeekDay(o), a = t.addDate(o, r - i);
  return t.getMonth(a) === t.getMonth(n) && t.getDate(a) > 1 && (a = t.addDate(a, -7)), a;
}
function ld(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  switch (t) {
    case "year":
      return n.addYear(e, r * 10);
    case "quarter":
    case "month":
      return n.addYear(e, r);
    default:
      return n.addMonth(e, r);
  }
}
function bo(e, t) {
  var n = t.generateConfig, r = t.locale, o = t.format;
  return typeof o == "function" ? o(e) : n.locale.format(r.locale, e, o);
}
function O_(e, t) {
  var n = t.generateConfig, r = t.locale, o = t.formatList;
  return !e || typeof o[0] == "function" ? null : n.locale.parse(r.locale, e, o);
}
function Ah(e) {
  var t = e.cellDate, n = e.mode, r = e.disabledDate, o = e.generateConfig;
  if (!r)
    return !1;
  var i = function(b, m, v) {
    for (var C = m; C <= v; ) {
      var x = void 0;
      switch (b) {
        case "date": {
          if (x = o.setDate(t, C), !r(x))
            return !1;
          break;
        }
        case "month": {
          if (x = o.setMonth(t, C), !Ah({
            cellDate: x,
            mode: "month",
            generateConfig: o,
            disabledDate: r
          }))
            return !1;
          break;
        }
        case "year": {
          if (x = o.setYear(t, C), !Ah({
            cellDate: x,
            mode: "year",
            generateConfig: o,
            disabledDate: r
          }))
            return !1;
          break;
        }
      }
      C += 1;
    }
    return !0;
  };
  switch (n) {
    case "date":
    case "week":
      return r(t);
    case "month": {
      var a = 1, s = o.getDate(o.getEndDate(t));
      return i("date", a, s);
    }
    case "quarter": {
      var l = Math.floor(o.getMonth(t) / 3) * 3, u = l + 2;
      return i("month", l, u);
    }
    case "year":
      return i("month", 0, 11);
    case "decade": {
      var f = o.getYear(t), p = Math.floor(f / Li) * Li, h = p + Li - 1;
      return i("year", p, h);
    }
  }
}
function jh(e, t) {
  var n = t.formatList, r = t.generateConfig, o = t.locale, i = ua(function() {
    if (!e)
      return [[""], ""];
    for (var u = "", f = [], p = 0; p < n.length; p += 1) {
      var h = n[p], y = bo(e, {
        generateConfig: r,
        locale: o,
        format: h
      });
      f.push(y), p === 0 && (u = y);
    }
    return [f, u];
  }, [e, n, o], function(u, f) {
    return (
      // Not Same Date
      !Bc(r, u[0], f[0]) || // Not Same format
      !Fi(u[1], f[1], !0) || // Not Same locale
      !Fi(u[2], f[2], !0)
    );
  }), a = de(i, 2), s = a[0], l = a[1];
  return c.useMemo(function() {
    return [s, l];
  }, [s.join(""), l]);
}
function Q1(e, t) {
  var n = t.formatList, r = t.generateConfig, o = t.locale, i = Ot(null), a = de(i, 2), s = a[0], l = a[1], u = _t(null);
  function f(v) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (cancelAnimationFrame(u.current), C) {
      l(v);
      return;
    }
    u.current = requestAnimationFrame(function() {
      l(v);
    });
  }
  var p = jh(s, {
    formatList: n,
    generateConfig: r,
    locale: o
  }), h = de(p, 2), y = h[1];
  function b(v) {
    f(v);
  }
  function m() {
    var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    f(null, v);
  }
  return kt(function() {
    m(!0);
  }, [e]), kt(function() {
    return function() {
      return cancelAnimationFrame(u.current);
    };
  }, []), [y, b, m];
}
var Ep = /* @__PURE__ */ new Map();
function LY(e, t) {
  var n;
  function r() {
    Qc(e) ? t() : n = Pn(function() {
      r();
    });
  }
  return r(), function() {
    Pn.cancel(n);
  };
}
function J1(e, t, n) {
  if (Ep.get(e) && cancelAnimationFrame(Ep.get(e)), n <= 0) {
    Ep.set(e, requestAnimationFrame(function() {
      e.scrollTop = t;
    }));
    return;
  }
  var r = t - e.scrollTop, o = r / n * 10;
  Ep.set(e, requestAnimationFrame(function() {
    e.scrollTop += o, e.scrollTop !== t && J1(e, t, n - 10);
  }));
}
function ou(e, t) {
  var n = t.onLeftRight, r = t.onCtrlLeftRight, o = t.onUpDown, i = t.onPageUpDown, a = t.onEnter, s = e.which, l = e.ctrlKey, u = e.metaKey;
  switch (s) {
    case Pe.LEFT:
      if (l || u) {
        if (r)
          return r(-1), !0;
      } else if (n)
        return n(-1), !0;
      break;
    case Pe.RIGHT:
      if (l || u) {
        if (r)
          return r(1), !0;
      } else if (n)
        return n(1), !0;
      break;
    case Pe.UP:
      if (o)
        return o(-1), !0;
      break;
    case Pe.DOWN:
      if (o)
        return o(1), !0;
      break;
    case Pe.PAGE_UP:
      if (i)
        return i(-1), !0;
      break;
    case Pe.PAGE_DOWN:
      if (i)
        return i(1), !0;
      break;
    case Pe.ENTER:
      if (a)
        return a(), !0;
      break;
  }
  return !1;
}
function __(e, t, n, r) {
  var o = e;
  if (!o)
    switch (t) {
      case "time":
        o = r ? "hh:mm:ss a" : "HH:mm:ss";
        break;
      case "week":
        o = "gggg-wo";
        break;
      case "month":
        o = "YYYY-MM";
        break;
      case "quarter":
        o = "YYYY-[Q]Q";
        break;
      case "year":
        o = "YYYY";
        break;
      default:
        o = n ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    }
  return o;
}
function N_(e, t, n) {
  var r = e === "time" ? 8 : 10, o = typeof t == "function" ? t(n.getNow()).length : t.length;
  return Math.max(r, o) + 2;
}
var Wu = null, $p = /* @__PURE__ */ new Set();
function AY(e) {
  return !Wu && typeof window != "undefined" && window.addEventListener && (Wu = function(n) {
    We($p).forEach(function(r) {
      r(n);
    });
  }, window.addEventListener("mousedown", Wu)), $p.add(e), function() {
    $p.delete(e), $p.size === 0 && (window.removeEventListener("mousedown", Wu), Wu = null);
  };
}
function jY(e) {
  var t = e.target;
  if (e.composed && t.shadowRoot) {
    var n;
    return ((n = e.composedPath) === null || n === void 0 ? void 0 : n.call(e)[0]) || t;
  }
  return t;
}
var kY = function(t) {
  return t === "month" || t === "date" ? "year" : t;
}, FY = function(t) {
  return t === "date" ? "month" : t;
}, BY = function(t) {
  return t === "month" || t === "date" ? "quarter" : t;
}, HY = function(t) {
  return t === "date" ? "week" : t;
}, zY = {
  year: kY,
  month: FY,
  quarter: BY,
  week: HY,
  time: null,
  date: null
};
function P_(e, t) {
  return e.some(function(n) {
    return n && n.contains(t);
  });
}
function ey(e) {
  var t = e.open, n = e.value, r = e.isClickOutside, o = e.triggerOpen, i = e.forwardKeyDown, a = e.onKeyDown, s = e.blurToCancel, l = e.changeOnBlur, u = e.onSubmit, f = e.onCancel, p = e.onFocus, h = e.onBlur, y = Ot(!1), b = de(y, 2), m = b[0], v = b[1], C = Ot(!1), x = de(C, 2), S = x[0], E = x[1], O = _t(!1), $ = _t(!1), _ = _t(!1), R = {
    onMouseDown: function() {
      v(!0), o(!0);
    },
    onKeyDown: function(I) {
      var j = function() {
        _.current = !0;
      };
      if (a(I, j), !_.current) {
        switch (I.which) {
          case Pe.ENTER: {
            t ? u() !== !1 && v(!0) : o(!0), I.preventDefault();
            return;
          }
          case Pe.TAB: {
            m && t && !I.shiftKey ? (v(!1), I.preventDefault()) : !m && t && !i(I) && I.shiftKey && (v(!0), I.preventDefault());
            return;
          }
          case Pe.ESC: {
            v(!0), f();
            return;
          }
        }
        !t && ![Pe.SHIFT].includes(I.which) ? o(!0) : m || i(I);
      }
    },
    onFocus: function(I) {
      v(!0), E(!0), p && p(I);
    },
    onBlur: function(I) {
      if (O.current || !r(document.activeElement)) {
        O.current = !1;
        return;
      }
      s ? setTimeout(function() {
        for (var j = document, F = j.activeElement; F && F.shadowRoot; )
          F = F.shadowRoot.activeElement;
        r(F) && f();
      }, 0) : t && (o(!1), $.current && u()), E(!1), h == null || h(I);
    }
  };
  return kt(function() {
    $.current = !1;
  }, [t]), kt(function() {
    $.current = !0;
  }, [n]), kt(function() {
    return AY(function(P) {
      var I = jY(P), j = r(I);
      t && (j ? !l && !s && (!S || j) && o(!1) : (O.current = !0, Pn(function() {
        O.current = !1;
      })));
    });
  }), [R, {
    focused: S,
    typing: m
  }];
}
function I_(e, t) {
  return c.useMemo(function() {
    return e || (t ? (mt(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(t).map(function(n) {
      var r = de(n, 2), o = r[0], i = r[1];
      return {
        label: o,
        value: i
      };
    })) : []);
  }, [e, t]);
}
function ty(e) {
  var t = e.valueTexts, n = e.onTextChange, r = c.useState(""), o = de(r, 2), i = o[0], a = o[1], s = c.useRef([]);
  s.current = t;
  function l(f) {
    a(f), n(f);
  }
  function u() {
    a(s.current[0]);
  }
  return Nn(function() {
    t.every(function(f) {
      return f !== i;
    }) && u();
  }, [t.join("||")]), [i, l, u];
}
var Ho = /* @__PURE__ */ c.createContext({});
function R_(e) {
  var t = e.cellRender, n = e.monthCellRender, r = e.dateRender, o = be.useMemo(function() {
    if (t)
      return t;
    if (!(!n && !r))
      return function(i, a) {
        var s = i;
        return r && a.type === "date" ? r(s, a.today) : n && a.type === "month" ? n(s, a.locale) : a.originNode;
      };
  }, [t, n, r]);
  return o;
}
function D_(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", r = String(e); r.length < t; )
    r = "".concat(n).concat(e);
  return r;
}
var VY = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n;
};
function T_(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function pn(e, t) {
  return e ? e[t] : null;
}
function gi(e, t, n) {
  var r = [pn(e, 0), pn(e, 1)];
  return r[n] = typeof t == "function" ? t(r[n]) : t, !r[0] && !r[1] ? null : r;
}
function mE(e) {
  return typeof e == "function" ? e() : e;
}
function Zg(e) {
  var t = e.cellPrefixCls, n = e.generateConfig, r = e.rangedValue, o = e.hoverRangedValue, i = e.isInView, a = e.isSameCell, s = e.offsetCell, l = e.today, u = e.value;
  function f(p) {
    var h, y = s(p, -1), b = s(p, 1), m = pn(r, 0), v = pn(r, 1), C = pn(o, 0), x = pn(o, 1), S = Zu(n, C, x, p);
    function E(I) {
      return a(m, I);
    }
    function O(I) {
      return a(v, I);
    }
    var $ = a(C, p), _ = a(x, p), R = (S || _) && (!i(y) || O(y)), P = (S || $) && (!i(b) || E(b));
    return h = {}, K(h, "".concat(t, "-in-view"), i(p)), K(h, "".concat(t, "-in-range"), Zu(n, m, v, p)), K(h, "".concat(t, "-range-start"), E(p)), K(h, "".concat(t, "-range-end"), O(p)), K(h, "".concat(t, "-range-start-single"), E(p) && !v), K(h, "".concat(t, "-range-end-single"), O(p) && !m), K(h, "".concat(t, "-range-start-near-hover"), E(p) && (a(y, C) || Zu(n, C, x, y))), K(h, "".concat(t, "-range-end-near-hover"), O(p) && (a(b, x) || Zu(n, C, x, b))), K(h, "".concat(t, "-range-hover"), S), K(h, "".concat(t, "-range-hover-start"), $), K(h, "".concat(t, "-range-hover-end"), _), K(h, "".concat(t, "-range-hover-edge-start"), R), K(h, "".concat(t, "-range-hover-edge-end"), P), K(h, "".concat(t, "-range-hover-edge-start-near-range"), R && a(y, v)), K(h, "".concat(t, "-range-hover-edge-end-near-range"), P && a(b, m)), K(h, "".concat(t, "-today"), a(l, p)), K(h, "".concat(t, "-selected"), a(u, p)), h;
  }
  return f;
}
var Dl = /* @__PURE__ */ c.createContext({});
function M_(e, t, n, r, o) {
  var i = e.setHour(t, n);
  return i = e.setMinute(i, r), i = e.setSecond(i, o), i;
}
function L_(e, t, n) {
  if (!n)
    return t;
  var r = t;
  return r = e.setHour(r, e.getHour(n)), r = e.setMinute(r, e.getMinute(n)), r = e.setSecond(r, e.getSecond(n)), r;
}
function WY(e, t, n, r, o, i) {
  var a = Math.floor(e / r) * r;
  if (a < e)
    return [a, 60 - o, 60 - i];
  var s = Math.floor(t / o) * o;
  if (s < t)
    return [a, s, 60 - i];
  var l = Math.floor(n / i) * i;
  return [a, s, l];
}
function KY(e, t) {
  var n = e.getYear(t), r = e.getMonth(t) + 1, o = e.getEndDate(e.getFixedDate("".concat(n, "-").concat(r, "-01"))), i = e.getDate(o), a = r < 10 ? "0".concat(r) : "".concat(r);
  return "".concat(n, "-").concat(a, "-").concat(i);
}
function rf(e) {
  for (var t = e.prefixCls, n = e.disabledDate, r = e.onSelect, o = e.picker, i = e.rowNum, a = e.colNum, s = e.prefixColumn, l = e.rowClassName, u = e.baseDate, f = e.getCellClassName, p = e.getCellText, h = e.getCellNode, y = e.getCellDate, b = e.generateConfig, m = e.titleCell, v = e.headerCells, C = c.useContext(Ho), x = C.onDateMouseEnter, S = C.onDateMouseLeave, E = C.mode, O = "".concat(t, "-cell"), $ = [], _ = 0; _ < i; _ += 1) {
    for (var R = [], P = void 0, I = function() {
      var A, M = _ * a + j, N = y(u, M), D = Ah({
        cellDate: N,
        mode: E,
        disabledDate: n,
        generateConfig: b
      });
      j === 0 && (P = N, s && R.push(s(P)));
      var T = m && m(N), L = /* @__PURE__ */ c.createElement("div", {
        className: "".concat(O, "-inner")
      }, p(N));
      R.push(/* @__PURE__ */ c.createElement("td", {
        key: j,
        title: T,
        className: se(O, J((A = {}, K(A, "".concat(O, "-disabled"), D), K(A, "".concat(O, "-start"), p(N) === 1 || o === "year" && Number(T) % 10 === 0), K(A, "".concat(O, "-end"), T === KY(b, N) || o === "year" && Number(T) % 10 === 9), A), f(N))),
        onClick: function() {
          D || r(N);
        },
        onMouseEnter: function() {
          !D && x && x(N);
        },
        onMouseLeave: function() {
          !D && S && S(N);
        }
      }, h ? h(N, L) : L));
    }, j = 0; j < a; j += 1)
      I();
    $.push(/* @__PURE__ */ c.createElement("tr", {
      key: _,
      className: l && l(P)
    }, R));
  }
  return /* @__PURE__ */ c.createElement("div", {
    className: "".concat(t, "-body")
  }, /* @__PURE__ */ c.createElement("table", {
    className: "".concat(t, "-content")
  }, v && /* @__PURE__ */ c.createElement("thead", null, /* @__PURE__ */ c.createElement("tr", null, v)), /* @__PURE__ */ c.createElement("tbody", null, $)));
}
function UY(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.prefixColumn, o = e.locale, i = e.rowCount, a = e.viewDate, s = e.value, l = e.cellRender, u = e.isSameCell, f = c.useContext(Dl), p = f.rangedValue, h = f.hoverRangedValue, y = MY(o.locale, n, a), b = "".concat(t, "-cell"), m = n.locale.getWeekFirstDay(o.locale), v = n.getNow(), C = [], x = o.shortWeekDays || (n.locale.getShortWeekDays ? n.locale.getShortWeekDays(o.locale) : []);
  r && C.push(/* @__PURE__ */ c.createElement("th", {
    key: "empty",
    "aria-label": "empty cell"
  }));
  for (var S = 0; S < sd; S += 1)
    C.push(/* @__PURE__ */ c.createElement("th", {
      key: S
    }, x[(S + m) % sd]));
  var E = Zg({
    cellPrefixCls: b,
    today: v,
    value: s,
    generateConfig: n,
    rangedValue: r ? null : p,
    hoverRangedValue: r ? null : h,
    isSameCell: u || function($, _) {
      return Aa(n, $, _);
    },
    isInView: function(_) {
      return Yb(n, _, a);
    },
    offsetCell: function(_, R) {
      return n.addDate(_, R);
    }
  }), O = l ? function($, _) {
    return l($, {
      originNode: _,
      today: v,
      type: "date",
      locale: o
    });
  } : void 0;
  return /* @__PURE__ */ c.createElement(rf, Oe({}, e, {
    rowNum: i,
    colNum: sd,
    baseDate: y,
    getCellNode: O,
    getCellText: n.getDate,
    getCellClassName: E,
    getCellDate: n.addDate,
    titleCell: function(_) {
      return bo(_, {
        locale: o,
        format: "YYYY-MM-DD",
        generateConfig: n
      });
    },
    headerCells: C
  }));
}
var Op = {
  visibility: "hidden"
};
function iu(e) {
  var t = e.prefixCls, n = e.prevIcon, r = n === void 0 ? "‹" : n, o = e.nextIcon, i = o === void 0 ? "›" : o, a = e.superPrevIcon, s = a === void 0 ? "«" : a, l = e.superNextIcon, u = l === void 0 ? "»" : l, f = e.onSuperPrev, p = e.onSuperNext, h = e.onPrev, y = e.onNext, b = e.children, m = c.useContext(Ho), v = m.hideNextBtn, C = m.hidePrevBtn;
  return /* @__PURE__ */ c.createElement("div", {
    className: t
  }, f && /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: f,
    tabIndex: -1,
    className: "".concat(t, "-super-prev-btn"),
    style: C ? Op : {}
  }, s), h && /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: h,
    tabIndex: -1,
    className: "".concat(t, "-prev-btn"),
    style: C ? Op : {}
  }, r), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(t, "-view")
  }, b), y && /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: y,
    tabIndex: -1,
    className: "".concat(t, "-next-btn"),
    style: v ? Op : {}
  }, i), p && /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: p,
    tabIndex: -1,
    className: "".concat(t, "-super-next-btn"),
    style: v ? Op : {}
  }, u));
}
function GY(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.locale, o = e.viewDate, i = e.onNextMonth, a = e.onPrevMonth, s = e.onNextYear, l = e.onPrevYear, u = e.onYearClick, f = e.onMonthClick, p = c.useContext(Ho), h = p.hideHeader;
  if (h)
    return null;
  var y = "".concat(t, "-header"), b = r.shortMonths || (n.locale.getShortMonths ? n.locale.getShortMonths(r.locale) : []), m = n.getMonth(o), v = /* @__PURE__ */ c.createElement("button", {
    type: "button",
    key: "year",
    onClick: u,
    tabIndex: -1,
    className: "".concat(t, "-year-btn")
  }, bo(o, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  })), C = /* @__PURE__ */ c.createElement("button", {
    type: "button",
    key: "month",
    onClick: f,
    tabIndex: -1,
    className: "".concat(t, "-month-btn")
  }, r.monthFormat ? bo(o, {
    locale: r,
    format: r.monthFormat,
    generateConfig: n
  }) : b[m]), x = r.monthBeforeYear ? [C, v] : [v, C];
  return /* @__PURE__ */ c.createElement(iu, Oe({}, e, {
    prefixCls: y,
    onSuperPrev: l,
    onPrev: a,
    onNext: i,
    onSuperNext: s
  }), x);
}
var qY = 6;
function Xb(e) {
  var t = e.prefixCls, n = e.panelName, r = n === void 0 ? "date" : n, o = e.keyboardConfig, i = e.active, a = e.operationRef, s = e.generateConfig, l = e.value, u = e.viewDate, f = e.onViewDateChange, p = e.onPanelChange, h = e.onSelect, y = "".concat(t, "-").concat(r, "-panel");
  a.current = {
    onKeyDown: function(C) {
      return ou(C, J({
        onLeftRight: function(S) {
          h(s.addDate(l || u, S), "key");
        },
        onCtrlLeftRight: function(S) {
          h(s.addYear(l || u, S), "key");
        },
        onUpDown: function(S) {
          h(s.addDate(l || u, S * sd), "key");
        },
        onPageUpDown: function(S) {
          h(s.addMonth(l || u, S), "key");
        }
      }, o));
    }
  };
  var b = function(C) {
    var x = s.addYear(u, C);
    f(x), p(null, x);
  }, m = function(C) {
    var x = s.addMonth(u, C);
    f(x), p(null, x);
  };
  return /* @__PURE__ */ c.createElement("div", {
    className: se(y, K({}, "".concat(y, "-active"), i))
  }, /* @__PURE__ */ c.createElement(GY, Oe({}, e, {
    prefixCls: t,
    value: l,
    viewDate: u,
    onPrevYear: function() {
      b(-1);
    },
    onNextYear: function() {
      b(1);
    },
    onPrevMonth: function() {
      m(-1);
    },
    onNextMonth: function() {
      m(1);
    },
    onMonthClick: function() {
      p("month", u);
    },
    onYearClick: function() {
      p("year", u);
    }
  })), /* @__PURE__ */ c.createElement(UY, Oe({}, e, {
    onSelect: function(C) {
      return h(C, "mouse");
    },
    prefixCls: t,
    value: l,
    viewDate: u,
    rowCount: qY
  })));
}
function YY(e) {
  var t = e.value, n = e.generateConfig, r = e.disabledMinutes, o = e.disabledSeconds, i = e.minutes, a = e.seconds, s = e.use12Hours, l = function(f, p, h, y) {
    var b = n.getNow(), m = t || b, v = !s || !f ? p : p + 12, C = p < 0 ? n.getHour(b) : v, x = h < 0 ? n.getMinute(b) : h, S = y < 0 ? n.getSecond(b) : y, E = r && r(C);
    if (E != null && E.includes(x)) {
      var O = i.find(function(R) {
        return !E.includes(R.value);
      });
      if (O)
        x = O.value;
      else
        return null;
    }
    var $ = o && o(C, x);
    if ($ != null && $.includes(S)) {
      var _ = a.find(function(R) {
        return !$.includes(R.value);
      });
      if (_)
        S = _.value;
      else
        return null;
    }
    return m = M_(n, m, C, x, S), m;
  };
  return l;
}
function _p(e) {
  var t = e.prefixCls, n = e.units, r = e.onSelect, o = e.value, i = e.active, a = e.hideDisabledOptions, s = e.info, l = e.type, u = "".concat(t, "-cell"), f = c.useContext(Ho), p = f.open, h = _t(null), y = _t(/* @__PURE__ */ new Map()), b = _t();
  return A0(function() {
    var m = y.current.get(o);
    m && p !== !1 && J1(h.current, m.offsetTop, 120);
  }, [o]), A0(function() {
    if (p) {
      var m = y.current.get(o);
      m && (b.current = LY(m, function() {
        J1(h.current, m.offsetTop, 0);
      }));
    }
    return function() {
      var v;
      (v = b.current) === null || v === void 0 || v.call(b);
    };
  }, [p]), /* @__PURE__ */ c.createElement("ul", {
    className: se("".concat(t, "-column"), K({}, "".concat(t, "-column-active"), i)),
    ref: h,
    style: {
      position: "relative"
    }
  }, n.map(function(m) {
    var v;
    return a && m.disabled ? null : /* @__PURE__ */ c.createElement("li", {
      key: m.value,
      ref: function(x) {
        y.current.set(m.value, x);
      },
      className: se(u, (v = {}, K(v, "".concat(u, "-disabled"), m.disabled), K(v, "".concat(u, "-selected"), o === m.value), v)),
      onClick: function() {
        m.disabled || r(m.value);
      }
    }, s.cellRender ? s.cellRender(m.value, {
      today: s.today,
      locale: s.locale,
      originNode: /* @__PURE__ */ c.createElement("div", {
        className: "".concat(u, "-inner")
      }, m.label),
      type: "time",
      subType: l
    }) : /* @__PURE__ */ c.createElement("div", {
      className: "".concat(u, "-inner")
    }, m.label));
  }));
}
function XY(e, t) {
  if (e.length !== t.length)
    return !0;
  for (var n = 0; n < e.length; n += 1)
    if (e[n].disabled !== t[n].disabled)
      return !0;
  return !1;
}
function Jv(e, t, n, r) {
  for (var o = [], i = n >= 1 ? n | 0 : 1, a = e; a <= t; a += i)
    o.push({
      label: D_(a, 2),
      value: a,
      disabled: (r || []).includes(a)
    });
  return o;
}
function ZY(e) {
  var t = e.generateConfig, n = e.prefixCls, r = e.operationRef, o = e.activeColumnIndex, i = e.value, a = e.showHour, s = e.showMinute, l = e.showSecond, u = e.use12Hours, f = e.hourStep, p = f === void 0 ? 1 : f, h = e.minuteStep, y = h === void 0 ? 1 : h, b = e.secondStep, m = b === void 0 ? 1 : b, v = e.disabledHours, C = e.disabledMinutes, x = e.disabledSeconds, S = e.disabledTime, E = e.hideDisabledOptions, O = e.onSelect, $ = e.cellRender, _ = e.locale, R = [], P = "".concat(n, "-content"), I = "".concat(n, "-time-panel"), j, F = i ? t.getHour(i) : -1, A = F, M = i ? t.getMinute(i) : -1, N = i ? t.getSecond(i) : -1, D = t.getNow(), T = c.useMemo(function() {
    if (S) {
      var G = S(D);
      return [G.disabledHours, G.disabledMinutes, G.disabledSeconds];
    }
    return [v, C, x];
  }, [v, C, x, S, D]), L = de(T, 3), z = L[0], H = L[1], V = L[2], Y = Jv(0, 23, p, z && z()), Z = ua(function() {
    return Y;
  }, Y, XY);
  u && (j = A >= 12, A %= 12);
  var oe = c.useMemo(function() {
    if (!u)
      return [!1, !1];
    var G = [!0, !0];
    return Z.forEach(function(ne) {
      var fe = ne.disabled, ye = ne.value;
      fe || (ye >= 12 ? G[1] = !1 : G[0] = !1);
    }), G;
  }, [u, Z]), ee = de(oe, 2), ae = ee[0], le = ee[1], ue = c.useMemo(function() {
    return u ? Z.filter(j ? function(G) {
      return G.value >= 12;
    } : function(G) {
      return G.value < 12;
    }).map(function(G) {
      var ne = G.value % 12, fe = ne === 0 ? "12" : D_(ne, 2);
      return J(J({}, G), {}, {
        label: fe,
        value: ne
      });
    }) : Z;
  }, [u, j, Z]), ie = Jv(0, 59, y, H && H(F)), re = Jv(0, 59, m, V && V(F, M)), Q = YY({
    value: i,
    generateConfig: t,
    disabledMinutes: H,
    disabledSeconds: V,
    minutes: ie,
    seconds: re,
    use12Hours: u
  });
  r.current = {
    onUpDown: function(ne) {
      var fe = R[o];
      if (fe)
        for (var ye = fe.units.findIndex(function(Ce) {
          return Ce.value === fe.value;
        }), we = fe.units.length, he = 1; he < we; he += 1) {
          var me = fe.units[(ye + ne * he + we) % we];
          if (me.disabled !== !0) {
            fe.onSelect(me.value);
            break;
          }
        }
    }
  };
  function ce(G, ne, fe, ye, we) {
    G !== !1 && R.push({
      node: /* @__PURE__ */ c.cloneElement(ne, {
        prefixCls: I,
        value: fe,
        active: o === R.length,
        onSelect: we,
        units: ye,
        hideDisabledOptions: E
      }),
      onSelect: we,
      value: fe,
      units: ye
    });
  }
  ce(a, /* @__PURE__ */ c.createElement(_p, {
    key: "hour",
    type: "hour",
    info: {
      today: D,
      locale: _,
      cellRender: $
    }
  }), A, ue, function(G) {
    O(Q(j, G, M, N), "mouse");
  }), ce(s, /* @__PURE__ */ c.createElement(_p, {
    key: "minute",
    type: "minute",
    info: {
      today: D,
      locale: _,
      cellRender: $
    }
  }), M, ie, function(G) {
    O(Q(j, A, G, N), "mouse");
  }), ce(l, /* @__PURE__ */ c.createElement(_p, {
    key: "second",
    type: "second",
    info: {
      today: D,
      locale: _,
      cellRender: $
    }
  }), N, re, function(G) {
    O(Q(j, A, M, G), "mouse");
  });
  var ge = -1;
  return typeof j == "boolean" && (ge = j ? 1 : 0), ce(u === !0, /* @__PURE__ */ c.createElement(_p, {
    key: "meridiem",
    type: "meridiem",
    info: {
      today: D,
      locale: _,
      cellRender: $
    }
  }), ge, [{
    label: "AM",
    value: 0,
    disabled: ae
  }, {
    label: "PM",
    value: 1,
    disabled: le
  }], function(G) {
    O(Q(!!G, A, M, N), "mouse");
  }), /* @__PURE__ */ c.createElement("div", {
    className: P
  }, R.map(function(G) {
    var ne = G.node;
    return ne;
  }));
}
function QY(e) {
  var t = c.useContext(Ho), n = t.hideHeader;
  if (n)
    return null;
  var r = e.prefixCls, o = e.generateConfig, i = e.locale, a = e.value, s = e.format, l = "".concat(r, "-header");
  return /* @__PURE__ */ c.createElement(iu, {
    prefixCls: l
  }, a ? bo(a, {
    locale: i,
    format: s,
    generateConfig: o
  }) : " ");
}
var JY = function(t) {
  return t.filter(function(n) {
    return n !== !1;
  }).length;
};
function A_(e) {
  var t = e.generateConfig, n = e.format, r = n === void 0 ? "HH:mm:ss" : n, o = e.prefixCls, i = e.active, a = e.operationRef, s = e.showHour, l = e.showMinute, u = e.showSecond, f = e.use12Hours, p = f === void 0 ? !1 : f, h = e.onSelect, y = e.value, b = "".concat(o, "-time-panel"), m = c.useRef(), v = c.useState(-1), C = de(v, 2), x = C[0], S = C[1], E = JY([s, l, u, p]);
  return a.current = {
    onKeyDown: function($) {
      return ou($, {
        onLeftRight: function(R) {
          S((x + R + E) % E);
        },
        onUpDown: function(R) {
          x === -1 ? S(0) : m.current && m.current.onUpDown(R);
        },
        onEnter: function() {
          h(y || t.getNow(), "key"), S(-1);
        }
      });
    },
    onBlur: function() {
      S(-1);
    }
  }, /* @__PURE__ */ c.createElement("div", {
    className: se(b, K({}, "".concat(b, "-active"), i))
  }, /* @__PURE__ */ c.createElement(QY, Oe({}, e, {
    format: r,
    prefixCls: o
  })), /* @__PURE__ */ c.createElement(ZY, Oe({}, e, {
    prefixCls: o,
    activeColumnIndex: x,
    operationRef: m
  })));
}
var vE = VY("date", "time"), e0 = function(t, n, r) {
  var o = new Set(n);
  if (o.has(t)) {
    for (var i = 0; i <= r; i++)
      if (!o.has(i) && i >= t)
        return i;
  }
  return t;
};
function eX(e) {
  var t = e.prefixCls, n = e.operationRef, r = e.generateConfig, o = e.value, i = e.defaultValue, a = e.disabledTime, s = e.showTime, l = e.onSelect, u = e.cellRender, f = "".concat(t, "-datetime-panel"), p = c.useState(null), h = de(p, 2), y = h[0], b = h[1], m = c.useRef({}), v = c.useRef({}), C = Vt(s) === "object" ? J({}, s) : {};
  function x($) {
    var _ = vE.indexOf(y) + $, R = vE[_] || null;
    return R;
  }
  var S = function(_) {
    v.current.onBlur && v.current.onBlur(_), b(null);
  };
  n.current = {
    onKeyDown: function(_) {
      if (_.which === Pe.TAB) {
        var R = x(_.shiftKey ? -1 : 1);
        return b(R), R && _.preventDefault(), !0;
      }
      if (y) {
        var P = y === "date" ? m : v;
        return P.current && P.current.onKeyDown && P.current.onKeyDown(_), !0;
      }
      return [Pe.LEFT, Pe.RIGHT, Pe.UP, Pe.DOWN].includes(_.which) ? (b("date"), !0) : !1;
    },
    onBlur: S,
    onClose: S
  };
  var E = function(_, R) {
    var P = _;
    if (R === "date") {
      var I, j, F, A = (a == null ? void 0 : a(o || C.defaultValue)) || {}, M = e0(r.getHour(P), ((I = A.disabledHours) === null || I === void 0 ? void 0 : I.call(A)) || [-1], 23), N = e0(r.getMinute(P), ((j = A.disabledMinutes) === null || j === void 0 ? void 0 : j.call(A, M)) || [-1], 59), D = e0(r.getSecond(P), ((F = A.disabledSeconds) === null || F === void 0 ? void 0 : F.call(A, M, N)) || [-1], 59);
      P = r.setHour(P, M), P = r.setMinute(P, N), P = r.setSecond(P, D);
    } else
      R === "time" && !o && i && (P = r.setYear(P, r.getYear(i)), P = r.setMonth(P, r.getMonth(i)), P = r.setDate(P, r.getDate(i)));
    l && l(P, "mouse");
  }, O = a ? a(o || null) : {};
  return /* @__PURE__ */ c.createElement("div", {
    className: se(f, K({}, "".concat(f, "-active"), y))
  }, /* @__PURE__ */ c.createElement(Xb, Oe({}, e, {
    cellRender: u,
    operationRef: m,
    active: y === "date",
    onSelect: function(_) {
      E(L_(r, _, !o && Vt(s) === "object" ? s.defaultValue : null), "date");
    }
  })), /* @__PURE__ */ c.createElement(A_, Oe({}, e, {
    cellRender: u ? function($, _) {
      return u($, J(J({}, _), {}, {
        type: "time"
      }));
    } : void 0,
    format: void 0
  }, C, O, {
    disabledTime: null,
    defaultValue: void 0,
    operationRef: v,
    active: y === "time",
    onSelect: function(_) {
      E(_, "time");
    }
  })));
}
function tX(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.viewDate, o = e.onPrevDecades, i = e.onNextDecades, a = c.useContext(Ho), s = a.hideHeader;
  if (s)
    return null;
  var l = "".concat(t, "-header"), u = n.getYear(r), f = Math.floor(u / La) * La, p = f + La - 1;
  return /* @__PURE__ */ c.createElement(iu, Oe({}, e, {
    prefixCls: l,
    onSuperPrev: o,
    onSuperNext: i
  }), f, "-", p);
}
var ny = 3, yE = 4;
function nX(e) {
  var t = Li - 1, n = e.prefixCls, r = e.viewDate, o = e.generateConfig, i = e.cellRender, a = e.locale, s = "".concat(n, "-cell"), l = o.getYear(r), u = Math.floor(l / Li) * Li, f = Math.floor(l / La) * La, p = f + La - 1, h = o.setYear(r, f - Math.ceil((ny * yE * Li - La) / 2)), y = function(v) {
    var C, x = o.getYear(v), S = x + t;
    return C = {}, K(C, "".concat(s, "-in-view"), f <= x && S <= p), K(C, "".concat(s, "-selected"), x === u), C;
  }, b = i ? function(m, v) {
    return i(m, {
      originNode: v,
      today: o.getNow(),
      type: "decade",
      locale: a
    });
  } : void 0;
  return /* @__PURE__ */ c.createElement(rf, Oe({}, e, {
    rowNum: yE,
    colNum: ny,
    baseDate: h,
    getCellNode: b,
    getCellText: function(v) {
      var C = o.getYear(v);
      return "".concat(C, "-").concat(C + t);
    },
    getCellClassName: y,
    getCellDate: function(v, C) {
      return o.addYear(v, C * Li);
    }
  }));
}
function rX(e) {
  var t = e.prefixCls, n = e.onViewDateChange, r = e.generateConfig, o = e.viewDate, i = e.operationRef, a = e.onSelect, s = e.onPanelChange, l = "".concat(t, "-decade-panel");
  i.current = {
    onKeyDown: function(h) {
      return ou(h, {
        onLeftRight: function(b) {
          a(r.addYear(o, b * Li), "key");
        },
        onCtrlLeftRight: function(b) {
          a(r.addYear(o, b * La), "key");
        },
        onUpDown: function(b) {
          a(r.addYear(o, b * Li * ny), "key");
        },
        onEnter: function() {
          s("year", o);
        }
      });
    }
  };
  var u = function(h) {
    var y = r.addYear(o, h * La);
    n(y), s(null, y);
  }, f = function(h) {
    a(h, "mouse"), s("year", h);
  };
  return /* @__PURE__ */ c.createElement("div", {
    className: l
  }, /* @__PURE__ */ c.createElement(tX, Oe({}, e, {
    prefixCls: t,
    onPrevDecades: function() {
      u(-1);
    },
    onNextDecades: function() {
      u(1);
    }
  })), /* @__PURE__ */ c.createElement(nX, Oe({}, e, {
    prefixCls: t,
    onSelect: f
  })));
}
function oX(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.locale, o = e.viewDate, i = e.onNextYear, a = e.onPrevYear, s = e.onYearClick, l = c.useContext(Ho), u = l.hideHeader;
  if (u)
    return null;
  var f = "".concat(t, "-header");
  return /* @__PURE__ */ c.createElement(iu, Oe({}, e, {
    prefixCls: f,
    onSuperPrev: a,
    onSuperNext: i
  }), /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: s,
    className: "".concat(t, "-year-btn")
  }, bo(o, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  })));
}
var Zb = 3, iX = 4;
function aX(e) {
  var t = e.prefixCls, n = e.locale, r = e.value, o = e.viewDate, i = e.generateConfig, a = e.cellRender, s = c.useContext(Dl), l = s.rangedValue, u = s.hoverRangedValue, f = "".concat(t, "-cell"), p = Zg({
    cellPrefixCls: f,
    value: r,
    generateConfig: i,
    rangedValue: l,
    hoverRangedValue: u,
    isSameCell: function(v, C) {
      return Yb(i, v, C);
    },
    isInView: function() {
      return !0;
    },
    offsetCell: function(v, C) {
      return i.addMonth(v, C);
    }
  }), h = n.shortMonths || (i.locale.getShortMonths ? i.locale.getShortMonths(n.locale) : []), y = i.setMonth(o, 0), b = a ? function(m, v) {
    return a(m, {
      originNode: v,
      locale: n,
      today: i.getNow(),
      type: "month"
    });
  } : void 0;
  return /* @__PURE__ */ c.createElement(rf, Oe({}, e, {
    rowNum: iX,
    colNum: Zb,
    baseDate: y,
    getCellNode: b,
    getCellText: function(v) {
      return n.monthFormat ? bo(v, {
        locale: n,
        format: n.monthFormat,
        generateConfig: i
      }) : h[i.getMonth(v)];
    },
    getCellClassName: p,
    getCellDate: i.addMonth,
    titleCell: function(v) {
      return bo(v, {
        locale: n,
        format: "YYYY-MM",
        generateConfig: i
      });
    }
  }));
}
function sX(e) {
  var t = e.prefixCls, n = e.operationRef, r = e.onViewDateChange, o = e.generateConfig, i = e.value, a = e.viewDate, s = e.onPanelChange, l = e.onSelect, u = "".concat(t, "-month-panel");
  n.current = {
    onKeyDown: function(h) {
      return ou(h, {
        onLeftRight: function(b) {
          l(o.addMonth(i || a, b), "key");
        },
        onCtrlLeftRight: function(b) {
          l(o.addYear(i || a, b), "key");
        },
        onUpDown: function(b) {
          l(o.addMonth(i || a, b * Zb), "key");
        },
        onEnter: function() {
          s("date", i || a);
        }
      });
    }
  };
  var f = function(h) {
    var y = o.addYear(a, h);
    r(y), s(null, y);
  };
  return /* @__PURE__ */ c.createElement("div", {
    className: u
  }, /* @__PURE__ */ c.createElement(oX, Oe({}, e, {
    prefixCls: t,
    onPrevYear: function() {
      f(-1);
    },
    onNextYear: function() {
      f(1);
    },
    onYearClick: function() {
      s("year", a);
    }
  })), /* @__PURE__ */ c.createElement(aX, Oe({}, e, {
    prefixCls: t,
    onSelect: function(h) {
      l(h, "mouse"), s("date", h);
    }
  })));
}
function lX(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.locale, o = e.viewDate, i = e.onNextYear, a = e.onPrevYear, s = e.onYearClick, l = c.useContext(Ho), u = l.hideHeader;
  if (u)
    return null;
  var f = "".concat(t, "-header");
  return /* @__PURE__ */ c.createElement(iu, Oe({}, e, {
    prefixCls: f,
    onSuperPrev: a,
    onSuperNext: i
  }), /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: s,
    className: "".concat(t, "-year-btn")
  }, bo(o, {
    locale: r,
    format: r.yearFormat,
    generateConfig: n
  })));
}
var cX = 4, uX = 1;
function dX(e) {
  var t = e.prefixCls, n = e.locale, r = e.value, o = e.viewDate, i = e.generateConfig, a = e.cellRender, s = c.useContext(Dl), l = s.rangedValue, u = s.hoverRangedValue, f = "".concat(t, "-cell"), p = Zg({
    cellPrefixCls: f,
    value: r,
    generateConfig: i,
    rangedValue: l,
    hoverRangedValue: u,
    isSameCell: function(m, v) {
      return $_(i, m, v);
    },
    isInView: function() {
      return !0;
    },
    offsetCell: function(m, v) {
      return i.addMonth(m, v * 3);
    }
  }), h = i.setDate(i.setMonth(o, 0), 1), y = a ? function(b, m) {
    return a(b, {
      originNode: m,
      locale: n,
      today: i.getNow(),
      type: "quarter"
    });
  } : void 0;
  return /* @__PURE__ */ c.createElement(rf, Oe({}, e, {
    rowNum: uX,
    colNum: cX,
    baseDate: h,
    getCellNode: y,
    getCellText: function(m) {
      return bo(m, {
        locale: n,
        format: n.quarterFormat || "[Q]Q",
        generateConfig: i
      });
    },
    getCellClassName: p,
    getCellDate: function(m, v) {
      return i.addMonth(m, v * 3);
    },
    titleCell: function(m) {
      return bo(m, {
        locale: n,
        format: "YYYY-[Q]Q",
        generateConfig: i
      });
    }
  }));
}
function fX(e) {
  var t = e.prefixCls, n = e.operationRef, r = e.onViewDateChange, o = e.generateConfig, i = e.value, a = e.viewDate, s = e.onPanelChange, l = e.onSelect, u = "".concat(t, "-quarter-panel");
  n.current = {
    onKeyDown: function(h) {
      return ou(h, {
        onLeftRight: function(b) {
          l(o.addMonth(i || a, b * 3), "key");
        },
        onCtrlLeftRight: function(b) {
          l(o.addYear(i || a, b), "key");
        },
        onUpDown: function(b) {
          l(o.addYear(i || a, b), "key");
        }
      });
    }
  };
  var f = function(h) {
    var y = o.addYear(a, h);
    r(y), s(null, y);
  };
  return /* @__PURE__ */ c.createElement("div", {
    className: u
  }, /* @__PURE__ */ c.createElement(lX, Oe({}, e, {
    prefixCls: t,
    onPrevYear: function() {
      f(-1);
    },
    onNextYear: function() {
      f(1);
    },
    onYearClick: function() {
      s("year", a);
    }
  })), /* @__PURE__ */ c.createElement(dX, Oe({}, e, {
    prefixCls: t,
    onSelect: function(h) {
      l(h, "mouse");
    }
  })));
}
function pX(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.locale, o = e.value, i = e.disabledDate, a = e.onSelect, s = c.useContext(Dl), l = s.rangedValue, u = s.hoverRangedValue, f = c.useContext(Ho), p = f.onDateMouseEnter, h = f.onDateMouseLeave, y = (u == null ? void 0 : u[0]) || (l == null ? void 0 : l[0]), b = (u == null ? void 0 : u[1]) || (l == null ? void 0 : l[1]), m = "".concat(t, "-cell"), v = function(E) {
    var O = Ah({
      cellDate: E,
      mode: "week",
      disabledDate: i,
      generateConfig: n
    });
    return /* @__PURE__ */ c.createElement("td", {
      key: "week",
      className: se(m, "".concat(m, "-week")),
      onClick: function() {
        O || a(E, "mouse");
      },
      onMouseEnter: function() {
        !O && p && p(E);
      },
      onMouseLeave: function() {
        !O && h && h(E);
      }
    }, /* @__PURE__ */ c.createElement("div", {
      className: "".concat(m, "-inner")
    }, n.locale.getWeek(r.locale, E)));
  }, C = "".concat(t, "-week-panel-row"), x = function(E) {
    var O, $ = rh(n, r.locale, y, E), _ = rh(n, r.locale, b, E);
    return se(C, (O = {}, K(O, "".concat(C, "-selected"), !l && rh(n, r.locale, o, E)), K(O, "".concat(C, "-range-start"), $), K(O, "".concat(C, "-range-end"), _), K(O, "".concat(C, "-range-hover"), !$ && !_ && Zu(n, y, b, E)), O));
  };
  return /* @__PURE__ */ c.createElement(Xb, Oe({}, e, {
    panelName: "week",
    prefixColumn: v,
    rowClassName: x,
    keyboardConfig: {
      onLeftRight: null
    },
    isSameCell: function() {
      return !1;
    }
  }));
}
var bs = 10;
function hX(e) {
  var t = e.prefixCls, n = e.generateConfig, r = e.viewDate, o = e.onPrevDecade, i = e.onNextDecade, a = e.onDecadeClick, s = c.useContext(Ho), l = s.hideHeader;
  if (l)
    return null;
  var u = "".concat(t, "-header"), f = n.getYear(r), p = Math.floor(f / bs) * bs, h = p + bs - 1;
  return /* @__PURE__ */ c.createElement(iu, Oe({}, e, {
    prefixCls: u,
    onSuperPrev: o,
    onSuperNext: i
  }), /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: a,
    className: "".concat(t, "-decade-btn")
  }, p, "-", h));
}
var ry = 3, bE = 4;
function gX(e) {
  var t = e.prefixCls, n = e.value, r = e.viewDate, o = e.locale, i = e.generateConfig, a = e.cellRender, s = c.useContext(Dl), l = s.rangedValue, u = s.hoverRangedValue, f = "".concat(t, "-cell"), p = i.getYear(r), h = Math.floor(p / bs) * bs, y = h + bs - 1, b = i.setYear(r, h - Math.ceil((ry * bE - bs) / 2)), m = i.getNow(), v = function(E) {
    var O = i.getYear(E);
    return h <= O && O <= y;
  }, C = Zg({
    cellPrefixCls: f,
    value: n,
    generateConfig: i,
    rangedValue: l,
    hoverRangedValue: u,
    isSameCell: function(E, O) {
      return nf(i, E, O);
    },
    isInView: v,
    offsetCell: function(E, O) {
      return i.addYear(E, O);
    }
  }), x = a ? function(S, E) {
    return a(S, {
      originNode: E,
      today: m,
      type: "year",
      locale: o
    });
  } : void 0;
  return /* @__PURE__ */ c.createElement(rf, Oe({}, e, {
    rowNum: bE,
    colNum: ry,
    baseDate: b,
    getCellNode: x,
    getCellText: i.getYear,
    getCellClassName: C,
    getCellDate: i.addYear,
    titleCell: function(E) {
      return bo(E, {
        locale: o,
        format: "YYYY",
        generateConfig: i
      });
    }
  }));
}
function mX(e) {
  var t = e.prefixCls, n = e.operationRef, r = e.onViewDateChange, o = e.generateConfig, i = e.value, a = e.viewDate, s = e.sourceMode, l = e.onSelect, u = e.onPanelChange, f = "".concat(t, "-year-panel");
  n.current = {
    onKeyDown: function(y) {
      return ou(y, {
        onLeftRight: function(m) {
          l(o.addYear(i || a, m), "key");
        },
        onCtrlLeftRight: function(m) {
          l(o.addYear(i || a, m * bs), "key");
        },
        onUpDown: function(m) {
          l(o.addYear(i || a, m * ry), "key");
        },
        onEnter: function() {
          u(s === "date" ? "date" : "month", i || a);
        }
      });
    }
  };
  var p = function(y) {
    var b = o.addYear(a, y * 10);
    r(b), u(null, b);
  };
  return /* @__PURE__ */ c.createElement("div", {
    className: f
  }, /* @__PURE__ */ c.createElement(hX, Oe({}, e, {
    prefixCls: t,
    onPrevDecade: function() {
      p(-1);
    },
    onNextDecade: function() {
      p(1);
    },
    onDecadeClick: function() {
      u("decade", a);
    }
  })), /* @__PURE__ */ c.createElement(gX, Oe({}, e, {
    prefixCls: t,
    onSelect: function(y) {
      u(s === "date" ? "date" : "month", y), l(y, "mouse");
    }
  })));
}
function j_(e, t, n) {
  return n ? /* @__PURE__ */ c.createElement("div", {
    className: "".concat(e, "-footer-extra")
  }, n(t)) : null;
}
function k_(e) {
  var t = e.prefixCls, n = e.components, r = n === void 0 ? {} : n, o = e.needConfirmButton, i = e.onNow, a = e.onOk, s = e.okDisabled, l = e.showNow, u = e.locale, f, p;
  if (o) {
    var h = r.button || "button";
    i && l !== !1 && (f = /* @__PURE__ */ c.createElement("li", {
      className: "".concat(t, "-now")
    }, /* @__PURE__ */ c.createElement("a", {
      className: "".concat(t, "-now-btn"),
      onClick: i
    }, u.now))), p = o && /* @__PURE__ */ c.createElement("li", {
      className: "".concat(t, "-ok")
    }, /* @__PURE__ */ c.createElement(h, {
      disabled: s,
      onClick: a
    }, u.ok));
  }
  return !f && !p ? null : /* @__PURE__ */ c.createElement("ul", {
    className: "".concat(t, "-ranges")
  }, f, p);
}
var vX = ["date", "month"];
function F_(e) {
  var t, n = e, r = n.prefixCls, o = r === void 0 ? "rc-picker" : r, i = n.className, a = n.style, s = n.locale, l = n.generateConfig, u = n.value, f = n.defaultValue, p = n.pickerValue, h = n.defaultPickerValue, y = n.disabledDate, b = n.mode, m = n.picker, v = m === void 0 ? "date" : m, C = n.tabIndex, x = C === void 0 ? 0 : C, S = n.showNow, E = n.showTime, O = n.showToday, $ = n.renderExtraFooter, _ = n.hideHeader, R = n.onSelect, P = n.onChange, I = n.onPanelChange, j = n.onMouseDown, F = n.onPickerValueChange, A = n.onOk, M = n.components, N = n.direction, D = n.hourStep, T = D === void 0 ? 1 : D, L = n.minuteStep, z = L === void 0 ? 1 : L, H = n.secondStep, V = H === void 0 ? 1 : H, Y = n.dateRender, Z = n.monthCellRender, oe = n.cellRender, ee = v === "date" && !!E || v === "time", ae = 24 % T === 0, le = 60 % z === 0, ue = 60 % V === 0;
  process.env.NODE_ENV !== "production" && (mt(!u || l.isValidate(u), "Invalidate date pass to `value`."), mt(!u || l.isValidate(u), "Invalidate date pass to `defaultValue`."), mt(ae, "`hourStep` ".concat(T, " is invalid. It should be a factor of 24.")), mt(le, "`minuteStep` ".concat(z, " is invalid. It should be a factor of 60.")), mt(ue, "`secondStep` ".concat(V, " is invalid. It should be a factor of 60.")), mt(!h, "'defaultPickerValue' is deprecated. Please use 'defaultValue' instead."), mt(!Y, "'dateRender' is deprecated. Please use 'cellRender' instead."), mt(!Z, "'monthCellRender' is deprecated. Please use 'cellRender' instead."));
  var ie = c.useContext(Ho), re = ie.operationRef, Q = ie.onSelect, ce = ie.hideRanges, ge = ie.defaultOpenValue, G = c.useContext(Dl), ne = G.inRange, fe = G.panelPosition, ye = G.rangedValue, we = G.hoverRangedValue, he = c.useRef({}), me = c.useRef(!0), Ce = Fn(null, {
    value: u,
    defaultValue: f,
    postState: function(_e) {
      return !_e && ge && v === "time" ? ge : _e;
    }
  }), Te = de(Ce, 2), Ee = Te[0], Ge = Te[1], ke = Fn(null, {
    value: p,
    defaultValue: h || Ee,
    postState: function(_e) {
      var Ze = l.getNow();
      if (!_e)
        return Ze;
      if (!Ee && E) {
        var q = Vt(E) === "object" ? E.defaultValue : f;
        return L_(l, Array.isArray(_e) ? _e[0] : _e, q || Ze);
      }
      return Array.isArray(_e) ? _e[0] : _e;
    }
  }), qe = de(ke, 2), ze = qe[0], pt = qe[1], Ke = function(_e) {
    pt(_e), F && F(_e);
  }, et = function(_e) {
    var Ze = zY[v];
    return Ze ? Ze(_e) : _e;
  }, Je = Fn(function() {
    return v === "time" ? "time" : et("date");
  }, {
    value: b
  }), Et = de(Je, 2), Ye = Et[0], wt = Et[1];
  c.useEffect(function() {
    wt(v);
  }, [v]);
  var dt = c.useState(function() {
    return Ye;
  }), Ct = de(dt, 2), ot = Ct[0], jt = Ct[1], Rt = function(_e, Ze) {
    var q = et(_e || Ye);
    jt(Ye), wt(q), I && (Ye !== q || Bc(l, ze, ze)) && I(Ze, q);
  }, Le = function(_e, Ze) {
    var q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    (Ye === v || q) && (Ge(_e), R && R(_e), Q && Q(_e, Ze), P && !Bc(l, _e, Ee) && !(y != null && y(_e)) && P(_e));
  }, Ve = function(_e) {
    if (vX.includes(Ye)) {
      var Ze, q, Se = Ye === "date";
      switch (_e === Pe.PAGE_UP || _e === Pe.PAGE_DOWN ? q = Se ? l.addMonth : l.addYear : q = Se ? l.addDate : l.addMonth, _e) {
        case Pe.LEFT:
        case Pe.PAGE_UP:
          Ze = q(ze, -1);
          break;
        case Pe.RIGHT:
        case Pe.PAGE_DOWN:
          Ze = q(ze, 1);
          break;
        case Pe.UP:
        case Pe.DOWN:
          Ze = q(ze, Number("".concat(_e === Pe.UP ? "-" : "").concat(Se ? sd : Zb)));
          break;
      }
      if (Ze)
        return !(y != null && y(Ze));
    }
    return !0;
  }, Ae = function(_e) {
    if (he.current && he.current.onKeyDown) {
      var Ze = !0, q = _e.which;
      if ([Pe.LEFT, Pe.RIGHT, Pe.UP, Pe.DOWN, Pe.PAGE_UP, Pe.PAGE_DOWN, Pe.ENTER].includes(q) && (_e.preventDefault(), q !== Pe.ENTER && x === 0 && (Ze = Ve(q))), Ze)
        return he.current.onKeyDown(_e);
    }
    return mt(!1, "Panel not correct handle keyDown event. Please help to fire issue about this."), !1;
  }, ft = function(_e) {
    he.current && he.current.onBlur && he.current.onBlur(_e);
  };
  re && fe !== "right" && (re.current = {
    onKeyDown: Ae,
    onClose: function() {
      he.current && he.current.onClose && he.current.onClose();
    }
  }), c.useEffect(function() {
    u && !me.current && pt(u);
  }, [u]), c.useEffect(function() {
    me.current = !1;
  }, []);
  var He, Fe = R_({
    cellRender: oe,
    monthCellRender: Z,
    dateRender: Y
  }), yt = J(J({}, e), {}, {
    cellRender: Fe,
    operationRef: he,
    prefixCls: o,
    viewDate: ze,
    value: Ee,
    onViewDateChange: Ke,
    sourceMode: ot,
    onPanelChange: Rt,
    disabledDate: y
  });
  switch (delete yt.onChange, delete yt.onSelect, Ye) {
    case "decade":
      He = /* @__PURE__ */ c.createElement(rX, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
      break;
    case "year":
      He = /* @__PURE__ */ c.createElement(mX, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
      break;
    case "month":
      He = /* @__PURE__ */ c.createElement(sX, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
      break;
    case "quarter":
      He = /* @__PURE__ */ c.createElement(fX, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
      break;
    case "week":
      He = /* @__PURE__ */ c.createElement(pX, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
      break;
    case "time":
      delete yt.showTime, He = /* @__PURE__ */ c.createElement(A_, Oe({}, yt, Vt(E) === "object" ? E : null, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
      break;
    default:
      E ? He = /* @__PURE__ */ c.createElement(eX, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      })) : He = /* @__PURE__ */ c.createElement(Xb, Oe({}, yt, {
        onSelect: function(_e, Ze) {
          Ke(_e), Le(_e, Ze);
        }
      }));
  }
  var Qe, tt, lt = function() {
    var _e = l.getNow(), Ze = WY(l.getHour(_e), l.getMinute(_e), l.getSecond(_e), ae ? T : 1, le ? z : 1, ue ? V : 1), q = M_(
      l,
      _e,
      Ze[0],
      // hour
      Ze[1],
      // minute
      Ze[2]
      // second
    );
    Le(q, "submit");
  };
  ce || (Qe = j_(o, Ye, $), E && Ye !== "date" ? tt = null : tt = k_({
    prefixCls: o,
    components: M,
    needConfirmButton: ee,
    okDisabled: !Ee || y && y(Ee),
    locale: s,
    showNow: S,
    onNow: ee && lt,
    onOk: function() {
      Ee && (Le(Ee, "submit", !0), A && A(Ee));
    }
  }));
  var ht;
  if (O && Ye === "date" && v === "date" && !E) {
    var bt = l.getNow(), ct = "".concat(o, "-today-btn"), xt = y && y(bt);
    ht = /* @__PURE__ */ c.createElement("a", {
      className: se(ct, xt && "".concat(ct, "-disabled")),
      "aria-disabled": xt,
      onClick: function() {
        xt || Le(bt, "mouse", !0);
      }
    }, s.today);
  }
  return /* @__PURE__ */ c.createElement(Ho.Provider, {
    value: J(J({}, ie), {}, {
      mode: Ye,
      hideHeader: "hideHeader" in e ? _ : ie.hideHeader,
      hidePrevBtn: ne && fe === "right",
      hideNextBtn: ne && fe === "left"
    })
  }, /* @__PURE__ */ c.createElement("div", {
    tabIndex: x,
    className: se("".concat(o, "-panel"), i, (t = {}, K(t, "".concat(o, "-panel-has-range"), ye && ye[0] && ye[1]), K(t, "".concat(o, "-panel-has-range-hover"), we && we[0] && we[1]), K(t, "".concat(o, "-panel-rtl"), N === "rtl"), t)),
    style: a,
    onKeyDown: Ae,
    onBlur: ft,
    onMouseDown: j
  }, He, Qe || tt || ht ? /* @__PURE__ */ c.createElement("div", {
    className: "".concat(o, "-footer")
  }, Qe, tt, ht) : null));
}
var yX = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function B_(e) {
  var t, n = e.prefixCls, r = e.popupElement, o = e.popupStyle, i = e.visible, a = e.dropdownClassName, s = e.dropdownAlign, l = e.transitionName, u = e.getPopupContainer, f = e.children, p = e.range, h = e.popupPlacement, y = e.direction, b = "".concat(n, "-dropdown"), m = function() {
    return h !== void 0 ? h : y === "rtl" ? "bottomRight" : "bottomLeft";
  };
  return /* @__PURE__ */ c.createElement(Jd, {
    showAction: [],
    hideAction: [],
    popupPlacement: m(),
    builtinPlacements: yX,
    prefixCls: b,
    popupTransitionName: l,
    popup: r,
    popupAlign: s,
    popupVisible: i,
    popupClassName: se(a, (t = {}, K(t, "".concat(b, "-range"), p), K(t, "".concat(b, "-rtl"), y === "rtl"), t)),
    popupStyle: o,
    getPopupContainer: u
  }, f);
}
function H_(e) {
  var t = e.prefixCls, n = e.presets, r = e.onClick, o = e.onHover;
  return n.length ? /* @__PURE__ */ c.createElement("div", {
    className: "".concat(t, "-presets")
  }, /* @__PURE__ */ c.createElement("ul", null, n.map(function(i, a) {
    var s = i.label, l = i.value;
    return /* @__PURE__ */ c.createElement("li", {
      key: a,
      onClick: function() {
        return r == null ? void 0 : r(mE(l));
      },
      onMouseEnter: function() {
        return o == null ? void 0 : o(mE(l));
      },
      onMouseLeave: function() {
        return o == null ? void 0 : o(null);
      }
    }, s);
  }))) : null;
}
function z_(e) {
  var t = e.picker, n = e.disabledHours, r = e.disabledMinutes, o = e.disabledSeconds;
  t === "time" && (n || r || o) && mt(!1, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
}
function V_(e, t, n) {
  var r = Vt(t) === "object" ? t.clearIcon : n;
  return r || /* @__PURE__ */ be.createElement("span", {
    className: "".concat(e, "-clear-btn")
  });
}
function bX(e) {
  var t, n = e, r = n.prefixCls, o = r === void 0 ? "rc-picker" : r, i = n.id, a = n.name, s = n.tabIndex, l = n.style, u = n.className, f = n.dropdownClassName, p = n.dropdownAlign, h = n.popupStyle, y = n.transitionName, b = n.generateConfig, m = n.locale, v = n.inputReadOnly, C = n.allowClear, x = n.autoFocus, S = n.showTime, E = n.picker, O = E === void 0 ? "date" : E, $ = n.format, _ = n.use12Hours, R = n.value, P = n.defaultValue, I = n.presets, j = n.open, F = n.defaultOpen, A = n.defaultOpenValue, M = n.suffixIcon, N = n.clearIcon, D = n.disabled, T = n.disabledDate, L = n.placeholder, z = n.getPopupContainer, H = n.pickerRef, V = n.panelRender, Y = n.onChange, Z = n.onOpenChange, oe = n.onFocus, ee = n.onBlur, ae = n.onMouseDown, le = n.onMouseUp, ue = n.onMouseEnter, ie = n.onMouseLeave, re = n.onContextMenu, Q = n.onClick, ce = n.onKeyDown, ge = n.onSelect, G = n.direction, ne = n.autoComplete, fe = ne === void 0 ? "off" : ne, ye = n.inputRender, we = n.changeOnBlur, he = c.useRef(null), me = O === "date" && !!S || O === "time", Ce = I_(I);
  process.env.NODE_ENV !== "production" && z_(e);
  var Te = T_(__($, O, S, _)), Ee = c.useRef(null), Ge = c.useRef(null), ke = c.useRef(null), qe = Fn(null, {
    value: R,
    defaultValue: P
  }), ze = de(qe, 2), pt = ze[0], Ke = ze[1], et = c.useState(pt), Je = de(et, 2), Et = Je[0], Ye = Je[1], wt = c.useRef(null), dt = Fn(!1, {
    value: j,
    defaultValue: F,
    postState: function(It) {
      return D ? !1 : It;
    },
    onChange: function(It) {
      Z && Z(It), !It && wt.current && wt.current.onClose && wt.current.onClose();
    }
  }), Ct = de(dt, 2), ot = Ct[0], jt = Ct[1], Rt = jh(Et, {
    formatList: Te,
    generateConfig: b,
    locale: m
  }), Le = de(Rt, 2), Ve = Le[0], Ae = Le[1], ft = ty({
    valueTexts: Ve,
    onTextChange: function(It) {
      var St = O_(It, {
        locale: m,
        formatList: Te,
        generateConfig: b
      });
      St && (!T || !T(St)) && Ye(St);
    }
  }), He = de(ft, 3), Fe = He[0], yt = He[1], Qe = He[2], tt = function(It) {
    Ye(It), Ke(It), Y && !Bc(b, pt, It) && Y(It, It ? bo(It, {
      generateConfig: b,
      locale: m,
      format: Te[0]
    }) : "");
  }, lt = function(It) {
    D && It || jt(It);
  }, ht = function(It) {
    return ot && wt.current && wt.current.onKeyDown ? wt.current.onKeyDown(It) : (mt(!1, "Picker not correct forward KeyDown operation. Please help to fire issue about this."), !1);
  }, bt = function() {
    for (var It = arguments.length, St = new Array(It), Lt = 0; Lt < It; Lt++)
      St[Lt] = arguments[Lt];
    Q == null || Q.apply(void 0, St), he.current && (he.current.focus(), lt(!0));
  }, ct = function(It) {
    we && tt(Et), ee == null || ee(It);
  }, xt = ey({
    blurToCancel: me,
    changeOnBlur: we,
    open: ot,
    value: Fe,
    triggerOpen: lt,
    forwardKeyDown: ht,
    isClickOutside: function(It) {
      return !P_([Ee.current, Ge.current, ke.current], It);
    },
    onSubmit: function() {
      return (
        // When user typing disabledDate with keyboard and enter, this value will be empty
        !Et || // Normal disabled check
        T && T(Et) ? !1 : (tt(Et), lt(!1), Qe(), !0)
      );
    },
    onCancel: function() {
      lt(!1), Ye(pt), Qe();
    },
    onKeyDown: function(It, St) {
      ce == null || ce(It, St);
    },
    onFocus: oe,
    onBlur: ct
  }), vt = de(xt, 2), _e = vt[0], Ze = vt[1], q = Ze.focused, Se = Ze.typing;
  c.useEffect(function() {
    ot || (Ye(pt), !Ve.length || Ve[0] === "" ? yt("") : Ae !== Fe && Qe());
  }, [ot, Ve]), c.useEffect(function() {
    ot || Qe();
  }, [O]), c.useEffect(function() {
    Ye(pt);
  }, [pt]), H && (H.current = {
    focus: function() {
      var It;
      (It = he.current) === null || It === void 0 || It.focus();
    },
    blur: function() {
      var It;
      (It = he.current) === null || It === void 0 || It.blur();
    }
  });
  var Re = Q1(Fe, {
    formatList: Te,
    generateConfig: b,
    locale: m
  }), ut = de(Re, 3), $t = ut[0], Ne = ut[1], Ie = ut[2], De = J(J({}, e), {}, {
    className: void 0,
    style: void 0,
    pickerValue: void 0,
    onPickerValueChange: void 0,
    onChange: null
  }), Me = /* @__PURE__ */ c.createElement("div", {
    className: "".concat(o, "-panel-layout")
  }, /* @__PURE__ */ c.createElement(H_, {
    prefixCls: o,
    presets: Ce,
    onClick: function(It) {
      tt(It), lt(!1);
    }
  }), /* @__PURE__ */ c.createElement(F_, Oe({}, De, {
    generateConfig: b,
    className: se(K({}, "".concat(o, "-panel-focused"), !Se)),
    value: Et,
    locale: m,
    tabIndex: -1,
    onSelect: function(It) {
      ge == null || ge(It), Ye(It);
    },
    direction: G,
    onPanelChange: function(It, St) {
      var Lt = e.onPanelChange;
      Ie(!0), Lt == null || Lt(It, St);
    }
  })));
  V && (Me = V(Me));
  var Tt = /* @__PURE__ */ c.createElement("div", {
    className: "".concat(o, "-panel-container"),
    ref: Ee,
    onMouseDown: function(It) {
      It.preventDefault();
    }
  }, Me), Pt;
  M && (Pt = /* @__PURE__ */ c.createElement("span", {
    className: "".concat(o, "-suffix"),
    onMouseDown: function(It) {
      It.preventDefault();
    }
  }, M)), process.env.NODE_ENV !== "production" && mt(!e.clearIcon, "`clearIcon` will be removed in future. Please use `allowClear` instead.");
  var Ut = V_(o, C, N), Kt = /* @__PURE__ */ c.createElement("span", {
    onMouseDown: function(It) {
      It.preventDefault(), It.stopPropagation();
    },
    onMouseUp: function(It) {
      It.preventDefault(), It.stopPropagation(), tt(null), lt(!1);
    },
    className: "".concat(o, "-clear"),
    role: "button"
  }, Ut), $n = !!C && pt && !D, Jt = J(J(J({
    id: i,
    tabIndex: s,
    disabled: D,
    readOnly: v || typeof Te[0] == "function" || !Se,
    value: $t || Fe,
    onChange: function(It) {
      yt(It.target.value);
    },
    autoFocus: x,
    placeholder: L,
    ref: he,
    title: Fe
  }, _e), {}, {
    size: N_(O, Te[0], b),
    name: a
  }, ei(e, {
    aria: !0,
    data: !0
  })), {}, {
    autoComplete: fe
  }), On = ye ? ye(Jt) : /* @__PURE__ */ c.createElement("input", Jt);
  process.env.NODE_ENV !== "production" && mt(!A, "`defaultOpenValue` may confuse user for the current value status. Please use `defaultValue` instead.");
  var Jn = function(It, St) {
    (St === "submit" || St !== "key" && !me) && (tt(It), lt(!1));
  }, er = G === "rtl" ? "bottomRight" : "bottomLeft";
  return /* @__PURE__ */ c.createElement(Ho.Provider, {
    value: {
      operationRef: wt,
      hideHeader: O === "time",
      onSelect: Jn,
      open: ot,
      defaultOpenValue: A,
      onDateMouseEnter: Ne,
      onDateMouseLeave: Ie
    }
  }, /* @__PURE__ */ c.createElement(B_, {
    visible: ot,
    popupElement: Tt,
    popupStyle: h,
    prefixCls: o,
    dropdownClassName: f,
    dropdownAlign: p,
    getPopupContainer: z,
    transitionName: y,
    popupPlacement: er,
    direction: G
  }, /* @__PURE__ */ c.createElement("div", {
    ref: ke,
    className: se(o, u, (t = {}, K(t, "".concat(o, "-disabled"), D), K(t, "".concat(o, "-focused"), q), K(t, "".concat(o, "-rtl"), G === "rtl"), t)),
    style: l,
    onMouseDown: ae,
    onMouseUp: le,
    onMouseEnter: ue,
    onMouseLeave: ie,
    onContextMenu: re,
    onClick: bt
  }, /* @__PURE__ */ c.createElement("div", {
    className: se("".concat(o, "-input"), K({}, "".concat(o, "-input-placeholder"), !!$t)),
    ref: Ge
  }, On, Pt, $n && Kt))));
}
var CX = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    var r;
    zr(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), K(nt(r), "pickerRef", /* @__PURE__ */ c.createRef()), K(nt(r), "focus", function() {
      r.pickerRef.current && r.pickerRef.current.focus();
    }), K(nt(r), "blur", function() {
      r.pickerRef.current && r.pickerRef.current.blur();
    }), r;
  }
  return Vr(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ c.createElement(bX, Oe({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]), n;
}(c.Component);
function xX(e, t) {
  var n = e.picker, r = e.locale, o = e.selectedValue, i = e.disabledDate, a = e.disabled, s = e.generateConfig, l = pn(o, 0), u = pn(o, 1);
  function f(m) {
    return s.locale.getWeekFirstDate(r.locale, m);
  }
  function p(m) {
    var v = s.getYear(m), C = s.getMonth(m);
    return v * 100 + C;
  }
  function h(m) {
    var v = s.getYear(m), C = Z1(s, m);
    return v * 10 + C;
  }
  var y = c.useCallback(function(m) {
    if (a[0] || i && i(m))
      return !0;
    if (a[1] && u)
      return !Aa(s, m, u) && s.isAfter(m, u);
    if (!t && u)
      switch (n) {
        case "quarter":
          return h(m) > h(u);
        case "month":
          return p(m) > p(u);
        case "week":
          return f(m) > f(u);
        default:
          return !Aa(s, m, u) && s.isAfter(m, u);
      }
    return !1;
  }, [i, a[1], u, t]), b = c.useCallback(function(m) {
    if (a[1] || i && i(m))
      return !0;
    if (a[0] && l)
      return !Aa(s, m, u) && s.isAfter(l, m);
    if (!t && l)
      switch (n) {
        case "quarter":
          return h(m) < h(l);
        case "month":
          return p(m) < p(l);
        case "week":
          return f(m) < f(l);
        default:
          return !Aa(s, m, l) && s.isAfter(l, m);
      }
    return !1;
  }, [i, a[0], l, t]);
  return [y, b];
}
function SX(e, t, n, r, o, i, a, s, l, u, f) {
  var p = c.useState(!1), h = de(p, 2), y = h[0], b = h[1], m = Fn(e || !1, {
    value: t
  }), v = de(m, 2), C = v[0], x = v[1], S = Fn(e || !1, {
    value: t,
    onChange: function(L) {
      f == null || f(L);
    }
  }), E = de(S, 2), O = E[0], $ = E[1], _ = Fn(0, {
    value: n
  }), R = de(_, 2), P = R[0], I = R[1], j = c.useState(null), F = de(j, 2), A = F[0], M = F[1];
  c.useEffect(function() {
    O && b(!0);
  }, [O]);
  var N = function(L) {
    return L === 0 ? 1 : 0;
  }, D = Ir(function(T, L, z) {
    if (L === !1)
      $(T);
    else if (T) {
      I(L), $(T);
      var H = N(L);
      !O || // Also set next index if next is empty
      ![s, l][H] ? M(H) : (b(!1), A !== null && M(null));
    } else if (z === "confirm" || z === "blur" && r) {
      var V = C && !o ? N(L) : A;
      V !== null && (b(!1), I(V)), M(null), V !== null && !u[V] ? Pn(function() {
        var Y, Z = [i, a][V];
        (Y = Z.current) === null || Y === void 0 || Y.focus();
      }) : $(!1);
    } else
      $(!1), x(!1);
  });
  return [O, P, y, D];
}
function wX(e, t, n, r) {
  var o = ld(e, n, r, 1);
  function i(a) {
    return a(e, t) ? "same" : a(o, t) ? "closing" : "far";
  }
  switch (n) {
    case "year":
      return i(function(a, s) {
        return DY(r, a, s);
      });
    case "quarter":
    case "month":
      return i(function(a, s) {
        return nf(r, a, s);
      });
    default:
      return i(function(a, s) {
        return Yb(r, a, s);
      });
  }
}
function EX(e, t, n, r) {
  var o = pn(e, 0), i = pn(e, 1);
  if (t === 0)
    return o;
  if (o && i) {
    var a = wX(o, i, n, r);
    switch (a) {
      case "same":
        return o;
      case "closing":
        return o;
      default:
        return ld(i, n, r, -1);
    }
  }
  return o;
}
function $X(e) {
  var t = e.values, n = e.picker, r = e.defaultDates, o = e.generateConfig, i = c.useState(function() {
    return [pn(r, 0), pn(r, 1)];
  }), a = de(i, 2), s = a[0], l = a[1], u = c.useState(null), f = de(u, 2), p = f[0], h = f[1], y = pn(t, 0), b = pn(t, 1);
  function m(C) {
    return s[C] ? s[C] : pn(p, C) || EX(t, C, n, o) || y || b || o.getNow();
  }
  function v(C, x) {
    if (C) {
      var S = gi(p, C, x);
      l(
        // Should always be an array
        gi(s, null, x) || [null, null]
      );
      var E = (x + 1) % 2;
      pn(t, E) || (S = gi(S, C, E)), h(S);
    } else
      (y || b) && h(null);
  }
  return [m, v];
}
function CE(e, t) {
  return e && e[0] && e[1] && t.isAfter(e[0], e[1]) ? [e[1], e[0]] : e;
}
function xE(e, t, n, r) {
  return !!(e || r && r[t] || n[(t + 1) % 2]);
}
function OX(e) {
  var t, n, r, o = e, i = o.prefixCls, a = i === void 0 ? "rc-picker" : i, s = o.id, l = o.style, u = o.className, f = o.popupStyle, p = o.dropdownClassName, h = o.transitionName, y = o.dropdownAlign, b = o.getPopupContainer, m = o.generateConfig, v = o.locale, C = o.placeholder, x = o.autoFocus, S = o.disabled, E = o.format, O = o.picker, $ = O === void 0 ? "date" : O, _ = o.showTime, R = o.use12Hours, P = o.separator, I = P === void 0 ? "~" : P, j = o.value, F = o.defaultValue, A = o.defaultPickerValue, M = o.open, N = o.defaultOpen, D = o.disabledDate, T = o.disabledTime, L = o.dateRender, z = o.monthCellRender, H = o.cellRender, V = o.panelRender, Y = o.presets, Z = o.ranges, oe = o.allowEmpty, ee = o.allowClear, ae = o.suffixIcon, le = o.clearIcon, ue = o.pickerRef, ie = o.inputReadOnly, re = o.mode, Q = o.renderExtraFooter, ce = o.onChange, ge = o.onOpenChange, G = o.onPanelChange, ne = o.onCalendarChange, fe = o.onFocus, ye = o.onBlur, we = o.onMouseDown, he = o.onMouseUp, me = o.onMouseEnter, Ce = o.onMouseLeave, Te = o.onClick, Ee = o.onOk, Ge = o.onKeyDown, ke = o.components, qe = o.order, ze = o.direction, pt = o.activePickerIndex, Ke = o.autoComplete, et = Ke === void 0 ? "off" : Ke, Je = o.changeOnBlur, Et = $ === "date" && !!_ || $ === "time", Ye = _t(null), wt = _t(null), dt = _t(null), Ct = _t(null), ot = _t(null), jt = _t(null), Rt = _t(null), Le = _t(null);
  process.env.NODE_ENV !== "production" && z_(e);
  var Ve = T_(__(E, $, _, R)), Ae = function(Mt, un) {
    return Mt && Mt[un] ? bo(Mt[un], {
      generateConfig: m,
      locale: v,
      format: Ve[0]
    }) : "";
  }, ft = _t(null), He = c.useMemo(function() {
    return Array.isArray(S) ? S : [S || !1, S || !1];
  }, [S]), Fe = Fn(null, {
    value: j,
    defaultValue: F,
    postState: function(Mt) {
      return $ === "time" && !qe ? Mt : CE(Mt, m);
    }
  }), yt = de(Fe, 2), Qe = yt[0], tt = yt[1], lt = $X({
    values: Qe,
    picker: $,
    defaultDates: A,
    generateConfig: m
  }), ht = de(lt, 2), bt = ht[0], ct = ht[1], xt = Fn(Qe, {
    postState: function(Mt) {
      var un = Mt;
      if (He[0] && He[1])
        return un;
      for (var cn = 0; cn < 2; cn += 1)
        He[cn] && !un && !pn(un, cn) && !pn(oe, cn) && (un = gi(un, m.getNow(), cn));
      return un;
    }
  }), vt = de(xt, 2), _e = vt[0], Ze = vt[1], q = Fn([$, $], {
    value: re
  }), Se = de(q, 2), Re = Se[0], ut = Se[1];
  kt(function() {
    ut([$, $]);
  }, [$]);
  var $t = function(Mt, un) {
    ut(Mt), G && G(un, Mt);
  }, Ne = SX(N, M, pt, Je, Et, jt, Rt, pn(_e, 0), pn(_e, 1), He, ge), Ie = de(Ne, 4), De = Ie[0], Me = Ie[1], Tt = Ie[2], Pt = Ie[3], Ut = De && Me === 0, Kt = De && Me === 1, $n = xX({
    picker: $,
    selectedValue: _e,
    locale: v,
    disabled: He,
    disabledDate: D,
    generateConfig: m
  }, !De || Tt), Jt = de($n, 2), On = Jt[0], Jn = Jt[1], er = Ot(0), Xt = de(er, 2), It = Xt[0], St = Xt[1];
  kt(function() {
    !De && Ye.current && St(Ye.current.offsetWidth);
  }, [De]);
  function Lt(yn) {
    Pt(!0, yn, "open"), Pn(function() {
      var Mt, un = [jt, Rt][yn];
      (Mt = un.current) === null || Mt === void 0 || Mt.focus();
    }, 0);
  }
  function ln(yn, Mt, un) {
    var cn = yn, Kn = pn(cn, 0), Jr = pn(cn, 1);
    Kn && Jr && m.isAfter(Kn, Jr) && (// WeekPicker only compare week
    $ === "week" && !rh(m, v.locale, Kn, Jr) || // QuotaPicker only compare week
    $ === "quarter" && !$_(m, Kn, Jr) || // Other non-TimePicker compare date
    $ !== "week" && $ !== "quarter" && $ !== "time" && !Aa(m, Kn, Jr) ? Mt === 0 ? (cn = [Kn, null], Jr = null) : (Kn = null, cn = [null, Jr]) : ($ !== "time" || qe !== !1) && (cn = CE(cn, m))), Ze(cn);
    var Mo = Ae(cn, 0), xr = Ae(cn, 1);
    if (ne) {
      var ii = {
        range: Mt === 0 ? "start" : "end"
      };
      ne(cn, [Mo, xr], ii);
    }
    if (!un) {
      var Ei = xE(Kn, 0, He, oe), Yi = xE(Jr, 1, He, oe), po = cn === null || Ei && Yi;
      po && (tt(cn), ce && (!Bc(m, pn(Qe, 0), Kn) || !Bc(m, pn(Qe, 1), Jr)) && ce(cn, [Mo, xr]));
    }
  }
  var lr = function(Mt) {
    return De && ft.current && ft.current.onKeyDown ? ft.current.onKeyDown(Mt) : (mt(!1, "Picker not correct forward KeyDown operation. Please help to fire issue about this."), !1);
  }, fr = {
    formatList: Ve,
    generateConfig: m,
    locale: v
  }, Er = jh(pn(_e, 0), fr), Qr = de(Er, 2), $r = Qr[0], Or = Qr[1], io = jh(pn(_e, 1), fr), At = de(io, 2), Nt = At[0], Qt = At[1], vn = function(Mt, un) {
    var cn = O_(Mt, {
      locale: v,
      formatList: Ve,
      generateConfig: m
    }), Kn = un === 0 ? On : Jn;
    cn && !Kn(cn) && (Ze(gi(_e, cn, un)), ct(cn, un));
  }, sn = ty({
    valueTexts: $r,
    onTextChange: function(Mt) {
      return vn(Mt, 0);
    }
  }), Mn = de(sn, 3), Wn = Mn[0], Dr = Mn[1], Gt = Mn[2], Zt = ty({
    valueTexts: Nt,
    onTextChange: function(Mt) {
      return vn(Mt, 1);
    }
  }), hn = de(Zt, 3), tn = hn[0], yr = hn[1], _r = hn[2], Wr = Ot(null), jr = de(Wr, 2), ao = jr[0], To = jr[1], Gi = Ot(null), pa = de(Gi, 2), ri = pa[0], Xa = pa[1], Za = Q1(Wn, {
    formatList: Ve,
    generateConfig: m,
    locale: v
  }), ha = de(Za, 3), Wt = ha[0], nn = ha[1], nr = ha[2], hr = Q1(tn, {
    formatList: Ve,
    generateConfig: m,
    locale: v
  }), rr = de(hr, 3), ga = rr[0], ks = rr[1], Qa = rr[2], Ja = function(Mt) {
    Xa(gi(_e, Mt, Me)), Me === 0 ? nn(Mt) : ks(Mt);
  }, cr = function() {
    Xa(gi(_e, null, Me)), Me === 0 ? nr() : Qa();
  }, or = c.useState(De), pf = de(or, 2), vm = pf[0], ym = pf[1];
  c.useEffect(function() {
    ym(De);
  }, [De]);
  var bm = function(Mt) {
    if (vm) {
      if (Et) {
        var un = Me ? 0 : 1, cn = pn(_e, un);
        cn && ln(_e, un, !0);
      } else if (Je) {
        var Kn = pn(_e, Me);
        Kn && ln(_e, Me);
      }
    }
    return ye == null ? void 0 : ye(Mt);
  }, hf = function(Mt, un) {
    return {
      blurToCancel: !Je && Et,
      changeOnBlur: Je,
      forwardKeyDown: lr,
      onBlur: bm,
      isClickOutside: function(Kn) {
        var Jr = [dt.current, Ct.current, Ye.current];
        return !P_([].concat(We(Et ? [Jr[Me]] : Jr), [wt.current]), Kn);
      },
      onFocus: function(Kn) {
        fe && fe(Kn);
      },
      triggerOpen: function(Kn) {
        Kn ? Pt(Kn, Mt, "open") : Pt(
          Kn,
          // Close directly if no selected value provided
          pn(_e, Mt) ? Mt : !1,
          "blur"
        );
      },
      onSubmit: function() {
        if (
          // When user typing disabledDate with keyboard and enter, this value will be empty
          !_e || // Normal disabled check
          D && D(_e[Mt])
        )
          return !1;
        ln(_e, Mt), un(), Pt(!1, Me, "confirm");
      },
      onCancel: function() {
        Pt(!1, Mt, "cancel"), Ze(Qe), un();
      }
    };
  }, gf = {
    onKeyDown: function(Mt, un) {
      Ge == null || Ge(Mt, un);
    }
  }, mf = ey(J(J({}, hf(0, Gt)), {}, {
    open: Ut,
    value: Wn
  }, gf)), vf = de(mf, 2), Kr = vf[0], Ml = vf[1], qi = Ml.focused, pu = Ml.typing, hu = ey(J(J({}, hf(1, _r)), {}, {
    open: Kt,
    value: tn
  }, gf)), xo = de(hu, 2), yf = xo[0], gu = xo[1], mu = gu.focused, vu = gu.typing, bf = function(Mt) {
    Te && Te(Mt), !De && !jt.current.contains(Mt.target) && !Rt.current.contains(Mt.target) && (He[0] ? He[1] || Lt(1) : Lt(0));
  }, Cf = function(Mt) {
    we && we(Mt), De && (qi || mu) && !jt.current.contains(Mt.target) && !Rt.current.contains(Mt.target) && Mt.preventDefault();
  }, So = Qe && Qe[0] ? bo(Qe[0], {
    locale: v,
    format: "YYYYMMDDHHmmss",
    generateConfig: m
  }) : "", Cm = Qe && Qe[1] ? bo(Qe[1], {
    locale: v,
    format: "YYYYMMDDHHmmss",
    generateConfig: m
  }) : "";
  kt(function() {
    De || (Ze(Qe), !$r.length || $r[0] === "" ? Dr("") : Or !== Wn && Gt(), !Nt.length || Nt[0] === "" ? yr("") : Qt !== tn && _r());
  }, [De, $r, Nt]), kt(function() {
    Ze(Qe);
  }, [So, Cm]);
  var fo = R_({
    cellRender: H,
    monthCellRender: z,
    dateRender: L
  }), xm = c.useMemo(function() {
    if (fo)
      return function(yn, Mt) {
        return fo(yn, J(J({}, Mt), {}, {
          range: Me ? "end" : "start"
        }));
      };
  }, [Me, fo]);
  process.env.NODE_ENV !== "production" && (j && Array.isArray(S) && (pn(S, 0) && !pn(j, 0) || pn(S, 1) && !pn(j, 1)) && mt(!1, "`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead."), mt(!L, "'dateRender' is deprecated. Please use 'cellRender' instead."), mt(!z, "'monthCellRender' is deprecated. Please use 'cellRender' instead."), mt(!le, "`clearIcon` will be removed in future. Please use `allowClear` instead.")), ue && (ue.current = {
    focus: function() {
      jt.current && jt.current.focus();
    },
    blur: function() {
      jt.current && jt.current.blur(), Rt.current && Rt.current.blur();
    }
  });
  var xf = I_(Y, Z);
  function oi() {
    var yn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, un = null;
    De && ri && ri[0] && ri[1] && m.isAfter(ri[1], ri[0]) && (un = ri);
    var cn = _;
    if (_ && Vt(_) === "object" && _.defaultValue) {
      var Kn = _.defaultValue;
      cn = J(J({}, _), {}, {
        defaultValue: pn(Kn, Me) || void 0
      });
    }
    return /* @__PURE__ */ c.createElement(Dl.Provider, {
      value: {
        inRange: !0,
        panelPosition: yn,
        rangedValue: ao || _e,
        hoverRangedValue: un
      }
    }, /* @__PURE__ */ c.createElement(F_, Oe({}, e, Mt, {
      cellRender: xm,
      showTime: cn,
      mode: Re[Me],
      generateConfig: m,
      style: void 0,
      direction: ze,
      disabledDate: Me === 0 ? On : Jn,
      disabledTime: function(Mo) {
        return T ? T(Mo, Me === 0 ? "start" : "end") : !1;
      },
      className: se(K({}, "".concat(a, "-panel-focused"), Me === 0 ? !pu : !vu)),
      value: pn(_e, Me),
      locale: v,
      tabIndex: -1,
      onPanelChange: function(Mo, xr) {
        Me === 0 && nr(!0), Me === 1 && Qa(!0), $t(gi(Re, xr, Me), gi(_e, Mo, Me));
        var ii = Mo;
        yn === "right" && Re[Me] === xr && (ii = ld(ii, xr, m, -1)), ct(ii, Me);
      },
      onOk: null,
      onSelect: void 0,
      onChange: void 0,
      defaultValue: Me === 0 ? pn(_e, 1) : pn(_e, 0)
      // defaultPickerValue={undefined}
    })));
  }
  var Wo = 0, Ll = 0;
  if (Me && dt.current && ot.current && wt.current && Le.current) {
    Wo = dt.current.offsetWidth + ot.current.offsetWidth;
    var pr = Le.current.offsetLeft > Wo ? Le.current.offsetLeft - Wo : Le.current.offsetLeft, wi = wt.current.offsetWidth, Al = Le.current.offsetWidth;
    wi && Al && Wo > wi - Al - (ze === "rtl" ? 0 : pr) && (Ll = Wo);
  }
  var Sm = ze === "rtl" ? {
    right: Wo
  } : {
    left: Wo
  };
  function yu() {
    var yn, Mt = j_(a, Re[Me], Q), un = k_({
      prefixCls: a,
      components: ke,
      needConfirmButton: Et,
      okDisabled: !pn(_e, Me) || D && D(_e[Me]),
      locale: v,
      // rangeList,
      onOk: function() {
        var po = pn(_e, Me);
        po && (ln(_e, Me), Ee == null || Ee(_e), Pt(!1, Me, "confirm"));
      }
    });
    if ($ !== "time" && !_) {
      var cn = bt(Me), Kn = ld(cn, $, m), Jr = Re[Me], Mo = Jr === $, xr = oi(Mo ? "left" : !1, {
        pickerValue: cn,
        onPickerValueChange: function(po) {
          ct(po, Me);
        }
      }), ii = oi("right", {
        pickerValue: Kn,
        onPickerValueChange: function(po) {
          ct(ld(po, $, m, -1), Me);
        }
      });
      ze === "rtl" ? yn = /* @__PURE__ */ c.createElement(c.Fragment, null, ii, Mo && xr) : yn = /* @__PURE__ */ c.createElement(c.Fragment, null, xr, Mo && ii);
    } else
      yn = oi();
    var Ei = /* @__PURE__ */ c.createElement("div", {
      className: "".concat(a, "-panel-layout")
    }, /* @__PURE__ */ c.createElement(H_, {
      prefixCls: a,
      presets: xf,
      onClick: function(po) {
        ln(po, null), Pt(!1, Me, "preset");
      },
      onHover: function(po) {
        To(po);
      }
    }), /* @__PURE__ */ c.createElement("div", null, /* @__PURE__ */ c.createElement("div", {
      className: "".concat(a, "-panels")
    }, yn), (Mt || un) && /* @__PURE__ */ c.createElement("div", {
      className: "".concat(a, "-footer")
    }, Mt, un)));
    return V && (Ei = V(Ei)), /* @__PURE__ */ c.createElement("div", {
      className: "".concat(a, "-panel-container"),
      style: {
        marginLeft: Ll
      },
      ref: wt,
      onMouseDown: function(po) {
        po.preventDefault();
      }
    }, Ei);
  }
  var wm = /* @__PURE__ */ c.createElement("div", {
    className: se("".concat(a, "-range-wrapper"), "".concat(a, "-").concat($, "-range-wrapper")),
    style: {
      minWidth: It
    }
  }, /* @__PURE__ */ c.createElement("div", {
    ref: Le,
    className: "".concat(a, "-range-arrow"),
    style: Sm
  }), yu()), Sf;
  ae && (Sf = /* @__PURE__ */ c.createElement("span", {
    className: "".concat(a, "-suffix"),
    onMouseDown: function(Mt) {
      Mt.preventDefault();
    }
  }, ae));
  var Em = V_(a, ee, le), wf = /* @__PURE__ */ c.createElement("span", {
    onMouseDown: function(Mt) {
      Mt.preventDefault(), Mt.stopPropagation();
    },
    onMouseUp: function(Mt) {
      Mt.preventDefault(), Mt.stopPropagation();
      var un = Qe;
      He[0] || (un = gi(un, null, 0)), He[1] || (un = gi(un, null, 1)), ln(un, null), Pt(!1, Me, "clear");
    },
    className: "".concat(a, "-clear"),
    role: "button"
  }, Em), jl = ee && (pn(Qe, 0) && !He[0] || pn(Qe, 1) && !He[1]), ma = {
    size: N_($, Ve[0], m)
  }, bu = 0, kl = 0;
  dt.current && Ct.current && ot.current && (Me === 0 ? kl = dt.current.offsetWidth : (bu = Wo, kl = Ct.current.offsetWidth));
  var Ef = ze === "rtl" ? {
    right: bu
  } : {
    left: bu
  }, Cu = function(Mt, un) {
    var cn = gi(_e, Mt, Me);
    if (un === "submit" || un !== "key" && !Et) {
      ln(cn, Me), Me === 0 ? nr() : Qa();
      var Kn = Me === 0 ? 1 : 0;
      He[Kn] ? Pt(!1, !1, "confirm") : Pt(!1, Me, "confirm");
    } else
      Ze(cn);
  };
  return /* @__PURE__ */ c.createElement(Ho.Provider, {
    value: {
      operationRef: ft,
      hideHeader: $ === "time",
      onDateMouseEnter: Ja,
      onDateMouseLeave: cr,
      hideRanges: !0,
      onSelect: Cu,
      open: De
    }
  }, /* @__PURE__ */ c.createElement(B_, {
    visible: De,
    popupElement: wm,
    popupStyle: f,
    prefixCls: a,
    dropdownClassName: p,
    dropdownAlign: y,
    getPopupContainer: b,
    transitionName: h,
    range: !0,
    direction: ze
  }, /* @__PURE__ */ c.createElement("div", Oe({
    ref: Ye,
    className: se(a, "".concat(a, "-range"), u, (t = {}, K(t, "".concat(a, "-disabled"), He[0] && He[1]), K(t, "".concat(a, "-focused"), Me === 0 ? qi : mu), K(t, "".concat(a, "-rtl"), ze === "rtl"), t)),
    style: l,
    onClick: bf,
    onMouseEnter: me,
    onMouseLeave: Ce,
    onMouseDown: Cf,
    onMouseUp: he
  }, ei(e, {
    aria: !0,
    data: !0
  })), /* @__PURE__ */ c.createElement("div", {
    className: se("".concat(a, "-input"), (n = {}, K(n, "".concat(a, "-input-active"), Me === 0), K(n, "".concat(a, "-input-placeholder"), !!Wt), n)),
    ref: dt
  }, /* @__PURE__ */ c.createElement("input", Oe({
    id: s,
    disabled: He[0],
    readOnly: ie || typeof Ve[0] == "function" || !pu,
    value: Wt || Wn,
    onChange: function(Mt) {
      Dr(Mt.target.value);
    },
    autoFocus: x,
    placeholder: pn(C, 0) || "",
    ref: jt
  }, Kr, ma, {
    autoComplete: et
  }))), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(a, "-range-separator"),
    ref: ot
  }, I), /* @__PURE__ */ c.createElement("div", {
    className: se("".concat(a, "-input"), (r = {}, K(r, "".concat(a, "-input-active"), Me === 1), K(r, "".concat(a, "-input-placeholder"), !!ga), r)),
    ref: Ct
  }, /* @__PURE__ */ c.createElement("input", Oe({
    disabled: He[1],
    readOnly: ie || typeof Ve[0] == "function" || !vu,
    value: ga || tn,
    onChange: function(Mt) {
      yr(Mt.target.value);
    },
    placeholder: pn(C, 1) || "",
    ref: Rt
  }, yf, ma, {
    autoComplete: et
  }))), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(a, "-active-bar"),
    style: J(J({}, Ef), {}, {
      width: kl,
      position: "absolute"
    })
  }), Sf, jl && wf)));
}
var _X = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    var r;
    zr(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), K(nt(r), "pickerRef", /* @__PURE__ */ c.createRef()), K(nt(r), "focus", function() {
      r.pickerRef.current && r.pickerRef.current.focus();
    }), K(nt(r), "blur", function() {
      r.pickerRef.current && r.pickerRef.current.blur();
    }), r;
  }
  return Vr(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ c.createElement(OX, Oe({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]), n;
}(c.Component);
const W_ = /* @__PURE__ */ c.createContext(null), NX = W_.Provider, K_ = /* @__PURE__ */ c.createContext(null), PX = K_.Provider;
var IX = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], U_ = /* @__PURE__ */ ni(function(e, t) {
  var n, r = e.prefixCls, o = r === void 0 ? "rc-checkbox" : r, i = e.className, a = e.style, s = e.checked, l = e.disabled, u = e.defaultChecked, f = u === void 0 ? !1 : u, p = e.type, h = p === void 0 ? "checkbox" : p, y = e.title, b = e.onChange, m = Yt(e, IX), v = _t(null), C = Fn(f, {
    value: s
  }), x = de(C, 2), S = x[0], E = x[1];
  Ua(t, function() {
    return {
      focus: function() {
        var R;
        (R = v.current) === null || R === void 0 || R.focus();
      },
      blur: function() {
        var R;
        (R = v.current) === null || R === void 0 || R.blur();
      },
      input: v.current
    };
  });
  var O = se(o, i, (n = {}, K(n, "".concat(o, "-checked"), S), K(n, "".concat(o, "-disabled"), l), n)), $ = function(R) {
    l || ("checked" in e || E(R.target.checked), b == null || b({
      target: J(J({}, e), {}, {
        type: h,
        checked: R.target.checked
      }),
      stopPropagation: function() {
        R.stopPropagation();
      },
      preventDefault: function() {
        R.preventDefault();
      },
      nativeEvent: R.nativeEvent
    }));
  };
  return /* @__PURE__ */ c.createElement("span", {
    className: O,
    title: y,
    style: a
  }, /* @__PURE__ */ c.createElement("input", Oe({}, m, {
    className: "".concat(o, "-input"),
    ref: v,
    onChange: $,
    disabled: l,
    checked: !!S,
    type: h
  })), /* @__PURE__ */ c.createElement("span", {
    className: "".concat(o, "-inner")
  }));
});
const RX = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-group`;
  return {
    [r]: Object.assign(Object.assign({}, Qn(e)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${r}-rtl`]: {
        direction: "rtl"
      },
      [`${n}-badge ${n}-badge-count`]: {
        zIndex: 1
      },
      [`> ${n}-badge:not(:first-child) > ${n}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, DX = (e) => {
  const {
    componentCls: t,
    wrapperMarginInlineEnd: n,
    colorPrimary: r,
    radioSize: o,
    motionDurationSlow: i,
    motionDurationMid: a,
    motionEaseInOutCirc: s,
    colorBgContainer: l,
    colorBorder: u,
    lineWidth: f,
    colorBgContainerDisabled: p,
    colorTextDisabled: h,
    paddingXS: y,
    dotColorDisabled: b,
    lineType: m,
    radioColor: v,
    radioBgColor: C,
    calc: x
  } = e, S = `${t}-inner`, O = x(o).sub(x(4).mul(2)), $ = x(1).mul(o).equal();
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, Qn(e)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: n,
      cursor: "pointer",
      // RTL
      [`&${t}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: e.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      // hashId 在 wrapper 上，只能铺平
      [`${t}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${te(f)} ${m} ${r}`,
        borderRadius: "50%",
        visibility: "hidden",
        content: '""'
      },
      [t]: Object.assign(Object.assign({}, Qn(e)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${t}-wrapper:hover &,
        &:hover ${S}`]: {
        borderColor: r
      },
      [`${t}-input:focus-visible + ${S}`]: Object.assign({}, Va(e)),
      [`${t}:hover::after, ${t}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${t}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: $,
          height: $,
          marginBlockStart: x(1).mul(o).div(-2).equal(),
          marginInlineStart: x(1).mul(o).div(-2).equal(),
          backgroundColor: v,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: $,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${i} ${s}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: $,
        height: $,
        backgroundColor: l,
        borderColor: u,
        borderStyle: "solid",
        borderWidth: f,
        borderRadius: "50%",
        transition: `all ${a}`
      },
      [`${t}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${t}-checked`]: {
        [S]: {
          borderColor: r,
          backgroundColor: C,
          "&::after": {
            transform: `scale(${e.calc(e.dotSize).div(o).equal()})`,
            opacity: 1,
            transition: `all ${i} ${s}`
          }
        }
      },
      [`${t}-disabled`]: {
        cursor: "not-allowed",
        [S]: {
          backgroundColor: p,
          borderColor: u,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: b
          }
        },
        [`${t}-input`]: {
          cursor: "not-allowed"
        },
        [`${t}-disabled + span`]: {
          color: h,
          cursor: "not-allowed"
        },
        [`&${t}-checked`]: {
          [S]: {
            "&::after": {
              transform: `scale(${x(O).div(o).equal({
                unit: !1
              })})`
            }
          }
        }
      },
      [`span${t} + *`]: {
        paddingInlineStart: y,
        paddingInlineEnd: y
      }
    })
  };
}, TX = (e) => {
  const {
    buttonColor: t,
    controlHeight: n,
    componentCls: r,
    lineWidth: o,
    lineType: i,
    colorBorder: a,
    motionDurationSlow: s,
    motionDurationMid: l,
    buttonPaddingInline: u,
    fontSize: f,
    buttonBg: p,
    fontSizeLG: h,
    controlHeightLG: y,
    controlHeightSM: b,
    paddingXS: m,
    borderRadius: v,
    borderRadiusSM: C,
    borderRadiusLG: x,
    buttonCheckedBg: S,
    buttonSolidCheckedColor: E,
    colorTextDisabled: O,
    colorBgContainerDisabled: $,
    buttonCheckedBgDisabled: _,
    buttonCheckedColorDisabled: R,
    colorPrimary: P,
    colorPrimaryHover: I,
    colorPrimaryActive: j,
    buttonSolidCheckedBg: F,
    buttonSolidCheckedHoverBg: A,
    buttonSolidCheckedActiveBg: M,
    calc: N
  } = e;
  return {
    [`${r}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: n,
      margin: 0,
      paddingInline: u,
      paddingBlock: 0,
      color: t,
      fontSize: f,
      lineHeight: te(N(n).sub(N(o).mul(2)).equal()),
      background: p,
      border: `${te(o)} ${i} ${a}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: N(o).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: o,
      cursor: "pointer",
      transition: [`color ${l}`, `background ${l}`, `box-shadow ${l}`].join(","),
      a: {
        color: t
      },
      [`> ${r}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: N(o).mul(-1).equal(),
          insetInlineStart: N(o).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: o,
          paddingInline: 0,
          backgroundColor: a,
          transition: `background-color ${s}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${te(o)} ${i} ${a}`,
        borderStartStartRadius: v,
        borderEndStartRadius: v
      },
      "&:last-child": {
        borderStartEndRadius: v,
        borderEndEndRadius: v
      },
      "&:first-child:last-child": {
        borderRadius: v
      },
      [`${r}-group-large &`]: {
        height: y,
        fontSize: h,
        lineHeight: te(N(y).sub(N(o).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: x,
          borderEndStartRadius: x
        },
        "&:last-child": {
          borderStartEndRadius: x,
          borderEndEndRadius: x
        }
      },
      [`${r}-group-small &`]: {
        height: b,
        paddingInline: N(m).sub(o).equal(),
        paddingBlock: 0,
        lineHeight: te(N(b).sub(N(o).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: C,
          borderEndStartRadius: C
        },
        "&:last-child": {
          borderStartEndRadius: C,
          borderEndEndRadius: C
        }
      },
      "&:hover": {
        position: "relative",
        color: P
      },
      "&:has(:focus-visible)": Object.assign({}, Va(e)),
      [`${r}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${r}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: P,
        background: S,
        borderColor: P,
        "&::before": {
          backgroundColor: P
        },
        "&:first-child": {
          borderColor: P
        },
        "&:hover": {
          color: I,
          borderColor: I,
          "&::before": {
            backgroundColor: I
          }
        },
        "&:active": {
          color: j,
          borderColor: j,
          "&::before": {
            backgroundColor: j
          }
        }
      },
      [`${r}-group-solid &-checked:not(${r}-button-wrapper-disabled)`]: {
        color: E,
        background: F,
        borderColor: F,
        "&:hover": {
          color: E,
          background: A,
          borderColor: A
        },
        "&:active": {
          color: E,
          background: M,
          borderColor: M
        }
      },
      "&-disabled": {
        color: O,
        backgroundColor: $,
        borderColor: a,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: O,
          backgroundColor: $,
          borderColor: a
        }
      },
      [`&-disabled${r}-button-wrapper-checked`]: {
        color: R,
        backgroundColor: _,
        borderColor: a,
        boxShadow: "none"
      }
    }
  };
}, MX = (e) => {
  const {
    wireframe: t,
    padding: n,
    marginXS: r,
    lineWidth: o,
    fontSizeLG: i,
    colorText: a,
    colorBgContainer: s,
    colorTextDisabled: l,
    controlItemBgActiveDisabled: u,
    colorTextLightSolid: f,
    colorPrimary: p,
    colorPrimaryHover: h,
    colorPrimaryActive: y,
    colorWhite: b
  } = e, m = 4, v = i, C = t ? v - m * 2 : v - (m + o) * 2;
  return {
    // Radio
    radioSize: v,
    dotSize: C,
    dotColorDisabled: l,
    // Radio buttons
    buttonSolidCheckedColor: f,
    buttonSolidCheckedBg: p,
    buttonSolidCheckedHoverBg: h,
    buttonSolidCheckedActiveBg: y,
    buttonBg: s,
    buttonCheckedBg: s,
    buttonColor: a,
    buttonCheckedBgDisabled: u,
    buttonCheckedColorDisabled: l,
    buttonPaddingInline: n - o,
    wrapperMarginInlineEnd: r,
    // internal
    radioColor: t ? p : b,
    radioBgColor: t ? s : p
  };
}, G_ = Gn("Radio", (e) => {
  const {
    controlOutline: t,
    controlOutlineWidth: n
  } = e, r = `0 0 0 ${te(n)} ${t}`, i = Sn(e, {
    radioFocusShadow: r,
    radioButtonFocusShadow: r
  });
  return [RX(i), DX(i), TX(i)];
}, MX, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var LX = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const AX = (e, t) => {
  var n, r;
  const o = c.useContext(W_), i = c.useContext(K_), {
    getPrefixCls: a,
    direction: s,
    radio: l
  } = c.useContext(Ft), u = c.useRef(null), f = Do(t, u), {
    isFormItemInput: p
  } = c.useContext(uo);
  if (process.env.NODE_ENV !== "production") {
    const M = xn("Radio");
    process.env.NODE_ENV !== "production" && M(!("optionType" in e), "usage", "`optionType` is only support in Radio.Group.");
  }
  const h = (M) => {
    var N, D;
    (N = e.onChange) === null || N === void 0 || N.call(e, M), (D = o == null ? void 0 : o.onChange) === null || D === void 0 || D.call(o, M);
  }, {
    prefixCls: y,
    className: b,
    rootClassName: m,
    children: v,
    style: C,
    title: x
  } = e, S = LX(e, ["prefixCls", "className", "rootClassName", "children", "style", "title"]), E = a("radio", y), O = ((o == null ? void 0 : o.optionType) || i) === "button", $ = O ? `${E}-button` : E, _ = Ar(E), [R, P, I] = G_(E, _), j = Object.assign({}, S), F = c.useContext(Ki);
  o && (j.name = o.name, j.onChange = h, j.checked = e.value === o.value, j.disabled = (n = j.disabled) !== null && n !== void 0 ? n : o.disabled), j.disabled = (r = j.disabled) !== null && r !== void 0 ? r : F;
  const A = se(`${$}-wrapper`, {
    [`${$}-wrapper-checked`]: j.checked,
    [`${$}-wrapper-disabled`]: j.disabled,
    [`${$}-wrapper-rtl`]: s === "rtl",
    [`${$}-wrapper-in-form-item`]: p
  }, l == null ? void 0 : l.className, b, m, P, I, _);
  return R(/* @__PURE__ */ c.createElement(xb, {
    component: "Radio",
    disabled: j.disabled
  }, /* @__PURE__ */ c.createElement("label", {
    className: A,
    style: Object.assign(Object.assign({}, l == null ? void 0 : l.style), C),
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    title: x
  }, /* @__PURE__ */ c.createElement(U_, Object.assign({}, j, {
    className: se(j.className, !O && Og),
    type: "radio",
    prefixCls: $,
    ref: f
  })), v !== void 0 ? /* @__PURE__ */ c.createElement("span", null, v) : null)));
}, _d = /* @__PURE__ */ c.forwardRef(AX);
process.env.NODE_ENV !== "production" && (_d.displayName = "Radio");
const jX = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r
  } = c.useContext(Ft), [o, i] = Fn(e.defaultValue, {
    value: e.value
  }), a = (M) => {
    const N = o, D = M.target.value;
    "value" in e || i(D);
    const {
      onChange: T
    } = e;
    T && D !== N && T(M);
  }, {
    prefixCls: s,
    className: l,
    rootClassName: u,
    options: f,
    buttonStyle: p = "outline",
    disabled: h,
    children: y,
    size: b,
    style: m,
    id: v,
    onMouseEnter: C,
    onMouseLeave: x,
    onFocus: S,
    onBlur: E
  } = e, O = n("radio", s), $ = `${O}-group`, _ = Ar(O), [R, P, I] = G_(O, _);
  let j = y;
  f && f.length > 0 && (j = f.map((M) => typeof M == "string" || typeof M == "number" ? /* @__PURE__ */ c.createElement(_d, {
    key: M.toString(),
    prefixCls: O,
    disabled: h,
    value: M,
    checked: o === M
  }, M) : /* @__PURE__ */ c.createElement(_d, {
    key: `radio-group-value-options-${M.value}`,
    prefixCls: O,
    disabled: M.disabled || h,
    value: M.value,
    checked: o === M.value,
    title: M.title,
    style: M.style,
    id: M.id,
    required: M.required
  }, M.label)));
  const F = Co(b), A = se($, `${$}-${p}`, {
    [`${$}-${F}`]: F,
    [`${$}-rtl`]: r === "rtl"
  }, l, u, P, I, _);
  return R(/* @__PURE__ */ c.createElement("div", Object.assign({}, ei(e, {
    aria: !0,
    data: !0
  }), {
    className: A,
    style: m,
    onMouseEnter: C,
    onMouseLeave: x,
    onFocus: S,
    onBlur: E,
    id: v,
    ref: t
  }), /* @__PURE__ */ c.createElement(NX, {
    value: {
      onChange: a,
      value: o,
      disabled: e.disabled,
      name: e.name,
      optionType: e.optionType
    }
  }, j)));
}), kX = /* @__PURE__ */ c.memo(jX);
var FX = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const BX = (e, t) => {
  const {
    getPrefixCls: n
  } = c.useContext(Ft), {
    prefixCls: r
  } = e, o = FX(e, ["prefixCls"]), i = n("radio", r);
  return /* @__PURE__ */ c.createElement(PX, {
    value: "button"
  }, /* @__PURE__ */ c.createElement(_d, Object.assign({
    prefixCls: i
  }, o, {
    type: "radio",
    ref: t
  })));
}, HX = /* @__PURE__ */ c.forwardRef(BX), Ci = _d;
Ci.Button = HX;
Ci.Group = kX;
Ci.__ANT_RADIO = !0;
function Qb(e) {
  return Sn(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const Jb = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: o,
    controlHeightSM: i,
    controlHeightLG: a,
    fontSizeLG: s,
    lineHeightLG: l,
    paddingSM: u,
    controlPaddingHorizontalSM: f,
    controlPaddingHorizontal: p,
    colorFillAlter: h,
    colorPrimaryHover: y,
    colorPrimary: b,
    controlOutlineWidth: m,
    controlOutline: v,
    colorErrorOutline: C,
    colorWarningOutline: x,
    colorBgContainer: S
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - o, 0),
    paddingBlockSM: Math.max(Math.round((i - n * r) / 2 * 10) / 10 - o, 0),
    paddingBlockLG: Math.ceil((a - s * l) / 2 * 10) / 10 - o,
    paddingInline: u - o,
    paddingInlineSM: f - o,
    paddingInlineLG: p - o,
    addonBg: h,
    activeBorderColor: b,
    hoverBorderColor: y,
    activeShadow: `0 0 0 ${m}px ${v}`,
    errorActiveShadow: `0 0 0 ${m}px ${C}`,
    warningActiveShadow: `0 0 0 ${m}px ${x}`,
    hoverBg: S,
    activeBg: S,
    inputFontSize: n,
    inputFontSizeLG: s,
    inputFontSizeSM: n
  };
}, zX = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), Qg = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "&:hover:not([disabled])": Object.assign({}, zX(Sn(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), eC = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), SE = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, eC(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), q_ = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eC(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.colorPrimaryHover,
    activeBorderColor: e.colorPrimary,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, Qg(e))
  }), SE(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), SE(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), wE = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), VX = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, wE(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), wE(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, Qg(e))
    }
  })
}), Y_ = (e, t) => ({
  "&-borderless": Object.assign({
    background: "transparent",
    border: "none",
    "&:focus, &:focus-within": {
      outline: "none"
    },
    [`&${e.componentCls}-disabled, &[disabled]`]: {
      color: e.colorTextDisabled
    }
  }, t)
}), X_ = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), EE = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, X_(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), Z_ = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, X_(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.colorPrimary
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, Qg(e))
  }), EE(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), EE(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), $E = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), WX = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${te(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${te(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, $E(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), $E(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), Q_ = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), J_ = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: n,
    borderRadiusLG: r,
    paddingInlineLG: o
  } = e;
  return {
    padding: `${te(t)} ${te(o)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: n,
    borderRadius: r
  };
}, tC = (e) => ({
  padding: `${te(e.paddingBlockSM)} ${te(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), nC = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${te(e.paddingBlock)} ${te(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, Q_(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, J_(e)),
  "&-sm": Object.assign({}, tC(e)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
}), KX = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, J_(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, tC(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${te(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${n}-select`]: {
          margin: `${te(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${te(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${n}-select-single:not(${n}-select-customize-input):not(${n}-pagination-size-changer)`]: {
            [`${n}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${te(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${n}-select-selector`]: {
              color: e.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${n}-cascader-picker`]: {
          margin: `-9px ${te(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${n}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [`${t}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, Eh()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${n}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${t}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${n}-select > ${n}-select-selector,
      & > ${n}-select-auto-complete ${t},
      & > ${n}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${n}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${n}-select > ${n}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${n}-select:first-child > ${n}-select-selector,
      & > ${n}-select-auto-complete:first-child ${t},
      & > ${n}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${n}-select:last-child > ${n}-select-selector,
      & > ${n}-cascader-picker:last-child ${t},
      & > ${n}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${n}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, UX = (e) => {
  const {
    componentCls: t,
    controlHeightSM: n,
    lineWidth: r,
    calc: o
  } = e, a = o(n).sub(o(r).mul(2)).sub(16).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e)), nC(e)), q_(e)), Z_(e)), Y_(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: n,
          paddingTop: a,
          paddingBottom: a
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, GX = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${te(e.inputAffixPadding)}`
      }
    }
  };
}, qX = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: n,
    colorTextDescription: r,
    motionDurationSlow: o,
    colorIcon: i,
    colorIconHover: a,
    iconCls: s
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign({}, nC(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: r
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: n
        },
        "&-suffix": {
          marginInlineStart: n
        }
      }
    }), GX(e)), {
      // password
      [`${s}${t}-password-icon`]: {
        color: i,
        cursor: "pointer",
        transition: `all ${o}`,
        "&:hover": {
          color: a
        }
      }
    })
  };
}, YX = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: n,
    borderRadiusSM: r
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, Qn(e)), KX(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: n,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: r
          }
        }
      }, VX(e)), WX(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, XX = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-search`;
  return {
    [r]: {
      [`${t}`]: {
        "&:hover, &:focus": {
          borderColor: e.colorPrimaryHover,
          [`+ ${t}-group-addon ${r}-button:not(${n}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal({
          unit: !1
        })
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${r}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: e.borderRadius,
            borderEndEndRadius: e.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${r}-button:not(${n}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${n}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${r}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${r}-button`]: {
        height: e.controlHeightLG
      },
      [`&-small ${r}-button`]: {
        height: e.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, ZX = (e) => {
  const {
    componentCls: t,
    paddingLG: n
  } = e, r = `${t}-textarea`;
  return {
    [r]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      "&-allow-clear": {
        [`> ${t}`]: {
          paddingInlineEnd: n
        }
      },
      [`&-affix-wrapper${r}-has-feedback`]: {
        [`${t}`]: {
          paddingInlineEnd: n
        }
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingXS,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${r}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
}, QX = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, rC = Gn("Input", (e) => {
  const t = Sn(e, Qb(e));
  return [
    UX(t),
    ZX(t),
    qX(t),
    YX(t),
    XX(t),
    QX(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    Ng(t)
  ];
}, Jb), JX = (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    paddingXXS: r,
    padding: o
  } = e;
  return {
    pickerCellCls: `${t}-cell`,
    pickerCellInnerCls: `${t}-cell-inner`,
    pickerYearMonthCellWidth: e.calc(n).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: e.calc(n).mul(1.4).equal(),
    pickerCellPaddingVertical: e.calc(r).add(e.calc(r).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: e.calc(o).add(e.calc(r).div(2)).equal()
    // 18 in normal
  };
}, eZ = (e) => ({
  cellHoverBg: e.controlItemBgHover,
  cellActiveWithRangeBg: e.controlItemBgActive,
  cellHoverWithRangeBg: new sr(e.colorPrimary).lighten(35).toHexString(),
  cellRangeBorderColor: new sr(e.colorPrimary).lighten(20).toHexString(),
  cellBgDisabled: e.colorBgContainerDisabled,
  timeColumnWidth: e.controlHeightLG * 1.4,
  timeColumnHeight: 28 * 8,
  timeCellHeight: 28,
  cellWidth: e.controlHeightSM * 1.5,
  cellHeight: e.controlHeightSM,
  textHeight: e.controlHeightLG,
  withoutTimeCellHeight: e.controlHeightLG * 1.65
}), tZ = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, Jb(e)), eZ(e)), Vg(e)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: e.zIndexPopupBase + 50
}), nZ = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, q_(e)), Z_(e)), Y_(e))
}), rZ = nZ, t0 = (e, t, n, r) => {
  const o = e.calc(n).add(2).equal(), i = e.max(e.calc(t).sub(o).div(2).equal(), 0), a = e.max(e.calc(t).sub(o).sub(i).equal(), 0);
  return {
    padding: `${te(i)} ${te(r)} ${te(a)}`
  };
}, oZ = (e) => {
  const {
    componentCls: t,
    pickerCellCls: n,
    pickerCellInnerCls: r,
    cellHeight: o,
    motionDurationSlow: i,
    borderRadiusSM: a,
    motionDurationMid: s,
    cellHoverBg: l,
    lineWidth: u,
    lineType: f,
    colorPrimary: p,
    cellActiveWithRangeBg: h,
    colorTextLightSolid: y,
    controlHeightSM: b,
    cellRangeBorderColor: m,
    pickerCellBorderGap: v,
    cellHoverWithRangeBg: C,
    cellWidth: x,
    colorTextDisabled: S,
    cellBgDisabled: E
  } = e;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: o,
      transform: "translateY(-50%)",
      transition: `all ${i}`,
      content: '""'
    },
    // >>> Default
    [r]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: o,
      height: o,
      lineHeight: te(o),
      borderRadius: a,
      transition: `background ${s}, border ${s}`
    },
    "&-range-hover-start, &-range-hover-end": {
      [r]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    // >>> Hover
    [`&:hover:not(${n}-in-view),
    &:hover:not(${n}-selected):not(${n}-range-start):not(${n}-range-end):not(${n}-range-hover-start):not(${n}-range-hover-end)`]: {
      [r]: {
        background: l
      }
    },
    // >>> Today
    [`&-in-view${n}-today ${r}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${te(u)} ${f} ${p}`,
        borderRadius: a,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${n}-in-range`]: {
      position: "relative",
      "&::before": {
        background: h
      }
    },
    // >>> Selected
    [`&-in-view${n}-selected ${r},
      &-in-view${n}-range-start ${r},
      &-in-view${n}-range-end ${r}`]: {
      color: y,
      background: p
    },
    [`&-in-view${n}-range-start:not(${n}-range-start-single),
      &-in-view${n}-range-end:not(${n}-range-end-single)`]: {
      "&::before": {
        background: h
      }
    },
    [`&-in-view${n}-range-start::before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${n}-range-end::before`]: {
      insetInlineEnd: "50%"
    },
    // >>> Range Hover
    [`&-in-view${n}-range-hover-start:not(${n}-in-range):not(${n}-range-start):not(${n}-range-end),
      &-in-view${n}-range-hover-end:not(${n}-in-range):not(${n}-range-start):not(${n}-range-end),
      &-in-view${n}-range-hover-start${n}-range-start-single,
      &-in-view${n}-range-hover-start${n}-range-start${n}-range-end${n}-range-end-near-hover,
      &-in-view${n}-range-hover-end${n}-range-start${n}-range-end${n}-range-start-near-hover,
      &-in-view${n}-range-hover-end${n}-range-end-single,
      &-in-view${n}-range-hover:not(${n}-in-range)`]: {
      "&::after": {
        position: "absolute",
        top: "50%",
        zIndex: 0,
        height: b,
        borderTop: `${te(u)} dashed ${m}`,
        borderBottom: `${te(u)} dashed ${m}`,
        transform: "translateY(-50%)",
        transition: `all ${i}`,
        content: '""'
      }
    },
    // Add space for stash
    "&-range-hover-start::after,\n      &-range-hover-end::after,\n      &-range-hover::after": {
      insetInlineEnd: 0,
      insetInlineStart: v
    },
    // Hover with in range
    [`&-in-view${n}-in-range${n}-range-hover::before,
      &-in-view${n}-in-range${n}-range-hover-start::before,
      &-in-view${n}-in-range${n}-range-hover-end::before,
      &-in-view${n}-range-start${n}-range-hover::before,
      &-in-view${n}-range-end${n}-range-hover::before,
      &-in-view${n}-range-start:not(${n}-range-start-single)${n}-range-hover-start::before,
      &-in-view${n}-range-end:not(${n}-range-end-single)${n}-range-hover-end::before,
      ${t}-panel
      > :not(${t}-date-panel)
      &-in-view${n}-in-range${n}-range-hover-start::before,
      ${t}-panel
      > :not(${t}-date-panel)
      &-in-view${n}-in-range${n}-range-hover-end::before`]: {
      background: C
    },
    // range start border-radius
    [`&-in-view${n}-range-start:not(${n}-range-start-single):not(${n}-range-end) ${r}`]: {
      borderStartStartRadius: a,
      borderEndStartRadius: a,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${n}-range-end:not(${n}-range-end-single):not(${n}-range-start) ${r}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: a,
      borderEndEndRadius: a
    },
    [`&-range-hover${n}-range-end::after`]: {
      insetInlineStart: "50%"
    },
    // Edge start
    [`tr > &-in-view${n}-range-hover:first-child::after,
      tr > &-in-view${n}-range-hover-end:first-child::after,
      &-in-view${n}-start${n}-range-hover-edge-start${n}-range-hover-edge-start-near-range::after,
      &-in-view${n}-range-hover-edge-start:not(${n}-range-hover-edge-start-near-range)::after,
      &-in-view${n}-range-hover-start::after`]: {
      insetInlineStart: e.calc(x).sub(o).div(2).equal(),
      borderInlineStart: `${te(u)} dashed ${m}`,
      borderStartStartRadius: a,
      borderEndStartRadius: a
    },
    // Edge end
    [`tr > &-in-view${n}-range-hover:last-child::after,
      tr > &-in-view${n}-range-hover-start:last-child::after,
      &-in-view${n}-end${n}-range-hover-edge-end${n}-range-hover-edge-end-near-range::after,
      &-in-view${n}-range-hover-edge-end:not(${n}-range-hover-edge-end-near-range)::after,
      &-in-view${n}-range-hover-end::after`]: {
      insetInlineEnd: e.calc(x).sub(o).div(2).equal(),
      borderInlineEnd: `${te(u)} dashed ${m}`,
      borderStartEndRadius: a,
      borderEndEndRadius: a
    },
    // >>> Disabled
    "&-disabled": {
      color: S,
      pointerEvents: "none",
      [r]: {
        background: "transparent"
      },
      "&::before": {
        background: E
      }
    },
    [`&-disabled${n}-today ${r}::before`]: {
      borderColor: S
    }
  };
}, iZ = (e) => {
  const {
    componentCls: t,
    pickerCellCls: n,
    pickerCellInnerCls: r,
    pickerYearMonthCellWidth: o,
    pickerControlIconSize: i,
    cellWidth: a,
    paddingSM: s,
    paddingXS: l,
    paddingXXS: u,
    colorBgContainer: f,
    lineWidth: p,
    lineType: h,
    borderRadiusLG: y,
    colorPrimary: b,
    colorTextHeading: m,
    colorSplit: v,
    pickerControlIconBorderWidth: C,
    colorIcon: x,
    textHeight: S,
    motionDurationMid: E,
    colorIconHover: O,
    fontWeightStrong: $,
    cellHeight: _,
    pickerCellPaddingVertical: R,
    colorTextDisabled: P,
    colorText: I,
    fontSize: j,
    cellHoverWithRangeBg: F,
    motionDurationSlow: A,
    withoutTimeCellHeight: M,
    pickerQuarterPanelContentHeight: N,
    colorLink: D,
    colorLinkActive: T,
    colorLinkHover: L,
    cellRangeBorderColor: z,
    borderRadiusSM: H,
    colorTextLightSolid: V,
    cellHoverBg: Y,
    timeColumnHeight: Z,
    timeColumnWidth: oe,
    timeCellHeight: ee,
    controlItemBgActive: ae,
    marginXXS: le,
    pickerDatePanelPaddingHorizontal: ue,
    pickerControlIconMargin: ie
  } = e, re = e.calc(a).mul(7).add(e.calc(ue).mul(2)).equal(), Q = e.calc(re).sub(e.calc(l).mul(2)).div(3).sub(e.pickerYearMonthCellWidth).sub(s).equal(), ce = e.calc(re).sub(e.calc(l).mul(2)).div(4).sub(e.pickerYearMonthCellWidth).equal();
  return {
    [t]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: f,
        border: `${te(p)} ${h} ${v}`,
        borderRadius: y,
        outline: "none",
        "&-focused": {
          borderColor: b
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-prev-icon,
              ${t}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${t}-next-icon,
              ${t}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: re
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${te(l)}`,
        color: m,
        borderBottom: `${te(p)} ${h} ${v}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: x,
          lineHeight: te(S),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${E}`,
          fontSize: "inherit"
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: j,
          "&:hover": {
            color: O
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: $,
          lineHeight: te(S),
          button: {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: l
            },
            "&:hover": {
              color: b
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        display: "inline-block",
        width: i,
        height: i,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          display: "inline-block",
          width: i,
          height: i,
          border: "0 solid currentcolor",
          borderBlockStartWidth: C,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: C,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: ie,
          insetInlineStart: ie,
          display: "inline-block",
          width: i,
          height: i,
          border: "0 solid currentcolor",
          borderBlockStartWidth: C,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: C,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      "&-prev-icon,\n        &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon,\n        &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: _,
          fontWeight: "normal"
        },
        th: {
          height: e.calc(_).add(e.calc(R).mul(2)).equal(),
          color: I,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${te(R)} 0`,
        color: P,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: I
        }
      }, oZ(e)),
      // DatePanel only
      [`&-date-panel ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-start ${r},
        &-date-panel ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-end ${r}`]: {
        "&::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: -1,
          background: F,
          transition: `all ${A}`,
          content: '""'
        }
      },
      [`&-date-panel
        ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-start
        ${r}::after`]: {
        insetInlineEnd: e.calc(a).sub(_).mul(-1).div(2).equal(),
        insetInlineStart: 0
      },
      [`&-date-panel ${t}-cell-in-view${t}-cell-in-range${t}-cell-range-hover-end ${r}::after`]: {
        insetInlineEnd: 0,
        insetInlineStart: e.calc(a).sub(_).mul(-1).div(2).equal()
      },
      // Hover with range start & end
      [`&-range-hover${t}-range-start::after`]: {
        insetInlineEnd: "50%"
      },
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-content`]: {
          height: e.calc(M).mul(4).equal()
        },
        [r]: {
          padding: `0 ${te(l)}`
        }
      },
      "&-quarter-panel": {
        [`${t}-content`]: {
          height: N
        },
        // Quarter Panel Special Style
        [`${t}-cell-range-hover-start::after`]: {
          insetInlineStart: ce,
          borderInlineStart: `${te(p)} dashed ${z}`,
          [`${t}-panel-rtl &`]: {
            insetInlineEnd: ce,
            borderInlineEnd: `${te(p)} dashed ${z}`
          }
        },
        [`${t}-cell-range-hover-end::after`]: {
          insetInlineEnd: ce,
          borderInlineEnd: `${te(p)} dashed ${z}`,
          [`${t}-panel-rtl &`]: {
            insetInlineStart: ce,
            borderInlineStart: `${te(p)} dashed ${z}`
          }
        }
      },
      // ======================== Footer ========================
      [`&-panel ${t}-footer`]: {
        borderTop: `${te(p)} ${h} ${v}`
      },
      "&-footer": {
        width: "min-content",
        minWidth: "100%",
        lineHeight: te(e.calc(S).sub(e.calc(p).mul(2)).equal()),
        textAlign: "center",
        "&-extra": {
          padding: `0 ${te(s)}`,
          lineHeight: te(e.calc(S).sub(e.calc(p).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${te(p)} ${h} ${v}`
          }
        }
      },
      "&-now": {
        textAlign: "start"
      },
      "&-today-btn": {
        color: D,
        "&:hover": {
          color: L
        },
        "&:active": {
          color: T
        },
        [`&${t}-today-btn-disabled`]: {
          color: P,
          cursor: "not-allowed"
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [r]: {
          padding: `0 ${te(e.calc(l).div(2).equal())}`
        },
        [`${t}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${t}-body`]: {
          padding: `0 ${te(l)}`
        },
        [r]: {
          width: o
        },
        [`${t}-cell-range-hover-start::after`]: {
          borderStartStartRadius: H,
          borderEndStartRadius: H,
          borderStartEndRadius: 0,
          borderEndEndRadius: 0,
          [`${t}-panel-rtl &`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            borderStartEndRadius: H,
            borderEndEndRadius: H
          }
        },
        [`${t}-cell-range-hover-end::after`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0,
          borderStartEndRadius: H,
          borderEndEndRadius: H,
          [`${t}-panel-rtl &`]: {
            borderStartStartRadius: H,
            borderEndStartRadius: H,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      },
      "&-year-panel,\n        &-month-panel": {
        [`${t}-cell-range-hover-start::after`]: {
          insetInlineStart: Q,
          borderInlineStart: `${te(p)} dashed ${z}`,
          [`${t}-panel-rtl &`]: {
            insetInlineEnd: Q,
            borderInlineEnd: `${te(p)} dashed ${z}`
          }
        },
        [`${t}-cell-range-hover-end::after`]: {
          insetInlineEnd: Q,
          borderInlineEnd: `${te(p)} dashed ${z}`,
          [`${t}-panel-rtl &`]: {
            insetInlineStart: Q,
            borderInlineStart: `${te(p)} dashed ${z}`
          }
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        [`${t}-body`]: {
          padding: `${te(l)} ${te(s)}`
        },
        // Clear cell style
        [`${t}-cell`]: {
          [`&:hover ${r},
            &-selected ${r},
            ${r}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            "&:before": {
              transition: `background ${E}`
            },
            "&:first-child:before": {
              borderStartStartRadius: H,
              borderEndStartRadius: H
            },
            "&:last-child:before": {
              borderStartEndRadius: H,
              borderEndEndRadius: H
            }
          },
          "&:hover td": {
            "&:before": {
              background: Y
            }
          },
          "&-range-start td,\n            &-range-end td,\n            &-selected td": {
            // Rise priority to override hover style
            [`&${n}`]: {
              "&:before": {
                background: b
              },
              [`&${t}-cell-week`]: {
                color: new sr(V).setAlpha(0.5).toHexString()
              },
              [r]: {
                color: V
              }
            }
          },
          "&-range-hover td:before": {
            background: ae
          }
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${t}-body`]: {
          padding: `${te(l)} ${te(ue)}`
        },
        [`${t}-content`]: {
          width: e.calc(a).mul(7).equal(),
          th: {
            width: a,
            boxSizing: "border-box",
            padding: 0
          }
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${t}-time-panel`]: {
          borderInlineStart: `${te(p)} ${h} ${v}`
        },
        [`${t}-date-panel,
          ${t}-time-panel`]: {
          transition: `opacity ${A}`
        },
        // Keyboard
        "&-active": {
          [`${t}-date-panel,
            ${t}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        direction: "ltr",
        [`${t}-content`]: {
          display: "flex",
          flex: "auto",
          height: Z
        },
        "&-column": {
          flex: "1 0 auto",
          width: oe,
          margin: `${te(u)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${E}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: e.colorTextTertiary,
            borderRadius: 4
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${e.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: e.calc(Z).sub(ee).equal(),
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${te(p)} ${h} ${v}`
          },
          "&-active": {
            background: new sr(ae).setAlpha(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${t}-time-panel-cell`]: {
              marginInline: le,
              [`${t}-time-panel-cell-inner`]: {
                display: "block",
                width: e.calc(oe).sub(e.calc(le).mul(2)).equal(),
                height: ee,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: e.calc(oe).sub(ee).div(2).equal(),
                color: I,
                lineHeight: te(ee),
                borderRadius: H,
                cursor: "pointer",
                transition: `background ${E}`,
                "&:hover": {
                  background: Y
                }
              },
              "&-selected": {
                [`${t}-time-panel-cell-inner`]: {
                  background: ae
                }
              },
              "&-disabled": {
                [`${t}-time-panel-cell-inner`]: {
                  color: P,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/39227
      [`&-datetime-panel ${t}-time-panel-column:after`]: {
        height: e.calc(Z).sub(ee).add(e.calc(u).mul(2)).equal()
      }
    }
  };
}, aZ = (e) => {
  const {
    componentCls: t,
    colorError: n,
    colorWarning: r
  } = e;
  return {
    [`${t}:not(${t}-disabled):not([disabled])`]: {
      [`&${t}-status-error`]: {
        [`${t}-active-bar`]: {
          background: n
        }
      },
      [`&${t}-status-warning`]: {
        [`${t}-active-bar`]: {
          background: r
        }
      }
    }
  };
}, sZ = (e) => {
  const {
    componentCls: t,
    antCls: n,
    controlHeight: r,
    paddingInline: o,
    lineWidth: i,
    lineType: a,
    colorBorder: s,
    borderRadius: l,
    motionDurationMid: u,
    colorTextDisabled: f,
    colorTextPlaceholder: p,
    controlHeightLG: h,
    fontSizeLG: y,
    controlHeightSM: b,
    paddingInlineSM: m,
    paddingXS: v,
    marginXS: C,
    colorTextDescription: x,
    lineWidthBold: S,
    colorPrimary: E,
    motionDurationSlow: O,
    zIndexPopup: $,
    paddingXXS: _,
    paddingSM: R,
    textHeight: P,
    cellActiveWithRangeBg: I,
    colorPrimaryBorder: j,
    sizePopupArrow: F,
    colorBgElevated: A,
    borderRadiusLG: M,
    boxShadowSecondary: N,
    borderRadiusSM: D,
    colorSplit: T,
    cellHoverBg: L,
    presetsWidth: z,
    presetsMaxWidth: H,
    boxShadowPopoverArrow: V,
    fontHeight: Y,
    fontHeightLG: Z,
    lineHeightLG: oe
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign({}, Qn(e)), t0(e, r, Y, o)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        lineHeight: 1,
        borderRadius: l,
        transition: `border ${u}, box-shadow ${u}, background ${u}`,
        // ======================== Input =========================
        [`${t}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({
            position: "relative",
            display: "inline-block",
            width: "100%",
            color: "inherit",
            fontSize: e.fontSize,
            lineHeight: e.lineHeight,
            transition: `all ${u}`
          }, Q_(p)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none",
              outline: 0
            },
            "&[disabled]": {
              background: "transparent",
              color: f,
              cursor: "not-allowed"
            }
          }),
          "&:hover": {
            [`${t}-clear`]: {
              opacity: 1
            },
            // Should use the following selector, but since `:has` has poor compatibility,
            // we use `:not(:last-child)` instead, which may cause some problems in some cases.
            // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
            [`${t}-suffix:not(:last-child)`]: {
              opacity: 0
            }
          },
          "&-placeholder": {
            "> input": {
              color: p
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, t0(e, h, Z, o)), {
          [`${t}-input > input`]: {
            fontSize: y,
            lineHeight: oe
          }
        }),
        "&-small": Object.assign({}, t0(e, b, Y, m)),
        [`${t}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: e.calc(v).div(2).equal(),
          color: f,
          lineHeight: 1,
          pointerEvents: "none",
          transition: `opacity ${u}, color ${u}`,
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: C
            }
          }
        },
        [`${t}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: f,
          lineHeight: 1,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${u}, color ${u}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: x
          }
        },
        [`${t}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: y,
          color: f,
          fontSize: y,
          verticalAlign: "top",
          cursor: "default",
          [`${t}-focused &`]: {
            color: x
          },
          [`${t}-range-separator &`]: {
            [`${t}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Clear
          [`${t}-clear`]: {
            insetInlineEnd: o
          },
          "&:hover": {
            [`${t}-clear`]: {
              opacity: 1
            },
            // Should use the following selector, but since `:has` has poor compatibility,
            // we use `:not(:last-child)` instead, which may cause some problems in some cases.
            // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
            [`${t}-suffix:not(:last-child)`]: {
              opacity: 0
            }
          },
          // Active bar
          [`${t}-active-bar`]: {
            bottom: e.calc(i).mul(-1).equal(),
            height: S,
            marginInlineStart: o,
            background: E,
            opacity: 0,
            transition: `all ${O} ease-out`,
            pointerEvents: "none"
          },
          [`&${t}-focused`]: {
            [`${t}-active-bar`]: {
              opacity: 1
            }
          },
          [`${t}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${te(v)}`,
            lineHeight: 1
          },
          [`&${t}-small`]: {
            [`${t}-clear`]: {
              insetInlineEnd: m
            },
            [`${t}-active-bar`]: {
              marginInlineStart: m
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, Qn(e)), iZ(e)), {
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: $,
          [`&${t}-dropdown-hidden`]: {
            display: "none"
          },
          [`&${t}-dropdown-placement-bottomLeft`]: {
            [`${t}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${t}-dropdown-placement-topLeft`]: {
            [`${t}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-topRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-topRight`]: {
            animationName: Tg
          },
          [`&${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-enter${n}-slide-up-enter-active${t}-dropdown-placement-bottomRight,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-appear${n}-slide-up-appear-active${t}-dropdown-placement-bottomRight`]: {
            animationName: Rg
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-topRight`]: {
            animationName: Mg
          },
          [`&${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomLeft,
          &${n}-slide-up-leave${n}-slide-up-leave-active${t}-dropdown-placement-bottomRight`]: {
            animationName: Dg
          },
          // Time picker with additional style
          [`${t}-panel > ${t}-time-panel`]: {
            paddingTop: _
          },
          // ======================== Ranges ========================
          [`${t}-ranges`]: {
            marginBottom: 0,
            padding: `${te(_)} ${te(R)}`,
            overflow: "hidden",
            lineHeight: te(e.calc(P).sub(e.calc(i).mul(2)).sub(e.calc(v).div(2)).equal()),
            textAlign: "start",
            listStyle: "none",
            display: "flex",
            justifyContent: "space-between",
            "> li": {
              display: "inline-block"
            },
            // https://github.com/ant-design/ant-design/issues/23687
            [`${t}-preset > ${n}-tag-blue`]: {
              color: E,
              background: I,
              borderColor: j,
              cursor: "pointer"
            },
            [`${t}-ok`]: {
              marginInlineStart: "auto"
            }
          },
          [`${t}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${t}-range-arrow`]: Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            marginInlineStart: e.calc(o).mul(1.5).equal(),
            transition: `left ${O} ease-out`
          }, k6(e, A, V)),
          [`${t}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: A,
            borderRadius: M,
            boxShadow: N,
            transition: `margin ${O}`,
            // ======================== Layout ========================
            [`${t}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${t}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: z,
              maxWidth: H,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: v,
                borderInlineEnd: `${te(i)} ${a} ${T}`,
                li: Object.assign(Object.assign({}, gl), {
                  borderRadius: D,
                  paddingInline: v,
                  paddingBlock: e.calc(b).sub(Y).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${O}`,
                  "+ li": {
                    marginTop: C
                  },
                  "&:hover": {
                    background: L
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${t}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              direction: "ltr",
              [`${t}-panel`]: {
                borderWidth: `0 0 ${te(i)}`
              },
              "&:last-child": {
                [`${t}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${t}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${t}-content,
            table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: s
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${te(e.calc(F).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${t}-separator`]: {
            transform: "rotate(180deg)"
          },
          [`${t}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    _s(e, "slide-up"),
    _s(e, "slide-down"),
    Ac(e, "move-up"),
    Ac(e, "move-down")
  ];
}, eN = Gn("DatePicker", (e) => {
  const t = Sn(Qb(e), JX(e));
  return [
    sZ(t),
    rZ(t),
    aZ(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    Ng(e, {
      focusElCls: `${e.componentCls}-focused`
    })
  ];
}, tZ);
var lZ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
const cZ = lZ;
var tN = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: cZ
  }));
};
process.env.NODE_ENV !== "production" && (tN.displayName = "PlusOutlined");
const kh = /* @__PURE__ */ c.forwardRef(tN);
function uZ(e, t, n) {
  var r = n || {}, o = r.noTrailing, i = o === void 0 ? !1 : o, a = r.noLeading, s = a === void 0 ? !1 : a, l = r.debounceMode, u = l === void 0 ? void 0 : l, f, p = !1, h = 0;
  function y() {
    f && clearTimeout(f);
  }
  function b(v) {
    var C = v || {}, x = C.upcomingOnly, S = x === void 0 ? !1 : x;
    y(), p = !S;
  }
  function m() {
    for (var v = arguments.length, C = new Array(v), x = 0; x < v; x++)
      C[x] = arguments[x];
    var S = this, E = Date.now() - h;
    if (p)
      return;
    function O() {
      h = Date.now(), t.apply(S, C);
    }
    function $() {
      f = void 0;
    }
    !s && u && !f && O(), y(), u === void 0 && E > e ? s ? (h = Date.now(), i || (f = setTimeout(u ? $ : O, e))) : O() : i !== !0 && (f = setTimeout(u ? $ : O, u === void 0 ? e - E : e));
  }
  return m.cancel = b, m;
}
function dZ(e, t, n) {
  var r = n || {}, o = r.atBegin, i = o === void 0 ? !1 : o;
  return uZ(e, t, {
    debounceMode: i !== !1
  });
}
function Qo(e, t) {
  return e[t];
}
var fZ = ["children"];
function nN(e, t) {
  return "".concat(e, "-").concat(t);
}
function pZ(e) {
  return e && e.type && e.type.isTreeNode;
}
function of(e, t) {
  return e != null ? e : t;
}
function Hc(e) {
  var t = e || {}, n = t.title, r = t._title, o = t.key, i = t.children, a = n || "title";
  return {
    title: a,
    _title: r || [a],
    key: o || "key",
    children: i || "children"
  };
}
function hZ(e, t) {
  var n = /* @__PURE__ */ new Map();
  function r(o) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (o || []).forEach(function(a) {
      var s = a[t.key], l = a[t.children];
      mt(s != null, "Tree node must have a certain key: [".concat(i).concat(s, "]"));
      var u = String(s);
      mt(!n.has(u) || s === null || s === void 0, "Same 'key' exist in the Tree: ".concat(u)), n.set(u, !0), r(l, "".concat(i).concat(u, " > "));
    });
  }
  r(e);
}
function rN(e) {
  function t(n) {
    var r = Rr(n);
    return r.map(function(o) {
      if (!pZ(o))
        return mt(!o, "Tree/TreeNode can only accept TreeNode as children."), null;
      var i = o.key, a = o.props, s = a.children, l = Yt(a, fZ), u = J({
        key: i
      }, l), f = t(s);
      return f.length && (u.children = f), u;
    }).filter(function(o) {
      return o;
    });
  }
  return t(e);
}
function n0(e, t, n) {
  var r = Hc(n), o = r._title, i = r.key, a = r.children, s = new Set(t === !0 ? [] : t), l = [];
  function u(f) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return f.map(function(h, y) {
      for (var b = nN(p ? p.pos : "0", y), m = of(h[i], b), v, C = 0; C < o.length; C += 1) {
        var x = o[C];
        if (h[x] !== void 0) {
          v = h[x];
          break;
        }
      }
      var S = J(J({}, dr(h, [].concat(We(o), [i, a]))), {}, {
        title: v,
        key: m,
        parent: p,
        pos: b,
        children: null,
        data: h,
        isStart: [].concat(We(p ? p.isStart : []), [y === 0]),
        isEnd: [].concat(We(p ? p.isEnd : []), [y === f.length - 1])
      });
      return l.push(S), t === !0 || s.has(m) ? S.children = u(h[a] || [], S) : S.children = [], S;
    });
  }
  return u(e), l;
}
function gZ(e, t, n) {
  var r = {};
  Vt(n) === "object" ? r = n : r = {
    externalGetKey: n
  }, r = r || {};
  var o = r, i = o.childrenPropName, a = o.externalGetKey, s = o.fieldNames, l = Hc(s), u = l.key, f = l.children, p = i || f, h;
  a ? typeof a == "string" ? h = function(m) {
    return m[a];
  } : typeof a == "function" && (h = function(m) {
    return a(m);
  }) : h = function(m, v) {
    return of(m[u], v);
  };
  function y(b, m, v, C) {
    var x = b ? b[p] : e, S = b ? nN(v.pos, m) : "0", E = b ? [].concat(We(C), [b]) : [];
    if (b) {
      var O = h(b, S), $ = {
        node: b,
        index: m,
        pos: S,
        key: O,
        parentPos: v.node ? v.pos : null,
        level: v.level + 1,
        nodes: E
      };
      t($);
    }
    x && x.forEach(function(_, R) {
      y(_, R, {
        node: b,
        pos: S,
        level: v ? v.level + 1 : -1
      }, E);
    });
  }
  y(null);
}
function Jg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.initWrapper, r = t.processEntity, o = t.onProcessFinished, i = t.externalGetKey, a = t.childrenPropName, s = t.fieldNames, l = arguments.length > 2 ? arguments[2] : void 0, u = i || l, f = {}, p = {}, h = {
    posEntities: f,
    keyEntities: p
  };
  return n && (h = n(h) || h), gZ(e, function(y) {
    var b = y.node, m = y.index, v = y.pos, C = y.key, x = y.parentPos, S = y.level, E = y.nodes, O = {
      node: b,
      nodes: E,
      index: m,
      key: C,
      pos: v,
      level: S
    }, $ = of(C, v);
    f[v] = O, p[$] = O, O.parent = f[x], O.parent && (O.parent.children = O.parent.children || [], O.parent.children.push(O)), r && r(O, h);
  }, {
    externalGetKey: u,
    childrenPropName: a,
    fieldNames: s
  }), o && o(h), h;
}
function cd(e, t) {
  var n = t.expandedKeys, r = t.selectedKeys, o = t.loadedKeys, i = t.loadingKeys, a = t.checkedKeys, s = t.halfCheckedKeys, l = t.dragOverNodeKey, u = t.dropPosition, f = t.keyEntities, p = Qo(f, e), h = {
    eventKey: e,
    expanded: n.indexOf(e) !== -1,
    selected: r.indexOf(e) !== -1,
    loaded: o.indexOf(e) !== -1,
    loading: i.indexOf(e) !== -1,
    checked: a.indexOf(e) !== -1,
    halfChecked: s.indexOf(e) !== -1,
    pos: String(p ? p.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: l === e && u === 0,
    dragOverGapTop: l === e && u === -1,
    dragOverGapBottom: l === e && u === 1
  };
  return h;
}
function kr(e) {
  var t = e.data, n = e.expanded, r = e.selected, o = e.checked, i = e.loaded, a = e.loading, s = e.halfChecked, l = e.dragOver, u = e.dragOverGapTop, f = e.dragOverGapBottom, p = e.pos, h = e.active, y = e.eventKey, b = J(J({}, t), {}, {
    expanded: n,
    selected: r,
    checked: o,
    loaded: i,
    loading: a,
    halfChecked: s,
    dragOver: l,
    dragOverGapTop: u,
    dragOverGapBottom: f,
    pos: p,
    active: h,
    key: y
  });
  return "props" in b || Object.defineProperty(b, "props", {
    get: function() {
      return mt(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), e;
    }
  }), b;
}
function oN(e, t) {
  var n = /* @__PURE__ */ new Set();
  return e.forEach(function(r) {
    t.has(r) || n.add(r);
  }), n;
}
function mZ(e) {
  var t = e || {}, n = t.disabled, r = t.disableCheckbox, o = t.checkable;
  return !!(n || r) || o === !1;
}
function vZ(e, t, n, r) {
  for (var o = new Set(e), i = /* @__PURE__ */ new Set(), a = 0; a <= n; a += 1) {
    var s = t.get(a) || /* @__PURE__ */ new Set();
    s.forEach(function(p) {
      var h = p.key, y = p.node, b = p.children, m = b === void 0 ? [] : b;
      o.has(h) && !r(y) && m.filter(function(v) {
        return !r(v.node);
      }).forEach(function(v) {
        o.add(v.key);
      });
    });
  }
  for (var l = /* @__PURE__ */ new Set(), u = n; u >= 0; u -= 1) {
    var f = t.get(u) || /* @__PURE__ */ new Set();
    f.forEach(function(p) {
      var h = p.parent, y = p.node;
      if (!(r(y) || !p.parent || l.has(p.parent.key))) {
        if (r(p.parent.node)) {
          l.add(h.key);
          return;
        }
        var b = !0, m = !1;
        (h.children || []).filter(function(v) {
          return !r(v.node);
        }).forEach(function(v) {
          var C = v.key, x = o.has(C);
          b && !x && (b = !1), !m && (x || i.has(C)) && (m = !0);
        }), b && o.add(h.key), m && i.add(h.key), l.add(h.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(o),
    halfCheckedKeys: Array.from(oN(i, o))
  };
}
function yZ(e, t, n, r, o) {
  for (var i = new Set(e), a = new Set(t), s = 0; s <= r; s += 1) {
    var l = n.get(s) || /* @__PURE__ */ new Set();
    l.forEach(function(h) {
      var y = h.key, b = h.node, m = h.children, v = m === void 0 ? [] : m;
      !i.has(y) && !a.has(y) && !o(b) && v.filter(function(C) {
        return !o(C.node);
      }).forEach(function(C) {
        i.delete(C.key);
      });
    });
  }
  a = /* @__PURE__ */ new Set();
  for (var u = /* @__PURE__ */ new Set(), f = r; f >= 0; f -= 1) {
    var p = n.get(f) || /* @__PURE__ */ new Set();
    p.forEach(function(h) {
      var y = h.parent, b = h.node;
      if (!(o(b) || !h.parent || u.has(h.parent.key))) {
        if (o(h.parent.node)) {
          u.add(y.key);
          return;
        }
        var m = !0, v = !1;
        (y.children || []).filter(function(C) {
          return !o(C.node);
        }).forEach(function(C) {
          var x = C.key, S = i.has(x);
          m && !S && (m = !1), !v && (S || a.has(x)) && (v = !0);
        }), m || i.delete(y.key), v && a.add(y.key), u.add(y.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(i),
    halfCheckedKeys: Array.from(oN(a, i))
  };
}
function ka(e, t, n, r) {
  var o = [], i;
  r ? i = r : i = mZ;
  var a = new Set(e.filter(function(f) {
    var p = !!Qo(n, f);
    return p || o.push(f), p;
  })), s = /* @__PURE__ */ new Map(), l = 0;
  Object.keys(n).forEach(function(f) {
    var p = n[f], h = p.level, y = s.get(h);
    y || (y = /* @__PURE__ */ new Set(), s.set(h, y)), y.add(p), l = Math.max(l, h);
  }), mt(!o.length, "Tree missing follow keys: ".concat(o.slice(0, 100).map(function(f) {
    return "'".concat(f, "'");
  }).join(", ")));
  var u;
  return t === !0 ? u = vZ(a, s, l, i) : u = yZ(a, t.halfCheckedKeys, s, l, i), u;
}
const bZ = (e) => {
  const {
    checkboxCls: t
  } = e, n = `${t}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${t}-group`]: Object.assign(Object.assign({}, Qn(e)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: e.marginXS,
        // Group > Grid
        [`> ${e.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [n]: Object.assign(Object.assign({}, Qn(e)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${n}`]: {
          marginInlineStart: 0
        },
        [`&${n}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [t]: Object.assign(Object.assign({}, Qn(e)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: e.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${t}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${t}-inner`]: Object.assign({}, Va(e))
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: e.checkboxSize,
          height: e.checkboxSize,
          direction: "ltr",
          backgroundColor: e.colorBgContainer,
          border: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderRadius: e.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${e.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: e.calc(e.checkboxSize).div(14).mul(5).equal(),
            height: e.calc(e.checkboxSize).div(14).mul(8).equal(),
            border: `${te(e.lineWidthBold)} solid ${e.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${e.motionDurationFast} ${e.motionEaseInBack}, opacity ${e.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: e.paddingXS,
          paddingInlineEnd: e.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${n}:not(${n}-disabled),
        ${t}:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          borderColor: e.colorPrimary
        }
      },
      [`${n}:not(${n}-disabled)`]: {
        [`&:hover ${t}-checked:not(${t}-disabled) ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${t}-checked:not(${t}-disabled):after`]: {
          borderColor: e.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${t}-checked`]: {
        [`${t}-inner`]: {
          backgroundColor: e.colorPrimary,
          borderColor: e.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${e.motionDurationMid} ${e.motionEaseOutBack} ${e.motionDurationFast}`
          }
        }
      },
      [`
        ${n}-checked:not(${n}-disabled),
        ${t}-checked:not(${t}-disabled)
      `]: {
        [`&:hover ${t}-inner`]: {
          backgroundColor: e.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [t]: {
        "&-indeterminate": {
          // Wrapper > Checkbox > inner
          [`${t}-inner`]: {
            backgroundColor: e.colorBgContainer,
            borderColor: e.colorBorder,
            "&:after": {
              top: "50%",
              insetInlineStart: "50%",
              width: e.calc(e.fontSizeLG).div(2).equal(),
              height: e.calc(e.fontSizeLG).div(2).equal(),
              backgroundColor: e.colorPrimary,
              border: 0,
              transform: "translate(-50%, -50%) scale(1)",
              opacity: 1,
              content: '""'
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${n}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${t}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${t}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${t}-inner`]: {
          background: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          "&:after": {
            borderColor: e.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: e.colorTextDisabled
        },
        [`&${t}-indeterminate ${t}-inner::after`]: {
          background: e.colorTextDisabled
        }
      }
    }
  ];
};
function oC(e, t) {
  const n = Sn(t, {
    checkboxCls: `.${e}`,
    checkboxSize: t.controlInteractiveSize
  });
  return [bZ(n)];
}
const iN = Gn("Checkbox", (e, t) => {
  let {
    prefixCls: n
  } = t;
  return [oC(n, e)];
}), CZ = /* @__PURE__ */ be.createContext(null), aN = CZ;
var xZ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const SZ = (e, t) => {
  var n;
  const {
    prefixCls: r,
    className: o,
    rootClassName: i,
    children: a,
    indeterminate: s = !1,
    style: l,
    onMouseEnter: u,
    onMouseLeave: f,
    skipGroup: p = !1,
    disabled: h
  } = e, y = xZ(e, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: b,
    direction: m,
    checkbox: v
  } = c.useContext(Ft), C = c.useContext(aN), {
    isFormItemInput: x
  } = c.useContext(uo), S = c.useContext(Ki), E = (n = (C == null ? void 0 : C.disabled) || h) !== null && n !== void 0 ? n : S, O = c.useRef(y.value);
  if (process.env.NODE_ENV !== "production") {
    const N = xn("Checkbox");
    process.env.NODE_ENV !== "production" && N("checked" in y || !!C || !("value" in y), "usage", "`value` is not a valid prop, do you mean `checked`?");
  }
  c.useEffect(() => {
    C == null || C.registerValue(y.value);
  }, []), c.useEffect(() => {
    if (!p)
      return y.value !== O.current && (C == null || C.cancelValue(O.current), C == null || C.registerValue(y.value), O.current = y.value), () => C == null ? void 0 : C.cancelValue(y.value);
  }, [y.value]);
  const $ = b("checkbox", r), _ = Ar($), [R, P, I] = iN($, _), j = Object.assign({}, y);
  C && !p && (j.onChange = function() {
    y.onChange && y.onChange.apply(y, arguments), C.toggleOption && C.toggleOption({
      label: a,
      value: y.value
    });
  }, j.name = C.name, j.checked = C.value.includes(y.value));
  const F = se(`${$}-wrapper`, {
    [`${$}-rtl`]: m === "rtl",
    [`${$}-wrapper-checked`]: j.checked,
    [`${$}-wrapper-disabled`]: E,
    [`${$}-wrapper-in-form-item`]: x
  }, v == null ? void 0 : v.className, o, i, I, _, P), A = se({
    [`${$}-indeterminate`]: s
  }, Og, P), M = s ? "mixed" : void 0;
  return R(/* @__PURE__ */ c.createElement(xb, {
    component: "Checkbox",
    disabled: E
  }, /* @__PURE__ */ c.createElement("label", {
    className: F,
    style: Object.assign(Object.assign({}, v == null ? void 0 : v.style), l),
    onMouseEnter: u,
    onMouseLeave: f
  }, /* @__PURE__ */ c.createElement(U_, Object.assign({
    "aria-checked": M
  }, j, {
    prefixCls: $,
    className: A,
    disabled: E,
    ref: t
  })), a !== void 0 && /* @__PURE__ */ c.createElement("span", null, a))));
}, sN = /* @__PURE__ */ c.forwardRef(SZ);
process.env.NODE_ENV !== "production" && (sN.displayName = "Checkbox");
const lN = sN;
var wZ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const EZ = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    defaultValue: n,
    children: r,
    options: o = [],
    prefixCls: i,
    className: a,
    rootClassName: s,
    style: l,
    onChange: u
  } = e, f = wZ(e, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: p,
    direction: h
  } = c.useContext(Ft), [y, b] = c.useState(f.value || n || []), [m, v] = c.useState([]);
  c.useEffect(() => {
    "value" in f && b(f.value || []);
  }, [f.value]);
  const C = c.useMemo(() => o.map((N) => typeof N == "string" || typeof N == "number" ? {
    label: N,
    value: N
  } : N), [o]), x = (N) => {
    v((D) => D.filter((T) => T !== N));
  }, S = (N) => {
    v((D) => [].concat(We(D), [N]));
  }, E = (N) => {
    const D = y.indexOf(N.value), T = We(y);
    D === -1 ? T.push(N.value) : T.splice(D, 1), "value" in f || b(T), u == null || u(T.filter((L) => m.includes(L)).sort((L, z) => {
      const H = C.findIndex((Y) => Y.value === L), V = C.findIndex((Y) => Y.value === z);
      return H - V;
    }));
  }, O = p("checkbox", i), $ = `${O}-group`, _ = Ar(O), [R, P, I] = iN(O, _), j = dr(f, ["value", "disabled"]), F = o.length ? C.map((N) => /* @__PURE__ */ c.createElement(lN, {
    prefixCls: O,
    key: N.value.toString(),
    disabled: "disabled" in N ? N.disabled : f.disabled,
    value: N.value,
    checked: y.includes(N.value),
    onChange: N.onChange,
    className: `${$}-item`,
    style: N.style,
    title: N.title,
    id: N.id,
    required: N.required
  }, N.label)) : r, A = {
    toggleOption: E,
    value: y,
    disabled: f.disabled,
    name: f.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: S,
    cancelValue: x
  }, M = se($, {
    [`${$}-rtl`]: h === "rtl"
  }, a, s, I, _, P);
  return R(/* @__PURE__ */ c.createElement("div", Object.assign({
    className: M,
    style: l
  }, j, {
    ref: t
  }), /* @__PURE__ */ c.createElement(aN.Provider, {
    value: A
  }, F)));
}), $Z = EZ, em = lN;
em.Group = $Z;
em.__ANT_CHECKBOX = !0;
process.env.NODE_ENV !== "production" && (em.displayName = "Checkbox");
const Fh = em, OZ = /* @__PURE__ */ Rs({}), cN = OZ, _Z = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, NZ = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, PZ = (e, t) => {
  const {
    componentCls: n,
    gridColumns: r
  } = e, o = {};
  for (let i = r; i >= 0; i--)
    i === 0 ? (o[`${n}${t}-${i}`] = {
      display: "none"
    }, o[`${n}-push-${i}`] = {
      insetInlineStart: "auto"
    }, o[`${n}-pull-${i}`] = {
      insetInlineEnd: "auto"
    }, o[`${n}${t}-push-${i}`] = {
      insetInlineStart: "auto"
    }, o[`${n}${t}-pull-${i}`] = {
      insetInlineEnd: "auto"
    }, o[`${n}${t}-offset-${i}`] = {
      marginInlineStart: 0
    }, o[`${n}${t}-order-${i}`] = {
      order: 0
    }) : (o[`${n}${t}-${i}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${i / r * 100}%`,
        maxWidth: `${i / r * 100}%`
      }
    ], o[`${n}${t}-push-${i}`] = {
      insetInlineStart: `${i / r * 100}%`
    }, o[`${n}${t}-pull-${i}`] = {
      insetInlineEnd: `${i / r * 100}%`
    }, o[`${n}${t}-offset-${i}`] = {
      marginInlineStart: `${i / r * 100}%`
    }, o[`${n}${t}-order-${i}`] = {
      order: i
    });
  return o;
}, oy = (e, t) => PZ(e, t), IZ = (e, t, n) => ({
  [`@media (min-width: ${te(t)})`]: Object.assign({}, oy(e, n))
}), RZ = () => ({}), DZ = () => ({}), TZ = Gn("Grid", _Z, RZ), MZ = Gn("Grid", (e) => {
  const t = Sn(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), n = {
    "-sm": t.screenSMMin,
    "-md": t.screenMDMin,
    "-lg": t.screenLGMin,
    "-xl": t.screenXLMin,
    "-xxl": t.screenXXLMin
  };
  return [NZ(t), oy(t, ""), oy(t, "-xs"), Object.keys(n).map((r) => IZ(t, n[r], r)).reduce((r, o) => Object.assign(Object.assign({}, r), o), {})];
}, DZ);
var LZ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function AZ(e) {
  return typeof e == "number" ? `${e} ${e} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(e) ? `0 0 ${e}` : e;
}
const jZ = ["xs", "sm", "md", "lg", "xl", "xxl"], uN = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r
  } = c.useContext(Ft), {
    gutter: o,
    wrap: i
  } = c.useContext(cN), {
    prefixCls: a,
    span: s,
    order: l,
    offset: u,
    push: f,
    pull: p,
    className: h,
    children: y,
    flex: b,
    style: m
  } = e, v = LZ(e, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), C = n("col", a), [x, S, E] = MZ(C);
  let O = {};
  jZ.forEach((R) => {
    let P = {};
    const I = e[R];
    typeof I == "number" ? P.span = I : typeof I == "object" && (P = I || {}), delete v[R], O = Object.assign(Object.assign({}, O), {
      [`${C}-${R}-${P.span}`]: P.span !== void 0,
      [`${C}-${R}-order-${P.order}`]: P.order || P.order === 0,
      [`${C}-${R}-offset-${P.offset}`]: P.offset || P.offset === 0,
      [`${C}-${R}-push-${P.push}`]: P.push || P.push === 0,
      [`${C}-${R}-pull-${P.pull}`]: P.pull || P.pull === 0,
      [`${C}-${R}-flex-${P.flex}`]: P.flex || P.flex === "auto",
      [`${C}-rtl`]: r === "rtl"
    });
  });
  const $ = se(C, {
    [`${C}-${s}`]: s !== void 0,
    [`${C}-order-${l}`]: l,
    [`${C}-offset-${u}`]: u,
    [`${C}-push-${f}`]: f,
    [`${C}-pull-${p}`]: p
  }, h, O, S, E), _ = {};
  if (o && o[0] > 0) {
    const R = o[0] / 2;
    _.paddingLeft = R, _.paddingRight = R;
  }
  return b && (_.flex = AZ(b), i === !1 && !_.minWidth && (_.minWidth = 0)), x(/* @__PURE__ */ c.createElement("div", Object.assign({}, v, {
    style: Object.assign(Object.assign({}, _), m),
    className: $,
    ref: t
  }), y));
});
process.env.NODE_ENV !== "production" && (uN.displayName = "Col");
const ds = uN;
var kZ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function OE(e, t) {
  const [n, r] = c.useState(typeof e == "string" ? e : ""), o = () => {
    if (typeof e == "string" && r(e), typeof e == "object")
      for (let i = 0; i < jc.length; i++) {
        const a = jc[i];
        if (!t[a])
          continue;
        const s = e[a];
        if (s !== void 0) {
          r(s);
          return;
        }
      }
  };
  return c.useEffect(() => {
    o();
  }, [JSON.stringify(e), t]), n;
}
const dN = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    justify: r,
    align: o,
    className: i,
    style: a,
    children: s,
    gutter: l = 0,
    wrap: u
  } = e, f = kZ(e, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: p,
    direction: h
  } = c.useContext(Ft), [y, b] = c.useState({
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  }), [m, v] = c.useState({
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    xxl: !1
  }), C = OE(o, m), x = OE(r, m), S = c.useRef(l), E = T6();
  c.useEffect(() => {
    const T = E.subscribe((L) => {
      v(L);
      const z = S.current || 0;
      (!Array.isArray(z) && typeof z == "object" || Array.isArray(z) && (typeof z[0] == "object" || typeof z[1] == "object")) && b(L);
    });
    return () => E.unsubscribe(T);
  }, []);
  const O = () => {
    const T = [void 0, void 0];
    return (Array.isArray(l) ? l : [l, void 0]).forEach((z, H) => {
      if (typeof z == "object")
        for (let V = 0; V < jc.length; V++) {
          const Y = jc[V];
          if (y[Y] && z[Y] !== void 0) {
            T[H] = z[Y];
            break;
          }
        }
      else
        T[H] = z;
    }), T;
  }, $ = p("row", n), [_, R, P] = TZ($), I = O(), j = se($, {
    [`${$}-no-wrap`]: u === !1,
    [`${$}-${x}`]: x,
    [`${$}-${C}`]: C,
    [`${$}-rtl`]: h === "rtl"
  }, i, R, P), F = {}, A = I[0] != null && I[0] > 0 ? I[0] / -2 : void 0;
  A && (F.marginLeft = A, F.marginRight = A), [, F.rowGap] = I;
  const [M, N] = I, D = c.useMemo(() => ({
    gutter: [M, N],
    wrap: u
  }), [M, N, u]);
  return _(/* @__PURE__ */ c.createElement(cN.Provider, {
    value: D
  }, /* @__PURE__ */ c.createElement("div", Object.assign({}, f, {
    className: j,
    style: Object.assign(Object.assign({}, F), a),
    ref: t
  }), s)));
});
process.env.NODE_ENV !== "production" && (dN.displayName = "Row");
const oh = dN;
var fN = /* @__PURE__ */ be.forwardRef(function(e, t) {
  var n, r = e.prefixCls, o = e.forceRender, i = e.className, a = e.style, s = e.children, l = e.isActive, u = e.role, f = be.useState(l || o), p = de(f, 2), h = p[0], y = p[1];
  return be.useEffect(function() {
    (o || l) && y(!0);
  }, [o, l]), h ? /* @__PURE__ */ be.createElement("div", {
    ref: t,
    className: se("".concat(r, "-content"), (n = {}, K(n, "".concat(r, "-content-active"), l), K(n, "".concat(r, "-content-inactive"), !l), n), i),
    style: a,
    role: u
  }, /* @__PURE__ */ be.createElement("div", {
    className: "".concat(r, "-content-box")
  }, s)) : null;
});
fN.displayName = "PanelContent";
var FZ = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"], pN = /* @__PURE__ */ be.forwardRef(function(e, t) {
  var n, r, o = e.showArrow, i = o === void 0 ? !0 : o, a = e.headerClass, s = e.isActive, l = e.onItemClick, u = e.forceRender, f = e.className, p = e.prefixCls, h = e.collapsible, y = e.accordion, b = e.panelKey, m = e.extra, v = e.header, C = e.expandIcon, x = e.openMotion, S = e.destroyInactivePanel, E = e.children, O = Yt(e, FZ), $ = h === "disabled", _ = h === "header", R = h === "icon", P = m != null && typeof m != "boolean", I = function() {
    l == null || l(b);
  }, j = function(T) {
    (T.key === "Enter" || T.keyCode === Pe.ENTER || T.which === Pe.ENTER) && I();
  }, F = typeof C == "function" ? C(e) : /* @__PURE__ */ be.createElement("i", {
    className: "arrow"
  });
  F && (F = /* @__PURE__ */ be.createElement("div", {
    className: "".concat(p, "-expand-icon"),
    onClick: ["header", "icon"].includes(h) ? I : void 0
  }, F));
  var A = se((n = {}, K(n, "".concat(p, "-item"), !0), K(n, "".concat(p, "-item-active"), s), K(n, "".concat(p, "-item-disabled"), $), n), f), M = se(a, (r = {}, K(r, "".concat(p, "-header"), !0), K(r, "".concat(p, "-header-collapsible-only"), _), K(r, "".concat(p, "-icon-collapsible-only"), R), r)), N = {
    className: M,
    "aria-expanded": s,
    "aria-disabled": $,
    onKeyDown: j
  };
  return !_ && !R && (N.onClick = I, N.role = y ? "tab" : "button", N.tabIndex = $ ? -1 : 0), /* @__PURE__ */ be.createElement("div", Oe({}, O, {
    ref: t,
    className: A
  }), /* @__PURE__ */ be.createElement("div", N, i && F, /* @__PURE__ */ be.createElement("span", {
    className: "".concat(p, "-header-text"),
    onClick: h === "header" ? I : void 0
  }, v), P && /* @__PURE__ */ be.createElement("div", {
    className: "".concat(p, "-extra")
  }, m)), /* @__PURE__ */ be.createElement(Bi, Oe({
    visible: s,
    leavedClassName: "".concat(p, "-content-hidden")
  }, x, {
    forceRender: u,
    removeOnLeave: S
  }), function(D, T) {
    var L = D.className, z = D.style;
    return /* @__PURE__ */ be.createElement(fN, {
      ref: T,
      prefixCls: p,
      className: L,
      style: z,
      isActive: s,
      forceRender: u,
      role: y ? "tabpanel" : void 0
    }, E);
  }));
}), BZ = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"], HZ = function(t, n) {
  var r = n.prefixCls, o = n.accordion, i = n.collapsible, a = n.destroyInactivePanel, s = n.onItemClick, l = n.activeKey, u = n.openMotion, f = n.expandIcon;
  return t.map(function(p, h) {
    var y = p.children, b = p.label, m = p.key, v = p.collapsible, C = p.onItemClick, x = p.destroyInactivePanel, S = Yt(p, BZ), E = String(m != null ? m : h), O = v != null ? v : i, $ = x != null ? x : a, _ = function(I) {
      O !== "disabled" && (s(I), C == null || C(I));
    }, R = !1;
    return o ? R = l[0] === E : R = l.indexOf(E) > -1, /* @__PURE__ */ be.createElement(pN, Oe({}, S, {
      prefixCls: r,
      key: E,
      panelKey: E,
      isActive: R,
      accordion: o,
      openMotion: u,
      expandIcon: f,
      header: b,
      collapsible: O,
      onItemClick: _,
      destroyInactivePanel: $
    }), y);
  });
}, zZ = function(t, n, r) {
  if (!t)
    return null;
  var o = r.prefixCls, i = r.accordion, a = r.collapsible, s = r.destroyInactivePanel, l = r.onItemClick, u = r.activeKey, f = r.openMotion, p = r.expandIcon, h = t.key || String(n), y = t.props, b = y.header, m = y.headerClass, v = y.destroyInactivePanel, C = y.collapsible, x = y.onItemClick, S = !1;
  i ? S = u[0] === h : S = u.indexOf(h) > -1;
  var E = C != null ? C : a, O = function(R) {
    E !== "disabled" && (l(R), x == null || x(R));
  }, $ = {
    key: h,
    panelKey: h,
    header: b,
    headerClass: m,
    isActive: S,
    prefixCls: o,
    destroyInactivePanel: v != null ? v : s,
    openMotion: f,
    accordion: i,
    children: t.props.children,
    onItemClick: O,
    expandIcon: p,
    collapsible: E
  };
  return typeof t.type == "string" ? t : (Object.keys($).forEach(function(_) {
    typeof $[_] == "undefined" && delete $[_];
  }), /* @__PURE__ */ be.cloneElement(t, $));
};
function VZ(e, t, n) {
  return Array.isArray(e) ? HZ(e, n) : Rr(t).map(function(r, o) {
    return zZ(r, o, n);
  });
}
function WZ(e) {
  var t = e;
  if (!Array.isArray(t)) {
    var n = Vt(t);
    t = n === "number" || n === "string" ? [t] : [];
  }
  return t.map(function(r) {
    return String(r);
  });
}
var KZ = /* @__PURE__ */ be.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-collapse" : n, o = e.destroyInactivePanel, i = o === void 0 ? !1 : o, a = e.style, s = e.accordion, l = e.className, u = e.children, f = e.collapsible, p = e.openMotion, h = e.expandIcon, y = e.activeKey, b = e.defaultActiveKey, m = e.onChange, v = e.items, C = se(r, l), x = Fn([], {
    value: y,
    onChange: function(P) {
      return m == null ? void 0 : m(P);
    },
    defaultValue: b,
    postState: WZ
  }), S = de(x, 2), E = S[0], O = S[1], $ = function(P) {
    return O(function() {
      if (s)
        return E[0] === P ? [] : [P];
      var I = E.indexOf(P), j = I > -1;
      return j ? E.filter(function(F) {
        return F !== P;
      }) : [].concat(We(E), [P]);
    });
  };
  mt(!u, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var _ = VZ(v, u, {
    prefixCls: r,
    accordion: s,
    openMotion: p,
    expandIcon: h,
    collapsible: f,
    destroyInactivePanel: i,
    onItemClick: $,
    activeKey: E
  });
  return /* @__PURE__ */ be.createElement("div", {
    ref: t,
    className: C,
    style: a,
    role: s ? "tablist" : void 0
  }, _);
});
const iC = Object.assign(KZ, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: pN
});
iC.Panel;
const UZ = /* @__PURE__ */ c.forwardRef((e, t) => {
  process.env.NODE_ENV !== "production" && xn("Collapse.Panel").deprecated(!("disabled" in e), "disabled", 'collapsible="disabled"');
  const {
    getPrefixCls: n
  } = c.useContext(Ft), {
    prefixCls: r,
    className: o,
    showArrow: i = !0
  } = e, a = n("collapse", r), s = se({
    [`${a}-no-arrow`]: !i
  }, o);
  return /* @__PURE__ */ c.createElement(iC.Panel, Object.assign({
    ref: t
  }, e, {
    prefixCls: a,
    className: s
  }));
}), GZ = UZ, qZ = (e) => {
  const {
    componentCls: t,
    contentBg: n,
    padding: r,
    headerBg: o,
    headerPadding: i,
    collapseHeaderPaddingSM: a,
    collapseHeaderPaddingLG: s,
    collapsePanelBorderRadius: l,
    lineWidth: u,
    lineType: f,
    colorBorder: p,
    colorText: h,
    colorTextHeading: y,
    colorTextDisabled: b,
    fontSizeLG: m,
    lineHeight: v,
    lineHeightLG: C,
    marginSM: x,
    paddingSM: S,
    paddingLG: E,
    paddingXS: O,
    motionDurationSlow: $,
    fontSizeIcon: _,
    contentPadding: R,
    fontHeight: P,
    fontHeightLG: I
  } = e, j = `${te(u)} ${f} ${p}`;
  return {
    [t]: Object.assign(Object.assign({}, Qn(e)), {
      backgroundColor: o,
      border: j,
      borderBottom: 0,
      borderRadius: l,
      "&-rtl": {
        direction: "rtl"
      },
      [`& > ${t}-item`]: {
        borderBottom: j,
        "&:last-child": {
          [`
            &,
            & > ${t}-header`]: {
            borderRadius: `0 0 ${te(l)} ${te(l)}`
          }
        },
        [`> ${t}-header`]: {
          position: "relative",
          // Compatible with old version of antd, should remove in next version
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "flex-start",
          padding: i,
          color: y,
          lineHeight: v,
          cursor: "pointer",
          transition: `all ${$}, visibility 0s`,
          [`> ${t}-header-text`]: {
            flex: "auto"
          },
          "&:focus": {
            outline: "none"
          },
          // >>>>> Arrow
          [`${t}-expand-icon`]: {
            height: P,
            display: "flex",
            alignItems: "center",
            paddingInlineEnd: x
          },
          [`${t}-arrow`]: Object.assign(Object.assign({}, Ud()), {
            fontSize: _,
            svg: {
              transition: `transform ${$}`
            }
          }),
          // >>>>> Text
          [`${t}-header-text`]: {
            marginInlineEnd: "auto"
          }
        },
        [`${t}-icon-collapsible-only`]: {
          cursor: "unset",
          [`${t}-expand-icon`]: {
            cursor: "pointer"
          }
        }
      },
      [`${t}-content`]: {
        color: h,
        backgroundColor: n,
        borderTop: j,
        [`& > ${t}-content-box`]: {
          padding: R
        },
        "&-hidden": {
          display: "none"
        }
      },
      "&-small": {
        [`> ${t}-item`]: {
          [`> ${t}-header`]: {
            padding: a,
            paddingInlineStart: O,
            [`> ${t}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: e.calc(S).sub(O).equal()
            }
          },
          [`> ${t}-content > ${t}-content-box`]: {
            padding: S
          }
        }
      },
      "&-large": {
        [`> ${t}-item`]: {
          fontSize: m,
          lineHeight: C,
          [`> ${t}-header`]: {
            padding: s,
            paddingInlineStart: r,
            [`> ${t}-expand-icon`]: {
              height: I,
              // Arrow offset
              marginInlineStart: e.calc(E).sub(r).equal()
            }
          },
          [`> ${t}-content > ${t}-content-box`]: {
            padding: E
          }
        }
      },
      [`${t}-item:last-child`]: {
        [`> ${t}-content`]: {
          borderRadius: `0 0 ${te(l)} ${te(l)}`
        }
      },
      [`& ${t}-item-disabled > ${t}-header`]: {
        "\n          &,\n          & > .arrow\n        ": {
          color: b,
          cursor: "not-allowed"
        }
      },
      // ========================== Icon Position ==========================
      [`&${t}-icon-position-end`]: {
        [`& > ${t}-item`]: {
          [`> ${t}-header`]: {
            [`${t}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: x
            }
          }
        }
      }
    })
  };
}, YZ = (e) => {
  const {
    componentCls: t
  } = e, n = `> ${t}-item > ${t}-header ${t}-arrow svg`;
  return {
    [`${t}-rtl`]: {
      [n]: {
        transform: "rotate(180deg)"
      }
    }
  };
}, XZ = (e) => {
  const {
    componentCls: t,
    headerBg: n,
    paddingXXS: r,
    colorBorder: o
  } = e;
  return {
    [`${t}-borderless`]: {
      backgroundColor: n,
      border: 0,
      [`> ${t}-item`]: {
        borderBottom: `1px solid ${o}`
      },
      [`
        > ${t}-item:last-child,
        > ${t}-item:last-child ${t}-header
      `]: {
        borderRadius: 0
      },
      [`> ${t}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${t}-item > ${t}-content`]: {
        backgroundColor: "transparent",
        borderTop: 0
      },
      [`> ${t}-item > ${t}-content > ${t}-content-box`]: {
        paddingTop: r
      }
    }
  };
}, ZZ = (e) => {
  const {
    componentCls: t,
    paddingSM: n
  } = e;
  return {
    [`${t}-ghost`]: {
      backgroundColor: "transparent",
      border: 0,
      [`> ${t}-item`]: {
        borderBottom: 0,
        [`> ${t}-content`]: {
          backgroundColor: "transparent",
          border: 0,
          [`> ${t}-content-box`]: {
            paddingBlock: n
          }
        }
      }
    }
  };
}, QZ = (e) => ({
  headerPadding: `${e.paddingSM}px ${e.padding}px`,
  headerBg: e.colorFillAlter,
  contentPadding: `${e.padding}px 16px`,
  // Fixed Value
  contentBg: e.colorBgContainer
}), JZ = Gn("Collapse", (e) => {
  const t = Sn(e, {
    collapseHeaderPaddingSM: `${te(e.paddingXS)} ${te(e.paddingSM)}`,
    collapseHeaderPaddingLG: `${te(e.padding)} ${te(e.paddingLG)}`,
    collapsePanelBorderRadius: e.borderRadiusLG
  });
  return [qZ(t), XZ(t), ZZ(t), YZ(t), Ag(t)];
}, QZ), hN = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    getPrefixCls: n,
    direction: r,
    collapse: o
  } = c.useContext(Ft), {
    prefixCls: i,
    className: a,
    rootClassName: s,
    style: l,
    bordered: u = !0,
    ghost: f,
    size: p,
    expandIconPosition: h = "start",
    children: y,
    expandIcon: b
  } = e, m = Co((I) => {
    var j;
    return (j = p != null ? p : I) !== null && j !== void 0 ? j : "middle";
  }), v = n("collapse", i), C = n(), [x, S, E] = JZ(v);
  if (process.env.NODE_ENV !== "production") {
    const I = xn("Collapse");
    process.env.NODE_ENV !== "production" && I(h !== "left" && h !== "right", "deprecated", "`expandIconPosition` with `left` or `right` is deprecated. Please use `start` or `end` instead.");
  }
  const O = c.useMemo(() => h === "left" ? "start" : h === "right" ? "end" : h, [h]), $ = function() {
    let I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const j = b ? b(I) : /* @__PURE__ */ c.createElement(Fc, {
      rotate: I.isActive ? 90 : void 0
    });
    return Yr(j, () => ({
      className: se(j.props.className, `${v}-arrow`)
    }));
  }, _ = se(`${v}-icon-position-${O}`, {
    [`${v}-borderless`]: !u,
    [`${v}-rtl`]: r === "rtl",
    [`${v}-ghost`]: !!f,
    [`${v}-${m}`]: m !== "middle"
  }, o == null ? void 0 : o.className, a, s, S, E), R = Object.assign(Object.assign({}, xd(C)), {
    motionAppear: !1,
    leavedClassName: `${v}-content-hidden`
  }), P = c.useMemo(() => y ? Rr(y).map((I, j) => {
    var F, A;
    if (!((F = I.props) === null || F === void 0) && F.disabled) {
      const M = (A = I.key) !== null && A !== void 0 ? A : String(j), {
        disabled: N,
        collapsible: D
      } = I.props, T = Object.assign(Object.assign({}, dr(I.props, ["disabled"])), {
        key: M,
        collapsible: D != null ? D : N ? "disabled" : void 0
      });
      return Yr(I, T);
    }
    return I;
  }) : null, [y]);
  return x(/* @__PURE__ */ c.createElement(iC, Object.assign({
    ref: t,
    openMotion: R
  }, dr(e, ["rootClassName"]), {
    expandIcon: $,
    prefixCls: v,
    className: _,
    style: Object.assign(Object.assign({}, o == null ? void 0 : o.style), l)
  }), P));
});
process.env.NODE_ENV !== "production" && (hN.displayName = "Collapse");
const aC = Object.assign(hN, {
  Panel: GZ
}), eQ = (e) => {
  const {
    componentCls: t,
    sizePaddingEdgeHorizontal: n,
    colorSplit: r,
    lineWidth: o,
    textPaddingInline: i,
    orientationMargin: a,
    verticalMarginInline: s
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Qn(e)), {
      borderBlockStart: `${te(o)} solid ${r}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: s,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${te(o)} solid ${r}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${te(e.dividerHorizontalGutterMargin)} 0`
      },
      [`&-horizontal${t}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${te(e.dividerHorizontalWithTextGutterMargin)} 0`,
        color: e.colorTextHeading,
        fontWeight: 500,
        fontSize: e.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${r}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${te(o)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${t}-with-text-left`]: {
        "&::before": {
          width: `calc(${a} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${a} * 100%)`
        }
      },
      [`&-horizontal${t}-with-text-right`]: {
        "&::before": {
          width: `calc(100% - ${a} * 100%)`
        },
        "&::after": {
          width: `calc(${a} * 100%)`
        }
      },
      [`${t}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: i
      },
      "&-dashed": {
        background: "none",
        borderColor: r,
        borderStyle: "dashed",
        borderWidth: `${te(o)} 0 0`
      },
      [`&-horizontal${t}-with-text${t}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${t}-dashed`]: {
        borderInlineStartWidth: o,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${t}-with-text`]: {
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`&-horizontal${t}-with-text-left${t}-no-default-orientation-margin-left`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${t}-inner-text`]: {
          paddingInlineStart: n
        }
      },
      [`&-horizontal${t}-with-text-right${t}-no-default-orientation-margin-right`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${t}-inner-text`]: {
          paddingInlineEnd: n
        }
      }
    })
  };
}, tQ = (e) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: e.marginXS
}), nQ = Gn("Divider", (e) => {
  const t = Sn(e, {
    dividerHorizontalWithTextGutterMargin: e.margin,
    dividerHorizontalGutterMargin: e.marginLG,
    sizePaddingEdgeHorizontal: 0
  });
  return [eQ(t)];
}, tQ, {
  unitless: {
    orientationMargin: !0
  }
});
var rQ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const gN = (e) => {
  const {
    getPrefixCls: t,
    direction: n,
    divider: r
  } = c.useContext(Ft), {
    prefixCls: o,
    type: i = "horizontal",
    orientation: a = "center",
    orientationMargin: s,
    className: l,
    rootClassName: u,
    children: f,
    dashed: p,
    plain: h,
    style: y
  } = e, b = rQ(e, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "plain", "style"]), m = t("divider", o), [v, C, x] = nQ(m), S = a.length > 0 ? `-${a}` : a, E = !!f, O = a === "left" && s != null, $ = a === "right" && s != null, _ = se(m, r == null ? void 0 : r.className, C, x, `${m}-${i}`, {
    [`${m}-with-text`]: E,
    [`${m}-with-text${S}`]: E,
    [`${m}-dashed`]: !!p,
    [`${m}-plain`]: !!h,
    [`${m}-rtl`]: n === "rtl",
    [`${m}-no-default-orientation-margin-left`]: O,
    [`${m}-no-default-orientation-margin-right`]: $
  }, l, u), R = c.useMemo(() => typeof s == "number" ? s : /^\d+$/.test(s) ? Number(s) : s, [s]), P = Object.assign(Object.assign({}, O && {
    marginLeft: R
  }), $ && {
    marginRight: R
  });
  if (process.env.NODE_ENV !== "production") {
    const I = xn("Divider");
    process.env.NODE_ENV !== "production" && I(!f || i !== "vertical", "usage", "`children` not working in `vertical` mode.");
  }
  return v(/* @__PURE__ */ c.createElement("div", Object.assign({
    className: _,
    style: Object.assign(Object.assign({}, r == null ? void 0 : r.style), y)
  }, b, {
    role: "separator"
  }), f && i !== "vertical" && /* @__PURE__ */ c.createElement("span", {
    className: `${m}-inner-text`,
    style: P
  }, f)));
};
process.env.NODE_ENV !== "production" && (gN.displayName = "Divider");
const _E = gN;
function oQ(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function iQ(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function Bh(e, t, n, r) {
  if (n) {
    var o = t;
    if (t.type === "click") {
      var i = e.cloneNode(!0);
      o = Object.create(t, {
        target: {
          value: i
        },
        currentTarget: {
          value: i
        }
      }), i.value = "", n(o);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      var a = e.cloneNode(!0);
      o = Object.create(t, {
        target: {
          value: a
        },
        currentTarget: {
          value: a
        }
      }), a.value = r, n(o);
      return;
    }
    n(o);
  }
}
function aQ(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var o = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(o, o);
          break;
        default:
          e.setSelectionRange(0, o);
      }
    }
  }
}
var mN = function(t) {
  var n, r, o = t.inputElement, i = t.children, a = t.prefixCls, s = t.prefix, l = t.suffix, u = t.addonBefore, f = t.addonAfter, p = t.className, h = t.style, y = t.disabled, b = t.readOnly, m = t.focused, v = t.triggerFocus, C = t.allowClear, x = t.value, S = t.handleReset, E = t.hidden, O = t.classes, $ = t.classNames, _ = t.dataAttrs, R = t.styles, P = t.components, I = i != null ? i : o, j = (P == null ? void 0 : P.affixWrapper) || "span", F = (P == null ? void 0 : P.groupWrapper) || "span", A = (P == null ? void 0 : P.wrapper) || "span", M = (P == null ? void 0 : P.groupAddon) || "span", N = _t(null), D = function(G) {
    var ne;
    (ne = N.current) !== null && ne !== void 0 && ne.contains(G.target) && (v == null || v());
  }, T = iQ(t), L = /* @__PURE__ */ JL(I, {
    value: x,
    className: se(I.props.className, !T && ($ == null ? void 0 : $.variant)) || null
  });
  if (T) {
    var z, H = null;
    if (C) {
      var V, Y = !y && !b && x, Z = "".concat(a, "-clear-icon"), oe = Vt(C) === "object" && C !== null && C !== void 0 && C.clearIcon ? C.clearIcon : "✖";
      H = /* @__PURE__ */ be.createElement("span", {
        onClick: S,
        onMouseDown: function(G) {
          return G.preventDefault();
        },
        className: se(Z, (V = {}, K(V, "".concat(Z, "-hidden"), !Y), K(V, "".concat(Z, "-has-suffix"), !!l), V)),
        role: "button",
        tabIndex: -1
      }, oe);
    }
    var ee = "".concat(a, "-affix-wrapper"), ae = se(ee, (z = {}, K(z, "".concat(a, "-disabled"), y), K(z, "".concat(ee, "-disabled"), y), K(z, "".concat(ee, "-focused"), m), K(z, "".concat(ee, "-readonly"), b), K(z, "".concat(ee, "-input-with-clear-btn"), l && C && x), z), O == null ? void 0 : O.affixWrapper, $ == null ? void 0 : $.affixWrapper, $ == null ? void 0 : $.variant), le = (l || C) && /* @__PURE__ */ be.createElement("span", {
      className: se("".concat(a, "-suffix"), $ == null ? void 0 : $.suffix),
      style: R == null ? void 0 : R.suffix
    }, H, l);
    L = /* @__PURE__ */ be.createElement(j, Oe({
      className: ae,
      style: R == null ? void 0 : R.affixWrapper,
      onClick: D
    }, _ == null ? void 0 : _.affixWrapper, {
      ref: N
    }), s && /* @__PURE__ */ be.createElement("span", {
      className: se("".concat(a, "-prefix"), $ == null ? void 0 : $.prefix),
      style: R == null ? void 0 : R.prefix
    }, s), L, le);
  }
  if (oQ(t)) {
    var ue = "".concat(a, "-group"), ie = "".concat(ue, "-addon"), re = "".concat(ue, "-wrapper"), Q = se("".concat(a, "-wrapper"), ue, O == null ? void 0 : O.wrapper, $ == null ? void 0 : $.wrapper), ce = se(re, K({}, "".concat(re, "-disabled"), y), O == null ? void 0 : O.group, $ == null ? void 0 : $.groupWrapper);
    L = /* @__PURE__ */ be.createElement(F, {
      className: ce
    }, /* @__PURE__ */ be.createElement(A, {
      className: Q
    }, u && /* @__PURE__ */ be.createElement(M, {
      className: ie
    }, u), L, f && /* @__PURE__ */ be.createElement(M, {
      className: ie
    }, f)));
  }
  return /* @__PURE__ */ be.cloneElement(L, {
    className: se((n = L.props) === null || n === void 0 ? void 0 : n.className, p) || null,
    style: J(J({}, (r = L.props) === null || r === void 0 ? void 0 : r.style), h),
    hidden: E
  });
}, sQ = ["show"];
function vN(e, t) {
  return c.useMemo(function() {
    var n = {};
    t && (n.show = Vt(t) === "object" && t.formatter ? t.formatter : !!t), n = J(J({}, n), e);
    var r = n, o = r.show, i = Yt(r, sQ);
    return J(J({}, i), {}, {
      show: !!o,
      showFormatter: typeof o == "function" ? o : void 0,
      strategy: i.strategy || function(a) {
        return a.length;
      }
    });
  }, [e, t]);
}
var lQ = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], cQ = /* @__PURE__ */ ni(function(e, t) {
  var n = e.autoComplete, r = e.onChange, o = e.onFocus, i = e.onBlur, a = e.onPressEnter, s = e.onKeyDown, l = e.prefixCls, u = l === void 0 ? "rc-input" : l, f = e.disabled, p = e.htmlSize, h = e.className, y = e.maxLength, b = e.suffix, m = e.showCount, v = e.count, C = e.type, x = C === void 0 ? "text" : C, S = e.classes, E = e.classNames, O = e.styles, $ = e.onCompositionStart, _ = e.onCompositionEnd, R = Yt(e, lQ), P = Ot(!1), I = de(P, 2), j = I[0], F = I[1], A = _t(!1), M = _t(null), N = function(me) {
    M.current && aQ(M.current, me);
  }, D = Fn(e.defaultValue, {
    value: e.value
  }), T = de(D, 2), L = T[0], z = T[1], H = L == null ? "" : String(L), V = Ot(null), Y = de(V, 2), Z = Y[0], oe = Y[1], ee = vN(v, m), ae = ee.max || y, le = ee.strategy(H), ue = !!ae && le > ae;
  Ua(t, function() {
    return {
      focus: N,
      blur: function() {
        var me;
        (me = M.current) === null || me === void 0 || me.blur();
      },
      setSelectionRange: function(me, Ce, Te) {
        var Ee;
        (Ee = M.current) === null || Ee === void 0 || Ee.setSelectionRange(me, Ce, Te);
      },
      select: function() {
        var me;
        (me = M.current) === null || me === void 0 || me.select();
      },
      input: M.current
    };
  }), kt(function() {
    F(function(he) {
      return he && f ? !1 : he;
    });
  }, [f]);
  var ie = function(me, Ce, Te) {
    var Ee = Ce;
    if (!A.current && ee.exceedFormatter && ee.max && ee.strategy(Ce) > ee.max) {
      if (Ee = ee.exceedFormatter(Ce, {
        max: ee.max
      }), Ce !== Ee) {
        var Ge, ke;
        oe([((Ge = M.current) === null || Ge === void 0 ? void 0 : Ge.selectionStart) || 0, ((ke = M.current) === null || ke === void 0 ? void 0 : ke.selectionEnd) || 0]);
      }
    } else if (Te.source === "compositionEnd")
      return;
    z(Ee), M.current && Bh(M.current, me, r, Ee);
  };
  kt(function() {
    if (Z) {
      var he;
      (he = M.current) === null || he === void 0 || he.setSelectionRange.apply(he, We(Z));
    }
  }, [Z]);
  var re = function(me) {
    ie(me, me.target.value, {
      source: "change"
    });
  }, Q = function(me) {
    A.current = !1, ie(me, me.currentTarget.value, {
      source: "compositionEnd"
    }), _ == null || _(me);
  }, ce = function(me) {
    a && me.key === "Enter" && a(me), s == null || s(me);
  }, ge = function(me) {
    F(!0), o == null || o(me);
  }, G = function(me) {
    F(!1), i == null || i(me);
  }, ne = function(me) {
    z(""), N(), M.current && Bh(M.current, me, r);
  }, fe = ue && "".concat(u, "-out-of-range"), ye = function() {
    var me = dr(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ be.createElement("input", Oe({
      autoComplete: n
    }, me, {
      onChange: re,
      onFocus: ge,
      onBlur: G,
      onKeyDown: ce,
      className: se(u, K({}, "".concat(u, "-disabled"), f), E == null ? void 0 : E.input),
      style: O == null ? void 0 : O.input,
      ref: M,
      size: p,
      type: x,
      onCompositionStart: function(Te) {
        A.current = !0, $ == null || $(Te);
      },
      onCompositionEnd: Q
    }));
  }, we = function() {
    var me = Number(ae) > 0;
    if (b || ee.show) {
      var Ce = ee.showFormatter ? ee.showFormatter({
        value: H,
        count: le,
        maxLength: ae
      }) : "".concat(le).concat(me ? " / ".concat(ae) : "");
      return /* @__PURE__ */ be.createElement(be.Fragment, null, ee.show && /* @__PURE__ */ be.createElement("span", {
        className: se("".concat(u, "-show-count-suffix"), K({}, "".concat(u, "-show-count-has-suffix"), !!b), E == null ? void 0 : E.count),
        style: J({}, O == null ? void 0 : O.count)
      }, Ce), b);
    }
    return null;
  };
  return /* @__PURE__ */ be.createElement(mN, Oe({}, R, {
    prefixCls: u,
    className: se(h, fe),
    handleReset: ne,
    value: H,
    focused: j,
    triggerFocus: N,
    suffix: we(),
    disabled: f,
    classes: S,
    classNames: E,
    styles: O
  }), ye());
});
const uQ = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = Cn(Ft), {
    prefixCls: r,
    className: o
  } = e, i = t("input-group", r), a = t("input"), [s, l] = rC(a), u = se(i, {
    [`${i}-lg`]: e.size === "large",
    [`${i}-sm`]: e.size === "small",
    [`${i}-compact`]: e.compact,
    [`${i}-rtl`]: n === "rtl"
  }, l, o), f = Cn(uo), p = mr(() => Object.assign(Object.assign({}, f), {
    isFormItemInput: !1
  }), [f]);
  return process.env.NODE_ENV !== "production" && xn("Input.Group").deprecated(!1, "Input.Group", "Space.Compact"), s(/* @__PURE__ */ c.createElement("span", {
    className: u,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ c.createElement(uo.Provider, {
    value: p
  }, e.children)));
}, dQ = uQ;
function yN(e, t) {
  const n = _t([]), r = () => {
    n.current.push(setTimeout(() => {
      var o, i, a, s;
      !((o = e.current) === null || o === void 0) && o.input && ((i = e.current) === null || i === void 0 ? void 0 : i.input.getAttribute("type")) === "password" && (!((a = e.current) === null || a === void 0) && a.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return kt(() => (t && r(), () => n.current.forEach((o) => {
    o && clearTimeout(o);
  })), []), r;
}
function fQ(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
const pQ = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ be.createElement(Ds, null)
  }), t;
};
var hQ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function gQ(e, t) {
  if (!e)
    return;
  e.focus(t);
  const {
    cursor: n
  } = t || {};
  if (n) {
    const r = e.value.length;
    switch (n) {
      case "start":
        e.setSelectionRange(0, 0);
        break;
      case "end":
        e.setSelectionRange(r, r);
        break;
      default:
        e.setSelectionRange(0, r);
        break;
    }
  }
}
const mQ = /* @__PURE__ */ ni((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o = !0,
    status: i,
    size: a,
    disabled: s,
    onBlur: l,
    onFocus: u,
    suffix: f,
    allowClear: p,
    addonAfter: h,
    addonBefore: y,
    className: b,
    style: m,
    styles: v,
    rootClassName: C,
    onChange: x,
    classNames: S,
    variant: E
  } = e, O = hQ(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: G
    } = xn("Input");
    G(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: $,
    direction: _,
    input: R
  } = be.useContext(Ft), P = $("input", r), I = _t(null), j = Ar(P), [F, A, M] = rC(P, j), {
    compactSize: N,
    compactItemClassnames: D
  } = Ms(P, _), T = Co((G) => {
    var ne;
    return (ne = a != null ? a : N) !== null && ne !== void 0 ? ne : G;
  }), L = be.useContext(Ki), z = s != null ? s : L, {
    status: H,
    hasFeedback: V,
    feedbackIcon: Y
  } = Cn(uo), Z = eu(H, i), oe = fQ(e) || !!V, ee = _t(oe);
  if (process.env.NODE_ENV !== "production") {
    const G = xn("Input");
    kt(() => {
      var ne;
      oe && !ee.current && process.env.NODE_ENV !== "production" && G(document.activeElement === ((ne = I.current) === null || ne === void 0 ? void 0 : ne.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), ee.current = oe;
    }, [oe]);
  }
  const ae = yN(I, !0), le = (G) => {
    ae(), l == null || l(G);
  }, ue = (G) => {
    ae(), u == null || u(G);
  }, ie = (G) => {
    ae(), x == null || x(G);
  }, re = (V || f) && /* @__PURE__ */ be.createElement(be.Fragment, null, f, V && Y), Q = pQ(p), [ce, ge] = tu(E, o);
  return F(/* @__PURE__ */ be.createElement(cQ, Object.assign({
    ref: Do(t, I),
    prefixCls: P,
    autoComplete: R == null ? void 0 : R.autoComplete
  }, O, {
    disabled: z,
    onBlur: le,
    onFocus: ue,
    style: Object.assign(Object.assign({}, R == null ? void 0 : R.style), m),
    styles: Object.assign(Object.assign({}, R == null ? void 0 : R.styles), v),
    suffix: re,
    allowClear: Q,
    className: se(b, C, M, j, D, R == null ? void 0 : R.className),
    onChange: ie,
    addonAfter: h && /* @__PURE__ */ be.createElement(vl, null, /* @__PURE__ */ be.createElement(F1, {
      override: !0,
      status: !0
    }, h)),
    addonBefore: y && /* @__PURE__ */ be.createElement(vl, null, /* @__PURE__ */ be.createElement(F1, {
      override: !0,
      status: !0
    }, y)),
    classNames: Object.assign(Object.assign(Object.assign({}, S), R == null ? void 0 : R.classNames), {
      input: se({
        [`${P}-sm`]: T === "small",
        [`${P}-lg`]: T === "large",
        [`${P}-rtl`]: _ === "rtl"
      }, S == null ? void 0 : S.input, (n = R == null ? void 0 : R.classNames) === null || n === void 0 ? void 0 : n.input, A),
      variant: se({
        [`${P}-${ce}`]: ge
      }, bl(P, Z)),
      affixWrapper: se({
        [`${P}-affix-wrapper-sm`]: T === "small",
        [`${P}-affix-wrapper-lg`]: T === "large",
        [`${P}-affix-wrapper-rtl`]: _ === "rtl"
      }, A),
      wrapper: se({
        [`${P}-group-rtl`]: _ === "rtl"
      }, A),
      groupWrapper: se({
        [`${P}-group-wrapper-sm`]: T === "small",
        [`${P}-group-wrapper-lg`]: T === "large",
        [`${P}-group-wrapper-rtl`]: _ === "rtl",
        [`${P}-group-wrapper-${ce}`]: ge
      }, bl(`${P}-group-wrapper`, Z, V), A)
    })
  })));
}), sC = mQ;
var vQ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const yQ = vQ;
var bN = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: yQ
  }));
};
process.env.NODE_ENV !== "production" && (bN.displayName = "EyeInvisibleOutlined");
const bQ = /* @__PURE__ */ c.forwardRef(bN);
var CQ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const xQ = CQ;
var CN = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: xQ
  }));
};
process.env.NODE_ENV !== "production" && (CN.displayName = "EyeOutlined");
const SQ = /* @__PURE__ */ c.forwardRef(CN);
var wQ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const EQ = (e) => e ? /* @__PURE__ */ c.createElement(SQ, null) : /* @__PURE__ */ c.createElement(bQ, null), $Q = {
  click: "onClick",
  hover: "onMouseOver"
}, xN = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    visibilityToggle: n = !0
  } = e, r = typeof n == "object" && n.visible !== void 0, [o, i] = Ot(() => r ? n.visible : !1), a = _t(null);
  c.useEffect(() => {
    r && i(n.visible);
  }, [r, n]);
  const s = yN(a), l = () => {
    const {
      disabled: O
    } = e;
    O || (o && s(), i(($) => {
      var _;
      const R = !$;
      return typeof n == "object" && ((_ = n.onVisibleChange) === null || _ === void 0 || _.call(n, R)), R;
    }));
  }, u = (O) => {
    const {
      action: $ = "click",
      iconRender: _ = EQ
    } = e, R = $Q[$] || "", P = _(o), I = {
      [R]: l,
      className: `${O}-icon`,
      key: "passwordIcon",
      onMouseDown: (j) => {
        j.preventDefault();
      },
      onMouseUp: (j) => {
        j.preventDefault();
      }
    };
    return /* @__PURE__ */ c.cloneElement(/* @__PURE__ */ c.isValidElement(P) ? P : /* @__PURE__ */ c.createElement("span", null, P), I);
  }, {
    className: f,
    prefixCls: p,
    inputPrefixCls: h,
    size: y
  } = e, b = wQ(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: m
  } = c.useContext(Ft), v = m("input", h), C = m("input-password", p), x = n && u(C), S = se(C, f, {
    [`${C}-${y}`]: !!y
  }), E = Object.assign(Object.assign({}, dr(b, ["suffix", "iconRender", "visibilityToggle"])), {
    type: o ? "text" : "password",
    className: S,
    prefixCls: v,
    suffix: x
  });
  return y && (E.size = y), /* @__PURE__ */ c.createElement(sC, Object.assign({
    ref: Do(t, a)
  }, E));
});
process.env.NODE_ENV !== "production" && (xN.displayName = "Input.Password");
const OQ = xN;
var _Q = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const SN = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    inputPrefixCls: r,
    className: o,
    size: i,
    suffix: a,
    enterButton: s = !1,
    addonAfter: l,
    loading: u,
    disabled: f,
    onSearch: p,
    onChange: h,
    onCompositionStart: y,
    onCompositionEnd: b
  } = e, m = _Q(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: v,
    direction: C
  } = c.useContext(Ft), x = c.useRef(!1), S = v("input-search", n), E = v("input", r), {
    compactSize: O
  } = Ms(S, C), $ = Co((H) => {
    var V;
    return (V = i != null ? i : O) !== null && V !== void 0 ? V : H;
  }), _ = c.useRef(null), R = (H) => {
    H && H.target && H.type === "click" && p && p(H.target.value, H, {
      source: "clear"
    }), h && h(H);
  }, P = (H) => {
    var V;
    document.activeElement === ((V = _.current) === null || V === void 0 ? void 0 : V.input) && H.preventDefault();
  }, I = (H) => {
    var V, Y;
    p && p((Y = (V = _.current) === null || V === void 0 ? void 0 : V.input) === null || Y === void 0 ? void 0 : Y.value, H, {
      source: "input"
    });
  }, j = (H) => {
    x.current || u || I(H);
  }, F = typeof s == "boolean" ? /* @__PURE__ */ c.createElement(Hg, null) : null, A = `${S}-button`;
  let M;
  const N = s || {}, D = N.type && N.type.__ANT_BUTTON === !0;
  D || N.type === "button" ? M = Yr(N, Object.assign({
    onMouseDown: P,
    onClick: (H) => {
      var V, Y;
      (Y = (V = N == null ? void 0 : N.props) === null || V === void 0 ? void 0 : V.onClick) === null || Y === void 0 || Y.call(V, H), I(H);
    },
    key: "enterButton"
  }, D ? {
    className: A,
    size: $
  } : {})) : M = /* @__PURE__ */ c.createElement(Io, {
    className: A,
    type: s ? "primary" : void 0,
    size: $,
    disabled: f,
    key: "enterButton",
    onMouseDown: P,
    onClick: I,
    loading: u,
    icon: F
  }, s), l && (M = [M, Yr(l, {
    key: "addonAfter"
  })]);
  const T = se(S, {
    [`${S}-rtl`]: C === "rtl",
    [`${S}-${$}`]: !!$,
    [`${S}-with-button`]: !!s
  }, o), L = (H) => {
    x.current = !0, y == null || y(H);
  }, z = (H) => {
    x.current = !1, b == null || b(H);
  };
  return /* @__PURE__ */ c.createElement(sC, Object.assign({
    ref: Do(_, t),
    onPressEnter: j
  }, m, {
    size: $,
    onCompositionStart: L,
    onCompositionEnd: z,
    prefixCls: E,
    addonAfter: M,
    suffix: a,
    onChange: R,
    className: T,
    disabled: f
  }));
});
process.env.NODE_ENV !== "production" && (SN.displayName = "Search");
const NQ = SN;
var PQ = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, IQ = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], r0 = {}, hi;
function RQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && r0[n])
    return r0[n];
  var r = window.getComputedStyle(e), o = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), i = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), a = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), s = IQ.map(function(u) {
    return "".concat(u, ":").concat(r.getPropertyValue(u));
  }).join(";"), l = {
    sizingStyle: s,
    paddingSize: i,
    borderSize: a,
    boxSizing: o
  };
  return t && n && (r0[n] = l), l;
}
function DQ(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  hi || (hi = document.createElement("textarea"), hi.setAttribute("tab-index", "-1"), hi.setAttribute("aria-hidden", "true"), document.body.appendChild(hi)), e.getAttribute("wrap") ? hi.setAttribute("wrap", e.getAttribute("wrap")) : hi.removeAttribute("wrap");
  var o = RQ(e, t), i = o.paddingSize, a = o.borderSize, s = o.boxSizing, l = o.sizingStyle;
  hi.setAttribute("style", "".concat(l, ";").concat(PQ)), hi.value = e.value || e.placeholder || "";
  var u = void 0, f = void 0, p, h = hi.scrollHeight;
  if (s === "border-box" ? h += a : s === "content-box" && (h -= i), n !== null || r !== null) {
    hi.value = " ";
    var y = hi.scrollHeight - i;
    n !== null && (u = y * n, s === "border-box" && (u = u + i + a), h = Math.max(u, h)), r !== null && (f = y * r, s === "border-box" && (f = f + i + a), p = h > f ? "" : "hidden", h = Math.min(f, h));
  }
  var b = {
    height: h,
    overflowY: p,
    resize: "none"
  };
  return u && (b.minHeight = u), f && (b.maxHeight = f), b;
}
var TQ = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], o0 = 0, i0 = 1, a0 = 2, MQ = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e, r = n.prefixCls;
  n.onPressEnter;
  var o = n.defaultValue, i = n.value, a = n.autoSize, s = n.onResize, l = n.className, u = n.style, f = n.disabled, p = n.onChange, h = n.onInternalAutoSize, y = Yt(n, TQ), b = Fn(o, {
    value: i,
    postState: function(ee) {
      return ee != null ? ee : "";
    }
  }), m = de(b, 2), v = m[0], C = m[1], x = function(ee) {
    C(ee.target.value), p == null || p(ee);
  }, S = c.useRef();
  c.useImperativeHandle(t, function() {
    return {
      textArea: S.current
    };
  });
  var E = c.useMemo(function() {
    return a && Vt(a) === "object" ? [a.minRows, a.maxRows] : [];
  }, [a]), O = de(E, 2), $ = O[0], _ = O[1], R = !!a, P = function() {
    try {
      if (document.activeElement === S.current) {
        var ee = S.current, ae = ee.selectionStart, le = ee.selectionEnd, ue = ee.scrollTop;
        S.current.setSelectionRange(ae, le), S.current.scrollTop = ue;
      }
    } catch (ie) {
    }
  }, I = c.useState(a0), j = de(I, 2), F = j[0], A = j[1], M = c.useState(), N = de(M, 2), D = N[0], T = N[1], L = function() {
    A(o0), process.env.NODE_ENV === "test" && (h == null || h());
  };
  Nn(function() {
    R && L();
  }, [i, $, _, R]), Nn(function() {
    if (F === o0)
      A(i0);
    else if (F === i0) {
      var oe = DQ(S.current, !1, $, _);
      A(a0), T(oe);
    } else
      P();
  }, [F]);
  var z = c.useRef(), H = function() {
    Pn.cancel(z.current);
  }, V = function(ee) {
    F === a0 && (s == null || s(ee), a && (H(), z.current = Pn(function() {
      L();
    })));
  };
  c.useEffect(function() {
    return H;
  }, []);
  var Y = R ? D : null, Z = J(J({}, u), Y);
  return (F === o0 || F === i0) && (Z.overflowY = "hidden", Z.overflowX = "hidden"), /* @__PURE__ */ c.createElement(zo, {
    onResize: V,
    disabled: !(a || s)
  }, /* @__PURE__ */ c.createElement("textarea", Oe({}, y, {
    ref: S,
    style: Z,
    className: se(r, l, K({}, "".concat(r, "-disabled"), f)),
    disabled: f,
    value: v,
    onChange: x
  })));
}), LQ = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"], AQ = /* @__PURE__ */ be.forwardRef(function(e, t) {
  var n, r, o = e.defaultValue, i = e.value, a = e.onFocus, s = e.onBlur, l = e.onChange, u = e.allowClear, f = e.maxLength, p = e.onCompositionStart, h = e.onCompositionEnd, y = e.suffix, b = e.prefixCls, m = b === void 0 ? "rc-textarea" : b, v = e.showCount, C = e.count, x = e.className, S = e.style, E = e.disabled, O = e.hidden, $ = e.classNames, _ = e.styles, R = e.onResize, P = Yt(e, LQ), I = Fn(o, {
    value: i,
    defaultValue: o
  }), j = de(I, 2), F = j[0], A = j[1], M = F == null ? "" : String(F), N = be.useState(!1), D = de(N, 2), T = D[0], L = D[1], z = be.useRef(!1), H = be.useState(null), V = de(H, 2), Y = V[0], Z = V[1], oe = _t(null), ee = function() {
    var Ke;
    return (Ke = oe.current) === null || Ke === void 0 ? void 0 : Ke.textArea;
  }, ae = function() {
    ee().focus();
  };
  Ua(t, function() {
    return {
      resizableTextArea: oe.current,
      focus: ae,
      blur: function() {
        ee().blur();
      }
    };
  }), kt(function() {
    L(function(pt) {
      return !E && pt;
    });
  }, [E]);
  var le = be.useState(null), ue = de(le, 2), ie = ue[0], re = ue[1];
  be.useEffect(function() {
    if (ie) {
      var pt;
      (pt = ee()).setSelectionRange.apply(pt, We(ie));
    }
  }, [ie]);
  var Q = vN(C, v), ce = (n = Q.max) !== null && n !== void 0 ? n : f, ge = Number(ce) > 0, G = Q.strategy(M), ne = !!ce && G > ce, fe = function(Ke, et) {
    var Je = et;
    !z.current && Q.exceedFormatter && Q.max && Q.strategy(et) > Q.max && (Je = Q.exceedFormatter(et, {
      max: Q.max
    }), et !== Je && re([ee().selectionStart || 0, ee().selectionEnd || 0])), A(Je), Bh(Ke.currentTarget, Ke, l, Je);
  }, ye = function(Ke) {
    z.current = !0, p == null || p(Ke);
  }, we = function(Ke) {
    z.current = !1, fe(Ke, Ke.currentTarget.value), h == null || h(Ke);
  }, he = function(Ke) {
    fe(Ke, Ke.target.value);
  }, me = function(Ke) {
    var et = P.onPressEnter, Je = P.onKeyDown;
    Ke.key === "Enter" && et && et(Ke), Je == null || Je(Ke);
  }, Ce = function(Ke) {
    L(!0), a == null || a(Ke);
  }, Te = function(Ke) {
    L(!1), s == null || s(Ke);
  }, Ee = function(Ke) {
    A(""), ae(), Bh(ee(), Ke, l);
  }, Ge = y, ke;
  Q.show && (Q.showFormatter ? ke = Q.showFormatter({
    value: M,
    count: G,
    maxLength: ce
  }) : ke = "".concat(G).concat(ge ? " / ".concat(ce) : ""), Ge = /* @__PURE__ */ be.createElement(be.Fragment, null, Ge, /* @__PURE__ */ be.createElement("span", {
    className: se("".concat(m, "-data-count"), $ == null ? void 0 : $.count),
    style: _ == null ? void 0 : _.count
  }, ke)));
  var qe = function(Ke) {
    var et;
    R == null || R(Ke), (et = ee()) !== null && et !== void 0 && et.style.height && Z(!0);
  }, ze = !P.autoSize && !v && !u;
  return /* @__PURE__ */ be.createElement(mN, {
    value: M,
    allowClear: u,
    handleReset: Ee,
    suffix: Ge,
    prefixCls: m,
    classNames: J(J({}, $), {}, {
      affixWrapper: se($ == null ? void 0 : $.affixWrapper, (r = {}, K(r, "".concat(m, "-show-count"), v), K(r, "".concat(m, "-textarea-allow-clear"), u), r))
    }),
    disabled: E,
    focused: T,
    className: se(x, ne && "".concat(m, "-out-of-range")),
    style: J(J({}, S), Y && !ze ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof ke == "string" ? ke : void 0
      }
    },
    hidden: O
  }, /* @__PURE__ */ be.createElement(MQ, Oe({}, P, {
    maxLength: f,
    onKeyDown: me,
    onChange: he,
    onFocus: Ce,
    onBlur: Te,
    onCompositionStart: ye,
    onCompositionEnd: we,
    className: se($ == null ? void 0 : $.textarea),
    style: J(J({}, _ == null ? void 0 : _.textarea), {}, {
      resize: S == null ? void 0 : S.resize
    }),
    disabled: E,
    prefixCls: m,
    onResize: qe,
    ref: oe
  })));
}), jQ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const kQ = /* @__PURE__ */ ni((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: o = !0,
    size: i,
    disabled: a,
    status: s,
    allowClear: l,
    classNames: u,
    rootClassName: f,
    className: p,
    variant: h
  } = e, y = jQ(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: D
    } = xn("TextArea");
    D(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: b,
    direction: m
  } = c.useContext(Ft), v = Co(i), C = c.useContext(Ki), x = a != null ? a : C, {
    status: S,
    hasFeedback: E,
    feedbackIcon: O
  } = c.useContext(uo), $ = eu(S, s), _ = c.useRef(null);
  c.useImperativeHandle(t, () => {
    var D;
    return {
      resizableTextArea: (D = _.current) === null || D === void 0 ? void 0 : D.resizableTextArea,
      focus: (T) => {
        var L, z;
        gQ((z = (L = _.current) === null || L === void 0 ? void 0 : L.resizableTextArea) === null || z === void 0 ? void 0 : z.textArea, T);
      },
      blur: () => {
        var T;
        return (T = _.current) === null || T === void 0 ? void 0 : T.blur();
      }
    };
  });
  const R = b("input", r);
  let P;
  typeof l == "object" && (l != null && l.clearIcon) ? P = l : l && (P = {
    clearIcon: /* @__PURE__ */ c.createElement(Ds, null)
  });
  const I = Ar(R), [j, F, A] = rC(R, I), [M, N] = tu(h, o);
  return j(/* @__PURE__ */ c.createElement(AQ, Object.assign({}, y, {
    disabled: x,
    allowClear: P,
    className: se(A, I, p, f),
    classNames: Object.assign(Object.assign({}, u), {
      textarea: se({
        [`${R}-sm`]: v === "small",
        [`${R}-lg`]: v === "large"
      }, F, u == null ? void 0 : u.textarea),
      variant: se({
        [`${R}-${M}`]: N
      }, bl(R, $)),
      affixWrapper: se(`${R}-textarea-affix-wrapper`, {
        [`${R}-affix-wrapper-rtl`]: m === "rtl",
        [`${R}-affix-wrapper-sm`]: v === "small",
        [`${R}-affix-wrapper-lg`]: v === "large",
        [`${R}-textarea-show-count`]: e.showCount || ((n = e.count) === null || n === void 0 ? void 0 : n.show)
      }, F)
    }),
    prefixCls: R,
    suffix: E && /* @__PURE__ */ c.createElement("span", {
      className: `${R}-textarea-suffix`
    }, O),
    ref: _
  })));
}), wN = kQ, au = sC;
process.env.NODE_ENV !== "production" && (au.displayName = "Input");
au.Group = dQ;
au.Search = NQ;
au.TextArea = wN;
au.Password = OQ;
const tm = au;
var FQ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" };
const BQ = FQ;
var EN = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: BQ
  }));
};
process.env.NODE_ENV !== "production" && (EN.displayName = "CalendarOutlined");
const $N = /* @__PURE__ */ c.forwardRef(EN);
var HQ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" };
const zQ = HQ;
var ON = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: zQ
  }));
};
process.env.NODE_ENV !== "production" && (ON.displayName = "ClockCircleOutlined");
const _N = /* @__PURE__ */ c.forwardRef(ON);
var VQ = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" };
const WQ = VQ;
var NN = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: WQ
  }));
};
process.env.NODE_ENV !== "production" && (NN.displayName = "SwapRightOutlined");
const KQ = /* @__PURE__ */ c.forwardRef(NN);
function UQ(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.yearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.quarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.monthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.weekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.placeholder : e.lang.placeholder;
}
function GQ(e, t, n) {
  return n !== void 0 ? n : t === "year" && e.lang.yearPlaceholder ? e.lang.rangeYearPlaceholder : t === "quarter" && e.lang.quarterPlaceholder ? e.lang.rangeQuarterPlaceholder : t === "month" && e.lang.monthPlaceholder ? e.lang.rangeMonthPlaceholder : t === "week" && e.lang.weekPlaceholder ? e.lang.rangeWeekPlaceholder : t === "time" && e.timePickerLocale.placeholder ? e.timePickerLocale.rangePlaceholder : e.lang.rangePlaceholder;
}
function lC(e, t) {
  const n = {
    adjustX: 1,
    adjustY: 1
  };
  switch (t) {
    case "bottomLeft":
      return {
        points: ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
    case "bottomRight":
      return {
        points: ["tr", "br"],
        offset: [0, 4],
        overflow: n
      };
    case "topLeft":
      return {
        points: ["bl", "tl"],
        offset: [0, -4],
        overflow: n
      };
    case "topRight":
      return {
        points: ["br", "tr"],
        offset: [0, -4],
        overflow: n
      };
    default:
      return {
        points: e === "rtl" ? ["tr", "br"] : ["tl", "bl"],
        offset: [0, 4],
        overflow: n
      };
  }
}
function qQ(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function Hh(e) {
  const {
    format: t,
    picker: n,
    showHour: r,
    showMinute: o,
    showSecond: i,
    use12Hours: a
  } = e, s = qQ(t)[0], l = Object.assign({}, e);
  return t && Array.isArray(t) && (l.format = s), s && typeof s == "string" && (!s.includes("s") && i === void 0 && (l.showSecond = !1), !s.includes("m") && o === void 0 && (l.showMinute = !1), !s.includes("H") && !s.includes("h") && !s.includes("K") && !s.includes("k") && r === void 0 && (l.showHour = !1), (s.includes("a") || s.includes("A")) && a === void 0 && (l.use12Hours = !0)), n === "time" ? l : (typeof s == "function" && delete l.format, {
    showTime: l
  });
}
function PN(e, t, n) {
  if (e === !1)
    return !1;
  const r = {
    clearIcon: t != null ? t : n
  };
  return typeof e == "object" ? Object.assign(Object.assign({}, r), e) : r;
}
function YQ(e) {
  return /* @__PURE__ */ c.createElement(Io, Object.assign({
    size: "small",
    type: "primary"
  }, e));
}
const XQ = {
  button: YQ
}, IN = XQ;
var ZQ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function QQ(e) {
  const t = /* @__PURE__ */ ni((n, r) => {
    var o;
    const {
      prefixCls: i,
      getPopupContainer: a,
      className: s,
      style: l,
      placement: u,
      size: f,
      disabled: p,
      bordered: h = !0,
      placeholder: y,
      popupClassName: b,
      dropdownClassName: m,
      status: v,
      clearIcon: C,
      allowClear: x,
      rootClassName: S,
      variant: E
    } = n, O = ZQ(n, ["prefixCls", "getPopupContainer", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupClassName", "dropdownClassName", "status", "clearIcon", "allowClear", "rootClassName", "variant"]), $ = c.useRef(null), {
      getPrefixCls: _,
      direction: R,
      getPopupContainer: P,
      rangePicker: I
    } = Cn(Ft), j = _("picker", i), {
      compactSize: F,
      compactItemClassnames: A
    } = Ms(j, R), {
      format: M,
      showTime: N,
      picker: D
    } = n, T = _(), [L, z] = tu(E, h), H = Ar(j), [V, Y, Z] = eN(j, H), oe = Object.assign(Object.assign({}, N ? Hh(Object.assign({
      format: M,
      picker: D
    }, N)) : {}), D === "time" ? Hh(Object.assign(Object.assign({
      format: M
    }, n), {
      picker: D
    })) : {});
    if (process.env.NODE_ENV !== "production") {
      const fe = xn("DatePicker.RangePicker");
      fe.deprecated(!m, "dropdownClassName", "popupClassName"), fe.deprecated(!("bordered" in n), "bordered", "variant");
    }
    const ee = Co((fe) => {
      var ye;
      return (ye = f != null ? f : F) !== null && ye !== void 0 ? ye : fe;
    }), ae = c.useContext(Ki), le = p != null ? p : ae, ue = Cn(uo), {
      hasFeedback: ie,
      status: re,
      feedbackIcon: Q
    } = ue, ce = /* @__PURE__ */ c.createElement(c.Fragment, null, D === "time" ? /* @__PURE__ */ c.createElement(_N, null) : /* @__PURE__ */ c.createElement($N, null), ie && Q);
    Ua(r, () => ({
      focus: () => {
        var fe;
        return (fe = $.current) === null || fe === void 0 ? void 0 : fe.focus();
      },
      blur: () => {
        var fe;
        return (fe = $.current) === null || fe === void 0 ? void 0 : fe.blur();
      }
    }));
    const [ge] = _l("Calendar", wh), G = Object.assign(Object.assign({}, ge), n.locale), [ne] = Ts("DatePicker", (o = n.popupStyle) === null || o === void 0 ? void 0 : o.zIndex);
    return V(/* @__PURE__ */ c.createElement(vl, null, /* @__PURE__ */ c.createElement(_X, Object.assign({
      separator: /* @__PURE__ */ c.createElement("span", {
        "aria-label": "to",
        className: `${j}-separator`
      }, /* @__PURE__ */ c.createElement(KQ, null)),
      disabled: le,
      ref: $,
      dropdownAlign: lC(R, u),
      placeholder: GQ(G, D, y),
      suffixIcon: ce,
      prevIcon: /* @__PURE__ */ c.createElement("span", {
        className: `${j}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ c.createElement("span", {
        className: `${j}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ c.createElement("span", {
        className: `${j}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ c.createElement("span", {
        className: `${j}-super-next-icon`
      }),
      transitionName: `${T}-slide-up`
    }, O, oe, {
      className: se({
        [`${j}-${ee}`]: ee,
        [`${j}-${L}`]: z
      }, bl(j, eu(re, v), ie), Y, A, s, I == null ? void 0 : I.className, Z, H, S),
      style: Object.assign(Object.assign({}, I == null ? void 0 : I.style), l),
      locale: G.lang,
      prefixCls: j,
      getPopupContainer: a || P,
      generateConfig: e,
      components: IN,
      direction: R,
      dropdownClassName: se(Y, b || m, Z, H, S),
      popupStyle: Object.assign(Object.assign({}, n.popupStyle), {
        zIndex: ne
      }),
      allowClear: PN(x, C, /* @__PURE__ */ c.createElement(Ds, null))
    }))));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "RangePicker"), t;
}
var JQ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function eJ(e) {
  function t(l, u) {
    const f = u === "TimePicker" ? "timePicker" : "datePicker", p = /* @__PURE__ */ ni((h, y) => {
      var b;
      const {
        prefixCls: m,
        getPopupContainer: v,
        style: C,
        className: x,
        rootClassName: S,
        size: E,
        bordered: O,
        placement: $,
        placeholder: _,
        popupClassName: R,
        dropdownClassName: P,
        disabled: I,
        status: j,
        clearIcon: F,
        allowClear: A,
        variant: M
      } = h, N = JQ(h, ["prefixCls", "getPopupContainer", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupClassName", "dropdownClassName", "disabled", "status", "clearIcon", "allowClear", "variant"]), {
        getPrefixCls: D,
        direction: T,
        getPopupContainer: L,
        // Consume different styles according to different names
        [f]: z
      } = Cn(Ft), H = D("picker", m), {
        compactSize: V,
        compactItemClassnames: Y
      } = Ms(H, T), Z = c.useRef(null), {
        format: oe,
        showTime: ee
      } = h, [ae, le] = tu(M, O), ue = Ar(H), [ie, re, Q] = eN(H, ue);
      Ua(y, () => ({
        focus: () => {
          var ze;
          return (ze = Z.current) === null || ze === void 0 ? void 0 : ze.focus();
        },
        blur: () => {
          var ze;
          return (ze = Z.current) === null || ze === void 0 ? void 0 : ze.blur();
        }
      }));
      const ce = {
        showToday: !0
      };
      let ge = {};
      l && (ge.picker = l);
      const G = l || h.picker;
      ge = Object.assign(Object.assign(Object.assign({}, ge), ee ? Hh(Object.assign({
        format: oe,
        picker: G
      }, ee)) : {}), G === "time" ? Hh(Object.assign(Object.assign({
        format: oe
      }, h), {
        picker: G
      })) : {});
      const ne = D();
      if (process.env.NODE_ENV !== "production") {
        const ze = xn(u || "DatePicker");
        process.env.NODE_ENV !== "production" && ze(l !== "quarter", "deprecated", `DatePicker.${u} is legacy usage. Please use DatePicker[picker='${l}'] directly.`), ze.deprecated(!P, "dropdownClassName", "popupClassName"), ze.deprecated(!("bordered" in h), "bordered", "variant");
      }
      const fe = Co((ze) => {
        var pt;
        return (pt = E != null ? E : V) !== null && pt !== void 0 ? pt : ze;
      }), ye = c.useContext(Ki), we = I != null ? I : ye, he = Cn(uo), {
        hasFeedback: me,
        status: Ce,
        feedbackIcon: Te
      } = he, Ee = /* @__PURE__ */ c.createElement(c.Fragment, null, G === "time" ? /* @__PURE__ */ c.createElement(_N, null) : /* @__PURE__ */ c.createElement($N, null), me && Te), [Ge] = _l("DatePicker", wh), ke = Object.assign(Object.assign({}, Ge), h.locale), [qe] = Ts("DatePicker", (b = h.popupStyle) === null || b === void 0 ? void 0 : b.zIndex);
      return ie(/* @__PURE__ */ c.createElement(vl, null, /* @__PURE__ */ c.createElement(CX, Object.assign({
        ref: Z,
        placeholder: UQ(ke, G, _),
        suffixIcon: Ee,
        dropdownAlign: lC(T, $),
        prevIcon: /* @__PURE__ */ c.createElement("span", {
          className: `${H}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ c.createElement("span", {
          className: `${H}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ c.createElement("span", {
          className: `${H}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ c.createElement("span", {
          className: `${H}-super-next-icon`
        }),
        transitionName: `${ne}-slide-up`
      }, ce, N, ge, {
        locale: ke.lang,
        className: se({
          [`${H}-${fe}`]: fe,
          [`${H}-${ae}`]: le
        }, bl(H, eu(Ce, j), me), re, Y, z == null ? void 0 : z.className, x, Q, ue, S),
        style: Object.assign(Object.assign({}, z == null ? void 0 : z.style), C),
        prefixCls: H,
        getPopupContainer: v || L,
        generateConfig: e,
        components: IN,
        direction: T,
        disabled: we,
        dropdownClassName: se(re, Q, ue, S, R || P),
        popupStyle: Object.assign(Object.assign({}, h.popupStyle), {
          zIndex: qe
        }),
        allowClear: PN(A, F, /* @__PURE__ */ c.createElement(Ds, null))
      }))));
    });
    return u && (p.displayName = u), p;
  }
  const n = t(), r = t("week", "WeekPicker"), o = t("month", "MonthPicker"), i = t("year", "YearPicker"), a = t("time", "TimePicker"), s = t("quarter", "QuarterPicker");
  return {
    DatePicker: n,
    WeekPicker: r,
    MonthPicker: o,
    YearPicker: i,
    TimePicker: a,
    QuarterPicker: s
  };
}
function RN(e) {
  const {
    DatePicker: t,
    WeekPicker: n,
    MonthPicker: r,
    YearPicker: o,
    TimePicker: i,
    QuarterPicker: a
  } = eJ(e), s = QQ(e), l = t;
  return l.WeekPicker = n, l.MonthPicker = r, l.YearPicker = o, l.RangePicker = s, l.TimePicker = i, l.QuarterPicker = a, process.env.NODE_ENV !== "production" && (l.displayName = "DatePicker"), l;
}
const As = RN(RY);
function DN(e) {
  const t = lC(e.direction, e.placement);
  return t.overflow.adjustY = !1, t.overflow.adjustX = !1, Object.assign(Object.assign({}, e), {
    dropdownAlign: t
  });
}
const tJ = Zd(As, "picker", null, DN);
As._InternalPanelDoNotUseOrYouWillBeFired = tJ;
const nJ = Zd(As.RangePicker, "picker", null, DN);
As._InternalRangePanelDoNotUseOrYouWillBeFired = nJ;
As.generatePicker = RN;
var NE = /* @__PURE__ */ c.createContext(null), TN = /* @__PURE__ */ c.createContext({}), MN = function(t) {
  var n = t.prefixCls, r = t.className, o = t.style, i = t.children, a = t.containerRef, s = t.id, l = t.onMouseEnter, u = t.onMouseOver, f = t.onMouseLeave, p = t.onClick, h = t.onKeyDown, y = t.onKeyUp, b = {
    onMouseEnter: l,
    onMouseOver: u,
    onMouseLeave: f,
    onClick: p,
    onKeyDown: h,
    onKeyUp: y
  }, m = c.useContext(TN), v = m.panel, C = Ol(v, a);
  return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("div", Oe({
    id: s,
    className: se("".concat(n, "-content"), r),
    style: J({}, o),
    "aria-modal": "true",
    role: "dialog",
    ref: C
  }, b), i));
};
process.env.NODE_ENV !== "production" && (MN.displayName = "DrawerPanel");
function PE(e) {
  return typeof e == "string" && String(Number(e)) === e ? (mt(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function rJ(e) {
  mt(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), mt(Hr() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var IE = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function oJ(e, t) {
  var n, r, o, i = e.prefixCls, a = e.open, s = e.placement, l = e.inline, u = e.push, f = e.forceRender, p = e.autoFocus, h = e.keyboard, y = e.classNames, b = e.rootClassName, m = e.rootStyle, v = e.zIndex, C = e.className, x = e.id, S = e.style, E = e.motion, O = e.width, $ = e.height, _ = e.children, R = e.mask, P = e.maskClosable, I = e.maskMotion, j = e.maskClassName, F = e.maskStyle, A = e.afterOpenChange, M = e.onClose, N = e.onMouseEnter, D = e.onMouseOver, T = e.onMouseLeave, L = e.onClick, z = e.onKeyDown, H = e.onKeyUp, V = e.styles, Y = c.useRef(), Z = c.useRef(), oe = c.useRef();
  c.useImperativeHandle(t, function() {
    return Y.current;
  });
  var ee = function(Ce) {
    var Te = Ce.keyCode, Ee = Ce.shiftKey;
    switch (Te) {
      case Pe.TAB: {
        if (Te === Pe.TAB) {
          if (!Ee && document.activeElement === oe.current) {
            var Ge;
            (Ge = Z.current) === null || Ge === void 0 || Ge.focus({
              preventScroll: !0
            });
          } else if (Ee && document.activeElement === Z.current) {
            var ke;
            (ke = oe.current) === null || ke === void 0 || ke.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case Pe.ESC: {
        M && h && (Ce.stopPropagation(), M(Ce));
        break;
      }
    }
  };
  c.useEffect(function() {
    if (a && p) {
      var me;
      (me = Y.current) === null || me === void 0 || me.focus({
        preventScroll: !0
      });
    }
  }, [a]);
  var ae = c.useState(!1), le = de(ae, 2), ue = le[0], ie = le[1], re = c.useContext(NE), Q;
  u === !1 ? Q = {
    distance: 0
  } : u === !0 ? Q = {} : Q = u || {};
  var ce = (n = (r = (o = Q) === null || o === void 0 ? void 0 : o.distance) !== null && r !== void 0 ? r : re == null ? void 0 : re.pushDistance) !== null && n !== void 0 ? n : 180, ge = c.useMemo(function() {
    return {
      pushDistance: ce,
      push: function() {
        ie(!0);
      },
      pull: function() {
        ie(!1);
      }
    };
  }, [ce]);
  c.useEffect(function() {
    if (a) {
      var me;
      re == null || (me = re.push) === null || me === void 0 || me.call(re);
    } else {
      var Ce;
      re == null || (Ce = re.pull) === null || Ce === void 0 || Ce.call(re);
    }
  }, [a]), c.useEffect(function() {
    return function() {
      var me;
      re == null || (me = re.pull) === null || me === void 0 || me.call(re);
    };
  }, []);
  var G = R && /* @__PURE__ */ c.createElement(Bi, Oe({
    key: "mask"
  }, I, {
    visible: a
  }), function(me, Ce) {
    var Te = me.className, Ee = me.style;
    return /* @__PURE__ */ c.createElement("div", {
      className: se("".concat(i, "-mask"), Te, y == null ? void 0 : y.mask, j),
      style: J(J(J({}, Ee), F), V == null ? void 0 : V.mask),
      onClick: P && a ? M : void 0,
      ref: Ce
    });
  }), ne = typeof E == "function" ? E(s) : E, fe = {};
  if (ue && ce)
    switch (s) {
      case "top":
        fe.transform = "translateY(".concat(ce, "px)");
        break;
      case "bottom":
        fe.transform = "translateY(".concat(-ce, "px)");
        break;
      case "left":
        fe.transform = "translateX(".concat(ce, "px)");
        break;
      default:
        fe.transform = "translateX(".concat(-ce, "px)");
        break;
    }
  s === "left" || s === "right" ? fe.width = PE(O) : fe.height = PE($);
  var ye = {
    onMouseEnter: N,
    onMouseOver: D,
    onMouseLeave: T,
    onClick: L,
    onKeyDown: z,
    onKeyUp: H
  }, we = /* @__PURE__ */ c.createElement(Bi, Oe({
    key: "panel"
  }, ne, {
    visible: a,
    forceRender: f,
    onVisibleChanged: function(Ce) {
      A == null || A(Ce);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(i, "-content-wrapper-hidden")
  }), function(me, Ce) {
    var Te = me.className, Ee = me.style;
    return /* @__PURE__ */ c.createElement("div", Oe({
      className: se("".concat(i, "-content-wrapper"), y == null ? void 0 : y.wrapper, Te),
      style: J(J(J({}, fe), Ee), V == null ? void 0 : V.wrapper)
    }, ei(e, {
      data: !0
    })), /* @__PURE__ */ c.createElement(MN, Oe({
      id: x,
      containerRef: Ce,
      prefixCls: i,
      className: se(C, y == null ? void 0 : y.content),
      style: J(J({}, S), V == null ? void 0 : V.content)
    }, ye), _));
  }), he = J({}, m);
  return v && (he.zIndex = v), /* @__PURE__ */ c.createElement(NE.Provider, {
    value: ge
  }, /* @__PURE__ */ c.createElement("div", {
    className: se(i, "".concat(i, "-").concat(s), b, K(K({}, "".concat(i, "-open"), a), "".concat(i, "-inline"), l)),
    style: he,
    tabIndex: -1,
    ref: Y,
    onKeyDown: ee
  }, G, /* @__PURE__ */ c.createElement("div", {
    tabIndex: 0,
    ref: Z,
    style: IE,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), we, /* @__PURE__ */ c.createElement("div", {
    tabIndex: 0,
    ref: oe,
    style: IE,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var LN = /* @__PURE__ */ c.forwardRef(oJ);
process.env.NODE_ENV !== "production" && (LN.displayName = "DrawerPopup");
var AN = function(t) {
  var n = t.open, r = n === void 0 ? !1 : n, o = t.prefixCls, i = o === void 0 ? "rc-drawer" : o, a = t.placement, s = a === void 0 ? "right" : a, l = t.autoFocus, u = l === void 0 ? !0 : l, f = t.keyboard, p = f === void 0 ? !0 : f, h = t.width, y = h === void 0 ? 378 : h, b = t.mask, m = b === void 0 ? !0 : b, v = t.maskClosable, C = v === void 0 ? !0 : v, x = t.getContainer, S = t.forceRender, E = t.afterOpenChange, O = t.destroyOnClose, $ = t.onMouseEnter, _ = t.onMouseOver, R = t.onMouseLeave, P = t.onClick, I = t.onKeyDown, j = t.onKeyUp, F = t.panelRef, A = c.useState(!1), M = de(A, 2), N = M[0], D = M[1];
  process.env.NODE_ENV !== "production" && rJ(t);
  var T = c.useState(!1), L = de(T, 2), z = L[0], H = L[1];
  Nn(function() {
    H(!0);
  }, []);
  var V = z ? r : !1, Y = c.useRef(), Z = c.useRef();
  Nn(function() {
    V && (Z.current = document.activeElement);
  }, [V]);
  var oe = function(ie) {
    var re;
    if (D(ie), E == null || E(ie), !ie && Z.current && !((re = Y.current) !== null && re !== void 0 && re.contains(Z.current))) {
      var Q;
      (Q = Z.current) === null || Q === void 0 || Q.focus({
        preventScroll: !0
      });
    }
  }, ee = c.useMemo(function() {
    return {
      panel: F
    };
  }, [F]);
  if (!S && !N && !V && O)
    return null;
  var ae = {
    onMouseEnter: $,
    onMouseOver: _,
    onMouseLeave: R,
    onClick: P,
    onKeyDown: I,
    onKeyUp: j
  }, le = J(J({}, t), {}, {
    open: V,
    prefixCls: i,
    placement: s,
    autoFocus: u,
    keyboard: p,
    width: y,
    mask: m,
    maskClosable: C,
    inline: x === !1,
    afterOpenChange: oe,
    ref: Y
  }, ae);
  return /* @__PURE__ */ c.createElement(TN.Provider, {
    value: ee
  }, /* @__PURE__ */ c.createElement(Ig, {
    open: V || S || N,
    autoDestroy: !1,
    getContainer: x,
    autoLock: m && (V || N)
  }, /* @__PURE__ */ c.createElement(LN, le)));
};
process.env.NODE_ENV !== "production" && (AN.displayName = "Drawer");
const iJ = (e) => {
  var t, n;
  const {
    prefixCls: r,
    title: o,
    footer: i,
    extra: a,
    closeIcon: s,
    closable: l,
    onClose: u,
    headerStyle: f,
    bodyStyle: p,
    footerStyle: h,
    children: y,
    classNames: b,
    styles: m
  } = e, {
    drawer: v
  } = c.useContext(Ft), C = c.useCallback(($) => /* @__PURE__ */ c.createElement("button", {
    type: "button",
    onClick: u,
    "aria-label": "Close",
    className: `${r}-close`
  }, $), [u]), [x, S] = KV(l, s, C, void 0, !0), E = c.useMemo(() => {
    var $, _;
    return !o && !x ? null : /* @__PURE__ */ c.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, ($ = v == null ? void 0 : v.styles) === null || $ === void 0 ? void 0 : $.header), f), m == null ? void 0 : m.header),
      className: se(`${r}-header`, {
        [`${r}-header-close-only`]: x && !o && !a
      }, (_ = v == null ? void 0 : v.classNames) === null || _ === void 0 ? void 0 : _.header, b == null ? void 0 : b.header)
    }, /* @__PURE__ */ c.createElement("div", {
      className: `${r}-header-title`
    }, S, o && /* @__PURE__ */ c.createElement("div", {
      className: `${r}-title`
    }, o)), a && /* @__PURE__ */ c.createElement("div", {
      className: `${r}-extra`
    }, a));
  }, [x, S, a, f, r, o]), O = c.useMemo(() => {
    var $, _;
    if (!i)
      return null;
    const R = `${r}-footer`;
    return /* @__PURE__ */ c.createElement("div", {
      className: se(R, ($ = v == null ? void 0 : v.classNames) === null || $ === void 0 ? void 0 : $.footer, b == null ? void 0 : b.footer),
      style: Object.assign(Object.assign(Object.assign({}, (_ = v == null ? void 0 : v.styles) === null || _ === void 0 ? void 0 : _.footer), h), m == null ? void 0 : m.footer)
    }, i);
  }, [i, h, r]);
  return /* @__PURE__ */ c.createElement(c.Fragment, null, E, /* @__PURE__ */ c.createElement("div", {
    className: se(`${r}-body`, b == null ? void 0 : b.body, (t = v == null ? void 0 : v.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (n = v == null ? void 0 : v.styles) === null || n === void 0 ? void 0 : n.body), p), m == null ? void 0 : m.body)
  }, y), O);
}, jN = iJ, aJ = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, kN = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), FN = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, kN({
  opacity: e
}, {
  opacity: 1
})), sJ = (e, t) => [FN(0.7, t), kN({
  transform: aJ(e)
}, {
  transform: "none"
})], lJ = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: FN(0, n),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((r, o) => Object.assign(Object.assign({}, r), {
        [`&-${o}`]: sJ(o, n)
      }), {})
    }
  };
}, cJ = lJ, uJ = (e) => {
  const {
    componentCls: t,
    zIndexPopup: n,
    colorBgMask: r,
    colorBgElevated: o,
    motionDurationSlow: i,
    motionDurationMid: a,
    padding: s,
    paddingLG: l,
    fontSizeLG: u,
    lineHeightLG: f,
    lineWidth: p,
    lineType: h,
    colorSplit: y,
    marginSM: b,
    colorIcon: m,
    colorIconHover: v,
    colorText: C,
    fontWeightStrong: x,
    footerPaddingBlock: S,
    footerPaddingInline: E
  } = e, O = `${t}-content-wrapper`;
  return {
    [t]: {
      position: "fixed",
      inset: 0,
      zIndex: n,
      pointerEvents: "none",
      "&-pure": {
        position: "relative",
        background: o,
        display: "flex",
        flexDirection: "column",
        [`&${t}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${t}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${t}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${t}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${t}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: n,
        background: r,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [O]: {
        position: "absolute",
        zIndex: n,
        maxWidth: "100vw",
        transition: `all ${i}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${O}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${O}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${O}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${O}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${t}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: o,
        pointerEvents: "auto"
      },
      // Header
      [`${t}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${te(s)} ${te(l)}`,
        fontSize: u,
        lineHeight: f,
        borderBottom: `${te(p)} ${h} ${y}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${t}-extra`]: {
        flex: "none"
      },
      [`${t}-close`]: {
        display: "inline-block",
        marginInlineEnd: b,
        color: m,
        fontWeight: x,
        fontSize: u,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        outline: 0,
        cursor: "pointer",
        transition: `color ${a}`,
        textRendering: "auto",
        "&:focus, &:hover": {
          color: v,
          textDecoration: "none"
        }
      },
      [`${t}-title`]: {
        flex: 1,
        margin: 0,
        color: C,
        fontWeight: e.fontWeightStrong,
        fontSize: u,
        lineHeight: f
      },
      // Body
      [`${t}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: l,
        overflow: "auto"
      },
      // Footer
      [`${t}-footer`]: {
        flexShrink: 0,
        padding: `${te(S)} ${te(E)}`,
        borderTop: `${te(p)} ${h} ${y}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, dJ = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), BN = Gn("Drawer", (e) => {
  const t = Sn(e, {});
  return [uJ(t), cJ(t)];
}, dJ);
var HN = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const fJ = {
  distance: 180
}, cC = (e) => {
  var t, n, r, o, i, a, s, l, u, f, p;
  const {
    rootClassName: h,
    width: y,
    height: b,
    size: m = "default",
    mask: v = !0,
    push: C = fJ,
    open: x,
    afterOpenChange: S,
    onClose: E,
    prefixCls: O,
    getContainer: $,
    style: _,
    className: R,
    // Deprecated
    visible: P,
    afterVisibleChange: I,
    maskStyle: j,
    drawerStyle: F,
    contentWrapperStyle: A
  } = e, M = HN(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle"]), {
    getPopupContainer: N,
    getPrefixCls: D,
    direction: T,
    drawer: L
  } = c.useContext(Ft), z = D("drawer", O), [H, V, Y] = BN(z), Z = (
    // 有可能为 false，所以不能直接判断
    $ === void 0 && N ? () => N(document.body) : $
  ), oe = se({
    "no-mask": !v,
    [`${z}-rtl`]: T === "rtl"
  }, h, V, Y);
  if (process.env.NODE_ENV !== "production") {
    const ce = xn("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"]].forEach((ge) => {
      let [G, ne] = ge;
      ce.deprecated(!(G in e), G, ne);
    }), Z !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && process.env.NODE_ENV !== "production" && ce(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const ee = c.useMemo(() => y != null ? y : m === "large" ? 736 : 378, [y, m]), ae = c.useMemo(() => b != null ? b : m === "large" ? 736 : 378, [b, m]), le = {
    motionName: ml(z, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, ue = (ce) => ({
    motionName: ml(z, `panel-motion-${ce}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), ie = BW(), [re, Q] = Ts("Drawer", M.zIndex);
  return H(/* @__PURE__ */ c.createElement(vl, null, /* @__PURE__ */ c.createElement(F1, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ c.createElement(Eg.Provider, {
    value: Q
  }, /* @__PURE__ */ c.createElement(AN, Object.assign({
    prefixCls: z,
    onClose: E,
    maskMotion: le,
    motion: ue
  }, M, {
    classNames: {
      mask: se((n = M.classNames) === null || n === void 0 ? void 0 : n.mask, (r = L == null ? void 0 : L.classNames) === null || r === void 0 ? void 0 : r.mask),
      content: se((o = M.classNames) === null || o === void 0 ? void 0 : o.content, (i = L == null ? void 0 : L.classNames) === null || i === void 0 ? void 0 : i.content)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, (a = M.styles) === null || a === void 0 ? void 0 : a.mask), j), (s = L == null ? void 0 : L.styles) === null || s === void 0 ? void 0 : s.mask),
      content: Object.assign(Object.assign(Object.assign({}, (l = M.styles) === null || l === void 0 ? void 0 : l.content), F), (u = L == null ? void 0 : L.styles) === null || u === void 0 ? void 0 : u.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, (f = M.styles) === null || f === void 0 ? void 0 : f.wrapper), A), (p = L == null ? void 0 : L.styles) === null || p === void 0 ? void 0 : p.wrapper)
    },
    open: x != null ? x : P,
    mask: v,
    push: C,
    width: ee,
    height: ae,
    style: Object.assign(Object.assign({}, L == null ? void 0 : L.style), _),
    className: se(L == null ? void 0 : L.className, R),
    rootClassName: oe,
    getContainer: Z,
    afterOpenChange: S != null ? S : I,
    panelRef: ie,
    zIndex: re
  }), /* @__PURE__ */ c.createElement(jN, Object.assign({
    prefixCls: z
  }, M, {
    onClose: E
  })))))));
}, pJ = (e) => {
  const {
    prefixCls: t,
    style: n,
    className: r,
    placement: o = "right"
  } = e, i = HN(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: a
  } = c.useContext(Ft), s = a("drawer", t), [l, u, f] = BN(s), p = se(s, `${s}-pure`, `${s}-${o}`, u, f, r);
  return l(/* @__PURE__ */ c.createElement("div", {
    className: p,
    style: n
  }, /* @__PURE__ */ c.createElement(jN, Object.assign({
    prefixCls: s
  }, i))));
};
cC._InternalPanelDoNotUseOrYouWillBeFired = pJ;
process.env.NODE_ENV !== "production" && (cC.displayName = "Drawer");
const uC = cC;
function zh(e) {
  return ["small", "middle", "large"].includes(e);
}
function RE(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const zN = /* @__PURE__ */ be.createContext({
  latestIndex: 0
}), hJ = zN.Provider, gJ = (e) => {
  let {
    className: t,
    index: n,
    children: r,
    split: o,
    style: i
  } = e;
  const {
    latestIndex: a
  } = c.useContext(zN);
  return r == null ? null : /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("div", {
    className: t,
    style: i
  }, r), n < a && o && /* @__PURE__ */ c.createElement("span", {
    className: `${t}-split`
  }, o));
}, mJ = gJ;
var vJ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const VN = /* @__PURE__ */ c.forwardRef((e, t) => {
  var n, r;
  const {
    getPrefixCls: o,
    space: i,
    direction: a
  } = c.useContext(Ft), {
    size: s = (i == null ? void 0 : i.size) || "small",
    align: l,
    className: u,
    rootClassName: f,
    children: p,
    direction: h = "horizontal",
    prefixCls: y,
    split: b,
    style: m,
    wrap: v = !1,
    classNames: C,
    styles: x
  } = e, S = vJ(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [E, O] = Array.isArray(s) ? s : [s, s], $ = zh(O), _ = zh(E), R = RE(O), P = RE(E), I = Rr(p, {
    keepEmpty: !0
  }), j = l === void 0 && h === "horizontal" ? "center" : l, F = o("space", y), [A, M, N] = R5(F), D = se(F, i == null ? void 0 : i.className, M, `${F}-${h}`, {
    [`${F}-rtl`]: a === "rtl",
    [`${F}-align-${j}`]: j,
    [`${F}-gap-row-${O}`]: $,
    [`${F}-gap-col-${E}`]: _
  }, u, f, N), T = se(`${F}-item`, (n = C == null ? void 0 : C.item) !== null && n !== void 0 ? n : (r = i == null ? void 0 : i.classNames) === null || r === void 0 ? void 0 : r.item);
  let L = 0;
  const z = I.map((Y, Z) => {
    var oe, ee;
    Y != null && (L = Z);
    const ae = Y && Y.key || `${T}-${Z}`;
    return /* @__PURE__ */ c.createElement(mJ, {
      className: T,
      key: ae,
      index: Z,
      split: b,
      style: (oe = x == null ? void 0 : x.item) !== null && oe !== void 0 ? oe : (ee = i == null ? void 0 : i.styles) === null || ee === void 0 ? void 0 : ee.item
    }, Y);
  }), H = c.useMemo(() => ({
    latestIndex: L
  }), [L]);
  if (I.length === 0)
    return null;
  const V = {};
  return v && (V.flexWrap = "wrap"), !_ && P && (V.columnGap = E), !$ && R && (V.rowGap = O), A(/* @__PURE__ */ c.createElement("div", Object.assign({
    ref: t,
    className: D,
    style: Object.assign(Object.assign(Object.assign({}, V), i == null ? void 0 : i.style), m)
  }, S), /* @__PURE__ */ c.createElement(hJ, {
    value: H
  }, z)));
});
process.env.NODE_ENV !== "production" && (VN.displayName = "Space");
const WN = VN;
WN.Compact = eV;
const yJ = WN;
var bJ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const KN = (e) => {
  const {
    getPopupContainer: t,
    getPrefixCls: n,
    direction: r
  } = c.useContext(Ft), {
    prefixCls: o,
    type: i = "default",
    danger: a,
    disabled: s,
    loading: l,
    onClick: u,
    htmlType: f,
    children: p,
    className: h,
    menu: y,
    arrow: b,
    autoFocus: m,
    overlay: v,
    trigger: C,
    align: x,
    open: S,
    onOpenChange: E,
    placement: O,
    getPopupContainer: $,
    href: _,
    icon: R = /* @__PURE__ */ c.createElement(d_, null),
    title: P,
    buttonsRender: I = (ue) => ue,
    mouseEnterDelay: j,
    mouseLeaveDelay: F,
    overlayClassName: A,
    overlayStyle: M,
    destroyPopupOnHide: N,
    dropdownRender: D
  } = e, T = bJ(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "dropdownRender"]), L = n("dropdown", o), z = `${L}-button`, H = {
    menu: y,
    arrow: b,
    autoFocus: m,
    align: x,
    disabled: s,
    trigger: s ? [] : C,
    onOpenChange: E,
    getPopupContainer: $ || t,
    mouseEnterDelay: j,
    mouseLeaveDelay: F,
    overlayClassName: A,
    overlayStyle: M,
    destroyPopupOnHide: N,
    dropdownRender: D
  }, {
    compactSize: V,
    compactItemClassnames: Y
  } = Ms(L, r), Z = se(z, Y, h);
  "overlay" in e && (H.overlay = v), "open" in e && (H.open = S), "placement" in e ? H.placement = O : H.placement = r === "rtl" ? "bottomLeft" : "bottomRight";
  const oe = /* @__PURE__ */ c.createElement(Io, {
    type: i,
    danger: a,
    disabled: s,
    loading: l,
    onClick: u,
    htmlType: f,
    href: _,
    title: P
  }, p), ee = /* @__PURE__ */ c.createElement(Io, {
    type: i,
    danger: a,
    icon: R
  }), [ae, le] = I([oe, ee]);
  return /* @__PURE__ */ c.createElement(yJ.Compact, Object.assign({
    className: Z,
    size: V,
    block: !0
  }, T), ae, /* @__PURE__ */ c.createElement(v_, Object.assign({}, H), le));
};
KN.__ANT_BUTTON = !0;
const CJ = KN, UN = v_;
UN.Button = CJ;
const GN = UN, qN = ["wrap", "nowrap", "wrap-reverse"], YN = ["flex-start", "flex-end", "start", "end", "center", "space-between", "space-around", "space-evenly", "stretch", "normal", "left", "right"], XN = ["center", "start", "end", "flex-start", "flex-end", "self-start", "self-end", "baseline", "normal", "stretch"], xJ = (e, t) => {
  const n = {};
  return qN.forEach((r) => {
    n[`${e}-wrap-${r}`] = t.wrap === r;
  }), n;
}, SJ = (e, t) => {
  const n = {};
  return XN.forEach((r) => {
    n[`${e}-align-${r}`] = t.align === r;
  }), n[`${e}-align-stretch`] = !t.align && !!t.vertical, n;
}, wJ = (e, t) => {
  const n = {};
  return YN.forEach((r) => {
    n[`${e}-justify-${r}`] = t.justify === r;
  }), n;
};
function EJ(e, t) {
  return se(Object.assign(Object.assign(Object.assign({}, xJ(e, t)), SJ(e, t)), wJ(e, t)));
}
const $J = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      display: "flex",
      "&-vertical": {
        flexDirection: "column"
      },
      "&-rtl": {
        direction: "rtl"
      },
      "&:empty": {
        display: "none"
      }
    }
  };
}, OJ = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-small": {
        gap: e.flexGapSM
      },
      "&-gap-middle": {
        gap: e.flexGap
      },
      "&-gap-large": {
        gap: e.flexGapLG
      }
    }
  };
}, _J = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return qN.forEach((r) => {
    n[`${t}-wrap-${r}`] = {
      flexWrap: r
    };
  }), n;
}, NJ = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return XN.forEach((r) => {
    n[`${t}-align-${r}`] = {
      alignItems: r
    };
  }), n;
}, PJ = (e) => {
  const {
    componentCls: t
  } = e, n = {};
  return YN.forEach((r) => {
    n[`${t}-justify-${r}`] = {
      justifyContent: r
    };
  }), n;
}, IJ = () => ({}), RJ = Gn("Flex", (e) => {
  const {
    paddingXS: t,
    padding: n,
    paddingLG: r
  } = e, o = Sn(e, {
    flexGapSM: t,
    flexGap: n,
    flexGapLG: r
  });
  return [$J(o), OJ(o), _J(o), NJ(o), PJ(o)];
}, IJ, {
  // Flex component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/46403
  resetStyle: !1
});
var DJ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const ZN = /* @__PURE__ */ be.forwardRef((e, t) => {
  const {
    prefixCls: n,
    rootClassName: r,
    className: o,
    style: i,
    flex: a,
    gap: s,
    children: l,
    vertical: u = !1,
    component: f = "div"
  } = e, p = DJ(e, ["prefixCls", "rootClassName", "className", "style", "flex", "gap", "children", "vertical", "component"]), {
    flex: h,
    direction: y,
    getPrefixCls: b
  } = be.useContext(Ft), m = b("flex", n), [v, C, x] = RJ(m), S = u != null ? u : h == null ? void 0 : h.vertical, E = se(o, r, h == null ? void 0 : h.className, m, C, x, EJ(m, e), {
    [`${m}-rtl`]: y === "rtl",
    [`${m}-gap-${s}`]: zh(s),
    [`${m}-vertical`]: S
  }), O = Object.assign(Object.assign({}, h == null ? void 0 : h.style), i);
  return a && (O.flex = a), s && !zh(s) && (O.gap = s), v(/* @__PURE__ */ be.createElement(f, Object.assign({
    ref: t,
    className: E,
    style: O
  }, dr(p, ["justify", "wrap", "align"])), l));
});
process.env.NODE_ENV !== "production" && (ZN.displayName = "Flex");
const zc = ZN;
function Vh(e) {
  const [t, n] = c.useState(e);
  return c.useEffect(() => {
    const r = setTimeout(() => {
      n(e);
    }, e.length ? 0 : 10);
    return () => {
      clearTimeout(r);
    };
  }, [e]), t;
}
const TJ = (e) => {
  const {
    componentCls: t
  } = e, n = `${t}-show-help`, r = `${t}-show-help-item`;
  return {
    [n]: {
      // Explain holder
      transition: `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [r]: {
        overflow: "hidden",
        transition: `height ${e.motionDurationSlow} ${e.motionEaseInOut},
                     opacity ${e.motionDurationSlow} ${e.motionEaseInOut},
                     transform ${e.motionDurationSlow} ${e.motionEaseInOut} !important`,
        [`&${r}-appear, &${r}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${r}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, MJ = TJ, LJ = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.marginLG,
    padding: 0,
    color: e.colorTextDescription,
    fontSize: e.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${te(e.controlOutlineWidth)} ${e.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.colorText,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight
  }
}), DE = (e, t) => {
  const {
    formItemCls: n
  } = e;
  return {
    [n]: {
      [`${n}-label > label`]: {
        height: t
      },
      [`${n}-control-input`]: {
        minHeight: t
      }
    }
  };
}, AJ = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [e.componentCls]: Object.assign(Object.assign(Object.assign({}, Qn(e)), LJ(e)), {
      [`${t}-text`]: {
        display: "inline-block",
        paddingInlineEnd: e.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, DE(e, e.controlHeightSM)),
      "&-large": Object.assign({}, DE(e, e.controlHeightLG))
    })
  };
}, jJ = (e) => {
  const {
    formItemCls: t,
    iconCls: n,
    componentCls: r,
    rootPrefixCls: o,
    labelRequiredMarkColor: i,
    labelColor: a,
    labelFontSize: s,
    labelHeight: l,
    labelColonMarginInlineStart: u,
    labelColonMarginInlineEnd: f,
    itemMarginBottom: p
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Qn(e)), {
      marginBottom: p,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden.${o}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${t}-split`]: {
          color: e.colorError
        }
      },
      "&-has-error": {
        [`${t}-split`]: {
          color: e.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${t}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: e.lineHeight,
          whiteSpace: "unset"
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: l,
          color: a,
          fontSize: s,
          [`> ${n}`]: {
            fontSize: e.fontSize,
            verticalAlign: "top"
          },
          // Required mark
          [`&${t}-required:not(${t}-required-mark-optional)::before`]: {
            display: "inline-block",
            marginInlineEnd: e.marginXXS,
            color: i,
            fontSize: e.fontSize,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
            content: '"*"',
            [`${r}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-optional`]: {
            display: "inline-block",
            marginInlineStart: e.marginXXS,
            color: e.colorTextDescription,
            [`${r}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-tooltip`]: {
            color: e.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: e.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: u,
            marginInlineEnd: f
          },
          [`&${t}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${t}-control`]: {
        "--ant-display": "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${o}-col-'"]):not([class*="' ${o}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [t]: {
        "&-explain, &-extra": {
          clear: "both",
          color: e.colorTextDescription,
          fontSize: e.fontSize,
          lineHeight: e.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: e.controlHeightSM,
          transition: `color ${e.motionDurationMid} ${e.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: e.colorError
          },
          "&-warning": {
            color: e.colorWarning
          }
        }
      },
      [`&-with-help ${t}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${t}-feedback-icon`]: {
        fontSize: e.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: Pb,
        animationDuration: e.motionDurationMid,
        animationTimingFunction: e.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: e.colorSuccess
        },
        "&-error": {
          color: e.colorError
        },
        "&-warning": {
          color: e.colorWarning
        },
        "&-validating": {
          color: e.colorPrimary
        }
      }
    })
  };
}, kJ = (e) => {
  const {
    componentCls: t,
    formItemCls: n
  } = e;
  return {
    [`${t}-horizontal`]: {
      [`${n}-label`]: {
        flexGrow: 0
      },
      [`${n}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${n}-label[class$='-24'], ${n}-label[class*='-24 ']`]: {
        [`& + ${n}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, FJ = (e) => {
  const {
    componentCls: t,
    formItemCls: n
  } = e;
  return {
    [`${t}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [n]: {
        flex: "none",
        marginInlineEnd: e.margin,
        marginBottom: 0,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${n}-label,
        > ${n}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${n}-label`]: {
          flex: "none"
        },
        [`${t}-text`]: {
          display: "inline-block"
        },
        [`${n}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, fc = (e) => ({
  padding: e.verticalLabelPadding,
  margin: e.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), BJ = (e) => {
  const {
    componentCls: t,
    formItemCls: n,
    rootPrefixCls: r
  } = e;
  return {
    [`${n} ${n}-label`]: fc(e),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${t}:not(${t}-inline)`]: {
      [n]: {
        flexWrap: "wrap",
        [`${n}-label, ${n}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${r}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, HJ = (e) => {
  const {
    componentCls: t,
    formItemCls: n,
    rootPrefixCls: r
  } = e;
  return {
    [`${t}-vertical`]: {
      [n]: {
        "&-row": {
          flexDirection: "column"
        },
        "&-label > label": {
          height: "auto"
        },
        [`${t}-item-control`]: {
          width: "100%"
        }
      }
    },
    [`${t}-vertical ${n}-label,
      .${r}-col-24${n}-label,
      .${r}-col-xl-24${n}-label`]: fc(e),
    [`@media (max-width: ${te(e.screenXSMax)})`]: [BJ(e), {
      [t]: {
        [`.${r}-col-xs-24${n}-label`]: fc(e)
      }
    }],
    [`@media (max-width: ${te(e.screenSMMax)})`]: {
      [t]: {
        [`.${r}-col-sm-24${n}-label`]: fc(e)
      }
    },
    [`@media (max-width: ${te(e.screenMDMax)})`]: {
      [t]: {
        [`.${r}-col-md-24${n}-label`]: fc(e)
      }
    },
    [`@media (max-width: ${te(e.screenLGMax)})`]: {
      [t]: {
        [`.${r}-col-lg-24${n}-label`]: fc(e)
      }
    }
  };
}, zJ = (e) => ({
  labelRequiredMarkColor: e.colorError,
  labelColor: e.colorTextHeading,
  labelFontSize: e.fontSize,
  labelHeight: e.controlHeight,
  labelColonMarginInlineStart: e.marginXXS / 2,
  labelColonMarginInlineEnd: e.marginXS,
  itemMarginBottom: e.marginLG,
  verticalLabelPadding: `0 0 ${e.paddingXS}px`,
  verticalLabelMargin: 0
}), QN = (e, t) => Sn(e, {
  formItemCls: `${e.componentCls}-item`,
  rootPrefixCls: t
}), dC = Gn("Form", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = QN(e, n);
  return [AJ(r), jJ(r), MJ(r), kJ(r), FJ(r), HJ(r), Ag(r), Pb];
}, zJ, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
}), TE = [];
function s0(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  return {
    key: typeof e == "string" ? e : `${t}-${r}`,
    error: e,
    errorStatus: n
  };
}
const VJ = (e) => {
  let {
    help: t,
    helpStatus: n,
    errors: r = TE,
    warnings: o = TE,
    className: i,
    fieldId: a,
    onVisibleChanged: s
  } = e;
  const {
    prefixCls: l
  } = c.useContext(_b), u = `${l}-item-explain`, f = Ar(l), [p, h, y] = dC(l, f), b = mr(() => xd(l), [l]), m = Vh(r), v = Vh(o), C = c.useMemo(() => t != null ? [s0(t, "help", n)] : [].concat(We(m.map((S, E) => s0(S, "error", "error", E))), We(v.map((S, E) => s0(S, "warning", "warning", E)))), [t, n, m, v]), x = {};
  return a && (x.id = `${a}_help`), p(/* @__PURE__ */ c.createElement(Bi, {
    motionDeadline: b.motionDeadline,
    motionName: `${l}-show-help`,
    visible: !!C.length,
    onVisibleChanged: s
  }, (S) => {
    const {
      className: E,
      style: O
    } = S;
    return /* @__PURE__ */ c.createElement("div", Object.assign({}, x, {
      className: se(u, E, y, f, i, h),
      style: O,
      role: "alert"
    }), /* @__PURE__ */ c.createElement(n5, Object.assign({
      keys: C
    }, xd(l), {
      motionName: `${l}-show-help-item`,
      component: !1
    }), ($) => {
      const {
        key: _,
        error: R,
        errorStatus: P,
        className: I,
        style: j
      } = $;
      return /* @__PURE__ */ c.createElement("div", {
        key: _,
        className: se(I, {
          [`${u}-${P}`]: P
        }),
        style: j
      }, R);
    }));
  }));
}, JN = VJ, WJ = ["parentNode"], KJ = "form_item";
function ud(e) {
  return e === void 0 || e === !1 ? [] : Array.isArray(e) ? e : [e];
}
function e8(e, t) {
  if (!e.length)
    return;
  const n = e.join("_");
  return t ? `${t}_${n}` : WJ.includes(n) ? `${KJ}_${n}` : n;
}
function t8(e, t, n, r, o, i) {
  let a = r;
  return i !== void 0 ? a = i : n.validating ? a = "validating" : e.length ? a = "error" : t.length ? a = "warning" : (n.touched || o && n.validated) && (a = "success"), a;
}
function ME(e) {
  return ud(e).join("_");
}
function n8(e) {
  const [t] = Ob(), n = c.useRef({}), r = c.useMemo(() => e != null ? e : Object.assign(Object.assign({}, t), {
    __INTERNAL__: {
      itemRef: (o) => (i) => {
        const a = ME(o);
        i ? n.current[a] = i : delete n.current[a];
      }
    },
    scrollToField: function(o) {
      let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const a = ud(o), s = e8(a, r.__INTERNAL__.name), l = s ? document.getElementById(s) : null;
      l && nz(l, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, i));
    },
    getFieldInstance: (o) => {
      const i = ME(o);
      return n.current[i];
    }
  }), [e, t]);
  return [r];
}
const Np = {};
function UJ(e) {
  let {
    name: t
  } = e;
  const n = xn("Form");
  kt(() => {
    if (t)
      return Np[t] = (Np[t] || 0) + 1, process.env.NODE_ENV !== "production" && n(Np[t] <= 1, "usage", "There exist multiple Form with same `name`."), () => {
        Np[t] -= 1;
      };
  }, [t]);
}
var GJ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const qJ = (e, t) => {
  const n = c.useContext(Ki), {
    getPrefixCls: r,
    direction: o,
    form: i
  } = c.useContext(Ft), {
    prefixCls: a,
    className: s,
    rootClassName: l,
    size: u,
    disabled: f = n,
    form: p,
    colon: h,
    labelAlign: y,
    labelWrap: b,
    labelCol: m,
    wrapperCol: v,
    hideRequiredMark: C,
    layout: x = "horizontal",
    scrollToFirstError: S,
    requiredMark: E,
    onFinishFailed: O,
    name: $,
    style: _,
    feedbackIcons: R,
    variant: P
  } = e, I = GJ(e, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]), j = Co(u), F = c.useContext(wO);
  process.env.NODE_ENV !== "production" && UJ(e);
  const A = mr(() => E !== void 0 ? E : C ? !1 : i && i.requiredMark !== void 0 ? i.requiredMark : !0, [C, E, i]), M = h != null ? h : i == null ? void 0 : i.colon, N = r("form", a), D = Ar(N), [T, L, z] = dC(N, D), H = se(N, `${N}-${x}`, {
    [`${N}-hide-required-mark`]: A === !1,
    [`${N}-rtl`]: o === "rtl",
    [`${N}-${j}`]: j
  }, z, D, L, i == null ? void 0 : i.className, s, l), [V] = n8(p), {
    __INTERNAL__: Y
  } = V;
  Y.name = $;
  const Z = mr(() => ({
    name: $,
    labelAlign: y,
    labelCol: m,
    labelWrap: b,
    wrapperCol: v,
    vertical: x === "vertical",
    colon: M,
    requiredMark: A,
    itemRef: Y.itemRef,
    form: V,
    feedbackIcons: R
  }), [$, y, m, v, x, M, A, V, R]);
  c.useImperativeHandle(t, () => V);
  const oe = (ae, le) => {
    if (ae) {
      let ue = {
        block: "nearest"
      };
      typeof ae == "object" && (ue = ae), V.scrollToField(le, ue);
    }
  }, ee = (ae) => {
    if (O == null || O(ae), ae.errorFields.length) {
      const le = ae.errorFields[0].name;
      if (S !== void 0) {
        oe(S, le);
        return;
      }
      i && i.scrollToFirstError !== void 0 && oe(i.scrollToFirstError, le);
    }
  };
  return T(/* @__PURE__ */ c.createElement(Q5.Provider, {
    value: P
  }, /* @__PURE__ */ c.createElement(LO, {
    disabled: f
  }, /* @__PURE__ */ c.createElement(Kd.Provider, {
    value: j
  }, /* @__PURE__ */ c.createElement(Z5, {
    // This is not list in API, we pass with spread
    validateMessages: F
  }, /* @__PURE__ */ c.createElement(Ka.Provider, {
    value: Z
  }, /* @__PURE__ */ c.createElement(Jc, Object.assign({
    id: $
  }, I, {
    name: $,
    onFinishFailed: ee,
    form: V,
    style: Object.assign(Object.assign({}, i == null ? void 0 : i.style), _),
    className: H
  }))))))));
}, r8 = /* @__PURE__ */ c.forwardRef(qJ);
process.env.NODE_ENV !== "production" && (r8.displayName = "Form");
function YJ(e) {
  if (typeof e == "function")
    return e;
  const t = Rr(e);
  return t.length <= 1 ? t[0] : t;
}
const o8 = () => {
  const {
    status: e,
    errors: t = [],
    warnings: n = []
  } = Cn(uo);
  if (process.env.NODE_ENV !== "production") {
    const r = xn("Form.Item");
    process.env.NODE_ENV !== "production" && r(e !== void 0, "usage", "Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus");
  }
  return {
    status: e,
    errors: t,
    warnings: n
  };
};
o8.Context = uo;
const XJ = o8;
function ZJ(e) {
  const [t, n] = c.useState(e), r = _t(null), o = _t([]), i = _t(!1);
  c.useEffect(() => (i.current = !1, () => {
    i.current = !0, Pn.cancel(r.current), r.current = null;
  }), []);
  function a(s) {
    i.current || (r.current === null && (o.current = [], r.current = Pn(() => {
      r.current = null, n((l) => {
        let u = l;
        return o.current.forEach((f) => {
          u = f(u);
        }), u;
      });
    })), o.current.push(s));
  }
  return [t, a];
}
function QJ() {
  const {
    itemRef: e
  } = c.useContext(Ka), t = c.useRef({});
  function n(r, o) {
    const i = o && typeof o == "object" && o.ref, a = r.join("_");
    return (t.current.name !== a || t.current.originRef !== i) && (t.current.name = a, t.current.originRef = i, t.current.ref = Do(e(r), i)), t.current.ref;
  }
  return n;
}
const JJ = (e) => {
  const {
    formItemCls: t
  } = e;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${t}-control`]: {
        display: "flex"
      }
    }
  };
}, eee = gb(["Form", "item-item"], (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = QN(e, n);
  return [JJ(r)];
}), tee = (e) => {
  const {
    prefixCls: t,
    status: n,
    wrapperCol: r,
    children: o,
    errors: i,
    warnings: a,
    _internalItemRender: s,
    extra: l,
    help: u,
    fieldId: f,
    marginBottom: p,
    onErrorVisibleChanged: h
  } = e, y = `${t}-item`, b = c.useContext(Ka), m = r || b.wrapperCol || {}, v = se(`${y}-control`, m.className), C = c.useMemo(() => Object.assign({}, b), [b]);
  delete C.labelCol, delete C.wrapperCol;
  const x = /* @__PURE__ */ c.createElement("div", {
    className: `${y}-control-input`
  }, /* @__PURE__ */ c.createElement("div", {
    className: `${y}-control-input-content`
  }, o)), S = c.useMemo(() => ({
    prefixCls: t,
    status: n
  }), [t, n]), E = p !== null || i.length || a.length ? /* @__PURE__ */ c.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "nowrap"
    }
  }, /* @__PURE__ */ c.createElement(_b.Provider, {
    value: S
  }, /* @__PURE__ */ c.createElement(JN, {
    fieldId: f,
    errors: i,
    warnings: a,
    help: u,
    helpStatus: n,
    className: `${y}-explain-connected`,
    onVisibleChanged: h
  })), !!p && /* @__PURE__ */ c.createElement("div", {
    style: {
      width: 0,
      height: p
    }
  })) : null, O = {};
  f && (O.id = `${f}_extra`);
  const $ = l ? /* @__PURE__ */ c.createElement("div", Object.assign({}, O, {
    className: `${y}-extra`
  }), l) : null, _ = s && s.mark === "pro_table_render" && s.render ? s.render(e, {
    input: x,
    errorList: E,
    extra: $
  }) : /* @__PURE__ */ c.createElement(c.Fragment, null, x, E, $);
  return /* @__PURE__ */ c.createElement(Ka.Provider, {
    value: C
  }, /* @__PURE__ */ c.createElement(ds, Object.assign({}, m, {
    className: v
  }), _), /* @__PURE__ */ c.createElement(eee, {
    prefixCls: t
  }));
}, nee = tee;
var ree = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
const oee = ree;
var i8 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: oee
  }));
};
process.env.NODE_ENV !== "production" && (i8.displayName = "QuestionCircleOutlined");
const iee = /* @__PURE__ */ c.forwardRef(i8);
var aee = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function see(e) {
  return e ? typeof e == "object" && !/* @__PURE__ */ c.isValidElement(e) ? e : {
    title: e
  } : null;
}
const lee = (e) => {
  let {
    prefixCls: t,
    label: n,
    htmlFor: r,
    labelCol: o,
    labelAlign: i,
    colon: a,
    required: s,
    requiredMark: l,
    tooltip: u
  } = e;
  var f;
  const [p] = _l("Form"), {
    vertical: h,
    labelAlign: y,
    labelCol: b,
    labelWrap: m,
    colon: v
  } = c.useContext(Ka);
  if (!n)
    return null;
  const C = o || b || {}, x = i || y, S = `${t}-item-label`, E = se(S, x === "left" && `${S}-left`, C.className, {
    [`${S}-wrap`]: !!m
  });
  let O = n;
  const $ = a === !0 || v !== !1 && a !== !1;
  $ && !h && typeof n == "string" && n.trim() !== "" && (O = n.replace(/[:|：]\s*$/, ""));
  const R = see(u);
  if (R) {
    const {
      icon: F = /* @__PURE__ */ c.createElement(iee, null)
    } = R, A = aee(R, ["icon"]), M = /* @__PURE__ */ c.createElement(Bo, Object.assign({}, A), /* @__PURE__ */ c.cloneElement(F, {
      className: `${t}-item-tooltip`,
      title: "",
      onClick: (N) => {
        N.preventDefault();
      },
      tabIndex: null
    }));
    O = /* @__PURE__ */ c.createElement(c.Fragment, null, O, M);
  }
  const P = l === "optional", I = typeof l == "function";
  I ? O = l(O, {
    required: !!s
  }) : P && !s && (O = /* @__PURE__ */ c.createElement(c.Fragment, null, O, /* @__PURE__ */ c.createElement("span", {
    className: `${t}-item-optional`,
    title: ""
  }, (p == null ? void 0 : p.optional) || ((f = za.Form) === null || f === void 0 ? void 0 : f.optional))));
  const j = se({
    [`${t}-item-required`]: s,
    [`${t}-item-required-mark-optional`]: P || I,
    [`${t}-item-no-colon`]: !$
  });
  return /* @__PURE__ */ c.createElement(ds, Object.assign({}, C, {
    className: E
  }), /* @__PURE__ */ c.createElement("label", {
    htmlFor: r,
    className: j,
    title: typeof n == "string" ? n : ""
  }, O));
}, cee = lee, uee = {
  success: bb,
  warning: wg,
  error: Ds,
  validating: qd
};
function a8(e) {
  let {
    children: t,
    errors: n,
    warnings: r,
    hasFeedback: o,
    validateStatus: i,
    prefixCls: a,
    meta: s,
    noStyle: l
  } = e;
  const u = `${a}-item`, {
    feedbackIcons: f
  } = c.useContext(Ka), p = t8(n, r, s, null, !!o, i), {
    isFormItemInput: h,
    status: y,
    hasFeedback: b,
    feedbackIcon: m
  } = c.useContext(uo), v = c.useMemo(() => {
    var C;
    let x;
    if (o) {
      const E = o !== !0 && o.icons || f, O = p && ((C = E == null ? void 0 : E({
        status: p,
        errors: n,
        warnings: r
      })) === null || C === void 0 ? void 0 : C[p]), $ = p && uee[p];
      x = O !== !1 && $ ? /* @__PURE__ */ c.createElement("span", {
        className: se(`${u}-feedback-icon`, `${u}-feedback-icon-${p}`)
      }, O || /* @__PURE__ */ c.createElement($, null)) : null;
    }
    const S = {
      status: p || "",
      errors: n,
      warnings: r,
      hasFeedback: !!o,
      feedbackIcon: x,
      isFormItemInput: !0
    };
    return l && (S.status = (p != null ? p : y) || "", S.isFormItemInput = h, S.hasFeedback = !!(o != null ? o : b), S.feedbackIcon = o !== void 0 ? S.feedbackIcon : m), S;
  }, [p, o, l, h, y]);
  return /* @__PURE__ */ c.createElement(uo.Provider, {
    value: v
  }, t);
}
var dee = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function fee(e) {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: o,
    help: i,
    errors: a,
    warnings: s,
    validateStatus: l,
    meta: u,
    hasFeedback: f,
    hidden: p,
    children: h,
    fieldId: y,
    required: b,
    isRequired: m,
    onSubItemMetaChange: v
  } = e, C = dee(e, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange"]), x = `${t}-item`, {
    requiredMark: S
  } = c.useContext(Ka), E = c.useRef(null), O = Vh(a), $ = Vh(s), _ = i != null, R = !!(_ || a.length || s.length), P = !!E.current && Qc(E.current), [I, j] = c.useState(null);
  Nn(() => {
    if (R && E.current) {
      const D = getComputedStyle(E.current);
      j(parseInt(D.marginBottom, 10));
    }
  }, [R, P]);
  const F = (D) => {
    D || j(null);
  }, M = function() {
    let D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const T = D ? O : u.errors, L = D ? $ : u.warnings;
    return t8(T, L, u, "", !!f, l);
  }(), N = se(x, n, r, {
    [`${x}-with-help`]: _ || O.length || $.length,
    // Status
    [`${x}-has-feedback`]: M && f,
    [`${x}-has-success`]: M === "success",
    [`${x}-has-warning`]: M === "warning",
    [`${x}-has-error`]: M === "error",
    [`${x}-is-validating`]: M === "validating",
    [`${x}-hidden`]: p
  });
  return /* @__PURE__ */ c.createElement("div", {
    className: N,
    style: o,
    ref: E
  }, /* @__PURE__ */ c.createElement(oh, Object.assign({
    className: `${x}-row`
  }, dr(C, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ c.createElement(cee, Object.assign({
    htmlFor: y
  }, e, {
    requiredMark: S,
    required: b != null ? b : m,
    prefixCls: t
  })), /* @__PURE__ */ c.createElement(nee, Object.assign({}, e, u, {
    errors: O,
    warnings: $,
    prefixCls: t,
    status: M,
    help: i,
    marginBottom: I,
    onErrorVisibleChanged: F
  }), /* @__PURE__ */ c.createElement(X5.Provider, {
    value: v
  }, /* @__PURE__ */ c.createElement(a8, {
    prefixCls: t,
    meta: u,
    errors: u.errors,
    warnings: u.warnings,
    hasFeedback: f,
    // Already calculated
    validateStatus: M
  }, h)))), !!I && /* @__PURE__ */ c.createElement("div", {
    className: `${x}-margin-offset`,
    style: {
      marginBottom: -I
    }
  }));
}
const pee = "__SPLIT__";
function hee(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every((o) => {
    const i = e[o], a = t[o];
    return i === a || typeof i == "function" || typeof a == "function";
  });
}
const gee = /* @__PURE__ */ c.memo((e) => {
  let {
    children: t
  } = e;
  return t;
}, (e, t) => hee(e.control, t.control) && e.update === t.update && e.childProps.length === t.childProps.length && e.childProps.every((n, r) => n === t.childProps[r]));
function LE() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function mee(e) {
  const {
    name: t,
    noStyle: n,
    className: r,
    dependencies: o,
    prefixCls: i,
    shouldUpdate: a,
    rules: s,
    children: l,
    required: u,
    label: f,
    messageVariables: p,
    trigger: h = "onChange",
    validateTrigger: y,
    hidden: b,
    help: m
  } = e, {
    getPrefixCls: v
  } = c.useContext(Ft), {
    name: C
  } = c.useContext(Ka), x = YJ(l), S = typeof x == "function", E = c.useContext(X5), {
    validateTrigger: O
  } = c.useContext(yl), $ = y !== void 0 ? y : O, _ = t != null, R = v("form", i), P = Ar(R), [I, j, F] = dC(R, P), A = xn("Form.Item");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && A(t !== null, "usage", "`null` is passed as `name` property");
  const M = c.useContext(wd), N = c.useRef(), [D, T] = ZJ({}), [L, z] = xs(() => LE()), H = (le) => {
    const ue = M == null ? void 0 : M.getKey(le.name);
    if (z(le.destroy ? LE() : le, !0), n && m !== !1 && E) {
      let ie = le.name;
      if (le.destroy)
        ie = N.current || ie;
      else if (ue !== void 0) {
        const [re, Q] = ue;
        ie = [re].concat(We(Q)), N.current = ie;
      }
      E(le, ie);
    }
  }, V = (le, ue) => {
    T((ie) => {
      const re = Object.assign({}, ie), ce = [].concat(We(le.name.slice(0, -1)), We(ue)).join(pee);
      return le.destroy ? delete re[ce] : re[ce] = le, re;
    });
  }, [Y, Z] = c.useMemo(() => {
    const le = We(L.errors), ue = We(L.warnings);
    return Object.values(D).forEach((ie) => {
      le.push.apply(le, We(ie.errors || [])), ue.push.apply(ue, We(ie.warnings || []));
    }), [le, ue];
  }, [D, L.errors, L.warnings]), oe = QJ();
  function ee(le, ue, ie) {
    return n && !b ? /* @__PURE__ */ c.createElement(a8, {
      prefixCls: R,
      hasFeedback: e.hasFeedback,
      validateStatus: e.validateStatus,
      meta: L,
      errors: Y,
      warnings: Z,
      noStyle: !0
    }, le) : /* @__PURE__ */ c.createElement(fee, Object.assign({
      key: "row"
    }, e, {
      className: se(r, F, P, j),
      prefixCls: R,
      fieldId: ue,
      isRequired: ie,
      errors: Y,
      warnings: Z,
      meta: L,
      onSubItemMetaChange: V
    }), le);
  }
  if (!_ && !S && !o)
    return I(ee(x));
  let ae = {};
  return typeof f == "string" ? ae.label = f : t && (ae.label = String(t)), p && (ae = Object.assign(Object.assign({}, ae), p)), I(/* @__PURE__ */ c.createElement($b, Object.assign({}, e, {
    messageVariables: ae,
    trigger: h,
    validateTrigger: $,
    onMetaChange: H
  }), (le, ue, ie) => {
    const re = ud(t).length && ue ? ue.name : [], Q = e8(re, C), ce = u !== void 0 ? u : !!(s && s.some((ne) => {
      if (ne && typeof ne == "object" && ne.required && !ne.warningOnly)
        return !0;
      if (typeof ne == "function") {
        const fe = ne(ie);
        return fe && fe.required && !fe.warningOnly;
      }
      return !1;
    })), ge = Object.assign({}, le);
    let G = null;
    if (process.env.NODE_ENV !== "production" && A(!(a && o), "usage", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps."), Array.isArray(x) && _)
      process.env.NODE_ENV !== "production" && A(!1, "usage", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item."), G = x;
    else if (S && (!(a || o) || _))
      process.env.NODE_ENV !== "production" && A(!!(a || o), "usage", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`."), process.env.NODE_ENV !== "production" && A(!_, "usage", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.");
    else if (o && !S && !_)
      process.env.NODE_ENV !== "production" && A(!1, "usage", "Must set `name` or use a render function when `dependencies` is set.");
    else if (ti(x)) {
      process.env.NODE_ENV !== "production" && A(x.props.defaultValue === void 0, "usage", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      const ne = Object.assign(Object.assign({}, x.props), ge);
      if (ne.id || (ne.id = Q), m || Y.length > 0 || Z.length > 0 || e.extra) {
        const we = [];
        (m || Y.length > 0) && we.push(`${Q}_help`), e.extra && we.push(`${Q}_extra`), ne["aria-describedby"] = we.join(" ");
      }
      Y.length > 0 && (ne["aria-invalid"] = "true"), ce && (ne["aria-required"] = "true"), ki(x) && (ne.ref = oe(re, x)), new Set([].concat(We(ud(h)), We(ud($)))).forEach((we) => {
        ne[we] = function() {
          for (var he, me, Ce, Te, Ee, Ge = arguments.length, ke = new Array(Ge), qe = 0; qe < Ge; qe++)
            ke[qe] = arguments[qe];
          (Ce = ge[we]) === null || Ce === void 0 || (he = Ce).call.apply(he, [ge].concat(ke)), (Ee = (Te = x.props)[we]) === null || Ee === void 0 || (me = Ee).call.apply(me, [Te].concat(ke));
        };
      });
      const ye = [ne["aria-required"], ne["aria-invalid"], ne["aria-describedby"]];
      G = /* @__PURE__ */ c.createElement(gee, {
        control: ge,
        update: x,
        childProps: ye
      }, Yr(x, ne));
    } else
      S && (a || o) && !_ ? G = x(ie) : (process.env.NODE_ENV !== "production" && A(!re.length, "usage", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead."), G = x);
    return ee(G, Q, ce);
  }));
}
const s8 = mee;
s8.useStatus = XJ;
const vee = s8;
var yee = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const bee = (e) => {
  var {
    prefixCls: t,
    children: n
  } = e, r = yee(e, ["prefixCls", "children"]);
  if (process.env.NODE_ENV !== "production") {
    const s = xn("Form.List");
    process.env.NODE_ENV !== "production" && s(typeof r.name == "number" || (Array.isArray(r.name) ? !!r.name.length : !!r.name), "usage", "Miss `name` prop.");
  }
  const {
    getPrefixCls: o
  } = c.useContext(Ft), i = o("form", t), a = c.useMemo(() => ({
    prefixCls: i,
    status: "error"
  }), [i]);
  return /* @__PURE__ */ c.createElement(U5, Object.assign({}, r), (s, l, u) => /* @__PURE__ */ c.createElement(_b.Provider, {
    value: a
  }, n(s.map((f) => Object.assign(Object.assign({}, f), {
    fieldKey: f.key
  })), l, {
    errors: u.errors,
    warnings: u.warnings
  })));
}, Cee = bee;
function xee() {
  const {
    form: e
  } = Cn(Ka);
  return e;
}
const Hn = r8;
Hn.Item = vee;
Hn.List = Cee;
Hn.ErrorList = JN;
Hn.useForm = n8;
Hn.useFormInstance = xee;
Hn.useWatch = Y5;
Hn.Provider = Z5;
Hn.create = () => {
  process.env.NODE_ENV !== "production" && Wd(!1, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.");
};
function AE(e) {
  var t = e.getBoundingClientRect(), n = document.documentElement;
  return {
    left: t.left + (window.pageXOffset || n.scrollLeft) - (n.clientLeft || document.body.clientLeft || 0),
    top: t.top + (window.pageYOffset || n.scrollTop) - (n.clientTop || document.body.clientTop || 0)
  };
}
function Pp(e, t, n, r) {
  var o = j0.unstable_batchedUpdates ? function(a) {
    j0.unstable_batchedUpdates(n, a);
  } : n;
  return e != null && e.addEventListener && e.addEventListener(t, o, r), {
    remove: function() {
      e != null && e.removeEventListener && e.removeEventListener(t, o, r);
    }
  };
}
function See(e, t, n) {
  return typeof n == "boolean" ? n : e.length ? !0 : Rr(t).some((o) => o.type === c_);
}
const wee = (e) => {
  const {
    componentCls: t,
    bodyBg: n,
    lightSiderBg: r,
    lightTriggerBg: o,
    lightTriggerColor: i
  } = e;
  return {
    [`${t}-sider-light`]: {
      background: r,
      [`${t}-sider-trigger`]: {
        color: i,
        background: o
      },
      [`${t}-sider-zero-width-trigger`]: {
        color: i,
        background: o,
        border: `1px solid ${n}`,
        // Safe to modify to any other color
        borderInlineStart: 0
      }
    }
  };
}, Eee = (e) => {
  const {
    antCls: t,
    // .ant
    componentCls: n,
    // .ant-layout
    colorText: r,
    triggerColor: o,
    footerBg: i,
    triggerBg: a,
    headerHeight: s,
    headerPadding: l,
    headerColor: u,
    footerPadding: f,
    triggerHeight: p,
    zeroTriggerHeight: h,
    zeroTriggerWidth: y,
    motionDurationMid: b,
    motionDurationSlow: m,
    fontSize: v,
    borderRadius: C,
    bodyBg: x,
    headerBg: S,
    siderBg: E
  } = e;
  return {
    [n]: Object.assign(Object.assign({
      display: "flex",
      flex: "auto",
      flexDirection: "column",
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: x,
      "&, *": {
        boxSizing: "border-box"
      },
      [`&${n}-has-sider`]: {
        flexDirection: "row",
        [`> ${n}, > ${n}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${n}-header, &${n}-footer`]: {
        flex: "0 0 auto"
      },
      [`${n}-sider`]: {
        position: "relative",
        // fix firefox can't set width smaller than content on flex item
        minWidth: 0,
        background: E,
        transition: `all ${b}, background 0s`,
        "&-children": {
          height: "100%",
          // Hack for fixing margin collapse bug
          // https://github.com/ant-design/ant-design/issues/7967
          // solution from https://stackoverflow.com/a/33132624/3040605
          marginTop: -0.1,
          paddingTop: 0.1,
          [`${t}-menu${t}-menu-inline-collapsed`]: {
            width: "auto"
          }
        },
        "&-has-trigger": {
          paddingBottom: p
        },
        "&-right": {
          order: 1
        },
        "&-trigger": {
          position: "fixed",
          bottom: 0,
          zIndex: 1,
          height: p,
          color: o,
          lineHeight: te(p),
          textAlign: "center",
          background: a,
          cursor: "pointer",
          transition: `all ${b}`
        },
        "&-zero-width": {
          "> *": {
            overflow: "hidden"
          },
          "&-trigger": {
            position: "absolute",
            top: s,
            insetInlineEnd: e.calc(y).mul(-1).equal(),
            zIndex: 1,
            width: y,
            height: h,
            color: o,
            fontSize: e.fontSizeXL,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: E,
            borderStartStartRadius: 0,
            borderStartEndRadius: C,
            borderEndEndRadius: C,
            borderEndStartRadius: 0,
            cursor: "pointer",
            transition: `background ${m} ease`,
            "&::after": {
              position: "absolute",
              inset: 0,
              background: "transparent",
              transition: `all ${m}`,
              content: '""'
            },
            "&:hover::after": {
              background: "rgba(255, 255, 255, 0.2)"
            },
            "&-right": {
              insetInlineStart: e.calc(y).mul(-1).equal(),
              borderStartStartRadius: C,
              borderStartEndRadius: 0,
              borderEndEndRadius: 0,
              borderEndStartRadius: C
            }
          }
        }
      }
    }, wee(e)), {
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    }),
    // ==================== Header ====================
    [`${n}-header`]: {
      height: s,
      padding: l,
      color: u,
      lineHeight: te(s),
      background: S,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${t}-menu`]: {
        lineHeight: "inherit"
      }
    },
    // ==================== Footer ====================
    [`${n}-footer`]: {
      padding: f,
      color: r,
      fontSize: v,
      background: i
    },
    // =================== Content ====================
    [`${n}-content`]: {
      flex: "auto",
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
}, $ee = (e) => {
  const {
    colorBgLayout: t,
    controlHeight: n,
    controlHeightLG: r,
    colorText: o,
    controlHeightSM: i,
    marginXXS: a,
    colorTextLightSolid: s,
    colorBgContainer: l
  } = e, u = r * 1.25;
  return {
    // Deprecated
    colorBgHeader: "#001529",
    colorBgBody: t,
    colorBgTrigger: "#002140",
    bodyBg: t,
    headerBg: "#001529",
    headerHeight: n * 2,
    headerPadding: `0 ${u}px`,
    headerColor: o,
    footerPadding: `${i}px ${u}px`,
    footerBg: t,
    siderBg: "#001529",
    triggerHeight: r + a * 2,
    triggerBg: "#002140",
    triggerColor: s,
    zeroTriggerWidth: r,
    zeroTriggerHeight: r,
    lightSiderBg: l,
    lightTriggerBg: l,
    lightTriggerColor: o
  };
}, l8 = Gn("Layout", (e) => [Eee(e)], $ee, {
  deprecatedTokens: [["colorBgBody", "bodyBg"], ["colorBgHeader", "headerBg"], ["colorBgTrigger", "triggerBg"]]
});
var c8 = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function nm(e) {
  let {
    suffixCls: t,
    tagName: n,
    displayName: r
  } = e;
  return (o) => {
    const i = /* @__PURE__ */ c.forwardRef((a, s) => /* @__PURE__ */ c.createElement(o, Object.assign({
      ref: s,
      suffixCls: t,
      tagName: n
    }, a)));
    return process.env.NODE_ENV !== "production" && (i.displayName = r), i;
  };
}
const fC = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    suffixCls: r,
    className: o,
    tagName: i
  } = e, a = c8(e, ["prefixCls", "suffixCls", "className", "tagName"]), {
    getPrefixCls: s
  } = c.useContext(Ft), l = s("layout", n), [u, f, p] = l8(l), h = r ? `${l}-${r}` : l;
  return u(/* @__PURE__ */ c.createElement(i, Object.assign({
    className: se(n || h, o, f, p),
    ref: t
  }, a)));
}), Oee = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    direction: n
  } = c.useContext(Ft), [r, o] = c.useState([]), {
    prefixCls: i,
    className: a,
    rootClassName: s,
    children: l,
    hasSider: u,
    tagName: f,
    style: p
  } = e, h = c8(e, ["prefixCls", "className", "rootClassName", "children", "hasSider", "tagName", "style"]), y = dr(h, ["suffixCls"]), {
    getPrefixCls: b,
    layout: m
  } = c.useContext(Ft), v = b("layout", i), C = See(r, l, u), [x, S, E] = l8(v), O = se(v, {
    [`${v}-has-sider`]: C,
    [`${v}-rtl`]: n === "rtl"
  }, m == null ? void 0 : m.className, a, s, S, E), $ = c.useMemo(() => ({
    siderHook: {
      addSider: (_) => {
        o((R) => [].concat(We(R), [_]));
      },
      removeSider: (_) => {
        o((R) => R.filter((P) => P !== _));
      }
    }
  }), []);
  return x(/* @__PURE__ */ c.createElement(s_.Provider, {
    value: $
  }, /* @__PURE__ */ c.createElement(f, Object.assign({
    ref: t,
    className: O,
    style: Object.assign(Object.assign({}, m == null ? void 0 : m.style), p)
  }, y), l)));
}), _ee = nm({
  tagName: "div",
  displayName: "Layout"
})(Oee), Nee = nm({
  suffixCls: "header",
  tagName: "header",
  displayName: "Header"
})(fC), Pee = nm({
  suffixCls: "footer",
  tagName: "footer",
  displayName: "Footer"
})(fC), Iee = nm({
  suffixCls: "content",
  tagName: "main",
  displayName: "Content"
})(fC), Ree = _ee, su = Ree;
su.Header = Nee;
su.Footer = Pee;
su.Content = Iee;
su.Sider = c_;
su._InternalSiderContext = Yg;
const Dee = su, Tee = function() {
  const e = Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]);
  for (let t = 1; t < arguments.length; t++) {
    const n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    n && Object.keys(n).forEach((r) => {
      const o = n[r];
      o !== void 0 && (e[r] = o);
    });
  }
  return e;
};
var Mee = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" };
const Lee = Mee;
var u8 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Lee
  }));
};
process.env.NODE_ENV !== "production" && (u8.displayName = "DoubleLeftOutlined");
const jE = /* @__PURE__ */ c.forwardRef(u8);
var Aee = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" };
const jee = Aee;
var d8 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: jee
  }));
};
process.env.NODE_ENV !== "production" && (d8.displayName = "DoubleRightOutlined");
const kE = /* @__PURE__ */ c.forwardRef(d8);
var kee = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, Fee = ["10", "20", "50", "100"], f8 = function(t) {
  var n = t.pageSizeOptions, r = n === void 0 ? Fee : n, o = t.locale, i = t.changeSize, a = t.pageSize, s = t.goButton, l = t.quickGo, u = t.rootPrefixCls, f = t.selectComponentClass, p = t.selectPrefixCls, h = t.disabled, y = t.buildOptionText, b = be.useState(""), m = de(b, 2), v = m[0], C = m[1], x = function() {
    return !v || Number.isNaN(v) ? void 0 : Number(v);
  }, S = typeof y == "function" ? y : function(M) {
    return "".concat(M, " ").concat(o.items_per_page);
  }, E = function(N) {
    i == null || i(Number(N));
  }, O = function(N) {
    C(N.target.value);
  }, $ = function(N) {
    s || v === "" || (C(""), !(N.relatedTarget && (N.relatedTarget.className.indexOf("".concat(u, "-item-link")) >= 0 || N.relatedTarget.className.indexOf("".concat(u, "-item")) >= 0)) && (l == null || l(x())));
  }, _ = function(N) {
    v !== "" && (N.keyCode === Pe.ENTER || N.type === "click") && (C(""), l == null || l(x()));
  }, R = function() {
    return r.some(function(N) {
      return N.toString() === a.toString();
    }) ? r : r.concat([a.toString()]).sort(function(N, D) {
      var T = Number.isNaN(Number(N)) ? 0 : Number(N), L = Number.isNaN(Number(D)) ? 0 : Number(D);
      return T - L;
    });
  }, P = "".concat(u, "-options");
  if (!i && !l)
    return null;
  var I = null, j = null, F = null;
  if (i && f) {
    var A = R().map(function(M, N) {
      return /* @__PURE__ */ be.createElement(f.Option, {
        key: N,
        value: M.toString()
      }, S(M));
    });
    I = /* @__PURE__ */ be.createElement(f, {
      disabled: h,
      prefixCls: p,
      showSearch: !1,
      className: "".concat(P, "-size-changer"),
      optionLabelProp: "children",
      popupMatchSelectWidth: !1,
      value: (a || r[0]).toString(),
      onChange: E,
      getPopupContainer: function(N) {
        return N.parentNode;
      },
      "aria-label": o.page_size,
      defaultOpen: !1
    }, A);
  }
  return l && (s && (F = typeof s == "boolean" ? /* @__PURE__ */ be.createElement("button", {
    type: "button",
    onClick: _,
    onKeyUp: _,
    disabled: h,
    className: "".concat(P, "-quick-jumper-button")
  }, o.jump_to_confirm) : /* @__PURE__ */ be.createElement("span", {
    onClick: _,
    onKeyUp: _
  }, s)), j = /* @__PURE__ */ be.createElement("div", {
    className: "".concat(P, "-quick-jumper")
  }, o.jump_to, /* @__PURE__ */ be.createElement("input", {
    disabled: h,
    type: "text",
    value: v,
    onChange: O,
    onKeyUp: _,
    onBlur: $,
    "aria-label": o.page
  }), o.page, F)), /* @__PURE__ */ be.createElement("li", {
    className: P
  }, I, j);
};
process.env.NODE_ENV !== "production" && (f8.displayName = "Options");
var pc = function(t) {
  var n, r = t.rootPrefixCls, o = t.page, i = t.active, a = t.className, s = t.showTitle, l = t.onClick, u = t.onKeyPress, f = t.itemRender, p = "".concat(r, "-item"), h = se(p, "".concat(p, "-").concat(o), (n = {}, K(n, "".concat(p, "-active"), i), K(n, "".concat(p, "-disabled"), !o), n), a), y = function() {
    l(o);
  }, b = function(C) {
    u(C, l, o);
  }, m = f(o, "page", /* @__PURE__ */ be.createElement("a", {
    rel: "nofollow"
  }, o));
  return m ? /* @__PURE__ */ be.createElement("li", {
    title: s ? String(o) : null,
    className: h,
    onClick: y,
    onKeyDown: b,
    tabIndex: 0
  }, m) : null;
};
process.env.NODE_ENV !== "production" && (pc.displayName = "Pager");
var Bee = function(t, n, r) {
  return r;
};
function l0() {
}
function FE(e) {
  var t = Number(e);
  return typeof t == "number" && !Number.isNaN(t) && isFinite(t) && Math.floor(t) === t;
}
function qs(e, t, n) {
  var r = typeof e == "undefined" ? t : e;
  return Math.floor((n - 1) / r) + 1;
}
var p8 = function(t) {
  var n, r = t.prefixCls, o = r === void 0 ? "rc-pagination" : r, i = t.selectPrefixCls, a = i === void 0 ? "rc-select" : i, s = t.className, l = t.selectComponentClass, u = t.current, f = t.defaultCurrent, p = f === void 0 ? 1 : f, h = t.total, y = h === void 0 ? 0 : h, b = t.pageSize, m = t.defaultPageSize, v = m === void 0 ? 10 : m, C = t.onChange, x = C === void 0 ? l0 : C, S = t.hideOnSinglePage, E = t.showPrevNextJumpers, O = E === void 0 ? !0 : E, $ = t.showQuickJumper, _ = t.showLessItems, R = t.showTitle, P = R === void 0 ? !0 : R, I = t.onShowSizeChange, j = I === void 0 ? l0 : I, F = t.locale, A = F === void 0 ? kee : F, M = t.style, N = t.totalBoundaryShowSizeChanger, D = N === void 0 ? 50 : N, T = t.disabled, L = t.simple, z = t.showTotal, H = t.showSizeChanger, V = t.pageSizeOptions, Y = t.itemRender, Z = Y === void 0 ? Bee : Y, oe = t.jumpPrevIcon, ee = t.jumpNextIcon, ae = t.prevIcon, le = t.nextIcon, ue = be.useRef(null), ie = Fn(10, {
    value: b,
    defaultValue: v
  }), re = de(ie, 2), Q = re[0], ce = re[1], ge = Fn(1, {
    value: u,
    defaultValue: p,
    postState: function(Lt) {
      return Math.max(1, Math.min(Lt, qs(void 0, Q, y)));
    }
  }), G = de(ge, 2), ne = G[0], fe = G[1], ye = be.useState(ne), we = de(ye, 2), he = we[0], me = we[1];
  kt(function() {
    me(ne);
  }, [ne]);
  var Ce = x !== l0, Te = "current" in t;
  process.env.NODE_ENV !== "production" && mt(Te ? Ce : !0, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  var Ee = Math.max(1, ne - (_ ? 3 : 5)), Ge = Math.min(qs(void 0, Q, y), ne + (_ ? 3 : 5));
  function ke(St, Lt) {
    var ln = St || /* @__PURE__ */ be.createElement("button", {
      type: "button",
      "aria-label": Lt,
      className: "".concat(o, "-item-link")
    });
    return typeof St == "function" && (ln = /* @__PURE__ */ be.createElement(St, J({}, t))), ln;
  }
  function qe(St) {
    var Lt = St.target.value, ln = qs(void 0, Q, y), lr;
    return Lt === "" ? lr = Lt : Number.isNaN(Number(Lt)) ? lr = he : Lt >= ln ? lr = ln : lr = Number(Lt), lr;
  }
  function ze(St) {
    return FE(St) && St !== ne && FE(y) && y > 0;
  }
  var pt = y > Q ? $ : !1;
  function Ke(St) {
    (St.keyCode === Pe.UP || St.keyCode === Pe.DOWN) && St.preventDefault();
  }
  function et(St) {
    var Lt = qe(St);
    switch (Lt !== he && me(Lt), St.keyCode) {
      case Pe.ENTER:
        Ye(Lt);
        break;
      case Pe.UP:
        Ye(Lt - 1);
        break;
      case Pe.DOWN:
        Ye(Lt + 1);
        break;
    }
  }
  function Je(St) {
    Ye(qe(St));
  }
  function Et(St) {
    var Lt = qs(St, Q, y), ln = ne > Lt && Lt !== 0 ? Lt : ne;
    ce(St), me(ln), j == null || j(ne, St), fe(ln), x == null || x(ln, St);
  }
  function Ye(St) {
    if (ze(St) && !T) {
      var Lt = qs(void 0, Q, y), ln = St;
      return St > Lt ? ln = Lt : St < 1 && (ln = 1), ln !== he && me(ln), fe(ln), x == null || x(ln, Q), ln;
    }
    return ne;
  }
  var wt = ne > 1, dt = ne < qs(void 0, Q, y), Ct = H != null ? H : y > D;
  function ot() {
    wt && Ye(ne - 1);
  }
  function jt() {
    dt && Ye(ne + 1);
  }
  function Rt() {
    Ye(Ee);
  }
  function Le() {
    Ye(Ge);
  }
  function Ve(St, Lt) {
    if (St.key === "Enter" || St.charCode === Pe.ENTER || St.keyCode === Pe.ENTER) {
      for (var ln = arguments.length, lr = new Array(ln > 2 ? ln - 2 : 0), fr = 2; fr < ln; fr++)
        lr[fr - 2] = arguments[fr];
      Lt.apply(void 0, lr);
    }
  }
  function Ae(St) {
    Ve(St, ot);
  }
  function ft(St) {
    Ve(St, jt);
  }
  function He(St) {
    Ve(St, Rt);
  }
  function Fe(St) {
    Ve(St, Le);
  }
  function yt(St) {
    var Lt = Z(St, "prev", ke(ae, "prev page"));
    return /* @__PURE__ */ be.isValidElement(Lt) ? /* @__PURE__ */ be.cloneElement(Lt, {
      disabled: !wt
    }) : Lt;
  }
  function Qe(St) {
    var Lt = Z(St, "next", ke(le, "next page"));
    return /* @__PURE__ */ be.isValidElement(Lt) ? /* @__PURE__ */ be.cloneElement(Lt, {
      disabled: !dt
    }) : Lt;
  }
  function tt(St) {
    (St.type === "click" || St.keyCode === Pe.ENTER) && Ye(he);
  }
  var lt = null, ht = ei(t, {
    aria: !0,
    data: !0
  }), bt = z && /* @__PURE__ */ be.createElement("li", {
    className: "".concat(o, "-total-text")
  }, z(y, [y === 0 ? 0 : (ne - 1) * Q + 1, ne * Q > y ? y : ne * Q])), ct = null, xt = qs(void 0, Q, y);
  if (S && y <= Q)
    return null;
  var vt = [], _e = {
    rootPrefixCls: o,
    onClick: Ye,
    onKeyPress: Ve,
    showTitle: P,
    itemRender: Z,
    page: -1
  }, Ze = ne - 1 > 0 ? ne - 1 : 0, q = ne + 1 < xt ? ne + 1 : xt, Se = $ && $.goButton, Re = Se, ut = null;
  L && (Se && (typeof Se == "boolean" ? Re = /* @__PURE__ */ be.createElement("button", {
    type: "button",
    onClick: tt,
    onKeyUp: tt
  }, A.jump_to_confirm) : Re = /* @__PURE__ */ be.createElement("span", {
    onClick: tt,
    onKeyUp: tt
  }, Se), Re = /* @__PURE__ */ be.createElement("li", {
    title: P ? "".concat(A.jump_to).concat(ne, "/").concat(xt) : null,
    className: "".concat(o, "-simple-pager")
  }, Re)), ut = /* @__PURE__ */ be.createElement("li", {
    title: P ? "".concat(ne, "/").concat(xt) : null,
    className: "".concat(o, "-simple-pager")
  }, /* @__PURE__ */ be.createElement("input", {
    type: "text",
    value: he,
    disabled: T,
    onKeyDown: Ke,
    onKeyUp: et,
    onChange: et,
    onBlur: Je,
    size: 3
  }), /* @__PURE__ */ be.createElement("span", {
    className: "".concat(o, "-slash")
  }, "/"), xt));
  var $t = _ ? 1 : 2;
  if (xt <= 3 + $t * 2) {
    xt || vt.push(/* @__PURE__ */ be.createElement(pc, Oe({}, _e, {
      key: "noPager",
      page: 1,
      className: "".concat(o, "-item-disabled")
    })));
    for (var Ne = 1; Ne <= xt; Ne += 1)
      vt.push(/* @__PURE__ */ be.createElement(pc, Oe({}, _e, {
        key: Ne,
        page: Ne,
        active: ne === Ne
      })));
  } else {
    var Ie = _ ? A.prev_3 : A.prev_5, De = _ ? A.next_3 : A.next_5, Me = Z(Ee, "jump-prev", ke(oe, "prev page")), Tt = Z(Ge, "jump-next", ke(ee, "next page"));
    O && (lt = Me ? /* @__PURE__ */ be.createElement("li", {
      title: P ? Ie : null,
      key: "prev",
      onClick: Rt,
      tabIndex: 0,
      onKeyDown: He,
      className: se("".concat(o, "-jump-prev"), K({}, "".concat(o, "-jump-prev-custom-icon"), !!oe))
    }, Me) : null, ct = Tt ? /* @__PURE__ */ be.createElement("li", {
      title: P ? De : null,
      key: "next",
      onClick: Le,
      tabIndex: 0,
      onKeyDown: Fe,
      className: se("".concat(o, "-jump-next"), K({}, "".concat(o, "-jump-next-custom-icon"), !!ee))
    }, Tt) : null);
    var Pt = Math.max(1, ne - $t), Ut = Math.min(ne + $t, xt);
    ne - 1 <= $t && (Ut = 1 + $t * 2), xt - ne <= $t && (Pt = xt - $t * 2);
    for (var Kt = Pt; Kt <= Ut; Kt += 1)
      vt.push(/* @__PURE__ */ be.createElement(pc, Oe({}, _e, {
        key: Kt,
        page: Kt,
        active: ne === Kt
      })));
    if (ne - 1 >= $t * 2 && ne !== 3 && (vt[0] = /* @__PURE__ */ be.cloneElement(vt[0], {
      className: se("".concat(o, "-item-after-jump-prev"), vt[0].props.className)
    }), vt.unshift(lt)), xt - ne >= $t * 2 && ne !== xt - 2) {
      var $n = vt[vt.length - 1];
      vt[vt.length - 1] = /* @__PURE__ */ be.cloneElement($n, {
        className: se("".concat(o, "-item-before-jump-next"), $n.props.className)
      }), vt.push(ct);
    }
    Pt !== 1 && vt.unshift(/* @__PURE__ */ be.createElement(pc, Oe({}, _e, {
      key: 1,
      page: 1
    }))), Ut !== xt && vt.push(/* @__PURE__ */ be.createElement(pc, Oe({}, _e, {
      key: xt,
      page: xt
    })));
  }
  var Jt = yt(Ze);
  if (Jt) {
    var On = !wt || !xt;
    Jt = /* @__PURE__ */ be.createElement("li", {
      title: P ? A.prev_page : null,
      onClick: ot,
      tabIndex: On ? null : 0,
      onKeyDown: Ae,
      className: se("".concat(o, "-prev"), K({}, "".concat(o, "-disabled"), On)),
      "aria-disabled": On
    }, Jt);
  }
  var Jn = Qe(q);
  if (Jn) {
    var er, Xt;
    L ? (er = !dt, Xt = wt ? 0 : null) : (er = !dt || !xt, Xt = er ? null : 0), Jn = /* @__PURE__ */ be.createElement("li", {
      title: P ? A.next_page : null,
      onClick: jt,
      tabIndex: Xt,
      onKeyDown: ft,
      className: se("".concat(o, "-next"), K({}, "".concat(o, "-disabled"), er)),
      "aria-disabled": er
    }, Jn);
  }
  var It = se(o, s, (n = {}, K(n, "".concat(o, "-simple"), L), K(n, "".concat(o, "-disabled"), T), n));
  return /* @__PURE__ */ be.createElement("ul", Oe({
    className: It,
    style: M,
    ref: ue
  }, ht), bt, Jt, L ? ut : vt, Jn, /* @__PURE__ */ be.createElement(f8, {
    locale: A,
    rootPrefixCls: o,
    disabled: T,
    selectComponentClass: l,
    selectPrefixCls: a,
    changeSize: Ct ? Et : null,
    pageSize: Q,
    pageSizeOptions: V,
    quickGo: pt ? Ye : null,
    goButton: Re
  }));
};
process.env.NODE_ENV !== "production" && (p8.displayName = "Pagination");
const h8 = (e) => /* @__PURE__ */ c.createElement(Ls, Object.assign({}, e, {
  showSearch: !0,
  size: "small"
})), g8 = (e) => /* @__PURE__ */ c.createElement(Ls, Object.assign({}, e, {
  showSearch: !0,
  size: "middle"
}));
h8.Option = Ls.Option;
g8.Option = Ls.Option;
const Hee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${t}-item-link`]: {
          color: e.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${t}-disabled`]: {
      cursor: "not-allowed",
      [`${t}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: e.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: e.colorBorder,
          backgroundColor: e.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: e.itemActiveBgDisabled
          },
          a: {
            color: e.itemActiveColorDisabled
          }
        }
      },
      [`${t}-item-link`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${t}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${t}-simple-pager`]: {
        color: e.colorTextDisabled
      },
      [`${t}-jump-prev, ${t}-jump-next`]: {
        [`${t}-item-link-icon`]: {
          opacity: 0
        },
        [`${t}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${t}-simple`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&${t}-disabled ${t}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, zee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-mini ${t}-total-text, &${t}-mini ${t}-simple-pager`]: {
      height: e.itemSizeSM,
      lineHeight: te(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-item`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: te(e.calc(e.itemSizeSM).sub(2).equal())
    },
    [`&${t}-mini:not(${t}-disabled) ${t}-item:not(${t}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    },
    [`&${t}-mini ${t}-prev, &${t}-mini ${t}-next`]: {
      minWidth: e.itemSizeSM,
      height: e.itemSizeSM,
      margin: 0,
      lineHeight: te(e.itemSizeSM)
    },
    [`&${t}-mini:not(${t}-disabled)`]: {
      [`${t}-prev, ${t}-next`]: {
        [`&:hover ${t}-item-link`]: {
          backgroundColor: e.colorBgTextHover
        },
        [`&:active ${t}-item-link`]: {
          backgroundColor: e.colorBgTextActive
        },
        [`&${t}-disabled:hover ${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${t}-mini ${t}-prev ${t}-item-link,
    &${t}-mini ${t}-next ${t}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: e.itemSizeSM,
        lineHeight: te(e.itemSizeSM)
      }
    },
    [`&${t}-mini ${t}-jump-prev, &${t}-mini ${t}-jump-next`]: {
      height: e.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: te(e.itemSizeSM)
    },
    [`&${t}-mini ${t}-options`]: {
      marginInlineStart: e.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: e.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: e.itemSizeSM,
        lineHeight: te(e.itemSizeSM),
        input: Object.assign(Object.assign({}, tC(e)), {
          width: e.paginationMiniQuickJumperInputWidth,
          height: e.controlHeightSM
        })
      }
    }
  };
}, Vee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`
    &${t}-simple ${t}-prev,
    &${t}-simple ${t}-next
    `]: {
      height: e.itemSizeSM,
      lineHeight: te(e.itemSizeSM),
      verticalAlign: "top",
      [`${t}-item-link`]: {
        height: e.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        },
        "&::after": {
          height: e.itemSizeSM,
          lineHeight: te(e.itemSizeSM)
        }
      }
    },
    [`&${t}-simple ${t}-simple-pager`]: {
      display: "inline-block",
      height: e.itemSizeSM,
      marginInlineEnd: e.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        marginInlineEnd: e.marginXS,
        padding: `0 ${te(e.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: e.itemInputBg,
        border: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `border-color ${e.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: e.colorPrimary
        },
        "&:focus": {
          borderColor: e.colorPrimaryHover,
          boxShadow: `${te(e.inputOutlineOffset)} 0 ${te(e.controlOutlineWidth)} ${e.controlOutline}`
        },
        "&[disabled]": {
          color: e.colorTextDisabled,
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, Wee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-jump-prev, ${t}-jump-next`]: {
      outline: 0,
      [`${t}-item-container`]: {
        position: "relative",
        [`${t}-item-link-icon`]: {
          color: e.colorPrimary,
          fontSize: e.fontSizeSM,
          opacity: 0,
          transition: `all ${e.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${t}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: e.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: e.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: e.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${e.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${t}-item-link-icon`]: {
          opacity: 1
        },
        [`${t}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${t}-prev,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      marginInlineEnd: e.marginXS
    },
    [`
    ${t}-prev,
    ${t}-next,
    ${t}-jump-prev,
    ${t}-jump-next
    `]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      color: e.colorText,
      fontFamily: e.fontFamily,
      lineHeight: `${te(e.itemSize)}`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: e.borderRadius,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid}`
    },
    [`${t}-prev, ${t}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: e.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${t}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: e.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${te(e.lineWidth)} ${e.lineType} transparent`,
        borderRadius: e.borderRadius,
        outline: "none",
        transition: `all ${e.motionDurationMid}`
      },
      [`&:hover ${t}-item-link`]: {
        backgroundColor: e.colorBgTextHover
      },
      [`&:active ${t}-item-link`]: {
        backgroundColor: e.colorBgTextActive
      },
      [`&${t}-disabled:hover`]: {
        [`${t}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${t}-slash`]: {
      marginInlineEnd: e.paginationSlashMarginInlineEnd,
      marginInlineStart: e.paginationSlashMarginInlineStart
    },
    [`${t}-options`]: {
      display: "inline-block",
      marginInlineStart: e.margin,
      verticalAlign: "middle",
      "&-size-changer.-select": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: e.controlHeight,
        marginInlineStart: e.marginXS,
        lineHeight: te(e.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, nC(e)), eC(e, {
          borderColor: e.colorBorder,
          hoverBorderColor: e.colorPrimaryHover,
          activeBorderColor: e.colorPrimary,
          activeShadow: e.activeShadow
        })), {
          "&[disabled]": Object.assign({}, Qg(e)),
          width: e.calc(e.controlHeightLG).mul(1.25).equal(),
          height: e.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: e.marginXS,
          marginInlineEnd: e.marginXS
        })
      }
    }
  };
}, Kee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-item`]: {
      display: "inline-block",
      minWidth: e.itemSize,
      height: e.itemSize,
      marginInlineEnd: e.marginXS,
      fontFamily: e.fontFamily,
      lineHeight: te(e.calc(e.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${te(e.lineWidth)} ${e.lineType} transparent`,
      borderRadius: e.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${te(e.paginationItemPaddingInline)}`,
        color: e.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${t}-item-active)`]: {
        "&:hover": {
          transition: `all ${e.motionDurationMid}`,
          backgroundColor: e.colorBgTextHover
        },
        "&:active": {
          backgroundColor: e.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: e.fontWeightStrong,
        backgroundColor: e.itemActiveBg,
        borderColor: e.colorPrimary,
        a: {
          color: e.colorPrimary
        },
        "&:hover": {
          borderColor: e.colorPrimaryHover
        },
        "&:hover a": {
          color: e.colorPrimaryHover
        }
      }
    }
  };
}, Uee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e)), {
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${t}-total-text`]: {
        display: "inline-block",
        height: e.itemSize,
        marginInlineEnd: e.marginXS,
        lineHeight: te(e.calc(e.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), Kee(e)), Wee(e)), Vee(e)), zee(e)), Hee(e)), {
      // media query style
      [`@media only screen and (max-width: ${e.screenLG}px)`]: {
        [`${t}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${e.screenSM}px)`]: {
        [`${t}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${e.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, Gee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}:not(${t}-disabled)`]: {
      [`${t}-item`]: Object.assign({}, $h(e)),
      [`${t}-jump-prev, ${t}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${t}-item-link-icon`]: {
            opacity: 1
          },
          [`${t}-item-ellipsis`]: {
            opacity: 0
          }
        }, Va(e))
      },
      [`${t}-prev, ${t}-next`]: {
        [`&:focus-visible ${t}-item-link`]: Object.assign({}, Va(e))
      }
    }
  };
}, m8 = (e) => Object.assign({
  itemBg: e.colorBgContainer,
  itemSize: e.controlHeight,
  itemSizeSM: e.controlHeightSM,
  itemActiveBg: e.colorBgContainer,
  itemLinkBg: e.colorBgContainer,
  itemActiveColorDisabled: e.colorTextDisabled,
  itemActiveBgDisabled: e.controlItemBgActiveDisabled,
  itemInputBg: e.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, Jb(e)), v8 = (e) => Sn(e, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: e.calc(e.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: e.calc(e.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: e.calc(e.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: e.calc(e.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: e.marginXXS,
  paginationSlashMarginInlineEnd: e.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, Qb(e)), qee = Gn("Pagination", (e) => {
  const t = v8(e);
  return [Uee(t), Gee(t)];
}, m8), Yee = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}${t}-bordered${t}-disabled:not(${t}-mini)`]: {
      "&, &:hover": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      "&:focus-visible": {
        [`${t}-item-link`]: {
          borderColor: e.colorBorder
        }
      },
      [`${t}-item, ${t}-item-link`]: {
        backgroundColor: e.colorBgContainerDisabled,
        borderColor: e.colorBorder,
        [`&:hover:not(${t}-item-active)`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          a: {
            color: e.colorTextDisabled
          }
        },
        [`&${t}-item-active`]: {
          backgroundColor: e.itemActiveBgDisabled
        }
      },
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder,
          color: e.colorTextDisabled
        },
        [`${t}-item-link`]: {
          backgroundColor: e.colorBgContainerDisabled,
          borderColor: e.colorBorder
        }
      }
    },
    [`${t}${t}-bordered:not(${t}-mini)`]: {
      [`${t}-prev, ${t}-next`]: {
        "&:hover button": {
          borderColor: e.colorPrimaryHover,
          backgroundColor: e.itemBg
        },
        [`${t}-item-link`]: {
          backgroundColor: e.itemLinkBg,
          borderColor: e.colorBorder
        },
        [`&:hover ${t}-item-link`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          color: e.colorPrimary
        },
        [`&${t}-disabled`]: {
          [`${t}-item-link`]: {
            borderColor: e.colorBorder,
            color: e.colorTextDisabled
          }
        }
      },
      [`${t}-item`]: {
        backgroundColor: e.itemBg,
        border: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
        [`&:hover:not(${t}-item-active)`]: {
          borderColor: e.colorPrimary,
          backgroundColor: e.itemBg,
          a: {
            color: e.colorPrimary
          }
        },
        "&-active": {
          borderColor: e.colorPrimary
        }
      }
    }
  };
}, Xee = gb(["Pagination", "bordered"], (e) => {
  const t = v8(e);
  return [Yee(t)];
}, m8);
var Zee = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const y8 = (e) => {
  const {
    prefixCls: t,
    selectPrefixCls: n,
    className: r,
    rootClassName: o,
    style: i,
    size: a,
    locale: s,
    selectComponentClass: l,
    responsive: u,
    showSizeChanger: f
  } = e, p = Zee(e, ["prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]), {
    xs: h
  } = zg(u), [, y] = ro(), {
    getPrefixCls: b,
    direction: m,
    pagination: v = {}
  } = c.useContext(Ft), C = b("pagination", t), [x, S, E] = qee(C), O = f != null ? f : v.showSizeChanger, $ = c.useMemo(() => {
    const M = /* @__PURE__ */ c.createElement("span", {
      className: `${C}-item-ellipsis`
    }, "•••"), N = /* @__PURE__ */ c.createElement("button", {
      className: `${C}-item-link`,
      type: "button",
      tabIndex: -1
    }, m === "rtl" ? /* @__PURE__ */ c.createElement(Fc, null) : /* @__PURE__ */ c.createElement(Th, null)), D = /* @__PURE__ */ c.createElement("button", {
      className: `${C}-item-link`,
      type: "button",
      tabIndex: -1
    }, m === "rtl" ? /* @__PURE__ */ c.createElement(Th, null) : /* @__PURE__ */ c.createElement(Fc, null)), T = /* @__PURE__ */ c.createElement("a", {
      className: `${C}-item-link`
    }, /* @__PURE__ */ c.createElement("div", {
      className: `${C}-item-container`
    }, m === "rtl" ? /* @__PURE__ */ c.createElement(kE, {
      className: `${C}-item-link-icon`
    }) : /* @__PURE__ */ c.createElement(jE, {
      className: `${C}-item-link-icon`
    }), M)), L = /* @__PURE__ */ c.createElement("a", {
      className: `${C}-item-link`
    }, /* @__PURE__ */ c.createElement("div", {
      className: `${C}-item-container`
    }, m === "rtl" ? /* @__PURE__ */ c.createElement(jE, {
      className: `${C}-item-link-icon`
    }) : /* @__PURE__ */ c.createElement(kE, {
      className: `${C}-item-link-icon`
    }), M));
    return {
      prevIcon: N,
      nextIcon: D,
      jumpPrevIcon: T,
      jumpNextIcon: L
    };
  }, [m, C]), [_] = _l("Pagination", EO), R = Object.assign(Object.assign({}, _), s), P = Co(a), I = P === "small" || !!(h && !P && u), j = b("select", n), F = se({
    [`${C}-mini`]: I,
    [`${C}-rtl`]: m === "rtl",
    [`${C}-bordered`]: y.wireframe
  }, v == null ? void 0 : v.className, r, o, S, E), A = Object.assign(Object.assign({}, v == null ? void 0 : v.style), i);
  return x(/* @__PURE__ */ c.createElement(c.Fragment, null, y.wireframe && /* @__PURE__ */ c.createElement(Xee, {
    prefixCls: C
  }), /* @__PURE__ */ c.createElement(p8, Object.assign({}, $, p, {
    style: A,
    prefixCls: C,
    selectPrefixCls: j,
    className: F,
    selectComponentClass: l || (I ? h8 : g8),
    locale: R,
    showSizeChanger: O
  }))));
};
process.env.NODE_ENV !== "production" && (y8.displayName = "Pagination");
const b8 = y8, Qee = new Bn("antSpinMove", {
  to: {
    opacity: 1
  }
}), Jee = new Bn("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), ete = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({}, Qn(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "static",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: n(n(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [`${t}-dot ${t}-dot-item`]: {
          backgroundColor: e.colorWhite
        },
        [`${t}-text`]: {
          color: e.colorTextLightSolid
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: n(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: n(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          height: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          backgroundColor: e.colorPrimary,
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: Qee,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: Jee,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        fontSize: e.dotSizeSM,
        i: {
          width: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal(),
          height: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        fontSize: e.dotSizeLG,
        i: {
          width: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, tte = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: n
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: n
  };
}, nte = Gn("Spin", (e) => {
  const t = Sn(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [ete(t)];
}, tte);
var rte = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let ih = null;
function ote(e, t) {
  const {
    indicator: n
  } = t, r = `${e}-dot`;
  return n === null ? null : ti(n) ? Yr(n, {
    className: se(n.props.className, r)
  }) : ti(ih) ? Yr(ih, {
    className: se(ih.props.className, r)
  }) : /* @__PURE__ */ c.createElement("span", {
    className: se(r, `${e}-dot-spin`)
  }, /* @__PURE__ */ c.createElement("i", {
    className: `${e}-dot-item`,
    key: 1
  }), /* @__PURE__ */ c.createElement("i", {
    className: `${e}-dot-item`,
    key: 2
  }), /* @__PURE__ */ c.createElement("i", {
    className: `${e}-dot-item`,
    key: 3
  }), /* @__PURE__ */ c.createElement("i", {
    className: `${e}-dot-item`,
    key: 4
  }));
}
function ite(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const pC = (e) => {
  const {
    prefixCls: t,
    spinning: n = !0,
    delay: r = 0,
    className: o,
    rootClassName: i,
    size: a = "default",
    tip: s,
    wrapperClassName: l,
    style: u,
    children: f,
    fullscreen: p = !1
  } = e, h = rte(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen"]), {
    getPrefixCls: y
  } = c.useContext(Ft), b = y("spin", t), [m, v, C] = nte(b), [x, S] = c.useState(() => n && !ite(n, r));
  c.useEffect(() => {
    if (n) {
      const F = dZ(r, () => {
        S(!0);
      });
      return F(), () => {
        var A;
        (A = F == null ? void 0 : F.cancel) === null || A === void 0 || A.call(F);
      };
    }
    S(!1);
  }, [r, n]);
  const E = c.useMemo(() => typeof f != "undefined" && !p, [f, p]);
  if (process.env.NODE_ENV !== "production") {
    const F = xn("Spin");
    process.env.NODE_ENV !== "production" && F(!s || E || p, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const {
    direction: O,
    spin: $
  } = c.useContext(Ft), _ = se(b, $ == null ? void 0 : $.className, {
    [`${b}-sm`]: a === "small",
    [`${b}-lg`]: a === "large",
    [`${b}-spinning`]: x,
    [`${b}-show-text`]: !!s,
    [`${b}-fullscreen`]: p,
    [`${b}-fullscreen-show`]: p && x,
    [`${b}-rtl`]: O === "rtl"
  }, o, i, v, C), R = se(`${b}-container`, {
    [`${b}-blur`]: x
  }), P = dr(h, ["indicator"]), I = Object.assign(Object.assign({}, $ == null ? void 0 : $.style), u), j = /* @__PURE__ */ c.createElement("div", Object.assign({}, P, {
    style: I,
    className: _,
    "aria-live": "polite",
    "aria-busy": x
  }), ote(b, e), s && (E || p) ? /* @__PURE__ */ c.createElement("div", {
    className: `${b}-text`
  }, s) : null);
  return m(E ? /* @__PURE__ */ c.createElement("div", Object.assign({}, P, {
    className: se(`${b}-nested-loading`, l, v, C)
  }), x && /* @__PURE__ */ c.createElement("div", {
    key: "loading"
  }, j), /* @__PURE__ */ c.createElement("div", {
    className: R,
    key: "container"
  }, f)) : j);
};
pC.setDefaultIndicator = (e) => {
  ih = e;
};
process.env.NODE_ENV !== "production" && (pC.displayName = "Spin");
const af = pC;
let vi = null, ol = (e) => e(), Nd = [], Pd = {};
function BE() {
  const {
    getContainer: e,
    duration: t,
    rtl: n,
    maxCount: r,
    top: o
  } = Pd, i = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => i,
    duration: t,
    rtl: n,
    maxCount: r,
    top: o
  };
}
const ate = /* @__PURE__ */ be.forwardRef((e, t) => {
  const {
    messageConfig: n,
    sync: r
  } = e, {
    getPrefixCls: o
  } = Cn(Ft), i = Pd.prefixCls || o("message"), a = Cn(hK), [s, l] = N5(Object.assign(Object.assign(Object.assign({}, n), {
    prefixCls: i
  }), a.message));
  return be.useImperativeHandle(t, () => {
    const u = Object.assign({}, s);
    return Object.keys(u).forEach((f) => {
      u[f] = function() {
        return r(), s[f].apply(s, arguments);
      };
    }), {
      instance: u,
      sync: r
    };
  }), l;
}), ste = /* @__PURE__ */ be.forwardRef((e, t) => {
  const [n, r] = be.useState(BE), o = () => {
    r(BE);
  };
  be.useEffect(o, []);
  const i = s5(), a = i.getRootPrefixCls(), s = i.getIconPrefixCls(), l = i.getTheme(), u = /* @__PURE__ */ be.createElement(ate, {
    ref: t,
    sync: o,
    messageConfig: n
  });
  return /* @__PURE__ */ be.createElement(vb, {
    prefixCls: a,
    iconPrefixCls: s,
    theme: l
  }, i.holderRender ? i.holderRender(u) : u);
});
function rm() {
  if (!vi) {
    const e = document.createDocumentFragment(), t = {
      fragment: e
    };
    vi = t, ol(() => {
      P5(/* @__PURE__ */ be.createElement(ste, {
        ref: (n) => {
          const {
            instance: r,
            sync: o
          } = n || {};
          Promise.resolve().then(() => {
            !t.instance && r && (t.instance = r, t.sync = o, rm());
          });
        }
      }), e);
    });
    return;
  }
  vi.instance && (Nd.forEach((e) => {
    const {
      type: t,
      skipped: n
    } = e;
    if (!n)
      switch (t) {
        case "open": {
          ol(() => {
            const r = vi.instance.open(Object.assign(Object.assign({}, Pd), e.config));
            r == null || r.then(e.resolve), e.setCloseFn(r);
          });
          break;
        }
        case "destroy":
          ol(() => {
            vi == null || vi.instance.destroy(e.key);
          });
          break;
        default:
          ol(() => {
            var r;
            const o = (r = vi.instance)[t].apply(r, We(e.args));
            o == null || o.then(e.resolve), e.setCloseFn(o);
          });
      }
  }), Nd = []);
}
function lte(e) {
  Pd = Object.assign(Object.assign({}, Pd), e), ol(() => {
    var t;
    (t = vi == null ? void 0 : vi.sync) === null || t === void 0 || t.call(vi);
  });
}
function cte(e) {
  const t = Cb((n) => {
    let r;
    const o = {
      type: "open",
      config: e,
      resolve: n,
      setCloseFn: (i) => {
        r = i;
      }
    };
    return Nd.push(o), () => {
      r ? ol(() => {
        r();
      }) : o.skipped = !0;
    };
  });
  return rm(), t;
}
function ute(e, t) {
  const n = s5();
  process.env.NODE_ENV !== "production" && !n.holderRender && CH("message");
  const r = Cb((o) => {
    let i;
    const a = {
      type: e,
      args: t,
      resolve: o,
      setCloseFn: (s) => {
        i = s;
      }
    };
    return Nd.push(a), () => {
      i ? ol(() => {
        i();
      }) : a.skipped = !0;
    };
  });
  return rm(), r;
}
function dte(e) {
  Nd.push({
    type: "destroy",
    key: e
  }), rm();
}
const fte = ["success", "info", "warning", "error", "loading"], pte = {
  open: cte,
  destroy: dte,
  config: lte,
  useMessage: Rz,
  _InternalPanelDoNotUseOrYouWillBeFired: wz
}, Id = pte;
fte.forEach((e) => {
  Id[e] = function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return ute(e, n);
  };
});
process.env.NODE_ENV;
process.env.NODE_ENV;
const hte = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    antCls: r,
    zIndexPopup: o,
    colorText: i,
    colorWarning: a,
    marginXXS: s,
    marginXS: l,
    fontSize: u,
    fontWeightStrong: f,
    colorTextHeading: p
  } = e;
  return {
    [t]: {
      zIndex: o,
      [`&${r}-popover`]: {
        fontSize: u
      },
      [`${t}-message`]: {
        marginBottom: l,
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${t}-message-icon ${n}`]: {
          color: a,
          fontSize: u,
          lineHeight: 1,
          marginInlineEnd: l
        },
        [`${t}-title`]: {
          fontWeight: f,
          color: p,
          "&:only-child": {
            fontWeight: "normal"
          }
        },
        [`${t}-description`]: {
          marginTop: s,
          color: i
        }
      },
      [`${t}-buttons`]: {
        textAlign: "end",
        whiteSpace: "nowrap",
        button: {
          marginInlineStart: l
        }
      }
    }
  };
}, gte = (e) => {
  const {
    zIndexPopupBase: t
  } = e;
  return {
    zIndexPopup: t + 60
  };
}, C8 = Gn("Popconfirm", (e) => hte(e), gte, {
  resetStyle: !1
});
var mte = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const x8 = (e) => {
  const {
    prefixCls: t,
    okButtonProps: n,
    cancelButtonProps: r,
    title: o,
    description: i,
    cancelText: a,
    okText: s,
    okType: l = "primary",
    icon: u = /* @__PURE__ */ c.createElement(wg, null),
    showCancel: f = !0,
    close: p,
    onConfirm: h,
    onCancel: y,
    onPopupClick: b
  } = e, {
    getPrefixCls: m
  } = c.useContext(Ft), [v] = _l("Popconfirm", za.Popconfirm), C = kc(o), x = kc(i);
  return /* @__PURE__ */ c.createElement("div", {
    className: `${t}-inner-content`,
    onClick: b
  }, /* @__PURE__ */ c.createElement("div", {
    className: `${t}-message`
  }, u && /* @__PURE__ */ c.createElement("span", {
    className: `${t}-message-icon`
  }, u), /* @__PURE__ */ c.createElement("div", {
    className: `${t}-message-text`
  }, C && /* @__PURE__ */ c.createElement("div", {
    className: se(`${t}-title`)
  }, C), x && /* @__PURE__ */ c.createElement("div", {
    className: `${t}-description`
  }, x))), /* @__PURE__ */ c.createElement("div", {
    className: `${t}-buttons`
  }, f && /* @__PURE__ */ c.createElement(Io, Object.assign({
    onClick: y,
    size: "small"
  }, r), a || (v == null ? void 0 : v.cancelText)), /* @__PURE__ */ c.createElement(AV, {
    buttonProps: Object.assign(Object.assign({
      size: "small"
    }, M5(l)), n),
    actionFn: h,
    close: p,
    prefixCls: m("btn"),
    quitOnNullishReturnValue: !0,
    emitEvent: !0
  }, s || (v == null ? void 0 : v.okText))));
}, vte = (e) => {
  const {
    prefixCls: t,
    placement: n,
    className: r,
    style: o
  } = e, i = mte(e, ["prefixCls", "placement", "className", "style"]), {
    getPrefixCls: a
  } = c.useContext(Ft), s = a("popconfirm", t), [l] = C8(s);
  return l(/* @__PURE__ */ c.createElement(W6, {
    placement: n,
    className: se(s, r),
    style: o,
    content: /* @__PURE__ */ c.createElement(x8, Object.assign({
      prefixCls: s
    }, i))
  }));
}, yte = vte;
var bte = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const hC = /* @__PURE__ */ c.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: o,
    placement: i = "top",
    trigger: a = "click",
    okType: s = "primary",
    icon: l = /* @__PURE__ */ c.createElement(wg, null),
    children: u,
    overlayClassName: f,
    onOpenChange: p,
    onVisibleChange: h
  } = e, y = bte(e, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName", "onOpenChange", "onVisibleChange"]), {
    getPrefixCls: b
  } = c.useContext(Ft), [m, v] = Fn(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), C = (I, j) => {
    v(I, !0), h == null || h(I), p == null || p(I, j);
  }, x = (I) => {
    C(!1, I);
  }, S = (I) => {
    var j;
    return (j = e.onConfirm) === null || j === void 0 ? void 0 : j.call(void 0, I);
  }, E = (I) => {
    var j;
    C(!1, I), (j = e.onCancel) === null || j === void 0 || j.call(void 0, I);
  }, O = (I) => {
    I.keyCode === Pe.ESC && m && C(!1, I);
  }, $ = (I) => {
    const {
      disabled: j = !1
    } = e;
    j || C(I);
  }, _ = b("popconfirm", o), R = se(_, f), [P] = C8(_);
  return P(/* @__PURE__ */ c.createElement(K6, Object.assign({}, dr(y, ["title"]), {
    trigger: a,
    placement: i,
    onOpenChange: $,
    open: m,
    ref: t,
    overlayClassName: R,
    content: /* @__PURE__ */ c.createElement(x8, Object.assign({
      okType: s,
      icon: l
    }, e, {
      prefixCls: _,
      close: x,
      onConfirm: S,
      onCancel: E
    })),
    "data-popover-inject": !0
  }), Yr(u, {
    onKeyDown: (I) => {
      var j, F;
      /* @__PURE__ */ c.isValidElement(u) && ((F = u == null ? void 0 : (j = u.props).onKeyDown) === null || F === void 0 || F.call(j, I)), O(I);
    }
  })));
});
hC._InternalPanelDoNotUseOrYouWillBeFired = yte;
process.env.NODE_ENV !== "production" && (hC.displayName = "Popconfirm");
const gC = hC;
var Cte = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, xte = function() {
  var t = _t([]), n = _t(null);
  return kt(function() {
    var r = Date.now(), o = !1;
    t.current.forEach(function(i) {
      if (i) {
        o = !0;
        var a = i.style;
        a.transitionDuration = ".3s, .3s, .3s, .06s", n.current && r - n.current < 100 && (a.transitionDuration = "0s, 0s");
      }
    }), o && (n.current = Date.now());
  }), t.current;
};
process.env.NODE_ENV;
var HE = 0, Ste = process.env.NODE_ENV !== "test" && Hr();
function wte() {
  var e;
  return Ste ? (e = HE, HE += 1) : e = "TEST_OR_SSR", e;
}
const Ete = function(e) {
  var t = c.useState(), n = de(t, 2), r = n[0], o = n[1];
  return c.useEffect(function() {
    o("rc_progress_".concat(wte()));
  }, []), e || r;
};
var zE = function(t) {
  var n = t.bg, r = t.children;
  return /* @__PURE__ */ c.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: n
    }
  }, r);
};
function VE(e, t) {
  return Object.keys(e).map(function(n) {
    var r = parseFloat(n), o = "".concat(Math.floor(r * t), "%");
    return "".concat(e[n], " ").concat(o);
  });
}
var S8 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.color, o = e.gradientId, i = e.radius, a = e.style, s = e.ptg, l = e.strokeLinecap, u = e.strokeWidth, f = e.size, p = e.gapDegree, h = r && Vt(r) === "object", y = h ? "#FFF" : void 0, b = f / 2, m = /* @__PURE__ */ c.createElement("circle", {
    className: "".concat(n, "-circle-path"),
    r: i,
    cx: b,
    cy: b,
    stroke: y,
    strokeLinecap: l,
    strokeWidth: u,
    opacity: s === 0 ? 0 : 1,
    style: a,
    ref: t
  });
  if (!h)
    return m;
  var v = "".concat(o, "-conic"), C = p ? "".concat(180 + p / 2, "deg") : "0deg", x = VE(r, (360 - p) / 360), S = VE(r, 1), E = "conic-gradient(from ".concat(C, ", ").concat(x.join(", "), ")"), O = "linear-gradient(to ".concat(p ? "bottom" : "top", ", ").concat(S.join(", "), ")");
  return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("mask", {
    id: v
  }, m), /* @__PURE__ */ c.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: f,
    height: f,
    mask: "url(#".concat(v, ")")
  }, /* @__PURE__ */ c.createElement(zE, {
    bg: O
  }, /* @__PURE__ */ c.createElement(zE, {
    bg: E
  }))));
});
process.env.NODE_ENV !== "production" && (S8.displayName = "PtgCircle");
var Qu = 100, c0 = function(t, n, r, o, i, a, s, l, u, f) {
  var p = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, h = r / 100 * 360 * ((360 - a) / 360), y = a === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[s], b = (100 - o) / 100 * n;
  u === "round" && o !== 100 && (b += f / 2, b >= n && (b = n - 0.01));
  var m = Qu / 2;
  return {
    stroke: typeof l == "string" ? l : void 0,
    strokeDasharray: "".concat(n, "px ").concat(t),
    strokeDashoffset: b + p,
    transform: "rotate(".concat(i + h + y, "deg)"),
    transformOrigin: "".concat(m, "px ").concat(m, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, $te = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function WE(e) {
  var t = e != null ? e : [];
  return Array.isArray(t) ? t : [t];
}
var w8 = function(t) {
  var n = J(J({}, Cte), t), r = n.id, o = n.prefixCls, i = n.steps, a = n.strokeWidth, s = n.trailWidth, l = n.gapDegree, u = l === void 0 ? 0 : l, f = n.gapPosition, p = n.trailColor, h = n.strokeLinecap, y = n.style, b = n.className, m = n.strokeColor, v = n.percent, C = Yt(n, $te), x = Qu / 2, S = Ete(r), E = "".concat(S, "-gradient"), O = x - a / 2, $ = Math.PI * 2 * O, _ = u > 0 ? 90 + u / 2 : -90, R = $ * ((360 - u) / 360), P = Vt(i) === "object" ? i : {
    count: i,
    space: 2
  }, I = P.count, j = P.space, F = WE(v), A = WE(m), M = A.find(function(V) {
    return V && Vt(V) === "object";
  }), N = M && Vt(M) === "object", D = N ? "butt" : h, T = c0($, R, 0, 100, _, u, f, p, D, a), L = xte(), z = function() {
    var Y = 0;
    return F.map(function(Z, oe) {
      var ee = A[oe] || A[A.length - 1], ae = c0($, R, Y, Z, _, u, f, ee, D, a);
      return Y += Z, /* @__PURE__ */ c.createElement(S8, {
        key: oe,
        color: ee,
        ptg: Z,
        radius: O,
        prefixCls: o,
        gradientId: E,
        style: ae,
        strokeLinecap: D,
        strokeWidth: a,
        gapDegree: u,
        ref: function(ue) {
          L[oe] = ue;
        },
        size: Qu
      });
    }).reverse();
  }, H = function() {
    var Y = Math.round(I * (F[0] / 100)), Z = 100 / I, oe = 0;
    return new Array(I).fill(null).map(function(ee, ae) {
      var le = ae <= Y - 1 ? A[0] : p, ue = le && Vt(le) === "object" ? "url(#".concat(E, ")") : void 0, ie = c0($, R, oe, Z, _, u, f, le, "butt", a, j);
      return oe += (R - ie.strokeDashoffset + j) * 100 / R, /* @__PURE__ */ c.createElement("circle", {
        key: ae,
        className: "".concat(o, "-circle-path"),
        r: O,
        cx: x,
        cy: x,
        stroke: ue,
        strokeWidth: a,
        opacity: 1,
        style: ie,
        ref: function(Q) {
          L[ae] = Q;
        }
      });
    });
  };
  return /* @__PURE__ */ c.createElement("svg", Oe({
    className: se("".concat(o, "-circle"), b),
    viewBox: "0 0 ".concat(Qu, " ").concat(Qu),
    style: y,
    id: r,
    role: "presentation"
  }, C), !I && /* @__PURE__ */ c.createElement("circle", {
    className: "".concat(o, "-circle-trail"),
    r: O,
    cx: x,
    cy: x,
    stroke: p,
    strokeLinecap: D,
    strokeWidth: s || a,
    style: T
  }), I ? H() : z());
};
process.env.NODE_ENV !== "production" && (w8.displayName = "Circle");
function Ss(e) {
  return !e || e < 0 ? 0 : e > 100 ? 100 : e;
}
function Wh(e) {
  let {
    success: t,
    successPercent: n
  } = e, r = n;
  return t && "progress" in t && (r = t.progress), t && "percent" in t && (r = t.percent), r;
}
const Ote = (e) => {
  let {
    percent: t,
    success: n,
    successPercent: r
  } = e;
  const o = Ss(Wh({
    success: n,
    successPercent: r
  }));
  return [o, Ss(Ss(t) - o)];
}, _te = (e) => {
  let {
    success: t = {},
    strokeColor: n
  } = e;
  const {
    strokeColor: r
  } = t;
  return [r || bc.green, n || null];
}, om = (e, t, n) => {
  var r, o, i, a;
  let s = -1, l = -1;
  if (t === "step") {
    const u = n.steps, f = n.strokeWidth;
    typeof e == "string" || typeof e == "undefined" ? (s = e === "small" ? 2 : 14, l = f != null ? f : 8) : typeof e == "number" ? [s, l] = [e, e] : [s = 14, l = 8] = e, s *= u;
  } else if (t === "line") {
    const u = n == null ? void 0 : n.strokeWidth;
    typeof e == "string" || typeof e == "undefined" ? l = u || (e === "small" ? 6 : 8) : typeof e == "number" ? [s, l] = [e, e] : [s = -1, l = 8] = e;
  } else
    (t === "circle" || t === "dashboard") && (typeof e == "string" || typeof e == "undefined" ? [s, l] = e === "small" ? [60, 60] : [120, 120] : typeof e == "number" ? [s, l] = [e, e] : (s = (o = (r = e[0]) !== null && r !== void 0 ? r : e[1]) !== null && o !== void 0 ? o : 120, l = (a = (i = e[0]) !== null && i !== void 0 ? i : e[1]) !== null && a !== void 0 ? a : 120));
  return [s, l];
}, Nte = 3, Pte = (e) => Nte / e * 100, Ite = (e) => {
  const {
    prefixCls: t,
    trailColor: n = null,
    strokeLinecap: r = "round",
    gapPosition: o,
    gapDegree: i,
    width: a = 120,
    type: s,
    children: l,
    success: u,
    size: f = a
  } = e, [p, h] = om(f, "circle");
  let {
    strokeWidth: y
  } = e;
  y === void 0 && (y = Math.max(Pte(p), 6));
  const b = {
    width: p,
    height: h,
    fontSize: p * 0.15 + 6
  }, m = c.useMemo(() => {
    if (i || i === 0)
      return i;
    if (s === "dashboard")
      return 75;
  }, [i, s]), v = o || s === "dashboard" && "bottom" || void 0, C = Object.prototype.toString.call(e.strokeColor) === "[object Object]", x = _te({
    success: u,
    strokeColor: e.strokeColor
  }), S = se(`${t}-inner`, {
    [`${t}-circle-gradient`]: C
  }), E = /* @__PURE__ */ c.createElement(w8, {
    percent: Ote(e),
    strokeWidth: y,
    trailWidth: y,
    strokeColor: x,
    strokeLinecap: r,
    trailColor: n,
    prefixCls: t,
    gapDegree: m,
    gapPosition: v
  });
  return /* @__PURE__ */ c.createElement("div", {
    className: S,
    style: b
  }, p <= 20 ? /* @__PURE__ */ c.createElement(Bo, {
    title: l
  }, /* @__PURE__ */ c.createElement("span", null, E)) : /* @__PURE__ */ c.createElement(c.Fragment, null, E, l));
}, Rte = Ite, Kh = "--progress-line-stroke-color", E8 = "--progress-percent", KE = (e) => {
  const t = e ? "100%" : "-100%";
  return new Bn(`antProgress${e ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${t}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
}, Dte = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Qn(e)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: e.fontSize,
        marginInlineEnd: e.marginXS,
        marginBottom: e.marginXS
      },
      [`${t}-outer`]: {
        display: "inline-block",
        width: "100%"
      },
      [`&${t}-show-info`]: {
        [`${t}-outer`]: {
          marginInlineEnd: `calc(-2em - ${te(e.marginXS)})`,
          paddingInlineEnd: `calc(2em + ${te(e.paddingXS)})`
        }
      },
      [`${t}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: e.remainingColor,
        borderRadius: e.lineBorderRadius
      },
      [`${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.defaultColor
        }
      },
      [`${t}-success-bg, ${t}-bg`]: {
        position: "relative",
        background: e.defaultColor,
        borderRadius: e.lineBorderRadius,
        transition: `all ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`
      },
      [`${t}-bg`]: {
        overflow: "hidden",
        "&::after": {
          content: '""',
          background: {
            _multi_value_: !0,
            value: ["inherit", `var(${Kh})`]
          },
          height: "100%",
          width: `calc(1 / var(${E8}) * 100%)`,
          display: "block"
        }
      },
      [`${t}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: e.colorSuccess
      },
      [`${t}-text`]: {
        display: "inline-block",
        width: "2em",
        marginInlineStart: e.marginXS,
        color: e.colorText,
        lineHeight: 1,
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [n]: {
          fontSize: e.fontSize
        }
      },
      [`&${t}-status-active`]: {
        [`${t}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: e.colorBgContainer,
          borderRadius: e.lineBorderRadius,
          opacity: 0,
          animationName: KE(),
          animationDuration: e.progressActiveMotionDuration,
          animationTimingFunction: e.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${t}-rtl${t}-status-active`]: {
        [`${t}-bg::before`]: {
          animationName: KE(!0)
        }
      },
      [`&${t}-status-exception`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorError
        },
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`&${t}-status-exception ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorError
        }
      },
      [`&${t}-status-success`]: {
        [`${t}-bg`]: {
          backgroundColor: e.colorSuccess
        },
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      },
      [`&${t}-status-success ${t}-inner:not(${t}-circle-gradient)`]: {
        [`${t}-circle-path`]: {
          stroke: e.colorSuccess
        }
      }
    })
  };
}, Tte = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: {
      [`${t}-circle-trail`]: {
        stroke: e.remainingColor
      },
      [`&${t}-circle ${t}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${t}-circle ${t}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: e.circleTextColor,
        fontSize: e.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [n]: {
          fontSize: e.circleIconFontSize
        }
      },
      [`${t}-circle&-status-exception`]: {
        [`${t}-text`]: {
          color: e.colorError
        }
      },
      [`${t}-circle&-status-success`]: {
        [`${t}-text`]: {
          color: e.colorSuccess
        }
      }
    },
    [`${t}-inline-circle`]: {
      lineHeight: 1,
      [`${t}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
}, Mte = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`${t}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: e.progressStepMinWidth,
          marginInlineEnd: e.progressStepMarginInlineEnd,
          backgroundColor: e.remainingColor,
          transition: `all ${e.motionDurationSlow}`,
          "&-active": {
            backgroundColor: e.defaultColor
          }
        }
      }
    }
  };
}, Lte = (e) => {
  const {
    componentCls: t,
    iconCls: n
  } = e;
  return {
    [t]: {
      [`${t}-small&-line, ${t}-small&-line ${t}-text ${n}`]: {
        fontSize: e.fontSizeSM
      }
    }
  };
}, Ate = (e) => ({
  circleTextColor: e.colorText,
  defaultColor: e.colorInfo,
  remainingColor: e.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${e.fontSize / e.fontSizeSM}em`
}), jte = Gn("Progress", (e) => {
  const t = e.calc(e.marginXXS).div(2).equal(), n = Sn(e, {
    progressStepMarginInlineEnd: t,
    progressStepMinWidth: t,
    progressActiveMotionDuration: "2.4s"
  });
  return [Dte(n), Tte(n), Mte(n), Lte(n)];
}, Ate);
var kte = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Fte = (e) => {
  let t = [];
  return Object.keys(e).forEach((n) => {
    const r = parseFloat(n.replace(/%/g, ""));
    isNaN(r) || t.push({
      key: r,
      value: e[n]
    });
  }), t = t.sort((n, r) => n.key - r.key), t.map((n) => {
    let {
      key: r,
      value: o
    } = n;
    return `${o} ${r}%`;
  }).join(", ");
}, Bte = (e, t) => {
  const {
    from: n = bc.blue,
    to: r = bc.blue,
    direction: o = t === "rtl" ? "to left" : "to right"
  } = e, i = kte(e, ["from", "to", "direction"]);
  if (Object.keys(i).length !== 0) {
    const s = Fte(i), l = `linear-gradient(${o}, ${s})`;
    return {
      background: l,
      [Kh]: l
    };
  }
  const a = `linear-gradient(${o}, ${n}, ${r})`;
  return {
    background: a,
    [Kh]: a
  };
}, Hte = (e) => {
  const {
    prefixCls: t,
    direction: n,
    percent: r,
    size: o,
    strokeWidth: i,
    strokeColor: a,
    strokeLinecap: s = "round",
    children: l,
    trailColor: u = null,
    success: f
  } = e, p = a && typeof a != "string" ? Bte(a, n) : {
    [Kh]: a,
    background: a
  }, h = s === "square" || s === "butt" ? 0 : void 0, y = o != null ? o : [-1, i || (o === "small" ? 6 : 8)], [b, m] = om(y, "line", {
    strokeWidth: i
  });
  process.env.NODE_ENV !== "production" && xn("Progress").deprecated(!("strokeWidth" in e), "strokeWidth", "size");
  const v = {
    backgroundColor: u || void 0,
    borderRadius: h
  }, C = Object.assign(Object.assign({
    width: `${Ss(r)}%`,
    height: m,
    borderRadius: h
  }, p), {
    [E8]: Ss(r) / 100
  }), x = Wh(e), S = {
    width: `${Ss(x)}%`,
    height: m,
    borderRadius: h,
    backgroundColor: f == null ? void 0 : f.strokeColor
  }, E = {
    width: b < 0 ? "100%" : b,
    height: m
  };
  return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("div", {
    className: `${t}-outer`,
    style: E
  }, /* @__PURE__ */ c.createElement("div", {
    className: `${t}-inner`,
    style: v
  }, /* @__PURE__ */ c.createElement("div", {
    className: `${t}-bg`,
    style: C
  }), x !== void 0 ? /* @__PURE__ */ c.createElement("div", {
    className: `${t}-success-bg`,
    style: S
  }) : null)), l);
}, zte = Hte, Vte = (e) => {
  const {
    size: t,
    steps: n,
    percent: r = 0,
    strokeWidth: o = 8,
    strokeColor: i,
    trailColor: a = null,
    prefixCls: s,
    children: l
  } = e, u = Math.round(n * (r / 100)), f = t === "small" ? 2 : 14, p = t != null ? t : [f, o], [h, y] = om(p, "step", {
    steps: n,
    strokeWidth: o
  }), b = h / n, m = new Array(n);
  for (let v = 0; v < n; v++) {
    const C = Array.isArray(i) ? i[v] : i;
    m[v] = /* @__PURE__ */ c.createElement("div", {
      key: v,
      className: se(`${s}-steps-item`, {
        [`${s}-steps-item-active`]: v <= u - 1
      }),
      style: {
        backgroundColor: v <= u - 1 ? C : a,
        width: b,
        height: y
      }
    });
  }
  return /* @__PURE__ */ c.createElement("div", {
    className: `${s}-steps-outer`
  }, m, l);
}, Wte = Vte;
var Kte = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Ute = ["normal", "exception", "active", "success"], $8 = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    rootClassName: o,
    steps: i,
    strokeColor: a,
    percent: s = 0,
    size: l = "default",
    showInfo: u = !0,
    type: f = "line",
    status: p,
    format: h,
    style: y
  } = e, b = Kte(e, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style"]), m = c.useMemo(() => {
    var A, M;
    const N = Wh(e);
    return parseInt(N !== void 0 ? (A = N != null ? N : 0) === null || A === void 0 ? void 0 : A.toString() : (M = s != null ? s : 0) === null || M === void 0 ? void 0 : M.toString(), 10);
  }, [s, e.success, e.successPercent]), v = c.useMemo(() => !Ute.includes(p) && m >= 100 ? "success" : p || "normal", [p, m]), {
    getPrefixCls: C,
    direction: x,
    progress: S
  } = c.useContext(Ft), E = C("progress", n), [O, $, _] = jte(E), R = c.useMemo(() => {
    if (!u)
      return null;
    const A = Wh(e);
    let M;
    const N = h || ((T) => `${T}%`), D = f === "line";
    return h || v !== "exception" && v !== "success" ? M = N(Ss(s), Ss(A)) : v === "exception" ? M = D ? /* @__PURE__ */ c.createElement(Ds, null) : /* @__PURE__ */ c.createElement(Gd, null) : v === "success" && (M = D ? /* @__PURE__ */ c.createElement(bb, null) : /* @__PURE__ */ c.createElement(Bg, null)), /* @__PURE__ */ c.createElement("span", {
      className: `${E}-text`,
      title: typeof M == "string" ? M : void 0
    }, M);
  }, [u, s, m, v, f, E, h]);
  if (process.env.NODE_ENV !== "production") {
    const A = xn("Progress");
    A.deprecated(!("successPercent" in e), "successPercent", "success.percent"), A.deprecated(!("width" in e), "width", "size"), (f === "circle" || f === "dashboard") && Array.isArray(l) && process.env.NODE_ENV !== "production" && A(!1, "usage", 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.'), e.success && "progress" in e.success && A.deprecated(!1, "success.progress", "success.percent");
  }
  const P = Array.isArray(a) ? a[0] : a, I = typeof a == "string" || Array.isArray(a) ? a : void 0;
  let j;
  f === "line" ? j = i ? /* @__PURE__ */ c.createElement(Wte, Object.assign({}, e, {
    strokeColor: I,
    prefixCls: E,
    steps: i
  }), R) : /* @__PURE__ */ c.createElement(zte, Object.assign({}, e, {
    strokeColor: P,
    prefixCls: E,
    direction: x
  }), R) : (f === "circle" || f === "dashboard") && (j = /* @__PURE__ */ c.createElement(Rte, Object.assign({}, e, {
    strokeColor: P,
    prefixCls: E,
    progressStatus: v
  }), R));
  const F = se(E, `${E}-status-${v}`, `${E}-${f === "dashboard" && "circle" || i && "steps" || f}`, {
    [`${E}-inline-circle`]: f === "circle" && om(l, "circle")[0] <= 20,
    [`${E}-show-info`]: u,
    [`${E}-${l}`]: typeof l == "string",
    [`${E}-rtl`]: x === "rtl"
  }, S == null ? void 0 : S.className, r, o, $, _);
  return O(/* @__PURE__ */ c.createElement("div", Object.assign({
    ref: t,
    style: Object.assign(Object.assign({}, S == null ? void 0 : S.style), y),
    className: F,
    role: "progressbar",
    "aria-valuenow": m
  }, dr(b, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), j));
});
process.env.NODE_ENV !== "production" && ($8.displayName = "Progress");
const Gte = $8;
var qte = ["className", "prefixCls", "style", "active", "status", "iconPrefix", "icon", "wrapperStyle", "stepNumber", "disabled", "description", "title", "subTitle", "progressDot", "stepIcon", "tailContent", "icons", "stepIndex", "onStepClick", "onClick", "render"];
function UE(e) {
  return typeof e == "string";
}
function O8(e) {
  var t, n = e.className, r = e.prefixCls, o = e.style, i = e.active, a = e.status, s = e.iconPrefix, l = e.icon;
  e.wrapperStyle;
  var u = e.stepNumber, f = e.disabled, p = e.description, h = e.title, y = e.subTitle, b = e.progressDot, m = e.stepIcon, v = e.tailContent, C = e.icons, x = e.stepIndex, S = e.onStepClick, E = e.onClick, O = e.render, $ = Yt(e, qte), _ = !!S && !f, R = {};
  _ && (R.role = "button", R.tabIndex = 0, R.onClick = function(M) {
    E == null || E(M), S(x);
  }, R.onKeyDown = function(M) {
    var N = M.which;
    (N === Pe.ENTER || N === Pe.SPACE) && S(x);
  });
  var P = function() {
    var N, D, T = se("".concat(r, "-icon"), "".concat(s, "icon"), (N = {}, K(N, "".concat(s, "icon-").concat(l), l && UE(l)), K(N, "".concat(s, "icon-check"), !l && a === "finish" && (C && !C.finish || !C)), K(N, "".concat(s, "icon-cross"), !l && a === "error" && (C && !C.error || !C)), N)), L = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon-dot")
    });
    return b ? typeof b == "function" ? D = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon")
    }, b(L, {
      index: u - 1,
      status: a,
      title: h,
      description: p
    })) : D = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon")
    }, L) : l && !UE(l) ? D = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon")
    }, l) : C && C.finish && a === "finish" ? D = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon")
    }, C.finish) : C && C.error && a === "error" ? D = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon")
    }, C.error) : l || a === "finish" || a === "error" ? D = /* @__PURE__ */ c.createElement("span", {
      className: T
    }) : D = /* @__PURE__ */ c.createElement("span", {
      className: "".concat(r, "-icon")
    }, u), m && (D = m({
      index: u - 1,
      status: a,
      title: h,
      description: p,
      node: D
    })), D;
  }, I = a || "wait", j = se("".concat(r, "-item"), "".concat(r, "-item-").concat(I), n, (t = {}, K(t, "".concat(r, "-item-custom"), l), K(t, "".concat(r, "-item-active"), i), K(t, "".concat(r, "-item-disabled"), f === !0), t)), F = J({}, o), A = /* @__PURE__ */ c.createElement("div", Oe({}, $, {
    className: j,
    style: F
  }), /* @__PURE__ */ c.createElement("div", Oe({
    onClick: E
  }, R, {
    className: "".concat(r, "-item-container")
  }), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(r, "-item-tail")
  }, v), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(r, "-item-icon")
  }, P()), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(r, "-item-content")
  }, /* @__PURE__ */ c.createElement("div", {
    className: "".concat(r, "-item-title")
  }, h, y && /* @__PURE__ */ c.createElement("div", {
    title: typeof y == "string" ? y : void 0,
    className: "".concat(r, "-item-subtitle")
  }, y)), p && /* @__PURE__ */ c.createElement("div", {
    className: "".concat(r, "-item-description")
  }, p))));
  return O && (A = O(A) || null), A;
}
var Yte = ["prefixCls", "style", "className", "children", "direction", "type", "labelPlacement", "iconPrefix", "status", "size", "current", "progressDot", "stepIcon", "initial", "icons", "onChange", "itemRender", "items"];
function mC(e) {
  var t, n = e.prefixCls, r = n === void 0 ? "rc-steps" : n, o = e.style, i = o === void 0 ? {} : o, a = e.className;
  e.children;
  var s = e.direction, l = s === void 0 ? "horizontal" : s, u = e.type, f = u === void 0 ? "default" : u, p = e.labelPlacement, h = p === void 0 ? "horizontal" : p, y = e.iconPrefix, b = y === void 0 ? "rc" : y, m = e.status, v = m === void 0 ? "process" : m, C = e.size, x = e.current, S = x === void 0 ? 0 : x, E = e.progressDot, O = E === void 0 ? !1 : E, $ = e.stepIcon, _ = e.initial, R = _ === void 0 ? 0 : _, P = e.icons, I = e.onChange, j = e.itemRender, F = e.items, A = F === void 0 ? [] : F, M = Yt(e, Yte), N = f === "navigation", D = f === "inline", T = D || O, L = D ? "horizontal" : l, z = D ? void 0 : C, H = T ? "vertical" : h, V = se(r, "".concat(r, "-").concat(L), a, (t = {}, K(t, "".concat(r, "-").concat(z), z), K(t, "".concat(r, "-label-").concat(H), L === "horizontal"), K(t, "".concat(r, "-dot"), !!T), K(t, "".concat(r, "-navigation"), N), K(t, "".concat(r, "-inline"), D), t)), Y = function(ee) {
    I && S !== ee && I(ee);
  }, Z = function(ee, ae) {
    var le = J({}, ee), ue = R + ae;
    return v === "error" && ae === S - 1 && (le.className = "".concat(r, "-next-error")), le.status || (ue === S ? le.status = v : ue < S ? le.status = "finish" : le.status = "wait"), D && (le.icon = void 0, le.subTitle = void 0), !le.render && j && (le.render = function(ie) {
      return j(le, ie);
    }), /* @__PURE__ */ be.createElement(O8, Oe({}, le, {
      active: ue === S,
      stepNumber: ue + 1,
      stepIndex: ue,
      key: ue,
      prefixCls: r,
      iconPrefix: b,
      wrapperStyle: i,
      progressDot: T,
      stepIcon: $,
      icons: P,
      onStepClick: I && Y
    }));
  };
  return /* @__PURE__ */ be.createElement("div", Oe({
    className: V,
    style: i
  }, M), A.filter(function(oe) {
    return oe;
  }).map(Z));
}
mC.Step = O8;
const Xte = (e) => {
  const {
    componentCls: t,
    customIconTop: n,
    customIconSize: r,
    customIconFontSize: o
  } = e;
  return {
    [`${t}-item-custom`]: {
      [`> ${t}-item-container > ${t}-item-icon`]: {
        height: "auto",
        background: "none",
        border: 0,
        [`> ${t}-icon`]: {
          top: n,
          width: r,
          height: r,
          fontSize: o,
          lineHeight: `${te(o)}`
        }
      }
    },
    // Only adjust horizontal customize icon width
    [`&:not(${t}-vertical)`]: {
      [`${t}-item-custom`]: {
        [`${t}-item-icon`]: {
          width: "auto",
          background: "none"
        }
      }
    }
  };
}, Zte = (e) => {
  const {
    componentCls: t,
    inlineDotSize: n,
    inlineTitleColor: r,
    inlineTailColor: o
  } = e, i = e.calc(e.paddingXS).add(e.lineWidth).equal(), a = {
    [`${t}-item-container ${t}-item-content ${t}-item-title`]: {
      color: r
    }
  };
  return {
    [`&${t}-inline`]: {
      width: "auto",
      display: "inline-flex",
      [`${t}-item`]: {
        flex: "none",
        "&-container": {
          padding: `${te(i)} ${te(e.paddingXXS)} 0`,
          margin: `0 ${te(e.calc(e.marginXXS).div(2).equal())}`,
          borderRadius: e.borderRadiusSM,
          cursor: "pointer",
          transition: `background-color ${e.motionDurationMid}`,
          "&:hover": {
            background: e.controlItemBgHover
          },
          "&[role='button']:hover": {
            opacity: 1
          }
        },
        "&-icon": {
          width: n,
          height: n,
          marginInlineStart: `calc(50% - ${te(e.calc(n).div(2).equal())})`,
          [`> ${t}-icon`]: {
            top: 0
          },
          [`${t}-icon-dot`]: {
            borderRadius: e.calc(e.fontSizeSM).div(4).equal()
          }
        },
        "&-content": {
          width: "auto",
          marginTop: e.calc(e.marginXS).sub(e.lineWidth).equal()
        },
        "&-title": {
          color: r,
          fontSize: e.fontSizeSM,
          lineHeight: e.lineHeightSM,
          fontWeight: "normal",
          marginBottom: e.calc(e.marginXXS).div(2).equal()
        },
        "&-description": {
          display: "none"
        },
        "&-tail": {
          marginInlineStart: 0,
          top: e.calc(n).div(2).add(i).equal(),
          transform: "translateY(-50%)",
          "&:after": {
            width: "100%",
            height: e.lineWidth,
            borderRadius: 0,
            marginInlineStart: 0,
            background: o
          }
        },
        [`&:first-child ${t}-item-tail`]: {
          width: "50%",
          marginInlineStart: "50%"
        },
        [`&:last-child ${t}-item-tail`]: {
          display: "block",
          width: "50%"
        },
        "&-wait": Object.assign({
          [`${t}-item-icon ${t}-icon ${t}-icon-dot`]: {
            backgroundColor: e.colorBorderBg,
            border: `${te(e.lineWidth)} ${e.lineType} ${o}`
          }
        }, a),
        "&-finish": Object.assign({
          [`${t}-item-tail::after`]: {
            backgroundColor: o
          },
          [`${t}-item-icon ${t}-icon ${t}-icon-dot`]: {
            backgroundColor: o,
            border: `${te(e.lineWidth)} ${e.lineType} ${o}`
          }
        }, a),
        "&-error": a,
        "&-active, &-process": Object.assign({
          [`${t}-item-icon`]: {
            width: n,
            height: n,
            marginInlineStart: `calc(50% - ${te(e.calc(n).div(2).equal())})`,
            top: 0
          }
        }, a),
        [`&:not(${t}-item-active) > ${t}-item-container[role='button']:hover`]: {
          [`${t}-item-title`]: {
            color: r
          }
        }
      }
    }
  };
}, Qte = (e) => {
  const {
    componentCls: t,
    iconSize: n,
    lineHeight: r,
    iconSizeSM: o
  } = e;
  return {
    [`&${t}-label-vertical`]: {
      [`${t}-item`]: {
        overflow: "visible",
        "&-tail": {
          marginInlineStart: e.calc(n).div(2).add(e.controlHeightLG).equal(),
          padding: `${te(e.paddingXXS)} ${te(e.paddingLG)}`
        },
        "&-content": {
          display: "block",
          width: e.calc(n).div(2).add(e.controlHeightLG).mul(2).equal(),
          marginTop: e.marginSM,
          textAlign: "center"
        },
        "&-icon": {
          display: "inline-block",
          marginInlineStart: e.controlHeightLG
        },
        "&-title": {
          paddingInlineEnd: 0,
          paddingInlineStart: 0,
          "&::after": {
            display: "none"
          }
        },
        "&-subtitle": {
          display: "block",
          marginBottom: e.marginXXS,
          marginInlineStart: 0,
          lineHeight: r
        }
      },
      [`&${t}-small:not(${t}-dot)`]: {
        [`${t}-item`]: {
          "&-icon": {
            marginInlineStart: e.calc(n).sub(o).div(2).add(e.controlHeightLG).equal()
          }
        }
      }
    }
  };
}, Jte = (e) => {
  const {
    componentCls: t,
    navContentMaxWidth: n,
    navArrowColor: r,
    stepsNavActiveColor: o,
    motionDurationSlow: i
  } = e;
  return {
    [`&${t}-navigation`]: {
      paddingTop: e.paddingSM,
      [`&${t}-small`]: {
        [`${t}-item`]: {
          "&-container": {
            marginInlineStart: e.calc(e.marginSM).mul(-1).equal()
          }
        }
      },
      [`${t}-item`]: {
        overflow: "visible",
        textAlign: "center",
        "&-container": {
          display: "inline-block",
          height: "100%",
          marginInlineStart: e.calc(e.margin).mul(-1).equal(),
          paddingBottom: e.paddingSM,
          textAlign: "start",
          transition: `opacity ${i}`,
          [`${t}-item-content`]: {
            maxWidth: n
          },
          [`${t}-item-title`]: Object.assign(Object.assign({
            maxWidth: "100%",
            paddingInlineEnd: 0
          }, gl), {
            "&::after": {
              display: "none"
            }
          })
        },
        [`&:not(${t}-item-active)`]: {
          [`${t}-item-container[role='button']`]: {
            cursor: "pointer",
            "&:hover": {
              opacity: 0.85
            }
          }
        },
        "&:last-child": {
          flex: 1,
          "&::after": {
            display: "none"
          }
        },
        "&::after": {
          position: "absolute",
          top: `calc(50% - ${te(e.calc(e.paddingSM).div(2).equal())})`,
          insetInlineStart: "100%",
          display: "inline-block",
          width: e.fontSizeIcon,
          height: e.fontSizeIcon,
          borderTop: `${te(e.lineWidth)} ${e.lineType} ${r}`,
          borderBottom: "none",
          borderInlineStart: "none",
          borderInlineEnd: `${te(e.lineWidth)} ${e.lineType} ${r}`,
          transform: "translateY(-50%) translateX(-50%) rotate(45deg)",
          content: '""'
        },
        "&::before": {
          position: "absolute",
          bottom: 0,
          insetInlineStart: "50%",
          display: "inline-block",
          width: 0,
          height: e.lineWidthBold,
          backgroundColor: o,
          transition: `width ${i}, inset-inline-start ${i}`,
          transitionTimingFunction: "ease-out",
          content: '""'
        }
      },
      [`${t}-item${t}-item-active::before`]: {
        insetInlineStart: 0,
        width: "100%"
      }
    },
    [`&${t}-navigation${t}-vertical`]: {
      [`> ${t}-item`]: {
        marginInlineEnd: 0,
        "&::before": {
          display: "none"
        },
        [`&${t}-item-active::before`]: {
          top: 0,
          insetInlineEnd: 0,
          insetInlineStart: "unset",
          display: "block",
          width: e.calc(e.lineWidth).mul(3).equal(),
          height: `calc(100% - ${te(e.marginLG)})`
        },
        "&::after": {
          position: "relative",
          insetInlineStart: "50%",
          display: "block",
          width: e.calc(e.controlHeight).mul(0.25).equal(),
          height: e.calc(e.controlHeight).mul(0.25).equal(),
          marginBottom: e.marginXS,
          textAlign: "center",
          transform: "translateY(-50%) translateX(-50%) rotate(135deg)"
        },
        "&:last-child": {
          "&::after": {
            display: "none"
          }
        },
        [`> ${t}-item-container > ${t}-item-tail`]: {
          visibility: "hidden"
        }
      }
    },
    [`&${t}-navigation${t}-horizontal`]: {
      [`> ${t}-item > ${t}-item-container > ${t}-item-tail`]: {
        visibility: "hidden"
      }
    }
  };
}, ene = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e;
  return {
    [`&${n}-with-progress`]: {
      [`${n}-item`]: {
        paddingTop: e.paddingXXS,
        [`&-process ${n}-item-container ${n}-item-icon ${n}-icon`]: {
          color: e.processIconColor
        }
      },
      [`&${n}-vertical > ${n}-item `]: {
        paddingInlineStart: e.paddingXXS,
        [`> ${n}-item-container > ${n}-item-tail`]: {
          top: e.marginXXS,
          insetInlineStart: e.calc(e.iconSize).div(2).sub(e.lineWidth).add(e.paddingXXS).equal()
        }
      },
      [`&, &${n}-small`]: {
        [`&${n}-horizontal ${n}-item:first-child`]: {
          paddingBottom: e.paddingXXS,
          paddingInlineStart: e.paddingXXS
        }
      },
      [`&${n}-small${n}-vertical > ${n}-item > ${n}-item-container > ${n}-item-tail`]: {
        insetInlineStart: e.calc(e.iconSizeSM).div(2).sub(e.lineWidth).add(e.paddingXXS).equal()
      },
      [`&${n}-label-vertical`]: {
        [`${n}-item ${n}-item-tail`]: {
          top: e.calc(e.margin).sub(e.calc(e.lineWidth).mul(2).equal()).equal()
        }
      },
      [`${n}-item-icon`]: {
        position: "relative",
        [`${t}-progress`]: {
          position: "absolute",
          insetBlockStart: e.calc(e.calc(e.iconSize).sub(e.stepsProgressSize).sub(e.calc(e.lineWidth).mul(2).equal()).equal()).div(2).equal(),
          insetInlineStart: e.calc(e.calc(e.iconSize).sub(e.stepsProgressSize).sub(e.calc(e.lineWidth).mul(2).equal()).equal()).div(2).equal()
        }
      }
    }
  };
}, tne = (e) => {
  const {
    componentCls: t,
    descriptionMaxWidth: n,
    lineHeight: r,
    dotCurrentSize: o,
    dotSize: i,
    motionDurationSlow: a
  } = e;
  return {
    [`&${t}-dot, &${t}-dot${t}-small`]: {
      [`${t}-item`]: {
        "&-title": {
          lineHeight: r
        },
        "&-tail": {
          // Math.floor((token.size - token.lineWidth * 3) / 2)
          top: e.calc(e.dotSize).sub(e.calc(e.lineWidth).mul(3).equal()).div(2).equal(),
          width: "100%",
          marginTop: 0,
          marginBottom: 0,
          marginInline: `${te(e.calc(n).div(2).equal())} 0`,
          padding: 0,
          "&::after": {
            width: `calc(100% - ${te(e.calc(e.marginSM).mul(2).equal())})`,
            height: e.calc(e.lineWidth).mul(3).equal(),
            marginInlineStart: e.marginSM
          }
        },
        "&-icon": {
          width: i,
          height: i,
          marginInlineStart: e.calc(e.descriptionMaxWidth).sub(i).div(2).equal(),
          paddingInlineEnd: 0,
          lineHeight: `${te(i)}`,
          background: "transparent",
          border: 0,
          [`${t}-icon-dot`]: {
            position: "relative",
            float: "left",
            width: "100%",
            height: "100%",
            borderRadius: 100,
            // very large number
            transition: `all ${a}`,
            /* expand hover area */
            "&::after": {
              position: "absolute",
              top: e.calc(e.marginSM).mul(-1).equal(),
              insetInlineStart: e.calc(i).sub(e.calc(e.controlHeightLG).mul(1.5).equal()).div(2).equal(),
              width: e.calc(e.controlHeightLG).mul(1.5).equal(),
              height: e.controlHeight,
              background: "transparent",
              content: '""'
            }
          }
        },
        "&-content": {
          width: n
        },
        [`&-process ${t}-item-icon`]: {
          position: "relative",
          top: e.calc(i).sub(o).div(2).equal(),
          width: o,
          height: o,
          lineHeight: `${te(o)}`,
          background: "none",
          marginInlineStart: e.calc(e.descriptionMaxWidth).sub(o).div(2).equal()
        },
        [`&-process ${t}-icon`]: {
          [`&:first-child ${t}-icon-dot`]: {
            insetInlineStart: 0
          }
        }
      }
    },
    [`&${t}-vertical${t}-dot`]: {
      [`${t}-item-icon`]: {
        marginTop: e.calc(e.controlHeight).sub(i).div(2).equal(),
        marginInlineStart: 0,
        background: "none"
      },
      [`${t}-item-process ${t}-item-icon`]: {
        marginTop: e.calc(e.controlHeight).sub(o).div(2).equal(),
        top: 0,
        insetInlineStart: e.calc(i).sub(o).div(2).equal(),
        marginInlineStart: 0
      },
      // https://github.com/ant-design/ant-design/issues/18354
      [`${t}-item > ${t}-item-container > ${t}-item-tail`]: {
        top: e.calc(e.controlHeight).sub(i).div(2).equal(),
        insetInlineStart: 0,
        margin: 0,
        padding: `${te(e.calc(i).add(e.paddingXS).equal())} 0 ${te(e.paddingXS)}`,
        "&::after": {
          marginInlineStart: e.calc(i).sub(e.lineWidth).div(2).equal()
        }
      },
      [`&${t}-small`]: {
        [`${t}-item-icon`]: {
          marginTop: e.calc(e.controlHeightSM).sub(i).div(2).equal()
        },
        [`${t}-item-process ${t}-item-icon`]: {
          marginTop: e.calc(e.controlHeightSM).sub(o).div(2).equal()
        },
        [`${t}-item > ${t}-item-container > ${t}-item-tail`]: {
          top: e.calc(e.controlHeightSM).sub(i).div(2).equal()
        }
      },
      [`${t}-item:first-child ${t}-icon-dot`]: {
        insetInlineStart: 0
      },
      [`${t}-item-content`]: {
        width: "inherit"
      }
    }
  };
}, nne = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`&${t}-rtl`]: {
      direction: "rtl",
      [`${t}-item`]: {
        "&-subtitle": {
          float: "left"
        }
      },
      // nav
      [`&${t}-navigation`]: {
        [`${t}-item::after`]: {
          transform: "rotate(-45deg)"
        }
      },
      // vertical
      [`&${t}-vertical`]: {
        [`> ${t}-item`]: {
          "&::after": {
            transform: "rotate(225deg)"
          },
          [`${t}-item-icon`]: {
            float: "right"
          }
        }
      },
      // progress-dot
      [`&${t}-dot`]: {
        [`${t}-item-icon ${t}-icon-dot, &${t}-small ${t}-item-icon ${t}-icon-dot`]: {
          float: "right"
        }
      }
    }
  };
}, rne = (e) => {
  const {
    componentCls: t,
    iconSizeSM: n,
    // stepsSmallIconMargin,
    fontSizeSM: r,
    fontSize: o,
    colorTextDescription: i
  } = e;
  return {
    [`&${t}-small`]: {
      [`&${t}-horizontal:not(${t}-label-vertical) ${t}-item`]: {
        paddingInlineStart: e.paddingSM,
        "&:first-child": {
          paddingInlineStart: 0
        }
      },
      [`${t}-item-icon`]: {
        width: n,
        height: n,
        // margin: stepsSmallIconMargin,
        marginTop: 0,
        marginBottom: 0,
        marginInline: `0 ${te(e.marginXS)}`,
        fontSize: r,
        lineHeight: `${te(n)}`,
        textAlign: "center",
        borderRadius: n
      },
      [`${t}-item-title`]: {
        paddingInlineEnd: e.paddingSM,
        fontSize: o,
        lineHeight: `${te(n)}`,
        "&::after": {
          top: e.calc(n).div(2).equal()
        }
      },
      [`${t}-item-description`]: {
        color: i,
        fontSize: o
      },
      [`${t}-item-tail`]: {
        top: e.calc(n).div(2).sub(e.paddingXXS).equal()
      },
      [`${t}-item-custom ${t}-item-icon`]: {
        width: "inherit",
        height: "inherit",
        lineHeight: "inherit",
        background: "none",
        border: 0,
        borderRadius: 0,
        [`> ${t}-icon`]: {
          fontSize: n,
          lineHeight: `${te(n)}`,
          transform: "none"
        }
      }
    }
  };
}, one = (e) => {
  const {
    componentCls: t,
    iconSizeSM: n,
    iconSize: r
  } = e;
  return {
    [`&${t}-vertical`]: {
      display: "flex",
      flexDirection: "column",
      [`> ${t}-item`]: {
        display: "block",
        flex: "1 0 auto",
        paddingInlineStart: 0,
        overflow: "visible",
        [`${t}-item-icon`]: {
          float: "left",
          marginInlineEnd: e.margin
        },
        [`${t}-item-content`]: {
          display: "block",
          minHeight: e.calc(e.controlHeight).mul(1.5).equal(),
          overflow: "hidden"
        },
        [`${t}-item-title`]: {
          lineHeight: `${te(r)}`
        },
        [`${t}-item-description`]: {
          paddingBottom: e.paddingSM
        }
      },
      [`> ${t}-item > ${t}-item-container > ${t}-item-tail`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: e.calc(r).div(2).sub(e.lineWidth).equal(),
        width: e.lineWidth,
        height: "100%",
        padding: `${te(e.calc(e.marginXXS).mul(1.5).add(r).equal())} 0 ${te(e.calc(e.marginXXS).mul(1.5).equal())}`,
        "&::after": {
          width: e.lineWidth,
          height: "100%"
        }
      },
      [`> ${t}-item:not(:last-child) > ${t}-item-container > ${t}-item-tail`]: {
        display: "block"
      },
      [` > ${t}-item > ${t}-item-container > ${t}-item-content > ${t}-item-title`]: {
        "&::after": {
          display: "none"
        }
      },
      [`&${t}-small ${t}-item-container`]: {
        [`${t}-item-tail`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: e.calc(n).div(2).sub(e.lineWidth).equal(),
          padding: `${te(e.calc(e.marginXXS).mul(1.5).add(n).equal())} 0 ${te(e.calc(e.marginXXS).mul(1.5).equal())}`
        },
        [`${t}-item-title`]: {
          lineHeight: `${te(n)}`
        }
      }
    }
  };
};
var yc;
(function(e) {
  e.wait = "wait", e.process = "process", e.finish = "finish", e.error = "error";
})(yc || (yc = {}));
const Ip = (e, t) => {
  const n = `${t.componentCls}-item`, r = `${e}IconColor`, o = `${e}TitleColor`, i = `${e}DescriptionColor`, a = `${e}TailColor`, s = `${e}IconBgColor`, l = `${e}IconBorderColor`, u = `${e}DotColor`;
  return {
    [`${n}-${e} ${n}-icon`]: {
      backgroundColor: t[s],
      borderColor: t[l],
      [`> ${t.componentCls}-icon`]: {
        color: t[r],
        [`${t.componentCls}-icon-dot`]: {
          background: t[u]
        }
      }
    },
    [`${n}-${e}${n}-custom ${n}-icon`]: {
      [`> ${t.componentCls}-icon`]: {
        color: t[u]
      }
    },
    [`${n}-${e} > ${n}-container > ${n}-content > ${n}-title`]: {
      color: t[o],
      "&::after": {
        backgroundColor: t[a]
      }
    },
    [`${n}-${e} > ${n}-container > ${n}-content > ${n}-description`]: {
      color: t[i]
    },
    [`${n}-${e} > ${n}-container > ${n}-tail::after`]: {
      backgroundColor: t[a]
    }
  };
}, ine = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e, r = `${t}-item`, o = `${r}-icon`;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [r]: {
      position: "relative",
      display: "inline-block",
      flex: 1,
      overflow: "hidden",
      verticalAlign: "top",
      "&:last-child": {
        flex: "none",
        [`> ${r}-container > ${r}-tail, > ${r}-container >  ${r}-content > ${r}-title::after`]: {
          display: "none"
        }
      }
    },
    [`${r}-container`]: {
      outline: "none",
      "&:focus-visible": {
        [o]: Object.assign({}, Va(e))
      }
    },
    [`${o}, ${r}-content`]: {
      display: "inline-block",
      verticalAlign: "top"
    },
    [o]: {
      width: e.iconSize,
      height: e.iconSize,
      marginTop: 0,
      marginBottom: 0,
      marginInlineStart: 0,
      marginInlineEnd: e.marginXS,
      fontSize: e.iconFontSize,
      fontFamily: e.fontFamily,
      lineHeight: `${te(e.iconSize)}`,
      textAlign: "center",
      borderRadius: e.iconSize,
      border: `${te(e.lineWidth)} ${e.lineType} transparent`,
      transition: `background-color ${n}, border-color ${n}`,
      [`${t}-icon`]: {
        position: "relative",
        top: e.iconTop,
        color: e.colorPrimary,
        lineHeight: 1
      }
    },
    [`${r}-tail`]: {
      position: "absolute",
      top: e.calc(e.iconSize).div(2).sub(e.paddingXXS).equal(),
      insetInlineStart: 0,
      width: "100%",
      "&::after": {
        display: "inline-block",
        width: "100%",
        height: e.lineWidth,
        background: e.colorSplit,
        borderRadius: e.lineWidth,
        transition: `background ${n}`,
        content: '""'
      }
    },
    [`${r}-title`]: {
      position: "relative",
      display: "inline-block",
      paddingInlineEnd: e.padding,
      color: e.colorText,
      fontSize: e.fontSizeLG,
      lineHeight: `${te(e.titleLineHeight)}`,
      "&::after": {
        position: "absolute",
        top: e.calc(e.titleLineHeight).div(2).equal(),
        insetInlineStart: "100%",
        display: "block",
        width: 9999,
        height: e.lineWidth,
        background: e.processTailColor,
        content: '""'
      }
    },
    [`${r}-subtitle`]: {
      display: "inline",
      marginInlineStart: e.marginXS,
      color: e.colorTextDescription,
      fontWeight: "normal",
      fontSize: e.fontSize
    },
    [`${r}-description`]: {
      color: e.colorTextDescription,
      fontSize: e.fontSize
    }
  }, Ip(yc.wait, e)), Ip(yc.process, e)), {
    [`${r}-process > ${r}-container > ${r}-title`]: {
      fontWeight: e.fontWeightStrong
    }
  }), Ip(yc.finish, e)), Ip(yc.error, e)), {
    [`${r}${t}-next-error > ${t}-item-title::after`]: {
      background: e.colorError
    },
    [`${r}-disabled`]: {
      cursor: "not-allowed"
    }
  });
}, ane = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return {
    [`& ${t}-item`]: {
      [`&:not(${t}-item-active)`]: {
        [`& > ${t}-item-container[role='button']`]: {
          cursor: "pointer",
          [`${t}-item`]: {
            [`&-title, &-subtitle, &-description, &-icon ${t}-icon`]: {
              transition: `color ${n}`
            }
          },
          "&:hover": {
            [`${t}-item`]: {
              "&-title, &-subtitle, &-description": {
                color: e.colorPrimary
              }
            }
          }
        },
        [`&:not(${t}-item-process)`]: {
          [`& > ${t}-item-container[role='button']:hover`]: {
            [`${t}-item`]: {
              "&-icon": {
                borderColor: e.colorPrimary,
                [`${t}-icon`]: {
                  color: e.colorPrimary
                }
              }
            }
          }
        }
      }
    },
    [`&${t}-horizontal:not(${t}-label-vertical)`]: {
      [`${t}-item`]: {
        paddingInlineStart: e.padding,
        whiteSpace: "nowrap",
        "&:first-child": {
          paddingInlineStart: 0
        },
        [`&:last-child ${t}-item-title`]: {
          paddingInlineEnd: 0
        },
        "&-tail": {
          display: "none"
        },
        "&-description": {
          maxWidth: e.descriptionMaxWidth,
          whiteSpace: "normal"
        }
      }
    }
  };
}, sne = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Qn(e)), {
      display: "flex",
      width: "100%",
      fontSize: 0,
      textAlign: "initial"
    }), ine(e)), ane(e)), Xte(e)), rne(e)), one(e)), Qte(e)), tne(e)), Jte(e)), nne(e)), ene(e)), Zte(e))
  };
}, lne = (e) => ({
  titleLineHeight: e.controlHeight,
  customIconSize: e.controlHeight,
  customIconTop: 0,
  customIconFontSize: e.controlHeightSM,
  iconSize: e.controlHeight,
  iconTop: -0.5,
  // magic for ui experience
  iconFontSize: e.fontSize,
  iconSizeSM: e.fontSizeHeading3,
  dotSize: e.controlHeight / 4,
  dotCurrentSize: e.controlHeightLG / 4,
  navArrowColor: e.colorTextDisabled,
  navContentMaxWidth: "auto",
  descriptionMaxWidth: 140,
  waitIconColor: e.wireframe ? e.colorTextDisabled : e.colorTextLabel,
  waitIconBgColor: e.wireframe ? e.colorBgContainer : e.colorFillContent,
  waitIconBorderColor: e.wireframe ? e.colorTextDisabled : "transparent",
  finishIconBgColor: e.wireframe ? e.colorBgContainer : e.controlItemBgActive,
  finishIconBorderColor: e.wireframe ? e.colorPrimary : e.controlItemBgActive
}), cne = Gn("Steps", (e) => {
  const {
    colorTextDisabled: t,
    controlHeightLG: n,
    colorTextLightSolid: r,
    colorText: o,
    colorPrimary: i,
    colorTextDescription: a,
    colorTextQuaternary: s,
    colorError: l,
    colorBorderSecondary: u,
    colorSplit: f
  } = e, p = Sn(e, {
    // Steps component less variable
    processIconColor: r,
    processTitleColor: o,
    processDescriptionColor: o,
    processIconBgColor: i,
    processIconBorderColor: i,
    processDotColor: i,
    processTailColor: f,
    waitTitleColor: a,
    waitDescriptionColor: a,
    waitTailColor: f,
    waitDotColor: t,
    finishIconColor: i,
    finishTitleColor: o,
    finishDescriptionColor: a,
    finishTailColor: i,
    finishDotColor: i,
    errorIconColor: r,
    errorTitleColor: l,
    errorDescriptionColor: l,
    errorTailColor: f,
    errorIconBgColor: l,
    errorIconBorderColor: l,
    errorDotColor: l,
    stepsNavActiveColor: i,
    stepsProgressSize: n,
    // Steps inline variable
    inlineDotSize: 6,
    inlineTitleColor: s,
    inlineTailColor: u
  });
  return [sne(p)];
}, lne);
function une(e) {
  return e.filter((t) => t);
}
function dne(e, t) {
  if (process.env.NODE_ENV === "test" && xn("Menu").deprecated(!t, "Step", "items"), e)
    return e;
  const n = Rr(t).map((r) => {
    if (/* @__PURE__ */ c.isValidElement(r)) {
      const {
        props: o
      } = r;
      return Object.assign({}, o);
    }
    return null;
  });
  return une(n);
}
var fne = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const vC = (e) => {
  const {
    percent: t,
    size: n,
    className: r,
    rootClassName: o,
    direction: i,
    items: a,
    responsive: s = !0,
    current: l = 0,
    children: u,
    style: f
  } = e, p = fne(e, ["percent", "size", "className", "rootClassName", "direction", "items", "responsive", "current", "children", "style"]), {
    xs: h
  } = zg(s), {
    getPrefixCls: y,
    direction: b,
    steps: m
  } = c.useContext(Ft), v = c.useMemo(() => s && h ? "vertical" : i, [h, i]), C = Co(n), x = y("steps", e.prefixCls), [S, E, O] = cne(x), $ = e.type === "inline", _ = y("", e.iconPrefix), R = dne(a, u), P = $ ? void 0 : t, I = Object.assign(Object.assign({}, m == null ? void 0 : m.style), f), j = se(m == null ? void 0 : m.className, {
    [`${x}-rtl`]: b === "rtl",
    [`${x}-with-progress`]: P !== void 0
  }, r, o, E, O), F = {
    finish: /* @__PURE__ */ c.createElement(Bg, {
      className: `${x}-finish-icon`
    }),
    error: /* @__PURE__ */ c.createElement(Gd, {
      className: `${x}-error-icon`
    })
  }, A = (N) => {
    let {
      node: D,
      status: T
    } = N;
    if (T === "process" && P !== void 0) {
      const L = C === "small" ? 32 : 40;
      return /* @__PURE__ */ c.createElement("div", {
        className: `${x}-progress-icon`
      }, /* @__PURE__ */ c.createElement(Gte, {
        type: "circle",
        percent: P,
        size: L,
        strokeWidth: 4,
        format: () => null
      }), D);
    }
    return D;
  }, M = (N, D) => N.description ? /* @__PURE__ */ c.createElement(Bo, {
    title: N.description
  }, D) : D;
  return S(/* @__PURE__ */ c.createElement(mC, Object.assign({
    icons: F
  }, p, {
    style: I,
    current: l,
    size: C,
    items: R,
    itemRender: $ ? M : void 0,
    stepIcon: A,
    direction: v,
    prefixCls: x,
    iconPrefix: _,
    className: j
  })));
};
vC.Step = mC.Step;
process.env.NODE_ENV !== "production" && (vC.displayName = "Steps");
const pne = vC;
var ta = {}, sf = "rc-table-internal-hook";
function yC(e) {
  var t = /* @__PURE__ */ c.createContext(void 0), n = function(o) {
    var i = o.value, a = o.children, s = c.useRef(i);
    s.current = i;
    var l = c.useState(function() {
      return {
        getValue: function() {
          return s.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), u = de(l, 1), f = u[0];
    return Nn(function() {
      t4(function() {
        f.listeners.forEach(function(p) {
          p(i);
        });
      });
    }, [i]), /* @__PURE__ */ c.createElement(t.Provider, {
      value: f
    }, a);
  };
  return {
    Context: t,
    Provider: n,
    defaultValue: e
  };
}
function Ro(e, t) {
  var n = Ir(typeof t == "function" ? t : function(p) {
    if (t === void 0)
      return p;
    if (!Array.isArray(t))
      return p[t];
    var h = {};
    return t.forEach(function(y) {
      h[y] = p[y];
    }), h;
  }), r = c.useContext(e == null ? void 0 : e.Context), o = r || {}, i = o.listeners, a = o.getValue, s = c.useRef();
  s.current = n(r ? a() : e == null ? void 0 : e.defaultValue);
  var l = c.useState({}), u = de(l, 2), f = u[1];
  return Nn(function() {
    if (!r)
      return;
    function p(h) {
      var y = n(h);
      Fi(s.current, y, !0) || f({});
    }
    return i.add(p), function() {
      i.delete(p);
    };
  }, [r]), s.current;
}
function hne() {
  var e = /* @__PURE__ */ c.createContext(null);
  function t() {
    return c.useContext(e);
  }
  function n(o, i) {
    var a = ki(o), s = function(u, f) {
      var p = a ? {
        ref: f
      } : {}, h = c.useRef(0), y = c.useRef(u), b = t();
      return b !== null ? /* @__PURE__ */ c.createElement(o, Oe({}, u, p)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!i || i(y.current, u)) && (h.current += 1), y.current = u, /* @__PURE__ */ c.createElement(e.Provider, {
          value: h.current
        }, /* @__PURE__ */ c.createElement(o, Oe({}, u, p))))
      );
    };
    return process.env.NODE_ENV !== "production" && (s.displayName = "ImmutableRoot(".concat(o.displayName || o.name, ")")), a ? /* @__PURE__ */ c.forwardRef(s) : s;
  }
  function r(o, i) {
    var a = ki(o), s = function(u, f) {
      var p = a ? {
        ref: f
      } : {};
      return t(), /* @__PURE__ */ c.createElement(o, Oe({}, u, p));
    };
    return process.env.NODE_ENV !== "production" && (s.displayName = "ImmutableResponse(".concat(o.displayName || o.name, ")")), a ? /* @__PURE__ */ c.memo(/* @__PURE__ */ c.forwardRef(s), i) : /* @__PURE__ */ c.memo(s, i);
  }
  return {
    makeImmutable: n,
    responseImmutable: r,
    useImmutableMark: t
  };
}
var bC = hne(), _8 = bC.makeImmutable, lu = bC.responseImmutable, gne = bC.useImmutableMark, Vo = yC();
function N8(e, t) {
  var n = c.useRef(0);
  n.current += 1;
  var r = c.useRef(e), o = [];
  Object.keys(e || {}).map(function(a) {
    var s;
    (e == null ? void 0 : e[a]) !== ((s = r.current) === null || s === void 0 ? void 0 : s[a]) && o.push(a);
  }), r.current = e;
  var i = c.useRef([]);
  return o.length && (i.current = o), c.useDebugValue(n.current), c.useDebugValue(i.current.join(", ")), t && console.log("".concat(t, ":"), n.current, i.current), n.current;
}
const Ns = process.env.NODE_ENV !== "production" ? N8 : function() {
};
var mne = /* @__PURE__ */ c.memo(function() {
  var e = N8();
  return /* @__PURE__ */ c.createElement("h1", null, "Render Times: ", e);
});
mne.displayName = "RenderBlock";
var P8 = /* @__PURE__ */ c.createContext({
  renderWithProps: !1
}), vne = "RC_TABLE_KEY";
function yne(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function im(e) {
  var t = [], n = {};
  return e.forEach(function(r) {
    for (var o = r || {}, i = o.key, a = o.dataIndex, s = i || yne(a).join("-") || vne; n[s]; )
      s = "".concat(s, "_next");
    n[s] = !0, t.push(s);
  }), t;
}
function iy(e) {
  return e != null;
}
function bne(e) {
  return e && Vt(e) === "object" && !Array.isArray(e) && !/* @__PURE__ */ c.isValidElement(e);
}
function Cne(e, t, n, r, o, i) {
  var a = c.useContext(P8), s = gne(), l = ua(function() {
    if (iy(r))
      return [r];
    var u = t == null || t === "" ? [] : Array.isArray(t) ? t : [t], f = yi(e, u), p = f, h = void 0;
    if (o) {
      var y = o(f, e, n);
      bne(y) ? (process.env.NODE_ENV !== "production" && mt(!1, "`columns.render` return cell props is deprecated with perf issue, please use `onCell` instead."), p = y.children, h = y.props, a.renderWithProps = !0) : p = y;
    }
    return [p, h];
  }, [
    // Force update deps
    s,
    // Normal deps
    e,
    r,
    t,
    o,
    n
  ], function(u, f) {
    if (i) {
      var p = de(u, 2), h = p[1], y = de(f, 2), b = y[1];
      return i(b, h);
    }
    return a.renderWithProps ? !0 : !Fi(u, f, !0);
  });
  return l;
}
function xne(e, t, n, r) {
  var o = e + t - 1;
  return e <= r && o >= n;
}
function Sne(e, t) {
  return Ro(Vo, function(n) {
    var r = xne(e, t || 1, n.hoverStartRow, n.hoverEndRow);
    return [r, n.onHover];
  });
}
var wne = function(t) {
  var n = t.ellipsis, r = t.rowType, o = t.children, i, a = n === !0 ? {
    showTitle: !0
  } : n;
  return a && (a.showTitle || r === "header") && (typeof o == "string" || typeof o == "number" ? i = o.toString() : /* @__PURE__ */ c.isValidElement(o) && typeof o.props.children == "string" && (i = o.props.children)), i;
};
function Ene(e) {
  var t, n, r, o, i, a, s, l;
  process.env.NODE_ENV !== "production" && Ns(e);
  var u = e.component, f = e.children, p = e.ellipsis, h = e.scope, y = e.prefixCls, b = e.className, m = e.align, v = e.record, C = e.render, x = e.dataIndex, S = e.renderIndex, E = e.shouldCellUpdate, O = e.index, $ = e.rowType, _ = e.colSpan, R = e.rowSpan, P = e.fixLeft, I = e.fixRight, j = e.firstFixLeft, F = e.lastFixLeft, A = e.firstFixRight, M = e.lastFixRight, N = e.appendNode, D = e.additionalProps, T = D === void 0 ? {} : D, L = e.isSticky, z = "".concat(y, "-cell"), H = Ro(Vo, ["supportSticky", "allColumnsFixedLeft"]), V = H.supportSticky, Y = H.allColumnsFixedLeft, Z = Cne(v, x, S, f, C, E), oe = de(Z, 2), ee = oe[0], ae = oe[1], le = {}, ue = typeof P == "number" && V, ie = typeof I == "number" && V;
  ue && (le.position = "sticky", le.left = P), ie && (le.position = "sticky", le.right = I);
  var re = (t = (n = (r = ae == null ? void 0 : ae.colSpan) !== null && r !== void 0 ? r : T.colSpan) !== null && n !== void 0 ? n : _) !== null && t !== void 0 ? t : 1, Q = (o = (i = (a = ae == null ? void 0 : ae.rowSpan) !== null && a !== void 0 ? a : T.rowSpan) !== null && i !== void 0 ? i : R) !== null && o !== void 0 ? o : 1, ce = Sne(O, Q), ge = de(ce, 2), G = ge[0], ne = ge[1], fe = Ir(function(Ee) {
    var Ge;
    v && ne(O, O + Q - 1), T == null || (Ge = T.onMouseEnter) === null || Ge === void 0 || Ge.call(T, Ee);
  }), ye = Ir(function(Ee) {
    var Ge;
    v && ne(-1, -1), T == null || (Ge = T.onMouseLeave) === null || Ge === void 0 || Ge.call(T, Ee);
  });
  if (re === 0 || Q === 0)
    return null;
  var we = (s = T.title) !== null && s !== void 0 ? s : wne({
    rowType: $,
    ellipsis: p,
    children: ee
  }), he = se(z, b, (l = {}, K(K(K(K(K(K(K(K(K(K(l, "".concat(z, "-fix-left"), ue && V), "".concat(z, "-fix-left-first"), j && V), "".concat(z, "-fix-left-last"), F && V), "".concat(z, "-fix-left-all"), F && Y && V), "".concat(z, "-fix-right"), ie && V), "".concat(z, "-fix-right-first"), A && V), "".concat(z, "-fix-right-last"), M && V), "".concat(z, "-ellipsis"), p), "".concat(z, "-with-append"), N), "".concat(z, "-fix-sticky"), (ue || ie) && L && V), K(l, "".concat(z, "-row-hover"), !ae && G)), T.className, ae == null ? void 0 : ae.className), me = {};
  m && (me.textAlign = m);
  var Ce = J(J(J(J({}, le), T.style), me), ae == null ? void 0 : ae.style), Te = ee;
  return Vt(Te) === "object" && !Array.isArray(Te) && !/* @__PURE__ */ c.isValidElement(Te) && (Te = null), p && (F || A) && (Te = /* @__PURE__ */ c.createElement("span", {
    className: "".concat(z, "-content")
  }, Te)), /* @__PURE__ */ c.createElement(u, Oe({}, ae, T, {
    className: he,
    style: Ce,
    title: we,
    scope: h,
    onMouseEnter: fe,
    onMouseLeave: ye,
    colSpan: re !== 1 ? re : null,
    rowSpan: Q !== 1 ? Q : null
  }), N, Te);
}
const Tl = /* @__PURE__ */ c.memo(Ene);
function CC(e, t, n, r, o, i) {
  var a = n[e] || {}, s = n[t] || {}, l, u;
  a.fixed === "left" ? l = r.left[o === "rtl" ? t : e] : s.fixed === "right" && (u = r.right[o === "rtl" ? e : t]);
  var f = !1, p = !1, h = !1, y = !1, b = n[t + 1], m = n[e - 1], v = !(i != null && i.children);
  if (o === "rtl") {
    if (l !== void 0) {
      var C = m && m.fixed === "left";
      y = !C && v;
    } else if (u !== void 0) {
      var x = b && b.fixed === "right";
      h = !x && v;
    }
  } else if (l !== void 0) {
    var S = b && b.fixed === "left";
    f = !S && v;
  } else if (u !== void 0) {
    var E = m && m.fixed === "right";
    p = !E && v;
  }
  return {
    fixLeft: l,
    fixRight: u,
    lastFixLeft: f,
    firstFixRight: p,
    lastFixRight: h,
    firstFixLeft: y,
    isSticky: r.isSticky
  };
}
var I8 = /* @__PURE__ */ c.createContext({});
function $ne(e) {
  var t = e.className, n = e.index, r = e.children, o = e.colSpan, i = o === void 0 ? 1 : o, a = e.rowSpan, s = e.align, l = Ro(Vo, ["prefixCls", "direction"]), u = l.prefixCls, f = l.direction, p = c.useContext(I8), h = p.scrollColumnIndex, y = p.stickyOffsets, b = p.flattenColumns, m = p.columns, v = n + i - 1, C = v + 1 === h ? i + 1 : i, x = CC(n, n + C - 1, b, y, f, m == null ? void 0 : m[n]);
  return /* @__PURE__ */ c.createElement(Tl, Oe({
    className: t,
    index: n,
    component: "td",
    prefixCls: u,
    record: null,
    dataIndex: null,
    align: s,
    colSpan: C,
    rowSpan: a,
    render: function() {
      return r;
    }
  }, x));
}
var One = ["children"];
function _ne(e) {
  var t = e.children, n = Yt(e, One);
  return /* @__PURE__ */ c.createElement("tr", n, t);
}
function am(e) {
  var t = e.children;
  return t;
}
am.Row = _ne;
am.Cell = $ne;
function Nne(e) {
  process.env.NODE_ENV !== "production" && Ns(e);
  var t = e.children, n = e.stickyOffsets, r = e.flattenColumns, o = e.columns, i = Ro(Vo, "prefixCls"), a = r.length - 1, s = r[a], l = c.useMemo(function() {
    return {
      stickyOffsets: n,
      flattenColumns: r,
      scrollColumnIndex: s != null && s.scrollbar ? a : null,
      columns: o
    };
  }, [s, r, a, n, o]);
  return /* @__PURE__ */ c.createElement(I8.Provider, {
    value: l
  }, /* @__PURE__ */ c.createElement("tfoot", {
    className: "".concat(i, "-summary")
  }, t));
}
const Rp = lu(Nne);
var R8 = am;
function Pne(e) {
  return null;
}
function Ine(e) {
  return null;
}
function D8(e, t, n, r, o, i, a) {
  e.push({
    record: t,
    indent: n,
    index: a
  });
  var s = i(t), l = o == null ? void 0 : o.has(s);
  if (t && Array.isArray(t[r]) && l)
    for (var u = 0; u < t[r].length; u += 1)
      D8(e, t[r][u], n + 1, r, o, i, u);
}
function T8(e, t, n, r) {
  var o = c.useMemo(function() {
    if (n != null && n.size) {
      for (var i = [], a = 0; a < (e == null ? void 0 : e.length); a += 1) {
        var s = e[a];
        D8(i, s, 0, t, n, r, a);
      }
      return i;
    }
    return e == null ? void 0 : e.map(function(l, u) {
      return {
        record: l,
        indent: 0,
        index: u
      };
    });
  }, [e, t, n, r]);
  return o;
}
function M8(e, t, n, r) {
  var o = Ro(Vo, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), i = o.flattenColumns, a = o.expandableType, s = o.expandedKeys, l = o.childrenColumnName, u = o.onTriggerExpand, f = o.rowExpandable, p = o.onRow, h = o.expandRowByClick, y = o.rowClassName, b = a === "nest", m = a === "row" && (!f || f(e)), v = m || b, C = s && s.has(t), x = l && e && e[l], S = Ir(u), E = p == null ? void 0 : p(e, n), O = E == null ? void 0 : E.onClick, $ = function(I) {
    h && v && u(e, I);
    for (var j = arguments.length, F = new Array(j > 1 ? j - 1 : 0), A = 1; A < j; A++)
      F[A - 1] = arguments[A];
    O == null || O.apply(void 0, [I].concat(F));
  }, _;
  typeof y == "string" ? _ = y : typeof y == "function" && (_ = y(e, n, r));
  var R = im(i);
  return J(J({}, o), {}, {
    columnsKey: R,
    nestExpandable: b,
    expanded: C,
    hasNestChildren: x,
    record: e,
    onTriggerExpand: S,
    rowSupportExpand: m,
    expandable: v,
    rowProps: J(J({}, E), {}, {
      className: se(_, E == null ? void 0 : E.className),
      onClick: $
    })
  });
}
function L8(e) {
  process.env.NODE_ENV !== "production" && Ns(e);
  var t = e.prefixCls, n = e.children, r = e.component, o = e.cellComponent, i = e.className, a = e.expanded, s = e.colSpan, l = e.isEmpty, u = Ro(Vo, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), f = u.scrollbarSize, p = u.fixHeader, h = u.fixColumn, y = u.componentWidth, b = u.horizonScroll, m = n;
  return (l ? b && y : h) && (m = /* @__PURE__ */ c.createElement("div", {
    style: {
      width: y - (p ? f : 0),
      position: "sticky",
      left: 0,
      overflow: "hidden"
    },
    className: "".concat(t, "-expanded-row-fixed")
  }, m)), /* @__PURE__ */ c.createElement(r, {
    className: i,
    style: {
      display: a ? null : "none"
    }
  }, /* @__PURE__ */ c.createElement(Tl, {
    component: o,
    prefixCls: t,
    colSpan: s
  }, m));
}
function A8(e, t, n, r, o) {
  var i = e.record, a = e.prefixCls, s = e.columnsKey, l = e.fixedInfoList, u = e.expandIconColumnIndex, f = e.nestExpandable, p = e.indentSize, h = e.expandIcon, y = e.expanded, b = e.hasNestChildren, m = e.onTriggerExpand, v = s[n], C = l[n], x;
  n === (u || 0) && f && (x = /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("span", {
    style: {
      paddingLeft: "".concat(p * r, "px")
    },
    className: "".concat(a, "-row-indent indent-level-").concat(r)
  }), h({
    prefixCls: a,
    expanded: y,
    expandable: b,
    record: i,
    onExpand: m
  })));
  var S;
  return t.onCell && (S = t.onCell(i, o)), {
    key: v,
    fixedInfo: C,
    appendCellNode: x,
    additionalCellProps: S || {}
  };
}
function j8(e) {
  process.env.NODE_ENV !== "production" && Ns(e);
  var t = e.className, n = e.style, r = e.record, o = e.index, i = e.renderIndex, a = e.rowKey, s = e.indent, l = s === void 0 ? 0 : s, u = e.rowComponent, f = e.cellComponent, p = e.scopeCellComponent, h = M8(r, a, o, l), y = h.prefixCls, b = h.flattenColumns, m = h.expandedRowClassName, v = h.expandedRowRender, C = h.rowProps, x = h.expanded, S = h.rowSupportExpand, E = c.useRef(!1);
  E.current || (E.current = x), process.env.NODE_ENV !== "production" && Ns(e);
  var O = /* @__PURE__ */ c.createElement(u, Oe({}, C, {
    "data-row-key": a,
    className: se(t, "".concat(y, "-row"), "".concat(y, "-row-level-").concat(l), C == null ? void 0 : C.className),
    style: J(J({}, n), C == null ? void 0 : C.style)
  }), b.map(function(P, I) {
    var j = P.render, F = P.dataIndex, A = P.className, M = A8(h, P, I, l, o), N = M.key, D = M.fixedInfo, T = M.appendCellNode, L = M.additionalCellProps;
    return /* @__PURE__ */ c.createElement(Tl, Oe({
      className: A,
      ellipsis: P.ellipsis,
      align: P.align,
      scope: P.rowScope,
      component: P.rowScope ? p : f,
      prefixCls: y,
      key: N,
      record: r,
      index: o,
      renderIndex: i,
      dataIndex: F,
      render: j,
      shouldCellUpdate: P.shouldCellUpdate
    }, D, {
      appendNode: T,
      additionalProps: L
    }));
  })), $;
  if (S && (E.current || x)) {
    var _ = v(r, o, l + 1, x), R = m && m(r, o, l);
    $ = /* @__PURE__ */ c.createElement(L8, {
      expanded: x,
      className: se("".concat(y, "-expanded-row"), "".concat(y, "-expanded-row-level-").concat(l + 1), R),
      prefixCls: y,
      component: u,
      cellComponent: f,
      colSpan: b.length,
      isEmpty: !1
    }, _);
  }
  return /* @__PURE__ */ c.createElement(c.Fragment, null, O, $);
}
j8.displayName = "BodyRow";
const Rne = lu(j8);
function Dne(e) {
  var t = e.columnKey, n = e.onColumnResize, r = c.useRef();
  return c.useEffect(function() {
    r.current && n(t, r.current.offsetWidth);
  }, []), /* @__PURE__ */ c.createElement(zo, {
    data: t
  }, /* @__PURE__ */ c.createElement("td", {
    ref: r,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ c.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, " ")));
}
function Tne(e) {
  var t = e.prefixCls, n = e.columnsKey, r = e.onColumnResize;
  return /* @__PURE__ */ c.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(t, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    }
  }, /* @__PURE__ */ c.createElement(zo.Collection, {
    onBatchResize: function(i) {
      i.forEach(function(a) {
        var s = a.data, l = a.size;
        r(s, l.offsetWidth);
      });
    }
  }, n.map(function(o) {
    return /* @__PURE__ */ c.createElement(Dne, {
      key: o,
      columnKey: o,
      onColumnResize: r
    });
  })));
}
function k8(e) {
  process.env.NODE_ENV !== "production" && Ns(e);
  var t = e.data, n = e.measureColumnWidth, r = Ro(Vo, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode"]), o = r.prefixCls, i = r.getComponent, a = r.onColumnResize, s = r.flattenColumns, l = r.getRowKey, u = r.expandedKeys, f = r.childrenColumnName, p = r.emptyNode, h = T8(t, f, u, l), y = c.useRef({
    renderWithProps: !1
  }), b = i(["body", "wrapper"], "tbody"), m = i(["body", "row"], "tr"), v = i(["body", "cell"], "td"), C = i(["body", "cell"], "th"), x;
  t.length ? x = h.map(function(E, O) {
    var $ = E.record, _ = E.indent, R = E.index, P = l($, O);
    return /* @__PURE__ */ c.createElement(Rne, {
      key: P,
      rowKey: P,
      record: $,
      index: O,
      renderIndex: R,
      rowComponent: m,
      cellComponent: v,
      scopeCellComponent: C,
      getRowKey: l,
      indent: _
    });
  }) : x = /* @__PURE__ */ c.createElement(L8, {
    expanded: !0,
    className: "".concat(o, "-placeholder"),
    prefixCls: o,
    component: m,
    cellComponent: v,
    colSpan: s.length,
    isEmpty: !0
  }, p);
  var S = im(s);
  return /* @__PURE__ */ c.createElement(P8.Provider, {
    value: y.current
  }, /* @__PURE__ */ c.createElement(b, {
    className: "".concat(o, "-tbody")
  }, n && /* @__PURE__ */ c.createElement(Tne, {
    prefixCls: o,
    columnsKey: S,
    onColumnResize: a
  }), x));
}
k8.displayName = "Body";
const Mne = lu(k8);
var Lne = ["expandable"], dd = "RC_TABLE_INTERNAL_COL_DEFINE";
function Ane(e) {
  var t = e.expandable, n = Yt(e, Lne), r;
  return "expandable" in e ? r = J(J({}, n), t) : (process.env.NODE_ENV !== "production" && ["indentSize", "expandedRowKeys", "defaultExpandedRowKeys", "defaultExpandAllRows", "expandedRowRender", "expandRowByClick", "expandIcon", "onExpand", "onExpandedRowsChange", "expandedRowClassName", "expandIconColumnIndex", "showExpandColumn", "title"].some(function(o) {
    return o in e;
  }) && mt(!1, "expanded related props have been moved into `expandable`."), r = n), r.showExpandColumn === !1 && (r.expandIconColumnIndex = -1), r;
}
var jne = ["columnType"];
function F8(e) {
  for (var t = e.colWidths, n = e.columns, r = e.columCount, o = [], i = r || n.length, a = !1, s = i - 1; s >= 0; s -= 1) {
    var l = t[s], u = n && n[s], f = u && u[dd];
    if (l || f || a) {
      var p = f || {};
      p.columnType;
      var h = Yt(p, jne);
      o.unshift(/* @__PURE__ */ c.createElement("col", Oe({
        key: s,
        style: {
          width: l
        }
      }, h))), a = !0;
    }
  }
  return /* @__PURE__ */ c.createElement("colgroup", null, o);
}
var kne = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function Fne(e, t) {
  return mr(function() {
    for (var n = [], r = 0; r < t; r += 1) {
      var o = e[r];
      if (o !== void 0)
        n[r] = o;
      else
        return null;
    }
    return n;
  }, [e.join("_"), t]);
}
var B8 = /* @__PURE__ */ c.forwardRef(function(e, t) {
  process.env.NODE_ENV !== "production" && Ns(e);
  var n = e.className, r = e.noData, o = e.columns, i = e.flattenColumns, a = e.colWidths, s = e.columCount, l = e.stickyOffsets, u = e.direction, f = e.fixHeader, p = e.stickyTopOffset, h = e.stickyBottomOffset, y = e.stickyClassName, b = e.onScroll, m = e.maxContentScroll, v = e.children, C = Yt(e, kne), x = Ro(Vo, ["prefixCls", "scrollbarSize", "isSticky"]), S = x.prefixCls, E = x.scrollbarSize, O = x.isSticky, $ = O && !f ? 0 : E, _ = c.useRef(null), R = c.useCallback(function(D) {
    md(t, D), md(_, D);
  }, []);
  c.useEffect(function() {
    var D;
    function T(L) {
      var z = L, H = z.currentTarget, V = z.deltaX;
      V && (b({
        currentTarget: H,
        scrollLeft: H.scrollLeft + V
      }), L.preventDefault());
    }
    return (D = _.current) === null || D === void 0 || D.addEventListener("wheel", T), function() {
      var L;
      (L = _.current) === null || L === void 0 || L.removeEventListener("wheel", T);
    };
  }, []);
  var P = c.useMemo(function() {
    return i.every(function(D) {
      return D.width;
    });
  }, [i]), I = i[i.length - 1], j = {
    fixed: I ? I.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(S, "-cell-scrollbar")
      };
    }
  }, F = mr(function() {
    return $ ? [].concat(We(o), [j]) : o;
  }, [$, o]), A = mr(function() {
    return $ ? [].concat(We(i), [j]) : i;
  }, [$, i]), M = mr(function() {
    var D = l.right, T = l.left;
    return J(J({}, l), {}, {
      left: u === "rtl" ? [].concat(We(T.map(function(L) {
        return L + $;
      })), [0]) : T,
      right: u === "rtl" ? D : [].concat(We(D.map(function(L) {
        return L + $;
      })), [0]),
      isSticky: O
    });
  }, [$, l, O]), N = Fne(a, s);
  return /* @__PURE__ */ c.createElement("div", {
    style: J({
      overflow: "hidden"
    }, O ? {
      top: p,
      bottom: h
    } : {}),
    ref: R,
    className: se(n, K({}, y, !!y))
  }, /* @__PURE__ */ c.createElement("table", {
    style: {
      tableLayout: "fixed",
      visibility: r || N ? null : "hidden"
    }
  }, (!r || !m || P) && /* @__PURE__ */ c.createElement(F8, {
    colWidths: N ? [].concat(We(N), [$]) : [],
    columCount: s + 1,
    columns: A
  }), v(J(J({}, C), {}, {
    stickyOffsets: M,
    columns: F,
    flattenColumns: A
  }))));
});
B8.displayName = "FixedHolder";
const GE = /* @__PURE__ */ c.memo(B8);
function H8(e) {
  var t = e.cells, n = e.stickyOffsets, r = e.flattenColumns, o = e.rowComponent, i = e.cellComponent, a = e.tdCellComponent, s = e.onHeaderRow, l = e.index, u = Ro(Vo, ["prefixCls", "direction"]), f = u.prefixCls, p = u.direction, h;
  s && (h = s(t.map(function(b) {
    return b.column;
  }), l));
  var y = im(t.map(function(b) {
    return b.column;
  }));
  return /* @__PURE__ */ c.createElement(o, h, t.map(function(b, m) {
    var v = b.column, C = CC(b.colStart, b.colEnd, r, n, p, v), x;
    return v && v.onHeaderCell && (x = b.column.onHeaderCell(v)), /* @__PURE__ */ c.createElement(Tl, Oe({}, b, {
      scope: v.title ? b.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: v.ellipsis,
      align: v.align,
      component: v.title ? i : a,
      prefixCls: f,
      key: y[m]
    }, C, {
      additionalProps: x,
      rowType: "header"
    }));
  }));
}
H8.displayName = "HeaderRow";
function Bne(e) {
  var t = [];
  function n(a, s) {
    var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    t[l] = t[l] || [];
    var u = s, f = a.filter(Boolean).map(function(p) {
      var h = {
        key: p.key,
        className: p.className || "",
        children: p.title,
        column: p,
        colStart: u
      }, y = 1, b = p.children;
      return b && b.length > 0 && (y = n(b, u, l + 1).reduce(function(m, v) {
        return m + v;
      }, 0), h.hasSubColumns = !0), "colSpan" in p && (y = p.colSpan), "rowSpan" in p && (h.rowSpan = p.rowSpan), h.colSpan = y, h.colEnd = h.colStart + y - 1, t[l].push(h), u += y, y;
    });
    return f;
  }
  n(e, 0);
  for (var r = t.length, o = function(s) {
    t[s].forEach(function(l) {
      !("rowSpan" in l) && !l.hasSubColumns && (l.rowSpan = r - s);
    });
  }, i = 0; i < r; i += 1)
    o(i);
  return t;
}
function Hne(e) {
  process.env.NODE_ENV !== "production" && Ns(e);
  var t = e.stickyOffsets, n = e.columns, r = e.flattenColumns, o = e.onHeaderRow, i = Ro(Vo, ["prefixCls", "getComponent"]), a = i.prefixCls, s = i.getComponent, l = c.useMemo(function() {
    return Bne(n);
  }, [n]), u = s(["header", "wrapper"], "thead"), f = s(["header", "row"], "tr"), p = s(["header", "cell"], "th"), h = s(["header", "cell"], "td");
  return /* @__PURE__ */ c.createElement(u, {
    className: "".concat(a, "-thead")
  }, l.map(function(y, b) {
    var m = /* @__PURE__ */ c.createElement(H8, {
      key: b,
      flattenColumns: r,
      cells: y,
      stickyOffsets: t,
      rowComponent: f,
      cellComponent: p,
      tdCellComponent: h,
      onHeaderRow: o,
      index: b
    });
    return m;
  }));
}
const qE = lu(Hne);
function YE(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof t == "number" ? t : t.endsWith("%") ? e * parseFloat(t) / 100 : null;
}
function zne(e, t, n) {
  return c.useMemo(function() {
    if (t && t > 0) {
      var r = 0, o = 0;
      e.forEach(function(h) {
        var y = YE(t, h.width);
        y ? r += y : o += 1;
      });
      var i = Math.max(t, n), a = Math.max(i - r, o), s = o, l = a / o, u = 0, f = e.map(function(h) {
        var y = J({}, h), b = YE(t, y.width);
        if (b)
          y.width = b;
        else {
          var m = Math.floor(l);
          y.width = s === 1 ? a : m, a -= m, s -= 1;
        }
        return u += y.width, y;
      });
      if (u < i) {
        var p = i / u;
        a = i, f.forEach(function(h, y) {
          var b = Math.floor(h.width * p);
          h.width = y === f.length - 1 ? a : b, a -= b;
        });
      }
      return [f, Math.max(u, i)];
    }
    return [e, t];
  }, [e, t, n]);
}
var Vne = ["children"], Wne = ["fixed"];
function xC(e) {
  return Rr(e).filter(function(t) {
    return /* @__PURE__ */ c.isValidElement(t);
  }).map(function(t) {
    var n = t.key, r = t.props, o = r.children, i = Yt(r, Vne), a = J({
      key: n
    }, i);
    return o && (a.children = xC(o)), a;
  });
}
function z8(e) {
  return e.filter(function(t) {
    return t && Vt(t) === "object" && !t.hidden;
  }).map(function(t) {
    var n = t.children;
    return n && n.length > 0 ? J(J({}, t), {}, {
      children: z8(n)
    }) : t;
  });
}
function ay(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return e.filter(function(n) {
    return n && Vt(n) === "object";
  }).reduce(function(n, r, o) {
    var i = r.fixed, a = i === !0 ? "left" : i, s = "".concat(t, "-").concat(o), l = r.children;
    return l && l.length > 0 ? [].concat(We(n), We(ay(l, s).map(function(u) {
      return J({
        fixed: a
      }, u);
    }))) : [].concat(We(n), [J(J({
      key: s
    }, r), {}, {
      fixed: a
    })]);
  }, []);
}
function Kne(e) {
  for (var t = !0, n = 0; n < e.length; n += 1) {
    var r = e[n];
    if (t && r.fixed !== "left")
      t = !1;
    else if (!t && r.fixed === "left") {
      mt(!1, "Index ".concat(n - 1, " of `columns` missing `fixed='left'` prop."));
      break;
    }
  }
  for (var o = !0, i = e.length - 1; i >= 0; i -= 1) {
    var a = e[i];
    if (o && a.fixed !== "right")
      o = !1;
    else if (!o && a.fixed === "right") {
      mt(!1, "Index ".concat(i + 1, " of `columns` missing `fixed='right'` prop."));
      break;
    }
  }
}
function Une(e) {
  return e.map(function(t) {
    var n = t.fixed, r = Yt(t, Wne), o = n;
    return n === "left" ? o = "right" : n === "right" && (o = "left"), J({
      fixed: o
    }, r);
  });
}
function Gne(e, t) {
  var n = e.prefixCls, r = e.columns, o = e.children, i = e.expandable, a = e.expandedKeys, s = e.columnTitle, l = e.getRowKey, u = e.onTriggerExpand, f = e.expandIcon, p = e.rowExpandable, h = e.expandIconColumnIndex, y = e.direction, b = e.expandRowByClick, m = e.columnWidth, v = e.fixed, C = e.scrollWidth, x = e.clientWidth, S = c.useMemo(function() {
    var j = r || xC(o) || [];
    return z8(j.slice());
  }, [r, o]), E = c.useMemo(function() {
    if (i) {
      var j = S.slice();
      if (process.env.NODE_ENV !== "production" && h >= 0 && mt(!1, "`expandIconColumnIndex` is deprecated. Please use `Table.EXPAND_COLUMN` in `columns` instead."), !j.includes(ta)) {
        var F = h || 0;
        F >= 0 && j.splice(F, 0, ta);
      }
      process.env.NODE_ENV !== "production" && j.filter(function(T) {
        return T === ta;
      }).length > 1 && mt(!1, "There exist more than one `EXPAND_COLUMN` in `columns`.");
      var A = j.indexOf(ta);
      j = j.filter(function(T, L) {
        return T !== ta || L === A;
      });
      var M = S[A], N;
      (v === "left" || v) && !h ? N = "left" : (v === "right" || v) && h === S.length ? N = "right" : N = M ? M.fixed : null;
      var D = K(K(K(K(K(K({}, dd, {
        className: "".concat(n, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), "title", s), "fixed", N), "className", "".concat(n, "-row-expand-icon-cell")), "width", m), "render", function(L, z, H) {
        var V = l(z, H), Y = a.has(V), Z = p ? p(z) : !0, oe = f({
          prefixCls: n,
          expanded: Y,
          expandable: Z,
          record: z,
          onExpand: u
        });
        return b ? /* @__PURE__ */ c.createElement("span", {
          onClick: function(ae) {
            return ae.stopPropagation();
          }
        }, oe) : oe;
      });
      return j.map(function(T) {
        return T === ta ? D : T;
      });
    }
    return process.env.NODE_ENV !== "production" && S.includes(ta) && mt(!1, "`expandable` is not config but there exist `EXPAND_COLUMN` in `columns`."), S.filter(function(T) {
      return T !== ta;
    });
  }, [i, S, l, a, f, y]), O = c.useMemo(function() {
    var j = E;
    return t && (j = t(j)), j.length || (j = [{
      render: function() {
        return null;
      }
    }]), j;
  }, [t, E, y]), $ = c.useMemo(function() {
    return y === "rtl" ? Une(ay(O)) : ay(O);
  }, [O, y, C]);
  process.env.NODE_ENV !== "production" && Kne(y === "rtl" ? $.slice().reverse() : $);
  var _ = zne($, C, x), R = de(_, 2), P = R[0], I = R[1];
  return [O, P, I];
}
function qne(e) {
  var t = e.prefixCls, n = e.record, r = e.onExpand, o = e.expanded, i = e.expandable, a = "".concat(t, "-row-expand-icon");
  if (!i)
    return /* @__PURE__ */ c.createElement("span", {
      className: se(a, "".concat(t, "-row-spaced"))
    });
  var s = function(u) {
    r(n, u), u.stopPropagation();
  };
  return /* @__PURE__ */ c.createElement("span", {
    className: se(a, K(K({}, "".concat(t, "-row-expanded"), o), "".concat(t, "-row-collapsed"), !o)),
    onClick: s
  });
}
function Yne(e, t, n) {
  var r = [];
  function o(i) {
    (i || []).forEach(function(a, s) {
      r.push(t(a, s)), o(a[n]);
    });
  }
  return o(e), r;
}
function Xne(e, t, n) {
  var r = Ane(e), o = r.expandIcon, i = r.expandedRowKeys, a = r.defaultExpandedRowKeys, s = r.defaultExpandAllRows, l = r.expandedRowRender, u = r.onExpand, f = r.onExpandedRowsChange, p = r.childrenColumnName, h = o || qne, y = p || "children", b = c.useMemo(function() {
    return l ? "row" : e.expandable && e.internalHooks === sf && e.expandable.__PARENT_RENDER_ICON__ || t.some(function(O) {
      return O && Vt(O) === "object" && O[y];
    }) ? "nest" : !1;
  }, [!!l, t]), m = c.useState(function() {
    return a || (s ? Yne(t, n, y) : []);
  }), v = de(m, 2), C = v[0], x = v[1], S = c.useMemo(function() {
    return new Set(i || C || []);
  }, [i, C]), E = c.useCallback(function(O) {
    var $ = n(O, t.indexOf(O)), _, R = S.has($);
    R ? (S.delete($), _ = We(S)) : _ = [].concat(We(S), [$]), x(_), u && u(!R, O), f && f(_);
  }, [n, S, t, u, f]);
  return process.env.NODE_ENV !== "production" && l && t.some(function(O) {
    return Array.isArray(O == null ? void 0 : O[y]);
  }) && mt(!1, "`expandedRowRender` should not use with nested Table"), [r, b, S, h, y, E];
}
function Zne(e, t, n, r) {
  var o = e.map(function(i, a) {
    return CC(a, a, e, t, n, r == null ? void 0 : r[a]);
  });
  return ua(function() {
    return o;
  }, [o], function(i, a) {
    return !Fi(i, a);
  });
}
function V8(e) {
  var t = _t(e), n = Ot({}), r = de(n, 2), o = r[1], i = _t(null), a = _t([]);
  function s(l) {
    a.current.push(l);
    var u = Promise.resolve();
    i.current = u, u.then(function() {
      if (i.current === u) {
        var f = a.current, p = t.current;
        a.current = [], f.forEach(function(h) {
          t.current = h(t.current);
        }), i.current = null, p !== t.current && o({});
      }
    });
  }
  return kt(function() {
    return function() {
      i.current = null;
    };
  }, []), [t.current, s];
}
function Qne(e) {
  var t = _t(e || null), n = _t();
  function r() {
    window.clearTimeout(n.current);
  }
  function o(a) {
    t.current = a, r(), n.current = window.setTimeout(function() {
      t.current = null, n.current = void 0;
    }, 100);
  }
  function i() {
    return t.current;
  }
  return kt(function() {
    return r;
  }, []), [o, i];
}
function Jne() {
  var e = c.useState(-1), t = de(e, 2), n = t[0], r = t[1], o = c.useState(-1), i = de(o, 2), a = i[0], s = i[1], l = c.useCallback(function(u, f) {
    r(u), s(f);
  }, []);
  return [n, a, l];
}
var XE = Hr() ? window : null;
function ere(e, t) {
  var n = Vt(e) === "object" ? e : {}, r = n.offsetHeader, o = r === void 0 ? 0 : r, i = n.offsetSummary, a = i === void 0 ? 0 : i, s = n.offsetScroll, l = s === void 0 ? 0 : s, u = n.getContainer, f = u === void 0 ? function() {
    return XE;
  } : u, p = f() || XE;
  return c.useMemo(function() {
    var h = !!e;
    return {
      isSticky: h,
      stickyClassName: h ? "".concat(t, "-sticky-holder") : "",
      offsetHeader: o,
      offsetSummary: a,
      offsetScroll: l,
      container: p
    };
  }, [l, o, a, t, p]);
}
function tre(e, t, n) {
  var r = mr(function() {
    for (var o = [], i = [], a = 0, s = 0, l = 0; l < t; l += 1)
      if (n === "rtl") {
        i[l] = s, s += e[l] || 0;
        var u = t - l - 1;
        o[u] = a, a += e[u] || 0;
      } else {
        o[l] = a, a += e[l] || 0;
        var f = t - l - 1;
        i[f] = s, s += e[f] || 0;
      }
    return {
      left: o,
      right: i
    };
  }, [e, t, n]);
  return r;
}
function ZE(e) {
  var t = e.className, n = e.children;
  return /* @__PURE__ */ c.createElement("div", {
    className: t
  }, n);
}
var nre = function(t, n) {
  var r, o, i = t.scrollBodyRef, a = t.onScroll, s = t.offsetScroll, l = t.container, u = Ro(Vo, "prefixCls"), f = ((r = i.current) === null || r === void 0 ? void 0 : r.scrollWidth) || 0, p = ((o = i.current) === null || o === void 0 ? void 0 : o.clientWidth) || 0, h = f && p * (p / f), y = c.useRef(), b = V8({
    scrollLeft: 0,
    isHiddenScrollBar: !1
  }), m = de(b, 2), v = m[0], C = m[1], x = c.useRef({
    delta: 0,
    x: 0
  }), S = c.useState(!1), E = de(S, 2), O = E[0], $ = E[1], _ = function() {
    $(!1);
  }, R = function(A) {
    A.persist(), x.current.delta = A.pageX - v.scrollLeft, x.current.x = 0, $(!0), A.preventDefault();
  }, P = function(A) {
    var M, N = A || ((M = window) === null || M === void 0 ? void 0 : M.event), D = N.buttons;
    if (!O || D === 0) {
      O && $(!1);
      return;
    }
    var T = x.current.x + A.pageX - x.current.x - x.current.delta;
    T <= 0 && (T = 0), T + h >= p && (T = p - h), a({
      scrollLeft: T / p * (f + 2)
    }), x.current.x = A.pageX;
  }, I = function() {
    if (i.current) {
      var A = AE(i.current).top, M = A + i.current.offsetHeight, N = l === window ? document.documentElement.scrollTop + window.innerHeight : AE(l).top + l.clientHeight;
      M - $1() <= N || A >= N - s ? C(function(D) {
        return J(J({}, D), {}, {
          isHiddenScrollBar: !0
        });
      }) : C(function(D) {
        return J(J({}, D), {}, {
          isHiddenScrollBar: !1
        });
      });
    }
  }, j = function(A) {
    C(function(M) {
      return J(J({}, M), {}, {
        scrollLeft: A / f * p || 0
      });
    });
  };
  return c.useImperativeHandle(n, function() {
    return {
      setScrollLeft: j
    };
  }), c.useEffect(function() {
    var F = Pp(document.body, "mouseup", _, !1), A = Pp(document.body, "mousemove", P, !1);
    return I(), function() {
      F.remove(), A.remove();
    };
  }, [h, O]), c.useEffect(function() {
    var F = Pp(l, "scroll", I, !1), A = Pp(window, "resize", I, !1);
    return function() {
      F.remove(), A.remove();
    };
  }, [l]), c.useEffect(function() {
    v.isHiddenScrollBar || C(function(F) {
      var A = i.current;
      return A ? J(J({}, F), {}, {
        scrollLeft: A.scrollLeft / A.scrollWidth * A.clientWidth
      }) : F;
    });
  }, [v.isHiddenScrollBar]), f <= p || !h || v.isHiddenScrollBar ? null : /* @__PURE__ */ c.createElement("div", {
    style: {
      height: $1(),
      width: p,
      bottom: s
    },
    className: "".concat(u, "-sticky-scroll")
  }, /* @__PURE__ */ c.createElement("div", {
    onMouseDown: R,
    ref: y,
    className: se("".concat(u, "-sticky-scroll-bar"), K({}, "".concat(u, "-sticky-scroll-bar-active"), O)),
    style: {
      width: "".concat(h, "px"),
      transform: "translate3d(".concat(v.scrollLeft, "px, 0, 0)")
    }
  }));
};
const rre = /* @__PURE__ */ c.forwardRef(nre);
var W8 = "rc-table", ore = [], ire = {};
function are() {
  return "No Data";
}
function sre(e, t) {
  var n = J({
    rowKey: "key",
    prefixCls: W8,
    emptyText: are
  }, e), r = n.prefixCls, o = n.className, i = n.rowClassName, a = n.style, s = n.data, l = n.rowKey, u = n.scroll, f = n.tableLayout, p = n.direction, h = n.title, y = n.footer, b = n.summary, m = n.caption, v = n.id, C = n.showHeader, x = n.components, S = n.emptyText, E = n.onRow, O = n.onHeaderRow, $ = n.internalHooks, _ = n.transformColumns, R = n.internalRefs, P = n.tailor, I = n.getContainerWidth, j = n.sticky, F = s || ore, A = !!F.length, M = $ === sf;
  process.env.NODE_ENV !== "production" && (["onRowClick", "onRowDoubleClick", "onRowContextMenu", "onRowMouseEnter", "onRowMouseLeave"].forEach(function(Gt) {
    mt(n[Gt] === void 0, "`".concat(Gt, "` is removed, please use `onRow` instead."));
  }), mt(!("getBodyWrapper" in n), "`getBodyWrapper` is deprecated, please use custom `components` instead."));
  var N = c.useCallback(function(Gt, Zt) {
    return yi(x, Gt) || Zt;
  }, [x]), D = c.useMemo(function() {
    return typeof l == "function" ? l : function(Gt) {
      var Zt = Gt && Gt[l];
      return process.env.NODE_ENV !== "production" && mt(Zt !== void 0, "Each record in table should have a unique `key` prop, or set `rowKey` to an unique primary key."), Zt;
    };
  }, [l]), T = N(["body"]), L = Jne(), z = de(L, 3), H = z[0], V = z[1], Y = z[2], Z = Xne(n, F, D), oe = de(Z, 6), ee = oe[0], ae = oe[1], le = oe[2], ue = oe[3], ie = oe[4], re = oe[5], Q = u == null ? void 0 : u.x, ce = c.useState(0), ge = de(ce, 2), G = ge[0], ne = ge[1], fe = Gne(J(J(J({}, n), ee), {}, {
    expandable: !!ee.expandedRowRender,
    columnTitle: ee.columnTitle,
    expandedKeys: le,
    getRowKey: D,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: re,
    expandIcon: ue,
    expandIconColumnIndex: ee.expandIconColumnIndex,
    direction: p,
    scrollWidth: M && P && typeof Q == "number" ? Q : null,
    clientWidth: G
  }), M ? _ : null), ye = de(fe, 3), we = ye[0], he = ye[1], me = ye[2], Ce = me != null ? me : Q, Te = c.useMemo(function() {
    return {
      columns: we,
      flattenColumns: he
    };
  }, [we, he]), Ee = c.useRef(), Ge = c.useRef(), ke = c.useRef(), qe = c.useRef();
  c.useImperativeHandle(t, function() {
    return {
      nativeElement: Ee.current,
      scrollTo: function(Zt) {
        var hn;
        if (ke.current instanceof HTMLElement) {
          var tn = Zt.index, yr = Zt.top, _r = Zt.key;
          if (yr) {
            var Wr;
            (Wr = ke.current) === null || Wr === void 0 || Wr.scrollTo({
              top: yr
            });
          } else {
            var jr, ao = _r != null ? _r : D(F[tn]);
            (jr = ke.current.querySelector('[data-row-key="'.concat(ao, '"]'))) === null || jr === void 0 || jr.scrollIntoView();
          }
        } else
          (hn = ke.current) !== null && hn !== void 0 && hn.scrollTo && ke.current.scrollTo(Zt);
      }
    };
  });
  var ze = c.useRef(), pt = c.useState(!1), Ke = de(pt, 2), et = Ke[0], Je = Ke[1], Et = c.useState(!1), Ye = de(Et, 2), wt = Ye[0], dt = Ye[1], Ct = V8(/* @__PURE__ */ new Map()), ot = de(Ct, 2), jt = ot[0], Rt = ot[1], Le = im(he), Ve = Le.map(function(Gt) {
    return jt.get(Gt);
  }), Ae = c.useMemo(function() {
    return Ve;
  }, [Ve.join("_")]), ft = tre(Ae, he.length, p), He = u && iy(u.y), Fe = u && iy(Ce) || !!ee.fixed, yt = Fe && he.some(function(Gt) {
    var Zt = Gt.fixed;
    return Zt;
  }), Qe = c.useRef(), tt = ere(j, r), lt = tt.isSticky, ht = tt.offsetHeader, bt = tt.offsetSummary, ct = tt.offsetScroll, xt = tt.stickyClassName, vt = tt.container, _e = c.useMemo(function() {
    return b == null ? void 0 : b(F);
  }, [b, F]), Ze = (He || lt) && /* @__PURE__ */ c.isValidElement(_e) && _e.type === am && _e.props.fixed, q, Se, Re;
  He && (Se = {
    overflowY: "scroll",
    maxHeight: u.y
  }), Fe && (q = {
    overflowX: "auto"
  }, He || (Se = {
    overflowY: "hidden"
  }), Re = {
    width: Ce === !0 ? "auto" : Ce,
    minWidth: "100%"
  });
  var ut = c.useCallback(function(Gt, Zt) {
    Qc(Ee.current) && Rt(function(hn) {
      if (hn.get(Gt) !== Zt) {
        var tn = new Map(hn);
        return tn.set(Gt, Zt), tn;
      }
      return hn;
    });
  }, []), $t = Qne(null), Ne = de($t, 2), Ie = Ne[0], De = Ne[1];
  function Me(Gt, Zt) {
    Zt && (typeof Zt == "function" ? Zt(Gt) : Zt.scrollLeft !== Gt && (Zt.scrollLeft = Gt, Zt.scrollLeft !== Gt && setTimeout(function() {
      Zt.scrollLeft = Gt;
    }, 0)));
  }
  var Tt = Ir(function(Gt) {
    var Zt = Gt.currentTarget, hn = Gt.scrollLeft, tn = p === "rtl", yr = typeof hn == "number" ? hn : Zt.scrollLeft, _r = Zt || ire;
    if (!De() || De() === _r) {
      var Wr;
      Ie(_r), Me(yr, Ge.current), Me(yr, ke.current), Me(yr, ze.current), Me(yr, (Wr = Qe.current) === null || Wr === void 0 ? void 0 : Wr.setScrollLeft);
    }
    var jr = Zt || Ge.current;
    if (jr) {
      var ao = jr.scrollWidth, To = jr.clientWidth;
      if (ao === To) {
        Je(!1), dt(!1);
        return;
      }
      tn ? (Je(-yr < ao - To), dt(-yr > 0)) : (Je(yr > 0), dt(yr < ao - To));
    }
  }), Pt = function() {
    Fe && ke.current ? Tt({
      currentTarget: ke.current
    }) : (Je(!1), dt(!1));
  }, Ut = function(Zt) {
    var hn = Zt.width, tn = Ee.current ? Ee.current.offsetWidth : hn;
    M && I && Ee.current && (tn = I(Ee.current, tn) || tn), tn !== G && (Pt(), ne(tn));
  }, Kt = c.useRef(!1);
  c.useEffect(function() {
    Kt.current && Pt();
  }, [Fe, s, we.length]), c.useEffect(function() {
    Kt.current = !0;
  }, []);
  var $n = c.useState(0), Jt = de($n, 2), On = Jt[0], Jn = Jt[1], er = c.useState(!0), Xt = de(er, 2), It = Xt[0], St = Xt[1];
  c.useEffect(function() {
    (!P || !M) && (ke.current instanceof Element ? Jn(O1(ke.current).width) : Jn(O1(qe.current).width)), St(_1("position", "sticky"));
  }, []), c.useEffect(function() {
    M && R && (R.body.current = ke.current);
  });
  var Lt = c.useCallback(function(Gt) {
    return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(qE, Gt), Ze === "top" && /* @__PURE__ */ c.createElement(Rp, Gt, _e));
  }, [Ze, _e]), ln = c.useCallback(function(Gt) {
    return /* @__PURE__ */ c.createElement(Rp, Gt, _e);
  }, [_e]), lr = N(["table"], "table"), fr = c.useMemo(function() {
    return f || (yt ? Ce === "max-content" ? "auto" : "fixed" : He || lt || he.some(function(Gt) {
      var Zt = Gt.ellipsis;
      return Zt;
    }) ? "fixed" : "auto");
  }, [He, yt, he, f, lt]), Er, Qr = {
    colWidths: Ae,
    columCount: he.length,
    stickyOffsets: ft,
    onHeaderRow: O,
    fixHeader: He,
    scroll: u
  }, $r = c.useMemo(function() {
    return A ? null : typeof S == "function" ? S() : S;
  }, [A, S]), Or = /* @__PURE__ */ c.createElement(Mne, {
    data: F,
    measureColumnWidth: He || Fe || lt
  }), io = /* @__PURE__ */ c.createElement(F8, {
    colWidths: he.map(function(Gt) {
      var Zt = Gt.width;
      return Zt;
    }),
    columns: he
  }), At = m != null ? /* @__PURE__ */ c.createElement("caption", {
    className: "".concat(r, "-caption")
  }, m) : void 0, Nt = ei(n, {
    data: !0
  }), Qt = ei(n, {
    aria: !0
  });
  if (He || lt) {
    var vn;
    typeof T == "function" ? (vn = T(F, {
      scrollbarSize: On,
      ref: ke,
      onScroll: Tt
    }), Qr.colWidths = he.map(function(Gt, Zt) {
      var hn = Gt.width, tn = Zt === he.length - 1 ? hn - On : hn;
      return typeof tn == "number" && !Number.isNaN(tn) ? tn : (process.env.NODE_ENV !== "production" && mt(n.columns.length === 0, "When use `components.body` with render props. Each column should have a fixed `width` value."), 0);
    })) : vn = /* @__PURE__ */ c.createElement("div", {
      style: J(J({}, q), Se),
      onScroll: Tt,
      ref: ke,
      className: se("".concat(r, "-body"))
    }, /* @__PURE__ */ c.createElement(lr, Oe({
      style: J(J({}, Re), {}, {
        tableLayout: fr
      })
    }, Qt), At, io, Or, !Ze && _e && /* @__PURE__ */ c.createElement(Rp, {
      stickyOffsets: ft,
      flattenColumns: he,
      columns: we
    }, _e)));
    var sn = J(J(J({
      noData: !F.length,
      maxContentScroll: Fe && Ce === "max-content"
    }, Qr), Te), {}, {
      direction: p,
      stickyClassName: xt,
      onScroll: Tt
    });
    Er = /* @__PURE__ */ c.createElement(c.Fragment, null, C !== !1 && /* @__PURE__ */ c.createElement(GE, Oe({}, sn, {
      stickyTopOffset: ht,
      className: "".concat(r, "-header"),
      ref: Ge
    }), Lt), vn, Ze && Ze !== "top" && /* @__PURE__ */ c.createElement(GE, Oe({}, sn, {
      stickyBottomOffset: bt,
      className: "".concat(r, "-summary"),
      ref: ze
    }), ln), lt && ke.current && ke.current instanceof Element && /* @__PURE__ */ c.createElement(rre, {
      ref: Qe,
      offsetScroll: ct,
      scrollBodyRef: ke,
      onScroll: Tt,
      container: vt
    }));
  } else
    Er = /* @__PURE__ */ c.createElement("div", {
      style: J(J({}, q), Se),
      className: se("".concat(r, "-content")),
      onScroll: Tt,
      ref: ke
    }, /* @__PURE__ */ c.createElement(lr, Oe({
      style: J(J({}, Re), {}, {
        tableLayout: fr
      })
    }, Qt), At, io, C !== !1 && /* @__PURE__ */ c.createElement(qE, Oe({}, Qr, Te)), Or, _e && /* @__PURE__ */ c.createElement(Rp, {
      stickyOffsets: ft,
      flattenColumns: he,
      columns: we
    }, _e)));
  var Mn = /* @__PURE__ */ c.createElement("div", Oe({
    className: se(r, o, K(K(K(K(K(K(K(K(K({}, "".concat(r, "-rtl"), p === "rtl"), "".concat(r, "-ping-left"), et), "".concat(r, "-ping-right"), wt), "".concat(r, "-layout-fixed"), f === "fixed"), "".concat(r, "-fixed-header"), He), "".concat(r, "-fixed-column"), yt), "".concat(r, "-scroll-horizontal"), Fe), "".concat(r, "-has-fix-left"), he[0] && he[0].fixed), "".concat(r, "-has-fix-right"), he[he.length - 1] && he[he.length - 1].fixed === "right")),
    style: a,
    id: v,
    ref: Ee
  }, Nt), h && /* @__PURE__ */ c.createElement(ZE, {
    className: "".concat(r, "-title")
  }, h(F)), /* @__PURE__ */ c.createElement("div", {
    ref: qe,
    className: "".concat(r, "-container")
  }, Er), y && /* @__PURE__ */ c.createElement(ZE, {
    className: "".concat(r, "-footer")
  }, y(F)));
  Fe && (Mn = /* @__PURE__ */ c.createElement(zo, {
    onResize: Ut
  }, Mn));
  var Wn = Zne(he, ft, p, we), Dr = c.useMemo(function() {
    return {
      // Scroll
      scrollX: Ce,
      // Table
      prefixCls: r,
      getComponent: N,
      scrollbarSize: On,
      direction: p,
      fixedInfoList: Wn,
      isSticky: lt,
      supportSticky: It,
      componentWidth: G,
      fixHeader: He,
      fixColumn: yt,
      horizonScroll: Fe,
      // Body
      tableLayout: fr,
      rowClassName: i,
      expandedRowClassName: ee.expandedRowClassName,
      expandIcon: ue,
      expandableType: ae,
      expandRowByClick: ee.expandRowByClick,
      expandedRowRender: ee.expandedRowRender,
      onTriggerExpand: re,
      expandIconColumnIndex: ee.expandIconColumnIndex,
      indentSize: ee.indentSize,
      allColumnsFixedLeft: he.every(function(Gt) {
        return Gt.fixed === "left";
      }),
      emptyNode: $r,
      // Column
      columns: we,
      flattenColumns: he,
      onColumnResize: ut,
      // Row
      hoverStartRow: H,
      hoverEndRow: V,
      onHover: Y,
      rowExpandable: ee.rowExpandable,
      onRow: E,
      getRowKey: D,
      expandedKeys: le,
      childrenColumnName: ie
    };
  }, [
    // Scroll
    Ce,
    // Table
    r,
    N,
    On,
    p,
    Wn,
    lt,
    It,
    G,
    He,
    yt,
    Fe,
    // Body
    fr,
    i,
    ee.expandedRowClassName,
    ue,
    ae,
    ee.expandRowByClick,
    ee.expandedRowRender,
    re,
    ee.expandIconColumnIndex,
    ee.indentSize,
    $r,
    // Column
    we,
    he,
    ut,
    // Row
    H,
    V,
    Y,
    ee.rowExpandable,
    E,
    D,
    le,
    ie
  ]);
  return /* @__PURE__ */ c.createElement(Vo.Provider, {
    value: Dr
  }, Mn);
}
var K8 = /* @__PURE__ */ c.forwardRef(sre);
process.env.NODE_ENV !== "production" && (K8.displayName = "Table");
function U8(e) {
  return _8(K8, e);
}
var cu = U8();
cu.EXPAND_COLUMN = ta;
cu.INTERNAL_HOOKS = sf;
cu.Column = Pne;
cu.ColumnGroup = Ine;
cu.Summary = R8;
var G8 = yC(null), q8 = yC(null);
function lre(e, t, n) {
  var r = t || 1;
  return n[e + r] - (n[e] || 0);
}
function cre(e) {
  var t = e.rowInfo, n = e.column, r = e.colIndex, o = e.indent, i = e.index, a = e.renderIndex, s = e.record, l = e.style, u = e.className, f = e.inverse, p = e.getHeight, h = n.render, y = n.dataIndex, b = n.className, m = n.width, v = Ro(q8, ["columnsOffset"]), C = v.columnsOffset, x = A8(t, n, r, o, i), S = x.key, E = x.fixedInfo, O = x.appendCellNode, $ = x.additionalCellProps, _ = $.style, R = $.colSpan, P = R === void 0 ? 1 : R, I = $.rowSpan, j = I === void 0 ? 1 : I, F = r - 1, A = lre(F, P, C), M = P > 1 ? m - A : 0, N = J(J(J({}, _), l), {}, {
    flex: "0 0 ".concat(A, "px"),
    width: "".concat(A, "px"),
    marginRight: M,
    pointerEvents: "auto"
  }), D = c.useMemo(function() {
    return f ? j <= 1 : P === 0 || j === 0 || j > 1;
  }, [j, P, f]);
  D ? N.visibility = "hidden" : f && (N.height = p == null ? void 0 : p(j));
  var T = D ? function() {
    return null;
  } : h, L = {};
  return (j === 0 || P === 0) && (L.rowSpan = 1, L.colSpan = 1), /* @__PURE__ */ c.createElement(Tl, Oe({
    className: se(b, u),
    ellipsis: n.ellipsis,
    align: n.align,
    scope: n.rowScope,
    component: "div",
    prefixCls: t.prefixCls,
    key: S,
    record: s,
    index: i,
    renderIndex: a,
    dataIndex: y,
    render: T,
    shouldCellUpdate: n.shouldCellUpdate
  }, E, {
    appendNode: O,
    additionalProps: J(J({}, $), {}, {
      style: N
    }, L)
  }));
}
var ure = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], dre = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.data, r = e.index, o = e.className, i = e.rowKey, a = e.style, s = e.extra, l = e.getHeight, u = Yt(e, ure), f = n.record, p = n.indent, h = n.index, y = Ro(Vo, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), b = y.scrollX, m = y.flattenColumns, v = y.prefixCls, C = y.fixColumn, x = y.componentWidth, S = M8(f, i, r, p), E = S.rowSupportExpand, O = S.expanded, $ = S.rowProps, _ = S.expandedRowRender, R = S.expandedRowClassName, P;
  if (E && O) {
    var I = _(f, r, p + 1, O), j = R == null ? void 0 : R(f, r, p), F = {};
    C && (F = {
      style: K({}, "--virtual-width", "".concat(x, "px"))
    });
    var A = "".concat(v, "-expanded-row-cell");
    P = /* @__PURE__ */ c.createElement("div", {
      className: se("".concat(v, "-expanded-row"), "".concat(v, "-expanded-row-level-").concat(p + 1), j)
    }, /* @__PURE__ */ c.createElement(Tl, {
      component: "div",
      prefixCls: v,
      className: se(A, K({}, "".concat(A, "-fixed"), C)),
      additionalProps: F
    }, I));
  }
  var M = J(J({}, a), {}, {
    width: b
  });
  s && (M.position = "absolute", M.pointerEvents = "none");
  var N = /* @__PURE__ */ c.createElement("div", Oe({}, $, u, {
    ref: E ? null : t,
    className: se(o, "".concat(v, "-row"), $ == null ? void 0 : $.className, K({}, "".concat(v, "-row-extra"), s)),
    style: J(J({}, M), $ == null ? void 0 : $.style)
  }), m.map(function(D, T) {
    return /* @__PURE__ */ c.createElement(cre, {
      key: T,
      rowInfo: S,
      column: D,
      colIndex: T,
      indent: p,
      index: r,
      renderIndex: h,
      record: f,
      inverse: s,
      getHeight: l
    });
  }));
  return E ? /* @__PURE__ */ c.createElement("div", {
    ref: t
  }, N, P) : N;
}), sy = lu(dre);
process.env.NODE_ENV !== "production" && (sy.displayName = "BodyLine");
var fre = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.data, r = e.onScroll, o = Ro(Vo, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "emptyNode", "scrollX"]), i = o.flattenColumns, a = o.onColumnResize, s = o.getRowKey, l = o.expandedKeys, u = o.prefixCls, f = o.childrenColumnName, p = o.emptyNode, h = o.scrollX, y = Ro(G8), b = y.sticky, m = y.scrollY, v = y.listItemHeight, C = c.useRef(), x = T8(n, f, l, s), S = c.useMemo(function() {
    var j = 0;
    return i.map(function(F) {
      var A = F.width, M = F.key;
      return j += A, [M, A, j];
    });
  }, [i]), E = c.useMemo(function() {
    return S.map(function(j) {
      return j[2];
    });
  }, [S]);
  c.useEffect(function() {
    S.forEach(function(j) {
      var F = de(j, 2), A = F[0], M = F[1];
      a(A, M);
    });
  }, [S]), c.useImperativeHandle(t, function() {
    var j = {
      scrollTo: function(A) {
        var M;
        (M = C.current) === null || M === void 0 || M.scrollTo(A);
      }
    };
    return Object.defineProperty(j, "scrollLeft", {
      get: function() {
        var A;
        return ((A = C.current) === null || A === void 0 ? void 0 : A.getScrollInfo().x) || 0;
      },
      set: function(A) {
        var M;
        (M = C.current) === null || M === void 0 || M.scrollTo({
          left: A
        });
      }
    }), j;
  });
  var O = function(F, A) {
    var M, N = (M = x[A]) === null || M === void 0 ? void 0 : M.record, D = F.onCell;
    if (D) {
      var T, L = D(N, A);
      return (T = L == null ? void 0 : L.rowSpan) !== null && T !== void 0 ? T : 1;
    }
    return 1;
  }, $ = function(F) {
    var A = F.start, M = F.end, N = F.getSize, D = F.offsetY;
    if (M < 0)
      return null;
    for (var T = i.filter(
      // rowSpan is 0
      function(ie) {
        return O(ie, A) === 0;
      }
    ), L = A, z = function(re) {
      if (T = T.filter(function(Q) {
        return O(Q, re) === 0;
      }), !T.length)
        return L = re, 1;
    }, H = A; H >= 0 && !z(H); H -= 1)
      ;
    for (var V = i.filter(
      // rowSpan is not 1
      function(ie) {
        return O(ie, M) !== 1;
      }
    ), Y = M, Z = function(re) {
      if (V = V.filter(function(Q) {
        return O(Q, re) !== 1;
      }), !V.length)
        return Y = Math.max(re - 1, M), 1;
    }, oe = M; oe < x.length && !Z(oe); oe += 1)
      ;
    for (var ee = [], ae = function(re) {
      var Q = x[re];
      if (!Q)
        return 1;
      i.some(function(ce) {
        return O(ce, re) > 1;
      }) && ee.push(re);
    }, le = L; le <= Y; le += 1)
      ae(le);
    var ue = ee.map(function(ie) {
      var re = x[ie], Q = s(re.record, ie), ce = function(ne) {
        var fe = ie + ne - 1, ye = s(x[fe].record, fe), we = N(Q, ye);
        return we.bottom - we.top;
      }, ge = N(Q);
      return /* @__PURE__ */ c.createElement(sy, {
        key: ie,
        data: re,
        rowKey: Q,
        index: ie,
        style: {
          top: -D + ge.top
        },
        extra: !0,
        getHeight: ce
      });
    });
    return ue;
  }, _ = c.useMemo(function() {
    return {
      columnsOffset: E
    };
  }, [E]), R = "".concat(u, "-tbody"), P;
  if (x.length) {
    var I = {};
    b && (I.position = "sticky", I.bottom = 0, Vt(b) === "object" && b.offsetScroll && (I.bottom = b.offsetScroll)), P = /* @__PURE__ */ c.createElement(kg, {
      fullHeight: !1,
      ref: C,
      styles: {
        horizontalScrollBar: I
      },
      className: se(R, "".concat(R, "-virtual")),
      height: m,
      itemHeight: v || 24,
      data: x,
      itemKey: function(F) {
        return s(F.record);
      },
      scrollWidth: h,
      onVirtualScroll: function(F) {
        var A = F.x;
        r({
          scrollLeft: A
        });
      },
      extraRender: $
    }, function(j, F, A) {
      var M = s(j.record, F);
      return /* @__PURE__ */ c.createElement(sy, Oe({
        data: j,
        rowKey: M,
        index: F
      }, A));
    });
  } else
    P = /* @__PURE__ */ c.createElement("div", {
      className: se("".concat(u, "-placeholder"))
    }, /* @__PURE__ */ c.createElement(Tl, {
      component: "div",
      prefixCls: u
    }, p));
  return /* @__PURE__ */ c.createElement(q8.Provider, {
    value: _
  }, P);
}), Y8 = lu(fre);
process.env.NODE_ENV !== "production" && (Y8.displayName = "ResponseGrid");
var pre = function(t, n) {
  var r = n.ref, o = n.onScroll;
  return /* @__PURE__ */ c.createElement(Y8, {
    ref: r,
    data: t,
    onScroll: o
  });
};
function hre(e, t) {
  var n = e.columns, r = e.scroll, o = e.sticky, i = e.prefixCls, a = i === void 0 ? W8 : i, s = e.className, l = e.listItemHeight, u = e.components, f = r || {}, p = f.x, h = f.y;
  typeof p != "number" && (process.env.NODE_ENV !== "production" && mt(!p, "`scroll.x` in virtual table must be number."), p = 1), typeof h != "number" && (h = 500, process.env.NODE_ENV !== "production" && mt(!1, "`scroll.y` in virtual table must be number."));
  var y = c.useMemo(function() {
    return {
      sticky: o,
      scrollY: h,
      listItemHeight: l
    };
  }, [o, h, l]);
  return /* @__PURE__ */ c.createElement(G8.Provider, {
    value: y
  }, /* @__PURE__ */ c.createElement(cu, Oe({}, e, {
    className: se(s, "".concat(a, "-virtual")),
    scroll: J(J({}, r), {}, {
      x: p
    }),
    components: J(J({}, u), {}, {
      body: pre
    }),
    columns: n,
    internalHooks: sf,
    tailor: !0,
    ref: t
  })));
}
var X8 = /* @__PURE__ */ c.forwardRef(hre);
process.env.NODE_ENV !== "production" && (X8.displayName = "VirtualTable");
function Z8(e) {
  return _8(X8, e);
}
Z8();
function gre(e) {
  return null;
}
function mre(e) {
  return null;
}
var SC = /* @__PURE__ */ c.createContext(null), vre = function(t) {
  for (var n = t.prefixCls, r = t.level, o = t.isStart, i = t.isEnd, a = "".concat(n, "-indent-unit"), s = [], l = 0; l < r; l += 1)
    s.push(/* @__PURE__ */ c.createElement("span", {
      key: l,
      className: se(a, K(K({}, "".concat(a, "-start"), o[l]), "".concat(a, "-end"), i[l]))
    }));
  return /* @__PURE__ */ c.createElement("span", {
    "aria-hidden": "true",
    className: "".concat(n, "-indent")
  }, s);
};
const yre = /* @__PURE__ */ c.memo(vre);
var bre = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], QE = "open", JE = "close", Cre = "---", xre = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    var r;
    zr(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), K(nt(r), "state", {
      dragNodeHighlight: !1
    }), K(nt(r), "selectHandle", void 0), K(nt(r), "cacheIndent", void 0), K(nt(r), "onSelectorClick", function(s) {
      var l = r.props.context.onNodeClick;
      l(s, kr(r.props)), r.isSelectable() ? r.onSelect(s) : r.onCheck(s);
    }), K(nt(r), "onSelectorDoubleClick", function(s) {
      var l = r.props.context.onNodeDoubleClick;
      l(s, kr(r.props));
    }), K(nt(r), "onSelect", function(s) {
      if (!r.isDisabled()) {
        var l = r.props.context.onNodeSelect;
        l(s, kr(r.props));
      }
    }), K(nt(r), "onCheck", function(s) {
      if (!r.isDisabled()) {
        var l = r.props, u = l.disableCheckbox, f = l.checked, p = r.props.context.onNodeCheck;
        if (!(!r.isCheckable() || u)) {
          var h = !f;
          p(s, kr(r.props), h);
        }
      }
    }), K(nt(r), "onMouseEnter", function(s) {
      var l = r.props.context.onNodeMouseEnter;
      l(s, kr(r.props));
    }), K(nt(r), "onMouseLeave", function(s) {
      var l = r.props.context.onNodeMouseLeave;
      l(s, kr(r.props));
    }), K(nt(r), "onContextMenu", function(s) {
      var l = r.props.context.onNodeContextMenu;
      l(s, kr(r.props));
    }), K(nt(r), "onDragStart", function(s) {
      var l = r.props.context.onNodeDragStart;
      s.stopPropagation(), r.setState({
        dragNodeHighlight: !0
      }), l(s, nt(r));
      try {
        s.dataTransfer.setData("text/plain", "");
      } catch (u) {
      }
    }), K(nt(r), "onDragEnter", function(s) {
      var l = r.props.context.onNodeDragEnter;
      s.preventDefault(), s.stopPropagation(), l(s, nt(r));
    }), K(nt(r), "onDragOver", function(s) {
      var l = r.props.context.onNodeDragOver;
      s.preventDefault(), s.stopPropagation(), l(s, nt(r));
    }), K(nt(r), "onDragLeave", function(s) {
      var l = r.props.context.onNodeDragLeave;
      s.stopPropagation(), l(s, nt(r));
    }), K(nt(r), "onDragEnd", function(s) {
      var l = r.props.context.onNodeDragEnd;
      s.stopPropagation(), r.setState({
        dragNodeHighlight: !1
      }), l(s, nt(r));
    }), K(nt(r), "onDrop", function(s) {
      var l = r.props.context.onNodeDrop;
      s.preventDefault(), s.stopPropagation(), r.setState({
        dragNodeHighlight: !1
      }), l(s, nt(r));
    }), K(nt(r), "onExpand", function(s) {
      var l = r.props, u = l.loading, f = l.context.onNodeExpand;
      u || f(s, kr(r.props));
    }), K(nt(r), "setSelectHandle", function(s) {
      r.selectHandle = s;
    }), K(nt(r), "getNodeState", function() {
      var s = r.props.expanded;
      return r.isLeaf() ? null : s ? QE : JE;
    }), K(nt(r), "hasChildren", function() {
      var s = r.props.eventKey, l = r.props.context.keyEntities, u = Qo(l, s) || {}, f = u.children;
      return !!(f || []).length;
    }), K(nt(r), "isLeaf", function() {
      var s = r.props, l = s.isLeaf, u = s.loaded, f = r.props.context.loadData, p = r.hasChildren();
      return l === !1 ? !1 : l || !f && !p || f && u && !p;
    }), K(nt(r), "isDisabled", function() {
      var s = r.props.disabled, l = r.props.context.disabled;
      return !!(l || s);
    }), K(nt(r), "isCheckable", function() {
      var s = r.props.checkable, l = r.props.context.checkable;
      return !l || s === !1 ? !1 : l;
    }), K(nt(r), "syncLoadData", function(s) {
      var l = s.expanded, u = s.loading, f = s.loaded, p = r.props.context, h = p.loadData, y = p.onNodeLoad;
      u || h && l && !r.isLeaf() && !r.hasChildren() && !f && y(kr(r.props));
    }), K(nt(r), "isDraggable", function() {
      var s = r.props, l = s.data, u = s.context.draggable;
      return !!(u && (!u.nodeDraggable || u.nodeDraggable(l)));
    }), K(nt(r), "renderDragHandler", function() {
      var s = r.props.context, l = s.draggable, u = s.prefixCls;
      return l != null && l.icon ? /* @__PURE__ */ c.createElement("span", {
        className: "".concat(u, "-draggable-icon")
      }, l.icon) : null;
    }), K(nt(r), "renderSwitcherIconDom", function(s) {
      var l = r.props.switcherIcon, u = r.props.context.switcherIcon, f = l || u;
      return typeof f == "function" ? f(J(J({}, r.props), {}, {
        isLeaf: s
      })) : f;
    }), K(nt(r), "renderSwitcher", function() {
      var s = r.props.expanded, l = r.props.context.prefixCls;
      if (r.isLeaf()) {
        var u = r.renderSwitcherIconDom(!0);
        return u !== !1 ? /* @__PURE__ */ c.createElement("span", {
          className: se("".concat(l, "-switcher"), "".concat(l, "-switcher-noop"))
        }, u) : null;
      }
      var f = se("".concat(l, "-switcher"), "".concat(l, "-switcher_").concat(s ? QE : JE)), p = r.renderSwitcherIconDom(!1);
      return p !== !1 ? /* @__PURE__ */ c.createElement("span", {
        onClick: r.onExpand,
        className: f
      }, p) : null;
    }), K(nt(r), "renderCheckbox", function() {
      var s = r.props, l = s.checked, u = s.halfChecked, f = s.disableCheckbox, p = r.props.context.prefixCls, h = r.isDisabled(), y = r.isCheckable();
      if (!y)
        return null;
      var b = typeof y != "boolean" ? y : null;
      return /* @__PURE__ */ c.createElement("span", {
        className: se("".concat(p, "-checkbox"), l && "".concat(p, "-checkbox-checked"), !l && u && "".concat(p, "-checkbox-indeterminate"), (h || f) && "".concat(p, "-checkbox-disabled")),
        onClick: r.onCheck
      }, b);
    }), K(nt(r), "renderIcon", function() {
      var s = r.props.loading, l = r.props.context.prefixCls;
      return /* @__PURE__ */ c.createElement("span", {
        className: se("".concat(l, "-iconEle"), "".concat(l, "-icon__").concat(r.getNodeState() || "docu"), s && "".concat(l, "-icon_loading"))
      });
    }), K(nt(r), "renderSelector", function() {
      var s = r.state.dragNodeHighlight, l = r.props, u = l.title, f = u === void 0 ? Cre : u, p = l.selected, h = l.icon, y = l.loading, b = l.data, m = r.props.context, v = m.prefixCls, C = m.showIcon, x = m.icon, S = m.loadData, E = m.titleRender, O = r.isDisabled(), $ = "".concat(v, "-node-content-wrapper"), _;
      if (C) {
        var R = h || x;
        _ = R ? /* @__PURE__ */ c.createElement("span", {
          className: se("".concat(v, "-iconEle"), "".concat(v, "-icon__customize"))
        }, typeof R == "function" ? R(r.props) : R) : r.renderIcon();
      } else
        S && y && (_ = r.renderIcon());
      var P;
      typeof f == "function" ? P = f(b) : E ? P = E(b) : P = f;
      var I = /* @__PURE__ */ c.createElement("span", {
        className: "".concat(v, "-title")
      }, P);
      return /* @__PURE__ */ c.createElement("span", {
        ref: r.setSelectHandle,
        title: typeof f == "string" ? f : "",
        className: se("".concat($), "".concat($, "-").concat(r.getNodeState() || "normal"), !O && (p || s) && "".concat(v, "-node-selected")),
        onMouseEnter: r.onMouseEnter,
        onMouseLeave: r.onMouseLeave,
        onContextMenu: r.onContextMenu,
        onClick: r.onSelectorClick,
        onDoubleClick: r.onSelectorDoubleClick
      }, _, I, r.renderDropIndicator());
    }), K(nt(r), "renderDropIndicator", function() {
      var s = r.props, l = s.disabled, u = s.eventKey, f = r.props.context, p = f.draggable, h = f.dropLevelOffset, y = f.dropPosition, b = f.prefixCls, m = f.indent, v = f.dropIndicatorRender, C = f.dragOverNodeKey, x = f.direction, S = !!p, E = !l && S && C === u, O = m != null ? m : r.cacheIndent;
      return r.cacheIndent = m, E ? v({
        dropPosition: y,
        dropLevelOffset: h,
        indent: O,
        prefixCls: b,
        direction: x
      }) : null;
    }), r;
  }
  return Vr(n, [{
    key: "componentDidMount",
    value: (
      // Isomorphic needn't load data in server side
      function() {
        this.syncLoadData(this.props);
      }
    )
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function() {
      var o = this.props.selectable, i = this.props.context.selectable;
      return typeof o == "boolean" ? o : i;
    }
  }, {
    key: "render",
    value: (
      // =========================== Render ===========================
      function() {
        var o, i = this.props, a = i.eventKey, s = i.className, l = i.style, u = i.dragOver, f = i.dragOverGapTop, p = i.dragOverGapBottom, h = i.isLeaf, y = i.isStart, b = i.isEnd, m = i.expanded, v = i.selected, C = i.checked, x = i.halfChecked, S = i.loading, E = i.domRef, O = i.active;
        i.data;
        var $ = i.onMouseMove, _ = i.selectable, R = Yt(i, bre), P = this.props.context, I = P.prefixCls, j = P.filterTreeNode, F = P.keyEntities, A = P.dropContainerKey, M = P.dropTargetKey, N = P.draggingNodeKey, D = this.isDisabled(), T = ei(R, {
          aria: !0,
          data: !0
        }), L = Qo(F, a) || {}, z = L.level, H = b[b.length - 1], V = this.isDraggable(), Y = !D && V, Z = N === a, oe = _ !== void 0 ? {
          "aria-selected": !!_
        } : void 0;
        return /* @__PURE__ */ c.createElement("div", Oe({
          ref: E,
          className: se(s, "".concat(I, "-treenode"), (o = {}, K(K(K(K(K(K(K(K(K(K(o, "".concat(I, "-treenode-disabled"), D), "".concat(I, "-treenode-switcher-").concat(m ? "open" : "close"), !h), "".concat(I, "-treenode-checkbox-checked"), C), "".concat(I, "-treenode-checkbox-indeterminate"), x), "".concat(I, "-treenode-selected"), v), "".concat(I, "-treenode-loading"), S), "".concat(I, "-treenode-active"), O), "".concat(I, "-treenode-leaf-last"), H), "".concat(I, "-treenode-draggable"), V), "dragging", Z), K(K(K(K(K(K(o, "drop-target", M === a), "drop-container", A === a), "drag-over", !D && u), "drag-over-gap-top", !D && f), "drag-over-gap-bottom", !D && p), "filter-node", j && j(kr(this.props))))),
          style: l,
          draggable: Y,
          "aria-grabbed": Z,
          onDragStart: Y ? this.onDragStart : void 0,
          onDragEnter: V ? this.onDragEnter : void 0,
          onDragOver: V ? this.onDragOver : void 0,
          onDragLeave: V ? this.onDragLeave : void 0,
          onDrop: V ? this.onDrop : void 0,
          onDragEnd: V ? this.onDragEnd : void 0,
          onMouseMove: $
        }, oe, T), /* @__PURE__ */ c.createElement(yre, {
          prefixCls: I,
          level: z,
          isStart: y,
          isEnd: b
        }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
      }
    )
  }]), n;
}(c.Component), Vc = function(t) {
  return /* @__PURE__ */ c.createElement(SC.Consumer, null, function(n) {
    return /* @__PURE__ */ c.createElement(xre, Oe({}, t, {
      context: n
    }));
  });
};
Vc.displayName = "TreeNode";
Vc.isTreeNode = 1;
function Ji(e, t) {
  if (!e)
    return [];
  var n = e.slice(), r = n.indexOf(t);
  return r >= 0 && n.splice(r, 1), n;
}
function Ia(e, t) {
  var n = (e || []).slice();
  return n.indexOf(t) === -1 && n.push(t), n;
}
function wC(e) {
  return e.split("-");
}
function Sre(e, t) {
  var n = [], r = Qo(t, e);
  function o() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    i.forEach(function(a) {
      var s = a.key, l = a.children;
      n.push(s), o(l);
    });
  }
  return o(r.children), n;
}
function wre(e) {
  if (e.parent) {
    var t = wC(e.pos);
    return Number(t[t.length - 1]) === e.parent.children.length - 1;
  }
  return !1;
}
function Ere(e) {
  var t = wC(e.pos);
  return Number(t[t.length - 1]) === 0;
}
function e$(e, t, n, r, o, i, a, s, l, u) {
  var f, p = e.clientX, h = e.clientY, y = e.target.getBoundingClientRect(), b = y.top, m = y.height, v = (u === "rtl" ? -1 : 1) * (((o == null ? void 0 : o.x) || 0) - p), C = (v - 12) / r, x = l.filter(function(D) {
    var T;
    return (T = s[D]) === null || T === void 0 || (T = T.children) === null || T === void 0 ? void 0 : T.length;
  }), S = Qo(s, n.props.eventKey);
  if (h < b + m / 2) {
    var E = a.findIndex(function(D) {
      return D.key === S.key;
    }), O = E <= 0 ? 0 : E - 1, $ = a[O].key;
    S = Qo(s, $);
  }
  var _ = S.key, R = S, P = S.key, I = 0, j = 0;
  if (!x.includes(_))
    for (var F = 0; F < C && wre(S); F += 1)
      S = S.parent, j += 1;
  var A = t.props.data, M = S.node, N = !0;
  return Ere(S) && S.level === 0 && h < b + m / 2 && i({
    dragNode: A,
    dropNode: M,
    dropPosition: -1
  }) && S.key === n.props.eventKey ? I = -1 : (R.children || []).length && x.includes(P) ? i({
    dragNode: A,
    dropNode: M,
    dropPosition: 0
  }) ? I = 0 : N = !1 : j === 0 ? C > -1.5 ? i({
    dragNode: A,
    dropNode: M,
    dropPosition: 1
  }) ? I = 1 : N = !1 : i({
    dragNode: A,
    dropNode: M,
    dropPosition: 0
  }) ? I = 0 : i({
    dragNode: A,
    dropNode: M,
    dropPosition: 1
  }) ? I = 1 : N = !1 : i({
    dragNode: A,
    dropNode: M,
    dropPosition: 1
  }) ? I = 1 : N = !1, {
    dropPosition: I,
    dropLevelOffset: j,
    dropTargetKey: S.key,
    dropTargetPos: S.pos,
    dragOverNodeKey: P,
    dropContainerKey: I === 0 ? null : ((f = S.parent) === null || f === void 0 ? void 0 : f.key) || null,
    dropAllowed: N
  };
}
function t$(e, t) {
  if (e) {
    var n = t.multiple;
    return n ? e.slice() : e.length ? [e[0]] : e;
  }
}
function u0(e) {
  if (!e)
    return null;
  var t;
  if (Array.isArray(e))
    t = {
      checkedKeys: e,
      halfCheckedKeys: void 0
    };
  else if (Vt(e) === "object")
    t = {
      checkedKeys: e.checked || void 0,
      halfCheckedKeys: e.halfChecked || void 0
    };
  else
    return mt(!1, "`checkedKeys` is not an array or an object"), null;
  return t;
}
function ly(e, t) {
  var n = /* @__PURE__ */ new Set();
  function r(o) {
    if (!n.has(o)) {
      var i = Qo(t, o);
      if (i) {
        n.add(o);
        var a = i.parent, s = i.node;
        s.disabled || a && r(a.key);
      }
    }
  }
  return (e || []).forEach(function(o) {
    r(o);
  }), We(n);
}
function $re(e) {
  const [t, n] = Ot(null);
  return [ar((i, a, s) => {
    const l = t != null ? t : i, u = Math.min(l || 0, i), f = Math.max(l || 0, i), p = a.slice(u, f + 1).map((b) => e(b)), h = p.some((b) => !s.has(b)), y = [];
    return p.forEach((b) => {
      h ? (s.has(b) || y.push(b), s.add(b)) : (s.delete(b), y.push(b));
    }), n(h ? f : null), y;
  }, [t]), (i) => {
    n(i);
  }];
}
const ea = {}, cy = "SELECT_ALL", uy = "SELECT_INVERT", dy = "SELECT_NONE", n$ = [], Q8 = (e, t) => {
  let n = [];
  return (t || []).forEach((r) => {
    n.push(r), r && typeof r == "object" && e in r && (n = [].concat(We(n), We(Q8(e, r[e]))));
  }), n;
}, Ore = (e, t) => {
  const {
    preserveSelectedRowKeys: n,
    selectedRowKeys: r,
    defaultSelectedRowKeys: o,
    getCheckboxProps: i,
    onChange: a,
    onSelect: s,
    onSelectAll: l,
    onSelectInvert: u,
    onSelectNone: f,
    onSelectMultiple: p,
    columnWidth: h,
    type: y,
    selections: b,
    fixed: m,
    renderCell: v,
    hideSelectAll: C,
    checkStrictly: x = !0
  } = t || {}, {
    prefixCls: S,
    data: E,
    pageData: O,
    getRecordByKey: $,
    getRowKey: _,
    expandType: R,
    childrenColumnName: P,
    locale: I,
    getPopupContainer: j
  } = e, F = xn("Table"), [A, M] = $re((Q) => Q), [N, D] = Fn(r || o || n$, {
    value: r
  }), T = c.useRef(/* @__PURE__ */ new Map()), L = ar((Q) => {
    if (n) {
      const ce = /* @__PURE__ */ new Map();
      Q.forEach((ge) => {
        let G = $(ge);
        !G && T.current.has(ge) && (G = T.current.get(ge)), ce.set(ge, G);
      }), T.current = ce;
    }
  }, [$, n]);
  c.useEffect(() => {
    L(N);
  }, [N]);
  const {
    keyEntities: z
  } = mr(() => {
    if (x)
      return {
        keyEntities: null
      };
    let Q = E;
    if (n) {
      const ce = new Set(E.map((G, ne) => _(G, ne))), ge = Array.from(T.current).reduce((G, ne) => {
        let [fe, ye] = ne;
        return ce.has(fe) ? G : G.concat(ye);
      }, []);
      Q = [].concat(We(Q), We(ge));
    }
    return Jg(Q, {
      externalGetKey: _,
      childrenPropName: P
    });
  }, [E, _, x, P, n]), H = mr(() => Q8(P, O), [P, O]), V = mr(() => {
    const Q = /* @__PURE__ */ new Map();
    return H.forEach((ce, ge) => {
      const G = _(ce, ge), ne = (i ? i(ce) : null) || {};
      Q.set(G, ne), process.env.NODE_ENV !== "production" && F(!("checked" in ne || "defaultChecked" in ne), "usage", "Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.");
    }), Q;
  }, [H, _, i]), Y = ar((Q) => {
    var ce;
    return !!(!((ce = V.get(_(Q))) === null || ce === void 0) && ce.disabled);
  }, [V, _]), [Z, oe] = mr(() => {
    if (x)
      return [N || [], []];
    const {
      checkedKeys: Q,
      halfCheckedKeys: ce
    } = ka(N, !0, z, Y);
    return [Q || [], ce];
  }, [N, x, z, Y]), ee = mr(() => {
    const Q = y === "radio" ? Z.slice(0, 1) : Z;
    return new Set(Q);
  }, [Z, y]), ae = mr(() => y === "radio" ? /* @__PURE__ */ new Set() : new Set(oe), [oe, y]);
  c.useEffect(() => {
    t || D(n$);
  }, [!!t]);
  const le = ar((Q, ce) => {
    let ge, G;
    L(Q), n ? (ge = Q, G = Q.map((ne) => T.current.get(ne))) : (ge = [], G = [], Q.forEach((ne) => {
      const fe = $(ne);
      fe !== void 0 && (ge.push(ne), G.push(fe));
    })), D(ge), a == null || a(ge, G, {
      type: ce
    });
  }, [D, $, a, n]), ue = ar((Q, ce, ge, G) => {
    if (s) {
      const ne = ge.map((fe) => $(fe));
      s($(Q), ce, ne, G);
    }
    le(ge, "single");
  }, [s, $, le]), ie = mr(() => !b || C ? null : (b === !0 ? [cy, uy, dy] : b).map((ce) => ce === cy ? {
    key: "all",
    text: I.selectionAll,
    onSelect() {
      le(E.map((ge, G) => _(ge, G)).filter((ge) => {
        const G = V.get(ge);
        return !(G != null && G.disabled) || ee.has(ge);
      }), "all");
    }
  } : ce === uy ? {
    key: "invert",
    text: I.selectInvert,
    onSelect() {
      const ge = new Set(ee);
      O.forEach((ne, fe) => {
        const ye = _(ne, fe), we = V.get(ye);
        we != null && we.disabled || (ge.has(ye) ? ge.delete(ye) : ge.add(ye));
      });
      const G = Array.from(ge);
      u && (F.deprecated(!1, "onSelectInvert", "onChange"), u(G)), le(G, "invert");
    }
  } : ce === dy ? {
    key: "none",
    text: I.selectNone,
    onSelect() {
      f == null || f(), le(Array.from(ee).filter((ge) => {
        const G = V.get(ge);
        return G == null ? void 0 : G.disabled;
      }), "none");
    }
  } : ce).map((ce) => Object.assign(Object.assign({}, ce), {
    onSelect: function() {
      for (var ge, G, ne = arguments.length, fe = new Array(ne), ye = 0; ye < ne; ye++)
        fe[ye] = arguments[ye];
      (G = ce.onSelect) === null || G === void 0 || (ge = G).call.apply(ge, [ce].concat(fe)), M(null);
    }
  })), [b, ee, O, _, u, le]);
  return [ar((Q) => {
    var ce;
    if (!t)
      return process.env.NODE_ENV !== "production" && F(!Q.includes(ea), "usage", "`rowSelection` is not config but `SELECTION_COLUMN` exists in the `columns`."), Q.filter((et) => et !== ea);
    let ge = We(Q);
    const G = new Set(ee), ne = H.map(_).filter((et) => !V.get(et).disabled), fe = ne.every((et) => G.has(et)), ye = ne.some((et) => G.has(et)), we = () => {
      const et = [];
      fe ? ne.forEach((Et) => {
        G.delete(Et), et.push(Et);
      }) : ne.forEach((Et) => {
        G.has(Et) || (G.add(Et), et.push(Et));
      });
      const Je = Array.from(G);
      l == null || l(!fe, Je.map((Et) => $(Et)), et.map((Et) => $(Et))), le(Je, "all"), M(null);
    };
    let he, me;
    if (y !== "radio") {
      let et;
      if (ie) {
        const dt = {
          getPopupContainer: j,
          items: ie.map((Ct, ot) => {
            const {
              key: jt,
              text: Rt,
              onSelect: Le
            } = Ct;
            return {
              key: jt != null ? jt : ot,
              onClick: () => {
                Le == null || Le(ne);
              },
              label: Rt
            };
          })
        };
        et = /* @__PURE__ */ c.createElement("div", {
          className: `${S}-selection-extra`
        }, /* @__PURE__ */ c.createElement(GN, {
          menu: dt,
          getPopupContainer: j
        }, /* @__PURE__ */ c.createElement("span", null, /* @__PURE__ */ c.createElement(ef, null))));
      }
      const Je = H.map((dt, Ct) => {
        const ot = _(dt, Ct), jt = V.get(ot) || {};
        return Object.assign({
          checked: G.has(ot)
        }, jt);
      }).filter((dt) => {
        let {
          disabled: Ct
        } = dt;
        return Ct;
      }), Et = !!Je.length && Je.length === H.length, Ye = Et && Je.every((dt) => {
        let {
          checked: Ct
        } = dt;
        return Ct;
      }), wt = Et && Je.some((dt) => {
        let {
          checked: Ct
        } = dt;
        return Ct;
      });
      me = /* @__PURE__ */ c.createElement(Fh, {
        checked: Et ? Ye : !!H.length && fe,
        indeterminate: Et ? !Ye && wt : !fe && ye,
        onChange: we,
        disabled: H.length === 0 || Et,
        "aria-label": et ? "Custom selection" : "Select all",
        skipGroup: !0
      }), he = !C && /* @__PURE__ */ c.createElement("div", {
        className: `${S}-selection`
      }, me, et);
    }
    let Ce;
    y === "radio" ? Ce = (et, Je, Et) => {
      const Ye = _(Je, Et), wt = G.has(Ye);
      return {
        node: /* @__PURE__ */ c.createElement(Ci, Object.assign({}, V.get(Ye), {
          checked: wt,
          onClick: (dt) => dt.stopPropagation(),
          onChange: (dt) => {
            G.has(Ye) || ue(Ye, !0, [Ye], dt.nativeEvent);
          }
        })),
        checked: wt
      };
    } : Ce = (et, Je, Et) => {
      var Ye;
      const wt = _(Je, Et), dt = G.has(wt), Ct = ae.has(wt), ot = V.get(wt);
      let jt;
      return R === "nest" ? (jt = Ct, process.env.NODE_ENV !== "production" && F(typeof (ot == null ? void 0 : ot.indeterminate) != "boolean", "usage", "set `indeterminate` using `rowSelection.getCheckboxProps` is not allowed with tree structured dataSource.")) : jt = (Ye = ot == null ? void 0 : ot.indeterminate) !== null && Ye !== void 0 ? Ye : Ct, {
        node: /* @__PURE__ */ c.createElement(Fh, Object.assign({}, ot, {
          indeterminate: jt,
          checked: dt,
          skipGroup: !0,
          onClick: (Rt) => Rt.stopPropagation(),
          onChange: (Rt) => {
            let {
              nativeEvent: Le
            } = Rt;
            const {
              shiftKey: Ve
            } = Le, Ae = ne.findIndex((He) => He === wt), ft = Z.some((He) => ne.includes(He));
            if (Ve && x && ft) {
              const He = A(Ae, ne, G), Fe = Array.from(G);
              p == null || p(!dt, Fe.map((yt) => $(yt)), He.map((yt) => $(yt))), le(Fe, "multiple");
            } else {
              const He = Z;
              if (x) {
                const Fe = dt ? Ji(He, wt) : Ia(He, wt);
                ue(wt, !dt, Fe, Le);
              } else {
                const Fe = ka([].concat(We(He), [wt]), !0, z, Y), {
                  checkedKeys: yt,
                  halfCheckedKeys: Qe
                } = Fe;
                let tt = yt;
                if (dt) {
                  const lt = new Set(yt);
                  lt.delete(wt), tt = ka(Array.from(lt), {
                    checked: !1,
                    halfCheckedKeys: Qe
                  }, z, Y).checkedKeys;
                }
                ue(wt, !dt, tt, Le);
              }
            }
            M(dt ? null : Ae);
          }
        })),
        checked: dt
      };
    };
    const Te = (et, Je, Et) => {
      const {
        node: Ye,
        checked: wt
      } = Ce(et, Je, Et);
      return v ? v(wt, Je, Et, Ye) : Ye;
    };
    if (!ge.includes(ea))
      if (ge.findIndex((et) => {
        var Je;
        return ((Je = et[dd]) === null || Je === void 0 ? void 0 : Je.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [et, ...Je] = ge;
        ge = [et, ea].concat(We(Je));
      } else
        ge = [ea].concat(We(ge));
    const Ee = ge.indexOf(ea);
    process.env.NODE_ENV !== "production" && F(ge.filter((et) => et === ea).length <= 1, "usage", "Multiple `SELECTION_COLUMN` exist in `columns`."), ge = ge.filter((et, Je) => et !== ea || Je === Ee);
    const Ge = ge[Ee - 1], ke = ge[Ee + 1];
    let qe = m;
    qe === void 0 && ((ke == null ? void 0 : ke.fixed) !== void 0 ? qe = ke.fixed : (Ge == null ? void 0 : Ge.fixed) !== void 0 && (qe = Ge.fixed)), qe && Ge && ((ce = Ge[dd]) === null || ce === void 0 ? void 0 : ce.columnType) === "EXPAND_COLUMN" && Ge.fixed === void 0 && (Ge.fixed = qe);
    const ze = se(`${S}-selection-col`, {
      [`${S}-selection-col-with-dropdown`]: b && y === "checkbox"
    }), pt = () => t != null && t.columnTitle ? typeof t.columnTitle == "function" ? t.columnTitle(me) : t.columnTitle : he, Ke = {
      fixed: qe,
      width: h,
      className: `${S}-selection-column`,
      title: pt(),
      render: Te,
      onCell: t.onCell,
      [dd]: {
        className: ze
      }
    };
    return ge.map((et) => et === ea ? Ke : et);
  }, [_, H, t, Z, ee, ae, h, ie, R, V, p, ue, Y]), ee];
};
function _re(e, t) {
  return e._antProxy = e._antProxy || {}, Object.keys(t).forEach((n) => {
    if (!(n in e._antProxy)) {
      const r = e[n];
      e._antProxy[n] = r, e[n] = t[n];
    }
  }), e;
}
function Nre(e, t) {
  return Ua(e, () => {
    const n = t(), {
      nativeElement: r
    } = n;
    return typeof Proxy != "undefined" ? new Proxy(r, {
      get(o, i) {
        return n[i] ? n[i] : Reflect.get(o, i);
      }
    }) : _re(r, n);
  });
}
function Pre(e) {
  return function(n) {
    let {
      prefixCls: r,
      onExpand: o,
      record: i,
      expanded: a,
      expandable: s
    } = n;
    const l = `${r}-row-expand-icon`;
    return /* @__PURE__ */ c.createElement("button", {
      type: "button",
      onClick: (u) => {
        o(i, u), u.stopPropagation();
      },
      className: se(l, {
        [`${l}-spaced`]: !s,
        [`${l}-expanded`]: s && a,
        [`${l}-collapsed`]: s && !a
      }),
      "aria-label": a ? e.collapse : e.expand,
      "aria-expanded": a
    });
  };
}
function Ire(e) {
  return (n, r) => {
    const o = n.querySelector(`.${e}-container`);
    let i = r;
    if (o) {
      const a = getComputedStyle(o), s = parseInt(a.borderLeftWidth, 10), l = parseInt(a.borderRightWidth, 10);
      i = r - s - l;
    }
    return i;
  };
}
function Cl(e, t) {
  return "key" in e && e.key !== void 0 && e.key !== null ? e.key : e.dataIndex ? Array.isArray(e.dataIndex) ? e.dataIndex.join(".") : e.dataIndex : t;
}
function lf(e, t) {
  return t ? `${t}-${e}` : `${e}`;
}
function sm(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Rre(e, t) {
  const n = sm(e, t);
  return Object.prototype.toString.call(n) === "[object Object]" ? "" : n;
}
var Dre = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" };
const Tre = Dre;
var J8 = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Tre
  }));
};
process.env.NODE_ENV !== "production" && (J8.displayName = "FilterFilled");
const Mre = /* @__PURE__ */ c.forwardRef(J8);
function Lre(e) {
  const t = c.useRef(e), n = M6();
  return [() => t.current, (r) => {
    t.current = r, n();
  }];
}
function Are(e) {
  var t = e.dropPosition, n = e.dropLevelOffset, r = e.indent, o = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (t) {
    case -1:
      o.top = 0, o.left = -n * r;
      break;
    case 1:
      o.bottom = 0, o.left = -n * r;
      break;
    case 0:
      o.bottom = 0, o.left = r;
      break;
  }
  return /* @__PURE__ */ c.createElement("div", {
    style: o
  });
}
function eP(e) {
  if (e == null)
    throw new TypeError("Cannot destructure " + e);
}
function jre(e, t) {
  var n = c.useState(!1), r = de(n, 2), o = r[0], i = r[1];
  Nn(function() {
    if (o)
      return e(), function() {
        t();
      };
  }, [o]), Nn(function() {
    return i(!0), function() {
      i(!1);
    };
  }, []);
}
var kre = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], tP = function(t, n) {
  var r = t.className, o = t.style, i = t.motion, a = t.motionNodes, s = t.motionType, l = t.onMotionStart, u = t.onMotionEnd, f = t.active, p = t.treeNodeRequiredProps, h = Yt(t, kre), y = c.useState(!0), b = de(y, 2), m = b[0], v = b[1], C = c.useContext(SC), x = C.prefixCls, S = a && s !== "hide";
  Nn(function() {
    a && S !== m && v(S);
  }, [a]);
  var E = function() {
    a && l();
  }, O = c.useRef(!1), $ = function() {
    a && !O.current && (O.current = !0, u());
  };
  jre(E, $);
  var _ = function(P) {
    S === P && $();
  };
  return a ? /* @__PURE__ */ c.createElement(Bi, Oe({
    ref: n,
    visible: m
  }, i, {
    motionAppear: s === "show",
    onVisibleChanged: _
  }), function(R, P) {
    var I = R.className, j = R.style;
    return /* @__PURE__ */ c.createElement("div", {
      ref: P,
      className: se("".concat(x, "-treenode-motion"), I),
      style: j
    }, a.map(function(F) {
      var A = Object.assign({}, (eP(F.data), F.data)), M = F.title, N = F.key, D = F.isStart, T = F.isEnd;
      delete A.children;
      var L = cd(N, p);
      return /* @__PURE__ */ c.createElement(Vc, Oe({}, A, L, {
        title: M,
        active: f,
        data: F.data,
        key: N,
        isStart: D,
        isEnd: T
      }));
    }));
  }) : /* @__PURE__ */ c.createElement(Vc, Oe({
    domRef: n,
    className: r,
    style: o
  }, h, {
    active: f
  }));
};
tP.displayName = "MotionTreeNode";
var Fre = /* @__PURE__ */ c.forwardRef(tP);
function Bre() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = e.length, r = t.length;
  if (Math.abs(n - r) !== 1)
    return {
      add: !1,
      key: null
    };
  function o(i, a) {
    var s = /* @__PURE__ */ new Map();
    i.forEach(function(u) {
      s.set(u, !0);
    });
    var l = a.filter(function(u) {
      return !s.has(u);
    });
    return l.length === 1 ? l[0] : null;
  }
  return n < r ? {
    add: !0,
    key: o(e, t)
  } : {
    add: !1,
    key: o(t, e)
  };
}
function r$(e, t, n) {
  var r = e.findIndex(function(s) {
    return s.key === n;
  }), o = e[r + 1], i = t.findIndex(function(s) {
    return s.key === n;
  });
  if (o) {
    var a = t.findIndex(function(s) {
      return s.key === o.key;
    });
    return t.slice(i + 1, a);
  }
  return t.slice(i + 1);
}
var Hre = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], o$ = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, zre = function() {
}, xl = "RC_TREE_MOTION_".concat(Math.random()), fy = {
  key: xl
}, nP = {
  key: xl,
  level: 0,
  index: 0,
  pos: "0",
  node: fy,
  nodes: [fy]
}, i$ = {
  parent: null,
  children: [],
  pos: nP.pos,
  data: fy,
  title: null,
  key: xl,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function a$(e, t, n, r) {
  return t === !1 || !n ? e : e.slice(0, Math.ceil(n / r) + 1);
}
function s$(e) {
  var t = e.key, n = e.pos;
  return of(t, n);
}
function Vre(e) {
  for (var t = String(e.data.key), n = e; n.parent; )
    n = n.parent, t = "".concat(n.data.key, " > ").concat(t);
  return t;
}
var rP = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.data;
  e.selectable, e.checkable;
  var o = e.expandedKeys, i = e.selectedKeys, a = e.checkedKeys, s = e.loadedKeys, l = e.loadingKeys, u = e.halfCheckedKeys, f = e.keyEntities, p = e.disabled, h = e.dragging, y = e.dragOverNodeKey, b = e.dropPosition, m = e.motion, v = e.height, C = e.itemHeight, x = e.virtual, S = e.focusable, E = e.activeItem, O = e.focused, $ = e.tabIndex, _ = e.onKeyDown, R = e.onFocus, P = e.onBlur, I = e.onActiveChange, j = e.onListChangeStart, F = e.onListChangeEnd, A = Yt(e, Hre), M = c.useRef(null), N = c.useRef(null);
  c.useImperativeHandle(t, function() {
    return {
      scrollTo: function(Ce) {
        M.current.scrollTo(Ce);
      },
      getIndentWidth: function() {
        return N.current.offsetWidth;
      }
    };
  });
  var D = c.useState(o), T = de(D, 2), L = T[0], z = T[1], H = c.useState(r), V = de(H, 2), Y = V[0], Z = V[1], oe = c.useState(r), ee = de(oe, 2), ae = ee[0], le = ee[1], ue = c.useState([]), ie = de(ue, 2), re = ie[0], Q = ie[1], ce = c.useState(null), ge = de(ce, 2), G = ge[0], ne = ge[1], fe = c.useRef(r);
  fe.current = r;
  function ye() {
    var me = fe.current;
    Z(me), le(me), Q([]), ne(null), F();
  }
  Nn(function() {
    z(o);
    var me = Bre(L, o);
    if (me.key !== null)
      if (me.add) {
        var Ce = Y.findIndex(function(ze) {
          var pt = ze.key;
          return pt === me.key;
        }), Te = a$(r$(Y, r, me.key), x, v, C), Ee = Y.slice();
        Ee.splice(Ce + 1, 0, i$), le(Ee), Q(Te), ne("show");
      } else {
        var Ge = r.findIndex(function(ze) {
          var pt = ze.key;
          return pt === me.key;
        }), ke = a$(r$(r, Y, me.key), x, v, C), qe = r.slice();
        qe.splice(Ge + 1, 0, i$), le(qe), Q(ke), ne("hide");
      }
    else
      Y !== r && (Z(r), le(r));
  }, [o, r]), c.useEffect(function() {
    h || ye();
  }, [h]);
  var we = m ? ae : r, he = {
    expandedKeys: o,
    selectedKeys: i,
    loadedKeys: s,
    loadingKeys: l,
    checkedKeys: a,
    halfCheckedKeys: u,
    dragOverNodeKey: y,
    dropPosition: b,
    keyEntities: f
  };
  return /* @__PURE__ */ c.createElement(c.Fragment, null, O && E && /* @__PURE__ */ c.createElement("span", {
    style: o$,
    "aria-live": "assertive"
  }, Vre(E)), /* @__PURE__ */ c.createElement("div", null, /* @__PURE__ */ c.createElement("input", {
    style: o$,
    disabled: S === !1 || p,
    tabIndex: S !== !1 ? $ : null,
    onKeyDown: _,
    onFocus: R,
    onBlur: P,
    value: "",
    onChange: zre,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ c.createElement("div", {
    className: "".concat(n, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ c.createElement("div", {
    className: "".concat(n, "-indent")
  }, /* @__PURE__ */ c.createElement("div", {
    ref: N,
    className: "".concat(n, "-indent-unit")
  }))), /* @__PURE__ */ c.createElement(kg, Oe({}, A, {
    data: we,
    itemKey: s$,
    height: v,
    fullHeight: !1,
    virtual: x,
    itemHeight: C,
    prefixCls: "".concat(n, "-list"),
    ref: M,
    onVisibleChange: function(Ce, Te) {
      var Ee = new Set(Ce), Ge = Te.filter(function(ke) {
        return !Ee.has(ke);
      });
      Ge.some(function(ke) {
        return s$(ke) === xl;
      }) && ye();
    }
  }), function(me) {
    var Ce = me.pos, Te = Object.assign({}, (eP(me.data), me.data)), Ee = me.title, Ge = me.key, ke = me.isStart, qe = me.isEnd, ze = of(Ge, Ce);
    delete Te.key, delete Te.children;
    var pt = cd(ze, he);
    return /* @__PURE__ */ c.createElement(Fre, Oe({}, Te, pt, {
      title: Ee,
      active: !!E && Ge === E.key,
      pos: Ce,
      data: me.data,
      isStart: ke,
      isEnd: qe,
      motion: m,
      motionNodes: Ge === xl ? re : null,
      motionType: G,
      onMotionStart: j,
      onMotionEnd: ye,
      treeNodeRequiredProps: he,
      onMouseMove: function() {
        I(null);
      }
    }));
  }));
});
rP.displayName = "NodeList";
var Wre = 10, lm = /* @__PURE__ */ function(e) {
  Wi(n, e);
  var t = Ga(n);
  function n() {
    var r;
    zr(this, n);
    for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return r = t.call.apply(t, [this].concat(i)), K(nt(r), "destroyed", !1), K(nt(r), "delayedDragEnterLogic", void 0), K(nt(r), "loadingRetryTimes", {}), K(nt(r), "state", {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
      dropContainerKey: null,
      // the container key of abstract-drop-node if dropPosition is -1 or 1
      dropLevelOffset: null,
      // the drop level offset of abstract-drag-over-node
      dropTargetPos: null,
      // the pos of abstract-drop-node
      dropAllowed: !0,
      // if drop to abstract-drop-node is allowed
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: Hc()
    }), K(nt(r), "dragStartMousePosition", null), K(nt(r), "dragNode", void 0), K(nt(r), "currentMouseOverDroppableNodeKey", null), K(nt(r), "listRef", /* @__PURE__ */ c.createRef()), K(nt(r), "onNodeDragStart", function(s, l) {
      var u = r.state, f = u.expandedKeys, p = u.keyEntities, h = r.props.onDragStart, y = l.props.eventKey;
      r.dragNode = l, r.dragStartMousePosition = {
        x: s.clientX,
        y: s.clientY
      };
      var b = Ji(f, y);
      r.setState({
        draggingNodeKey: y,
        dragChildrenKeys: Sre(y, p),
        indent: r.listRef.current.getIndentWidth()
      }), r.setExpandedKeys(b), window.addEventListener("dragend", r.onWindowDragEnd), h == null || h({
        event: s,
        node: kr(l.props)
      });
    }), K(nt(r), "onNodeDragEnter", function(s, l) {
      var u = r.state, f = u.expandedKeys, p = u.keyEntities, h = u.dragChildrenKeys, y = u.flattenNodes, b = u.indent, m = r.props, v = m.onDragEnter, C = m.onExpand, x = m.allowDrop, S = m.direction, E = l.props, O = E.pos, $ = E.eventKey, _ = nt(r), R = _.dragNode;
      if (r.currentMouseOverDroppableNodeKey !== $ && (r.currentMouseOverDroppableNodeKey = $), !R) {
        r.resetDragState();
        return;
      }
      var P = e$(s, R, l, b, r.dragStartMousePosition, x, y, p, f, S), I = P.dropPosition, j = P.dropLevelOffset, F = P.dropTargetKey, A = P.dropContainerKey, M = P.dropTargetPos, N = P.dropAllowed, D = P.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        h.indexOf(F) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !N
      ) {
        r.resetDragState();
        return;
      }
      if (r.delayedDragEnterLogic || (r.delayedDragEnterLogic = {}), Object.keys(r.delayedDragEnterLogic).forEach(function(T) {
        clearTimeout(r.delayedDragEnterLogic[T]);
      }), R.props.eventKey !== l.props.eventKey && (s.persist(), r.delayedDragEnterLogic[O] = window.setTimeout(function() {
        if (r.state.draggingNodeKey !== null) {
          var T = We(f), L = Qo(p, l.props.eventKey);
          L && (L.children || []).length && (T = Ia(f, l.props.eventKey)), "expandedKeys" in r.props || r.setExpandedKeys(T), C == null || C(T, {
            node: kr(l.props),
            expanded: !0,
            nativeEvent: s.nativeEvent
          });
        }
      }, 800)), R.props.eventKey === F && j === 0) {
        r.resetDragState();
        return;
      }
      r.setState({
        dragOverNodeKey: D,
        dropPosition: I,
        dropLevelOffset: j,
        dropTargetKey: F,
        dropContainerKey: A,
        dropTargetPos: M,
        dropAllowed: N
      }), v == null || v({
        event: s,
        node: kr(l.props),
        expandedKeys: f
      });
    }), K(nt(r), "onNodeDragOver", function(s, l) {
      var u = r.state, f = u.dragChildrenKeys, p = u.flattenNodes, h = u.keyEntities, y = u.expandedKeys, b = u.indent, m = r.props, v = m.onDragOver, C = m.allowDrop, x = m.direction, S = nt(r), E = S.dragNode;
      if (E) {
        var O = e$(s, E, l, b, r.dragStartMousePosition, C, p, h, y, x), $ = O.dropPosition, _ = O.dropLevelOffset, R = O.dropTargetKey, P = O.dropContainerKey, I = O.dropAllowed, j = O.dropTargetPos, F = O.dragOverNodeKey;
        f.indexOf(R) !== -1 || !I || (E.props.eventKey === R && _ === 0 ? r.state.dropPosition === null && r.state.dropLevelOffset === null && r.state.dropTargetKey === null && r.state.dropContainerKey === null && r.state.dropTargetPos === null && r.state.dropAllowed === !1 && r.state.dragOverNodeKey === null || r.resetDragState() : $ === r.state.dropPosition && _ === r.state.dropLevelOffset && R === r.state.dropTargetKey && P === r.state.dropContainerKey && j === r.state.dropTargetPos && I === r.state.dropAllowed && F === r.state.dragOverNodeKey || r.setState({
          dropPosition: $,
          dropLevelOffset: _,
          dropTargetKey: R,
          dropContainerKey: P,
          dropTargetPos: j,
          dropAllowed: I,
          dragOverNodeKey: F
        }), v == null || v({
          event: s,
          node: kr(l.props)
        }));
      }
    }), K(nt(r), "onNodeDragLeave", function(s, l) {
      r.currentMouseOverDroppableNodeKey === l.props.eventKey && !s.currentTarget.contains(s.relatedTarget) && (r.resetDragState(), r.currentMouseOverDroppableNodeKey = null);
      var u = r.props.onDragLeave;
      u == null || u({
        event: s,
        node: kr(l.props)
      });
    }), K(nt(r), "onWindowDragEnd", function(s) {
      r.onNodeDragEnd(s, null, !0), window.removeEventListener("dragend", r.onWindowDragEnd);
    }), K(nt(r), "onNodeDragEnd", function(s, l) {
      var u = r.props.onDragEnd;
      r.setState({
        dragOverNodeKey: null
      }), r.cleanDragState(), u == null || u({
        event: s,
        node: kr(l.props)
      }), r.dragNode = null, window.removeEventListener("dragend", r.onWindowDragEnd);
    }), K(nt(r), "onNodeDrop", function(s, l) {
      var u, f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, p = r.state, h = p.dragChildrenKeys, y = p.dropPosition, b = p.dropTargetKey, m = p.dropTargetPos, v = p.dropAllowed;
      if (v) {
        var C = r.props.onDrop;
        if (r.setState({
          dragOverNodeKey: null
        }), r.cleanDragState(), b !== null) {
          var x = J(J({}, cd(b, r.getTreeNodeRequiredProps())), {}, {
            active: ((u = r.getActiveItem()) === null || u === void 0 ? void 0 : u.key) === b,
            data: Qo(r.state.keyEntities, b).node
          }), S = h.indexOf(b) !== -1;
          mt(!S, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var E = wC(m), O = {
            event: s,
            node: kr(x),
            dragNode: r.dragNode ? kr(r.dragNode.props) : null,
            dragNodesKeys: [r.dragNode.props.eventKey].concat(h),
            dropToGap: y !== 0,
            dropPosition: y + Number(E[E.length - 1])
          };
          f || C == null || C(O), r.dragNode = null;
        }
      }
    }), K(nt(r), "cleanDragState", function() {
      var s = r.state.draggingNodeKey;
      s !== null && r.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), r.dragStartMousePosition = null, r.currentMouseOverDroppableNodeKey = null;
    }), K(nt(r), "triggerExpandActionExpand", function(s, l) {
      var u = r.state, f = u.expandedKeys, p = u.flattenNodes, h = l.expanded, y = l.key, b = l.isLeaf;
      if (!(b || s.shiftKey || s.metaKey || s.ctrlKey)) {
        var m = p.filter(function(C) {
          return C.key === y;
        })[0], v = kr(J(J({}, cd(y, r.getTreeNodeRequiredProps())), {}, {
          data: m.data
        }));
        r.setExpandedKeys(h ? Ji(f, y) : Ia(f, y)), r.onNodeExpand(s, v);
      }
    }), K(nt(r), "onNodeClick", function(s, l) {
      var u = r.props, f = u.onClick, p = u.expandAction;
      p === "click" && r.triggerExpandActionExpand(s, l), f == null || f(s, l);
    }), K(nt(r), "onNodeDoubleClick", function(s, l) {
      var u = r.props, f = u.onDoubleClick, p = u.expandAction;
      p === "doubleClick" && r.triggerExpandActionExpand(s, l), f == null || f(s, l);
    }), K(nt(r), "onNodeSelect", function(s, l) {
      var u = r.state.selectedKeys, f = r.state, p = f.keyEntities, h = f.fieldNames, y = r.props, b = y.onSelect, m = y.multiple, v = l.selected, C = l[h.key], x = !v;
      x ? m ? u = Ia(u, C) : u = [C] : u = Ji(u, C);
      var S = u.map(function(E) {
        var O = Qo(p, E);
        return O ? O.node : null;
      }).filter(function(E) {
        return E;
      });
      r.setUncontrolledState({
        selectedKeys: u
      }), b == null || b(u, {
        event: "select",
        selected: x,
        node: l,
        selectedNodes: S,
        nativeEvent: s.nativeEvent
      });
    }), K(nt(r), "onNodeCheck", function(s, l, u) {
      var f = r.state, p = f.keyEntities, h = f.checkedKeys, y = f.halfCheckedKeys, b = r.props, m = b.checkStrictly, v = b.onCheck, C = l.key, x, S = {
        event: "check",
        node: l,
        checked: u,
        nativeEvent: s.nativeEvent
      };
      if (m) {
        var E = u ? Ia(h, C) : Ji(h, C), O = Ji(y, C);
        x = {
          checked: E,
          halfChecked: O
        }, S.checkedNodes = E.map(function(j) {
          return Qo(p, j);
        }).filter(function(j) {
          return j;
        }).map(function(j) {
          return j.node;
        }), r.setUncontrolledState({
          checkedKeys: E
        });
      } else {
        var $ = ka([].concat(We(h), [C]), !0, p), _ = $.checkedKeys, R = $.halfCheckedKeys;
        if (!u) {
          var P = new Set(_);
          P.delete(C);
          var I = ka(Array.from(P), {
            checked: !1,
            halfCheckedKeys: R
          }, p);
          _ = I.checkedKeys, R = I.halfCheckedKeys;
        }
        x = _, S.checkedNodes = [], S.checkedNodesPositions = [], S.halfCheckedKeys = R, _.forEach(function(j) {
          var F = Qo(p, j);
          if (F) {
            var A = F.node, M = F.pos;
            S.checkedNodes.push(A), S.checkedNodesPositions.push({
              node: A,
              pos: M
            });
          }
        }), r.setUncontrolledState({
          checkedKeys: _
        }, !1, {
          halfCheckedKeys: R
        });
      }
      v == null || v(x, S);
    }), K(nt(r), "onNodeLoad", function(s) {
      var l = s.key, u = new Promise(function(f, p) {
        r.setState(function(h) {
          var y = h.loadedKeys, b = y === void 0 ? [] : y, m = h.loadingKeys, v = m === void 0 ? [] : m, C = r.props, x = C.loadData, S = C.onLoad;
          if (!x || b.indexOf(l) !== -1 || v.indexOf(l) !== -1)
            return null;
          var E = x(s);
          return E.then(function() {
            var O = r.state.loadedKeys, $ = Ia(O, l);
            S == null || S($, {
              event: "load",
              node: s
            }), r.setUncontrolledState({
              loadedKeys: $
            }), r.setState(function(_) {
              return {
                loadingKeys: Ji(_.loadingKeys, l)
              };
            }), f();
          }).catch(function(O) {
            if (r.setState(function(_) {
              return {
                loadingKeys: Ji(_.loadingKeys, l)
              };
            }), r.loadingRetryTimes[l] = (r.loadingRetryTimes[l] || 0) + 1, r.loadingRetryTimes[l] >= Wre) {
              var $ = r.state.loadedKeys;
              mt(!1, "Retry for `loadData` many times but still failed. No more retry."), r.setUncontrolledState({
                loadedKeys: Ia($, l)
              }), f();
            }
            p(O);
          }), {
            loadingKeys: Ia(v, l)
          };
        });
      });
      return u.catch(function() {
      }), u;
    }), K(nt(r), "onNodeMouseEnter", function(s, l) {
      var u = r.props.onMouseEnter;
      u == null || u({
        event: s,
        node: l
      });
    }), K(nt(r), "onNodeMouseLeave", function(s, l) {
      var u = r.props.onMouseLeave;
      u == null || u({
        event: s,
        node: l
      });
    }), K(nt(r), "onNodeContextMenu", function(s, l) {
      var u = r.props.onRightClick;
      u && (s.preventDefault(), u({
        event: s,
        node: l
      }));
    }), K(nt(r), "onFocus", function() {
      var s = r.props.onFocus;
      r.setState({
        focused: !0
      });
      for (var l = arguments.length, u = new Array(l), f = 0; f < l; f++)
        u[f] = arguments[f];
      s == null || s.apply(void 0, u);
    }), K(nt(r), "onBlur", function() {
      var s = r.props.onBlur;
      r.setState({
        focused: !1
      }), r.onActiveChange(null);
      for (var l = arguments.length, u = new Array(l), f = 0; f < l; f++)
        u[f] = arguments[f];
      s == null || s.apply(void 0, u);
    }), K(nt(r), "getTreeNodeRequiredProps", function() {
      var s = r.state, l = s.expandedKeys, u = s.selectedKeys, f = s.loadedKeys, p = s.loadingKeys, h = s.checkedKeys, y = s.halfCheckedKeys, b = s.dragOverNodeKey, m = s.dropPosition, v = s.keyEntities;
      return {
        expandedKeys: l || [],
        selectedKeys: u || [],
        loadedKeys: f || [],
        loadingKeys: p || [],
        checkedKeys: h || [],
        halfCheckedKeys: y || [],
        dragOverNodeKey: b,
        dropPosition: m,
        keyEntities: v
      };
    }), K(nt(r), "setExpandedKeys", function(s) {
      var l = r.state, u = l.treeData, f = l.fieldNames, p = n0(u, s, f);
      r.setUncontrolledState({
        expandedKeys: s,
        flattenNodes: p
      }, !0);
    }), K(nt(r), "onNodeExpand", function(s, l) {
      var u = r.state.expandedKeys, f = r.state, p = f.listChanging, h = f.fieldNames, y = r.props, b = y.onExpand, m = y.loadData, v = l.expanded, C = l[h.key];
      if (!p) {
        var x = u.indexOf(C), S = !v;
        if (mt(v && x !== -1 || !v && x === -1, "Expand state not sync with index check"), S ? u = Ia(u, C) : u = Ji(u, C), r.setExpandedKeys(u), b == null || b(u, {
          node: l,
          expanded: S,
          nativeEvent: s.nativeEvent
        }), S && m) {
          var E = r.onNodeLoad(l);
          E && E.then(function() {
            var O = n0(r.state.treeData, u, h);
            r.setUncontrolledState({
              flattenNodes: O
            });
          }).catch(function() {
            var O = r.state.expandedKeys, $ = Ji(O, C);
            r.setExpandedKeys($);
          });
        }
      }
    }), K(nt(r), "onListChangeStart", function() {
      r.setUncontrolledState({
        listChanging: !0
      });
    }), K(nt(r), "onListChangeEnd", function() {
      setTimeout(function() {
        r.setUncontrolledState({
          listChanging: !1
        });
      });
    }), K(nt(r), "onActiveChange", function(s) {
      var l = r.state.activeKey, u = r.props, f = u.onActiveChange, p = u.itemScrollOffset, h = p === void 0 ? 0 : p;
      l !== s && (r.setState({
        activeKey: s
      }), s !== null && r.scrollTo({
        key: s,
        offset: h
      }), f == null || f(s));
    }), K(nt(r), "getActiveItem", function() {
      var s = r.state, l = s.activeKey, u = s.flattenNodes;
      return l === null ? null : u.find(function(f) {
        var p = f.key;
        return p === l;
      }) || null;
    }), K(nt(r), "offsetActiveKey", function(s) {
      var l = r.state, u = l.flattenNodes, f = l.activeKey, p = u.findIndex(function(b) {
        var m = b.key;
        return m === f;
      });
      p === -1 && s < 0 && (p = u.length), p = (p + s + u.length) % u.length;
      var h = u[p];
      if (h) {
        var y = h.key;
        r.onActiveChange(y);
      } else
        r.onActiveChange(null);
    }), K(nt(r), "onKeyDown", function(s) {
      var l = r.state, u = l.activeKey, f = l.expandedKeys, p = l.checkedKeys, h = l.fieldNames, y = r.props, b = y.onKeyDown, m = y.checkable, v = y.selectable;
      switch (s.which) {
        case Pe.UP: {
          r.offsetActiveKey(-1), s.preventDefault();
          break;
        }
        case Pe.DOWN: {
          r.offsetActiveKey(1), s.preventDefault();
          break;
        }
      }
      var C = r.getActiveItem();
      if (C && C.data) {
        var x = r.getTreeNodeRequiredProps(), S = C.data.isLeaf === !1 || !!(C.data[h.children] || []).length, E = kr(J(J({}, cd(u, x)), {}, {
          data: C.data,
          active: !0
        }));
        switch (s.which) {
          case Pe.LEFT: {
            S && f.includes(u) ? r.onNodeExpand({}, E) : C.parent && r.onActiveChange(C.parent.key), s.preventDefault();
            break;
          }
          case Pe.RIGHT: {
            S && !f.includes(u) ? r.onNodeExpand({}, E) : C.children && C.children.length && r.onActiveChange(C.children[0].key), s.preventDefault();
            break;
          }
          case Pe.ENTER:
          case Pe.SPACE: {
            m && !E.disabled && E.checkable !== !1 && !E.disableCheckbox ? r.onNodeCheck({}, E, !p.includes(u)) : !m && v && !E.disabled && E.selectable !== !1 && r.onNodeSelect({}, E);
            break;
          }
        }
      }
      b == null || b(s);
    }), K(nt(r), "setUncontrolledState", function(s) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!r.destroyed) {
        var f = !1, p = !0, h = {};
        Object.keys(s).forEach(function(y) {
          if (y in r.props) {
            p = !1;
            return;
          }
          f = !0, h[y] = s[y];
        }), f && (!l || p) && r.setState(J(J({}, h), u));
      }
    }), K(nt(r), "scrollTo", function(s) {
      r.listRef.current.scrollTo(s);
    }), r;
  }
  return Vr(n, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var o = this.props, i = o.activeKey, a = o.itemScrollOffset, s = a === void 0 ? 0 : a;
      i !== void 0 && i !== this.state.activeKey && (this.setState({
        activeKey: i
      }), i !== null && this.scrollTo({
        key: i,
        offset: s
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state, i = o.focused, a = o.flattenNodes, s = o.keyEntities, l = o.draggingNodeKey, u = o.activeKey, f = o.dropLevelOffset, p = o.dropContainerKey, h = o.dropTargetKey, y = o.dropPosition, b = o.dragOverNodeKey, m = o.indent, v = this.props, C = v.prefixCls, x = v.className, S = v.style, E = v.showLine, O = v.focusable, $ = v.tabIndex, _ = $ === void 0 ? 0 : $, R = v.selectable, P = v.showIcon, I = v.icon, j = v.switcherIcon, F = v.draggable, A = v.checkable, M = v.checkStrictly, N = v.disabled, D = v.motion, T = v.loadData, L = v.filterTreeNode, z = v.height, H = v.itemHeight, V = v.virtual, Y = v.titleRender, Z = v.dropIndicatorRender, oe = v.onContextMenu, ee = v.onScroll, ae = v.direction, le = v.rootClassName, ue = v.rootStyle, ie = ei(this.props, {
        aria: !0,
        data: !0
      }), re;
      return F && (Vt(F) === "object" ? re = F : typeof F == "function" ? re = {
        nodeDraggable: F
      } : re = {}), /* @__PURE__ */ c.createElement(SC.Provider, {
        value: {
          prefixCls: C,
          selectable: R,
          showIcon: P,
          icon: I,
          switcherIcon: j,
          draggable: re,
          draggingNodeKey: l,
          checkable: A,
          checkStrictly: M,
          disabled: N,
          keyEntities: s,
          dropLevelOffset: f,
          dropContainerKey: p,
          dropTargetKey: h,
          dropPosition: y,
          dragOverNodeKey: b,
          indent: m,
          direction: ae,
          dropIndicatorRender: Z,
          loadData: T,
          filterTreeNode: L,
          titleRender: Y,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      }, /* @__PURE__ */ c.createElement("div", {
        role: "tree",
        className: se(C, x, le, K(K(K({}, "".concat(C, "-show-line"), E), "".concat(C, "-focused"), i), "".concat(C, "-active-focused"), u !== null)),
        style: ue
      }, /* @__PURE__ */ c.createElement(rP, Oe({
        ref: this.listRef,
        prefixCls: C,
        style: S,
        data: a,
        disabled: N,
        selectable: R,
        checkable: !!A,
        motion: D,
        dragging: l !== null,
        height: z,
        itemHeight: H,
        virtual: V,
        focusable: O,
        focused: i,
        tabIndex: _,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: oe,
        onScroll: ee
      }, this.getTreeNodeRequiredProps(), ie))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, i) {
      var a = i.prevProps, s = {
        prevProps: o
      };
      function l($) {
        return !a && $ in o || a && a[$] !== o[$];
      }
      var u, f = i.fieldNames;
      if (l("fieldNames") && (f = Hc(o.fieldNames), s.fieldNames = f), l("treeData") ? u = o.treeData : l("children") && (mt(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), u = rN(o.children)), u) {
        s.treeData = u;
        var p = Jg(u, {
          fieldNames: f
        });
        s.keyEntities = J(K({}, xl, nP), p.keyEntities), process.env.NODE_ENV !== "production" && hZ(u, f);
      }
      var h = s.keyEntities || i.keyEntities;
      if (l("expandedKeys") || a && l("autoExpandParent"))
        s.expandedKeys = o.autoExpandParent || !a && o.defaultExpandParent ? ly(o.expandedKeys, h) : o.expandedKeys;
      else if (!a && o.defaultExpandAll) {
        var y = J({}, h);
        delete y[xl], s.expandedKeys = Object.keys(y).map(function($) {
          return y[$].key;
        });
      } else
        !a && o.defaultExpandedKeys && (s.expandedKeys = o.autoExpandParent || o.defaultExpandParent ? ly(o.defaultExpandedKeys, h) : o.defaultExpandedKeys);
      if (s.expandedKeys || delete s.expandedKeys, u || s.expandedKeys) {
        var b = n0(u || i.treeData, s.expandedKeys || i.expandedKeys, f);
        s.flattenNodes = b;
      }
      if (o.selectable && (l("selectedKeys") ? s.selectedKeys = t$(o.selectedKeys, o) : !a && o.defaultSelectedKeys && (s.selectedKeys = t$(o.defaultSelectedKeys, o))), o.checkable) {
        var m;
        if (l("checkedKeys") ? m = u0(o.checkedKeys) || {} : !a && o.defaultCheckedKeys ? m = u0(o.defaultCheckedKeys) || {} : u && (m = u0(o.checkedKeys) || {
          checkedKeys: i.checkedKeys,
          halfCheckedKeys: i.halfCheckedKeys
        }), m) {
          var v = m, C = v.checkedKeys, x = C === void 0 ? [] : C, S = v.halfCheckedKeys, E = S === void 0 ? [] : S;
          if (!o.checkStrictly) {
            var O = ka(x, !0, h);
            x = O.checkedKeys, E = O.halfCheckedKeys;
          }
          s.checkedKeys = x, s.halfCheckedKeys = E;
        }
      }
      return l("loadedKeys") && (s.loadedKeys = o.loadedKeys), s;
    }
  }]), n;
}(c.Component);
K(lm, "defaultProps", {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: Are,
  allowDrop: function() {
    return !0;
  },
  expandAction: !1
});
K(lm, "TreeNode", Vc);
var Kre = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" };
const Ure = Kre;
var oP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Ure
  }));
};
process.env.NODE_ENV !== "production" && (oP.displayName = "FileOutlined");
const iP = /* @__PURE__ */ c.forwardRef(oP);
var Gre = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" };
const qre = Gre;
var aP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: qre
  }));
};
process.env.NODE_ENV !== "production" && (aP.displayName = "FolderOpenOutlined");
const Yre = /* @__PURE__ */ c.forwardRef(aP);
var Xre = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" };
const Zre = Xre;
var sP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Zre
  }));
};
process.env.NODE_ENV !== "production" && (sP.displayName = "FolderOutlined");
const Qre = /* @__PURE__ */ c.forwardRef(sP);
var Jre = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" };
const eoe = Jre;
var lP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: eoe
  }));
};
process.env.NODE_ENV !== "production" && (lP.displayName = "HolderOutlined");
const toe = /* @__PURE__ */ c.forwardRef(lP), noe = new Bn("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), roe = (e, t) => ({
  [`.${e}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${t.motionDurationSlow}`
    }
  }
}), ooe = (e, t) => ({
  [`.${e}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: t.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${te(t.lineWidthBold)} solid ${t.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), ioe = (e, t) => {
  const {
    treeCls: n,
    treeNodeCls: r,
    treeNodePadding: o,
    titleHeight: i,
    nodeSelectedBg: a,
    nodeHoverBg: s
  } = t, l = t.paddingXS;
  return {
    [n]: Object.assign(Object.assign({}, Qn(t)), {
      background: t.colorBgContainer,
      borderRadius: t.borderRadius,
      transition: `background-color ${t.motionDurationSlow}`,
      [`&${n}-rtl`]: {
        // >>> Switcher
        [`${n}-switcher`]: {
          "&_close": {
            [`${n}-switcher-icon`]: {
              svg: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      },
      [`&-focused:not(:hover):not(${n}-active-focused)`]: Object.assign({}, Va(t)),
      // =================== Virtual List ===================
      [`${n}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${n}-block-node`]: {
        [`${n}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${n}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${r}.dragging`]: {
            position: "relative",
            "&:after": {
              position: "absolute",
              top: 0,
              insetInlineEnd: 0,
              bottom: o,
              insetInlineStart: 0,
              border: `1px solid ${t.colorPrimary}`,
              opacity: 0,
              animationName: noe,
              animationDuration: t.motionDurationSlow,
              animationPlayState: "running",
              animationFillMode: "forwards",
              content: '""',
              pointerEvents: "none"
            }
          }
        }
      },
      // ===================== TreeNode =====================
      [`${r}`]: {
        display: "flex",
        alignItems: "flex-start",
        padding: `0 0 ${te(o)} 0`,
        outline: "none",
        "&-rtl": {
          direction: "rtl"
        },
        // Disabled
        "&-disabled": {
          // >>> Title
          [`${n}-node-content-wrapper`]: {
            color: t.colorTextDisabled,
            cursor: "not-allowed",
            "&:hover": {
              background: "transparent"
            }
          }
        },
        [`&-active ${n}-node-content-wrapper`]: {
          background: t.controlItemBgHover
        },
        [`&:not(${r}-disabled).filter-node ${n}-title`]: {
          color: "inherit",
          fontWeight: 500
        },
        "&-draggable": {
          cursor: "grab",
          [`${n}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: i,
            lineHeight: `${te(i)}`,
            textAlign: "center",
            visibility: "visible",
            opacity: 0.2,
            transition: `opacity ${t.motionDurationSlow}`,
            [`${r}:hover &`]: {
              opacity: 0.45
            }
          },
          [`&${r}-disabled`]: {
            [`${n}-draggable-icon`]: {
              visibility: "hidden"
            }
          }
        }
      },
      // >>> Indent
      [`${n}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: i
        }
      },
      // >>> Drag Handler
      [`${n}-draggable-icon`]: {
        visibility: "hidden"
      },
      // >>> Switcher
      [`${n}-switcher`]: Object.assign(Object.assign({}, roe(e, t)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: i,
        margin: 0,
        lineHeight: `${te(i)}`,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: `all ${t.motionDurationSlow}`,
        borderRadius: t.borderRadius,
        "&-noop": {
          cursor: "unset"
        },
        [`&:not(${n}-switcher-noop):hover`]: {
          backgroundColor: t.colorBgTextHover
        },
        "&_close": {
          [`${n}-switcher-icon`]: {
            svg: {
              transform: "rotate(-90deg)"
            }
          }
        },
        "&-loading-icon": {
          color: t.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: t.calc(i).div(2).equal(),
            bottom: t.calc(o).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${t.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: t.calc(t.calc(i).div(2).equal()).mul(0.8).equal(),
            height: t.calc(i).div(2).equal(),
            borderBottom: `1px solid ${t.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Checkbox
      [`${n}-checkbox`]: {
        top: "initial",
        marginInlineEnd: l,
        alignSelf: "flex-start",
        marginTop: t.marginXXS
      },
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${n}-node-content-wrapper, ${n}-checkbox + span`]: {
        position: "relative",
        zIndex: "auto",
        minHeight: i,
        margin: 0,
        padding: `0 ${te(t.calc(t.paddingXS).div(2).equal())}`,
        color: "inherit",
        lineHeight: `${te(i)}`,
        background: "transparent",
        borderRadius: t.borderRadius,
        cursor: "pointer",
        transition: `all ${t.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
        "&:hover": {
          backgroundColor: s
        },
        [`&${n}-node-selected`]: {
          backgroundColor: a
        },
        // Icon
        [`${n}-iconEle`]: {
          display: "inline-block",
          width: i,
          height: i,
          lineHeight: `${te(i)}`,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/28217
      [`${n}-unselectable ${n}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      // ==================== Draggable =====================
      [`${n}-node-content-wrapper`]: Object.assign({
        lineHeight: `${te(i)}`,
        userSelect: "none"
      }, ooe(e, t)),
      [`${r}.drop-container`]: {
        "> [draggable]": {
          boxShadow: `0 0 0 2px ${t.colorPrimary}`
        }
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${n}-indent`]: {
          "&-unit": {
            position: "relative",
            height: "100%",
            "&:before": {
              position: "absolute",
              top: 0,
              insetInlineEnd: t.calc(i).div(2).equal(),
              bottom: t.calc(o).mul(-1).equal(),
              borderInlineEnd: `1px solid ${t.colorBorder}`,
              content: '""'
            },
            "&-end": {
              "&:before": {
                display: "none"
              }
            }
          }
        },
        // ============== Cover Background ==============
        [`${n}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${r}-leaf-last`]: {
        [`${n}-switcher`]: {
          "&-leaf-line": {
            "&:before": {
              top: "auto !important",
              bottom: "auto !important",
              height: `${te(t.calc(i).div(2).equal())} !important`
            }
          }
        }
      }
    })
  };
}, aoe = (e) => {
  const {
    treeCls: t,
    treeNodeCls: n,
    treeNodePadding: r,
    directoryNodeSelectedBg: o,
    directoryNodeSelectedColor: i
  } = e;
  return {
    [`${t}${t}-directory`]: {
      // ================== TreeNode ==================
      [n]: {
        position: "relative",
        // Hover color
        "&:before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: r,
          insetInlineStart: 0,
          transition: `background-color ${e.motionDurationMid}`,
          content: '""',
          pointerEvents: "none"
        },
        "&:hover": {
          "&:before": {
            background: e.controlItemBgHover
          }
        },
        // Elements
        "> *": {
          zIndex: 1
        },
        // >>> Switcher
        [`${t}-switcher`]: {
          transition: `color ${e.motionDurationMid}`
        },
        // >>> Title
        [`${t}-node-content-wrapper`]: {
          borderRadius: 0,
          userSelect: "none",
          "&:hover": {
            background: "transparent"
          },
          [`&${t}-node-selected`]: {
            color: i,
            background: "transparent"
          }
        },
        // ============= Selected =============
        "&-selected": {
          "\n            &:hover::before,\n            &::before\n          ": {
            background: o
          },
          // >>> Switcher
          [`${t}-switcher`]: {
            color: i
          },
          // >>> Title
          [`${t}-node-content-wrapper`]: {
            color: i,
            background: "transparent"
          }
        }
      }
    }
  };
}, cP = (e, t) => {
  const n = `.${e}`, r = `${n}-treenode`, o = t.calc(t.paddingXS).div(2).equal(), i = Sn(t, {
    treeCls: n,
    treeNodeCls: r,
    treeNodePadding: o
  });
  return [
    // Basic
    ioe(e, i),
    // Directory
    aoe(i)
  ];
}, uP = (e) => {
  const {
    controlHeightSM: t
  } = e;
  return {
    titleHeight: t,
    nodeHoverBg: e.controlItemBgHover,
    nodeSelectedBg: e.controlItemBgActive
  };
}, soe = (e) => {
  const {
    colorTextLightSolid: t,
    colorPrimary: n
  } = e;
  return Object.assign(Object.assign({}, uP(e)), {
    directoryNodeSelectedColor: t,
    directoryNodeSelectedBg: n
  });
}, loe = Gn("Tree", (e, t) => {
  let {
    prefixCls: n
  } = t;
  return [{
    [e.componentCls]: oC(`${n}-checkbox`, e)
  }, cP(n, e), Ag(e)];
}, soe), l$ = 4;
function coe(e) {
  const {
    dropPosition: t,
    dropLevelOffset: n,
    prefixCls: r,
    indent: o,
    direction: i = "ltr"
  } = e, a = i === "ltr" ? "left" : "right", s = i === "ltr" ? "right" : "left", l = {
    [a]: -n * o + l$,
    [s]: 0
  };
  switch (t) {
    case -1:
      l.top = -3;
      break;
    case 1:
      l.bottom = -3;
      break;
    default:
      l.bottom = -3, l[a] = o + l$;
      break;
  }
  return /* @__PURE__ */ be.createElement("div", {
    style: l,
    className: `${r}-drop-indicator`
  });
}
var uoe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" };
const doe = uoe;
var dP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: doe
  }));
};
process.env.NODE_ENV !== "production" && (dP.displayName = "CaretDownFilled");
const foe = /* @__PURE__ */ c.forwardRef(dP);
var poe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" };
const hoe = poe;
var fP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: hoe
  }));
};
process.env.NODE_ENV !== "production" && (fP.displayName = "MinusSquareOutlined");
const goe = /* @__PURE__ */ c.forwardRef(fP);
var moe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" };
const voe = moe;
var pP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: voe
  }));
};
process.env.NODE_ENV !== "production" && (pP.displayName = "PlusSquareOutlined");
const yoe = /* @__PURE__ */ c.forwardRef(pP), boe = (e) => {
  const {
    prefixCls: t,
    switcherIcon: n,
    treeNodeProps: r,
    showLine: o
  } = e, {
    isLeaf: i,
    expanded: a,
    loading: s
  } = r;
  if (s)
    return /* @__PURE__ */ c.createElement(qd, {
      className: `${t}-switcher-loading-icon`
    });
  let l;
  if (o && typeof o == "object" && (l = o.showLeafIcon), i) {
    if (!o)
      return null;
    if (typeof l != "boolean" && l) {
      const p = typeof l == "function" ? l(r) : l, h = `${t}-switcher-line-custom-icon`;
      return ti(p) ? Yr(p, {
        className: se(p.props.className || "", h)
      }) : p;
    }
    return l ? /* @__PURE__ */ c.createElement(iP, {
      className: `${t}-switcher-line-icon`
    }) : /* @__PURE__ */ c.createElement("span", {
      className: `${t}-switcher-leaf-line`
    });
  }
  const u = `${t}-switcher-icon`, f = typeof n == "function" ? n(r) : n;
  return ti(f) ? Yr(f, {
    className: se(f.props.className || "", u)
  }) : f !== void 0 ? f : o ? a ? /* @__PURE__ */ c.createElement(goe, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ c.createElement(yoe, {
    className: `${t}-switcher-line-icon`
  }) : /* @__PURE__ */ c.createElement(foe, {
    className: u
  });
}, hP = boe, gP = /* @__PURE__ */ be.forwardRef((e, t) => {
  var n;
  const {
    getPrefixCls: r,
    direction: o,
    virtual: i,
    tree: a
  } = be.useContext(Ft), {
    prefixCls: s,
    className: l,
    showIcon: u = !1,
    showLine: f,
    switcherIcon: p,
    blockNode: h = !1,
    children: y,
    checkable: b = !1,
    selectable: m = !0,
    draggable: v,
    motion: C,
    style: x
  } = e, S = r("tree", s), E = r(), O = C != null ? C : Object.assign(Object.assign({}, xd(E)), {
    motionAppear: !1
  }), $ = Object.assign(Object.assign({}, e), {
    checkable: b,
    selectable: m,
    showIcon: u,
    motion: O,
    blockNode: h,
    showLine: !!f,
    dropIndicatorRender: coe
  }), [_, R, P] = loe(S), [, I] = ro(), j = I.paddingXS / 2 + (((n = I.Tree) === null || n === void 0 ? void 0 : n.titleHeight) || I.controlHeightSM), F = be.useMemo(() => {
    if (!v)
      return !1;
    let M = {};
    switch (typeof v) {
      case "function":
        M.nodeDraggable = v;
        break;
      case "object":
        M = Object.assign({}, v);
        break;
    }
    return M.icon !== !1 && (M.icon = M.icon || /* @__PURE__ */ be.createElement(toe, null)), M;
  }, [v]), A = (M) => /* @__PURE__ */ be.createElement(hP, {
    prefixCls: S,
    switcherIcon: p,
    treeNodeProps: M,
    showLine: f
  });
  return _(/* @__PURE__ */ be.createElement(lm, Object.assign({
    itemHeight: j,
    ref: t,
    virtual: i
  }, $, {
    // newProps may contain style so declare style below it
    style: Object.assign(Object.assign({}, a == null ? void 0 : a.style), x),
    prefixCls: S,
    className: se({
      [`${S}-icon-hide`]: !u,
      [`${S}-block-node`]: h,
      [`${S}-unselectable`]: !m,
      [`${S}-rtl`]: o === "rtl"
    }, a == null ? void 0 : a.className, l, R, P),
    direction: o,
    checkable: b && /* @__PURE__ */ be.createElement("span", {
      className: `${S}-checkbox-inner`
    }),
    selectable: m,
    switcherIcon: A,
    draggable: F
  }), y));
});
process.env.NODE_ENV !== "production" && (gP.displayName = "Tree");
const mP = gP;
var Da;
(function(e) {
  e[e.None = 0] = "None", e[e.Start = 1] = "Start", e[e.End = 2] = "End";
})(Da || (Da = {}));
function EC(e, t, n) {
  const {
    key: r,
    children: o
  } = n;
  function i(a) {
    const s = a[r], l = a[o];
    t(s, a) !== !1 && EC(l || [], t, n);
  }
  e.forEach(i);
}
function Coe(e) {
  let {
    treeData: t,
    expandedKeys: n,
    startKey: r,
    endKey: o,
    fieldNames: i
  } = e;
  const a = [];
  let s = Da.None;
  if (r && r === o)
    return [r];
  if (!r || !o)
    return [];
  function l(u) {
    return u === r || u === o;
  }
  return EC(t, (u) => {
    if (s === Da.End)
      return !1;
    if (l(u)) {
      if (a.push(u), s === Da.None)
        s = Da.Start;
      else if (s === Da.Start)
        return s = Da.End, !1;
    } else
      s === Da.Start && a.push(u);
    return n.includes(u);
  }, Hc(i)), a;
}
function d0(e, t, n) {
  const r = We(t), o = [];
  return EC(e, (i, a) => {
    const s = r.indexOf(i);
    return s !== -1 && (o.push(a), r.splice(s, 1)), !!r.length;
  }, Hc(n)), o;
}
var c$ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function xoe(e) {
  const {
    isLeaf: t,
    expanded: n
  } = e;
  return t ? /* @__PURE__ */ c.createElement(iP, null) : n ? /* @__PURE__ */ c.createElement(Yre, null) : /* @__PURE__ */ c.createElement(Qre, null);
}
function u$(e) {
  let {
    treeData: t,
    children: n
  } = e;
  return t || rN(n);
}
const Soe = (e, t) => {
  var {
    defaultExpandAll: n,
    defaultExpandParent: r,
    defaultExpandedKeys: o
  } = e, i = c$(e, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const a = c.useRef(), s = c.useRef(), l = () => {
    const {
      keyEntities: R
    } = Jg(u$(i));
    let P;
    return n ? P = Object.keys(R) : r ? P = ly(i.expandedKeys || o || [], R) : P = i.expandedKeys || o, P;
  }, [u, f] = c.useState(i.selectedKeys || i.defaultSelectedKeys || []), [p, h] = c.useState(() => l());
  c.useEffect(() => {
    "selectedKeys" in i && f(i.selectedKeys);
  }, [i.selectedKeys]), c.useEffect(() => {
    "expandedKeys" in i && h(i.expandedKeys);
  }, [i.expandedKeys]);
  const y = (R, P) => {
    var I;
    return "expandedKeys" in i || h(R), (I = i.onExpand) === null || I === void 0 ? void 0 : I.call(i, R, P);
  }, b = (R, P) => {
    var I;
    const {
      multiple: j,
      fieldNames: F
    } = i, {
      node: A,
      nativeEvent: M
    } = P, {
      key: N = ""
    } = A, D = u$(i), T = Object.assign(Object.assign({}, P), {
      selected: !0
    }), L = (M == null ? void 0 : M.ctrlKey) || (M == null ? void 0 : M.metaKey), z = M == null ? void 0 : M.shiftKey;
    let H;
    j && L ? (H = R, a.current = N, s.current = H, T.selectedNodes = d0(D, H, F)) : j && z ? (H = Array.from(new Set([].concat(We(s.current || []), We(Coe({
      treeData: D,
      expandedKeys: p,
      startKey: N,
      endKey: a.current,
      fieldNames: F
    }))))), T.selectedNodes = d0(D, H, F)) : (H = [N], a.current = N, s.current = H, T.selectedNodes = d0(D, H, F)), (I = i.onSelect) === null || I === void 0 || I.call(i, H, T), "selectedKeys" in i || f(H);
  }, {
    getPrefixCls: m,
    direction: v
  } = c.useContext(Ft), {
    prefixCls: C,
    className: x,
    showIcon: S = !0,
    expandAction: E = "click"
  } = i, O = c$(i, ["prefixCls", "className", "showIcon", "expandAction"]), $ = m("tree", C), _ = se(`${$}-directory`, {
    [`${$}-directory-rtl`]: v === "rtl"
  }, x);
  return /* @__PURE__ */ c.createElement(mP, Object.assign({
    icon: xoe,
    ref: t,
    blockNode: !0
  }, O, {
    showIcon: S,
    expandAction: E,
    prefixCls: $,
    className: _,
    expandedKeys: p,
    selectedKeys: u,
    onSelect: b,
    onExpand: y
  }));
}, vP = /* @__PURE__ */ c.forwardRef(Soe);
process.env.NODE_ENV !== "production" && (vP.displayName = "DirectoryTree");
const woe = vP, $C = mP;
$C.DirectoryTree = woe;
$C.TreeNode = Vc;
const Eoe = $C;
function d$(e) {
  let {
    value: t,
    onChange: n,
    filterSearch: r,
    tablePrefixCls: o,
    locale: i
  } = e;
  return r ? /* @__PURE__ */ c.createElement("div", {
    className: `${o}-filter-dropdown-search`
  }, /* @__PURE__ */ c.createElement(tm, {
    prefix: /* @__PURE__ */ c.createElement(Hg, null),
    placeholder: i.filterSearchPlaceholder,
    onChange: n,
    value: t,
    // for skip min-width of input
    htmlSize: 1,
    className: `${o}-filter-dropdown-search-input`
  })) : null;
}
const $oe = (e) => {
  const {
    keyCode: t
  } = e;
  t === Pe.ENTER && e.stopPropagation();
}, yP = /* @__PURE__ */ c.forwardRef((e, t) => /* @__PURE__ */ c.createElement("div", {
  className: e.className,
  onClick: (n) => n.stopPropagation(),
  onKeyDown: $oe,
  ref: t
}, e.children));
process.env.NODE_ENV !== "production" && (yP.displayName = "FilterDropdownMenuWrapper");
const Ooe = yP;
function xc(e) {
  let t = [];
  return (e || []).forEach((n) => {
    let {
      value: r,
      children: o
    } = n;
    t.push(r), o && (t = [].concat(We(t), We(xc(o))));
  }), t;
}
function _oe(e) {
  return e.some((t) => {
    let {
      children: n
    } = t;
    return n;
  });
}
function bP(e, t) {
  return typeof t == "string" || typeof t == "number" ? t == null ? void 0 : t.toString().toLowerCase().includes(e.trim().toLowerCase()) : !1;
}
function CP(e) {
  let {
    filters: t,
    prefixCls: n,
    filteredKeys: r,
    filterMultiple: o,
    searchValue: i,
    filterSearch: a
  } = e;
  return t.map((s, l) => {
    const u = String(s.value);
    if (s.children)
      return {
        key: u || l,
        label: s.text,
        popupClassName: `${n}-dropdown-submenu`,
        children: CP({
          filters: s.children,
          prefixCls: n,
          filteredKeys: r,
          filterMultiple: o,
          searchValue: i,
          filterSearch: a
        })
      };
    const f = o ? Fh : Ci, p = {
      key: s.value !== void 0 ? u : l,
      label: /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(f, {
        checked: r.includes(u)
      }), /* @__PURE__ */ c.createElement("span", null, s.text))
    };
    return i.trim() ? typeof a == "function" ? a(i, s) ? p : null : bP(i, s.text) ? p : null : p;
  });
}
function f0(e) {
  return e || [];
}
function Noe(e) {
  var t, n;
  const {
    tablePrefixCls: r,
    prefixCls: o,
    column: i,
    dropdownPrefixCls: a,
    columnKey: s,
    filterMultiple: l,
    filterMode: u = "menu",
    filterSearch: f = !1,
    filterState: p,
    triggerFilter: h,
    locale: y,
    children: b,
    getPopupContainer: m,
    rootClassName: v
  } = e, {
    filterDropdownOpen: C,
    onFilterDropdownOpenChange: x,
    filterResetToDefaultFilteredValue: S,
    defaultFilteredValue: E,
    // Deprecated
    filterDropdownVisible: O,
    onFilterDropdownVisibleChange: $
  } = i, [_, R] = c.useState(!1), P = !!(p && (!((t = p.filteredKeys) === null || t === void 0) && t.length || p.forceFiltered)), I = (fe) => {
    R(fe), x == null || x(fe), $ == null || $(fe);
  };
  if (process.env.NODE_ENV !== "production") {
    const fe = xn("Table");
    [["filterDropdownVisible", "filterDropdownOpen", O], ["onFilterDropdownVisibleChange", "onFilterDropdownOpenChange", $]].forEach((ye) => {
      let [we, he, me] = ye;
      fe.deprecated(me == null, we, he);
    });
  }
  const j = (n = C != null ? C : O) !== null && n !== void 0 ? n : _, F = p == null ? void 0 : p.filteredKeys, [A, M] = Lre(f0(F)), N = (fe) => {
    let {
      selectedKeys: ye
    } = fe;
    M(ye);
  }, D = (fe, ye) => {
    let {
      node: we,
      checked: he
    } = ye;
    N(l ? {
      selectedKeys: fe
    } : {
      selectedKeys: he && we.key ? [we.key] : []
    });
  };
  c.useEffect(() => {
    _ && N({
      selectedKeys: f0(F)
    });
  }, [F]);
  const [T, L] = c.useState([]), z = (fe) => {
    L(fe);
  }, [H, V] = c.useState(""), Y = (fe) => {
    const {
      value: ye
    } = fe.target;
    V(ye);
  };
  c.useEffect(() => {
    _ || V("");
  }, [_]);
  const Z = (fe) => {
    const ye = fe && fe.length ? fe : null;
    if (ye === null && (!p || !p.filteredKeys) || Fi(ye, p == null ? void 0 : p.filteredKeys, !0))
      return null;
    h({
      column: i,
      key: s,
      filteredKeys: ye
    });
  }, oe = () => {
    I(!1), Z(A());
  }, ee = function() {
    let {
      confirm: fe,
      closeDropdown: ye
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      confirm: !1,
      closeDropdown: !1
    };
    fe && Z([]), ye && I(!1), V(""), M(S ? (E || []).map((we) => String(we)) : []);
  }, ae = function() {
    let {
      closeDropdown: fe
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      closeDropdown: !0
    };
    fe && I(!1), Z(A());
  }, le = (fe, ye) => {
    ye.source === "trigger" && (fe && F !== void 0 && M(f0(F)), I(fe), !fe && !i.filterDropdown && oe());
  }, ue = se({
    [`${a}-menu-without-submenu`]: !_oe(i.filters || [])
  }), ie = (fe) => {
    if (fe.target.checked) {
      const ye = xc(i == null ? void 0 : i.filters).map((we) => String(we));
      M(ye);
    } else
      M([]);
  }, re = (fe) => {
    let {
      filters: ye
    } = fe;
    return (ye || []).map((we, he) => {
      const me = String(we.value), Ce = {
        title: we.text,
        key: we.value !== void 0 ? me : String(he)
      };
      return we.children && (Ce.children = re({
        filters: we.children
      })), Ce;
    });
  }, Q = (fe) => {
    var ye;
    return Object.assign(Object.assign({}, fe), {
      text: fe.title,
      value: fe.key,
      children: ((ye = fe.children) === null || ye === void 0 ? void 0 : ye.map((we) => Q(we))) || []
    });
  };
  let ce;
  if (typeof i.filterDropdown == "function")
    ce = i.filterDropdown({
      prefixCls: `${a}-custom`,
      setSelectedKeys: (fe) => N({
        selectedKeys: fe
      }),
      selectedKeys: A(),
      confirm: ae,
      clearFilters: ee,
      filters: i.filters,
      visible: j,
      close: () => {
        I(!1);
      }
    });
  else if (i.filterDropdown)
    ce = i.filterDropdown;
  else {
    const fe = A() || [], ye = () => (i.filters || []).length === 0 ? /* @__PURE__ */ c.createElement(Js, {
      image: Js.PRESENTED_IMAGE_SIMPLE,
      description: y.filterEmptyText,
      imageStyle: {
        height: 24
      },
      style: {
        margin: 0,
        padding: "16px 0"
      }
    }) : u === "tree" ? /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(d$, {
      filterSearch: f,
      value: H,
      onChange: Y,
      tablePrefixCls: r,
      locale: y
    }), /* @__PURE__ */ c.createElement("div", {
      className: `${r}-filter-dropdown-tree`
    }, l ? /* @__PURE__ */ c.createElement(Fh, {
      checked: fe.length === xc(i.filters).length,
      indeterminate: fe.length > 0 && fe.length < xc(i.filters).length,
      className: `${r}-filter-dropdown-checkall`,
      onChange: ie
    }, y.filterCheckall) : null, /* @__PURE__ */ c.createElement(Eoe, {
      checkable: !0,
      selectable: !1,
      blockNode: !0,
      multiple: l,
      checkStrictly: !l,
      className: `${a}-menu`,
      onCheck: D,
      checkedKeys: fe,
      selectedKeys: fe,
      showIcon: !1,
      treeData: re({
        filters: i.filters
      }),
      autoExpandParent: !0,
      defaultExpandAll: !0,
      filterTreeNode: H.trim() ? (he) => typeof f == "function" ? f(H, Q(he)) : bP(H, he.title) : void 0
    }))) : /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(d$, {
      filterSearch: f,
      value: H,
      onChange: Y,
      tablePrefixCls: r,
      locale: y
    }), /* @__PURE__ */ c.createElement(m_, {
      selectable: !0,
      multiple: l,
      prefixCls: `${a}-menu`,
      className: ue,
      onSelect: N,
      onDeselect: N,
      selectedKeys: fe,
      getPopupContainer: m,
      openKeys: T,
      onOpenChange: z,
      items: CP({
        filters: i.filters || [],
        filterSearch: f,
        prefixCls: o,
        filteredKeys: A(),
        filterMultiple: l,
        searchValue: H
      })
    })), we = () => S ? Fi((E || []).map((he) => String(he)), fe, !0) : fe.length === 0;
    ce = /* @__PURE__ */ c.createElement(c.Fragment, null, ye(), /* @__PURE__ */ c.createElement("div", {
      className: `${o}-dropdown-btns`
    }, /* @__PURE__ */ c.createElement(Io, {
      type: "link",
      size: "small",
      disabled: we(),
      onClick: () => ee()
    }, y.filterReset), /* @__PURE__ */ c.createElement(Io, {
      type: "primary",
      size: "small",
      onClick: oe
    }, y.filterConfirm)));
  }
  i.filterDropdown && (ce = /* @__PURE__ */ c.createElement(g_, {
    selectable: void 0
  }, ce));
  const ge = () => /* @__PURE__ */ c.createElement(Ooe, {
    className: `${o}-dropdown`
  }, ce);
  let G;
  typeof i.filterIcon == "function" ? G = i.filterIcon(P) : i.filterIcon ? G = i.filterIcon : G = /* @__PURE__ */ c.createElement(Mre, null);
  const {
    direction: ne
  } = c.useContext(Ft);
  return /* @__PURE__ */ c.createElement("div", {
    className: `${o}-column`
  }, /* @__PURE__ */ c.createElement("span", {
    className: `${r}-column-title`
  }, b), /* @__PURE__ */ c.createElement(GN, {
    dropdownRender: ge,
    trigger: ["click"],
    open: j,
    onOpenChange: le,
    getPopupContainer: m,
    placement: ne === "rtl" ? "bottomLeft" : "bottomRight",
    rootClassName: v
  }, /* @__PURE__ */ c.createElement("span", {
    role: "button",
    tabIndex: -1,
    className: se(`${o}-trigger`, {
      active: P
    }),
    onClick: (fe) => {
      fe.stopPropagation();
    }
  }, G)));
}
function py(e, t, n) {
  let r = [];
  return (e || []).forEach((o, i) => {
    var a;
    const s = lf(i, n);
    if (o.filters || "filterDropdown" in o || "onFilter" in o)
      if ("filteredValue" in o) {
        let l = o.filteredValue;
        "filterDropdown" in o || (l = (a = l == null ? void 0 : l.map(String)) !== null && a !== void 0 ? a : l), r.push({
          column: o,
          key: Cl(o, s),
          filteredKeys: l,
          forceFiltered: o.filtered
        });
      } else
        r.push({
          column: o,
          key: Cl(o, s),
          filteredKeys: t && o.defaultFilteredValue ? o.defaultFilteredValue : void 0,
          forceFiltered: o.filtered
        });
    "children" in o && (r = [].concat(We(r), We(py(o.children, t, s))));
  }), r;
}
function xP(e, t, n, r, o, i, a, s, l) {
  return n.map((u, f) => {
    const p = lf(f, s), {
      filterMultiple: h = !0,
      filterMode: y,
      filterSearch: b
    } = u;
    let m = u;
    if (m.filters || m.filterDropdown) {
      const v = Cl(m, p), C = r.find((x) => {
        let {
          key: S
        } = x;
        return v === S;
      });
      m = Object.assign(Object.assign({}, m), {
        title: (x) => /* @__PURE__ */ c.createElement(Noe, {
          tablePrefixCls: e,
          prefixCls: `${e}-filter`,
          dropdownPrefixCls: t,
          column: m,
          columnKey: v,
          filterState: C,
          filterMultiple: h,
          filterMode: y,
          filterSearch: b,
          triggerFilter: i,
          locale: o,
          getPopupContainer: a,
          rootClassName: l
        }, sm(u.title, x))
      });
    }
    return "children" in m && (m = Object.assign(Object.assign({}, m), {
      children: xP(e, t, m.children, r, o, i, a, p, l)
    })), m;
  });
}
function f$(e) {
  const t = {};
  return e.forEach((n) => {
    let {
      key: r,
      filteredKeys: o,
      column: i
    } = n;
    const a = r, {
      filters: s,
      filterDropdown: l
    } = i;
    if (l)
      t[a] = o || null;
    else if (Array.isArray(o)) {
      const u = xc(s);
      t[a] = u.filter((f) => o.includes(String(f)));
    } else
      t[a] = null;
  }), t;
}
function hy(e, t, n) {
  return t.reduce((r, o) => {
    const {
      column: {
        onFilter: i,
        filters: a
      },
      filteredKeys: s
    } = o;
    return i && s && s.length ? r.map((l) => Object.assign({}, l)).filter((l) => s.some((u) => {
      const f = xc(a), p = f.findIndex((y) => String(y) === String(u)), h = p !== -1 ? f[p] : u;
      return l[n] && (l[n] = hy(l[n], t, n)), i(h, l);
    })) : r;
  }, e);
}
const SP = (e) => e.flatMap((t) => "children" in t ? [t].concat(We(SP(t.children || []))) : [t]);
function Poe(e) {
  let {
    prefixCls: t,
    dropdownPrefixCls: n,
    mergedColumns: r,
    onFilterChange: o,
    getPopupContainer: i,
    locale: a,
    rootClassName: s
  } = e;
  const l = xn("Table"), u = c.useMemo(() => SP(r || []), [r]), [f, p] = c.useState(() => py(u, !0)), h = c.useMemo(() => {
    const v = py(u, !1);
    if (v.length === 0)
      return v;
    let C = !0, x = !0;
    if (v.forEach((S) => {
      let {
        filteredKeys: E
      } = S;
      E !== void 0 ? C = !1 : x = !1;
    }), C) {
      const S = (u || []).map((E, O) => Cl(E, lf(O)));
      return f.filter((E) => {
        let {
          key: O
        } = E;
        return S.includes(O);
      }).map((E) => {
        const O = u[S.findIndex(($) => $ === E.key)];
        return Object.assign(Object.assign({}, E), {
          column: Object.assign(Object.assign({}, E.column), O),
          forceFiltered: O.filtered
        });
      });
    }
    return process.env.NODE_ENV !== "production" && l(x, "usage", "Columns should all contain `filteredValue` or not contain `filteredValue`."), v;
  }, [u, f]), y = c.useMemo(() => f$(h), [h]), b = (v) => {
    const C = h.filter((x) => {
      let {
        key: S
      } = x;
      return S !== v.key;
    });
    C.push(v), p(C), o(f$(C), C);
  };
  return [(v) => xP(t, n, v, h, a, b, i, void 0, s), h, y];
}
function Ioe(e, t, n) {
  const r = c.useRef({});
  function o(i) {
    if (!r.current || r.current.data !== e || r.current.childrenColumnName !== t || r.current.getRowKey !== n) {
      let s = function(l) {
        l.forEach((u, f) => {
          const p = n(u, f);
          a.set(p, u), u && typeof u == "object" && t in u && s(u[t] || []);
        });
      };
      const a = /* @__PURE__ */ new Map();
      s(e), r.current = {
        data: e,
        childrenColumnName: t,
        kvMap: a,
        getRowKey: n
      };
    }
    return r.current.kvMap.get(i);
  }
  return [o];
}
var Roe = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const wP = 10;
function Doe(e, t) {
  const n = {
    current: e.current,
    pageSize: e.pageSize
  };
  return Object.keys(t && typeof t == "object" ? t : {}).forEach((o) => {
    const i = e[o];
    typeof i != "function" && (n[o] = i);
  }), n;
}
function Toe(e, t, n) {
  const r = n && typeof n == "object" ? n : {}, {
    total: o = 0
  } = r, i = Roe(r, ["total"]), [a, s] = Ot(() => ({
    current: "defaultCurrent" in i ? i.defaultCurrent : 1,
    pageSize: "defaultPageSize" in i ? i.defaultPageSize : wP
  })), l = Tee(a, i, {
    total: o > 0 ? o : e
  }), u = Math.ceil((o || e) / l.pageSize);
  l.current > u && (l.current = u || 1);
  const f = (h, y) => {
    s({
      current: h != null ? h : 1,
      pageSize: y || l.pageSize
    });
  }, p = (h, y) => {
    var b;
    n && ((b = n.onChange) === null || b === void 0 || b.call(n, h, y)), f(h, y), t(h, y || (l == null ? void 0 : l.pageSize));
  };
  return n === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, l), {
    onChange: p
  }), f];
}
var Moe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" };
const Loe = Moe;
var EP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Loe
  }));
};
process.env.NODE_ENV !== "production" && (EP.displayName = "CaretDownOutlined");
const Aoe = /* @__PURE__ */ c.forwardRef(EP);
var joe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" };
const koe = joe;
var $P = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: koe
  }));
};
process.env.NODE_ENV !== "production" && ($P.displayName = "CaretUpOutlined");
const Foe = /* @__PURE__ */ c.forwardRef($P), ah = "ascend", p0 = "descend";
function Uh(e) {
  return typeof e.sorter == "object" && typeof e.sorter.multiple == "number" ? e.sorter.multiple : !1;
}
function p$(e) {
  return typeof e == "function" ? e : e && typeof e == "object" && e.compare ? e.compare : !1;
}
function Boe(e, t) {
  return t ? e[e.indexOf(t) + 1] : e[0];
}
function gy(e, t, n) {
  let r = [];
  function o(i, a) {
    r.push({
      column: i,
      key: Cl(i, a),
      multiplePriority: Uh(i),
      sortOrder: i.sortOrder
    });
  }
  return (e || []).forEach((i, a) => {
    const s = lf(a, n);
    i.children ? ("sortOrder" in i && o(i, s), r = [].concat(We(r), We(gy(i.children, t, s)))) : i.sorter && ("sortOrder" in i ? o(i, s) : t && i.defaultSortOrder && r.push({
      column: i,
      key: Cl(i, s),
      multiplePriority: Uh(i),
      sortOrder: i.defaultSortOrder
    }));
  }), r;
}
function OP(e, t, n, r, o, i, a, s) {
  return (t || []).map((l, u) => {
    const f = lf(u, s);
    let p = l;
    if (p.sorter) {
      const h = p.sortDirections || o, y = p.showSorterTooltip === void 0 ? a : p.showSorterTooltip, b = Cl(p, f), m = n.find((R) => {
        let {
          key: P
        } = R;
        return P === b;
      }), v = m ? m.sortOrder : null, C = Boe(h, v);
      let x;
      if (l.sortIcon)
        x = l.sortIcon({
          sortOrder: v
        });
      else {
        const R = h.includes(ah) && /* @__PURE__ */ c.createElement(Foe, {
          className: se(`${e}-column-sorter-up`, {
            active: v === ah
          })
        }), P = h.includes(p0) && /* @__PURE__ */ c.createElement(Aoe, {
          className: se(`${e}-column-sorter-down`, {
            active: v === p0
          })
        });
        x = /* @__PURE__ */ c.createElement("span", {
          className: se(`${e}-column-sorter`, {
            [`${e}-column-sorter-full`]: !!(R && P)
          })
        }, /* @__PURE__ */ c.createElement("span", {
          className: `${e}-column-sorter-inner`,
          "aria-hidden": "true"
        }, R, P));
      }
      const {
        cancelSort: S,
        triggerAsc: E,
        triggerDesc: O
      } = i || {};
      let $ = S;
      C === p0 ? $ = O : C === ah && ($ = E);
      const _ = typeof y == "object" ? Object.assign({
        title: $
      }, y) : {
        title: $
      };
      p = Object.assign(Object.assign({}, p), {
        className: se(p.className, {
          [`${e}-column-sort`]: v
        }),
        title: (R) => {
          const P = /* @__PURE__ */ c.createElement("div", {
            className: `${e}-column-sorters`
          }, /* @__PURE__ */ c.createElement("span", {
            className: `${e}-column-title`
          }, sm(l.title, R)), x);
          return y ? /* @__PURE__ */ c.createElement(Bo, Object.assign({}, _), P) : P;
        },
        onHeaderCell: (R) => {
          const P = l.onHeaderCell && l.onHeaderCell(R) || {}, I = P.onClick, j = P.onKeyDown;
          P.onClick = (M) => {
            r({
              column: l,
              key: b,
              sortOrder: C,
              multiplePriority: Uh(l)
            }), I == null || I(M);
          }, P.onKeyDown = (M) => {
            M.keyCode === Pe.ENTER && (r({
              column: l,
              key: b,
              sortOrder: C,
              multiplePriority: Uh(l)
            }), j == null || j(M));
          };
          const F = Rre(l.title, {}), A = F == null ? void 0 : F.toString();
          return v ? P["aria-sort"] = v === "ascend" ? "ascending" : "descending" : P["aria-label"] = A || "", P.className = se(P.className, `${e}-column-has-sorters`), P.tabIndex = 0, l.ellipsis && (P.title = (F != null ? F : "").toString()), P;
        }
      });
    }
    return "children" in p && (p = Object.assign(Object.assign({}, p), {
      children: OP(e, p.children, n, r, o, i, a, f)
    })), p;
  });
}
function h$(e) {
  const {
    column: t,
    sortOrder: n
  } = e;
  return {
    column: t,
    order: n,
    field: t.dataIndex,
    columnKey: t.key
  };
}
function g$(e) {
  const t = e.filter((n) => {
    let {
      sortOrder: r
    } = n;
    return r;
  }).map(h$);
  return t.length === 0 && e.length ? Object.assign(Object.assign({}, h$(e[e.length - 1])), {
    column: void 0
  }) : t.length <= 1 ? t[0] || {} : t;
}
function my(e, t, n) {
  const r = t.slice().sort((a, s) => s.multiplePriority - a.multiplePriority), o = e.slice(), i = r.filter((a) => {
    let {
      column: {
        sorter: s
      },
      sortOrder: l
    } = a;
    return p$(s) && l;
  });
  return i.length ? o.sort((a, s) => {
    for (let l = 0; l < i.length; l += 1) {
      const u = i[l], {
        column: {
          sorter: f
        },
        sortOrder: p
      } = u, h = p$(f);
      if (h && p) {
        const y = h(a, s, p);
        if (y !== 0)
          return p === ah ? y : -y;
      }
    }
    return 0;
  }).map((a) => {
    const s = a[n];
    return s ? Object.assign(Object.assign({}, a), {
      [n]: my(s, t, n)
    }) : a;
  }) : o;
}
function Hoe(e) {
  let {
    prefixCls: t,
    mergedColumns: n,
    onSorterChange: r,
    sortDirections: o,
    tableLocale: i,
    showSorterTooltip: a
  } = e;
  const [s, l] = c.useState(gy(n, !0)), u = c.useMemo(() => {
    let b = !0;
    const m = gy(n, !1);
    if (!m.length)
      return s;
    const v = [];
    function C(S) {
      b ? v.push(S) : v.push(Object.assign(Object.assign({}, S), {
        sortOrder: null
      }));
    }
    let x = null;
    return m.forEach((S) => {
      x === null ? (C(S), S.sortOrder && (S.multiplePriority === !1 ? b = !1 : x = !0)) : (x && S.multiplePriority !== !1 || (b = !1), C(S));
    }), v;
  }, [n, s]), f = c.useMemo(() => {
    const b = u.map((m) => {
      let {
        column: v,
        sortOrder: C
      } = m;
      return {
        column: v,
        order: C
      };
    });
    return {
      sortColumns: b,
      // Legacy
      sortColumn: b[0] && b[0].column,
      sortOrder: b[0] && b[0].order
    };
  }, [u]);
  function p(b) {
    let m;
    b.multiplePriority === !1 || !u.length || u[0].multiplePriority === !1 ? m = [b] : m = [].concat(We(u.filter((v) => {
      let {
        key: C
      } = v;
      return C !== b.key;
    })), [b]), l(m), r(g$(m), m);
  }
  return [(b) => OP(t, b, u, p, o, i, a), u, f, () => g$(u)];
}
function _P(e, t) {
  return e.map((n) => {
    const r = Object.assign({}, n);
    return r.title = sm(n.title, t), "children" in r && (r.children = _P(r.children, t)), r;
  });
}
function zoe(e) {
  return [c.useCallback((n) => _P(n, e), [e])];
}
const Voe = U8((e, t) => {
  const {
    _renderTimes: n
  } = e, {
    _renderTimes: r
  } = t;
  return n !== r;
}), Woe = Z8((e, t) => {
  const {
    _renderTimes: n
  } = e, {
    _renderTimes: r
  } = t;
  return n !== r;
}), Koe = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    lineType: r,
    tableBorderColor: o,
    tableHeaderBg: i,
    tablePaddingVertical: a,
    tablePaddingHorizontal: s,
    calc: l
  } = e, u = `${te(n)} ${r} ${o}`, f = (p, h, y) => ({
    [`&${t}-${p}`]: {
      [`> ${t}-container`]: {
        [`> ${t}-content, > ${t}-body`]: {
          "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ": {
            [`> ${t}-expanded-row-fixed`]: {
              margin: `${te(l(h).mul(-1).equal())}
              ${te(l(l(y).add(n)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${t}-wrapper`]: {
      [`${t}${t}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${t}-title`]: {
          border: u,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${t}-container`]: {
          borderInlineStart: u,
          borderTop: u,
          [`
            > ${t}-content,
            > ${t}-header,
            > ${t}-body,
            > ${t}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ": {
                borderInlineEnd: u
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: u
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ": {
                [`> ${t}-cell-fix-right-first::after`]: {
                  borderInlineEnd: u
                }
              },
              // ========================== Expandable ==========================
              "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ": {
                [`> ${t}-expanded-row-fixed`]: {
                  margin: `${te(l(a).mul(-1).equal())} ${te(l(l(s).add(n)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: n,
                    bottom: 0,
                    borderInlineEnd: u,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${t}-scroll-horizontal`]: {
          [`> ${t}-container > ${t}-body`]: {
            "> table > tbody": {
              [`
                > tr${t}-expanded-row,
                > tr${t}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, f("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle)), f("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${t}-footer`]: {
          border: u,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${t}-cell`]: {
        [`${t}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${te(n)} 0 ${te(n)} ${i}`
        }
      },
      [`${t}-bordered ${t}-cell-scrollbar`]: {
        borderInlineEnd: u
      }
    }
  };
}, Uoe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-cell-ellipsis`]: Object.assign(Object.assign({}, gl), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${t}-cell-fix-left-last,
          &${t}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${t}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${t}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, Goe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-tbody > tr${t}-placeholder`]: {
        textAlign: "center",
        color: e.colorTextDisabled,
        "\n          &:hover > th,\n          &:hover > td,\n        ": {
          background: e.colorBgContainer
        }
      }
    }
  };
}, qoe = (e) => {
  const {
    componentCls: t,
    antCls: n,
    motionDurationSlow: r,
    lineWidth: o,
    paddingXS: i,
    lineType: a,
    tableBorderColor: s,
    tableExpandIconBg: l,
    tableExpandColumnWidth: u,
    borderRadius: f,
    tablePaddingVertical: p,
    tablePaddingHorizontal: h,
    tableExpandedRowBg: y,
    paddingXXS: b,
    expandIconMarginTop: m,
    expandIconSize: v,
    expandIconHalfInner: C,
    expandIconScale: x,
    calc: S
  } = e, E = `${te(o)} ${a} ${s}`, O = S(b).sub(o).equal();
  return {
    [`${t}-wrapper`]: {
      [`${t}-expand-icon-col`]: {
        width: u
      },
      [`${t}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${t}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${t}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${t}-row-expand-icon`]: Object.assign(Object.assign({}, pb(e)), {
        position: "relative",
        float: "left",
        boxSizing: "border-box",
        width: v,
        height: v,
        padding: 0,
        color: "inherit",
        lineHeight: te(v),
        background: l,
        border: E,
        borderRadius: f,
        transform: `scale(${x})`,
        transition: `all ${r}`,
        userSelect: "none",
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${r} ease-out`,
          content: '""'
        },
        "&::before": {
          top: C,
          insetInlineEnd: O,
          insetInlineStart: O,
          height: o
        },
        "&::after": {
          top: O,
          bottom: O,
          insetInlineStart: C,
          width: o,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${t}-row-indent + ${t}-row-expand-icon`]: {
        marginTop: m,
        marginInlineEnd: i
      },
      [`tr${t}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: y
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${n}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "auto"
          }
        }
      },
      // With fixed
      [`${t}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${te(S(p).mul(-1).equal())} ${te(S(h).mul(-1).equal())}`,
        padding: `${te(p)} ${te(h)}`
      }
    }
  };
}, Yoe = (e) => {
  const {
    componentCls: t,
    antCls: n,
    iconCls: r,
    tableFilterDropdownWidth: o,
    tableFilterDropdownSearchWidth: i,
    paddingXXS: a,
    paddingXS: s,
    colorText: l,
    lineWidth: u,
    lineType: f,
    tableBorderColor: p,
    headerIconColor: h,
    fontSizeSM: y,
    tablePaddingHorizontal: b,
    borderRadius: m,
    motionDurationSlow: v,
    colorTextDescription: C,
    colorPrimary: x,
    tableHeaderFilterActiveBg: S,
    colorTextDisabled: E,
    tableFilterDropdownBg: O,
    tableFilterDropdownHeight: $,
    controlItemBgHover: _,
    controlItemBgActive: R,
    boxShadowSecondary: P,
    filterDropdownMenuBg: I,
    calc: j
  } = e, F = `${n}-dropdown`, A = `${t}-filter-dropdown`, M = `${n}-tree`, N = `${te(u)} ${f} ${p}`;
  return [
    {
      [`${t}-wrapper`]: {
        [`${t}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${t}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: j(a).mul(-1).equal(),
          marginInline: `${te(a)} ${te(j(b).div(2).mul(-1).equal())}`,
          padding: `0 ${te(a)}`,
          color: h,
          fontSize: y,
          borderRadius: m,
          cursor: "pointer",
          transition: `all ${v}`,
          "&:hover": {
            color: C,
            background: S
          },
          "&.active": {
            color: x
          }
        }
      }
    },
    {
      // Dropdown
      [`${n}-dropdown`]: {
        [A]: Object.assign(Object.assign({}, Qn(e)), {
          minWidth: o,
          backgroundColor: O,
          borderRadius: m,
          boxShadow: P,
          overflow: "hidden",
          // Reset menu
          [`${F}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: $,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: I,
            "&:empty::after": {
              display: "block",
              padding: `${te(s)} 0`,
              color: E,
              fontSize: y,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${A}-tree`]: {
            paddingBlock: `${te(s)} 0`,
            paddingInline: s,
            [M]: {
              padding: 0
            },
            [`${M}-treenode ${M}-node-content-wrapper:hover`]: {
              backgroundColor: _
            },
            [`${M}-treenode-checkbox-checked ${M}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: R
              }
            }
          },
          [`${A}-search`]: {
            padding: s,
            borderBottom: N,
            "&-input": {
              input: {
                minWidth: i
              },
              [r]: {
                color: E
              }
            }
          },
          [`${A}-checkall`]: {
            width: "100%",
            marginBottom: a,
            marginInlineStart: a
          },
          // Operation
          [`${A}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${te(j(s).sub(u).equal())} ${te(s)}`,
            overflow: "hidden",
            borderTop: N
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${n}-dropdown ${A}, ${A}-submenu`]: {
        // Checkbox
        [`${n}-checkbox-wrapper + span`]: {
          paddingInlineStart: s,
          color: l
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, Xoe = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    colorSplit: r,
    motionDurationSlow: o,
    zIndexTableFixed: i,
    tableBg: a,
    zIndexTableSticky: s,
    calc: l
  } = e, u = r;
  return {
    [`${t}-wrapper`]: {
      [`
        ${t}-cell-fix-left,
        ${t}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: i,
        background: a
      },
      [`
        ${t}-cell-fix-left-first::after,
        ${t}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: l(n).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${o}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${t}-cell-fix-right-first::after,
        ${t}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: l(n).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${o}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${t}-container`]: {
        position: "relative",
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: l(s).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${o}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${t}-ping-left`]: {
        [`&:not(${t}-has-fix-left) ${t}-container::before`]: {
          boxShadow: `inset 10px 0 8px -8px ${u}`
        },
        [`
          ${t}-cell-fix-left-first::after,
          ${t}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${u}`
        },
        [`${t}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${t}-ping-right`]: {
        [`&:not(${t}-has-fix-right) ${t}-container::after`]: {
          boxShadow: `inset -10px 0 8px -8px ${u}`
        },
        [`
          ${t}-cell-fix-right-first::after,
          ${t}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${u}`
        }
      }
    }
  };
}, Zoe = (e) => {
  const {
    componentCls: t,
    antCls: n,
    margin: r
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${t}-pagination${n}-pagination`]: {
        margin: `${te(r)} 0`
      },
      [`${t}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: e.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
}, Qoe = (e) => {
  const {
    componentCls: t,
    tableRadius: n
  } = e;
  return {
    [`${t}-wrapper`]: {
      [t]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${t}-title, ${t}-header`]: {
          borderRadius: `${te(n)} ${te(n)} 0 0`
        },
        [`${t}-title + ${t}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${t}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: n,
          borderStartEndRadius: n,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: n
            },
            "> *:last-child": {
              borderStartEndRadius: n
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${te(n)} ${te(n)}`
        }
      }
    }
  };
}, Joe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${t}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${t}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${t}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${t}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${t}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, eie = (e) => {
  const {
    componentCls: t,
    antCls: n,
    iconCls: r,
    fontSizeIcon: o,
    padding: i,
    paddingXS: a,
    headerIconColor: s,
    headerIconHoverColor: l,
    tableSelectionColumnWidth: u,
    tableSelectedRowBg: f,
    tableSelectedRowHoverBg: p,
    tableRowHoverBg: h,
    tablePaddingHorizontal: y,
    calc: b
  } = e;
  return {
    [`${t}-wrapper`]: {
      // ========================== Selections ==========================
      [`${t}-selection-col`]: {
        width: u,
        [`&${t}-selection-col-with-dropdown`]: {
          width: b(u).add(o).add(b(i).div(4)).equal()
        }
      },
      [`${t}-bordered ${t}-selection-col`]: {
        width: b(u).add(b(a).mul(2)).equal(),
        [`&${t}-selection-col-with-dropdown`]: {
          width: b(u).add(o).add(b(i).div(4)).add(b(a).mul(2)).equal()
        }
      },
      [`
        table tr th${t}-selection-column,
        table tr td${t}-selection-column,
        ${t}-selection-column
      `]: {
        paddingInlineEnd: e.paddingXS,
        paddingInlineStart: e.paddingXS,
        textAlign: "center",
        [`${n}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${t}-selection-column${t}-cell-fix-left`]: {
        zIndex: e.zIndexTableFixed + 1
      },
      [`table tr th${t}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${t}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${t}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: te(b(y).div(4).equal()),
        [r]: {
          color: s,
          fontSize: o,
          verticalAlign: "baseline",
          "&:hover": {
            color: l
          }
        }
      },
      // ============================= Rows =============================
      [`${t}-tbody`]: {
        [`${t}-row`]: {
          [`&${t}-row-selected`]: {
            [`> ${t}-cell`]: {
              background: f,
              "&-row-hover": {
                background: p
              }
            }
          },
          [`> ${t}-cell-row-hover`]: {
            background: h
          }
        }
      }
    }
  };
}, tie = (e) => {
  const {
    componentCls: t,
    tableExpandColumnWidth: n,
    calc: r
  } = e, o = (i, a, s, l) => ({
    [`${t}${t}-${i}`]: {
      fontSize: l,
      [`
        ${t}-title,
        ${t}-footer,
        ${t}-cell,
        ${t}-thead > tr > th,
        ${t}-tbody > tr > th,
        ${t}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${te(a)} ${te(s)}`
      },
      [`${t}-filter-trigger`]: {
        marginInlineEnd: te(r(s).div(2).mul(-1).equal())
      },
      [`${t}-expanded-row-fixed`]: {
        margin: `${te(r(a).mul(-1).equal())} ${te(r(s).mul(-1).equal())}`
      },
      [`${t}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${t}-wrapper:only-child ${t}`]: {
          marginBlock: te(r(a).mul(-1).equal()),
          marginInline: `${te(r(n).sub(s).equal())} ${te(r(s).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${t}-selection-extra`]: {
        paddingInlineStart: te(r(s).div(4).equal())
      }
    }
  });
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({}, o("middle", e.tablePaddingVerticalMiddle, e.tablePaddingHorizontalMiddle, e.tableFontSizeMiddle)), o("small", e.tablePaddingVerticalSmall, e.tablePaddingHorizontalSmall, e.tableFontSizeSmall))
  };
}, nie = (e) => {
  const {
    componentCls: t,
    marginXXS: n,
    fontSizeIcon: r,
    headerIconColor: o,
    headerIconHoverColor: i
  } = e;
  return {
    [`${t}-wrapper`]: {
      [`${t}-thead th${t}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        transition: `all ${e.motionDurationSlow}`,
        "&:hover": {
          background: e.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: e.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${t}-cell-fix-left:hover,
          &${t}-cell-fix-right:hover
        `]: {
          background: e.tableFixedHeaderSortActiveBg
        }
      },
      [`${t}-thead th${t}-column-sort`]: {
        background: e.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${t}-column-sort`]: {
        background: e.tableBodySortBg
      },
      [`${t}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1
      },
      [`${t}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${t}-column-sorter`]: {
        marginInlineStart: n,
        color: o,
        fontSize: 0,
        transition: `color ${e.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: r,
          "&.active": {
            color: e.colorPrimary
          }
        },
        [`${t}-column-sorter-up + ${t}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${t}-column-sorters:hover ${t}-column-sorter`]: {
        color: i
      }
    }
  };
}, rie = (e) => {
  const {
    componentCls: t,
    opacityLoading: n,
    tableScrollThumbBg: r,
    tableScrollThumbBgHover: o,
    tableScrollThumbSize: i,
    tableScrollBg: a,
    zIndexTableSticky: s,
    stickyScrollBarBorderRadius: l,
    lineWidth: u,
    lineType: f,
    tableBorderColor: p
  } = e, h = `${te(u)} ${f} ${p}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: s,
          background: e.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${te(i)} !important`,
          zIndex: s,
          display: "flex",
          alignItems: "center",
          background: a,
          borderTop: h,
          opacity: n,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: i,
            backgroundColor: r,
            borderRadius: l,
            transition: `all ${e.motionDurationSlow}, transform none`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: o
            }
          }
        }
      }
    }
  };
}, m$ = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    tableBorderColor: r,
    calc: o
  } = e, i = `${te(n)} ${e.lineType} ${r}`;
  return {
    [`${t}-wrapper`]: {
      [`${t}-summary`]: {
        position: "relative",
        zIndex: e.zIndexTableFixed,
        background: e.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: i
          }
        }
      },
      [`div${t}-summary`]: {
        boxShadow: `0 ${te(o(n).mul(-1).equal())} 0 ${r}`
      }
    }
  };
}, oie = (e) => {
  const {
    componentCls: t,
    motionDurationMid: n,
    lineWidth: r,
    lineType: o,
    tableBorderColor: i,
    calc: a
  } = e, s = `${te(r)} ${o} ${i}`, l = `${t}-expanded-row-cell`;
  return {
    [`${t}-wrapper`]: {
      // ========================== Row ==========================
      [`${t}-tbody-virtual`]: {
        [`${t}-row`]: {
          display: "flex",
          boxSizing: "border-box",
          width: "100%"
        },
        [`${t}-cell`]: {
          borderBottom: s,
          transition: `background ${n}`
        },
        [`${t}-expanded-row`]: {
          [`${l}${l}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${te(r)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${t}-bordered`]: {
        [`${t}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: s,
            position: "absolute"
          },
          [`${t}-cell`]: {
            borderInlineEnd: s,
            [`&${t}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: a(r).mul(-1).equal(),
              borderInlineStart: s
            }
          }
        },
        // Empty placeholder
        [`&${t}-virtual`]: {
          [`${t}-placeholder ${t}-cell`]: {
            borderInlineEnd: s,
            borderBottom: s
          }
        }
      }
    }
  };
}, iie = (e) => {
  const {
    componentCls: t,
    fontWeightStrong: n,
    tablePaddingVertical: r,
    tablePaddingHorizontal: o,
    tableExpandColumnWidth: i,
    lineWidth: a,
    lineType: s,
    tableBorderColor: l,
    tableFontSize: u,
    tableBg: f,
    tableRadius: p,
    tableHeaderTextColor: h,
    motionDurationMid: y,
    tableHeaderBg: b,
    tableHeaderCellSplitColor: m,
    tableFooterTextColor: v,
    tableFooterBg: C,
    calc: x
  } = e, S = `${te(a)} ${s} ${l}`;
  return {
    [`${t}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%"
    }, Eh()), {
      [t]: Object.assign(Object.assign({}, Qn(e)), {
        fontSize: u,
        background: f,
        borderRadius: `${te(p)} ${te(p)} 0 0`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${te(p)} ${te(p)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${t}-cell,
          ${t}-thead > tr > th,
          ${t}-tbody > tr > th,
          ${t}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${te(r)} ${te(o)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${t}-title`]: {
        padding: `${te(r)} ${te(o)}`
      },
      // ============================ Header ============================
      [`${t}-thead`]: {
        "\n          > tr > th,\n          > tr > td\n        ": {
          position: "relative",
          color: h,
          fontWeight: n,
          textAlign: "start",
          background: b,
          borderBottom: S,
          transition: `background ${y} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${t}-selection-column):not(${t}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: m,
            transform: "translateY(-50%)",
            transition: `background-color ${y}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${t}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${y}, border-color ${y}`,
            borderBottom: S,
            // ========================= Nest Table ===========================
            [`
              > ${t}-wrapper:only-child,
              > ${t}-expanded-row-fixed > ${t}-wrapper:only-child
            `]: {
              [t]: {
                marginBlock: te(x(r).mul(-1).equal()),
                marginInline: `${te(x(i).sub(o).equal())}
                ${te(x(o).mul(-1).equal())}`,
                [`${t}-tbody > tr:last-child > td`]: {
                  borderBottom: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: h,
            fontWeight: n,
            textAlign: "start",
            background: b,
            borderBottom: S,
            transition: `background ${y} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${t}-footer`]: {
        padding: `${te(r)} ${te(o)}`,
        color: v,
        background: C
      }
    })
  };
}, aie = (e) => {
  const {
    colorFillAlter: t,
    colorBgContainer: n,
    colorTextHeading: r,
    colorFillSecondary: o,
    colorFillContent: i,
    controlItemBgActive: a,
    controlItemBgActiveHover: s,
    padding: l,
    paddingSM: u,
    paddingXS: f,
    colorBorderSecondary: p,
    borderRadiusLG: h,
    controlHeight: y,
    colorTextPlaceholder: b,
    fontSize: m,
    fontSizeSM: v,
    lineHeight: C,
    lineWidth: x,
    colorIcon: S,
    colorIconHover: E,
    opacityLoading: O,
    controlInteractiveSize: $
  } = e, _ = new sr(o).onBackground(n).toHexShortString(), R = new sr(i).onBackground(n).toHexShortString(), P = new sr(t).onBackground(n).toHexShortString(), I = new sr(S), j = new sr(E), F = $ / 2 - x, A = F * 2 + x * 3;
  return {
    headerBg: P,
    headerColor: r,
    headerSortActiveBg: _,
    headerSortHoverBg: R,
    bodySortBg: P,
    rowHoverBg: P,
    rowSelectedBg: a,
    rowSelectedHoverBg: s,
    rowExpandedBg: t,
    cellPaddingBlock: l,
    cellPaddingInline: l,
    cellPaddingBlockMD: u,
    cellPaddingInlineMD: f,
    cellPaddingBlockSM: f,
    cellPaddingInlineSM: f,
    borderColor: p,
    headerBorderRadius: h,
    footerBg: P,
    footerColor: r,
    cellFontSize: m,
    cellFontSizeMD: m,
    cellFontSizeSM: m,
    headerSplitColor: p,
    fixedHeaderSortActiveBg: _,
    headerFilterHoverBg: i,
    filterDropdownMenuBg: n,
    filterDropdownBg: n,
    expandIconBg: n,
    selectionColumnWidth: y,
    stickyScrollBarBg: b,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (m * C - x * 3) / 2 - Math.ceil((v * 1.4 - x * 3) / 2),
    headerIconColor: I.clone().setAlpha(I.getAlpha() * O).toRgbString(),
    headerIconHoverColor: j.clone().setAlpha(j.getAlpha() * O).toRgbString(),
    expandIconHalfInner: F,
    expandIconSize: A,
    expandIconScale: $ / A
  };
}, sie = Gn("Table", (e) => {
  const {
    colorTextHeading: t,
    colorSplit: n,
    colorBgContainer: r,
    controlInteractiveSize: o,
    headerBg: i,
    headerColor: a,
    headerSortActiveBg: s,
    headerSortHoverBg: l,
    bodySortBg: u,
    rowHoverBg: f,
    rowSelectedBg: p,
    rowSelectedHoverBg: h,
    rowExpandedBg: y,
    cellPaddingBlock: b,
    cellPaddingInline: m,
    cellPaddingBlockMD: v,
    cellPaddingInlineMD: C,
    cellPaddingBlockSM: x,
    cellPaddingInlineSM: S,
    borderColor: E,
    footerBg: O,
    footerColor: $,
    headerBorderRadius: _,
    cellFontSize: R,
    cellFontSizeMD: P,
    cellFontSizeSM: I,
    headerSplitColor: j,
    fixedHeaderSortActiveBg: F,
    headerFilterHoverBg: A,
    filterDropdownBg: M,
    expandIconBg: N,
    selectionColumnWidth: D,
    stickyScrollBarBg: T,
    calc: L
  } = e, z = 2, H = Sn(e, {
    tableFontSize: R,
    tableBg: r,
    tableRadius: _,
    tablePaddingVertical: b,
    tablePaddingHorizontal: m,
    tablePaddingVerticalMiddle: v,
    tablePaddingHorizontalMiddle: C,
    tablePaddingVerticalSmall: x,
    tablePaddingHorizontalSmall: S,
    tableBorderColor: E,
    tableHeaderTextColor: a,
    tableHeaderBg: i,
    tableFooterTextColor: $,
    tableFooterBg: O,
    tableHeaderCellSplitColor: j,
    tableHeaderSortBg: s,
    tableHeaderSortHoverBg: l,
    tableBodySortBg: u,
    tableFixedHeaderSortActiveBg: F,
    tableHeaderFilterActiveBg: A,
    tableFilterDropdownBg: M,
    tableRowHoverBg: f,
    tableSelectedRowBg: p,
    tableSelectedRowHoverBg: h,
    zIndexTableFixed: z,
    zIndexTableSticky: z + 1,
    tableFontSizeMiddle: P,
    tableFontSizeSmall: I,
    tableSelectionColumnWidth: D,
    tableExpandIconBg: N,
    tableExpandColumnWidth: L(o).add(L(e.padding).mul(2)).equal(),
    tableExpandedRowBg: y,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: T,
    tableScrollThumbBgHover: t,
    tableScrollBg: n
  });
  return [iie(H), Zoe(H), m$(H), nie(H), Yoe(H), Koe(H), Qoe(H), qoe(H), m$(H), Goe(H), eie(H), Xoe(H), rie(H), Uoe(H), tie(H), Joe(H), oie(H)];
}, aie, {
  unitless: {
    expandIconScale: !0
  }
}), lie = [], cie = (e, t) => {
  const {
    prefixCls: n,
    className: r,
    rootClassName: o,
    style: i,
    size: a,
    bordered: s,
    dropdownPrefixCls: l,
    dataSource: u,
    pagination: f,
    rowSelection: p,
    rowKey: h = "key",
    rowClassName: y,
    columns: b,
    children: m,
    childrenColumnName: v,
    onChange: C,
    getPopupContainer: x,
    loading: S,
    expandIcon: E,
    expandable: O,
    expandedRowRender: $,
    expandIconColumnIndex: _,
    indentSize: R,
    scroll: P,
    sortDirections: I,
    locale: j,
    showSorterTooltip: F = !0,
    virtual: A
  } = e, M = xn("Table");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && M(!(typeof h == "function" && h.length > 1), "usage", "`index` parameter of `rowKey` function is deprecated. There is no guarantee that it will work as expected.");
  const N = c.useMemo(() => b || xC(m), [b, m]), D = c.useMemo(() => N.some((q) => q.responsive), [N]), T = zg(D), L = c.useMemo(() => {
    const q = new Set(Object.keys(T).filter((Se) => T[Se]));
    return N.filter((Se) => !Se.responsive || Se.responsive.some((Re) => q.has(Re)));
  }, [N, T]), z = dr(e, ["className", "style", "columns"]), {
    locale: H = za,
    direction: V,
    table: Y,
    renderEmpty: Z,
    getPrefixCls: oe,
    getPopupContainer: ee
  } = c.useContext(Ft), ae = Co(a), le = Object.assign(Object.assign({}, H.Table), j), ue = u || lie, ie = oe("table", n), re = oe("dropdown", l), [, Q] = ro(), ce = Ar(ie), [ge, G, ne] = sie(ie, ce), fe = Object.assign({
    childrenColumnName: v,
    expandIconColumnIndex: _
  }, O), {
    childrenColumnName: ye = "children"
  } = fe, we = c.useMemo(() => ue.some((q) => q == null ? void 0 : q[ye]) ? "nest" : $ || O && O.expandedRowRender ? "row" : null, [ue]), he = {
    body: c.useRef()
  }, me = Ire(ie), Ce = c.useRef(null), Te = c.useRef(null);
  Nre(t, () => Object.assign(Object.assign({}, Te.current), {
    nativeElement: Ce.current
  }));
  const Ee = c.useMemo(() => typeof h == "function" ? h : (q) => q == null ? void 0 : q[h], [h]), [Ge] = Ioe(ue, ye, Ee), ke = {}, qe = function(q, Se) {
    let Re = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    var ut, $t, Ne;
    const Ie = Object.assign(Object.assign({}, ke), q);
    Re && ((ut = ke.resetPagination) === null || ut === void 0 || ut.call(ke), !(($t = Ie.pagination) === null || $t === void 0) && $t.current && (Ie.pagination.current = 1), f && f.onChange && f.onChange(1, (Ne = Ie.pagination) === null || Ne === void 0 ? void 0 : Ne.pageSize)), P && P.scrollToFirstRowOnChange !== !1 && he.body.current && iz(0, {
      getContainer: () => he.body.current
    }), C == null || C(Ie.pagination, Ie.filters, Ie.sorter, {
      currentDataSource: hy(my(ue, Ie.sorterStates, ye), Ie.filterStates, ye),
      action: Se
    });
  }, ze = (q, Se) => {
    qe({
      sorter: q,
      sorterStates: Se
    }, "sort", !1);
  }, [pt, Ke, et, Je] = Hoe({
    prefixCls: ie,
    mergedColumns: L,
    onSorterChange: ze,
    sortDirections: I || ["ascend", "descend"],
    tableLocale: le,
    showSorterTooltip: F
  }), Et = c.useMemo(() => my(ue, Ke, ye), [ue, Ke]);
  ke.sorter = Je(), ke.sorterStates = Ke;
  const Ye = (q, Se) => {
    qe({
      filters: q,
      filterStates: Se
    }, "filter", !0);
  }, [wt, dt, Ct] = Poe({
    prefixCls: ie,
    locale: le,
    dropdownPrefixCls: re,
    mergedColumns: L,
    onFilterChange: Ye,
    getPopupContainer: x || ee,
    rootClassName: se(o, ce)
  }), ot = hy(Et, dt, ye);
  ke.filters = Ct, ke.filterStates = dt;
  const jt = c.useMemo(() => {
    const q = {};
    return Object.keys(Ct).forEach((Se) => {
      Ct[Se] !== null && (q[Se] = Ct[Se]);
    }), Object.assign(Object.assign({}, et), {
      filters: q
    });
  }, [et, Ct]), [Rt] = zoe(jt), Le = (q, Se) => {
    qe({
      pagination: Object.assign(Object.assign({}, ke.pagination), {
        current: q,
        pageSize: Se
      })
    }, "paginate");
  }, [Ve, Ae] = Toe(ot.length, Le, f);
  ke.pagination = f === !1 ? {} : Doe(Ve, f), ke.resetPagination = Ae;
  const ft = c.useMemo(() => {
    if (f === !1 || !Ve.pageSize)
      return ot;
    const {
      current: q = 1,
      total: Se,
      pageSize: Re = wP
    } = Ve;
    return process.env.NODE_ENV !== "production" && M(q > 0, "usage", "`current` should be positive number."), ot.length < Se ? ot.length > Re ? (process.env.NODE_ENV !== "production" && M(!1, "usage", "`dataSource` length is less than `pagination.total` but large than `pagination.pageSize`. Please make sure your config correct data with async mode."), ot.slice((q - 1) * Re, q * Re)) : ot : ot.slice((q - 1) * Re, q * Re);
  }, [!!f, ot, Ve && Ve.current, Ve && Ve.pageSize, Ve && Ve.total]), [He, Fe] = Ore({
    prefixCls: ie,
    data: ot,
    pageData: ft,
    getRowKey: Ee,
    getRecordByKey: Ge,
    expandType: we,
    childrenColumnName: ye,
    locale: le,
    getPopupContainer: x || ee
  }, p), yt = (q, Se, Re) => {
    let ut;
    return typeof y == "function" ? ut = se(y(q, Se, Re)) : ut = se(y), se({
      [`${ie}-row-selected`]: Fe.has(Ee(q, Se))
    }, ut);
  };
  fe.__PARENT_RENDER_ICON__ = fe.expandIcon, fe.expandIcon = fe.expandIcon || E || Pre(le), we === "nest" && fe.expandIconColumnIndex === void 0 ? fe.expandIconColumnIndex = p ? 1 : 0 : fe.expandIconColumnIndex > 0 && p && (fe.expandIconColumnIndex -= 1), typeof fe.indentSize != "number" && (fe.indentSize = typeof R == "number" ? R : 15);
  const Qe = c.useCallback((q) => Rt(He(wt(pt(q)))), [pt, wt, He]);
  let tt, lt;
  if (f !== !1 && (Ve != null && Ve.total)) {
    let q;
    Ve.size ? q = Ve.size : q = ae === "small" || ae === "middle" ? "small" : void 0;
    const Se = ($t) => /* @__PURE__ */ c.createElement(b8, Object.assign({}, Ve, {
      className: se(`${ie}-pagination ${ie}-pagination-${$t}`, Ve.className),
      size: q
    })), Re = V === "rtl" ? "left" : "right", {
      position: ut
    } = Ve;
    if (ut !== null && Array.isArray(ut)) {
      const $t = ut.find((De) => De.includes("top")), Ne = ut.find((De) => De.includes("bottom")), Ie = ut.every((De) => `${De}` == "none");
      !$t && !Ne && !Ie && (lt = Se(Re)), $t && (tt = Se($t.toLowerCase().replace("top", ""))), Ne && (lt = Se(Ne.toLowerCase().replace("bottom", "")));
    } else
      lt = Se(Re);
  }
  let ht;
  typeof S == "boolean" ? ht = {
    spinning: S
  } : typeof S == "object" && (ht = Object.assign({
    spinning: !0
  }, S));
  const bt = se(ne, ce, `${ie}-wrapper`, Y == null ? void 0 : Y.className, {
    [`${ie}-wrapper-rtl`]: V === "rtl"
  }, r, o, G), ct = Object.assign(Object.assign({}, Y == null ? void 0 : Y.style), i), xt = j && j.emptyText || (Z == null ? void 0 : Z("Table")) || /* @__PURE__ */ c.createElement(kb, {
    componentName: "Table"
  }), vt = A ? Woe : Voe, _e = {}, Ze = c.useMemo(() => {
    const {
      fontSize: q,
      lineHeight: Se,
      padding: Re,
      paddingXS: ut,
      paddingSM: $t
    } = Q, Ne = Math.floor(q * Se);
    switch (ae) {
      case "large":
        return Re * 2 + Ne;
      case "small":
        return ut * 2 + Ne;
      default:
        return $t * 2 + Ne;
    }
  }, [Q, ae]);
  return A && (_e.listItemHeight = Ze), ge(/* @__PURE__ */ c.createElement("div", {
    ref: Ce,
    className: bt,
    style: ct
  }, /* @__PURE__ */ c.createElement(af, Object.assign({
    spinning: !1
  }, ht), tt, /* @__PURE__ */ c.createElement(vt, Object.assign({}, _e, z, {
    ref: Te,
    columns: L,
    direction: V,
    expandable: fe,
    prefixCls: ie,
    className: se({
      [`${ie}-middle`]: ae === "middle",
      [`${ie}-small`]: ae === "small",
      [`${ie}-bordered`]: s,
      [`${ie}-empty`]: ue.length === 0
    }, ne, ce, G),
    data: ft,
    rowKey: Ee,
    rowClassName: yt,
    emptyText: xt,
    // Internal
    internalHooks: sf,
    internalRefs: he,
    transformColumns: Qe,
    getContainerWidth: me
  })), lt)));
}, uie = /* @__PURE__ */ c.forwardRef(cie), die = (e, t) => {
  const n = c.useRef(0);
  return n.current += 1, /* @__PURE__ */ c.createElement(uie, Object.assign({}, e, {
    ref: t,
    _renderTimes: n.current
  }));
}, da = /* @__PURE__ */ c.forwardRef(die);
da.SELECTION_COLUMN = ea;
da.EXPAND_COLUMN = ta;
da.SELECTION_ALL = cy;
da.SELECTION_INVERT = uy;
da.SELECTION_NONE = dy;
da.Column = gre;
da.ColumnGroup = mre;
da.Summary = R8;
process.env.NODE_ENV !== "production" && (da.displayName = "Table");
const NP = da;
var fie = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" };
const pie = fie;
var PP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: pie
  }));
};
process.env.NODE_ENV !== "production" && (PP.displayName = "DeleteOutlined");
const hie = /* @__PURE__ */ c.forwardRef(PP);
var gie = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const mie = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
}, vie = /* @__PURE__ */ c.forwardRef((e, t) => {
  const n = (u) => {
    const {
      keyCode: f
    } = u;
    f === Pe.ENTER && u.preventDefault();
  }, r = (u) => {
    const {
      keyCode: f
    } = u, {
      onClick: p
    } = e;
    f === Pe.ENTER && p && p();
  }, {
    style: o,
    noStyle: i,
    disabled: a
  } = e, s = gie(e, ["style", "noStyle", "disabled"]);
  let l = {};
  return i || (l = Object.assign({}, mie)), a && (l.pointerEvents = "none"), l = Object.assign(Object.assign({}, l), o), /* @__PURE__ */ c.createElement("div", Object.assign({
    role: "button",
    tabIndex: 0,
    ref: t
  }, s, {
    onKeyDown: n,
    onKeyUp: r,
    style: l
  }));
}), v$ = vie, yie = function(e) {
  var t = c.useRef({
    valueLabels: /* @__PURE__ */ new Map()
  });
  return c.useMemo(function() {
    var n = t.current.valueLabels, r = /* @__PURE__ */ new Map(), o = e.map(function(i) {
      var a, s = i.value, l = (a = i.label) !== null && a !== void 0 ? a : n.get(s);
      return r.set(s, l), J(J({}, i), {}, {
        label: l
      });
    });
    return t.current.valueLabels = r, [o];
  }, [e]);
}, bie = function(e, t, n, r) {
  return c.useMemo(function() {
    var o = e.map(function(l) {
      var u = l.value;
      return u;
    }), i = t.map(function(l) {
      var u = l.value;
      return u;
    }), a = o.filter(function(l) {
      return !r[l];
    });
    if (n) {
      var s = ka(o, !0, r);
      o = s.checkedKeys, i = s.halfCheckedKeys;
    }
    return [
      // Checked keys should fill with missing keys which should de-duplicated
      Array.from(new Set([].concat(We(a), We(o)))),
      // Half checked keys
      i
    ];
  }, [e, t, n, r]);
};
function IP(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
function Cie(e) {
  var t = e || {}, n = t.label, r = t.value, o = t.children, i = r || "value";
  return {
    _title: n ? [n] : ["title", "label"],
    value: i,
    key: i,
    children: o || "children"
  };
}
function vy(e) {
  return !e || e.disabled || e.disableCheckbox || e.checkable === !1;
}
function xie(e, t) {
  var n = [];
  function r(o) {
    o.forEach(function(i) {
      var a = i[t.children];
      a && (n.push(i[t.value]), r(a));
    });
  }
  return r(e), n;
}
function yy(e) {
  return e == null;
}
const Sie = function(e, t) {
  return c.useMemo(function() {
    var n = Jg(e, {
      fieldNames: t,
      initWrapper: function(o) {
        return J(J({}, o), {}, {
          valueEntities: /* @__PURE__ */ new Map()
        });
      },
      processEntity: function(o, i) {
        var a = o.node[t.value];
        if (process.env.NODE_ENV !== "production") {
          var s = o.node.key;
          mt(!yy(a), "TreeNode `value` is invalidate: undefined"), mt(!i.valueEntities.has(a), "Same `value` exist in the tree: ".concat(a)), mt(!s || String(s) === String(a), "`key` or `value` with TreeNode must be the same or you can remove one of them. key: ".concat(s, ", value: ").concat(a, "."));
        }
        i.valueEntities.set(a, o);
      }
    });
    return n;
  }, [e, t]);
};
var OC = function() {
  return null;
}, wie = ["children", "value"];
function RP(e) {
  return Rr(e).map(function(t) {
    if (!/* @__PURE__ */ c.isValidElement(t) || !t.type)
      return null;
    var n = t, r = n.key, o = n.props, i = o.children, a = o.value, s = Yt(o, wie), l = J({
      key: r,
      value: a
    }, s), u = RP(i);
    return u.length && (l.children = u), l;
  }).filter(function(t) {
    return t;
  });
}
function by(e) {
  if (!e)
    return e;
  var t = J({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return mt(!1, "New `rc-tree-select` not support return node instance as argument anymore. Please consider to remove `props` access."), t;
    }
  }), t;
}
function Eie(e, t, n, r, o, i) {
  var a = null, s = null;
  function l() {
    function u(f) {
      var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0", h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      return f.map(function(y, b) {
        var m = "".concat(p, "-").concat(b), v = y[i.value], C = n.includes(v), x = u(y[i.children] || [], m, C), S = /* @__PURE__ */ c.createElement(OC, y, x.map(function(O) {
          return O.node;
        }));
        if (t === v && (a = S), C) {
          var E = {
            pos: m,
            node: S,
            children: x
          };
          return h || s.push(E), E;
        }
        return null;
      }).filter(function(y) {
        return y;
      });
    }
    s || (s = [], u(r), s.sort(function(f, p) {
      var h = f.node.props.value, y = p.node.props.value, b = n.indexOf(h), m = n.indexOf(y);
      return b - m;
    }));
  }
  Object.defineProperty(e, "triggerNode", {
    get: function() {
      return mt(!1, "`triggerNode` is deprecated. Please consider decoupling data with node."), l(), a;
    }
  }), Object.defineProperty(e, "allCheckedNodes", {
    get: function() {
      return mt(!1, "`allCheckedNodes` is deprecated. Please consider decoupling data with node."), l(), o ? s : s.map(function(f) {
        var p = f.node;
        return p;
      });
    }
  });
}
const $ie = function(e, t, n) {
  var r = n.treeNodeFilterProp, o = n.filterTreeNode, i = n.fieldNames, a = i.children;
  return c.useMemo(function() {
    if (!t || o === !1)
      return e;
    var s;
    if (typeof o == "function")
      s = o;
    else {
      var l = t.toUpperCase();
      s = function(p, h) {
        var y = h[r];
        return String(y).toUpperCase().includes(l);
      };
    }
    function u(f) {
      var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return f.reduce(function(h, y) {
        var b = y[a], m = p || s(t, by(y)), v = u(b || [], m);
        return (m || v.length) && h.push(J(J({}, y), {}, K({
          isLeaf: void 0
        }, a, v))), h;
      }, []);
    }
    return u(e);
  }, [e, t, a, r, o]);
};
function y$(e) {
  var t = c.useRef();
  t.current = e;
  var n = c.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function Oie(e, t) {
  var n = t.id, r = t.pId, o = t.rootPId, i = {}, a = [], s = e.map(function(l) {
    var u = J({}, l), f = u[n];
    return i[f] = u, u.key = u.key || f, u;
  });
  return s.forEach(function(l) {
    var u = l[r], f = i[u];
    f && (f.children = f.children || [], f.children.push(l)), (u === o || !f && o === null) && a.push(l);
  }), a;
}
function _ie(e, t, n) {
  return c.useMemo(function() {
    return e ? n ? Oie(e, J({
      id: "id",
      pId: "pId",
      rootPId: null
    }, n !== !0 ? n : {})) : e : RP(t);
  }, [t, n, e]);
}
var DP = /* @__PURE__ */ c.createContext(null), TP = /* @__PURE__ */ c.createContext(null), Nie = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, Pie = function(t, n) {
  var r = t6(), o = r.prefixCls, i = r.multiple, a = r.searchValue, s = r.toggleOpen, l = r.open, u = r.notFoundContent, f = c.useContext(TP), p = f.virtual, h = f.listHeight, y = f.listItemHeight, b = f.listItemScrollOffset, m = f.treeData, v = f.fieldNames, C = f.onSelect, x = f.dropdownMatchSelectWidth, S = f.treeExpandAction, E = f.treeTitleRender, O = c.useContext(DP), $ = O.checkable, _ = O.checkedKeys, R = O.halfCheckedKeys, P = O.treeExpandedKeys, I = O.treeDefaultExpandAll, j = O.treeDefaultExpandedKeys, F = O.onTreeExpand, A = O.treeIcon, M = O.showTreeIcon, N = O.switcherIcon, D = O.treeLine, T = O.treeNodeFilterProp, L = O.loadData, z = O.treeLoadedKeys, H = O.treeMotion, V = O.onTreeLoad, Y = O.keyEntities, Z = c.useRef(), oe = ua(function() {
    return m;
  }, [l, m], function(qe, ze) {
    return ze[0] && qe[1] !== ze[1];
  }), ee = c.useState(null), ae = de(ee, 2), le = ae[0], ue = ae[1], ie = Y[le], re = c.useMemo(function() {
    return $ ? {
      checked: _,
      halfChecked: R
    } : null;
  }, [$, _, R]);
  c.useEffect(function() {
    if (l && !i && _.length) {
      var qe;
      (qe = Z.current) === null || qe === void 0 || qe.scrollTo({
        key: _[0]
      }), ue(_[0]);
    }
  }, [l]);
  var Q = String(a).toLowerCase(), ce = function(ze) {
    return Q ? String(ze[T]).toLowerCase().includes(Q) : !1;
  }, ge = c.useState(j), G = de(ge, 2), ne = G[0], fe = G[1], ye = c.useState(null), we = de(ye, 2), he = we[0], me = we[1], Ce = c.useMemo(function() {
    return P ? We(P) : a ? he : ne;
  }, [ne, he, P, a]);
  c.useEffect(function() {
    a && me(xie(m, v));
  }, [a]);
  var Te = function(ze) {
    fe(ze), me(ze), F && F(ze);
  }, Ee = function(ze) {
    ze.preventDefault();
  }, Ge = function(ze, pt) {
    var Ke = pt.node;
    $ && vy(Ke) || (C(Ke.key, {
      selected: !_.includes(Ke.key)
    }), i || s(!1));
  };
  if (c.useImperativeHandle(n, function() {
    var qe;
    return {
      scrollTo: (qe = Z.current) === null || qe === void 0 ? void 0 : qe.scrollTo,
      onKeyDown: function(pt) {
        var Ke, et = pt.which;
        switch (et) {
          case Pe.UP:
          case Pe.DOWN:
          case Pe.LEFT:
          case Pe.RIGHT:
            (Ke = Z.current) === null || Ke === void 0 || Ke.onKeyDown(pt);
            break;
          case Pe.ENTER: {
            if (ie) {
              var Je = (ie == null ? void 0 : ie.node) || {}, Et = Je.selectable, Ye = Je.value;
              Et !== !1 && Ge(null, {
                node: {
                  key: le
                },
                selected: !_.includes(Ye)
              });
            }
            break;
          }
          case Pe.ESC:
            s(!1);
        }
      },
      onKeyUp: function() {
      }
    };
  }), oe.length === 0)
    return /* @__PURE__ */ c.createElement("div", {
      role: "listbox",
      className: "".concat(o, "-empty"),
      onMouseDown: Ee
    }, u);
  var ke = {
    fieldNames: v
  };
  return z && (ke.loadedKeys = z), Ce && (ke.expandedKeys = Ce), /* @__PURE__ */ c.createElement("div", {
    onMouseDown: Ee
  }, ie && l && /* @__PURE__ */ c.createElement("span", {
    style: Nie,
    "aria-live": "assertive"
  }, ie.node.value), /* @__PURE__ */ c.createElement(lm, Oe({
    ref: Z,
    focusable: !1,
    prefixCls: "".concat(o, "-tree"),
    treeData: oe,
    height: h,
    itemHeight: y,
    itemScrollOffset: b,
    virtual: p !== !1 && x !== !1,
    multiple: i,
    icon: A,
    showIcon: M,
    switcherIcon: N,
    showLine: D,
    loadData: a ? null : L,
    motion: H,
    activeKey: le,
    checkable: $,
    checkStrictly: !0,
    checkedKeys: re,
    selectedKeys: $ ? [] : _,
    defaultExpandAll: I,
    titleRender: E
  }, ke, {
    // Proxy event out
    onActiveChange: ue,
    onSelect: Ge,
    onCheck: Ge,
    onExpand: Te,
    onLoad: V,
    filterTreeNode: ce,
    expandAction: S
  })));
}, MP = /* @__PURE__ */ c.forwardRef(Pie);
process.env.NODE_ENV !== "production" && (MP.displayName = "OptionList");
var _C = "SHOW_ALL", NC = "SHOW_PARENT", cm = "SHOW_CHILD";
function b$(e, t, n, r) {
  var o = new Set(e);
  return t === cm ? e.filter(function(i) {
    var a = n[i];
    return !(a && a.children && a.children.some(function(s) {
      var l = s.node;
      return o.has(l[r.value]);
    }) && a.children.every(function(s) {
      var l = s.node;
      return vy(l) || o.has(l[r.value]);
    }));
  }) : t === NC ? e.filter(function(i) {
    var a = n[i], s = a ? a.parent : null;
    return !(s && !vy(s.node) && o.has(s.key));
  }) : e;
}
function Iie(e) {
  var t = e.searchPlaceholder, n = e.treeCheckStrictly, r = e.treeCheckable, o = e.labelInValue, i = e.value, a = e.multiple;
  mt(!t, "`searchPlaceholder` has been removed."), n && o === !1 && mt(!1, "`treeCheckStrictly` will force set `labelInValue` to `true`."), (o || n) && mt(IP(i).every(function(s) {
    return s && Vt(s) === "object" && "value" in s;
  }), "Invalid prop `value` supplied to `TreeSelect`. You should use { label: string, value: string | number } or [{ label: string, value: string | number }] instead."), n || a || r ? mt(!i || Array.isArray(i), "`value` should be an array when `TreeSelect` is checkable or multiple.") : mt(!Array.isArray(i), "`value` should not be array when `TreeSelect` is single mode.");
}
var Rie = ["id", "prefixCls", "value", "defaultValue", "onChange", "onSelect", "onDeselect", "searchValue", "inputValue", "onSearch", "autoClearSearchValue", "filterTreeNode", "treeNodeFilterProp", "showCheckedStrategy", "treeNodeLabelProp", "multiple", "treeCheckable", "treeCheckStrictly", "labelInValue", "fieldNames", "treeDataSimpleMode", "treeData", "children", "loadData", "treeLoadedKeys", "onTreeLoad", "treeDefaultExpandAll", "treeExpandedKeys", "treeDefaultExpandedKeys", "onTreeExpand", "treeExpandAction", "virtual", "listHeight", "listItemHeight", "listItemScrollOffset", "onDropdownVisibleChange", "dropdownMatchSelectWidth", "treeLine", "treeIcon", "showTreeIcon", "switcherIcon", "treeMotion", "treeTitleRender"];
function Die(e) {
  return !e || Vt(e) !== "object";
}
var LP = /* @__PURE__ */ c.forwardRef(function(e, t) {
  var n = e.id, r = e.prefixCls, o = r === void 0 ? "rc-tree-select" : r, i = e.value, a = e.defaultValue, s = e.onChange, l = e.onSelect, u = e.onDeselect, f = e.searchValue, p = e.inputValue, h = e.onSearch, y = e.autoClearSearchValue, b = y === void 0 ? !0 : y, m = e.filterTreeNode, v = e.treeNodeFilterProp, C = v === void 0 ? "value" : v, x = e.showCheckedStrategy, S = e.treeNodeLabelProp, E = e.multiple, O = e.treeCheckable, $ = e.treeCheckStrictly, _ = e.labelInValue, R = e.fieldNames, P = e.treeDataSimpleMode, I = e.treeData, j = e.children, F = e.loadData, A = e.treeLoadedKeys, M = e.onTreeLoad, N = e.treeDefaultExpandAll, D = e.treeExpandedKeys, T = e.treeDefaultExpandedKeys, L = e.onTreeExpand, z = e.treeExpandAction, H = e.virtual, V = e.listHeight, Y = V === void 0 ? 200 : V, Z = e.listItemHeight, oe = Z === void 0 ? 20 : Z, ee = e.listItemScrollOffset, ae = ee === void 0 ? 0 : ee, le = e.onDropdownVisibleChange, ue = e.dropdownMatchSelectWidth, ie = ue === void 0 ? !0 : ue, re = e.treeLine, Q = e.treeIcon, ce = e.showTreeIcon, ge = e.switcherIcon, G = e.treeMotion, ne = e.treeTitleRender, fe = Yt(e, Rie), ye = m6(n), we = O && !$, he = O || $, me = $ || _, Ce = he || E, Te = Fn(a, {
    value: i
  }), Ee = de(Te, 2), Ge = Ee[0], ke = Ee[1], qe = c.useMemo(function() {
    return O ? x || cm : _C;
  }, [x, O]);
  process.env.NODE_ENV !== "production" && Iie(e);
  var ze = c.useMemo(
    function() {
      return Cie(R);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [JSON.stringify(R)]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), pt = Fn("", {
    value: f !== void 0 ? f : p,
    postState: function(Ie) {
      return Ie || "";
    }
  }), Ke = de(pt, 2), et = Ke[0], Je = Ke[1], Et = function(Ie) {
    Je(Ie), h == null || h(Ie);
  }, Ye = _ie(I, j, P), wt = Sie(Ye, ze), dt = wt.keyEntities, Ct = wt.valueEntities, ot = c.useCallback(function(Ne) {
    var Ie = [], De = [];
    return Ne.forEach(function(Me) {
      Ct.has(Me) ? De.push(Me) : Ie.push(Me);
    }), {
      missingRawValues: Ie,
      existRawValues: De
    };
  }, [Ct]), jt = $ie(Ye, et, {
    fieldNames: ze,
    treeNodeFilterProp: C,
    filterTreeNode: m
  }), Rt = c.useCallback(function(Ne) {
    if (Ne) {
      if (S)
        return Ne[S];
      for (var Ie = ze._title, De = 0; De < Ie.length; De += 1) {
        var Me = Ne[Ie[De]];
        if (Me !== void 0)
          return Me;
      }
    }
  }, [ze, S]), Le = c.useCallback(function(Ne) {
    var Ie = IP(Ne);
    return Ie.map(function(De) {
      return Die(De) ? {
        value: De
      } : De;
    });
  }, []), Ve = c.useCallback(function(Ne) {
    var Ie = Le(Ne);
    return Ie.map(function(De) {
      var Me = De.label, Tt = De.value, Pt = De.halfChecked, Ut, Kt = Ct.get(Tt);
      if (Kt) {
        var $n;
        Me = ($n = Me) !== null && $n !== void 0 ? $n : Rt(Kt.node), Ut = Kt.node.disabled;
      } else if (Me === void 0) {
        var Jt = Le(Ge).find(function(On) {
          return On.value === Tt;
        });
        Me = Jt.label;
      }
      return {
        label: Me,
        value: Tt,
        halfChecked: Pt,
        disabled: Ut
      };
    });
  }, [Ct, Rt, Le, Ge]), Ae = c.useMemo(function() {
    return Le(Ge);
  }, [Le, Ge]), ft = c.useMemo(function() {
    var Ne = [], Ie = [];
    return Ae.forEach(function(De) {
      De.halfChecked ? Ie.push(De) : Ne.push(De);
    }), [Ne, Ie];
  }, [Ae]), He = de(ft, 2), Fe = He[0], yt = He[1], Qe = c.useMemo(function() {
    return Fe.map(function(Ne) {
      return Ne.value;
    });
  }, [Fe]), tt = bie(Fe, yt, we, dt), lt = de(tt, 2), ht = lt[0], bt = lt[1], ct = c.useMemo(function() {
    var Ne = b$(ht, qe, dt, ze), Ie = Ne.map(function(Pt) {
      var Ut, Kt;
      return (Ut = (Kt = dt[Pt]) === null || Kt === void 0 || (Kt = Kt.node) === null || Kt === void 0 ? void 0 : Kt[ze.value]) !== null && Ut !== void 0 ? Ut : Pt;
    }), De = Ie.map(function(Pt) {
      var Ut = Fe.find(function($n) {
        return $n.value === Pt;
      }), Kt;
      return _ && Ut.label !== void 0 ? Kt = Ut.label : !_ && ne && (Kt = ne(Ut)), {
        value: Pt,
        label: Kt
      };
    }), Me = Ve(De), Tt = Me[0];
    return !Ce && Tt && yy(Tt.value) && yy(Tt.label) ? [] : Me.map(function(Pt) {
      var Ut;
      return J(J({}, Pt), {}, {
        label: (Ut = Pt.label) !== null && Ut !== void 0 ? Ut : Pt.value
      });
    });
  }, [ze, Ce, ht, Fe, Ve, qe, dt]), xt = yie(ct), vt = de(xt, 1), _e = vt[0], Ze = y$(function(Ne, Ie, De) {
    var Me = Ve(Ne);
    if (ke(Me), b && Je(""), s) {
      var Tt = Ne;
      if (we) {
        var Pt = b$(Ne, qe, dt, ze);
        Tt = Pt.map(function(St) {
          var Lt = Ct.get(St);
          return Lt ? Lt.node[ze.value] : St;
        });
      }
      var Ut = Ie || {
        triggerValue: void 0,
        selected: void 0
      }, Kt = Ut.triggerValue, $n = Ut.selected, Jt = Tt;
      if ($) {
        var On = yt.filter(function(St) {
          return !Tt.includes(St.value);
        });
        Jt = [].concat(We(Jt), We(On));
      }
      var Jn = Ve(Jt), er = {
        // [Legacy] Always return as array contains label & value
        preValue: Fe,
        triggerValue: Kt
      }, Xt = !0;
      ($ || De === "selection" && !$n) && (Xt = !1), Eie(er, Kt, Ne, Ye, Xt, ze), he ? er.checked = $n : er.selected = $n;
      var It = me ? Jn : Jn.map(function(St) {
        return St.value;
      });
      s(Ce ? It : It[0], me ? null : Jn.map(function(St) {
        return St.label;
      }), er);
    }
  }), q = c.useCallback(function(Ne, Ie) {
    var De, Me = Ie.selected, Tt = Ie.source, Pt = dt[Ne], Ut = Pt == null ? void 0 : Pt.node, Kt = (De = Ut == null ? void 0 : Ut[ze.value]) !== null && De !== void 0 ? De : Ne;
    if (!Ce)
      Ze([Kt], {
        selected: !0,
        triggerValue: Kt
      }, "option");
    else {
      var $n = Me ? [].concat(We(Qe), [Kt]) : ht.filter(function(Lt) {
        return Lt !== Kt;
      });
      if (we) {
        var Jt = ot($n), On = Jt.missingRawValues, Jn = Jt.existRawValues, er = Jn.map(function(Lt) {
          return Ct.get(Lt).key;
        }), Xt;
        if (Me) {
          var It = ka(er, !0, dt);
          Xt = It.checkedKeys;
        } else {
          var St = ka(er, {
            checked: !1,
            halfCheckedKeys: bt
          }, dt);
          Xt = St.checkedKeys;
        }
        $n = [].concat(We(On), We(Xt.map(function(Lt) {
          return dt[Lt].node[ze.value];
        })));
      }
      Ze($n, {
        selected: Me,
        triggerValue: Kt
      }, Tt || "option");
    }
    Me || !Ce ? l == null || l(Kt, by(Ut)) : u == null || u(Kt, by(Ut));
  }, [ot, Ct, dt, ze, Ce, Qe, Ze, we, l, u, ht, bt]), Se = c.useCallback(function(Ne) {
    if (le) {
      var Ie = {};
      Object.defineProperty(Ie, "documentClickClose", {
        get: function() {
          return mt(!1, "Second param of `onDropdownVisibleChange` has been removed."), !1;
        }
      }), le(Ne, Ie);
    }
  }, [le]), Re = y$(function(Ne, Ie) {
    var De = Ne.map(function(Me) {
      return Me.value;
    });
    if (Ie.type === "clear") {
      Ze(De, {}, "selection");
      return;
    }
    Ie.values.length && q(Ie.values[0].value, {
      selected: !1,
      source: "selection"
    });
  }), ut = c.useMemo(function() {
    return {
      virtual: H,
      dropdownMatchSelectWidth: ie,
      listHeight: Y,
      listItemHeight: oe,
      listItemScrollOffset: ae,
      treeData: jt,
      fieldNames: ze,
      onSelect: q,
      treeExpandAction: z,
      treeTitleRender: ne
    };
  }, [H, ie, Y, oe, ae, jt, ze, q, z, ne]), $t = c.useMemo(function() {
    return {
      checkable: he,
      loadData: F,
      treeLoadedKeys: A,
      onTreeLoad: M,
      checkedKeys: ht,
      halfCheckedKeys: bt,
      treeDefaultExpandAll: N,
      treeExpandedKeys: D,
      treeDefaultExpandedKeys: T,
      onTreeExpand: L,
      treeIcon: Q,
      treeMotion: G,
      showTreeIcon: ce,
      switcherIcon: ge,
      treeLine: re,
      treeNodeFilterProp: C,
      keyEntities: dt
    };
  }, [he, F, A, M, ht, bt, N, D, T, L, Q, G, ce, ge, re, C, dt]);
  return /* @__PURE__ */ c.createElement(TP.Provider, {
    value: ut
  }, /* @__PURE__ */ c.createElement(DP.Provider, {
    value: $t
  }, /* @__PURE__ */ c.createElement(Tb, Oe({
    ref: t
  }, fe, {
    // >>> MISC
    id: ye,
    prefixCls: o,
    mode: Ce ? "multiple" : void 0,
    displayValues: _e,
    onDisplayValuesChange: Re,
    searchValue: et,
    onSearch: Et,
    OptionList: MP,
    emptyOptions: !Ye.length,
    onDropdownVisibleChange: Se,
    dropdownMatchSelectWidth: ie
  }))));
});
process.env.NODE_ENV !== "production" && (LP.displayName = "TreeSelect");
var cf = LP;
cf.TreeNode = OC;
cf.SHOW_ALL = _C;
cf.SHOW_PARENT = NC;
cf.SHOW_CHILD = cm;
const Tie = (e) => {
  const {
    componentCls: t,
    treePrefixCls: n,
    colorBgElevated: r
  } = e, o = `.${n}`;
  return [
    // ======================================================
    // ==                     Dropdown                     ==
    // ======================================================
    {
      [`${t}-dropdown`]: [
        {
          padding: `${te(e.paddingXS)} ${te(e.calc(e.paddingXS).div(2).equal())}`
        },
        // ====================== Tree ======================
        cP(n, Sn(e, {
          colorBgContainer: r
        })),
        {
          [o]: {
            borderRadius: 0,
            [`${o}-list-holder-inner`]: {
              alignItems: "stretch",
              [`${o}-treenode`]: {
                [`${o}-node-content-wrapper`]: {
                  flex: "auto"
                }
              }
            }
          }
        },
        // ==================== Checkbox ====================
        oC(`${n}-checkbox`, e),
        // ====================== RTL =======================
        {
          "&-rtl": {
            direction: "rtl",
            [`${o}-switcher${o}-switcher_close`]: {
              [`${o}-switcher-icon svg`]: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      ]
    }
  ];
};
function Mie(e, t, n) {
  return Gn("TreeSelect", (r) => {
    const o = Sn(r, {
      treePrefixCls: t
    });
    return [Tie(o)];
  }, uP)(e, n);
}
var Lie = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Aie = (e, t) => {
  var n, {
    prefixCls: r,
    size: o,
    disabled: i,
    bordered: a = !0,
    className: s,
    rootClassName: l,
    treeCheckable: u,
    multiple: f,
    listHeight: p = 256,
    listItemHeight: h = 26,
    placement: y,
    notFoundContent: b,
    switcherIcon: m,
    treeLine: v,
    getPopupContainer: C,
    popupClassName: x,
    dropdownClassName: S,
    treeIcon: E = !1,
    transitionName: O,
    choiceTransitionName: $ = "",
    status: _,
    treeExpandAction: R,
    builtinPlacements: P,
    dropdownMatchSelectWidth: I,
    popupMatchSelectWidth: j,
    allowClear: F,
    variant: A,
    dropdownStyle: M,
    tagRender: N
  } = e, D = Lie(e, ["prefixCls", "size", "disabled", "bordered", "className", "rootClassName", "treeCheckable", "multiple", "listHeight", "listItemHeight", "placement", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "popupClassName", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName", "status", "treeExpandAction", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "allowClear", "variant", "dropdownStyle", "tagRender"]);
  const {
    getPopupContainer: T,
    getPrefixCls: L,
    renderEmpty: z,
    direction: H,
    virtual: V,
    popupMatchSelectWidth: Y,
    popupOverflow: Z
  } = c.useContext(Ft);
  if (process.env.NODE_ENV !== "production") {
    const Ve = xn("TreeSelect");
    process.env.NODE_ENV !== "production" && Ve(f !== !1 || !u, "usage", "`multiple` will always be `true` when `treeCheckable` is true"), Ve.deprecated(!S, "dropdownClassName", "popupClassName"), Ve.deprecated(I === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && Ve(!("showArrow" in D), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), Ve.deprecated(!("bordered" in D), "bordered", "variant");
  }
  const oe = L(), ee = L("select", r), ae = L("select-tree", r), le = L("tree-select", r), {
    compactSize: ue,
    compactItemClassnames: ie
  } = Ms(ee, H), re = Ar(ee), Q = Ar(le), [ce, ge, G] = $6(ee, re), [ne] = Mie(le, ae, Q), [fe, ye] = tu(A, a), we = se(x || S, `${le}-dropdown`, {
    [`${le}-dropdown-rtl`]: H === "rtl"
  }, l, G, re, Q, ge), he = !!(u || f), me = I6(D.suffixIcon, D.showArrow), Ce = (n = j != null ? j : I) !== null && n !== void 0 ? n : Y, {
    status: Te,
    hasFeedback: Ee,
    isFormItemInput: Ge,
    feedbackIcon: ke
  } = c.useContext(uo), qe = eu(Te, _), {
    suffixIcon: ze,
    removeIcon: pt,
    clearIcon: Ke
  } = P6(Object.assign(Object.assign({}, D), {
    multiple: he,
    showSuffixIcon: me,
    hasFeedback: Ee,
    feedbackIcon: ke,
    prefixCls: ee,
    componentName: "TreeSelect"
  })), et = F === !0 ? {
    clearIcon: Ke
  } : F;
  let Je;
  b !== void 0 ? Je = b : Je = (z == null ? void 0 : z("Select")) || /* @__PURE__ */ c.createElement(kb, {
    componentName: "Select"
  });
  const Et = dr(D, ["suffixIcon", "removeIcon", "clearIcon", "itemIcon", "switcherIcon"]), Ye = c.useMemo(() => y !== void 0 ? y : H === "rtl" ? "bottomRight" : "bottomLeft", [y, H]), wt = Co((Ve) => {
    var Ae;
    return (Ae = o != null ? o : ue) !== null && Ae !== void 0 ? Ae : Ve;
  }), dt = c.useContext(Ki), Ct = i != null ? i : dt, ot = se(!r && le, {
    [`${ee}-lg`]: wt === "large",
    [`${ee}-sm`]: wt === "small",
    [`${ee}-rtl`]: H === "rtl",
    [`${ee}-${fe}`]: ye,
    [`${ee}-in-form-item`]: Ge
  }, bl(ee, qe, Ee), ie, s, l, G, re, Q, ge), jt = (Ve) => /* @__PURE__ */ c.createElement(hP, {
    prefixCls: ae,
    switcherIcon: m,
    treeNodeProps: Ve,
    showLine: v
  }), [Rt] = Ts("SelectLike", M == null ? void 0 : M.zIndex), Le = /* @__PURE__ */ c.createElement(cf, Object.assign({
    virtual: V,
    disabled: Ct
  }, Et, {
    dropdownMatchSelectWidth: Ce,
    builtinPlacements: S6(P, Z),
    ref: t,
    prefixCls: ee,
    className: ot,
    listHeight: p,
    listItemHeight: h,
    treeCheckable: u && /* @__PURE__ */ c.createElement("span", {
      className: `${ee}-tree-checkbox-inner`
    }),
    treeLine: !!v,
    suffixIcon: ze,
    multiple: he,
    placement: Ye,
    removeIcon: pt,
    allowClear: et,
    switcherIcon: jt,
    showTreeIcon: E,
    notFoundContent: Je,
    getPopupContainer: C || T,
    treeMotion: null,
    dropdownClassName: we,
    dropdownStyle: Object.assign(Object.assign({}, M), {
      zIndex: Rt
    }),
    choiceTransitionName: ml(oe, "", $),
    transitionName: ml(oe, "slide-up", O),
    treeExpandAction: R,
    tagRender: he ? N : void 0
  }));
  return ce(ne(Le));
}, jie = /* @__PURE__ */ c.forwardRef(Aie), js = jie, kie = Zd(js);
js.TreeNode = OC;
js.SHOW_ALL = _C;
js.SHOW_PARENT = NC;
js.SHOW_CHILD = cm;
js._InternalPanelDoNotUseOrYouWillBeFired = kie;
process.env.NODE_ENV !== "production" && (js.displayName = "TreeSelect");
const AP = js;
var Fie = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
const Bie = Fie;
var jP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Bie
  }));
};
process.env.NODE_ENV !== "production" && (jP.displayName = "CopyOutlined");
const kP = /* @__PURE__ */ c.forwardRef(jP);
var Hie = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
const zie = Hie;
var FP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: zie
  }));
};
process.env.NODE_ENV !== "production" && (FP.displayName = "EditOutlined");
const Vie = /* @__PURE__ */ c.forwardRef(FP);
var Wie = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
    n.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(o) {
      e.addRange(o);
    }), t && t.focus();
  };
}, Kie = Wie, C$ = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Uie = "Copy to clipboard: #{key}, Enter";
function Gie(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function qie(e, t) {
  var n, r, o, i, a, s, l = !1;
  t || (t = {}), n = t.debug || !1;
  try {
    o = Kie(), i = document.createRange(), a = document.getSelection(), s = document.createElement("span"), s.textContent = e, s.ariaHidden = "true", s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function(f) {
      if (f.stopPropagation(), t.format)
        if (f.preventDefault(), typeof f.clipboardData == "undefined") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var p = C$[t.format] || C$.default;
          window.clipboardData.setData(p, e);
        } else
          f.clipboardData.clearData(), f.clipboardData.setData(t.format, e);
      t.onCopy && (f.preventDefault(), t.onCopy(f.clipboardData));
    }), document.body.appendChild(s), i.selectNodeContents(s), a.addRange(i);
    var u = document.execCommand("copy");
    if (!u)
      throw new Error("copy command was unsuccessful");
    l = !0;
  } catch (f) {
    n && console.error("unable to copy using execCommand: ", f), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), l = !0;
    } catch (p) {
      n && console.error("unable to copy using clipboardData: ", p), n && console.error("falling back to prompt"), r = Gie("message" in t ? t.message : Uie), window.prompt(r, e);
    }
  } finally {
    a && (typeof a.removeRange == "function" ? a.removeRange(i) : a.removeAllRanges()), s && document.body.removeChild(s), o();
  }
  return l;
}
var Yie = qie;
const Xie = /* @__PURE__ */ Vi(Yie);
var Zie = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
const Qie = Zie;
var BP = function(t, n) {
  return /* @__PURE__ */ c.createElement(Tn, Oe({}, t, {
    ref: n,
    icon: Qie
  }));
};
process.env.NODE_ENV !== "production" && (BP.displayName = "EnterOutlined");
const Jie = /* @__PURE__ */ c.forwardRef(BP), eae = (e, t, n, r) => {
  const {
    titleMarginBottom: o,
    fontWeightStrong: i
  } = r;
  return {
    marginBottom: o,
    color: n,
    fontWeight: i,
    fontSize: e,
    lineHeight: t
  };
}, tae = (e) => {
  const t = [1, 2, 3, 4, 5], n = {};
  return t.forEach((r) => {
    n[`
      h${r}&,
      div&-h${r},
      div&-h${r} > textarea,
      h${r}
    `] = eae(e[`fontSizeHeading${r}`], e[`lineHeightHeading${r}`], e.colorTextHeading, e);
  }), n;
}, nae = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    "a&, a": Object.assign(Object.assign({}, pb(e)), {
      textDecoration: e.linkDecoration,
      "&:active, &:hover": {
        textDecoration: e.linkHoverDecoration
      },
      [`&[disabled], &${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: e.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, rae = (e) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: e.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: dB[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: e.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), oae = (e) => {
  const {
    componentCls: t,
    paddingSM: n
  } = e, r = n;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: e.calc(e.paddingSM).mul(-1).equal(),
        marginTop: e.calc(r).mul(-1).equal(),
        marginBottom: `calc(1em - ${te(r)})`
      },
      [`${t}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: e.calc(e.marginXS).add(2).equal(),
        insetBlockEnd: e.marginXS,
        color: e.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: e.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, iae = (e) => ({
  [`${e.componentCls}-copy-success`]: {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: e.colorSuccess
    }
  },
  [`${e.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
}), aae = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-single-line": {
    whiteSpace: "nowrap"
  },
  "&-ellipsis-single-line": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), sae = (e) => {
  const {
    componentCls: t,
    titleMarginTop: n
  } = e;
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: e.colorText,
      wordBreak: "break-word",
      lineHeight: e.lineHeight,
      [`&${t}-secondary`]: {
        color: e.colorTextDescription
      },
      [`&${t}-success`]: {
        color: e.colorSuccess
      },
      [`&${t}-warning`]: {
        color: e.colorWarning
      },
      [`&${t}-danger`]: {
        color: e.colorError,
        "a&:active, a&:focus": {
          color: e.colorErrorActive
        },
        "a&:hover": {
          color: e.colorErrorHover
        }
      },
      [`&${t}-disabled`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, tae(e)), {
      [`
      & + h1${t},
      & + h2${t},
      & + h3${t},
      & + h4${t},
      & + h5${t}
      `]: {
        marginTop: n
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: n
        }
      }
    }), rae(e)), nae(e)), {
      // Operation
      [`
        ${t}-expand,
        ${t}-edit,
        ${t}-copy
      `]: Object.assign(Object.assign({}, pb(e)), {
        marginInlineStart: e.marginXXS
      })
    }), oae(e)), iae(e)), aae()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, lae = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), HP = Gn("Typography", (e) => [sae(e)], lae), cae = (e) => {
  const {
    prefixCls: t,
    "aria-label": n,
    className: r,
    style: o,
    direction: i,
    maxLength: a,
    autoSize: s = !0,
    value: l,
    onSave: u,
    onCancel: f,
    onEnd: p,
    component: h,
    enterIcon: y = /* @__PURE__ */ c.createElement(Jie, null)
  } = e, b = c.useRef(null), m = c.useRef(!1), v = c.useRef(), [C, x] = c.useState(l);
  c.useEffect(() => {
    x(l);
  }, [l]), c.useEffect(() => {
    if (b.current && b.current.resizableTextArea) {
      const {
        textArea: N
      } = b.current.resizableTextArea;
      N.focus();
      const {
        length: D
      } = N.value;
      N.setSelectionRange(D, D);
    }
  }, []);
  const S = (N) => {
    let {
      target: D
    } = N;
    x(D.value.replace(/[\n\r]/g, ""));
  }, E = () => {
    m.current = !0;
  }, O = () => {
    m.current = !1;
  }, $ = (N) => {
    let {
      keyCode: D
    } = N;
    m.current || (v.current = D);
  }, _ = () => {
    u(C.trim());
  }, R = (N) => {
    let {
      keyCode: D,
      ctrlKey: T,
      altKey: L,
      metaKey: z,
      shiftKey: H
    } = N;
    v.current === D && !m.current && !T && !L && !z && !H && (D === Pe.ENTER ? (_(), p == null || p()) : D === Pe.ESC && f());
  }, P = () => {
    _();
  }, I = h ? `${t}-${h}` : "", [j, F, A] = HP(t), M = se(t, `${t}-edit-content`, {
    [`${t}-rtl`]: i === "rtl"
  }, r, I, F, A);
  return j(/* @__PURE__ */ c.createElement("div", {
    className: M,
    style: o
  }, /* @__PURE__ */ c.createElement(wN, {
    ref: b,
    maxLength: a,
    value: C,
    onChange: S,
    onKeyDown: $,
    onKeyUp: R,
    onCompositionStart: E,
    onCompositionEnd: O,
    onBlur: P,
    "aria-label": n,
    rows: 1,
    autoSize: s
  }), y !== null ? Yr(y, {
    className: `${t}-edit-content-confirm`
  }) : null));
}, uae = cae;
function h0(e, t) {
  return c.useMemo(() => {
    const n = !!e;
    return [n, Object.assign(Object.assign({}, t), n && typeof e == "object" ? e : null)];
  }, [e]);
}
const dae = (e, t) => {
  const n = c.useRef(!1);
  c.useEffect(() => {
    n.current ? e() : n.current = !0;
  }, t);
};
var fae = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const PC = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    prefixCls: n,
    component: r = "article",
    className: o,
    rootClassName: i,
    setContentRef: a,
    children: s,
    direction: l,
    style: u
  } = e, f = fae(e, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: p,
    direction: h,
    typography: y
  } = c.useContext(Ft), b = l != null ? l : h;
  let m = t;
  a && (m = Do(t, a)), process.env.NODE_ENV !== "production" && xn("Typography").deprecated(!a, "setContentRef", "ref");
  const v = p("typography", n), [C, x, S] = HP(v), E = se(v, y == null ? void 0 : y.className, {
    [`${v}-rtl`]: b === "rtl"
  }, o, i, x, S), O = Object.assign(Object.assign({}, y == null ? void 0 : y.style), u);
  return C(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ c.createElement(r, Object.assign({
      className: E,
      style: O,
      ref: m
    }, f), s)
  );
});
process.env.NODE_ENV !== "production" && (PC.displayName = "Typography");
function zP(e) {
  const t = typeof e;
  return t === "string" || t === "number";
}
function pae(e) {
  let t = 0;
  return e.forEach((n) => {
    zP(n) ? t += String(n).length : t += 1;
  }), t;
}
function g0(e, t) {
  let n = 0;
  const r = [];
  for (let o = 0; o < e.length; o += 1) {
    if (n === t)
      return r;
    const i = e[o], s = zP(i) ? String(i).length : 1, l = n + s;
    if (l > t) {
      const u = t - n;
      return r.push(String(i).slice(0, u)), r;
    }
    r.push(i), n = l;
  }
  return e;
}
const hae = 0, Dp = 1, x$ = 2, m0 = 3, v0 = 4, VP = (e) => {
  let {
    enabledMeasure: t,
    children: n,
    text: r,
    width: o,
    fontSize: i,
    rows: a,
    onEllipsis: s
  } = e;
  const [[l, u, f], p] = c.useState([0, 0, 0]), [h, y] = c.useState(0), [b, m] = c.useState(hae), [v, C] = c.useState(0), x = c.useRef(null), S = c.useRef(null), E = c.useMemo(() => Rr(r), [r]), O = c.useMemo(() => pae(E), [E]), $ = c.useMemo(() => !t || b !== m0 ? h && b !== v0 && t ? n(g0(E, h), h < O) : n(E, !1) : n(g0(E, u), u < O), [t, b, n, E, u, O]);
  Nn(() => {
    t && o && i && O && (m(Dp), p([0, Math.ceil(O / 2), O]));
  }, [t, o, i, r, O, a]), Nn(() => {
    var I;
    b === Dp && C(((I = x.current) === null || I === void 0 ? void 0 : I.offsetHeight) || 0);
  }, [b]), Nn(() => {
    var I, j;
    if (v) {
      if (b === Dp) {
        const F = ((I = S.current) === null || I === void 0 ? void 0 : I.offsetHeight) || 0, A = a * v;
        F <= A ? (m(v0), s(!1)) : m(x$);
      } else if (b === x$)
        if (l !== f) {
          const F = ((j = S.current) === null || j === void 0 ? void 0 : j.offsetHeight) || 0, A = a * v;
          let M = l, N = f;
          l === f - 1 ? N = l : F <= A ? M = u : N = u;
          const D = Math.ceil((M + N) / 2);
          p([M, D, N]);
        } else
          m(m0), y(u), s(!0);
    }
  }, [b, l, f, a, v]);
  const _ = {
    width: o,
    whiteSpace: "normal",
    margin: 0,
    padding: 0
  }, R = (I, j, F) => /* @__PURE__ */ c.createElement("span", {
    "aria-hidden": !0,
    ref: j,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      zIndex: -9999,
      visibility: "hidden",
      pointerEvents: "none",
      fontSize: Math.ceil(i / 2) * 2
    }, F)
  }, I), P = (I, j) => {
    const F = g0(E, I);
    return R(n(F, !0), j, _);
  };
  return /* @__PURE__ */ c.createElement(c.Fragment, null, $, t && b !== m0 && b !== v0 && /* @__PURE__ */ c.createElement(c.Fragment, null, R("lg", x, {
    wordBreak: "keep-all",
    whiteSpace: "nowrap"
  }), b === Dp ? R(n(E, !1), S, _) : P(u, S)));
};
process.env.NODE_ENV !== "production" && (VP.displayName = "Ellipsis");
const gae = VP, WP = (e) => {
  let {
    enabledEllipsis: t,
    isEllipsis: n,
    children: r,
    tooltipProps: o
  } = e;
  return !(o != null && o.title) || !t ? r : /* @__PURE__ */ c.createElement(Bo, Object.assign({
    open: n ? void 0 : !1
  }, o), r);
};
process.env.NODE_ENV !== "production" && (WP.displayName = "EllipsisTooltip");
const mae = WP;
var vae = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function yae(e, t) {
  let {
    mark: n,
    code: r,
    underline: o,
    delete: i,
    strong: a,
    keyboard: s,
    italic: l
  } = e, u = t;
  function f(p, h) {
    h && (u = /* @__PURE__ */ c.createElement(p, {}, u));
  }
  return f("strong", a), f("u", o), f("del", i), f("code", r), f("mark", n), f("kbd", s), f("i", l), u;
}
function Tp(e, t, n) {
  return e === !0 || e === void 0 ? t : e || n && t;
}
function S$(e) {
  return e === !1 ? [!1, !1] : Array.isArray(e) ? e : [e];
}
const bae = "...", Cae = /* @__PURE__ */ c.forwardRef((e, t) => {
  var n, r, o;
  const {
    prefixCls: i,
    className: a,
    style: s,
    type: l,
    disabled: u,
    children: f,
    ellipsis: p,
    editable: h,
    copyable: y,
    component: b,
    title: m
  } = e, v = vae(e, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: C,
    direction: x
  } = c.useContext(Ft), [S] = _l("Text"), E = c.useRef(null), O = c.useRef(null), $ = C("typography", i), _ = dr(v, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [R, P] = h0(h), [I, j] = Fn(!1, {
    value: P.editing
  }), {
    triggerType: F = ["icon"]
  } = P, A = (Le) => {
    var Ve;
    Le && ((Ve = P.onStart) === null || Ve === void 0 || Ve.call(P)), j(Le);
  };
  dae(() => {
    var Le;
    I || (Le = O.current) === null || Le === void 0 || Le.focus();
  }, [I]);
  const M = (Le) => {
    Le == null || Le.preventDefault(), A(!0);
  }, N = (Le) => {
    var Ve;
    (Ve = P.onChange) === null || Ve === void 0 || Ve.call(P, Le), A(!1);
  }, D = () => {
    var Le;
    (Le = P.onCancel) === null || Le === void 0 || Le.call(P), A(!1);
  }, [T, L] = h0(y), [z, H] = c.useState(!1), V = c.useRef(null), Y = {};
  L.format && (Y.format = L.format);
  const Z = () => {
    V.current && clearTimeout(V.current);
  }, oe = (Le) => {
    var Ve;
    Le == null || Le.preventDefault(), Le == null || Le.stopPropagation(), Xie(L.text || String(f) || "", Y), H(!0), Z(), V.current = setTimeout(() => {
      H(!1);
    }, 3e3), (Ve = L.onCopy) === null || Ve === void 0 || Ve.call(L, Le);
  };
  c.useEffect(() => Z, []);
  const [ee, ae] = c.useState(!1), [le, ue] = c.useState(!1), [ie, re] = c.useState(!1), [Q, ce] = c.useState(!1), [ge, G] = c.useState(!1), [ne, fe] = c.useState(!0), [ye, we] = h0(p, {
    expandable: !1
  }), he = ye && !ie, {
    rows: me = 1
  } = we, Ce = c.useMemo(() => (
    // Disable ellipsis
    !he || // Provide suffix
    we.suffix !== void 0 || we.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    we.expandable || R || T
  ), [he, we, R, T]);
  Nn(() => {
    ye && !Ce && (ae(_1("webkitLineClamp")), ue(_1("textOverflow")));
  }, [Ce, ye]);
  const Te = c.useMemo(() => Ce ? !1 : me === 1 ? le : ee, [Ce, le, ee]), Ee = he && (Te ? ge : Q), Ge = he && me === 1 && Te, ke = he && me > 1 && Te, qe = (Le) => {
    var Ve;
    re(!0), (Ve = we.onExpand) === null || Ve === void 0 || Ve.call(we, Le);
  }, [ze, pt] = c.useState(0), [Ke, et] = c.useState(0), Je = (Le, Ve) => {
    let {
      offsetWidth: Ae
    } = Le;
    var ft;
    pt(Ae), et(parseInt((ft = window.getComputedStyle) === null || ft === void 0 ? void 0 : ft.call(window, Ve).fontSize, 10) || 0);
  }, Et = (Le) => {
    var Ve;
    ce(Le), Q !== Le && ((Ve = we.onEllipsis) === null || Ve === void 0 || Ve.call(we, Le));
  };
  c.useEffect(() => {
    const Le = E.current;
    if (ye && Te && Le) {
      const Ve = ke ? Le.offsetHeight < Le.scrollHeight : Le.offsetWidth < Le.scrollWidth;
      ge !== Ve && G(Ve);
    }
  }, [ye, Te, f, ke, ne, ze]), c.useEffect(() => {
    const Le = E.current;
    if (typeof IntersectionObserver == "undefined" || !Le || !Te || !he)
      return;
    const Ve = new IntersectionObserver(() => {
      fe(!!Le.offsetParent);
    });
    return Ve.observe(Le), () => {
      Ve.disconnect();
    };
  }, [Te, he]);
  let Ye = {};
  we.tooltip === !0 ? Ye = {
    title: (n = P.text) !== null && n !== void 0 ? n : f
  } : /* @__PURE__ */ c.isValidElement(we.tooltip) ? Ye = {
    title: we.tooltip
  } : typeof we.tooltip == "object" ? Ye = Object.assign({
    title: (r = P.text) !== null && r !== void 0 ? r : f
  }, we.tooltip) : Ye = {
    title: we.tooltip
  };
  const wt = c.useMemo(() => {
    const Le = (Ve) => ["string", "number"].includes(typeof Ve);
    if (!(!ye || Te)) {
      if (Le(P.text))
        return P.text;
      if (Le(f))
        return f;
      if (Le(m))
        return m;
      if (Le(Ye.title))
        return Ye.title;
    }
  }, [ye, Te, m, Ye.title, Ee]);
  if (I)
    return /* @__PURE__ */ c.createElement(uae, {
      value: (o = P.text) !== null && o !== void 0 ? o : typeof f == "string" ? f : "",
      onSave: N,
      onCancel: D,
      onEnd: P.onEnd,
      prefixCls: $,
      className: a,
      style: s,
      direction: x,
      component: b,
      maxLength: P.maxLength,
      autoSize: P.autoSize,
      enterIcon: P.enterIcon
    });
  const dt = () => {
    const {
      expandable: Le,
      symbol: Ve
    } = we;
    if (!Le)
      return null;
    let Ae;
    return Ve ? Ae = Ve : Ae = S == null ? void 0 : S.expand, /* @__PURE__ */ c.createElement("a", {
      key: "expand",
      className: `${$}-expand`,
      onClick: qe,
      "aria-label": S == null ? void 0 : S.expand
    }, Ae);
  }, Ct = () => {
    if (!R)
      return;
    const {
      icon: Le,
      tooltip: Ve
    } = P, Ae = Rr(Ve)[0] || (S == null ? void 0 : S.edit), ft = typeof Ae == "string" ? Ae : "";
    return F.includes("icon") ? /* @__PURE__ */ c.createElement(Bo, {
      key: "edit",
      title: Ve === !1 ? "" : Ae
    }, /* @__PURE__ */ c.createElement(v$, {
      ref: O,
      className: `${$}-edit`,
      onClick: M,
      "aria-label": ft
    }, Le || /* @__PURE__ */ c.createElement(Vie, {
      role: "button"
    }))) : null;
  }, ot = () => {
    if (!T)
      return null;
    const {
      tooltips: Le,
      icon: Ve
    } = L, Ae = S$(Le), ft = S$(Ve), He = z ? Tp(Ae[1], S == null ? void 0 : S.copied) : Tp(Ae[0], S == null ? void 0 : S.copy), Fe = z ? S == null ? void 0 : S.copied : S == null ? void 0 : S.copy, yt = typeof He == "string" ? He : Fe;
    return /* @__PURE__ */ c.createElement(Bo, {
      key: "copy",
      title: He
    }, /* @__PURE__ */ c.createElement(v$, {
      className: se(`${$}-copy`, {
        [`${$}-copy-success`]: z,
        [`${$}-copy-icon-only`]: f == null
      }),
      onClick: oe,
      "aria-label": yt
    }, z ? Tp(ft[1], /* @__PURE__ */ c.createElement(Bg, null), !0) : Tp(ft[0], /* @__PURE__ */ c.createElement(kP, null), !0)));
  }, jt = (Le) => [Le && dt(), Ct(), ot()], Rt = (Le) => [Le && /* @__PURE__ */ c.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, bae), we.suffix, jt(Le)];
  return /* @__PURE__ */ c.createElement(zo, {
    onResize: Je,
    disabled: !he
  }, (Le) => /* @__PURE__ */ c.createElement(mae, {
    tooltipProps: Ye,
    enabledEllipsis: he,
    isEllipsis: Ee
  }, /* @__PURE__ */ c.createElement(PC, Object.assign({
    className: se({
      [`${$}-${l}`]: l,
      [`${$}-disabled`]: u,
      [`${$}-ellipsis`]: ye,
      [`${$}-single-line`]: he && me === 1,
      [`${$}-ellipsis-single-line`]: Ge,
      [`${$}-ellipsis-multiple-line`]: ke
    }, a),
    prefixCls: i,
    style: Object.assign(Object.assign({}, s), {
      WebkitLineClamp: ke ? me : void 0
    }),
    component: b,
    ref: Do(Le, E, t),
    direction: x,
    onClick: F.includes("text") ? M : void 0,
    "aria-label": wt == null ? void 0 : wt.toString(),
    title: m
  }, _), /* @__PURE__ */ c.createElement(gae, {
    enabledMeasure: he && !Te,
    text: f,
    rows: me,
    width: ze,
    fontSize: Ke,
    onEllipsis: Et
  }, (Ve, Ae) => {
    let ft = Ve;
    return Ve.length && Ae && wt && (ft = /* @__PURE__ */ c.createElement("span", {
      key: "show-content",
      "aria-hidden": !0
    }, ft)), yae(e, /* @__PURE__ */ c.createElement(c.Fragment, null, ft, Rt(Ae)));
  }))));
}), um = Cae;
var xae = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Sae = /* @__PURE__ */ c.forwardRef((e, t) => {
  var {
    ellipsis: n,
    rel: r
  } = e, o = xae(e, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const a = xn("Typography.Link");
    process.env.NODE_ENV !== "production" && a(typeof n != "object", "usage", "`ellipsis` only supports boolean value.");
  }
  const i = Object.assign(Object.assign({}, o), {
    rel: r === void 0 && o.target === "_blank" ? "noopener noreferrer" : r
  });
  return delete i.navigate, /* @__PURE__ */ c.createElement(um, Object.assign({}, i, {
    ref: t,
    ellipsis: !!n,
    component: "a"
  }));
}), wae = Sae, Eae = /* @__PURE__ */ c.forwardRef((e, t) => /* @__PURE__ */ c.createElement(um, Object.assign({
  ref: t
}, e, {
  component: "div"
}))), $ae = Eae;
var Oae = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const _ae = (e, t) => {
  var {
    ellipsis: n
  } = e, r = Oae(e, ["ellipsis"]);
  const o = c.useMemo(() => n && typeof n == "object" ? dr(n, ["expandable", "rows"]) : n, [n]);
  if (process.env.NODE_ENV !== "production") {
    const i = xn("Typography.Text");
    process.env.NODE_ENV !== "production" && i(typeof n != "object" || !n || !("expandable" in n) && !("rows" in n), "usage", "`ellipsis` do not support `expandable` or `rows` props.");
  }
  return /* @__PURE__ */ c.createElement(um, Object.assign({
    ref: t
  }, r, {
    ellipsis: o,
    component: "span"
  }));
}, Nae = /* @__PURE__ */ c.forwardRef(_ae);
var Pae = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const w$ = [1, 2, 3, 4, 5], Iae = /* @__PURE__ */ c.forwardRef((e, t) => {
  const {
    level: n = 1
  } = e, r = Pae(e, ["level"]);
  let o;
  if (process.env.NODE_ENV !== "production") {
    const i = xn("Typography.Title");
    process.env.NODE_ENV !== "production" && i(w$.includes(n), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.");
  }
  return w$.includes(n) ? o = `h${n}` : o = "h1", /* @__PURE__ */ c.createElement(um, Object.assign({
    ref: t
  }, r, {
    component: o
  }));
}), Rae = Iae, Ps = PC;
Ps.Text = Nae;
Ps.Link = wae;
Ps.Title = Rae;
Ps.Paragraph = $ae;
const Dae = new zj({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1,
      retry: !1,
      staleTime: 1 / 0
    },
    mutations: {
      retry: !1
    }
  }
}), Tae = {
  rulesInformation: {},
  formData: {
    create_operation: [],
    inspection_groups_fetch: []
  },
  setFormData: () => null
}, Si = Rs(Tae), Mae = ({
  children: e,
  org: t,
  cropCycle: n,
  environment: r,
  baseRoute: o,
  unitSystem: i,
  appId: a,
  workspaceId: s
}) => {
  const [l, u] = Ot({
    create_operation: [],
    create_plan: {},
    properties: [],
    fields: [],
    org_id: "",
    workers: [],
    inspection_groups_fetch: []
  }), f = mr(
    () => ({
      formData: l,
      rulesInformation: {
        org: t,
        cropCycle: n,
        environment: r,
        baseRoute: o,
        unitSystem: i,
        appId: a,
        workspaceId: s
      },
      setFormData: u
    }),
    [
      o,
      n,
      r,
      l,
      t,
      i,
      a,
      s
    ]
  );
  return /* @__PURE__ */ B.jsx(Si.Provider, { value: f, children: e });
};
/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Rd() {
  return Rd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rd.apply(this, arguments);
}
var Cs;
(function(e) {
  e.Pop = "POP", e.Push = "PUSH", e.Replace = "REPLACE";
})(Cs || (Cs = {}));
const E$ = "popstate";
function Lae(e) {
  e === void 0 && (e = {});
  function t(r, o) {
    let {
      pathname: i,
      search: a,
      hash: s
    } = r.location;
    return Cy(
      "",
      {
        pathname: i,
        search: a,
        hash: s
      },
      // state defaults to `null` because `window.history.state` does
      o.state && o.state.usr || null,
      o.state && o.state.key || "default"
    );
  }
  function n(r, o) {
    return typeof o == "string" ? o : Dd(o);
  }
  return jae(t, n, null, e);
}
function mn(e, t) {
  if (e === !1 || e === null || typeof e == "undefined")
    throw new Error(t);
}
function zi(e, t) {
  if (!e) {
    typeof console != "undefined" && console.warn(t);
    try {
      throw new Error(t);
    } catch (n) {
    }
  }
}
function Aae() {
  return Math.random().toString(36).substr(2, 8);
}
function $$(e, t) {
  return {
    usr: e.state,
    key: e.key,
    idx: t
  };
}
function Cy(e, t, n, r) {
  return n === void 0 && (n = null), Rd({
    pathname: typeof e == "string" ? e : e.pathname,
    search: "",
    hash: ""
  }, typeof t == "string" ? uu(t) : t, {
    state: n,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: t && t.key || r || Aae()
  });
}
function Dd(e) {
  let {
    pathname: t = "/",
    search: n = "",
    hash: r = ""
  } = e;
  return n && n !== "?" && (t += n.charAt(0) === "?" ? n : "?" + n), r && r !== "#" && (t += r.charAt(0) === "#" ? r : "#" + r), t;
}
function uu(e) {
  let t = {};
  if (e) {
    let n = e.indexOf("#");
    n >= 0 && (t.hash = e.substr(n), e = e.substr(0, n));
    let r = e.indexOf("?");
    r >= 0 && (t.search = e.substr(r), e = e.substr(0, r)), e && (t.pathname = e);
  }
  return t;
}
function jae(e, t, n, r) {
  r === void 0 && (r = {});
  let {
    window: o = document.defaultView,
    v5Compat: i = !1
  } = r, a = o.history, s = Cs.Pop, l = null, u = f();
  u == null && (u = 0, a.replaceState(Rd({}, a.state, {
    idx: u
  }), ""));
  function f() {
    return (a.state || {
      idx: null
    }).idx;
  }
  function p() {
    s = Cs.Pop;
    let v = f(), C = v == null ? null : v - u;
    u = v, l && l({
      action: s,
      location: m.location,
      delta: C
    });
  }
  function h(v, C) {
    s = Cs.Push;
    let x = Cy(m.location, v, C);
    n && n(x, v), u = f() + 1;
    let S = $$(x, u), E = m.createHref(x);
    try {
      a.pushState(S, "", E);
    } catch (O) {
      if (O instanceof DOMException && O.name === "DataCloneError")
        throw O;
      o.location.assign(E);
    }
    i && l && l({
      action: s,
      location: m.location,
      delta: 1
    });
  }
  function y(v, C) {
    s = Cs.Replace;
    let x = Cy(m.location, v, C);
    n && n(x, v), u = f();
    let S = $$(x, u), E = m.createHref(x);
    a.replaceState(S, "", E), i && l && l({
      action: s,
      location: m.location,
      delta: 0
    });
  }
  function b(v) {
    let C = o.location.origin !== "null" ? o.location.origin : o.location.href, x = typeof v == "string" ? v : Dd(v);
    return mn(C, "No window.location.(origin|href) available to create URL for href: " + x), new URL(x, C);
  }
  let m = {
    get action() {
      return s;
    },
    get location() {
      return e(o, a);
    },
    listen(v) {
      if (l)
        throw new Error("A history only accepts one active listener");
      return o.addEventListener(E$, p), l = v, () => {
        o.removeEventListener(E$, p), l = null;
      };
    },
    createHref(v) {
      return t(o, v);
    },
    createURL: b,
    encodeLocation(v) {
      let C = b(v);
      return {
        pathname: C.pathname,
        search: C.search,
        hash: C.hash
      };
    },
    push: h,
    replace: y,
    go(v) {
      return a.go(v);
    }
  };
  return m;
}
var O$;
(function(e) {
  e.data = "data", e.deferred = "deferred", e.redirect = "redirect", e.error = "error";
})(O$ || (O$ = {}));
function kae(e, t, n) {
  n === void 0 && (n = "/");
  let r = typeof t == "string" ? uu(t) : t, o = Is(r.pathname || "/", n);
  if (o == null)
    return null;
  let i = KP(e);
  Fae(i);
  let a = null;
  for (let s = 0; a == null && s < i.length; ++s)
    a = qae(
      i[s],
      // Incoming pathnames are generally encoded from either window.location
      // or from router.navigate, but we want to match against the unencoded
      // paths in the route definitions.  Memory router locations won't be
      // encoded here but there also shouldn't be anything to decode so this
      // should be a safe operation.  This avoids needing matchRoutes to be
      // history-aware.
      Xae(o)
    );
  return a;
}
function KP(e, t, n, r) {
  t === void 0 && (t = []), n === void 0 && (n = []), r === void 0 && (r = "");
  let o = (i, a, s) => {
    let l = {
      relativePath: s === void 0 ? i.path || "" : s,
      caseSensitive: i.caseSensitive === !0,
      childrenIndex: a,
      route: i
    };
    l.relativePath.startsWith("/") && (mn(l.relativePath.startsWith(r), 'Absolute route path "' + l.relativePath + '" nested under path ' + ('"' + r + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), l.relativePath = l.relativePath.slice(r.length));
    let u = Fa([r, l.relativePath]), f = n.concat(l);
    i.children && i.children.length > 0 && (mn(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      i.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + u + '".')
    ), KP(i.children, t, f, u)), !(i.path == null && !i.index) && t.push({
      path: u,
      score: Uae(u, i.index),
      routesMeta: f
    });
  };
  return e.forEach((i, a) => {
    var s;
    if (i.path === "" || !((s = i.path) != null && s.includes("?")))
      o(i, a);
    else
      for (let l of UP(i.path))
        o(i, a, l);
  }), t;
}
function UP(e) {
  let t = e.split("/");
  if (t.length === 0)
    return [];
  let [n, ...r] = t, o = n.endsWith("?"), i = n.replace(/\?$/, "");
  if (r.length === 0)
    return o ? [i, ""] : [i];
  let a = UP(r.join("/")), s = [];
  return s.push(...a.map((l) => l === "" ? i : [i, l].join("/"))), o && s.push(...a), s.map((l) => e.startsWith("/") && l === "" ? "/" : l);
}
function Fae(e) {
  e.sort((t, n) => t.score !== n.score ? n.score - t.score : Gae(t.routesMeta.map((r) => r.childrenIndex), n.routesMeta.map((r) => r.childrenIndex)));
}
const Bae = /^:[\w-]+$/, Hae = 3, zae = 2, Vae = 1, Wae = 10, Kae = -2, _$ = (e) => e === "*";
function Uae(e, t) {
  let n = e.split("/"), r = n.length;
  return n.some(_$) && (r += Kae), t && (r += zae), n.filter((o) => !_$(o)).reduce((o, i) => o + (Bae.test(i) ? Hae : i === "" ? Vae : Wae), r);
}
function Gae(e, t) {
  return e.length === t.length && e.slice(0, -1).every((r, o) => r === t[o]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function qae(e, t) {
  let {
    routesMeta: n
  } = e, r = {}, o = "/", i = [];
  for (let a = 0; a < n.length; ++a) {
    let s = n[a], l = a === n.length - 1, u = o === "/" ? t : t.slice(o.length) || "/", f = Gh({
      path: s.relativePath,
      caseSensitive: s.caseSensitive,
      end: l
    }, u);
    if (!f)
      return null;
    Object.assign(r, f.params);
    let p = s.route;
    i.push({
      // TODO: Can this as be avoided?
      params: r,
      pathname: Fa([o, f.pathname]),
      pathnameBase: tse(Fa([o, f.pathnameBase])),
      route: p
    }), f.pathnameBase !== "/" && (o = Fa([o, f.pathnameBase]));
  }
  return i;
}
function Gh(e, t) {
  typeof e == "string" && (e = {
    path: e,
    caseSensitive: !1,
    end: !0
  });
  let [n, r] = Yae(e.path, e.caseSensitive, e.end), o = t.match(n);
  if (!o)
    return null;
  let i = o[0], a = i.replace(/(.)\/+$/, "$1"), s = o.slice(1);
  return {
    params: r.reduce((u, f, p) => {
      let {
        paramName: h,
        isOptional: y
      } = f;
      if (h === "*") {
        let m = s[p] || "";
        a = i.slice(0, i.length - m.length).replace(/(.)\/+$/, "$1");
      }
      const b = s[p];
      return y && !b ? u[h] = void 0 : u[h] = Zae(b || "", h), u;
    }, {}),
    pathname: i,
    pathnameBase: a,
    pattern: e
  };
}
function Yae(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !0), zi(e === "*" || !e.endsWith("*") || e.endsWith("/*"), 'Route path "' + e + '" will be treated as if it were ' + ('"' + e.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + e.replace(/\*$/, "/*") + '".'));
  let r = [], o = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (a, s, l) => (r.push({
    paramName: s,
    isOptional: l != null
  }), l ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return e.endsWith("*") ? (r.push({
    paramName: "*"
  }), o += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : n ? o += "\\/*$" : e !== "" && e !== "/" && (o += "(?:(?=\\/|$))"), [new RegExp(o, t ? void 0 : "i"), r];
}
function Xae(e) {
  try {
    return decodeURI(e);
  } catch (t) {
    return zi(!1, 'The URL path "' + e + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + t + ").")), e;
  }
}
function Zae(e, t) {
  try {
    return decodeURIComponent(e);
  } catch (n) {
    return zi(!1, 'The value for the URL param "' + t + '" will not be decoded because' + (' the string "' + e + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + n + ").")), e;
  }
}
function Is(e, t) {
  if (t === "/")
    return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let n = t.endsWith("/") ? t.length - 1 : t.length, r = e.charAt(n);
  return r && r !== "/" ? null : e.slice(n) || "/";
}
function Qae(e, t) {
  t === void 0 && (t = "/");
  let {
    pathname: n,
    search: r = "",
    hash: o = ""
  } = typeof e == "string" ? uu(e) : e;
  return {
    pathname: n ? n.startsWith("/") ? n : Jae(n, t) : t,
    search: nse(r),
    hash: rse(o)
  };
}
function Jae(e, t) {
  let n = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? n.length > 1 && n.pop() : o !== "." && n.push(o);
  }), n.length > 1 ? n.join("/") : "/";
}
function y0(e, t, n, r) {
  return "Cannot include a '" + e + "' character in a manually specified " + ("`to." + t + "` field [" + JSON.stringify(r) + "].  Please separate it out to the ") + ("`to." + n + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function ese(e) {
  return e.filter((t, n) => n === 0 || t.route.path && t.route.path.length > 0);
}
function GP(e, t) {
  let n = ese(e);
  return t ? n.map((r, o) => o === e.length - 1 ? r.pathname : r.pathnameBase) : n.map((r) => r.pathnameBase);
}
function qP(e, t, n, r) {
  r === void 0 && (r = !1);
  let o;
  typeof e == "string" ? o = uu(e) : (o = Rd({}, e), mn(!o.pathname || !o.pathname.includes("?"), y0("?", "pathname", "search", o)), mn(!o.pathname || !o.pathname.includes("#"), y0("#", "pathname", "hash", o)), mn(!o.search || !o.search.includes("#"), y0("#", "search", "hash", o)));
  let i = e === "" || o.pathname === "", a = i ? "/" : o.pathname, s;
  if (a == null)
    s = n;
  else {
    let p = t.length - 1;
    if (!r && a.startsWith("..")) {
      let h = a.split("/");
      for (; h[0] === ".."; )
        h.shift(), p -= 1;
      o.pathname = h.join("/");
    }
    s = p >= 0 ? t[p] : "/";
  }
  let l = Qae(o, s), u = a && a !== "/" && a.endsWith("/"), f = (i || a === ".") && n.endsWith("/");
  return !l.pathname.endsWith("/") && (u || f) && (l.pathname += "/"), l;
}
const Fa = (e) => e.join("/").replace(/\/\/+/g, "/"), tse = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), nse = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, rse = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function ose(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
const YP = ["post", "put", "patch", "delete"];
new Set(YP);
const ise = ["get", ...YP];
new Set(ise);
/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Td() {
  return Td = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Td.apply(this, arguments);
}
const uf = /* @__PURE__ */ c.createContext(null);
process.env.NODE_ENV !== "production" && (uf.displayName = "DataRouter");
const IC = /* @__PURE__ */ c.createContext(null);
process.env.NODE_ENV !== "production" && (IC.displayName = "DataRouterState");
const ase = /* @__PURE__ */ c.createContext(null);
process.env.NODE_ENV !== "production" && (ase.displayName = "Await");
const Ui = /* @__PURE__ */ c.createContext(null);
process.env.NODE_ENV !== "production" && (Ui.displayName = "Navigation");
const df = /* @__PURE__ */ c.createContext(null);
process.env.NODE_ENV !== "production" && (df.displayName = "Location");
const fa = /* @__PURE__ */ c.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (fa.displayName = "Route");
const RC = /* @__PURE__ */ c.createContext(null);
process.env.NODE_ENV !== "production" && (RC.displayName = "RouteError");
function sse(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t;
  du() || (process.env.NODE_ENV !== "production" ? mn(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : mn(!1));
  let {
    basename: r,
    navigator: o
  } = c.useContext(Ui), {
    hash: i,
    pathname: a,
    search: s
  } = ff(e, {
    relative: n
  }), l = a;
  return r !== "/" && (l = a === "/" ? r : Fa([r, a])), o.createHref({
    pathname: l,
    search: s,
    hash: i
  });
}
function du() {
  return c.useContext(df) != null;
}
function qa() {
  return du() || (process.env.NODE_ENV !== "production" ? mn(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : mn(!1)), c.useContext(df).location;
}
function lse(e) {
  du() || (process.env.NODE_ENV !== "production" ? mn(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component."
  ) : mn(!1));
  let {
    pathname: t
  } = qa();
  return c.useMemo(() => Gh(e, t), [t, e]);
}
const XP = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function ZP(e) {
  c.useContext(Ui).static || c.useLayoutEffect(e);
}
function Ya() {
  let {
    isDataRoute: e
  } = c.useContext(fa);
  return e ? wse() : cse();
}
function cse() {
  du() || (process.env.NODE_ENV !== "production" ? mn(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : mn(!1));
  let e = c.useContext(uf), {
    basename: t,
    future: n,
    navigator: r
  } = c.useContext(Ui), {
    matches: o
  } = c.useContext(fa), {
    pathname: i
  } = qa(), a = JSON.stringify(GP(o, n.v7_relativeSplatPath)), s = c.useRef(!1);
  return ZP(() => {
    s.current = !0;
  }), c.useCallback(function(u, f) {
    if (f === void 0 && (f = {}), process.env.NODE_ENV !== "production" && zi(s.current, XP), !s.current)
      return;
    if (typeof u == "number") {
      r.go(u);
      return;
    }
    let p = qP(u, JSON.parse(a), i, f.relative === "path");
    e == null && t !== "/" && (p.pathname = p.pathname === "/" ? t : Fa([t, p.pathname])), (f.replace ? r.replace : r.push)(p, f.state, f);
  }, [t, r, a, i, e]);
}
function use() {
  let {
    matches: e
  } = c.useContext(fa), t = e[e.length - 1];
  return t ? t.params : {};
}
function ff(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    future: r
  } = c.useContext(Ui), {
    matches: o
  } = c.useContext(fa), {
    pathname: i
  } = qa(), a = JSON.stringify(GP(o, r.v7_relativeSplatPath));
  return c.useMemo(() => qP(e, JSON.parse(a), i, n === "path"), [e, a, i, n]);
}
function dse(e, t) {
  return fse(e, t);
}
function fse(e, t, n, r) {
  du() || (process.env.NODE_ENV !== "production" ? mn(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : mn(!1));
  let {
    navigator: o
  } = c.useContext(Ui), {
    matches: i
  } = c.useContext(fa), a = i[i.length - 1], s = a ? a.params : {}, l = a ? a.pathname : "/", u = a ? a.pathnameBase : "/", f = a && a.route;
  if (process.env.NODE_ENV !== "production") {
    let x = f && f.path || "";
    JP(l, !f || x.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + l + '" (under <Route path="' + x + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + x + '"> to <Route ') + ('path="' + (x === "/" ? "*" : x + "/*") + '">.'));
  }
  let p = qa(), h;
  if (t) {
    var y;
    let x = typeof t == "string" ? uu(t) : t;
    u === "/" || (y = x.pathname) != null && y.startsWith(u) || (process.env.NODE_ENV !== "production" ? mn(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + u + '" ') + ('but pathname "' + x.pathname + '" was given in the `location` prop.')) : mn(!1)), h = x;
  } else
    h = p;
  let b = h.pathname || "/", m = u === "/" ? b : b.slice(u.length) || "/", v = kae(e, {
    pathname: m
  });
  process.env.NODE_ENV !== "production" && (process.env.NODE_ENV !== "production" && zi(f || v != null, 'No routes matched location "' + h.pathname + h.search + h.hash + '" '), process.env.NODE_ENV !== "production" && zi(v == null || v[v.length - 1].route.element !== void 0 || v[v.length - 1].route.Component !== void 0 || v[v.length - 1].route.lazy !== void 0, 'Matched leaf route at location "' + h.pathname + h.search + h.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
  let C = vse(v && v.map((x) => Object.assign({}, x, {
    params: Object.assign({}, s, x.params),
    pathname: Fa([
      u,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(x.pathname).pathname : x.pathname
    ]),
    pathnameBase: x.pathnameBase === "/" ? u : Fa([
      u,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(x.pathnameBase).pathname : x.pathnameBase
    ])
  })), i, n, r);
  return t && C ? /* @__PURE__ */ c.createElement(df.Provider, {
    value: {
      location: Td({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, h),
      navigationType: Cs.Pop
    }
  }, C) : C;
}
function pse() {
  let e = Sse(), t = ose(e) ? e.status + " " + e.statusText : e instanceof Error ? e.message : JSON.stringify(e), n = e instanceof Error ? e.stack : null, r = "rgba(200,200,200, 0.5)", o = {
    padding: "0.5rem",
    backgroundColor: r
  }, i = {
    padding: "2px 4px",
    backgroundColor: r
  }, a = null;
  return process.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", e), a = /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ c.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ c.createElement("code", {
    style: i
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ c.createElement("code", {
    style: i
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ c.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, t), n ? /* @__PURE__ */ c.createElement("pre", {
    style: o
  }, n) : null, a);
}
const hse = /* @__PURE__ */ c.createElement(pse, null);
class gse extends c.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      revalidation: t.revalidation,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return {
      error: t
    };
  }
  static getDerivedStateFromProps(t, n) {
    return n.location !== t.location || n.revalidation !== "idle" && t.revalidation === "idle" ? {
      error: t.error,
      location: t.location,
      revalidation: t.revalidation
    } : {
      error: t.error !== void 0 ? t.error : n.error,
      location: n.location,
      revalidation: t.revalidation || n.revalidation
    };
  }
  componentDidCatch(t, n) {
    console.error("React Router caught the following error during render", t, n);
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ c.createElement(fa.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ c.createElement(RC.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function mse(e) {
  let {
    routeContext: t,
    match: n,
    children: r
  } = e, o = c.useContext(uf);
  return o && o.static && o.staticContext && (n.route.errorElement || n.route.ErrorBoundary) && (o.staticContext._deepestRenderedBoundaryId = n.route.id), /* @__PURE__ */ c.createElement(fa.Provider, {
    value: t
  }, r);
}
function vse(e, t, n, r) {
  var o;
  if (t === void 0 && (t = []), n === void 0 && (n = null), r === void 0 && (r = null), e == null) {
    var i;
    if ((i = n) != null && i.errors)
      e = n.matches;
    else
      return null;
  }
  let a = e, s = (o = n) == null ? void 0 : o.errors;
  if (s != null) {
    let f = a.findIndex((p) => p.route.id && (s == null ? void 0 : s[p.route.id]));
    f >= 0 || (process.env.NODE_ENV !== "production" ? mn(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(s).join(",")) : mn(!1)), a = a.slice(0, Math.min(a.length, f + 1));
  }
  let l = !1, u = -1;
  if (n && r && r.v7_partialHydration)
    for (let f = 0; f < a.length; f++) {
      let p = a[f];
      if ((p.route.HydrateFallback || p.route.hydrateFallbackElement) && (u = f), p.route.id) {
        let {
          loaderData: h,
          errors: y
        } = n, b = p.route.loader && h[p.route.id] === void 0 && (!y || y[p.route.id] === void 0);
        if (p.route.lazy || b) {
          l = !0, u >= 0 ? a = a.slice(0, u + 1) : a = [a[0]];
          break;
        }
      }
    }
  return a.reduceRight((f, p, h) => {
    let y, b = !1, m = null, v = null;
    n && (y = s && p.route.id ? s[p.route.id] : void 0, m = p.route.errorElement || hse, l && (u < 0 && h === 0 ? (JP("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), b = !0, v = null) : u === h && (b = !0, v = p.route.hydrateFallbackElement || null)));
    let C = t.concat(a.slice(0, h + 1)), x = () => {
      let S;
      return y ? S = m : b ? S = v : p.route.Component ? S = /* @__PURE__ */ c.createElement(p.route.Component, null) : p.route.element ? S = p.route.element : S = f, /* @__PURE__ */ c.createElement(mse, {
        match: p,
        routeContext: {
          outlet: f,
          matches: C,
          isDataRoute: n != null
        },
        children: S
      });
    };
    return n && (p.route.ErrorBoundary || p.route.errorElement || h === 0) ? /* @__PURE__ */ c.createElement(gse, {
      location: n.location,
      revalidation: n.revalidation,
      component: m,
      error: y,
      children: x(),
      routeContext: {
        outlet: null,
        matches: C,
        isDataRoute: !0
      }
    }) : x();
  }, null);
}
var QP = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e;
}(QP || {}), Md = /* @__PURE__ */ function(e) {
  return e.UseBlocker = "useBlocker", e.UseLoaderData = "useLoaderData", e.UseActionData = "useActionData", e.UseRouteError = "useRouteError", e.UseNavigation = "useNavigation", e.UseRouteLoaderData = "useRouteLoaderData", e.UseMatches = "useMatches", e.UseRevalidator = "useRevalidator", e.UseNavigateStable = "useNavigate", e.UseRouteId = "useRouteId", e;
}(Md || {});
function DC(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function yse(e) {
  let t = c.useContext(uf);
  return t || (process.env.NODE_ENV !== "production" ? mn(!1, DC(e)) : mn(!1)), t;
}
function bse(e) {
  let t = c.useContext(IC);
  return t || (process.env.NODE_ENV !== "production" ? mn(!1, DC(e)) : mn(!1)), t;
}
function Cse(e) {
  let t = c.useContext(fa);
  return t || (process.env.NODE_ENV !== "production" ? mn(!1, DC(e)) : mn(!1)), t;
}
function TC(e) {
  let t = Cse(e), n = t.matches[t.matches.length - 1];
  return n.route.id || (process.env.NODE_ENV !== "production" ? mn(!1, e + ' can only be used on routes that contain a unique "id"') : mn(!1)), n.route.id;
}
function xse() {
  return TC(Md.UseRouteId);
}
function Sse() {
  var e;
  let t = c.useContext(RC), n = bse(Md.UseRouteError), r = TC(Md.UseRouteError);
  return t !== void 0 ? t : (e = n.errors) == null ? void 0 : e[r];
}
function wse() {
  let {
    router: e
  } = yse(QP.UseNavigateStable), t = TC(Md.UseNavigateStable), n = c.useRef(!1);
  return ZP(() => {
    n.current = !0;
  }), c.useCallback(function(o, i) {
    i === void 0 && (i = {}), process.env.NODE_ENV !== "production" && zi(n.current, XP), n.current && (typeof o == "number" ? e.navigate(o) : e.navigate(o, Td({
      fromRouteId: t
    }, i)));
  }, [e, t]);
}
const N$ = {};
function JP(e, t, n) {
  !t && !N$[e] && (N$[e] = !0, process.env.NODE_ENV !== "production" && zi(!1, n));
}
function e9(e) {
  process.env.NODE_ENV !== "production" ? mn(!1, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.") : mn(!1);
}
function Ese(e) {
  let {
    basename: t = "/",
    children: n = null,
    location: r,
    navigationType: o = Cs.Pop,
    navigator: i,
    static: a = !1,
    future: s
  } = e;
  du() && (process.env.NODE_ENV !== "production" ? mn(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : mn(!1));
  let l = t.replace(/^\/*/, "/"), u = c.useMemo(() => ({
    basename: l,
    navigator: i,
    static: a,
    future: Td({
      v7_relativeSplatPath: !1
    }, s)
  }), [l, s, i, a]);
  typeof r == "string" && (r = uu(r));
  let {
    pathname: f = "/",
    search: p = "",
    hash: h = "",
    state: y = null,
    key: b = "default"
  } = r, m = c.useMemo(() => {
    let v = Is(f, l);
    return v == null ? null : {
      location: {
        pathname: v,
        search: p,
        hash: h,
        state: y,
        key: b
      },
      navigationType: o
    };
  }, [l, f, p, h, y, b, o]);
  return process.env.NODE_ENV !== "production" && zi(m != null, '<Router basename="' + l + '"> is not able to match the URL ' + ('"' + f + p + h + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), m == null ? null : /* @__PURE__ */ c.createElement(Ui.Provider, {
    value: u
  }, /* @__PURE__ */ c.createElement(df.Provider, {
    children: n,
    value: m
  }));
}
function $se(e) {
  let {
    children: t,
    location: n
  } = e;
  return dse(xy(t), n);
}
new Promise(() => {
});
function xy(e, t) {
  t === void 0 && (t = []);
  let n = [];
  return c.Children.forEach(e, (r, o) => {
    if (!/* @__PURE__ */ c.isValidElement(r))
      return;
    let i = [...t, o];
    if (r.type === c.Fragment) {
      n.push.apply(n, xy(r.props.children, i));
      return;
    }
    r.type !== e9 && (process.env.NODE_ENV !== "production" ? mn(!1, "[" + (typeof r.type == "string" ? r.type : r.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>") : mn(!1)), !r.props.index || !r.props.children || (process.env.NODE_ENV !== "production" ? mn(!1, "An index route cannot have child routes.") : mn(!1));
    let a = {
      id: r.props.id || i.join("-"),
      caseSensitive: r.props.caseSensitive,
      element: r.props.element,
      Component: r.props.Component,
      index: r.props.index,
      path: r.props.path,
      loader: r.props.loader,
      action: r.props.action,
      errorElement: r.props.errorElement,
      ErrorBoundary: r.props.ErrorBoundary,
      hasErrorBoundary: r.props.ErrorBoundary != null || r.props.errorElement != null,
      shouldRevalidate: r.props.shouldRevalidate,
      handle: r.props.handle,
      lazy: r.props.lazy
    };
    r.props.children && (a.children = xy(r.props.children, i)), n.push(a);
  }), n;
}
/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Wc() {
  return Wc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wc.apply(this, arguments);
}
function MC(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
const sh = "get", lh = "application/x-www-form-urlencoded";
function dm(e) {
  return e != null && typeof e.tagName == "string";
}
function Ose(e) {
  return dm(e) && e.tagName.toLowerCase() === "button";
}
function _se(e) {
  return dm(e) && e.tagName.toLowerCase() === "form";
}
function Nse(e) {
  return dm(e) && e.tagName.toLowerCase() === "input";
}
function Pse(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Ise(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !Pse(e);
}
let Mp = null;
function Rse() {
  if (Mp === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), Mp = !1;
    } catch (e) {
      Mp = !0;
    }
  return Mp;
}
const Dse = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function b0(e) {
  return e != null && !Dse.has(e) ? (process.env.NODE_ENV !== "production" && zi(!1, '"' + e + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + lh + '"')), null) : e;
}
function Tse(e, t) {
  let n, r, o, i, a;
  if (_se(e)) {
    let s = e.getAttribute("action");
    r = s ? Is(s, t) : null, n = e.getAttribute("method") || sh, o = b0(e.getAttribute("enctype")) || lh, i = new FormData(e);
  } else if (Ose(e) || Nse(e) && (e.type === "submit" || e.type === "image")) {
    let s = e.form;
    if (s == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let l = e.getAttribute("formaction") || s.getAttribute("action");
    if (r = l ? Is(l, t) : null, n = e.getAttribute("formmethod") || s.getAttribute("method") || sh, o = b0(e.getAttribute("formenctype")) || b0(s.getAttribute("enctype")) || lh, i = new FormData(s, e), !Rse()) {
      let {
        name: u,
        type: f,
        value: p
      } = e;
      if (f === "image") {
        let h = u ? u + "." : "";
        i.append(h + "x", "0"), i.append(h + "y", "0");
      } else
        u && i.append(u, p);
    }
  } else {
    if (dm(e))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    n = sh, r = null, o = lh, a = e;
  }
  return i && o === "text/plain" && (a = i, i = void 0), {
    action: r,
    method: n.toLowerCase(),
    encType: o,
    formData: i,
    body: a
  };
}
const Mse = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], Lse = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], Ase = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"], jse = "6";
try {
  window.__reactRouterVersion = jse;
} catch (e) {
}
const t9 = /* @__PURE__ */ c.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (t9.displayName = "ViewTransition");
const kse = /* @__PURE__ */ c.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (kse.displayName = "Fetchers");
const Fse = "startTransition", P$ = c[Fse];
function Bse(e) {
  let {
    basename: t,
    children: n,
    future: r,
    window: o
  } = e, i = c.useRef();
  i.current == null && (i.current = Lae({
    window: o,
    v5Compat: !0
  }));
  let a = i.current, [s, l] = c.useState({
    action: a.action,
    location: a.location
  }), {
    v7_startTransition: u
  } = r || {}, f = c.useCallback((p) => {
    u && P$ ? P$(() => l(p)) : l(p);
  }, [l, u]);
  return c.useLayoutEffect(() => a.listen(f), [a, f]), /* @__PURE__ */ c.createElement(Ese, {
    basename: t,
    children: n,
    location: s.location,
    navigationType: s.action,
    navigator: a,
    future: r
  });
}
process.env.NODE_ENV;
const Hse = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", zse = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, n9 = /* @__PURE__ */ c.forwardRef(function(t, n) {
  let {
    onClick: r,
    relative: o,
    reloadDocument: i,
    replace: a,
    state: s,
    target: l,
    to: u,
    preventScrollReset: f,
    unstable_viewTransition: p
  } = t, h = MC(t, Mse), {
    basename: y
  } = c.useContext(Ui), b, m = !1;
  if (typeof u == "string" && zse.test(u) && (b = u, Hse))
    try {
      let S = new URL(window.location.href), E = u.startsWith("//") ? new URL(S.protocol + u) : new URL(u), O = Is(E.pathname, y);
      E.origin === S.origin && O != null ? u = O + E.search + E.hash : m = !0;
    } catch (S) {
      process.env.NODE_ENV !== "production" && zi(!1, '<Link to="' + u + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let v = sse(u, {
    relative: o
  }), C = Use(u, {
    replace: a,
    state: s,
    target: l,
    preventScrollReset: f,
    relative: o,
    unstable_viewTransition: p
  });
  function x(S) {
    r && r(S), S.defaultPrevented || C(S);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ c.createElement("a", Wc({}, h, {
      href: b || v,
      onClick: m || i ? r : x,
      ref: n,
      target: l
    }))
  );
});
process.env.NODE_ENV !== "production" && (n9.displayName = "Link");
const Vse = /* @__PURE__ */ c.forwardRef(function(t, n) {
  let {
    "aria-current": r = "page",
    caseSensitive: o = !1,
    className: i = "",
    end: a = !1,
    style: s,
    to: l,
    unstable_viewTransition: u,
    children: f
  } = t, p = MC(t, Lse), h = ff(l, {
    relative: p.relative
  }), y = qa(), b = c.useContext(IC), {
    navigator: m,
    basename: v
  } = c.useContext(Ui), C = b != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  Qse(h) && u === !0, x = m.encodeLocation ? m.encodeLocation(h).pathname : h.pathname, S = y.pathname, E = b && b.navigation && b.navigation.location ? b.navigation.location.pathname : null;
  o || (S = S.toLowerCase(), E = E ? E.toLowerCase() : null, x = x.toLowerCase()), E && v && (E = Is(E, v) || E);
  const O = x !== "/" && x.endsWith("/") ? x.length - 1 : x.length;
  let $ = S === x || !a && S.startsWith(x) && S.charAt(O) === "/", _ = E != null && (E === x || !a && E.startsWith(x) && E.charAt(x.length) === "/"), R = {
    isActive: $,
    isPending: _,
    isTransitioning: C
  }, P = $ ? r : void 0, I;
  typeof i == "function" ? I = i(R) : I = [i, $ ? "active" : null, _ ? "pending" : null, C ? "transitioning" : null].filter(Boolean).join(" ");
  let j = typeof s == "function" ? s(R) : s;
  return /* @__PURE__ */ c.createElement(n9, Wc({}, p, {
    "aria-current": P,
    className: I,
    ref: n,
    style: j,
    to: l,
    unstable_viewTransition: u
  }), typeof f == "function" ? f(R) : f);
});
process.env.NODE_ENV !== "production" && (Vse.displayName = "NavLink");
const Wse = /* @__PURE__ */ c.forwardRef((e, t) => {
  let {
    fetcherKey: n,
    navigate: r,
    reloadDocument: o,
    replace: i,
    state: a,
    method: s = sh,
    action: l,
    onSubmit: u,
    relative: f,
    preventScrollReset: p,
    unstable_viewTransition: h
  } = e, y = MC(e, Ase), b = Xse(), m = Zse(l, {
    relative: f
  }), v = s.toLowerCase() === "get" ? "get" : "post", C = (x) => {
    if (u && u(x), x.defaultPrevented)
      return;
    x.preventDefault();
    let S = x.nativeEvent.submitter, E = (S == null ? void 0 : S.getAttribute("formmethod")) || s;
    b(S || x.currentTarget, {
      fetcherKey: n,
      method: E,
      navigate: r,
      replace: i,
      state: a,
      relative: f,
      preventScrollReset: p,
      unstable_viewTransition: h
    });
  };
  return /* @__PURE__ */ c.createElement("form", Wc({
    ref: t,
    method: v,
    action: m,
    onSubmit: o ? u : C
  }, y));
});
process.env.NODE_ENV !== "production" && (Wse.displayName = "Form");
process.env.NODE_ENV;
var qh;
(function(e) {
  e.UseScrollRestoration = "useScrollRestoration", e.UseSubmit = "useSubmit", e.UseSubmitFetcher = "useSubmitFetcher", e.UseFetcher = "useFetcher", e.useViewTransitionState = "useViewTransitionState";
})(qh || (qh = {}));
var I$;
(function(e) {
  e.UseFetcher = "useFetcher", e.UseFetchers = "useFetchers", e.UseScrollRestoration = "useScrollRestoration";
})(I$ || (I$ = {}));
function Kse(e) {
  return e + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function r9(e) {
  let t = c.useContext(uf);
  return t || (process.env.NODE_ENV !== "production" ? mn(!1, Kse(e)) : mn(!1)), t;
}
function Use(e, t) {
  let {
    target: n,
    replace: r,
    state: o,
    preventScrollReset: i,
    relative: a,
    unstable_viewTransition: s
  } = t === void 0 ? {} : t, l = Ya(), u = qa(), f = ff(e, {
    relative: a
  });
  return c.useCallback((p) => {
    if (Ise(p, n)) {
      p.preventDefault();
      let h = r !== void 0 ? r : Dd(u) === Dd(f);
      l(e, {
        replace: h,
        state: o,
        preventScrollReset: i,
        relative: a,
        unstable_viewTransition: s
      });
    }
  }, [u, l, f, r, o, n, e, i, a, s]);
}
function Gse() {
  if (typeof document == "undefined")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let qse = 0, Yse = () => "__" + String(++qse) + "__";
function Xse() {
  let {
    router: e
  } = r9(qh.UseSubmit), {
    basename: t
  } = c.useContext(Ui), n = xse();
  return c.useCallback(function(r, o) {
    o === void 0 && (o = {}), Gse();
    let {
      action: i,
      method: a,
      encType: s,
      formData: l,
      body: u
    } = Tse(r, t);
    if (o.navigate === !1) {
      let f = o.fetcherKey || Yse();
      e.fetch(f, n, o.action || i, {
        preventScrollReset: o.preventScrollReset,
        formData: l,
        body: u,
        formMethod: o.method || a,
        formEncType: o.encType || s,
        unstable_flushSync: o.unstable_flushSync
      });
    } else
      e.navigate(o.action || i, {
        preventScrollReset: o.preventScrollReset,
        formData: l,
        body: u,
        formMethod: o.method || a,
        formEncType: o.encType || s,
        replace: o.replace,
        state: o.state,
        fromRouteId: n,
        unstable_flushSync: o.unstable_flushSync,
        unstable_viewTransition: o.unstable_viewTransition
      });
  }, [e, t, n]);
}
function Zse(e, t) {
  let {
    relative: n
  } = t === void 0 ? {} : t, {
    basename: r
  } = c.useContext(Ui), o = c.useContext(fa);
  o || (process.env.NODE_ENV !== "production" ? mn(!1, "useFormAction must be used inside a RouteContext") : mn(!1));
  let [i] = o.matches.slice(-1), a = Wc({}, ff(e || ".", {
    relative: n
  })), s = qa();
  if (e == null) {
    a.search = s.search;
    let l = new URLSearchParams(a.search);
    l.has("index") && l.get("index") === "" && (l.delete("index"), a.search = l.toString() ? "?" + l.toString() : "");
  }
  return (!e || e === ".") && i.route.index && (a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index"), r !== "/" && (a.pathname = a.pathname === "/" ? r : Fa([r, a.pathname])), Dd(a);
}
function Qse(e, t) {
  t === void 0 && (t = {});
  let n = c.useContext(t9);
  n == null && (process.env.NODE_ENV !== "production" ? mn(!1, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : mn(!1));
  let {
    basename: r
  } = r9(qh.useViewTransitionState), o = ff(e, {
    relative: t.relative
  });
  if (!n.isTransitioning)
    return !1;
  let i = Is(n.currentLocation.pathname, r) || n.currentLocation.pathname, a = Is(n.nextLocation.pathname, r) || n.nextLocation.pathname;
  return Gh(o.pathname, a) != null || Gh(o.pathname, i) != null;
}
const o9 = {
  10: "#EAF6FF",
  20: "#C6E6FF",
  30: "#82CFFF",
  40: "#31B4F2",
  50: "#0092E4",
  60: "#0071CD",
  70: "#005693",
  80: "#003B69",
  90: "#002747",
  100: "#00172D"
}, vr = {
  10: "#DFFBE8",
  20: "#C3EAD1",
  30: "#90D6AA",
  40: "#5EBB7F",
  50: "#19A04B",
  60: "#14803C",
  70: "#0C612C",
  80: "#06431C",
  90: "#032D10",
  100: "#011B07"
}, fu = {
  10: "#FFF1F1",
  20: "#FFD9D9",
  30: "#FFB3B3",
  40: "#F98989",
  50: "#EB4B4B",
  60: "#CF3537",
  70: "#9C2628",
  80: "#70191A",
  90: "#4C0E0F",
  100: "#300606"
}, C0 = {
  10: "#FFF3DD",
  20: "#FFE4AE",
  30: "#F0C355",
  40: "#E99921",
  50: "#C17E19",
  60: "#9A6412",
  70: "#744A0B",
  80: "#523305",
  90: "#372102",
  100: "#221201"
}, Ht = {
  0: "#FFFFFF",
  10: "#F3F4F6",
  20: "#DFE2E7",
  30: "#C2C7D0",
  40: "#A3A9B9",
  50: "#868CA2",
  60: "#696F88",
  70: "#4D5165",
  80: "#363948",
  90: "#232630",
  100: "#14151C"
};
var no = function() {
  return no = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, no.apply(this, arguments);
};
function Sl(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Jse(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var ele = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, tle = /* @__PURE__ */ Jse(
  function(e) {
    return ele.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), nle = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, wl = typeof process != "undefined" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", i9 = "active", a9 = "data-styled-version", fm = "6.1.8", LC = `/*!sc*/
`, AC = typeof window != "undefined" && "HTMLElement" in window, rle = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process != "undefined" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), ole = {}, R$ = /invalid hook call/i, Lp = /* @__PURE__ */ new Set(), s9 = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var n = t ? ' with the id of "'.concat(t, '"') : "", r = "The component ".concat(e).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, o = console.error;
    try {
      var i = !0;
      console.error = function(a) {
        for (var s = [], l = 1; l < arguments.length; l++)
          s[l - 1] = arguments[l];
        R$.test(a) ? (i = !1, Lp.delete(r)) : o.apply(void 0, Sl([a], s, !1));
      }, _t(), i && !Lp.has(r) && (console.warn(r), Lp.add(r));
    } catch (a) {
      R$.test(a.message) && Lp.delete(r);
    } finally {
      console.error = o;
    }
  }
}, pm = Object.freeze([]), Kc = Object.freeze({});
function l9(e, t, n) {
  return n === void 0 && (n = Kc), e.theme !== n.theme && e.theme || t || n.theme;
}
var Sy = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), ile = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, ale = /(^-|-$)/g;
function D$(e) {
  return e.replace(ile, "-").replace(ale, "");
}
var sle = /(a)(d)/gi, Ap = 52, T$ = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function wy(e) {
  var t, n = "";
  for (t = Math.abs(e); t > Ap; t = t / Ap | 0)
    n = T$(t % Ap) + n;
  return (T$(t % Ap) + n).replace(sle, "$1-$2");
}
var x0, c9 = 5381, el = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, u9 = function(e) {
  return el(c9, e);
};
function d9(e) {
  return wy(u9(e) >>> 0);
}
function f9(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function S0(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var p9 = typeof Symbol == "function" && Symbol.for, h9 = p9 ? Symbol.for("react.memo") : 60115, lle = p9 ? Symbol.for("react.forward_ref") : 60112, cle = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, ule = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, g9 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, dle = ((x0 = {})[lle] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, x0[h9] = g9, x0);
function M$(e) {
  return ("type" in (t = e) && t.type.$$typeof) === h9 ? g9 : "$$typeof" in e ? dle[e.$$typeof] : cle;
  var t;
}
var fle = Object.defineProperty, ple = Object.getOwnPropertyNames, L$ = Object.getOwnPropertySymbols, hle = Object.getOwnPropertyDescriptor, gle = Object.getPrototypeOf, A$ = Object.prototype;
function m9(e, t, n) {
  if (typeof t != "string") {
    if (A$) {
      var r = gle(t);
      r && r !== A$ && m9(e, r, n);
    }
    var o = ple(t);
    L$ && (o = o.concat(L$(t)));
    for (var i = M$(e), a = M$(t), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!(l in ule || n && n[l] || a && l in a || i && l in i)) {
        var u = hle(t, l);
        try {
          fle(e, l, u);
        } catch (f) {
        }
      }
    }
  }
  return e;
}
function El(e) {
  return typeof e == "function";
}
function jC(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function il(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function Ey(e, t) {
  if (e.length === 0)
    return "";
  for (var n = e[0], r = 1; r < e.length; r++)
    n += t ? t + e[r] : e[r];
  return n;
}
function Uc(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $y(e, t, n) {
  if (n === void 0 && (n = !1), !n && !Uc(e) && !Array.isArray(e))
    return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      e[r] = $y(e[r], t[r]);
  else if (Uc(t))
    for (var r in t)
      e[r] = $y(e[r], t[r]);
  return e;
}
function kC(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
var mle = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function vle() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = e[0], r = [], o = 1, i = e.length; o < i; o += 1)
    r.push(e[o]);
  return r.forEach(function(a) {
    n = n.replace(/%[a-z]/, a);
  }), n;
}
function Ba(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : "")) : new Error(vle.apply(void 0, Sl([mle[e]], t, !1)).trim());
}
var yle = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var n = 0, r = 0; r < t; r++)
      n += this.groupSizes[r];
    return n;
  }, e.prototype.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var r = this.groupSizes, o = r.length, i = o; t >= i; )
        if ((i <<= 1) < 0)
          throw Ba(16, "".concat(t));
      this.groupSizes = new Uint32Array(i), this.groupSizes.set(r), this.length = i;
      for (var a = o; a < i; a++)
        this.groupSizes[a] = 0;
    }
    for (var s = this.indexOfGroup(t + 1), l = (a = 0, n.length); a < l; a++)
      this.tag.insertRule(s, n[a]) && (this.groupSizes[t]++, s++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], r = this.indexOfGroup(t), o = r + n;
      this.groupSizes[t] = 0;
      for (var i = r; i < o; i++)
        this.tag.deleteRule(r);
    }
  }, e.prototype.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return n;
    for (var r = this.groupSizes[t], o = this.indexOfGroup(t), i = o + r, a = o; a < i; a++)
      n += "".concat(this.tag.getRule(a)).concat(LC);
    return n;
  }, e;
}(), ch = /* @__PURE__ */ new Map(), Yh = /* @__PURE__ */ new Map(), uh = 1, jp = function(e) {
  if (ch.has(e))
    return ch.get(e);
  for (; Yh.has(uh); )
    uh++;
  var t = uh++;
  if (process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1073741824))
    throw Ba(16, "".concat(t));
  return ch.set(e, t), Yh.set(t, e), t;
}, ble = function(e, t) {
  uh = t + 1, ch.set(e, t), Yh.set(t, e);
}, Cle = "style[".concat(wl, "][").concat(a9, '="').concat(fm, '"]'), xle = new RegExp("^".concat(wl, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Sle = function(e, t, n) {
  for (var r, o = n.split(","), i = 0, a = o.length; i < a; i++)
    (r = o[i]) && e.registerName(t, r);
}, wle = function(e, t) {
  for (var n, r = ((n = t.textContent) !== null && n !== void 0 ? n : "").split(LC), o = [], i = 0, a = r.length; i < a; i++) {
    var s = r[i].trim();
    if (s) {
      var l = s.match(xle);
      if (l) {
        var u = 0 | parseInt(l[1], 10), f = l[2];
        u !== 0 && (ble(f, u), Sle(e, f, l[3]), e.getTag().insertRules(u, o)), o.length = 0;
      } else
        o.push(s);
    }
  }
};
function Ele() {
  return typeof __webpack_nonce__ != "undefined" ? __webpack_nonce__ : null;
}
var v9 = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), o = function(s) {
    var l = Array.from(s.querySelectorAll("style[".concat(wl, "]")));
    return l[l.length - 1];
  }(n), i = o !== void 0 ? o.nextSibling : null;
  r.setAttribute(wl, i9), r.setAttribute(a9, fm);
  var a = Ele();
  return a && r.setAttribute("nonce", a), n.insertBefore(r, i), r;
}, $le = function() {
  function e(t) {
    this.element = v9(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet)
        return n.sheet;
      for (var r = document.styleSheets, o = 0, i = r.length; o < i; o++) {
        var a = r[o];
        if (a.ownerNode === n)
          return a;
      }
      throw Ba(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch (r) {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n && n.cssText ? n.cssText : "";
  }, e;
}(), Ole = function() {
  function e(t) {
    this.element = v9(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var r = document.createTextNode(n);
      return this.element.insertBefore(r, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), _le = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), j$ = AC, Nle = { isServer: !AC, useCSSOMInjection: !rle }, Xh = function() {
  function e(t, n, r) {
    t === void 0 && (t = Kc), n === void 0 && (n = {});
    var o = this;
    this.options = no(no({}, Nle), t), this.gs = n, this.names = new Map(r), this.server = !!t.isServer, !this.server && AC && j$ && (j$ = !1, function(i) {
      for (var a = document.querySelectorAll(Cle), s = 0, l = a.length; s < l; s++) {
        var u = a[s];
        u && u.getAttribute(wl) !== i9 && (wle(i, u), u.parentNode && u.parentNode.removeChild(u));
      }
    }(this)), kC(this, function() {
      return function(i) {
        for (var a = i.getTag(), s = a.length, l = "", u = function(p) {
          var h = function(C) {
            return Yh.get(C);
          }(p);
          if (h === void 0)
            return "continue";
          var y = i.names.get(h), b = a.getGroup(p);
          if (y === void 0 || b.length === 0)
            return "continue";
          var m = "".concat(wl, ".g").concat(p, '[id="').concat(h, '"]'), v = "";
          y !== void 0 && y.forEach(function(C) {
            C.length > 0 && (v += "".concat(C, ","));
          }), l += "".concat(b).concat(m, '{content:"').concat(v, '"}').concat(LC);
        }, f = 0; f < s; f++)
          u(f);
        return l;
      }(o);
    });
  }
  return e.registerId = function(t) {
    return jp(t);
  }, e.prototype.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(no(no({}, this.options), t), this.gs, n && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(n) {
      var r = n.useCSSOMInjection, o = n.target;
      return n.isServer ? new _le(o) : r ? new $le(o) : new Ole(o);
    }(this.options), new yle(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, e.prototype.registerName = function(t, n) {
    if (jp(t), this.names.has(t))
      this.names.get(t).add(n);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(n), this.names.set(t, r);
    }
  }, e.prototype.insertRules = function(t, n, r) {
    this.registerName(t, n), this.getTag().insertRules(jp(t), r);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(jp(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), Ple = /&/g, Ile = /^\s*\/\/.*$/gm;
function y9(e, t) {
  return e.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(t, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(t, " ")), n.props = n.props.map(function(r) {
      return "".concat(t, " ").concat(r);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = y9(n.children, t)), n;
  });
}
function Rle(e) {
  var t, n, r, o = e === void 0 ? Kc : e, i = o.options, a = i === void 0 ? Kc : i, s = o.plugins, l = s === void 0 ? pm : s, u = function(h, y, b) {
    return b.startsWith(n) && b.endsWith(n) && b.replaceAll(n, "").length > 0 ? ".".concat(t) : h;
  }, f = l.slice();
  f.push(function(h) {
    h.type === vg && h.value.includes("&") && (h.props[0] = h.props[0].replace(Ple, n).replace(r, u));
  }), a.prefix && f.push(_F), f.push(uO);
  var p = function(h, y, b, m) {
    y === void 0 && (y = ""), b === void 0 && (b = ""), m === void 0 && (m = "&"), t = m, n = y, r = new RegExp("\\".concat(n, "\\b"), "g");
    var v = h.replace(Ile, ""), C = lO(b || y ? "".concat(b, " ").concat(y, " { ").concat(v, " }") : v);
    a.namespace && (C = y9(C, a.namespace));
    var x = [];
    return yd(C, $F(f.concat(OF(function(S) {
      return x.push(S);
    })))), x;
  };
  return p.hash = l.length ? l.reduce(function(h, y) {
    return y.name || Ba(15), el(h, y.name);
  }, c9).toString() : "", p;
}
var Dle = new Xh(), Oy = Rle(), b9 = be.createContext({ shouldForwardProp: void 0, styleSheet: Dle, stylis: Oy });
b9.Consumer;
be.createContext(void 0);
function _y() {
  return Cn(b9);
}
var k$ = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(o, i) {
      i === void 0 && (i = Oy);
      var a = r.name + i.hash;
      o.hasNameForId(r.id, a) || o.insertRules(r.id, a, i(r.rules, a, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = n, kC(this, function() {
      throw Ba(12, String(r.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = Oy), this.name + t.hash;
  }, e;
}(), Tle = function(e) {
  return e >= "A" && e <= "Z";
};
function F$(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var r = e[n];
    if (n === 1 && r === "-" && e[0] === "-")
      return e;
    Tle(r) ? t += "-" + r.toLowerCase() : t += r;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var C9 = function(e) {
  return e == null || e === !1 || e === "";
}, x9 = function(e) {
  var t, n, r = [];
  for (var o in e) {
    var i = e[o];
    e.hasOwnProperty(o) && !C9(i) && (Array.isArray(i) && i.isCss || El(i) ? r.push("".concat(F$(o), ":"), i, ";") : Uc(i) ? r.push.apply(r, Sl(Sl(["".concat(o, " {")], x9(i), !1), ["}"], !1)) : r.push("".concat(F$(o), ": ").concat((t = o, (n = i) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || t in nle || t.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return r;
};
function ws(e, t, n, r) {
  if (C9(e))
    return [];
  if (jC(e))
    return [".".concat(e.styledComponentId)];
  if (El(e)) {
    if (!El(i = e) || i.prototype && i.prototype.isReactComponent || !t)
      return [e];
    var o = e(t);
    return process.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || o instanceof k$ || Uc(o) || o === null || console.error("".concat(f9(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), ws(o, t, n, r);
  }
  var i;
  return e instanceof k$ ? n ? (e.inject(n, r), [e.getName(r)]) : [e] : Uc(e) ? x9(e) : Array.isArray(e) ? Array.prototype.concat.apply(pm, e.map(function(a) {
    return ws(a, t, n, r);
  })) : [e.toString()];
}
function S9(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (El(n) && !jC(n))
      return !1;
  }
  return !0;
}
var Mle = u9(fm), Lle = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && S9(t), this.componentId = n, this.baseHash = el(Mle, n), this.baseStyle = r, Xh.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, n, r) : "";
    if (this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId))
        o = il(o, this.staticRulesId);
      else {
        var i = Ey(ws(this.rules, t, n, r)), a = wy(el(this.baseHash, i) >>> 0);
        if (!n.hasNameForId(this.componentId, a)) {
          var s = r(i, ".".concat(a), void 0, this.componentId);
          n.insertRules(this.componentId, a, s);
        }
        o = il(o, a), this.staticRulesId = a;
      }
    else {
      for (var l = el(this.baseHash, r.hash), u = "", f = 0; f < this.rules.length; f++) {
        var p = this.rules[f];
        if (typeof p == "string")
          u += p, process.env.NODE_ENV !== "production" && (l = el(l, p));
        else if (p) {
          var h = Ey(ws(p, t, n, r));
          l = el(l, h + f), u += h;
        }
      }
      if (u) {
        var y = wy(l >>> 0);
        n.hasNameForId(this.componentId, y) || n.insertRules(this.componentId, y, r(u, ".".concat(y), void 0, this.componentId)), o = il(o, y);
      }
    }
    return o;
  }, e;
}(), Ld = be.createContext(void 0);
Ld.Consumer;
function Ale(e) {
  var t = be.useContext(Ld), n = mr(function() {
    return function(r, o) {
      if (!r)
        throw Ba(14);
      if (El(r)) {
        var i = r(o);
        if (process.env.NODE_ENV !== "production" && (i === null || Array.isArray(i) || typeof i != "object"))
          throw Ba(7);
        return i;
      }
      if (Array.isArray(r) || typeof r != "object")
        throw Ba(8);
      return o ? no(no({}, o), r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? be.createElement(Ld.Provider, { value: n }, e.children) : null;
}
var w0 = {}, B$ = /* @__PURE__ */ new Set();
function jle(e, t, n) {
  var r = jC(e), o = e, i = !S0(e), a = t.attrs, s = a === void 0 ? pm : a, l = t.componentId, u = l === void 0 ? function(E, O) {
    var $ = typeof E != "string" ? "sc" : D$(E);
    w0[$] = (w0[$] || 0) + 1;
    var _ = "".concat($, "-").concat(d9(fm + $ + w0[$]));
    return O ? "".concat(O, "-").concat(_) : _;
  }(t.displayName, t.parentComponentId) : l, f = t.displayName, p = f === void 0 ? function(E) {
    return S0(E) ? "styled.".concat(E) : "Styled(".concat(f9(E), ")");
  }(e) : f, h = t.displayName && t.componentId ? "".concat(D$(t.displayName), "-").concat(t.componentId) : t.componentId || u, y = r && o.attrs ? o.attrs.concat(s).filter(Boolean) : s, b = t.shouldForwardProp;
  if (r && o.shouldForwardProp) {
    var m = o.shouldForwardProp;
    if (t.shouldForwardProp) {
      var v = t.shouldForwardProp;
      b = function(E, O) {
        return m(E, O) && v(E, O);
      };
    } else
      b = m;
  }
  var C = new Lle(n, h, r ? o.componentStyle : void 0);
  function x(E, O) {
    return function($, _, R) {
      var P = $.attrs, I = $.componentStyle, j = $.defaultProps, F = $.foldedComponentIds, A = $.styledComponentId, M = $.target, N = be.useContext(Ld), D = _y(), T = $.shouldForwardProp || D.shouldForwardProp;
      process.env.NODE_ENV !== "production" && GS(A);
      var L = l9(_, N, j) || Kc, z = function(ee, ae, le) {
        for (var ue, ie = no(no({}, ae), { className: void 0, theme: le }), re = 0; re < ee.length; re += 1) {
          var Q = El(ue = ee[re]) ? ue(ie) : ue;
          for (var ce in Q)
            ie[ce] = ce === "className" ? il(ie[ce], Q[ce]) : ce === "style" ? no(no({}, ie[ce]), Q[ce]) : Q[ce];
        }
        return ae.className && (ie.className = il(ie.className, ae.className)), ie;
      }(P, _, L), H = z.as || M, V = {};
      for (var Y in z)
        z[Y] === void 0 || Y[0] === "$" || Y === "as" || Y === "theme" && z.theme === L || (Y === "forwardedAs" ? V.as = z.forwardedAs : T && !T(Y, H) || (V[Y] = z[Y], T || process.env.NODE_ENV !== "development" || tle(Y) || B$.has(Y) || !Sy.has(H) || (B$.add(Y), console.warn('styled-components: it looks like an unknown prop "'.concat(Y, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var Z = function(ee, ae) {
        var le = _y(), ue = ee.generateAndInjectStyles(ae, le.styleSheet, le.stylis);
        return process.env.NODE_ENV !== "production" && GS(ue), ue;
      }(I, z);
      process.env.NODE_ENV !== "production" && $.warnTooManyClasses && $.warnTooManyClasses(Z);
      var oe = il(F, A);
      return Z && (oe += " " + Z), z.className && (oe += " " + z.className), V[S0(H) && !Sy.has(H) ? "class" : "className"] = oe, V.ref = R, eA(H, V);
    }(S, E, O);
  }
  x.displayName = p;
  var S = be.forwardRef(x);
  return S.attrs = y, S.componentStyle = C, S.displayName = p, S.shouldForwardProp = b, S.foldedComponentIds = r ? il(o.foldedComponentIds, o.styledComponentId) : "", S.styledComponentId = h, S.target = r ? o.target : e, Object.defineProperty(S, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(E) {
    this._foldedDefaultProps = r ? function(O) {
      for (var $ = [], _ = 1; _ < arguments.length; _++)
        $[_ - 1] = arguments[_];
      for (var R = 0, P = $; R < P.length; R++)
        $y(O, P[R], !0);
      return O;
    }({}, o.defaultProps, E) : E;
  } }), process.env.NODE_ENV !== "production" && (s9(p, h), S.warnTooManyClasses = /* @__PURE__ */ function(E, O) {
    var $ = {}, _ = !1;
    return function(R) {
      if (!_ && ($[R] = !0, Object.keys($).length >= 200)) {
        var P = O ? ' with the id of "'.concat(O, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(E).concat(P, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), _ = !0, $ = {};
      }
    };
  }(p, h)), kC(S, function() {
    return ".".concat(S.styledComponentId);
  }), i && m9(S, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), S;
}
function H$(e, t) {
  for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}
var z$ = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function FC(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (El(e) || Uc(e))
    return z$(ws(H$(pm, Sl([e], t, !0))));
  var r = e;
  return t.length === 0 && r.length === 1 && typeof r[0] == "string" ? ws(r) : z$(ws(H$(r, t)));
}
function Ny(e, t, n) {
  if (n === void 0 && (n = Kc), !t)
    throw Ba(1, t);
  var r = function(o) {
    for (var i = [], a = 1; a < arguments.length; a++)
      i[a - 1] = arguments[a];
    return e(t, n, FC.apply(void 0, Sl([o], i, !1)));
  };
  return r.attrs = function(o) {
    return Ny(e, t, no(no({}, n), { attrs: Array.prototype.concat(n.attrs, o).filter(Boolean) }));
  }, r.withConfig = function(o) {
    return Ny(e, t, no(no({}, n), o));
  }, r;
}
var w9 = function(e) {
  return Ny(jle, e);
}, Ue = w9;
Sy.forEach(function(e) {
  Ue[e] = w9(e);
});
var kle = function() {
  function e(t, n) {
    this.rules = t, this.componentId = n, this.isStatic = S9(t), Xh.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function(t, n, r, o) {
    var i = o(Ey(ws(this.rules, n, r, o)), ""), a = this.componentId + t;
    r.insertRules(a, a, i);
  }, e.prototype.removeStyles = function(t, n) {
    n.clearRules(this.componentId + t);
  }, e.prototype.renderStyles = function(t, n, r, o) {
    t > 2 && Xh.registerId(this.componentId + t), this.removeStyles(t, r), this.createStyles(t, n, r, o);
  }, e;
}();
function Fle(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  var r = FC.apply(void 0, Sl([e], t, !1)), o = "sc-global-".concat(d9(JSON.stringify(r))), i = new kle(r, o);
  process.env.NODE_ENV !== "production" && s9(o);
  var a = function(l) {
    var u = _y(), f = be.useContext(Ld), p = be.useRef(u.styleSheet.allocateGSInstance(o)).current;
    return process.env.NODE_ENV !== "production" && be.Children.count(l.children) && console.warn("The global style component ".concat(o, " was given child JSX. createGlobalStyle does not render children.")), process.env.NODE_ENV !== "production" && r.some(function(h) {
      return typeof h == "string" && h.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), u.styleSheet.server && s(p, l, u.styleSheet, f, u.stylis), be.useLayoutEffect(function() {
      if (!u.styleSheet.server)
        return s(p, l, u.styleSheet, f, u.stylis), function() {
          return i.removeStyles(p, u.styleSheet);
        };
    }, [p, l, u.styleSheet, f, u.stylis]), null;
  };
  function s(l, u, f, p, h) {
    if (i.isStatic)
      i.renderStyles(l, ole, f, h);
    else {
      var y = no(no({}, u), { theme: l9(u, p, a.defaultProps) });
      i.renderStyles(l, y, f, h);
    }
  }
  return be.memo(a);
}
process.env.NODE_ENV !== "production" && typeof navigator != "undefined" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var kp = "__sc-".concat(wl, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window != "undefined" && (window[kp] || (window[kp] = 0), window[kp] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[kp] += 1);
const Ble = Ue.div`
  height: 56px;
  padding: 8px 20px 8px 16px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: ${Ht[10]};
`, Hle = Ue.p`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.15px;
  color: ${Ht[100]};
`, zle = Ue.a`
  border: none;
  background-color: ${vr[60]};
  padding: 10px 16px;
  color: ${Ht[0]};
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    color: ${Ht[0]};
  }
`;
function Vle() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    typeof t[0] == "string" && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const V$ = {};
function Py() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && V$[t[0]] || (typeof t[0] == "string" && (V$[t[0]] = /* @__PURE__ */ new Date()), Vle(...t));
}
const E9 = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
};
function W$(e, t, n) {
  e.loadNamespaces(t, E9(e, n));
}
function K$(e, t, n, r) {
  typeof n == "string" && (n = [n]), n.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, E9(e, r));
}
function Wle(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = t.languages[0], o = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  const a = (s, l) => {
    const u = t.services.backendConnector.state[`${s}|${l}`];
    return u === -1 || u === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(r, e) && (!o || a(i, e)));
}
function Kle(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? (Py("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: (o, i) => {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !i(o.isLanguageChangingTo, e))
        return !1;
    }
  }) : Wle(e, t, n);
}
const Ule = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Gle = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, qle = (e) => Gle[e], Yle = (e) => e.replace(Ule, qle);
let Iy = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Yle
};
function Xle() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Iy = je(je({}, Iy), e);
}
function Zle() {
  return Iy;
}
let $9;
function Qle(e) {
  $9 = e;
}
function Jle() {
  return $9;
}
const ece = {
  type: "3rdParty",
  init(e) {
    Xle(e.options.react), Qle(e);
  }
}, tce = Rs();
class nce {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const rce = (e, t) => {
  const n = _t();
  return kt(() => {
    n.current = t ? n.current : e;
  }, [e, t]), n.current;
};
function oo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: o
  } = Cn(tce) || {}, i = n || r || Jle();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new nce()), !i) {
    Py("You will need to pass in an i18next instance by using initReactI18next");
    const S = (O, $) => typeof $ == "string" ? $ : $ && typeof $ == "object" && typeof $.defaultValue == "string" ? $.defaultValue : Array.isArray(O) ? O[O.length - 1] : O, E = [S, {}, !1];
    return E.t = S, E.i18n = {}, E.ready = !1, E;
  }
  i.options.react && i.options.react.wait !== void 0 && Py("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = je(je(je({}, Zle()), i.options.react), t), {
    useSuspense: s,
    keyPrefix: l
  } = a;
  let u = e || o || i.options && i.options.defaultNS;
  u = typeof u == "string" ? [u] : u || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(u);
  const f = (i.isInitialized || i.initializedStoreOnce) && u.every((S) => Kle(S, i, a));
  function p() {
    return i.getFixedT(t.lng || null, a.nsMode === "fallback" ? u : u[0], l);
  }
  const [h, y] = Ot(p);
  let b = u.join();
  t.lng && (b = `${t.lng}${b}`);
  const m = rce(b), v = _t(!0);
  kt(() => {
    const {
      bindI18n: S,
      bindI18nStore: E
    } = a;
    v.current = !0, !f && !s && (t.lng ? K$(i, t.lng, u, () => {
      v.current && y(p);
    }) : W$(i, u, () => {
      v.current && y(p);
    })), f && m && m !== b && v.current && y(p);
    function O() {
      v.current && y(p);
    }
    return S && i && i.on(S, O), E && i && i.store.on(E, O), () => {
      v.current = !1, S && i && S.split(" ").forEach(($) => i.off($, O)), E && i && E.split(" ").forEach(($) => i.store.off($, O));
    };
  }, [i, b]);
  const C = _t(!0);
  kt(() => {
    v.current && !C.current && y(p), C.current = !1;
  }, [i, l]);
  const x = [h, i, f];
  if (x.t = h, x.i18n = i, x.ready = f, f || !f && !s)
    return x;
  throw new Promise((S) => {
    t.lng ? K$(i, t.lng, u, () => S()) : W$(i, u, () => S());
  });
}
const oce = () => {
  const { t: e } = oo(), t = Ya();
  return /* @__PURE__ */ B.jsxs(Ble, { children: [
    /* @__PURE__ */ B.jsx(Hle, { children: e("atoms.smart_event_calendar_header.styled_text_title_text") }),
    /* @__PURE__ */ B.jsxs(
      zle,
      {
        onClick: () => {
          t("/create-plan");
        },
        children: [
          /* @__PURE__ */ B.jsx(kh, {}),
          " ",
          e("atoms.smart_event_calendar_header.styled_button_text")
        ]
      }
    )
  ] });
}, ice = Ue(pne)`
  .smv-steps-item-icon {
    background-color: transparent !important;
  }
  .smv-steps-item-title {
    color: ${Ht[50]} !important;
  }
  .smv-steps-item-wait .smv-steps-item-icon {
    border-color: ${Ht[50]} !important;
  }
  .smv-steps-icon {
    color: ${({ theme: e }) => e.token.colorPrimary} !important;
  }
  .smv-steps-item-wait .smv-steps-item-icon > .smv-steps-icon {
    color: ${Ht[50]} !important;
  }
  .smv-steps-item-process .smv-steps-item-icon {
    background-color: ${({ theme: e }) => e.token.colorPrimary} !important;
  }
  .smv-steps-item-process .smv-steps-item-icon > .smv-steps-icon {
    color: ${Ht[0]} !important;
  }
`, E0 = ({ items: e, current: t }) => /* @__PURE__ */ B.jsx(ice, { size: "small", current: t, items: e }), ace = ({ children: e }) => /* @__PURE__ */ B.jsx(Dee.Content, { style: { overflow: "visible" }, children: e }), sce = Ue.div`
  width: 100%;
  border-bottom: 1px solid #ddd;
`, lce = ({ children: e }) => /* @__PURE__ */ B.jsx(sce, { children: e }), BC = () => {
  const t = btoa(`
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-label="alert triangle icon"
  id="alert-triangle-icon"
>
  <path
    d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z"
    fill="#E99921"
  />
</svg>`);
  return /* @__PURE__ */ B.jsx(
    "img",
    {
      src: `data:image/svg+xml;base64,${t}`,
      alt: "alert triangle icon",
      id: "close-icon"
    }
  );
}, HC = ({ width: e = 24, height: t = 24 }) => {
  const n = `
    <svg xmlns='http://www.w3.org/2000/svg' width='${e}' height='${t}' viewBox='0 0 24 24' fill='currentColor'>
      <path d='M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z'/>
    </svg>`, r = btoa(n);
  return /* @__PURE__ */ B.jsx(
    "img",
    {
      src: `data:image/svg+xml;base64,${r}`,
      alt: "chevron left icon",
      id: "chevron-left-icon",
      width: e,
      height: t,
      style: { fill: "currentColor" }
    }
  );
}, cce = Ue.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: transparent;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.15px;
  color: ${Ht[100]};
`, uce = {
  backgroundColor: Ht[0],
  border: "1px",
  borderColor: Ht[30],
  borderStyle: "solid",
  borderRadius: "4px",
  fontSize: "14px",
  color: Ht[100]
}, dce = {
  backgroundColor: Ht[10],
  border: "none",
  borderRadius: "4px",
  color: fu[50],
  fontSize: "14px"
}, $0 = ({
  navigateUrl: e
}) => {
  const t = Ya(), n = Cn(Si), r = () => {
    e === "/" && n.setFormData({
      create_operation: [],
      create_plan: {},
      fields: [],
      workers: [],
      inspection_groups_fetch: []
    }), t(e);
  }, { t: o } = oo();
  return /* @__PURE__ */ B.jsx(
    gC,
    {
      title: o("molecules.confirmation_dialog.alert_title"),
      description: o("molecules.confirmation_dialog.alert_description"),
      okText: o("molecules.confirmation_dialog.alert_ok_text"),
      cancelText: o("molecules.confirmation_dialog.alert_cancel_text"),
      placement: "bottomLeft",
      cancelButtonProps: {
        style: uce
      },
      okButtonProps: {
        style: dce
      },
      okType: "danger",
      icon: /* @__PURE__ */ B.jsx(BC, {}),
      onConfirm: r,
      children: /* @__PURE__ */ B.jsxs(cce, { children: [
        /* @__PURE__ */ B.jsx(HC, {}),
        o("molecules.confirmation_dialog.chevron_left_icon")
      ] })
    }
  );
}, fce = ({
  children: e
}) => {
  var o;
  const { pathname: t } = qa(), n = [
    {
      title: "Basic information"
    },
    {
      title: "Fields"
    },
    {
      title: "Operations"
    }
  ], r = {
    "/create-plan": /* @__PURE__ */ B.jsxs(oh, { style: { marginBottom: 14, marginTop: 14, marginRight: 25 }, children: [
      /* @__PURE__ */ B.jsx(ds, { span: 12, children: /* @__PURE__ */ B.jsx($0, { navigateUrl: "/" }) }),
      /* @__PURE__ */ B.jsx(ds, { span: 12, children: /* @__PURE__ */ B.jsx(E0, { current: 0, items: n }) })
    ] }),
    [String((o = lse("/create-plan/:season/fields")) == null ? void 0 : o.pathname)]: /* @__PURE__ */ B.jsxs(oh, { style: { marginBottom: 14, marginTop: 14, marginRight: 25 }, children: [
      /* @__PURE__ */ B.jsx(ds, { span: 12, children: /* @__PURE__ */ B.jsx($0, { navigateUrl: "/" }) }),
      /* @__PURE__ */ B.jsx(ds, { span: 12, children: /* @__PURE__ */ B.jsx(E0, { current: 1, items: n }) })
    ] }),
    "/create-operation": /* @__PURE__ */ B.jsxs(oh, { style: { marginBottom: 14, marginTop: 14, marginRight: 25 }, children: [
      /* @__PURE__ */ B.jsx(ds, { span: 12, children: /* @__PURE__ */ B.jsx($0, { navigateUrl: "/" }) }),
      /* @__PURE__ */ B.jsx(ds, { span: 12, children: /* @__PURE__ */ B.jsx(E0, { current: 2, items: n }) })
    ] }),
    "/": /* @__PURE__ */ B.jsx(zc, { children: /* @__PURE__ */ B.jsx(oce, {}) })
  };
  return /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
    /* @__PURE__ */ B.jsx(lce, { children: r[t] }),
    /* @__PURE__ */ B.jsx(ace, { children: e })
  ] });
}, pce = (e, t) => {
  const n = e[t];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((r, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(o.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, hce = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class Zh {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || hce, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, o) {
    return o && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new Zh(this.logger, je({
      prefix: `${this.prefix}:${t}:`
    }, this.options));
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Zh(this.logger, t);
  }
}
var sa = new Zh();
class hm {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const o = this.observers[r].get(n) || 0;
      this.observers[r].set(n, o + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((a) => {
      let [s, l] = a;
      for (let u = 0; u < l; u++)
        s(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [s, l] = a;
      for (let u = 0; u < l; u++)
        s.apply(s, [t, ...r]);
    });
  }
}
function Ku() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function U$(e) {
  return e == null ? "" : "" + e;
}
function gce(e, t, n) {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}
const mce = /###/g;
function fd(e, t, n) {
  function r(s) {
    return s && s.indexOf("###") > -1 ? s.replace(mce, ".") : s;
  }
  function o() {
    return !e || typeof e == "string";
  }
  const i = typeof t != "string" ? t : t.split(".");
  let a = 0;
  for (; a < i.length - 1; ) {
    if (o())
      return {};
    const s = r(i[a]);
    !e[s] && n && (e[s] = new n()), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {}, ++a;
  }
  return o() ? {} : {
    obj: e,
    k: r(i[a])
  };
}
function G$(e, t, n) {
  const {
    obj: r,
    k: o
  } = fd(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[o] = n;
    return;
  }
  let i = t[t.length - 1], a = t.slice(0, t.length - 1), s = fd(e, a, Object);
  for (; s.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), s = fd(e, a, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] != "undefined" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}
function vce(e, t, n, r) {
  const {
    obj: o,
    k: i
  } = fd(e, t, Object);
  o[i] = o[i] || [], r && (o[i] = o[i].concat(n)), r || o[i].push(n);
}
function Qh(e, t) {
  const {
    obj: n,
    k: r
  } = fd(e, t);
  if (n)
    return n[r];
}
function yce(e, t, n) {
  const r = Qh(e, n);
  return r !== void 0 ? r : Qh(t, n);
}
function O9(e, t, n) {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : O9(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function cc(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var bce = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function Cce(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => bce[t]) : e;
}
class xce {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const Sce = [" ", ",", "?", "!", ";"], wce = new xce(20);
function Ece(e, t, n) {
  t = t || "", n = n || "";
  const r = Sce.filter((a) => t.indexOf(a) < 0 && n.indexOf(a) < 0);
  if (r.length === 0)
    return !0;
  const o = wce.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !o.test(e);
  if (!i) {
    const a = e.indexOf(n);
    a > 0 && !o.test(e.substring(0, a)) && (i = !0);
  }
  return i;
}
function Ry(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let o = e;
  for (let i = 0; i < r.length; ) {
    if (!o || typeof o != "object")
      return;
    let a, s = "";
    for (let l = i; l < r.length; ++l)
      if (l !== i && (s += n), s += r[l], a = o[s], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < r.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    o = a;
  }
  return o;
}
function Jh(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class q$ extends hm {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, a = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : typeof r == "string" && i ? s.push(...r.split(i)) : s.push(r)));
    const l = Qh(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !a || typeof r != "string" ? l : Ry(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, o) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(a ? r.split(a) : r)), t.indexOf(".") > -1 && (s = t.split("."), o = n, n = s[1]), this.addNamespaces(n), G$(this.data, s, o), i.silent || this.emit("added", t, n, r, o);
  }
  addResources(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (typeof r[i] == "string" || Object.prototype.toString.apply(r[i]) === "[object Array]") && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    o.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, o, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), o = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = Qh(this.data, s) || {};
    o ? O9(l, r, i) : l = je(je({}, l), r), G$(this.data, s, l), a.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? je({}, this.getResource(t, n)) : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var _9 = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, o) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, o));
    }), t;
  }
};
const Y$ = {};
class eg extends hm {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), gce(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = sa.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const a = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !Ece(t, r, o);
    if (a && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: i
        };
      const u = t.split(r);
      (r !== o || r === o && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), t = u.join(o);
    }
    return typeof i == "string" && (i = [i]), {
      key: t,
      namespaces: i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = je({}, n)), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const o = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], u = n.lng || this.language, f = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (f) {
        const E = n.nsSeparator || this.options.nsSeparator;
        return o ? {
          res: `${l}${E}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: u,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${E}${a}`;
      }
      return o ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: u,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : a;
    }
    const p = this.resolve(t, n);
    let h = p && p.res;
    const y = p && p.usedKey || a, b = p && p.exactUsedKey || a, m = Object.prototype.toString.apply(h), v = ["[object Number]", "[object Function]", "[object RegExp]"], C = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (x && h && (typeof h != "string" && typeof h != "boolean" && typeof h != "number") && v.indexOf(m) < 0 && !(typeof C == "string" && m === "[object Array]")) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const E = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(y, h, Bt(je({}, n), {
          ns: s
        })) : `key '${a} (${this.language})' returned an object instead of string.`;
        return o ? (p.res = E, p.usedParams = this.getUsedParamsDetails(n), p) : E;
      }
      if (i) {
        const E = m === "[object Array]", O = E ? [] : {}, $ = E ? b : y;
        for (const _ in h)
          if (Object.prototype.hasOwnProperty.call(h, _)) {
            const R = `${$}${i}${_}`;
            O[_] = this.translate(R, Bt(je({}, n), {
              joinArrays: !1,
              ns: s
            })), O[_] === R && (O[_] = h[_]);
          }
        h = O;
      }
    } else if (x && typeof C == "string" && m === "[object Array]")
      h = h.join(C), h && (h = this.extendTranslation(h, t, n, r));
    else {
      let E = !1, O = !1;
      const $ = n.count !== void 0 && typeof n.count != "string", _ = eg.hasDefaultValue(n), R = $ ? this.pluralResolver.getSuffix(u, n.count, n) : "", P = n.ordinal && $ ? this.pluralResolver.getSuffix(u, n.count, {
        ordinal: !1
      }) : "", I = $ && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), j = I && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${R}`] || n[`defaultValue${P}`] || n.defaultValue;
      !this.isValidLookup(h) && _ && (E = !0, h = j), this.isValidLookup(h) || (O = !0, h = a);
      const A = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && O ? void 0 : h, M = _ && j !== h && this.options.updateMissing;
      if (O || E || M) {
        if (this.logger.log(M ? "updateKey" : "missingKey", u, l, a, M ? j : h), i) {
          const L = this.resolve(a, Bt(je({}, n), {
            keySeparator: !1
          }));
          L && L.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let N = [];
        const D = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && D && D[0])
          for (let L = 0; L < D.length; L++)
            N.push(D[L]);
        else
          this.options.saveMissingTo === "all" ? N = this.languageUtils.toResolveHierarchy(n.lng || this.language) : N.push(n.lng || this.language);
        const T = (L, z, H) => {
          const V = _ && H !== h ? H : A;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(L, l, z, V, M, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(L, l, z, V, M, n), this.emit("missingKey", L, l, z, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && $ ? N.forEach((L) => {
          const z = this.pluralResolver.getSuffixes(L, n);
          I && n[`defaultValue${this.options.pluralSeparator}zero`] && z.indexOf(`${this.options.pluralSeparator}zero`) < 0 && z.push(`${this.options.pluralSeparator}zero`), z.forEach((H) => {
            T([L], a + H, n[`defaultValue${H}`] || j);
          });
        }) : T(N, a, j));
      }
      h = this.extendTranslation(h, t, n, p, r), O && h === a && this.options.appendNamespaceToMissingKey && (h = `${l}:${a}`), (O || E) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, E ? h : void 0) : h = this.options.parseMissingKeyHandler(h));
    }
    return o ? (p.res = h, p.usedParams = this.getUsedParamsDetails(n), p) : h;
  }
  extendTranslation(t, n, r, o, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, je(je({}, this.options.interpolation.defaultVariables), r), r.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init(Bt(je({}, r), {
        interpolation: je(je({}, this.options.interpolation), r.interpolation)
      }));
      const u = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let f;
      if (u) {
        const h = t.match(this.interpolator.nestingRegexp);
        f = h && h.length;
      }
      let p = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (p = je(je({}, this.options.interpolation.defaultVariables), p)), t = this.interpolator.interpolate(t, p, r.lng || this.language, r), u) {
        const h = t.match(this.interpolator.nestingRegexp), y = h && h.length;
        f < y && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && o && o.res && (r.lng = o.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var h = arguments.length, y = new Array(h), b = 0; b < h; b++)
          y[b] = arguments[b];
        return i && i[0] === y[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${y[0]} in key: ${n[0]}`), null) : a.translate(...y, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = typeof s == "string" ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = _9.handle(l, t, n, this.options && this.options.postProcessPassResolved ? je({
      i18nResolved: Bt(je({}, o), {
        usedParams: this.getUsedParamsDetails(r)
      })
    }, r) : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, o, i, a, s;
    return typeof t == "string" && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const u = this.extractFromKey(l, n), f = u.key;
      o = f;
      let p = u.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const h = n.count !== void 0 && typeof n.count != "string", y = h && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), b = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", m = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      p.forEach((v) => {
        this.isValidLookup(r) || (s = v, !Y$[`${m[0]}-${v}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Y$[`${m[0]}-${v}`] = !0, this.logger.warn(`key "${o}" for languages "${m.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((C) => {
          if (this.isValidLookup(r))
            return;
          a = C;
          const x = [f];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, f, C, v, n);
          else {
            let E;
            h && (E = this.pluralResolver.getSuffix(C, n.count, n));
            const O = `${this.options.pluralSeparator}zero`, $ = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (x.push(f + E), n.ordinal && E.indexOf($) === 0 && x.push(f + E.replace($, this.options.pluralSeparator)), y && x.push(f + O)), b) {
              const _ = `${f}${this.options.contextSeparator}${n.context}`;
              x.push(_), h && (x.push(_ + E), n.ordinal && E.indexOf($) === 0 && x.push(_ + E.replace($, this.options.pluralSeparator)), y && x.push(_ + O));
            }
          }
          let S;
          for (; S = x.pop(); )
            this.isValidLookup(r) || (i = S, r = this.getResource(C, v, S, n));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: i,
      usedLng: a,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, o) : this.resourceStore.getResource(t, n, r, o);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && typeof t.replace != "string";
    let o = r ? t.replace : t;
    if (r && typeof t.count != "undefined" && (o.count = t.count), this.options.interpolation.defaultVariables && (o = je(je({}, this.options.interpolation.defaultVariables), o)), !r) {
      o = je({}, o);
      for (const i of n)
        delete o[i];
    }
    return o;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
function O0(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class X$ {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = sa.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Jh(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Jh(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((o) => o.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = O0(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = O0(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = O0(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const o = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(o))
        return n = o;
      n = this.options.supportedLngs.find((i) => {
        if (i === o)
          return i;
        if (!(i.indexOf("-") < 0 && o.indexOf("-") < 0) && i.indexOf(o) === 0)
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Object.prototype.toString.apply(t) === "[object Array]")
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), o = [], i = (a) => {
      a && (this.isSupportedCode(a) ? o.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : typeof t == "string" && i(this.formatLanguageCode(t)), r.forEach((a) => {
      o.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), o;
  }
}
let $ce = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Oce = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const _ce = ["v1", "v2", "v3"], Nce = ["v4"], Z$ = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function Pce() {
  const e = {};
  return $ce.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: Oce[t.fc]
      };
    });
  }), e;
}
class Ice {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = sa.create("pluralResolver"), (!this.options.compatibilityJSON || Nce.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Pce();
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(Jh(t === "dev" ? "en" : t), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch (r) {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((o) => `${n}${o}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((o, i) => Z$[o] - Z$[i]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : r.numbers.map((o) => this.getSuffix(t, o, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const o = this.getRule(t, r);
    return o ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : this.getSuffixRetroCompatible(o, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let o = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
    const i = () => this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? `_plural_${o.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !_ce.includes(this.options.compatibilityJSON);
  }
}
function Q$(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = yce(e, t, n);
  return !i && o && typeof n == "string" && (i = Ry(e, n, r), i === void 0 && (i = Ry(t, n, r))), i;
}
class Rce {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = sa.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const n = t.interpolation;
    this.escape = n.escape !== void 0 ? n.escape : Cce, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? cc(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? cc(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? cc(n.nestingPrefix) : n.nestingPrefixEscaped || cc("$t("), this.nestingSuffix = n.nestingSuffix ? cc(n.nestingSuffix) : n.nestingSuffixEscaped || cc(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, o) {
    let i, a, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function u(b) {
      return b.replace(/\$/g, "$$$$");
    }
    const f = (b) => {
      if (b.indexOf(this.formatSeparator) < 0) {
        const x = Q$(n, l, b, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(x, void 0, r, Bt(je(je({}, o), n), {
          interpolationkey: b
        })) : x;
      }
      const m = b.split(this.formatSeparator), v = m.shift().trim(), C = m.join(this.formatSeparator).trim();
      return this.format(Q$(n, l, v, this.options.keySeparator, this.options.ignoreJSONStructure), C, r, Bt(je(je({}, o), n), {
        interpolationkey: v
      }));
    };
    this.resetRegExp();
    const p = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, h = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (b) => u(b)
    }, {
      regex: this.regexp,
      safeValue: (b) => this.escapeValue ? u(this.escape(b)) : u(b)
    }].forEach((b) => {
      for (s = 0; i = b.regex.exec(t); ) {
        const m = i[1].trim();
        if (a = f(m), a === void 0)
          if (typeof p == "function") {
            const C = p(t, i, o);
            a = typeof C == "string" ? C : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, m))
            a = "";
          else if (h) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), a = "";
        else
          typeof a != "string" && !this.useRawValueToEscape && (a = U$(a));
        const v = b.safeValue(a);
        if (t = t.replace(i[0], v), h ? (b.regex.lastIndex += a.length, b.regex.lastIndex -= i[0].length) : b.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, i, a;
    function s(l, u) {
      const f = this.nestingOptionsSeparator;
      if (l.indexOf(f) < 0)
        return l;
      const p = l.split(new RegExp(`${f}[ ]*{`));
      let h = `{${p[1]}`;
      l = p[0], h = this.interpolate(h, a);
      const y = h.match(/'/g), b = h.match(/"/g);
      (y && y.length % 2 === 0 && !b || b.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        a = JSON.parse(h), u && (a = je(je({}, u), a));
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${f}${h}`;
      }
      return delete a.defaultValue, l;
    }
    for (; o = this.nestingRegexp.exec(t); ) {
      let l = [];
      a = je({}, r), a = a.replace && typeof a.replace != "string" ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let u = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const f = o[1].split(this.formatSeparator).map((p) => p.trim());
        o[1] = f.shift(), l = f, u = !0;
      }
      if (i = n(s.call(this, o[1].trim(), a), a), i && o[0] === t && typeof i != "string")
        return i;
      typeof i != "string" && (i = U$(i)), i || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${t}`), i = ""), u && (i = l.reduce((f, p) => this.format(f, p, r.lng, Bt(je({}, r), {
        interpolationkey: o[1].trim()
      })), i.trim())), t = t.replace(o[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
function Dce(e) {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    t === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : t === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((a) => {
      if (!a)
        return;
      const [s, ...l] = a.split(":"), u = l.join(":").trim().replace(/^'+|'+$/g, "");
      n[s.trim()] || (n[s.trim()] = u), u === "false" && (n[s.trim()] = !1), u === "true" && (n[s.trim()] = !0), isNaN(u) || (n[s.trim()] = parseInt(u, 10));
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function uc(e) {
  const t = {};
  return function(r, o, i) {
    const a = o + JSON.stringify(i);
    let s = t[a];
    return s || (s = e(Jh(o), i), t[a] = s), s(r);
  };
}
class Tce {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = sa.create("formatter"), this.options = t, this.formats = {
      number: uc((n, r) => {
        const o = new Intl.NumberFormat(n, je({}, r));
        return (i) => o.format(i);
      }),
      currency: uc((n, r) => {
        const o = new Intl.NumberFormat(n, Bt(je({}, r), {
          style: "currency"
        }));
        return (i) => o.format(i);
      }),
      datetime: uc((n, r) => {
        const o = new Intl.DateTimeFormat(n, je({}, r));
        return (i) => o.format(i);
      }),
      relativetime: uc((n, r) => {
        const o = new Intl.RelativeTimeFormat(n, je({}, r));
        return (i) => o.format(i, r.range || "day");
      }),
      list: uc((n, r) => {
        const o = new Intl.ListFormat(n, je({}, r));
        return (i) => o.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = uc(n);
  }
  format(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((s, l) => {
      const {
        formatName: u,
        formatOptions: f
      } = Dce(l);
      if (this.formats[u]) {
        let p = s;
        try {
          const h = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, y = h.locale || h.lng || o.locale || o.lng || r;
          p = this.formats[u](s, y, je(je(je({}, f), o), h));
        } catch (h) {
          this.logger.warn(h);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return s;
    }, t);
  }
}
function Mce(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
class Lce extends hm {
  constructor(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = sa.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, o.backend, o);
  }
  queueLoad(t, n, r, o) {
    const i = {}, a = {}, s = {}, l = {};
    return t.forEach((u) => {
      let f = !0;
      n.forEach((p) => {
        const h = `${u}|${p}`;
        !r.reload && this.store.hasResourceBundle(u, p) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? a[h] === void 0 && (a[h] = !0) : (this.state[h] = 1, f = !1, a[h] === void 0 && (a[h] = !0), i[h] === void 0 && (i[h] = !0), l[p] === void 0 && (l[p] = !0)));
      }), f || (s[u] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const o = t.split("|"), i = o[0], a = o[1];
    n && this.emit("failedLoading", i, a, n), r && this.store.addResourceBundle(i, a, r), this.state[t] = n ? -1 : 2;
    const s = {};
    this.queue.forEach((l) => {
      vce(l.loaded, [i], a), Mce(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((u) => {
        s[u] || (s[u] = {});
        const f = l.loaded[u];
        f.length && f.forEach((p) => {
          s[u][p] === void 0 && (s[u][p] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: o,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const s = (u, f) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (u && f && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, o + 1, i * 2, a);
        }, i);
        return;
      }
      a(u, f);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const u = l(t, n);
        u && typeof u.then == "function" ? u.then((f) => s(null, f)).catch(s) : s(null, u);
      } catch (u) {
        s(u);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const i = this.queueLoad(t, n, r, o);
    if (!i.toLoad.length)
      return i.pending.length || o(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), o = r[0], i = r[1];
    this.read(o, i, "read", void 0, void 0, (a, s) => {
      a && this.logger.warn(`${n}loading namespace ${i} for language ${o} failed`, a), !a && s && this.logger.log(`${n}loaded namespace ${i} for language ${o}`, s), this.loaded(t, a, s);
    });
  }
  saveMissing(t, n, r, o, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = Bt(je({}, a), {
          isUpdate: i
        }), u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let f;
            u.length === 5 ? f = u(t, n, r, o, l) : f = u(t, n, r, o), f && typeof f.then == "function" ? f.then((p) => s(null, p)).catch(s) : s(null, f);
          } catch (f) {
            s(f);
          }
        else
          u(t, n, r, o, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, o);
    }
  }
}
function J$() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      let n = {};
      if (typeof t[1] == "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
        const r = t[3] || t[2];
        Object.keys(r).forEach((o) => {
          n[o] = r[o];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: (e) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function e3(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function Fp() {
}
function Ace(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
}
class Ad extends hm {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = e3(t), this.services = {}, this.logger = sa, this.modules = {
      external: []
    }, Ace(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const o = J$();
    this.options = je(je(je({}, o), this.options), e3(n)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = je(je({}, o.interpolation), this.options.interpolation)), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function i(f) {
      return f ? typeof f == "function" ? new f() : f : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? sa.init(i(this.modules.logger), this.options) : sa.init(null, this.options);
      let f;
      this.modules.formatter ? f = this.modules.formatter : typeof Intl != "undefined" && (f = Tce);
      const p = new X$(this.options);
      this.store = new q$(this.options.resources, this.options);
      const h = this.services;
      h.logger = sa, h.resourceStore = this.store, h.languageUtils = p, h.pluralResolver = new Ice(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), f && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (h.formatter = i(f), h.formatter.init(h, this.options), this.options.interpolation.format = h.formatter.format.bind(h.formatter)), h.interpolator = new Rce(this.options), h.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, h.backendConnector = new Lce(i(this.modules.backend), h.resourceStore, h, this.options), h.backendConnector.on("*", function(y) {
        for (var b = arguments.length, m = new Array(b > 1 ? b - 1 : 0), v = 1; v < b; v++)
          m[v - 1] = arguments[v];
        t.emit(y, ...m);
      }), this.modules.languageDetector && (h.languageDetector = i(this.modules.languageDetector), h.languageDetector.init && h.languageDetector.init(h, this.options.detection, this.options)), this.modules.i18nFormat && (h.i18nFormat = i(this.modules.i18nFormat), h.i18nFormat.init && h.i18nFormat.init(this)), this.translator = new eg(this.services, this.options), this.translator.on("*", function(y) {
        for (var b = arguments.length, m = new Array(b > 1 ? b - 1 : 0), v = 1; v < b; v++)
          m[v - 1] = arguments[v];
        t.emit(y, ...m);
      }), this.modules.external.forEach((y) => {
        y.init && y.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Fp), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const f = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      f.length > 0 && f[0] !== "dev" && (this.options.lng = f[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((f) => {
      this[f] = function() {
        return t.store[f](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((f) => {
      this[f] = function() {
        return t.store[f](...arguments), t;
      };
    });
    const l = Ku(), u = () => {
      const f = (p, h) => {
        this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(h), r(p, h);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return f(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, f);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), l;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fp;
    const o = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (o && o.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const i = [], a = (s) => {
        if (!s || s === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((u) => {
          u !== "cimode" && i.indexOf(u) < 0 && i.push(u);
        });
      };
      o ? a(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((s) => a(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(s);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const o = Ku();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = Fp), this.services.backendConnector.reload(t, n, (i) => {
      o.resolve(), r(i);
    }), o;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && _9.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const o = Ku();
    this.emit("languageChanging", t);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, u) => {
      u ? (i(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, o.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const u = typeof l == "string" ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      u && (this.language || i(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (f) => {
        a(f, u);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), o;
  }
  getFixedT(t, n, r) {
    var o = this;
    const i = function(a, s) {
      let l;
      if (typeof s != "object") {
        for (var u = arguments.length, f = new Array(u > 2 ? u - 2 : 0), p = 2; p < u; p++)
          f[p - 2] = arguments[p];
        l = o.options.overloadTranslationOptionHandler([a, s].concat(f));
      } else
        l = je({}, s);
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix = l.keyPrefix || r || i.keyPrefix;
      const h = o.options.keySeparator || ".";
      let y;
      return l.keyPrefix && Array.isArray(a) ? y = a.map((b) => `${l.keyPrefix}${h}${b}`) : y = l.keyPrefix ? `${l.keyPrefix}${h}${a}` : a, o.t(y, l);
    };
    return typeof t == "string" ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const a = (s, l) => {
      const u = this.services.backendConnector.state[`${s}|${l}`];
      return u === -1 || u === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, a);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, t) && (!o || a(i, t)));
  }
  loadNamespaces(t, n) {
    const r = Ku();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Ku();
    typeof t == "string" && (t = [t]);
    const o = this.options.preload || [], i = t.filter((a) => o.indexOf(a) < 0);
    return i.length ? (this.options.preload = o.concat(i), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new X$(J$());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Ad(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Fp;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const o = Bt(je(je({}, this.options), t), {
      isClone: !0
    }), i = new Ad(o);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = je({}, this.services), i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new q$(this.store.data, o), i.services.resourceStore = i.store), i.translator = new eg(i.services, o), i.translator.on("*", function(s) {
      for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), f = 1; f < l; f++)
        u[f - 1] = arguments[f];
      i.emit(s, ...u);
    }), i.init(o, n), i.translator.options = o, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Zr = Ad.createInstance();
Zr.createInstance = Ad.createInstance;
Zr.createInstance;
Zr.dir;
Zr.init;
Zr.loadResources;
Zr.reloadResources;
Zr.use;
Zr.changeLanguage;
Zr.getFixedT;
Zr.t;
Zr.exists;
Zr.setDefaultNamespace;
Zr.hasLoadedNamespace;
Zr.loadNamespaces;
Zr.loadLanguages;
function N9(e, t, n) {
  function r(s) {
    return s && s.indexOf("###") > -1 ? s.replace(/###/g, ".") : s;
  }
  function o() {
    return !e || typeof e == "string";
  }
  for (var i = typeof t != "string" ? [].concat(t) : t.split("."); i.length > 1; ) {
    if (o())
      return {};
    var a = r(i.shift());
    !e[a] && n && (e[a] = new n()), e = e[a];
  }
  return o() ? {} : {
    obj: e,
    k: r(i.shift())
  };
}
function jce(e, t, n) {
  var r = N9(e, t, Object), o = r.obj, i = r.k;
  o[i] = n;
}
function kce(e, t) {
  var n = N9(e, t), r = n.obj, o = n.k;
  if (r)
    return r[o];
}
var P9 = [], Fce = P9.forEach, Bce = P9.slice;
function Hce(e) {
  return Fce.call(Bce.call(arguments, 1), function(t) {
    if (t)
      for (var n in t)
        e[n] === void 0 && (e[n] = t[n]);
  }), e;
}
var Dy = function(e, t) {
  return Dy = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, Dy(e, t);
};
function gm(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Dy(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Vn = function() {
  return Vn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Vn.apply(this, arguments);
};
function zce(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function _0(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var An;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(An || (An = {}));
var br;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(br || (br = {}));
var Gc;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(Gc || (Gc = {}));
function t3(e) {
  return e.type === br.literal;
}
function Vce(e) {
  return e.type === br.argument;
}
function I9(e) {
  return e.type === br.number;
}
function R9(e) {
  return e.type === br.date;
}
function D9(e) {
  return e.type === br.time;
}
function T9(e) {
  return e.type === br.select;
}
function M9(e) {
  return e.type === br.plural;
}
function Wce(e) {
  return e.type === br.pound;
}
function L9(e) {
  return e.type === br.tag;
}
function A9(e) {
  return !!(e && typeof e == "object" && e.type === Gc.number);
}
function Ty(e) {
  return !!(e && typeof e == "object" && e.type === Gc.dateTime);
}
var j9 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Kce = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Uce(e) {
  var t = {};
  return e.replace(Kce, function(n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var Gce = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function qce(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(Gce).filter(function(h) {
    return h.length > 0;
  }), n = [], r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = i.split("/");
    if (a.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = a[0], l = a.slice(1), u = 0, f = l; u < f.length; u++) {
      var p = f[u];
      if (p.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: l });
  }
  return n;
}
function Yce(e) {
  return e.replace(/^(.*?)-/, "");
}
var n3 = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, k9 = /^(@+)?(\+|#+)?[rs]?$/g, Xce = /(\*)(0+)|(#+)(0+)|(0+)/g, F9 = /^(0+)$/;
function r3(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(k9, function(n, r, o) {
    return typeof o != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : o === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof o == "string" ? o.length : 0)), "";
  }), t;
}
function B9(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function Zce(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !F9.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function o3(e) {
  var t = {}, n = B9(e);
  return n || t;
}
function Qce(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var o = r[n];
    switch (o.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = o.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = Yce(o.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = Vn(Vn(Vn({}, t), { notation: "scientific" }), o.options.reduce(function(l, u) {
          return Vn(Vn({}, l), o3(u));
        }, {}));
        continue;
      case "engineering":
        t = Vn(Vn(Vn({}, t), { notation: "engineering" }), o.options.reduce(function(l, u) {
          return Vn(Vn({}, l), o3(u));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(o.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (o.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        o.options[0].replace(Xce, function(l, u, f, p, h, y) {
          if (u)
            t.minimumIntegerDigits = f.length;
          else {
            if (p && h)
              throw new Error("We currently do not support maximum integer digits");
            if (y)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (F9.test(o.stem)) {
      t.minimumIntegerDigits = o.stem.length;
      continue;
    }
    if (n3.test(o.stem)) {
      if (o.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      o.stem.replace(n3, function(l, u, f, p, h, y) {
        return f === "*" ? t.minimumFractionDigits = u.length : p && p[0] === "#" ? t.maximumFractionDigits = p.length : h && y ? (t.minimumFractionDigits = h.length, t.maximumFractionDigits = h.length + y.length) : (t.minimumFractionDigits = u.length, t.maximumFractionDigits = u.length), "";
      });
      var i = o.options[0];
      i === "w" ? t = Vn(Vn({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = Vn(Vn({}, t), r3(i)));
      continue;
    }
    if (k9.test(o.stem)) {
      t = Vn(Vn({}, t), r3(o.stem));
      continue;
    }
    var a = B9(o.stem);
    a && (t = Vn(Vn({}, t), a));
    var s = Zce(o.stem);
    s && (t = Vn(Vn({}, t), s));
  }
  return t;
}
var Bp = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function Jce(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var o = e.charAt(r);
    if (o === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === o; )
        i++, r++;
      var a = 1 + (i & 1), s = i < 2 ? 1 : 3 + (i >> 1), l = "a", u = eue(t);
      for ((u == "H" || u == "k") && (s = 0); s-- > 0; )
        n += l;
      for (; a-- > 0; )
        n = u + n;
    } else
      o === "J" ? n += "H" : n += o;
  }
  return n;
}
function eue(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var o = Bp[r || ""] || Bp[n || ""] || Bp["".concat(n, "-001")] || Bp["001"];
  return o[0];
}
var N0, tue = new RegExp("^".concat(j9.source, "*")), nue = new RegExp("".concat(j9.source, "*$"));
function jn(e, t) {
  return { start: e, end: t };
}
var rue = !!String.prototype.startsWith && "_a".startsWith("a", 1), oue = !!String.fromCodePoint, iue = !!Object.fromEntries, aue = !!String.prototype.codePointAt, sue = !!String.prototype.trimStart, lue = !!String.prototype.trimEnd, cue = !!Number.isSafeInteger, uue = cue ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, My = !0;
try {
  var due = z9("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  My = ((N0 = due.exec("a")) === null || N0 === void 0 ? void 0 : N0[0]) === "a";
} catch (e) {
  My = !1;
}
var i3 = rue ? (
  // Native
  function(t, n, r) {
    return t.startsWith(n, r);
  }
) : (
  // For IE11
  function(t, n, r) {
    return t.slice(r, r + n.length) === n;
  }
), Ly = oue ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = "", o = t.length, i = 0, a; o > i; ) {
      if (a = t[i++], a > 1114111)
        throw RangeError(a + " is not a valid code point");
      r += a < 65536 ? String.fromCharCode(a) : String.fromCharCode(((a -= 65536) >> 10) + 55296, a % 1024 + 56320);
    }
    return r;
  }
), a3 = (
  // native
  iue ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var n = {}, r = 0, o = t; r < o.length; r++) {
        var i = o[r], a = i[0], s = i[1];
        n[a] = s;
      }
      return n;
    }
  )
), H9 = aue ? (
  // Native
  function(t, n) {
    return t.codePointAt(n);
  }
) : (
  // IE 11
  function(t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var o = t.charCodeAt(n), i;
      return o < 55296 || o > 56319 || n + 1 === r || (i = t.charCodeAt(n + 1)) < 56320 || i > 57343 ? o : (o - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), fue = sue ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(tue, "");
  }
), pue = lue ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(nue, "");
  }
);
function z9(e, t) {
  return new RegExp(e, t);
}
var Ay;
if (My) {
  var s3 = z9("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Ay = function(t, n) {
    var r;
    s3.lastIndex = n;
    var o = s3.exec(t);
    return (r = o[1]) !== null && r !== void 0 ? r : "";
  };
} else
  Ay = function(t, n) {
    for (var r = []; ; ) {
      var o = H9(t, n);
      if (o === void 0 || V9(o) || vue(o))
        break;
      r.push(o), n += o >= 65536 ? 2 : 1;
    }
    return Ly.apply(void 0, r);
  };
var hue = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var o = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var a = this.parseArgument(t, r);
          if (a.err)
            return a;
          o.push(a.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), o.push({
              type: br.pound,
              location: jn(s, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(An.UNMATCHED_CLOSING_TAG, jn(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && jy(this.peek() || 0)) {
            var a = this.parseTag(t, n);
            if (a.err)
              return a;
            o.push(a.val);
          } else {
            var a = this.parseLiteral(t, n);
            if (a.err)
              return a;
            o.push(a.val);
          }
        }
      }
      return { val: o, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var o = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: br.literal,
            value: "<".concat(o, "/>"),
            location: jn(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, n, !0);
        if (i.err)
          return i;
        var a = i.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !jy(this.char()))
            return this.error(An.INVALID_TAG, jn(s, this.clonePosition()));
          var l = this.clonePosition(), u = this.parseTagName();
          return o !== u ? this.error(An.UNMATCHED_CLOSING_TAG, jn(l, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: br.tag,
              value: o,
              children: a,
              location: jn(r, this.clonePosition())
            },
            err: null
          } : this.error(An.INVALID_TAG, jn(s, this.clonePosition())));
        } else
          return this.error(An.UNCLOSED_TAG, jn(r, this.clonePosition()));
      } else
        return this.error(An.INVALID_TAG, jn(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && mue(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), o = ""; ; ) {
        var i = this.tryParseQuote(n);
        if (i) {
          o += i;
          continue;
        }
        var a = this.tryParseUnquoted(t, n);
        if (a) {
          o += a;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          o += s;
          continue;
        }
        break;
      }
      var l = jn(r, this.clonePosition());
      return {
        val: { type: br.literal, value: o, location: l },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !gue(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return Ly.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), Ly(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(An.EXPECT_ARGUMENT_CLOSING_BRACE, jn(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(An.EMPTY_ARGUMENT, jn(r, this.clonePosition()));
      var o = this.parseIdentifierIfPossible().value;
      if (!o)
        return this.error(An.MALFORMED_ARGUMENT, jn(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(An.EXPECT_ARGUMENT_CLOSING_BRACE, jn(r, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: br.argument,
              // value does not include the opening and closing braces.
              value: o,
              location: jn(r, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(An.EXPECT_ARGUMENT_CLOSING_BRACE, jn(r, this.clonePosition())) : this.parseArgumentOptions(t, n, o, r);
        default:
          return this.error(An.MALFORMED_ARGUMENT, jn(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = Ay(this.message, n), o = n + r.length;
      this.bumpTo(o);
      var i = this.clonePosition(), a = jn(t, i);
      return { value: r, location: a };
    }, e.prototype.parseArgumentOptions = function(t, n, r, o) {
      var i, a = this.clonePosition(), s = this.parseIdentifierIfPossible().value, l = this.clonePosition();
      switch (s) {
        case "":
          return this.error(An.EXPECT_ARGUMENT_TYPE, jn(a, l));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var u = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var f = this.clonePosition(), p = this.parseSimpleArgStyleIfPossible();
            if (p.err)
              return p;
            var h = pue(p.val);
            if (h.length === 0)
              return this.error(An.EXPECT_ARGUMENT_STYLE, jn(this.clonePosition(), this.clonePosition()));
            var y = jn(f, this.clonePosition());
            u = { style: h, styleLocation: y };
          }
          var b = this.tryParseArgumentClose(o);
          if (b.err)
            return b;
          var m = jn(o, this.clonePosition());
          if (u && i3(u == null ? void 0 : u.style, "::", 0)) {
            var v = fue(u.style.slice(2));
            if (s === "number") {
              var p = this.parseNumberSkeletonFromString(v, u.styleLocation);
              return p.err ? p : {
                val: { type: br.number, value: r, location: m, style: p.val },
                err: null
              };
            } else {
              if (v.length === 0)
                return this.error(An.EXPECT_DATE_TIME_SKELETON, m);
              var C = v;
              this.locale && (C = Jce(v, this.locale));
              var h = {
                type: Gc.dateTime,
                pattern: C,
                location: u.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Uce(C) : {}
              }, x = s === "date" ? br.date : br.time;
              return {
                val: { type: x, value: r, location: m, style: h },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? br.number : s === "date" ? br.date : br.time,
              value: r,
              location: m,
              style: (i = u == null ? void 0 : u.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var S = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(An.EXPECT_SELECT_ARGUMENT_OPTIONS, jn(S, Vn({}, S)));
          this.bumpSpace();
          var E = this.parseIdentifierIfPossible(), O = 0;
          if (s !== "select" && E.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(An.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, jn(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var p = this.tryParseDecimalInteger(An.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, An.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (p.err)
              return p;
            this.bumpSpace(), E = this.parseIdentifierIfPossible(), O = p.val;
          }
          var $ = this.tryParsePluralOrSelectOptions(t, s, n, E);
          if ($.err)
            return $;
          var b = this.tryParseArgumentClose(o);
          if (b.err)
            return b;
          var _ = jn(o, this.clonePosition());
          return s === "select" ? {
            val: {
              type: br.select,
              value: r,
              options: a3($.val),
              location: _
            },
            err: null
          } : {
            val: {
              type: br.plural,
              value: r,
              options: a3($.val),
              offset: O,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: _
            },
            err: null
          };
        }
        default:
          return this.error(An.INVALID_ARGUMENT_TYPE, jn(a, l));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(An.EXPECT_ARGUMENT_CLOSING_BRACE, jn(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var o = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(An.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, jn(o, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = qce(t);
      } catch (o) {
        return this.error(An.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: Gc.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? Qce(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, o) {
      for (var i, a = !1, s = [], l = /* @__PURE__ */ new Set(), u = o.value, f = o.location; ; ) {
        if (u.length === 0) {
          var p = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var h = this.tryParseDecimalInteger(An.EXPECT_PLURAL_ARGUMENT_SELECTOR, An.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (h.err)
              return h;
            f = jn(p, this.clonePosition()), u = this.message.slice(p.offset, this.offset());
          } else
            break;
        }
        if (l.has(u))
          return this.error(n === "select" ? An.DUPLICATE_SELECT_ARGUMENT_SELECTOR : An.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, f);
        u === "other" && (a = !0), this.bumpSpace();
        var y = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? An.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : An.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, jn(this.clonePosition(), this.clonePosition()));
        var b = this.parseMessage(t + 1, n, r);
        if (b.err)
          return b;
        var m = this.tryParseArgumentClose(y);
        if (m.err)
          return m;
        s.push([
          u,
          {
            value: b.val,
            location: jn(y, this.clonePosition())
          }
        ]), l.add(u), this.bumpSpace(), i = this.parseIdentifierIfPossible(), u = i.value, f = i.location;
      }
      return s.length === 0 ? this.error(n === "select" ? An.EXPECT_SELECT_ARGUMENT_SELECTOR : An.EXPECT_PLURAL_ARGUMENT_SELECTOR, jn(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !a ? this.error(An.MISSING_OTHER_CLAUSE, jn(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, o = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var i = !1, a = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          i = !0, a = a * 10 + (s - 48), this.bump();
        else
          break;
      }
      var l = jn(o, this.clonePosition());
      return i ? (a *= r, uue(a) ? { val: a, err: null } : this.error(n, l)) : this.error(t, l);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = H9(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (i3(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && V9(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r != null ? r : null;
    }, e;
  }()
);
function jy(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function gue(e) {
  return jy(e) || e === 47;
}
function mue(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function V9(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function vue(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function ky(e) {
  e.forEach(function(t) {
    if (delete t.location, T9(t) || M9(t))
      for (var n in t.options)
        delete t.options[n].location, ky(t.options[n].value);
    else
      I9(t) && A9(t.style) || (R9(t) || D9(t)) && Ty(t.style) ? delete t.style.location : L9(t) && ky(t.children);
  });
}
function yue(e, t) {
  t === void 0 && (t = {}), t = Vn({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new hue(e, t).parse();
  if (n.err) {
    var r = SyntaxError(An[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || ky(n.val), n.val;
}
function P0(e, t) {
  var n = t && t.cache ? t.cache : Eue, r = t && t.serializer ? t.serializer : wue, o = t && t.strategy ? t.strategy : Cue;
  return o(e, {
    cache: n,
    serializer: r
  });
}
function bue(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function W9(e, t, n, r) {
  var o = bue(r) ? r : n(r), i = t.get(o);
  return typeof i == "undefined" && (i = e.call(this, r), t.set(o, i)), i;
}
function K9(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), o = n(r), i = t.get(o);
  return typeof i == "undefined" && (i = e.apply(this, r), t.set(o, i)), i;
}
function zC(e, t, n, r, o) {
  return n.bind(t, e, r, o);
}
function Cue(e, t) {
  var n = e.length === 1 ? W9 : K9;
  return zC(e, this, n, t.cache.create(), t.serializer);
}
function xue(e, t) {
  return zC(e, this, K9, t.cache.create(), t.serializer);
}
function Sue(e, t) {
  return zC(e, this, W9, t.cache.create(), t.serializer);
}
var wue = function() {
  return JSON.stringify(arguments);
};
function VC() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
VC.prototype.get = function(e) {
  return this.cache[e];
};
VC.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Eue = {
  create: function() {
    return new VC();
  }
}, I0 = {
  variadic: xue,
  monadic: Sue
}, qc;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(qc || (qc = {}));
var mm = (
  /** @class */
  function(e) {
    gm(t, e);
    function t(n, r, o) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = o, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), l3 = (
  /** @class */
  function(e) {
    gm(t, e);
    function t(n, r, o, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(o).join('", "'), '"'), qc.INVALID_VALUE, i) || this;
    }
    return t;
  }(mm)
), $ue = (
  /** @class */
  function(e) {
    gm(t, e);
    function t(n, r, o) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), qc.INVALID_VALUE, o) || this;
    }
    return t;
  }(mm)
), Oue = (
  /** @class */
  function(e) {
    gm(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), qc.MISSING_VALUE, r) || this;
    }
    return t;
  }(mm)
), _o;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(_o || (_o = {}));
function _ue(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== _o.literal || n.type !== _o.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function Nue(e) {
  return typeof e == "function";
}
function dh(e, t, n, r, o, i, a) {
  if (e.length === 1 && t3(e[0]))
    return [
      {
        type: _o.literal,
        value: e[0].value
      }
    ];
  for (var s = [], l = 0, u = e; l < u.length; l++) {
    var f = u[l];
    if (t3(f)) {
      s.push({
        type: _o.literal,
        value: f.value
      });
      continue;
    }
    if (Wce(f)) {
      typeof i == "number" && s.push({
        type: _o.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var p = f.value;
    if (!(o && p in o))
      throw new Oue(p, a);
    var h = o[p];
    if (Vce(f)) {
      (!h || typeof h == "string" || typeof h == "number") && (h = typeof h == "string" || typeof h == "number" ? String(h) : ""), s.push({
        type: typeof h == "string" ? _o.literal : _o.object,
        value: h
      });
      continue;
    }
    if (R9(f)) {
      var y = typeof f.style == "string" ? r.date[f.style] : Ty(f.style) ? f.style.parsedOptions : void 0;
      s.push({
        type: _o.literal,
        value: n.getDateTimeFormat(t, y).format(h)
      });
      continue;
    }
    if (D9(f)) {
      var y = typeof f.style == "string" ? r.time[f.style] : Ty(f.style) ? f.style.parsedOptions : r.time.medium;
      s.push({
        type: _o.literal,
        value: n.getDateTimeFormat(t, y).format(h)
      });
      continue;
    }
    if (I9(f)) {
      var y = typeof f.style == "string" ? r.number[f.style] : A9(f.style) ? f.style.parsedOptions : void 0;
      y && y.scale && (h = h * (y.scale || 1)), s.push({
        type: _o.literal,
        value: n.getNumberFormat(t, y).format(h)
      });
      continue;
    }
    if (L9(f)) {
      var b = f.children, m = f.value, v = o[m];
      if (!Nue(v))
        throw new $ue(m, "function", a);
      var C = dh(b, t, n, r, o, i), x = v(C.map(function(O) {
        return O.value;
      }));
      Array.isArray(x) || (x = [x]), s.push.apply(s, x.map(function(O) {
        return {
          type: typeof O == "string" ? _o.literal : _o.object,
          value: O
        };
      }));
    }
    if (T9(f)) {
      var S = f.options[h] || f.options.other;
      if (!S)
        throw new l3(f.value, h, Object.keys(f.options), a);
      s.push.apply(s, dh(S.value, t, n, r, o));
      continue;
    }
    if (M9(f)) {
      var S = f.options["=".concat(h)];
      if (!S) {
        if (!Intl.PluralRules)
          throw new mm(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, qc.MISSING_INTL_API, a);
        var E = n.getPluralRules(t, { type: f.pluralType }).select(h - (f.offset || 0));
        S = f.options[E] || f.options.other;
      }
      if (!S)
        throw new l3(f.value, h, Object.keys(f.options), a);
      s.push.apply(s, dh(S.value, t, n, r, o, h - (f.offset || 0)));
      continue;
    }
  }
  return _ue(s);
}
function Pue(e, t) {
  return t ? Vn(Vn(Vn({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = Vn(Vn({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function Iue(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = Pue(e[r], t[r]), n;
  }, Vn({}, e)) : e;
}
function R0(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Rue(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: P0(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, _0([void 0], n, !1)))();
    }, {
      cache: R0(e.number),
      strategy: I0.variadic
    }),
    getDateTimeFormat: P0(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, _0([void 0], n, !1)))();
    }, {
      cache: R0(e.dateTime),
      strategy: I0.variadic
    }),
    getPluralRules: P0(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, _0([void 0], n, !1)))();
    }, {
      cache: R0(e.pluralRules),
      strategy: I0.variadic
    })
  };
}
var c3 = (
  /** @class */
  function() {
    function e(t, n, r, o) {
      var i = this;
      if (n === void 0 && (n = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(l) {
        var u = i.formatToParts(l);
        if (u.length === 1)
          return u[0].value;
        var f = u.reduce(function(p, h) {
          return !p.length || h.type !== _o.literal || typeof p[p.length - 1] != "string" ? p.push(h.value) : p[p.length - 1] += h.value, p;
        }, []);
        return f.length <= 1 ? f[0] || "" : f;
      }, this.formatToParts = function(l) {
        return dh(i.ast, i.locales, i.formatters, i.formats, l, void 0, i.message);
      }, this.resolvedOptions = function() {
        var l;
        return {
          locale: ((l = i.resolvedLocale) === null || l === void 0 ? void 0 : l.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var a = o || {};
        a.formatters;
        var s = zce(a, ["formatters"]);
        this.ast = e.__parse(t, Vn(Vn({}, s), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Iue(e.formats, r), this.formatters = o && o.formatters || Rue(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (typeof Intl.Locale != "undefined") {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = yue, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
);
function u3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function d3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? u3(Object(n), !0).forEach(function(r) {
      Due(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Due(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Tue(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f3(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Mue(e, t, n) {
  return t && f3(e.prototype, t), n && f3(e, n), e;
}
function Lue() {
  return {
    memoize: !0,
    memoizeFallback: !1,
    bindI18n: "",
    bindI18nStore: "",
    parseErrorHandler: function(t, n, r, o) {
      return r;
    },
    parseLngForICU: function(t) {
      return t;
    }
  };
}
var U9 = /* @__PURE__ */ function() {
  function e(t) {
    Tue(this, e), this.type = "i18nFormat", this.mem = {}, this.init(null, t);
  }
  return Mue(e, [{
    key: "init",
    value: function(n, r) {
      var o = this, i = n && n.options && n.options.i18nFormat || {};
      if (this.options = Hce(i, r, this.options || {}, Lue()), this.formats = this.options.formats, n) {
        var a = this.options, s = a.bindI18n, l = a.bindI18nStore, u = a.memoize;
        n.IntlMessageFormat = c3, n.ICU = this, u && (s && n.on(s, function() {
          return o.clearCache();
        }), l && n.store.on(l, function() {
          return o.clearCache();
        }));
      }
    }
  }, {
    key: "addUserDefinedFormats",
    value: function(n) {
      this.formats = this.formats ? d3(d3({}, this.formats), n) : n;
    }
  }, {
    key: "parse",
    value: function(n, r, o, i, a, s) {
      var l = s && s.resolved && s.resolved.res, u = this.options.memoize && "".concat(o, ".").concat(i, ".").concat(a.replace(/\./g, "###")), f;
      this.options.memoize && (f = kce(this.mem, u));
      try {
        if (!f) {
          var p = this.options.parseLngForICU(o);
          f = new c3(n, p, this.formats, {
            ignoreTag: !0
          }), this.options.memoize && (this.options.memoizeFallback || !s || l) && jce(this.mem, u, f);
        }
        return f.format(r);
      } catch (h) {
        return this.options.parseErrorHandler(h, a, n, r);
      }
    }
  }, {
    key: "addLookupKeys",
    value: function(n, r, o, i, a) {
      return n;
    }
  }, {
    key: "clearCache",
    value: function() {
      this.mem = {};
    }
  }]), e;
}();
U9.type = "i18nFormat";
var G9 = [], Aue = G9.forEach, jue = G9.slice;
function kue(e) {
  return Aue.call(jue.call(arguments, 1), function(t) {
    if (t)
      for (var n in t)
        e[n] === void 0 && (e[n] = t[n]);
  }), e;
}
var p3 = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Fue = function(t, n, r) {
  var o = r || {};
  o.path = o.path || "/";
  var i = encodeURIComponent(n), a = "".concat(t, "=").concat(i);
  if (o.maxAge > 0) {
    var s = o.maxAge - 0;
    if (Number.isNaN(s))
      throw new Error("maxAge should be a Number");
    a += "; Max-Age=".concat(Math.floor(s));
  }
  if (o.domain) {
    if (!p3.test(o.domain))
      throw new TypeError("option domain is invalid");
    a += "; Domain=".concat(o.domain);
  }
  if (o.path) {
    if (!p3.test(o.path))
      throw new TypeError("option path is invalid");
    a += "; Path=".concat(o.path);
  }
  if (o.expires) {
    if (typeof o.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    a += "; Expires=".concat(o.expires.toUTCString());
  }
  if (o.httpOnly && (a += "; HttpOnly"), o.secure && (a += "; Secure"), o.sameSite) {
    var l = typeof o.sameSite == "string" ? o.sameSite.toLowerCase() : o.sameSite;
    switch (l) {
      case !0:
        a += "; SameSite=Strict";
        break;
      case "lax":
        a += "; SameSite=Lax";
        break;
      case "strict":
        a += "; SameSite=Strict";
        break;
      case "none":
        a += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return a;
}, h3 = {
  create: function(t, n, r, o) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    r && (i.expires = /* @__PURE__ */ new Date(), i.expires.setTime(i.expires.getTime() + r * 60 * 1e3)), o && (i.domain = o), document.cookie = Fue(t, encodeURIComponent(n), i);
  },
  read: function(t) {
    for (var n = "".concat(t, "="), r = document.cookie.split(";"), o = 0; o < r.length; o++) {
      for (var i = r[o]; i.charAt(0) === " "; )
        i = i.substring(1, i.length);
      if (i.indexOf(n) === 0)
        return i.substring(n.length, i.length);
    }
    return null;
  },
  remove: function(t) {
    this.create(t, "", -1);
  }
}, Bue = {
  name: "cookie",
  lookup: function(t) {
    var n;
    if (t.lookupCookie && typeof document != "undefined") {
      var r = h3.read(t.lookupCookie);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupCookie && typeof document != "undefined" && h3.create(n.lookupCookie, t, n.cookieMinutes, n.cookieDomain, n.cookieOptions);
  }
}, Hue = {
  name: "querystring",
  lookup: function(t) {
    var n;
    if (typeof window != "undefined") {
      var r = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (r = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var o = r.substring(1), i = o.split("&"), a = 0; a < i.length; a++) {
        var s = i[a].indexOf("=");
        if (s > 0) {
          var l = i[a].substring(0, s);
          l === t.lookupQuerystring && (n = i[a].substring(s + 1));
        }
      }
    }
    return n;
  }
}, Uu = null, g3 = function() {
  if (Uu !== null)
    return Uu;
  try {
    Uu = window !== "undefined" && window.localStorage !== null;
    var t = "i18next.translate.boo";
    window.localStorage.setItem(t, "foo"), window.localStorage.removeItem(t);
  } catch (n) {
    Uu = !1;
  }
  return Uu;
}, zue = {
  name: "localStorage",
  lookup: function(t) {
    var n;
    if (t.lookupLocalStorage && g3()) {
      var r = window.localStorage.getItem(t.lookupLocalStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupLocalStorage && g3() && window.localStorage.setItem(n.lookupLocalStorage, t);
  }
}, Gu = null, m3 = function() {
  if (Gu !== null)
    return Gu;
  try {
    Gu = window !== "undefined" && window.sessionStorage !== null;
    var t = "i18next.translate.boo";
    window.sessionStorage.setItem(t, "foo"), window.sessionStorage.removeItem(t);
  } catch (n) {
    Gu = !1;
  }
  return Gu;
}, Vue = {
  name: "sessionStorage",
  lookup: function(t) {
    var n;
    if (t.lookupSessionStorage && m3()) {
      var r = window.sessionStorage.getItem(t.lookupSessionStorage);
      r && (n = r);
    }
    return n;
  },
  cacheUserLanguage: function(t, n) {
    n.lookupSessionStorage && m3() && window.sessionStorage.setItem(n.lookupSessionStorage, t);
  }
}, Wue = {
  name: "navigator",
  lookup: function(t) {
    var n = [];
    if (typeof navigator != "undefined") {
      if (navigator.languages)
        for (var r = 0; r < navigator.languages.length; r++)
          n.push(navigator.languages[r]);
      navigator.userLanguage && n.push(navigator.userLanguage), navigator.language && n.push(navigator.language);
    }
    return n.length > 0 ? n : void 0;
  }
}, Kue = {
  name: "htmlTag",
  lookup: function(t) {
    var n, r = t.htmlTag || (typeof document != "undefined" ? document.documentElement : null);
    return r && typeof r.getAttribute == "function" && (n = r.getAttribute("lang")), n;
  }
}, Uue = {
  name: "path",
  lookup: function(t) {
    var n;
    if (typeof window != "undefined") {
      var r = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (r instanceof Array)
        if (typeof t.lookupFromPathIndex == "number") {
          if (typeof r[t.lookupFromPathIndex] != "string")
            return;
          n = r[t.lookupFromPathIndex].replace("/", "");
        } else
          n = r[0].replace("/", "");
    }
    return n;
  }
}, Gue = {
  name: "subdomain",
  lookup: function(t) {
    var n = typeof t.lookupFromSubdomainIndex == "number" ? t.lookupFromSubdomainIndex + 1 : 1, r = typeof window != "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (r)
      return r[n];
  }
};
function que() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(t) {
      return t;
    }
  };
}
var q9 = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    zr(this, e), this.type = "languageDetector", this.detectors = {}, this.init(t, n);
  }
  return Vr(e, [{
    key: "init",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n || {
        languageUtils: {}
      }, this.options = kue(r, this.options || {}, que()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(i) {
        return i.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = o, this.addDetector(Bue), this.addDetector(Hue), this.addDetector(zue), this.addDetector(Vue), this.addDetector(Wue), this.addDetector(Kue), this.addDetector(Uue), this.addDetector(Gue);
    }
  }, {
    key: "addDetector",
    value: function(n) {
      this.detectors[n.name] = n;
    }
  }, {
    key: "detect",
    value: function(n) {
      var r = this;
      n || (n = this.options.order);
      var o = [];
      return n.forEach(function(i) {
        if (r.detectors[i]) {
          var a = r.detectors[i].lookup(r.options);
          a && typeof a == "string" && (a = [a]), a && (o = o.concat(a));
        }
      }), o = o.map(function(i) {
        return r.options.convertDetectedLanguage(i);
      }), this.services.languageUtils.getBestMatchFromCodes ? o : o.length > 0 ? o[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(n, r) {
      var o = this;
      r || (r = this.options.caches), r && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(n) > -1 || r.forEach(function(i) {
        o.detectors[i] && o.detectors[i].cacheUserLanguage(n, o.options);
      }));
    }
  }]), e;
}();
q9.type = "languageDetector";
function Fy(e) {
  "@babel/helpers - typeof";
  return Fy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fy(e);
}
function Y9() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest == "undefined" ? "undefined" : Fy(XMLHttpRequest)) === "object";
}
function Yue(e) {
  return !!e && typeof e.then == "function";
}
function Xue(e) {
  return Yue(e) ? e : Promise.resolve(e);
}
function Zue(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var By = { exports: {} }, Hp = { exports: {} }, v3;
function Que() {
  return v3 || (v3 = 1, function(e, t) {
    var n = typeof globalThis != "undefined" && globalThis || typeof self != "undefined" && self || typeof lo != "undefined" && lo, r = function() {
      function i() {
        this.fetch = !1, this.DOMException = n.DOMException;
      }
      return i.prototype = n, new i();
    }();
    (function(i) {
      (function(a) {
        var s = typeof i != "undefined" && i || typeof self != "undefined" && self || typeof s != "undefined" && s, l = {
          searchParams: "URLSearchParams" in s,
          iterable: "Symbol" in s && "iterator" in Symbol,
          blob: "FileReader" in s && "Blob" in s && function() {
            try {
              return new Blob(), !0;
            } catch (N) {
              return !1;
            }
          }(),
          formData: "FormData" in s,
          arrayBuffer: "ArrayBuffer" in s
        };
        function u(N) {
          return N && DataView.prototype.isPrototypeOf(N);
        }
        if (l.arrayBuffer)
          var f = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], p = ArrayBuffer.isView || function(N) {
            return N && f.indexOf(Object.prototype.toString.call(N)) > -1;
          };
        function h(N) {
          if (typeof N != "string" && (N = String(N)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(N) || N === "")
            throw new TypeError('Invalid character in header field name: "' + N + '"');
          return N.toLowerCase();
        }
        function y(N) {
          return typeof N != "string" && (N = String(N)), N;
        }
        function b(N) {
          var D = {
            next: function() {
              var T = N.shift();
              return { done: T === void 0, value: T };
            }
          };
          return l.iterable && (D[Symbol.iterator] = function() {
            return D;
          }), D;
        }
        function m(N) {
          this.map = {}, N instanceof m ? N.forEach(function(D, T) {
            this.append(T, D);
          }, this) : Array.isArray(N) ? N.forEach(function(D) {
            this.append(D[0], D[1]);
          }, this) : N && Object.getOwnPropertyNames(N).forEach(function(D) {
            this.append(D, N[D]);
          }, this);
        }
        m.prototype.append = function(N, D) {
          N = h(N), D = y(D);
          var T = this.map[N];
          this.map[N] = T ? T + ", " + D : D;
        }, m.prototype.delete = function(N) {
          delete this.map[h(N)];
        }, m.prototype.get = function(N) {
          return N = h(N), this.has(N) ? this.map[N] : null;
        }, m.prototype.has = function(N) {
          return this.map.hasOwnProperty(h(N));
        }, m.prototype.set = function(N, D) {
          this.map[h(N)] = y(D);
        }, m.prototype.forEach = function(N, D) {
          for (var T in this.map)
            this.map.hasOwnProperty(T) && N.call(D, this.map[T], T, this);
        }, m.prototype.keys = function() {
          var N = [];
          return this.forEach(function(D, T) {
            N.push(T);
          }), b(N);
        }, m.prototype.values = function() {
          var N = [];
          return this.forEach(function(D) {
            N.push(D);
          }), b(N);
        }, m.prototype.entries = function() {
          var N = [];
          return this.forEach(function(D, T) {
            N.push([T, D]);
          }), b(N);
        }, l.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
        function v(N) {
          if (N.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          N.bodyUsed = !0;
        }
        function C(N) {
          return new Promise(function(D, T) {
            N.onload = function() {
              D(N.result);
            }, N.onerror = function() {
              T(N.error);
            };
          });
        }
        function x(N) {
          var D = new FileReader(), T = C(D);
          return D.readAsArrayBuffer(N), T;
        }
        function S(N) {
          var D = new FileReader(), T = C(D);
          return D.readAsText(N), T;
        }
        function E(N) {
          for (var D = new Uint8Array(N), T = new Array(D.length), L = 0; L < D.length; L++)
            T[L] = String.fromCharCode(D[L]);
          return T.join("");
        }
        function O(N) {
          if (N.slice)
            return N.slice(0);
          var D = new Uint8Array(N.byteLength);
          return D.set(new Uint8Array(N)), D.buffer;
        }
        function $() {
          return this.bodyUsed = !1, this._initBody = function(N) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = N, N ? typeof N == "string" ? this._bodyText = N : l.blob && Blob.prototype.isPrototypeOf(N) ? this._bodyBlob = N : l.formData && FormData.prototype.isPrototypeOf(N) ? this._bodyFormData = N : l.searchParams && URLSearchParams.prototype.isPrototypeOf(N) ? this._bodyText = N.toString() : l.arrayBuffer && l.blob && u(N) ? (this._bodyArrayBuffer = O(N.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(N) || p(N)) ? this._bodyArrayBuffer = O(N) : this._bodyText = N = Object.prototype.toString.call(N) : this._bodyText = "", this.headers.get("content-type") || (typeof N == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(N) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, l.blob && (this.blob = function() {
            var N = v(this);
            if (N)
              return N;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var N = v(this);
              return N || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else
              return this.blob().then(x);
          }), this.text = function() {
            var N = v(this);
            if (N)
              return N;
            if (this._bodyBlob)
              return S(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(E(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, l.formData && (this.formData = function() {
            return this.text().then(I);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var _ = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function R(N) {
          var D = N.toUpperCase();
          return _.indexOf(D) > -1 ? D : N;
        }
        function P(N, D) {
          if (!(this instanceof P))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          D = D || {};
          var T = D.body;
          if (N instanceof P) {
            if (N.bodyUsed)
              throw new TypeError("Already read");
            this.url = N.url, this.credentials = N.credentials, D.headers || (this.headers = new m(N.headers)), this.method = N.method, this.mode = N.mode, this.signal = N.signal, !T && N._bodyInit != null && (T = N._bodyInit, N.bodyUsed = !0);
          } else
            this.url = String(N);
          if (this.credentials = D.credentials || this.credentials || "same-origin", (D.headers || !this.headers) && (this.headers = new m(D.headers)), this.method = R(D.method || this.method || "GET"), this.mode = D.mode || this.mode || null, this.signal = D.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && T)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(T), (this.method === "GET" || this.method === "HEAD") && (D.cache === "no-store" || D.cache === "no-cache")) {
            var L = /([?&])_=[^&]*/;
            if (L.test(this.url))
              this.url = this.url.replace(L, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var z = /\?/;
              this.url += (z.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        P.prototype.clone = function() {
          return new P(this, { body: this._bodyInit });
        };
        function I(N) {
          var D = new FormData();
          return N.trim().split("&").forEach(function(T) {
            if (T) {
              var L = T.split("="), z = L.shift().replace(/\+/g, " "), H = L.join("=").replace(/\+/g, " ");
              D.append(decodeURIComponent(z), decodeURIComponent(H));
            }
          }), D;
        }
        function j(N) {
          var D = new m(), T = N.replace(/\r?\n[\t ]+/g, " ");
          return T.split("\r").map(function(L) {
            return L.indexOf(`
`) === 0 ? L.substr(1, L.length) : L;
          }).forEach(function(L) {
            var z = L.split(":"), H = z.shift().trim();
            if (H) {
              var V = z.join(":").trim();
              D.append(H, V);
            }
          }), D;
        }
        $.call(P.prototype);
        function F(N, D) {
          if (!(this instanceof F))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          D || (D = {}), this.type = "default", this.status = D.status === void 0 ? 200 : D.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = D.statusText === void 0 ? "" : "" + D.statusText, this.headers = new m(D.headers), this.url = D.url || "", this._initBody(N);
        }
        $.call(F.prototype), F.prototype.clone = function() {
          return new F(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new m(this.headers),
            url: this.url
          });
        }, F.error = function() {
          var N = new F(null, { status: 0, statusText: "" });
          return N.type = "error", N;
        };
        var A = [301, 302, 303, 307, 308];
        F.redirect = function(N, D) {
          if (A.indexOf(D) === -1)
            throw new RangeError("Invalid status code");
          return new F(null, { status: D, headers: { location: N } });
        }, a.DOMException = s.DOMException;
        try {
          new a.DOMException();
        } catch (N) {
          a.DOMException = function(D, T) {
            this.message = D, this.name = T;
            var L = Error(D);
            this.stack = L.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function M(N, D) {
          return new Promise(function(T, L) {
            var z = new P(N, D);
            if (z.signal && z.signal.aborted)
              return L(new a.DOMException("Aborted", "AbortError"));
            var H = new XMLHttpRequest();
            function V() {
              H.abort();
            }
            H.onload = function() {
              var Z = {
                status: H.status,
                statusText: H.statusText,
                headers: j(H.getAllResponseHeaders() || "")
              };
              Z.url = "responseURL" in H ? H.responseURL : Z.headers.get("X-Request-URL");
              var oe = "response" in H ? H.response : H.responseText;
              setTimeout(function() {
                T(new F(oe, Z));
              }, 0);
            }, H.onerror = function() {
              setTimeout(function() {
                L(new TypeError("Network request failed"));
              }, 0);
            }, H.ontimeout = function() {
              setTimeout(function() {
                L(new TypeError("Network request failed"));
              }, 0);
            }, H.onabort = function() {
              setTimeout(function() {
                L(new a.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function Y(Z) {
              try {
                return Z === "" && s.location.href ? s.location.href : Z;
              } catch (oe) {
                return Z;
              }
            }
            H.open(z.method, Y(z.url), !0), z.credentials === "include" ? H.withCredentials = !0 : z.credentials === "omit" && (H.withCredentials = !1), "responseType" in H && (l.blob ? H.responseType = "blob" : l.arrayBuffer && z.headers.get("Content-Type") && z.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (H.responseType = "arraybuffer")), D && typeof D.headers == "object" && !(D.headers instanceof m) ? Object.getOwnPropertyNames(D.headers).forEach(function(Z) {
              H.setRequestHeader(Z, y(D.headers[Z]));
            }) : z.headers.forEach(function(Z, oe) {
              H.setRequestHeader(oe, Z);
            }), z.signal && (z.signal.addEventListener("abort", V), H.onreadystatechange = function() {
              H.readyState === 4 && z.signal.removeEventListener("abort", V);
            }), H.send(typeof z._bodyInit == "undefined" ? null : z._bodyInit);
          });
        }
        return M.polyfill = !0, s.fetch || (s.fetch = M, s.Headers = m, s.Request = P, s.Response = F), a.Headers = m, a.Request = P, a.Response = F, a.fetch = M, a;
      })({});
    })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
    var o = n.fetch ? n : r;
    t = o.fetch, t.default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
  }(Hp, Hp.exports)), Hp.exports;
}
(function(e, t) {
  var n;
  if (typeof fetch == "function" && (typeof lo != "undefined" && lo.fetch ? n = lo.fetch : typeof window != "undefined" && window.fetch ? n = window.fetch : n = fetch), typeof Zue != "undefined" && (typeof window == "undefined" || typeof window.document == "undefined")) {
    var r = n || Que();
    r.default && (r = r.default), t.default = r, e.exports = t.default;
  }
})(By, By.exports);
var X9 = By.exports;
const Z9 = /* @__PURE__ */ Vi(X9), y3 = /* @__PURE__ */ nA({
  __proto__: null,
  default: Z9
}, [X9]);
function b3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function C3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? b3(Object(n), !0).forEach(function(r) {
      Jue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Jue(e, t, n) {
  return t = ede(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ede(e) {
  var t = tde(e, "string");
  return $l(t) == "symbol" ? t : String(t);
}
function tde(e, t) {
  if ($l(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if ($l(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $l(e) {
  "@babel/helpers - typeof";
  return $l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $l(e);
}
var Ha;
typeof fetch == "function" && (typeof global != "undefined" && global.fetch ? Ha = global.fetch : typeof window != "undefined" && window.fetch ? Ha = window.fetch : Ha = fetch);
var jd;
Y9() && (typeof global != "undefined" && global.XMLHttpRequest ? jd = global.XMLHttpRequest : typeof window != "undefined" && window.XMLHttpRequest && (jd = window.XMLHttpRequest));
var tg;
typeof ActiveXObject == "function" && (typeof global != "undefined" && global.ActiveXObject ? tg = global.ActiveXObject : typeof window != "undefined" && window.ActiveXObject && (tg = window.ActiveXObject));
!Ha && y3 && !jd && !tg && (Ha = Z9 || y3);
typeof Ha != "function" && (Ha = void 0);
var Hy = function(t, n) {
  if (n && $l(n) === "object") {
    var r = "";
    for (var o in n)
      r += "&" + encodeURIComponent(o) + "=" + encodeURIComponent(n[o]);
    if (!r)
      return t;
    t = t + (t.indexOf("?") !== -1 ? "&" : "?") + r.slice(1);
  }
  return t;
}, x3 = function(t, n, r, o) {
  var i = function(l) {
    if (!l.ok)
      return r(l.statusText || "Error", {
        status: l.status
      });
    l.text().then(function(u) {
      r(null, {
        status: l.status,
        data: u
      });
    }).catch(r);
  };
  if (o) {
    var a = o(t, n);
    if (a instanceof Promise) {
      a.then(i).catch(r);
      return;
    }
  }
  typeof fetch == "function" ? fetch(t, n).then(i).catch(r) : Ha(t, n).then(i).catch(r);
}, S3 = !1, nde = function(t, n, r, o) {
  t.queryStringParams && (n = Hy(n, t.queryStringParams));
  var i = C3({}, typeof t.customHeaders == "function" ? t.customHeaders() : t.customHeaders);
  typeof window == "undefined" && typeof global != "undefined" && typeof global.process != "undefined" && global.process.versions && global.process.versions.node && (i["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), r && (i["Content-Type"] = "application/json");
  var a = typeof t.requestOptions == "function" ? t.requestOptions(r) : t.requestOptions, s = C3({
    method: r ? "POST" : "GET",
    body: r ? t.stringify(r) : void 0,
    headers: i
  }, S3 ? {} : a), l = typeof t.alternateFetch == "function" && t.alternateFetch.length >= 1 ? t.alternateFetch : void 0;
  try {
    x3(n, s, o, l);
  } catch (u) {
    if (!a || Object.keys(a).length === 0 || !u.message || u.message.indexOf("not implemented") < 0)
      return o(u);
    try {
      Object.keys(a).forEach(function(f) {
        delete s[f];
      }), x3(n, s, o, l), S3 = !0;
    } catch (f) {
      o(f);
    }
  }
}, rde = function(t, n, r, o) {
  r && $l(r) === "object" && (r = Hy("", r).slice(1)), t.queryStringParams && (n = Hy(n, t.queryStringParams));
  try {
    var i;
    jd ? i = new jd() : i = new tg("MSXML2.XMLHTTP.3.0"), i.open(r ? "POST" : "GET", n, 1), t.crossDomain || i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.withCredentials = !!t.withCredentials, r && i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.overrideMimeType && i.overrideMimeType("application/json");
    var a = t.customHeaders;
    if (a = typeof a == "function" ? a() : a, a)
      for (var s in a)
        i.setRequestHeader(s, a[s]);
    i.onreadystatechange = function() {
      i.readyState > 3 && o(i.status >= 400 ? i.statusText : null, {
        status: i.status,
        data: i.responseText
      });
    }, i.send(r);
  } catch (l) {
    console && console.log(l);
  }
}, ode = function(t, n, r, o) {
  if (typeof r == "function" && (o = r, r = void 0), o = o || function() {
  }, Ha && n.indexOf("file:") !== 0)
    return nde(t, n, r, o);
  if (Y9() || typeof ActiveXObject == "function")
    return rde(t, n, r, o);
  o(new Error("No fetch and no xhr implementation found!"));
};
function kd(e) {
  "@babel/helpers - typeof";
  return kd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kd(e);
}
function w3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function D0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w3(Object(n), !0).forEach(function(r) {
      Q9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ide(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function E3(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, J9(r.key), r);
  }
}
function ade(e, t, n) {
  return t && E3(e.prototype, t), n && E3(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Q9(e, t, n) {
  return t = J9(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function J9(e) {
  var t = sde(e, "string");
  return kd(t) == "symbol" ? t : String(t);
}
function sde(e, t) {
  if (kd(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (kd(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lde = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(n) {
      return JSON.parse(n);
    },
    stringify: JSON.stringify,
    parsePayload: function(n, r, o) {
      return Q9({}, r, o || "");
    },
    parseLoadPayload: function(n, r) {
    },
    request: ode,
    reloadInterval: typeof window != "undefined" ? !1 : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, eI = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    ide(this, e), this.services = t, this.options = n, this.allOptions = r, this.type = "backend", this.init(t, n, r);
  }
  return ade(e, [{
    key: "init",
    value: function(n) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n, this.options = D0(D0(D0({}, lde()), this.options || {}), o), this.allOptions = i, this.services && this.options.reloadInterval && setInterval(function() {
        return r.reload();
      }, this.options.reloadInterval);
    }
  }, {
    key: "readMulti",
    value: function(n, r, o) {
      this._readAny(n, n, r, r, o);
    }
  }, {
    key: "read",
    value: function(n, r, o) {
      this._readAny([n], n, [r], r, o);
    }
  }, {
    key: "_readAny",
    value: function(n, r, o, i, a) {
      var s = this, l = this.options.loadPath;
      typeof this.options.loadPath == "function" && (l = this.options.loadPath(n, o)), l = Xue(l), l.then(function(u) {
        if (!u)
          return a(null, {});
        var f = s.services.interpolator.interpolate(u, {
          lng: n.join("+"),
          ns: o.join("+")
        });
        s.loadUrl(f, a, r, i);
      });
    }
  }, {
    key: "loadUrl",
    value: function(n, r, o, i) {
      var a = this, s = typeof o == "string" ? [o] : o, l = typeof i == "string" ? [i] : i, u = this.options.parseLoadPayload(s, l);
      this.options.request(this.options, n, u, function(f, p) {
        if (p && (p.status >= 500 && p.status < 600 || !p.status))
          return r("failed loading " + n + "; status code: " + p.status, !0);
        if (p && p.status >= 400 && p.status < 500)
          return r("failed loading " + n + "; status code: " + p.status, !1);
        if (!p && f && f.message && f.message.indexOf("Failed to fetch") > -1)
          return r("failed loading " + n + ": " + f.message, !0);
        if (f)
          return r(f, !1);
        var h, y;
        try {
          typeof p.data == "string" ? h = a.options.parse(p.data, o, i) : h = p.data;
        } catch (b) {
          y = "failed parsing " + n + " to json";
        }
        if (y)
          return r(y, !1);
        r(null, h);
      });
    }
  }, {
    key: "create",
    value: function(n, r, o, i, a) {
      var s = this;
      if (this.options.addPath) {
        typeof n == "string" && (n = [n]);
        var l = this.options.parsePayload(r, o, i), u = 0, f = [], p = [];
        n.forEach(function(h) {
          var y = s.options.addPath;
          typeof s.options.addPath == "function" && (y = s.options.addPath(h, r));
          var b = s.services.interpolator.interpolate(y, {
            lng: h,
            ns: r
          });
          s.options.request(s.options, b, l, function(m, v) {
            u += 1, f.push(m), p.push(v), u === n.length && typeof a == "function" && a(f, p);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var n = this, r = this.services, o = r.backendConnector, i = r.languageUtils, a = r.logger, s = o.language;
      if (!(s && s.toLowerCase() === "cimode")) {
        var l = [], u = function(p) {
          var h = i.toResolveHierarchy(p);
          h.forEach(function(y) {
            l.indexOf(y) < 0 && l.push(y);
          });
        };
        u(s), this.allOptions.preload && this.allOptions.preload.forEach(function(f) {
          return u(f);
        }), l.forEach(function(f) {
          n.allOptions.ns.forEach(function(p) {
            o.read(f, p, "read", null, null, function(h, y) {
              h && a.warn("loading namespace ".concat(p, " for language ").concat(f, " failed"), h), !h && y && a.log("loaded namespace ".concat(p, " for language ").concat(f), y), o.loaded("".concat(f, "|").concat(p), h, y);
            });
          });
        });
      }
    }
  }]), e;
}();
eI.type = "backend";
const tI = {
  smart_event_calendar_header: {
    styled_button_text: "Create operation",
    styled_text_title_text: "Smart event calendar"
  }
}, nI = {
  basic_info_fields: {
    form_item_label: "Name",
    form_item_msg: "The plan name is required.",
    form_item_placeholder: "Plan name",
    form_label_crop_cycle: "Crop cycle",
    form_label_estimated_planting_date: "Estimated planting date",
    form_rule_msg_estimated_planting_date: "The estimated planting date is required.",
    form_rules_msg_crop_cycle: "The crop cycle is required.",
    select_crop_cycle_placeholder: "Select crop cycle"
  },
  basic_info_form: {
    label_crop_cycle: "Crop cycle",
    label_estimated_planting_date: "Estimated planting date",
    select_crop_cycle_placeholder: "Select crop cycle",
    text_input_plan_label: "Name",
    text_input_plan_name: "plan_name",
    text_input_plan_placeholder: "Plan A"
  },
  confirmation_dialog: {
    alert_cancel_text: "Cancel",
    alert_description: "Would you like to exit?",
    alert_ok_text: "Yes, continue and exit",
    alert_title: "You will lose the data entered.",
    chevron_left_icon: "New plan"
  },
  delete_smart_plan_dialog: {
    alert_cancel_text: "Cancel",
    alert_description: "Would you like to delete this smart plan?",
    alert_message_cancel: "Operation Cancelled",
    alert_message_success: "Smart plan deleted successfully",
    alert_ok_text: "Yes",
    alert_title: "Delete smart plan"
  },
  list_filter: {
    button_apply_text: "Apply",
    button_cancel_text: "Cancel",
    button_clear_selection_text: "Clear selection"
  },
  operation_collapse: {
    info_group_description: "Soil treatment",
    info_group_hectares_description: "ha/sample",
    info_group_hectares_title: "Hectares/sample",
    info_group_inspection_group: "Inspection Group",
    info_group_sample_size_title: "Sample size per area",
    info_group_title: "Inspection group",
    operation_type_label: "SCOUTING"
  },
  operation_form: {
    button_cancel_text: "Cancel",
    button_create_operation_text: "Create operation",
    button_update_operation_text: "Update operation",
    criteria_msg: "The criteria is required.",
    input_name_placeholder: "Operation name",
    inspection_group_label_text: "Days after conclusion of previous activity",
    item_activity_msg: "The activity is required.",
    item_date_range_msg: "Date range is required.",
    item_days_msg: "The criteria days is required.",
    item_days_or_degress_msg: "The criteria days is required.",
    item_gdd_degrees_msg: "The criteria GDD value is required.",
    item_hectar_value_msg: "Hectar per area is required.",
    item_name_msg: "The operation name is required.",
    item_scounting_type_msg: "Point distribution is required.",
    label_criteria_text: "Criteria",
    label_name_text: "Name",
    parent_activity_label_text: "Activity to be considered",
    point_distribution_label_text: "Point distribution",
    radio_free_by_rate_text: "Hectares / sample",
    radio_free_sample_count_text: "Sample size per area",
    select_activity_placeholder: "Select",
    select_criteria_placeholder: "Select time range type",
    select_inspection_group_placeholder: "Select one or more inspection group",
    type_label_text: "Type: Scouting"
  },
  operation_list: {
    button_create_operation_text: "Create operation",
    list_title_text: "Operations"
  },
  operations_table: {
    calendar_icon_start_due_date_text: "START/DUE DATE",
    column_assignee_title: "Assignee",
    column_criteria_title: "Criteria",
    column_operation_name_title: "Operation name",
    column_region_field_title: "Property/Field",
    column_status_title: "Status",
    column_type_title: "Type",
    columns_start_date_title: "Start date",
    double_user_icon_assignee_text: "Assignee(s)",
    info_icon_details_text: "Details",
    label_deleted_text: "Delete",
    light_gray_tag_hectares_sample_text: "Hectares/sample:",
    light_gray_tag_inspection_group_text: "Inspection group:",
    regular_text_region_area_text: "Region / Area: 4",
    field_not_found: "Field not found"
  },
  region_tree_select: {
    props_selected_area_placeholder: "Please select"
  },
  search_input: {
    input_search_placeholder: "Search",
    tooltip_search_title: "Search"
  },
  smart_plan_subheader: {
    linked_header_operation_tasks_text: "Operations tasks",
    linked_header_plans_text: "Plans",
    pages_items_key_1_label: "10 / page",
    pages_items_key_2_label: "25 / page",
    pages_items_key_3_label: "50 / page",
    space_pages_text: "Pages",
    space_status_text: "Status",
    status_items_key_1_label: "All tasks",
    status_items_key_2_label: "Scheduled",
    status_items_key_3_label: "Delayed",
    status_items_key_4_label: "Completed"
  }
}, rI = {
  create_operation: {
    button_action_create_op_plan_text: "Create new operation plan",
    button_action_create_operation_text: "Create operation",
    drawer_create_operation_title: "Create new operation",
    empty_state_no_operation_description: "Click the below to create your first operation",
    empty_state_no_operation_title: "No operations were created for this plan",
    message_failed_registered: "Failed to record operations",
    the_operations: "The operations",
    does_not_have_schema: "do not have a related schema.",
    schema_not_found: "No schemas found for this crop in this workspace",
    message_success_registered: "Operations registered successfully. It could take a few minutes to be displayed on the Smart Event Calendar page",
    title_section_title: "Create and setup the operation plan"
  },
  create_plan: {
    control_steps_cancel_title: "Cancel",
    controle_steps_next_title: "Next",
    form_title_crop_cycle_text: "Basic information",
    title_section_crop_cycle_title: "What is the name and the crop cycle of the plan?"
  },
  fields: {
    control_step_second_next: "Next",
    control_steps_first_title: "Back",
    field_required_box_fields_name_msg: "* The fields are required.",
    title_section_title: "Select the fields"
  },
  smart_calendar: {
    button_link_text: "New plan",
    empty_state_description: "Click the below to create your first operation plan",
    empty_state_title: "No operation plan was created"
  }
}, oI = {
  create_plan: {
    form_title: "Basic information",
    title: "What is the name and the crop cycle of the plan?"
  }
}, iI = {
  atoms: tI,
  molecules: nI,
  sections: rI,
  smart_plan: oI
}, cde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  atoms: tI,
  default: iI,
  molecules: nI,
  sections: rI,
  smart_plan: oI
}, Symbol.toStringTag, { value: "Module" })), ude = () => an(void 0, null, function* () {
  return yield Zr.use(eI).use(U9).use(q9).use(ece).init({
    resources: {
      "en-GB": {
        translations: iI
      }
    },
    fallbackLng: "en-GB",
    lng: "en-GB",
    ns: ["translations"],
    defaultNS: "translations",
    debug: !0,
    interpolation: {
      escapeValue: !1
    }
  }), Zr;
});
ude();
const dde = (e) => an(void 0, null, function* () {
  const { default: t } = yield pce(/* @__PURE__ */ Object.assign({ "./locales/en-GB.json": () => Promise.resolve().then(() => cde), "./locales/pt-BR.json": () => import("./pt-BR-IYn7CvzD.js") }), `./locales/${e}.json`);
  yield Zr.changeLanguage(e, () => {
    Zr.addResourceBundle(e, "translations", t, !0, !0);
  });
}), fde = ({
  listVarieties: e,
  listSeasonFields: t,
  idByFields: n
}) => {
  var i;
  const r = (i = t == null ? void 0 : t.filter((a) => a.field_id === n)) == null ? void 0 : i[0], o = r == null ? void 0 : r.varieties_ids.reduce(
    (a, s) => {
      const l = e == null ? void 0 : e.find(
        ({ id: u }) => u === s
      );
      return l && a.push(l.name), a;
    },
    []
  );
  return {
    varietyFormatted: o == null ? void 0 : o.join(", "),
    variety: o
  };
}, pde = (e, t, n, r) => {
  if (e) {
    const o = t == null ? void 0 : t.map((i, a) => {
      const { id: s } = i, l = e == null ? void 0 : e.filter(({ property_id: u }) => u === s).map((u) => Bt(je({}, u), {
        variety: fde({
          listVarieties: n,
          listSeasonFields: r,
          idByFields: u.id
        }),
        key: u.id
      }));
      return Bt(je({}, i), {
        type_row: "property",
        key: a,
        children: [...l]
      });
    }).filter((i) => i.children.length > 0);
    if (o)
      return o;
  }
};
var ng = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
ng.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", u = 500, f = "__lodash_placeholder__", p = 1, h = 2, y = 4, b = 1, m = 2, v = 1, C = 2, x = 4, S = 8, E = 16, O = 32, $ = 64, _ = 128, R = 256, P = 512, I = 30, j = "...", F = 800, A = 16, M = 1, N = 2, D = 3, T = 1 / 0, L = 9007199254740991, z = 17976931348623157e292, H = NaN, V = 4294967295, Y = V - 1, Z = V >>> 1, oe = [
      ["ary", _],
      ["bind", v],
      ["bindKey", C],
      ["curry", S],
      ["curryRight", E],
      ["flip", P],
      ["partial", O],
      ["partialRight", $],
      ["rearg", R]
    ], ee = "[object Arguments]", ae = "[object Array]", le = "[object AsyncFunction]", ue = "[object Boolean]", ie = "[object Date]", re = "[object DOMException]", Q = "[object Error]", ce = "[object Function]", ge = "[object GeneratorFunction]", G = "[object Map]", ne = "[object Number]", fe = "[object Null]", ye = "[object Object]", we = "[object Promise]", he = "[object Proxy]", me = "[object RegExp]", Ce = "[object Set]", Te = "[object String]", Ee = "[object Symbol]", Ge = "[object Undefined]", ke = "[object WeakMap]", qe = "[object WeakSet]", ze = "[object ArrayBuffer]", pt = "[object DataView]", Ke = "[object Float32Array]", et = "[object Float64Array]", Je = "[object Int8Array]", Et = "[object Int16Array]", Ye = "[object Int32Array]", wt = "[object Uint8Array]", dt = "[object Uint8ClampedArray]", Ct = "[object Uint16Array]", ot = "[object Uint32Array]", jt = /\b__p \+= '';/g, Rt = /\b(__p \+=) '' \+/g, Le = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ve = /&(?:amp|lt|gt|quot|#39);/g, Ae = /[&<>"']/g, ft = RegExp(Ve.source), He = RegExp(Ae.source), Fe = /<%-([\s\S]+?)%>/g, yt = /<%([\s\S]+?)%>/g, Qe = /<%=([\s\S]+?)%>/g, tt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lt = /^\w*$/, ht = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, bt = /[\\^$.*+?()[\]{}|]/g, ct = RegExp(bt.source), xt = /^\s+/, vt = /\s/, _e = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ze = /\{\n\/\* \[wrapped with (.+)\] \*/, q = /,? & /, Se = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Re = /[()=,{}\[\]\/\s]/, ut = /\\(\\)?/g, $t = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ne = /\w*$/, Ie = /^[-+]0x[0-9a-f]+$/i, De = /^0b[01]+$/i, Me = /^\[object .+?Constructor\]$/, Tt = /^0o[0-7]+$/i, Pt = /^(?:0|[1-9]\d*)$/, Ut = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Kt = /($^)/, $n = /['\n\r\u2028\u2029\\]/g, Jt = "\\ud800-\\udfff", On = "\\u0300-\\u036f", Jn = "\\ufe20-\\ufe2f", er = "\\u20d0-\\u20ff", Xt = On + Jn + er, It = "\\u2700-\\u27bf", St = "a-z\\xdf-\\xf6\\xf8-\\xff", Lt = "\\xac\\xb1\\xd7\\xf7", ln = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", lr = "\\u2000-\\u206f", fr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Er = "A-Z\\xc0-\\xd6\\xd8-\\xde", Qr = "\\ufe0e\\ufe0f", $r = Lt + ln + lr + fr, Or = "['’]", io = "[" + Jt + "]", At = "[" + $r + "]", Nt = "[" + Xt + "]", Qt = "\\d+", vn = "[" + It + "]", sn = "[" + St + "]", Mn = "[^" + Jt + $r + Qt + It + St + Er + "]", Wn = "\\ud83c[\\udffb-\\udfff]", Dr = "(?:" + Nt + "|" + Wn + ")", Gt = "[^" + Jt + "]", Zt = "(?:\\ud83c[\\udde6-\\uddff]){2}", hn = "[\\ud800-\\udbff][\\udc00-\\udfff]", tn = "[" + Er + "]", yr = "\\u200d", _r = "(?:" + sn + "|" + Mn + ")", Wr = "(?:" + tn + "|" + Mn + ")", jr = "(?:" + Or + "(?:d|ll|m|re|s|t|ve))?", ao = "(?:" + Or + "(?:D|LL|M|RE|S|T|VE))?", To = Dr + "?", Gi = "[" + Qr + "]?", pa = "(?:" + yr + "(?:" + [Gt, Zt, hn].join("|") + ")" + Gi + To + ")*", ri = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Xa = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Za = Gi + To + pa, ha = "(?:" + [vn, Zt, hn].join("|") + ")" + Za, Wt = "(?:" + [Gt + Nt + "?", Nt, Zt, hn, io].join("|") + ")", nn = RegExp(Or, "g"), nr = RegExp(Nt, "g"), hr = RegExp(Wn + "(?=" + Wn + ")|" + Wt + Za, "g"), rr = RegExp([
      tn + "?" + sn + "+" + jr + "(?=" + [At, tn, "$"].join("|") + ")",
      Wr + "+" + ao + "(?=" + [At, tn + _r, "$"].join("|") + ")",
      tn + "?" + _r + "+" + jr,
      tn + "+" + ao,
      Xa,
      ri,
      Qt,
      ha
    ].join("|"), "g"), ga = RegExp("[" + yr + Jt + Xt + Qr + "]"), ks = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Qa = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Ja = -1, cr = {};
    cr[Ke] = cr[et] = cr[Je] = cr[Et] = cr[Ye] = cr[wt] = cr[dt] = cr[Ct] = cr[ot] = !0, cr[ee] = cr[ae] = cr[ze] = cr[ue] = cr[pt] = cr[ie] = cr[Q] = cr[ce] = cr[G] = cr[ne] = cr[ye] = cr[me] = cr[Ce] = cr[Te] = cr[ke] = !1;
    var or = {};
    or[ee] = or[ae] = or[ze] = or[pt] = or[ue] = or[ie] = or[Ke] = or[et] = or[Je] = or[Et] = or[Ye] = or[G] = or[ne] = or[ye] = or[me] = or[Ce] = or[Te] = or[Ee] = or[wt] = or[dt] = or[Ct] = or[ot] = !0, or[Q] = or[ce] = or[ke] = !1;
    var pf = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, vm = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ym = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, bm = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, hf = parseFloat, gf = parseInt, mf = typeof lo == "object" && lo && lo.Object === Object && lo, vf = typeof self == "object" && self && self.Object === Object && self, Kr = mf || vf || Function("return this")(), Ml = t && !t.nodeType && t, qi = Ml && !0 && e && !e.nodeType && e, pu = qi && qi.exports === Ml, hu = pu && mf.process, xo = function() {
      try {
        var xe = qi && qi.require && qi.require("util").types;
        return xe || hu && hu.binding && hu.binding("util");
      } catch (Xe) {
      }
    }(), yf = xo && xo.isArrayBuffer, gu = xo && xo.isDate, mu = xo && xo.isMap, vu = xo && xo.isRegExp, bf = xo && xo.isSet, Cf = xo && xo.isTypedArray;
    function So(xe, Xe, Be) {
      switch (Be.length) {
        case 0:
          return xe.call(Xe);
        case 1:
          return xe.call(Xe, Be[0]);
        case 2:
          return xe.call(Xe, Be[0], Be[1]);
        case 3:
          return xe.call(Xe, Be[0], Be[1], Be[2]);
      }
      return xe.apply(Xe, Be);
    }
    function Cm(xe, Xe, Be, zt) {
      for (var dn = -1, Un = xe == null ? 0 : xe.length; ++dn < Un; ) {
        var Ur = xe[dn];
        Xe(zt, Ur, Be(Ur), xe);
      }
      return zt;
    }
    function fo(xe, Xe) {
      for (var Be = -1, zt = xe == null ? 0 : xe.length; ++Be < zt && Xe(xe[Be], Be, xe) !== !1; )
        ;
      return xe;
    }
    function xm(xe, Xe) {
      for (var Be = xe == null ? 0 : xe.length; Be-- && Xe(xe[Be], Be, xe) !== !1; )
        ;
      return xe;
    }
    function xf(xe, Xe) {
      for (var Be = -1, zt = xe == null ? 0 : xe.length; ++Be < zt; )
        if (!Xe(xe[Be], Be, xe))
          return !1;
      return !0;
    }
    function oi(xe, Xe) {
      for (var Be = -1, zt = xe == null ? 0 : xe.length, dn = 0, Un = []; ++Be < zt; ) {
        var Ur = xe[Be];
        Xe(Ur, Be, xe) && (Un[dn++] = Ur);
      }
      return Un;
    }
    function Wo(xe, Xe) {
      var Be = xe == null ? 0 : xe.length;
      return !!Be && ma(xe, Xe, 0) > -1;
    }
    function Ll(xe, Xe, Be) {
      for (var zt = -1, dn = xe == null ? 0 : xe.length; ++zt < dn; )
        if (Be(Xe, xe[zt]))
          return !0;
      return !1;
    }
    function pr(xe, Xe) {
      for (var Be = -1, zt = xe == null ? 0 : xe.length, dn = Array(zt); ++Be < zt; )
        dn[Be] = Xe(xe[Be], Be, xe);
      return dn;
    }
    function wi(xe, Xe) {
      for (var Be = -1, zt = Xe.length, dn = xe.length; ++Be < zt; )
        xe[dn + Be] = Xe[Be];
      return xe;
    }
    function Al(xe, Xe, Be, zt) {
      var dn = -1, Un = xe == null ? 0 : xe.length;
      for (zt && Un && (Be = xe[++dn]); ++dn < Un; )
        Be = Xe(Be, xe[dn], dn, xe);
      return Be;
    }
    function Sm(xe, Xe, Be, zt) {
      var dn = xe == null ? 0 : xe.length;
      for (zt && dn && (Be = xe[--dn]); dn--; )
        Be = Xe(Be, xe[dn], dn, xe);
      return Be;
    }
    function yu(xe, Xe) {
      for (var Be = -1, zt = xe == null ? 0 : xe.length; ++Be < zt; )
        if (Xe(xe[Be], Be, xe))
          return !0;
      return !1;
    }
    var wm = Cu("length");
    function Sf(xe) {
      return xe.split("");
    }
    function Em(xe) {
      return xe.match(Se) || [];
    }
    function wf(xe, Xe, Be) {
      var zt;
      return Be(xe, function(dn, Un, Ur) {
        if (Xe(dn, Un, Ur))
          return zt = Un, !1;
      }), zt;
    }
    function jl(xe, Xe, Be, zt) {
      for (var dn = xe.length, Un = Be + (zt ? 1 : -1); zt ? Un-- : ++Un < dn; )
        if (Xe(xe[Un], Un, xe))
          return Un;
      return -1;
    }
    function ma(xe, Xe, Be) {
      return Xe === Xe ? TI(xe, Xe, Be) : jl(xe, kl, Be);
    }
    function bu(xe, Xe, Be, zt) {
      for (var dn = Be - 1, Un = xe.length; ++dn < Un; )
        if (zt(xe[dn], Xe))
          return dn;
      return -1;
    }
    function kl(xe) {
      return xe !== xe;
    }
    function Ef(xe, Xe) {
      var Be = xe == null ? 0 : xe.length;
      return Be ? cn(xe, Xe) / Be : H;
    }
    function Cu(xe) {
      return function(Xe) {
        return Xe == null ? n : Xe[xe];
      };
    }
    function yn(xe) {
      return function(Xe) {
        return xe == null ? n : xe[Xe];
      };
    }
    function Mt(xe, Xe, Be, zt, dn) {
      return dn(xe, function(Un, Ur, ur) {
        Be = zt ? (zt = !1, Un) : Xe(Be, Un, Ur, ur);
      }), Be;
    }
    function un(xe, Xe) {
      var Be = xe.length;
      for (xe.sort(Xe); Be--; )
        xe[Be] = xe[Be].value;
      return xe;
    }
    function cn(xe, Xe) {
      for (var Be, zt = -1, dn = xe.length; ++zt < dn; ) {
        var Un = Xe(xe[zt]);
        Un !== n && (Be = Be === n ? Un : Be + Un);
      }
      return Be;
    }
    function Kn(xe, Xe) {
      for (var Be = -1, zt = Array(xe); ++Be < xe; )
        zt[Be] = Xe(Be);
      return zt;
    }
    function Jr(xe, Xe) {
      return pr(Xe, function(Be) {
        return [Be, xe[Be]];
      });
    }
    function Mo(xe) {
      return xe && xe.slice(0, JC(xe) + 1).replace(xt, "");
    }
    function xr(xe) {
      return function(Xe) {
        return xe(Xe);
      };
    }
    function ii(xe, Xe) {
      return pr(Xe, function(Be) {
        return xe[Be];
      });
    }
    function Ei(xe, Xe) {
      return xe.has(Xe);
    }
    function Yi(xe, Xe) {
      for (var Be = -1, zt = xe.length; ++Be < zt && ma(Xe, xe[Be], 0) > -1; )
        ;
      return Be;
    }
    function po(xe, Xe) {
      for (var Be = xe.length; Be-- && ma(Xe, xe[Be], 0) > -1; )
        ;
      return Be;
    }
    function $I(xe, Xe) {
      for (var Be = xe.length, zt = 0; Be--; )
        xe[Be] === Xe && ++zt;
      return zt;
    }
    var OI = yn(pf), _I = yn(vm);
    function NI(xe) {
      return "\\" + bm[xe];
    }
    function PI(xe, Xe) {
      return xe == null ? n : xe[Xe];
    }
    function Fl(xe) {
      return ga.test(xe);
    }
    function II(xe) {
      return ks.test(xe);
    }
    function RI(xe) {
      for (var Xe, Be = []; !(Xe = xe.next()).done; )
        Be.push(Xe.value);
      return Be;
    }
    function $m(xe) {
      var Xe = -1, Be = Array(xe.size);
      return xe.forEach(function(zt, dn) {
        Be[++Xe] = [dn, zt];
      }), Be;
    }
    function QC(xe, Xe) {
      return function(Be) {
        return xe(Xe(Be));
      };
    }
    function es(xe, Xe) {
      for (var Be = -1, zt = xe.length, dn = 0, Un = []; ++Be < zt; ) {
        var Ur = xe[Be];
        (Ur === Xe || Ur === f) && (xe[Be] = f, Un[dn++] = Be);
      }
      return Un;
    }
    function $f(xe) {
      var Xe = -1, Be = Array(xe.size);
      return xe.forEach(function(zt) {
        Be[++Xe] = zt;
      }), Be;
    }
    function DI(xe) {
      var Xe = -1, Be = Array(xe.size);
      return xe.forEach(function(zt) {
        Be[++Xe] = [zt, zt];
      }), Be;
    }
    function TI(xe, Xe, Be) {
      for (var zt = Be - 1, dn = xe.length; ++zt < dn; )
        if (xe[zt] === Xe)
          return zt;
      return -1;
    }
    function MI(xe, Xe, Be) {
      for (var zt = Be + 1; zt--; )
        if (xe[zt] === Xe)
          return zt;
      return zt;
    }
    function Bl(xe) {
      return Fl(xe) ? AI(xe) : wm(xe);
    }
    function $i(xe) {
      return Fl(xe) ? jI(xe) : Sf(xe);
    }
    function JC(xe) {
      for (var Xe = xe.length; Xe-- && vt.test(xe.charAt(Xe)); )
        ;
      return Xe;
    }
    var LI = yn(ym);
    function AI(xe) {
      for (var Xe = hr.lastIndex = 0; hr.test(xe); )
        ++Xe;
      return Xe;
    }
    function jI(xe) {
      return xe.match(hr) || [];
    }
    function kI(xe) {
      return xe.match(rr) || [];
    }
    var FI = function xe(Xe) {
      Xe = Xe == null ? Kr : Hl.defaults(Kr.Object(), Xe, Hl.pick(Kr, Qa));
      var Be = Xe.Array, zt = Xe.Date, dn = Xe.Error, Un = Xe.Function, Ur = Xe.Math, ur = Xe.Object, Om = Xe.RegExp, BI = Xe.String, ai = Xe.TypeError, Of = Be.prototype, HI = Un.prototype, zl = ur.prototype, _f = Xe["__core-js_shared__"], Nf = HI.toString, tr = zl.hasOwnProperty, zI = 0, ex = function() {
        var d = /[^.]+$/.exec(_f && _f.keys && _f.keys.IE_PROTO || "");
        return d ? "Symbol(src)_1." + d : "";
      }(), Pf = zl.toString, VI = Nf.call(ur), WI = Kr._, KI = Om(
        "^" + Nf.call(tr).replace(bt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), If = pu ? Xe.Buffer : n, ts = Xe.Symbol, Rf = Xe.Uint8Array, tx = If ? If.allocUnsafe : n, Df = QC(ur.getPrototypeOf, ur), nx = ur.create, rx = zl.propertyIsEnumerable, Tf = Of.splice, ox = ts ? ts.isConcatSpreadable : n, xu = ts ? ts.iterator : n, Fs = ts ? ts.toStringTag : n, Mf = function() {
        try {
          var d = Ws(ur, "defineProperty");
          return d({}, "", {}), d;
        } catch (g) {
        }
      }(), UI = Xe.clearTimeout !== Kr.clearTimeout && Xe.clearTimeout, GI = zt && zt.now !== Kr.Date.now && zt.now, qI = Xe.setTimeout !== Kr.setTimeout && Xe.setTimeout, Lf = Ur.ceil, Af = Ur.floor, _m = ur.getOwnPropertySymbols, YI = If ? If.isBuffer : n, ix = Xe.isFinite, XI = Of.join, ZI = QC(ur.keys, ur), Gr = Ur.max, ho = Ur.min, QI = zt.now, JI = Xe.parseInt, ax = Ur.random, eR = Of.reverse, Nm = Ws(Xe, "DataView"), Su = Ws(Xe, "Map"), Pm = Ws(Xe, "Promise"), Vl = Ws(Xe, "Set"), wu = Ws(Xe, "WeakMap"), Eu = Ws(ur, "create"), jf = wu && new wu(), Wl = {}, tR = Ks(Nm), nR = Ks(Su), rR = Ks(Pm), oR = Ks(Vl), iR = Ks(wu), kf = ts ? ts.prototype : n, $u = kf ? kf.valueOf : n, sx = kf ? kf.toString : n;
      function U(d) {
        if (Nr(d) && !fn(d) && !(d instanceof Rn)) {
          if (d instanceof si)
            return d;
          if (tr.call(d, "__wrapped__"))
            return lS(d);
        }
        return new si(d);
      }
      var Kl = /* @__PURE__ */ function() {
        function d() {
        }
        return function(g) {
          if (!Sr(g))
            return {};
          if (nx)
            return nx(g);
          d.prototype = g;
          var w = new d();
          return d.prototype = n, w;
        };
      }();
      function Ff() {
      }
      function si(d, g) {
        this.__wrapped__ = d, this.__actions__ = [], this.__chain__ = !!g, this.__index__ = 0, this.__values__ = n;
      }
      U.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Fe,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: yt,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Qe,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: U
        }
      }, U.prototype = Ff.prototype, U.prototype.constructor = U, si.prototype = Kl(Ff.prototype), si.prototype.constructor = si;
      function Rn(d) {
        this.__wrapped__ = d, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = V, this.__views__ = [];
      }
      function aR() {
        var d = new Rn(this.__wrapped__);
        return d.__actions__ = Lo(this.__actions__), d.__dir__ = this.__dir__, d.__filtered__ = this.__filtered__, d.__iteratees__ = Lo(this.__iteratees__), d.__takeCount__ = this.__takeCount__, d.__views__ = Lo(this.__views__), d;
      }
      function sR() {
        if (this.__filtered__) {
          var d = new Rn(this);
          d.__dir__ = -1, d.__filtered__ = !0;
        } else
          d = this.clone(), d.__dir__ *= -1;
        return d;
      }
      function lR() {
        var d = this.__wrapped__.value(), g = this.__dir__, w = fn(d), k = g < 0, W = w ? d.length : 0, X = C7(0, W, this.__views__), pe = X.start, ve = X.end, $e = ve - pe, it = k ? ve : pe - 1, at = this.__iteratees__, gt = at.length, Dt = 0, qt = ho($e, this.__takeCount__);
        if (!w || !k && W == $e && qt == $e)
          return Rx(d, this.__actions__);
        var rn = [];
        e:
          for (; $e-- && Dt < qt; ) {
            it += g;
            for (var wn = -1, on = d[it]; ++wn < gt; ) {
              var In = at[wn], Ln = In.iteratee, Go = In.type, $o = Ln(on);
              if (Go == N)
                on = $o;
              else if (!$o) {
                if (Go == M)
                  continue e;
                break e;
              }
            }
            rn[Dt++] = on;
          }
        return rn;
      }
      Rn.prototype = Kl(Ff.prototype), Rn.prototype.constructor = Rn;
      function Bs(d) {
        var g = -1, w = d == null ? 0 : d.length;
        for (this.clear(); ++g < w; ) {
          var k = d[g];
          this.set(k[0], k[1]);
        }
      }
      function cR() {
        this.__data__ = Eu ? Eu(null) : {}, this.size = 0;
      }
      function uR(d) {
        var g = this.has(d) && delete this.__data__[d];
        return this.size -= g ? 1 : 0, g;
      }
      function dR(d) {
        var g = this.__data__;
        if (Eu) {
          var w = g[d];
          return w === l ? n : w;
        }
        return tr.call(g, d) ? g[d] : n;
      }
      function fR(d) {
        var g = this.__data__;
        return Eu ? g[d] !== n : tr.call(g, d);
      }
      function pR(d, g) {
        var w = this.__data__;
        return this.size += this.has(d) ? 0 : 1, w[d] = Eu && g === n ? l : g, this;
      }
      Bs.prototype.clear = cR, Bs.prototype.delete = uR, Bs.prototype.get = dR, Bs.prototype.has = fR, Bs.prototype.set = pR;
      function va(d) {
        var g = -1, w = d == null ? 0 : d.length;
        for (this.clear(); ++g < w; ) {
          var k = d[g];
          this.set(k[0], k[1]);
        }
      }
      function hR() {
        this.__data__ = [], this.size = 0;
      }
      function gR(d) {
        var g = this.__data__, w = Bf(g, d);
        if (w < 0)
          return !1;
        var k = g.length - 1;
        return w == k ? g.pop() : Tf.call(g, w, 1), --this.size, !0;
      }
      function mR(d) {
        var g = this.__data__, w = Bf(g, d);
        return w < 0 ? n : g[w][1];
      }
      function vR(d) {
        return Bf(this.__data__, d) > -1;
      }
      function yR(d, g) {
        var w = this.__data__, k = Bf(w, d);
        return k < 0 ? (++this.size, w.push([d, g])) : w[k][1] = g, this;
      }
      va.prototype.clear = hR, va.prototype.delete = gR, va.prototype.get = mR, va.prototype.has = vR, va.prototype.set = yR;
      function ya(d) {
        var g = -1, w = d == null ? 0 : d.length;
        for (this.clear(); ++g < w; ) {
          var k = d[g];
          this.set(k[0], k[1]);
        }
      }
      function bR() {
        this.size = 0, this.__data__ = {
          hash: new Bs(),
          map: new (Su || va)(),
          string: new Bs()
        };
      }
      function CR(d) {
        var g = Qf(this, d).delete(d);
        return this.size -= g ? 1 : 0, g;
      }
      function xR(d) {
        return Qf(this, d).get(d);
      }
      function SR(d) {
        return Qf(this, d).has(d);
      }
      function wR(d, g) {
        var w = Qf(this, d), k = w.size;
        return w.set(d, g), this.size += w.size == k ? 0 : 1, this;
      }
      ya.prototype.clear = bR, ya.prototype.delete = CR, ya.prototype.get = xR, ya.prototype.has = SR, ya.prototype.set = wR;
      function Hs(d) {
        var g = -1, w = d == null ? 0 : d.length;
        for (this.__data__ = new ya(); ++g < w; )
          this.add(d[g]);
      }
      function ER(d) {
        return this.__data__.set(d, l), this;
      }
      function $R(d) {
        return this.__data__.has(d);
      }
      Hs.prototype.add = Hs.prototype.push = ER, Hs.prototype.has = $R;
      function Oi(d) {
        var g = this.__data__ = new va(d);
        this.size = g.size;
      }
      function OR() {
        this.__data__ = new va(), this.size = 0;
      }
      function _R(d) {
        var g = this.__data__, w = g.delete(d);
        return this.size = g.size, w;
      }
      function NR(d) {
        return this.__data__.get(d);
      }
      function PR(d) {
        return this.__data__.has(d);
      }
      function IR(d, g) {
        var w = this.__data__;
        if (w instanceof va) {
          var k = w.__data__;
          if (!Su || k.length < o - 1)
            return k.push([d, g]), this.size = ++w.size, this;
          w = this.__data__ = new ya(k);
        }
        return w.set(d, g), this.size = w.size, this;
      }
      Oi.prototype.clear = OR, Oi.prototype.delete = _R, Oi.prototype.get = NR, Oi.prototype.has = PR, Oi.prototype.set = IR;
      function lx(d, g) {
        var w = fn(d), k = !w && Us(d), W = !w && !k && as(d), X = !w && !k && !W && Yl(d), pe = w || k || W || X, ve = pe ? Kn(d.length, BI) : [], $e = ve.length;
        for (var it in d)
          (g || tr.call(d, it)) && !(pe && // Safari 9 has enumerable `arguments.length` in strict mode.
          (it == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          W && (it == "offset" || it == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          X && (it == "buffer" || it == "byteLength" || it == "byteOffset") || // Skip index properties.
          Sa(it, $e))) && ve.push(it);
        return ve;
      }
      function cx(d) {
        var g = d.length;
        return g ? d[Bm(0, g - 1)] : n;
      }
      function RR(d, g) {
        return Jf(Lo(d), zs(g, 0, d.length));
      }
      function DR(d) {
        return Jf(Lo(d));
      }
      function Im(d, g, w) {
        (w !== n && !_i(d[g], w) || w === n && !(g in d)) && ba(d, g, w);
      }
      function Ou(d, g, w) {
        var k = d[g];
        (!(tr.call(d, g) && _i(k, w)) || w === n && !(g in d)) && ba(d, g, w);
      }
      function Bf(d, g) {
        for (var w = d.length; w--; )
          if (_i(d[w][0], g))
            return w;
        return -1;
      }
      function TR(d, g, w, k) {
        return ns(d, function(W, X, pe) {
          g(k, W, w(W), pe);
        }), k;
      }
      function ux(d, g) {
        return d && Zi(g, eo(g), d);
      }
      function MR(d, g) {
        return d && Zi(g, jo(g), d);
      }
      function ba(d, g, w) {
        g == "__proto__" && Mf ? Mf(d, g, {
          configurable: !0,
          enumerable: !0,
          value: w,
          writable: !0
        }) : d[g] = w;
      }
      function Rm(d, g) {
        for (var w = -1, k = g.length, W = Be(k), X = d == null; ++w < k; )
          W[w] = X ? n : dv(d, g[w]);
        return W;
      }
      function zs(d, g, w) {
        return d === d && (w !== n && (d = d <= w ? d : w), g !== n && (d = d >= g ? d : g)), d;
      }
      function li(d, g, w, k, W, X) {
        var pe, ve = g & p, $e = g & h, it = g & y;
        if (w && (pe = W ? w(d, k, W, X) : w(d)), pe !== n)
          return pe;
        if (!Sr(d))
          return d;
        var at = fn(d);
        if (at) {
          if (pe = S7(d), !ve)
            return Lo(d, pe);
        } else {
          var gt = go(d), Dt = gt == ce || gt == ge;
          if (as(d))
            return Mx(d, ve);
          if (gt == ye || gt == ee || Dt && !W) {
            if (pe = $e || Dt ? {} : Jx(d), !ve)
              return $e ? d7(d, MR(pe, d)) : u7(d, ux(pe, d));
          } else {
            if (!or[gt])
              return W ? d : {};
            pe = w7(d, gt, ve);
          }
        }
        X || (X = new Oi());
        var qt = X.get(d);
        if (qt)
          return qt;
        X.set(d, pe), NS(d) ? d.forEach(function(on) {
          pe.add(li(on, g, w, on, d, X));
        }) : OS(d) && d.forEach(function(on, In) {
          pe.set(In, li(on, g, w, In, d, X));
        });
        var rn = it ? $e ? Zm : Xm : $e ? jo : eo, wn = at ? n : rn(d);
        return fo(wn || d, function(on, In) {
          wn && (In = on, on = d[In]), Ou(pe, In, li(on, g, w, In, d, X));
        }), pe;
      }
      function LR(d) {
        var g = eo(d);
        return function(w) {
          return dx(w, d, g);
        };
      }
      function dx(d, g, w) {
        var k = w.length;
        if (d == null)
          return !k;
        for (d = ur(d); k--; ) {
          var W = w[k], X = g[W], pe = d[W];
          if (pe === n && !(W in d) || !X(pe))
            return !1;
        }
        return !0;
      }
      function fx(d, g, w) {
        if (typeof d != "function")
          throw new ai(a);
        return Tu(function() {
          d.apply(n, w);
        }, g);
      }
      function _u(d, g, w, k) {
        var W = -1, X = Wo, pe = !0, ve = d.length, $e = [], it = g.length;
        if (!ve)
          return $e;
        w && (g = pr(g, xr(w))), k ? (X = Ll, pe = !1) : g.length >= o && (X = Ei, pe = !1, g = new Hs(g));
        e:
          for (; ++W < ve; ) {
            var at = d[W], gt = w == null ? at : w(at);
            if (at = k || at !== 0 ? at : 0, pe && gt === gt) {
              for (var Dt = it; Dt--; )
                if (g[Dt] === gt)
                  continue e;
              $e.push(at);
            } else
              X(g, gt, k) || $e.push(at);
          }
        return $e;
      }
      var ns = Fx(Xi), px = Fx(Tm, !0);
      function AR(d, g) {
        var w = !0;
        return ns(d, function(k, W, X) {
          return w = !!g(k, W, X), w;
        }), w;
      }
      function Hf(d, g, w) {
        for (var k = -1, W = d.length; ++k < W; ) {
          var X = d[k], pe = g(X);
          if (pe != null && (ve === n ? pe === pe && !Uo(pe) : w(pe, ve)))
            var ve = pe, $e = X;
        }
        return $e;
      }
      function jR(d, g, w, k) {
        var W = d.length;
        for (w = bn(w), w < 0 && (w = -w > W ? 0 : W + w), k = k === n || k > W ? W : bn(k), k < 0 && (k += W), k = w > k ? 0 : IS(k); w < k; )
          d[w++] = g;
        return d;
      }
      function hx(d, g) {
        var w = [];
        return ns(d, function(k, W, X) {
          g(k, W, X) && w.push(k);
        }), w;
      }
      function so(d, g, w, k, W) {
        var X = -1, pe = d.length;
        for (w || (w = $7), W || (W = []); ++X < pe; ) {
          var ve = d[X];
          g > 0 && w(ve) ? g > 1 ? so(ve, g - 1, w, k, W) : wi(W, ve) : k || (W[W.length] = ve);
        }
        return W;
      }
      var Dm = Bx(), gx = Bx(!0);
      function Xi(d, g) {
        return d && Dm(d, g, eo);
      }
      function Tm(d, g) {
        return d && gx(d, g, eo);
      }
      function zf(d, g) {
        return oi(g, function(w) {
          return wa(d[w]);
        });
      }
      function Vs(d, g) {
        g = os(g, d);
        for (var w = 0, k = g.length; d != null && w < k; )
          d = d[Qi(g[w++])];
        return w && w == k ? d : n;
      }
      function mx(d, g, w) {
        var k = g(d);
        return fn(d) ? k : wi(k, w(d));
      }
      function wo(d) {
        return d == null ? d === n ? Ge : fe : Fs && Fs in ur(d) ? b7(d) : D7(d);
      }
      function Mm(d, g) {
        return d > g;
      }
      function kR(d, g) {
        return d != null && tr.call(d, g);
      }
      function FR(d, g) {
        return d != null && g in ur(d);
      }
      function BR(d, g, w) {
        return d >= ho(g, w) && d < Gr(g, w);
      }
      function Lm(d, g, w) {
        for (var k = w ? Ll : Wo, W = d[0].length, X = d.length, pe = X, ve = Be(X), $e = 1 / 0, it = []; pe--; ) {
          var at = d[pe];
          pe && g && (at = pr(at, xr(g))), $e = ho(at.length, $e), ve[pe] = !w && (g || W >= 120 && at.length >= 120) ? new Hs(pe && at) : n;
        }
        at = d[0];
        var gt = -1, Dt = ve[0];
        e:
          for (; ++gt < W && it.length < $e; ) {
            var qt = at[gt], rn = g ? g(qt) : qt;
            if (qt = w || qt !== 0 ? qt : 0, !(Dt ? Ei(Dt, rn) : k(it, rn, w))) {
              for (pe = X; --pe; ) {
                var wn = ve[pe];
                if (!(wn ? Ei(wn, rn) : k(d[pe], rn, w)))
                  continue e;
              }
              Dt && Dt.push(rn), it.push(qt);
            }
          }
        return it;
      }
      function HR(d, g, w, k) {
        return Xi(d, function(W, X, pe) {
          g(k, w(W), X, pe);
        }), k;
      }
      function Nu(d, g, w) {
        g = os(g, d), d = rS(d, g);
        var k = d == null ? d : d[Qi(ui(g))];
        return k == null ? n : So(k, d, w);
      }
      function vx(d) {
        return Nr(d) && wo(d) == ee;
      }
      function zR(d) {
        return Nr(d) && wo(d) == ze;
      }
      function VR(d) {
        return Nr(d) && wo(d) == ie;
      }
      function Pu(d, g, w, k, W) {
        return d === g ? !0 : d == null || g == null || !Nr(d) && !Nr(g) ? d !== d && g !== g : WR(d, g, w, k, Pu, W);
      }
      function WR(d, g, w, k, W, X) {
        var pe = fn(d), ve = fn(g), $e = pe ? ae : go(d), it = ve ? ae : go(g);
        $e = $e == ee ? ye : $e, it = it == ee ? ye : it;
        var at = $e == ye, gt = it == ye, Dt = $e == it;
        if (Dt && as(d)) {
          if (!as(g))
            return !1;
          pe = !0, at = !1;
        }
        if (Dt && !at)
          return X || (X = new Oi()), pe || Yl(d) ? Xx(d, g, w, k, W, X) : v7(d, g, $e, w, k, W, X);
        if (!(w & b)) {
          var qt = at && tr.call(d, "__wrapped__"), rn = gt && tr.call(g, "__wrapped__");
          if (qt || rn) {
            var wn = qt ? d.value() : d, on = rn ? g.value() : g;
            return X || (X = new Oi()), W(wn, on, w, k, X);
          }
        }
        return Dt ? (X || (X = new Oi()), y7(d, g, w, k, W, X)) : !1;
      }
      function KR(d) {
        return Nr(d) && go(d) == G;
      }
      function Am(d, g, w, k) {
        var W = w.length, X = W, pe = !k;
        if (d == null)
          return !X;
        for (d = ur(d); W--; ) {
          var ve = w[W];
          if (pe && ve[2] ? ve[1] !== d[ve[0]] : !(ve[0] in d))
            return !1;
        }
        for (; ++W < X; ) {
          ve = w[W];
          var $e = ve[0], it = d[$e], at = ve[1];
          if (pe && ve[2]) {
            if (it === n && !($e in d))
              return !1;
          } else {
            var gt = new Oi();
            if (k)
              var Dt = k(it, at, $e, d, g, gt);
            if (!(Dt === n ? Pu(at, it, b | m, k, gt) : Dt))
              return !1;
          }
        }
        return !0;
      }
      function yx(d) {
        if (!Sr(d) || _7(d))
          return !1;
        var g = wa(d) ? KI : Me;
        return g.test(Ks(d));
      }
      function UR(d) {
        return Nr(d) && wo(d) == me;
      }
      function GR(d) {
        return Nr(d) && go(d) == Ce;
      }
      function qR(d) {
        return Nr(d) && ip(d.length) && !!cr[wo(d)];
      }
      function bx(d) {
        return typeof d == "function" ? d : d == null ? ko : typeof d == "object" ? fn(d) ? Sx(d[0], d[1]) : xx(d) : HS(d);
      }
      function jm(d) {
        if (!Du(d))
          return ZI(d);
        var g = [];
        for (var w in ur(d))
          tr.call(d, w) && w != "constructor" && g.push(w);
        return g;
      }
      function YR(d) {
        if (!Sr(d))
          return R7(d);
        var g = Du(d), w = [];
        for (var k in d)
          k == "constructor" && (g || !tr.call(d, k)) || w.push(k);
        return w;
      }
      function km(d, g) {
        return d < g;
      }
      function Cx(d, g) {
        var w = -1, k = Ao(d) ? Be(d.length) : [];
        return ns(d, function(W, X, pe) {
          k[++w] = g(W, X, pe);
        }), k;
      }
      function xx(d) {
        var g = Jm(d);
        return g.length == 1 && g[0][2] ? tS(g[0][0], g[0][1]) : function(w) {
          return w === d || Am(w, d, g);
        };
      }
      function Sx(d, g) {
        return tv(d) && eS(g) ? tS(Qi(d), g) : function(w) {
          var k = dv(w, d);
          return k === n && k === g ? fv(w, d) : Pu(g, k, b | m);
        };
      }
      function Vf(d, g, w, k, W) {
        d !== g && Dm(g, function(X, pe) {
          if (W || (W = new Oi()), Sr(X))
            XR(d, g, pe, w, Vf, k, W);
          else {
            var ve = k ? k(rv(d, pe), X, pe + "", d, g, W) : n;
            ve === n && (ve = X), Im(d, pe, ve);
          }
        }, jo);
      }
      function XR(d, g, w, k, W, X, pe) {
        var ve = rv(d, w), $e = rv(g, w), it = pe.get($e);
        if (it) {
          Im(d, w, it);
          return;
        }
        var at = X ? X(ve, $e, w + "", d, g, pe) : n, gt = at === n;
        if (gt) {
          var Dt = fn($e), qt = !Dt && as($e), rn = !Dt && !qt && Yl($e);
          at = $e, Dt || qt || rn ? fn(ve) ? at = ve : Tr(ve) ? at = Lo(ve) : qt ? (gt = !1, at = Mx($e, !0)) : rn ? (gt = !1, at = Lx($e, !0)) : at = [] : Mu($e) || Us($e) ? (at = ve, Us(ve) ? at = RS(ve) : (!Sr(ve) || wa(ve)) && (at = Jx($e))) : gt = !1;
        }
        gt && (pe.set($e, at), W(at, $e, k, X, pe), pe.delete($e)), Im(d, w, at);
      }
      function wx(d, g) {
        var w = d.length;
        if (w)
          return g += g < 0 ? w : 0, Sa(g, w) ? d[g] : n;
      }
      function Ex(d, g, w) {
        g.length ? g = pr(g, function(X) {
          return fn(X) ? function(pe) {
            return Vs(pe, X.length === 1 ? X[0] : X);
          } : X;
        }) : g = [ko];
        var k = -1;
        g = pr(g, xr(en()));
        var W = Cx(d, function(X, pe, ve) {
          var $e = pr(g, function(it) {
            return it(X);
          });
          return { criteria: $e, index: ++k, value: X };
        });
        return un(W, function(X, pe) {
          return c7(X, pe, w);
        });
      }
      function ZR(d, g) {
        return $x(d, g, function(w, k) {
          return fv(d, k);
        });
      }
      function $x(d, g, w) {
        for (var k = -1, W = g.length, X = {}; ++k < W; ) {
          var pe = g[k], ve = Vs(d, pe);
          w(ve, pe) && Iu(X, os(pe, d), ve);
        }
        return X;
      }
      function QR(d) {
        return function(g) {
          return Vs(g, d);
        };
      }
      function Fm(d, g, w, k) {
        var W = k ? bu : ma, X = -1, pe = g.length, ve = d;
        for (d === g && (g = Lo(g)), w && (ve = pr(d, xr(w))); ++X < pe; )
          for (var $e = 0, it = g[X], at = w ? w(it) : it; ($e = W(ve, at, $e, k)) > -1; )
            ve !== d && Tf.call(ve, $e, 1), Tf.call(d, $e, 1);
        return d;
      }
      function Ox(d, g) {
        for (var w = d ? g.length : 0, k = w - 1; w--; ) {
          var W = g[w];
          if (w == k || W !== X) {
            var X = W;
            Sa(W) ? Tf.call(d, W, 1) : Vm(d, W);
          }
        }
        return d;
      }
      function Bm(d, g) {
        return d + Af(ax() * (g - d + 1));
      }
      function JR(d, g, w, k) {
        for (var W = -1, X = Gr(Lf((g - d) / (w || 1)), 0), pe = Be(X); X--; )
          pe[k ? X : ++W] = d, d += w;
        return pe;
      }
      function Hm(d, g) {
        var w = "";
        if (!d || g < 1 || g > L)
          return w;
        do
          g % 2 && (w += d), g = Af(g / 2), g && (d += d);
        while (g);
        return w;
      }
      function _n(d, g) {
        return ov(nS(d, g, ko), d + "");
      }
      function e7(d) {
        return cx(Xl(d));
      }
      function t7(d, g) {
        var w = Xl(d);
        return Jf(w, zs(g, 0, w.length));
      }
      function Iu(d, g, w, k) {
        if (!Sr(d))
          return d;
        g = os(g, d);
        for (var W = -1, X = g.length, pe = X - 1, ve = d; ve != null && ++W < X; ) {
          var $e = Qi(g[W]), it = w;
          if ($e === "__proto__" || $e === "constructor" || $e === "prototype")
            return d;
          if (W != pe) {
            var at = ve[$e];
            it = k ? k(at, $e, ve) : n, it === n && (it = Sr(at) ? at : Sa(g[W + 1]) ? [] : {});
          }
          Ou(ve, $e, it), ve = ve[$e];
        }
        return d;
      }
      var _x = jf ? function(d, g) {
        return jf.set(d, g), d;
      } : ko, n7 = Mf ? function(d, g) {
        return Mf(d, "toString", {
          configurable: !0,
          enumerable: !1,
          value: hv(g),
          writable: !0
        });
      } : ko;
      function r7(d) {
        return Jf(Xl(d));
      }
      function ci(d, g, w) {
        var k = -1, W = d.length;
        g < 0 && (g = -g > W ? 0 : W + g), w = w > W ? W : w, w < 0 && (w += W), W = g > w ? 0 : w - g >>> 0, g >>>= 0;
        for (var X = Be(W); ++k < W; )
          X[k] = d[k + g];
        return X;
      }
      function o7(d, g) {
        var w;
        return ns(d, function(k, W, X) {
          return w = g(k, W, X), !w;
        }), !!w;
      }
      function Wf(d, g, w) {
        var k = 0, W = d == null ? k : d.length;
        if (typeof g == "number" && g === g && W <= Z) {
          for (; k < W; ) {
            var X = k + W >>> 1, pe = d[X];
            pe !== null && !Uo(pe) && (w ? pe <= g : pe < g) ? k = X + 1 : W = X;
          }
          return W;
        }
        return zm(d, g, ko, w);
      }
      function zm(d, g, w, k) {
        var W = 0, X = d == null ? 0 : d.length;
        if (X === 0)
          return 0;
        g = w(g);
        for (var pe = g !== g, ve = g === null, $e = Uo(g), it = g === n; W < X; ) {
          var at = Af((W + X) / 2), gt = w(d[at]), Dt = gt !== n, qt = gt === null, rn = gt === gt, wn = Uo(gt);
          if (pe)
            var on = k || rn;
          else
            it ? on = rn && (k || Dt) : ve ? on = rn && Dt && (k || !qt) : $e ? on = rn && Dt && !qt && (k || !wn) : qt || wn ? on = !1 : on = k ? gt <= g : gt < g;
          on ? W = at + 1 : X = at;
        }
        return ho(X, Y);
      }
      function Nx(d, g) {
        for (var w = -1, k = d.length, W = 0, X = []; ++w < k; ) {
          var pe = d[w], ve = g ? g(pe) : pe;
          if (!w || !_i(ve, $e)) {
            var $e = ve;
            X[W++] = pe === 0 ? 0 : pe;
          }
        }
        return X;
      }
      function Px(d) {
        return typeof d == "number" ? d : Uo(d) ? H : +d;
      }
      function Ko(d) {
        if (typeof d == "string")
          return d;
        if (fn(d))
          return pr(d, Ko) + "";
        if (Uo(d))
          return sx ? sx.call(d) : "";
        var g = d + "";
        return g == "0" && 1 / d == -T ? "-0" : g;
      }
      function rs(d, g, w) {
        var k = -1, W = Wo, X = d.length, pe = !0, ve = [], $e = ve;
        if (w)
          pe = !1, W = Ll;
        else if (X >= o) {
          var it = g ? null : g7(d);
          if (it)
            return $f(it);
          pe = !1, W = Ei, $e = new Hs();
        } else
          $e = g ? [] : ve;
        e:
          for (; ++k < X; ) {
            var at = d[k], gt = g ? g(at) : at;
            if (at = w || at !== 0 ? at : 0, pe && gt === gt) {
              for (var Dt = $e.length; Dt--; )
                if ($e[Dt] === gt)
                  continue e;
              g && $e.push(gt), ve.push(at);
            } else
              W($e, gt, w) || ($e !== ve && $e.push(gt), ve.push(at));
          }
        return ve;
      }
      function Vm(d, g) {
        return g = os(g, d), d = rS(d, g), d == null || delete d[Qi(ui(g))];
      }
      function Ix(d, g, w, k) {
        return Iu(d, g, w(Vs(d, g)), k);
      }
      function Kf(d, g, w, k) {
        for (var W = d.length, X = k ? W : -1; (k ? X-- : ++X < W) && g(d[X], X, d); )
          ;
        return w ? ci(d, k ? 0 : X, k ? X + 1 : W) : ci(d, k ? X + 1 : 0, k ? W : X);
      }
      function Rx(d, g) {
        var w = d;
        return w instanceof Rn && (w = w.value()), Al(g, function(k, W) {
          return W.func.apply(W.thisArg, wi([k], W.args));
        }, w);
      }
      function Wm(d, g, w) {
        var k = d.length;
        if (k < 2)
          return k ? rs(d[0]) : [];
        for (var W = -1, X = Be(k); ++W < k; )
          for (var pe = d[W], ve = -1; ++ve < k; )
            ve != W && (X[W] = _u(X[W] || pe, d[ve], g, w));
        return rs(so(X, 1), g, w);
      }
      function Dx(d, g, w) {
        for (var k = -1, W = d.length, X = g.length, pe = {}; ++k < W; ) {
          var ve = k < X ? g[k] : n;
          w(pe, d[k], ve);
        }
        return pe;
      }
      function Km(d) {
        return Tr(d) ? d : [];
      }
      function Um(d) {
        return typeof d == "function" ? d : ko;
      }
      function os(d, g) {
        return fn(d) ? d : tv(d, g) ? [d] : sS(qn(d));
      }
      var i7 = _n;
      function is(d, g, w) {
        var k = d.length;
        return w = w === n ? k : w, !g && w >= k ? d : ci(d, g, w);
      }
      var Tx = UI || function(d) {
        return Kr.clearTimeout(d);
      };
      function Mx(d, g) {
        if (g)
          return d.slice();
        var w = d.length, k = tx ? tx(w) : new d.constructor(w);
        return d.copy(k), k;
      }
      function Gm(d) {
        var g = new d.constructor(d.byteLength);
        return new Rf(g).set(new Rf(d)), g;
      }
      function a7(d, g) {
        var w = g ? Gm(d.buffer) : d.buffer;
        return new d.constructor(w, d.byteOffset, d.byteLength);
      }
      function s7(d) {
        var g = new d.constructor(d.source, Ne.exec(d));
        return g.lastIndex = d.lastIndex, g;
      }
      function l7(d) {
        return $u ? ur($u.call(d)) : {};
      }
      function Lx(d, g) {
        var w = g ? Gm(d.buffer) : d.buffer;
        return new d.constructor(w, d.byteOffset, d.length);
      }
      function Ax(d, g) {
        if (d !== g) {
          var w = d !== n, k = d === null, W = d === d, X = Uo(d), pe = g !== n, ve = g === null, $e = g === g, it = Uo(g);
          if (!ve && !it && !X && d > g || X && pe && $e && !ve && !it || k && pe && $e || !w && $e || !W)
            return 1;
          if (!k && !X && !it && d < g || it && w && W && !k && !X || ve && w && W || !pe && W || !$e)
            return -1;
        }
        return 0;
      }
      function c7(d, g, w) {
        for (var k = -1, W = d.criteria, X = g.criteria, pe = W.length, ve = w.length; ++k < pe; ) {
          var $e = Ax(W[k], X[k]);
          if ($e) {
            if (k >= ve)
              return $e;
            var it = w[k];
            return $e * (it == "desc" ? -1 : 1);
          }
        }
        return d.index - g.index;
      }
      function jx(d, g, w, k) {
        for (var W = -1, X = d.length, pe = w.length, ve = -1, $e = g.length, it = Gr(X - pe, 0), at = Be($e + it), gt = !k; ++ve < $e; )
          at[ve] = g[ve];
        for (; ++W < pe; )
          (gt || W < X) && (at[w[W]] = d[W]);
        for (; it--; )
          at[ve++] = d[W++];
        return at;
      }
      function kx(d, g, w, k) {
        for (var W = -1, X = d.length, pe = -1, ve = w.length, $e = -1, it = g.length, at = Gr(X - ve, 0), gt = Be(at + it), Dt = !k; ++W < at; )
          gt[W] = d[W];
        for (var qt = W; ++$e < it; )
          gt[qt + $e] = g[$e];
        for (; ++pe < ve; )
          (Dt || W < X) && (gt[qt + w[pe]] = d[W++]);
        return gt;
      }
      function Lo(d, g) {
        var w = -1, k = d.length;
        for (g || (g = Be(k)); ++w < k; )
          g[w] = d[w];
        return g;
      }
      function Zi(d, g, w, k) {
        var W = !w;
        w || (w = {});
        for (var X = -1, pe = g.length; ++X < pe; ) {
          var ve = g[X], $e = k ? k(w[ve], d[ve], ve, w, d) : n;
          $e === n && ($e = d[ve]), W ? ba(w, ve, $e) : Ou(w, ve, $e);
        }
        return w;
      }
      function u7(d, g) {
        return Zi(d, ev(d), g);
      }
      function d7(d, g) {
        return Zi(d, Zx(d), g);
      }
      function Uf(d, g) {
        return function(w, k) {
          var W = fn(w) ? Cm : TR, X = g ? g() : {};
          return W(w, d, en(k, 2), X);
        };
      }
      function Ul(d) {
        return _n(function(g, w) {
          var k = -1, W = w.length, X = W > 1 ? w[W - 1] : n, pe = W > 2 ? w[2] : n;
          for (X = d.length > 3 && typeof X == "function" ? (W--, X) : n, pe && Eo(w[0], w[1], pe) && (X = W < 3 ? n : X, W = 1), g = ur(g); ++k < W; ) {
            var ve = w[k];
            ve && d(g, ve, k, X);
          }
          return g;
        });
      }
      function Fx(d, g) {
        return function(w, k) {
          if (w == null)
            return w;
          if (!Ao(w))
            return d(w, k);
          for (var W = w.length, X = g ? W : -1, pe = ur(w); (g ? X-- : ++X < W) && k(pe[X], X, pe) !== !1; )
            ;
          return w;
        };
      }
      function Bx(d) {
        return function(g, w, k) {
          for (var W = -1, X = ur(g), pe = k(g), ve = pe.length; ve--; ) {
            var $e = pe[d ? ve : ++W];
            if (w(X[$e], $e, X) === !1)
              break;
          }
          return g;
        };
      }
      function f7(d, g, w) {
        var k = g & v, W = Ru(d);
        function X() {
          var pe = this && this !== Kr && this instanceof X ? W : d;
          return pe.apply(k ? w : this, arguments);
        }
        return X;
      }
      function Hx(d) {
        return function(g) {
          g = qn(g);
          var w = Fl(g) ? $i(g) : n, k = w ? w[0] : g.charAt(0), W = w ? is(w, 1).join("") : g.slice(1);
          return k[d]() + W;
        };
      }
      function Gl(d) {
        return function(g) {
          return Al(FS(kS(g).replace(nn, "")), d, "");
        };
      }
      function Ru(d) {
        return function() {
          var g = arguments;
          switch (g.length) {
            case 0:
              return new d();
            case 1:
              return new d(g[0]);
            case 2:
              return new d(g[0], g[1]);
            case 3:
              return new d(g[0], g[1], g[2]);
            case 4:
              return new d(g[0], g[1], g[2], g[3]);
            case 5:
              return new d(g[0], g[1], g[2], g[3], g[4]);
            case 6:
              return new d(g[0], g[1], g[2], g[3], g[4], g[5]);
            case 7:
              return new d(g[0], g[1], g[2], g[3], g[4], g[5], g[6]);
          }
          var w = Kl(d.prototype), k = d.apply(w, g);
          return Sr(k) ? k : w;
        };
      }
      function p7(d, g, w) {
        var k = Ru(d);
        function W() {
          for (var X = arguments.length, pe = Be(X), ve = X, $e = ql(W); ve--; )
            pe[ve] = arguments[ve];
          var it = X < 3 && pe[0] !== $e && pe[X - 1] !== $e ? [] : es(pe, $e);
          if (X -= it.length, X < w)
            return Ux(
              d,
              g,
              Gf,
              W.placeholder,
              n,
              pe,
              it,
              n,
              n,
              w - X
            );
          var at = this && this !== Kr && this instanceof W ? k : d;
          return So(at, this, pe);
        }
        return W;
      }
      function zx(d) {
        return function(g, w, k) {
          var W = ur(g);
          if (!Ao(g)) {
            var X = en(w, 3);
            g = eo(g), w = function(ve) {
              return X(W[ve], ve, W);
            };
          }
          var pe = d(g, w, k);
          return pe > -1 ? W[X ? g[pe] : pe] : n;
        };
      }
      function Vx(d) {
        return xa(function(g) {
          var w = g.length, k = w, W = si.prototype.thru;
          for (d && g.reverse(); k--; ) {
            var X = g[k];
            if (typeof X != "function")
              throw new ai(a);
            if (W && !pe && Zf(X) == "wrapper")
              var pe = new si([], !0);
          }
          for (k = pe ? k : w; ++k < w; ) {
            X = g[k];
            var ve = Zf(X), $e = ve == "wrapper" ? Qm(X) : n;
            $e && nv($e[0]) && $e[1] == (_ | S | O | R) && !$e[4].length && $e[9] == 1 ? pe = pe[Zf($e[0])].apply(pe, $e[3]) : pe = X.length == 1 && nv(X) ? pe[ve]() : pe.thru(X);
          }
          return function() {
            var it = arguments, at = it[0];
            if (pe && it.length == 1 && fn(at))
              return pe.plant(at).value();
            for (var gt = 0, Dt = w ? g[gt].apply(this, it) : at; ++gt < w; )
              Dt = g[gt].call(this, Dt);
            return Dt;
          };
        });
      }
      function Gf(d, g, w, k, W, X, pe, ve, $e, it) {
        var at = g & _, gt = g & v, Dt = g & C, qt = g & (S | E), rn = g & P, wn = Dt ? n : Ru(d);
        function on() {
          for (var In = arguments.length, Ln = Be(In), Go = In; Go--; )
            Ln[Go] = arguments[Go];
          if (qt)
            var $o = ql(on), qo = $I(Ln, $o);
          if (k && (Ln = jx(Ln, k, W, qt)), X && (Ln = kx(Ln, X, pe, qt)), In -= qo, qt && In < it) {
            var Mr = es(Ln, $o);
            return Ux(
              d,
              g,
              Gf,
              on.placeholder,
              w,
              Ln,
              Mr,
              ve,
              $e,
              it - In
            );
          }
          var Ni = gt ? w : this, $a = Dt ? Ni[d] : d;
          return In = Ln.length, ve ? Ln = T7(Ln, ve) : rn && In > 1 && Ln.reverse(), at && $e < In && (Ln.length = $e), this && this !== Kr && this instanceof on && ($a = wn || Ru($a)), $a.apply(Ni, Ln);
        }
        return on;
      }
      function Wx(d, g) {
        return function(w, k) {
          return HR(w, d, g(k), {});
        };
      }
      function qf(d, g) {
        return function(w, k) {
          var W;
          if (w === n && k === n)
            return g;
          if (w !== n && (W = w), k !== n) {
            if (W === n)
              return k;
            typeof w == "string" || typeof k == "string" ? (w = Ko(w), k = Ko(k)) : (w = Px(w), k = Px(k)), W = d(w, k);
          }
          return W;
        };
      }
      function qm(d) {
        return xa(function(g) {
          return g = pr(g, xr(en())), _n(function(w) {
            var k = this;
            return d(g, function(W) {
              return So(W, k, w);
            });
          });
        });
      }
      function Yf(d, g) {
        g = g === n ? " " : Ko(g);
        var w = g.length;
        if (w < 2)
          return w ? Hm(g, d) : g;
        var k = Hm(g, Lf(d / Bl(g)));
        return Fl(g) ? is($i(k), 0, d).join("") : k.slice(0, d);
      }
      function h7(d, g, w, k) {
        var W = g & v, X = Ru(d);
        function pe() {
          for (var ve = -1, $e = arguments.length, it = -1, at = k.length, gt = Be(at + $e), Dt = this && this !== Kr && this instanceof pe ? X : d; ++it < at; )
            gt[it] = k[it];
          for (; $e--; )
            gt[it++] = arguments[++ve];
          return So(Dt, W ? w : this, gt);
        }
        return pe;
      }
      function Kx(d) {
        return function(g, w, k) {
          return k && typeof k != "number" && Eo(g, w, k) && (w = k = n), g = Ea(g), w === n ? (w = g, g = 0) : w = Ea(w), k = k === n ? g < w ? 1 : -1 : Ea(k), JR(g, w, k, d);
        };
      }
      function Xf(d) {
        return function(g, w) {
          return typeof g == "string" && typeof w == "string" || (g = di(g), w = di(w)), d(g, w);
        };
      }
      function Ux(d, g, w, k, W, X, pe, ve, $e, it) {
        var at = g & S, gt = at ? pe : n, Dt = at ? n : pe, qt = at ? X : n, rn = at ? n : X;
        g |= at ? O : $, g &= ~(at ? $ : O), g & x || (g &= ~(v | C));
        var wn = [
          d,
          g,
          W,
          qt,
          gt,
          rn,
          Dt,
          ve,
          $e,
          it
        ], on = w.apply(n, wn);
        return nv(d) && oS(on, wn), on.placeholder = k, iS(on, d, g);
      }
      function Ym(d) {
        var g = Ur[d];
        return function(w, k) {
          if (w = di(w), k = k == null ? 0 : ho(bn(k), 292), k && ix(w)) {
            var W = (qn(w) + "e").split("e"), X = g(W[0] + "e" + (+W[1] + k));
            return W = (qn(X) + "e").split("e"), +(W[0] + "e" + (+W[1] - k));
          }
          return g(w);
        };
      }
      var g7 = Vl && 1 / $f(new Vl([, -0]))[1] == T ? function(d) {
        return new Vl(d);
      } : vv;
      function Gx(d) {
        return function(g) {
          var w = go(g);
          return w == G ? $m(g) : w == Ce ? DI(g) : Jr(g, d(g));
        };
      }
      function Ca(d, g, w, k, W, X, pe, ve) {
        var $e = g & C;
        if (!$e && typeof d != "function")
          throw new ai(a);
        var it = k ? k.length : 0;
        if (it || (g &= ~(O | $), k = W = n), pe = pe === n ? pe : Gr(bn(pe), 0), ve = ve === n ? ve : bn(ve), it -= W ? W.length : 0, g & $) {
          var at = k, gt = W;
          k = W = n;
        }
        var Dt = $e ? n : Qm(d), qt = [
          d,
          g,
          w,
          k,
          W,
          at,
          gt,
          X,
          pe,
          ve
        ];
        if (Dt && I7(qt, Dt), d = qt[0], g = qt[1], w = qt[2], k = qt[3], W = qt[4], ve = qt[9] = qt[9] === n ? $e ? 0 : d.length : Gr(qt[9] - it, 0), !ve && g & (S | E) && (g &= ~(S | E)), !g || g == v)
          var rn = f7(d, g, w);
        else
          g == S || g == E ? rn = p7(d, g, ve) : (g == O || g == (v | O)) && !W.length ? rn = h7(d, g, w, k) : rn = Gf.apply(n, qt);
        var wn = Dt ? _x : oS;
        return iS(wn(rn, qt), d, g);
      }
      function qx(d, g, w, k) {
        return d === n || _i(d, zl[w]) && !tr.call(k, w) ? g : d;
      }
      function Yx(d, g, w, k, W, X) {
        return Sr(d) && Sr(g) && (X.set(g, d), Vf(d, g, n, Yx, X), X.delete(g)), d;
      }
      function m7(d) {
        return Mu(d) ? n : d;
      }
      function Xx(d, g, w, k, W, X) {
        var pe = w & b, ve = d.length, $e = g.length;
        if (ve != $e && !(pe && $e > ve))
          return !1;
        var it = X.get(d), at = X.get(g);
        if (it && at)
          return it == g && at == d;
        var gt = -1, Dt = !0, qt = w & m ? new Hs() : n;
        for (X.set(d, g), X.set(g, d); ++gt < ve; ) {
          var rn = d[gt], wn = g[gt];
          if (k)
            var on = pe ? k(wn, rn, gt, g, d, X) : k(rn, wn, gt, d, g, X);
          if (on !== n) {
            if (on)
              continue;
            Dt = !1;
            break;
          }
          if (qt) {
            if (!yu(g, function(In, Ln) {
              if (!Ei(qt, Ln) && (rn === In || W(rn, In, w, k, X)))
                return qt.push(Ln);
            })) {
              Dt = !1;
              break;
            }
          } else if (!(rn === wn || W(rn, wn, w, k, X))) {
            Dt = !1;
            break;
          }
        }
        return X.delete(d), X.delete(g), Dt;
      }
      function v7(d, g, w, k, W, X, pe) {
        switch (w) {
          case pt:
            if (d.byteLength != g.byteLength || d.byteOffset != g.byteOffset)
              return !1;
            d = d.buffer, g = g.buffer;
          case ze:
            return !(d.byteLength != g.byteLength || !X(new Rf(d), new Rf(g)));
          case ue:
          case ie:
          case ne:
            return _i(+d, +g);
          case Q:
            return d.name == g.name && d.message == g.message;
          case me:
          case Te:
            return d == g + "";
          case G:
            var ve = $m;
          case Ce:
            var $e = k & b;
            if (ve || (ve = $f), d.size != g.size && !$e)
              return !1;
            var it = pe.get(d);
            if (it)
              return it == g;
            k |= m, pe.set(d, g);
            var at = Xx(ve(d), ve(g), k, W, X, pe);
            return pe.delete(d), at;
          case Ee:
            if ($u)
              return $u.call(d) == $u.call(g);
        }
        return !1;
      }
      function y7(d, g, w, k, W, X) {
        var pe = w & b, ve = Xm(d), $e = ve.length, it = Xm(g), at = it.length;
        if ($e != at && !pe)
          return !1;
        for (var gt = $e; gt--; ) {
          var Dt = ve[gt];
          if (!(pe ? Dt in g : tr.call(g, Dt)))
            return !1;
        }
        var qt = X.get(d), rn = X.get(g);
        if (qt && rn)
          return qt == g && rn == d;
        var wn = !0;
        X.set(d, g), X.set(g, d);
        for (var on = pe; ++gt < $e; ) {
          Dt = ve[gt];
          var In = d[Dt], Ln = g[Dt];
          if (k)
            var Go = pe ? k(Ln, In, Dt, g, d, X) : k(In, Ln, Dt, d, g, X);
          if (!(Go === n ? In === Ln || W(In, Ln, w, k, X) : Go)) {
            wn = !1;
            break;
          }
          on || (on = Dt == "constructor");
        }
        if (wn && !on) {
          var $o = d.constructor, qo = g.constructor;
          $o != qo && "constructor" in d && "constructor" in g && !(typeof $o == "function" && $o instanceof $o && typeof qo == "function" && qo instanceof qo) && (wn = !1);
        }
        return X.delete(d), X.delete(g), wn;
      }
      function xa(d) {
        return ov(nS(d, n, dS), d + "");
      }
      function Xm(d) {
        return mx(d, eo, ev);
      }
      function Zm(d) {
        return mx(d, jo, Zx);
      }
      var Qm = jf ? function(d) {
        return jf.get(d);
      } : vv;
      function Zf(d) {
        for (var g = d.name + "", w = Wl[g], k = tr.call(Wl, g) ? w.length : 0; k--; ) {
          var W = w[k], X = W.func;
          if (X == null || X == d)
            return W.name;
        }
        return g;
      }
      function ql(d) {
        var g = tr.call(U, "placeholder") ? U : d;
        return g.placeholder;
      }
      function en() {
        var d = U.iteratee || gv;
        return d = d === gv ? bx : d, arguments.length ? d(arguments[0], arguments[1]) : d;
      }
      function Qf(d, g) {
        var w = d.__data__;
        return O7(g) ? w[typeof g == "string" ? "string" : "hash"] : w.map;
      }
      function Jm(d) {
        for (var g = eo(d), w = g.length; w--; ) {
          var k = g[w], W = d[k];
          g[w] = [k, W, eS(W)];
        }
        return g;
      }
      function Ws(d, g) {
        var w = PI(d, g);
        return yx(w) ? w : n;
      }
      function b7(d) {
        var g = tr.call(d, Fs), w = d[Fs];
        try {
          d[Fs] = n;
          var k = !0;
        } catch (X) {
        }
        var W = Pf.call(d);
        return k && (g ? d[Fs] = w : delete d[Fs]), W;
      }
      var ev = _m ? function(d) {
        return d == null ? [] : (d = ur(d), oi(_m(d), function(g) {
          return rx.call(d, g);
        }));
      } : yv, Zx = _m ? function(d) {
        for (var g = []; d; )
          wi(g, ev(d)), d = Df(d);
        return g;
      } : yv, go = wo;
      (Nm && go(new Nm(new ArrayBuffer(1))) != pt || Su && go(new Su()) != G || Pm && go(Pm.resolve()) != we || Vl && go(new Vl()) != Ce || wu && go(new wu()) != ke) && (go = function(d) {
        var g = wo(d), w = g == ye ? d.constructor : n, k = w ? Ks(w) : "";
        if (k)
          switch (k) {
            case tR:
              return pt;
            case nR:
              return G;
            case rR:
              return we;
            case oR:
              return Ce;
            case iR:
              return ke;
          }
        return g;
      });
      function C7(d, g, w) {
        for (var k = -1, W = w.length; ++k < W; ) {
          var X = w[k], pe = X.size;
          switch (X.type) {
            case "drop":
              d += pe;
              break;
            case "dropRight":
              g -= pe;
              break;
            case "take":
              g = ho(g, d + pe);
              break;
            case "takeRight":
              d = Gr(d, g - pe);
              break;
          }
        }
        return { start: d, end: g };
      }
      function x7(d) {
        var g = d.match(Ze);
        return g ? g[1].split(q) : [];
      }
      function Qx(d, g, w) {
        g = os(g, d);
        for (var k = -1, W = g.length, X = !1; ++k < W; ) {
          var pe = Qi(g[k]);
          if (!(X = d != null && w(d, pe)))
            break;
          d = d[pe];
        }
        return X || ++k != W ? X : (W = d == null ? 0 : d.length, !!W && ip(W) && Sa(pe, W) && (fn(d) || Us(d)));
      }
      function S7(d) {
        var g = d.length, w = new d.constructor(g);
        return g && typeof d[0] == "string" && tr.call(d, "index") && (w.index = d.index, w.input = d.input), w;
      }
      function Jx(d) {
        return typeof d.constructor == "function" && !Du(d) ? Kl(Df(d)) : {};
      }
      function w7(d, g, w) {
        var k = d.constructor;
        switch (g) {
          case ze:
            return Gm(d);
          case ue:
          case ie:
            return new k(+d);
          case pt:
            return a7(d, w);
          case Ke:
          case et:
          case Je:
          case Et:
          case Ye:
          case wt:
          case dt:
          case Ct:
          case ot:
            return Lx(d, w);
          case G:
            return new k();
          case ne:
          case Te:
            return new k(d);
          case me:
            return s7(d);
          case Ce:
            return new k();
          case Ee:
            return l7(d);
        }
      }
      function E7(d, g) {
        var w = g.length;
        if (!w)
          return d;
        var k = w - 1;
        return g[k] = (w > 1 ? "& " : "") + g[k], g = g.join(w > 2 ? ", " : " "), d.replace(_e, `{
/* [wrapped with ` + g + `] */
`);
      }
      function $7(d) {
        return fn(d) || Us(d) || !!(ox && d && d[ox]);
      }
      function Sa(d, g) {
        var w = typeof d;
        return g = g == null ? L : g, !!g && (w == "number" || w != "symbol" && Pt.test(d)) && d > -1 && d % 1 == 0 && d < g;
      }
      function Eo(d, g, w) {
        if (!Sr(w))
          return !1;
        var k = typeof g;
        return (k == "number" ? Ao(w) && Sa(g, w.length) : k == "string" && g in w) ? _i(w[g], d) : !1;
      }
      function tv(d, g) {
        if (fn(d))
          return !1;
        var w = typeof d;
        return w == "number" || w == "symbol" || w == "boolean" || d == null || Uo(d) ? !0 : lt.test(d) || !tt.test(d) || g != null && d in ur(g);
      }
      function O7(d) {
        var g = typeof d;
        return g == "string" || g == "number" || g == "symbol" || g == "boolean" ? d !== "__proto__" : d === null;
      }
      function nv(d) {
        var g = Zf(d), w = U[g];
        if (typeof w != "function" || !(g in Rn.prototype))
          return !1;
        if (d === w)
          return !0;
        var k = Qm(w);
        return !!k && d === k[0];
      }
      function _7(d) {
        return !!ex && ex in d;
      }
      var N7 = _f ? wa : bv;
      function Du(d) {
        var g = d && d.constructor, w = typeof g == "function" && g.prototype || zl;
        return d === w;
      }
      function eS(d) {
        return d === d && !Sr(d);
      }
      function tS(d, g) {
        return function(w) {
          return w == null ? !1 : w[d] === g && (g !== n || d in ur(w));
        };
      }
      function P7(d) {
        var g = rp(d, function(k) {
          return w.size === u && w.clear(), k;
        }), w = g.cache;
        return g;
      }
      function I7(d, g) {
        var w = d[1], k = g[1], W = w | k, X = W < (v | C | _), pe = k == _ && w == S || k == _ && w == R && d[7].length <= g[8] || k == (_ | R) && g[7].length <= g[8] && w == S;
        if (!(X || pe))
          return d;
        k & v && (d[2] = g[2], W |= w & v ? 0 : x);
        var ve = g[3];
        if (ve) {
          var $e = d[3];
          d[3] = $e ? jx($e, ve, g[4]) : ve, d[4] = $e ? es(d[3], f) : g[4];
        }
        return ve = g[5], ve && ($e = d[5], d[5] = $e ? kx($e, ve, g[6]) : ve, d[6] = $e ? es(d[5], f) : g[6]), ve = g[7], ve && (d[7] = ve), k & _ && (d[8] = d[8] == null ? g[8] : ho(d[8], g[8])), d[9] == null && (d[9] = g[9]), d[0] = g[0], d[1] = W, d;
      }
      function R7(d) {
        var g = [];
        if (d != null)
          for (var w in ur(d))
            g.push(w);
        return g;
      }
      function D7(d) {
        return Pf.call(d);
      }
      function nS(d, g, w) {
        return g = Gr(g === n ? d.length - 1 : g, 0), function() {
          for (var k = arguments, W = -1, X = Gr(k.length - g, 0), pe = Be(X); ++W < X; )
            pe[W] = k[g + W];
          W = -1;
          for (var ve = Be(g + 1); ++W < g; )
            ve[W] = k[W];
          return ve[g] = w(pe), So(d, this, ve);
        };
      }
      function rS(d, g) {
        return g.length < 2 ? d : Vs(d, ci(g, 0, -1));
      }
      function T7(d, g) {
        for (var w = d.length, k = ho(g.length, w), W = Lo(d); k--; ) {
          var X = g[k];
          d[k] = Sa(X, w) ? W[X] : n;
        }
        return d;
      }
      function rv(d, g) {
        if (!(g === "constructor" && typeof d[g] == "function") && g != "__proto__")
          return d[g];
      }
      var oS = aS(_x), Tu = qI || function(d, g) {
        return Kr.setTimeout(d, g);
      }, ov = aS(n7);
      function iS(d, g, w) {
        var k = g + "";
        return ov(d, E7(k, M7(x7(k), w)));
      }
      function aS(d) {
        var g = 0, w = 0;
        return function() {
          var k = QI(), W = A - (k - w);
          if (w = k, W > 0) {
            if (++g >= F)
              return arguments[0];
          } else
            g = 0;
          return d.apply(n, arguments);
        };
      }
      function Jf(d, g) {
        var w = -1, k = d.length, W = k - 1;
        for (g = g === n ? k : g; ++w < g; ) {
          var X = Bm(w, W), pe = d[X];
          d[X] = d[w], d[w] = pe;
        }
        return d.length = g, d;
      }
      var sS = P7(function(d) {
        var g = [];
        return d.charCodeAt(0) === 46 && g.push(""), d.replace(ht, function(w, k, W, X) {
          g.push(W ? X.replace(ut, "$1") : k || w);
        }), g;
      });
      function Qi(d) {
        if (typeof d == "string" || Uo(d))
          return d;
        var g = d + "";
        return g == "0" && 1 / d == -T ? "-0" : g;
      }
      function Ks(d) {
        if (d != null) {
          try {
            return Nf.call(d);
          } catch (g) {
          }
          try {
            return d + "";
          } catch (g) {
          }
        }
        return "";
      }
      function M7(d, g) {
        return fo(oe, function(w) {
          var k = "_." + w[0];
          g & w[1] && !Wo(d, k) && d.push(k);
        }), d.sort();
      }
      function lS(d) {
        if (d instanceof Rn)
          return d.clone();
        var g = new si(d.__wrapped__, d.__chain__);
        return g.__actions__ = Lo(d.__actions__), g.__index__ = d.__index__, g.__values__ = d.__values__, g;
      }
      function L7(d, g, w) {
        (w ? Eo(d, g, w) : g === n) ? g = 1 : g = Gr(bn(g), 0);
        var k = d == null ? 0 : d.length;
        if (!k || g < 1)
          return [];
        for (var W = 0, X = 0, pe = Be(Lf(k / g)); W < k; )
          pe[X++] = ci(d, W, W += g);
        return pe;
      }
      function A7(d) {
        for (var g = -1, w = d == null ? 0 : d.length, k = 0, W = []; ++g < w; ) {
          var X = d[g];
          X && (W[k++] = X);
        }
        return W;
      }
      function j7() {
        var d = arguments.length;
        if (!d)
          return [];
        for (var g = Be(d - 1), w = arguments[0], k = d; k--; )
          g[k - 1] = arguments[k];
        return wi(fn(w) ? Lo(w) : [w], so(g, 1));
      }
      var k7 = _n(function(d, g) {
        return Tr(d) ? _u(d, so(g, 1, Tr, !0)) : [];
      }), F7 = _n(function(d, g) {
        var w = ui(g);
        return Tr(w) && (w = n), Tr(d) ? _u(d, so(g, 1, Tr, !0), en(w, 2)) : [];
      }), B7 = _n(function(d, g) {
        var w = ui(g);
        return Tr(w) && (w = n), Tr(d) ? _u(d, so(g, 1, Tr, !0), n, w) : [];
      });
      function H7(d, g, w) {
        var k = d == null ? 0 : d.length;
        return k ? (g = w || g === n ? 1 : bn(g), ci(d, g < 0 ? 0 : g, k)) : [];
      }
      function z7(d, g, w) {
        var k = d == null ? 0 : d.length;
        return k ? (g = w || g === n ? 1 : bn(g), g = k - g, ci(d, 0, g < 0 ? 0 : g)) : [];
      }
      function V7(d, g) {
        return d && d.length ? Kf(d, en(g, 3), !0, !0) : [];
      }
      function W7(d, g) {
        return d && d.length ? Kf(d, en(g, 3), !0) : [];
      }
      function K7(d, g, w, k) {
        var W = d == null ? 0 : d.length;
        return W ? (w && typeof w != "number" && Eo(d, g, w) && (w = 0, k = W), jR(d, g, w, k)) : [];
      }
      function cS(d, g, w) {
        var k = d == null ? 0 : d.length;
        if (!k)
          return -1;
        var W = w == null ? 0 : bn(w);
        return W < 0 && (W = Gr(k + W, 0)), jl(d, en(g, 3), W);
      }
      function uS(d, g, w) {
        var k = d == null ? 0 : d.length;
        if (!k)
          return -1;
        var W = k - 1;
        return w !== n && (W = bn(w), W = w < 0 ? Gr(k + W, 0) : ho(W, k - 1)), jl(d, en(g, 3), W, !0);
      }
      function dS(d) {
        var g = d == null ? 0 : d.length;
        return g ? so(d, 1) : [];
      }
      function U7(d) {
        var g = d == null ? 0 : d.length;
        return g ? so(d, T) : [];
      }
      function G7(d, g) {
        var w = d == null ? 0 : d.length;
        return w ? (g = g === n ? 1 : bn(g), so(d, g)) : [];
      }
      function q7(d) {
        for (var g = -1, w = d == null ? 0 : d.length, k = {}; ++g < w; ) {
          var W = d[g];
          k[W[0]] = W[1];
        }
        return k;
      }
      function fS(d) {
        return d && d.length ? d[0] : n;
      }
      function Y7(d, g, w) {
        var k = d == null ? 0 : d.length;
        if (!k)
          return -1;
        var W = w == null ? 0 : bn(w);
        return W < 0 && (W = Gr(k + W, 0)), ma(d, g, W);
      }
      function X7(d) {
        var g = d == null ? 0 : d.length;
        return g ? ci(d, 0, -1) : [];
      }
      var Z7 = _n(function(d) {
        var g = pr(d, Km);
        return g.length && g[0] === d[0] ? Lm(g) : [];
      }), Q7 = _n(function(d) {
        var g = ui(d), w = pr(d, Km);
        return g === ui(w) ? g = n : w.pop(), w.length && w[0] === d[0] ? Lm(w, en(g, 2)) : [];
      }), J7 = _n(function(d) {
        var g = ui(d), w = pr(d, Km);
        return g = typeof g == "function" ? g : n, g && w.pop(), w.length && w[0] === d[0] ? Lm(w, n, g) : [];
      });
      function eD(d, g) {
        return d == null ? "" : XI.call(d, g);
      }
      function ui(d) {
        var g = d == null ? 0 : d.length;
        return g ? d[g - 1] : n;
      }
      function tD(d, g, w) {
        var k = d == null ? 0 : d.length;
        if (!k)
          return -1;
        var W = k;
        return w !== n && (W = bn(w), W = W < 0 ? Gr(k + W, 0) : ho(W, k - 1)), g === g ? MI(d, g, W) : jl(d, kl, W, !0);
      }
      function nD(d, g) {
        return d && d.length ? wx(d, bn(g)) : n;
      }
      var rD = _n(pS);
      function pS(d, g) {
        return d && d.length && g && g.length ? Fm(d, g) : d;
      }
      function oD(d, g, w) {
        return d && d.length && g && g.length ? Fm(d, g, en(w, 2)) : d;
      }
      function iD(d, g, w) {
        return d && d.length && g && g.length ? Fm(d, g, n, w) : d;
      }
      var aD = xa(function(d, g) {
        var w = d == null ? 0 : d.length, k = Rm(d, g);
        return Ox(d, pr(g, function(W) {
          return Sa(W, w) ? +W : W;
        }).sort(Ax)), k;
      });
      function sD(d, g) {
        var w = [];
        if (!(d && d.length))
          return w;
        var k = -1, W = [], X = d.length;
        for (g = en(g, 3); ++k < X; ) {
          var pe = d[k];
          g(pe, k, d) && (w.push(pe), W.push(k));
        }
        return Ox(d, W), w;
      }
      function iv(d) {
        return d == null ? d : eR.call(d);
      }
      function lD(d, g, w) {
        var k = d == null ? 0 : d.length;
        return k ? (w && typeof w != "number" && Eo(d, g, w) ? (g = 0, w = k) : (g = g == null ? 0 : bn(g), w = w === n ? k : bn(w)), ci(d, g, w)) : [];
      }
      function cD(d, g) {
        return Wf(d, g);
      }
      function uD(d, g, w) {
        return zm(d, g, en(w, 2));
      }
      function dD(d, g) {
        var w = d == null ? 0 : d.length;
        if (w) {
          var k = Wf(d, g);
          if (k < w && _i(d[k], g))
            return k;
        }
        return -1;
      }
      function fD(d, g) {
        return Wf(d, g, !0);
      }
      function pD(d, g, w) {
        return zm(d, g, en(w, 2), !0);
      }
      function hD(d, g) {
        var w = d == null ? 0 : d.length;
        if (w) {
          var k = Wf(d, g, !0) - 1;
          if (_i(d[k], g))
            return k;
        }
        return -1;
      }
      function gD(d) {
        return d && d.length ? Nx(d) : [];
      }
      function mD(d, g) {
        return d && d.length ? Nx(d, en(g, 2)) : [];
      }
      function vD(d) {
        var g = d == null ? 0 : d.length;
        return g ? ci(d, 1, g) : [];
      }
      function yD(d, g, w) {
        return d && d.length ? (g = w || g === n ? 1 : bn(g), ci(d, 0, g < 0 ? 0 : g)) : [];
      }
      function bD(d, g, w) {
        var k = d == null ? 0 : d.length;
        return k ? (g = w || g === n ? 1 : bn(g), g = k - g, ci(d, g < 0 ? 0 : g, k)) : [];
      }
      function CD(d, g) {
        return d && d.length ? Kf(d, en(g, 3), !1, !0) : [];
      }
      function xD(d, g) {
        return d && d.length ? Kf(d, en(g, 3)) : [];
      }
      var SD = _n(function(d) {
        return rs(so(d, 1, Tr, !0));
      }), wD = _n(function(d) {
        var g = ui(d);
        return Tr(g) && (g = n), rs(so(d, 1, Tr, !0), en(g, 2));
      }), ED = _n(function(d) {
        var g = ui(d);
        return g = typeof g == "function" ? g : n, rs(so(d, 1, Tr, !0), n, g);
      });
      function $D(d) {
        return d && d.length ? rs(d) : [];
      }
      function OD(d, g) {
        return d && d.length ? rs(d, en(g, 2)) : [];
      }
      function _D(d, g) {
        return g = typeof g == "function" ? g : n, d && d.length ? rs(d, n, g) : [];
      }
      function av(d) {
        if (!(d && d.length))
          return [];
        var g = 0;
        return d = oi(d, function(w) {
          if (Tr(w))
            return g = Gr(w.length, g), !0;
        }), Kn(g, function(w) {
          return pr(d, Cu(w));
        });
      }
      function hS(d, g) {
        if (!(d && d.length))
          return [];
        var w = av(d);
        return g == null ? w : pr(w, function(k) {
          return So(g, n, k);
        });
      }
      var ND = _n(function(d, g) {
        return Tr(d) ? _u(d, g) : [];
      }), PD = _n(function(d) {
        return Wm(oi(d, Tr));
      }), ID = _n(function(d) {
        var g = ui(d);
        return Tr(g) && (g = n), Wm(oi(d, Tr), en(g, 2));
      }), RD = _n(function(d) {
        var g = ui(d);
        return g = typeof g == "function" ? g : n, Wm(oi(d, Tr), n, g);
      }), DD = _n(av);
      function TD(d, g) {
        return Dx(d || [], g || [], Ou);
      }
      function MD(d, g) {
        return Dx(d || [], g || [], Iu);
      }
      var LD = _n(function(d) {
        var g = d.length, w = g > 1 ? d[g - 1] : n;
        return w = typeof w == "function" ? (d.pop(), w) : n, hS(d, w);
      });
      function gS(d) {
        var g = U(d);
        return g.__chain__ = !0, g;
      }
      function AD(d, g) {
        return g(d), d;
      }
      function ep(d, g) {
        return g(d);
      }
      var jD = xa(function(d) {
        var g = d.length, w = g ? d[0] : 0, k = this.__wrapped__, W = function(X) {
          return Rm(X, d);
        };
        return g > 1 || this.__actions__.length || !(k instanceof Rn) || !Sa(w) ? this.thru(W) : (k = k.slice(w, +w + (g ? 1 : 0)), k.__actions__.push({
          func: ep,
          args: [W],
          thisArg: n
        }), new si(k, this.__chain__).thru(function(X) {
          return g && !X.length && X.push(n), X;
        }));
      });
      function kD() {
        return gS(this);
      }
      function FD() {
        return new si(this.value(), this.__chain__);
      }
      function BD() {
        this.__values__ === n && (this.__values__ = PS(this.value()));
        var d = this.__index__ >= this.__values__.length, g = d ? n : this.__values__[this.__index__++];
        return { done: d, value: g };
      }
      function HD() {
        return this;
      }
      function zD(d) {
        for (var g, w = this; w instanceof Ff; ) {
          var k = lS(w);
          k.__index__ = 0, k.__values__ = n, g ? W.__wrapped__ = k : g = k;
          var W = k;
          w = w.__wrapped__;
        }
        return W.__wrapped__ = d, g;
      }
      function VD() {
        var d = this.__wrapped__;
        if (d instanceof Rn) {
          var g = d;
          return this.__actions__.length && (g = new Rn(this)), g = g.reverse(), g.__actions__.push({
            func: ep,
            args: [iv],
            thisArg: n
          }), new si(g, this.__chain__);
        }
        return this.thru(iv);
      }
      function WD() {
        return Rx(this.__wrapped__, this.__actions__);
      }
      var KD = Uf(function(d, g, w) {
        tr.call(d, w) ? ++d[w] : ba(d, w, 1);
      });
      function UD(d, g, w) {
        var k = fn(d) ? xf : AR;
        return w && Eo(d, g, w) && (g = n), k(d, en(g, 3));
      }
      function GD(d, g) {
        var w = fn(d) ? oi : hx;
        return w(d, en(g, 3));
      }
      var qD = zx(cS), YD = zx(uS);
      function XD(d, g) {
        return so(tp(d, g), 1);
      }
      function ZD(d, g) {
        return so(tp(d, g), T);
      }
      function QD(d, g, w) {
        return w = w === n ? 1 : bn(w), so(tp(d, g), w);
      }
      function mS(d, g) {
        var w = fn(d) ? fo : ns;
        return w(d, en(g, 3));
      }
      function vS(d, g) {
        var w = fn(d) ? xm : px;
        return w(d, en(g, 3));
      }
      var JD = Uf(function(d, g, w) {
        tr.call(d, w) ? d[w].push(g) : ba(d, w, [g]);
      });
      function eT(d, g, w, k) {
        d = Ao(d) ? d : Xl(d), w = w && !k ? bn(w) : 0;
        var W = d.length;
        return w < 0 && (w = Gr(W + w, 0)), ap(d) ? w <= W && d.indexOf(g, w) > -1 : !!W && ma(d, g, w) > -1;
      }
      var tT = _n(function(d, g, w) {
        var k = -1, W = typeof g == "function", X = Ao(d) ? Be(d.length) : [];
        return ns(d, function(pe) {
          X[++k] = W ? So(g, pe, w) : Nu(pe, g, w);
        }), X;
      }), nT = Uf(function(d, g, w) {
        ba(d, w, g);
      });
      function tp(d, g) {
        var w = fn(d) ? pr : Cx;
        return w(d, en(g, 3));
      }
      function rT(d, g, w, k) {
        return d == null ? [] : (fn(g) || (g = g == null ? [] : [g]), w = k ? n : w, fn(w) || (w = w == null ? [] : [w]), Ex(d, g, w));
      }
      var oT = Uf(function(d, g, w) {
        d[w ? 0 : 1].push(g);
      }, function() {
        return [[], []];
      });
      function iT(d, g, w) {
        var k = fn(d) ? Al : Mt, W = arguments.length < 3;
        return k(d, en(g, 4), w, W, ns);
      }
      function aT(d, g, w) {
        var k = fn(d) ? Sm : Mt, W = arguments.length < 3;
        return k(d, en(g, 4), w, W, px);
      }
      function sT(d, g) {
        var w = fn(d) ? oi : hx;
        return w(d, op(en(g, 3)));
      }
      function lT(d) {
        var g = fn(d) ? cx : e7;
        return g(d);
      }
      function cT(d, g, w) {
        (w ? Eo(d, g, w) : g === n) ? g = 1 : g = bn(g);
        var k = fn(d) ? RR : t7;
        return k(d, g);
      }
      function uT(d) {
        var g = fn(d) ? DR : r7;
        return g(d);
      }
      function dT(d) {
        if (d == null)
          return 0;
        if (Ao(d))
          return ap(d) ? Bl(d) : d.length;
        var g = go(d);
        return g == G || g == Ce ? d.size : jm(d).length;
      }
      function fT(d, g, w) {
        var k = fn(d) ? yu : o7;
        return w && Eo(d, g, w) && (g = n), k(d, en(g, 3));
      }
      var pT = _n(function(d, g) {
        if (d == null)
          return [];
        var w = g.length;
        return w > 1 && Eo(d, g[0], g[1]) ? g = [] : w > 2 && Eo(g[0], g[1], g[2]) && (g = [g[0]]), Ex(d, so(g, 1), []);
      }), np = GI || function() {
        return Kr.Date.now();
      };
      function hT(d, g) {
        if (typeof g != "function")
          throw new ai(a);
        return d = bn(d), function() {
          if (--d < 1)
            return g.apply(this, arguments);
        };
      }
      function yS(d, g, w) {
        return g = w ? n : g, g = d && g == null ? d.length : g, Ca(d, _, n, n, n, n, g);
      }
      function bS(d, g) {
        var w;
        if (typeof g != "function")
          throw new ai(a);
        return d = bn(d), function() {
          return --d > 0 && (w = g.apply(this, arguments)), d <= 1 && (g = n), w;
        };
      }
      var sv = _n(function(d, g, w) {
        var k = v;
        if (w.length) {
          var W = es(w, ql(sv));
          k |= O;
        }
        return Ca(d, k, g, w, W);
      }), CS = _n(function(d, g, w) {
        var k = v | C;
        if (w.length) {
          var W = es(w, ql(CS));
          k |= O;
        }
        return Ca(g, k, d, w, W);
      });
      function xS(d, g, w) {
        g = w ? n : g;
        var k = Ca(d, S, n, n, n, n, n, g);
        return k.placeholder = xS.placeholder, k;
      }
      function SS(d, g, w) {
        g = w ? n : g;
        var k = Ca(d, E, n, n, n, n, n, g);
        return k.placeholder = SS.placeholder, k;
      }
      function wS(d, g, w) {
        var k, W, X, pe, ve, $e, it = 0, at = !1, gt = !1, Dt = !0;
        if (typeof d != "function")
          throw new ai(a);
        g = di(g) || 0, Sr(w) && (at = !!w.leading, gt = "maxWait" in w, X = gt ? Gr(di(w.maxWait) || 0, g) : X, Dt = "trailing" in w ? !!w.trailing : Dt);
        function qt(Mr) {
          var Ni = k, $a = W;
          return k = W = n, it = Mr, pe = d.apply($a, Ni), pe;
        }
        function rn(Mr) {
          return it = Mr, ve = Tu(In, g), at ? qt(Mr) : pe;
        }
        function wn(Mr) {
          var Ni = Mr - $e, $a = Mr - it, zS = g - Ni;
          return gt ? ho(zS, X - $a) : zS;
        }
        function on(Mr) {
          var Ni = Mr - $e, $a = Mr - it;
          return $e === n || Ni >= g || Ni < 0 || gt && $a >= X;
        }
        function In() {
          var Mr = np();
          if (on(Mr))
            return Ln(Mr);
          ve = Tu(In, wn(Mr));
        }
        function Ln(Mr) {
          return ve = n, Dt && k ? qt(Mr) : (k = W = n, pe);
        }
        function Go() {
          ve !== n && Tx(ve), it = 0, k = $e = W = ve = n;
        }
        function $o() {
          return ve === n ? pe : Ln(np());
        }
        function qo() {
          var Mr = np(), Ni = on(Mr);
          if (k = arguments, W = this, $e = Mr, Ni) {
            if (ve === n)
              return rn($e);
            if (gt)
              return Tx(ve), ve = Tu(In, g), qt($e);
          }
          return ve === n && (ve = Tu(In, g)), pe;
        }
        return qo.cancel = Go, qo.flush = $o, qo;
      }
      var gT = _n(function(d, g) {
        return fx(d, 1, g);
      }), mT = _n(function(d, g, w) {
        return fx(d, di(g) || 0, w);
      });
      function vT(d) {
        return Ca(d, P);
      }
      function rp(d, g) {
        if (typeof d != "function" || g != null && typeof g != "function")
          throw new ai(a);
        var w = function() {
          var k = arguments, W = g ? g.apply(this, k) : k[0], X = w.cache;
          if (X.has(W))
            return X.get(W);
          var pe = d.apply(this, k);
          return w.cache = X.set(W, pe) || X, pe;
        };
        return w.cache = new (rp.Cache || ya)(), w;
      }
      rp.Cache = ya;
      function op(d) {
        if (typeof d != "function")
          throw new ai(a);
        return function() {
          var g = arguments;
          switch (g.length) {
            case 0:
              return !d.call(this);
            case 1:
              return !d.call(this, g[0]);
            case 2:
              return !d.call(this, g[0], g[1]);
            case 3:
              return !d.call(this, g[0], g[1], g[2]);
          }
          return !d.apply(this, g);
        };
      }
      function yT(d) {
        return bS(2, d);
      }
      var bT = i7(function(d, g) {
        g = g.length == 1 && fn(g[0]) ? pr(g[0], xr(en())) : pr(so(g, 1), xr(en()));
        var w = g.length;
        return _n(function(k) {
          for (var W = -1, X = ho(k.length, w); ++W < X; )
            k[W] = g[W].call(this, k[W]);
          return So(d, this, k);
        });
      }), lv = _n(function(d, g) {
        var w = es(g, ql(lv));
        return Ca(d, O, n, g, w);
      }), ES = _n(function(d, g) {
        var w = es(g, ql(ES));
        return Ca(d, $, n, g, w);
      }), CT = xa(function(d, g) {
        return Ca(d, R, n, n, n, g);
      });
      function xT(d, g) {
        if (typeof d != "function")
          throw new ai(a);
        return g = g === n ? g : bn(g), _n(d, g);
      }
      function ST(d, g) {
        if (typeof d != "function")
          throw new ai(a);
        return g = g == null ? 0 : Gr(bn(g), 0), _n(function(w) {
          var k = w[g], W = is(w, 0, g);
          return k && wi(W, k), So(d, this, W);
        });
      }
      function wT(d, g, w) {
        var k = !0, W = !0;
        if (typeof d != "function")
          throw new ai(a);
        return Sr(w) && (k = "leading" in w ? !!w.leading : k, W = "trailing" in w ? !!w.trailing : W), wS(d, g, {
          leading: k,
          maxWait: g,
          trailing: W
        });
      }
      function ET(d) {
        return yS(d, 1);
      }
      function $T(d, g) {
        return lv(Um(g), d);
      }
      function OT() {
        if (!arguments.length)
          return [];
        var d = arguments[0];
        return fn(d) ? d : [d];
      }
      function _T(d) {
        return li(d, y);
      }
      function NT(d, g) {
        return g = typeof g == "function" ? g : n, li(d, y, g);
      }
      function PT(d) {
        return li(d, p | y);
      }
      function IT(d, g) {
        return g = typeof g == "function" ? g : n, li(d, p | y, g);
      }
      function RT(d, g) {
        return g == null || dx(d, g, eo(g));
      }
      function _i(d, g) {
        return d === g || d !== d && g !== g;
      }
      var DT = Xf(Mm), TT = Xf(function(d, g) {
        return d >= g;
      }), Us = vx(/* @__PURE__ */ function() {
        return arguments;
      }()) ? vx : function(d) {
        return Nr(d) && tr.call(d, "callee") && !rx.call(d, "callee");
      }, fn = Be.isArray, MT = yf ? xr(yf) : zR;
      function Ao(d) {
        return d != null && ip(d.length) && !wa(d);
      }
      function Tr(d) {
        return Nr(d) && Ao(d);
      }
      function LT(d) {
        return d === !0 || d === !1 || Nr(d) && wo(d) == ue;
      }
      var as = YI || bv, AT = gu ? xr(gu) : VR;
      function jT(d) {
        return Nr(d) && d.nodeType === 1 && !Mu(d);
      }
      function kT(d) {
        if (d == null)
          return !0;
        if (Ao(d) && (fn(d) || typeof d == "string" || typeof d.splice == "function" || as(d) || Yl(d) || Us(d)))
          return !d.length;
        var g = go(d);
        if (g == G || g == Ce)
          return !d.size;
        if (Du(d))
          return !jm(d).length;
        for (var w in d)
          if (tr.call(d, w))
            return !1;
        return !0;
      }
      function FT(d, g) {
        return Pu(d, g);
      }
      function BT(d, g, w) {
        w = typeof w == "function" ? w : n;
        var k = w ? w(d, g) : n;
        return k === n ? Pu(d, g, n, w) : !!k;
      }
      function cv(d) {
        if (!Nr(d))
          return !1;
        var g = wo(d);
        return g == Q || g == re || typeof d.message == "string" && typeof d.name == "string" && !Mu(d);
      }
      function HT(d) {
        return typeof d == "number" && ix(d);
      }
      function wa(d) {
        if (!Sr(d))
          return !1;
        var g = wo(d);
        return g == ce || g == ge || g == le || g == he;
      }
      function $S(d) {
        return typeof d == "number" && d == bn(d);
      }
      function ip(d) {
        return typeof d == "number" && d > -1 && d % 1 == 0 && d <= L;
      }
      function Sr(d) {
        var g = typeof d;
        return d != null && (g == "object" || g == "function");
      }
      function Nr(d) {
        return d != null && typeof d == "object";
      }
      var OS = mu ? xr(mu) : KR;
      function zT(d, g) {
        return d === g || Am(d, g, Jm(g));
      }
      function VT(d, g, w) {
        return w = typeof w == "function" ? w : n, Am(d, g, Jm(g), w);
      }
      function WT(d) {
        return _S(d) && d != +d;
      }
      function KT(d) {
        if (N7(d))
          throw new dn(i);
        return yx(d);
      }
      function UT(d) {
        return d === null;
      }
      function GT(d) {
        return d == null;
      }
      function _S(d) {
        return typeof d == "number" || Nr(d) && wo(d) == ne;
      }
      function Mu(d) {
        if (!Nr(d) || wo(d) != ye)
          return !1;
        var g = Df(d);
        if (g === null)
          return !0;
        var w = tr.call(g, "constructor") && g.constructor;
        return typeof w == "function" && w instanceof w && Nf.call(w) == VI;
      }
      var uv = vu ? xr(vu) : UR;
      function qT(d) {
        return $S(d) && d >= -L && d <= L;
      }
      var NS = bf ? xr(bf) : GR;
      function ap(d) {
        return typeof d == "string" || !fn(d) && Nr(d) && wo(d) == Te;
      }
      function Uo(d) {
        return typeof d == "symbol" || Nr(d) && wo(d) == Ee;
      }
      var Yl = Cf ? xr(Cf) : qR;
      function YT(d) {
        return d === n;
      }
      function XT(d) {
        return Nr(d) && go(d) == ke;
      }
      function ZT(d) {
        return Nr(d) && wo(d) == qe;
      }
      var QT = Xf(km), JT = Xf(function(d, g) {
        return d <= g;
      });
      function PS(d) {
        if (!d)
          return [];
        if (Ao(d))
          return ap(d) ? $i(d) : Lo(d);
        if (xu && d[xu])
          return RI(d[xu]());
        var g = go(d), w = g == G ? $m : g == Ce ? $f : Xl;
        return w(d);
      }
      function Ea(d) {
        if (!d)
          return d === 0 ? d : 0;
        if (d = di(d), d === T || d === -T) {
          var g = d < 0 ? -1 : 1;
          return g * z;
        }
        return d === d ? d : 0;
      }
      function bn(d) {
        var g = Ea(d), w = g % 1;
        return g === g ? w ? g - w : g : 0;
      }
      function IS(d) {
        return d ? zs(bn(d), 0, V) : 0;
      }
      function di(d) {
        if (typeof d == "number")
          return d;
        if (Uo(d))
          return H;
        if (Sr(d)) {
          var g = typeof d.valueOf == "function" ? d.valueOf() : d;
          d = Sr(g) ? g + "" : g;
        }
        if (typeof d != "string")
          return d === 0 ? d : +d;
        d = Mo(d);
        var w = De.test(d);
        return w || Tt.test(d) ? gf(d.slice(2), w ? 2 : 8) : Ie.test(d) ? H : +d;
      }
      function RS(d) {
        return Zi(d, jo(d));
      }
      function eM(d) {
        return d ? zs(bn(d), -L, L) : d === 0 ? d : 0;
      }
      function qn(d) {
        return d == null ? "" : Ko(d);
      }
      var tM = Ul(function(d, g) {
        if (Du(g) || Ao(g)) {
          Zi(g, eo(g), d);
          return;
        }
        for (var w in g)
          tr.call(g, w) && Ou(d, w, g[w]);
      }), DS = Ul(function(d, g) {
        Zi(g, jo(g), d);
      }), sp = Ul(function(d, g, w, k) {
        Zi(g, jo(g), d, k);
      }), nM = Ul(function(d, g, w, k) {
        Zi(g, eo(g), d, k);
      }), rM = xa(Rm);
      function oM(d, g) {
        var w = Kl(d);
        return g == null ? w : ux(w, g);
      }
      var iM = _n(function(d, g) {
        d = ur(d);
        var w = -1, k = g.length, W = k > 2 ? g[2] : n;
        for (W && Eo(g[0], g[1], W) && (k = 1); ++w < k; )
          for (var X = g[w], pe = jo(X), ve = -1, $e = pe.length; ++ve < $e; ) {
            var it = pe[ve], at = d[it];
            (at === n || _i(at, zl[it]) && !tr.call(d, it)) && (d[it] = X[it]);
          }
        return d;
      }), aM = _n(function(d) {
        return d.push(n, Yx), So(TS, n, d);
      });
      function sM(d, g) {
        return wf(d, en(g, 3), Xi);
      }
      function lM(d, g) {
        return wf(d, en(g, 3), Tm);
      }
      function cM(d, g) {
        return d == null ? d : Dm(d, en(g, 3), jo);
      }
      function uM(d, g) {
        return d == null ? d : gx(d, en(g, 3), jo);
      }
      function dM(d, g) {
        return d && Xi(d, en(g, 3));
      }
      function fM(d, g) {
        return d && Tm(d, en(g, 3));
      }
      function pM(d) {
        return d == null ? [] : zf(d, eo(d));
      }
      function hM(d) {
        return d == null ? [] : zf(d, jo(d));
      }
      function dv(d, g, w) {
        var k = d == null ? n : Vs(d, g);
        return k === n ? w : k;
      }
      function gM(d, g) {
        return d != null && Qx(d, g, kR);
      }
      function fv(d, g) {
        return d != null && Qx(d, g, FR);
      }
      var mM = Wx(function(d, g, w) {
        g != null && typeof g.toString != "function" && (g = Pf.call(g)), d[g] = w;
      }, hv(ko)), vM = Wx(function(d, g, w) {
        g != null && typeof g.toString != "function" && (g = Pf.call(g)), tr.call(d, g) ? d[g].push(w) : d[g] = [w];
      }, en), yM = _n(Nu);
      function eo(d) {
        return Ao(d) ? lx(d) : jm(d);
      }
      function jo(d) {
        return Ao(d) ? lx(d, !0) : YR(d);
      }
      function bM(d, g) {
        var w = {};
        return g = en(g, 3), Xi(d, function(k, W, X) {
          ba(w, g(k, W, X), k);
        }), w;
      }
      function CM(d, g) {
        var w = {};
        return g = en(g, 3), Xi(d, function(k, W, X) {
          ba(w, W, g(k, W, X));
        }), w;
      }
      var xM = Ul(function(d, g, w) {
        Vf(d, g, w);
      }), TS = Ul(function(d, g, w, k) {
        Vf(d, g, w, k);
      }), SM = xa(function(d, g) {
        var w = {};
        if (d == null)
          return w;
        var k = !1;
        g = pr(g, function(X) {
          return X = os(X, d), k || (k = X.length > 1), X;
        }), Zi(d, Zm(d), w), k && (w = li(w, p | h | y, m7));
        for (var W = g.length; W--; )
          Vm(w, g[W]);
        return w;
      });
      function wM(d, g) {
        return MS(d, op(en(g)));
      }
      var EM = xa(function(d, g) {
        return d == null ? {} : ZR(d, g);
      });
      function MS(d, g) {
        if (d == null)
          return {};
        var w = pr(Zm(d), function(k) {
          return [k];
        });
        return g = en(g), $x(d, w, function(k, W) {
          return g(k, W[0]);
        });
      }
      function $M(d, g, w) {
        g = os(g, d);
        var k = -1, W = g.length;
        for (W || (W = 1, d = n); ++k < W; ) {
          var X = d == null ? n : d[Qi(g[k])];
          X === n && (k = W, X = w), d = wa(X) ? X.call(d) : X;
        }
        return d;
      }
      function OM(d, g, w) {
        return d == null ? d : Iu(d, g, w);
      }
      function _M(d, g, w, k) {
        return k = typeof k == "function" ? k : n, d == null ? d : Iu(d, g, w, k);
      }
      var LS = Gx(eo), AS = Gx(jo);
      function NM(d, g, w) {
        var k = fn(d), W = k || as(d) || Yl(d);
        if (g = en(g, 4), w == null) {
          var X = d && d.constructor;
          W ? w = k ? new X() : [] : Sr(d) ? w = wa(X) ? Kl(Df(d)) : {} : w = {};
        }
        return (W ? fo : Xi)(d, function(pe, ve, $e) {
          return g(w, pe, ve, $e);
        }), w;
      }
      function PM(d, g) {
        return d == null ? !0 : Vm(d, g);
      }
      function IM(d, g, w) {
        return d == null ? d : Ix(d, g, Um(w));
      }
      function RM(d, g, w, k) {
        return k = typeof k == "function" ? k : n, d == null ? d : Ix(d, g, Um(w), k);
      }
      function Xl(d) {
        return d == null ? [] : ii(d, eo(d));
      }
      function DM(d) {
        return d == null ? [] : ii(d, jo(d));
      }
      function TM(d, g, w) {
        return w === n && (w = g, g = n), w !== n && (w = di(w), w = w === w ? w : 0), g !== n && (g = di(g), g = g === g ? g : 0), zs(di(d), g, w);
      }
      function MM(d, g, w) {
        return g = Ea(g), w === n ? (w = g, g = 0) : w = Ea(w), d = di(d), BR(d, g, w);
      }
      function LM(d, g, w) {
        if (w && typeof w != "boolean" && Eo(d, g, w) && (g = w = n), w === n && (typeof g == "boolean" ? (w = g, g = n) : typeof d == "boolean" && (w = d, d = n)), d === n && g === n ? (d = 0, g = 1) : (d = Ea(d), g === n ? (g = d, d = 0) : g = Ea(g)), d > g) {
          var k = d;
          d = g, g = k;
        }
        if (w || d % 1 || g % 1) {
          var W = ax();
          return ho(d + W * (g - d + hf("1e-" + ((W + "").length - 1))), g);
        }
        return Bm(d, g);
      }
      var AM = Gl(function(d, g, w) {
        return g = g.toLowerCase(), d + (w ? jS(g) : g);
      });
      function jS(d) {
        return pv(qn(d).toLowerCase());
      }
      function kS(d) {
        return d = qn(d), d && d.replace(Ut, OI).replace(nr, "");
      }
      function jM(d, g, w) {
        d = qn(d), g = Ko(g);
        var k = d.length;
        w = w === n ? k : zs(bn(w), 0, k);
        var W = w;
        return w -= g.length, w >= 0 && d.slice(w, W) == g;
      }
      function kM(d) {
        return d = qn(d), d && He.test(d) ? d.replace(Ae, _I) : d;
      }
      function FM(d) {
        return d = qn(d), d && ct.test(d) ? d.replace(bt, "\\$&") : d;
      }
      var BM = Gl(function(d, g, w) {
        return d + (w ? "-" : "") + g.toLowerCase();
      }), HM = Gl(function(d, g, w) {
        return d + (w ? " " : "") + g.toLowerCase();
      }), zM = Hx("toLowerCase");
      function VM(d, g, w) {
        d = qn(d), g = bn(g);
        var k = g ? Bl(d) : 0;
        if (!g || k >= g)
          return d;
        var W = (g - k) / 2;
        return Yf(Af(W), w) + d + Yf(Lf(W), w);
      }
      function WM(d, g, w) {
        d = qn(d), g = bn(g);
        var k = g ? Bl(d) : 0;
        return g && k < g ? d + Yf(g - k, w) : d;
      }
      function KM(d, g, w) {
        d = qn(d), g = bn(g);
        var k = g ? Bl(d) : 0;
        return g && k < g ? Yf(g - k, w) + d : d;
      }
      function UM(d, g, w) {
        return w || g == null ? g = 0 : g && (g = +g), JI(qn(d).replace(xt, ""), g || 0);
      }
      function GM(d, g, w) {
        return (w ? Eo(d, g, w) : g === n) ? g = 1 : g = bn(g), Hm(qn(d), g);
      }
      function qM() {
        var d = arguments, g = qn(d[0]);
        return d.length < 3 ? g : g.replace(d[1], d[2]);
      }
      var YM = Gl(function(d, g, w) {
        return d + (w ? "_" : "") + g.toLowerCase();
      });
      function XM(d, g, w) {
        return w && typeof w != "number" && Eo(d, g, w) && (g = w = n), w = w === n ? V : w >>> 0, w ? (d = qn(d), d && (typeof g == "string" || g != null && !uv(g)) && (g = Ko(g), !g && Fl(d)) ? is($i(d), 0, w) : d.split(g, w)) : [];
      }
      var ZM = Gl(function(d, g, w) {
        return d + (w ? " " : "") + pv(g);
      });
      function QM(d, g, w) {
        return d = qn(d), w = w == null ? 0 : zs(bn(w), 0, d.length), g = Ko(g), d.slice(w, w + g.length) == g;
      }
      function JM(d, g, w) {
        var k = U.templateSettings;
        w && Eo(d, g, w) && (g = n), d = qn(d), g = sp({}, g, k, qx);
        var W = sp({}, g.imports, k.imports, qx), X = eo(W), pe = ii(W, X), ve, $e, it = 0, at = g.interpolate || Kt, gt = "__p += '", Dt = Om(
          (g.escape || Kt).source + "|" + at.source + "|" + (at === Qe ? $t : Kt).source + "|" + (g.evaluate || Kt).source + "|$",
          "g"
        ), qt = "//# sourceURL=" + (tr.call(g, "sourceURL") ? (g.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ja + "]") + `
`;
        d.replace(Dt, function(on, In, Ln, Go, $o, qo) {
          return Ln || (Ln = Go), gt += d.slice(it, qo).replace($n, NI), In && (ve = !0, gt += `' +
__e(` + In + `) +
'`), $o && ($e = !0, gt += `';
` + $o + `;
__p += '`), Ln && (gt += `' +
((__t = (` + Ln + `)) == null ? '' : __t) +
'`), it = qo + on.length, on;
        }), gt += `';
`;
        var rn = tr.call(g, "variable") && g.variable;
        if (!rn)
          gt = `with (obj) {
` + gt + `
}
`;
        else if (Re.test(rn))
          throw new dn(s);
        gt = ($e ? gt.replace(jt, "") : gt).replace(Rt, "$1").replace(Le, "$1;"), gt = "function(" + (rn || "obj") + `) {
` + (rn ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ve ? ", __e = _.escape" : "") + ($e ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + gt + `return __p
}`;
        var wn = BS(function() {
          return Un(X, qt + "return " + gt).apply(n, pe);
        });
        if (wn.source = gt, cv(wn))
          throw wn;
        return wn;
      }
      function eL(d) {
        return qn(d).toLowerCase();
      }
      function tL(d) {
        return qn(d).toUpperCase();
      }
      function nL(d, g, w) {
        if (d = qn(d), d && (w || g === n))
          return Mo(d);
        if (!d || !(g = Ko(g)))
          return d;
        var k = $i(d), W = $i(g), X = Yi(k, W), pe = po(k, W) + 1;
        return is(k, X, pe).join("");
      }
      function rL(d, g, w) {
        if (d = qn(d), d && (w || g === n))
          return d.slice(0, JC(d) + 1);
        if (!d || !(g = Ko(g)))
          return d;
        var k = $i(d), W = po(k, $i(g)) + 1;
        return is(k, 0, W).join("");
      }
      function oL(d, g, w) {
        if (d = qn(d), d && (w || g === n))
          return d.replace(xt, "");
        if (!d || !(g = Ko(g)))
          return d;
        var k = $i(d), W = Yi(k, $i(g));
        return is(k, W).join("");
      }
      function iL(d, g) {
        var w = I, k = j;
        if (Sr(g)) {
          var W = "separator" in g ? g.separator : W;
          w = "length" in g ? bn(g.length) : w, k = "omission" in g ? Ko(g.omission) : k;
        }
        d = qn(d);
        var X = d.length;
        if (Fl(d)) {
          var pe = $i(d);
          X = pe.length;
        }
        if (w >= X)
          return d;
        var ve = w - Bl(k);
        if (ve < 1)
          return k;
        var $e = pe ? is(pe, 0, ve).join("") : d.slice(0, ve);
        if (W === n)
          return $e + k;
        if (pe && (ve += $e.length - ve), uv(W)) {
          if (d.slice(ve).search(W)) {
            var it, at = $e;
            for (W.global || (W = Om(W.source, qn(Ne.exec(W)) + "g")), W.lastIndex = 0; it = W.exec(at); )
              var gt = it.index;
            $e = $e.slice(0, gt === n ? ve : gt);
          }
        } else if (d.indexOf(Ko(W), ve) != ve) {
          var Dt = $e.lastIndexOf(W);
          Dt > -1 && ($e = $e.slice(0, Dt));
        }
        return $e + k;
      }
      function aL(d) {
        return d = qn(d), d && ft.test(d) ? d.replace(Ve, LI) : d;
      }
      var sL = Gl(function(d, g, w) {
        return d + (w ? " " : "") + g.toUpperCase();
      }), pv = Hx("toUpperCase");
      function FS(d, g, w) {
        return d = qn(d), g = w ? n : g, g === n ? II(d) ? kI(d) : Em(d) : d.match(g) || [];
      }
      var BS = _n(function(d, g) {
        try {
          return So(d, n, g);
        } catch (w) {
          return cv(w) ? w : new dn(w);
        }
      }), lL = xa(function(d, g) {
        return fo(g, function(w) {
          w = Qi(w), ba(d, w, sv(d[w], d));
        }), d;
      });
      function cL(d) {
        var g = d == null ? 0 : d.length, w = en();
        return d = g ? pr(d, function(k) {
          if (typeof k[1] != "function")
            throw new ai(a);
          return [w(k[0]), k[1]];
        }) : [], _n(function(k) {
          for (var W = -1; ++W < g; ) {
            var X = d[W];
            if (So(X[0], this, k))
              return So(X[1], this, k);
          }
        });
      }
      function uL(d) {
        return LR(li(d, p));
      }
      function hv(d) {
        return function() {
          return d;
        };
      }
      function dL(d, g) {
        return d == null || d !== d ? g : d;
      }
      var fL = Vx(), pL = Vx(!0);
      function ko(d) {
        return d;
      }
      function gv(d) {
        return bx(typeof d == "function" ? d : li(d, p));
      }
      function hL(d) {
        return xx(li(d, p));
      }
      function gL(d, g) {
        return Sx(d, li(g, p));
      }
      var mL = _n(function(d, g) {
        return function(w) {
          return Nu(w, d, g);
        };
      }), vL = _n(function(d, g) {
        return function(w) {
          return Nu(d, w, g);
        };
      });
      function mv(d, g, w) {
        var k = eo(g), W = zf(g, k);
        w == null && !(Sr(g) && (W.length || !k.length)) && (w = g, g = d, d = this, W = zf(g, eo(g)));
        var X = !(Sr(w) && "chain" in w) || !!w.chain, pe = wa(d);
        return fo(W, function(ve) {
          var $e = g[ve];
          d[ve] = $e, pe && (d.prototype[ve] = function() {
            var it = this.__chain__;
            if (X || it) {
              var at = d(this.__wrapped__), gt = at.__actions__ = Lo(this.__actions__);
              return gt.push({ func: $e, args: arguments, thisArg: d }), at.__chain__ = it, at;
            }
            return $e.apply(d, wi([this.value()], arguments));
          });
        }), d;
      }
      function yL() {
        return Kr._ === this && (Kr._ = WI), this;
      }
      function vv() {
      }
      function bL(d) {
        return d = bn(d), _n(function(g) {
          return wx(g, d);
        });
      }
      var CL = qm(pr), xL = qm(xf), SL = qm(yu);
      function HS(d) {
        return tv(d) ? Cu(Qi(d)) : QR(d);
      }
      function wL(d) {
        return function(g) {
          return d == null ? n : Vs(d, g);
        };
      }
      var EL = Kx(), $L = Kx(!0);
      function yv() {
        return [];
      }
      function bv() {
        return !1;
      }
      function OL() {
        return {};
      }
      function _L() {
        return "";
      }
      function NL() {
        return !0;
      }
      function PL(d, g) {
        if (d = bn(d), d < 1 || d > L)
          return [];
        var w = V, k = ho(d, V);
        g = en(g), d -= V;
        for (var W = Kn(k, g); ++w < d; )
          g(w);
        return W;
      }
      function IL(d) {
        return fn(d) ? pr(d, Qi) : Uo(d) ? [d] : Lo(sS(qn(d)));
      }
      function RL(d) {
        var g = ++zI;
        return qn(d) + g;
      }
      var DL = qf(function(d, g) {
        return d + g;
      }, 0), TL = Ym("ceil"), ML = qf(function(d, g) {
        return d / g;
      }, 1), LL = Ym("floor");
      function AL(d) {
        return d && d.length ? Hf(d, ko, Mm) : n;
      }
      function jL(d, g) {
        return d && d.length ? Hf(d, en(g, 2), Mm) : n;
      }
      function kL(d) {
        return Ef(d, ko);
      }
      function FL(d, g) {
        return Ef(d, en(g, 2));
      }
      function BL(d) {
        return d && d.length ? Hf(d, ko, km) : n;
      }
      function HL(d, g) {
        return d && d.length ? Hf(d, en(g, 2), km) : n;
      }
      var zL = qf(function(d, g) {
        return d * g;
      }, 1), VL = Ym("round"), WL = qf(function(d, g) {
        return d - g;
      }, 0);
      function KL(d) {
        return d && d.length ? cn(d, ko) : 0;
      }
      function UL(d, g) {
        return d && d.length ? cn(d, en(g, 2)) : 0;
      }
      return U.after = hT, U.ary = yS, U.assign = tM, U.assignIn = DS, U.assignInWith = sp, U.assignWith = nM, U.at = rM, U.before = bS, U.bind = sv, U.bindAll = lL, U.bindKey = CS, U.castArray = OT, U.chain = gS, U.chunk = L7, U.compact = A7, U.concat = j7, U.cond = cL, U.conforms = uL, U.constant = hv, U.countBy = KD, U.create = oM, U.curry = xS, U.curryRight = SS, U.debounce = wS, U.defaults = iM, U.defaultsDeep = aM, U.defer = gT, U.delay = mT, U.difference = k7, U.differenceBy = F7, U.differenceWith = B7, U.drop = H7, U.dropRight = z7, U.dropRightWhile = V7, U.dropWhile = W7, U.fill = K7, U.filter = GD, U.flatMap = XD, U.flatMapDeep = ZD, U.flatMapDepth = QD, U.flatten = dS, U.flattenDeep = U7, U.flattenDepth = G7, U.flip = vT, U.flow = fL, U.flowRight = pL, U.fromPairs = q7, U.functions = pM, U.functionsIn = hM, U.groupBy = JD, U.initial = X7, U.intersection = Z7, U.intersectionBy = Q7, U.intersectionWith = J7, U.invert = mM, U.invertBy = vM, U.invokeMap = tT, U.iteratee = gv, U.keyBy = nT, U.keys = eo, U.keysIn = jo, U.map = tp, U.mapKeys = bM, U.mapValues = CM, U.matches = hL, U.matchesProperty = gL, U.memoize = rp, U.merge = xM, U.mergeWith = TS, U.method = mL, U.methodOf = vL, U.mixin = mv, U.negate = op, U.nthArg = bL, U.omit = SM, U.omitBy = wM, U.once = yT, U.orderBy = rT, U.over = CL, U.overArgs = bT, U.overEvery = xL, U.overSome = SL, U.partial = lv, U.partialRight = ES, U.partition = oT, U.pick = EM, U.pickBy = MS, U.property = HS, U.propertyOf = wL, U.pull = rD, U.pullAll = pS, U.pullAllBy = oD, U.pullAllWith = iD, U.pullAt = aD, U.range = EL, U.rangeRight = $L, U.rearg = CT, U.reject = sT, U.remove = sD, U.rest = xT, U.reverse = iv, U.sampleSize = cT, U.set = OM, U.setWith = _M, U.shuffle = uT, U.slice = lD, U.sortBy = pT, U.sortedUniq = gD, U.sortedUniqBy = mD, U.split = XM, U.spread = ST, U.tail = vD, U.take = yD, U.takeRight = bD, U.takeRightWhile = CD, U.takeWhile = xD, U.tap = AD, U.throttle = wT, U.thru = ep, U.toArray = PS, U.toPairs = LS, U.toPairsIn = AS, U.toPath = IL, U.toPlainObject = RS, U.transform = NM, U.unary = ET, U.union = SD, U.unionBy = wD, U.unionWith = ED, U.uniq = $D, U.uniqBy = OD, U.uniqWith = _D, U.unset = PM, U.unzip = av, U.unzipWith = hS, U.update = IM, U.updateWith = RM, U.values = Xl, U.valuesIn = DM, U.without = ND, U.words = FS, U.wrap = $T, U.xor = PD, U.xorBy = ID, U.xorWith = RD, U.zip = DD, U.zipObject = TD, U.zipObjectDeep = MD, U.zipWith = LD, U.entries = LS, U.entriesIn = AS, U.extend = DS, U.extendWith = sp, mv(U, U), U.add = DL, U.attempt = BS, U.camelCase = AM, U.capitalize = jS, U.ceil = TL, U.clamp = TM, U.clone = _T, U.cloneDeep = PT, U.cloneDeepWith = IT, U.cloneWith = NT, U.conformsTo = RT, U.deburr = kS, U.defaultTo = dL, U.divide = ML, U.endsWith = jM, U.eq = _i, U.escape = kM, U.escapeRegExp = FM, U.every = UD, U.find = qD, U.findIndex = cS, U.findKey = sM, U.findLast = YD, U.findLastIndex = uS, U.findLastKey = lM, U.floor = LL, U.forEach = mS, U.forEachRight = vS, U.forIn = cM, U.forInRight = uM, U.forOwn = dM, U.forOwnRight = fM, U.get = dv, U.gt = DT, U.gte = TT, U.has = gM, U.hasIn = fv, U.head = fS, U.identity = ko, U.includes = eT, U.indexOf = Y7, U.inRange = MM, U.invoke = yM, U.isArguments = Us, U.isArray = fn, U.isArrayBuffer = MT, U.isArrayLike = Ao, U.isArrayLikeObject = Tr, U.isBoolean = LT, U.isBuffer = as, U.isDate = AT, U.isElement = jT, U.isEmpty = kT, U.isEqual = FT, U.isEqualWith = BT, U.isError = cv, U.isFinite = HT, U.isFunction = wa, U.isInteger = $S, U.isLength = ip, U.isMap = OS, U.isMatch = zT, U.isMatchWith = VT, U.isNaN = WT, U.isNative = KT, U.isNil = GT, U.isNull = UT, U.isNumber = _S, U.isObject = Sr, U.isObjectLike = Nr, U.isPlainObject = Mu, U.isRegExp = uv, U.isSafeInteger = qT, U.isSet = NS, U.isString = ap, U.isSymbol = Uo, U.isTypedArray = Yl, U.isUndefined = YT, U.isWeakMap = XT, U.isWeakSet = ZT, U.join = eD, U.kebabCase = BM, U.last = ui, U.lastIndexOf = tD, U.lowerCase = HM, U.lowerFirst = zM, U.lt = QT, U.lte = JT, U.max = AL, U.maxBy = jL, U.mean = kL, U.meanBy = FL, U.min = BL, U.minBy = HL, U.stubArray = yv, U.stubFalse = bv, U.stubObject = OL, U.stubString = _L, U.stubTrue = NL, U.multiply = zL, U.nth = nD, U.noConflict = yL, U.noop = vv, U.now = np, U.pad = VM, U.padEnd = WM, U.padStart = KM, U.parseInt = UM, U.random = LM, U.reduce = iT, U.reduceRight = aT, U.repeat = GM, U.replace = qM, U.result = $M, U.round = VL, U.runInContext = xe, U.sample = lT, U.size = dT, U.snakeCase = YM, U.some = fT, U.sortedIndex = cD, U.sortedIndexBy = uD, U.sortedIndexOf = dD, U.sortedLastIndex = fD, U.sortedLastIndexBy = pD, U.sortedLastIndexOf = hD, U.startCase = ZM, U.startsWith = QM, U.subtract = WL, U.sum = KL, U.sumBy = UL, U.template = JM, U.times = PL, U.toFinite = Ea, U.toInteger = bn, U.toLength = IS, U.toLower = eL, U.toNumber = di, U.toSafeInteger = eM, U.toString = qn, U.toUpper = tL, U.trim = nL, U.trimEnd = rL, U.trimStart = oL, U.truncate = iL, U.unescape = aL, U.uniqueId = RL, U.upperCase = sL, U.upperFirst = pv, U.each = mS, U.eachRight = vS, U.first = fS, mv(U, function() {
        var d = {};
        return Xi(U, function(g, w) {
          tr.call(U.prototype, w) || (d[w] = g);
        }), d;
      }(), { chain: !1 }), U.VERSION = r, fo(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(d) {
        U[d].placeholder = U;
      }), fo(["drop", "take"], function(d, g) {
        Rn.prototype[d] = function(w) {
          w = w === n ? 1 : Gr(bn(w), 0);
          var k = this.__filtered__ && !g ? new Rn(this) : this.clone();
          return k.__filtered__ ? k.__takeCount__ = ho(w, k.__takeCount__) : k.__views__.push({
            size: ho(w, V),
            type: d + (k.__dir__ < 0 ? "Right" : "")
          }), k;
        }, Rn.prototype[d + "Right"] = function(w) {
          return this.reverse()[d](w).reverse();
        };
      }), fo(["filter", "map", "takeWhile"], function(d, g) {
        var w = g + 1, k = w == M || w == D;
        Rn.prototype[d] = function(W) {
          var X = this.clone();
          return X.__iteratees__.push({
            iteratee: en(W, 3),
            type: w
          }), X.__filtered__ = X.__filtered__ || k, X;
        };
      }), fo(["head", "last"], function(d, g) {
        var w = "take" + (g ? "Right" : "");
        Rn.prototype[d] = function() {
          return this[w](1).value()[0];
        };
      }), fo(["initial", "tail"], function(d, g) {
        var w = "drop" + (g ? "" : "Right");
        Rn.prototype[d] = function() {
          return this.__filtered__ ? new Rn(this) : this[w](1);
        };
      }), Rn.prototype.compact = function() {
        return this.filter(ko);
      }, Rn.prototype.find = function(d) {
        return this.filter(d).head();
      }, Rn.prototype.findLast = function(d) {
        return this.reverse().find(d);
      }, Rn.prototype.invokeMap = _n(function(d, g) {
        return typeof d == "function" ? new Rn(this) : this.map(function(w) {
          return Nu(w, d, g);
        });
      }), Rn.prototype.reject = function(d) {
        return this.filter(op(en(d)));
      }, Rn.prototype.slice = function(d, g) {
        d = bn(d);
        var w = this;
        return w.__filtered__ && (d > 0 || g < 0) ? new Rn(w) : (d < 0 ? w = w.takeRight(-d) : d && (w = w.drop(d)), g !== n && (g = bn(g), w = g < 0 ? w.dropRight(-g) : w.take(g - d)), w);
      }, Rn.prototype.takeRightWhile = function(d) {
        return this.reverse().takeWhile(d).reverse();
      }, Rn.prototype.toArray = function() {
        return this.take(V);
      }, Xi(Rn.prototype, function(d, g) {
        var w = /^(?:filter|find|map|reject)|While$/.test(g), k = /^(?:head|last)$/.test(g), W = U[k ? "take" + (g == "last" ? "Right" : "") : g], X = k || /^find/.test(g);
        W && (U.prototype[g] = function() {
          var pe = this.__wrapped__, ve = k ? [1] : arguments, $e = pe instanceof Rn, it = ve[0], at = $e || fn(pe), gt = function(In) {
            var Ln = W.apply(U, wi([In], ve));
            return k && Dt ? Ln[0] : Ln;
          };
          at && w && typeof it == "function" && it.length != 1 && ($e = at = !1);
          var Dt = this.__chain__, qt = !!this.__actions__.length, rn = X && !Dt, wn = $e && !qt;
          if (!X && at) {
            pe = wn ? pe : new Rn(this);
            var on = d.apply(pe, ve);
            return on.__actions__.push({ func: ep, args: [gt], thisArg: n }), new si(on, Dt);
          }
          return rn && wn ? d.apply(this, ve) : (on = this.thru(gt), rn ? k ? on.value()[0] : on.value() : on);
        });
      }), fo(["pop", "push", "shift", "sort", "splice", "unshift"], function(d) {
        var g = Of[d], w = /^(?:push|sort|unshift)$/.test(d) ? "tap" : "thru", k = /^(?:pop|shift)$/.test(d);
        U.prototype[d] = function() {
          var W = arguments;
          if (k && !this.__chain__) {
            var X = this.value();
            return g.apply(fn(X) ? X : [], W);
          }
          return this[w](function(pe) {
            return g.apply(fn(pe) ? pe : [], W);
          });
        };
      }), Xi(Rn.prototype, function(d, g) {
        var w = U[g];
        if (w) {
          var k = w.name + "";
          tr.call(Wl, k) || (Wl[k] = []), Wl[k].push({ name: g, func: w });
        }
      }), Wl[Gf(n, C).name] = [{
        name: "wrapper",
        func: n
      }], Rn.prototype.clone = aR, Rn.prototype.reverse = sR, Rn.prototype.value = lR, U.prototype.at = jD, U.prototype.chain = kD, U.prototype.commit = FD, U.prototype.next = BD, U.prototype.plant = zD, U.prototype.reverse = VD, U.prototype.toJSON = U.prototype.valueOf = U.prototype.value = WD, U.prototype.first = U.prototype.head, xu && (U.prototype[xu] = HD), U;
    }, Hl = FI();
    qi ? ((qi.exports = Hl)._ = Hl, Ml._ = Hl) : Kr._ = Hl;
  }).call(lo);
})(ng, ng.exports);
var hde = ng.exports;
const gde = /* @__PURE__ */ Vi(hde);
Ue.div`
  display: flex;
  flex-direction: column;
`;
Ue(Hn)`
  padding: 24px 16px;
  border: 1px solid ${Ht[20]};
  border-radius: 8px;
`;
const mde = Ue.div`
  .smv-form-item {
    margin-bottom: 0;
    width: 100%;
  }

  .smv-form-item-explain-error {
    font-size: 12px;
    color: ${fu[50]};
  }

  .smv-form-item-label {
    padding: 0;
  }
`, Es = Ue.label`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.105px;
  color: ${Ht[60]};
  padding: 0;
`, vde = Ue(As)`
  border-color: #d9d9d9;
  border-radius: 4px;
  width: 100%;
  height: 40px;
`, Yc = Ue(Ls)`
  border: none;
  border-radius: 4px;
  width: 100%;
  min-height: 40px;
  border-color: #d9d9d9;

  > div {
    min-height: 40px;
  }
`, aI = Ue(Yc.Option)`
  display: flex;
`, yde = Ue.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 16px;

  .smv-form-item {
    width: 100%;
  }

  .smv-form-item-explain-error {
    font-size: 12px;
    color: ${fu[50]};
  }

  .smv-form-item-label {
    padding: 0;
  }
`;
var Cr = /* @__PURE__ */ ((e) => (e.SCOUTING = "SCOUTING", e.PLANTING = "PLANTING", e.PRE_PLANTING = "PRE_PLANTING", e.PLANTING_FEMALE = "FEMALE", e.PLANTING_MALE = "MALE", e.IRRIGATION = "IRRIGATION", e))(Cr || {});
const bde = (e) => {
  var o;
  const t = Cn(Si), { environment: n } = (o = t.rulesInformation) != null ? o : {}, r = n === "staging";
  return /* @__PURE__ */ B.jsxs(Hn.Item, { id: "task_type", children: [
    /* @__PURE__ */ B.jsx(Es, { children: "Task type" }),
    /* @__PURE__ */ B.jsx(
      Hn.Item,
      {
        name: "task_type",
        rules: [
          {
            required: !0,
            message: "Task type is required."
          }
        ],
        noStyle: !0,
        children: /* @__PURE__ */ B.jsx(
          Yc,
          je({
            "aria-label": "task_type",
            placeholder: "Select task type",
            options: [
              {
                label: "Scouting",
                value: Cr.SCOUTING
              },
              {
                label: "Planting « Pre-planting",
                value: Cr.PRE_PLANTING
              },
              {
                label: "Planting « Planting Female",
                value: Cr.PLANTING_FEMALE
              },
              {
                label: "Planting « Planting Male",
                value: Cr.PLANTING_MALE
              },
              r ? {
                label: "Irrigation",
                value: Cr.IRRIGATION
              } : {}
            ].filter((i) => Object.keys(i).length)
          }, e)
        )
      }
    )
  ] });
}, zy = (e) => an(void 0, null, function* () {
  try {
    return yield Fo.post(
      "/v2/properties/ids/fields",
      {
        ids: e
      }
    );
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), rg = (t) => an(void 0, [t], function* ({ id: e }) {
  try {
    return yield Fo.get(
      `/v2/orgs/${e}/properties`
    );
  } catch (n) {
    throw console.error("Error when requesting fields", n), n;
  }
}), Cde = () => an(void 0, null, function* () {
  try {
    return yield Fo.get("/v2/varieties");
  } catch (e) {
    throw console.error("Erro durante as solicitações:", e), e;
  }
}), sI = (e) => an(void 0, null, function* () {
  try {
    return yield Fo.get(
      `/v2/seasons/${e}/season-fields`
    );
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), lI = (e) => an(void 0, null, function* () {
  var n;
  const t = e.map(({ field_id: r }) => r);
  try {
    return ((n = (yield Fo.post("/v2/fields/ids", {
      ids: t
    })).data) == null ? void 0 : n.content).map(
      (a) => Bt(je({}, a), {
        crop_zone: e.find(
          ({ field_id: s }) => s === a.id
        ).id
      })
    );
  } catch (r) {
    throw console.error("Erro durante as solicitações:", r), r;
  }
}), WC = (e) => an(void 0, null, function* () {
  try {
    return yield hh.get(
      `/api/v1/methodologies/${e}/inspection-groups`
    );
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), KC = (e, t) => an(void 0, null, function* () {
  try {
    return yield hh.get(
      `/v1/season-areas?seasonIds=${e}&propertyId=${t}&includeMethodology=true`
    );
  } catch (n) {
    throw console.error("Erro durante as solicitações:", n), n;
  }
}), xde = (e) => {
  const { criteria: t, date_range: n, activity: r, days_or_degrees: o } = e;
  return t === "Date" && n ? {
    start_date: n[0] ? n[0].toISOString() : null,
    end_date: n[1] ? n[1].toISOString() : null
  } : Bt(je({}, t === "DAO" ? {
    parent_operation_id: r
  } : null), {
    date_rule: je({
      type: t
    }, t === "GDD" ? { gdd_degree: o } : { days: o })
  });
}, Sde = (e) => {
  if (e.task_type !== Cr.SCOUTING)
    return null;
  const {
    hectar_value: t,
    inspection_groups: n,
    min_scouting_completeness: r,
    min_expected_points: o,
    scouting_type: i
  } = e;
  return {
    point_factor: Number(t),
    inspection_groups: n,
    min_scouting_completeness: r,
    min_expected_points: o,
    scouting_type: i
  };
}, wde = (e, t) => an(void 0, null, function* () {
  var h, y;
  const { create_plan: n, create_operation: r, properties: o, crop_zone: i, workers: a } = e, { plan_name: s, seasons_ids: l, start_date: u } = n != null ? n : {}, { org: f } = t, p = r.map(
    (O) => {
      var $ = O, {
        hectar_value: b,
        inspection_groups: m,
        min_scouting_completeness: v,
        min_expected_points: C,
        scouting_type: x,
        task_type: S
      } = $, E = Cv($, [
        "hectar_value",
        "inspection_groups",
        "min_scouting_completeness",
        "min_expected_points",
        "scouting_type",
        "task_type"
      ]);
      return je(je(je({}, gde.omit(E, ["criteria", "days_or_degrees"])), xde(E)), Sde({
        hectar_value: b,
        inspection_groups: m,
        min_scouting_completeness: v,
        min_expected_points: C,
        scouting_type: x,
        task_type: S
      }));
    }
  );
  try {
    return yield Fo.post(
      "/v3/operations/smart-plan",
      {
        plan_name: s,
        seasons_ids: [l],
        properties_ids: o,
        start_date: u,
        end_date: u,
        org_id: f,
        plan_operations: p,
        crop_zone_ids: i,
        assignees: a,
        unit_system: (y = (h = localStorage.getItem("currentUnitSystem")) == null ? void 0 : h.toLowerCase()) != null ? y : "metric"
      }
    );
  } catch (b) {
    throw console.error("Erro durante as solicitações:", b), b;
  }
}), cI = (e) => an(void 0, null, function* () {
  try {
    return yield Fo.get(
      `/v2/orgs/${e}/seasons`
    );
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), Ede = (e) => an(void 0, null, function* () {
  try {
    return yield Fo.delete(`/v3/operations/ag/${e}`);
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), $de = (e, t, n = "") => an(void 0, null, function* () {
  const r = {
    headers: {
      "X-Company-Id": t
    },
    params: {}
  };
  n && (r.params.cursor = n);
  try {
    return yield Fo.post(
      "/v3/operations/smart-plan/ag/filtered",
      e,
      r
    );
  } catch (o) {
    throw console.error("Erro durante as solicitações:", o), o;
  }
}), uI = (e, t) => an(void 0, null, function* () {
  try {
    return yield ph.post(
      `/v2/orgs/${e}/workers-by-properties?page=0&size=999&sort=name`,
      t
    );
  } catch (n) {
    throw console.error("Erro durante as solicitações:", n), n;
  }
}), Ode = (e) => an(void 0, null, function* () {
  try {
    return yield Fo.get(
      `/v3/operations/smart-plan/${e}`
    );
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), _de = (e, t) => an(void 0, null, function* () {
  try {
    return yield Fo.get(
      `/v3/operations/smart-plan?org_id=${e}&season_id=${t}`
    );
  } catch (n) {
    throw console.error("Erro durante as solicitações:", n), n;
  }
}), Nde = (e) => an(void 0, null, function* () {
  try {
    return yield Fo.delete(
      `/v3/operations/smart-plan/${e}`
    );
  } catch (t) {
    throw console.error("Erro durante as solicitações:", t), t;
  }
}), Pde = (e, t) => an(void 0, null, function* () {
  try {
    return (yield ph.post(
      "/v2/season-fields/list",
      {
        season_ids: e,
        property_ids: t
      }
    )).data;
  } catch (n) {
    throw console.error("Erro durante as solicitações:", n), n;
  }
}), Ide = (e) => {
  var L;
  const { season: t } = use(), n = Cn(Si), { formData: r } = n, { fields: o = [] } = r, { create_plan: i, crop_zone: a = [] } = r, { org: s } = (L = n.rulesInformation) != null ? L : {}, [l, u] = Ot([]), [f, p] = Ot({ original: [], filtered: [] }), [h, y] = Ot(!1), [b, m] = Ot(!1), [v, C] = Ot([]), [x, S] = Ot([]), [E, O] = Ot(
    []
  ), [$, _] = Ot(!1);
  kt(() => {
    if (!s)
      return;
    m(!0), an(void 0, null, function* () {
      const {
        data: { content: H }
      } = yield rg({ id: s });
      u(H);
    });
  }, [s]);
  const R = ar(
    (z) => an(void 0, null, function* () {
      if (t) {
        const {
          data: { content: H }
        } = yield sI(t), V = yield P(z), Y = yield I(V);
        Y && (H.filter((Z) => Y.includes(Z.field_id)).length === 0 && m(!1), S(
          H.filter((Z) => Y.includes(Z.field_id))
        ));
      }
    }),
    [t]
  ), P = (z) => an(void 0, null, function* () {
    var V;
    const H = yield rg({ id: z });
    return (V = H == null ? void 0 : H.data) == null ? void 0 : V.content.map(
      (Y) => Y.id
    );
  }), I = (z) => an(void 0, null, function* () {
    var Y;
    if (!z)
      return;
    const H = 99;
    let V = [];
    for (let Z = 0; Z < z.length; Z += H) {
      const oe = z.slice(Z, Z + H), ee = yield zy(oe), ae = ((Y = ee == null ? void 0 : ee.data) == null ? void 0 : Y.content.map(
        (le) => le.id
      )) || [];
      V = V.concat(ae);
    }
    return V;
  }), j = ar(() => an(void 0, null, function* () {
    if (!x.length)
      return;
    const z = yield lI(x);
    O(z);
  }), [x]), F = ar(() => an(void 0, null, function* () {
    const {
      data: { content: z }
    } = yield Cde();
    z && C(z);
  }), []), A = ar(
    (z) => {
      const H = z.map((V) => V.crop_zone).filter((V) => V !== void 0);
      n.setFormData((V) => Bt(je({}, V), {
        properties: [
          ...new Set(
            z.filter(({ type_row: Y }) => Y !== "property").flatMap(({ property_id: Y }) => Y)
          )
        ],
        fields: z,
        crop_zone: H
      }));
    },
    [n]
  ), M = () => {
    if (f.original) {
      const z = f.original.flatMap(
        ({ children: V }) => N(V)
      ), H = D(z);
      return T(H);
    }
    return [];
  }, N = (z) => z.flatMap(
    ({ variety: H }) => {
      var V;
      return ((V = H.variety) == null ? void 0 : V.map((Y) => Y)) || [];
    }
  ), D = (z) => Array.from(new Set(z)), T = (z) => z.map((H) => ({ text: H, value: H }));
  return kt(() => {
    const z = Array.isArray(o) && o.length ? o.map((V) => V.property_id) : i == null ? void 0 : i.properties_ids, H = Array.isArray(a) && a.length ? a : i == null ? void 0 : i.crop_zone_ids;
    if (!$ && i && E.length > 0 && z && H) {
      const V = E.filter(
        (Z) => (z == null ? void 0 : z.includes(Z.property_id)) && (H == null ? void 0 : H.includes(Z.crop_zone))
      ).map((Z) => Bt(je({}, Z), {
        key: parseInt(Z.id, 10),
        areas: "",
        type_row: "default",
        children: []
      })), Y = e.getFieldValue("fields_name");
      Y != null && Y.length || (e.setFieldsValue({ fields_name: V }), A(V), _(!0));
    }
  }, [
    $,
    i,
    E,
    e,
    A,
    o,
    a
  ]), kt(() => {
    s && (F(), R(s));
  }, [F, R, s]), kt(() => {
    x.length && j();
  }, [j, x]), kt(() => {
    if (E.length && l.length && v.length) {
      const z = pde(
        E,
        l,
        v,
        x
      );
      m(!1), p({
        original: z,
        filtered: z
      });
    }
  }, [E, l, x, v]), {
    listProperties: l,
    fieldsFiltered: f,
    statusFields: h,
    loadingScreen: b,
    listVarieties: v,
    listSeasonFields: x,
    listFields: E,
    isInitialized: $,
    setStatusFields: y,
    updateFieldsByVarieties: (z) => {
      if (f.original) {
        const H = Rde(f.original, z);
        p(Bt(je({}, f), {
          filtered: z.length > 0 ? H : f.original
        }));
      }
    },
    rowSelection: {
      selectedRowKeys: Array.isArray(o) ? o.map(({ id: z }) => z) : [],
      onChange: (z, H) => {
        y(!1), e.setFieldValue("fields_name", H), A(H);
      }
    },
    listVarietiesFromCurrentFields: M
  };
}, Rde = (e, t) => e.reduce((n, r) => {
  const { children: o } = r, i = o.filter(
    ({ variety: { variety: a } }) => a == null ? void 0 : a.some((s) => t.includes(s))
  );
  return i.length && n.push(Bt(je({}, r), { children: i })), n;
}, []), Dde = () => /* @__PURE__ */ B.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ B.jsxs("g", { clipPath: "url(#clip0_9496_148053)", children: [
        /* @__PURE__ */ B.jsx("rect", { width: "32", height: "32", rx: "4", fill: "#DFFBE8" }),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            d: "M13.75 14.5C13.75 14.0858 14.0858 13.75 14.5 13.75H17.5C17.9142 13.75 18.25 14.0858 18.25 14.5V17.5C18.25 17.9142 17.9142 18.25 17.5 18.25H14.5C14.0858 18.25 13.75 17.9142 13.75 17.5V14.5Z",
            fill: "#14803C"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.75 9.25H12.25V10.75L19.75 10.75V9.25H21.25V10.75L22.75 10.75V12.25H21.25V19.75H22.75V21.25H21.25V22.75H19.75V21.25L12.25 21.25V22.75H10.75V21.25H9.25V19.75H10.75V12.25H9.25V10.75L10.75 10.75V9.25ZM12.25 19.75V12.25L19.75 12.25V19.75L12.25 19.75Z",
            fill: "#14803C"
          }
        )
      ] }),
      /* @__PURE__ */ B.jsx("defs", { children: /* @__PURE__ */ B.jsx("clipPath", { id: "clip0_9496_148053", children: /* @__PURE__ */ B.jsx("rect", { width: "32", height: "32", rx: "8", fill: "white" }) }) })
    ]
  }
), Tde = Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`, Mde = Ue(Io)`
  width: 100%;
  max-width: 332px;
  border-radius: 4px;
  margin-right: 16px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  background-color: transparent;
  border: 1px solid ${Ht[30]};
  cursor: pointer;

  :hover {
    background-color: ${Ht[10]};
  }
`;
Ue(Io)`
  width: 100%;
  max-width: 332px;
  border-radius: 4px;
  background-color: ${vr[60]};
  color: ${Ht[0]};
`;
const Lde = () => {
  const t = btoa(`
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z' fill='#FFFFFF'/>
    </svg>`);
  return /* @__PURE__ */ B.jsx(
    "img",
    {
      src: `data:image/svg+xml;base64,${t}`,
      alt: "chevron right icon",
      id: "chevron-right-icon",
      width: "18",
      height: "18"
    }
  );
}, Ade = Ue.button`
  width: 100%;
  max-width: 332px;
  border-radius: 4px;
  background-color: ${vr[60]};
  color: ${Ht[0]};
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  cursor: pointer;

  :hover {
    color: #dfe2e7;
  }

  &:disabled {
    border: 1px solid ${Ht[20]};
    background-color: ${Ht[10]};
    color: ${Ht[30]};
    cursor: default;

    :hover {
      color: ${Ht[30]};
    }
  }
`, Fd = (e) => /* @__PURE__ */ B.jsx(Ade, je({}, e)), dI = ({
  control: e,
  title: t,
  isFormInvalid: n,
  previousEvent: r,
  nextEvent: o
}) => {
  const i = Ya(), { previous: a, next: s } = e != null ? e : {}, { first: l, second: u } = t, f = () => {
    a && i(a), r && r();
  }, p = () => {
    s && i(s), o && o();
  };
  return /* @__PURE__ */ B.jsxs(Tde, { children: [
    /* @__PURE__ */ B.jsxs(Mde, { onClick: f, children: [
      /* @__PURE__ */ B.jsx(HC, { width: 18, height: 18 }),
      l
    ] }),
    /* @__PURE__ */ B.jsxs(Fd, { onClick: p, disabled: n, children: [
      u,
      /* @__PURE__ */ B.jsx(Lde, {})
    ] })
  ] });
}, jde = Ue(NP)`
  .smv-checkbox-inner {
    border-radius: 2px !important;
    ${({ required: e }) => e && "border: 1px solid red;"}
  }
  .smv-table-row-expand-icon {
    border-radius: 2px !important;
  }
`, kde = ({
  columns: e,
  data: t,
  rowSelection: n,
  config: r,
  event: o,
  required: i = !1,
  emptyTable: a
}) => {
  const s = (l) => {
    o == null || o(l);
  };
  return /* @__PURE__ */ B.jsx(
    jde,
    je({
      bordered: !1,
      locale: {
        emptyText: a
      },
      onChange: s
    }, Bt(je({}, r), { required: i, dataSource: t, rowSelection: n, columns: e }))
  );
}, UC = ({ title: e, icon: t }) => /* @__PURE__ */ B.jsxs(zc, { gap: "middle", align: "start", children: [
  t,
  /* @__PURE__ */ B.jsx(Ps.Title, { level: 3, style: { margin: 0 }, children: e })
] }), Fde = Ue.div`
  margin-bottom: 3.2rem;
`, Bde = Ue(Hn.Item)`
  margin-bottom: 3.2rem;
`, Hde = Ue.section`
  max-width: 90rem;
  margin: 0 auto;
  margin-top: 3.2rem;
`, zde = Ue.div`
  max-width: 1000px;
  margin: 0 auto;
  display: block !important;
  margin-bottom: 5rem;
`, Vde = () => {
  var p;
  const [e] = Hn.useForm(), t = Ya(), { t: n } = oo(), {
    fieldsFiltered: r,
    statusFields: o,
    loadingScreen: i,
    setStatusFields: a,
    updateFieldsByVarieties: s,
    rowSelection: l,
    listVarietiesFromCurrentFields: u
  } = Ide(e), f = [
    {
      title: "Area",
      dataIndex: "name",
      key: "name",
      width: "70%"
    },
    {
      title: "Variety",
      dataIndex: "variety",
      width: "40%",
      key: "variety",
      ellipsis: {
        showTitle: !1
      },
      render: (h) => {
        if (h)
          return /* @__PURE__ */ B.jsx(Bo, { title: h.varietyFormatted, children: h.varietyFormatted });
      }
    }
  ];
  return /* @__PURE__ */ B.jsxs(Hde, { children: [
    /* @__PURE__ */ B.jsx(af, { size: "large", spinning: i, fullscreen: !0 }),
    /* @__PURE__ */ B.jsxs(Hn, { form: e, children: [
      /* @__PURE__ */ B.jsx(Fde, { children: /* @__PURE__ */ B.jsx(zc, { justify: "center", children: /* @__PURE__ */ B.jsx(
        UC,
        {
          icon: /* @__PURE__ */ B.jsx(Dde, {}),
          title: n("sections.fields.title_section_title")
        }
      ) }) }),
      /* @__PURE__ */ B.jsxs(zde, { children: [
        /* @__PURE__ */ B.jsx(
          Bde,
          {
            name: "fields_name",
            rules: [
              {
                required: !0,
                message: n(
                  "sections.fields.field_required_box_fields_name_msg"
                )
              }
            ]
          }
        ),
        /* @__PURE__ */ B.jsx(
          Ls,
          {
            style: { width: 400, marginBottom: 30 },
            placeholder: "Varieties",
            mode: "tags",
            onChange: s,
            options: u()
          }
        ),
        /* @__PURE__ */ B.jsx(
          kde,
          {
            required: o,
            columns: f,
            emptyTable: "There are no fields for this season",
            rowSelection: Bt(je({}, l), { checkStrictly: !1 }),
            data: (p = r.filtered) != null ? p : []
          }
        )
      ] }),
      /* @__PURE__ */ B.jsx(
        dI,
        {
          title: {
            first: n("sections.fields.control_steps_first_title"),
            second: n("sections.fields.control_step_second_next")
          },
          previousEvent: () => {
            t("/create-plan");
          },
          nextEvent: () => {
            const h = e.getFieldValue("fields_name");
            Array.isArray(h) && h.length > 0 ? t("/create-operation") : a(!0);
          }
        }
      )
    ] })
  ] });
}, Wde = Ue.section`
  height: 100%;
  width: 100%;
`, Kde = Ue.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`, $3 = Ue.a`
  border-radius: 4px;
  background-color: ${vr[60]};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  color: ${Ht[0]};
  max-width: 182px;

  :hover {
    color: #dfe2e7;
  }

  svg {
    margin-right: 4px;
  }
`;
function Ude(e, t) {
  const [n, r] = Ot(e);
  return kt(() => {
    const o = setTimeout(() => r(e), t != null ? t : 500);
    return () => {
      clearTimeout(o);
    };
  }, [e, t]), n;
}
function Gde(e) {
  const t = _t();
  return kt(() => {
    t.current = e;
  }, [e]), t.current;
}
function qde(e, t) {
  const [n, r] = Ot(1);
  return { paginatedItems: e.slice(
    (n - 1) * t,
    n * t
  ), currentPage: n, handleChangePage: (a) => {
    r(a);
  } };
}
const GC = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    style: { fill: "currentColor" },
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 2.25H14.25V0.75H12.75V2.25H5.25V0.75H3.75V2.25H3C2.175 2.25 1.5 2.925 1.5 3.75V15.75C1.5 16.575 2.175 17.25 3 17.25H15C15.825 17.25 16.5 16.575 16.5 15.75V3.75C16.5 2.925 15.825 2.25 15 2.25ZM15 15.75H3V7.5H15V15.75ZM3 6H15V3.75H3V6Z",
        fill: "currentColor"
      }
    )
  }
), Yde = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.75 9C8.1975 9 9.375 7.8225 9.375 6.375C9.375 4.9275 8.1975 3.75 6.75 3.75C5.3025 3.75 4.125 4.9275 4.125 6.375C4.125 7.8225 5.3025 9 6.75 9ZM6.75 5.25C7.3725 5.25 7.875 5.7525 7.875 6.375C7.875 6.9975 7.3725 7.5 6.75 7.5C6.1275 7.5 5.625 6.9975 5.625 6.375C5.625 5.7525 6.1275 5.25 6.75 5.25ZM3.5775 12.75H6.7875C6.765 12.87 6.75 12.9975 6.75 13.125V14.25H1.5V13.125C1.5 11.3775 4.995 10.5 6.75 10.5C7.17 10.5 7.6875 10.5525 8.235 10.65C7.7025 11.01 7.26 11.46 7.005 12.0075C6.96375 12.0075 6.92062 12.0056 6.8775 12.0037C6.83438 12.0019 6.79125 12 6.75 12C5.6025 12 4.32 12.375 3.5775 12.75ZM12.375 10.875C10.995 10.875 8.25 11.6325 8.25 13.125V14.25H16.5V13.125C16.5 11.6325 13.755 10.875 12.375 10.875ZM14.25 7.875C14.25 8.58 13.8525 9.1875 13.2825 9.51C13.0125 9.66 12.705 9.75 12.375 9.75C12.045 9.75 11.7375 9.66 11.4675 9.51C10.8975 9.1875 10.5 8.58 10.5 7.875C10.5 6.84 11.34 6 12.375 6C13.41 6 14.25 6.84 14.25 7.875Z",
        fill: "#696F88"
      }
    )
  }
), Xde = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM8.25 5.25V6.75H9.75V5.25H8.25ZM8.25 8.25V12.75H9.75V8.25H8.25ZM3 9C3 12.3075 5.6925 15 9 15C12.3075 15 15 12.3075 15 9C15 5.6925 12.3075 3 9 3C5.6925 3 3 5.6925 3 9Z",
        fill: "#696F88"
      }
    )
  }
), fI = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.875 2.25H7.125L6.375 3H3.75V4.5H14.25V3H11.625L10.875 2.25ZM12 6.75V14.25H6V6.75H12ZM4.5 5.25H13.5V14.25C13.5 15.075 12.825 15.75 12 15.75H6C5.175 15.75 4.5 15.075 4.5 14.25V5.25Z",
        fill: "#696F88"
      }
    )
  }
), Zde = Ue.div`
  max-height: 220px;
  max-width: 200px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent rgba(255, 255, 255, 0.3);

  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;

    &,
    &:hover,
    &:active {
      background-color: transparent;
    }
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;

    &,
    &:hover,
    &:active {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
`, Qde = Ue.div`
  display: flex;
`, O3 = {
  backgroundColor: `${Ht[10]}`,
  border: `1px solid ${Ht[20]}`,
  color: `${Ht[70]}`,
  width: "24",
  height: "24",
  fontSize: "12px",
  fontWeight: "600",
  letterSpacing: "-0.09",
  marginRight: "4px"
}, T0 = 3, qC = Gy(({ assignees: e }) => {
  let t = e, n = [];
  (t == null ? void 0 : t.length) > T0 + 1 && (t = e.slice(0, T0), n = e.slice(T0));
  const r = { marginRight: "4px" }, o = /* @__PURE__ */ B.jsxs(Qde, { children: [
    t == null ? void 0 : t.map((i) => /* @__PURE__ */ B.jsx(Bo, { title: i.name, placement: "bottom", children: /* @__PURE__ */ B.jsx(eh, { style: O3, children: i.initials }) }, i.id)),
    n.length > 0 && /* @__PURE__ */ B.jsx(
      Bo,
      {
        title: /* @__PURE__ */ B.jsx(Zde, { children: n.map((i) => /* @__PURE__ */ B.jsx("div", { children: /* @__PURE__ */ B.jsx("p", { children: i.name }) }, i.id)) }),
        children: /* @__PURE__ */ B.jsxs(eh, { style: r, children: [
          "+",
          n.length
        ] })
      }
    )
  ] });
  return t && t.length === 1 ? /* @__PURE__ */ B.jsx(eh, { style: O3, children: t[0].initials }) : o;
});
qC.displayName = "AvatarGroup";
const pI = ({ color: e = "#696f88", width: t = 16, height: n = 16 }) => {
  const r = `
    <svg xmlns='http://www.w3.org/2000/svg' width='${t}' height='${n}' viewBox='0 0 24 24' fill='none'>
      <path d='M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z' fill='${e}'/>
    </svg>`, o = btoa(r);
  return /* @__PURE__ */ B.jsx(
    "img",
    {
      src: `data:image/svg+xml;base64,${o}`,
      alt: "close icon",
      id: "close-icon"
    }
  );
}, Jde = (e) => /* @__PURE__ */ B.jsx(
  "svg",
  Bt(je({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, e), {
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M10.675 1.333h1.333v2h-1.333zM4.006 2.667H2.673v4h1.333zM9.182 7.11c.515-.644 1.319-.935 2.078-1.049.249-.037.481-.054.681-.06a6.65 6.65 0 0 1-.097.548c-.155.697-.45 1.47-.988 2.007-.525.526-1.197.738-1.777.81a4.181 4.181 0 0 1-.554.031 2.823 2.823 0 0 1-.03-.413c0-.5.13-1.18.687-1.874zm4.146-1.75h-.667zM2.66 10.029l-.632.212.001.003.002.007.008.022.028.076a7.783 7.783 0 0 0 .515 1.093c.353.617.934 1.424 1.78 1.848.806.404 1.764.489 2.465.489.18 0 .348-.006.5-.014v.902H8.66v-3.936c.174-.003.37-.015.583-.041.753-.094 1.747-.382 2.555-1.19.797-.796 1.168-1.857 1.346-2.66a8.01 8.01 0 0 0 .182-1.44V4.77l-.583-.072-.083.662.082-.662h-.005l-.01-.002-.03-.003a6.237 6.237 0 0 0-.462-.026 7.096 7.096 0 0 0-1.174.076c-.907.136-2.103.512-2.921 1.533-.777.97-.98 1.959-.98 2.708a4.086 4.086 0 0 0 .167 1.153v.13a4.468 4.468 0 0 0-.99-.81c-1.016-.61-2.03-.605-2.766-.458a4.52 4.52 0 0 0-1.143.396l-.075.04-.023.014-.008.004-.002.002h-.002l-.46.277.17.507zm0 0-.342-.572.342.572zm4.354 2.157c.041.088.078.173.11.254a7.34 7.34 0 0 1-.297.005c-.632 0-1.34-.083-1.868-.347-.488-.245-.907-.77-1.22-1.318a6.327 6.327 0 0 1-.208-.396 3.13 3.13 0 0 1 .302-.076c.514-.103 1.166-.098 1.818.293.68.408 1.105 1.032 1.363 1.585zm.992-8.852H6.674v1.333h1.333z",
        clipRule: "evenodd"
      }
    )
  })
), efe = (e) => /* @__PURE__ */ B.jsxs(
  "svg",
  Bt(je({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, e), {
    children: [
      /* @__PURE__ */ B.jsx("path", { d: "M6.938 3.852c.523-.337.527-1.14.009-1.795S5.584 1.144 5.06 1.48c-.523.337-.527 1.14-.009 1.795s1.362.913 1.886.576ZM8.489 8.902c.366-.543.146-1.386-.492-1.884s-1.453-.462-1.82.08c-.367.543-.147 1.386.491 1.884.639.498 1.454.462 1.82-.08ZM10.385 4.724c-.518.654-.514 1.458.01 1.795.523.336 1.367.079 1.885-.576.518-.655.514-1.458-.01-1.795-.522-.337-1.367-.08-1.885.576Z" }),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M2 8.667C1.262 8.667.665 9.264.665 10v5.333h14.667V10c0-.736-.597-1.333-1.334-1.333h-1.48c-.617 0-1.09.409-1.308.86-.299.619-1.119 1.806-3.212 1.806s-2.913-1.187-3.212-1.806c-.218-.451-.69-.86-1.308-.86h-1.48ZM2 14v-4h1.479l.007.002a.107.107 0 0 1 .027.014c.026.018.054.05.074.091.444.918 1.65 2.56 4.412 2.56 2.763 0 3.97-1.642 4.413-2.56a.244.244 0 0 1 .074-.091.107.107 0 0 1 .027-.014L12.52 10H14v4H2Z",
          clipRule: "evenodd"
        }
      )
    ]
  })
), _3 = (e) => /* @__PURE__ */ B.jsxs("svg", Bt(je({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, e), { children: [
  /* @__PURE__ */ B.jsx("g", { clipPath: "url(#clip0_10815_6337)", children: /* @__PURE__ */ B.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9598 7.33329C13.6532 4.55329 11.4465 2.34663 8.6665 2.03996V0.666626H7.33317V2.03996C4.55317 2.34663 2.3465 4.55329 2.03984 7.33329H0.666504V8.66663H2.03984C2.3465 11.4466 4.55317 13.6533 7.33317 13.96V15.3333H8.6665V13.96C11.4465 13.6533 13.6532 11.4466 13.9598 8.66663H15.3332V7.33329H13.9598ZM7.99984 12.6666C5.41984 12.6666 3.33317 10.58 3.33317 7.99996C3.33317 5.41996 5.41984 3.33329 7.99984 3.33329C10.5798 3.33329 12.6665 5.41996 12.6665 7.99996C12.6665 10.58 10.5798 12.6666 7.99984 12.6666ZM7.33317 9.69325V7.33329H7.99984H8.6665V9.69325C8.57212 9.7648 8.45805 9.84094 8.33783 9.90041C8.19357 9.97177 8.07898 9.99996 7.99984 9.99996C7.9207 9.99996 7.8061 9.97177 7.66184 9.90041C7.54163 9.84094 7.42755 9.7648 7.33317 9.69325ZM9.33317 7.33329C9.33317 6.9651 9.03469 6.66663 8.6665 6.66663C8.6665 6.60692 8.65865 6.54905 8.64393 6.49398L9.5689 5.56902L9.09749 5.09762L8.17256 6.02255C8.11747 6.00782 8.05957 5.99996 7.99984 5.99996C7.94012 5.99996 7.88223 6.00781 7.82716 6.02254L6.90223 5.09762L6.43083 5.56902L7.35575 6.49394C7.34102 6.54902 7.33317 6.60691 7.33317 6.66663C6.96498 6.66663 6.6665 6.9651 6.6665 7.33329V7.66665H6.13791L5.56887 7.09762L5.09747 7.56902L5.86177 8.33332H6.6665V8.99996H5.86177L5.09747 9.76426L5.56887 10.2357L6.13791 9.66663H6.6665V9.72382C6.6665 9.90063 6.73609 10.0713 6.87461 10.1812C7.1235 10.3786 7.56167 10.6666 7.99984 10.6666C8.438 10.6666 8.87617 10.3786 9.12506 10.1812C9.26359 10.0713 9.33317 9.90063 9.33317 9.72382V9.66663H9.86177L10.4308 10.2357L10.9022 9.76426L10.1379 8.99996H9.33317V8.33332H10.1379L10.9022 7.56902L10.4308 7.09762L9.86177 7.66665H9.33317V7.33329Z"
    }
  ) }),
  /* @__PURE__ */ B.jsx("defs", { children: /* @__PURE__ */ B.jsx("clipPath", { id: "clip0_10815_6337", children: /* @__PURE__ */ B.jsx("rect", { width: "16", height: "16", fill: "white" }) }) })
] })), hI = (e, t = "#0C612C") => {
  switch (e) {
    case Cr.SCOUTING:
      return /* @__PURE__ */ B.jsx(_3, { fill: t });
    case Cr.PLANTING:
      return /* @__PURE__ */ B.jsx(efe, { fill: t });
    case Cr.IRRIGATION:
      return /* @__PURE__ */ B.jsx(Jde, { fill: t });
    default:
      return /* @__PURE__ */ B.jsx(_3, { fill: t });
  }
}, YC = (e, t) => {
  switch (t) {
    case Cr.PLANTING_FEMALE:
      return "Planting « Female";
    case Cr.PLANTING_MALE:
      return "Planting « Male";
    case Cr.PRE_PLANTING:
      return "Planting « Pre-Planting";
  }
  switch (e) {
    case Cr.IRRIGATION:
      return "Irrigation";
    default:
      return "Scouting";
  }
};
var Br = /* @__PURE__ */ ((e) => (e.PLANNED = "PLANNED", e.PLANNED_WITH_DELAY = "PLANNED_WITH_DELAY", e.IN_PROGRESS = "IN_PROGRESS", e.IN_PROGRESS_WITH_DELAY = "IN_PROGRESS_WITH_DELAY", e.COMPLETED = "COMPLETED", e.COMPLETED_WITH_DELAY = "COMPLETED_WITH_DELAY", e))(Br || {});
const tfe = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    style: { fill: "currentColor" },
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00016 1.33337C4.32016 1.33337 1.3335 4.32004 1.3335 8.00004C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8.00004C14.6668 4.32004 11.6802 1.33337 8.00016 1.33337ZM6.66683 9.44676L11.0602 5.05343L12.0002 6.00009L6.66683 11.3334L4.00016 8.66676L4.94016 7.72676L6.66683 9.44676Z",
        style: { fill: "currentColor" }
      }
    )
  }
), nfe = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 20 20",
    style: { fill: "currentColor" },
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM14 10L8 5.5V14.5L14 10Z",
        style: { fill: "currentColor" }
      }
    )
  }
), rfe = Ue.section`
  width: 100%;
  box-sizing: border-box;

  .smv-pagination-options-size-changer {
    display: none;
  }
`, ofe = Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid ${vr[20]};
  background: ${vr[10]};
  color: ${vr[70]};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.09px;
  white-space: nowrap;
`, ife = Ue.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 20px 0 10px;
`, N3 = {
  [Br.COMPLETED]: vr[50],
  [Br.COMPLETED_WITH_DELAY]: C0[60],
  [Br.PLANNED]: o9[60],
  [Br.PLANNED_WITH_DELAY]: C0[60],
  [Br.IN_PROGRESS]: vr[70],
  [Br.IN_PROGRESS_WITH_DELAY]: C0[60]
}, afe = Ue.div`
  color: ${({ status: e }) => N3[e] || N3[Br.COMPLETED]};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.105px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`, Zs = Ue.p`
  color: ${Ht[100]};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.105px;
  margin: 0;
`, sfe = Ue(Zs)`
  font-weight: 600;
`, P3 = Ue.p`
  color: ${Ht[60]};
  font-size: ${({ fontSize: e }) => `${e}px`};
  line-height: 20px;
  letter-spacing: -0.09px;
  margin: 0;
  white-space: break-spaces;
  display: flex;
`;
Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
Ue.p`
  color: ${Ht[60]};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.09px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const lfe = {
  [Br.PLANNED]: "Scheduled",
  [Br.PLANNED_WITH_DELAY]: "Scheduled with delay",
  [Br.COMPLETED]: "Completed",
  [Br.COMPLETED_WITH_DELAY]: "Completed with delay",
  [Br.IN_PROGRESS]: "In progress",
  [Br.IN_PROGRESS_WITH_DELAY]: "In progress with delay"
}, cfe = (e) => {
  switch (e) {
    case Br.PLANNED:
    case Br.PLANNED_WITH_DELAY:
      return /* @__PURE__ */ B.jsx(GC, {});
    case Br.IN_PROGRESS:
    case Br.IN_PROGRESS_WITH_DELAY:
      return /* @__PURE__ */ B.jsx(nfe, {});
    case Br.COMPLETED:
    case Br.COMPLETED_WITH_DELAY:
      return /* @__PURE__ */ B.jsx(tfe, {});
  }
}, ufe = (e) => /* @__PURE__ */ B.jsxs(afe, { status: e, children: [
  cfe(e),
  lfe[e]
] }), XC = (e, t) => {
  if (e.indexOf("GDD") !== -1) {
    const n = RegExp(/\d+/).exec(e);
    return t == "imperial" ? `GDD: ${Number(n) * 9 / 5 + 32} °F` : `GDD: ${Number(n)} °C`;
  }
  return e;
}, dfe = Ue.div`
  display: flex;
  align-items: center;
  gap: 5px;
`, zp = Ue.div`
  margin: 24px 0;
  padding: 0 16px;
`, ffe = Ue.div`
  margin: 0;
  padding: 0 16px;
  display: flex;
  align-content: center;
`, pfe = Ue.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
`, hfe = Ue.button`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`, gfe = Ue.p`
  color: ${Ht[80]};
  font-size: 10px;
  font-weight: 400;
  margin-top: 8px;
`, Vy = Ue.p`
  color: ${Ht[100]};
  font-size: 14px;
  letter-spacing: -0.105px;
  margin-top: 2px;
`, mfe = Ue.p`
  color: ${Ht[100]};
  margin-left: 1rem;
  margin-block-start: 1em !important;
`, vfe = Ue(Vy)`
  font-weight: 600;
`, Vp = Ue.p`
  color: ${Ht[60]};
  font-weight: 400;
  letter-spacing: -0.075px;
  margin: 12px 0 4px 0;
  line-height: 20px;
  letter-spacing: -0.09px;
  margin: 0;
  white-space: break-spaces;
  display: flex;
  width: ${({ width: e }) => `${e}px`};
`;
Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const M0 = Ue.p`
  color: ${Ht[60]};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.09px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 8px;
`, yfe = Ue.div`
  display: flex;
`, Wy = Ue.p`
  color: ${Ht[60]};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.075px;
  margin: 12px 0 4px 0;
`, I3 = Ue.p`
  color: ${Ht[100]};
  font-size: 14px;
  font-weight: 400;
  margin-top: 20px;
`, gI = (e, t) => {
  if (t) {
    if (e === "FREE_SAMPLE_COUNT")
      return /* @__PURE__ */ B.jsxs(Wy, { children: [
        "Sample size per area",
        /* @__PURE__ */ B.jsx(I3, { children: Math.floor(t) })
      ] });
    if (e === "FREE_BY_RATE")
      return /* @__PURE__ */ B.jsxs(zc, { gap: "middle", align: "center", children: [
        /* @__PURE__ */ B.jsx(Wy, { children: "Hectares/sample:" }),
        /* @__PURE__ */ B.jsx(I3, { children: Math.floor(t) })
      ] });
  }
}, bfe = (e) => {
  if (!e.length)
    return;
  const t = e.map(
    (n) => n.name.localized_strings.en
  );
  return t.length > 0 ? t.join(", ") : t;
}, Cfe = {
  body: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "16px 0"
  }
}, xfe = {
  backgroundColor: Ht[10],
  border: "none",
  borderRadius: "4px",
  color: fu[50],
  fontSize: "14px"
}, Sfe = ({
  selectedRow: e,
  showDrawer: t,
  onClose: n,
  onDeleteTask: r,
  listSeasonFields: o,
  unitSystem: i
}) => {
  var m, v, C, x, S;
  const [a, s] = Ot([]), [l, u] = Ot(""), [f, p] = Ot(""), [h, y] = Ot(""), { t: b } = oo();
  return kt(() => {
    an(void 0, null, function* () {
      const O = e.planId.id, $ = yield Ode(O), _ = e.agroOperationGroupId.id, R = $.data.plan_operations.filter(
        (P) => P.id === _
      );
      s(R), u($.data.seasons_ids[0]);
    });
  }, [e]), kt(() => {
    an(void 0, null, function* () {
      const O = o.find(
        (R) => R.id === e.cropZoneId
      ), $ = O == null ? void 0 : O.property_id;
      if (!$ || !l)
        return;
      const _ = yield KC(l, $);
      if (p(_.data[0].methodologyId), f) {
        const R = yield WC(f);
        y(
          bfe(R.data)
        );
      }
    });
  }, [l, e, a, o, f]), /* @__PURE__ */ B.jsxs(
    uC,
    {
      title: /* @__PURE__ */ B.jsxs(dfe, { children: [
        hI(e.type, "#000"),
        YC(e.type, e.plantingType)
      ] }),
      placement: "right",
      onClose: n,
      open: t,
      styles: Cfe,
      children: [
        /* @__PURE__ */ B.jsxs("div", { children: [
          /* @__PURE__ */ B.jsxs(zp, { children: [
            /* @__PURE__ */ B.jsx(Vp, { fontSize: 14, children: e.operationInfo.planName }),
            /* @__PURE__ */ B.jsx(vfe, { children: e.operationInfo.operationName })
          ] }),
          /* @__PURE__ */ B.jsxs(zp, { children: [
            /* @__PURE__ */ B.jsxs(M0, { children: [
              /* @__PURE__ */ B.jsx(GC, {}),
              " START DATE"
            ] }),
            /* @__PURE__ */ B.jsx(Vy, { children: e.startDate }),
            /* @__PURE__ */ B.jsx(Vp, { fontSize: 14, children: XC(e.criteria, i) })
          ] }),
          /* @__PURE__ */ B.jsxs(zp, { children: [
            /* @__PURE__ */ B.jsxs(M0, { children: [
              /* @__PURE__ */ B.jsx(Yde, {}),
              " Assignee(s)"
            ] }),
            /* @__PURE__ */ B.jsx(eh.Group, { maxCount: 4, maxPopoverPlacement: "bottom", children: /* @__PURE__ */ B.jsx(qC, { assignees: e.assignees }) })
          ] }),
          /* @__PURE__ */ B.jsx(_E, {}),
          /* @__PURE__ */ B.jsxs(zp, { children: [
            /* @__PURE__ */ B.jsxs(M0, { children: [
              /* @__PURE__ */ B.jsx(Xde, {}),
              " Details"
            ] }),
            /* @__PURE__ */ B.jsx(Vp, { fontSize: 14, children: gI(
              (m = a[0]) == null ? void 0 : m.scouting_type,
              (v = a[0]) == null ? void 0 : v.point_factor
            ) }),
            h && /* @__PURE__ */ B.jsxs(yfe, { children: [
              /* @__PURE__ */ B.jsxs(Vp, { fontSize: 14, width: 122, children: [
                "Inspection group:",
                " "
              ] }),
              /* @__PURE__ */ B.jsx(Vy, { children: h })
            ] })
          ] }),
          /* @__PURE__ */ B.jsxs(ffe, { children: [
            /* @__PURE__ */ B.jsx(Wy, { children: "Property/Area:" }),
            /* @__PURE__ */ B.jsx(mfe, { children: (C = e.region) != null && C.propertyName ? `${(x = e.region) == null ? void 0 : x.propertyName}/
              ${(S = e.region) == null ? void 0 : S.fieldName}` : "N/A" })
          ] })
        ] }),
        /* @__PURE__ */ B.jsxs(pfe, { children: [
          /* @__PURE__ */ B.jsx(_E, {}),
          /* @__PURE__ */ B.jsxs(
            gC,
            {
              title: b("molecules.delete_smart_plan_dialog.alert_title"),
              description: b(
                "molecules.delete_smart_plan_dialog.alert_description"
              ),
              icon: /* @__PURE__ */ B.jsx(BC, {}),
              onConfirm: () => {
                Id.success(
                  b("molecules.delete_smart_plan_dialog.alert_message_success")
                ), r();
              },
              onCancel: () => {
                Id.error(
                  b("molecules.delete_smart_plan_dialog.alert_message_cancel")
                );
              },
              okText: b("molecules.delete_smart_plan_dialog.alert_ok_text"),
              okType: "danger",
              okButtonProps: xfe,
              cancelText: b("molecules.delete_smart_plan_dialog.alert_cancel_text"),
              children: [
                /* @__PURE__ */ B.jsx(hfe, { children: /* @__PURE__ */ B.jsx(fI, {}) }),
                /* @__PURE__ */ B.jsx(gfe, { children: "Delete" })
              ]
            }
          )
        ] })
      ]
    }
  );
}, wfe = ({ unitSystem: e }) => {
  const { t } = oo();
  return [
    {
      title: t("molecules.operations_table.columns_start_date_title"),
      dataIndex: "startDate",
      key: "startDate",
      render: (n) => /* @__PURE__ */ B.jsx(sfe, { children: n })
    },
    {
      title: t("molecules.operations_table.column_type_title"),
      dataIndex: "type",
      key: "type",
      render: (n, { plantingType: r }) => /* @__PURE__ */ B.jsxs(ofe, { children: [
        hI(n),
        YC(n, r).toUpperCase()
      ] })
    },
    {
      title: t("molecules.operations_table.column_operation_name_title"),
      dataIndex: "operationInfo",
      key: "operationInfo",
      render: (n, { operationInfo: r }) => /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
        /* @__PURE__ */ B.jsxs(P3, { fontSize: 12, children: [
          r.planName,
          " /"
        ] }),
        /* @__PURE__ */ B.jsx(Zs, { children: r.operationName })
      ] })
    },
    {
      title: t("molecules.operations_table.column_region_field_title"),
      dataIndex: "region",
      key: "region",
      render: (n) => n ? /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
        n.propertyName && /* @__PURE__ */ B.jsxs(P3, { fontSize: 12, children: [
          n.propertyName,
          " /"
        ] }),
        n.fieldName ? /* @__PURE__ */ B.jsx(Zs, { children: n.fieldName }) : /* @__PURE__ */ B.jsxs(Zs, { style: { color: "red" }, children: [
          t("molecules.operations_table.field_not_found"),
          " "
        ] })
      ] }) : /* @__PURE__ */ B.jsxs(Zs, { style: { color: "red" }, children: [
        t("molecules.operations_table.field_not_found"),
        " "
      ] })
    },
    {
      title: t("molecules.operations_table.column_status_title"),
      dataIndex: "status",
      key: "status",
      render: (n, { calculatedStatus: r }) => ufe(r)
    },
    {
      title: t("molecules.operations_table.column_criteria_title"),
      dataIndex: "criteria",
      key: "criteria",
      render: (n) => /* @__PURE__ */ B.jsx(Zs, { children: XC(n, e) })
    },
    {
      title: "ID",
      dataIndex: "externalId",
      key: "externalId",
      render: (n) => /* @__PURE__ */ B.jsx(Zs, { children: n })
    },
    {
      title: t("molecules.operations_table.column_assignee_title"),
      dataIndex: "assignees",
      key: "assignees",
      render: (n, { assignees: r }) => /* @__PURE__ */ B.jsx(qC, { assignees: r })
    },
    {
      dataIndex: "id",
      key: "id",
      hidden: !0
    },
    {
      dataIndex: "planId",
      key: "planId",
      hidden: !0
    },
    {
      dataIndex: "agroOperationGroupId",
      key: "agroOperationGroupId",
      hidden: !0
    },
    {
      dataIndex: "seasonId",
      key: "seasonId",
      hidden: !0
    },
    {
      dataIndex: "cropZoneId",
      key: "cropZoneId",
      hidden: !0
    }
  ].filter((n) => !n.hidden);
}, Efe = ({
  workOrderList: e,
  itemsPerPage: t = 25,
  onDeleteTask: n,
  listSeasonFields: r,
  unitSystem: o,
  isLastPage: i,
  loadMoreData: a,
  resetPagination: s,
  setResetPagination: l
}) => {
  const [u, f] = Ot(!1), [p, h] = Ot(), { paginatedItems: y, currentPage: b, handleChangePage: m } = qde(
    e,
    t
  ), v = wfe({ unitSystem: o });
  kt(() => {
    s && (m(1), l == null || l(!1));
  }, [m, s, l, e]);
  const C = () => {
    f(!0);
  }, x = () => {
    f(!1);
  }, S = ar(() => {
    p && (n == null || n(p.id), x());
  }, [n, p]), E = (O) => ({
    onClick: () => {
      h(O), C();
    }
  });
  if (r)
    return /* @__PURE__ */ B.jsxs(rfe, { children: [
      /* @__PURE__ */ B.jsx(
        NP,
        {
          dataSource: y,
          columns: v,
          onRow: E,
          pagination: !1
        }
      ),
      e.length > 0 && /* @__PURE__ */ B.jsxs(ife, { children: [
        /* @__PURE__ */ B.jsx(
          b8,
          {
            current: b,
            pageSize: t,
            onChange: m,
            total: e.length,
            showTotal: (O, $) => `${$[0]}-${$[1]} of ${O}${i ? "" : " displayed"}`
          }
        ),
        !i && /* @__PURE__ */ B.jsx(Io, { onClick: a, children: "Load More" })
      ] }),
      p && /* @__PURE__ */ B.jsx(
        Sfe,
        {
          selectedRow: p,
          showDrawer: u,
          onClose: x,
          onDeleteTask: S,
          listSeasonFields: r,
          unitSystem: o
        }
      )
    ] });
}, $fe = Ue.button`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${Ht[10]};
  border: transparent;
  cursor: pointer;
`, R3 = Ue.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;
  color: ${Ht[100]};
  margin: 0 0 4px 0;
`, Ofe = Ue.p`
  color: ${Ht[60]};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.09px;
  margin: 0;
  white-space: break-spaces;
  display: flex;
`, _fe = Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid ${vr[20]};
  background: ${vr[10]};
  color: ${vr[70]};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.09px;
`, Nfe = Ue.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`, Pfe = Ue.div`
.smv-collapse {
  width: 100%;

  .smv-collapse-header {
    padding: 0;
  }

  .smv-collapse-content-box {
    border-top: 1px solid #dfe2e7;
    padding: 0;
    margin-top: 16px;
  }
`, Ife = Ue(aC)`
  background: ${Ht[0]};
  border-radius: 16px;
  border: 4px solid ${vr[10]};
  margin-top: 12px;
  padding: 20px;
`, Rfe = ({ isActive: e }) => /* @__PURE__ */ B.jsx($fe, { children: /* @__PURE__ */ B.jsx(ef, { rotate: e ? 180 : 360 }) }), Dfe = ({
  operations: e
}) => {
  var r;
  const t = Cn(Si), { unitSystem: n } = (r = t.rulesInformation) != null ? r : {};
  return /* @__PURE__ */ B.jsxs(Pfe, { children: [
    /* @__PURE__ */ B.jsx(R3, { children: "Operations: " }),
    e.map((o) => {
      var i;
      return /* @__PURE__ */ B.jsx(
        Ife,
        {
          bordered: !1,
          expandIcon: (a) => /* @__PURE__ */ B.jsx(Rfe, { isActive: a.isActive }),
          expandIconPosition: "end",
          items: [
            {
              label: /* @__PURE__ */ B.jsxs(Nfe, { children: [
                /* @__PURE__ */ B.jsxs("div", { children: [
                  /* @__PURE__ */ B.jsx(R3, { children: o.name }),
                  n && /* @__PURE__ */ B.jsx(Ofe, { children: XC(
                    (i = o.criteria) != null ? i : "",
                    n
                  ) })
                ] }),
                /* @__PURE__ */ B.jsx(_fe, { children: o.type })
              ] }),
              children: /* @__PURE__ */ B.jsx("p", { children: o.details })
            }
          ]
        },
        o.id
      );
    })
  ] });
}, Tfe = Ue.button`
  display: flex;
  justify-items: center;
  border: none;
  background-color: transparent;
  box-shadow: none;
  outline: none;
  cursor: pointer;
  margin-left: auto;

  svg {
    color: ${Ht[60]};
    gap: 12px;
  }
`, Mfe = ({
  planId: e,
  onConfirmDelete: t
}) => {
  const [n, r] = Ot(!1), { t: o } = oo(), i = () => an(void 0, null, function* () {
    r(!0), yield Nde(e), Id.success(
      o("molecules.delete_smart_plan_dialog.alert_message_success")
    ), r(!1), t == null || t();
  });
  return /* @__PURE__ */ B.jsx(
    gC,
    {
      title: o("molecules.delete_smart_plan_dialog.alert_title"),
      description: o("molecules.delete_smart_plan_dialog.alert_description"),
      icon: /* @__PURE__ */ B.jsx(BC, {}),
      onConfirm: (a) => {
        a == null || a.stopPropagation(), i();
      },
      okText: o("molecules.delete_smart_plan_dialog.alert_ok_text"),
      okType: "danger",
      onCancel: (a) => a == null ? void 0 : a.stopPropagation(),
      children: /* @__PURE__ */ B.jsx(
        Tfe,
        {
          title: "Delete plan",
          onClick: (a) => a.stopPropagation(),
          disabled: n,
          children: n ? /* @__PURE__ */ B.jsx(af, { size: "small" }) : /* @__PURE__ */ B.jsx(hie, {})
        }
      )
    }
  );
}, Lfe = Ue.button`
  display: flex;
  justify-items: center;
  border: none;
  background-color: transparent;
  box-shadow: none;
  outline: none;
  cursor: pointer;
  margin-left: auto;

  svg {
    color: ${Ht[60]};
    gap: 12px;
  }
`, Afe = ({ onClick: e }) => /* @__PURE__ */ B.jsx(Lfe, { title: "Duplicate plan", onClick: e, children: /* @__PURE__ */ B.jsx(kP, {}) });
function mI(e) {
  return qr(e).format("DD/MM/YYYY");
}
const jfe = () => {
  const e = qr(), t = e.startOf("month"), n = e.endOf("month");
  return [t, n];
}, kfe = (e) => e.split(" ").map((t) => t[0]).join("").toUpperCase(), vI = (e, t) => {
  if ((e == null ? void 0 : e.type) === "DAE" || (e == null ? void 0 : e.type) === "DAP")
    return `${e.type}: ${e.days}`;
  if ((e == null ? void 0 : e.type) === "GDD")
    return `${e.type}: ${e.gdd_degree} °`;
  if ((e == null ? void 0 : e.type) === "DAO") {
    const n = e.days === 1 ? "day" : "days";
    return `${e.days} ${n} after: ${t}`;
  }
  return "Date";
}, yI = {
  planned: ["PLANNED"],
  delayed: [
    "PLANNED_WITH_DELAY",
    "COMPLETED_WITH_DELAY",
    "IN_PROGRESS_WITH_DELAY"
  ],
  completed: ["COMPLETED"]
}, bI = (e, t) => t ? yI[t.toLowerCase()].some(
  (r) => r === e.calculatedStatus
) : !0, Ffe = (e = []) => {
  const t = {
    planned: 0,
    completed: 0,
    delayed: 0
  }, n = Object.keys(yI);
  return e.forEach((r) => {
    n.forEach((o) => {
      bI(r, o) && t[o]++;
    });
  }), t;
}, Bfe = (e, t, n, r, o) => e ? e.map(
  (a, s) => {
    var C;
    const l = (C = a.properties_ids) == null ? void 0 : C.flatMap(
      (x) => t[x] || []
    ), u = l == null ? void 0 : l.map(({ name: x, id: S }) => ({
      id: S,
      name: x,
      initials: kfe(x)
    })), f = e.filter(
      (x) => x.id === a.summarized_work_order.parent_operation_id
    ), p = f.length > 0 ? f[0].description : void 0, h = vI(
      a.summarized_work_order.date_rule,
      p
    ), y = a.linked_documents.filter(
      (x) => x.type === "SMART_PLAN"
    ), b = a.linked_documents.filter(
      (x) => x.type === "AGRO_OPERATION_GROUP"
    ), m = {
      cropZoneId: a.summarized_work_order.crop_zones_id[0],
      seasonFieldList: n,
      propertyList: r,
      getNamesBySeasonFields: o
    }, v = zfe(m);
    return {
      key: s + 1,
      startDate: mI(a.summarized_work_order.start_date),
      type: a.operation_type,
      plantingType: a.planting_type,
      operationInfo: {
        planName: a.smart_plan.plan_name,
        operationName: a.description
      },
      region: v,
      status: a.status,
      calculatedStatus: a.calculated_status,
      criteria: h,
      externalId: a.external_id,
      assignees: u,
      propertiesIds: a.properties_ids,
      id: a.id,
      cropZoneId: a.summarized_work_order.crop_zones_id[0],
      planId: y[0],
      agroOperationGroupId: b[0],
      seasonId: a.seasons_ids[0]
    };
  }
) : void 0, Hfe = (e, t) => t.map((r, o) => {
  const { id: i } = r, a = e == null ? void 0 : e.filter(
    ({ property_id: s }) => s === i || s.length === 0
  ).map((s) => Bt(je({}, s), {
    key: s.id
  }));
  return Bt(je({}, r), {
    type_row: "property",
    key: o,
    children: [...a]
  });
}).filter((r) => r.children.length > 0), zfe = ({
  cropZoneId: e,
  seasonFieldList: t,
  propertyList: n,
  getNamesBySeasonFields: r
}) => {
  var l, u, f, p, h;
  if (!t)
    return null;
  const { property_id: o, field_id: i } = (l = t.find((y) => y.id === e)) != null ? l : {};
  if (!o || !i)
    return null;
  const a = (f = (u = n.find(({ id: y }) => y === o)) == null ? void 0 : u.name) != null ? f : "N/A", s = (h = (p = r.find((y) => y.id === i)) == null ? void 0 : p.name) != null ? h : "N/A";
  return {
    propertyId: o,
    propertyName: a,
    fieldId: i,
    fieldName: s
  };
}, Vfe = (e, t) => {
  const n = [];
  for (let r = 0; r < e.length; r += t)
    n.push(e.slice(r, r + t));
  return n;
}, Wfe = (e, t) => {
  var r;
  if (((r = e.date_rule) == null ? void 0 : r.type) !== "DAO")
    return;
  const n = t.find(
    (o) => o.id === e.parent_operation_id
  );
  return n == null ? void 0 : n.name;
}, Kfe = (e) => ({
  id: e.id,
  name: e.plan_name,
  createdAt: mI(e.created_at),
  operations: e.plan_operations.map((t) => {
    const n = Wfe(t, e.plan_operations);
    return {
      id: t.id,
      type: t.type,
      name: t.name,
      criteria: vI(t.date_rule, n),
      details: gI(
        t.scouting_type,
        t.point_factor
      )
    };
  })
}), Ufe = Ue.div`
  display: flex;
  flex-direction: column;
  min-width: 680px;
  gap: 20px;
  margin-top: 32px;
  padding: 0px 20px;
`, Gfe = Ue.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;
  color: ${Ht[100]};
  margin: 0 0 4px 0;
`, qfe = Ue.p`
  color: ${Ht[60]};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.09px;
  margin: 0;
  white-space: break-spaces;
  display: flex;
`, Yfe = Ue.button`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${Ht[10]};
  border: transparent;
  cursor: pointer;
`, CI = Ue(aC)`
  background: ${Ht[0]};
  border-radius: 16px;
  border: 4px solid ${vr[10]};
  padding: 16px 20px;
`;
Ue(CI)`
  margin-top: 12px;
  padding: 20px;
`;
const Xfe = Ue.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 23px;
`, Zfe = ({ isActive: e }) => /* @__PURE__ */ B.jsx(Yfe, { children: /* @__PURE__ */ B.jsx(ef, { rotate: e ? 180 : 360 }) }), Qfe = ({ list: e, onDeletePlan: t }) => {
  const n = Ya(), r = ar(
    (o) => {
      const i = e.find((a) => a.id === o);
      i && n("/create-plan", { state: { clonedPlan: i } });
    },
    [e, n]
  );
  return e.length ? /* @__PURE__ */ B.jsx(Ufe, { children: e.map(Kfe).map((o) => /* @__PURE__ */ B.jsx(
    CI,
    {
      bordered: !1,
      expandIconPosition: "end",
      expandIcon: (i) => /* @__PURE__ */ B.jsx(Zfe, { isActive: i.isActive }),
      items: [
        {
          label: /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
            /* @__PURE__ */ B.jsx(Gfe, { children: o.name }),
            /* @__PURE__ */ B.jsxs(qfe, { children: [
              "Created at: ",
              o.createdAt
            ] })
          ] }),
          children: /* @__PURE__ */ B.jsx(Dfe, { operations: o.operations }),
          extra: /* @__PURE__ */ B.jsxs(Xfe, { children: [
            /* @__PURE__ */ B.jsx(
              Mfe,
              {
                planId: o.id,
                onConfirmDelete: () => t(o.id)
              }
            ),
            /* @__PURE__ */ B.jsx(Afe, { onClick: () => r(o.id) })
          ] })
        }
      ]
    },
    o.id
  )) }) : null;
}, og = {
  date: !1,
  search: !1
}, Jfe = FC`
  color: ${vr[50]} !important;
  border-bottom: 2px solid ${vr[60]};
`, epe = Ue(Io)`
  display: flex;
  padding: 20px;
  height: auto;
  color: ${Ht[60]} !important;
  border-bottom: 2px solid transparent;
  border: none;
  box-shadow: none;
  border-radius: unset;
  background: transparent !important;

  ${({ type: e }) => e === "primary" && Jfe};
`, D3 = ({
  text: e,
  isActive: t,
  onToggleList: n
}) => /* @__PURE__ */ B.jsx(epe, { onClick: n, type: t ? "primary" : "default", children: e }), tpe = (e) => {
  const { t } = oo();
  return /* @__PURE__ */ B.jsx(
    Ls,
    je({
      placeholder: "Status",
      options: [
        {
          value: "",
          label: t("molecules.smart_plan_subheader.status_items_key_1_label")
        },
        {
          value: "PLANNED",
          label: t("molecules.smart_plan_subheader.status_items_key_2_label")
        },
        {
          value: "DELAYED",
          label: t("molecules.smart_plan_subheader.status_items_key_3_label")
        },
        {
          value: "COMPLETED",
          label: t("molecules.smart_plan_subheader.status_items_key_4_label")
        }
      ]
    }, e)
  );
}, npe = Ue.button`
  width: 32px;
  height: 32px;
  background-color: #f3f4f6;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    color: ${vr[60]};
  }
`, rpe = Ue.div`
  display: flex;

  .smv-picker-range {
    background-color: ${Ht[10]};
    border: none;
    border-radius: 4px 0 0 4px;
    max-width: 232px;
  }
`, ope = Ue(As.RangePicker)`
  width: 100%;
  min-width: 232px;
`, ipe = Ue.button`
  background-color: ${Ht[10]};
  border-radius: 0 4px 4px 0px;
  border: none;
  cursor: pointer;

  svg {
    color: #696f88;
    width: 18px;
    height: 18px;
  }
`, xI = Gy(
  ({
    onDateFilterChange: e,
    dateFilter: t,
    isOpen: n,
    onOpen: r,
    onClose: o
  }) => /* @__PURE__ */ B.jsx(B.Fragment, { children: n ? /* @__PURE__ */ B.jsxs(rpe, { children: [
    /* @__PURE__ */ B.jsx(
      ope,
      {
        format: ["DD MMM YYYY"],
        onChange: e,
        value: t,
        allowClear: !1
      }
    ),
    /* @__PURE__ */ B.jsx(ipe, { onClick: o, children: /* @__PURE__ */ B.jsx(pI, {}) })
  ] }) : /* @__PURE__ */ B.jsx(Bo, { title: "Set a time range", placement: "bottom", children: /* @__PURE__ */ B.jsx(npe, { onClick: r, children: /* @__PURE__ */ B.jsx(GC, {}) }) }) })
);
xI.displayName = "DatePickerButton";
const ape = Ue(Ci)`
  display: flex;
  max-width: 400px;
  width: 100%;
`, ZC = Ue.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.09px;
  color: ${o9[60]};
  margin: 4px 0;

  strong {
    font-size: 14px;
  }
`, spe = Ue(ZC)`
  color: ${fu[60]};
`, lpe = Ue(ZC)`
  color: ${vr[60]};
`, cpe = ({
  statusCount: e,
  filterStatus: t,
  onSelectChange: n
}) => /* @__PURE__ */ B.jsxs(
  ape.Group,
  {
    value: t,
    onChange: n,
    name: "group-status-filter",
    children: [
      /* @__PURE__ */ B.jsx(Ci.Button, { value: "PLANNED", children: /* @__PURE__ */ B.jsxs(ZC, { children: [
        /* @__PURE__ */ B.jsx("strong", { children: e.planned }),
        " Scheduled"
      ] }) }),
      /* @__PURE__ */ B.jsx(Ci.Button, { value: "DELAYED", children: /* @__PURE__ */ B.jsxs(spe, { children: [
        /* @__PURE__ */ B.jsx("strong", { children: e.delayed }),
        " Delayed"
      ] }) }),
      /* @__PURE__ */ B.jsx(Ci.Button, { value: "COMPLETED", children: /* @__PURE__ */ B.jsxs(lpe, { children: [
        /* @__PURE__ */ B.jsx("strong", { children: e.completed }),
        " Completed"
      ] }) })
    ]
  }
), upe = () => /* @__PURE__ */ B.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    children: /* @__PURE__ */ B.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 4.5V6H15.75V4.5H2.25ZM7.5 13.5H10.5V12H7.5V13.5ZM13.5 9.75H4.5V8.25H13.5V9.75Z",
        fill: "#14803C"
      }
    )
  }
), { SHOW_PARENT: dpe } = AP;
function SI(e, t = "0") {
  return e ? e.map((n, r) => {
    const o = `${t}-${r}`;
    return {
      title: n.name,
      key: o,
      value: n.id,
      children: Array.isArray(n.children) ? SI(n.children, o) : void 0
    };
  }) : [];
}
const fpe = ({
  onSelectedAreaChange: e,
  selectedArea: t,
  fieldsFiltered: n
}) => {
  const r = {
    treeData: SI(n),
    value: t,
    onChange: e,
    treeCheckable: !0,
    showCheckedStrategy: dpe,
    placeholder: "Please select",
    style: {
      width: "100%"
    }
  };
  return /* @__PURE__ */ B.jsx(AP, Bt(je({}, r), { disabled: !n.length }));
};
Ue.a`
  width: 32px;
  height: 32px;
  background-color: #f3f4f6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    color: ${vr[60]};
  }
`;
const ppe = Ue.div`
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${fu[50]};
  position: absolute;
  top: -2px;
  right: -2px;
`, hpe = Ue.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`, gpe = Ue.div`
  display: flex;
  gap: 8px;
`, wI = Gy(
  ({ selectedArea: e, fieldsFiltered: t, onSaveSelectedArea: n }) => {
    const [r, o] = Ot(e), [i, a] = Ot(!1);
    kt(() => {
      o(e);
    }, [e]);
    const s = () => {
      a(!0);
    }, l = () => {
      a(!1);
    }, u = () => {
      n == null || n(r), l();
    }, f = () => {
      o([]);
    };
    return /* @__PURE__ */ B.jsxs("div", { children: [
      /* @__PURE__ */ B.jsxs("button", { onClick: s, "aria-label": "Filter by...", children: [
        /* @__PURE__ */ B.jsx(upe, {}),
        e && e.length > 0 && /* @__PURE__ */ B.jsx(ppe, {})
      ] }),
      /* @__PURE__ */ B.jsxs(
        uC,
        {
          title: "Filter by...",
          placement: "right",
          onClose: l,
          open: i,
          styles: {
            body: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }
          },
          children: [
            /* @__PURE__ */ B.jsx(
              fpe,
              {
                selectedArea: r,
                onSelectedAreaChange: o,
                fieldsFiltered: t
              }
            ),
            /* @__PURE__ */ B.jsxs(hpe, { children: [
              /* @__PURE__ */ B.jsx(Io, { type: "text", onClick: f, children: "Clear selection" }),
              /* @__PURE__ */ B.jsxs(gpe, { children: [
                /* @__PURE__ */ B.jsx(Io, { type: "text", onClick: l, children: "Cancel" }),
                /* @__PURE__ */ B.jsx(Fd, { onClick: u, children: "Apply" })
              ] })
            ] })
          ]
        }
      )
    ] });
  }
);
wI.displayName = "ListFilter";
const mpe = (e) => {
  const { t } = oo();
  return /* @__PURE__ */ B.jsx(
    Ls,
    je({
      placeholder: "Pages",
      options: [
        {
          value: 10,
          label: t("molecules.smart_plan_subheader.pages_items_key_1_label")
        },
        {
          value: 25,
          label: t("molecules.smart_plan_subheader.pages_items_key_2_label")
        },
        {
          value: 50,
          label: t("molecules.smart_plan_subheader.pages_items_key_3_label")
        }
      ],
      "data-testid": "select-pages"
    }, e)
  );
}, Ky = Ue(Hg)`
  color: ${vr[60]};
`, vpe = Ue.button`
  width: 32px;
  height: 32px;
  background-color: #f3f4f6;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`, ype = Ue.div`
  position: relative;

  ${Ky} {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: ${Ht[60]};
    margin: 0 10px;
  }
`, bpe = Ue.button`
  background-color: transparent;
  outline: none;
  border: none;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    height: 15px;
    width: 15px;
    color: ${Ht[60]};
  }
`, Cpe = Ue.input`
  max-width: 200px;
  height: 32px;
  background-color: #f3f4f6;
  border-radius: 4px;
  padding: 0 30px;
  outline: none;
  border: none;
`, T3 = ({
  onSearch: e,
  search: t,
  isOpen: n,
  onOpen: r,
  onClose: o
}) => {
  const { t: i } = oo();
  return /* @__PURE__ */ B.jsx(B.Fragment, { children: n ? /* @__PURE__ */ B.jsxs(ype, { children: [
    /* @__PURE__ */ B.jsx(Ky, {}),
    /* @__PURE__ */ B.jsx(
      Cpe,
      {
        placeholder: i("molecules.search_input.input_search_placeholder"),
        onChange: e,
        value: t,
        autoFocus: !0
      }
    ),
    /* @__PURE__ */ B.jsx(bpe, { onClick: o, children: /* @__PURE__ */ B.jsx(pI, {}) })
  ] }) : /* @__PURE__ */ B.jsx(
    Bo,
    {
      title: i("molecules.search_input.tooltip_search_title"),
      placement: "bottom",
      children: /* @__PURE__ */ B.jsx(vpe, { onClick: r, children: /* @__PURE__ */ B.jsx(Ky, {}) })
    }
  ) });
}, xpe = Ue.div`
  display: flex;
  gap: 12px;

  .smv-btn {
    background-color: ${Ht[10]};
    border: none;
  }

  .smv-space-compact {
    max-width: 160px;
    width: 100%;
  }
`, Spe = ({
  statusCount: e,
  onItemsPerPageChange: t,
  onFilterStatusChange: n,
  onDateFilterChange: r,
  onSearch: o,
  onPlanSearch: i,
  itemsPerPage: a,
  filterStatus: s = "",
  search: l,
  searchPlan: u,
  dateFilter: f,
  fieldsFiltered: p,
  selectedArea: h,
  onSaveSelectedArea: y,
  onToggleList: b,
  toggleList: m,
  setSearch: v,
  setOpenFilters: C,
  openFilters: x,
  onOpenPlanSearch: S,
  onClosePlanSearch: E,
  planSearchIsOpen: O = !1,
  setResetPagination: $
}) => {
  if (!p)
    return;
  const _ = ({ target: I }) => {
    n == null || n(I.value);
  }, R = (I) => () => {
    I === "date" && (v == null || v("")), C == null || C(Bt(je({}, og), { [I]: !0 }));
  }, P = () => {
    C == null || C(je({}, og)), v == null || v(""), $ == null || $((I) => !I);
  };
  return /* @__PURE__ */ B.jsxs(
    zc,
    {
      align: "center",
      justify: "space-between",
      "data-testid": "subheader-container",
      children: [
        /* @__PURE__ */ B.jsxs(zc, { gap: 16, align: "center", children: [
          /* @__PURE__ */ B.jsx(
            D3,
            {
              text: "Operations tasks",
              onToggleList: () => b == null ? void 0 : b("operations"),
              isActive: m === "operations"
            }
          ),
          /* @__PURE__ */ B.jsx(
            D3,
            {
              text: "Plans",
              onToggleList: () => b == null ? void 0 : b("plans"),
              isActive: m === "plans"
            }
          )
        ] }),
        m === "plans" && /* @__PURE__ */ B.jsx(
          T3,
          {
            isOpen: O,
            onOpen: S,
            onClose: E,
            onSearch: i,
            search: u
          }
        ),
        m === "operations" && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
          /* @__PURE__ */ B.jsx(
            cpe,
            {
              statusCount: e,
              onSelectChange: _,
              filterStatus: s
            }
          ),
          /* @__PURE__ */ B.jsxs(xpe, { children: [
            /* @__PURE__ */ B.jsx(
              T3,
              {
                isOpen: x == null ? void 0 : x.search,
                onOpen: R("search"),
                onClose: P,
                onSearch: o,
                search: l
              }
            ),
            /* @__PURE__ */ B.jsx(
              xI,
              {
                isOpen: x == null ? void 0 : x.date,
                onOpen: R("date"),
                onClose: P,
                onDateFilterChange: r,
                dateFilter: f
              }
            ),
            /* @__PURE__ */ B.jsx(
              wI,
              {
                selectedArea: h,
                fieldsFiltered: p,
                onSaveSelectedArea: y
              }
            ),
            /* @__PURE__ */ B.jsx(
              tpe,
              {
                onChange: n,
                value: s
              }
            ),
            /* @__PURE__ */ B.jsx(mpe, { onChange: t, value: a })
          ] })
        ] })
      ]
    }
  );
}, M3 = () => /* @__PURE__ */ B.jsxs(
  "svg",
  {
    width: "285",
    height: "143",
    viewBox: "0 0 285 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M31.3432 122.175C18.9785 111.815 0 120.736 0 141.34L284.927 141.34C286.115 125.916 272.6 105.079 255.059 111.815C242.454 116.656 222.662 123.326 203.262 105.079C192.373 94.8363 182.428 103.714 172.67 109.596C162.912 115.477 154.391 100.906 139.463 109.596C119.334 121.312 113.583 106.347 100.356 109.596C90.6633 111.976 87.3819 127.83 67.2873 118.146C56.0727 112.742 44.6636 133.336 31.3432 122.175Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ B.jsxs("g", { opacity: "0.6", children: [
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "42.4871",
            y: "64.7256",
            width: "5.17492",
            height: "71.1546",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "216.364",
            y: "64.7256",
            width: "5.17493",
            height: "71.1546",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "129.007",
            y: "68.6884",
            width: "4.60739",
            height: "71.3302",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "59.238",
            y: "68.6884",
            width: "3.94919",
            height: "69.3488",
            rx: "0.875783",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "129.007",
            y: "74.6326",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "129.007",
            y: "88.5023",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "130.042",
            y: "102",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "130.042",
            y: "116.231",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "130.042",
            y: "129.367",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "44.7576",
            y: "73.3666",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "44.7576",
            y: "87.2364",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            width: "103.56",
            height: "5.36175",
            rx: "1",
            transform: "matrix(0.853455 0.521166 -0.479128 0.877745 131.995 75.5595)",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "45.7925",
            y: "100.734",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "45.7925",
            y: "114.965",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "45.7925",
            y: "128.101",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            d: "M18.4629 135.708C18.6518 135.508 18.9144 135.395 19.1891 135.395H47.0486C47.6009 135.395 48.0486 135.843 48.0486 136.395V141C48.0486 141.552 47.6009 142 47.0486 142H14.8297C13.9519 142 13.5 140.95 14.1035 140.312L18.4629 135.708Z",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            d: "M215.889 136.395C215.889 135.843 216.337 135.395 216.889 135.395H248.353C248.637 135.395 248.907 135.516 249.097 135.728L253.227 140.332C253.805 140.976 253.348 142 252.483 142H216.889C216.337 142 215.889 141.552 215.889 141V136.395Z",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            width: "55.0488",
            height: "2.93604",
            rx: "1",
            transform: "matrix(0.221648 0.975127 -0.963581 0.267418 48.0576 76.8365)",
            fill: "#C2C7D0"
          }
        )
      ] }),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M37.1996 129.5C38.4117 133.686 38.563 138.784 38.5069 139.92C37.7653 140.336 37.3535 140.218 37.3535 140.218C37.3535 140.218 37.5216 136.813 37.0315 132.906C36.539 128.98 35.1434 124.449 34.048 121.703C33.7816 121.096 33.648 120.787 33.7496 120.982C33.8458 121.205 33.9456 121.446 34.048 121.703C34.8094 123.44 36.6559 127.622 37.1996 129.5Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M40.0358 129.312C40.2612 133.583 39.1242 138.319 38.7754 139.341C37.8794 139.462 37.4707 139.208 37.4707 139.208C37.4707 139.208 38.5169 136.14 38.9896 132.379C39.4644 128.601 39.1315 123.947 38.6638 121.038C38.5348 120.386 38.471 120.056 38.5297 120.27C38.5752 120.509 38.6201 120.766 38.6638 121.038C39.0327 122.902 39.9346 127.395 40.0358 129.312Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M36.2214 129.602C37.8517 133.555 38.3513 138.4 38.3619 139.48C37.5569 139.893 37.0874 139.791 37.0874 139.791C37.0874 139.791 37.0557 136.549 36.2531 132.844C35.4468 129.123 33.5881 124.846 32.1818 122.26C31.8437 121.688 31.674 121.398 31.8004 121.58C31.9228 121.791 32.0503 122.018 32.1818 122.26C33.1483 123.894 35.4899 127.829 36.2214 129.602Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M38.5062 129.986C39.0527 134.228 38.2756 139.036 38.0049 140.082C37.1205 140.27 36.6939 140.048 36.6939 140.048C36.6939 140.048 37.506 136.91 37.694 133.124C37.8829 129.32 37.2004 124.705 36.515 121.84C36.3372 121.199 36.2487 120.875 36.3233 121.084C36.3868 121.319 36.4509 121.572 36.515 121.84C37.0232 123.67 38.261 128.082 38.5062 129.986Z",
          fill: "#009933"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M39.7306 129.144C38.3397 133.445 37.9895 138.515 38.0026 139.633C38.7389 139.951 39.1611 139.782 39.1611 139.782C39.1611 139.782 39.122 136.43 39.7699 132.497C40.4208 128.546 42.0114 123.879 43.2284 121.019C43.5221 120.384 43.6695 120.061 43.559 120.267C43.4528 120.5 43.3422 120.752 43.2284 121.019C42.389 122.837 40.3547 127.215 39.7306 129.144Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M31.1135 141.976L34.3729 141.971C36.3948 141.969 37.9416 139.972 37.2357 138.078C36.402 135.84 35.1892 133.839 33.1049 134.097C31.4933 134.296 29.8987 136.206 28.7084 138.238C27.6785 139.996 29.0759 141.978 31.1135 141.976Z",
          fill: "#A3A9B9"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M46.2924 141.866L40.5382 141.862C38.2835 141.86 36.5991 139.302 38.0403 137.568C39.1427 136.242 40.6597 135.253 42.9261 135.42C44.7798 135.556 46.6172 136.672 48.1265 138.006C49.8314 139.514 48.5681 141.868 46.2924 141.866Z",
          fill: "#696F88"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M34.7207 141.996L37.7733 141.994C40.0402 141.992 41.7917 139.295 40.07 137.821C39.2219 137.094 38.1253 136.625 36.6471 136.731C35.388 136.822 34.1378 137.441 33.0367 138.256C31.197 139.616 32.4325 141.998 34.7207 141.996Z",
          fill: "#4D5165"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M220.837 129.5C222.049 133.686 222.201 138.784 222.145 139.92C221.403 140.336 220.991 140.218 220.991 140.218C220.991 140.218 221.159 136.813 220.669 132.906C220.177 128.98 218.781 124.449 217.686 121.703C217.419 121.096 217.286 120.787 217.387 120.982C217.483 121.205 217.583 121.446 217.686 121.703C218.447 123.44 220.294 127.622 220.837 129.5Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M221.873 129.312C222.099 133.583 220.962 138.319 220.613 139.341C219.717 139.462 219.308 139.208 219.308 139.208C219.308 139.208 220.354 136.14 220.827 132.379C221.302 128.601 220.969 123.947 220.501 121.038C220.372 120.386 220.308 120.056 220.367 120.27C220.413 120.509 220.458 120.766 220.501 121.038C220.87 122.902 221.772 127.395 221.873 129.312Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M219.259 129.719C220.889 133.671 221.389 138.516 221.399 139.597C220.595 140.01 220.125 139.907 220.125 139.907C220.125 139.907 220.093 136.665 219.291 132.961C218.484 129.24 216.626 124.962 215.219 122.376C214.881 121.804 214.712 121.514 214.838 121.697C214.96 121.907 215.088 122.134 215.219 122.376C216.186 124.01 218.528 127.945 219.259 129.719Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M223.368 129.144C221.977 133.445 221.627 138.515 221.64 139.633C222.377 139.951 222.799 139.782 222.799 139.782C222.799 139.782 222.76 136.43 223.408 132.497C224.058 128.546 225.649 123.879 226.866 121.019C227.16 120.384 227.307 120.061 227.197 120.267C227.09 120.5 226.98 120.752 226.866 121.019C226.027 122.837 223.992 127.215 223.368 129.144Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M217.957 141.762L214.697 141.758C212.675 141.755 211.128 139.759 211.834 137.864C212.668 135.627 213.881 133.626 215.965 133.883C217.577 134.082 219.171 135.992 220.362 138.024C221.392 139.782 219.994 141.765 217.957 141.762Z",
          fill: "#A3A9B9"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M229.93 141.866L224.176 141.862C221.921 141.86 220.237 139.302 221.678 137.568C222.78 136.242 224.297 135.253 226.564 135.42C228.417 135.556 230.255 136.672 231.764 138.006C233.469 139.514 232.206 141.868 229.93 141.866Z",
          fill: "#696F88"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.1",
          d: "M254.01 38.9674H211.72C210.577 37.8186 211.719 34.9452 214.577 34.9446C217.435 34.9441 216.034 31.9782 219.72 29.1982C224.292 25.75 230.008 29.1983 231.722 31.497C233.437 33.7957 236.037 29.863 239.723 30.9224C243.151 31.9079 242.953 35.7141 244.866 34.9446C250.581 32.6464 254.582 38.9679 254.01 38.9674Z",
          fill: "#868CA2"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M193.556 46.2325H229.341C230.308 45.2864 229.341 42.9201 226.923 42.9197C224.505 42.9192 225.69 40.4768 222.571 38.1873C218.702 35.3476 213.866 38.1874 212.416 40.0804C210.965 41.9735 208.765 38.7347 205.646 39.6072C202.744 40.4189 202.912 43.5533 201.293 42.9197C196.458 41.027 193.073 46.233 193.556 46.2325Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.1",
          d: "M98.1175 9.90698H133.902C134.869 8.8933 133.902 6.35793 131.484 6.35747C129.066 6.357 130.251 3.74007 127.132 1.28712C123.264 -1.75544 118.428 1.28716 116.977 3.31545C115.526 5.34374 113.326 1.87363 110.207 2.80842C107.306 3.67804 107.474 7.03639 105.855 6.35747C101.019 4.32964 97.6339 9.90744 98.1175 9.90698Z",
          fill: "#868CA2"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.1",
          d: "M19.1512 53.4977H68.5987C69.935 52.1461 68.5992 48.7656 65.2577 48.765C61.9166 48.7644 63.5541 45.2752 59.2443 42.0045C53.8986 37.9478 47.216 42.0046 45.2114 44.709C43.2068 47.4134 40.1667 42.7866 35.857 44.033C31.8477 45.1924 32.0796 49.6702 29.8426 48.765C23.161 46.0612 18.483 53.4983 19.1512 53.4977Z",
          fill: "#868CA2"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M85.9198 45.1478C86.4843 44.9802 88.2623 43.8321 88.0635 43.2707C87.8647 42.7094 86.6517 43.6899 86.3693 43.7737C86.087 43.8575 86.1547 42.2866 86.6201 41.8383C87.0854 41.39 88.4654 41.3151 88.5489 40.67C88.6325 40.0248 86.9385 40.5279 86.2822 40.8778C85.626 41.2277 84.7191 41.317 84.2537 41.7653C83.7884 42.2136 83.3309 43.1248 82.8656 43.5731C82.4933 43.9318 81.841 44.4978 81.4697 44.9182L81.0044 45.3665L82.9133 46.3507L82.9403 46.3646C82.945 46.4084 82.9011 46.5197 83.1039 46.449C83.9352 45.2717 85.355 45.3155 85.9198 45.1478Z",
          fill: "#DFE2E7"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M82.9133 46.3507C82.9956 46.3223 82.8384 46.5415 83.1039 46.449M83.1039 46.449C83.9352 45.2717 85.355 45.3155 85.9198 45.1478C86.4843 44.9802 88.2623 43.8321 88.0635 43.2707C87.8647 42.7094 86.6517 43.6899 86.3693 43.7737C86.087 43.8575 86.1547 42.2866 86.6201 41.8383C87.0854 41.39 88.4654 41.3151 88.5489 40.67C88.6325 40.0248 86.9385 40.5279 86.2822 40.8778C85.626 41.2277 84.7191 41.317 84.2537 41.7653C83.7884 42.2136 83.3309 43.1248 82.8656 43.5731C82.4933 43.9318 81.841 44.4978 81.4697 44.9182L81.0044 45.3665L83.1039 46.449Z",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M100.911 49.6143C99.7013 50.8057 99.0424 52.8279 99.4216 54.0755C96.7551 56.6204 92.8203 54.248 93.2275 53.4829C93.5121 52.9482 95.2088 49.9268 94.0052 48.4452C92.8015 46.9635 92.5006 46.6672 92.5006 46.6672C91.9319 46.9345 92.9079 46.183 92.2254 45.5414C91.941 45.274 91.3548 44.1425 91.6392 43.3406C91.8986 42.609 91.9877 41.7675 92.5006 42.2222L93.2275 41.9258C92.9369 34.0646 103.364 36.8881 102.327 43.3407C102.327 43.3407 103.648 43.3571 103.364 44.9612C103.214 45.8051 102.991 48.1455 102.327 48.0564C101.569 49.0367 102.416 48.1326 100.911 49.6143Z",
          fill: "#DFE2E7",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M95.6535 41.8235C98.73 41.8235 100.03 39.4991 100.03 40.2511C100.03 40.5778 99.665 41.201 100.911 42.1358C101.743 42.7592 102.469 44.9401 102.157 45.8749C101.846 46.8097 101.315 48.6342 100.03 49.9256C99.2372 50.7219 99.0217 52.0825 99.0217 53.3534C99.0217 54.023 99.3575 53.5791 99.9763 53.9766C100.595 54.374 100.907 53.7739 102.157 54.2882C103.627 54.8927 103.498 54.5587 105.273 55.2229C106.245 55.5865 105.316 53.1462 104.763 52.0825C104.21 51.0187 103.588 50.2707 104.763 48.3678C105.937 46.4649 104.594 44.5536 104.339 42.7592C104.175 41.6095 103.336 40.2392 102.785 39.338L102.781 39.3317C101.827 37.7735 100.911 36.8912 99.0217 36.8385C98.4186 36.8216 95.6656 36.4957 94.0561 37.4616C92.4983 38.3963 92.984 38.0952 91.8751 39.3317C90.7663 40.5681 89.7638 43.4049 90.6286 45.4787C91.1441 46.7149 89.2883 47.6336 90.1531 49.7075C90.8738 51.4357 89.4621 52.0959 89.0706 52.7302C88.6791 53.3645 89.9157 53.2465 91.2518 53.0418C92.5878 52.8371 93.3388 53.9556 94.0561 53.3534C94.7734 52.7512 95.1299 51.592 94.9909 50.8597C94.678 49.2112 94.3532 46.0824 92.8841 45.4787C92.1946 45.1954 92.4449 42.8539 93.2956 43.375C94.318 44.0014 92.8366 41.8235 95.6535 41.8235Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M111.158 83.3283C112.832 79.3693 115.244 73.5982 115.244 71.7373C115.244 69.4113 111.479 63.9693 110.938 62.9355C110.397 61.9017 106.188 56.7047 104.962 55.5346C102.525 53.2085 102.275 54.1482 100.38 53.8897C100.277 53.8757 100.103 53.8535 99.8751 53.8255C95.595 56.1179 94.3267 53.1762 93.6187 53.1762C92.8066 53.1762 91.7175 53.1144 90.9054 53.1144C90.0933 53.1144 89.4073 53.5737 87.8243 53.8255C85.6263 54.1751 79.0179 54.5998 78.4765 54.5998C78.0434 54.5998 82.969 48.4488 84.0852 46.1865C84.0852 46.1865 83.462 45.8749 82.8388 45.2517C82.0731 44.486 82.0014 44.3303 81.4433 44.3303C80.8658 44.3303 73.1795 54.2882 73.1795 57.0925C73.1795 58.9017 76.4054 59.6009 77.5417 59.6009H85.3315C86.9874 59.6009 88.7591 61.0973 88.7591 62.3896C88.7591 63.1649 88.1359 66.9113 88.1359 67.6866V67.7007C88.1358 68.5218 88.1351 73.5927 90.9054 77.6576C92.7788 80.4065 90.5384 81.5231 90.6286 82.6431L103.715 82.0199C103.806 79.2631 101.223 75.0826 101.223 74.0488C101.223 71.9812 104.027 63.301 104.027 62.9355C104.027 62.677 106.214 65.32 106.52 65.8171C107.286 67.0635 109.923 69.9741 110.464 70.491C111.005 71.0079 110.527 73.7093 110.464 74.0488C109.923 76.9551 109.514 77.2007 108.772 79.4065C108.618 79.8662 107.79 80.9364 107.7 81.3672L111.158 83.3283Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M100.38 53.8897C102.275 54.1482 102.525 53.2085 104.962 55.5346C106.188 56.7047 110.397 61.9017 110.938 62.9355C111.479 63.9693 115.244 69.4113 115.244 71.7373C115.244 73.5982 112.832 79.3693 111.158 83.3283L107.7 81.3672C107.79 80.9364 108.618 79.8662 108.772 79.4065C109.514 77.2007 109.923 76.9551 110.464 74.0488C110.527 73.7093 111.005 71.0079 110.464 70.491C109.923 69.9741 107.286 67.0635 106.52 65.8171C106.214 65.32 104.027 62.677 104.027 62.9355C104.027 63.301 101.223 71.9812 101.223 74.0488C101.223 75.0826 103.806 79.2631 103.715 82.0199L90.6286 82.6431C90.5384 81.5231 92.7788 80.4065 90.9054 77.6576C88.1188 73.5687 88.1359 68.462 88.1359 67.6866C88.1359 66.9113 88.7591 63.1649 88.7591 62.3896C88.7591 61.0973 86.9874 59.6009 85.3315 59.6009C83.6757 59.6009 79.7792 59.6009 77.5417 59.6009C76.4054 59.6009 73.1795 58.9017 73.1795 57.0925C73.1795 54.2882 80.8658 44.3303 81.4433 44.3303C82.0014 44.3303 82.0731 44.486 82.8388 45.2517C83.462 45.8749 84.0852 46.1865 84.0852 46.1865C82.969 48.4488 78.0434 54.5998 78.4765 54.5998C79.0179 54.5998 85.6263 54.1751 87.8243 53.8255C89.4073 53.5737 90.0933 53.1144 90.9054 53.1144C91.7175 53.1144 92.8066 53.1762 93.6187 53.1762C94.3267 53.1762 95.595 56.1179 99.8751 53.8255M100.38 53.8897C100.277 53.8757 100.103 53.8535 99.8751 53.8255M100.38 53.8897L99.8751 53.8255",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M106.607 125.48C106.184 127.899 105.524 132.2 105.253 134.526L99.2975 134.268V133.234C99.5682 127.031 100.164 114.212 100.38 112.558C100.651 110.49 99.5554 106.145 99.0139 104.594C98.4725 103.043 96.3196 92.9156 95.5075 93.9494C95.0966 94.4724 94.7503 104.012 93.4843 108.959C93.3039 112.75 93.017 119.846 92.8004 122.12C92.5839 124.395 92.1688 131.166 91.9883 134.268H86.5741V133.234C86.3936 126.342 86.0327 112.299 86.0327 111.266C86.0327 109.973 84.6382 101.688 85.3355 92.3705C85.7707 86.5544 89.4827 77.0487 89.4827 76.5318C89.4827 76.1183 88.0504 71.7093 88.0504 68.2244C88.0504 65.6462 88.9098 65.3597 89.1963 63.4523C89.3583 62.3732 89.4619 61.3818 89.5519 60.0924C89.8226 56.2157 89.8226 55.6988 90.0933 53.3727C90.0933 53.3727 90.364 53.1143 91.1762 53.1143C92.0322 53.1143 92.259 53.3727 92.259 53.3727C91.9883 56.7326 92.0924 62.8096 92.6338 63.068C93.8684 63.6574 97.4025 63.4523 99.5682 63.4523C101.734 63.4523 101.463 62.4185 101.463 61.6431C101.463 61.0228 101.192 56.1295 101.192 53.8896C101.463 53.8896 102.275 53.8896 103.087 54.1481C103.448 57.5079 103.519 61.0628 104.17 63.9692C104.514 65.5053 104.982 66.4152 104.982 68.2244C104.982 69.5166 103.519 75.2115 103.519 76.2453C103.519 79.0883 103.358 76.568 104.982 82.5776C106.607 88.5871 106.892 92.8289 107.163 95.2809C107.37 97.1579 109.314 111.524 109.314 113.075C109.314 114.625 107.148 122.379 106.607 125.48Z",
          fill: "#00004B",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M106.677 133.803C106.858 131.933 107.044 129.906 107.228 128.29C107.268 127.943 106.997 127.637 106.647 127.637H99.1607C98.8214 127.637 98.5539 127.924 98.5818 128.262C98.8359 131.34 99.4508 137.961 99.4508 138.36V141.845H101.336L101.949 140.619L103.221 141.845H113.275C113.38 141.667 113.526 140.736 113.275 140.093C112.961 139.289 107.305 138.36 106.677 137.824C106.049 137.288 106.527 135.35 106.677 133.803Z",
          fill: "white",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "rect",
        {
          width: "10.6303",
          height: "1.01489",
          transform: "matrix(-1 0 0 1 113.414 140.831)",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M92.5955 140.479C92.5955 140.066 92.5955 132.385 93.1184 128.312C93.1641 127.956 92.8902 127.637 92.5316 127.637H86.4055C86.0655 127.637 85.7978 127.926 85.8267 128.265C86.0436 130.807 86.3945 134.336 86.3945 135.561V135.561C86.3945 136.927 86.3945 140.752 86.7045 141.845H92.5955V140.479Z",
          fill: "white",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "rect",
        {
          width: "5.31516",
          height: "1.01489",
          transform: "matrix(-1 0 0 1 92.1521 140.831)",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "rect",
        {
          width: "2.12606",
          height: "1.01489",
          transform: "matrix(-1 0 0 1 101.721 140.831)",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M106.224 83.1883C106.545 82.5393 107.22 81.3874 107.701 81.2566L111.247 83.1883C111.263 83.4885 111.426 85.3686 111.141 85.8845C110.131 87.7129 107.899 87.1473 107.341 86.5817C106.925 86.1607 105.666 84.3194 106.224 83.1883Z",
          fill: "#DFE2E7",
          stroke: "#00004B",
          strokeWidth: "0.582063"
        }
      )
    ]
  }
), wpe = () => {
  const t = btoa(`
    <svg
      width="168"
      height="115"
      viewBox="0 0 168 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="No items found image"
    >
      <path
        d="M108.216 78.6464L113.662 85.383H65.5367L60.0995 78.6449L108.216 78.6464Z"
        fill="white"
      />
      <path
        d="M108.216 78.6463L124.18 72.1379V24.7034L107.901 31.2738H60.0994L43.8195 24.7019V72.1394L60.0994 78.6463H108.216Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.869 78.0417H88.4425L95.1649 85.9891H86.5914L79.869 78.0417ZM82.4785 79.2509L87.1552 84.7799H92.5555L87.8787 79.2509H82.4785Z"
        fill="#73DC78"
      />
      <path
        d="M108.217 37.9667H66.4889V78.6464H108.217V37.9667Z"
        fill="#DFE2E7"
      />
      <path
        d="M114.06 76.2643V85.383H113.662L108.216 78.6464L114.06 76.2643Z"
        fill="#DFE2E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.213 23.8048L60.2176 30.6692H107.782L124.787 23.8064V72.5439L114.666 76.67V85.9875H65.2462L59.7282 79.1493L43.213 72.5484V23.8048ZM61.3669 79.2509L65.8272 84.7784H112.395L107.926 79.2509L61.3669 79.2509ZM109.199 78.8988L113.453 84.1606V77.1647L109.199 78.8988ZM107.611 78.0417V38.5712L67.0954 38.5712L67.0954 78.0404L107.611 78.0417ZM65.8824 78.0404L65.8824 38.2083L60.7059 32.7861V78.0402L65.8824 78.0404ZM59.4929 31.6812V77.7525L44.426 71.7305V25.599L59.4929 31.6812ZM61.5139 31.8784L66.749 37.362L107.611 37.362V31.8784H61.5139ZM108.824 31.5534V77.7453L123.574 71.732V25.6005L108.824 31.5534Z"
       fill="#00004B"
      />
    </svg>`);
  return /* @__PURE__ */ B.jsx(
    "img",
    {
      src: `data:image/svg+xml;base64,${t}`,
      alt: "No items found image",
      id: "no-items-found-image",
      width: "18",
      height: "18"
    }
  );
}, Epe = Ue.div`
  max-width: 500px;
  padding: 12px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`, $pe = Ue.div`
  margin-top: 8px;
  width: 100%;

  span {
    display: block;
  }
`, Ope = Ue.div`
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`, _pe = Ue.h3`
  font-size: 16px;
`, Uy = ({
  image: e = /* @__PURE__ */ B.jsx(wpe, {}),
  title: t,
  description: n,
  children: r,
  marginTop: o = "50px"
}) => {
  const { t: i } = oo(), a = Array.isArray(n);
  return /* @__PURE__ */ B.jsxs(Epe, { style: { marginTop: o != null ? o : 0 }, children: [
    e,
    /* @__PURE__ */ B.jsx(_pe, { children: i(t) }),
    n && /* @__PURE__ */ B.jsx($pe, { children: a ? n.map((s) => /* @__PURE__ */ B.jsx(Ps.Text, { children: i(s) }, `desc-${s}`)) : /* @__PURE__ */ B.jsx(Ps.Text, { children: i(n) }) }),
    r && /* @__PURE__ */ B.jsx(Ope, { children: r })
  ] });
}, Npe = [
  "operationInfo.planName",
  "operationInfo.operationName",
  "region.fieldName",
  "region.propertyName",
  "criteria"
], L3 = "smart-event-calendar_selected-area", Ppe = () => {
  var Ve;
  const { t: e } = oo(), t = Ya(), n = Cn(Si), { org: r, cropCycle: o, unitSystem: i } = (Ve = n.rulesInformation) != null ? Ve : {}, [a, s] = Ot(), [l, u] = Ot([]), [f, p] = Ot({
    planned: 0,
    delayed: 0,
    completed: 0
  }), [h, y] = Ot(25), [b, m] = Ot(""), [v, C] = Ot(""), x = Ude(v, 500), [S, E] = Ot(
    jfe()
  ), [O, $] = Ot(), [_, R] = Ot(), [P, I] = Ot(), [j, F] = Ot(), [A, M] = Ot(() => {
    var Ae;
    try {
      const ft = (Ae = localStorage.getItem(L3)) != null ? Ae : "[]";
      return JSON.parse(ft);
    } catch (ft) {
      return [];
    }
  }), [N, D] = Ot(!0), [T, L] = Ot([]), [z, H] = Ot([]), [V, Y] = Ot("operations"), [Z, oe] = Ot(""), [ee, ae] = Ot(!1), [le, ue] = Ot(je({}, og)), [ie, re] = Ot(""), [Q, ce] = Ot(""), [ge, G] = Ot(!1), [ne, fe] = Ot(!1), ye = Gde(S), we = JSON.stringify(ye) !== JSON.stringify(S), [he, me] = Ot(!1), Ce = ar((Ae) => an(void 0, null, function* () {
    const {
      data: { content: ft }
    } = yield rg({
      id: Ae
    });
    $(ft);
  }), []), Te = ar((Ae) => an(void 0, null, function* () {
    var _e;
    const He = (yield cI(Ae)).data.content, Fe = He.some(
      (Ze) => Ze.active && !Ze.deleted
    ), Qe = He.filter(
      (Ze) => !Ze.deleted && (Fe ? Ze.active : !0)
    ).map((Ze) => Ze.id), tt = Vfe(Qe, 8), lt = yield rg({ id: Ae }), ht = (_e = lt == null ? void 0 : lt.data) == null ? void 0 : _e.content.map(
      (Ze) => Ze.id
    ), bt = 99, ct = [];
    for (let Ze = 0; Ze < ht.length; Ze += bt)
      ct.push(ht.slice(Ze, Ze + bt));
    const vt = (yield Promise.all(
      ct.map((Ze) => zy(Ze))
    )).flatMap((Ze) => Ze.data.content).map((Ze) => Ze.id);
    for (const Ze of tt)
      try {
        const q = yield Promise.allSettled(Ze.map(sI));
        I((Se = []) => {
          const Re = Se != null ? Se : [], ut = new Set(
            Re.map((Ne) => Ne.field_id)
          ), $t = q.flatMap(
            ({ value: Ne }) => Ne.data.content
          ).filter((Ne) => vt.includes(Ne.field_id));
          return console.log("groupedResult", $t), [
            ...Se,
            ...$t.filter(
              (Ne) => !ut.has(Ne.field_id)
            )
          ];
        });
      } catch (q) {
        console.error("Error fetching data:", q);
      }
  }), []), Ee = ar(() => an(void 0, null, function* () {
    if (P) {
      const Ae = yield lI(P);
      F(Ae);
    }
  }), [P]);
  kt(() => {
    r && !O && !_ && an(void 0, null, function* () {
      try {
        yield Ce(r), yield Te(r);
      } catch (ft) {
        console.error("Error fetching data:", ft);
      }
    }).catch((ft) => {
      console.error("Unhandled error:", ft);
    });
  }, [
    O,
    _,
    r,
    Ce,
    Te
  ]), kt(() => {
    if (!P)
      return;
    an(void 0, null, function* () {
      try {
        yield Ee();
      } catch (ft) {
        console.error("Error fetching fields:", ft);
      }
    });
  }, [Ee, P]), kt(() => {
    j && O && R(Hfe(j, O));
  }, [j, O]);
  const Ge = _t(ne);
  kt(() => {
    Ge.current = ne;
  }, [ne]), kt(() => {
    if (!r || Ge.current || !P || !O || !j)
      return;
    we && (re(""), s([])), fe(!0);
    const Ae = () => an(void 0, null, function* () {
      var Fe, yt, Qe, tt;
      const He = {
        org_id: r,
        seasons_ids: o,
        filtering_by: "ORDER",
        reference_window_start: S[0],
        reference_window_end: S[1],
        sort: "ASC",
        statuses: ["PLANNED", "IN_PROGRESS", "COMPLETED"],
        source: "50524f54-4543-544f-5226-434149554249"
      };
      D(!0);
      try {
        const lt = yield $de(He, r, ie), ht = Array.from(
          new Set(
            lt.data.content.flatMap(
              (Ne) => Ne.properties_ids
            )
          )
        ), bt = yield ft(), ct = ht.reduce(
          (Ne, Ie) => {
            const De = bt;
            return Bt(je({}, Ne), {
              [Ie]: De.content.filter(
                ({ property_ids: Me }) => Me.includes(Ie)
              )
            });
          },
          {}
        ), xt = Rt({ list: lt.data.content }), vt = Le({
          list: lt.data.content
        }), _e = {
          content: []
        };
        if (xt.length > 0 && vt.length > 0)
          for (let Ie = 0; Ie < vt.length; Ie += 99) {
            const De = vt.slice(Ie, Ie + 99), Me = yield Pde(
              xt,
              De
            );
            _e.content = _e.content.concat(
              Me.content
            );
          }
        const Ze = Array.from(
          new Set(
            (yt = (Fe = _e == null ? void 0 : _e.content) == null ? void 0 : Fe.map(
              (Ne) => Ne.property_id
            )) != null ? yt : []
          )
        ), q = 99, Se = [];
        for (let Ne = 0; Ne < Ze.length; Ne += q)
          Se.push(Ze.slice(Ne, Ne + q));
        const ut = {
          data: {
            content: (yield Promise.all(
              Se.map((Ne) => zy(Ne))
            )).flatMap(
              (Ne) => Ne.data.content
            )
          }
        }, $t = (tt = Bfe(
          lt.data.content,
          ct,
          P,
          O,
          (Qe = ut.data.content) != null ? Qe : []
        )) != null ? tt : [];
        s((Ne) => {
          const Ie = Ne != null ? Ne : [], De = new Set(Ie.map((Tt) => Tt.id)), Me = $t.filter(
            (Tt) => !De.has(Tt.id)
          );
          return [...Ie, ...Me];
        }), ce(lt.data.cursor || ""), G(lt.data.is_last), D(!1), fe(!1);
      } catch (lt) {
        console.error("Error fetching data:", lt);
      }
    }), ft = () => an(void 0, null, function* () {
      const He = {
        property_ids: P.map((yt) => yt.property_id),
        only_accounts_workers: !1
      }, { data: Fe } = yield uI(r, He);
      return Fe;
    });
    Ae();
  }, [
    S,
    j,
    P,
    O,
    o,
    r,
    ie,
    we
  ]);
  const ke = () => {
    re(Q);
  };
  kt(() => {
    const Ae = Ffe(a);
    p(Ae);
  }, [a]), kt(() => {
    var He;
    let Ae = (He = a == null ? void 0 : a.filter((Fe) => bI(Fe, b))) != null ? He : [];
    if (Ae = Ae.filter((Fe) => A.length > 0 && Fe.region ? A.includes(Fe.region.fieldId) || A.includes(Fe.region.propertyId) : !0), !x) {
      u(Ae || []);
      return;
    }
    const ft = Ae.filter((Fe) => Npe.some((yt) => {
      const Qe = yt.split(".");
      let tt = Fe;
      for (const lt of Qe) {
        if (typeof tt == "object" && tt !== null && !Array.isArray(tt) && !Object.prototype.hasOwnProperty.call(tt, lt) || !tt)
          break;
        tt = tt[lt];
      }
      return typeof tt == "string" ? tt.toLowerCase().includes(x.toLowerCase()) : !1;
    }));
    u(ft);
  }, [
    a,
    u,
    x,
    b,
    A
  ]), kt(() => {
    Et(A);
  }, [A]), kt(() => {
    oe(""), ae(!1);
  }, [V]);
  const qe = () => {
    me((Ae) => !Ae);
  }, ze = ar(
    (Ae) => {
      y(Ae);
    },
    [y]
  ), pt = ar(
    (Ae) => {
      C(""), ue(Bt(je({}, og), { search: !1 })), m(Ae), qe();
    },
    [m]
  ), Ke = (Ae) => {
    E(Ae), re("");
  }, et = (Ae) => {
    qe(), C(Ae.target.value);
  }, Je = (Ae) => {
    Ede(Ae).then(() => {
      s(
        (ft) => ft == null ? void 0 : ft.filter((He) => He.id !== Ae)
      );
    }).catch((ft) => {
      console.error("Error deleting task:", ft);
    });
  }, Et = (Ae) => {
    const ft = JSON.stringify(Ae);
    localStorage.setItem(L3, ft);
  }, Ye = (Ae) => {
    M(Ae), qe();
  };
  kt(() => {
    an(void 0, null, function* () {
      if (!(!o || !r))
        try {
          const He = (yield Promise.allSettled(
            o.map((Fe) => _de(r, Fe))
          )).filter(({ status: Fe }) => Fe === "fulfilled").flatMap(
            ({ value: Fe }) => Fe.data.content
          );
          L(He);
        } catch (ft) {
          console.error("Error fetching data:", ft);
        }
    });
  }, [o, r]), kt(() => {
    if (!Z.length) {
      H(T);
      return;
    }
    const Ae = T.filter(
      (ft) => ft.plan_name.toLowerCase().includes(Z.toLowerCase())
    );
    H(Ae);
  }, [Z, T]);
  const wt = (Ae) => {
    r && (Ce(r), Te(r), L((ft) => ft.filter((He) => He.id !== Ae)), s((ft) => ft == null ? void 0 : ft.filter((He) => He.planId.id !== Ae)));
  }, dt = (Ae) => {
    Y(Ae);
  }, Ct = ({ target: Ae }) => {
    oe(Ae.value);
  }, ot = () => {
    ae(!0);
  }, jt = () => {
    ae(!1), oe("");
  }, Rt = (Ae) => {
    if (!(Ae != null && Ae.list) || !Array.isArray(Ae.list))
      return [];
    const ft = Ae.list.reduce((He, Fe) => Fe.seasons_ids && Array.isArray(Fe.seasons_ids) ? [...He, ...Fe.seasons_ids] : He, []);
    return [...new Set(ft)];
  }, Le = (Ae) => {
    if (!(Ae != null && Ae.list) || !Array.isArray(Ae.list))
      return [];
    const ft = Ae.list.reduce((He, Fe) => Fe.properties_ids && Array.isArray(Fe.properties_ids) ? [...He, ...Fe.properties_ids] : He, []);
    return [...new Set(ft)];
  };
  return /* @__PURE__ */ B.jsxs(Wde, { children: [
    /* @__PURE__ */ B.jsx(
      Spe,
      {
        statusCount: f,
        itemsPerPage: h,
        filterStatus: b,
        onItemsPerPageChange: ze,
        onFilterStatusChange: pt,
        onDateFilterChange: Ke,
        onSearch: et,
        onPlanSearch: Ct,
        search: v,
        searchPlan: Z,
        onOpenPlanSearch: ot,
        onClosePlanSearch: jt,
        planSearchIsOpen: ee,
        dateFilter: S,
        fieldsFiltered: _,
        selectedArea: A,
        onSaveSelectedArea: Ye,
        onToggleList: dt,
        toggleList: V,
        setSearch: C,
        setOpenFilters: ue,
        openFilters: le,
        setResetPagination: me
      }
    ),
    /* @__PURE__ */ B.jsx(Kde, { children: V === "operations" ? /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
      N && /* @__PURE__ */ B.jsx(af, { size: "large", spinning: N, fullscreen: !0 }),
      !(a != null && a.length) && !N ? /* @__PURE__ */ B.jsx(
        Uy,
        {
          marginTop: "0px",
          image: /* @__PURE__ */ B.jsx(M3, {}),
          title: e("sections.smart_calendar.empty_state_title"),
          description: e(
            "sections.smart_calendar.empty_state_description"
          ),
          children: /* @__PURE__ */ B.jsxs($3, { onClick: () => t("/create-plan"), children: [
            /* @__PURE__ */ B.jsx(kh, {}),
            e("sections.smart_calendar.button_link_text")
          ] })
        }
      ) : /* @__PURE__ */ B.jsx(
        Efe,
        {
          workOrderList: l,
          itemsPerPage: h,
          onDeleteTask: Je,
          listSeasonFields: P,
          unitSystem: i != null ? i : "metric",
          isLastPage: ge,
          loadMoreData: ke,
          resetPagination: he,
          setResetPagination: me
        }
      )
    ] }) : /* @__PURE__ */ B.jsx(B.Fragment, { children: T.length ? /* @__PURE__ */ B.jsx(Qfe, { list: z, onDeletePlan: wt }) : /* @__PURE__ */ B.jsx(
      Uy,
      {
        marginTop: "0px",
        image: /* @__PURE__ */ B.jsx(M3, {}),
        title: "No plans were created for this organization",
        description: "Click the below to create your first plan",
        children: /* @__PURE__ */ B.jsxs($3, { onClick: () => t("/create-plan"), children: [
          /* @__PURE__ */ B.jsx(kh, {}),
          "Create plan"
        ] })
      }
    ) }) })
  ] });
}, Ipe = (e, t) => {
  const n = qa(), [r, o] = Ot(!1), i = (a) => {
    const s = qr(a);
    return s.isValid() ? s : void 0;
  };
  kt(() => {
    const a = n.state;
    if (!r && (a != null && a.clonedPlan)) {
      const s = a.clonedPlan;
      e.setFieldsValue({
        plan_name: "",
        start_date: i(s.start_date),
        seasons_ids: s.seasons_ids
      }), t.setFormData((l) => Bt(je({}, l), {
        create_plan: Bt(je({}, s), {
          plan_name: "",
          start_date: i(s.start_date),
          seasons_ids: s.seasons_ids[0],
          plan_operations: s.plan_operations.map((u) => Bt(je({}, u), {
            task_type: u.type === Cr.PLANTING ? u.planting_type : u.type
          }))
        })
      })), o(!0);
    }
  }, [r, n.state, e, t]);
}, Rpe = (e) => {
  const [t, n] = Ot([]);
  return kt(() => {
    an(void 0, null, function* () {
      if (!e)
        return;
      const i = (yield cI(e)).data.content.filter(
        (a) => a.active && !a.deleted
      );
      n(i);
    });
  }, [e]), { seasons: t };
}, Dpe = (e, t, n) => {
  const r = Ya();
  return { handleNextStep: () => {
    var u;
    const { plan_name: a, seasons_ids: s, start_date: l } = e.getFieldsValue();
    if (a && s && l) {
      const f = (u = n.find(
        (p) => p.id === s
      )) == null ? void 0 : u.crop_id;
      t.setFormData((p) => Bt(je({}, p), {
        create_plan: Bt(je({}, p.create_plan), {
          plan_name: a,
          seasons_ids: s,
          start_date: l,
          crop_id: f
        })
      })), r(`/create-plan/${s}/fields`);
    }
  }, handlePreviousStep: () => {
    r("/"), t.setFormData((a) => Bt(je({}, a), {
      create_plan: {}
    }));
  } };
}, Tpe = () => /* @__PURE__ */ B.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ B.jsxs("g", { clipPath: "url(#clip0_9494_147767)", children: [
        /* @__PURE__ */ B.jsx("rect", { width: "32", height: "32", rx: "4", fill: "#DFFBE8" }),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.25 11.1305L18.25 11.125L18.25 11.1195C18.25 9.83966 17.4332 8.68741 16.4459 7.92253C16.2806 7.77076 15.9374 7.62517 15.5533 7.9231C14.5666 8.68854 13.75 9.83953 13.75 11.1195L13.75 11.125L13.75 11.1305C13.75 11.4945 13.816 11.848 13.9332 12.1852C13.1534 11.8854 12.2714 11.8195 11.4537 11.9168C10.9484 11.977 10.8044 12.3369 10.7959 12.5711C10.6639 13.6657 10.8291 14.8771 11.4627 15.8005C11.4597 15.8009 11.4567 15.8012 11.4537 15.8016C10.9484 15.8617 10.8044 16.2217 10.7959 16.4559C10.6399 17.7489 10.8988 19.2049 11.8545 20.1567L11.8586 20.1608L11.8627 20.1649C12.7385 21.0371 14.0394 21.3265 15.25 21.2492V23.5C15.25 23.9142 15.5858 24.25 16 24.25C16.4142 24.25 16.75 23.9142 16.75 23.5V21.249C17.9617 21.3272 19.2647 21.0381 20.1414 20.1649L20.1455 20.1608L20.1497 20.1567C21.1053 19.2049 21.3642 17.7489 21.2082 16.4559C21.1998 16.2217 21.0558 15.8617 20.5504 15.8016C20.5474 15.8012 20.5443 15.8009 20.5413 15.8005C21.1749 14.8771 21.3401 13.6657 21.2081 12.5711C21.1996 12.3369 21.0556 11.977 20.5503 11.9168C19.731 11.8193 18.8471 11.8856 18.0662 12.187C18.1837 11.8492 18.25 11.495 18.25 11.1305ZM16 12.7696C16.4119 12.3208 16.8017 11.7505 16.804 11.125C16.8017 10.4995 16.4119 9.92922 16 9.48039C15.5881 9.92922 15.1983 10.4995 15.196 11.125C15.1983 11.7505 15.5881 12.3208 16 12.7696ZM14.7438 19.7335C14.1053 19.7018 13.3924 19.5636 12.9236 19.1001C12.4582 18.6332 12.3194 17.9233 12.2876 17.2873C12.9262 17.319 13.639 17.4572 14.1078 17.9207C14.5733 18.3876 14.712 19.0975 14.7438 19.7335ZM17.2604 19.7335C17.8989 19.7018 18.6118 19.5636 19.0806 19.1001C19.546 18.6332 19.6847 17.9233 19.7165 17.2873C19.078 17.319 18.3651 17.4572 17.8963 17.9207C17.4309 18.3876 17.2922 19.0975 17.2604 19.7335ZM12.9236 15.2153C13.3924 15.6789 14.1053 15.8171 14.7438 15.8487C14.712 15.2128 14.5733 14.5028 14.1078 14.0359C13.639 13.5724 12.9262 13.4342 12.2876 13.4026C12.3194 14.0385 12.4582 14.7484 12.9236 15.2153ZM19.0804 15.2153C18.6116 15.6789 17.8987 15.8171 17.2602 15.8487C17.292 15.2128 17.4307 14.5028 17.8962 14.0359C18.365 13.5724 19.0778 13.4342 19.7164 13.4026C19.6846 14.0385 19.5458 14.7484 19.0804 15.2153Z",
            fill: "#14803C"
          }
        )
      ] }),
      /* @__PURE__ */ B.jsx("defs", { children: /* @__PURE__ */ B.jsx("clipPath", { id: "clip0_9494_147767", children: /* @__PURE__ */ B.jsx("rect", { width: "32", height: "32", rx: "8", fill: "white" }) }) })
    ]
  }
);
function Mpe(e, t) {
  const n = new Date(e).getFullYear(), r = new Date(t).getFullYear();
  return `${n.toString().slice(2)}-${r.toString().slice(2)}`;
}
const Lpe = ({
  seasons: e,
  formInstance: t
}) => {
  const { t: n } = oo(), {
    formData: { create_plan: r }
  } = Cn(Si);
  return kt(() => {
    r && Object.keys(r).length && (t.setFieldValue("plan_name", r.plan_name), t.setFieldValue("start_date", r.start_date), t.setFieldValue("seasons_ids", r.seasons_ids));
  }, [r, t]), /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
    /* @__PURE__ */ B.jsx(mde, { children: /* @__PURE__ */ B.jsx(
      Hn.Item,
      {
        name: "plan_name",
        rules: [
          {
            required: !0,
            message: n("molecules.basic_info_fields.form_item_msg")
          }
        ],
        label: /* @__PURE__ */ B.jsx(Es, { children: n("molecules.basic_info_fields.form_item_label") }),
        children: /* @__PURE__ */ B.jsx(
          tm,
          {
            placeholder: n("molecules.basic_info_fields.form_item_placeholder")
          }
        )
      }
    ) }),
    /* @__PURE__ */ B.jsxs(yde, { children: [
      /* @__PURE__ */ B.jsx(
        Hn.Item,
        {
          label: /* @__PURE__ */ B.jsx(Es, { children: n("molecules.basic_info_fields.form_label_crop_cycle") }),
          name: "seasons_ids",
          rules: [
            {
              required: !0,
              message: n(
                "molecules.basic_info_fields.form_rules_msg_crop_cycle"
              )
            }
          ],
          children: /* @__PURE__ */ B.jsx(
            Yc,
            {
              placeholder: n(
                "molecules.basic_info_fields.select_crop_cycle_placeholder"
              ),
              children: e == null ? void 0 : e.map((o) => {
                const i = Mpe(
                  o.start_date,
                  o.end_date
                );
                return /* @__PURE__ */ B.jsxs(aI, { value: o.id, children: [
                  o.name,
                  " • ",
                  i
                ] }, o.id);
              })
            }
          )
        }
      ),
      /* @__PURE__ */ B.jsx(
        Hn.Item,
        {
          name: "start_date",
          label: /* @__PURE__ */ B.jsx(Es, { children: n(
            "molecules.basic_info_fields.form_label_estimated_planting_date"
          ) }),
          rules: [
            {
              required: !0,
              message: n(
                "molecules.basic_info_fields.form_rule_msg_estimated_planting_date"
              )
            }
          ],
          children: /* @__PURE__ */ B.jsx(vde, {})
        }
      )
    ] })
  ] });
}, Ape = Ue(Hn)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 680px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  gap: 3rem;
  margin-top: 3.2rem;
`;
Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
Ue.button`
  width: 100%;
  max-width: 332px;
  border-radius: 4px;
  margin-right: 16px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  background-color: transparent;
  border: 1px solid ${Ht[30]};
  cursor: pointer;

  :hover {
    background-color: ${Ht[10]};
  }
`;
const jpe = Ue.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`, kpe = Ue(Ps.Paragraph)`
  margin-top: 60px;
`, Fpe = () => {
  var a;
  const { t: e } = oo(), [t] = Hn.useForm(), n = Cn(Si), { seasons: r } = Rpe((a = n.rulesInformation) == null ? void 0 : a.org);
  Ipe(t, n);
  const { handleNextStep: o, handlePreviousStep: i } = Dpe(
    t,
    n,
    r
  );
  return /* @__PURE__ */ B.jsxs(Ape, { layout: "vertical", name: "basic-info", form: t, children: [
    /* @__PURE__ */ B.jsxs(jpe, { children: [
      /* @__PURE__ */ B.jsx(
        UC,
        {
          icon: /* @__PURE__ */ B.jsx(Tpe, {}),
          title: e("sections.create_plan.title_section_crop_cycle_title")
        }
      ),
      /* @__PURE__ */ B.jsx(kpe, { strong: !0, children: e("sections.create_plan.form_title_crop_cycle_text") }),
      /* @__PURE__ */ B.jsx(Lpe, { formInstance: t, seasons: r })
    ] }),
    /* @__PURE__ */ B.jsx(
      dI,
      {
        previousEvent: i,
        nextEvent: o,
        title: {
          first: e("sections.create_plan.control_steps_cancel_title"),
          second: e("sections.create_plan.controle_steps_next_title")
        }
      }
    )
  ] });
}, Bpe = () => {
  const e = Cn(Si), { create_plan: t, properties: n } = e.formData, [r, o] = Ot(!1), [i, a] = Ot([]), s = ar(
    (l) => an(void 0, null, function* () {
      if (!l || !n || r)
        return;
      const u = n.map((y) => KC(l, y).then(
        (b) => b.data
      )), f = yield Promise.all(u), p = new Set(
        f.flatMap(
          (y) => y.flatMap(({ methodologyId: b }) => b)
        )
      );
      if (!(p.size > 1) && f.length) {
        const y = Array.from(p)[0];
        if (y) {
          const b = yield WC(y);
          if (b.data.length > 0) {
            const m = b.data.map((v) => ({
              label: v.name.localized_strings.en,
              value: v.id
            }));
            e.setFormData((v) => Bt(je({}, v), {
              inspection_groups_fetch: m
            }));
          }
        }
      }
      o(!0);
    }),
    [e, r, n]
  );
  return kt(() => {
    if (t && Array.isArray(t.plan_operations) && t.plan_operations.length > 0 && !i.length) {
      const l = /* @__PURE__ */ new Map();
      t.plan_operations.forEach((f) => {
        const p = crypto.randomUUID();
        l.set(f.id, p);
      });
      const u = t.plan_operations.map(
        (f) => {
          var C, x, S, E, O, $;
          const p = (x = (C = f.date_rule) == null ? void 0 : C.type) != null ? x : "Date", h = qr(f.start_date), y = qr(f.end_date);
          let b;
          p === "Date" && h.isValid() && y.isValid() && (b = [h, y]);
          let m = (S = f == null ? void 0 : f.days_or_degrees) != null ? S : 0;
          p !== "Date" && (m = p === "GDD" ? (E = f.date_rule) == null ? void 0 : E.gdd_degree : (O = f.date_rule) == null ? void 0 : O.days);
          const v = Bt(je({}, f), {
            id: l.get(f.id),
            criteria: p,
            date_range: b,
            hectar_value: ($ = f.point_factor) == null ? void 0 : $.toString(),
            days_or_degrees: m
          });
          return p === "DAO" && (v.activity = l.get(f.parent_operation_id)), v;
        }
      );
      a(u), s(t.seasons_ids), e.setFormData((f) => Bt(je({}, f), {
        create_operation: u
      }));
    }
  }, [t, i.length, e, s]), [i, a];
}, Hpe = ({ color: e = "#696F88", width: t = 18, height: n = 18 }) => {
  const r = `
    <svg
      width="${t}"
      height="${n}"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="edit icon"
      id="edit-icon"
      >
      <path
        fill="${e}"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.659 3C17.409 3 17.149 3.1 16.959 3.29L15.129 5.12L18.879 8.87L20.709 7.04C21.099 6.65 21.099 6.02 20.709 5.63L18.369 3.29C18.169 3.09 17.919 3 17.659 3ZM14.059 9.02L14.979 9.94L5.91902 19H4.99902V18.08L14.059 9.02ZM2.99902 17.2514L14.059 6.19141L17.809 9.94141L6.74902 21.0014H2.99902V17.2514Z"
      />
    </svg>`, o = btoa(r);
  return /* @__PURE__ */ B.jsx(
    "img",
    {
      src: `data:image/svg+xml;base64,${o}`,
      alt: "edit icon",
      id: "edit-icon",
      width: t,
      height: n
    }
  );
}, zpe = Ue.button`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${Ht[10]};
  border: transparent;
  cursor: pointer;
`, Vpe = Ue.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`, Wpe = Ue.span`
  color: ${vr[60]};
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid ${vr[20]};
  background: ${vr[10]};
  display: flex;
  padding: 0px 4px;
  align-items: center;
  text-decoration: uppercase;
`, EI = Ue.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;
  color: ${Ht[100]};
  margin: 0 0 4px 0;
`, Kpe = Ue(EI)`
  color: ${Ht[60]};
  font-weight: 400;
  margin: 0;
`, A3 = Ue.button`
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  margin-left: auto;

  svg {
    color: ${Ht[60]};
    gap: 12px;
  }
`, Upe = Ue.div`
  display: flex;
  margin-left: 22px;
  min-width: 60px;
`, Gpe = Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
`, qpe = Ue.div`
  display: flex;
  gap: 12px;
`, j3 = Ue.div`
  width: 100%;
  max-width: 180px;
`, k3 = Ue.p`
  color: ${Ht[60]};
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.075px;
  text-transform: uppercase;
  margin: 12px 0 4px 0;
`, F3 = Ue.p`
  color: ${Ht[100]};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.09px;
  margin: 0;
`, Ype = (e) => `${e[0].month() + 1}/${e[0].date()}/${e[0].year()} - ${e[1].month() + 1}/${e[1].date()}/${e[1].year()}`, Xpe = {
  marginBottom: 12,
  background: Ht[0],
  borderRadius: 16,
  border: `4px solid ${vr[10]}`,
  paddingTop: 16,
  paddingLeft: 20,
  paddingBottom: 16,
  paddingRight: 20
}, Zpe = ({ isActive: e }) => /* @__PURE__ */ B.jsx(zpe, { children: /* @__PURE__ */ B.jsx(ef, { rotate: e ? 180 : 360 }) }), Qpe = ({
  onOpenEditDrawer: e,
  operation: t,
  isLastItem: n,
  onDeleteOperation: r,
  operations: o
}) => {
  const {
    name: i,
    criteria: a,
    days_or_degrees: s,
    activity: l,
    date_range: u,
    type: f,
    task_type: p
  } = t, h = Cn(Si), y = {
    DAO: () => {
      var v, C;
      const m = (C = (v = o.find((x) => x.id === l)) == null ? void 0 : v.name) != null ? C : "N/A";
      return `${s} days after: ${m}`;
    },
    DAP: () => `${a}: ${s} days`,
    DAE: () => `${a}: ${s} days`,
    GDD: () => {
      var m;
      return `GDD ${s} ${((m = h.rulesInformation) == null ? void 0 : m.unitSystem) === "metric" ? "°C" : "°F"}`;
    },
    Date: () => u ? Ype(u) : "Date"
  }, b = (m) => {
    m.stopPropagation(), e(t);
  };
  return /* @__PURE__ */ B.jsxs(Vpe, { children: [
    /* @__PURE__ */ B.jsxs("div", { children: [
      /* @__PURE__ */ B.jsx(EI, { children: i }),
      /* @__PURE__ */ B.jsx(Kpe, { children: y[a]() })
    ] }),
    /* @__PURE__ */ B.jsxs(Gpe, { children: [
      /* @__PURE__ */ B.jsx(Wpe, { children: YC(f, p).toUpperCase() }),
      /* @__PURE__ */ B.jsxs(Upe, { children: [
        /* @__PURE__ */ B.jsx(A3, { onClick: b, "aria-label": "edit operation", children: /* @__PURE__ */ B.jsx(Hpe, {}) }),
        n && /* @__PURE__ */ B.jsx(
          A3,
          {
            onClick: () => r(),
            "aria-label": "delete operation",
            children: /* @__PURE__ */ B.jsx(fI, {})
          }
        )
      ] })
    ] })
  ] });
}, Jpe = ({ operation: e }) => {
  const { hectar_value: t, inspection_groups: n, scouting_type: r } = e, o = Cn(Si), {
    formData: { inspection_groups_fetch: i }
  } = o, { t: a } = oo(), s = r === "FREE_SAMPLE_COUNT" ? "molecules.operation_collapse.info_group_sample_size_title" : "molecules.operation_collapse.info_group_hectares_title";
  return /* @__PURE__ */ B.jsxs(qpe, { children: [
    n && /* @__PURE__ */ B.jsxs(j3, { children: [
      /* @__PURE__ */ B.jsx(k3, { children: a("molecules.operation_collapse.info_group_inspection_group") }),
      /* @__PURE__ */ B.jsx(F3, { children: n.map((l) => {
        const u = i.find(
          (f) => f.value === l
        );
        return u ? u.label : "";
      }).join(", ") })
    ] }),
    /* @__PURE__ */ B.jsxs(j3, { children: [
      /* @__PURE__ */ B.jsx(k3, { children: a(s) }),
      /* @__PURE__ */ B.jsx(F3, { children: t })
    ] })
  ] });
}, ehe = ({
  onOpenEditDrawer: e,
  operation: t,
  isLastItem: n,
  onDeleteOperation: r,
  operations: o
}) => /* @__PURE__ */ B.jsx(
  aC,
  {
    bordered: !1,
    defaultActiveKey: ["1"],
    expandIcon: (i) => /* @__PURE__ */ B.jsx(Zpe, { isActive: i.isActive }),
    expandIconPosition: "end",
    items: [
      {
        label: /* @__PURE__ */ B.jsx(
          Qpe,
          {
            operation: t,
            onOpenEditDrawer: e,
            isLastItem: n,
            onDeleteOperation: () => r(t.id),
            operations: o
          }
        ),
        children: /* @__PURE__ */ B.jsx(Jpe, { operation: t }),
        style: Xpe
      }
    ]
  }
), the = Ue.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`, nhe = Ue.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;
  margin: 0;
`, rhe = Ue.button`
  border: none;
  background-color: transparent;
  padding: 10px 16px;
  color: ${vr[60]};
  cursor: pointer;
`, ohe = Ue.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px;
`, ihe = ({
  onOpenDrawer: e,
  operations: t,
  onDeleteOperation: n
}) => {
  const { t: r } = oo();
  return /* @__PURE__ */ B.jsxs(the, { children: [
    /* @__PURE__ */ B.jsxs(ohe, { children: [
      /* @__PURE__ */ B.jsx(nhe, { children: r("molecules.operation_list.list_title_text") }),
      /* @__PURE__ */ B.jsxs(rhe, { onClick: e(), children: [
        /* @__PURE__ */ B.jsx(kh, {}),
        " ",
        r("molecules.operation_list.button_create_operation_text")
      ] })
    ] }),
    t.map((o, i) => {
      const a = i === t.length - 1;
      return /* @__PURE__ */ B.jsx(
        ehe,
        {
          onOpenEditDrawer: e(o),
          operation: o,
          isLastItem: a,
          onDeleteOperation: (s) => n(s),
          operations: t
        },
        o.id
      );
    })
  ] });
}, B3 = (e) => {
  const t = [
    Cr.PLANTING_FEMALE,
    Cr.PLANTING_MALE,
    Cr.PRE_PLANTING
  ].includes(e.task_type);
  return je(Bt(je({}, e), {
    type: t ? Cr.PLANTING : e.task_type
  }), t && {
    planting_type: e.task_type
  });
}, ahe = () => /* @__PURE__ */ B.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ B.jsxs("g", { clipPath: "url(#clip0_9496_148535)", children: [
        /* @__PURE__ */ B.jsx("rect", { width: "32", height: "32", rx: "4", fill: "#DFFBE8" }),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            d: "M9.25 14.5H17.5V16H9.25V14.5ZM9.25 13H17.5V11.5H9.25V13ZM9.25 19H14.5V17.5H9.25V19ZM20.5075 16.6525L21.04 16.12C21.3325 15.8275 21.805 15.8275 22.0975 16.12L22.63 16.6525C22.9225 16.945 22.9225 17.4175 22.63 17.71L22.0975 18.2425L20.5075 16.6525ZM19.975 17.185L16 21.16V22.75H17.59L21.565 18.775L19.975 17.185Z",
            fill: "#14803C"
          }
        )
      ] }),
      /* @__PURE__ */ B.jsx("defs", { children: /* @__PURE__ */ B.jsx("clipPath", { id: "clip0_9496_148535", children: /* @__PURE__ */ B.jsx("rect", { width: "32", height: "32", rx: "8", fill: "white" }) }) })
    ]
  }
), she = () => /* @__PURE__ */ B.jsxs(
  "svg",
  {
    width: "285",
    height: "143",
    viewBox: "0 0 285 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M31.3432 122.175C18.9785 111.815 0 120.736 0 141.339L284.927 141.339C286.115 125.916 272.6 105.079 255.059 111.815C242.454 116.655 222.662 123.326 203.262 105.079C192.373 94.8363 182.428 103.714 172.67 109.596C162.912 115.477 154.391 100.906 139.463 109.596C119.334 121.312 113.583 106.347 100.356 109.596C90.6633 111.976 87.3819 127.83 67.2873 118.146C56.0727 112.742 44.6636 133.336 31.3432 122.175Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ B.jsxs("g", { opacity: "0.6", children: [
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "42.4871",
            y: "64.7256",
            width: "5.17492",
            height: "71.1546",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "216.364",
            y: "64.7256",
            width: "5.17493",
            height: "71.1546",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "129.007",
            y: "68.6885",
            width: "4.60739",
            height: "71.3302",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "59.238",
            y: "68.6885",
            width: "3.94919",
            height: "69.3488",
            rx: "0.875783",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "129.007",
            y: "74.6326",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "129.007",
            y: "88.5024",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "130.042",
            y: "102",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "130.042",
            y: "116.231",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "130.042",
            y: "129.367",
            width: "91.4896",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "44.7576",
            y: "73.3667",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "44.7576",
            y: "87.2363",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            width: "103.56",
            height: "5.36175",
            rx: "1",
            transform: "matrix(0.853455 0.521166 -0.479128 0.877745 131.995 75.5596)",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "45.7925",
            y: "100.734",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "45.7925",
            y: "114.965",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            x: "45.7925",
            y: "128.101",
            width: "15.1386",
            height: "6.56812",
            rx: "1",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            d: "M18.4629 135.708C18.6518 135.508 18.9144 135.395 19.1891 135.395H47.0486C47.6009 135.395 48.0486 135.843 48.0486 136.395V141C48.0486 141.552 47.6009 142 47.0486 142H14.8297C13.9519 142 13.5 140.95 14.1035 140.312L18.4629 135.708Z",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "path",
          {
            d: "M215.889 136.395C215.889 135.843 216.337 135.395 216.889 135.395H248.353C248.637 135.395 248.907 135.516 249.097 135.728L253.227 140.332C253.805 140.976 253.348 142 252.483 142H216.889C216.337 142 215.889 141.552 215.889 141V136.395Z",
            fill: "#C2C7D0"
          }
        ),
        /* @__PURE__ */ B.jsx(
          "rect",
          {
            width: "55.0488",
            height: "2.93604",
            rx: "1",
            transform: "matrix(0.221648 0.975127 -0.963581 0.267418 48.0576 76.8364)",
            fill: "#C2C7D0"
          }
        )
      ] }),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M118.852 50.4979C118.928 49.7712 119.921 47.3428 120.646 47.459C121.37 47.5752 120.454 49.2764 120.416 49.6398C120.378 50.0032 122.266 49.5668 122.705 48.8979C123.144 48.2291 122.925 46.5282 123.688 46.2809C124.451 46.0336 124.222 48.2143 123.945 49.0939C123.668 49.9736 123.764 51.1005 123.325 51.7694C122.886 52.4382 121.885 53.2017 121.446 53.8706C121.095 54.4057 120.555 55.3292 120.129 55.8769L119.69 56.5458L118.069 54.4378L118.046 54.408C117.992 54.4122 117.867 54.4908 117.907 54.2273C119.147 52.9477 118.776 51.2248 118.852 50.4979Z",
          fill: "#DFE2E7"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M118.069 54.4378C118.085 54.331 117.855 54.5722 117.907 54.2273M117.907 54.2273C119.147 52.9477 118.776 51.2248 118.852 50.4979C118.928 49.7712 119.921 47.3428 120.646 47.459C121.37 47.5752 120.454 49.2764 120.416 49.6398C120.378 50.0032 122.266 49.5668 122.705 48.8979C123.144 48.2291 122.925 46.5282 123.688 46.2809C124.451 46.0336 124.222 48.2143 123.945 49.0939C123.668 49.9736 123.764 51.1005 123.325 51.7694C122.886 52.4382 121.885 53.2017 121.446 53.8706C121.095 54.4057 120.555 55.3292 120.129 55.8769L119.69 56.5458L117.907 54.2273Z",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M67.4545 51.2803C67.3026 50.5275 66.0235 48.0853 65.2764 48.2791C64.5293 48.473 65.6564 50.1618 65.7323 50.5383C65.8083 50.9148 63.7885 50.6464 63.263 49.9902C62.7375 49.3341 62.7982 47.5324 61.9751 47.3497C61.152 47.167 61.6081 49.426 61.9848 50.319C62.3615 51.2119 62.3734 52.4006 62.8989 53.0567C63.4244 53.7129 64.5483 54.4119 65.0738 55.0681C65.4943 55.5931 66.1504 56.5057 66.6506 57.0363L67.1762 57.6925L68.6642 55.325L68.6852 55.2916C68.7422 55.2905 68.8808 55.3603 68.8127 55.0886C67.3881 53.8732 67.6065 52.0334 67.4545 51.2803Z",
          fill: "#DFE2E7"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M68.6642 55.325C68.6369 55.2148 68.9019 55.4442 68.8127 55.0886M68.8127 55.0886C67.3881 53.8732 67.6065 52.0334 67.4545 51.2803C67.3026 50.5275 66.0235 48.0853 65.2764 48.2791C64.5293 48.473 65.6564 50.1618 65.7323 50.5383C65.8083 50.9148 63.7885 50.6464 63.263 49.9902C62.7375 49.3341 62.7982 47.5324 61.9751 47.3497C61.152 47.167 61.6081 49.426 61.9848 50.319C62.3615 51.2119 62.3734 52.4006 62.8989 53.0567C63.4244 53.7129 64.5483 54.4119 65.0738 55.0681C65.4943 55.5931 66.1504 56.5057 66.6506 57.0363L67.1762 57.6925L68.8127 55.0886Z",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M117.21 54.7865C114.661 58.6362 112.367 65.0523 111.092 65.0523C109.817 62.9992 108.843 60.9274 108.288 59.8605C107.733 58.7936 107.142 55.7764 105.229 53.2466C103.137 50.4809 100.96 51.4163 99.0177 51.1496C98.9121 51.135 98.7332 51.1122 98.5 51.0833C94.1125 53.4491 92.8124 50.4132 92.0867 50.4132C91.2542 50.4132 90.1379 50.3494 89.3054 50.3494C88.4729 50.3494 85.8752 51.1191 84.0714 52.7334C82.2677 54.3476 80.4687 64.8265 79.9928 64.539C78.7182 63.7691 69.2861 57.0966 69.2861 54.7865C68.9161 54.6087 67.7566 55.2998 66.737 55.5564C65.6601 55.8275 65.27 55.8131 64.6979 55.8131C64.106 55.8131 70.1169 63.357 71.0708 64.2824C75.4043 68.4868 78.9731 72.5758 81.7772 71.9543C84.6911 71.3084 85.0908 61.2026 85.0908 61.2026V62.7427C85.0908 63.5429 84.8655 67.6866 84.8655 68.4868C84.8655 69.287 85.143 76.4887 84.8655 77.0221C84.6435 77.4489 84.773 79.8673 84.8655 81.0231H103.458C103.55 78.178 104.013 73.0212 104.013 71.9543C104.013 69.8205 103.7 63.633 103.7 63.2558C103.7 62.9891 104.5 65.2654 104.778 65.7988C105.055 66.3323 106.204 69.1385 106.759 69.6719C107.314 70.2054 108.543 73.5216 112.876 70.9551C114.032 70.271 113.789 71.0164 117.465 64.539C119.504 60.946 119.759 59.4061 121.799 54.7865H117.21Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M99.0177 51.1496C100.96 51.4163 103.137 50.4809 105.229 53.2466C107.142 55.7764 107.733 58.7936 108.288 59.8605C108.843 60.9274 109.817 62.9992 111.092 65.0523C112.367 65.0523 114.661 58.6362 117.21 54.7865H121.799C119.759 59.4061 119.504 60.946 117.465 64.539C113.789 71.0164 114.032 70.271 112.876 70.9551C108.543 73.5216 107.314 70.2054 106.759 69.6719C106.204 69.1385 105.055 66.3323 104.778 65.7988C104.5 65.2654 103.7 62.9891 103.7 63.2558C103.7 63.633 104.013 69.8205 104.013 71.9543C104.013 73.0212 103.55 78.178 103.458 81.0231H84.8655C84.773 79.8673 84.6435 77.4489 84.8655 77.0221C85.143 76.4887 84.8655 69.287 84.8655 68.4868C84.8655 67.6866 85.0908 63.5429 85.0908 62.7427C85.0908 61.4091 85.0908 61.2026 85.0908 61.2026C85.0908 61.2026 84.6911 71.3084 81.7772 71.9543C78.9731 72.5758 75.4043 68.4868 71.0708 64.2824C70.1169 63.357 64.106 55.8131 64.6979 55.8131C65.27 55.8131 65.6601 55.8275 66.737 55.5564C67.7566 55.2998 68.9161 54.6087 69.2861 54.7865C69.2861 57.0966 78.7182 63.7691 79.9928 64.539C80.4687 64.8265 82.2677 54.3476 84.0714 52.7334C85.8752 51.1191 88.4729 50.3494 89.3054 50.3494C90.1379 50.3494 91.2542 50.4132 92.0867 50.4132C92.8124 50.4132 94.1125 53.4491 98.5 51.0833M99.0177 51.1496C98.9121 51.135 98.7332 51.1122 98.5 51.0833M99.0177 51.1496L98.5 51.0833",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M98.2906 47.9873C98.2906 49.0436 98.5368 50.2495 98.9081 51.4943C96.2973 54.0331 91.5486 51.724 91.9473 50.9607C92.226 50.4273 92.7826 48.5602 93.0612 47.2266L92.226 43.4924C91.6691 43.7591 91.913 43.6609 91.2448 43.0207C90.9664 42.754 90.3924 41.6252 90.6708 40.8251C90.9248 40.0952 91.7238 40.3716 92.226 40.8252L92.2319 39.6126C91.9473 31.7698 103.299 30.2063 101.531 39.2616C101.531 39.2616 101.727 40.0159 101.531 41.7789C101.237 44.4396 100.087 45.6222 98.9081 46.5091C98.1656 47.4871 98.2906 47.5055 98.2906 47.9873Z",
          fill: "#DFE2E7",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M91.7238 38.3476C91.9779 37.5887 92.349 36.8113 92.9059 36.3237C93.144 36.5859 93.0091 38.3411 92.9063 38.8407C92.8036 39.3404 92.3557 39.9792 91.9891 40.3415C91.9246 40.5641 91.4697 39.1066 91.7238 38.3476Z",
          fill: "#00004B",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M91.6705 43.2867C90.1753 42.8977 87.1422 41.044 85.9238 39.8643C84.6018 38.5845 84.3028 35.7672 87.4968 35.4444C90.6909 35.1216 92.3112 36.8715 94.6672 37.5864C94.7621 37.6152 94.8582 37.6444 94.9552 37.6738C96.3144 37.7389 100.182 39.0146 101.182 39.2474C101.788 39.3315 102.329 39.364 102.766 39.3234C105.962 39.0272 107.423 36.9555 107.401 37.4304C107.378 37.9053 107.463 39.6756 106.33 40.843C105.791 41.3988 103.662 41.8439 101.307 41.731C101.756 41.7444 101.77 39.3846 101.182 39.2474C99.3606 38.995 96.9466 38.2773 94.9552 37.6738C93.5959 37.6086 92.8536 37.4994 92.3576 38.3747C91.8617 39.25 91.9643 40.2863 92.2513 40.6173C91.8133 40.279 90.7142 39.8211 90.4373 40.5303C89.9203 41.8542 91.5345 42.9629 91.6705 43.2867Z",
          fill: "white",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M92.14 33.4161C91.7656 33.7628 91.19 35.3087 91.303 36.0737C92.0255 36.5641 93.7692 37.6895 94.7907 38.015C96.4595 38.5468 98.8798 39.1236 100.156 39.1848C101.227 39.2362 103.202 39.7918 104.151 38.9381C103.698 38.9163 102.72 38.7599 102.381 38.379C101.956 37.9029 102.042 36.084 102.085 35.1746C102.128 34.2652 101.718 31.7262 100.884 31.1378C100.396 30.7934 98.9246 30.8127 97.5805 30.401C95.8162 29.8606 94.5985 31.1101 94.1992 31.6061C93.0682 33.011 92.608 32.9828 92.14 33.4161Z",
          fill: "white",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M93.7607 37.5408C94.6889 37.136 96.9776 36.7963 99.2235 37.3533C102.102 38.0672 102.766 39.3207 103.694 38.9158",
          stroke: "#00004B",
          strokeWidth: "0.935495",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M105.591 125.111C105.157 127.607 104.477 132.046 104.199 134.446L98.0734 134.18V133.113C98.3518 126.711 98.9644 113.482 99.1871 111.775C99.4655 109.641 97.795 105.106 97.2381 103.506C96.6813 101.906 95.0108 91.5033 94.1755 92.5702C93.7529 93.11 92.7834 102.439 92.2266 106.974C92.041 110.886 91.614 119.296 91.3913 121.644C91.1686 123.991 90.7417 130.979 90.556 134.18H84.9876V133.113C84.802 126 84.4308 111.508 84.4308 110.441V91.2366V74.9662C84.4308 74.5394 84.7092 67.7645 84.9876 64.0304C85.0273 63.4983 85.8229 62.43 87.215 61.0964C88.0267 60.3187 87.9576 58.9596 88.0502 57.6289C88.3287 53.628 88.3287 53.0945 88.6071 50.694C88.6071 50.694 88.8855 50.4272 89.7208 50.4272C90.6012 50.4272 90.8345 50.694 90.8345 50.694C90.556 54.1614 89.9992 60.5629 90.556 60.8296C91.8258 61.4379 96.1245 61.0964 98.3518 61.0964C100.579 61.0964 100.301 60.0294 100.301 59.2293C100.301 58.5891 100.022 53.5391 100.022 51.2274C100.301 51.2274 101.136 51.2274 101.971 51.4942C102.343 54.9616 102.892 60.5205 103.085 61.6298C103.363 63.2302 104.199 63.2302 104.199 65.0973V70.6986C104.199 73.6326 103.642 78.1669 103.92 80.8342C104.199 83.5015 105.312 90.7031 105.869 92.5702C106.426 94.4373 108.375 110.708 108.375 112.308C108.375 113.908 106.148 121.91 105.591 125.111Z",
          fill: "#00004B",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M105.662 133.699C105.819 132.074 105.979 130.334 106.139 128.83C106.223 128.035 105.604 127.336 104.805 127.336H98.7222C97.9469 127.336 97.3365 127.994 97.4021 128.766C97.6904 132.161 98.2301 138.022 98.2301 138.402V141.999H100.169L100.799 140.734L102.108 141.999H112.448C112.556 141.815 112.707 140.855 112.448 140.191C112.125 139.361 106.308 138.402 105.662 137.849C105.016 137.296 105.508 135.296 105.662 133.699Z",
          fill: "white",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "rect",
        {
          width: "10.9331",
          height: "1.04739",
          transform: "matrix(-1 0 0 1 112.591 140.953)",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M91.1789 140.589C91.1789 140.19 91.1789 133.221 91.6198 128.883C91.7027 128.068 91.0736 127.336 90.2544 127.336H85.6054C84.8285 127.336 84.2176 127.998 84.2856 128.772C84.5069 131.291 84.8012 134.372 84.8012 135.513C84.8012 136.923 84.8012 140.871 85.1201 141.999H91.1789V140.589Z",
          fill: "white",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx("path", { d: "M91.1606 140.953H85.258V142H91.1606V140.953Z", fill: "#00004B" }),
      /* @__PURE__ */ B.jsx(
        "rect",
        {
          width: "2.18663",
          height: "1.04739",
          transform: "matrix(-1 0 0 1 100.566 140.953)",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M95.0422 42.7965C95.9839 42.6543 96.518 42.9024 97.1675 43.4499C96.8947 43.8362 95.8367 44.4495 95.2377 44.4808C94.6388 44.5121 93.8279 44.1515 93.3521 43.8044C93.0824 43.7946 94.4069 42.8924 95.0422 42.7965Z",
          fill: "#00004B",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M99.0301 44.6433C97.9816 44.2768 97.7415 43.757 97.3894 43.4451C97.6746 43.2372 98.5157 43.096 99.209 43.3381C100.257 43.7044 100.443 43.9515 101.031 44.4758C100.57 44.6338 100.079 45.0097 99.0301 44.6433Z",
          fill: "#00004B",
          stroke: "#00004B",
          strokeWidth: "0.935495"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.7",
          d: "M85.2368 141.009C85.4562 139.908 85.2368 138.037 88.1987 138.037C91.1788 138.037 90.8315 139.688 90.8315 141.009",
          stroke: "#868CA2",
          strokeWidth: "0.8",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M37.1996 129.5C38.4117 133.686 38.563 138.784 38.5069 139.92C37.7653 140.336 37.3535 140.218 37.3535 140.218C37.3535 140.218 37.5216 136.813 37.0315 132.906C36.539 128.98 35.1434 124.449 34.048 121.703C33.7816 121.095 33.648 120.787 33.7496 120.982C33.8458 121.205 33.9456 121.446 34.048 121.703C34.8094 123.44 36.6559 127.622 37.1996 129.5Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M40.0358 129.311C40.2612 133.583 39.1242 138.319 38.7754 139.341C37.8794 139.461 37.4707 139.208 37.4707 139.208C37.4707 139.208 38.5169 136.14 38.9896 132.379C39.4644 128.601 39.1315 123.947 38.6638 121.038C38.5348 120.386 38.471 120.056 38.5297 120.27C38.5752 120.509 38.6201 120.766 38.6638 121.038C39.0327 122.902 39.9346 127.395 40.0358 129.311Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M36.2214 129.602C37.8517 133.555 38.3513 138.4 38.3619 139.481C37.5569 139.893 37.0874 139.791 37.0874 139.791C37.0874 139.791 37.0557 136.549 36.2531 132.844C35.4468 129.123 33.5881 124.846 32.1818 122.26C31.8437 121.688 31.674 121.398 31.8004 121.58C31.9228 121.791 32.0503 122.018 32.1818 122.26C33.1483 123.894 35.4899 127.829 36.2214 129.602Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M38.5062 129.986C39.0527 134.228 38.2756 139.036 38.0049 140.082C37.1205 140.27 36.6939 140.048 36.6939 140.048C36.6939 140.048 37.506 136.91 37.694 133.124C37.8829 129.32 37.2004 124.705 36.515 121.84C36.3372 121.199 36.2487 120.875 36.3233 121.084C36.3868 121.319 36.4509 121.572 36.515 121.84C37.0232 123.67 38.261 128.082 38.5062 129.986Z",
          fill: "#009933"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M39.7306 129.144C38.3397 133.445 37.9895 138.515 38.0026 139.633C38.7389 139.951 39.1611 139.782 39.1611 139.782C39.1611 139.782 39.122 136.43 39.7699 132.497C40.4208 128.545 42.0114 123.879 43.2284 121.019C43.5221 120.383 43.6695 120.061 43.559 120.267C43.4528 120.5 43.3422 120.752 43.2284 121.019C42.389 122.837 40.3547 127.215 39.7306 129.144Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M31.1135 141.976L34.3729 141.971C36.3948 141.969 37.9416 139.972 37.2357 138.078C36.402 135.84 35.1892 133.839 33.1049 134.097C31.4933 134.296 29.8987 136.206 28.7084 138.238C27.6785 139.996 29.0759 141.978 31.1135 141.976Z",
          fill: "#A3A9B9"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M46.2924 141.866L40.5382 141.862C38.2835 141.86 36.5991 139.302 38.0403 137.568C39.1427 136.242 40.6597 135.253 42.9261 135.42C44.7798 135.556 46.6172 136.672 48.1265 138.006C49.8314 139.514 48.5681 141.868 46.2924 141.866Z",
          fill: "#696F88"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M34.7207 141.996L37.7733 141.994C40.0402 141.992 41.7917 139.295 40.07 137.821C39.2219 137.094 38.1253 136.625 36.6471 136.731C35.388 136.822 34.1378 137.441 33.0367 138.256C31.197 139.616 32.4325 141.998 34.7207 141.996Z",
          fill: "#4D5165"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M220.837 129.5C222.049 133.686 222.201 138.784 222.145 139.92C221.403 140.336 220.991 140.218 220.991 140.218C220.991 140.218 221.159 136.813 220.669 132.906C220.177 128.98 218.781 124.449 217.686 121.703C217.419 121.095 217.286 120.787 217.387 120.982C217.483 121.205 217.583 121.446 217.686 121.703C218.447 123.44 220.294 127.622 220.837 129.5Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M221.873 129.311C222.099 133.583 220.962 138.319 220.613 139.341C219.717 139.461 219.308 139.208 219.308 139.208C219.308 139.208 220.354 136.14 220.827 132.379C221.302 128.601 220.969 123.947 220.501 121.038C220.372 120.386 220.308 120.056 220.367 120.27C220.413 120.509 220.458 120.766 220.501 121.038C220.87 122.902 221.772 127.395 221.873 129.311Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M219.259 129.719C220.889 133.671 221.389 138.516 221.399 139.597C220.595 140.01 220.125 139.907 220.125 139.907C220.125 139.907 220.093 136.665 219.291 132.961C218.484 129.24 216.626 124.962 215.219 122.376C214.881 121.804 214.712 121.514 214.838 121.697C214.96 121.907 215.088 122.134 215.219 122.376C216.186 124.01 218.528 127.945 219.259 129.719Z",
          fill: "#00004B"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M223.368 129.144C221.977 133.445 221.627 138.515 221.64 139.633C222.377 139.951 222.799 139.782 222.799 139.782C222.799 139.782 222.76 136.43 223.408 132.497C224.058 128.545 225.649 123.879 226.866 121.019C227.16 120.383 227.307 120.061 227.197 120.267C227.09 120.5 226.98 120.752 226.866 121.019C226.027 122.837 223.992 127.215 223.368 129.144Z",
          fill: "#73DC78"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M217.957 141.762L214.697 141.758C212.675 141.755 211.128 139.759 211.834 137.864C212.668 135.627 213.881 133.626 215.965 133.883C217.577 134.082 219.171 135.992 220.362 138.024C221.392 139.782 219.994 141.764 217.957 141.762Z",
          fill: "#A3A9B9"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M229.93 141.866L224.176 141.862C221.921 141.86 220.237 139.302 221.678 137.568C222.78 136.242 224.297 135.253 226.564 135.419C228.417 135.556 230.255 136.672 231.764 138.006C233.469 139.513 232.206 141.868 229.93 141.866Z",
          fill: "#696F88"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.1",
          d: "M254.01 38.9674H211.72C210.577 37.8186 211.719 34.9452 214.577 34.9446C217.435 34.9441 216.034 31.9782 219.72 29.1982C224.292 25.75 230.008 29.1983 231.722 31.497C233.437 33.7957 236.037 29.863 239.723 30.9224C243.151 31.9079 242.953 35.7141 244.866 34.9446C250.581 32.6464 254.582 38.9679 254.01 38.9674Z",
          fill: "#868CA2"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          d: "M193.556 46.2326H229.341C230.308 45.2865 229.341 42.9202 226.923 42.9197C224.505 42.9193 225.69 40.4768 222.571 38.1874C218.702 35.3477 213.866 38.1874 212.416 40.0805C210.965 41.9736 208.765 38.7348 205.646 39.6073C202.744 40.4189 202.912 43.5534 201.293 42.9197C196.458 41.0271 193.073 46.233 193.556 46.2326Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.1",
          d: "M98.1175 9.90698H133.902C134.869 8.8933 133.902 6.35793 131.484 6.35747C129.066 6.357 130.251 3.74007 127.132 1.28712C123.264 -1.75544 118.428 1.28716 116.977 3.31545C115.526 5.34374 113.326 1.87363 110.207 2.80842C107.306 3.67804 107.474 7.03639 105.855 6.35747C101.019 4.32964 97.6339 9.90744 98.1175 9.90698Z",
          fill: "#868CA2"
        }
      ),
      /* @__PURE__ */ B.jsx(
        "path",
        {
          opacity: "0.1",
          d: "M19.1512 53.4976H68.5987C69.935 52.1461 68.5992 48.7656 65.2577 48.765C61.9166 48.7643 63.5541 45.2751 59.2443 42.0045C53.8986 37.9477 47.216 42.0045 45.2114 44.7089C43.2068 47.4133 40.1667 42.7865 35.857 44.0329C31.8477 45.1924 32.0796 49.6702 29.8426 48.765C23.161 46.0612 18.483 53.4983 19.1512 53.4976Z",
          fill: "#868CA2"
        }
      )
    ]
  }
);
var hc = /* @__PURE__ */ ((e) => (e.DAE = "DAE", e.DAP = "DAP", e.DAO = "DAO", e.GDD = "GDD", e.DATE = "Date", e))(hc || {});
const lhe = [
  {
    value: hc.DAE,
    label: "DAE – Days after emergence"
  },
  {
    value: hc.DAO,
    label: "DAO – Days after operation"
  },
  {
    value: hc.GDD,
    label: "GDD – Growing degree days"
  },
  {
    value: hc.DAP,
    label: "DAP – Days after planting"
  },
  {
    value: hc.DATE,
    label: "Date"
  }
], che = (e) => {
  const { t } = oo();
  return /* @__PURE__ */ B.jsxs(Hn.Item, { id: "criteria", children: [
    /* @__PURE__ */ B.jsx(Es, { children: t("molecules.operation_form.label_criteria_text") }),
    /* @__PURE__ */ B.jsx(
      Hn.Item,
      {
        name: "criteria",
        rules: [
          {
            required: !0,
            message: t("molecules.operation_form.criteria_msg")
          }
        ],
        noStyle: !0,
        children: /* @__PURE__ */ B.jsx(
          Yc,
          je({
            "aria-label": "criteria",
            placeholder: t(
              "molecules.operation_form.select_criteria_placeholder"
            ),
            options: lhe
          }, e)
        )
      }
    )
  ] });
}, uhe = Ue(tm)`
  padding: 8px 10px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 4px;
`, H3 = (i) => {
  var a = i, {
    daysOrDegrees: e,
    isGDD: t,
    onChange: n,
    rules: r
  } = a, o = Cv(a, [
    "daysOrDegrees",
    "isGDD",
    "onChange",
    "rules"
  ]);
  return /* @__PURE__ */ B.jsx(Hn.Item, { name: "days_or_degrees", rules: r, noStyle: !0, children: /* @__PURE__ */ B.jsx(
    uhe,
    je({
      "aria-label": "days_or_degrees",
      onChange: n,
      suffix: t ? "degrees" : "days",
      type: "number",
      defaultValue: e,
      inputMode: "numeric",
      pattern: "[0-9]*"
    }, o)
  ) });
}, dhe = Ue.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .smv-input-affix-wrapper {
    margin-top: 0;
  }
`, fhe = Ue.div`
  display: flex;
  flex-direction: column;
`, L0 = Ue.div`
  padding-bottom: 20px;
  border-bottom: 1px solid ${Ht[20]};
`, z3 = Ue(tm)`
  padding: 8px 10px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 4px;
`;
Ue.strong`
  font-size: 14px;
  color: ${Ht[100]};
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;
  padding-top: 20px;
  display: flex;
`;
const phe = Ue.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.09px;
  text-transform: uppercase;
  color: ${Ht[60]};
  margin: 16px 0 8px 0;
`, hhe = Ue(Ci.Group)`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`, V3 = Ue(Es)`
  margin-top: 12px;
  display: flex;
  margin-bottom: 0;
`, ghe = Ue.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 16px 0;
  gap: 8px;
`, mhe = Ue(Fd)`
  max-width: 142px;
`, vhe = Ue(As.RangePicker)`
  width: 100%;
  height: 40px;
  border-radius: 4px;
`, yhe = Ue(Es)`
  margin-top: 0px;
`, bhe = ({
  closeDrawer: e,
  addOperation: t,
  onUpdateOperation: n,
  formInstance: r,
  operationsListed: o,
  seasonAndCompanyIds: i,
  contextPlans: a,
  selectedOperation: s
}) => {
  var M;
  const { t: l } = oo(), [
    u,
    f
  ] = Ot(!1), [p, h] = Ot("ha/sample"), [y, b] = Ot([]), [m, v] = Ot(!1), [C, x] = Ot(""), [S, E] = Ot(
    Cr.SCOUTING
  ), O = C === "DAO", $ = C === "DAE", _ = C === "DAP", R = C === "GDD", P = !O && !$ && !_ && !R, I = !!s, j = ar(() => an(void 0, null, function* () {
    const {
      formData: { properties: N }
    } = a;
    if (!(i != null && i.season) || !N || m)
      return;
    const D = N.map((H) => KC(
      i.season,
      H
    ).then((V) => V.data)), T = yield Promise.all(D), L = new Set(
      T.flatMap(
        (H) => H.flatMap(({ methodologyId: V }) => V)
      )
    ), z = L.size > 1;
    if (f(
      z || !T.length
    ), !z && T.length) {
      const H = Array.from(L)[0];
      if (f(!H), H) {
        const V = yield WC(H);
        if (f(
          !V.data.length
        ), V.data.length > 0) {
          const Y = V.data.map((Z) => ({
            label: Z.name.localized_strings.en,
            value: Z.id
          }));
          b(Y), a.setFormData((Z) => Bt(je({}, Z), {
            inspection_groups_fetch: Y
          }));
        }
      }
    }
    v(!0);
  }), [a, i, m]);
  kt(() => {
    m || j();
  }, [m, j]), kt(() => {
    r == null || r.resetFields(), s && (x(s.criteria), E(s.task_type), r == null || r.setFieldsValue(s), r == null || r.setFieldValue("task_type", s.task_type)), s || r == null || r.setFieldValue("task_type", Cr.SCOUTING);
  }, [r, s]);
  const F = () => {
    var ee;
    if (!r)
      return;
    const {
      date_range: N,
      scouting_type: D,
      hectar_value: T,
      name: L,
      days_or_degrees: z,
      activity: H,
      task_type: V
    } = r.getFieldsValue(), Y = (ee = z != null ? z : H) != null ? ee : N, Z = V === Cr.SCOUTING ? T && D : !0;
    Y && Z && L && (I ? n() : t(), e());
  }, A = () => {
    if ((r == null ? void 0 : r.getFieldValue(
      "scouting_type"
    )) == "FREE_SAMPLE_COUNT") {
      const D = r == null ? void 0 : r.getFieldValue(
        "hectar_value"
      );
      if (D != null) {
        const T = parseFloat(D);
        r == null || r.setFieldValue(
          "hectar_value",
          Number(T).toFixed()
        );
      }
    }
  };
  return /* @__PURE__ */ B.jsx(dhe, { children: /* @__PURE__ */ B.jsxs(
    Hn,
    {
      name: "operations",
      "aria-label": "operations",
      form: r,
      onFinish: F,
      children: [
        /* @__PURE__ */ B.jsxs(fhe, { children: [
          /* @__PURE__ */ B.jsxs(L0, { children: [
            /* @__PURE__ */ B.jsxs(Hn.Item, { id: "name", children: [
              /* @__PURE__ */ B.jsx(Es, { children: l("molecules.operation_form.label_name_text") }),
              /* @__PURE__ */ B.jsx(
                Hn.Item,
                {
                  name: "name",
                  rules: [
                    {
                      required: !0,
                      message: l("molecules.operation_form.item_name_msg")
                    }
                  ],
                  noStyle: !0,
                  children: /* @__PURE__ */ B.jsx(
                    z3,
                    {
                      "aria-label": "name",
                      type: "text",
                      onChange: (N) => {
                        const {
                          currentTarget: { value: D }
                        } = N;
                        r == null || r.setFieldValue("name", D);
                      },
                      placeholder: l(
                        "molecules.operation_form.input_name_placeholder"
                      ),
                      defaultValue: s == null ? void 0 : s.name
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ B.jsx(
              bde,
              {
                onChange: (N) => {
                  r == null || r.setFieldValue("task_type", N), E(N);
                },
                defaultValue: Cr.SCOUTING
              }
            ),
            /* @__PURE__ */ B.jsx(
              che,
              {
                onChange: (N) => {
                  r == null || r.setFieldValue("criteria", N), r == null || r.setFieldValue("days_or_degrees", null), x(N);
                },
                defaultValue: s == null ? void 0 : s.criteria
              }
            ),
            O && /* @__PURE__ */ B.jsxs(Hn.Item, { children: [
              /* @__PURE__ */ B.jsx(yhe, { children: l("molecules.operation_form.parent_activity_label_text") }),
              /* @__PURE__ */ B.jsx(
                Hn.Item,
                {
                  name: "activity",
                  rules: [
                    {
                      required: O,
                      message: l("molecules.operation_form.item_activity_msg")
                    }
                  ],
                  noStyle: !0,
                  children: /* @__PURE__ */ B.jsx(
                    Yc,
                    {
                      "aria-label": "activity",
                      onChange: (N) => {
                        r == null || r.setFieldValue("activity", N);
                      },
                      placeholder: l(
                        "molecules.operation_form.select_activity_placeholder"
                      ),
                      defaultValue: s == null ? void 0 : s.activity,
                      children: (M = o.filter((N) => I ? N.id !== s.id : !0)) == null ? void 0 : M.map((N) => /* @__PURE__ */ B.jsx(aI, { value: N.id, children: N.name }, N.id))
                    }
                  )
                }
              )
            ] }),
            O && /* @__PURE__ */ B.jsx(V3, { children: l("molecules.operation_form.inspection_group_label_text") }),
            !P && R && /* @__PURE__ */ B.jsx(
              H3,
              {
                min: 1,
                step: 0.1,
                rules: [
                  {
                    required: !0,
                    message: l("molecules.operation_form.item_gdd_degrees_msg")
                  }
                ],
                daysOrDegrees: s == null ? void 0 : s.days_or_degrees,
                onChange: ({ target: { value: N } }) => {
                  r == null || r.setFieldValue("days_or_degrees", Number(N));
                },
                isGDD: !0
              }
            ),
            !P && !R && /* @__PURE__ */ B.jsx(
              H3,
              {
                min: 1,
                max: 365,
                rules: [
                  {
                    required: !0,
                    message: l("molecules.operation_form.item_days_msg")
                  }
                ],
                daysOrDegrees: s == null ? void 0 : s.days_or_degrees,
                isGDD: R,
                onChange: ({ target: { value: N } }) => {
                  r == null || r.setFieldValue("days_or_degrees", Number(N));
                }
              }
            ),
            P && /* @__PURE__ */ B.jsx(
              Hn.Item,
              {
                id: "date_range",
                name: "date_range",
                rules: [
                  {
                    required: !0,
                    message: l("molecules.operation_form.item_date_range_msg")
                  }
                ],
                required: !0,
                noStyle: !0,
                children: /* @__PURE__ */ B.jsx(
                  vhe,
                  {
                    format: ["YYYY-MM-DD HH:mm"],
                    onChange: (N) => r == null ? void 0 : r.setFieldValue(N, "date_range")
                  }
                )
              }
            )
          ] }),
          S === Cr.SCOUTING && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
            /* @__PURE__ */ B.jsxs(L0, { children: [
              /* @__PURE__ */ B.jsx(phe, { children: l("molecules.operation_form.point_distribution_label_text") }),
              /* @__PURE__ */ B.jsx(
                Hn.Item,
                {
                  name: "scouting_type",
                  id: "hectar_operation",
                  rules: [
                    {
                      required: !0,
                      message: l(
                        "molecules.operation_form.item_scounting_type_msg"
                      )
                    }
                  ],
                  noStyle: !0,
                  children: /* @__PURE__ */ B.jsxs(
                    hhe,
                    {
                      onChange: (N) => {
                        const D = N.target.value;
                        r == null || r.setFieldValue(D, "scouting_type"), h(
                          D === "FREE_BY_RATE" ? "ha/sample" : "samples"
                        );
                      },
                      defaultValue: s == null ? void 0 : s.scouting_type,
                      children: [
                        /* @__PURE__ */ B.jsx(
                          Ci,
                          {
                            id: "FREE_BY_RATE",
                            value: "FREE_BY_RATE",
                            name: "scouting_type",
                            defaultChecked: !0,
                            children: l("molecules.operation_form.radio_free_by_rate_text")
                          }
                        ),
                        /* @__PURE__ */ B.jsx(
                          Ci,
                          {
                            id: "FREE_SAMPLE_COUNT",
                            value: "FREE_SAMPLE_COUNT",
                            name: "scouting_type",
                            children: l(
                              "molecules.operation_form.radio_free_sample_count_text"
                            )
                          }
                        )
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ B.jsx(
                Hn.Item,
                {
                  name: "hectar_value",
                  id: "hectar_operation_value",
                  rules: [
                    {
                      required: !0,
                      message: l(
                        "molecules.operation_form.item_hectar_value_msg"
                      )
                    }
                  ],
                  noStyle: !0,
                  children: /* @__PURE__ */ B.jsx(
                    z3,
                    {
                      suffix: p,
                      defaultValue: s == null ? void 0 : s.hectar_value,
                      type: "number",
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      onBlur: A
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ B.jsx(L0, { children: /* @__PURE__ */ B.jsxs(Hn.Item, { id: "inspection_groups", children: [
              /* @__PURE__ */ B.jsx(V3, { children: "Inspection group" }),
              /* @__PURE__ */ B.jsx(Hn.Item, { name: "inspection_groups", noStyle: !0, children: /* @__PURE__ */ B.jsx(
                Yc,
                {
                  mode: "multiple",
                  placement: "topLeft",
                  style: { width: "100%" },
                  placeholder: l(
                    "molecules.operation_form.select_inspection_group_placeholder"
                  ),
                  onChange: (N) => {
                    r == null || r.setFieldValue("inspection_groups", N);
                  },
                  defaultValue: s == null ? void 0 : s.inspection_groups,
                  options: y,
                  disabled: u
                }
              ) })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ B.jsxs(ghe, { children: [
          /* @__PURE__ */ B.jsx(Io, { type: "text", onClick: e, children: l("molecules.operation_form.button_cancel_text") }),
          /* @__PURE__ */ B.jsx(mhe, { type: "submit", children: l(I ? "molecules.operation_form.button_update_operation_text" : "molecules.operation_form.button_create_operation_text") })
        ] })
      ]
    }
  ) });
}, Che = Ue.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 680px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  gap: 3rem;
  margin-top: 3.2rem;
`, W3 = Ue.div`
  max-width: ${(e) => e.$limitedWidth ? "142px" : ""};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`, xhe = Ue.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .smv-collapse {
    width: 100%;

    .smv-collapse-header {
      padding: 0;
    }

    .smv-collapse-content-box {
      border-top: 1px solid #dfe2e7;
      padding: 0;
      margin-top: 16px;
    }
  }
`, She = Ue.button`
  width: 100%;
  max-width: 332px;
  border-radius: 4px;
  margin-right: 16px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  background-color: transparent;
  border: 1px solid ${Ht[30]};
  cursor: pointer;

  :hover {
    background-color: ${Ht[10]};
  }
`, whe = () => {
  var I, j;
  const e = Cn(Si), { org: t } = (I = e.rulesInformation) != null ? I : {}, [n] = Hn.useForm(), r = Ya(), [o, i] = Ot(!1), [a, s] = Ot([]), { t: l } = oo(), [u, f] = Id.useMessage(), [p, h] = Ot(!1), [y, b] = Ot(!1), [m, v] = Ot(null), [C, x] = Bpe(), S = ar(() => an(void 0, null, function* () {
    var M;
    const { properties: F } = e.formData, { org: A } = (M = e.rulesInformation) != null ? M : {};
    try {
      if (!A || !F)
        return;
      const N = {
        property_ids: F,
        only_accounts_workers: !1
      }, {
        data: { content: D }
      } = yield uI(A, N), T = D.map(
        ({ id: L, type: z }) => ({
          id: L,
          type: z,
          role: "EXECUTOR"
        })
      );
      s(T);
    } catch (N) {
      console.error(N);
    }
  }), [e.formData, e.rulesInformation]);
  kt(() => {
    S();
  }, [S]), kt(() => {
    a && a.length > 0 && !y && (e.setFormData((F) => Bt(je({}, F), {
      workers: a
    })), b(!0));
  }, [a, y, e]);
  const E = () => an(void 0, null, function* () {
    var F, A, M, N, D;
    if (!(!e.formData || !e.rulesInformation)) {
      h(!0);
      try {
        const T = yield wde(
          e.formData,
          e.rulesInformation
        );
        return yield u.open({
          type: "success",
          content: l("sections.create_operation.message_success_registered"),
          duration: 3
        }), r("/"), e.setFormData((L) => Bt(je({}, L), {
          fields: [],
          create_plan: {},
          create_operation: [],
          workers: []
        })), T;
      } catch (T) {
        const L = T;
        if (((A = (F = L == null ? void 0 : L.response) == null ? void 0 : F.data) == null ? void 0 : A.code) === "NotOperationSchema") {
          yield u.open({
            type: "error",
            content: l("sections.create_operation.schema_not_found")
          });
          return;
        }
        if (((N = (M = L == null ? void 0 : L.response) == null ? void 0 : M.data) == null ? void 0 : N.code) === "PlanOperationsWithoutSchema") {
          const V = JSON.parse((D = L.response.data.message) != null ? D : "{}").plan_operations_without_schema.map(
            ({ name: Y }) => Y
          );
          yield u.open({
            type: "error",
            content: `${l("sections.create_operation.the_operations")} [${V.join(", ")}] ${l("sections.create_operation.does_not_have_schema")}`
          });
          return;
        }
        yield u.open({
          type: "error",
          content: l("sections.create_operation.message_failed_registered")
        });
      } finally {
        h(!1);
      }
    }
  }), O = () => {
    const F = Bt(je({}, B3(n.getFieldsValue())), {
      min_scouting_completeness: 1,
      id: crypto.randomUUID()
    });
    e.setFormData((A) => {
      var M;
      return Bt(je({}, A), {
        workers: a,
        create_operation: [...(M = A.create_operation) != null ? M : [], F]
      });
    }), x((A) => [...A, F]), n.resetFields();
  }, $ = () => {
    const F = (A) => A.id === (m == null ? void 0 : m.id) ? B3(je(je({}, A), n.getFieldsValue())) : A;
    e.setFormData((A) => {
      var M;
      return Bt(je({}, A), {
        workers: a,
        create_operation: ((M = A.create_operation) != null ? M : []).map(F)
      });
    }), x(
      (A) => A.map(F)
    ), n.resetFields();
  }, _ = (F) => () => {
    n.resetFields(), i(!0), F && v(F);
  }, R = () => {
    n.resetFields(), i(!1), v(null);
  }, P = (F) => {
    const A = C.filter(({ id: M }) => M !== F);
    e.setFormData((M) => Bt(je({}, M), {
      workers: a,
      create_operation: [...A]
    })), x(A);
  };
  return /* @__PURE__ */ B.jsxs(Che, { children: [
    /* @__PURE__ */ B.jsx(af, { size: "large", spinning: p, fullscreen: !0 }),
    /* @__PURE__ */ B.jsx(
      UC,
      {
        icon: /* @__PURE__ */ B.jsx(ahe, {}),
        title: l("sections.create_operation.title_section_title")
      }
    ),
    f,
    /* @__PURE__ */ B.jsxs(xhe, { children: [
      C.length ? /* @__PURE__ */ B.jsx(
        ihe,
        {
          onOpenDrawer: _,
          operations: C,
          onDeleteOperation: P
        }
      ) : /* @__PURE__ */ B.jsx(
        Uy,
        {
          marginTop: "0px",
          image: /* @__PURE__ */ B.jsx(she, {}),
          title: l(
            "sections.create_operation.empty_state_no_operation_title"
          ),
          description: l(
            "sections.create_operation.empty_state_no_operation_description"
          ),
          children: /* @__PURE__ */ B.jsx(W3, { $limitedWidth: !0, children: /* @__PURE__ */ B.jsx(Fd, { onClick: _(), children: l(
            "sections.create_operation.button_action_create_operation_text"
          ) }) })
        }
      ),
      /* @__PURE__ */ B.jsx(
        uC,
        {
          title: l("sections.create_operation.drawer_create_operation_title"),
          placement: "right",
          onClose: R,
          open: o,
          destroyOnClose: !0,
          children: /* @__PURE__ */ B.jsx(
            bhe,
            {
              seasonAndCompanyIds: {
                org: t,
                season: (j = e.formData.create_plan) == null ? void 0 : j.seasons_ids
              },
              closeDrawer: R,
              addOperation: O,
              onUpdateOperation: $,
              contextPlans: e,
              formInstance: n,
              operationsListed: C,
              selectedOperation: m
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ B.jsxs(W3, { children: [
      /* @__PURE__ */ B.jsxs(
        She,
        {
          onClick: () => {
            var F;
            return r(
              `/create-plan/${(F = e.formData.create_plan) == null ? void 0 : F.seasons_ids}/fields/`
            );
          },
          type: "button",
          children: [
            /* @__PURE__ */ B.jsx(HC, { width: 18, height: 18 }),
            "Back"
          ]
        }
      ),
      /* @__PURE__ */ B.jsx(
        Fd,
        {
          onClick: () => {
            E();
          },
          disabled: !C.length,
          children: l("sections.create_operation.button_action_create_op_plan_text")
        }
      )
    ] })
  ] });
}, Ehe = [
  {
    path: "/create-plan",
    element: /* @__PURE__ */ B.jsx(Fpe, {}),
    index: 1
  },
  {
    path: "/create-plan/:season/fields",
    element: /* @__PURE__ */ B.jsx(Vde, {}),
    index: 2
  },
  {
    path: "/",
    element: /* @__PURE__ */ B.jsx(Ppe, {}),
    index: 3
  },
  {
    path: "/create-operation",
    element: /* @__PURE__ */ B.jsx(whe, {}),
    index: 4
  }
], K3 = {
  token: {
    colorPrimary: "#14803C",
    colorNeutralGray: "#868CA2",
    colorNeutralWhite: "#ffffff"
  },
  components: {
    Steps: {
      finishIconBorderColor: "#14803C",
      navArrowColor: "red"
    },
    Table: {
      rowSelectedBg: "transparent",
      rowHoverBg: "transparent",
      rowSelectedHoverBg: "transparent"
    },
    Button: {
      colorPrimary: "#14803C",
      algorithm: !0
    },
    Input: {
      colorPrimary: "#14803C",
      algorithm: !0
    }
  }
}, Nhe = ({
  config: {
    unitSystem: e,
    org: t,
    cropCycle: n,
    token: r,
    environment: o = "staging",
    baseRoute: i = "smart-plan",
    locale: a,
    appId: s,
    workspaceId: l
  }
}) => {
  const u = Fle`
  .st-layout .st-content{
    overflow: visible !important;
    overflow-y: scroll !important;
  }
`, [f, p] = Ot("en"), [h, y] = Ot(!1);
  return kt(() => {
    h || (Fo.defaults.headers.common.Authorization = `Bearer ${r}`, Fo.defaults.baseURL = o === "staging" ? "https://api.staging.base.cropwise.com" : "https://api.base.cropwise.com", s2.defaults.headers.common.Authorization = `Bearer ${r}`, s2.interceptors.request.use((b) => (o === "production" && (b.baseURL = "https://api.protector.cropwise.com"), b)), ph.defaults.headers.common.Authorization = `Bearer ${r}`, ph.interceptors.request.use((b) => (o === "production" && (b.baseURL = "https://api.beta.base.strider.ag"), b)), hh.defaults.headers.common.Authorization = `Bearer ${r}`, hh.interceptors.request.use((b) => (o === "production" && (b.baseURL = "https://api.beta.protector.strider.ag"), b)), y(!0));
  }, [o, h, r]), kt(() => {
    a !== f && (dde(a), p(a));
  }, [f, a]), /* @__PURE__ */ B.jsx(Wj, { client: Dae, children: /* @__PURE__ */ B.jsx(Ale, { theme: K3, children: /* @__PURE__ */ B.jsx(vb, { theme: K3, prefixCls: "smv", children: t && /* @__PURE__ */ B.jsxs(
    Mae,
    {
      baseRoute: i,
      environment: o,
      org: t,
      cropCycle: n,
      unitSystem: e,
      appId: s,
      workspaceId: l,
      children: [
        /* @__PURE__ */ B.jsx(u, {}),
        h && /* @__PURE__ */ B.jsx(Bse, { basename: i, children: /* @__PURE__ */ B.jsx(fce, { children: /* @__PURE__ */ B.jsx($se, { children: Ehe.map(({ element: b, path: m, index: v }) => /* @__PURE__ */ B.jsx(e9, { path: `${m}`, element: b }, v)) }) }) })
      ]
    }
  ) }) }) });
};
export {
  Nhe as SmartPlan
};
